import React__default, { useContext, useRef, useEffect, useState, Fragment as Fragment$2, useMemo, useLayoutEffect, createElement, forwardRef, createContext } from 'react';
import { useQuery, QueryClient, QueryClientProvider } from 'react-query';
import { useDispatch, useSelector, Provider } from 'react-redux';
import { useLocation, useRouteMatch, useHistory, Switch, Route, Redirect, Link as Link$1, NavLink, useParams, BrowserRouter } from 'react-router-dom';
import { useTranslation, getI18n } from 'react-i18next';
import { BackButton, FormStep, OTPInput, CardText, CardLabelError, AppContainer, Toast, Loader, FormComposer, CardSubHeader, Dropdown, Card as Card$1, CustomButton, SubmitBar, Banner, TopBar as TopBar$4, Hamburger, HomeIcon, LogoutIcon, EditPencilIcon, Phone, NavBar, GalleryIcon, RemoveIcon, CameraIcon, LabelFieldPair, CardLabel, TextInput as TextInput$3, MobileNumber, PrivateRoute, Table as Table$2, PageBasedInput, CardHeader, RadioButtons, SearchOnRadioButtons } from '@egovernments/digit-ui-react-components';
import { makeStyles, styled as styled$2 } from '@mui/styles';
import { styled, TextField, Container, Card, CssBaseline, CardContent, Grid, Typography, InputLabel, IconButton, Button, Box, Divider, Avatar as Avatar$1, Modal as Modal$1, makeStyles as makeStyles$2, TableContainer as TableContainer$2, Paper as Paper$2, Table as Table$5, TableBody as TableBody$2, TableRow as TableRow$2, TableCell as TableCell$2, TableHead as TableHead$2 } from '@material-ui/core';
import CachedIcon from '@mui/icons-material/Cached';
import { useForm, Controller, useController } from 'react-hook-form';
import axios from 'axios';
import Button$1 from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem$5 from '@mui/material/MenuItem';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { styled as styled$1, Typography as Typography$1, Box as Box$1, Tabs, Tab, MenuItem as MenuItem$4, OutlinedInput, FormHelperText, TextField as TextField$1, InputAdornment, IconButton as IconButton$2, FormControlLabel as FormControlLabel$1, Checkbox, Paper, CircularProgress, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Link, Dialog, DialogTitle, DialogContent, Button as Button$2, Card as Card$3, Accordion, AccordionSummary, AccordionDetails, Divider as Divider$1, FormControl as FormControl$1, InputLabel as InputLabel$1, Select as Select$1, Autocomplete, ListItemText, CardContent as CardContent$2, Container as Container$1, InputBase, Menu as Menu$1, AppBar, Toolbar, Drawer, alpha, Grid as Grid$1, RadioGroup as RadioGroup$1, useTheme, Stack, Slider, useMediaQuery, tableCellClasses, FormLabel, Radio as Radio$1, ButtonBase, Modal, keyframes, Alert, Popper, MenuList, DialogActions, CssBaseline as CssBaseline$1, TablePagination, DialogContentText, CardHeader as CardHeader$1, CardMedia, List, ListItem, Popover, TableSortLabel, LinearProgress } from '@mui/material';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import InputLabel$2 from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import IconButton$1 from '@mui/material/IconButton';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker, MobileTimePicker } from '@mui/x-date-pickers';
import 'dayjs/locale/en-in';
import dayjs from 'dayjs';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { Search as Search$1, ExpandMore, ArrowForwardIos, ArrowBackIos, VisibilityOff, Visibility, DarkMode, LightMode, TextDecrease, HdrAuto, TextIncrease, Language, Close, PictureAsPdf, VideoCameraBack, LanguageOutlined, Facebook, Instagram, LinkedIn, Twitter, Home as Home$2, Group, MiscellaneousServices, HelpOutline, Download, PrivacyTip, CalendarMonth, AccountCircle, Fullscreen, ArrowDownward } from '@mui/icons-material';
import '@egovernments/digit-ui-libraries/src/services/atoms/Utils/Date';
import CloseIcon from '@mui/icons-material/Close';
import Urls$1 from '@egovernments/digit-ui-libraries/src/services/atoms/urls';
import '@mui/icons-material/CloudUploadOutlined';
import '@mui/icons-material/Visibility';
import '@mui/icons-material/DeleteForever';
import { getDocumentByFileStoreId, getDocumentByFileStoreIdV2 } from '@egovernments/digit-ui-libraries/src/utils/fileType';
import '@mui/icons-material/Notifications';
import Box$2 from '@mui/material/Box';
import Card$2 from '@mui/material/Card';
import CardContent$1 from '@mui/material/CardContent';
import Typography$2 from '@mui/material/Typography';
import { makeStyles as makeStyles$1 } from '@material-ui/core/styles';
import { useHistory as useHistory$1 } from 'react-router-dom/cjs/react-router-dom';
import { AiFillHome, AiFillDashboard, AiFillWindows, AiFillFilePdf } from 'react-icons/ai';
import { TbArticleFilledFilled } from 'react-icons/tb';
import { BiSolidReport } from 'react-icons/bi';
import { FaEdit, FaFilePdf, FaArrowCircleUp, FaBars, FaCopy, FaChevronUp, FaChevronDown, FaQuestionCircle, FaUser } from 'react-icons/fa';
import DrawIcon from '@mui/icons-material/Draw';
import '@mui/material/AppBar';
import '@mui/material/Toolbar';
import SearchIcon from '@mui/icons-material/Search';
import VolumeDown from '@mui/icons-material/VolumeDown';
import VolumeUp from '@mui/icons-material/VolumeUp';
import ArrowDropDown from '@mui/icons-material/ArrowDropDown';
import SettingsIcon from '@mui/icons-material/Settings';
import MenuIcon from '@mui/icons-material/Menu';
import Table$1 from 'react-bootstrap/Table';
import HelpIcon from '@mui/icons-material/Help';
import Avatar from '@material-ui/core/Avatar';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import { styled as styled$3, createTheme, ThemeProvider } from '@mui/material/styles';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Table as Table$3, Container as Container$2, Row, Col } from 'react-bootstrap';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { BsFillVolumeUpFill, BsApple, BsFilePdf } from 'react-icons/bs';
import { DiAndroid } from 'react-icons/di';
import { FcHome } from 'react-icons/fc';
import { SlArrowDown } from 'react-icons/sl';
import '@mui/icons-material/Facebook';
import '@mui/icons-material/X';
import '@mui/icons-material/LinkedIn';
import '@mui/icons-material/Instagram';
import 'react-icons/md';
import '@mui/icons-material/Rule';
import Table$4 from '@mui/material/Table';
import TableBody$1 from '@mui/material/TableBody';
import TableCell$1, { tableCellClasses as tableCellClasses$1 } from '@mui/material/TableCell';
import TableContainer$1 from '@mui/material/TableContainer';
import TableHead$1 from '@mui/material/TableHead';
import TableRow$1 from '@mui/material/TableRow';
import Paper$1 from '@mui/material/Paper';
import Checkbox$1 from '@mui/material/Checkbox';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import '@mui/icons-material/Apartment';
import Card$4 from '@material-ui/core/Card';
import CardContent$3 from '@material-ui/core/CardContent';
import Typography$3 from '@material-ui/core/Typography';
import Link$2 from '@material-ui/core/Link';
import Button$3 from '@material-ui/core/Button';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import HomeIcon$1 from '@mui/icons-material/Home';
import Accordion$1 from '@mui/material/Accordion';
import AccordionSummary$1 from '@mui/material/AccordionSummary';
import AccordionDetails$1 from '@mui/material/AccordionDetails';
import PhoneIcon from '@mui/icons-material/Phone';
import FaxIcon from '@mui/icons-material/Fax';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import { HiUserGroup } from 'react-icons/hi2';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import { useHistory as useHistory$2 } from 'react-router-dom/cjs/react-router-dom.min';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import '@material-ui/core/Paper';
import TablePagination$1 from '@mui/material/TablePagination';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import 'react-icons/fa6';
import ClearIcon from '@mui/icons-material/Clear';
import FilterListIcon from '@mui/icons-material/FilterList';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import AccessibilityRoundedIcon from '@mui/icons-material/AccessibilityRounded';
import TextField$2 from '@mui/material/TextField';
import InputAdornment$1 from '@mui/material/InputAdornment';
import TableSortLabel$1 from '@mui/material/TableSortLabel';
import { compose, applyMiddleware, createStore, combineReducers } from 'redux';
import thunk from 'redux-thunk';

const CitizenHome = ({
  modules
}) => {
  const ComponentProvider = Digit.Contexts.ComponentProvider;
  const registry = useContext(ComponentProvider);
  const paymentModule = modules.filter(({
    code
  }) => code === "Payment")[0];
  const moduleArr = modules.filter(({
    code
  }) => code !== "Payment");
  const moduleArray = [paymentModule, ...moduleArr];
  const showQuickPay = moduleArr.some(module => module.code === "QuickPayLinks");
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(BackButton, null), /*#__PURE__*/React__default.createElement("div", {
    className: "citizenAllServiceGrid"
  }, moduleArray.filter(mod => mod).map(({
    code
  }, index) => {
    let Links = Digit.ComponentRegistryService.getComponent(`${code}Links`) || (() => /*#__PURE__*/React__default.createElement(React__default.Fragment, null));
    if (code === "Payment" && !showQuickPay) {
      Links = () => /*#__PURE__*/React__default.createElement(React__default.Fragment, null);
    }
    return /*#__PURE__*/React__default.createElement(Links, {
      key: index,
      matchPath: `/digit-ui/citizen/${code.toLowerCase()}`,
      userType: "citizen"
    });
  })));
};
const EmployeeHome = ({
  modules
}) => {
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, modules.map(({
    code
  }, index) => {
    const Card = Digit.ComponentRegistryService.getComponent(`${code}Card`) || (() => /*#__PURE__*/React__default.createElement(React__default.Fragment, null));
    return /*#__PURE__*/React__default.createElement(Card, {
      key: index
    });
  }));
};
const AppHome = ({
  userType,
  modules
}) => {
  if (userType === "citizen") {
    return /*#__PURE__*/React__default.createElement(CitizenHome, {
      modules: modules
    });
  }
  return /*#__PURE__*/React__default.createElement(EmployeeHome, {
    modules: modules
  });
};

const loginSteps = [{
  texts: {
    header: "CS_LOGIN_PROVIDE_MOBILE_NUMBER_AVAIL",
    cardText: "CS_LOGIN_TEXT",
    nextText: "CS_COMMONS_NEXT",
    submitBarLabel: "CS_COMMONS_NEXT"
  },
  inputs: [{
    label: "CORE_COMMON_MOBILE_NUMBER",
    type: "text",
    name: "mobileNumber",
    error: "ERR_HRMS_INVALID_MOB_NO",
    validation: {
      required: true,
      minLength: 10,
      maxLength: 10
    }
  }]
}, {
  texts: {
    header: "CS_LOGIN_OTP",
    cardText: "CS_LOGIN_OTP_TEXT",
    nextText: "CS_COMMONS_NEXT",
    submitBarLabel: "CS_COMMONS_NEXT"
  }
}, {
  texts: {
    header: "CS_LOGIN_PROVIDE_NAME",
    cardText: "CS_LOGIN_NAME_TEXT",
    nextText: "CS_COMMONS_NEXT",
    submitBarLabel: "CS_COMMONS_NEXT"
  },
  inputs: [{
    label: "CORE_COMMON_NAME",
    type: "text",
    name: "name",
    error: "CORE_COMMON_NAME_VALIDMSG",
    validation: {
      required: true,
      minLength: 1,
      pattern: /^[^{0-9}^\$\"<>?\\\\~!@#$%^()+={}\[\]*,/_:;“”‘’]{1,50}$/i
    }
  }]
}];

const SelectMobileNumber = ({
  t,
  onSelect,
  showRegisterLink,
  mobileNumber,
  onMobileChange,
  config
}) => {
  return /*#__PURE__*/React__default.createElement(FormStep, {
    isDisabled: mobileNumber.length !== 10,
    onSelect: onSelect,
    config: config,
    t: t,
    componentInFront: "+91",
    onChange: onMobileChange,
    value: mobileNumber
  });
};

function useInterval(callback, delay) {
  const savedCallback = useRef();
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);
  useEffect(() => {
    function tick() {
      savedCallback.current();
    }
    if (delay !== null) {
      const timer = setInterval(tick, delay);
      return () => clearInterval(timer);
    }
  }, [delay]);
}

const SelectOtp = ({
  config,
  otp,
  onOtpChange,
  onResend,
  onSelect,
  t,
  error,
  userType: _userType = "citizen"
}) => {
  const [timeLeft, setTimeLeft] = useState(30);
  useInterval(() => {
    setTimeLeft(timeLeft - 1);
  }, timeLeft > 0 ? 1000 : null);
  const handleResendOtp = () => {
    onResend();
    setTimeLeft(2);
  };
  if (_userType === "employee") {
    return /*#__PURE__*/React__default.createElement(Fragment$2, null, /*#__PURE__*/React__default.createElement(OTPInput, {
      length: 6,
      onChange: onOtpChange,
      value: otp
    }), timeLeft > 0 ? /*#__PURE__*/React__default.createElement(CardText, null, `${t("CS_RESEND_ANOTHER_OTP")} ${timeLeft} ${t("CS_RESEND_SECONDS")}`) : /*#__PURE__*/React__default.createElement("p", {
      className: "card-text-button",
      onClick: handleResendOtp
    }, t("CS_RESEND_OTP")), !error && /*#__PURE__*/React__default.createElement(CardLabelError, null, t("CS_INVALID_OTP")));
  }
  return /*#__PURE__*/React__default.createElement(FormStep, {
    onSelect: onSelect,
    config: config,
    t: t,
    isDisabled: (otp === null || otp === void 0 ? void 0 : otp.length) !== 6
  }, /*#__PURE__*/React__default.createElement(OTPInput, {
    length: 6,
    onChange: onOtpChange,
    value: otp
  }), timeLeft > 0 ? /*#__PURE__*/React__default.createElement(CardText, null, `${t("CS_RESEND_ANOTHER_OTP")} ${timeLeft} ${t("CS_RESEND_SECONDS")}`) : /*#__PURE__*/React__default.createElement("p", {
    className: "card-text-button",
    onClick: handleResendOtp
  }, t("CS_RESEND_OTP")), !error && /*#__PURE__*/React__default.createElement(CardLabelError, null, t("CS_INVALID_OTP")));
};

const SelectName = ({
  config,
  onSelect,
  t
}) => {
  return /*#__PURE__*/React__default.createElement(FormStep, {
    config: config,
    onSelect: onSelect,
    t: t
  });
};

const TYPE_REGISTER = {
  type: "register"
};
const TYPE_LOGIN = {
  type: "login"
};
const DEFAULT_REDIRECT_URL = "/digit-ui/citizen";
const setCitizenDetail = (userObject, token, tenantId) => {
  var _JSON$parse, _JSON$parse$value;
  let locale = (_JSON$parse = JSON.parse(sessionStorage.getItem("Digit.initData"))) === null || _JSON$parse === void 0 ? void 0 : (_JSON$parse$value = _JSON$parse.value) === null || _JSON$parse$value === void 0 ? void 0 : _JSON$parse$value.selectedLanguage;
  localStorage.setItem("Citizen.tenant-id", tenantId);
  localStorage.setItem("tenant-id", tenantId);
  localStorage.setItem("citizen.userRequestObject", JSON.stringify(userObject));
  localStorage.setItem("locale", locale);
  localStorage.setItem("Citizen.locale", locale);
  localStorage.setItem("token", token);
  localStorage.setItem("Citizen.token", token);
  localStorage.setItem("user-info", JSON.stringify(userObject));
  localStorage.setItem("Citizen.user-info", JSON.stringify(userObject));
};
const getFromLocation = (state, searchParams) => {
  return (state === null || state === void 0 ? void 0 : state.from) || (searchParams === null || searchParams === void 0 ? void 0 : searchParams.from) || DEFAULT_REDIRECT_URL;
};
const Login = ({
  stateCode,
  isUserRegistered: _isUserRegistered = true
}) => {
  var _location$state, _location$state7;
  const {
    t
  } = useTranslation();
  const location = useLocation();
  const {
    path
  } = useRouteMatch();
  const history = useHistory();
  const [user, setUser] = useState(null);
  const [error, setError] = useState(null);
  const [isOtpValid, setIsOtpValid] = useState(true);
  const [tokens, setTokens] = useState(null);
  const [params, setParmas] = useState(_isUserRegistered ? {} : location === null || location === void 0 ? void 0 : (_location$state = location.state) === null || _location$state === void 0 ? void 0 : _location$state.data);
  const [errorTO, setErrorTO] = useState(null);
  const searchParams = Digit.Hooks.useQueryParams();
  useEffect(() => {
    const user = Digit.UserService.getUser();
    const isLoggedIn = user && user.access_token && user.info;
    const isLoginOrLanding = path => {
      if (!path) return true;
      const normalized = path.replace(/\/$/, "");
      const prefixMatch = normalized.match(/^(.*)\/digit-ui/);
      const prefix = prefixMatch ? prefixMatch[1] : "";
      return normalized === `${prefix}/digit-ui` || normalized === `${prefix}/digit-ui/citizen` || normalized === `${prefix}/digit-ui/citizen/login` || normalized === `${prefix}/digit-ui/employee/user/login` || normalized === `${prefix}/digit-ui/employee/user/language-selection` || normalized === `${prefix}/digit-ui/citizen/select-language` || normalized === `${prefix}/digit-ui/citizen/select-location` || normalized.includes("dsc-service") || normalized.includes("process-signed-pdf");
    };
    if (isLoggedIn && isLoginOrLanding(location.pathname)) {
      const lastVisited = sessionStorage.getItem("last_visited_path");
      const getPrefix = p => {
        const match = p.match(/^(.*)\/digit-ui/);
        return match ? match[1] : "";
      };
      if (lastVisited && !isLoginOrLanding(lastVisited)) {
        history.replace(lastVisited);
      } else {
        const prefix = getPrefix(location.pathname);
        const defaultRedirect = user.info.type === "EMPLOYEE" ? `${prefix}/digit-ui/employee` : `${prefix}/digit-ui/citizen/profile`;
        history.replace(defaultRedirect);
      }
    }
  }, [location.pathname, history]);
  useEffect(() => {
    let errorTimeout;
    if (error) {
      if (errorTO) {
        clearTimeout(errorTO);
        setErrorTO(null);
      }
      errorTimeout = setTimeout(() => setError(""), 5000);
      setErrorTO(errorTimeout);
    }
    return () => {
      errorTimeout && clearTimeout(errorTimeout);
    };
  }, [error]);
  useEffect(() => {
    var _location$state2;
    if (!user) return;
    Digit.SessionStorage.set("citizen.userRequestObject", user);
    Digit.UserService.setUser(user);
    setCitizenDetail(user === null || user === void 0 ? void 0 : user.info, user === null || user === void 0 ? void 0 : user.access_token, stateCode);
    const redirectPath = ((_location$state2 = location.state) === null || _location$state2 === void 0 ? void 0 : _location$state2.from) || DEFAULT_REDIRECT_URL;
    history.replace(redirectPath);
  }, [user]);
  const stepItems = useMemo(() => loginSteps.map(step => {
    const texts = {};
    for (const key in step.texts) {
      texts[key] = t(step.texts[key]);
    }
    return {
      ...step,
      texts
    };
  }), [loginSteps]);
  const getUserType = () => Digit.UserService.getType();
  const handleOtpChange = otp => {
    setParmas({
      ...params,
      otp
    });
  };
  const handleMobileChange = event => {
    const {
      value
    } = event.target;
    if (/^\d{0,10}$/.test(value)) {
      setParmas({
        ...params,
        mobileNumber: value
      });
    }
  };
  const selectMobileNumber = async mobileNumber => {
    setParmas({
      ...params,
      ...mobileNumber
    });
    const data = {
      ...mobileNumber,
      tenantId: stateCode,
      userType: getUserType()
    };
    if (_isUserRegistered) {
      var _location$state4;
      const [res, err] = await sendOtp({
        otp: {
          ...data,
          ...TYPE_LOGIN
        }
      });
      if (!err) {
        var _location$state3;
        history.replace(`${path}/otp`, {
          from: getFromLocation(location.state, searchParams),
          role: (_location$state3 = location.state) === null || _location$state3 === void 0 ? void 0 : _location$state3.role
        });
        return;
      } else {
        if (!(location.state && location.state.role === 'FSM_DSO')) {
          history.push(`/digit-ui/citizen/register/name`, {
            from: getFromLocation(location.state, searchParams),
            data
          });
        }
      }
      if ((_location$state4 = location.state) !== null && _location$state4 !== void 0 && _location$state4.role) {
        var _location$state5;
        setError(((_location$state5 = location.state) === null || _location$state5 === void 0 ? void 0 : _location$state5.role) === "FSM_DSO" ? t("ES_ERROR_DSO_LOGIN") : "User not registered.");
      }
    } else {
      const [res, err] = await sendOtp({
        otp: {
          ...data,
          ...TYPE_REGISTER
        }
      });
      if (!err) {
        history.replace(`${path}/otp`, {
          from: getFromLocation(location.state, searchParams)
        });
        return;
      }
    }
  };
  const selectName = async name => {
    const data = {
      ...params,
      tenantId: stateCode,
      userType: getUserType(),
      ...name
    };
    setParmas({
      ...params,
      ...name
    });
    const [res, err] = await sendOtp({
      otp: {
        ...data,
        ...TYPE_REGISTER
      }
    });
    if (res) {
      history.replace(`${path}/otp`, {
        from: getFromLocation(location.state, searchParams)
      });
    }
  };
  const selectOtp = async () => {
    try {
      setIsOtpValid(true);
      const {
        mobileNumber,
        otp,
        name
      } = params;
      if (_isUserRegistered) {
        var _location$state6, _window, _window$globalConfigs;
        const requestData = {
          username: mobileNumber,
          password: otp,
          tenantId: stateCode,
          userType: getUserType()
        };
        const {
          ResponseInfo,
          UserRequest: info,
          ...tokens
        } = await Digit.UserService.authenticate(requestData);
        if ((_location$state6 = location.state) !== null && _location$state6 !== void 0 && _location$state6.role) {
          const roleInfo = info.roles.find(userRole => userRole.code === location.state.role);
          if (!roleInfo || !roleInfo.code) {
            setError(t("ES_ERROR_USER_NOT_PERMITTED"));
            setTimeout(() => history.replace(DEFAULT_REDIRECT_URL), 5000);
            return;
          }
        }
        if ((_window = window) !== null && _window !== void 0 && (_window$globalConfigs = _window.globalConfigs) !== null && _window$globalConfigs !== void 0 && _window$globalConfigs.getConfig("ENABLE_SINGLEINSTANCE")) {
          info.tenantId = Digit.ULBService.getStateId();
        }
        setUser({
          info,
          ...tokens
        });
      } else {
        var _window2, _window2$globalConfig;
        const requestData = {
          name,
          username: mobileNumber,
          otpReference: otp,
          tenantId: stateCode,
          mobileNumber
        };
        const {
          ResponseInfo,
          UserRequest: info,
          ...tokens
        } = await Digit.UserService.registerUser(requestData, stateCode);
        if ((_window2 = window) !== null && _window2 !== void 0 && (_window2$globalConfig = _window2.globalConfigs) !== null && _window2$globalConfig !== void 0 && _window2$globalConfig.getConfig("ENABLE_SINGLEINSTANCE")) {
          info.tenantId = Digit.ULBService.getStateId();
        }
        setUser({
          info,
          ...tokens
        });
      }
    } catch (err) {
      setIsOtpValid(false);
    }
  };
  const resendOtp = async () => {
    const {
      mobileNumber
    } = params;
    const data = {
      mobileNumber,
      tenantId: stateCode,
      userType: getUserType()
    };
    if (!_isUserRegistered) {
      await sendOtp({
        otp: {
          ...data,
          ...TYPE_REGISTER
        }
      });
    } else {
      await sendOtp({
        otp: {
          ...data,
          ...TYPE_LOGIN
        }
      });
    }
  };
  const sendOtp = async data => {
    try {
      const res = await Digit.UserService.sendOtp(data, stateCode);
      return [res, null];
    } catch (err) {
      return [null, err];
    }
  };
  return /*#__PURE__*/React__default.createElement(Switch, null, /*#__PURE__*/React__default.createElement(AppContainer, null, /*#__PURE__*/React__default.createElement(BackButton, null), /*#__PURE__*/React__default.createElement(Route, {
    path: `${path}`,
    exact: true
  }, /*#__PURE__*/React__default.createElement(SelectMobileNumber, {
    onSelect: selectMobileNumber,
    config: stepItems[0],
    mobileNumber: params.mobileNumber || "",
    onMobileChange: handleMobileChange,
    showRegisterLink: _isUserRegistered && !((_location$state7 = location.state) !== null && _location$state7 !== void 0 && _location$state7.role),
    t: t
  })), /*#__PURE__*/React__default.createElement(Route, {
    path: `${path}/otp`
  }, /*#__PURE__*/React__default.createElement(SelectOtp, {
    config: {
      ...stepItems[1],
      texts: {
        ...stepItems[1].texts,
        cardText: `${stepItems[1].texts.cardText} ${params.mobileNumber || ""}`
      }
    },
    onOtpChange: handleOtpChange,
    onResend: resendOtp,
    onSelect: selectOtp,
    otp: params.otp,
    error: isOtpValid,
    t: t
  })), /*#__PURE__*/React__default.createElement(Route, {
    path: `${path}/name`
  }, /*#__PURE__*/React__default.createElement(SelectName, {
    config: stepItems[2],
    onSelect: selectName,
    t: t
  })), error && /*#__PURE__*/React__default.createElement(Toast, {
    error: true,
    label: error,
    onClose: () => setError(null)
  })));
};

const loginConfig = [{
  texts: {
    header: "CORE_COMMON_LOGIN",
    submitButtonLabel: "CORE_COMMON_CONTINUE",
    secondaryButtonLabel: "CORE_COMMON_FORGOT_PASSWORD"
  },
  inputs: [{
    label: "CORE_LOGIN_USERNAME",
    type: "text",
    name: "username",
    error: "ERR_HRMS_INVALID_USER_ID"
  }, {
    label: "CORE_LOGIN_PASSWORD",
    type: "password",
    name: "password",
    error: "ERR_HRMS_WRONG_PASSWORD"
  }]
}];

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var b = "function" === typeof Symbol && Symbol.for,
  c = b ? Symbol.for("react.element") : 60103,
  d = b ? Symbol.for("react.portal") : 60106,
  e = b ? Symbol.for("react.fragment") : 60107,
  f = b ? Symbol.for("react.strict_mode") : 60108,
  g = b ? Symbol.for("react.profiler") : 60114,
  h = b ? Symbol.for("react.provider") : 60109,
  k = b ? Symbol.for("react.context") : 60110,
  l = b ? Symbol.for("react.async_mode") : 60111,
  m = b ? Symbol.for("react.concurrent_mode") : 60111,
  n = b ? Symbol.for("react.forward_ref") : 60112,
  p = b ? Symbol.for("react.suspense") : 60113,
  q = b ? Symbol.for("react.suspense_list") : 60120,
  r = b ? Symbol.for("react.memo") : 60115,
  t$1 = b ? Symbol.for("react.lazy") : 60116,
  v = b ? Symbol.for("react.block") : 60121,
  w = b ? Symbol.for("react.fundamental") : 60117,
  x = b ? Symbol.for("react.responder") : 60118,
  y = b ? Symbol.for("react.scope") : 60119;
function z(a) {
  if ("object" === typeof a && null !== a) {
    var u = a.$$typeof;
    switch (u) {
      case c:
        switch (a = a.type, a) {
          case l:
          case m:
          case e:
          case g:
          case f:
          case p:
            return a;
          default:
            switch (a = a && a.$$typeof, a) {
              case k:
              case n:
              case t$1:
              case r:
              case h:
                return a;
              default:
                return u;
            }
        }
      case d:
        return u;
    }
  }
}
function A(a) {
  return z(a) === m;
}
var AsyncMode = l;
var ConcurrentMode = m;
var ContextConsumer = k;
var ContextProvider = h;
var Element = c;
var ForwardRef = n;
var Fragment$1 = e;
var Lazy = t$1;
var Memo = r;
var Portal = d;
var Profiler = g;
var StrictMode = f;
var Suspense = p;
var isAsyncMode = function (a) {
  return A(a) || z(a) === l;
};
var isConcurrentMode = A;
var isContextConsumer = function (a) {
  return z(a) === k;
};
var isContextProvider = function (a) {
  return z(a) === h;
};
var isElement = function (a) {
  return "object" === typeof a && null !== a && a.$$typeof === c;
};
var isForwardRef = function (a) {
  return z(a) === n;
};
var isFragment = function (a) {
  return z(a) === e;
};
var isLazy = function (a) {
  return z(a) === t$1;
};
var isMemo = function (a) {
  return z(a) === r;
};
var isPortal = function (a) {
  return z(a) === d;
};
var isProfiler = function (a) {
  return z(a) === g;
};
var isStrictMode = function (a) {
  return z(a) === f;
};
var isSuspense = function (a) {
  return z(a) === p;
};
var isValidElementType = function (a) {
  return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t$1 || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
};
var typeOf = z;
var reactIs_production_min = {
  AsyncMode: AsyncMode,
  ConcurrentMode: ConcurrentMode,
  ContextConsumer: ContextConsumer,
  ContextProvider: ContextProvider,
  Element: Element,
  ForwardRef: ForwardRef,
  Fragment: Fragment$1,
  Lazy: Lazy,
  Memo: Memo,
  Portal: Portal,
  Profiler: Profiler,
  StrictMode: StrictMode,
  Suspense: Suspense,
  isAsyncMode: isAsyncMode,
  isConcurrentMode: isConcurrentMode,
  isContextConsumer: isContextConsumer,
  isContextProvider: isContextProvider,
  isElement: isElement,
  isForwardRef: isForwardRef,
  isFragment: isFragment,
  isLazy: isLazy,
  isMemo: isMemo,
  isPortal: isPortal,
  isProfiler: isProfiler,
  isStrictMode: isStrictMode,
  isSuspense: isSuspense,
  isValidElementType: isValidElementType,
  typeOf: typeOf
};

var reactIs_development = createCommonjsModule(function (module, exports) {

  if (process.env.NODE_ENV !== "production") {
    (function () {
      var hasSymbol = typeof Symbol === 'function' && Symbol.for;
      var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
      var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
      var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
      var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
      var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
      var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
      var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace;
      var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
      var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
      var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
      var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
      var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
      var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
      var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
      var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
      var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
      var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
      var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;
      function isValidElementType(type) {
        return typeof type === 'string' || typeof type === 'function' || type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
      }
      function typeOf(object) {
        if (typeof object === 'object' && object !== null) {
          var $$typeof = object.$$typeof;
          switch ($$typeof) {
            case REACT_ELEMENT_TYPE:
              var type = object.type;
              switch (type) {
                case REACT_ASYNC_MODE_TYPE:
                case REACT_CONCURRENT_MODE_TYPE:
                case REACT_FRAGMENT_TYPE:
                case REACT_PROFILER_TYPE:
                case REACT_STRICT_MODE_TYPE:
                case REACT_SUSPENSE_TYPE:
                  return type;
                default:
                  var $$typeofType = type && type.$$typeof;
                  switch ($$typeofType) {
                    case REACT_CONTEXT_TYPE:
                    case REACT_FORWARD_REF_TYPE:
                    case REACT_LAZY_TYPE:
                    case REACT_MEMO_TYPE:
                    case REACT_PROVIDER_TYPE:
                      return $$typeofType;
                    default:
                      return $$typeof;
                  }
              }
            case REACT_PORTAL_TYPE:
              return $$typeof;
          }
        }
        return undefined;
      }
      var AsyncMode = REACT_ASYNC_MODE_TYPE;
      var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
      var ContextConsumer = REACT_CONTEXT_TYPE;
      var ContextProvider = REACT_PROVIDER_TYPE;
      var Element = REACT_ELEMENT_TYPE;
      var ForwardRef = REACT_FORWARD_REF_TYPE;
      var Fragment = REACT_FRAGMENT_TYPE;
      var Lazy = REACT_LAZY_TYPE;
      var Memo = REACT_MEMO_TYPE;
      var Portal = REACT_PORTAL_TYPE;
      var Profiler = REACT_PROFILER_TYPE;
      var StrictMode = REACT_STRICT_MODE_TYPE;
      var Suspense = REACT_SUSPENSE_TYPE;
      var hasWarnedAboutDeprecatedIsAsyncMode = false;
      function isAsyncMode(object) {
        {
          if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true;
            console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
          }
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
      }
      function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
      }
      function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
      }
      function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
      }
      function isElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
      }
      function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
      }
      function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
      }
      function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
      }
      function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
      }
      function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
      }
      function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
      }
      function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
      }
      function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
      }
      exports.AsyncMode = AsyncMode;
      exports.ConcurrentMode = ConcurrentMode;
      exports.ContextConsumer = ContextConsumer;
      exports.ContextProvider = ContextProvider;
      exports.Element = Element;
      exports.ForwardRef = ForwardRef;
      exports.Fragment = Fragment;
      exports.Lazy = Lazy;
      exports.Memo = Memo;
      exports.Portal = Portal;
      exports.Profiler = Profiler;
      exports.StrictMode = StrictMode;
      exports.Suspense = Suspense;
      exports.isAsyncMode = isAsyncMode;
      exports.isConcurrentMode = isConcurrentMode;
      exports.isContextConsumer = isContextConsumer;
      exports.isContextProvider = isContextProvider;
      exports.isElement = isElement;
      exports.isForwardRef = isForwardRef;
      exports.isFragment = isFragment;
      exports.isLazy = isLazy;
      exports.isMemo = isMemo;
      exports.isPortal = isPortal;
      exports.isProfiler = isProfiler;
      exports.isStrictMode = isStrictMode;
      exports.isSuspense = isSuspense;
      exports.isValidElementType = isValidElementType;
      exports.typeOf = typeOf;
    })();
  }
});

var reactIs = createCommonjsModule(function (module) {

  if (process.env.NODE_ENV === 'production') {
    module.exports = reactIs_production_min;
  } else {
    module.exports = reactIs_development;
  }
});

var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;
function toObject(val) {
  if (val === null || val === undefined) {
    throw new TypeError('Object.assign cannot be called with null or undefined');
  }
  return Object(val);
}
function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    }
    var test1 = new String('abc');
    test1[5] = 'de';
    if (Object.getOwnPropertyNames(test1)[0] === '5') {
      return false;
    }
    var test2 = {};
    for (var i = 0; i < 10; i++) {
      test2['_' + String.fromCharCode(i)] = i;
    }
    var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
      return test2[n];
    });
    if (order2.join('') !== '0123456789') {
      return false;
    }
    var test3 = {};
    'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
      test3[letter] = letter;
    });
    if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
      return false;
    }
    return true;
  } catch (err) {
    return false;
  }
}
var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
  var from;
  var to = toObject(target);
  var symbols;
  for (var s = 1; s < arguments.length; s++) {
    from = Object(arguments[s]);
    for (var key in from) {
      if (hasOwnProperty.call(from, key)) {
        to[key] = from[key];
      }
    }
    if (getOwnPropertySymbols) {
      symbols = getOwnPropertySymbols(from);
      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable.call(from, symbols[i])) {
          to[symbols[i]] = from[symbols[i]];
        }
      }
    }
  }
  return to;
};

var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
var ReactPropTypesSecret_1 = ReactPropTypesSecret;

var has = Function.call.bind(Object.prototype.hasOwnProperty);

var printWarning = function () {};
if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has$1 = has;
  printWarning = function (text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      throw new Error(message);
    } catch (x) {}
  };
}
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has$1(typeSpecs, typeSpecName)) {
        var error;
        try {
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + typeof error + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          loggedTypeFailures[error.message] = true;
          var stack = getStack ? getStack() : '';
          printWarning('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
        }
      }
    }
  }
}
checkPropTypes.resetWarningCache = function () {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};
var checkPropTypes_1 = checkPropTypes;

var printWarning$1 = function () {};
if (process.env.NODE_ENV !== 'production') {
  printWarning$1 = function (text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      throw new Error(message);
    } catch (x) {}
  };
}
function emptyFunctionThatReturnsNull() {
  return null;
}
var factoryWithTypeCheckers = function (isValidElement, throwOnDirectAccess) {
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator';
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }
  var ANONYMOUS = '<<anonymous>>';
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bigint: createPrimitiveTypeChecker('bigint'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),
    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker
  };
  function is(x, y) {
    if (x === y) {
      return x !== 0 || 1 / x === 1 / y;
    } else {
      return x !== x && y !== y;
    }
  }
  function PropTypeError(message, data) {
    this.message = message;
    this.data = data && typeof data === 'object' ? data : {};
    this.stack = '';
  }
  PropTypeError.prototype = Error.prototype;
  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;
      if (secret !== ReactPropTypesSecret_1) {
        if (throwOnDirectAccess) {
          var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use `PropTypes.checkPropTypes()` to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          var cacheKey = componentName + ':' + propName;
          if (!manualPropTypeCallCache[cacheKey] && manualPropTypeWarningCount < 3) {
            printWarning$1('You are manually calling a React.PropTypes validation ' + 'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }
    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
  }
  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        var preciseType = getPreciseType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'), {
          expectedType: expectedType
        });
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }
  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!reactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning$1('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
        } else {
          printWarning$1('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }
      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }
  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning$1('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }
    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning$1('Invalid argument supplied to oneOfType. Expected an array of check functions, but ' + 'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
        return emptyFunctionThatReturnsNull;
      }
    }
    function validate(props, propName, componentName, location, propFullName) {
      var expectedTypes = [];
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1);
        if (checkerResult == null) {
          return null;
        }
        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
          expectedTypes.push(checkerResult.data.expectedType);
        }
      }
      var expectedTypesMessage = expectedTypes.length > 0 ? ', expected one of type [' + expectedTypes.join(', ') + ']' : '';
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
    }
    return createChainableTypeChecker(validate);
  }
  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function invalidValidatorError(componentName, location, propFullName, key, type) {
    return new PropTypeError((componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + type + '`.');
  }
  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      var allKeys = objectAssign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (has(shapeTypes, key) && typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        if (!checker) {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }
  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }
        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }
        return true;
      default:
        return false;
    }
  }
  function isSymbol(propType, propValue) {
    if (propType === 'symbol') {
      return true;
    }
    if (!propValue) {
      return false;
    }
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }
    return false;
  }
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }
  ReactPropTypes.checkPropTypes = checkPropTypes_1;
  ReactPropTypes.resetWarningCache = checkPropTypes_1.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
var factoryWithThrowingShims = function () {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret_1) {
      return;
    }
    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
    err.name = 'Invariant Violation';
    throw err;
  }
  shim.isRequired = shim;
  function getShim() {
    return shim;
  }
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,
    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

var propTypes = createCommonjsModule(function (module) {
  if (process.env.NODE_ENV !== 'production') {
    var ReactIs = reactIs;
    var throwOnDirectAccess = true;
    module.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
  } else {
    module.exports = factoryWithThrowingShims();
  }
});

const Background = ({
  children
}) => {
  return /*#__PURE__*/React__default.createElement("div", {
    className: "banner"
  }, children);
};

const Header = () => {
  const {
    data: storeData,
    isLoading
  } = Digit.Hooks.useStore.getInitData();
  const {
    t
  } = useTranslation();
  if (isLoading) return /*#__PURE__*/React__default.createElement(Loader, null);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "bannerHeader"
  });
};

const Urls = {
  MDMS: `/egov-mdms-service/v1/_search`,
  MdmsSearchV2: `/mdms-v2/v1/_search`,
  MdmsCreateV2: `/mdms-v2/v1/_create`,
  MdmsUpdateV2: `/mdms-v2/v1/_update`,
  opensearchAPI: `/bpa-services/v1/bpa/_plainsearch`,
  WorkFlow: `/egov-workflow-v2/egov-wf/businessservice/_search`,
  WorkFlowProcessSearch: `/egov-workflow-v2/egov-wf/process/_search`,
  WorkFlowProcessCount: `/egov-workflow-v2/egov-wf/process/_count`,
  localization: `/localization/messages/v1/_search`,
  qrCodeURL: {
    bpaQRCode: `/bpa-services/v1/bpa/_qrcodeurl`,
    tlQRCode: `/tl-services/v1/ltp/_qrcodeurl`,
    SelfMap: `/bpa-services/v1/bpa/_qrcodeurl/_SelfMap`
  },
  logoUrl: {
    bpaLogoUrl: `/bpa-services/v1/bpa/_logourl?`
  },
  bpaService: {
    remarksDetail: `/bpa-services/v1/bpa/_remarksDetail/_create`,
    remarksPaymentDetails: `/bpa-services/v1/bpa/_remarksDetail/_search?isApproved=PaymentDetails`,
    khasraDetails: `/bpa-services/v1/bpa/_remarksDetail/_search?isApproved=khasraDetails`,
    nocRemarks: `/bpa-services/v1/bpa/_remarksDetail/_search?isApproved=nocRemarks`,
    remarksDocument: `/bpa-services/v1/bpa/_remarksDetail/_search?isApproved=DocumentDetails`,
    remarksSiteInspection: `/bpa-services/v1/bpa/_remarksDetail/_search?isApproved=InspectionDetail`,
    remarksDrawing: `/bpa-services/v1/bpa/_remarksDetail/_search?isApproved=DrawingsDetails`,
    remarkspFARDetail: `/bpa-services/v1/bpa/_remarksDetail/_search?isApproved=remarksDetails`,
    remarksNoc: `/bpa-services/v1/bpa/_remarksDetail/_search?isApproved=nocDetails`,
    remarksNoting: `/bpa-services/v1/bpa/_remarksDetail/_search1?`,
    getNotice: `/bpa-services/v1/bpa/_getNotice?vaadId=`
  },
  location: {
    localities: `/egov-location/location/v11/boundarys/_search?hierarchyTypeCode=ADMIN&boundaryType=Locality`,
    revenue_localities: `/egov-location/location/v11/boundarys/_search?hierarchyTypeCode=REVENUE&boundaryType=Locality`,
    business_services: `/bpa-services/v1/bpa/business-services`
  },
  pgr_search: `/pgr-services/v2/request/_search`,
  pgr_update: `/pgr-services/v2/request/_update`,
  filter_data: `https://run.mocky.io/v3/597a50a0-90e5-4a45-b82e-8a2186b760bd`,
  FileStore: "/filestore/v1/files",
  FileFetch: "/filestore/v1/files/url",
  PGR_Create: `/pgr-services/v2/request/_create`,
  pgr_count: `/pgr-services/v2/request/_count`,
  OTP_Send: "/user-otp/v1/_send",
  Otp_Validate: "/otp/v1/_validate",
  OTP_Send_verify: "/otp/_verify",
  trackAppliactionStatus: "/bpa-services/v1/bpa/_trackapplicationstatus",
  Authenticate: "/user/oauth/token",
  RegisterUser: "/user/citizen/_create",
  ChangePassword: "/user/password/nologin/_update",
  ChangePassword1: "/user/password/_update",
  UserProfileUpdate: "/user/profile/_update",
  UserCaptchaGenerate: "/user/captcha/generate",
  UserCaptchaValidate: "/user/captcha/validate",
  EmployeeSearch: "/egov-hrms/employees/_search",
  UserManualDelete: "/bpa-services/v1/adminApi/_usermanual/_delete",
  InboxSearch: "/inbox/v1/_search",
  InboxSearchApplication: "/bpa-services/v1/bpa/_dashboard/_count",
  SearchApplication: "/bpa-services/v1/bpa/_dashboard/_applicationDetail",
  tlSearchApplication: "/tl-services/v1/_dashboard/_applicationDetail",
  InboxSearchApplicationProfessional: "/tl-services/v1/_dashboard/_count",
  UserSearch: "/user/_search",
  UserManualCreate: `/bpa-services/v1/adminApi/_usermanual/_create`,
  UserManualSearch: `/bpa-services/v1/adminApi/_usermanual/_search`,
  UserLogout: "/user/_logout",
  Shortener: "/egov-url-shortening/shortener",
  fsm: {
    search: "/fsm/v1/_search",
    create: "/fsm/v1/_create",
    update: "/fsm/v1/_update",
    vendorSearch: "/vendor/v1/_search",
    vehicleSearch: "/vehicle/v1/_search",
    audit: "/fsm/v1/_audit",
    vehicleTripSearch: "/vehicle/trip/v1/_search",
    billingSlabSearch: "/fsm-calculator/v1/billingSlab/_search",
    vehilceUpdate: "/vehicle/trip/v1/_update",
    vehicleTripCreate: "/vehicle/trip/v1/_create"
  },
  form11: {
    create: "/bpa-services/v1/bpa/_createForm",
    auth: "/user/oauth/token"
  },
  form12: {
    create: "/bpa-services/v1/bpa/_createForm",
    auth: "/user/oauth/token"
  },
  payment: {
    fetch_bill: "/billing-service/bill/v2/_fetchbill",
    demandSearch: "/billing-service/demand/_search",
    create_reciept: "/collection-services/payments/_create",
    print_reciept: "/collection-services/payments",
    generate_pdf: "/pdf-service/v1/_create",
    create_citizen_reciept: "/pg-service/transaction/v1/_create",
    update_citizen_reciept: "/pg-service/transaction/v1/_update",
    search_bill: "/billing-service/bill/v2/_search",
    reciept_search: "/collection-services/payments/:buisnessService/_search",
    obps_Reciept_Search: "/collection-services/payments/_search"
  },
  dsc: {
    signParams: "/dsc-service/v1/signature/getSignParams"
  },
  pt: {
    fectch_property: "/property-services/property/_search",
    fetch_payment_details: "/billing-service/bill/v2/_fetchbill",
    create: "/property-services/property/_create",
    search: "/property-services/property/_search",
    update: "/property-services/property/_update",
    pt_calculation_estimate: "/pt-calculator-v2/propertytax/v2/_estimate",
    assessment_create: "/property-services/assessment/_create",
    assessment_search: "/property-services/assessment/_search",
    payment_search: "/collection-services/payments/PT/_search",
    pt_calculate_mutation: "/pt-calculator-v2/propertytax/mutation/_calculate"
  },
  dss: {
    dashboardConfig: "/dashboard-analytics/dashboard/getDashboardConfig",
    getCharts: "/dashboard-analytics/dashboard/getChartV2"
  },
  mcollect: {
    search: "/echallan-services/eChallan/v1/_search",
    create: "/echallan-services/eChallan/v1/_create?",
    fetch_bill: "/billing-service/bill/v2/_fetchbill?",
    search_bill: "/egov-searcher/bill-genie/mcollectbills/_get",
    search_bill_pt: "/egov-searcher/bill-genie/billswithaddranduser/_get",
    update: "/echallan-services/eChallan/v1/_update",
    download_pdf: "/egov-pdf/download/UC/mcollect-challan",
    receipt_download: "/egov-pdf/download/PAYMENT/consolidatedreceipt",
    bill_download: "/egov-pdf/download/bills/consolidatedbill",
    count: "/echallan-services/eChallan/v1/_count"
  },
  hrms: {
    search: "/egov-hrms/employees/_search",
    count: "/egov-hrms/employees/_count",
    create: "/egov-hrms/employees/_create",
    update: "/egov-hrms/employees/_update",
    employeeSearch: "/user/users/_jobdelegation/_employeeSearch",
    employeeFileTransfer: "/user/users/_employeeFileTransfer",
    deactivateUser: "/user/users/_deactivate"
  },
  tl: {
    create: "/tl-services/v1/_create",
    search: "/tl-services/v1/_search",
    fetch_payment_details: "/billing-service/bill/v2/_fetchbill",
    download_pdf: "/egov-pdf/download/TL/",
    update: "/tl-services/v1/_update",
    billingslab: "/tl-calculator/billingslab/_search",
    designOfApproval: "/tl-services/_DesignOfApprovalLetter",
    workflowEsclate: "/egov-workflow-v2/egov-wf/auto/BPAREG/_escalate",
    coaValidate: "/tl-services/v1/validate/_architectureNo",
    misReportRegistration: "/tl-services/v1/_misReportRegistration"
  },
  receipts: {
    receipt_download: "/egov-pdf/download/PAYMENT/consolidatedreceipt",
    payments: "/collection-services/payments",
    count: "/egov-hrms/employees/_count"
  },
  obps: {
    compliance_create: "/bpa-services/_compliance/_create",
    compliance_search: "/bpa-services/_compliance/_search",
    compliance_update: "/bpa-services/_compliance/_update",
    scrutinyDetails: "/edcr/rest/dcr/scrutinydetails",
    comparisionReport: "/edcr/rest/dcr/occomparison",
    create: "/bpa-services/v1/bpa/_create",
    createForm11: "/bpa-services/v1/subdivision/_create",
    createLandUseUP: "/bpa-services/v1/_landUse/_create",
    createOwner: "/bpa-services/v1/_owner/_create",
    updateOwner: "/bpa-services/v1/_owner/_update",
    createPurchasableFAR: "/bpa-services/v1/_purchasableFAR/_create",
    updatePurchasableFAR: "/bpa-services/v1/_purchasableFAR/_update",
    createFormCLU: "/bpa-services/v1/subdivision/_create",
    createForm34: "/bpa-services/v1/subdivision/_create",
    createForm26: "/bpa-services/v1/offences/_create",
    nocSearch: "/noc-services/v1/noc/_search",
    updateNOC: "/noc-services/v1/noc/_update",
    update: "/bpa-services/v1/bpa/_update",
    updateForm11: "/bpa-services/v1/subdivision/_update",
    updateFormCLU: "/bpa-services/v1/subdivision/_update",
    updateForm34: "/bpa-services/v1/subdivision/_update",
    updateFormLandUse: "/bpa-services/v1/_landUse/_update",
    bpaSearch: "/bpa-services/v1/bpa/_search",
    ltpGrading: "/bpa-services/v1/bpa/_dashboard/_fastpasHome",
    bpaSearchChallan: "/bpa-services/v1/bpa/_searchChallan",
    bpaCommonSearch: "/bpa-services/v1/bpa/_commonsearch",
    searchLandUseUP: "/bpa-services/v1/_landUse/_search",
    searchfrom11: "/bpa-services/v1/subdivision/_search",
    searchfrom26: "/bpa-services/v1/subdivision/_search",
    searchFromCLU: "/bpa-services/v1/subdivision/_search",
    searchFrom34: "/bpa-services/v1/subdivision/_search",
    ownerSearch: "/bpa-services/v1/_owner/_search",
    searchPurchasableFar: "/bpa-services/v1/_purchasableFAR/_search",
    bpaRegSearch: "/tl-services/v1/BPAREG/_search",
    bpaRegCreate: "/tl-services/v1/BPAREG/_create",
    bpaRegGetBill: "/tl-calculator/v1/BPAREG/_getbill",
    bpaRegUpdate: "/tl-services/v1/BPAREG/_update",
    receipt_download: "/egov-pdf/download/PAYMENT/consolidatedreceipt",
    edcrreportdownload: "/bpa-services/v1/bpa/_permitorderedcr",
    designOfApproval: "/bpa-services/_DesignOfApprovalLetter",
    designOfStuctural: "/bpa-services/_Structralcertificate",
    farIntimationLetter: "/bpa-services/_FarInimitionLetter",
    scheduleInspection: "/bpa-services/v1/bpa/_dashboard/_inspection",
    applicationDetailData: "/bpa-services/v1/bpa//_dashboard/_applicationDetailData",
    applicationDetailDataView: "/bpa-services/v1/bpa/_dashboard/_applicationDetailData",
    fetchProfessional: "/tl-services/v1/_dashboard/_applicationDetailData",
    fetchAppendex: "/bpa-services/v1/bpa/_dashboard/_applicationDetailData",
    paymentList: "/collection-services/payments/_plainsearch",
    paymentReport: "/bpa-services/v1/_paymentReport",
    echargesReport: "/bpa-services/v1/_echargesReport",
    applicationReport: "/bpa-services/v1/_applicationReport",
    applicationMisReport: "/bpa-services/v1/bpa/_extarctMisData",
    paymentMisReport: "/bpa-services/v1/bpa/_extractAllMisData",
    paymentMisReportNew: "/bpa-services/v1/bpa/_extractAllMisData",
    dashboardReport: "/bpa-services/v1/bpa/_bidashboard",
    scrutinyFailedReport: "/edcr/rest/dcr/not-accepted-files",
    inwardApplicationReport: "/bpa-services/v1/_inwardApplicationReport",
    selfApprovalReport: "/bpa-services/v1/_selfCertification",
    installments: "/bpa-calculator/api/installments/_calculate",
    fastpassSearch: "/bpa-services/v1/bpa/_plainsearch",
    bpaCommonSearch: "/bpa-services/v1/bpa/_commonsearch",
    bpacalculate: "/bpa-calculator/_calculate",
    bpacalculatechallan: "/bpa-calculator/_calculateChallan",
    deleteChallan: "/bpa-calculator/bpa/delete-challan",
    migratedSearch: "/bpa-services/v1/bpamigration/_search",
    migratedSearchappNo: "/bpa-services/v1/bpamigration/_searchByAppNo",
    employeeSearchList: "/user/users/_jobdelegation/_employeeSearch",
    totalAmountOfCharges: "/bpa-services/v1/bpa/_totalAmountOfCharges",
    taxHeadEstimateSearch: "/bpa-services/v1/bpa/_taxHeadEstimateSearch",
    employeeWorkflowCount: "/bpa-services/v1/adminApi/_employee-workflow-count",
    installmentCalculate: "/bpa-calculator/_insatllmentCalculate",
    checkPaymentStatus: "/bpa-ui/application-payment-status/live-status",
    challanUpdaterDirect: "/bpa-ui/challan-updater-direct",
    getSelfApprovalData: "/bpa-services/v1/bpa/_dashboard/_selfcount"
  },
  edcr: {
    create: "/edcr/rest/dcr/scrutinize"
  },
  land: {
    chatBoard_data_search: "/land-services/egscrutiny/_search1?applicationNumber",
    chatBoard_data_search3: "/land-services/egscrutiny/_search3?applicationNumber",
    modal_data_search: "/land-services/egscrutiny/_search?applicationNumber"
  },
  events: {
    search: "/egov-user-event/v1/events/_search",
    update: "/egov-user-event/v1/events/lat/_update",
    updateEvent: "/egov-user-event/v1/events/_update",
    updateEventCDG: "/egov-user-event/v1/events/lat/_update",
    count: "/egov-user-event/v1/events/notifications/_count",
    create: "/egov-user-event/v1/events/_create"
  },
  ws: {
    water_search: "/ws-services/wc/_search",
    sewarage_search: "/sw-services/swc/_search"
  },
  engagement: {
    document: {
      search: "/egov-document-uploader/egov-du/document/_search",
      create: "/egov-document-uploader/egov-du/document/_create",
      delete: "/egov-document-uploader/egov-du/document/_delete",
      update: "/egov-document-uploader/egov-du/document/_update"
    },
    surveys: {
      create: "/egov-survey-services/egov-ss/survey/_create",
      update: "/egov-survey-services/egov-ss/survey/_update",
      search: "/egov-survey-services/egov-ss/survey/_search",
      delete: "/egov-survey-services/egov-ss/survey/_delete",
      submitResponse: "/egov-survey-services/egov-ss/survey/response/_submit",
      showResults: "/egov-survey-services/egov-ss/survey/response/_results"
    }
  },
  noc: {
    nocSearch: "/noc-services/v1/noc/_search",
    nocExcelSearch: "/noc-services/v1/noc/excel/search",
    nocExcelCreate: "/noc-services/v1/noc/excel/create",
    nocExcelUpdate: "/noc-services/v1/noc/excel/update",
    nocCountSearch: "/noc-services/v1/noc/_dashboard/noc/_count",
    nocCountApplicationData: "/noc-services/v1/noc/_dashboard/noc/_applicationDetailData"
  }
};

axios.defaults.headers.common['X-XSS-Protection'] = '1; mode=block';
axios.defaults.headers.common['X-Frame-Options'] = 'DENY';
axios.defaults.headers.common['Content-Security-Policy'] = "frame-ancestors 'none';";
axios.defaults.headers.common['X-Content-Type-Options'] = 'nosniff';
axios.defaults.headers.common['Strict-Transport-Security'] = 'max-age=31536000; includeSubDomains; preload';
axios.defaults.headers.common['Cache-Control'] = 'no-cache, no-store, must-revalidate';
axios.interceptors.response.use(res => res, err => {
  const isEmployee = window.location.pathname.split("/").includes("employee");
  if (err && err.response && err.response.data && err.response.data.Errors) {
    for (const error of err.response.data.Errors) {
      if (error.message.includes("InvalidAccessTokenException")) {
        localStorage.clear();
        sessionStorage.clear();
        window.location.href = "/digit-ui/citizen" + `?from=${encodeURIComponent(window.location.pathname + window.location.search)}`;
      }
    }
  }
  throw err;
});
const requestInfo = () => ({
  authToken: Digit.UserService.getUser().access_token || null
});
const authHeaders = () => ({
  "auth-token": Digit.UserService.getUser().access_token || null
});
const userServiceData = () => ({
  userInfo: Digit.UserService.getUser().info
});
window.Digit = window.Digit || {};
window.Digit = {
  ...window.Digit,
  RequestCache: window.Digit.RequestCache || {}
};
const Request = async ({
  method: _method = "POST",
  url,
  data: _data = {},
  headers: _headers = {},
  useCache: _useCache = false,
  params: _params = {},
  auth,
  urlParams: _urlParams = {},
  userService,
  locale: _locale = true,
  authHeader: _authHeader = false,
  setTimeParam: _setTimeParam = true,
  userDownload: _userDownload = false,
  noResponseData: _noResponseData = false,
  noRequestInfo: _noRequestInfo = false,
  multipartFormData: _multipartFormData = false,
  multipartData: _multipartData = {}
}) => {
  if (_method.toUpperCase() === "POST") {
    const ts = new Date().getTime();
    _data.RequestInfo = {
      apiId: "Rainmaker"
    };
    if (auth) {
      _data.RequestInfo = {
        ..._data.RequestInfo,
        ...requestInfo()
      };
    }
    if (userService) {
      _data.RequestInfo = {
        ..._data.RequestInfo,
        ...userServiceData()
      };
    }
    if (_locale) {
      _data.RequestInfo = {
        ..._data.RequestInfo,
        msgId: `${ts}|${Digit.StoreData.getCurrentLanguage()}`
      };
    }
    if (_noRequestInfo) {
      delete _data.RequestInfo;
    }
  }
  const headers1 = {
    "Content-Type": "application/json",
    Accept: window.globalConfigs.getConfig("ENABLE_SINGLEINSTANCE") ? "application/pdf,application/json" : "*/*",
    "X-XSS-Protection": "1; mode=block",
    "X-Frame-Options": "DENY",
    "Content-Security-Policy": "frame-ancestors 'none';",
    "X-Content-Type-Options": "nosniff",
    "Strict-Transport-Security": "max-age=31536000; includeSubDomains; preload",
    "Cache-Control": "no-cache, no-store, must-revalidate"
  };
  if (_authHeader) _headers = {
    ..._headers,
    ...authHeaders()
  };
  if (_userDownload) _headers = {
    ..._headers,
    ...headers1
  };
  let key = "";
  if (_useCache) {
    key = `${_method.toUpperCase()}.${url}.${btoa(escape(JSON.stringify(_params, null, 0)))}.${btoa(escape(JSON.stringify(_data, null, 0)))}`;
    const value = window.Digit.RequestCache[key];
    if (value) {
      return value;
    }
  } else if (_setTimeParam) {
    _params._ = Date.now();
  }
  let _url = url.split("/").map(path => {
    let key = path.split(":")[1];
    return _urlParams[key] ? _urlParams[key] : path;
  }).join("/");
  if (_multipartFormData) {
    const multipartFormDataRes = await axios({
      method: _method,
      url: _url,
      data: _multipartData.data,
      params: _params,
      headers: {
        "Content-Type": "multipart/form-data",
        "auth-token": Digit.UserService.getUser().access_token || null
      }
    });
    return multipartFormDataRes;
  }
  const tenantInfo = Digit.SessionStorage.get("userType") === "citizen" ? Digit.ULBService.getStateId() : Digit.ULBService.getCurrentTenantId() || Digit.ULBService.getStateId();
  if (!_params["tenantId"] && window.globalConfigs.getConfig("ENABLE_SINGLEINSTANCE")) {
    _params["tenantId"] = tenantInfo;
  }
  const res = _userDownload ? await axios({
    method: _method,
    url: _url,
    data: _data,
    params: _params,
    headers: _headers,
    responseType: "arraybuffer"
  }) : await axios({
    method: _method,
    url: _url,
    data: _data,
    params: _params,
    headers: _headers
  });
  if (_userDownload) return res;
  if (_noResponseData) return res;
  const returnData = res.data || res.response.data || {};
  if (_useCache && res.data && Object.keys(returnData).length !== 0) {
    window.Digit.RequestCache[key] = returnData;
  }
  return returnData;
};
const ServiceRequest = async ({
  serviceName,
  method: _method2 = "POST",
  url,
  data: _data2 = {},
  headers: _headers2 = {},
  useCache: _useCache2 = false,
  params: _params2 = {},
  auth,
  userService
}) => {
  const preHookName = `${serviceName}Pre`;
  const postHookName = `${serviceName}Post`;
  let reqParams = _params2;
  let reqData = _data2;
  if (window[preHookName] && typeof window[preHookName] === "function") {
    let preHookRes = await window[preHookName]({
      params: _params2,
      data: _data2
    });
    reqParams = preHookRes.params;
    reqData = preHookRes.data;
  }
  const resData = await Request({
    method: _method2,
    url,
    data: reqData,
    headers: _headers2,
    useCache: _useCache2,
    params: reqParams,
    auth,
    userService
  });
  if (window[postHookName] && typeof window[postHookName] === "function") {
    return await window[postHookName](resData);
  }
  return resData;
};

const TLService = {
  create: (details, tenantId) => Request({
    url: Urls.tl.create,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  search: details => Request({
    url: Urls.tl.search,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: details,
    auth: true
  }),
  search_bill: ({
    tenantId,
    filters
  }) => Request({
    url: filters.businesService !== "PT" ? Urls.mcollect.search_bill : Urls.mcollect.search_bill_pt,
    useCache: false,
    method: "POST",
    data: {
      searchCriteria: {
        tenantId,
        ...filters
      }
    },
    auth: true,
    userService: false
  }),
  TLsearch: ({
    tenantId,
    filters
  }) => Request({
    url: Urls.tl.search,
    useCache: false,
    method: "POST",
    auth: true,
    userService: false,
    params: {
      tenantId,
      ...filters
    }
  }),
  update: (details, tenantId) => Request({
    url: Urls.tl.update,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  billingslab: ({
    tenantId,
    filters,
    auth
  }) => Request({
    url: Urls.tl.billingslab,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {
      tenantId
    },
    auth: true
  }),
  designOfApprovalLetterPdf: (tenantId, applicationNumber, params) => Request({
    url: Urls.tl.designOfApproval,
    params: {
      tenantId,
      applicationNumber,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST",
    userDownload: true
  }),
  workflowEsclate: () => Request({
    url: Urls.tl.workflowEsclate,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    auth: true
  }),
  coaValidate: (details, tenantId) => Request({
    url: Urls.tl.coaValidate,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  misReportRegistration: (tenantId, params) => Request({
    url: Urls.tl.misReportRegistration,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  })
};

const StyledTextField = styled(TextField)(() => ({
  "& .MuiOutlinedInput-input": {
    padding: "10px 15px"
  }
}));
const useStyles = makeStyles(theme => ({
  root: {
    height: "100vh",
    backgroundImage: 'url("https://t3.ftcdn.net/jpg/02/99/39/50/360_F_299395041_SEg76lLpIaGAPRjI3uPqIdd3nm3ecRpv.jpg")',
    backgroundSize: "cover",
    backgroundPosition: "center center",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    objectFit: "cover",
    imageRendering: "auto",
    opacity: ".85"
  },
  overlay: {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(255, 255, 255, 0.8)"
  },
  card: {
    padding: "10px",
    backgroundColor: "rgba(255, 255, 255, 0.8)",
    border: "2px 0px 2px 2px",
    width: "370px",
    backgroundSize: ""
  },
  logo: {
    width: "110px",
    height: "85px"
  },
  header: {
    marginBottom: "10px",
    textDecoration: "none"
  },
  textField: {
    marginBottom: "10px"
  },
  button: {
    marginTop: "20px",
    width: "223px",
    height: "35px",
    borderRadius: "1px"
  }
}));
const EmployeeLoginCard = () => {
  const classes = useStyles();
  const tenantId = Digit.ULBService.getStateId();
  const setEmployeeDetail = (userObject, token) => {
    var _JSON$parse;
    let locale = ((_JSON$parse = JSON.parse(sessionStorage.getItem("Digit.locale"))) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.value) || "en_IN";
    localStorage.setItem("Employee.tenant-id", userObject === null || userObject === void 0 ? void 0 : userObject.tenantId);
    localStorage.setItem("tenant-id", userObject === null || userObject === void 0 ? void 0 : userObject.tenantId);
    localStorage.setItem("citizen.userRequestObject", JSON.stringify(userObject));
    localStorage.setItem("locale", locale);
    localStorage.setItem("Employee.locale", locale);
    localStorage.setItem("token", token);
    localStorage.setItem("Employee.token", token);
    localStorage.setItem("user-info", JSON.stringify(userObject));
    localStorage.setItem("Employee.user-info", JSON.stringify(userObject));
  };
  const {
    data: storeData,
    isLoading: isStoreLoading
  } = Digit.Hooks.useStore.getInitData();
  const {
    register,
    handleSubmit,
    watch
  } = useForm();
  const [user, setUser] = useState(null);
  const [showToast, setShowToast] = useState(null);
  const [disable, setDisable] = useState(true);
  const [captcha, setCaptcha] = useState("");
  const [captchaInput, setCaptchaInput] = useState("");
  const history = useHistory();
  useEffect(() => {
    var _user$info, _user$info$roles, _user$info2, _user$info2$roles, _window, _window$location, _window$location$href, _user$info3, _user$info4, _user$info4$roles, _user$info5, _user$info6, _user$info6$roles;
    if (!user) {
      return;
    }
    Digit.SessionStorage.set("citizen.userRequestObject", user);
    const filteredRoles = user === null || user === void 0 ? void 0 : (_user$info = user.info) === null || _user$info === void 0 ? void 0 : (_user$info$roles = _user$info.roles) === null || _user$info$roles === void 0 ? void 0 : _user$info$roles.filter(role => role.tenantId === Digit.SessionStorage.get("Employee.tenantId"));
    if ((user === null || user === void 0 ? void 0 : (_user$info2 = user.info) === null || _user$info2 === void 0 ? void 0 : (_user$info2$roles = _user$info2.roles) === null || _user$info2$roles === void 0 ? void 0 : _user$info2$roles.length) > 0) user.info.roles = filteredRoles;
    Digit.UserService.setUser(user);
    setEmployeeDetail(user === null || user === void 0 ? void 0 : user.info, user === null || user === void 0 ? void 0 : user.access_token);
    let redirectPath = "/digit-ui/employee";
    if ((_window = window) !== null && _window !== void 0 && (_window$location = _window.location) !== null && _window$location !== void 0 && (_window$location$href = _window$location.href) !== null && _window$location$href !== void 0 && _window$location$href.includes("from=")) {
      var _window2, _window2$location, _window2$location$hre, _window2$location$hre2;
      redirectPath = decodeURIComponent((_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$location = _window2.location) === null || _window2$location === void 0 ? void 0 : (_window2$location$hre = _window2$location.href) === null || _window2$location$hre === void 0 ? void 0 : (_window2$location$hre2 = _window2$location$hre.split("from=")) === null || _window2$location$hre2 === void 0 ? void 0 : _window2$location$hre2[1]) || "/digit-ui/employee";
    }
    if (user !== null && user !== void 0 && (_user$info3 = user.info) !== null && _user$info3 !== void 0 && _user$info3.roles && user !== null && user !== void 0 && (_user$info4 = user.info) !== null && _user$info4 !== void 0 && (_user$info4$roles = _user$info4.roles) !== null && _user$info4$roles !== void 0 && _user$info4$roles.every(e => e.code === "NATADMIN")) {
      redirectPath = "/digit-ui/employee/payment/integration/dss/NURT_DASHBOARD";
    }
    if (user !== null && user !== void 0 && (_user$info5 = user.info) !== null && _user$info5 !== void 0 && _user$info5.roles && user !== null && user !== void 0 && (_user$info6 = user.info) !== null && _user$info6 !== void 0 && (_user$info6$roles = _user$info6.roles) !== null && _user$info6$roles !== void 0 && _user$info6$roles.every(e => e.code === "STADMIN")) {
      redirectPath = "/digit-ui/employee/payment/integration/dss/home";
    }
    history.replace(redirectPath);
  }, [user]);
  useEffect(() => {
    generateCaptcha();
  }, []);
  useEffect(() => {
    if (captcha === captchaInput) {
      setDisable(false);
    } else {
      setDisable(true);
    }
  }, [captcha, captchaInput]);
  const generateCaptcha = () => {
    const randomCaptcha = Math.floor(1000 + Math.random() * 9000).toString();
    setCaptcha(randomCaptcha);
    setCaptchaInput("");
  };
  const trackEscalteApplication = async () => {
    const result = await TLService.workflowEsclate();
  };
  useEffect(() => {
    trackEscalteApplication();
  }, []);
  const onLogin = async data => {
    if (captcha !== captchaInput) {
      setShowToast({
        error: true,
        message: `Invalid CAPTCHA`
      });
      setTimeout(closeToast, 5000);
      return;
    }
    setDisable(true);
    const requestData = {
      username: data === null || data === void 0 ? void 0 : data.username,
      password: data === null || data === void 0 ? void 0 : data.password,
      userType: "EMPLOYEE"
    };
    requestData.tenantId = tenantId;
    delete requestData.city;
    try {
      const {
        UserRequest: info,
        ...tokens
      } = await Digit.UserService.authenticate(requestData);
      Digit.SessionStorage.set("Employee.tenantId", info === null || info === void 0 ? void 0 : info.tenantId);
      setUser({
        info,
        ...tokens
      });
    } catch (err) {
      setShowToast({
        error: true,
        message: `Invalid Login Credential`
      });
      setTimeout(closeToast, 5000);
    }
    setDisable(false);
  };
  const closeToast = () => {
    setShowToast(null);
  };
  const onForgotPassword = () => {
    history.push("/digit-ui/employee/user/forgot-password");
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React__default.createElement(Container, {
    component: "main",
    maxWidth: "xs"
  }, /*#__PURE__*/React__default.createElement(Card, {
    className: classes.card
  }, /*#__PURE__*/React__default.createElement(CssBaseline, null), /*#__PURE__*/React__default.createElement(CardContent, null, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    justifyContent: "center",
    alignItems: "center",
    spacing: 2
  }, /*#__PURE__*/React__default.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React__default.createElement("img", {
    src: "https://upload.wikimedia.org/wikipedia/commons/f/fa/Seal_of_Uttar_Pradesh.svg",
    alt: "Logo",
    className: classes.logo
  })), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React__default.createElement(Typography, {
    component: "h6",
    align: "center",
    style: {
      fontWeight: "600",
      fontFamily: "sans-serif",
      lineHeight: "24px",
      letterSpacing: ".5px"
    },
    className: classes.header
  }, "EMPLOYEE LOGIN")), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React__default.createElement(InputLabel, null, "Employee ID"), /*#__PURE__*/React__default.createElement(StyledTextField, Object.assign({}, register("username", {
    required: true
  }), {
    margin: "normal",
    variant: "outlined",
    required: true,
    fullWidth: true,
    id: "username",
    label: "",
    name: "username",
    placeholder: "Enter Employee ID",
    autoFocus: true,
    className: classes.textField,
    autoComplete: "off"
  }))), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React__default.createElement(InputLabel, {
    htmlFor: "password"
  }, "Password"), /*#__PURE__*/React__default.createElement(StyledTextField, Object.assign({}, register("password", {
    required: true
  }), {
    variant: "outlined",
    margin: "normal",
    required: true,
    fullWidth: true,
    name: "password",
    placeholder: "Enter Password",
    label: "",
    type: "password",
    id: "password",
    autoComplete: "off",
    className: classes.textField
  }))), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12,
    container: true,
    alignItems: "center"
  }, /*#__PURE__*/React__default.createElement(StyledTextField, {
    variant: "outlined",
    margin: "normal",
    required: true,
    fullWidth: true,
    id: "captcha",
    placeholder: "Enter CAPTCHA",
    autoComplete: "off",
    name: "captcha",
    value: captchaInput,
    onChange: e => setCaptchaInput(e.target.value),
    inputProps: {
      maxLength: 4
    }
  }), /*#__PURE__*/React__default.createElement(InputLabel, null, "CAPTCHA: ", /*#__PURE__*/React__default.createElement("span", {
    style: {
      fontStyle: "italic",
      fontSize: "16px"
    }
  }, captcha), /*#__PURE__*/React__default.createElement(IconButton, null, /*#__PURE__*/React__default.createElement(CachedIcon, {
    onClick: generateCaptcha
  })))), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React__default.createElement(Button, {
    type: "submit",
    fullWidth: true,
    variant: "contained",
    color: "primary",
    className: classes.button,
    onClick: handleSubmit(onLogin),
    disabled: disable
  }, "Continue")), /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React__default.createElement(Typography, {
    component: "div",
    align: "center",
    onClick: onForgotPassword,
    style: {
      cursor: "pointer",
      color: "#303F9F"
    }
  }, "Forgot Password?")))))), showToast && /*#__PURE__*/React__default.createElement(Toast, {
    error: showToast === null || showToast === void 0 ? void 0 : showToast.error,
    warning: showToast === null || showToast === void 0 ? void 0 : showToast.warning,
    label: showToast === null || showToast === void 0 ? void 0 : showToast.message,
    onClose: closeToast,
    isDleteBtn: true
  }));
};

const EmployeeLogin = () => {
  const {
    t
  } = useTranslation();
  const {
    path
  } = useRouteMatch();
  const loginParams = useMemo(() => loginConfig.map(step => {
    const texts = {};
    for (const key in step.texts) {
      texts[key] = t(step.texts[key]);
    }
    return {
      ...step,
      texts
    };
  }, [loginConfig]));
  return /*#__PURE__*/React__default.createElement(Switch, null, /*#__PURE__*/React__default.createElement(Route, {
    path: `${path}`,
    exact: true
  }, /*#__PURE__*/React__default.createElement(Box, null, /*#__PURE__*/React__default.createElement(EmployeeLoginCard, null))));
};

const config = [{
  texts: {
    header: "CORE_COMMON_RESET_PASSWORD_LABEL",
    submitButtonLabel: "CORE_COMMON_CHANGE_PASSWORD"
  },
  inputs: [{
    label: "CORE_LOGIN_USERNAME",
    type: "text",
    name: "userName",
    error: "ERR_HRMS_INVALID_USERNAME"
  }, {
    label: "CORE_LOGIN_NEW_PASSWORD",
    type: "password",
    name: "newPassword",
    error: "CORE_COMMON_REQUIRED_ERRMSG"
  }, {
    label: "CORE_LOGIN_CONFIRM_NEW_PASSWORD",
    type: "password",
    name: "confirmPassword",
    error: "CORE_COMMON_REQUIRED_ERRMSG"
  }]
}];

const ChangePasswordComponent = ({
  config: propsConfig,
  t
}) => {
  const [user, setUser] = useState(null);
  const {
    mobile_number: mobileNumber,
    tenantId
  } = Digit.Hooks.useQueryParams();
  const history = useHistory();
  const location = useLocation();
  const [otp, setOtp] = useState("");
  const [isOtpValid, setIsOtpValid] = useState(true);
  const [showToast, setShowToast] = useState(null);
  const getUserType = () => Digit.UserService.getType();
  useEffect(() => {
    var _location$state;
    if (!user) {
      Digit.UserService.setType("employee");
      return;
    }
    Digit.UserService.setUser(user);
    const redirectPath = ((_location$state = location.state) === null || _location$state === void 0 ? void 0 : _location$state.from) || "/digit-ui/employee";
    history.replace(redirectPath);
  }, [user]);
  const closeToast = () => {
    setShowToast(null);
  };
  const onResendOTP = async () => {
    const requestData = {
      otp: {
        mobileNumber,
        userType: getUserType().toUpperCase(),
        type: "passwordreset",
        tenantId
      }
    };
    try {
      await Digit.UserService.sendOtp(requestData, tenantId);
      setShowToast(t("ES_OTP_RESEND"));
    } catch (err) {
      var _err$response, _err$response$data;
      setShowToast((err === null || err === void 0 ? void 0 : (_err$response = err.response) === null || _err$response === void 0 ? void 0 : (_err$response$data = _err$response.data) === null || _err$response$data === void 0 ? void 0 : _err$response$data.error_description) || t("ES_INVALID_LOGIN_CREDENTIALS"));
    }
    setTimeout(closeToast, 5000);
  };
  const onChangePassword = async data => {
    try {
      if (data.newPassword !== data.confirmPassword) {
        return setShowToast(t("ERR_PASSWORD_DO_NOT_MATCH"));
      }
      const requestData = {
        ...data,
        otpReference: otp,
        tenantId,
        type: getUserType().toUpperCase()
      };
      const response = await Digit.UserService.changePasswordNoLogin(requestData, tenantId);
      navigateToLogin();
    } catch (err) {
      var _err$response2, _err$response2$data, _err$response2$data$e, _err$response2$data$e2, _err$response2$data$e3;
      setShowToast((err === null || err === void 0 ? void 0 : (_err$response2 = err.response) === null || _err$response2 === void 0 ? void 0 : (_err$response2$data = _err$response2.data) === null || _err$response2$data === void 0 ? void 0 : (_err$response2$data$e = _err$response2$data.error) === null || _err$response2$data$e === void 0 ? void 0 : (_err$response2$data$e2 = _err$response2$data$e.fields) === null || _err$response2$data$e2 === void 0 ? void 0 : (_err$response2$data$e3 = _err$response2$data$e2[0]) === null || _err$response2$data$e3 === void 0 ? void 0 : _err$response2$data$e3.message) || t("ES_SOMETHING_WRONG"));
      setTimeout(closeToast, 5000);
    }
  };
  const navigateToLogin = () => {
    history.replace("/digit-ui/employee/user/login");
  };
  const [username, password, confirmPassword] = propsConfig.inputs;
  const config = [{
    body: [{
      label: t(username.label),
      type: username.type,
      populators: {
        name: username.name
      },
      isMandatory: true
    }, {
      label: t(password.label),
      type: password.type,
      populators: {
        name: password.name
      },
      isMandatory: true
    }, {
      label: t(confirmPassword.label),
      type: confirmPassword.type,
      populators: {
        name: confirmPassword.name
      },
      isMandatory: true
    }]
  }];
  return /*#__PURE__*/React__default.createElement(Background, null, /*#__PURE__*/React__default.createElement("div", {
    className: "employeeBackbuttonAlign"
  }, /*#__PURE__*/React__default.createElement(BackButton, {
    variant: "white",
    style: {
      borderBottom: "none"
    }
  })), /*#__PURE__*/React__default.createElement(FormComposer, {
    onSubmit: onChangePassword,
    noBoxShadow: true,
    inline: true,
    submitInForm: true,
    config: config,
    label: propsConfig.texts.submitButtonLabel,
    cardStyle: {
      maxWidth: "408px",
      margin: "auto"
    },
    className: "employeeChangePassword"
  }, /*#__PURE__*/React__default.createElement(Header, null), /*#__PURE__*/React__default.createElement(CardSubHeader, {
    style: {
      textAlign: "center"
    }
  }, " ", propsConfig.texts.header, " "), /*#__PURE__*/React__default.createElement(CardText, null, `${t(`CS_LOGIN_OTP_TEXT`)} `, /*#__PURE__*/React__default.createElement("b", null, " ", `${t(`+ 91 - `)}`, " ", mobileNumber)), /*#__PURE__*/React__default.createElement(SelectOtp, {
    t: t,
    userType: "employee",
    otp: otp,
    onOtpChange: setOtp,
    error: isOtpValid,
    onResend: onResendOTP
  })), showToast && /*#__PURE__*/React__default.createElement(Toast, {
    error: true,
    label: t(showToast),
    onClose: closeToast
  }), /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%",
      position: "fixed",
      bottom: 0,
      backgroundColor: "white",
      textAlign: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "center",
      color: "black"
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      cursor: "pointer",
      fontSize: window.Digit.Utils.browser.isMobile() ? "12px" : "12px",
      fontWeight: "400"
    },
    onClick: () => {
      window.open("https://www.digit.org/", "_blank").focus();
    }
  }, "Powered by UPYOG"), /*#__PURE__*/React__default.createElement("span", {
    style: {
      margin: "0 10px",
      fontSize: window.Digit.Utils.browser.isMobile() ? "12px" : "12px"
    }
  }, "|"), /*#__PURE__*/React__default.createElement("a", {
    style: {
      cursor: "pointer",
      fontSize: window.Digit.Utils.browser.isMobile() ? "12px" : "12px",
      fontWeight: "400"
    },
    href: "#",
    target: "_blank"
  }, "UPYOG License"), /*#__PURE__*/React__default.createElement("span", {
    className: "upyog-copyright-footer",
    style: {
      margin: "0 10px",
      fontSize: "12px"
    }
  }, "|"), /*#__PURE__*/React__default.createElement("span", {
    className: "upyog-copyright-footer",
    style: {
      cursor: "pointer",
      fontSize: window.Digit.Utils.browser.isMobile() ? "12px" : "12px",
      fontWeight: "400"
    },
    onClick: () => {
      window.open("https://niua.in/", "_blank").focus();
    }
  }, "Copyright \xA9 2022 National Institute of Urban Affairs")), /*#__PURE__*/React__default.createElement("div", {
    className: "upyog-copyright-footer-web"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "",
    style: {
      cursor: "pointer",
      fontSize: window.Digit.Utils.browser.isMobile() ? "14px" : "16px",
      fontWeight: "400"
    },
    onClick: () => {
      window.open("https://niua.in/", "_blank").focus();
    }
  }, "Copyright \xA9 2022 National Institute of Urban Affairs"))));
};
ChangePasswordComponent.propTypes = {
  loginParams: propTypes.any
};
ChangePasswordComponent.defaultProps = {
  loginParams: null
};

const EmployeeChangePassword = () => {
  const {
    t
  } = useTranslation();
  const {
    path
  } = useRouteMatch();
  const params = useMemo(() => config.map(step => {
    const texts = {};
    for (const key in step.texts) {
      texts[key] = t(step.texts[key]);
    }
    return {
      ...step,
      texts
    };
  }, [config]));
  return /*#__PURE__*/React__default.createElement(Switch, null, /*#__PURE__*/React__default.createElement(Route, {
    path: `${path}`,
    exact: true
  }, /*#__PURE__*/React__default.createElement(ChangePasswordComponent, {
    config: params[0],
    t: t
  })));
};

const loginConfig$1 = [{
  texts: {
    header: "CORE_COMMON_FORGOT_PASSWORD_LABEL",
    description: "ES_FORGOT_PASSWORD_DESC",
    submitButtonLabel: "CORE_COMMON_CONTINUE"
  },
  inputs: [{
    label: "CORE_COMMON_MOBILE_NUMBER",
    type: "text",
    name: "mobileNumber",
    error: "ERR_HRMS_INVALID_MOBILE_NUMBER"
  }, {
    label: "CORE_COMMON_CITY",
    type: "custom",
    name: "city",
    error: "ERR_HRMS_INVALID_CITY"
  }]
}];

const ForgotPassword = ({
  config: propsConfig,
  t
}) => {
  const {
    data: cities,
    isLoading
  } = Digit.Hooks.useTenants();
  const [user, setUser] = useState(null);
  const history = useHistory();
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const [showToast, setShowToast] = useState(null);
  const getUserType = () => Digit.UserService.getType();
  useEffect(() => {
    var _location$state;
    if (!user) {
      Digit.UserService.setType("employee");
      return;
    }
    Digit.UserService.setUser(user);
    const redirectPath = ((_location$state = location.state) === null || _location$state === void 0 ? void 0 : _location$state.from) || "/digit-ui/employee";
    history.replace(redirectPath);
  }, [user]);
  const closeToast = () => {
    setShowToast(null);
  };
  const onForgotPassword = async data => {
    if (!data.city) {
      alert("Please Select City!");
      return;
    }
    const requestData = {
      otp: {
        mobileNumber: data.mobileNumber,
        userType: getUserType().toUpperCase(),
        type: "passwordreset",
        tenantId: tenantId
      }
    };
    try {
      const otpResponse = await Digit.UserService.sendOtp(requestData, tenantId);
      if (otpResponse !== null && otpResponse !== void 0 && otpResponse.isSuccessful) {
        history.push(`/digit-ui/employee/user/change-password?mobile_number=${data.mobileNumber}&tenantId=${tenantId}`);
      } else {
        setShowToast("OTP could not be sent. Please try again.");
        setTimeout(closeToast, 5000);
      }
    } catch (err) {
      var _err$response, _err$response$data, _err$response$data$er, _err$response$data$er2, _err$response$data$er3;
      setShowToast((err === null || err === void 0 ? void 0 : (_err$response = err.response) === null || _err$response === void 0 ? void 0 : (_err$response$data = _err$response.data) === null || _err$response$data === void 0 ? void 0 : (_err$response$data$er = _err$response$data.error) === null || _err$response$data$er === void 0 ? void 0 : (_err$response$data$er2 = _err$response$data$er.fields) === null || _err$response$data$er2 === void 0 ? void 0 : (_err$response$data$er3 = _err$response$data$er2[0]) === null || _err$response$data$er3 === void 0 ? void 0 : _err$response$data$er3.message) || "Invalid login credentials!");
      setTimeout(closeToast, 5000);
    }
  };
  const navigateToLogin = () => {
    history.replace("/digit-ui/employee/login");
  };
  const [userId, city] = propsConfig.inputs;
  const config = [{
    body: [{
      label: t(userId.label),
      type: userId.type,
      populators: {
        name: userId.name,
        componentInFront: "+91",
        maxlength: 10
      },
      isMandatory: true
    }, {
      label: t(city.label),
      type: city.type,
      populators: {
        name: city.name,
        customProps: {},
        component: (props, customProps) => /*#__PURE__*/React__default.createElement(Dropdown, Object.assign({
          option: cities,
          optionKey: "name",
          id: city.name,
          className: "login-city-dd",
          select: d => {
            props.onChange(d);
          }
        }, customProps))
      },
      isMandatory: true
    }]
  }];
  if (isLoading) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  return /*#__PURE__*/React__default.createElement(Background, null, /*#__PURE__*/React__default.createElement("div", {
    className: "employeeBackbuttonAlign"
  }, /*#__PURE__*/React__default.createElement(BackButton, {
    variant: "white",
    style: {
      borderBottom: "none"
    }
  })), /*#__PURE__*/React__default.createElement(FormComposer, {
    onSubmit: onForgotPassword,
    noBoxShadow: true,
    inline: true,
    submitInForm: true,
    config: config,
    label: propsConfig.texts.submitButtonLabel,
    secondaryActionLabel: propsConfig.texts.secondaryButtonLabel,
    onSecondayActionClick: navigateToLogin,
    heading: propsConfig.texts.header,
    description: propsConfig.texts.description,
    headingStyle: {
      textAlign: "center"
    },
    cardStyle: {
      maxWidth: "408px",
      margin: "auto"
    },
    className: "employeeForgotPassword"
  }, /*#__PURE__*/React__default.createElement(Header, null)), showToast && /*#__PURE__*/React__default.createElement(Toast, {
    error: true,
    label: t(showToast),
    onClose: closeToast
  }), /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%",
      position: "fixed",
      bottom: 0,
      backgroundColor: "white",
      textAlign: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "center",
      color: "black"
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      cursor: "pointer",
      fontSize: window.Digit.Utils.browser.isMobile() ? "12px" : "12px",
      fontWeight: "400"
    },
    onClick: () => {
      window.open("https://www.digit.org/", "_blank").focus();
    }
  }, "Powered by UPYOG"), /*#__PURE__*/React__default.createElement("span", {
    style: {
      margin: "0 10px",
      fontSize: window.Digit.Utils.browser.isMobile() ? "12px" : "12px"
    }
  }, "|"), /*#__PURE__*/React__default.createElement("a", {
    style: {
      cursor: "pointer",
      fontSize: window.Digit.Utils.browser.isMobile() ? "12px" : "12px",
      fontWeight: "400"
    },
    href: "#",
    target: "_blank"
  }, "UPYOG License"), /*#__PURE__*/React__default.createElement("span", {
    className: "upyog-copyright-footer",
    style: {
      margin: "0 10px",
      fontSize: "12px"
    }
  }, "|"), /*#__PURE__*/React__default.createElement("span", {
    className: "upyog-copyright-footer",
    style: {
      cursor: "pointer",
      fontSize: window.Digit.Utils.browser.isMobile() ? "12px" : "12px",
      fontWeight: "400"
    },
    onClick: () => {
      window.open("https://niua.in/", "_blank").focus();
    }
  }, "Copyright \xA9 2022 National Institute of Urban Affairs")), /*#__PURE__*/React__default.createElement("div", {
    className: "upyog-copyright-footer-web"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "",
    style: {
      cursor: "pointer",
      fontSize: window.Digit.Utils.browser.isMobile() ? "14px" : "16px",
      fontWeight: "400"
    },
    onClick: () => {
      window.open("https://niua.in/", "_blank").focus();
    }
  }, "Copyright \xA9 2022 National Institute of Urban Affairs"))));
};
ForgotPassword.propTypes = {
  loginParams: propTypes.any
};
ForgotPassword.defaultProps = {
  loginParams: null
};

const EmployeeForgotPassword = () => {
  const {
    t
  } = useTranslation();
  const {
    path
  } = useRouteMatch();
  const params = useMemo(() => loginConfig$1.map(step => {
    const texts = {};
    for (const key in step.texts) {
      texts[key] = t(step.texts[key]);
    }
    return {
      ...step,
      texts
    };
  }, [loginConfig$1]));
  return /*#__PURE__*/React__default.createElement(Switch, null, /*#__PURE__*/React__default.createElement(Route, {
    path: `${path}`,
    exact: true
  }, /*#__PURE__*/React__default.createElement(ForgotPassword, {
    config: params[0],
    t: t
  })));
};

const LanguageSelection = () => {
  const {
    data: storeData,
    isLoading
  } = Digit.Hooks.useStore.getInitData();
  const {
    t
  } = useTranslation();
  const history = useHistory();
  const {
    languages,
    stateInfo
  } = storeData || {};
  const selectedLanguage = Digit.StoreData.getCurrentLanguage();
  const [selected, setselected] = useState(selectedLanguage);
  const handleChangeLanguage = language => {
    setselected(language.value);
    Digit.LocalizationService.changeLanguage(language.value, stateInfo.code);
  };
  const handleSubmit = event => {
    history.push("/digit-ui/employee/user/login");
  };
  if (isLoading) return null;
  return /*#__PURE__*/React__default.createElement(Background, null, /*#__PURE__*/React__default.createElement(Card$1, {
    className: "bannerCard removeBottomMargin"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "language-selector",
    style: {
      justifyContent: "space-around",
      marginBottom: "24px",
      padding: "0 5%"
    }
  }, languages.map((language, index) => /*#__PURE__*/React__default.createElement("div", {
    className: "language-button-container",
    key: index
  }, /*#__PURE__*/React__default.createElement(CustomButton, {
    selected: language.value === selected,
    text: language.label,
    onClick: () => handleChangeLanguage(language)
  })))), /*#__PURE__*/React__default.createElement(SubmitBar, {
    style: {
      width: "100%"
    },
    label: t(`CORE_COMMON_CONTINUE`),
    onSubmit: handleSubmit
  })), /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: '100%',
      position: 'fixed',
      bottom: 0,
      backgroundColor: "white",
      textAlign: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'center',
      color: "black"
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      cursor: "pointer",
      fontSize: window.Digit.Utils.browser.isMobile() ? "12px" : "12px",
      fontWeight: "400"
    },
    onClick: () => {
      window.open('https://www.digit.org/', '_blank').focus();
    }
  }, "Powered by UPYOG"), /*#__PURE__*/React__default.createElement("span", {
    style: {
      margin: "0 10px",
      fontSize: window.Digit.Utils.browser.isMobile() ? "12px" : "12px"
    }
  }, "|"), /*#__PURE__*/React__default.createElement("a", {
    style: {
      cursor: "pointer",
      fontSize: window.Digit.Utils.browser.isMobile() ? "12px" : "12px",
      fontWeight: "400"
    },
    href: "#",
    target: "_blank"
  }, "UPYOG License"), /*#__PURE__*/React__default.createElement("span", {
    className: "upyog-copyright-footer",
    style: {
      margin: "0 10px",
      fontSize: "12px"
    }
  }, "|"), /*#__PURE__*/React__default.createElement("span", {
    className: "upyog-copyright-footer",
    style: {
      cursor: "pointer",
      fontSize: window.Digit.Utils.browser.isMobile() ? "12px" : "12px",
      fontWeight: "400"
    },
    onClick: () => {
      window.open('https://niua.in/', '_blank').focus();
    }
  }, "Copyright \xA9 2022 National Institute of Urban Affairs")), /*#__PURE__*/React__default.createElement("div", {
    className: "upyog-copyright-footer-web"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "",
    style: {
      cursor: "pointer",
      fontSize: window.Digit.Utils.browser.isMobile() ? "14px" : "16px",
      fontWeight: "400"
    },
    onClick: () => {
      window.open('https://niua.in/', '_blank').focus();
    }
  }, "Copyright \xA9 2022 National Institute of Urban Affairs"))));
};

const getTenants = (codes, tenants) => {
  return tenants.filter(tenant => {
    var _codes$map;
    return codes === null || codes === void 0 ? void 0 : (_codes$map = codes.map) === null || _codes$map === void 0 ? void 0 : _codes$map.call(codes, item => item.code).includes(tenant.code);
  });
};
const AppModules = ({
  stateCode,
  userType,
  modules,
  appTenants
}) => {
  const ComponentProvider = Digit.Contexts.ComponentProvider;
  const {
    path
  } = useRouteMatch();
  const location = useLocation();
  const user = Digit.UserService.getUser();
  if (!user || !(user !== null && user !== void 0 && user.access_token) || !(user !== null && user !== void 0 && user.info)) {
    return /*#__PURE__*/React__default.createElement(Redirect, {
      to: {
        pathname: "/digit-ui/citizen",
        state: {
          from: location.pathname + location.search
        }
      }
    });
  }
  const appRoutes = modules.map(({
    code,
    tenants
  }, index) => {
    const Module = Digit.ComponentRegistryService.getComponent(`${code}Module`);
    return Module ? /*#__PURE__*/React__default.createElement(Route, {
      key: index,
      path: `${path}/${code.toLowerCase()}`
    }, /*#__PURE__*/React__default.createElement(Module, {
      stateCode: stateCode,
      moduleCode: code,
      userType: userType,
      tenants: getTenants(tenants, appTenants)
    })) : null;
  });
  return /*#__PURE__*/React__default.createElement("div", {
    className: "ground-container"
  }, /*#__PURE__*/React__default.createElement(Switch, null, appRoutes, /*#__PURE__*/React__default.createElement(Route, {
    path: `${path}/login`
  }, " ", /*#__PURE__*/React__default.createElement(Redirect, {
    to: {
      pathname: "/digit-ui/citizen",
      state: {
        from: location.pathname + location.search
      }
    }
  })), /*#__PURE__*/React__default.createElement(Route, {
    path: `${path}/edit-challan`
  }, /*#__PURE__*/React__default.createElement(Redirect, {
    to: `${path}/obps/edit-challan`
  })), /*#__PURE__*/React__default.createElement(Route, {
    path: `${path}/forgot-password`
  }, /*#__PURE__*/React__default.createElement(EmployeeForgotPassword, null)), /*#__PURE__*/React__default.createElement(Route, {
    path: `${path}/change-password`
  }, " ", /*#__PURE__*/React__default.createElement(EmployeeChangePassword, null)), /*#__PURE__*/React__default.createElement(Route, null, /*#__PURE__*/React__default.createElement(AppHome, {
    userType: userType,
    modules: modules
  }))));
};

class ErrorBoundary extends React__default.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      errorStack: null,
      hasError: false
    };
  }
  static getDerivedStateFromError(error) {
    return {
      error: error === null || error === void 0 ? void 0 : error.message,
      hasError: true,
      errorStack: error === null || error === void 0 ? void 0 : error.stack
    };
  }
  componentDidCatch(error, errorInfo) {
    this.setState({
      error: error === null || error === void 0 ? void 0 : error.message,
      hasError: true,
      errorStack: error === null || error === void 0 ? void 0 : error.stack
    });
  }
  render() {
    if (this.state.hasError) {
      var _this$state;
      console.error("UI-error", (_this$state = this.state) === null || _this$state === void 0 ? void 0 : _this$state.error);
      return (
        /*#__PURE__*/
        React__default.createElement(Card, {
          style: {
            marginTop: '10%',
            marginLeft: '20%',
            width: '60%'
          }
        }, /*#__PURE__*/React__default.createElement(Banner, {
          message: 'Something went wrong',
          info: 'Thanks for your patience',
          successful: false
        }))
      );
    }
    return this.props.children;
  }
}

const StyledRadioGroup = styled$1(RadioGroup)(({
  theme
}) => ({
  columnGap: theme.spacing(1),
  alignItems: "center",
  minHeight: 40
}));
const RadioButton = ({
  row,
  data,
  control,
  name,
  width,
  defaultValue,
  clickControl,
  validation,
  disabled
}) => {
  return /*#__PURE__*/React__default.createElement(Controller, {
    name: name,
    control: control,
    rules: validation,
    defaultValue: defaultValue,
    render: ({
      field: {
        onChange,
        value
      },
      fieldState: {
        error
      }
    }) => /*#__PURE__*/React__default.createElement(StyledRadioGroup, {
      "aria-labelledby": "radio-buttons-group-label",
      value: value || defaultValue,
      name: name || "radio-buttons-group",
      row: row,
      onChange: clickControl,
      sx: {
        width: width || "18.25vw",
        translate: "-8px 0"
      }
    }, data === null || data === void 0 ? void 0 : data.map(item => {
      return /*#__PURE__*/React__default.createElement(FormControlLabel, {
        sx: {
          margin: 0
        },
        key: item === null || item === void 0 ? void 0 : item.value,
        value: (item === null || item === void 0 ? void 0 : item.value) || value,
        control: /*#__PURE__*/React__default.createElement(Radio, null),
        label: item === null || item === void 0 ? void 0 : item.label,
        onChange: onChange,
        disabled: disabled
      });
    }), error && /*#__PURE__*/React__default.createElement(Typography$1, {
      variant: "caption",
      color: "error"
    }, error.message))
  });
};

const FormInfo = styled$1(Box$1)(() => ({
  backgroundColor: '#fff7cb',
  margin: '2rem auto 0',
  padding: '1.5rem'
}));
const SubTabsWrapper = styled$1(Box$1)(({
  theme
}) => ({
  backgroundColor: '#F2F2F2',
  height: '8vh',
  display: 'flex',
  alignItems: 'center',
  '& .container1': {
    justifyContent: 'space-between',
    marginBlock: theme.spacing(4),
    alignItems: 'center',
    display: 'flex'
  }
}));
const MainTabs = styled$1(Tabs)(() => ({
  marginInline: 'auto'
}));
const MainTab = styled$1(Tab)(() => ({
  '&.MuiTab-root': {
    textTransform: 'none',
    paddingInline: '1rem',
    color: '#1F4A7C',
    outline: 'none'
  },
  '&.Mui-selected': {
    backgroundColor: '#1F4A7C',
    color: 'white'
  }
}));
const SubTabs = styled$1(Tabs)(() => ({
  '&.Mui-selected': {
    backgroundColor: '#5CB85C',
    color: 'white'
  }
}));
const SubTab = styled$1(Tab)(() => ({
  '&.MuiTab-root': {
    textTransform: 'none',
    paddingInline: '1rem',
    outline: 'none',
    fontSize: '1.25rem',
    fontWeight: '400'
  },
  '&.Mui-selected': {
    color: '#1F4A7C',
    borderBottom: '4px solid #1F4A7C',
    fontSize: '1.25rem',
    fontWeight: '600'
  }
}));
const MandatoryInfo = styled$1(Box$1)(() => ({
  lineHeight: 1,
  fontSize: 14,
  color: 'red',
  '& span': {
    display: 'inline-block',
    translate: '0 4px',
    fontSize: 18
  }
}));
const InfoBox = styled$1(Box$1)(() => ({
  lineHeight: 1.5,
  fontSize: '16px',
  color: '#1F4A7C',
  padding: '8px 16px',
  backgroundColor: '#f0f4fa',
  borderRadius: '1px',
  fontWeight: '600',
  marginLeft: '30px',
  '& span': {
    display: 'inline-block',
    translate: '0 4px',
    fontSize: 18
  }
}));
const StyledMenuItem = styled$1(MenuItem$4)(() => ({
  '&.MuiMenuItem-root': {
    padding: '0.25rem 0.75rem',
    display: 'block'
  }
}));

const SelectWrapper = ({
  label,
  inputLabel,
  data: _data = [],
  helperText,
  autoWidth,
  placeholder,
  control,
  name,
  defaultValue,
  width,
  disabled: _disabled = false,
  validation,
  isRequired
}) => {
  console.log("fromSelectInput", width);
  return /*#__PURE__*/React__default.createElement(Controller, {
    name: name || "name",
    control: control,
    rules: validation,
    defaultValue: defaultValue,
    render: ({
      field: {
        onChange,
        value
      },
      fieldState: {
        error
      }
    }) => /*#__PURE__*/React__default.createElement(FormControl, {
      sx: {
        width: width || "18.25vw"
      },
      size: "small",
      disabled: _disabled,
      error: !!error
    }, /*#__PURE__*/React__default.createElement(Select, {
      displayEmpty: true,
      value: value || defaultValue || "",
      onChange: onChange,
      autoWidth: autoWidth,
      sx: {
        width: width || "18.25vw",
        borderRadius: "1px"
      },
      size: "small",
      variant: "outlined",
      required: isRequired,
      input: /*#__PURE__*/React__default.createElement(OutlinedInput, null),
      renderValue: selected => {
        if (selected.length === 0) {
          return /*#__PURE__*/React__default.createElement("em", null, placeholder);
        }
        return selected;
      },
      inputProps: {
        "aria-label": "Without label"
      }
    }, /*#__PURE__*/React__default.createElement(StyledMenuItem, {
      disabled: true,
      value: ""
    }, /*#__PURE__*/React__default.createElement("em", null, placeholder)), Array.isArray(_data) && (_data === null || _data === void 0 ? void 0 : _data.map(item => {
      const dropdowns = (item === null || item === void 0 ? void 0 : item.name) || (item === null || item === void 0 ? void 0 : item.value) || (item === null || item === void 0 ? void 0 : item.i18nKey);
      return /*#__PURE__*/React__default.createElement(StyledMenuItem, {
        value: dropdowns,
        key: dropdowns
      }, dropdowns);
    }))), error && /*#__PURE__*/React__default.createElement(Typography$1, {
      variant: "caption",
      color: "error"
    }, error.message), helperText && !error && /*#__PURE__*/React__default.createElement(FormHelperText, null, helperText))
  });
};

const TextInput = ({
  children,
  select,
  width,
  height,
  multiline,
  control,
  name,
  defaultValue,
  validation,
  isRequired,
  ...rest
}) => {
  console.log("isRequired", name, isRequired);
  return /*#__PURE__*/React__default.createElement(Controller, {
    name: name,
    control: control,
    defaultValue: defaultValue,
    rules: validation,
    render: ({
      field: {
        onChange,
        value
      },
      fieldState: {
        error
      }
    }) => /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(TextField$1, Object.assign({
      sx: {
        ...(width && {
          minWidth: width
        }),
        ...(height && {
          minHeight: height
        }),
        marginRight: select ? "1rem" : 0
      },
      name: name,
      onChange: onChange,
      select: select,
      multiline: multiline,
      value: value || defaultValue || "",
      minRows: multiline ? 3 : 0,
      maxRows: multiline ? 3 : 0,
      error: !!error,
      required: isRequired
    }, rest), children), error && /*#__PURE__*/React__default.createElement(Typography$1, {
      variant: "caption",
      color: "error"
    }, error.message))
  });
};

const UploadButton = ({
  error
}) => {
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      textAlign: "center"
    }
  }, /*#__PURE__*/React__default.createElement(IconButton$1, {
    color: "primary",
    "aria-label": "upload picture",
    component: "label"
  }, /*#__PURE__*/React__default.createElement("input", {
    hidden: true,
    accept: "image/*",
    type: "file"
  }), /*#__PURE__*/React__default.createElement("img", {
    src: "https://tcp.hp.gov.in/img/noPhptoPassport.jpg",
    className: "img",
    alt: "upload"
  })), /*#__PURE__*/React__default.createElement("h6", {
    className: "error"
  }, error));
};

const formatDate = date => {
  return dayjs(date).format('YYYY-MM-DD');
};
const DatePick = ({
  label,
  defaultValue,
  control,
  name,
  width,
  validation
}) => {
  var _validation$required;
  const [reqDate, setReqDate] = useState(null);
  useEffect(() => {
    if (defaultValue) {
      setReqDate(dayjs(formatDate(defaultValue)));
    }
  }, [defaultValue]);
  return /*#__PURE__*/React__default.createElement(Controller, {
    name: name,
    defaultValue: reqDate,
    rules: {
      ...((validation === null || validation === void 0 ? void 0 : (_validation$required = validation.required) === null || _validation$required === void 0 ? void 0 : _validation$required.value) && {
        validate: value => {
          var _validation$required2;
          return !!value || (validation === null || validation === void 0 ? void 0 : (_validation$required2 = validation.required) === null || _validation$required2 === void 0 ? void 0 : _validation$required2.message);
        }
      })
    },
    control: control,
    render: ({
      field: {
        onChange,
        value
      },
      fieldState: {
        error
      }
    }) => /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(LocalizationProvider, {
      dateAdapter: AdapterDayjs,
      adapterLocale: "en-in"
    }, /*#__PURE__*/React__default.createElement(DatePicker, {
      label: label,
      value: value ? dayjs(value) : reqDate,
      sx: {
        width: width ? width : "18.25vw",
        borderRadius: '1px'
      },
      onChange: event => {
        if (event) {
          const formattedDate = formatDate(event);
          onChange(formattedDate);
        } else {
          onChange(null);
        }
      },
      renderInput: params => /*#__PURE__*/React__default.createElement(TextField$1, Object.assign({
        size: "small"
      }, params, {
        error: !!error,
        helperText: error ? error.message : null,
        sx: {
          width: width ? width : "18.25vw",
          borderRadius: '1px'
        }
      }))
    })), error && /*#__PURE__*/React__default.createElement(Typography$1, {
      variant: "caption",
      color: "error"
    }, error.message))
  });
};

const TimePick = ({
  label,
  variant,
  disabled,
  defaultValue,
  placeholder,
  InputProps,
  size,
  fullWidth,
  color,
  helperText,
  children,
  select,
  width,
  multiline,
  control,
  name,
  height
}) => {
  const [reqTime, setreqTime] = useState(new Date());
  return /*#__PURE__*/React__default.createElement(Controller, {
    name: name,
    control: control,
    render: ({
      field: {
        onChange,
        ...restField
      }
    }) => /*#__PURE__*/React__default.createElement(LocalizationProvider, {
      dateAdapter: AdapterDayjs,
      adapterLocale: "en-in"
    }, /*#__PURE__*/React__default.createElement(DemoContainer, {
      components: ['MobileTimePicker']
    }, /*#__PURE__*/React__default.createElement(DemoItem, null, /*#__PURE__*/React__default.createElement(MobileTimePicker, {
      slotProps: {
        textField: {
          size: 'small'
        }
      },
      label: label,
      onChange: event => {
        onChange(event);
        setreqTime(event);
      },
      sx: {
        width: width ? width : '18.25vw'
      },
      renderInput: params => /*#__PURE__*/React__default.createElement(TextField$1, Object.assign({
        size: "small"
      }, params))
    }))))
  });
};

const InputContainer = ({
  label,
  width,
  height,
  disabled: _disabled = false,
  selectSuffix: _selectSuffix = null,
  hasLabel: _hasLabel = true,
  mandatory,
  name,
  control,
  placeholder,
  type,
  data,
  mobileNumber,
  select,
  defaultValue,
  multiColumn,
  multiLine: _multiLine = false,
  uploadValidity,
  labelWidth,
  clickControl,
  getDocumentData,
  containerStyles,
  containerClasses,
  getIndex,
  getArea,
  validation,
  maxLength,
  showSearchIcon,
  onSearchClick,
  autoWidth,
  isRequired
}) => {
  console.log("fromInputcontainer", validation, name);
  return /*#__PURE__*/React__default.createElement("div", {
    className: `inputContainer ${containerClasses}`,
    style: containerStyles
  }, _hasLabel && type !== "defaultCheckbox" && /*#__PURE__*/React__default.createElement("h3", {
    className: `label ${multiColumn ? "multiCoumn" : ""}`,
    style: {
      width: labelWidth && labelWidth
    }
  }, label, mandatory && /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), type === "textInput" ? /*#__PURE__*/React__default.createElement(Box$1, {
    sx: {
      display: "flex",
      alignItems: "center",
      gap: "1vw",
      width: width || "18.25vw"
    }
  }, _selectSuffix && /*#__PURE__*/React__default.createElement(SelectWrapper, Object.assign({
    variant: "outlined",
    width: "6vw",
    size: "small"
  }, _selectSuffix, {
    defaultValue: _selectSuffix === null || _selectSuffix === void 0 ? void 0 : _selectSuffix.defaultValue,
    validation: validation
  })), /*#__PURE__*/React__default.createElement(TextInput, {
    placeholder: placeholder,
    variant: "outlined",
    size: "small",
    disabled: _disabled,
    width: width || (_selectSuffix ? "11.25vw" : "18.25vw"),
    height: height,
    name: name,
    select: select,
    control: control,
    defaultValue: defaultValue,
    multiline: _multiLine,
    isRequired: isRequired,
    InputProps: {
      style: {
        borderRadius: "1px"
      },
      ...(mobileNumber && {
        startAdornment: /*#__PURE__*/React__default.createElement(InputAdornment, {
          position: "start"
        }, "+91")
      }),
      endAdornment: showSearchIcon &&
      /*#__PURE__*/
      React__default.createElement(InputAdornment, {
        position: "end"
      }, /*#__PURE__*/React__default.createElement(IconButton$2, {
        onClick: onSearchClick
      }, /*#__PURE__*/React__default.createElement(Search$1, null)))
    },
    validation: validation,
    inputProps: {
      maxLength
    }
  }, !_selectSuffix && data && select && (data === null || data === void 0 ? void 0 : data.map(option => /*#__PURE__*/React__default.createElement(MenuItem$4, {
    key: option.value,
    value: option.value
  }, option.label))))) : type === "radioButton" ? /*#__PURE__*/React__default.createElement(RadioButton, {
    defaultValue: defaultValue,
    clickControl: clickControl,
    control: control,
    width: width,
    data: data,
    name: name,
    row: true,
    validation: validation,
    disabled: _disabled
  }) : type === "selectInput" ? /*#__PURE__*/React__default.createElement(SelectWrapper, {
    control: control,
    placeholder: placeholder,
    defaultValue: defaultValue,
    inputLabel: placeholder,
    width: width,
    label: label,
    data: data,
    name: name,
    autoWidth: autoWidth,
    disabled: _disabled,
    validation: validation,
    isRequired: isRequired,
    InputProps: {
      style: {
        borderRadius: "1px"
      }
    }
  }) : type === "upload" ? /*#__PURE__*/React__default.createElement(UploadButton, {
    error: uploadValidity
  }) : type === "htmlUpload" ? /*#__PURE__*/React__default.createElement("div", {
    className: "uploadHtml"
  }, /*#__PURE__*/React__default.createElement("input", {
    type: "file",
    name: name,
    onChange: e => {
      var _e$target;
      return getDocumentData(e === null || e === void 0 ? void 0 : (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.files[0], name);
    }
  }), /*#__PURE__*/React__default.createElement("h6", {
    className: "error"
  }, uploadValidity)) : type === "datePicker" ? /*#__PURE__*/React__default.createElement(DatePick, {
    placeholder: placeholder,
    control: control,
    name: name,
    width: width,
    validation: validation
  }) : type === "timePicker" ? /*#__PURE__*/React__default.createElement(TimePick, {
    control: control,
    label: label,
    name: name
  }) : type === "number" ? /*#__PURE__*/React__default.createElement(TextInput, {
    placeholder: placeholder,
    variant: "outlined",
    size: "small",
    type: "number",
    disabled: _disabled,
    width: width || "18.25vw",
    height: height,
    name: name,
    control: control,
    defaultValue: defaultValue,
    inputProps: {
      step: "any",
      min: 0,
      max: {
        maxLength
      }
    },
    InputProps: {
      style: {
        borderRadius: "1px"
      }
    }
  }) : type === "checkbox" ? /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    control: /*#__PURE__*/React__default.createElement(Controller, {
      name: name,
      control: control,
      defaultValue: defaultValue,
      render: ({
        field: {
          onChange,
          value
        }
      }) => /*#__PURE__*/React__default.createElement(Checkbox, {
        checked: value,
        onChange: e => {
          onChange(e.target.checked);
        },
        disabled: _disabled
      })
    }),
    label: label
  }) : type === "defaultCheckbox" ? /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    control: /*#__PURE__*/React__default.createElement(Checkbox, {
      name: name,
      checked: defaultValue,
      disabled: _disabled
    }),
    label: label
  }) : "");
};

const ButtonWrapper = ({
  variant,
  disabled,
  onClick,
  color,
  size,
  startIcon,
  endIcon,
  label,
  type,
  sx
}) => {
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Button$1, {
    sx: {
      borderRadius: "4px",
      ...sx
    },
    variant: variant,
    disabled: disabled,
    onClick: onClick,
    color: color,
    size: size,
    startIcon: startIcon,
    endIcon: endIcon,
    type: type || "button"
  }, label));
};

function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }
  var number = Number(dirtyNumber);
  if (isNaN(number)) {
    return number;
  }
  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}

function toDate(argument) {
  requiredArgs(1, arguments);
  var argStr = Object.prototype.toString.call(argument);
  if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') {
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule");
      console.warn(new Error().stack);
    }
    return new Date(NaN);
  }
}

function addMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var timestamp = toDate(dirtyDate).getTime();
  var amount = toInteger(dirtyAmount);
  return new Date(timestamp + amount);
}

function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}

function isDate(value) {
  requiredArgs(1, arguments);
  return value instanceof Date || typeof value === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}

function isValid(dirtyDate) {
  requiredArgs(1, arguments);
  if (!isDate(dirtyDate) && typeof dirtyDate !== 'number') {
    return false;
  }
  var date = toDate(dirtyDate);
  return !isNaN(Number(date));
}

var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXWeeks: {
    one: 'about 1 week',
    other: 'about {{count}} weeks'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weeks'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};
var formatDistance = function (token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale[token];
  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }
  return result;
};

function buildFormatLongFn(args) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}

var dateFormats = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};

var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};
var formatRelative = function (token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};

function buildLocalizeFn(args) {
  return function (dirtyIndex, dirtyOptions) {
    var options = dirtyOptions || {};
    var context = options.context ? String(options.context) : 'standalone';
    var valuesArray;
    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;
      var _width = options.width ? String(options.width) : args.defaultWidth;
      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }
    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
    return valuesArray[index];
  };
}

var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
};
var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};
var ordinalNumber = function (dirtyNumber, _options) {
  var number = Number(dirtyNumber);
  var rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';
      case 2:
        return number + 'nd';
      case 3:
        return number + 'rd';
    }
  }
  return number + 'th';
};
var localize = {
  ordinalNumber: ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};

function buildMatchFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);
    if (!matchResult) {
      return null;
    }
    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}
function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }
  return undefined;
}
function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
  return undefined;
}

function buildMatchPatternFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};

var locale = {
  code: 'en-US',
  formatDistance: formatDistance,
  formatLong: formatLong,
  formatRelative: formatRelative,
  localize: localize,
  match: match,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};

function subMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, -amount);
}

var MILLISECONDS_IN_DAY = 86400000;
function getUTCDayOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}

function startOfUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var weekStartsOn = 1;
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

function getUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

function startOfUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var year = getUTCISOWeekYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCISOWeek(fourthOfJanuary);
  return date;
}

var MILLISECONDS_IN_WEEK = 604800000;
function getUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCISOWeek(date).getTime() - startOfUTCISOWeekYear(date).getTime();
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

function startOfUTCWeek(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

function getUTCWeekYear(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate);
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, dirtyOptions);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, dirtyOptions);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

function startOfUTCWeekYear(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate);
  var year = getUTCWeekYear(dirtyDate, dirtyOptions);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCWeek(firstWeek, dirtyOptions);
  return date;
}

var MILLISECONDS_IN_WEEK$1 = 604800000;
function getUTCWeek(dirtyDate, options) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCWeek(date, options).getTime() - startOfUTCWeekYear(date, options).getTime();
  return Math.round(diff / MILLISECONDS_IN_WEEK$1) + 1;
}

function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();
  while (output.length < targetLength) {
    output = '0' + output;
  }
  return sign + output;
}

var formatters = {
  y: function (date, token) {
    var signedYear = date.getUTCFullYear();
    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === 'yy' ? year % 100 : year, token.length);
  },
  M: function (date, token) {
    var month = date.getUTCMonth();
    return token === 'M' ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  d: function (date, token) {
    return addLeadingZeros(date.getUTCDate(), token.length);
  },
  a: function (date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
    switch (token) {
      case 'a':
      case 'aa':
        return dayPeriodEnumValue.toUpperCase();
      case 'aaa':
        return dayPeriodEnumValue;
      case 'aaaaa':
        return dayPeriodEnumValue[0];
      case 'aaaa':
      default:
        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
    }
  },
  h: function (date, token) {
    return addLeadingZeros(date.getUTCHours() % 12 || 12, token.length);
  },
  H: function (date, token) {
    return addLeadingZeros(date.getUTCHours(), token.length);
  },
  m: function (date, token) {
    return addLeadingZeros(date.getUTCMinutes(), token.length);
  },
  s: function (date, token) {
    return addLeadingZeros(date.getUTCSeconds(), token.length);
  },
  S: function (date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token.length);
  }
};

var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
};
var formatters$1 = {
  G: function (date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;
    switch (token) {
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {
          width: 'abbreviated'
        });
      case 'GGGGG':
        return localize.era(era, {
          width: 'narrow'
        });
      case 'GGGG':
      default:
        return localize.era(era, {
          width: 'wide'
        });
    }
  },
  y: function (date, token, localize) {
    if (token === 'yo') {
      var signedYear = date.getUTCFullYear();
      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: 'year'
      });
    }
    return formatters.y(date, token);
  },
  Y: function (date, token, localize, options) {
    var signedWeekYear = getUTCWeekYear(date, options);
    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    }
    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {
        unit: 'year'
      });
    }
    return addLeadingZeros(weekYear, token.length);
  },
  R: function (date, token) {
    var isoWeekYear = getUTCISOWeekYear(date);
    return addLeadingZeros(isoWeekYear, token.length);
  },
  u: function (date, token) {
    var year = date.getUTCFullYear();
    return addLeadingZeros(year, token.length);
  },
  Q: function (date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      case 'Q':
        return String(quarter);
      case 'QQ':
        return addLeadingZeros(quarter, 2);
      case 'Qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      case 'QQQ':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'QQQQQ':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'QQQQ':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  q: function (date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      case 'q':
        return String(quarter);
      case 'qq':
        return addLeadingZeros(quarter, 2);
      case 'qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      case 'qqq':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'standalone'
        });
      case 'qqqqq':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'standalone'
        });
      case 'qqqq':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  M: function (date, token, localize) {
    var month = date.getUTCMonth();
    switch (token) {
      case 'M':
      case 'MM':
        return formatters.M(date, token);
      case 'Mo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      case 'MMM':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'MMMMM':
        return localize.month(month, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'MMMM':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  L: function (date, token, localize) {
    var month = date.getUTCMonth();
    switch (token) {
      case 'L':
        return String(month + 1);
      case 'LL':
        return addLeadingZeros(month + 1, 2);
      case 'Lo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      case 'LLL':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'standalone'
        });
      case 'LLLLL':
        return localize.month(month, {
          width: 'narrow',
          context: 'standalone'
        });
      case 'LLLL':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  w: function (date, token, localize, options) {
    var week = getUTCWeek(date, options);
    if (token === 'wo') {
      return localize.ordinalNumber(week, {
        unit: 'week'
      });
    }
    return addLeadingZeros(week, token.length);
  },
  I: function (date, token, localize) {
    var isoWeek = getUTCISOWeek(date);
    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {
        unit: 'week'
      });
    }
    return addLeadingZeros(isoWeek, token.length);
  },
  d: function (date, token, localize) {
    if (token === 'do') {
      return localize.ordinalNumber(date.getUTCDate(), {
        unit: 'date'
      });
    }
    return formatters.d(date, token);
  },
  D: function (date, token, localize) {
    var dayOfYear = getUTCDayOfYear(date);
    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {
        unit: 'dayOfYear'
      });
    }
    return addLeadingZeros(dayOfYear, token.length);
  },
  E: function (date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    switch (token) {
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'EEEEE':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'EEEEEE':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  e: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      case 'e':
        return String(localDayOfWeek);
      case 'ee':
        return addLeadingZeros(localDayOfWeek, 2);
      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });
      case 'eee':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'eeeee':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'eeeeee':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      case 'eeee':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  c: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      case 'c':
        return String(localDayOfWeek);
      case 'cc':
        return addLeadingZeros(localDayOfWeek, token.length);
      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });
      case 'ccc':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'standalone'
        });
      case 'ccccc':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'standalone'
        });
      case 'cccccc':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'standalone'
        });
      case 'cccc':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  i: function (date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token) {
      case 'i':
        return String(isoDayOfWeek);
      case 'ii':
        return addLeadingZeros(isoDayOfWeek, token.length);
      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: 'day'
        });
      case 'iii':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'iiiii':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'iiiiii':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      case 'iiii':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  a: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    switch (token) {
      case 'a':
      case 'aa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();
      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  b: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    }
    switch (token) {
      case 'b':
      case 'bb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();
      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  B: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }
    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  h: function (date, token, localize) {
    if (token === 'ho') {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return formatters.h(date, token);
  },
  H: function (date, token, localize) {
    if (token === 'Ho') {
      return localize.ordinalNumber(date.getUTCHours(), {
        unit: 'hour'
      });
    }
    return formatters.H(date, token);
  },
  K: function (date, token, localize) {
    var hours = date.getUTCHours() % 12;
    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return addLeadingZeros(hours, token.length);
  },
  k: function (date, token, localize) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;
    if (token === 'ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return addLeadingZeros(hours, token.length);
  },
  m: function (date, token, localize) {
    if (token === 'mo') {
      return localize.ordinalNumber(date.getUTCMinutes(), {
        unit: 'minute'
      });
    }
    return formatters.m(date, token);
  },
  s: function (date, token, localize) {
    if (token === 'so') {
      return localize.ordinalNumber(date.getUTCSeconds(), {
        unit: 'second'
      });
    }
    return formatters.s(date, token);
  },
  S: function (date, token) {
    return formatters.S(date, token);
  },
  X: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    if (timezoneOffset === 0) {
      return 'Z';
    }
    switch (token) {
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      case 'XXXX':
      case 'XX':
        return formatTimezone(timezoneOffset);
      case 'XXXXX':
      case 'XXX':
      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  x: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      case 'xxxx':
      case 'xx':
        return formatTimezone(timezoneOffset);
      case 'xxxxx':
      case 'xxx':
      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  O: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  z: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  t: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return addLeadingZeros(timestamp, token.length);
  },
  T: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return addLeadingZeros(timestamp, token.length);
  }
};
function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;
  if (minutes === 0) {
    return sign + String(hours);
  }
  var delimiter = dirtyDelimiter || '';
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }
  return formatTimezone(offset, dirtyDelimiter);
}
function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}

function dateLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short'
      });
    case 'PP':
      return formatLong.date({
        width: 'medium'
      });
    case 'PPP':
      return formatLong.date({
        width: 'long'
      });
    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full'
      });
  }
}
function timeLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short'
      });
    case 'pp':
      return formatLong.time({
        width: 'medium'
      });
    case 'ppp':
      return formatLong.time({
        width: 'long'
      });
    case 'pppp':
    default:
      return formatLong.time({
        width: 'full'
      });
  }
}
function dateTimeLongFormatter(pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/) || [];
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];
  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }
  var dateTimeFormat;
  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short'
      });
      break;
    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium'
      });
      break;
    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long'
      });
      break;
    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full'
      });
      break;
  }
  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
}
var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};

var protectedDayOfYearTokens = ['D', 'DD'];
var protectedWeekYearTokens = ['YY', 'YYYY'];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
  if (token === 'YYYY') {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'YY') {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'D') {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'DD') {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  }
}

var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function format(dirtyDate, dirtyFormatStr, dirtyOptions) {
  requiredArgs(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var options = dirtyOptions || {};
  var locale$1 = options.locale || locale;
  var localeFirstWeekContainsDate = locale$1.options && locale$1.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate);
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var localeWeekStartsOn = locale$1.options && locale$1.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn);
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  if (!locale$1.localize) {
    throw new RangeError('locale must contain localize property');
  }
  if (!locale$1.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }
  var originalDate = toDate(dirtyDate);
  if (!isValid(originalDate)) {
    throw new RangeError('Invalid time value');
  }
  var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
  var utcDate = subMilliseconds(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale$1,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];
    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = longFormatters[firstCharacter];
      return longFormatter(substring, locale$1.formatLong, formatterOptions);
    }
    return substring;
  }).join('').match(formattingTokensRegExp).map(function (substring) {
    if (substring === "''") {
      return "'";
    }
    var firstCharacter = substring[0];
    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }
    var formatter = formatters$1[firstCharacter];
    if (formatter) {
      if (!options.useAdditionalWeekYearTokens && isProtectedWeekYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, dirtyDate);
      }
      if (!options.useAdditionalDayOfYearTokens && isProtectedDayOfYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, dirtyDate);
      }
      return formatter(utcDate, substring, locale$1.localize, formatterOptions);
    }
    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }
    return substring;
  }).join('');
  return result;
}
function cleanEscapedString(input) {
  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}

const stringReplaceAll = (str = "", searcher = "", replaceWith = "") => {
  if (searcher == "") return str;
  while (str.includes(searcher)) {
    str = str.replace(searcher, replaceWith);
  }
  return str;
};

const localStoreSupport = () => {
  try {
    return "sessionStorage" in window && window["sessionStorage"] !== null;
  } catch (e) {
    return false;
  }
};
const k$1 = key => `Digit.${key}`;
const getStorage = storageClass => ({
  get: key => {
    if (localStoreSupport() && key) {
      let valueInStorage = storageClass.getItem(k$1(key));
      if (!valueInStorage || valueInStorage === "undefined") {
        return null;
      }
      const item = JSON.parse(valueInStorage);
      if (Date.now() > item.expiry) {
        storageClass.removeItem(k$1(key));
        return null;
      }
      return item.value;
    } else if (typeof window !== "undefined") {
      var _window, _window$eGov;
      return ((_window = window) === null || _window === void 0 ? void 0 : (_window$eGov = _window.eGov) === null || _window$eGov === void 0 ? void 0 : _window$eGov.Storage) && window.eGov.Storage[k$1(key)].value;
    } else {
      return null;
    }
  },
  set: (key, value, ttl = 86400) => {
    const item = {
      value,
      ttl,
      expiry: Date.now() + ttl * 1000
    };
    if (localStoreSupport()) {
      storageClass.setItem(k$1(key), JSON.stringify(item));
    } else if (typeof window !== "undefined") {
      window.eGov = window.eGov || {};
      window.eGov.Storage = window.eGov.Storage || {};
      window.eGov.Storage[k$1(key)] = item;
    }
  },
  del: key => {
    if (localStoreSupport()) {
      storageClass.removeItem(k$1(key));
    } else if (typeof window !== "undefined") {
      window.eGov = window.eGov || {};
      window.eGov.Storage = window.eGov.Storage || {};
      delete window.eGov.Storage[k$1(key)];
    }
  }
});
const PersistantStorage = getStorage(window.localStorage);

const SortByName = (na, nb) => {
  if (na < nb) {
    return -1;
  }
  if (na > nb) {
    return 1;
  }
  return 0;
};
const GetCitiesWithi18nKeys = (MdmsRes, moduleCode) => {
  const cityList = MdmsRes.tenant.citymodule && MdmsRes.tenant.citymodule.find(module => module.code === moduleCode).tenants || [];
  const citiesMap = cityList.map(city => city.code);
  const cities = MdmsRes.tenant.tenants.filter(city => citiesMap.includes(city.code)).map(({
    code,
    name,
    logoId,
    emailId,
    address,
    contactNumber
  }) => ({
    code,
    name,
    logoId,
    emailId,
    address,
    contactNumber,
    i18nKey: "TENANT_TENANTS_" + code.replace(".", "_").toUpperCase()
  })).sort((cityA, cityB) => {
    const na = cityA.name.toLowerCase(),
      nb = cityB.name.toLowerCase();
    return SortByName(na, nb);
  });
  return cities;
};
const initRequestBody = tenantId => ({
  MdmsCriteria: {
    tenantId,
    moduleDetails: [{
      moduleName: "common-masters",
      masterDetails: [{
        name: "Department"
      }, {
        name: "Designation"
      }, {
        name: "StateInfo"
      }, {
        name: "wfSlaConfig"
      }]
    }, {
      moduleName: "tenant",
      masterDetails: [{
        name: "tenants"
      }, {
        name: "citymodule"
      }]
    }, {
      moduleName: "DIGIT-UI",
      masterDetails: [{
        name: "ApiCachingSettings"
      }]
    }, {
      moduleName: "BPA",
      masterDetails: [{
        name: "SchemesRate"
      }]
    }]
  }
});
const getCriteria = (tenantId, moduleDetails) => {
  return {
    MdmsCriteria: {
      tenantId,
      ...moduleDetails
    }
  };
};
const getGeneralCriteria = (tenantId, moduleCode, type) => ({
  details: {
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: type
      }]
    }]
  }
});
const getMultipleTypes = (tenantId, moduleCode, types) => ({
  details: {
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: types.map(type => {
        if (typeof type === "object") {
          return {
            name: type.name,
            filter: type.filter
          };
        }
        return {
          name: type
        };
      })
    }]
  }
});
const getReceiptKey = (tenantId, moduleCode) => ({
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "uiCommonPay"
      }]
    }]
  }
});
const getModuleServiceDefsCriteria = (tenantId, moduleCode) => ({
  type: "serviceDefs",
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: `RAINMAKER-${moduleCode}`,
      masterDetails: [{
        name: "ServiceDefs"
      }]
    }]
  }
});
const getSanitationTypeCriteria = (tenantId, moduleCode) => ({
  type: "SanitationType",
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "SanitationType",
        filter: null
      }]
    }]
  }
});
const getPitTypeCriteria = (tenantId, moduleCode) => ({
  type: "PitType",
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "PitType",
        filter: null
      }]
    }]
  }
});
const getApplicationChannelCriteria = (tenantId, moduleCode) => ({
  type: "ApplicationChannel",
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "ApplicationChannel",
        filter: null
      }]
    }]
  }
});
const getPropertyTypeCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "PropertyType",
        filter: null
      }]
    }]
  }
});
const getPropertyUsageCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "PropertyType",
        filter: null
      }]
    }]
  }
});
const getCommonFieldsCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "CommonFieldsConfig",
        filter: null
      }]
    }]
  }
});
const getPreFieldsCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "PreFieldsConfig",
        filter: null
      }]
    }]
  }
});
const getPostFieldsCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "PostFieldsConfig",
        filter: null
      }]
    }]
  }
});
const getConfig = (tenantId, moduleCode) => ({
  type: "Config",
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "Config"
      }]
    }]
  }
});
const getVehicleTypeCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "VehicleMakeModel",
        filter: null
      }]
    }]
  }
});
const getChecklistCriteria = (tenantId, moduleCode) => ({
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "CheckList",
        filter: null
      }]
    }]
  }
});
const getSlumLocalityCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "Slum"
      }]
    }]
  }
});
const getPropertyOwnerTypeCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "OwnerType"
      }]
    }]
  }
});
const getSubPropertyOwnerShipCategoryCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "SubOwnerShipCategory"
      }]
    }]
  }
});
const getPropertyOwnerShipCategoryCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "OwnerShipCategory"
      }]
    }]
  }
});
const getTradeOwnerShipCategoryCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "OwnerShipCategory"
      }]
    }]
  }
});
const getDocumentRequiredScreenCategory = (tenantId, moduleCode) => ({
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "Documents"
      }]
    }]
  }
});
const getDefaultMapConfig = (tenantId, moduleCode) => ({
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "MapConfig"
      }]
    }]
  }
});
const getUsageCategoryList = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "UsageCategory"
      }]
    }]
  }
});
const getPTPropertyTypeList = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "PropertyType"
      }]
    }]
  }
});
const getTLStructureTypeList = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "StructureType"
      }]
    }]
  }
});
const getTLAccessoriesTypeList = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "AccessoriesCategory"
      }]
    }]
  }
});
const getTLFinancialYearList = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "FinancialYear",
        filter: `[?(@.module == "TL")]`
      }]
    }]
  }
});
const getPTFloorList = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "Floor"
      }]
    }]
  }
});
const getReasonCriteria = (tenantId, moduleCode, type, payload) => ({
  type,
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: payload.map(mdmsLoad => ({
        name: mdmsLoad
      }))
    }]
  }
});
const getBillingServiceForBusinessServiceCriteria = filter => ({
  moduleDetails: [{
    moduleName: "BillingService",
    masterDetails: [{
      name: "BusinessService",
      filter
    }, {
      name: "TaxHeadMaster"
    }, {
      name: "TaxPeriod"
    }]
  }]
});
const getRoleStatusCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "RoleStatusMapping",
        filter: null
      }]
    }]
  }
});
const getRentalDetailsCategoryCriteria = (tenantId, moduleCode) => ({
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "RentalDetails"
      }]
    }]
  }
});
const getChargeSlabsCategoryCriteria = (tenantId, moduleCode) => ({
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "ChargeSlabs"
      }]
    }]
  }
});
const getGenderTypeList = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "GenderType"
      }]
    }]
  }
});
const getDssDashboardCriteria = (tenantId, moduleCode) => ({
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "dashboard-config"
      }]
    }]
  }
});
const getMCollectBillingServiceCriteria = (tenantId, moduleCode, type, filter) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "BusinessService",
        filter: filter
      }]
    }]
  }
});
const getTradeUnitsDataList = (tenantId, moduleCode, type, filter) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "TradeType",
        filter: filter
      }]
    }]
  }
});
const getMCollectApplicationStatusCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "applicationStatus"
      }]
    }]
  }
});
const getHrmsEmployeeRolesandDesignations = () => ({
  moduleDetails: [{
    moduleName: "common-masters",
    masterDetails: [{
      name: "Department",
      filter: "[?(@.active == true)]"
    }, {
      name: "Designation",
      filter: "[?(@.active == true)]"
    }]
  }, {
    moduleName: "tenant",
    masterDetails: [{
      name: "tenants"
    }]
  }, {
    moduleName: "ACCESSCONTROL-ROLES",
    masterDetails: [{
      name: "roles",
      filter: "$.[?(@.code!='CITIZEN')]"
    }]
  }, {
    moduleName: "egov-location",
    masterDetails: [{
      name: "TenantBoundary"
    }]
  }]
});
const getFSTPPlantCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "FSTPPlantInfo"
      }]
    }]
  }
});
const getCancelReceiptReason = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "CancelReceiptReason"
      }]
    }]
  }
});
const getReceiptStatus = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "ReceiptStatus"
      }]
    }]
  }
});
const getCancelReceiptReasonAndStatus = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "ReceiptStatus"
      }, {
        name: "uiCommonPay"
      }]
    }]
  }
});
const getDocumentTypesCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "DocTypeMapping"
      }]
    }]
  }
});
const getTradeTypeRoleCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "TradeTypetoRoleMapping"
      }]
    }]
  }
});
const getMSDropDownCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "DropdownsConfig"
      }]
    }]
  }
});
const getLandUseCategories = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "BasicFarPurchasable"
      }]
    }]
  }
});
const getFSTPORejectionReasonCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "FSTPORejectionReason",
        filter: null
      }]
    }]
  }
});
const getFSMPaymentTypeCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "PaymentType",
        filter: null
      }]
    }]
  }
});
const getFSMTripNumberCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "TripNumber",
        filter: null
      }]
    }]
  }
});
const getFSMReceivedPaymentTypeCriteria = (tenantId, moduleCode, type) => ({
  type,
  details: {
    tenantId: tenantId,
    moduleDetails: [{
      moduleName: moduleCode,
      masterDetails: [{
        name: "ReceivedPaymentType",
        filter: null
      }]
    }]
  }
});
const GetEgovLocations = MdmsRes => {
  return MdmsRes["egov-location"].TenantBoundary[0].boundary.children.map(obj => ({
    name: obj.localname,
    i18nKey: obj.localname
  }));
};
const GetServiceDefs = (MdmsRes, moduleCode) => MdmsRes[`RAINMAKER-${moduleCode}`].ServiceDefs.filter(def => def.active);
const GetSanitationType = MdmsRes => MdmsRes["FSM"].SanitationType.filter(type => type.active);
const GetPitType = MdmsRes => MdmsRes["FSM"].PitType.filter(item => item.active).map(type => ({
  ...type,
  i18nKey: `PITTYPE_MASTERS_${type.code}`
}));
const GetApplicationChannel = MdmsRes => MdmsRes["FSM"].ApplicationChannel.filter(type => type.active).map(channel => ({
  ...channel,
  i18nKey: `ES_APPLICATION_DETAILS_APPLICATION_CHANNEL_${channel.code}`
}));
const GetPropertyType = MdmsRes => MdmsRes["FSM"].PropertyType.filter(property => property.active && !property.propertyType).map(item => ({
  ...item,
  i18nKey: `PROPERTYTYPE_MASTERS_${item.code}`,
  code: item.code
}));
const GetPropertySubtype = MdmsRes => MdmsRes["FSM"].PropertyType.filter(property => property.active && property.propertyType).map(item => ({
  ...item,
  i18nKey: `PROPERTYTYPE_MASTERS_${item.code}`,
  code: item.code
}));
const GetVehicleType = MdmsRes => MdmsRes["Vehicle"].VehicleMakeModel.filter(vehicle => vehicle.active).filter(vehicle => vehicle.make).map(vehicleDetails => {
  return {
    ...vehicleDetails,
    i18nKey: `COMMON_MASTER_VEHICLE_${vehicleDetails.code}`
  };
});
const GetSlumLocalityMapping = (MdmsRes, tenantId) => MdmsRes["FSM"].Slum.filter(type => type.active).reduce((prev, curr) => {
  return prev[curr.locality] ? {
    ...prev,
    [curr.locality]: [...prev[curr.locality], {
      ...curr,
      i18nKey: `${tenantId.toUpperCase().replace(".", "_")}_${curr.locality}_${curr.code}`
    }]
  } : {
    ...prev,
    [curr.locality]: [{
      ...curr,
      i18nKey: `${tenantId.toUpperCase().replace(".", "_")}_${curr.locality}_${curr.code}`
    }]
  };
}, {});
const GetPropertyOwnerShipCategory = MdmsRes => MdmsRes["PropertyTax"].OwnerShipCategory.filter(ownerShip => ownerShip.active).map(ownerShipDetails => {
  return {
    ...ownerShipDetails,
    i18nKey: `COMMON_MASTER_OWNER_TYPE_${ownerShipDetails.code}`
  };
});
const GetTradeOwnerShipCategory = MdmsRes => MdmsRes["common-masters"].OwnerShipCategory.filter(ownerShip => ownerShip.active).map(ownerShipDetails => {
  return {
    ...ownerShipDetails,
    i18nKey: `COMMON_MASTER_OWNER_TYPE_${ownerShipDetails.code}`
  };
});
const GetPropertyOwnerType = MdmsRes => MdmsRes["PropertyTax"].OwnerType.filter(owner => owner.active).map(ownerDetails => {
  return {
    ...ownerDetails,
    i18nKey: `PROPERTYTAX_OWNERTYPE_${ownerDetails.code}`
  };
});
const getSubPropertyOwnerShipCategory = MdmsRes => {
  MdmsRes["PropertyTax"].SubOwnerShipCategory.filter(category => category.active).map(subOwnerShipDetails => {
    return {
      ...subOwnerShipDetails,
      i18nKey: `PROPERTYTAX_BILLING_SLAB_${subOwnerShipDetails.code}`
    };
  });
  sessionStorage.setItem("getSubPropertyOwnerShipCategory", JSON.stringify(MdmsRes));
};
const getDocumentRequiredScreen = MdmsRes => {
  MdmsRes["PropertyTax"].Documents.filter(Documents => Documents.active).map(dropdownData => {
    return {
      ...Documents,
      i18nKey: `${dropdownData.code}`
    };
  });
};
const getTLDocumentRequiredScreen = MdmsRes => {
  MdmsRes["TradeLicense"].Documents.filter(Documents => Documents.active).map(dropdownData => {
    return {
      ...Documents,
      i18nKey: `${dropdownData.code}`
    };
  });
};
const getMapConfig = MdmsRes => {
  MdmsRes["PropertyTax"].MapConfig.filter(MapConfig => MapConfig).map(MapData => {
    return {
      ...MapConfig,
      defaultconfig: MapData.defaultConfig
    };
  });
};
const getUsageCategory = MdmsRes => MdmsRes["PropertyTax"].UsageCategory.filter(UsageCategory => UsageCategory.active).map(UsageCategorylist => {
  return {
    ...UsageCategorylist,
    i18nKey: `PROPERTYTAX_BILLING_SLAB_${UsageCategorylist.code}`
  };
});
const getPTPropertyType = MdmsRes => MdmsRes["PropertyTax"].UsageCategory.filter(PropertyType => PropertyType.active).map(PTPropertyTypelist => {
  return {
    ...UsageCategorylist,
    i18nKey: `COMMON_PROPTYPE_${stringReplaceAll(PTPropertyTypelist.code, ".", "_")}`
  };
});
const getTLStructureType = MdmsRes => MdmsRes["common-masters"].StructureType.filter(StructureType => StructureType.active).map(TLStructureTypeList => {
  return {
    ...TLStructureTypeList,
    i18nKey: `COMMON_MASTERS_STRUCTURETYPE_${stringReplaceAll(TLStructureTypeList.code, ".", "_")}`
  };
});
const getTLAccessoriesType = MdmsRes => MdmsRes["TradeLicense"].AccessoriesCategory.filter(AccessoriesCategory => AccessoriesCategory.active).map(TLAccessoryTypeList => {
  return {
    ...TLAccessoryTypeList,
    i18nKey: `TRADELICENSE_ACCESSORIESCATEGORY_${stringReplaceAll(TLAccessoryTypeList.code, ".", "_")}`
  };
});
const getTLFinancialYear = MdmsRes => MdmsRes["egf-master"].FinancialYear.filter(FinancialYear => FinancialYear.active && FinancialYear.module === "TL").map(FinancialYearList => {
  return {
    ...FinancialYearList
  };
});
const getFloorList = MdmsRes => MdmsRes["PropertyTax"].Floor.filter(PTFloor => PTFloor.active).map(PTFloorlist => {
  return {
    ...PTFloorlist,
    i18nKey: `PROPERTYTAX_FLOOR_${PTFloorlist.code}`
  };
});
const GetReasonType = (MdmsRes, type, moduleCode) => Object.assign({}, ...Object.keys(MdmsRes[moduleCode]).map(collection => ({
  [collection]: MdmsRes[moduleCode][collection].filter(reason => reason.active).map(reason => ({
    ...reason,
    i18nKey: `ES_ACTION_REASON_${reason.code}`
  }))
})));
const getRentalDetailsCategory = MdmsRes => {
  MdmsRes["PropertyTax"].RentalDetails.filter(category => category.active).map(RentalDetailsInfo => {
    return {
      ...RentalDetailsInfo,
      i18nKey: `PROPERTYTAX_BILLING_SLAB_${RentalDetailsInfo.code}`
    };
  });
};
const getChargeSlabsCategory = MdmsRes => {
  MdmsRes["PropertyTax"].ChargeSlabs.filter(category => category.active).map(ChargeSlabsInfo => {
    return {
      ...ChargeSlabsInfo
    };
  });
};
const getGenderType = MdmsRes => {
  return MdmsRes["common-masters"].GenderType.filter(GenderType => GenderType.active).map(genderDetails => {
    return {
      ...genderDetails,
      i18nKey: `PT_COMMON_GENDER_${genderDetails.code}`
    };
  });
};
const TLGenderType = MdmsRes => {
  MdmsRes["common-masters"].GenderType.filter(GenderType => GenderType.active).map(genders => {
    return {
      ...genders,
      i18nKey: `TL_GENDER_${genders.code}`
    };
  });
};
const PTGenderType = MdmsRes => {
  MdmsRes["common-masters"].GenderType.filter(GenderType => GenderType.active).map(formGender => {
    return {
      ...formGender,
      i18nKey: `PT_FORM3_${formGender.code}`
    };
  });
};
const HRGenderType = MdmsRes => {
  MdmsRes["common-masters"].GenderType.filter(GenderType => GenderType.active).map(comGender => {
    return {
      ...comGender,
      i18nKey: `COMMON_GENDER_${comGender.code}`
    };
  });
};
const GetMCollectBusinessService = MdmsRes => MdmsRes["BillingService"].BusinessService.map(businesServiceDetails => {
  return {
    ...businesServiceDetails,
    i18nKey: `BILLINGSERVICE_BUSINESSSERVICE_${businesServiceDetails.code}`
  };
});
const GetMCollectApplicationStatus = MdmsRes => MdmsRes["mCollect"].applcationStatus.map(appStatusDetails => {
  return {
    ...appStatusDetails,
    i18nKey: `BILLINGSERVICE_BUSINESSSERVICE_${appStatusDetails.code}`
  };
});
const getFSMGenderType = MdmsRes => {
  return MdmsRes["common-masters"].GenderType.map(genderDetails => {
    return {
      ...genderDetails,
      i18nKey: `COMMON_GENDER_${genderDetails.code}`
    };
  });
};
const GetFSTPORejectionReason = MdmsRes => {
  return MdmsRes["Vehicle"].FSTPORejectionReason.filter(reason => reason.active).map(reasonDetails => {
    return {
      ...reasonDetails,
      i18nKey: `ES_ACTION_REASON_${reasonDetails.code}`
    };
  });
};
const GetPaymentType = MdmsRes => {
  return MdmsRes["FSM"].PaymentType.filter(option => option.active).map(reasonDetails => {
    return {
      ...reasonDetails,
      i18nKey: `ES_ACTION_${reasonDetails.code}`
    };
  });
};
const GetTripNumber = MdmsRes => {
  return MdmsRes["FSM"].TripNumber.filter(option => option.active).map(reasonDetails => {
    return {
      ...reasonDetails,
      i18nKey: `ES_ACTION_TRIP_${reasonDetails.code}`
    };
  });
};
const GetReceivedPaymentType = MdmsRes => {
  return MdmsRes["FSM"].ReceivedPaymentType.filter(option => option.active).map(reasonDetails => {
    return {
      ...reasonDetails,
      i18nKey: `ES_ACTION_${reasonDetails.code}`
    };
  });
};
const getDssDashboard = MdmsRes => MdmsRes["dss-dashboard"]["dashboard-config"];
const GetRoleStatusMapping = MdmsRes => MdmsRes["DIGIT-UI"].RoleStatusMapping;
const GetCommonFields = (MdmsRes, moduleCode) => moduleCode.toUpperCase() === "PROPERTYTAX" ? MdmsRes["PropertyTax"].CommonFieldsConfig : MdmsRes["FSM"].CommonFieldsConfig;
const GetPreFields = MdmsRes => MdmsRes["FSM"].PreFieldsConfig;
const GetPostFields = MdmsRes => MdmsRes["FSM"].PostFieldsConfig;
const GetFSTPPlantInfo = MdmsRes => MdmsRes["FSM"].FSTPPlantInfo;
const GetDocumentsTypes = MdmsRes => MdmsRes["BPA"].DocTypeMapping;
const GetChecklist = MdmsRes => MdmsRes["BPA"].CheckList;
const transformResponse = (type, MdmsRes, moduleCode, tenantId) => {
  switch (type) {
    case "citymodule":
      return GetCitiesWithi18nKeys(MdmsRes, moduleCode);
    case "egovLocation":
      return GetEgovLocations(MdmsRes);
    case "serviceDefs":
      return GetServiceDefs(MdmsRes, moduleCode);
    case "ApplicationChannel":
      return GetApplicationChannel(MdmsRes);
    case "SanitationType":
      return GetSanitationType(MdmsRes);
    case "PropertyType":
      return GetPropertyType(MdmsRes);
    case "PropertySubtype":
      return GetPropertySubtype(MdmsRes);
    case "PitType":
      return GetPitType(MdmsRes);
    case "VehicleType":
      return GetVehicleType(MdmsRes);
    case "Slum":
      return GetSlumLocalityMapping(MdmsRes, tenantId);
    case "OwnerShipCategory":
      return GetPropertyOwnerShipCategory(MdmsRes);
    case "TLOwnerShipCategory":
      return GetTradeOwnerShipCategory(MdmsRes);
    case "OwnerType":
      return GetPropertyOwnerType(MdmsRes);
    case "SubOwnerShipCategory":
      return getSubPropertyOwnerShipCategory(MdmsRes);
    case "Documents":
      return getDocumentRequiredScreen(MdmsRes);
    case "TLDocuments":
      return getTLDocumentRequiredScreen(MdmsRes);
    case "MapConfig":
      return getMapConfig(MdmsRes);
    case "UsageCategory":
      return getUsageCategory(MdmsRes);
    case "PTPropertyType":
      return getPTPropertyType(MdmsRes);
    case "StructureType":
      return getTLStructureType(MdmsRes);
    case "AccessoryCategory":
      return getTLAccessoriesType(MdmsRes);
    case "FinancialYear":
      return getTLFinancialYear(MdmsRes);
    case "Floor":
      return getFloorList(MdmsRes);
    case "Reason":
      return GetReasonType(MdmsRes, type, moduleCode);
    case "RoleStatusMapping":
      return GetRoleStatusMapping(MdmsRes);
    case "CommonFieldsConfig":
      return GetCommonFields(MdmsRes, moduleCode);
    case "PreFieldsConfig":
      return GetPreFields(MdmsRes);
    case "PostFieldsConfig":
      return GetPostFields(MdmsRes);
    case "RentalDeatils":
      return getRentalDetailsCategory(MdmsRes);
    case "ChargeSlabs":
      return getChargeSlabsCategory(MdmsRes);
    case "DssDashboard":
      return getDssDashboard(MdmsRes);
    case "BusinessService":
      return GetMCollectBusinessService(MdmsRes);
    case "applcatonStatus":
      return GetMCollectApplicationStatus(MdmsRes);
    case "FSTPPlantInfo":
      return GetFSTPPlantInfo(MdmsRes);
    case "GenderType":
      return getGenderType(MdmsRes);
    case "TLGendertype":
      return TLGenderType(MdmsRes);
    case "PTGenderType":
      return PTGenderType(MdmsRes);
    case "HRGenderType":
      return HRGenderType(MdmsRes);
    case "DocumentTypes":
      return GetDocumentsTypes(MdmsRes);
    case "CheckList":
      return GetChecklist(MdmsRes);
    case "FSMGenderType":
      return getFSMGenderType(MdmsRes);
    case "FSTPORejectionReason":
      return GetFSTPORejectionReason(MdmsRes);
    case "PaymentType":
      return GetPaymentType(MdmsRes);
    case "TripNumber":
      return GetTripNumber(MdmsRes);
    case "ReceivedPaymentType":
      return GetReceivedPaymentType(MdmsRes);
    default:
      return MdmsRes;
  }
};
const mergedData = {};
const mergedPromises = {};
const callAllPromises = (success, promises = [], resData) => {
  promises.forEach(promise => {
    if (success) {
      promise.resolve(resData);
    } else {
      promise.reject(resData);
    }
  });
};
const mergeMDMSData = (data, tenantId, url) => {
  const key = `${tenantId}:${url}`;
  if (!mergedData[key] || Object.keys(mergedData[key]).length === 0) {
    mergedData[key] = data;
  } else {
    data.MdmsCriteria.moduleDetails.forEach(dataModuleDetails => {
      const moduleName = dataModuleDetails.moduleName;
      const masterDetails = dataModuleDetails.masterDetails;
      let found = false;
      mergedData[key].MdmsCriteria.moduleDetails.forEach(moduleDetail => {
        if (moduleDetail.moduleName === moduleName) {
          found = true;
          moduleDetail.masterDetails = [...moduleDetail.masterDetails, ...masterDetails];
        }
      });
      if (!found) {
        mergedData[key].MdmsCriteria.moduleDetails.push(dataModuleDetails);
      }
    });
  }
};
const debouncedCall = ({
  serviceName,
  url,
  data,
  useCache,
  params
}, resolve, reject) => {
  const key = `${params.tenantId}:${url}`;
  if (!mergedPromises[key] || mergedPromises[key].length === 0) {
    setTimeout(() => {
      let callData = JSON.parse(JSON.stringify(mergedData[key]));
      mergedData[key] = {};
      let callPromises = [...mergedPromises[key]];
      mergedPromises[key] = [];
      ServiceRequest({
        serviceName,
        url,
        data: callData,
        useCache,
        params
      }).then(data => {
        callAllPromises(true, callPromises, data);
      }).catch(err => {
        callAllPromises(false, callPromises, err);
      });
    }, 500);
  }
  mergeMDMSData(data, params.tenantId, url);
  if (!mergedPromises[key]) {
    mergedPromises[key] = [];
  }
  mergedPromises[key].push({
    resolve,
    reject
  });
};
const MdmsService = {
  init: stateCode => ServiceRequest({
    serviceName: "mdmsInit",
    url: Urls.MDMS,
    data: initRequestBody(stateCode),
    useCache: true,
    params: {
      tenantId: stateCode
    }
  }),
  call: (tenantId, details) => {
    return new Promise((resolve, reject) => debouncedCall({
      serviceName: "mdmsCall",
      url: Urls.MDMS,
      data: getCriteria(tenantId, details),
      useCache: true,
      params: {
        tenantId
      }
    }, resolve, reject));
  },
  search: (tenantId, details) => {
    return new Promise((resolve, reject) => debouncedCall({
      serviceName: "mdmsSearchV2",
      url: Urls.MdmsSearchV2,
      data: getCriteria(tenantId, details),
      useCache: true,
      params: {
        tenantId
      }
    }, resolve, reject));
  },
  getDataByCriteria: async (tenantId, mdmsDetails, moduleCode) => {
    const key = `MDMS.${tenantId}.${moduleCode}.${mdmsDetails.type}.${JSON.stringify(mdmsDetails.details)}`;
    const inStoreValue = PersistantStorage.get(key);
    if (inStoreValue) {
      return inStoreValue;
    }
    const {
      MdmsRes
    } = await MdmsService.call(tenantId, mdmsDetails.details);
    const responseValue = transformResponse(mdmsDetails.type, MdmsRes, moduleCode.toUpperCase(), tenantId);
    PersistantStorage.set(key, responseValue, 3600);
    return responseValue;
  },
  searchDataV2: async (tenantId, mdmsDetails, moduleCode) => {
    const key = `MDMSV2.${tenantId}.${moduleCode}.${mdmsDetails.type}.${JSON.stringify(mdmsDetails.details)}`;
    const inStoreValue = PersistantStorage.get(key);
    if (inStoreValue) {
      return inStoreValue;
    }
    const {
      MdmsRes
    } = await MdmsService.search(tenantId, mdmsDetails.details);
    const responseValue = transformResponse(mdmsDetails.type, MdmsRes, moduleCode.toUpperCase(), tenantId);
    PersistantStorage.set(key, responseValue, 3600);
    return responseValue;
  },
  getServiceDefs: (tenantId, moduleCode) => {
    return MdmsService.getDataByCriteria(tenantId, getModuleServiceDefsCriteria(tenantId, moduleCode), moduleCode);
  },
  getSanitationType: (tenantId, moduleCode) => {
    return MdmsService.getDataByCriteria(tenantId, getSanitationTypeCriteria(tenantId, moduleCode), moduleCode);
  },
  getApplicationChannel: (tenantId, moduleCode) => {
    return MdmsService.getDataByCriteria(tenantId, getApplicationChannelCriteria(tenantId, moduleCode), moduleCode);
  },
  getPropertyType: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getPropertyTypeCriteria(tenantId, moduleCode, type), moduleCode);
  },
  getPropertyUsage: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getPropertyUsageCriteria(tenantId, moduleCode, type), moduleCode);
  },
  getPropertySubtype: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getPropertyTypeCriteria(tenantId, moduleCode, type), moduleCode);
  },
  getPitType: (tenantId, moduleCode) => {
    return MdmsService.getDataByCriteria(tenantId, getPitTypeCriteria(tenantId, moduleCode), moduleCode);
  },
  getVehicleType: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getVehicleTypeCriteria(tenantId, moduleCode, type), moduleCode);
  },
  getChecklist: (tenantId, moduleCode) => {
    return MdmsService.getDataByCriteria(tenantId, getChecklistCriteria(tenantId, moduleCode), moduleCode);
  },
  getPaymentRules: (tenantId, filter) => {
    return MdmsService.call(tenantId, getBillingServiceForBusinessServiceCriteria(filter));
  },
  getCustomizationConfig: (tenantId, moduleCode) => {
    return MdmsService.getDataByCriteria(tenantId, getConfig(tenantId, moduleCode), moduleCode);
  },
  getSlumLocalityMapping: (tenantId, moduleCode, type) => MdmsService.getDataByCriteria(tenantId, getSlumLocalityCriteria(tenantId, moduleCode, type), moduleCode),
  getReason: (tenantId, moduleCode, type, payload) => MdmsService.getDataByCriteria(tenantId, getReasonCriteria(tenantId, moduleCode, type, payload), moduleCode),
  getRoleStatus: (tenantId, moduleCode, type) => MdmsService.getDataByCriteria(tenantId, getRoleStatusCriteria(tenantId, moduleCode, type), moduleCode),
  getCommonFieldsConfig: (tenantId, moduleCode, type, payload) => MdmsService.getDataByCriteria(tenantId, getCommonFieldsCriteria(tenantId, moduleCode, type), moduleCode),
  getPreFieldsConfig: (tenantId, moduleCode, type, payload) => MdmsService.getDataByCriteria(tenantId, getPreFieldsCriteria(tenantId, moduleCode, type), moduleCode),
  getPostFieldsConfig: (tenantId, moduleCode, type, payload) => MdmsService.getDataByCriteria(tenantId, getPostFieldsCriteria(tenantId, moduleCode, type), moduleCode),
  getPropertyOwnerShipCategory: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getPropertyOwnerShipCategoryCriteria(tenantId, moduleCode, type), moduleCode);
  },
  GetTradeOwnerShipCategory: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getTradeOwnerShipCategoryCriteria(tenantId, moduleCode, type), moduleCode);
  },
  getPropertyOwnerType: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getPropertyOwnerTypeCriteria(tenantId, moduleCode, type), moduleCode);
  },
  getPropertySubOwnerShipCategory: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getSubPropertyOwnerShipCategoryCriteria(tenantId, moduleCode, type), moduleCode);
  },
  getDocumentRequiredScreen: (tenantId, moduleCode) => {
    return MdmsService.getDataByCriteria(tenantId, getDocumentRequiredScreenCategory(tenantId, moduleCode), moduleCode);
  },
  getTLDocumentRequiredScreen: (tenantId, moduleCode) => {
    return MdmsService.getDataByCriteria(tenantId, getDocumentRequiredScreenCategory(tenantId, moduleCode), moduleCode);
  },
  getTradeUnitsData: (tenantId, moduleCode, type, filter) => {
    return MdmsService.getDataByCriteria(tenantId, getTradeUnitsDataList(tenantId, moduleCode, type, filter), moduleCode);
  },
  getMapConfig: (tenantId, moduleCode) => {
    return MdmsService.getDataByCriteria(tenantId, getDefaultMapConfig(tenantId, moduleCode), moduleCode);
  },
  getUsageCategory: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getUsageCategoryList(tenantId, moduleCode), moduleCode);
  },
  getPTPropertyType: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getPTPropertyTypeList(tenantId, moduleCode), moduleCode);
  },
  getTLStructureType: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getTLStructureTypeList(tenantId, moduleCode), moduleCode);
  },
  getTLAccessoriesType: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getTLAccessoriesTypeList(tenantId, moduleCode), moduleCode);
  },
  getTLFinancialYear: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getTLFinancialYearList(tenantId, moduleCode), moduleCode);
  },
  getFloorList: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getPTFloorList(tenantId, moduleCode, type), moduleCode);
  },
  getRentalDetails: (tenantId, moduleCode) => {
    return MdmsService.getDataByCriteria(tenantId, getRentalDetailsCategoryCriteria(tenantId, moduleCode), moduleCode);
  },
  getChargeSlabs: (tenantId, moduleCode) => {
    return MdmsService.getDataByCriteria(tenantId, getChargeSlabsCategoryCriteria(tenantId, moduleCode), moduleCode);
  },
  getDssDashboard: (tenantId, moduleCode) => {
    return MdmsService.getDataByCriteria(tenantId, getDssDashboardCriteria(tenantId, moduleCode), moduleCode);
  },
  getPaymentGateway: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getGeneralCriteria(tenantId, moduleCode, type), moduleCode);
  },
  getReceiptKey: (tenantId, moduleCode) => {
    return MdmsService.getDataByCriteria(tenantId, getReceiptKey(tenantId, moduleCode), moduleCode);
  },
  getHelpText: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getGeneralCriteria(tenantId, moduleCode, type), moduleCode);
  },
  getMCollectBillingService: (tenantId, moduleCode, type, filter) => {
    return MdmsService.getDataByCriteria(tenantId, getMCollectBillingServiceCriteria(tenantId, moduleCode, type, filter), moduleCode);
  },
  getMCollectApplcationStatus: (tenantId, moduleCode, type, filter) => {
    return MdmsService.getDataByCriteria(tenantId, getMCollectApplicationStatusCriteria(tenantId, moduleCode, type), moduleCode);
  },
  getHrmsEmployeeRolesandDesignation: tenantId => {
    return MdmsService.call(tenantId, getHrmsEmployeeRolesandDesignations());
  },
  getHrmsEmployeeTypes: (tenantId, moduleCode, type, filter) => {
    return MdmsService.getDataByCriteria(tenantId, getGeneralCriteria(tenantId, moduleCode, type), moduleCode);
  },
  getHrmsEmployeeReason: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getGeneralCriteria(tenantId, moduleCode, type), moduleCode);
  },
  getMultipleTypes: (tenantId, moduleCode, types) => {
    return MdmsService.getDataByCriteria(tenantId, getMultipleTypes(tenantId, moduleCode, types), moduleCode);
  },
  getMultipleTypesV2: (tenantId, moduleCode, types) => {
    return MdmsService.searchDataV2(tenantId, getMultipleTypes(tenantId, moduleCode, types), moduleCode);
  },
  getFSTPPlantInfo: (tenantId, moduleCode, types) => {
    return MdmsService.getDataByCriteria(tenantId, getFSTPPlantCriteria(tenantId, moduleCode, types), moduleCode);
  },
  getCancelReceiptReason: (tenantId, moduleCode) => {
    return MdmsService.getDataByCriteria(tenantId, getCancelReceiptReason(tenantId, moduleCode), moduleCode);
  },
  getReceiptStatus: (tenantId, moduleCode) => {
    return MdmsService.getDataByCriteria(tenantId, getReceiptStatus(tenantId, moduleCode), moduleCode);
  },
  getCancelReceiptReasonAndStatus: (tenantId, moduleCode) => {
    return MdmsService.getDataByCriteria(tenantId, getCancelReceiptReasonAndStatus(tenantId, moduleCode), moduleCode);
  },
  getGenderType: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getGenderTypeList(tenantId, moduleCode, type), moduleCode);
  },
  TLGenderType: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getGenderTypeList(tenantId, moduleCode, type), moduleCode);
  },
  PTGenderType: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getGenderTypeList(tenantId, moduleCode, type), moduleCode);
  },
  HRGenderType: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getGenderTypeList(tenantId, moduleCode, type), moduleCode);
  },
  getDocumentTypes: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getDocumentTypesCriteria(tenantId, moduleCode, type), moduleCode);
  },
  getTradeTypeRoleTypes: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getTradeTypeRoleCriteria(tenantId, moduleCode, type), moduleCode);
  },
  getMSDropDownTypes: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getMSDropDownCriteria(tenantId, moduleCode, type), moduleCode);
  },
  getLandUseCategories: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getLandUseCategories(tenantId, moduleCode, type), moduleCode);
  },
  getFSMGenderType: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getGenderTypeList(tenantId, moduleCode, type), moduleCode);
  },
  getFSTPORejectionReason: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getFSTPORejectionReasonCriteria(tenantId, moduleCode, type), moduleCode);
  },
  getFSMPaymentType: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getFSMPaymentTypeCriteria(tenantId, moduleCode, type), moduleCode);
  },
  getFSMTripNumber: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getFSMTripNumberCriteria(tenantId, moduleCode, type), moduleCode);
  },
  getFSMReceivedPaymentType: (tenantId, moduleCode, type) => {
    return MdmsService.getDataByCriteria(tenantId, getFSMReceivedPaymentTypeCriteria(tenantId, moduleCode, type), moduleCode);
  }
};

const UploadServices = {
  Filestorage: async (module, filedata, tenantId) => {
    var _window, _window$globalConfigs, _Digit$UserService$ge;
    const formData = new FormData();
    formData.append("file", filedata, filedata.name);
    formData.append("tenantId", tenantId);
    formData.append("module", module);
    let tenantInfo = (_window = window) !== null && _window !== void 0 && (_window$globalConfigs = _window.globalConfigs) !== null && _window$globalConfigs !== void 0 && _window$globalConfigs.getConfig("ENABLE_SINGLEINSTANCE") ? `?tenantId=${tenantId}` : "";
    var config = {
      method: "post",
      url: `${Urls.FileStore}${tenantInfo}`,
      data: formData,
      headers: {
        "auth-token": Digit.UserService.getUser() ? (_Digit$UserService$ge = Digit.UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : _Digit$UserService$ge.access_token : null
      }
    };
    return axios(config);
  },
  MultipleFilesStorage: async (module, filesData, tenantId) => {
    var _window2, _window2$globalConfig;
    const formData = new FormData();
    const filesArray = Array.from(filesData);
    filesArray === null || filesArray === void 0 ? void 0 : filesArray.forEach((fileData, index) => fileData ? formData.append("file", fileData, fileData.name) : null);
    formData.append("tenantId", tenantId);
    formData.append("module", module);
    let tenantInfo = (_window2 = window) !== null && _window2 !== void 0 && (_window2$globalConfig = _window2.globalConfigs) !== null && _window2$globalConfig !== void 0 && _window2$globalConfig.getConfig("ENABLE_SINGLEINSTANCE") ? `?tenantId=${tenantId}` : "";
    var config = {
      method: "post",
      url: `${Urls.FileStore}${tenantInfo}`,
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
        "auth-token": Digit.UserService.getUser().access_token
      }
    };
    return axios(config);
  },
  Filefetch: async (filesArray, tenantId) => {
    var _window3, _window3$globalConfig;
    let tenantInfo = (_window3 = window) !== null && _window3 !== void 0 && (_window3$globalConfig = _window3.globalConfigs) !== null && _window3$globalConfig !== void 0 && _window3$globalConfig.getConfig("ENABLE_SINGLEINSTANCE") ? `?tenantId=${tenantId}` : "";
    var config = {
      method: "get",
      url: `${Urls.FileFetch}${tenantInfo}`,
      params: {
        tenantId: tenantId,
        fileStoreIds: filesArray === null || filesArray === void 0 ? void 0 : filesArray.join(",")
      }
    };
    const res = await axios(config);
    return res;
  }
};

const OBPSService = {
  scrutinyDetails: (tenantId, params) => Request({
    url: Urls.obps.scrutinyDetails,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  comparisionReport: (tenantId, params) => Request({
    url: Urls.obps.comparisionReport,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  create: (details, tenantId) => Request({
    url: Urls.obps.create,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  createForm11: details => Request({
    url: Urls.obps.createForm11,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  createLandUseUP: details => Request({
    url: Urls.obps.createLandUseUP,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  createOwner: details => Request({
    url: Urls.obps.createOwner,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  updateOwner: details => Request({
    url: Urls.obps.updateOwner,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  createPurchasableFAR: details => Request({
    url: Urls.obps.createPurchasableFAR,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  updatePurchasableFAR: details => Request({
    url: Urls.obps.updatePurchasableFAR,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  calculateInstallments: details => Request({
    url: Urls.obps.installments,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  createFormCLU: details => Request({
    url: Urls.obps.createFormCLU,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  createForm34: details => Request({
    url: Urls.obps.createForm34,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  createForm26: (details, tenantId) => Request({
    url: Urls.obps.createForm26,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  NOCSearch: (tenantId, sourceRefId) => Request({
    url: Urls.obps.nocSearch,
    params: {
      tenantId,
      ...sourceRefId
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  NOCExcelCreate: (tenantId, details) => Request({
    url: Urls.noc.nocExcelCreate,
    params: {},
    data: details,
    auth: true,
    userService: true,
    method: "POST"
  }),
  NOCExcelUpdate: (tenantId, details) => Request({
    url: Urls.noc.nocExcelUpdate,
    params: {},
    data: details,
    auth: true,
    userService: true,
    method: "POST"
  }),
  update: (details, tenantId) => Request({
    url: Urls.obps.update,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  update11: (details, tenantId) => Request({
    url: Urls.obps.updateForm11,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  updateForm11: details => Request({
    url: Urls.obps.updateForm11,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  updateFormCLU: details => Request({
    url: Urls.obps.updateFormCLU,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  updateForm34: details => Request({
    url: Urls.obps.updateForm34,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  updateFormLandUse: details => Request({
    url: Urls.obps.updateFormLandUse,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  updateNOC: (details, tenantId) => Request({
    url: Urls.obps.updateNOC,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: true,
    method: "POST",
    params: {},
    auth: true
  }),
  BPASearch: (tenantId, params) => Request({
    url: Urls.obps.bpaSearch,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  BPASearchNoAuth: (tenantId, params) => Request({
    url: Urls.obps.bpaSearchChallan,
    params: {
      tenantId,
      ...params
    },
    method: "POST"
  }),
  BPAmigratedSearch: params => Request({
    url: Urls.obps.migratedSearch,
    params: {
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  BPAREGCommonSearch: (tenantId, params) => Request({
    url: Urls.obps.bpaCommonSearch,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  BPAmigratedSearchappNo: params => Request({
    url: Urls.obps.migratedSearchappNo,
    params: {
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  BPASearchForm11: (tenantId, params) => Request({
    url: Urls.obps.searchfrom11,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  BPAOwnerRegistration: (tenantId, params) => Request({
    url: Urls.obps.ownerSearch,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  BPASearchPurchasableFAR: (tenantId, params) => Request({
    url: Urls.obps.searchPurchasableFar,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  BPASearchFormLandUse: (tenantId, params) => Request({
    url: Urls.obps.searchLandUseUP,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  BPASearchForm26: (tenantId, params) => Request({
    url: Urls.obps.searchfrom26,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  BPASearchFormCLU: (tenantId, params) => Request({
    url: Urls.obps.searchFromCLU,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  BPAFastPASSearch: params => Request({
    url: Urls.obps.fastpassSearch,
    params: {
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  BPASearchForm34: (tenantId, params) => Request({
    url: Urls.obps.searchFrom34,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  BPASearchMyApplicationForm11: (tenantId, applicationType, limit, departement, details, params) => Request({
    url: Urls.obps.searchfrom11,
    params: {
      tenantId,
      applicationType,
      limit,
      departement,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST",
    data: details
  }),
  BPASearchMyApplicationForm12: (tenantId, applType, limit, departement, details, params) => Request({
    url: Urls.obps.bpaSearch,
    params: {
      tenantId,
      applType,
      limit,
      departement,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST",
    data: details
  }),
  BPAMyApplicationCommonsearch: (tenantId, applType, limit, departement, details, params) => Request({
    url: Urls.obps.bpaCommonSearch,
    params: {
      tenantId,
      applType,
      limit,
      departement,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST",
    data: details
  }),
  BPASearchMyApplicationFormLandUse: (tenantId, applicationType, limit, details, params) => Request({
    url: Urls.obps.searchLandUseUP,
    params: {
      tenantId,
      applicationType,
      limit,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST",
    data: details
  }),
  designOfApprovalLetterPdf: (tenantId, applicationNumber, params) => Request({
    url: Urls.obps.designOfApproval,
    params: {
      tenantId,
      applicationNumber,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST",
    userDownload: true
  }),
  designOfRegApprovalLetterPdf: (tenantId, applicationNumber, details) => Request({
    url: Urls.tl.designOfApproval,
    params: {
      tenantId,
      applicationNumber
    },
    auth: true,
    userService: true,
    method: "POST",
    userDownload: true,
    data: details
  }),
  designOfStructuralLetter: (tenantId, applicationNumber, params) => Request({
    url: Urls.obps.designOfStuctural,
    params: {
      tenantId,
      applicationNumber,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST",
    userDownload: true
  }),
  farIntimationLetter: (tenantId, applicationNumber) => Request({
    url: Urls.obps.farIntimationLetter,
    params: {
      tenantId,
      applicationNumber
    },
    auth: true,
    userService: true,
    method: "POST",
    data: {}
  }),
  scheduleInspection: details => Request({
    url: Urls.obps.scheduleInspection,
    auth: true,
    userService: true,
    method: "POST",
    data: details
  }),
  applicationDetailData: (tenantId, params) => Request({
    url: Urls.obps.applicationDetailData,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  logUrlData: params => Request({
    url: Urls.logoUrl.bpaLogoUrl,
    params: {
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  applicationDetailDataView: (tenantId, params) => Request({
    url: Urls.obps.applicationDetailDataView,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  NOCCountApplicationData: (tenantId, params) => Request({
    url: Urls.noc.nocCountApplicationData,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  fetchAppendex: (tenantId, params) => Request({
    url: Urls.obps.fetchAppendex,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  fetchProfessional: (tenantId, params) => Request({
    url: Urls.obps.fetchProfessional,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  NOCCountSearch: (tenantId, params) => Request({
    url: Urls.noc.nocCountSearch,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  InboxSearchApplication: (tenantId, params) => Request({
    url: Urls.InboxSearchApplication,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  InboxSearchApplicationProfessional: (tenantId, params) => Request({
    url: Urls.InboxSearchApplicationProfessional,
    params: {
      tenantId,
      ...params
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  paymentDetailData: tenantId => Request({
    url: Urls.obps.paymentList,
    params: {
      tenantId
    },
    auth: true,
    userService: true,
    method: "POST"
  }),
  paymentReportData: () => Request({
    url: Urls.obps.paymentReport,
    method: "POST"
  }),
  eChargesReportData: tenantId => Request({
    url: Urls.obps.echargesReport,
    params: {
      tenantId
    },
    method: "POST"
  }),
  applicationReportData: (tenantId, params) => Request({
    url: Urls.obps.applicationReport,
    params: {
      tenantId,
      ...params
    },
    userService: true,
    auth: true,
    method: "POST"
  }),
  applicationReportMISData: (tenantId, params) => Request({
    url: Urls.obps.applicationMisReport,
    params: {
      tenantId,
      ...params
    },
    userService: true,
    auth: true,
    method: "POST"
  }),
  searchReportData: params => Request({
    url: Urls.obps.employeeSearchList,
    params: params,
    userService: true,
    auth: true,
    method: "POST"
  }),
  paymentReportMISData: (tenantId, params) => Request({
    url: Urls.obps.paymentMisReport,
    params: {
      tenantId,
      ...params
    },
    userService: true,
    auth: true,
    method: "POST"
  }),
  paymentReportMISDataNew: async (tenantId, params) => {
    try {
      return await Request({
        url: Urls.obps.paymentMisReportNew || "/bpa-services/v1/bpa/_extractAllMisData",
        params: {
          tenantId,
          _: Date.now(),
          ...params
        },
        userService: true,
        auth: true,
        method: "POST"
      });
    } catch (err) {
      var _err$response;
      if ((err === null || err === void 0 ? void 0 : (_err$response = err.response) === null || _err$response === void 0 ? void 0 : _err$response.status) === 405) {
        return await Request({
          url: Urls.obps.paymentMisReportNew ,
          params: {
            tenantId,
            _: Date.now(),
            ...params
          },
          userService: true,
          auth: true,
          method: "GET"
        });
      }
      throw err;
    }
  },
  dashboardReportData: (tenantId, params) => Request({
    url: Urls.obps.dashboardReport,
    params: {
      tenantId,
      ...params
    },
    userService: true,
    auth: true,
    method: "POST"
  }),
  selfApprovalReportData: (tenantId, params) => Request({
    url: Urls.obps.selfApprovalReport,
    params: {
      tenantId,
      ...params
    },
    userService: true,
    auth: true,
    method: "POST"
  }),
  scrutinyReportFailedData: selectedDate => Request({
    url: Urls.obps.scrutinyFailedReport,
    params: {
      selectedDate
    },
    userService: true,
    auth: true,
    method: "GET"
  }),
  inwardReportData: tenantId => Request({
    url: Urls.obps.inwardApplicationReport,
    params: {
      tenantId
    },
    userService: true,
    auth: true,
    method: "POST"
  }),
  bpacalculate: details => Request({
    url: Urls.obps.bpacalculate,
    userService: true,
    auth: true,
    method: "POST",
    data: details
  }),
  bpacalculatechallan: details => Request({
    url: Urls.obps.bpacalculatechallan,
    userService: true,
    auth: true,
    method: "POST",
    data: details
  }),
  deleteChallan: (details, params) => Request({
    url: Urls.obps.deleteChallan,
    params: {
      ...params
    },
    userService: true,
    auth: true,
    method: "POST",
    data: details
  }),
  calculateInstallment: (details, params) => Request({
    url: Urls.obps.installmentCalculate,
    params: {
      ...params
    },
    userService: true,
    auth: true,
    method: "POST",
    data: details
  }),
  BPAREGSearch: (tenantId, details, params) => Request({
    url: Urls.obps.bpaRegSearch,
    params: {
      ...params
    },
    auth: true,
    userService: true,
    method: "POST",
    data: details
  }),
  BPAREGCreate: (details, tenantId) => Request({
    url: Urls.obps.bpaRegCreate,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: window.location.href.includes("openlink") ? false : true,
    method: "POST",
    params: {},
    auth: window.location.href.includes("openlink") ? false : true
  }),
  BPAREGGetBill: (tenantId, filters = {}) => Request({
    url: Urls.obps.bpaRegGetBill,
    useCache: false,
    method: "POST",
    auth: true,
    userService: false,
    params: {
      tenantId,
      ...filters
    }
  }).then(d => {
    return d;
  }).catch(err => {
    var _err$response2, _err$response2$data, _err$response2$data$E, _err$response2$data$E2;
    if ((err === null || err === void 0 ? void 0 : (_err$response2 = err.response) === null || _err$response2 === void 0 ? void 0 : (_err$response2$data = _err$response2.data) === null || _err$response2$data === void 0 ? void 0 : (_err$response2$data$E = _err$response2$data.Errors) === null || _err$response2$data$E === void 0 ? void 0 : (_err$response2$data$E2 = _err$response2$data$E[0]) === null || _err$response2$data$E2 === void 0 ? void 0 : _err$response2$data$E2.code) === "EG_BS_BILL_NO_DEMANDS_FOUND") return {
      Bill: []
    };else throw err;
  }),
  BPAREGupdate: (details, tenantId) => Request({
    url: Urls.obps.bpaRegUpdate,
    data: details,
    useCache: false,
    setTimeParam: false,
    userService: window.location.href.includes("openlink") ? false : true,
    method: "POST",
    params: {},
    auth: window.location.href.includes("openlink") ? false : true
  }),
  receipt_download: (bussinessService, consumerCode, tenantId, filters = {}) => Request({
    url: Urls.obps.receipt_download,
    data: {},
    useCache: true,
    method: "POST",
    params: {
      bussinessService,
      consumerCode,
      tenantId,
      ...filters
    },
    auth: true,
    locale: true,
    userService: true,
    userDownload: true
  }),
  edcr_report_download: (details, tenantId) => Request({
    url: Urls.obps.edcrreportdownload,
    data: details,
    useCache: true,
    method: "POST",
    auth: true,
    locale: true,
    userService: false,
    userDownload: true
  }),
  ltpGrading: (details, tenantId) => Request({
    url: Urls.obps.ltpGrading,
    useCache: false,
    method: "POST",
    auth: false,
    userService: false
  }),
  LicenseDetails: async (tenantId, params) => {
    var _response$Licenses, _License$tradeLicense, _License$tradeLicense2, _mdmsRes$StakeholderR, _mdmsRes$StakeholderR2, _License$tradeLicense8, _License$tradeLicense9, _License$tradeLicense10, _License$tradeLicense11, _License$tradeLicense12, _License$tradeLicense13, _License$tradeLicense14, _License$tradeLicense15, _License$tradeLicense16, _License$tradeLicense17, _License$tradeLicense18, _License$tradeLicense19, _License$tradeLicense20, _License$tradeLicense21, _License$tradeLicense22, _License$tradeLicense23, _License$tradeLicense24, _License$tradeLicense25, _License$tradeLicense26, _License$tradeLicense27, _License$tradeLicense28, _License$tradeLicense29, _License$tradeLicense30, _License$tradeLicense31, _License$tradeLicense32, _License$tradeLicense33, _License$tradeLicense34, _License$tradeLicense35, _License$tradeLicense36, _License$tradeLicense37, _License$tradeLicense38, _License$tradeLicense39, _License$tradeLicense40, _License$tradeLicense41, _License$tradeLicense42, _License$tradeLicense43, _License$tradeLicense44, _License$tradeLicense45, _License$tradeLicense46, _License$tradeLicense47, _License$tradeLicense48, _License$tradeLicense49, _License$tradeLicense50, _License$tradeLicense51, _License$tradeLicense52, _License$tradeLicense53, _License$tradeLicense54, _License$tradeLicense55, _License$tradeLicense56, _License$tradeLicense57, _License$tradeLicense58, _License$tradeLicense59, _License$tradeLicense60, _License$tradeLicense61, _License$tradeLicense62, _License$tradeLicense63, _License$tradeLicense64, _License$tradeLicense65, _License$tradeLicense66, _License$tradeLicense67, _License$tradeLicense68, _License$tradeLicense69, _License$tradeLicense70, _License$tradeLicense71, _License$tradeLicense72, _License$tradeLicense73, _License$tradeLicense74, _License$tradeLicense75, _License$tradeLicense76, _License$tradeLicense77, _License$tradeLicense78, _License$tradeLicense79, _License$tradeLicense80, _License$tradeLicense81, _License$tradeLicense82, _License$tradeLicense83, _License$tradeLicense84, _License$tradeLicense85, _License$tradeLicense86, _License$tradeLicense87, _License$tradeLicense88, _License$tradeLicense89, _License$tradeLicense90, _License$tradeLicense91, _License$tradeLicense92, _License$tradeLicense93, _License$tradeLicense94, _License$tradeLicense95, _License$tradeLicense96, _License$tradeLicense97, _License$tradeLicense98, _License$tradeLicense99, _License$tradeLicense100, _License$tradeLicense101, _License$tradeLicense102, _License$tradeLicense103, _License$tradeLicense104, _License$tradeLicense105, _License$tradeLicense106, _License$tradeLicense107, _License$tradeLicense108, _License$tradeLicense109, _License$tradeLicense110, _License$tradeLicense111, _License$tradeLicense112, _License$tradeLicense113, _License$tradeLicense114, _License$tradeLicense115, _License$tradeLicense116, _License$tradeLicense117, _License$tradeLicense118, _License$tradeLicense119, _License$tradeLicense120, _License$tradeLicense121, _License$tradeLicense122, _License$tradeLicense123, _License$tradeLicense124, _License$tradeLicense125, _License$tradeLicense126, _License$tradeLicense127, _License$tradeLicense128, _License$tradeLicense129, _License$tradeLicense130, _License$tradeLicense131, _License$tradeLicense132, _License$tradeLicense133, _License$tradeLicense134, _License$tradeLicense135, _License$tradeLicense136, _License$tradeLicense137, _paymentRes$Payments, _paymentRes$Payments2, _paymentRes$Payments3, _paymentRes$Payments4, _paymentRes$Payments5;
    const response = await OBPSService.BPAREGSearch(tenantId, {}, params);
    if (!(response !== null && response !== void 0 && (_response$Licenses = response.Licenses) !== null && _response$Licenses !== void 0 && _response$Licenses.length)) {
      return;
    }
    const [License] = response === null || response === void 0 ? void 0 : response.Licenses;
    const paymentRes = await Digit.PaymentService.recieptSearch(tenantId, "BPAREG", {
      consumerCodes: License === null || License === void 0 ? void 0 : License.applicationNumber,
      isEmployee: true
    });
    const mdmsRes = await MdmsService.getMultipleTypes(License === null || License === void 0 ? void 0 : License.tenantId, "StakeholderRegistraition", ["TradeTypetoRoleMapping"]);
    if (License !== null && License !== void 0 && (_License$tradeLicense = License.tradeLicenseDetail) !== null && _License$tradeLicense !== void 0 && (_License$tradeLicense2 = _License$tradeLicense.applicationDocuments) !== null && _License$tradeLicense2 !== void 0 && _License$tradeLicense2.length && (mdmsRes === null || mdmsRes === void 0 ? void 0 : (_mdmsRes$StakeholderR = mdmsRes.StakeholderRegistraition) === null || _mdmsRes$StakeholderR === void 0 ? void 0 : (_mdmsRes$StakeholderR2 = _mdmsRes$StakeholderR.TradeTypetoRoleMapping) === null || _mdmsRes$StakeholderR2 === void 0 ? void 0 : _mdmsRes$StakeholderR2.length) > 0) {
      var _mdmsRes$StakeholderR3, _mdmsRes$StakeholderR4;
      mdmsRes === null || mdmsRes === void 0 ? void 0 : (_mdmsRes$StakeholderR3 = mdmsRes.StakeholderRegistraition) === null || _mdmsRes$StakeholderR3 === void 0 ? void 0 : (_mdmsRes$StakeholderR4 = _mdmsRes$StakeholderR3.TradeTypetoRoleMapping) === null || _mdmsRes$StakeholderR4 === void 0 ? void 0 : _mdmsRes$StakeholderR4.map(doc => {
        var _doc$docTypes, _License$tradeLicense3, _License$tradeLicense4, _License$tradeLicense5;
        if ((doc === null || doc === void 0 ? void 0 : (_doc$docTypes = doc.docTypes) === null || _doc$docTypes === void 0 ? void 0 : _doc$docTypes.length) > 0 && (doc === null || doc === void 0 ? void 0 : doc.tradeType) == (License === null || License === void 0 ? void 0 : (_License$tradeLicense3 = License.tradeLicenseDetail) === null || _License$tradeLicense3 === void 0 ? void 0 : (_License$tradeLicense4 = _License$tradeLicense3.tradeUnits) === null || _License$tradeLicense4 === void 0 ? void 0 : (_License$tradeLicense5 = _License$tradeLicense4[0]) === null || _License$tradeLicense5 === void 0 ? void 0 : _License$tradeLicense5.tradeType)) {
          var _doc$docTypes2;
          doc === null || doc === void 0 ? void 0 : (_doc$docTypes2 = doc.docTypes) === null || _doc$docTypes2 === void 0 ? void 0 : _doc$docTypes2.map(docType => {
            var _License$tradeLicense6, _License$tradeLicense7;
            License === null || License === void 0 ? void 0 : (_License$tradeLicense6 = License.tradeLicenseDetail) === null || _License$tradeLicense6 === void 0 ? void 0 : (_License$tradeLicense7 = _License$tradeLicense6.applicationDocuments) === null || _License$tradeLicense7 === void 0 ? void 0 : _License$tradeLicense7.forEach(document => {
              if ((docType === null || docType === void 0 ? void 0 : docType.code) == (document === null || document === void 0 ? void 0 : document.documentType) && docType !== null && docType !== void 0 && docType.info) document.info = docType === null || docType === void 0 ? void 0 : docType.info;
            });
          });
        }
      });
    }
    const appDocumentFileStoreIds = License === null || License === void 0 ? void 0 : (_License$tradeLicense8 = License.tradeLicenseDetail) === null || _License$tradeLicense8 === void 0 ? void 0 : (_License$tradeLicense9 = _License$tradeLicense8.applicationDocuments) === null || _License$tradeLicense9 === void 0 ? void 0 : _License$tradeLicense9.map(appDoc => appDoc === null || appDoc === void 0 ? void 0 : appDoc.fileStoreId);
    let fileDetails = {};
    if ((appDocumentFileStoreIds === null || appDocumentFileStoreIds === void 0 ? void 0 : appDocumentFileStoreIds.length) > 0) {
      fileDetails = await UploadServices.Filefetch(appDocumentFileStoreIds, Digit.ULBService.getStateId());
    }
    const details = [{
      title: " ",
      values: [{
        title: "BPA_APPLICATION_NUMBER_LABEL",
        value: (License === null || License === void 0 ? void 0 : License.applicationNumber) || "NA"
      }]
    }, License !== null && License !== void 0 && (_License$tradeLicense10 = License.tradeLicenseDetail) !== null && _License$tradeLicense10 !== void 0 && (_License$tradeLicense11 = _License$tradeLicense10.tradeUnits) !== null && _License$tradeLicense11 !== void 0 && (_License$tradeLicense12 = _License$tradeLicense11[0]) !== null && _License$tradeLicense12 !== void 0 && _License$tradeLicense12.tradeType.includes("ARCHITECT") ? {
      title: "BPA_LICENSE_DETAILS_LABEL",
      asSectionHeader: true,
      values: [{
        title: "BPA_LICENSE_TYPE",
        value: `TRADELICENSE_TRADETYPE_${License === null || License === void 0 ? void 0 : (_License$tradeLicense13 = License.tradeLicenseDetail) === null || _License$tradeLicense13 === void 0 ? void 0 : (_License$tradeLicense14 = _License$tradeLicense13.tradeUnits) === null || _License$tradeLicense14 === void 0 ? void 0 : (_License$tradeLicense15 = _License$tradeLicense14[0]) === null || _License$tradeLicense15 === void 0 ? void 0 : (_License$tradeLicense16 = _License$tradeLicense15.tradeType) === null || _License$tradeLicense16 === void 0 ? void 0 : _License$tradeLicense16.split(".")[0]}` || "NA"
      }, {
        title: "BPA_COUNCIL_OF_ARCH_NO_LABEL",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense17 = License.tradeLicenseDetail) === null || _License$tradeLicense17 === void 0 ? void 0 : (_License$tradeLicense18 = _License$tradeLicense17.additionalDetail) === null || _License$tradeLicense18 === void 0 ? void 0 : _License$tradeLicense18.counsilForArchNo) || "NA"
      }]
    } : {
      title: "BPA_LICENSE_DETAILS_LABEL",
      asSectionHeader: true,
      values: [{
        title: "BPA_LICENSE_TYPE",
        value: `TRADELICENSE_TRADETYPE_${License === null || License === void 0 ? void 0 : (_License$tradeLicense19 = License.tradeLicenseDetail) === null || _License$tradeLicense19 === void 0 ? void 0 : (_License$tradeLicense20 = _License$tradeLicense19.tradeUnits) === null || _License$tradeLicense20 === void 0 ? void 0 : (_License$tradeLicense21 = _License$tradeLicense20[0]) === null || _License$tradeLicense21 === void 0 ? void 0 : (_License$tradeLicense22 = _License$tradeLicense21.tradeType) === null || _License$tradeLicense22 === void 0 ? void 0 : _License$tradeLicense22.split(".")[0]}` || "NA"
      }]
    }, {
      title: "BPA_LICENSEE_DETAILS_HEADER_OWNER_INFO",
      asSectionHeader: true,
      values: [{
        title: "BPA_APPLICANT_NAME_LABEL",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense23 = License.tradeLicenseDetail) === null || _License$tradeLicense23 === void 0 ? void 0 : (_License$tradeLicense24 = _License$tradeLicense23.owners) === null || _License$tradeLicense24 === void 0 ? void 0 : (_License$tradeLicense25 = _License$tradeLicense24[0]) === null || _License$tradeLicense25 === void 0 ? void 0 : _License$tradeLicense25.name) || "NA"
      }, {
        title: "BPA_APPLICANT_GENDER_LABEL",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense26 = License.tradeLicenseDetail) === null || _License$tradeLicense26 === void 0 ? void 0 : (_License$tradeLicense27 = _License$tradeLicense26.owners) === null || _License$tradeLicense27 === void 0 ? void 0 : (_License$tradeLicense28 = _License$tradeLicense27[0]) === null || _License$tradeLicense28 === void 0 ? void 0 : _License$tradeLicense28.gender) || "NA"
      }, {
        title: "BPA_OWNER_MOBILE_NO_LABEL",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense29 = License.tradeLicenseDetail) === null || _License$tradeLicense29 === void 0 ? void 0 : (_License$tradeLicense30 = _License$tradeLicense29.owners) === null || _License$tradeLicense30 === void 0 ? void 0 : (_License$tradeLicense31 = _License$tradeLicense30[0]) === null || _License$tradeLicense31 === void 0 ? void 0 : _License$tradeLicense31.mobileNumber) || "NA"
      }, {
        title: "BPA_APPLICANT_EMAIL_LABEL",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense32 = License.tradeLicenseDetail) === null || _License$tradeLicense32 === void 0 ? void 0 : (_License$tradeLicense33 = _License$tradeLicense32.owners) === null || _License$tradeLicense33 === void 0 ? void 0 : (_License$tradeLicense34 = _License$tradeLicense33[0]) === null || _License$tradeLicense34 === void 0 ? void 0 : _License$tradeLicense34.emailId) || "NA"
      }, {
        title: "BPA_APPLICANT_PAN_NO",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense35 = License.tradeLicenseDetail) === null || _License$tradeLicense35 === void 0 ? void 0 : (_License$tradeLicense36 = _License$tradeLicense35.owners) === null || _License$tradeLicense36 === void 0 ? void 0 : (_License$tradeLicense37 = _License$tradeLicense36[0]) === null || _License$tradeLicense37 === void 0 ? void 0 : _License$tradeLicense37.pan) || "NA"
      }]
    }, {
      title: "BPA_PERMANANT_ADDRESS_LABEL",
      asSectionHeader: true,
      values: [{
        title: "BPA_PERMANANT_ADDRESS_LABEL",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense38 = License.tradeLicenseDetail) === null || _License$tradeLicense38 === void 0 ? void 0 : (_License$tradeLicense39 = _License$tradeLicense38.additionalDetail) === null || _License$tradeLicense39 === void 0 ? void 0 : (_License$tradeLicense40 = _License$tradeLicense39[0]) === null || _License$tradeLicense40 === void 0 ? void 0 : (_License$tradeLicense41 = _License$tradeLicense40.tradeLicenseDetail) === null || _License$tradeLicense41 === void 0 ? void 0 : (_License$tradeLicense42 = _License$tradeLicense41.owners) === null || _License$tradeLicense42 === void 0 ? void 0 : (_License$tradeLicense43 = _License$tradeLicense42[0]) === null || _License$tradeLicense43 === void 0 ? void 0 : (_License$tradeLicense44 = _License$tradeLicense43.permanentAddress) === null || _License$tradeLicense44 === void 0 ? void 0 : _License$tradeLicense44.address) || "NA"
      }, {
        title: "CORE_COMMON_STATE",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense45 = License.tradeLicenseDetail) === null || _License$tradeLicense45 === void 0 ? void 0 : (_License$tradeLicense46 = _License$tradeLicense45.additionalDetail) === null || _License$tradeLicense46 === void 0 ? void 0 : (_License$tradeLicense47 = _License$tradeLicense46[0]) === null || _License$tradeLicense47 === void 0 ? void 0 : (_License$tradeLicense48 = _License$tradeLicense47.tradeLicenseDetail) === null || _License$tradeLicense48 === void 0 ? void 0 : (_License$tradeLicense49 = _License$tradeLicense48.owners) === null || _License$tradeLicense49 === void 0 ? void 0 : (_License$tradeLicense50 = _License$tradeLicense49[0]) === null || _License$tradeLicense50 === void 0 ? void 0 : (_License$tradeLicense51 = _License$tradeLicense50.permanentAddress) === null || _License$tradeLicense51 === void 0 ? void 0 : _License$tradeLicense51.state) || "NA"
      }, {
        title: "CORE_COMMON_DISTRICT",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense52 = License.tradeLicenseDetail) === null || _License$tradeLicense52 === void 0 ? void 0 : (_License$tradeLicense53 = _License$tradeLicense52.additionalDetail) === null || _License$tradeLicense53 === void 0 ? void 0 : (_License$tradeLicense54 = _License$tradeLicense53[0]) === null || _License$tradeLicense54 === void 0 ? void 0 : (_License$tradeLicense55 = _License$tradeLicense54.tradeLicenseDetail) === null || _License$tradeLicense55 === void 0 ? void 0 : (_License$tradeLicense56 = _License$tradeLicense55.owners) === null || _License$tradeLicense56 === void 0 ? void 0 : (_License$tradeLicense57 = _License$tradeLicense56[0]) === null || _License$tradeLicense57 === void 0 ? void 0 : (_License$tradeLicense58 = _License$tradeLicense57.permanentAddress) === null || _License$tradeLicense58 === void 0 ? void 0 : _License$tradeLicense58.district) || "NA"
      }, {
        title: "CORE_COMMON_TEHSIL",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense59 = License.tradeLicenseDetail) === null || _License$tradeLicense59 === void 0 ? void 0 : (_License$tradeLicense60 = _License$tradeLicense59.additionalDetail) === null || _License$tradeLicense60 === void 0 ? void 0 : (_License$tradeLicense61 = _License$tradeLicense60[0]) === null || _License$tradeLicense61 === void 0 ? void 0 : (_License$tradeLicense62 = _License$tradeLicense61.tradeLicenseDetail) === null || _License$tradeLicense62 === void 0 ? void 0 : (_License$tradeLicense63 = _License$tradeLicense62.owners) === null || _License$tradeLicense63 === void 0 ? void 0 : (_License$tradeLicense64 = _License$tradeLicense63[0]) === null || _License$tradeLicense64 === void 0 ? void 0 : (_License$tradeLicense65 = _License$tradeLicense64.permanentAddress) === null || _License$tradeLicense65 === void 0 ? void 0 : _License$tradeLicense65.tehsil) || "NA"
      }, {
        title: "CORE_COMMON_TOWN",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense66 = License.tradeLicenseDetail) === null || _License$tradeLicense66 === void 0 ? void 0 : (_License$tradeLicense67 = _License$tradeLicense66.additionalDetail) === null || _License$tradeLicense67 === void 0 ? void 0 : (_License$tradeLicense68 = _License$tradeLicense67[0]) === null || _License$tradeLicense68 === void 0 ? void 0 : (_License$tradeLicense69 = _License$tradeLicense68.tradeLicenseDetail) === null || _License$tradeLicense69 === void 0 ? void 0 : (_License$tradeLicense70 = _License$tradeLicense69.owners) === null || _License$tradeLicense70 === void 0 ? void 0 : (_License$tradeLicense71 = _License$tradeLicense70[0]) === null || _License$tradeLicense71 === void 0 ? void 0 : (_License$tradeLicense72 = _License$tradeLicense71.permanentAddress) === null || _License$tradeLicense72 === void 0 ? void 0 : _License$tradeLicense72.town) || "NA"
      }, {
        title: "CORE_COMMON_PINNO",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense73 = License.tradeLicenseDetail) === null || _License$tradeLicense73 === void 0 ? void 0 : (_License$tradeLicense74 = _License$tradeLicense73.additionalDetail) === null || _License$tradeLicense74 === void 0 ? void 0 : (_License$tradeLicense75 = _License$tradeLicense74[0]) === null || _License$tradeLicense75 === void 0 ? void 0 : (_License$tradeLicense76 = _License$tradeLicense75.tradeLicenseDetail) === null || _License$tradeLicense76 === void 0 ? void 0 : (_License$tradeLicense77 = _License$tradeLicense76.owners) === null || _License$tradeLicense77 === void 0 ? void 0 : (_License$tradeLicense78 = _License$tradeLicense77[0]) === null || _License$tradeLicense78 === void 0 ? void 0 : (_License$tradeLicense79 = _License$tradeLicense78.permanentAddress) === null || _License$tradeLicense79 === void 0 ? void 0 : _License$tradeLicense79.pinNo) || "NA"
      }, {
        title: "CORE_COMMON_UNIVERSITY_NAME",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense80 = License.tradeLicenseDetail) === null || _License$tradeLicense80 === void 0 ? void 0 : (_License$tradeLicense81 = _License$tradeLicense80.additionalDetail) === null || _License$tradeLicense81 === void 0 ? void 0 : (_License$tradeLicense82 = _License$tradeLicense81[0]) === null || _License$tradeLicense82 === void 0 ? void 0 : (_License$tradeLicense83 = _License$tradeLicense82.tradeLicenseDetail) === null || _License$tradeLicense83 === void 0 ? void 0 : (_License$tradeLicense84 = _License$tradeLicense83.owners) === null || _License$tradeLicense84 === void 0 ? void 0 : (_License$tradeLicense85 = _License$tradeLicense84[0]) === null || _License$tradeLicense85 === void 0 ? void 0 : (_License$tradeLicense86 = _License$tradeLicense85.permanentAddress) === null || _License$tradeLicense86 === void 0 ? void 0 : _License$tradeLicense86.university) || "NA"
      }]
    }, {
      title: "BPA_APPLICANT_CORRESPONDENCE_ADDRESS_LABEL",
      asSectionHeader: true,
      values: [{
        title: "BPA_APPLICANT_CORRESPONDENCE_ADDRESS_LABEL",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense87 = License.tradeLicenseDetail) === null || _License$tradeLicense87 === void 0 ? void 0 : (_License$tradeLicense88 = _License$tradeLicense87.additionalDetail) === null || _License$tradeLicense88 === void 0 ? void 0 : (_License$tradeLicense89 = _License$tradeLicense88[0]) === null || _License$tradeLicense89 === void 0 ? void 0 : (_License$tradeLicense90 = _License$tradeLicense89.tradeLicenseDetail) === null || _License$tradeLicense90 === void 0 ? void 0 : (_License$tradeLicense91 = _License$tradeLicense90.owners) === null || _License$tradeLicense91 === void 0 ? void 0 : (_License$tradeLicense92 = _License$tradeLicense91[0]) === null || _License$tradeLicense92 === void 0 ? void 0 : (_License$tradeLicense93 = _License$tradeLicense92.correspondenceAddress) === null || _License$tradeLicense93 === void 0 ? void 0 : _License$tradeLicense93.address) || "NA"
      }, {
        title: "CORE_COMMON_STATE",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense94 = License.tradeLicenseDetail) === null || _License$tradeLicense94 === void 0 ? void 0 : (_License$tradeLicense95 = _License$tradeLicense94.additionalDetail) === null || _License$tradeLicense95 === void 0 ? void 0 : (_License$tradeLicense96 = _License$tradeLicense95[0]) === null || _License$tradeLicense96 === void 0 ? void 0 : (_License$tradeLicense97 = _License$tradeLicense96.tradeLicenseDetail) === null || _License$tradeLicense97 === void 0 ? void 0 : (_License$tradeLicense98 = _License$tradeLicense97.owners) === null || _License$tradeLicense98 === void 0 ? void 0 : (_License$tradeLicense99 = _License$tradeLicense98[0]) === null || _License$tradeLicense99 === void 0 ? void 0 : (_License$tradeLicense100 = _License$tradeLicense99.correspondenceAddress) === null || _License$tradeLicense100 === void 0 ? void 0 : _License$tradeLicense100.state) || "NA"
      }, {
        title: "CORE_COMMON_DISTRICT",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense101 = License.tradeLicenseDetail) === null || _License$tradeLicense101 === void 0 ? void 0 : (_License$tradeLicense102 = _License$tradeLicense101.additionalDetail) === null || _License$tradeLicense102 === void 0 ? void 0 : (_License$tradeLicense103 = _License$tradeLicense102[0]) === null || _License$tradeLicense103 === void 0 ? void 0 : (_License$tradeLicense104 = _License$tradeLicense103.tradeLicenseDetail) === null || _License$tradeLicense104 === void 0 ? void 0 : (_License$tradeLicense105 = _License$tradeLicense104.owners) === null || _License$tradeLicense105 === void 0 ? void 0 : (_License$tradeLicense106 = _License$tradeLicense105[0]) === null || _License$tradeLicense106 === void 0 ? void 0 : (_License$tradeLicense107 = _License$tradeLicense106.correspondenceAddress) === null || _License$tradeLicense107 === void 0 ? void 0 : _License$tradeLicense107.district) || "NA"
      }, {
        title: "CORE_COMMON_TEHSIL",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense108 = License.tradeLicenseDetail) === null || _License$tradeLicense108 === void 0 ? void 0 : (_License$tradeLicense109 = _License$tradeLicense108.additionalDetail) === null || _License$tradeLicense109 === void 0 ? void 0 : (_License$tradeLicense110 = _License$tradeLicense109[0]) === null || _License$tradeLicense110 === void 0 ? void 0 : (_License$tradeLicense111 = _License$tradeLicense110.tradeLicenseDetail) === null || _License$tradeLicense111 === void 0 ? void 0 : (_License$tradeLicense112 = _License$tradeLicense111.owners) === null || _License$tradeLicense112 === void 0 ? void 0 : (_License$tradeLicense113 = _License$tradeLicense112[0]) === null || _License$tradeLicense113 === void 0 ? void 0 : (_License$tradeLicense114 = _License$tradeLicense113.correspondenceAddress) === null || _License$tradeLicense114 === void 0 ? void 0 : _License$tradeLicense114.tehsil) || "NA"
      }, {
        title: "CORE_COMMON_TOWN",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense115 = License.tradeLicenseDetail) === null || _License$tradeLicense115 === void 0 ? void 0 : (_License$tradeLicense116 = _License$tradeLicense115.additionalDetail) === null || _License$tradeLicense116 === void 0 ? void 0 : (_License$tradeLicense117 = _License$tradeLicense116[0]) === null || _License$tradeLicense117 === void 0 ? void 0 : (_License$tradeLicense118 = _License$tradeLicense117.tradeLicenseDetail) === null || _License$tradeLicense118 === void 0 ? void 0 : (_License$tradeLicense119 = _License$tradeLicense118.owners) === null || _License$tradeLicense119 === void 0 ? void 0 : (_License$tradeLicense120 = _License$tradeLicense119[0]) === null || _License$tradeLicense120 === void 0 ? void 0 : (_License$tradeLicense121 = _License$tradeLicense120.correspondenceAddress) === null || _License$tradeLicense121 === void 0 ? void 0 : _License$tradeLicense121.town) || "NA"
      }, {
        title: "CORE_COMMON_PINNO",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense122 = License.tradeLicenseDetail) === null || _License$tradeLicense122 === void 0 ? void 0 : (_License$tradeLicense123 = _License$tradeLicense122.additionalDetail) === null || _License$tradeLicense123 === void 0 ? void 0 : (_License$tradeLicense124 = _License$tradeLicense123[0]) === null || _License$tradeLicense124 === void 0 ? void 0 : (_License$tradeLicense125 = _License$tradeLicense124.tradeLicenseDetail) === null || _License$tradeLicense125 === void 0 ? void 0 : (_License$tradeLicense126 = _License$tradeLicense125.owners) === null || _License$tradeLicense126 === void 0 ? void 0 : (_License$tradeLicense127 = _License$tradeLicense126[0]) === null || _License$tradeLicense127 === void 0 ? void 0 : (_License$tradeLicense128 = _License$tradeLicense127.correspondenceAddress) === null || _License$tradeLicense128 === void 0 ? void 0 : _License$tradeLicense128.pinNo) || "NA"
      }, {
        title: "CORE_COMMON_UNIVERSITY_NAME",
        value: (License === null || License === void 0 ? void 0 : (_License$tradeLicense129 = License.tradeLicenseDetail) === null || _License$tradeLicense129 === void 0 ? void 0 : (_License$tradeLicense130 = _License$tradeLicense129.additionalDetail) === null || _License$tradeLicense130 === void 0 ? void 0 : (_License$tradeLicense131 = _License$tradeLicense130[0]) === null || _License$tradeLicense131 === void 0 ? void 0 : (_License$tradeLicense132 = _License$tradeLicense131.tradeLicenseDetail) === null || _License$tradeLicense132 === void 0 ? void 0 : (_License$tradeLicense133 = _License$tradeLicense132.owners) === null || _License$tradeLicense133 === void 0 ? void 0 : (_License$tradeLicense134 = _License$tradeLicense133[0]) === null || _License$tradeLicense134 === void 0 ? void 0 : (_License$tradeLicense135 = _License$tradeLicense134.correspondenceAddress) === null || _License$tradeLicense135 === void 0 ? void 0 : _License$tradeLicense135.university) || "NA"
      }]
    }, {
      title: "BPA_DOCUMENT_DETAILS_LABEL",
      asSectionHeader: true,
      additionalDetails: {
        documentsWithUrl: [{
          title: "",
          values: License === null || License === void 0 ? void 0 : (_License$tradeLicense136 = License.tradeLicenseDetail) === null || _License$tradeLicense136 === void 0 ? void 0 : (_License$tradeLicense137 = _License$tradeLicense136.applicationDocuments) === null || _License$tradeLicense137 === void 0 ? void 0 : _License$tradeLicense137.map(doc => {
            var _doc$documentType, _fileDetails, _fileDetails2, _fileDetails2$data$do;
            return {
              title: `BPAREG_HEADER_${doc === null || doc === void 0 ? void 0 : (_doc$documentType = doc.documentType) === null || _doc$documentType === void 0 ? void 0 : _doc$documentType.replaceAll(".", "_")}`,
              documentType: doc === null || doc === void 0 ? void 0 : doc.documentType,
              documentUid: doc === null || doc === void 0 ? void 0 : doc.documentUid,
              fileStoreId: doc === null || doc === void 0 ? void 0 : doc.fileStoreId,
              id: doc === null || doc === void 0 ? void 0 : doc.id,
              docInfo: doc === null || doc === void 0 ? void 0 : doc.info,
              url: (_fileDetails = fileDetails) !== null && _fileDetails !== void 0 && _fileDetails.data[doc === null || doc === void 0 ? void 0 : doc.fileStoreId] ? (_fileDetails2 = fileDetails) === null || _fileDetails2 === void 0 ? void 0 : (_fileDetails2$data$do = _fileDetails2.data[doc === null || doc === void 0 ? void 0 : doc.fileStoreId]) === null || _fileDetails2$data$do === void 0 ? void 0 : _fileDetails2$data$do.split(",")[0] : ""
            };
          })
        }]
      }
    }, (paymentRes === null || paymentRes === void 0 ? void 0 : (_paymentRes$Payments = paymentRes.Payments) === null || _paymentRes$Payments === void 0 ? void 0 : _paymentRes$Payments.length) > 0 && {
      title: "BPA_FEE_DETAILS_LABEL",
      additionalDetails: {
        inspectionReport: [],
        values: [{
          title: "BPAREG_FEES",
          value: /*#__PURE__*/React__default.createElement("span", null, "\u20B9", paymentRes === null || paymentRes === void 0 ? void 0 : (_paymentRes$Payments2 = paymentRes.Payments) === null || _paymentRes$Payments2 === void 0 ? void 0 : (_paymentRes$Payments3 = _paymentRes$Payments2[0]) === null || _paymentRes$Payments3 === void 0 ? void 0 : _paymentRes$Payments3.totalAmountPaid)
        }, {
          title: "BPA_STATUS_LABEL",
          isTransLate: true,
          isStatus: true,
          value: paymentRes !== null && paymentRes !== void 0 && (_paymentRes$Payments4 = paymentRes.Payments) !== null && _paymentRes$Payments4 !== void 0 && (_paymentRes$Payments5 = _paymentRes$Payments4[0]) !== null && _paymentRes$Payments5 !== void 0 && _paymentRes$Payments5.totalAmountPaid ? "WF_BPA_PAID" : "NA",
          isTransLate: true
        }]
      }
    }];
    return {
      applicationData: License,
      applicationDetails: details,
      tenantId: License === null || License === void 0 ? void 0 : License.tenantId,
      payments: (paymentRes === null || paymentRes === void 0 ? void 0 : paymentRes.Payments) || []
    };
  },
  BPADetailsPage: async (tenantId, filters) => {
    var _response$BPA, _response$BPA$, _response$BPA$$docume, _response$BPA2, _response$BPA3, _response$BPA3$, _response$BPA3$$addit, _response$BPA4, _response$BPA4$, _response$BPA4$$addit, _response$BPA5, _edcrResponse, _BPA$additionalDetail, _BPA$additionalDetail2, _BPA$additionalDetail3, _BPA$additionalDetail4, _BPA$additionalDetail5, _BPA$additionalDetail6, _BPA$additionalDetail7, _BPA$additionalDetail8, _BPA$additionalDetail9, _BPA$auditDetails, _BPA$auditDetails2, _edcr$, _edcr$2, _edcr$3, _edcr$3$planDetail, _edcr$3$planDetail$pl, _edcr$4, _edcr$4$planDetail, _edcr$4$planDetail$pl, _edcr$5, _edcr$5$planDetail, _edcr$5$planDetail$pl, _edcr$6, _edcr$6$planDetail, _edcr$6$planDetail$pl, _edcr$7, _edcr$7$planDetail, _edcr$7$planDetail$pl, _BPA$additionalDetail13, _BPA$additionalDetail14, _edcr$8, _edcr$9, _edcr$10, _edcr$11, _edcr$11$planDetail, _edcr$11$planDetail$b, _edcr$11$planDetail$b2, _edcr$11$planDetail$b3, _edcr$12, _edcr$12$planDetail, _edcr$12$planDetail$b, _edcr$12$planDetail$b2, _edcr$12$planDetail$b3, _edcr$13, _edcr$13$planDetail, _edcr$13$planDetail$b, _edcr$13$planDetail$b2, _edcr$13$planDetail$b3, _edcr$14, _edcr$14$planDetail, _edcr$14$planDetail$p, _BPA$landInfo, _BPA$landInfo$address, _BPA$additionalDetail15, _BPA$additionalDetail16, _BPA$additionalDetail17, _BPA$additionalDetail18, _BPA$additionalDetail19, _BPA$additionalDetail20, _BPA$landInfo2, _BPA$landInfo2$owners, _BPA$landInfo3, _BPA$landInfo3$owners, _BPA$additionalDetail21, _BPA$additionalDetail22, _BPA$additionalDetail23, _BPA$documents, _BPA$additionalDetail24, _BPA$additionalDetail25, _BPA$additionalDetail26, _BPA$additionalDetail27, _BPA$additionalDetail28, _BPA$additionalDetail29, _BPA$additionalDetail30, _billDetails$addition, _billDetails$addition2, _details;
    const response = await OBPSService.BPASearch(tenantId, filters);
    console.log("Latest5111111111111111111", response);
    const currentTenant = Digit.ULBService.getCurrentTenantId();
    let appDocumentFileStoreIds = response === null || response === void 0 ? void 0 : (_response$BPA = response.BPA) === null || _response$BPA === void 0 ? void 0 : (_response$BPA$ = _response$BPA[0]) === null || _response$BPA$ === void 0 ? void 0 : (_response$BPA$$docume = _response$BPA$.documents) === null || _response$BPA$$docume === void 0 ? void 0 : _response$BPA$$docume.map(docId => docId.fileStoreId);
    if (!appDocumentFileStoreIds) appDocumentFileStoreIds = [];
    if (!(response !== null && response !== void 0 && (_response$BPA2 = response.BPA) !== null && _response$BPA2 !== void 0 && _response$BPA2.length)) {
      return;
    }
    sessionStorage.setItem("BPA_ARCHITECT_NAME", JSON.stringify(response !== null && response !== void 0 && (_response$BPA3 = response.BPA) !== null && _response$BPA3 !== void 0 && (_response$BPA3$ = _response$BPA3[0]) !== null && _response$BPA3$ !== void 0 && (_response$BPA3$$addit = _response$BPA3$.additionalDetails) !== null && _response$BPA3$$addit !== void 0 && _response$BPA3$$addit.typeOfArchitect ? response === null || response === void 0 ? void 0 : (_response$BPA4 = response.BPA) === null || _response$BPA4 === void 0 ? void 0 : (_response$BPA4$ = _response$BPA4[0]) === null || _response$BPA4$ === void 0 ? void 0 : (_response$BPA4$$addit = _response$BPA4$.additionalDetails) === null || _response$BPA4$$addit === void 0 ? void 0 : _response$BPA4$$addit.typeOfArchitect : "ARCHITECT"));
    const BPA = response === null || response === void 0 ? void 0 : (_response$BPA5 = response.BPA) === null || _response$BPA5 === void 0 ? void 0 : _response$BPA5[0];
    let edcrResponse = {};
    if (BPA !== null && BPA !== void 0 && BPA.edcrNumber) {
      edcrResponse = await OBPSService.scrutinyDetails(currentTenant, {
        edcrNumber: BPA === null || BPA === void 0 ? void 0 : BPA.edcrNumber
      });
    }
    const edcr = ((_edcrResponse = edcrResponse) === null || _edcrResponse === void 0 ? void 0 : _edcrResponse.edcrDetail) || [];
    const nocResponse = await OBPSService.NOCSearch(currentTenant, {
      sourceRefId: BPA === null || BPA === void 0 ? void 0 : BPA.applicationNo
    });
    const noc = nocResponse === null || nocResponse === void 0 ? void 0 : nocResponse.Noc;
    noc === null || noc === void 0 ? void 0 : noc.map(nocDetails => {
      var _nocDetails$documents;
      nocDetails === null || nocDetails === void 0 ? void 0 : (_nocDetails$documents = nocDetails.documents) === null || _nocDetails$documents === void 0 ? void 0 : _nocDetails$documents.map(nocDoc => {
        if (nocDoc !== null && nocDoc !== void 0 && nocDoc.fileStoreId) appDocumentFileStoreIds.push(nocDoc === null || nocDoc === void 0 ? void 0 : nocDoc.fileStoreId);
      });
    });
    let fileDetails = {};
    let appBusinessService = [],
      collectionBillDetails = [],
      collectionBillArray = [],
      totalAmount = 0,
      collectionBillRes = [];
    const bussinessService = BPA === null || BPA === void 0 ? void 0 : BPA.businessService;
    const isUD = bussinessService === null || bussinessService === void 0 ? void 0 : bussinessService.includes("UD");
    if (bussinessService === "BPA_LOW") appBusinessService = ["BPA.LOW_RISK_PERMIT_FEE"];else if (bussinessService === "BPA") appBusinessService = ["BPA.FORM_12_FEE_UD", "BPA.FORM_12_FEE_UD"];else if (bussinessService === "BPA_OC") appBusinessService = ["BPA.NC_OC_APP_FEE", "BPA.NC_OC_SAN_FEE"];
    if (bussinessService !== null && bussinessService !== void 0 && bussinessService.includes("UD") || bussinessService !== null && bussinessService !== void 0 && bussinessService.includes("TCP")) appBusinessService = ["BPA.FORM_12_FEE", "BPA.FORM_12_FEE_UD"];
    const splittedFeeData = BPA === null || BPA === void 0 ? void 0 : (_BPA$additionalDetail = BPA.additionalDetails) === null || _BPA$additionalDetail === void 0 ? void 0 : (_BPA$additionalDetail2 = _BPA$additionalDetail.taxHeadEstimates) === null || _BPA$additionalDetail2 === void 0 ? void 0 : _BPA$additionalDetail2.map(item => {
      return Object.fromEntries(Object.entries(item).filter(([key, value]) => typeof value === "number"));
    });
    for (let _i = 0; _i < ((_appBusinessService = appBusinessService) === null || _appBusinessService === void 0 ? void 0 : _appBusinessService.length); _i++) {
      var _appBusinessService, _collectionres$Paymen, _collectionres$Paymen3;
      let collectionres = await Digit.PaymentService.recieptSearch(BPA === null || BPA === void 0 ? void 0 : BPA.tenantId, appBusinessService[_i], {
        consumerCodes: BPA === null || BPA === void 0 ? void 0 : BPA.applicationNo,
        isEmployee: true
      });
      if ((collectionres === null || collectionres === void 0 ? void 0 : (_collectionres$Paymen = collectionres.Payments) === null || _collectionres$Paymen === void 0 ? void 0 : _collectionres$Paymen.length) > 0) {
        var _collectionres$Paymen2;
        collectionres === null || collectionres === void 0 ? void 0 : (_collectionres$Paymen2 = collectionres.Payments) === null || _collectionres$Paymen2 === void 0 ? void 0 : _collectionres$Paymen2.map(res => {
          var _res$paymentDetails;
          res === null || res === void 0 ? void 0 : (_res$paymentDetails = res.paymentDetails) === null || _res$paymentDetails === void 0 ? void 0 : _res$paymentDetails.map(resData => {
            if ((resData === null || resData === void 0 ? void 0 : resData.businessService) == appBusinessService[_i]) {
              collectionBillRes.push(res);
            }
          });
        });
      }
      if ((collectionres === null || collectionres === void 0 ? void 0 : (_collectionres$Paymen3 = collectionres.Payments) === null || _collectionres$Paymen3 === void 0 ? void 0 : _collectionres$Paymen3.length) > 0) collectionBillDetails.push(...(collectionres === null || collectionres === void 0 ? void 0 : collectionres.Payments));
    }
    if ((collectionBillRes === null || collectionBillRes === void 0 ? void 0 : collectionBillRes.length) > 0) {
      collectionBillRes === null || collectionBillRes === void 0 ? void 0 : collectionBillRes.map(ob => {
        var _ob$paymentDetails, _ob$paymentDetails$, _ob$paymentDetails$$b, _ob$paymentDetails$$b2, _ob$paymentDetails$$b3;
        ob === null || ob === void 0 ? void 0 : (_ob$paymentDetails = ob.paymentDetails) === null || _ob$paymentDetails === void 0 ? void 0 : (_ob$paymentDetails$ = _ob$paymentDetails[0]) === null || _ob$paymentDetails$ === void 0 ? void 0 : (_ob$paymentDetails$$b = _ob$paymentDetails$.bill) === null || _ob$paymentDetails$$b === void 0 ? void 0 : (_ob$paymentDetails$$b2 = _ob$paymentDetails$$b.billDetails) === null || _ob$paymentDetails$$b2 === void 0 ? void 0 : (_ob$paymentDetails$$b3 = _ob$paymentDetails$$b2[0]) === null || _ob$paymentDetails$$b3 === void 0 ? void 0 : _ob$paymentDetails$$b3.billAccountDetails.map((bill, index) => {
          collectionBillArray.push({
            title: `${bill === null || bill === void 0 ? void 0 : bill.taxHeadCode}_DETAILS`,
            value: "",
            isSubTitle: true
          }, {
            title: bill === null || bill === void 0 ? void 0 : bill.taxHeadCode,
            value: `₹${bill === null || bill === void 0 ? void 0 : bill.amount}`
          }, {
            title: "BPA_STATUS_LABEL",
            value: "Paid"
          });
          totalAmount = totalAmount + parseInt(bill === null || bill === void 0 ? void 0 : bill.amount);
        });
      });
    } else {
      var _splittedFeeData$;
      for (const key in splittedFeeData === null || splittedFeeData === void 0 ? void 0 : splittedFeeData[0]) {
        if (key === "estimateAmount") continue;
        collectionBillArray.push({
          title: `BPA_COMMON_${key.toUpperCase()}_FEE`,
          value: `₹${splittedFeeData[0][key]}`
        });
      }
      collectionBillArray.push({
        title: "BPA_COMMON_TOTAL_FEE",
        value: `₹${splittedFeeData === null || splittedFeeData === void 0 ? void 0 : (_splittedFeeData$ = splittedFeeData[0]) === null || _splittedFeeData$ === void 0 ? void 0 : _splittedFeeData$.estimateAmount}`
      });
      collectionBillArray.push({
        title: "BPA_STATUS_LABEL",
        value: "Unpaid"
      });
    }
    totalAmount > 0 && collectionBillArray.push({
      title: "BPA_TOT_AMT_PAID",
      value: `₹${totalAmount}`
    });
    const billDetails = {
      title: "BPA_FEE_DETAILS_LABEL",
      isFeeDetails: true,
      additionalDetails: {
        inspectionReport: [],
        values: [...collectionBillArray]
      }
    };
    BPA === null || BPA === void 0 ? void 0 : (_BPA$additionalDetail3 = BPA.additionalDetails) === null || _BPA$additionalDetail3 === void 0 ? void 0 : (_BPA$additionalDetail4 = _BPA$additionalDetail3.fieldinspection_pending) === null || _BPA$additionalDetail4 === void 0 ? void 0 : _BPA$additionalDetail4.forEach(fiData => {
      var _fiData$docs;
      fiData === null || fiData === void 0 ? void 0 : (_fiData$docs = fiData.docs) === null || _fiData$docs === void 0 ? void 0 : _fiData$docs.forEach(fiDoc => {
        var _fileDetails$data$fiD;
        if (fileDetails !== null && fileDetails !== void 0 && fileDetails.data[fiDoc === null || fiDoc === void 0 ? void 0 : fiDoc.fileStoreId]) fiDoc.url = fileDetails === null || fileDetails === void 0 ? void 0 : (_fileDetails$data$fiD = fileDetails.data[fiDoc === null || fiDoc === void 0 ? void 0 : fiDoc.fileStoreId]) === null || _fileDetails$data$fiD === void 0 ? void 0 : _fileDetails$data$fiD.split(",")[0];
      });
    });
    function ConvertEpochToValidityDate(dateEpoch) {
      if (dateEpoch == null || dateEpoch == undefined || dateEpoch == "") {
        return "NA";
      }
      const dateFromApi = new Date(dateEpoch);
      let month = dateFromApi.getMonth() + 1;
      let day = dateFromApi.getDate();
      let year = dateFromApi.getFullYear() - 3;
      month = (month > 9 ? "" : "0") + month;
      day = (day > 9 ? "" : "0") + day;
      return `${day}/${month}/${year}`;
    }
    const nocDetails = noc === null || noc === void 0 ? void 0 : noc.map((nocDetails, index) => {
      var _nocDetails$additiona, _nocDetails$additiona2, _nocDetails$additiona3, _nocDetails$auditDeta, _nocDetails$documents2;
      return {
        title: index === 0 ? "BPA_NOC_DETAILS_SUMMARY" : "",
        values: [{
          title: `BPA_${nocDetails === null || nocDetails === void 0 ? void 0 : nocDetails.nocType}_LABEL`,
          value: nocDetails === null || nocDetails === void 0 ? void 0 : nocDetails.applicationNo,
          isNotTranslated: true
        }, {
          title: `BPA_NOC_STATUS`,
          value: nocDetails === null || nocDetails === void 0 ? void 0 : nocDetails.applicationStatus,
          field: "STATUS"
        }, (nocDetails === null || nocDetails === void 0 ? void 0 : (_nocDetails$additiona = nocDetails.additionalDetails) === null || _nocDetails$additiona === void 0 ? void 0 : _nocDetails$additiona.SubmittedOn) && {
          title: "BPA_SUDMITTED_ON_LABEL",
          value: nocDetails !== null && nocDetails !== void 0 && (_nocDetails$additiona2 = nocDetails.additionalDetails) !== null && _nocDetails$additiona2 !== void 0 && _nocDetails$additiona2.SubmittedOn ? format(new Date(Number(nocDetails === null || nocDetails === void 0 ? void 0 : (_nocDetails$additiona3 = nocDetails.additionalDetails) === null || _nocDetails$additiona3 === void 0 ? void 0 : _nocDetails$additiona3.SubmittedOn)), "dd/MM/yyyy") : "NA",
          isNotTranslated: true
        }, (nocDetails === null || nocDetails === void 0 ? void 0 : nocDetails.nocNo) && {
          title: "BPA_APPROVAL_NUMBER_LABEL",
          value: (nocDetails === null || nocDetails === void 0 ? void 0 : nocDetails.nocNo) || "NA",
          isNotTranslated: true
        }, (nocDetails === null || nocDetails === void 0 ? void 0 : nocDetails.nocNo) && {
          title: "BPA_APPROVED_REJECTED_ON_LABEL",
          value: (nocDetails === null || nocDetails === void 0 ? void 0 : nocDetails.applicationStatus) === "APPROVED" || (nocDetails === null || nocDetails === void 0 ? void 0 : nocDetails.applicationStatus) === "REJECTED" || (nocDetails === null || nocDetails === void 0 ? void 0 : nocDetails.applicationStatus) === "AUTO_APPROVED" || (nocDetails === null || nocDetails === void 0 ? void 0 : nocDetails.applicationStatus) === "AUTO_REJECTED" ? format(new Date(Number(nocDetails === null || nocDetails === void 0 ? void 0 : (_nocDetails$auditDeta = nocDetails.auditDetails) === null || _nocDetails$auditDeta === void 0 ? void 0 : _nocDetails$auditDeta.lastModifiedTime)), "dd/MM/yyyy") : "NA",
          isNotTranslated: true
        }],
        additionalDetails: {
          data: nocDetails,
          noc: [{
            title: "BPA_DOCUMENT_DETAILS_LABEL",
            values: nocDetails === null || nocDetails === void 0 ? void 0 : (_nocDetails$documents2 = nocDetails.documents) === null || _nocDetails$documents2 === void 0 ? void 0 : _nocDetails$documents2.map(doc => {
              var _doc$documentType2, _fileDetails$data, _fileDetails$data2, _fileDetails$data2$do;
              return {
                title: doc === null || doc === void 0 ? void 0 : (_doc$documentType2 = doc.documentType) === null || _doc$documentType2 === void 0 ? void 0 : _doc$documentType2.replaceAll(".", "_"),
                documentType: doc === null || doc === void 0 ? void 0 : doc.documentType,
                documentUid: doc === null || doc === void 0 ? void 0 : doc.documentUid,
                fileStoreId: doc === null || doc === void 0 ? void 0 : doc.fileStoreId,
                id: doc === null || doc === void 0 ? void 0 : doc.id,
                url: fileDetails !== null && fileDetails !== void 0 && (_fileDetails$data = fileDetails.data) !== null && _fileDetails$data !== void 0 && _fileDetails$data[doc === null || doc === void 0 ? void 0 : doc.fileStoreId] ? fileDetails === null || fileDetails === void 0 ? void 0 : (_fileDetails$data2 = fileDetails.data) === null || _fileDetails$data2 === void 0 ? void 0 : (_fileDetails$data2$do = _fileDetails$data2[doc === null || doc === void 0 ? void 0 : doc.fileStoreId]) === null || _fileDetails$data2$do === void 0 ? void 0 : _fileDetails$data2$do.split(",")[0] : ""
              };
            })
          }]
        }
      };
    });
    let inspectionReport = [];
    let checklist = [];
    BPA === null || BPA === void 0 ? void 0 : (_BPA$additionalDetail5 = BPA.additionalDetails) === null || _BPA$additionalDetail5 === void 0 ? void 0 : (_BPA$additionalDetail6 = _BPA$additionalDetail5.fieldinspection_pending) === null || _BPA$additionalDetail6 === void 0 ? void 0 : _BPA$additionalDetail6.filter(ob => ob.docs && ob.docs.length > 0).map((ob, ind) => {
      var _ob$date, _ob$date2, _ob$date3, _ob$questions, _ob$docs;
      checklist = [];
      inspectionReport.push({
        title: "BPA_FI_REPORT",
        asSectionHeader: true,
        values: [{
          title: "BPA_FI_DATE_LABEL",
          value: ob.date.includes("-") ? `${(_ob$date = ob.date) === null || _ob$date === void 0 ? void 0 : _ob$date.split("-")[2]}/${(_ob$date2 = ob.date) === null || _ob$date2 === void 0 ? void 0 : _ob$date2.split("-")[1]}/${(_ob$date3 = ob.date) === null || _ob$date3 === void 0 ? void 0 : _ob$date3.split("-")[0]}` : ob.date
        }, {
          title: "BPA_FI_TIME_LABEL",
          value: ob.time
        }]
      });
      ob === null || ob === void 0 ? void 0 : (_ob$questions = ob.questions) === null || _ob$questions === void 0 ? void 0 : _ob$questions.map((q, index) => {
        checklist.push({
          title: q.question,
          value: q.value
        });
        checklist.push({
          title: "BPA_ENTER_REMARKS",
          value: q.remarks
        });
      });
      inspectionReport.push({
        title: "BPA_CHECK_LIST_DETAILS",
        asSectionHeader: true,
        values: checklist
      });
      inspectionReport.push({
        title: "BPA_DOCUMENT_DETAILS_LABEL",
        asSectionHeader: true,
        additionalDetails: {
          obpsDocuments: [{
            title: "",
            values: ob === null || ob === void 0 ? void 0 : (_ob$docs = ob.docs) === null || _ob$docs === void 0 ? void 0 : _ob$docs.map(doc => {
              var _doc$documentType3, _fileDetails$data3, _fileDetails$data4, _fileDetails$data4$do;
              return {
                title: doc === null || doc === void 0 ? void 0 : (_doc$documentType3 = doc.documentType) === null || _doc$documentType3 === void 0 ? void 0 : _doc$documentType3.replaceAll(".", "_"),
                documentType: doc === null || doc === void 0 ? void 0 : doc.documentType,
                documentUid: doc === null || doc === void 0 ? void 0 : doc.fileStore,
                fileStoreId: doc === null || doc === void 0 ? void 0 : doc.fileStoreId,
                id: doc === null || doc === void 0 ? void 0 : doc.id,
                url: fileDetails !== null && fileDetails !== void 0 && (_fileDetails$data3 = fileDetails.data) !== null && _fileDetails$data3 !== void 0 && _fileDetails$data3[doc === null || doc === void 0 ? void 0 : doc.fileStoreId] ? fileDetails === null || fileDetails === void 0 ? void 0 : (_fileDetails$data4 = fileDetails.data) === null || _fileDetails$data4 === void 0 ? void 0 : (_fileDetails$data4$do = _fileDetails$data4[doc === null || doc === void 0 ? void 0 : doc.fileStoreId]) === null || _fileDetails$data4$do === void 0 ? void 0 : _fileDetails$data4$do.split(",")[0] : ""
              };
            })
          }]
        }
      });
    });
    let details = [];
    let applicationDetailsInfo = {
      title: " ",
      isCommon: true,
      values: [{
        title: "BPA_APPLICATION_NUMBER_LABEL",
        value: (BPA === null || BPA === void 0 ? void 0 : BPA.applicationNo) || "NA"
      }]
    };
    let envCitizenName = window.location.href.includes("/employee") ? "employee" : "citizen";
    if (BPA !== null && BPA !== void 0 && BPA.businessService.includes("BPA_OC")) {
      var _response$BPA6, _response$BPA6$, _response$BPA7, _response$BPA7$, _response$BPA8, _response$BPA8$, _response$BPA8$$addit, _response$BPA9, _response$BPA9$, _response$BPA9$$addit, _response$BPA10, _response$BPA10$, _response$BPA10$$addi;
      applicationDetailsInfo["values"] = [...(applicationDetailsInfo === null || applicationDetailsInfo === void 0 ? void 0 : applicationDetailsInfo.values), {
        title: "BPA_PERMIT_APP_NUMBER",
        to: `/digit-ui/${envCitizenName}/obps/bpa/${response === null || response === void 0 ? void 0 : (_response$BPA6 = response.BPA) === null || _response$BPA6 === void 0 ? void 0 : (_response$BPA6$ = _response$BPA6[0]) === null || _response$BPA6$ === void 0 ? void 0 : _response$BPA6$.applicationNo}`,
        value: response === null || response === void 0 ? void 0 : (_response$BPA7 = response.BPA) === null || _response$BPA7 === void 0 ? void 0 : (_response$BPA7$ = _response$BPA7[0]) === null || _response$BPA7$ === void 0 ? void 0 : _response$BPA7$.approvalNo,
        isLink: true
      }];
      applicationDetailsInfo["values"] = [...(applicationDetailsInfo === null || applicationDetailsInfo === void 0 ? void 0 : applicationDetailsInfo.values), {
        title: "BPA_PERMIT_VALIDITY",
        value: response !== null && response !== void 0 && (_response$BPA8 = response.BPA) !== null && _response$BPA8 !== void 0 && (_response$BPA8$ = _response$BPA8[0]) !== null && _response$BPA8$ !== void 0 && (_response$BPA8$$addit = _response$BPA8$.additionalDetails) !== null && _response$BPA8$$addit !== void 0 && _response$BPA8$$addit.validityDate ? `${ConvertEpochToValidityDate(response === null || response === void 0 ? void 0 : (_response$BPA9 = response.BPA) === null || _response$BPA9 === void 0 ? void 0 : (_response$BPA9$ = _response$BPA9[0]) === null || _response$BPA9$ === void 0 ? void 0 : (_response$BPA9$$addit = _response$BPA9$.additionalDetails) === null || _response$BPA9$$addit === void 0 ? void 0 : _response$BPA9$$addit.validityDate)} - ${format(new Date(response === null || response === void 0 ? void 0 : (_response$BPA10 = response.BPA) === null || _response$BPA10 === void 0 ? void 0 : (_response$BPA10$ = _response$BPA10[0]) === null || _response$BPA10$ === void 0 ? void 0 : (_response$BPA10$$addi = _response$BPA10$.additionalDetails) === null || _response$BPA10$$addi === void 0 ? void 0 : _response$BPA10$$addi.validityDate), "dd/MM/yyyy")}` : "NA"
      }];
    }
    let permitcondn = [];
    (BPA === null || BPA === void 0 ? void 0 : (_BPA$additionalDetail7 = BPA.additionalDetails) === null || _BPA$additionalDetail7 === void 0 ? void 0 : _BPA$additionalDetail7.pendingapproval) && (BPA === null || BPA === void 0 ? void 0 : (_BPA$additionalDetail8 = BPA.additionalDetails) === null || _BPA$additionalDetail8 === void 0 ? void 0 : _BPA$additionalDetail8.pendingapproval.length) > 0 && (BPA === null || BPA === void 0 ? void 0 : (_BPA$additionalDetail9 = BPA.additionalDetails) === null || _BPA$additionalDetail9 === void 0 ? void 0 : _BPA$additionalDetail9.pendingapproval.map((ob, index) => {
      permitcondn.push({
        title: `${index + 1}. ${ob}`,
        value: ""
      });
    }));
    let PermitConditions = {
      title: "BPA_PERMIT_CONDITIONS",
      isTitleVisible: (permitcondn === null || permitcondn === void 0 ? void 0 : permitcondn.length) > 0 ? false : true,
      isNotAllowed: (permitcondn === null || permitcondn === void 0 ? void 0 : permitcondn.length) > 0 ? false : true,
      additionalDetails: {
        inspectionReport: [],
        permit: [...permitcondn]
      }
    };
    if (permitcondn.length == 0) PermitConditions = {};
    if (BPA !== null && BPA !== void 0 && BPA.approvalNo) {
      var _applicationDetailsIn, _applicationDetailsIn2, _BPA$additionalDetail10, _BPA$additionalDetail11, _BPA$additionalDetail12;
      applicationDetailsInfo === null || applicationDetailsInfo === void 0 ? void 0 : (_applicationDetailsIn = applicationDetailsInfo.values) === null || _applicationDetailsIn === void 0 ? void 0 : _applicationDetailsIn.push({
        title: (BPA === null || BPA === void 0 ? void 0 : BPA.businessService) !== "BPA_OC" ? "BPA_PERMIT_NUMBER_LABEL" : "BPA_OC_PERMIT_NUMBER_LABEL",
        value: (BPA === null || BPA === void 0 ? void 0 : BPA.approvalNo) || "NA"
      });
      applicationDetailsInfo === null || applicationDetailsInfo === void 0 ? void 0 : (_applicationDetailsIn2 = applicationDetailsInfo.values) === null || _applicationDetailsIn2 === void 0 ? void 0 : _applicationDetailsIn2.push({
        title: (BPA === null || BPA === void 0 ? void 0 : BPA.businessService) !== "BPA_OC" ? "BPA_PERMIT_VALIDITY" : "BPA_OC_PERMIT_VALIDITY",
        value: BPA !== null && BPA !== void 0 && (_BPA$additionalDetail10 = BPA.additionalDetails) !== null && _BPA$additionalDetail10 !== void 0 && _BPA$additionalDetail10.validityDate ? `${ConvertEpochToValidityDate(BPA === null || BPA === void 0 ? void 0 : (_BPA$additionalDetail11 = BPA.additionalDetails) === null || _BPA$additionalDetail11 === void 0 ? void 0 : _BPA$additionalDetail11.validityDate)} - ${format(new Date(BPA === null || BPA === void 0 ? void 0 : (_BPA$additionalDetail12 = BPA.additionalDetails) === null || _BPA$additionalDetail12 === void 0 ? void 0 : _BPA$additionalDetail12.validityDate), "dd/MM/yyyy")}` : "NA"
      });
    }
    const basicDetails = {
      title: "BPA_BASIC_DETAILS_TITLE",
      asSectionHeader: true,
      isInsert: true,
      isCommon: true,
      values: [{
        title: "BPA_BASIC_DETAILS_APP_DATE_LABEL",
        value: BPA !== null && BPA !== void 0 && (_BPA$auditDetails = BPA.auditDetails) !== null && _BPA$auditDetails !== void 0 && _BPA$auditDetails.createdTime ? format(new Date(BPA === null || BPA === void 0 ? void 0 : (_BPA$auditDetails2 = BPA.auditDetails) === null || _BPA$auditDetails2 === void 0 ? void 0 : _BPA$auditDetails2.createdTime), "dd/MM/yyyy") : ""
      }, {
        title: "BPA_BASIC_DETAILS_APPLICATION_TYPE_LABEL",
        value: `WF_BPA_${edcr === null || edcr === void 0 ? void 0 : (_edcr$ = edcr[0]) === null || _edcr$ === void 0 ? void 0 : _edcr$.appliactionType}`
      }, {
        title: "BPA_BASIC_DETAILS_SERVICE_TYPE_LABEL",
        value: edcr === null || edcr === void 0 ? void 0 : (_edcr$2 = edcr[0]) === null || _edcr$2 === void 0 ? void 0 : _edcr$2.applicationSubType
      }, {
        title: "BPA_BASIC_DETAILS_OCCUPANCY_LABEL",
        value: edcr === null || edcr === void 0 ? void 0 : (_edcr$3 = edcr[0]) === null || _edcr$3 === void 0 ? void 0 : (_edcr$3$planDetail = _edcr$3.planDetail) === null || _edcr$3$planDetail === void 0 ? void 0 : (_edcr$3$planDetail$pl = _edcr$3$planDetail.planInformation) === null || _edcr$3$planDetail$pl === void 0 ? void 0 : _edcr$3$planDetail$pl.occupancy
      }, {
        title: "BPA_BASIC_DETAILS_APPLICATION_NAME_LABEL",
        value: edcr === null || edcr === void 0 ? void 0 : (_edcr$4 = edcr[0]) === null || _edcr$4 === void 0 ? void 0 : (_edcr$4$planDetail = _edcr$4.planDetail) === null || _edcr$4$planDetail === void 0 ? void 0 : (_edcr$4$planDetail$pl = _edcr$4$planDetail.planInformation) === null || _edcr$4$planDetail$pl === void 0 ? void 0 : _edcr$4$planDetail$pl.applicantName
      }]
    };
    const plotDetails = {
      title: "BPA_PLOT_DETAILS_TITLE",
      asSectionHeader: true,
      isCommon: true,
      values: [{
        title: "BPA_BOUNDARY_PLOT_AREA_LABEL",
        value: `${edcr === null || edcr === void 0 ? void 0 : (_edcr$5 = edcr[0]) === null || _edcr$5 === void 0 ? void 0 : (_edcr$5$planDetail = _edcr$5.planDetail) === null || _edcr$5$planDetail === void 0 ? void 0 : (_edcr$5$planDetail$pl = _edcr$5$planDetail.planInformation) === null || _edcr$5$planDetail$pl === void 0 ? void 0 : _edcr$5$planDetail$pl.plotArea}`,
        isNotTranslated: true,
        isUnit: "BPA_SQ_MT_LABEL"
      }, {
        title: "BPA_PLOT_NUMBER_LABEL",
        value: (edcr === null || edcr === void 0 ? void 0 : (_edcr$6 = edcr[0]) === null || _edcr$6 === void 0 ? void 0 : (_edcr$6$planDetail = _edcr$6.planDetail) === null || _edcr$6$planDetail === void 0 ? void 0 : (_edcr$6$planDetail$pl = _edcr$6$planDetail.planInformation) === null || _edcr$6$planDetail$pl === void 0 ? void 0 : _edcr$6$planDetail$pl.plotNo) || "NA",
        isNotTranslated: true
      }, {
        title: "BPA_KHATHA_NUMBER_LABEL",
        value: (edcr === null || edcr === void 0 ? void 0 : (_edcr$7 = edcr[0]) === null || _edcr$7 === void 0 ? void 0 : (_edcr$7$planDetail = _edcr$7.planDetail) === null || _edcr$7$planDetail === void 0 ? void 0 : (_edcr$7$planDetail$pl = _edcr$7$planDetail.planInformation) === null || _edcr$7$planDetail$pl === void 0 ? void 0 : _edcr$7$planDetail$pl.khataNo) || "NA",
        isNotTranslated: true
      }, {
        title: "BPA_HOLDING_NUMBER_LABEL",
        value: (BPA === null || BPA === void 0 ? void 0 : (_BPA$additionalDetail13 = BPA.additionalDetails) === null || _BPA$additionalDetail13 === void 0 ? void 0 : _BPA$additionalDetail13.holdingNo) || "NA",
        isNotTranslated: true
      }, {
        title: "BPA_BOUNDARY_LAND_REG_DETAIL_LABEL",
        value: (BPA === null || BPA === void 0 ? void 0 : (_BPA$additionalDetail14 = BPA.additionalDetails) === null || _BPA$additionalDetail14 === void 0 ? void 0 : _BPA$additionalDetail14.registrationDetails) || "NA",
        isNotTranslated: true
      }]
    };
    const scrutinyDetails = {
      title: "BPA_STEPPER_SCRUTINY_DETAILS_HEADER",
      isScrutinyDetails: true,
      isBackGroundColor: true,
      additionalDetails: {
        values: [{
          title: "BPA_EDCR_DETAILS",
          value: " ",
          isHeader: true
        }, {
          title: (BPA === null || BPA === void 0 ? void 0 : BPA.businessService) !== "BPA_OC" ? "BPA_EDCR_NO_LABEL" : "BPA_OC_EDCR_NO_LABEL",
          value: (BPA === null || BPA === void 0 ? void 0 : BPA.edcrNumber) || "NA"
        }],
        scruntinyDetails: [{
          title: "BPA_UPLOADED_PLAN_DIAGRAM",
          value: edcr === null || edcr === void 0 ? void 0 : (_edcr$8 = edcr[0]) === null || _edcr$8 === void 0 ? void 0 : _edcr$8.updatedDxfFile,
          text: "BPA_UPLOADED_PLAN_DXF"
        }, {
          title: "BPA_SCRUNTINY_REPORT_OUTPUT",
          value: edcr === null || edcr === void 0 ? void 0 : (_edcr$9 = edcr[0]) === null || _edcr$9 === void 0 ? void 0 : _edcr$9.planReport,
          text: "BPA_SCRUTINY_REPORT_PDF"
        }, {
          title: "BPA_UPLOADED_PLAN_DXF",
          value: edcr === null || edcr === void 0 ? void 0 : (_edcr$10 = edcr[0]) === null || _edcr$10 === void 0 ? void 0 : _edcr$10.dxfFile,
          text: "BPA_UPLOADED_PLAN_DXF"
        }]
      }
    };
    const buildingExtractionDetails = {
      title: "",
      isScrutinyDetails: true,
      isBackGroundColor: true,
      additionalDetails: {
        values: [{
          title: (BPA === null || BPA === void 0 ? void 0 : BPA.businessService) !== "BPA_OC" ? "BPA_BUILDING_EXTRACT_HEADER" : "BPA_ACTUAL_BUILDING_EXTRACT_HEADER",
          value: " ",
          isHeader: true
        }, {
          title: "BPA_TOTAL_BUILT_UP_AREA_HEADER",
          value: edcr === null || edcr === void 0 ? void 0 : (_edcr$11 = edcr[0]) === null || _edcr$11 === void 0 ? void 0 : (_edcr$11$planDetail = _edcr$11.planDetail) === null || _edcr$11$planDetail === void 0 ? void 0 : (_edcr$11$planDetail$b = _edcr$11$planDetail.blocks) === null || _edcr$11$planDetail$b === void 0 ? void 0 : (_edcr$11$planDetail$b2 = _edcr$11$planDetail$b[0]) === null || _edcr$11$planDetail$b2 === void 0 ? void 0 : (_edcr$11$planDetail$b3 = _edcr$11$planDetail$b2.building) === null || _edcr$11$planDetail$b3 === void 0 ? void 0 : _edcr$11$planDetail$b3.totalBuitUpArea,
          isUnit: "BPA_SQ_MTRS_LABEL"
        }, {
          title: "BPA_SCRUTINY_DETAILS_NUMBER_OF_FLOORS_LABEL",
          value: (edcr === null || edcr === void 0 ? void 0 : (_edcr$12 = edcr[0]) === null || _edcr$12 === void 0 ? void 0 : (_edcr$12$planDetail = _edcr$12.planDetail) === null || _edcr$12$planDetail === void 0 ? void 0 : (_edcr$12$planDetail$b = _edcr$12$planDetail.blocks) === null || _edcr$12$planDetail$b === void 0 ? void 0 : (_edcr$12$planDetail$b2 = _edcr$12$planDetail$b[0]) === null || _edcr$12$planDetail$b2 === void 0 ? void 0 : (_edcr$12$planDetail$b3 = _edcr$12$planDetail$b2.building) === null || _edcr$12$planDetail$b3 === void 0 ? void 0 : _edcr$12$planDetail$b3.totalFloors) || "NA"
        }, {
          title: "BPA_HEIGHT_FROM_GROUND_LEVEL",
          value: edcr === null || edcr === void 0 ? void 0 : (_edcr$13 = edcr[0]) === null || _edcr$13 === void 0 ? void 0 : (_edcr$13$planDetail = _edcr$13.planDetail) === null || _edcr$13$planDetail === void 0 ? void 0 : (_edcr$13$planDetail$b = _edcr$13$planDetail.blocks) === null || _edcr$13$planDetail$b === void 0 ? void 0 : (_edcr$13$planDetail$b2 = _edcr$13$planDetail$b[0]) === null || _edcr$13$planDetail$b2 === void 0 ? void 0 : (_edcr$13$planDetail$b3 = _edcr$13$planDetail$b2.building) === null || _edcr$13$planDetail$b3 === void 0 ? void 0 : _edcr$13$planDetail$b3.declaredBuildingHeigh,
          isUnit: "BPA_MTRS_LABEL"
        }],
        scruntinyDetails: []
      }
    };
    const demolitionAreaDetails = {
      title: "",
      isScrutinyDetails: true,
      isBackGroundColor: true,
      additionalDetails: {
        values: [{
          title: "BPA_APP_DETAILS_DEMOLITION_DETAILS_LABEL",
          value: " ",
          isHeader: true
        }, {
          title: "BPA_APPLICATION_DEMOLITION_AREA_LABEL",
          value: edcr === null || edcr === void 0 ? void 0 : (_edcr$14 = edcr[0]) === null || _edcr$14 === void 0 ? void 0 : (_edcr$14$planDetail = _edcr$14.planDetail) === null || _edcr$14$planDetail === void 0 ? void 0 : (_edcr$14$planDetail$p = _edcr$14$planDetail.planInformation) === null || _edcr$14$planDetail$p === void 0 ? void 0 : _edcr$14$planDetail$p.demolitionArea,
          isUnit: "BPA_SQ_MTRS_LABEL"
        }],
        scruntinyDetails: []
      }
    };
    const subOccupancyTableDetails = {
      title: "",
      isSubOccupancyTable: true,
      isTitleRepeat: true,
      additionalDetails: {
        values: [{
          title: "BPA_OCC_SUBOCC_HEADER",
          value: " ",
          isHeader: true
        }],
        subOccupancyTableDetails: [{
          title: "BPA_APPLICATION_DEMOLITION_AREA_LABEL",
          value: edcr
        }, {
          title: "NO_REPEAT",
          value: ""
        }]
      }
    };
    const addressDetails = {
      title: "BPA_NEW_TRADE_DETAILS_HEADER_DETAILS",
      asSectionHeader: true,
      isCommon: true,
      values: [{
        title: "BPA_CITY_LABEL",
        value: BPA === null || BPA === void 0 ? void 0 : (_BPA$landInfo = BPA.landInfo) === null || _BPA$landInfo === void 0 ? void 0 : (_BPA$landInfo$address = _BPA$landInfo.address) === null || _BPA$landInfo$address === void 0 ? void 0 : _BPA$landInfo$address.city
      }, {
        title: !isUD ? "BPA_LOC_NOTIFIED-AREA_LABEL" : "BPA_ULB-AREA_LABEL",
        value: BPA === null || BPA === void 0 ? void 0 : (_BPA$additionalDetail15 = BPA.additionalDetails) === null || _BPA$additionalDetail15 === void 0 ? void 0 : (_BPA$additionalDetail16 = _BPA$additionalDetail15.landInfo) === null || _BPA$additionalDetail16 === void 0 ? void 0 : (_BPA$additionalDetail17 = _BPA$additionalDetail16.address) === null || _BPA$additionalDetail17 === void 0 ? void 0 : _BPA$additionalDetail17.doorNo
      }, {
        title: !isUD ? "BPA_LOC_VILLAGE-AREA_LABEL" : "BPA_LOC_WARD-AREA_LABEL",
        value: BPA === null || BPA === void 0 ? void 0 : (_BPA$additionalDetail18 = BPA.additionalDetails) === null || _BPA$additionalDetail18 === void 0 ? void 0 : (_BPA$additionalDetail19 = _BPA$additionalDetail18.landInfo) === null || _BPA$additionalDetail19 === void 0 ? void 0 : (_BPA$additionalDetail20 = _BPA$additionalDetail19.address) === null || _BPA$additionalDetail20 === void 0 ? void 0 : _BPA$additionalDetail20.village
      }]
    };
    const checkOwnerLength = (BPA === null || BPA === void 0 ? void 0 : (_BPA$landInfo2 = BPA.landInfo) === null || _BPA$landInfo2 === void 0 ? void 0 : (_BPA$landInfo2$owners = _BPA$landInfo2.owners) === null || _BPA$landInfo2$owners === void 0 ? void 0 : _BPA$landInfo2$owners.length) || 1;
    if ((BPA === null || BPA === void 0 ? void 0 : (_BPA$landInfo3 = BPA.landInfo) === null || _BPA$landInfo3 === void 0 ? void 0 : (_BPA$landInfo3$owners = _BPA$landInfo3.owners) === null || _BPA$landInfo3$owners === void 0 ? void 0 : _BPA$landInfo3$owners.length) > 0) {
      var _BPA$landInfo4, _BPA$landInfo4$owners;
      BPA === null || BPA === void 0 ? void 0 : (_BPA$landInfo4 = BPA.landInfo) === null || _BPA$landInfo4 === void 0 ? void 0 : (_BPA$landInfo4$owners = _BPA$landInfo4.owners) === null || _BPA$landInfo4$owners === void 0 ? void 0 : _BPA$landInfo4$owners.forEach(ownerD => {
        if (!ownerD.isPrimaryOwner) ownerD.isPrimaryOwner = "false";
      });
    }
    const ownerDetails = {
      title: "BPA_APPLICANT_DETAILS_HEADER",
      isOwnerDetails: true,
      additionalDetails: {
        owners: BPA === null || BPA === void 0 ? void 0 : (_BPA$additionalDetail21 = BPA.additionalDetails) === null || _BPA$additionalDetail21 === void 0 ? void 0 : (_BPA$additionalDetail22 = _BPA$additionalDetail21.landInfo) === null || _BPA$additionalDetail22 === void 0 ? void 0 : (_BPA$additionalDetail23 = _BPA$additionalDetail22.owners) === null || _BPA$additionalDetail23 === void 0 ? void 0 : _BPA$additionalDetail23.map((owner, index) => {
          var _owner$permanentAddre, _owner$permanentAddre2, _owner$permanentAddre3, _owner$permanentAddre4, _owner$permanentAddre5, _owner$permanentAddre6, _owner$correspondence, _owner$correspondence2, _owner$correspondence3, _owner$correspondence4, _owner$correspondence5, _owner$correspondence6;
          return {
            title: Number(checkOwnerLength) > 1 ? "COMMON_OWNER" : "",
            values: [{
              title: "CORE_COMMON_NAME",
              value: owner === null || owner === void 0 ? void 0 : owner.name
            }, {
              title: "BPA_APPLICANT_GENDER_LABEL",
              value: owner === null || owner === void 0 ? void 0 : owner.gender
            }, {
              title: "CORE_COMMON_MOBILE_NUMBER",
              value: owner === null || owner === void 0 ? void 0 : owner.mobileNumber
            }, {
              title: "BPA_APPLICANT_EMAIL_LABEL",
              value: owner === null || owner === void 0 ? void 0 : owner.emailId
            }, {
              title: "CORE_COMMON_GUARDIAN_NAME",
              value: owner === null || owner === void 0 ? void 0 : owner.fatherOrHusbandName
            }, {
              title: "BPA_IS_PRIMARY_OWNER_LABEL",
              value: owner === null || owner === void 0 ? void 0 : owner.isPrimaryOwner,
              isNotTranslated: false
            }, {
              title: "BPA_OWNER_PERMANENT_ADDRESS_DETAILS",
              value: owner === null || owner === void 0 ? void 0 : (_owner$permanentAddre = owner.permanentAddress) === null || _owner$permanentAddre === void 0 ? void 0 : _owner$permanentAddre.address
            }, {
              title: "CORE_COMMON_STATE",
              value: owner === null || owner === void 0 ? void 0 : (_owner$permanentAddre2 = owner.permanentAddress) === null || _owner$permanentAddre2 === void 0 ? void 0 : _owner$permanentAddre2.state
            }, {
              title: "CORE_COMMON_DISTRICT",
              value: owner === null || owner === void 0 ? void 0 : (_owner$permanentAddre3 = owner.permanentAddress) === null || _owner$permanentAddre3 === void 0 ? void 0 : _owner$permanentAddre3.district
            }, {
              title: "CORE_COMMON_TEHSIL",
              value: owner === null || owner === void 0 ? void 0 : (_owner$permanentAddre4 = owner.permanentAddress) === null || _owner$permanentAddre4 === void 0 ? void 0 : _owner$permanentAddre4.tehsil
            }, {
              title: "CORE_COMMON_TOWN",
              value: owner === null || owner === void 0 ? void 0 : (_owner$permanentAddre5 = owner.permanentAddress) === null || _owner$permanentAddre5 === void 0 ? void 0 : _owner$permanentAddre5.town
            }, {
              title: "CORE_COMMON_PINNO",
              value: owner === null || owner === void 0 ? void 0 : (_owner$permanentAddre6 = owner.permanentAddress) === null || _owner$permanentAddre6 === void 0 ? void 0 : _owner$permanentAddre6.pinno
            }, {
              title: "BPA_OWNER_CORRESPONDANCE_ADDRESS_DETAILS",
              value: owner === null || owner === void 0 ? void 0 : (_owner$correspondence = owner.correspondenceAddress) === null || _owner$correspondence === void 0 ? void 0 : _owner$correspondence.address
            }, {
              title: "CORE_COMMON_STATE",
              value: owner === null || owner === void 0 ? void 0 : (_owner$correspondence2 = owner.correspondenceAddress) === null || _owner$correspondence2 === void 0 ? void 0 : _owner$correspondence2.state
            }, {
              title: "CORE_COMMON_DISTRICT",
              value: owner === null || owner === void 0 ? void 0 : (_owner$correspondence3 = owner.correspondenceAddress) === null || _owner$correspondence3 === void 0 ? void 0 : _owner$correspondence3.district
            }, {
              title: "CORE_COMMON_TEHSIL",
              value: owner === null || owner === void 0 ? void 0 : (_owner$correspondence4 = owner.correspondenceAddress) === null || _owner$correspondence4 === void 0 ? void 0 : _owner$correspondence4.tehsil
            }, {
              title: "CORE_COMMON_TOWN",
              value: owner === null || owner === void 0 ? void 0 : (_owner$correspondence5 = owner.correspondenceAddress) === null || _owner$correspondence5 === void 0 ? void 0 : _owner$correspondence5.town
            }, {
              title: "CORE_COMMON_PINNO",
              value: owner === null || owner === void 0 ? void 0 : (_owner$correspondence6 = owner.correspondenceAddress) === null || _owner$correspondence6 === void 0 ? void 0 : _owner$correspondence6.pinno
            }]
          };
        })
      }
    };
    const professionalDetails = {
      title: "BPA_PROFESSIONAL_DETAILS_HEADER",
      asSectionHeader: true,
      isprofessionalDetail: true,
      values: [BPA === null || BPA === void 0 ? void 0 : BPA.professionaldetails]
    };
    const documentDetails = {
      title: "BPA_DOCUMENT_DETAILS_LABEL",
      asSectionHeader: true,
      isDocumentDetails: true,
      additionalDetails: {
        obpsDocuments: [{
          title: "",
          values: BPA === null || BPA === void 0 ? void 0 : (_BPA$documents = BPA.documents) === null || _BPA$documents === void 0 ? void 0 : _BPA$documents.map(doc => {
            var _doc$documentType4, _fileDetails$data5, _fileDetails$data6, _fileDetails$data6$do;
            return {
              title: doc === null || doc === void 0 ? void 0 : (_doc$documentType4 = doc.documentType) === null || _doc$documentType4 === void 0 ? void 0 : _doc$documentType4.replaceAll(".", "_"),
              documentType: doc === null || doc === void 0 ? void 0 : doc.documentType,
              documentUid: doc === null || doc === void 0 ? void 0 : doc.documentUid,
              fileStoreId: doc === null || doc === void 0 ? void 0 : doc.fileStoreId,
              id: doc === null || doc === void 0 ? void 0 : doc.id,
              url: fileDetails !== null && fileDetails !== void 0 && (_fileDetails$data5 = fileDetails.data) !== null && _fileDetails$data5 !== void 0 && _fileDetails$data5[doc === null || doc === void 0 ? void 0 : doc.fileStoreId] ? fileDetails === null || fileDetails === void 0 ? void 0 : (_fileDetails$data6 = fileDetails.data) === null || _fileDetails$data6 === void 0 ? void 0 : (_fileDetails$data6$do = _fileDetails$data6[doc === null || doc === void 0 ? void 0 : doc.fileStoreId]) === null || _fileDetails$data6$do === void 0 ? void 0 : _fileDetails$data6$do.split(",")[0] : ""
            };
          })
        }]
      }
    };
    let approvalChecks = [];
    let approvalChecksDetails = {};
    if ((BPA === null || BPA === void 0 ? void 0 : BPA.status) === "APPROVAL_INPROGRESS") {
      approvalChecksDetails = {
        title: "",
        isTitleVisible: (approvalChecks === null || approvalChecks === void 0 ? void 0 : approvalChecks.length) > 0 ? false : true,
        asSectionHeader: true,
        isPermissions: true,
        additionalDetails: {
          permissions: approvalChecks
        }
      };
    }
    let val;
    var i;
    inspectionReport && (BPA === null || BPA === void 0 ? void 0 : (_BPA$additionalDetail24 = BPA.additionalDetails) === null || _BPA$additionalDetail24 === void 0 ? void 0 : (_BPA$additionalDetail25 = _BPA$additionalDetail24.fieldinspection_pending) === null || _BPA$additionalDetail25 === void 0 ? void 0 : (_BPA$additionalDetail26 = _BPA$additionalDetail25[0]) === null || _BPA$additionalDetail26 === void 0 ? void 0 : _BPA$additionalDetail26.questions.length) > 0 && inspectionReport.map((ob, index) => {
      if (ob.title.includes("FI_REPORT")) ;else if (ob.title.includes("CHECK_LIST")) ;else {
        var _ob$additionalDetails, _ob$additionalDetails2;
        let improvedDoc = [...((_ob$additionalDetails = ob.additionalDetails.obpsDocuments) === null || _ob$additionalDetails === void 0 ? void 0 : (_ob$additionalDetails2 = _ob$additionalDetails[0]) === null || _ob$additionalDetails2 === void 0 ? void 0 : _ob$additionalDetails2.values)];
        improvedDoc.map(ob => {
          ob["isNotDuplicate"] = true;
        });
        improvedDoc.map((ob, index) => {
          val = ob.documentType;
          if (ob.isNotDuplicate == true) for (i = index + 1; i < improvedDoc.length; i++) {
            if (val === improvedDoc[i].documentType) improvedDoc[i].isNotDuplicate = false;
          }
        });
      }
    });
    const fiReports = {
      title: "",
      isFieldInspection: true,
      isNotAllowed: (BPA === null || BPA === void 0 ? void 0 : (_BPA$additionalDetail27 = BPA.additionalDetails) === null || _BPA$additionalDetail27 === void 0 ? void 0 : (_BPA$additionalDetail28 = _BPA$additionalDetail27.fieldinspection_pending) === null || _BPA$additionalDetail28 === void 0 ? void 0 : _BPA$additionalDetail28.length) > 0 ? false : true,
      additionalDetails: {
        values: [],
        fiReport: (BPA === null || BPA === void 0 ? void 0 : (_BPA$additionalDetail29 = BPA.additionalDetails) === null || _BPA$additionalDetail29 === void 0 ? void 0 : (_BPA$additionalDetail30 = _BPA$additionalDetail29.fieldinspection_pending) === null || _BPA$additionalDetail30 === void 0 ? void 0 : _BPA$additionalDetail30.length) > 0 ? true : false
      }
    };
    if ((BPA === null || BPA === void 0 ? void 0 : BPA.businessService) !== "BPA_OC") {
      details = [...details, applicationDetailsInfo, basicDetails, plotDetails, scrutinyDetails, buildingExtractionDetails, subOccupancyTableDetails, demolitionAreaDetails, addressDetails, ownerDetails, professionalDetails, documentDetails, fiReports, ...nocDetails, approvalChecksDetails, PermitConditions];
    } else {
      details = [...details, applicationDetailsInfo, basicDetails, plotDetails, scrutinyDetails, buildingExtractionDetails, subOccupancyTableDetails, demolitionAreaDetails, documentDetails, fiReports, ...nocDetails, PermitConditions];
    }
    if (billDetails !== null && billDetails !== void 0 && (_billDetails$addition = billDetails.additionalDetails) !== null && _billDetails$addition !== void 0 && (_billDetails$addition2 = _billDetails$addition.values) !== null && _billDetails$addition2 !== void 0 && _billDetails$addition2.length) {
      details.push(billDetails);
    }
    let bpaFilterDetails = (_details = details) === null || _details === void 0 ? void 0 : _details.filter(data => data);
    return {
      applicationData: BPA,
      applicationDetails: bpaFilterDetails,
      tenantId: BPA === null || BPA === void 0 ? void 0 : BPA.tenantId,
      edcrDetails: edcr || [],
      nocData: noc,
      businessService: BPA === null || BPA === void 0 ? void 0 : BPA.businessService,
      applicationNo: BPA === null || BPA === void 0 ? void 0 : BPA.applicationNo,
      applicationStatus: BPA === null || BPA === void 0 ? void 0 : BPA.status,
      collectionBillDetails: collectionBillDetails
    };
  },
  BPADetailsPageForm11: async (tenantId, filters) => {
    var _response$PermissionO5;
    const response = await OBPSService.BPASearchForm11(tenantId, filters);
    if (filters !== null && filters !== void 0 && filters.isEmployee) {
      var _response$PermissionO, _response$PermissionO2, _filters$formType, _businessService$join, _response$PermissionO4;
      const businessServiceValue = response === null || response === void 0 ? void 0 : (_response$PermissionO = response.PermissionOfSubdivision) === null || _response$PermissionO === void 0 ? void 0 : (_response$PermissionO2 = _response$PermissionO[0]) === null || _response$PermissionO2 === void 0 ? void 0 : _response$PermissionO2.businessService;
      const businessService = Array.isArray(businessServiceValue) ? businessServiceValue : [businessServiceValue];
      const collectionBillRes = [],
        collectionBillDetails = [];
      const formNo = filters === null || filters === void 0 ? void 0 : (_filters$formType = filters.formType) === null || _filters$formType === void 0 ? void 0 : _filters$formType.replace("form", "");
      const appBusinessService = (_businessService$join = businessService.join("")) !== null && _businessService$join !== void 0 && _businessService$join.includes("UD") ? [`BPA.FORM_${formNo}_FEE_UD`] : [`BPA.FORM_${formNo}_FEE`];
      console.log("555556262", appBusinessService);
      for (let i = 0; i < (appBusinessService === null || appBusinessService === void 0 ? void 0 : appBusinessService.length); i++) {
        var _response$PermissionO3;
        if (appBusinessService[0] !== "BPA.FORM_NOC_FEE") {
          var _collectionres$Paymen4;
          let collectionres = await Digit.PaymentService.recieptSearch(tenantId, appBusinessService[i], {
            consumerCodes: filters === null || filters === void 0 ? void 0 : filters.applicationNo,
            isEmployee: filters === null || filters === void 0 ? void 0 : filters.isEmployee
          });
          if ((collectionres === null || collectionres === void 0 ? void 0 : (_collectionres$Paymen4 = collectionres.Payments) === null || _collectionres$Paymen4 === void 0 ? void 0 : _collectionres$Paymen4.length) > 0) {
            var _collectionres$Paymen5;
            collectionres === null || collectionres === void 0 ? void 0 : (_collectionres$Paymen5 = collectionres.Payments) === null || _collectionres$Paymen5 === void 0 ? void 0 : _collectionres$Paymen5.map(res => {
              var _res$paymentDetails2;
              res === null || res === void 0 ? void 0 : (_res$paymentDetails2 = res.paymentDetails) === null || _res$paymentDetails2 === void 0 ? void 0 : _res$paymentDetails2.map(resData => {
                if ((resData === null || resData === void 0 ? void 0 : resData.businessService) == appBusinessService[i]) {
                  collectionBillRes.push(res);
                }
              });
            });
            collectionBillDetails.push(...(collectionres === null || collectionres === void 0 ? void 0 : collectionres.Payments));
          }
        }
        return {
          appData: response === null || response === void 0 ? void 0 : (_response$PermissionO3 = response.PermissionOfSubdivision) === null || _response$PermissionO3 === void 0 ? void 0 : _response$PermissionO3[0],
          collectionBillRes,
          collectionBillDetails
        };
      }
      return {
        appData: response === null || response === void 0 ? void 0 : (_response$PermissionO4 = response.PermissionOfSubdivision) === null || _response$PermissionO4 === void 0 ? void 0 : _response$PermissionO4[0]
      };
    }
    return response === null || response === void 0 ? void 0 : (_response$PermissionO5 = response.PermissionOfSubdivision) === null || _response$PermissionO5 === void 0 ? void 0 : _response$PermissionO5[0];
  },
  BPADetailsPageFormLandUse: async (tenantId, filters) => {
    var _response$LandUse4;
    const response = await OBPSService.BPASearchFormLandUse(tenantId, filters);
    if (filters !== null && filters !== void 0 && filters.isEmployee) {
      var _response$LandUse, _response$LandUse$, _filters$formType2, _businessService$join2, _response$LandUse3;
      const businessServiceValue = response === null || response === void 0 ? void 0 : (_response$LandUse = response.LandUse) === null || _response$LandUse === void 0 ? void 0 : (_response$LandUse$ = _response$LandUse[0]) === null || _response$LandUse$ === void 0 ? void 0 : _response$LandUse$.businessService;
      const businessService = Array.isArray(businessServiceValue) ? businessServiceValue : [businessServiceValue];
      const collectionBillRes = [],
        collectionBillDetails = [];
      const formNo = filters === null || filters === void 0 ? void 0 : (_filters$formType2 = filters.formType) === null || _filters$formType2 === void 0 ? void 0 : _filters$formType2.replace("form", "");
      const appBusinessService = (_businessService$join2 = businessService.join("")) !== null && _businessService$join2 !== void 0 && _businessService$join2.includes("UD") ? [`BPA.FORM_${formNo}_FEE_UD`] : [`BPA.FORM_${formNo}_FEE`];
      console.log("555556262", appBusinessService);
      for (let i = 0; i < (appBusinessService === null || appBusinessService === void 0 ? void 0 : appBusinessService.length); i++) {
        var _response$LandUse2;
        if (appBusinessService[0] !== "BPA.FORM_NOC_FEE") {
          var _collectionres$Paymen6;
          let collectionres = await Digit.PaymentService.recieptSearch(tenantId, appBusinessService[i], {
            consumerCodes: filters === null || filters === void 0 ? void 0 : filters.applicationNo,
            isEmployee: filters === null || filters === void 0 ? void 0 : filters.isEmployee
          });
          if ((collectionres === null || collectionres === void 0 ? void 0 : (_collectionres$Paymen6 = collectionres.Payments) === null || _collectionres$Paymen6 === void 0 ? void 0 : _collectionres$Paymen6.length) > 0) {
            var _collectionres$Paymen7;
            collectionres === null || collectionres === void 0 ? void 0 : (_collectionres$Paymen7 = collectionres.Payments) === null || _collectionres$Paymen7 === void 0 ? void 0 : _collectionres$Paymen7.map(res => {
              var _res$paymentDetails3;
              res === null || res === void 0 ? void 0 : (_res$paymentDetails3 = res.paymentDetails) === null || _res$paymentDetails3 === void 0 ? void 0 : _res$paymentDetails3.map(resData => {
                if ((resData === null || resData === void 0 ? void 0 : resData.businessService) == appBusinessService[i]) {
                  collectionBillRes.push(res);
                }
              });
            });
            collectionBillDetails.push(...(collectionres === null || collectionres === void 0 ? void 0 : collectionres.Payments));
          }
        }
        return {
          appData: response === null || response === void 0 ? void 0 : (_response$LandUse2 = response.LandUse) === null || _response$LandUse2 === void 0 ? void 0 : _response$LandUse2[0],
          collectionBillRes,
          collectionBillDetails
        };
      }
      return {
        appData: response === null || response === void 0 ? void 0 : (_response$LandUse3 = response.LandUse) === null || _response$LandUse3 === void 0 ? void 0 : _response$LandUse3[0]
      };
    }
    return response === null || response === void 0 ? void 0 : (_response$LandUse4 = response.LandUse) === null || _response$LandUse4 === void 0 ? void 0 : _response$LandUse4[0];
  },
  Form12DetailsPage: async (tenantId, filter) => {
    var _response$BPA11;
    const response = await OBPSService.BPASearch(tenantId, filter);
    const BPA = response === null || response === void 0 ? void 0 : (_response$BPA11 = response.BPA) === null || _response$BPA11 === void 0 ? void 0 : _response$BPA11[0];
    return {
      applicationData: BPA
    };
  }
};

const MenuPopupCalender = () => {
  const history = useHistory();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = event => {
    history.push({
      pathname: `/digit-ui/employee/obps/scheduleInspection`
    });
  };
  const handleClosePopOver = () => {
    setAnchorEl(false);
  };
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Button$1, {
    id: "basic-button",
    "aria-controls": open ? 'basic-menu' : undefined,
    "aria-haspopup": "true",
    "aria-expanded": open ? 'true' : undefined,
    onClick: handleClick
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "grid"
    }
  }, /*#__PURE__*/React__default.createElement(CalendarMonthIcon, {
    style: {
      margin: "auto"
    }
  }), "Schedule Inspection")), /*#__PURE__*/React__default.createElement(Menu, {
    id: "basic-menu",
    anchorEl: anchorEl,
    open: open,
    onClose: handleClosePopOver,
    MenuListProps: {
      'aria-labelledby': 'basic-button'
    },
    sx: {
      zIndex: 10000
    }
  }, /*#__PURE__*/React__default.createElement(MenuItem$5, null)));
};

const UserManualTable = ({
  formType
}) => {
  var _Digit, _Digit$UserService, _Digit$UserService$ge;
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(true);
  const userInfo = ((_Digit = Digit) === null || _Digit === void 0 ? void 0 : (_Digit$UserService = _Digit.UserService) === null || _Digit$UserService === void 0 ? void 0 : (_Digit$UserService$ge = _Digit$UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : _Digit$UserService$ge.info) || {};
  const isEmployee = (userInfo === null || userInfo === void 0 ? void 0 : userInfo.type) === "EMPLOYEE";
  const filteredTableData = isEmployee ? tableData.filter(row => (row === null || row === void 0 ? void 0 : row.typeOfUser) === "Department Only") : tableData.filter(row => (row === null || row === void 0 ? void 0 : row.typeOfUser) !== "Department Only");
  const fetchManualData = async () => {
    try {
      var _response$data;
      const dataToSend = {
        RequestInfo: {
          apiId: "Rainmaker",
          action: "_create",
          did: 1,
          key: "",
          msgId: "20170310130900|en_IN",
          ts: 0,
          ver: ".01"
        }
      };
      const response = await axios.post(`${Urls$1.UserManualSearch}?isApproved=${formType}&isSubApproved=User Manual`, dataToSend);
      console.log("📘 Response From User Manual API:", response.data);
      setTableData(((_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.UserManual) || []);
    } catch (error) {
      console.error("❌ Error fetching user manual data:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchManualData();
  }, [formType]);
  if (loading) {
    return /*#__PURE__*/React__default.createElement(Paper, {
      elevation: 0,
      sx: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: 180,
        backgroundColor: "#f8fafc"
      }
    }, /*#__PURE__*/React__default.createElement(CircularProgress, {
      size: 28,
      sx: {
        color: "#0c5a88"
      }
    }), /*#__PURE__*/React__default.createElement(Typography$1, {
      sx: {
        ml: 2,
        color: "#0c5a88"
      }
    }, "Loading documents..."));
  }
  return /*#__PURE__*/React__default.createElement(TableContainer, {
    component: Paper,
    sx: {
      maxHeight: 300,
      overflow: "auto",
      borderRadius: 2,
      boxShadow: 1
    }
  }, /*#__PURE__*/React__default.createElement(Table, {
    size: "small"
  }, /*#__PURE__*/React__default.createElement(TableHead, {
    sx: {
      backgroundColor: "#e0edf8"
    }
  }, /*#__PURE__*/React__default.createElement(TableRow, null, /*#__PURE__*/React__default.createElement(TableCell, {
    sx: {
      fontWeight: 600
    }
  }, "S.No."), /*#__PURE__*/React__default.createElement(TableCell, {
    sx: {
      fontWeight: 600
    }
  }, "Category"), /*#__PURE__*/React__default.createElement(TableCell, {
    sx: {
      fontWeight: 600
    }
  }, "User Manual"), /*#__PURE__*/React__default.createElement(TableCell, {
    sx: {
      fontWeight: 600
    }
  }, "Description"), /*#__PURE__*/React__default.createElement(TableCell, {
    sx: {
      fontWeight: 600
    }
  }, "Updated On"), /*#__PURE__*/React__default.createElement(TableCell, {
    sx: {
      fontWeight: 600
    }
  }, "Download Link"))), /*#__PURE__*/React__default.createElement(TableBody, null, filteredTableData.length > 0 ? filteredTableData.map((row, index) => {
    var _row$auditDetails;
    return /*#__PURE__*/React__default.createElement(TableRow, {
      key: row.id || index
    }, /*#__PURE__*/React__default.createElement(TableCell, null, index + 1), /*#__PURE__*/React__default.createElement(TableCell, null, row.category || "—"), /*#__PURE__*/React__default.createElement(TableCell, null, row.isSubApproved || "—"), /*#__PURE__*/React__default.createElement(TableCell, null, row.description || "—"), /*#__PURE__*/React__default.createElement(TableCell, null, (_row$auditDetails = row.auditDetails) !== null && _row$auditDetails !== void 0 && _row$auditDetails.createdTime ? new Date(row.auditDetails.createdTime).toLocaleDateString() : "—"), /*#__PURE__*/React__default.createElement(TableCell, null, row.downloadLink ? /*#__PURE__*/React__default.createElement(Link, {
      href: row.downloadLink,
      target: "_blank",
      rel: "noopener",
      sx: {
        color: "#0c5a88",
        fontWeight: 500
      }
    }, "Download") : "—"));
  }) : /*#__PURE__*/React__default.createElement(TableRow, null, /*#__PURE__*/React__default.createElement(TableCell, {
    colSpan: 6,
    align: "center"
  }, "No data available")))));
};

const VideoTutorial = ({
  formType
}) => {
  var _Digit, _Digit$UserService, _Digit$UserService$ge;
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(true);
  const userInfo = ((_Digit = Digit) === null || _Digit === void 0 ? void 0 : (_Digit$UserService = _Digit.UserService) === null || _Digit$UserService === void 0 ? void 0 : (_Digit$UserService$ge = _Digit$UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : _Digit$UserService$ge.info) || {};
  const isEmployee = (userInfo === null || userInfo === void 0 ? void 0 : userInfo.type) === "EMPLOYEE";
  const filteredTableData = isEmployee ? tableData.filter(row => (row === null || row === void 0 ? void 0 : row.typeOfUser) === "Department Only") : tableData.filter(row => (row === null || row === void 0 ? void 0 : row.typeOfUser) !== "Department Only");
  const fetchManualData = async () => {
    try {
      var _response$data;
      const dataToSend = {
        RequestInfo: {
          apiId: "Rainmaker",
          action: "_create",
          did: 1,
          key: "",
          msgId: "20170310130900|en_IN",
          ts: 0,
          ver: ".01"
        }
      };
      const response = await axios.post(`${Urls$1.UserManualSearch}?isApproved=${formType}&isSubApproved=Video Tutorial`, dataToSend);
      console.log("📘 Response From Video Tutorial API:", response.data);
      setTableData(((_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.UserManual) || []);
    } catch (error) {
      console.error("❌ Error fetching Video Tutorial data:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchManualData();
  }, [formType]);
  if (loading) {
    return /*#__PURE__*/React__default.createElement(Paper, {
      elevation: 0,
      sx: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: 180,
        backgroundColor: "#f8fafc"
      }
    }, /*#__PURE__*/React__default.createElement(CircularProgress, {
      size: 28,
      sx: {
        color: "#0c5a88"
      }
    }), /*#__PURE__*/React__default.createElement(Typography$1, {
      sx: {
        ml: 2,
        color: "#0c5a88"
      }
    }, "Loading documents..."));
  }
  return /*#__PURE__*/React__default.createElement(TableContainer, {
    component: Paper,
    sx: {
      maxHeight: 300,
      overflow: "auto",
      borderRadius: 2,
      boxShadow: 1
    }
  }, /*#__PURE__*/React__default.createElement(Table, {
    size: "small"
  }, /*#__PURE__*/React__default.createElement(TableHead, {
    sx: {
      backgroundColor: "#e0edf8"
    }
  }, /*#__PURE__*/React__default.createElement(TableRow, null, /*#__PURE__*/React__default.createElement(TableCell, {
    sx: {
      fontWeight: 600
    }
  }, "S.No."), /*#__PURE__*/React__default.createElement(TableCell, {
    sx: {
      fontWeight: 600
    }
  }, "Category"), /*#__PURE__*/React__default.createElement(TableCell, {
    sx: {
      fontWeight: 600
    }
  }, "Video Tutorial"), /*#__PURE__*/React__default.createElement(TableCell, {
    sx: {
      fontWeight: 600
    }
  }, "Description"), /*#__PURE__*/React__default.createElement(TableCell, {
    sx: {
      fontWeight: 600
    }
  }, "Updated On"), /*#__PURE__*/React__default.createElement(TableCell, {
    sx: {
      fontWeight: 600
    }
  }, "Download Link"))), /*#__PURE__*/React__default.createElement(TableBody, null, filteredTableData.length > 0 ? filteredTableData.map((row, index) => {
    var _row$auditDetails;
    return /*#__PURE__*/React__default.createElement(TableRow, {
      key: row.id || index
    }, /*#__PURE__*/React__default.createElement(TableCell, null, index + 1), /*#__PURE__*/React__default.createElement(TableCell, null, row.category || "—"), /*#__PURE__*/React__default.createElement(TableCell, null, row.isSubApproved || "—"), /*#__PURE__*/React__default.createElement(TableCell, null, row.description || "—"), /*#__PURE__*/React__default.createElement(TableCell, null, (_row$auditDetails = row.auditDetails) !== null && _row$auditDetails !== void 0 && _row$auditDetails.createdTime ? new Date(row.auditDetails.createdTime).toLocaleDateString() : "—"), /*#__PURE__*/React__default.createElement(TableCell, null, row.downloadLink ? /*#__PURE__*/React__default.createElement(Link, {
      href: row.downloadLink,
      target: "_blank",
      rel: "noopener",
      sx: {
        color: "#0c5a88",
        fontWeight: 500
      }
    }, "Download") : "—"));
  }) : /*#__PURE__*/React__default.createElement(TableRow, null, /*#__PURE__*/React__default.createElement(TableCell, {
    colSpan: 6,
    align: "center"
  }, "No data available")))));
};

const FAQTable = ({
  formType
}) => {
  var _Digit, _Digit$UserService, _Digit$UserService$ge;
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(true);
  const userInfo = ((_Digit = Digit) === null || _Digit === void 0 ? void 0 : (_Digit$UserService = _Digit.UserService) === null || _Digit$UserService === void 0 ? void 0 : (_Digit$UserService$ge = _Digit$UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : _Digit$UserService$ge.info) || {};
  const isEmployee = (userInfo === null || userInfo === void 0 ? void 0 : userInfo.type) === "EMPLOYEE";
  const filteredTableData = isEmployee ? tableData.filter(row => (row === null || row === void 0 ? void 0 : row.typeOfUser) === "Department Only") : tableData.filter(row => (row === null || row === void 0 ? void 0 : row.typeOfUser) !== "Department Only");
  const fetchManualData = async () => {
    try {
      var _response$data;
      const dataToSend = {
        RequestInfo: {
          apiId: "Rainmaker",
          action: "_create",
          did: 1,
          key: "",
          msgId: "20170310130900|en_IN",
          ts: 0,
          ver: ".01"
        }
      };
      const response = await axios.post(`${Urls$1.UserManualSearch}?isApproved=${formType}&isSubApproved=FAQ`, dataToSend);
      console.log("📘 Response From FAQ API:", response.data);
      setTableData(((_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.UserManual) || []);
    } catch (error) {
      console.error("❌ Error fetching FAQ data:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchManualData();
  }, [formType]);
  if (loading) {
    return /*#__PURE__*/React__default.createElement(Paper, {
      elevation: 0,
      sx: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: 180,
        backgroundColor: "#f8fafc"
      }
    }, /*#__PURE__*/React__default.createElement(CircularProgress, {
      size: 28,
      sx: {
        color: "#0c5a88"
      }
    }), /*#__PURE__*/React__default.createElement(Typography$1, {
      sx: {
        ml: 2,
        color: "#0c5a88"
      }
    }, "Loading documents..."));
  }
  return /*#__PURE__*/React__default.createElement(TableContainer, {
    component: Paper,
    sx: {
      maxHeight: 300,
      overflow: "auto",
      borderRadius: 2,
      boxShadow: 1
    }
  }, /*#__PURE__*/React__default.createElement(Table, {
    size: "small"
  }, /*#__PURE__*/React__default.createElement(TableHead, {
    sx: {
      backgroundColor: "#e0edf8"
    }
  }, /*#__PURE__*/React__default.createElement(TableRow, null, /*#__PURE__*/React__default.createElement(TableCell, {
    sx: {
      fontWeight: 600
    }
  }, "S.No."), /*#__PURE__*/React__default.createElement(TableCell, {
    sx: {
      fontWeight: 600
    }
  }, "Category"), /*#__PURE__*/React__default.createElement(TableCell, {
    sx: {
      fontWeight: 600
    }
  }, "FAQ"), /*#__PURE__*/React__default.createElement(TableCell, {
    sx: {
      fontWeight: 600
    }
  }, "Description"), /*#__PURE__*/React__default.createElement(TableCell, {
    sx: {
      fontWeight: 600
    }
  }, "Updated On"), /*#__PURE__*/React__default.createElement(TableCell, {
    sx: {
      fontWeight: 600
    }
  }, "Download Link"))), /*#__PURE__*/React__default.createElement(TableBody, null, filteredTableData.length > 0 ? filteredTableData.map((row, index) => {
    var _row$auditDetails;
    return /*#__PURE__*/React__default.createElement(TableRow, {
      key: row.id || index
    }, /*#__PURE__*/React__default.createElement(TableCell, null, index + 1), /*#__PURE__*/React__default.createElement(TableCell, null, row.category || "—"), /*#__PURE__*/React__default.createElement(TableCell, null, row.isSubApproved || "—"), /*#__PURE__*/React__default.createElement(TableCell, null, row.description || "—"), /*#__PURE__*/React__default.createElement(TableCell, null, (_row$auditDetails = row.auditDetails) !== null && _row$auditDetails !== void 0 && _row$auditDetails.createdTime ? new Date(row.auditDetails.createdTime).toLocaleDateString() : "—"), /*#__PURE__*/React__default.createElement(TableCell, null, row.downloadLink ? /*#__PURE__*/React__default.createElement(Link, {
      href: row.downloadLink,
      target: "_blank",
      rel: "noopener",
      sx: {
        color: "#0c5a88",
        fontWeight: 500
      }
    }, "Download") : "—"));
  }) : /*#__PURE__*/React__default.createElement(TableRow, null, /*#__PURE__*/React__default.createElement(TableCell, {
    colSpan: 6,
    align: "center"
  }, "No data available")))));
};

const SOPTable = ({
  formType
}) => {
  var _Digit, _Digit$UserService, _Digit$UserService$ge;
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(true);
  const userInfo = ((_Digit = Digit) === null || _Digit === void 0 ? void 0 : (_Digit$UserService = _Digit.UserService) === null || _Digit$UserService === void 0 ? void 0 : (_Digit$UserService$ge = _Digit$UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : _Digit$UserService$ge.info) || {};
  const isEmployee = (userInfo === null || userInfo === void 0 ? void 0 : userInfo.type) === "EMPLOYEE";
  const filteredTableData = isEmployee ? tableData.filter(row => (row === null || row === void 0 ? void 0 : row.typeOfUser) === "Department Only") : tableData.filter(row => (row === null || row === void 0 ? void 0 : row.typeOfUser) !== "Department Only");
  const fetchManualData = async () => {
    try {
      var _response$data;
      const dataToSend = {
        RequestInfo: {
          apiId: "Rainmaker",
          action: "_create",
          did: 1,
          key: "",
          msgId: "20170310130900|en_IN",
          ts: 0,
          ver: ".01"
        }
      };
      const response = await axios.post(`${Urls$1.UserManualSearch}?isApproved=${formType}&isSubApproved=SOP`, dataToSend);
      console.log("📘 Response From SOP API:", response.data);
      setTableData(((_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.UserManual) || []);
    } catch (error) {
      console.error("❌ Error fetching SOP data:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchManualData();
  }, [formType]);
  if (loading) {
    return /*#__PURE__*/React__default.createElement(Paper, {
      elevation: 0,
      sx: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: 180,
        backgroundColor: "#f8fafc"
      }
    }, /*#__PURE__*/React__default.createElement(CircularProgress, {
      size: 28,
      sx: {
        color: "#0c5a88"
      }
    }), /*#__PURE__*/React__default.createElement(Typography$1, {
      sx: {
        ml: 2,
        color: "#0c5a88"
      }
    }, "Loading documents..."));
  }
  return /*#__PURE__*/React__default.createElement(TableContainer, {
    component: Paper,
    sx: {
      maxHeight: 300,
      overflow: "auto",
      borderRadius: 2,
      boxShadow: 1
    }
  }, /*#__PURE__*/React__default.createElement(Table, {
    size: "small"
  }, /*#__PURE__*/React__default.createElement(TableHead, {
    sx: {
      backgroundColor: "#e0edf8"
    }
  }, /*#__PURE__*/React__default.createElement(TableRow, null, /*#__PURE__*/React__default.createElement(TableCell, {
    sx: {
      fontWeight: 600
    }
  }, "S.No."), /*#__PURE__*/React__default.createElement(TableCell, {
    sx: {
      fontWeight: 600
    }
  }, "Category"), /*#__PURE__*/React__default.createElement(TableCell, {
    sx: {
      fontWeight: 600
    }
  }, "SOP"), /*#__PURE__*/React__default.createElement(TableCell, {
    sx: {
      fontWeight: 600
    }
  }, "Description"), /*#__PURE__*/React__default.createElement(TableCell, {
    sx: {
      fontWeight: 600
    }
  }, "Updated On"), /*#__PURE__*/React__default.createElement(TableCell, {
    sx: {
      fontWeight: 600
    }
  }, "Download Link"))), /*#__PURE__*/React__default.createElement(TableBody, null, filteredTableData.length > 0 ? filteredTableData.map((row, index) => {
    var _row$auditDetails;
    return /*#__PURE__*/React__default.createElement(TableRow, {
      key: row.id || index
    }, /*#__PURE__*/React__default.createElement(TableCell, null, index + 1), /*#__PURE__*/React__default.createElement(TableCell, null, row.category || "—"), /*#__PURE__*/React__default.createElement(TableCell, null, row.isSubApproved || "—"), /*#__PURE__*/React__default.createElement(TableCell, null, row.description || "—"), /*#__PURE__*/React__default.createElement(TableCell, null, (_row$auditDetails = row.auditDetails) !== null && _row$auditDetails !== void 0 && _row$auditDetails.createdTime ? new Date(row.auditDetails.createdTime).toLocaleDateString() : "—"), /*#__PURE__*/React__default.createElement(TableCell, null, row.downloadLink ? /*#__PURE__*/React__default.createElement(Link, {
      href: row.downloadLink,
      target: "_blank",
      rel: "noopener",
      sx: {
        color: "#0c5a88",
        fontWeight: 500
      }
    }, "Download") : "—"));
  }) : /*#__PURE__*/React__default.createElement(TableRow, null, /*#__PURE__*/React__default.createElement(TableCell, {
    colSpan: 6,
    align: "center"
  }, "No data available")))));
};

const SampleDrawing = ({
  formType
}) => {
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(true);
  const fetchManualData = async () => {
    try {
      var _response$data;
      const dataToSend = {
        RequestInfo: {
          apiId: "Rainmaker",
          action: "_create",
          did: 1,
          key: "",
          msgId: "20170310130900|en_IN",
          ts: 0,
          ver: ".01"
        }
      };
      const response = await axios.post(`${Urls$1.UserManualSearch}?isApproved=${formType}&isSubApproved=Sample Drawing`, dataToSend);
      console.log("📘 Response From Sample Drawing API:", response.data);
      setTableData(((_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.UserManual) || []);
    } catch (error) {
      console.error("❌ Error fetching Sample Drawing data:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchManualData();
  }, [formType]);
  if (loading) {
    return /*#__PURE__*/React__default.createElement(Paper, {
      elevation: 0,
      sx: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: 180,
        backgroundColor: "#f8fafc"
      }
    }, /*#__PURE__*/React__default.createElement(CircularProgress, {
      size: 28,
      sx: {
        color: "#0c5a88"
      }
    }), /*#__PURE__*/React__default.createElement(Typography$1, {
      sx: {
        ml: 2,
        color: "#0c5a88"
      }
    }, "Loading documents..."));
  }
  return /*#__PURE__*/React__default.createElement(TableContainer, {
    component: Paper,
    sx: {
      maxHeight: 300,
      overflow: "auto",
      borderRadius: 2,
      boxShadow: 1
    }
  }, /*#__PURE__*/React__default.createElement(Table, {
    size: "small"
  }, /*#__PURE__*/React__default.createElement(TableHead, {
    sx: {
      backgroundColor: "#e0edf8"
    }
  }, /*#__PURE__*/React__default.createElement(TableRow, null, /*#__PURE__*/React__default.createElement(TableCell, {
    sx: {
      fontWeight: 600
    }
  }, "S.No."), /*#__PURE__*/React__default.createElement(TableCell, {
    sx: {
      fontWeight: 600
    }
  }, "Category"), /*#__PURE__*/React__default.createElement(TableCell, {
    sx: {
      fontWeight: 600
    }
  }, "Sample Drawing"), /*#__PURE__*/React__default.createElement(TableCell, {
    sx: {
      fontWeight: 600
    }
  }, "Description"), /*#__PURE__*/React__default.createElement(TableCell, {
    sx: {
      fontWeight: 600
    }
  }, "Updated On"), /*#__PURE__*/React__default.createElement(TableCell, {
    sx: {
      fontWeight: 600
    }
  }, "Download Link"))), /*#__PURE__*/React__default.createElement(TableBody, null, tableData.length > 0 ? tableData.map((row, index) => {
    var _row$auditDetails;
    return /*#__PURE__*/React__default.createElement(TableRow, {
      key: row.id || index
    }, /*#__PURE__*/React__default.createElement(TableCell, null, index + 1), /*#__PURE__*/React__default.createElement(TableCell, null, row.category || "—"), /*#__PURE__*/React__default.createElement(TableCell, null, row.isSubApproved || "—"), /*#__PURE__*/React__default.createElement(TableCell, null, row.description || "—"), /*#__PURE__*/React__default.createElement(TableCell, null, (_row$auditDetails = row.auditDetails) !== null && _row$auditDetails !== void 0 && _row$auditDetails.createdTime ? new Date(row.auditDetails.createdTime).toLocaleDateString() : "—"), /*#__PURE__*/React__default.createElement(TableCell, null, row.downloadLink ? /*#__PURE__*/React__default.createElement(Link, {
      href: row.downloadLink,
      target: "_blank",
      rel: "noopener",
      sx: {
        color: "#0c5a88",
        fontWeight: 500
      }
    }, "Download") : "—"));
  }) : /*#__PURE__*/React__default.createElement(TableRow, null, /*#__PURE__*/React__default.createElement(TableCell, {
    colSpan: 6,
    align: "center"
  }, "No data available")))));
};

const BuildingShow = ({
  formType
}) => {
  var _Digit, _Digit$UserService, _Digit$UserService$ge;
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(true);
  const userInfo = ((_Digit = Digit) === null || _Digit === void 0 ? void 0 : (_Digit$UserService = _Digit.UserService) === null || _Digit$UserService === void 0 ? void 0 : (_Digit$UserService$ge = _Digit$UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : _Digit$UserService$ge.info) || {};
  const isEmployee = (userInfo === null || userInfo === void 0 ? void 0 : userInfo.type) === "EMPLOYEE";
  const filteredTableData = isEmployee ? tableData.filter(row => (row === null || row === void 0 ? void 0 : row.typeOfUser) === "Department Only") : tableData.filter(row => (row === null || row === void 0 ? void 0 : row.typeOfUser) !== "Department Only");
  const fetchManualData = async () => {
    try {
      var _response$data;
      const dataToSend = {
        RequestInfo: {
          apiId: "Rainmaker",
          action: "_create",
          did: 1,
          key: "",
          msgId: "20170310130900|en_IN",
          ts: 0,
          ver: ".01"
        }
      };
      const response = await axios.post(`${Urls$1.UserManualSearch}?isApproved=${formType}&isSubApproved=Building Byelaws and GO`, dataToSend);
      console.log("📘 Response From Building Byelaws and GO API:", response.data);
      setTableData(((_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.UserManual) || []);
    } catch (error) {
      console.error("❌ Error fetching Building Byelaws and GO data:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchManualData();
  }, [formType]);
  if (loading) {
    return /*#__PURE__*/React__default.createElement(Paper, {
      elevation: 0,
      sx: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: 180,
        backgroundColor: "#f8fafc"
      }
    }, /*#__PURE__*/React__default.createElement(CircularProgress, {
      size: 28,
      sx: {
        color: "#0c5a88"
      }
    }), /*#__PURE__*/React__default.createElement(Typography$1, {
      sx: {
        ml: 2,
        color: "#0c5a88"
      }
    }, "Loading documents..."));
  }
  return /*#__PURE__*/React__default.createElement(TableContainer, {
    component: Paper,
    sx: {
      maxHeight: 300,
      overflow: "auto",
      borderRadius: 2,
      boxShadow: 1
    }
  }, /*#__PURE__*/React__default.createElement(Table, {
    size: "small"
  }, /*#__PURE__*/React__default.createElement(TableHead, {
    sx: {
      backgroundColor: "#e0edf8"
    }
  }, /*#__PURE__*/React__default.createElement(TableRow, null, /*#__PURE__*/React__default.createElement(TableCell, {
    sx: {
      fontWeight: 600
    }
  }, "S.No."), /*#__PURE__*/React__default.createElement(TableCell, {
    sx: {
      fontWeight: 600
    }
  }, "Category"), /*#__PURE__*/React__default.createElement(TableCell, {
    sx: {
      fontWeight: 600
    }
  }, "Building Bye laws"), /*#__PURE__*/React__default.createElement(TableCell, {
    sx: {
      fontWeight: 600
    }
  }, "Description"), /*#__PURE__*/React__default.createElement(TableCell, {
    sx: {
      fontWeight: 600
    }
  }, "Updated On"), /*#__PURE__*/React__default.createElement(TableCell, {
    sx: {
      fontWeight: 600
    }
  }, "Download Link"))), /*#__PURE__*/React__default.createElement(TableBody, null, filteredTableData.length > 0 ? filteredTableData.map((row, index) => {
    var _row$auditDetails;
    return /*#__PURE__*/React__default.createElement(TableRow, {
      key: row.id || index
    }, /*#__PURE__*/React__default.createElement(TableCell, null, index + 1), /*#__PURE__*/React__default.createElement(TableCell, null, row.category || "—"), /*#__PURE__*/React__default.createElement(TableCell, null, row.isSubApproved || "—"), /*#__PURE__*/React__default.createElement(TableCell, null, row.description || "—"), /*#__PURE__*/React__default.createElement(TableCell, null, (_row$auditDetails = row.auditDetails) !== null && _row$auditDetails !== void 0 && _row$auditDetails.createdTime ? new Date(row.auditDetails.createdTime).toLocaleDateString() : "—"), /*#__PURE__*/React__default.createElement(TableCell, null, row.downloadLink ? /*#__PURE__*/React__default.createElement(Link, {
      href: row.downloadLink,
      target: "_blank",
      rel: "noopener",
      sx: {
        color: "#0c5a88",
        fontWeight: 500
      }
    }, "Download") : "—"));
  }) : /*#__PURE__*/React__default.createElement(TableRow, null, /*#__PURE__*/React__default.createElement(TableCell, {
    colSpan: 6,
    align: "center"
  }, "No data available")))));
};

var lodash = createCommonjsModule(function (module, exports) {
  (function () {
    var undefined$1;
    var VERSION = '4.17.21';
    var LARGE_ARRAY_SIZE = 200;
    var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';
    var HASH_UNDEFINED = '__lodash_hash_undefined__';
    var MAX_MEMOIZE_SIZE = 500;
    var PLACEHOLDER = '__lodash_placeholder__';
    var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;
    var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;
    var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;
    var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';
    var HOT_COUNT = 800,
      HOT_SPAN = 16;
    var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;
    var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;
    var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    var wrapFlags = [['ary', WRAP_ARY_FLAG], ['bind', WRAP_BIND_FLAG], ['bindKey', WRAP_BIND_KEY_FLAG], ['curry', WRAP_CURRY_FLAG], ['curryRight', WRAP_CURRY_RIGHT_FLAG], ['flip', WRAP_FLIP_FLAG], ['partial', WRAP_PARTIAL_FLAG], ['partialRight', WRAP_PARTIAL_RIGHT_FLAG], ['rearg', WRAP_REARG_FLAG]];
    var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';
    var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';
    var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;
    var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);
    var reTrimStart = /^\s+/;
    var reWhitespace = /\s/;
    var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;
    var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    var reEscapeChar = /\\(\\)?/g;
    var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    var reFlags = /\w*$/;
    var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    var reIsBinary = /^0b[01]+$/i;
    var reIsHostCtor = /^\[object .+?Constructor\]$/;
    var reIsOctal = /^0o[0-7]+$/i;
    var reIsUint = /^(?:0|[1-9]\d*)$/;
    var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    var reNoMatch = /($^)/;
    var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';
    var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
    var reApos = RegExp(rsApos, 'g');
    var reComboMark = RegExp(rsCombo, 'g');
    var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
    var reUnicodeWord = RegExp([rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')', rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')', rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower, rsUpper + '+' + rsOptContrUpper, rsOrdUpper, rsOrdLower, rsDigits, rsEmoji].join('|'), 'g');
    var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
    var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    var contextProps = ['Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array', 'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object', 'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array', 'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap', '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'];
    var templateCounter = -1;
    var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    var deburredLetters = {
      '\xc0': 'A',
      '\xc1': 'A',
      '\xc2': 'A',
      '\xc3': 'A',
      '\xc4': 'A',
      '\xc5': 'A',
      '\xe0': 'a',
      '\xe1': 'a',
      '\xe2': 'a',
      '\xe3': 'a',
      '\xe4': 'a',
      '\xe5': 'a',
      '\xc7': 'C',
      '\xe7': 'c',
      '\xd0': 'D',
      '\xf0': 'd',
      '\xc8': 'E',
      '\xc9': 'E',
      '\xca': 'E',
      '\xcb': 'E',
      '\xe8': 'e',
      '\xe9': 'e',
      '\xea': 'e',
      '\xeb': 'e',
      '\xcc': 'I',
      '\xcd': 'I',
      '\xce': 'I',
      '\xcf': 'I',
      '\xec': 'i',
      '\xed': 'i',
      '\xee': 'i',
      '\xef': 'i',
      '\xd1': 'N',
      '\xf1': 'n',
      '\xd2': 'O',
      '\xd3': 'O',
      '\xd4': 'O',
      '\xd5': 'O',
      '\xd6': 'O',
      '\xd8': 'O',
      '\xf2': 'o',
      '\xf3': 'o',
      '\xf4': 'o',
      '\xf5': 'o',
      '\xf6': 'o',
      '\xf8': 'o',
      '\xd9': 'U',
      '\xda': 'U',
      '\xdb': 'U',
      '\xdc': 'U',
      '\xf9': 'u',
      '\xfa': 'u',
      '\xfb': 'u',
      '\xfc': 'u',
      '\xdd': 'Y',
      '\xfd': 'y',
      '\xff': 'y',
      '\xc6': 'Ae',
      '\xe6': 'ae',
      '\xde': 'Th',
      '\xfe': 'th',
      '\xdf': 'ss',
      '\u0100': 'A',
      '\u0102': 'A',
      '\u0104': 'A',
      '\u0101': 'a',
      '\u0103': 'a',
      '\u0105': 'a',
      '\u0106': 'C',
      '\u0108': 'C',
      '\u010a': 'C',
      '\u010c': 'C',
      '\u0107': 'c',
      '\u0109': 'c',
      '\u010b': 'c',
      '\u010d': 'c',
      '\u010e': 'D',
      '\u0110': 'D',
      '\u010f': 'd',
      '\u0111': 'd',
      '\u0112': 'E',
      '\u0114': 'E',
      '\u0116': 'E',
      '\u0118': 'E',
      '\u011a': 'E',
      '\u0113': 'e',
      '\u0115': 'e',
      '\u0117': 'e',
      '\u0119': 'e',
      '\u011b': 'e',
      '\u011c': 'G',
      '\u011e': 'G',
      '\u0120': 'G',
      '\u0122': 'G',
      '\u011d': 'g',
      '\u011f': 'g',
      '\u0121': 'g',
      '\u0123': 'g',
      '\u0124': 'H',
      '\u0126': 'H',
      '\u0125': 'h',
      '\u0127': 'h',
      '\u0128': 'I',
      '\u012a': 'I',
      '\u012c': 'I',
      '\u012e': 'I',
      '\u0130': 'I',
      '\u0129': 'i',
      '\u012b': 'i',
      '\u012d': 'i',
      '\u012f': 'i',
      '\u0131': 'i',
      '\u0134': 'J',
      '\u0135': 'j',
      '\u0136': 'K',
      '\u0137': 'k',
      '\u0138': 'k',
      '\u0139': 'L',
      '\u013b': 'L',
      '\u013d': 'L',
      '\u013f': 'L',
      '\u0141': 'L',
      '\u013a': 'l',
      '\u013c': 'l',
      '\u013e': 'l',
      '\u0140': 'l',
      '\u0142': 'l',
      '\u0143': 'N',
      '\u0145': 'N',
      '\u0147': 'N',
      '\u014a': 'N',
      '\u0144': 'n',
      '\u0146': 'n',
      '\u0148': 'n',
      '\u014b': 'n',
      '\u014c': 'O',
      '\u014e': 'O',
      '\u0150': 'O',
      '\u014d': 'o',
      '\u014f': 'o',
      '\u0151': 'o',
      '\u0154': 'R',
      '\u0156': 'R',
      '\u0158': 'R',
      '\u0155': 'r',
      '\u0157': 'r',
      '\u0159': 'r',
      '\u015a': 'S',
      '\u015c': 'S',
      '\u015e': 'S',
      '\u0160': 'S',
      '\u015b': 's',
      '\u015d': 's',
      '\u015f': 's',
      '\u0161': 's',
      '\u0162': 'T',
      '\u0164': 'T',
      '\u0166': 'T',
      '\u0163': 't',
      '\u0165': 't',
      '\u0167': 't',
      '\u0168': 'U',
      '\u016a': 'U',
      '\u016c': 'U',
      '\u016e': 'U',
      '\u0170': 'U',
      '\u0172': 'U',
      '\u0169': 'u',
      '\u016b': 'u',
      '\u016d': 'u',
      '\u016f': 'u',
      '\u0171': 'u',
      '\u0173': 'u',
      '\u0174': 'W',
      '\u0175': 'w',
      '\u0176': 'Y',
      '\u0177': 'y',
      '\u0178': 'Y',
      '\u0179': 'Z',
      '\u017b': 'Z',
      '\u017d': 'Z',
      '\u017a': 'z',
      '\u017c': 'z',
      '\u017e': 'z',
      '\u0132': 'IJ',
      '\u0133': 'ij',
      '\u0152': 'Oe',
      '\u0153': 'oe',
      '\u0149': "'n",
      '\u017f': 's'
    };
    var htmlEscapes = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;'
    };
    var htmlUnescapes = {
      '&amp;': '&',
      '&lt;': '<',
      '&gt;': '>',
      '&quot;': '"',
      '&#39;': "'"
    };
    var stringEscapes = {
      '\\': '\\',
      "'": "'",
      '\n': 'n',
      '\r': 'r',
      '\u2028': 'u2028',
      '\u2029': 'u2029'
    };
    var freeParseFloat = parseFloat,
      freeParseInt = parseInt;
    var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
    var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    var root = freeGlobal || freeSelf || Function('return this')();
    var freeExports =  exports && !exports.nodeType && exports;
    var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;
    var moduleExports = freeModule && freeModule.exports === freeExports;
    var freeProcess = moduleExports && freeGlobal.process;
    var nodeUtil = function () {
      try {
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) {
          return types;
        }
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
      } catch (e) {}
    }();
    var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    function apply(func, thisArg, args) {
      switch (args.length) {
        case 0:
          return func.call(thisArg);
        case 1:
          return func.call(thisArg, args[0]);
        case 2:
          return func.call(thisArg, args[0], args[1]);
        case 3:
          return func.call(thisArg, args[0], args[1], args[2]);
      }
      return func.apply(thisArg, args);
    }
    function arrayAggregator(array, setter, iteratee, accumulator) {
      var index = -1,
        length = array == null ? 0 : array.length;
      while (++index < length) {
        var value = array[index];
        setter(accumulator, value, iteratee(value), array);
      }
      return accumulator;
    }
    function arrayEach(array, iteratee) {
      var index = -1,
        length = array == null ? 0 : array.length;
      while (++index < length) {
        if (iteratee(array[index], index, array) === false) {
          break;
        }
      }
      return array;
    }
    function arrayEachRight(array, iteratee) {
      var length = array == null ? 0 : array.length;
      while (length--) {
        if (iteratee(array[length], length, array) === false) {
          break;
        }
      }
      return array;
    }
    function arrayEvery(array, predicate) {
      var index = -1,
        length = array == null ? 0 : array.length;
      while (++index < length) {
        if (!predicate(array[index], index, array)) {
          return false;
        }
      }
      return true;
    }
    function arrayFilter(array, predicate) {
      var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result[resIndex++] = value;
        }
      }
      return result;
    }
    function arrayIncludes(array, value) {
      var length = array == null ? 0 : array.length;
      return !!length && baseIndexOf(array, value, 0) > -1;
    }
    function arrayIncludesWith(array, value, comparator) {
      var index = -1,
        length = array == null ? 0 : array.length;
      while (++index < length) {
        if (comparator(value, array[index])) {
          return true;
        }
      }
      return false;
    }
    function arrayMap(array, iteratee) {
      var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);
      while (++index < length) {
        result[index] = iteratee(array[index], index, array);
      }
      return result;
    }
    function arrayPush(array, values) {
      var index = -1,
        length = values.length,
        offset = array.length;
      while (++index < length) {
        array[offset + index] = values[index];
      }
      return array;
    }
    function arrayReduce(array, iteratee, accumulator, initAccum) {
      var index = -1,
        length = array == null ? 0 : array.length;
      if (initAccum && length) {
        accumulator = array[++index];
      }
      while (++index < length) {
        accumulator = iteratee(accumulator, array[index], index, array);
      }
      return accumulator;
    }
    function arrayReduceRight(array, iteratee, accumulator, initAccum) {
      var length = array == null ? 0 : array.length;
      if (initAccum && length) {
        accumulator = array[--length];
      }
      while (length--) {
        accumulator = iteratee(accumulator, array[length], length, array);
      }
      return accumulator;
    }
    function arraySome(array, predicate) {
      var index = -1,
        length = array == null ? 0 : array.length;
      while (++index < length) {
        if (predicate(array[index], index, array)) {
          return true;
        }
      }
      return false;
    }
    var asciiSize = baseProperty('length');
    function asciiToArray(string) {
      return string.split('');
    }
    function asciiWords(string) {
      return string.match(reAsciiWord) || [];
    }
    function baseFindKey(collection, predicate, eachFunc) {
      var result;
      eachFunc(collection, function (value, key, collection) {
        if (predicate(value, key, collection)) {
          result = key;
          return false;
        }
      });
      return result;
    }
    function baseFindIndex(array, predicate, fromIndex, fromRight) {
      var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);
      while (fromRight ? index-- : ++index < length) {
        if (predicate(array[index], index, array)) {
          return index;
        }
      }
      return -1;
    }
    function baseIndexOf(array, value, fromIndex) {
      return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    function baseIndexOfWith(array, value, fromIndex, comparator) {
      var index = fromIndex - 1,
        length = array.length;
      while (++index < length) {
        if (comparator(array[index], value)) {
          return index;
        }
      }
      return -1;
    }
    function baseIsNaN(value) {
      return value !== value;
    }
    function baseMean(array, iteratee) {
      var length = array == null ? 0 : array.length;
      return length ? baseSum(array, iteratee) / length : NAN;
    }
    function baseProperty(key) {
      return function (object) {
        return object == null ? undefined$1 : object[key];
      };
    }
    function basePropertyOf(object) {
      return function (key) {
        return object == null ? undefined$1 : object[key];
      };
    }
    function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
      eachFunc(collection, function (value, index, collection) {
        accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
      });
      return accumulator;
    }
    function baseSortBy(array, comparer) {
      var length = array.length;
      array.sort(comparer);
      while (length--) {
        array[length] = array[length].value;
      }
      return array;
    }
    function baseSum(array, iteratee) {
      var result,
        index = -1,
        length = array.length;
      while (++index < length) {
        var current = iteratee(array[index]);
        if (current !== undefined$1) {
          result = result === undefined$1 ? current : result + current;
        }
      }
      return result;
    }
    function baseTimes(n, iteratee) {
      var index = -1,
        result = Array(n);
      while (++index < n) {
        result[index] = iteratee(index);
      }
      return result;
    }
    function baseToPairs(object, props) {
      return arrayMap(props, function (key) {
        return [key, object[key]];
      });
    }
    function baseTrim(string) {
      return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
    }
    function baseUnary(func) {
      return function (value) {
        return func(value);
      };
    }
    function baseValues(object, props) {
      return arrayMap(props, function (key) {
        return object[key];
      });
    }
    function cacheHas(cache, key) {
      return cache.has(key);
    }
    function charsStartIndex(strSymbols, chrSymbols) {
      var index = -1,
        length = strSymbols.length;
      while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
      return index;
    }
    function charsEndIndex(strSymbols, chrSymbols) {
      var index = strSymbols.length;
      while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
      return index;
    }
    function countHolders(array, placeholder) {
      var length = array.length,
        result = 0;
      while (length--) {
        if (array[length] === placeholder) {
          ++result;
        }
      }
      return result;
    }
    var deburrLetter = basePropertyOf(deburredLetters);
    var escapeHtmlChar = basePropertyOf(htmlEscapes);
    function escapeStringChar(chr) {
      return '\\' + stringEscapes[chr];
    }
    function getValue(object, key) {
      return object == null ? undefined$1 : object[key];
    }
    function hasUnicode(string) {
      return reHasUnicode.test(string);
    }
    function hasUnicodeWord(string) {
      return reHasUnicodeWord.test(string);
    }
    function iteratorToArray(iterator) {
      var data,
        result = [];
      while (!(data = iterator.next()).done) {
        result.push(data.value);
      }
      return result;
    }
    function mapToArray(map) {
      var index = -1,
        result = Array(map.size);
      map.forEach(function (value, key) {
        result[++index] = [key, value];
      });
      return result;
    }
    function overArg(func, transform) {
      return function (arg) {
        return func(transform(arg));
      };
    }
    function replaceHolders(array, placeholder) {
      var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];
      while (++index < length) {
        var value = array[index];
        if (value === placeholder || value === PLACEHOLDER) {
          array[index] = PLACEHOLDER;
          result[resIndex++] = index;
        }
      }
      return result;
    }
    function setToArray(set) {
      var index = -1,
        result = Array(set.size);
      set.forEach(function (value) {
        result[++index] = value;
      });
      return result;
    }
    function setToPairs(set) {
      var index = -1,
        result = Array(set.size);
      set.forEach(function (value) {
        result[++index] = [value, value];
      });
      return result;
    }
    function strictIndexOf(array, value, fromIndex) {
      var index = fromIndex - 1,
        length = array.length;
      while (++index < length) {
        if (array[index] === value) {
          return index;
        }
      }
      return -1;
    }
    function strictLastIndexOf(array, value, fromIndex) {
      var index = fromIndex + 1;
      while (index--) {
        if (array[index] === value) {
          return index;
        }
      }
      return index;
    }
    function stringSize(string) {
      return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    function stringToArray(string) {
      return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    function trimmedEndIndex(string) {
      var index = string.length;
      while (index-- && reWhitespace.test(string.charAt(index))) {}
      return index;
    }
    var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    function unicodeSize(string) {
      var result = reUnicode.lastIndex = 0;
      while (reUnicode.test(string)) {
        ++result;
      }
      return result;
    }
    function unicodeToArray(string) {
      return string.match(reUnicode) || [];
    }
    function unicodeWords(string) {
      return string.match(reUnicodeWord) || [];
    }
    var runInContext = function runInContext(context) {
      context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
      var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;
      var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;
      var coreJsData = context['__core-js_shared__'];
      var funcToString = funcProto.toString;
      var hasOwnProperty = objectProto.hasOwnProperty;
      var idCounter = 0;
      var maskSrcKey = function () {
        var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
        return uid ? 'Symbol(src)_1.' + uid : '';
      }();
      var nativeObjectToString = objectProto.toString;
      var objectCtorString = funcToString.call(Object);
      var oldDash = root._;
      var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
      var Buffer = moduleExports ? context.Buffer : undefined$1,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined$1,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined$1,
        symIterator = Symbol ? Symbol.iterator : undefined$1,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined$1;
      var defineProperty = function () {
        try {
          var func = getNative(Object, 'defineProperty');
          func({}, '', {});
          return func;
        } catch (e) {}
      }();
      var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
      var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined$1,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;
      var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');
      var metaMap = WeakMap && new WeakMap();
      var realNames = {};
      var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);
      var symbolProto = Symbol ? Symbol.prototype : undefined$1,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined$1,
        symbolToString = symbolProto ? symbolProto.toString : undefined$1;
      function lodash(value) {
        if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
          if (value instanceof LodashWrapper) {
            return value;
          }
          if (hasOwnProperty.call(value, '__wrapped__')) {
            return wrapperClone(value);
          }
        }
        return new LodashWrapper(value);
      }
      var baseCreate = function () {
        function object() {}
        return function (proto) {
          if (!isObject(proto)) {
            return {};
          }
          if (objectCreate) {
            return objectCreate(proto);
          }
          object.prototype = proto;
          var result = new object();
          object.prototype = undefined$1;
          return result;
        };
      }();
      function baseLodash() {}
      function LodashWrapper(value, chainAll) {
        this.__wrapped__ = value;
        this.__actions__ = [];
        this.__chain__ = !!chainAll;
        this.__index__ = 0;
        this.__values__ = undefined$1;
      }
      lodash.templateSettings = {
        'escape': reEscape,
        'evaluate': reEvaluate,
        'interpolate': reInterpolate,
        'variable': '',
        'imports': {
          '_': lodash
        }
      };
      lodash.prototype = baseLodash.prototype;
      lodash.prototype.constructor = lodash;
      LodashWrapper.prototype = baseCreate(baseLodash.prototype);
      LodashWrapper.prototype.constructor = LodashWrapper;
      function LazyWrapper(value) {
        this.__wrapped__ = value;
        this.__actions__ = [];
        this.__dir__ = 1;
        this.__filtered__ = false;
        this.__iteratees__ = [];
        this.__takeCount__ = MAX_ARRAY_LENGTH;
        this.__views__ = [];
      }
      function lazyClone() {
        var result = new LazyWrapper(this.__wrapped__);
        result.__actions__ = copyArray(this.__actions__);
        result.__dir__ = this.__dir__;
        result.__filtered__ = this.__filtered__;
        result.__iteratees__ = copyArray(this.__iteratees__);
        result.__takeCount__ = this.__takeCount__;
        result.__views__ = copyArray(this.__views__);
        return result;
      }
      function lazyReverse() {
        if (this.__filtered__) {
          var result = new LazyWrapper(this);
          result.__dir__ = -1;
          result.__filtered__ = true;
        } else {
          result = this.clone();
          result.__dir__ *= -1;
        }
        return result;
      }
      function lazyValue() {
        var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : start - 1,
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);
        if (!isArr || !isRight && arrLength == length && takeCount == length) {
          return baseWrapperValue(array, this.__actions__);
        }
        var result = [];
        outer: while (length-- && resIndex < takeCount) {
          index += dir;
          var iterIndex = -1,
            value = array[index];
          while (++iterIndex < iterLength) {
            var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);
            if (type == LAZY_MAP_FLAG) {
              value = computed;
            } else if (!computed) {
              if (type == LAZY_FILTER_FLAG) {
                continue outer;
              } else {
                break outer;
              }
            }
          }
          result[resIndex++] = value;
        }
        return result;
      }
      LazyWrapper.prototype = baseCreate(baseLodash.prototype);
      LazyWrapper.prototype.constructor = LazyWrapper;
      function Hash(entries) {
        var index = -1,
          length = entries == null ? 0 : entries.length;
        this.clear();
        while (++index < length) {
          var entry = entries[index];
          this.set(entry[0], entry[1]);
        }
      }
      function hashClear() {
        this.__data__ = nativeCreate ? nativeCreate(null) : {};
        this.size = 0;
      }
      function hashDelete(key) {
        var result = this.has(key) && delete this.__data__[key];
        this.size -= result ? 1 : 0;
        return result;
      }
      function hashGet(key) {
        var data = this.__data__;
        if (nativeCreate) {
          var result = data[key];
          return result === HASH_UNDEFINED ? undefined$1 : result;
        }
        return hasOwnProperty.call(data, key) ? data[key] : undefined$1;
      }
      function hashHas(key) {
        var data = this.__data__;
        return nativeCreate ? data[key] !== undefined$1 : hasOwnProperty.call(data, key);
      }
      function hashSet(key, value) {
        var data = this.__data__;
        this.size += this.has(key) ? 0 : 1;
        data[key] = nativeCreate && value === undefined$1 ? HASH_UNDEFINED : value;
        return this;
      }
      Hash.prototype.clear = hashClear;
      Hash.prototype['delete'] = hashDelete;
      Hash.prototype.get = hashGet;
      Hash.prototype.has = hashHas;
      Hash.prototype.set = hashSet;
      function ListCache(entries) {
        var index = -1,
          length = entries == null ? 0 : entries.length;
        this.clear();
        while (++index < length) {
          var entry = entries[index];
          this.set(entry[0], entry[1]);
        }
      }
      function listCacheClear() {
        this.__data__ = [];
        this.size = 0;
      }
      function listCacheDelete(key) {
        var data = this.__data__,
          index = assocIndexOf(data, key);
        if (index < 0) {
          return false;
        }
        var lastIndex = data.length - 1;
        if (index == lastIndex) {
          data.pop();
        } else {
          splice.call(data, index, 1);
        }
        --this.size;
        return true;
      }
      function listCacheGet(key) {
        var data = this.__data__,
          index = assocIndexOf(data, key);
        return index < 0 ? undefined$1 : data[index][1];
      }
      function listCacheHas(key) {
        return assocIndexOf(this.__data__, key) > -1;
      }
      function listCacheSet(key, value) {
        var data = this.__data__,
          index = assocIndexOf(data, key);
        if (index < 0) {
          ++this.size;
          data.push([key, value]);
        } else {
          data[index][1] = value;
        }
        return this;
      }
      ListCache.prototype.clear = listCacheClear;
      ListCache.prototype['delete'] = listCacheDelete;
      ListCache.prototype.get = listCacheGet;
      ListCache.prototype.has = listCacheHas;
      ListCache.prototype.set = listCacheSet;
      function MapCache(entries) {
        var index = -1,
          length = entries == null ? 0 : entries.length;
        this.clear();
        while (++index < length) {
          var entry = entries[index];
          this.set(entry[0], entry[1]);
        }
      }
      function mapCacheClear() {
        this.size = 0;
        this.__data__ = {
          'hash': new Hash(),
          'map': new (Map || ListCache)(),
          'string': new Hash()
        };
      }
      function mapCacheDelete(key) {
        var result = getMapData(this, key)['delete'](key);
        this.size -= result ? 1 : 0;
        return result;
      }
      function mapCacheGet(key) {
        return getMapData(this, key).get(key);
      }
      function mapCacheHas(key) {
        return getMapData(this, key).has(key);
      }
      function mapCacheSet(key, value) {
        var data = getMapData(this, key),
          size = data.size;
        data.set(key, value);
        this.size += data.size == size ? 0 : 1;
        return this;
      }
      MapCache.prototype.clear = mapCacheClear;
      MapCache.prototype['delete'] = mapCacheDelete;
      MapCache.prototype.get = mapCacheGet;
      MapCache.prototype.has = mapCacheHas;
      MapCache.prototype.set = mapCacheSet;
      function SetCache(values) {
        var index = -1,
          length = values == null ? 0 : values.length;
        this.__data__ = new MapCache();
        while (++index < length) {
          this.add(values[index]);
        }
      }
      function setCacheAdd(value) {
        this.__data__.set(value, HASH_UNDEFINED);
        return this;
      }
      function setCacheHas(value) {
        return this.__data__.has(value);
      }
      SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
      SetCache.prototype.has = setCacheHas;
      function Stack(entries) {
        var data = this.__data__ = new ListCache(entries);
        this.size = data.size;
      }
      function stackClear() {
        this.__data__ = new ListCache();
        this.size = 0;
      }
      function stackDelete(key) {
        var data = this.__data__,
          result = data['delete'](key);
        this.size = data.size;
        return result;
      }
      function stackGet(key) {
        return this.__data__.get(key);
      }
      function stackHas(key) {
        return this.__data__.has(key);
      }
      function stackSet(key, value) {
        var data = this.__data__;
        if (data instanceof ListCache) {
          var pairs = data.__data__;
          if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([key, value]);
            this.size = ++data.size;
            return this;
          }
          data = this.__data__ = new MapCache(pairs);
        }
        data.set(key, value);
        this.size = data.size;
        return this;
      }
      Stack.prototype.clear = stackClear;
      Stack.prototype['delete'] = stackDelete;
      Stack.prototype.get = stackGet;
      Stack.prototype.has = stackHas;
      Stack.prototype.set = stackSet;
      function arrayLikeKeys(value, inherited) {
        var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;
        for (var key in value) {
          if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (key == 'length' || isBuff && (key == 'offset' || key == 'parent') || isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || isIndex(key, length)))) {
            result.push(key);
          }
        }
        return result;
      }
      function arraySample(array) {
        var length = array.length;
        return length ? array[baseRandom(0, length - 1)] : undefined$1;
      }
      function arraySampleSize(array, n) {
        return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
      }
      function arrayShuffle(array) {
        return shuffleSelf(copyArray(array));
      }
      function assignMergeValue(object, key, value) {
        if (value !== undefined$1 && !eq(object[key], value) || value === undefined$1 && !(key in object)) {
          baseAssignValue(object, key, value);
        }
      }
      function assignValue(object, key, value) {
        var objValue = object[key];
        if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined$1 && !(key in object)) {
          baseAssignValue(object, key, value);
        }
      }
      function assocIndexOf(array, key) {
        var length = array.length;
        while (length--) {
          if (eq(array[length][0], key)) {
            return length;
          }
        }
        return -1;
      }
      function baseAggregator(collection, setter, iteratee, accumulator) {
        baseEach(collection, function (value, key, collection) {
          setter(accumulator, value, iteratee(value), collection);
        });
        return accumulator;
      }
      function baseAssign(object, source) {
        return object && copyObject(source, keys(source), object);
      }
      function baseAssignIn(object, source) {
        return object && copyObject(source, keysIn(source), object);
      }
      function baseAssignValue(object, key, value) {
        if (key == '__proto__' && defineProperty) {
          defineProperty(object, key, {
            'configurable': true,
            'enumerable': true,
            'value': value,
            'writable': true
          });
        } else {
          object[key] = value;
        }
      }
      function baseAt(object, paths) {
        var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;
        while (++index < length) {
          result[index] = skip ? undefined$1 : get(object, paths[index]);
        }
        return result;
      }
      function baseClamp(number, lower, upper) {
        if (number === number) {
          if (upper !== undefined$1) {
            number = number <= upper ? number : upper;
          }
          if (lower !== undefined$1) {
            number = number >= lower ? number : lower;
          }
        }
        return number;
      }
      function baseClone(value, bitmask, customizer, key, object, stack) {
        var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;
        if (customizer) {
          result = object ? customizer(value, key, object, stack) : customizer(value);
        }
        if (result !== undefined$1) {
          return result;
        }
        if (!isObject(value)) {
          return value;
        }
        var isArr = isArray(value);
        if (isArr) {
          result = initCloneArray(value);
          if (!isDeep) {
            return copyArray(value, result);
          }
        } else {
          var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;
          if (isBuffer(value)) {
            return cloneBuffer(value, isDeep);
          }
          if (tag == objectTag || tag == argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : initCloneObject(value);
            if (!isDeep) {
              return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
            }
          } else {
            if (!cloneableTags[tag]) {
              return object ? value : {};
            }
            result = initCloneByTag(value, tag, isDeep);
          }
        }
        stack || (stack = new Stack());
        var stacked = stack.get(value);
        if (stacked) {
          return stacked;
        }
        stack.set(value, result);
        if (isSet(value)) {
          value.forEach(function (subValue) {
            result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
          });
        } else if (isMap(value)) {
          value.forEach(function (subValue, key) {
            result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
          });
        }
        var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
        var props = isArr ? undefined$1 : keysFunc(value);
        arrayEach(props || value, function (subValue, key) {
          if (props) {
            key = subValue;
            subValue = value[key];
          }
          assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
        return result;
      }
      function baseConforms(source) {
        var props = keys(source);
        return function (object) {
          return baseConformsTo(object, source, props);
        };
      }
      function baseConformsTo(object, source, props) {
        var length = props.length;
        if (object == null) {
          return !length;
        }
        object = Object(object);
        while (length--) {
          var key = props[length],
            predicate = source[key],
            value = object[key];
          if (value === undefined$1 && !(key in object) || !predicate(value)) {
            return false;
          }
        }
        return true;
      }
      function baseDelay(func, wait, args) {
        if (typeof func != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return setTimeout(function () {
          func.apply(undefined$1, args);
        }, wait);
      }
      function baseDifference(array, values, iteratee, comparator) {
        var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;
        if (!length) {
          return result;
        }
        if (iteratee) {
          values = arrayMap(values, baseUnary(iteratee));
        }
        if (comparator) {
          includes = arrayIncludesWith;
          isCommon = false;
        } else if (values.length >= LARGE_ARRAY_SIZE) {
          includes = cacheHas;
          isCommon = false;
          values = new SetCache(values);
        }
        outer: while (++index < length) {
          var value = array[index],
            computed = iteratee == null ? value : iteratee(value);
          value = comparator || value !== 0 ? value : 0;
          if (isCommon && computed === computed) {
            var valuesIndex = valuesLength;
            while (valuesIndex--) {
              if (values[valuesIndex] === computed) {
                continue outer;
              }
            }
            result.push(value);
          } else if (!includes(values, computed, comparator)) {
            result.push(value);
          }
        }
        return result;
      }
      var baseEach = createBaseEach(baseForOwn);
      var baseEachRight = createBaseEach(baseForOwnRight, true);
      function baseEvery(collection, predicate) {
        var result = true;
        baseEach(collection, function (value, index, collection) {
          result = !!predicate(value, index, collection);
          return result;
        });
        return result;
      }
      function baseExtremum(array, iteratee, comparator) {
        var index = -1,
          length = array.length;
        while (++index < length) {
          var value = array[index],
            current = iteratee(value);
          if (current != null && (computed === undefined$1 ? current === current && !isSymbol(current) : comparator(current, computed))) {
            var computed = current,
              result = value;
          }
        }
        return result;
      }
      function baseFill(array, value, start, end) {
        var length = array.length;
        start = toInteger(start);
        if (start < 0) {
          start = -start > length ? 0 : length + start;
        }
        end = end === undefined$1 || end > length ? length : toInteger(end);
        if (end < 0) {
          end += length;
        }
        end = start > end ? 0 : toLength(end);
        while (start < end) {
          array[start++] = value;
        }
        return array;
      }
      function baseFilter(collection, predicate) {
        var result = [];
        baseEach(collection, function (value, index, collection) {
          if (predicate(value, index, collection)) {
            result.push(value);
          }
        });
        return result;
      }
      function baseFlatten(array, depth, predicate, isStrict, result) {
        var index = -1,
          length = array.length;
        predicate || (predicate = isFlattenable);
        result || (result = []);
        while (++index < length) {
          var value = array[index];
          if (depth > 0 && predicate(value)) {
            if (depth > 1) {
              baseFlatten(value, depth - 1, predicate, isStrict, result);
            } else {
              arrayPush(result, value);
            }
          } else if (!isStrict) {
            result[result.length] = value;
          }
        }
        return result;
      }
      var baseFor = createBaseFor();
      var baseForRight = createBaseFor(true);
      function baseForOwn(object, iteratee) {
        return object && baseFor(object, iteratee, keys);
      }
      function baseForOwnRight(object, iteratee) {
        return object && baseForRight(object, iteratee, keys);
      }
      function baseFunctions(object, props) {
        return arrayFilter(props, function (key) {
          return isFunction(object[key]);
        });
      }
      function baseGet(object, path) {
        path = castPath(path, object);
        var index = 0,
          length = path.length;
        while (object != null && index < length) {
          object = object[toKey(path[index++])];
        }
        return index && index == length ? object : undefined$1;
      }
      function baseGetAllKeys(object, keysFunc, symbolsFunc) {
        var result = keysFunc(object);
        return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
      }
      function baseGetTag(value) {
        if (value == null) {
          return value === undefined$1 ? undefinedTag : nullTag;
        }
        return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
      }
      function baseGt(value, other) {
        return value > other;
      }
      function baseHas(object, key) {
        return object != null && hasOwnProperty.call(object, key);
      }
      function baseHasIn(object, key) {
        return object != null && key in Object(object);
      }
      function baseInRange(number, start, end) {
        return number >= nativeMin(start, end) && number < nativeMax(start, end);
      }
      function baseIntersection(arrays, iteratee, comparator) {
        var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];
        while (othIndex--) {
          var array = arrays[othIndex];
          if (othIndex && iteratee) {
            array = arrayMap(array, baseUnary(iteratee));
          }
          maxLength = nativeMin(array.length, maxLength);
          caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined$1;
        }
        array = arrays[0];
        var index = -1,
          seen = caches[0];
        outer: while (++index < length && result.length < maxLength) {
          var value = array[index],
            computed = iteratee ? iteratee(value) : value;
          value = comparator || value !== 0 ? value : 0;
          if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
            othIndex = othLength;
            while (--othIndex) {
              var cache = caches[othIndex];
              if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) {
                continue outer;
              }
            }
            if (seen) {
              seen.push(computed);
            }
            result.push(value);
          }
        }
        return result;
      }
      function baseInverter(object, setter, iteratee, accumulator) {
        baseForOwn(object, function (value, key, object) {
          setter(accumulator, iteratee(value), key, object);
        });
        return accumulator;
      }
      function baseInvoke(object, path, args) {
        path = castPath(path, object);
        object = parent(object, path);
        var func = object == null ? object : object[toKey(last(path))];
        return func == null ? undefined$1 : apply(func, object, args);
      }
      function baseIsArguments(value) {
        return isObjectLike(value) && baseGetTag(value) == argsTag;
      }
      function baseIsArrayBuffer(value) {
        return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
      }
      function baseIsDate(value) {
        return isObjectLike(value) && baseGetTag(value) == dateTag;
      }
      function baseIsEqual(value, other, bitmask, customizer, stack) {
        if (value === other) {
          return true;
        }
        if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
          return value !== value && other !== other;
        }
        return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
      }
      function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
        var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);
        objTag = objTag == argsTag ? objectTag : objTag;
        othTag = othTag == argsTag ? objectTag : othTag;
        var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;
        if (isSameTag && isBuffer(object)) {
          if (!isBuffer(other)) {
            return false;
          }
          objIsArr = true;
          objIsObj = false;
        }
        if (isSameTag && !objIsObj) {
          stack || (stack = new Stack());
          return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
        }
        if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
          var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
          if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack());
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
          }
        }
        if (!isSameTag) {
          return false;
        }
        stack || (stack = new Stack());
        return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
      }
      function baseIsMap(value) {
        return isObjectLike(value) && getTag(value) == mapTag;
      }
      function baseIsMatch(object, source, matchData, customizer) {
        var index = matchData.length,
          length = index,
          noCustomizer = !customizer;
        if (object == null) {
          return !length;
        }
        object = Object(object);
        while (index--) {
          var data = matchData[index];
          if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
            return false;
          }
        }
        while (++index < length) {
          data = matchData[index];
          var key = data[0],
            objValue = object[key],
            srcValue = data[1];
          if (noCustomizer && data[2]) {
            if (objValue === undefined$1 && !(key in object)) {
              return false;
            }
          } else {
            var stack = new Stack();
            if (customizer) {
              var result = customizer(objValue, srcValue, key, object, source, stack);
            }
            if (!(result === undefined$1 ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) {
              return false;
            }
          }
        }
        return true;
      }
      function baseIsNative(value) {
        if (!isObject(value) || isMasked(value)) {
          return false;
        }
        var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
        return pattern.test(toSource(value));
      }
      function baseIsRegExp(value) {
        return isObjectLike(value) && baseGetTag(value) == regexpTag;
      }
      function baseIsSet(value) {
        return isObjectLike(value) && getTag(value) == setTag;
      }
      function baseIsTypedArray(value) {
        return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
      }
      function baseIteratee(value) {
        if (typeof value == 'function') {
          return value;
        }
        if (value == null) {
          return identity;
        }
        if (typeof value == 'object') {
          return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
        }
        return property(value);
      }
      function baseKeys(object) {
        if (!isPrototype(object)) {
          return nativeKeys(object);
        }
        var result = [];
        for (var key in Object(object)) {
          if (hasOwnProperty.call(object, key) && key != 'constructor') {
            result.push(key);
          }
        }
        return result;
      }
      function baseKeysIn(object) {
        if (!isObject(object)) {
          return nativeKeysIn(object);
        }
        var isProto = isPrototype(object),
          result = [];
        for (var key in object) {
          if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
            result.push(key);
          }
        }
        return result;
      }
      function baseLt(value, other) {
        return value < other;
      }
      function baseMap(collection, iteratee) {
        var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];
        baseEach(collection, function (value, key, collection) {
          result[++index] = iteratee(value, key, collection);
        });
        return result;
      }
      function baseMatches(source) {
        var matchData = getMatchData(source);
        if (matchData.length == 1 && matchData[0][2]) {
          return matchesStrictComparable(matchData[0][0], matchData[0][1]);
        }
        return function (object) {
          return object === source || baseIsMatch(object, source, matchData);
        };
      }
      function baseMatchesProperty(path, srcValue) {
        if (isKey(path) && isStrictComparable(srcValue)) {
          return matchesStrictComparable(toKey(path), srcValue);
        }
        return function (object) {
          var objValue = get(object, path);
          return objValue === undefined$1 && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
        };
      }
      function baseMerge(object, source, srcIndex, customizer, stack) {
        if (object === source) {
          return;
        }
        baseFor(source, function (srcValue, key) {
          stack || (stack = new Stack());
          if (isObject(srcValue)) {
            baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
          } else {
            var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined$1;
            if (newValue === undefined$1) {
              newValue = srcValue;
            }
            assignMergeValue(object, key, newValue);
          }
        }, keysIn);
      }
      function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
        var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);
        if (stacked) {
          assignMergeValue(object, key, stacked);
          return;
        }
        var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined$1;
        var isCommon = newValue === undefined$1;
        if (isCommon) {
          var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);
          newValue = srcValue;
          if (isArr || isBuff || isTyped) {
            if (isArray(objValue)) {
              newValue = objValue;
            } else if (isArrayLikeObject(objValue)) {
              newValue = copyArray(objValue);
            } else if (isBuff) {
              isCommon = false;
              newValue = cloneBuffer(srcValue, true);
            } else if (isTyped) {
              isCommon = false;
              newValue = cloneTypedArray(srcValue, true);
            } else {
              newValue = [];
            }
          } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
            newValue = objValue;
            if (isArguments(objValue)) {
              newValue = toPlainObject(objValue);
            } else if (!isObject(objValue) || isFunction(objValue)) {
              newValue = initCloneObject(srcValue);
            }
          } else {
            isCommon = false;
          }
        }
        if (isCommon) {
          stack.set(srcValue, newValue);
          mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
          stack['delete'](srcValue);
        }
        assignMergeValue(object, key, newValue);
      }
      function baseNth(array, n) {
        var length = array.length;
        if (!length) {
          return;
        }
        n += n < 0 ? length : 0;
        return isIndex(n, length) ? array[n] : undefined$1;
      }
      function baseOrderBy(collection, iteratees, orders) {
        if (iteratees.length) {
          iteratees = arrayMap(iteratees, function (iteratee) {
            if (isArray(iteratee)) {
              return function (value) {
                return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
              };
            }
            return iteratee;
          });
        } else {
          iteratees = [identity];
        }
        var index = -1;
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        var result = baseMap(collection, function (value, key, collection) {
          var criteria = arrayMap(iteratees, function (iteratee) {
            return iteratee(value);
          });
          return {
            'criteria': criteria,
            'index': ++index,
            'value': value
          };
        });
        return baseSortBy(result, function (object, other) {
          return compareMultiple(object, other, orders);
        });
      }
      function basePick(object, paths) {
        return basePickBy(object, paths, function (value, path) {
          return hasIn(object, path);
        });
      }
      function basePickBy(object, paths, predicate) {
        var index = -1,
          length = paths.length,
          result = {};
        while (++index < length) {
          var path = paths[index],
            value = baseGet(object, path);
          if (predicate(value, path)) {
            baseSet(result, castPath(path, object), value);
          }
        }
        return result;
      }
      function basePropertyDeep(path) {
        return function (object) {
          return baseGet(object, path);
        };
      }
      function basePullAll(array, values, iteratee, comparator) {
        var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;
        if (array === values) {
          values = copyArray(values);
        }
        if (iteratee) {
          seen = arrayMap(array, baseUnary(iteratee));
        }
        while (++index < length) {
          var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;
          while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
            if (seen !== array) {
              splice.call(seen, fromIndex, 1);
            }
            splice.call(array, fromIndex, 1);
          }
        }
        return array;
      }
      function basePullAt(array, indexes) {
        var length = array ? indexes.length : 0,
          lastIndex = length - 1;
        while (length--) {
          var index = indexes[length];
          if (length == lastIndex || index !== previous) {
            var previous = index;
            if (isIndex(index)) {
              splice.call(array, index, 1);
            } else {
              baseUnset(array, index);
            }
          }
        }
        return array;
      }
      function baseRandom(lower, upper) {
        return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
      }
      function baseRange(start, end, step, fromRight) {
        var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);
        while (length--) {
          result[fromRight ? length : ++index] = start;
          start += step;
        }
        return result;
      }
      function baseRepeat(string, n) {
        var result = '';
        if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
          return result;
        }
        do {
          if (n % 2) {
            result += string;
          }
          n = nativeFloor(n / 2);
          if (n) {
            string += string;
          }
        } while (n);
        return result;
      }
      function baseRest(func, start) {
        return setToString(overRest(func, start, identity), func + '');
      }
      function baseSample(collection) {
        return arraySample(values(collection));
      }
      function baseSampleSize(collection, n) {
        var array = values(collection);
        return shuffleSelf(array, baseClamp(n, 0, array.length));
      }
      function baseSet(object, path, value, customizer) {
        if (!isObject(object)) {
          return object;
        }
        path = castPath(path, object);
        var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;
        while (nested != null && ++index < length) {
          var key = toKey(path[index]),
            newValue = value;
          if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
            return object;
          }
          if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined$1;
            if (newValue === undefined$1) {
              newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
            }
          }
          assignValue(nested, key, newValue);
          nested = nested[key];
        }
        return object;
      }
      var baseSetData = !metaMap ? identity : function (func, data) {
        metaMap.set(func, data);
        return func;
      };
      var baseSetToString = !defineProperty ? identity : function (func, string) {
        return defineProperty(func, 'toString', {
          'configurable': true,
          'enumerable': false,
          'value': constant(string),
          'writable': true
        });
      };
      function baseShuffle(collection) {
        return shuffleSelf(values(collection));
      }
      function baseSlice(array, start, end) {
        var index = -1,
          length = array.length;
        if (start < 0) {
          start = -start > length ? 0 : length + start;
        }
        end = end > length ? length : end;
        if (end < 0) {
          end += length;
        }
        length = start > end ? 0 : end - start >>> 0;
        start >>>= 0;
        var result = Array(length);
        while (++index < length) {
          result[index] = array[index + start];
        }
        return result;
      }
      function baseSome(collection, predicate) {
        var result;
        baseEach(collection, function (value, index, collection) {
          result = predicate(value, index, collection);
          return !result;
        });
        return !!result;
      }
      function baseSortedIndex(array, value, retHighest) {
        var low = 0,
          high = array == null ? low : array.length;
        if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
          while (low < high) {
            var mid = low + high >>> 1,
              computed = array[mid];
            if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) {
              low = mid + 1;
            } else {
              high = mid;
            }
          }
          return high;
        }
        return baseSortedIndexBy(array, value, identity, retHighest);
      }
      function baseSortedIndexBy(array, value, iteratee, retHighest) {
        var low = 0,
          high = array == null ? 0 : array.length;
        if (high === 0) {
          return 0;
        }
        value = iteratee(value);
        var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined$1;
        while (low < high) {
          var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined$1,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);
          if (valIsNaN) {
            var setLow = retHighest || othIsReflexive;
          } else if (valIsUndefined) {
            setLow = othIsReflexive && (retHighest || othIsDefined);
          } else if (valIsNull) {
            setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
          } else if (valIsSymbol) {
            setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
          } else if (othIsNull || othIsSymbol) {
            setLow = false;
          } else {
            setLow = retHighest ? computed <= value : computed < value;
          }
          if (setLow) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return nativeMin(high, MAX_ARRAY_INDEX);
      }
      function baseSortedUniq(array, iteratee) {
        var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];
        while (++index < length) {
          var value = array[index],
            computed = iteratee ? iteratee(value) : value;
          if (!index || !eq(computed, seen)) {
            var seen = computed;
            result[resIndex++] = value === 0 ? 0 : value;
          }
        }
        return result;
      }
      function baseToNumber(value) {
        if (typeof value == 'number') {
          return value;
        }
        if (isSymbol(value)) {
          return NAN;
        }
        return +value;
      }
      function baseToString(value) {
        if (typeof value == 'string') {
          return value;
        }
        if (isArray(value)) {
          return arrayMap(value, baseToString) + '';
        }
        if (isSymbol(value)) {
          return symbolToString ? symbolToString.call(value) : '';
        }
        var result = value + '';
        return result == '0' && 1 / value == -INFINITY ? '-0' : result;
      }
      function baseUniq(array, iteratee, comparator) {
        var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;
        if (comparator) {
          isCommon = false;
          includes = arrayIncludesWith;
        } else if (length >= LARGE_ARRAY_SIZE) {
          var set = iteratee ? null : createSet(array);
          if (set) {
            return setToArray(set);
          }
          isCommon = false;
          includes = cacheHas;
          seen = new SetCache();
        } else {
          seen = iteratee ? [] : result;
        }
        outer: while (++index < length) {
          var value = array[index],
            computed = iteratee ? iteratee(value) : value;
          value = comparator || value !== 0 ? value : 0;
          if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while (seenIndex--) {
              if (seen[seenIndex] === computed) {
                continue outer;
              }
            }
            if (iteratee) {
              seen.push(computed);
            }
            result.push(value);
          } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) {
              seen.push(computed);
            }
            result.push(value);
          }
        }
        return result;
      }
      function baseUnset(object, path) {
        path = castPath(path, object);
        object = parent(object, path);
        return object == null || delete object[toKey(last(path))];
      }
      function baseUpdate(object, path, updater, customizer) {
        return baseSet(object, path, updater(baseGet(object, path)), customizer);
      }
      function baseWhile(array, predicate, isDrop, fromRight) {
        var length = array.length,
          index = fromRight ? length : -1;
        while ((fromRight ? index-- : ++index < length) && predicate(array[index], index, array)) {}
        return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
      }
      function baseWrapperValue(value, actions) {
        var result = value;
        if (result instanceof LazyWrapper) {
          result = result.value();
        }
        return arrayReduce(actions, function (result, action) {
          return action.func.apply(action.thisArg, arrayPush([result], action.args));
        }, result);
      }
      function baseXor(arrays, iteratee, comparator) {
        var length = arrays.length;
        if (length < 2) {
          return length ? baseUniq(arrays[0]) : [];
        }
        var index = -1,
          result = Array(length);
        while (++index < length) {
          var array = arrays[index],
            othIndex = -1;
          while (++othIndex < length) {
            if (othIndex != index) {
              result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
          }
        }
        return baseUniq(baseFlatten(result, 1), iteratee, comparator);
      }
      function baseZipObject(props, values, assignFunc) {
        var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};
        while (++index < length) {
          var value = index < valsLength ? values[index] : undefined$1;
          assignFunc(result, props[index], value);
        }
        return result;
      }
      function castArrayLikeObject(value) {
        return isArrayLikeObject(value) ? value : [];
      }
      function castFunction(value) {
        return typeof value == 'function' ? value : identity;
      }
      function castPath(value, object) {
        if (isArray(value)) {
          return value;
        }
        return isKey(value, object) ? [value] : stringToPath(toString(value));
      }
      var castRest = baseRest;
      function castSlice(array, start, end) {
        var length = array.length;
        end = end === undefined$1 ? length : end;
        return !start && end >= length ? array : baseSlice(array, start, end);
      }
      var clearTimeout = ctxClearTimeout || function (id) {
        return root.clearTimeout(id);
      };
      function cloneBuffer(buffer, isDeep) {
        if (isDeep) {
          return buffer.slice();
        }
        var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
        buffer.copy(result);
        return result;
      }
      function cloneArrayBuffer(arrayBuffer) {
        var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
        new Uint8Array(result).set(new Uint8Array(arrayBuffer));
        return result;
      }
      function cloneDataView(dataView, isDeep) {
        var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
        return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
      }
      function cloneRegExp(regexp) {
        var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
        result.lastIndex = regexp.lastIndex;
        return result;
      }
      function cloneSymbol(symbol) {
        return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
      }
      function cloneTypedArray(typedArray, isDeep) {
        var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
        return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
      }
      function compareAscending(value, other) {
        if (value !== other) {
          var valIsDefined = value !== undefined$1,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);
          var othIsDefined = other !== undefined$1,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);
          if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) {
            return 1;
          }
          if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) {
            return -1;
          }
        }
        return 0;
      }
      function compareMultiple(object, other, orders) {
        var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;
        while (++index < length) {
          var result = compareAscending(objCriteria[index], othCriteria[index]);
          if (result) {
            if (index >= ordersLength) {
              return result;
            }
            var order = orders[index];
            return result * (order == 'desc' ? -1 : 1);
          }
        }
        return object.index - other.index;
      }
      function composeArgs(args, partials, holders, isCurried) {
        var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;
        while (++leftIndex < leftLength) {
          result[leftIndex] = partials[leftIndex];
        }
        while (++argsIndex < holdersLength) {
          if (isUncurried || argsIndex < argsLength) {
            result[holders[argsIndex]] = args[argsIndex];
          }
        }
        while (rangeLength--) {
          result[leftIndex++] = args[argsIndex++];
        }
        return result;
      }
      function composeArgsRight(args, partials, holders, isCurried) {
        var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;
        while (++argsIndex < rangeLength) {
          result[argsIndex] = args[argsIndex];
        }
        var offset = argsIndex;
        while (++rightIndex < rightLength) {
          result[offset + rightIndex] = partials[rightIndex];
        }
        while (++holdersIndex < holdersLength) {
          if (isUncurried || argsIndex < argsLength) {
            result[offset + holders[holdersIndex]] = args[argsIndex++];
          }
        }
        return result;
      }
      function copyArray(source, array) {
        var index = -1,
          length = source.length;
        array || (array = Array(length));
        while (++index < length) {
          array[index] = source[index];
        }
        return array;
      }
      function copyObject(source, props, object, customizer) {
        var isNew = !object;
        object || (object = {});
        var index = -1,
          length = props.length;
        while (++index < length) {
          var key = props[index];
          var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined$1;
          if (newValue === undefined$1) {
            newValue = source[key];
          }
          if (isNew) {
            baseAssignValue(object, key, newValue);
          } else {
            assignValue(object, key, newValue);
          }
        }
        return object;
      }
      function copySymbols(source, object) {
        return copyObject(source, getSymbols(source), object);
      }
      function copySymbolsIn(source, object) {
        return copyObject(source, getSymbolsIn(source), object);
      }
      function createAggregator(setter, initializer) {
        return function (collection, iteratee) {
          var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};
          return func(collection, setter, getIteratee(iteratee, 2), accumulator);
        };
      }
      function createAssigner(assigner) {
        return baseRest(function (object, sources) {
          var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined$1,
            guard = length > 2 ? sources[2] : undefined$1;
          customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined$1;
          if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined$1 : customizer;
            length = 1;
          }
          object = Object(object);
          while (++index < length) {
            var source = sources[index];
            if (source) {
              assigner(object, source, index, customizer);
            }
          }
          return object;
        });
      }
      function createBaseEach(eachFunc, fromRight) {
        return function (collection, iteratee) {
          if (collection == null) {
            return collection;
          }
          if (!isArrayLike(collection)) {
            return eachFunc(collection, iteratee);
          }
          var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);
          while (fromRight ? index-- : ++index < length) {
            if (iteratee(iterable[index], index, iterable) === false) {
              break;
            }
          }
          return collection;
        };
      }
      function createBaseFor(fromRight) {
        return function (object, iteratee, keysFunc) {
          var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;
          while (length--) {
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) {
              break;
            }
          }
          return object;
        };
      }
      function createBind(func, bitmask, thisArg) {
        var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);
        function wrapper() {
          var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
          return fn.apply(isBind ? thisArg : this, arguments);
        }
        return wrapper;
      }
      function createCaseFirst(methodName) {
        return function (string) {
          string = toString(string);
          var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined$1;
          var chr = strSymbols ? strSymbols[0] : string.charAt(0);
          var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
          return chr[methodName]() + trailing;
        };
      }
      function createCompounder(callback) {
        return function (string) {
          return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
        };
      }
      function createCtor(Ctor) {
        return function () {
          var args = arguments;
          switch (args.length) {
            case 0:
              return new Ctor();
            case 1:
              return new Ctor(args[0]);
            case 2:
              return new Ctor(args[0], args[1]);
            case 3:
              return new Ctor(args[0], args[1], args[2]);
            case 4:
              return new Ctor(args[0], args[1], args[2], args[3]);
            case 5:
              return new Ctor(args[0], args[1], args[2], args[3], args[4]);
            case 6:
              return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
            case 7:
              return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
          }
          var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);
          return isObject(result) ? result : thisBinding;
        };
      }
      function createCurry(func, bitmask, arity) {
        var Ctor = createCtor(func);
        function wrapper() {
          var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);
          while (index--) {
            args[index] = arguments[index];
          }
          var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
          length -= holders.length;
          if (length < arity) {
            return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined$1, args, holders, undefined$1, undefined$1, arity - length);
          }
          var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
          return apply(fn, this, args);
        }
        return wrapper;
      }
      function createFind(findIndexFunc) {
        return function (collection, predicate, fromIndex) {
          var iterable = Object(collection);
          if (!isArrayLike(collection)) {
            var iteratee = getIteratee(predicate, 3);
            collection = keys(collection);
            predicate = function (key) {
              return iteratee(iterable[key], key, iterable);
            };
          }
          var index = findIndexFunc(collection, predicate, fromIndex);
          return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined$1;
        };
      }
      function createFlow(fromRight) {
        return flatRest(function (funcs) {
          var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;
          if (fromRight) {
            funcs.reverse();
          }
          while (index--) {
            var func = funcs[index];
            if (typeof func != 'function') {
              throw new TypeError(FUNC_ERROR_TEXT);
            }
            if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
              var wrapper = new LodashWrapper([], true);
            }
          }
          index = wrapper ? index : length;
          while (++index < length) {
            func = funcs[index];
            var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined$1;
            if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) {
              wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
            } else {
              wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
            }
          }
          return function () {
            var args = arguments,
              value = args[0];
            if (wrapper && args.length == 1 && isArray(value)) {
              return wrapper.plant(value).value();
            }
            var index = 0,
              result = length ? funcs[index].apply(this, args) : value;
            while (++index < length) {
              result = funcs[index].call(this, result);
            }
            return result;
          };
        });
      }
      function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
        var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined$1 : createCtor(func);
        function wrapper() {
          var length = arguments.length,
            args = Array(length),
            index = length;
          while (index--) {
            args[index] = arguments[index];
          }
          if (isCurried) {
            var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
          }
          if (partials) {
            args = composeArgs(args, partials, holders, isCurried);
          }
          if (partialsRight) {
            args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
          }
          length -= holdersCount;
          if (isCurried && length < arity) {
            var newHolders = replaceHolders(args, placeholder);
            return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
          }
          var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;
          length = args.length;
          if (argPos) {
            args = reorder(args, argPos);
          } else if (isFlip && length > 1) {
            args.reverse();
          }
          if (isAry && ary < length) {
            args.length = ary;
          }
          if (this && this !== root && this instanceof wrapper) {
            fn = Ctor || createCtor(fn);
          }
          return fn.apply(thisBinding, args);
        }
        return wrapper;
      }
      function createInverter(setter, toIteratee) {
        return function (object, iteratee) {
          return baseInverter(object, setter, toIteratee(iteratee), {});
        };
      }
      function createMathOperation(operator, defaultValue) {
        return function (value, other) {
          var result;
          if (value === undefined$1 && other === undefined$1) {
            return defaultValue;
          }
          if (value !== undefined$1) {
            result = value;
          }
          if (other !== undefined$1) {
            if (result === undefined$1) {
              return other;
            }
            if (typeof value == 'string' || typeof other == 'string') {
              value = baseToString(value);
              other = baseToString(other);
            } else {
              value = baseToNumber(value);
              other = baseToNumber(other);
            }
            result = operator(value, other);
          }
          return result;
        };
      }
      function createOver(arrayFunc) {
        return flatRest(function (iteratees) {
          iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
          return baseRest(function (args) {
            var thisArg = this;
            return arrayFunc(iteratees, function (iteratee) {
              return apply(iteratee, thisArg, args);
            });
          });
        });
      }
      function createPadding(length, chars) {
        chars = chars === undefined$1 ? ' ' : baseToString(chars);
        var charsLength = chars.length;
        if (charsLength < 2) {
          return charsLength ? baseRepeat(chars, length) : chars;
        }
        var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
        return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
      }
      function createPartial(func, bitmask, thisArg, partials) {
        var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);
        function wrapper() {
          var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = this && this !== root && this instanceof wrapper ? Ctor : func;
          while (++leftIndex < leftLength) {
            args[leftIndex] = partials[leftIndex];
          }
          while (argsLength--) {
            args[leftIndex++] = arguments[++argsIndex];
          }
          return apply(fn, isBind ? thisArg : this, args);
        }
        return wrapper;
      }
      function createRange(fromRight) {
        return function (start, end, step) {
          if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
            end = step = undefined$1;
          }
          start = toFinite(start);
          if (end === undefined$1) {
            end = start;
            start = 0;
          } else {
            end = toFinite(end);
          }
          step = step === undefined$1 ? start < end ? 1 : -1 : toFinite(step);
          return baseRange(start, end, step, fromRight);
        };
      }
      function createRelationalOperation(operator) {
        return function (value, other) {
          if (!(typeof value == 'string' && typeof other == 'string')) {
            value = toNumber(value);
            other = toNumber(other);
          }
          return operator(value, other);
        };
      }
      function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
        var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined$1,
          newHoldersRight = isCurry ? undefined$1 : holders,
          newPartials = isCurry ? partials : undefined$1,
          newPartialsRight = isCurry ? undefined$1 : partials;
        bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
        bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
        if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
          bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
        }
        var newData = [func, bitmask, thisArg, newPartials, newHolders, newPartialsRight, newHoldersRight, argPos, ary, arity];
        var result = wrapFunc.apply(undefined$1, newData);
        if (isLaziable(func)) {
          setData(result, newData);
        }
        result.placeholder = placeholder;
        return setWrapToString(result, func, bitmask);
      }
      function createRound(methodName) {
        var func = Math[methodName];
        return function (number, precision) {
          number = toNumber(number);
          precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
          if (precision && nativeIsFinite(number)) {
            var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));
            pair = (toString(value) + 'e').split('e');
            return +(pair[0] + 'e' + (+pair[1] - precision));
          }
          return func(number);
        };
      }
      var createSet = !(Set && 1 / setToArray(new Set([, -0]))[1] == INFINITY) ? noop : function (values) {
        return new Set(values);
      };
      function createToPairs(keysFunc) {
        return function (object) {
          var tag = getTag(object);
          if (tag == mapTag) {
            return mapToArray(object);
          }
          if (tag == setTag) {
            return setToPairs(object);
          }
          return baseToPairs(object, keysFunc(object));
        };
      }
      function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
        var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
        if (!isBindKey && typeof func != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        var length = partials ? partials.length : 0;
        if (!length) {
          bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
          partials = holders = undefined$1;
        }
        ary = ary === undefined$1 ? ary : nativeMax(toInteger(ary), 0);
        arity = arity === undefined$1 ? arity : toInteger(arity);
        length -= holders ? holders.length : 0;
        if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
          var partialsRight = partials,
            holdersRight = holders;
          partials = holders = undefined$1;
        }
        var data = isBindKey ? undefined$1 : getData(func);
        var newData = [func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity];
        if (data) {
          mergeData(newData, data);
        }
        func = newData[0];
        bitmask = newData[1];
        thisArg = newData[2];
        partials = newData[3];
        holders = newData[4];
        arity = newData[9] = newData[9] === undefined$1 ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
        if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
          bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
        }
        if (!bitmask || bitmask == WRAP_BIND_FLAG) {
          var result = createBind(func, bitmask, thisArg);
        } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
          result = createCurry(func, bitmask, arity);
        } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
          result = createPartial(func, bitmask, thisArg, partials);
        } else {
          result = createHybrid.apply(undefined$1, newData);
        }
        var setter = data ? baseSetData : setData;
        return setWrapToString(setter(result, newData), func, bitmask);
      }
      function customDefaultsAssignIn(objValue, srcValue, key, object) {
        if (objValue === undefined$1 || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) {
          return srcValue;
        }
        return objValue;
      }
      function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
        if (isObject(objValue) && isObject(srcValue)) {
          stack.set(srcValue, objValue);
          baseMerge(objValue, srcValue, undefined$1, customDefaultsMerge, stack);
          stack['delete'](srcValue);
        }
        return objValue;
      }
      function customOmitClone(value) {
        return isPlainObject(value) ? undefined$1 : value;
      }
      function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
        var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;
        if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
          return false;
        }
        var arrStacked = stack.get(array);
        var othStacked = stack.get(other);
        if (arrStacked && othStacked) {
          return arrStacked == other && othStacked == array;
        }
        var index = -1,
          result = true,
          seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : undefined$1;
        stack.set(array, other);
        stack.set(other, array);
        while (++index < arrLength) {
          var arrValue = array[index],
            othValue = other[index];
          if (customizer) {
            var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
          }
          if (compared !== undefined$1) {
            if (compared) {
              continue;
            }
            result = false;
            break;
          }
          if (seen) {
            if (!arraySome(other, function (othValue, othIndex) {
              if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                return seen.push(othIndex);
              }
            })) {
              result = false;
              break;
            }
          } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
          }
        }
        stack['delete'](array);
        stack['delete'](other);
        return result;
      }
      function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
        switch (tag) {
          case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
              return false;
            }
            object = object.buffer;
            other = other.buffer;
          case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
              return false;
            }
            return true;
          case boolTag:
          case dateTag:
          case numberTag:
            return eq(+object, +other);
          case errorTag:
            return object.name == other.name && object.message == other.message;
          case regexpTag:
          case stringTag:
            return object == other + '';
          case mapTag:
            var convert = mapToArray;
          case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) {
              return false;
            }
            var stacked = stack.get(object);
            if (stacked) {
              return stacked == other;
            }
            bitmask |= COMPARE_UNORDERED_FLAG;
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
          case symbolTag:
            if (symbolValueOf) {
              return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
        }
        return false;
      }
      function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
        var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;
        if (objLength != othLength && !isPartial) {
          return false;
        }
        var index = objLength;
        while (index--) {
          var key = objProps[index];
          if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
            return false;
          }
        }
        var objStacked = stack.get(object);
        var othStacked = stack.get(other);
        if (objStacked && othStacked) {
          return objStacked == other && othStacked == object;
        }
        var result = true;
        stack.set(object, other);
        stack.set(other, object);
        var skipCtor = isPartial;
        while (++index < objLength) {
          key = objProps[index];
          var objValue = object[key],
            othValue = other[key];
          if (customizer) {
            var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
          }
          if (!(compared === undefined$1 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
          }
          skipCtor || (skipCtor = key == 'constructor');
        }
        if (result && !skipCtor) {
          var objCtor = object.constructor,
            othCtor = other.constructor;
          if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) {
            result = false;
          }
        }
        stack['delete'](object);
        stack['delete'](other);
        return result;
      }
      function flatRest(func) {
        return setToString(overRest(func, undefined$1, flatten), func + '');
      }
      function getAllKeys(object) {
        return baseGetAllKeys(object, keys, getSymbols);
      }
      function getAllKeysIn(object) {
        return baseGetAllKeys(object, keysIn, getSymbolsIn);
      }
      var getData = !metaMap ? noop : function (func) {
        return metaMap.get(func);
      };
      function getFuncName(func) {
        var result = func.name + '',
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
        while (length--) {
          var data = array[length],
            otherFunc = data.func;
          if (otherFunc == null || otherFunc == func) {
            return data.name;
          }
        }
        return result;
      }
      function getHolder(func) {
        var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
        return object.placeholder;
      }
      function getIteratee() {
        var result = lodash.iteratee || iteratee;
        result = result === iteratee ? baseIteratee : result;
        return arguments.length ? result(arguments[0], arguments[1]) : result;
      }
      function getMapData(map, key) {
        var data = map.__data__;
        return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
      }
      function getMatchData(object) {
        var result = keys(object),
          length = result.length;
        while (length--) {
          var key = result[length],
            value = object[key];
          result[length] = [key, value, isStrictComparable(value)];
        }
        return result;
      }
      function getNative(object, key) {
        var value = getValue(object, key);
        return baseIsNative(value) ? value : undefined$1;
      }
      function getRawTag(value) {
        var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];
        try {
          value[symToStringTag] = undefined$1;
          var unmasked = true;
        } catch (e) {}
        var result = nativeObjectToString.call(value);
        if (unmasked) {
          if (isOwn) {
            value[symToStringTag] = tag;
          } else {
            delete value[symToStringTag];
          }
        }
        return result;
      }
      var getSymbols = !nativeGetSymbols ? stubArray : function (object) {
        if (object == null) {
          return [];
        }
        object = Object(object);
        return arrayFilter(nativeGetSymbols(object), function (symbol) {
          return propertyIsEnumerable.call(object, symbol);
        });
      };
      var getSymbolsIn = !nativeGetSymbols ? stubArray : function (object) {
        var result = [];
        while (object) {
          arrayPush(result, getSymbols(object));
          object = getPrototype(object);
        }
        return result;
      };
      var getTag = baseGetTag;
      if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map()) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set()) != setTag || WeakMap && getTag(new WeakMap()) != weakMapTag) {
        getTag = function (value) {
          var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined$1,
            ctorString = Ctor ? toSource(Ctor) : '';
          if (ctorString) {
            switch (ctorString) {
              case dataViewCtorString:
                return dataViewTag;
              case mapCtorString:
                return mapTag;
              case promiseCtorString:
                return promiseTag;
              case setCtorString:
                return setTag;
              case weakMapCtorString:
                return weakMapTag;
            }
          }
          return result;
        };
      }
      function getView(start, end, transforms) {
        var index = -1,
          length = transforms.length;
        while (++index < length) {
          var data = transforms[index],
            size = data.size;
          switch (data.type) {
            case 'drop':
              start += size;
              break;
            case 'dropRight':
              end -= size;
              break;
            case 'take':
              end = nativeMin(end, start + size);
              break;
            case 'takeRight':
              start = nativeMax(start, end - size);
              break;
          }
        }
        return {
          'start': start,
          'end': end
        };
      }
      function getWrapDetails(source) {
        var match = source.match(reWrapDetails);
        return match ? match[1].split(reSplitDetails) : [];
      }
      function hasPath(object, path, hasFunc) {
        path = castPath(path, object);
        var index = -1,
          length = path.length,
          result = false;
        while (++index < length) {
          var key = toKey(path[index]);
          if (!(result = object != null && hasFunc(object, key))) {
            break;
          }
          object = object[key];
        }
        if (result || ++index != length) {
          return result;
        }
        length = object == null ? 0 : object.length;
        return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
      }
      function initCloneArray(array) {
        var length = array.length,
          result = new array.constructor(length);
        if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
          result.index = array.index;
          result.input = array.input;
        }
        return result;
      }
      function initCloneObject(object) {
        return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
      }
      function initCloneByTag(object, tag, isDeep) {
        var Ctor = object.constructor;
        switch (tag) {
          case arrayBufferTag:
            return cloneArrayBuffer(object);
          case boolTag:
          case dateTag:
            return new Ctor(+object);
          case dataViewTag:
            return cloneDataView(object, isDeep);
          case float32Tag:
          case float64Tag:
          case int8Tag:
          case int16Tag:
          case int32Tag:
          case uint8Tag:
          case uint8ClampedTag:
          case uint16Tag:
          case uint32Tag:
            return cloneTypedArray(object, isDeep);
          case mapTag:
            return new Ctor();
          case numberTag:
          case stringTag:
            return new Ctor(object);
          case regexpTag:
            return cloneRegExp(object);
          case setTag:
            return new Ctor();
          case symbolTag:
            return cloneSymbol(object);
        }
      }
      function insertWrapDetails(source, details) {
        var length = details.length;
        if (!length) {
          return source;
        }
        var lastIndex = length - 1;
        details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
        details = details.join(length > 2 ? ', ' : ' ');
        return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
      }
      function isFlattenable(value) {
        return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
      }
      function isIndex(value, length) {
        var type = typeof value;
        length = length == null ? MAX_SAFE_INTEGER : length;
        return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
      }
      function isIterateeCall(value, index, object) {
        if (!isObject(object)) {
          return false;
        }
        var type = typeof index;
        if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) {
          return eq(object[index], value);
        }
        return false;
      }
      function isKey(value, object) {
        if (isArray(value)) {
          return false;
        }
        var type = typeof value;
        if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) {
          return true;
        }
        return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
      }
      function isKeyable(value) {
        var type = typeof value;
        return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
      }
      function isLaziable(func) {
        var funcName = getFuncName(func),
          other = lodash[funcName];
        if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
          return false;
        }
        if (func === other) {
          return true;
        }
        var data = getData(other);
        return !!data && func === data[0];
      }
      function isMasked(func) {
        return !!maskSrcKey && maskSrcKey in func;
      }
      var isMaskable = coreJsData ? isFunction : stubFalse;
      function isPrototype(value) {
        var Ctor = value && value.constructor,
          proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
        return value === proto;
      }
      function isStrictComparable(value) {
        return value === value && !isObject(value);
      }
      function matchesStrictComparable(key, srcValue) {
        return function (object) {
          if (object == null) {
            return false;
          }
          return object[key] === srcValue && (srcValue !== undefined$1 || key in Object(object));
        };
      }
      function memoizeCapped(func) {
        var result = memoize(func, function (key) {
          if (cache.size === MAX_MEMOIZE_SIZE) {
            cache.clear();
          }
          return key;
        });
        var cache = result.cache;
        return result;
      }
      function mergeData(data, source) {
        var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
        var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
        if (!(isCommon || isCombo)) {
          return data;
        }
        if (srcBitmask & WRAP_BIND_FLAG) {
          data[2] = source[2];
          newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
        }
        var value = source[3];
        if (value) {
          var partials = data[3];
          data[3] = partials ? composeArgs(partials, value, source[4]) : value;
          data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
        }
        value = source[5];
        if (value) {
          partials = data[5];
          data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
          data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
        }
        value = source[7];
        if (value) {
          data[7] = value;
        }
        if (srcBitmask & WRAP_ARY_FLAG) {
          data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
        }
        if (data[9] == null) {
          data[9] = source[9];
        }
        data[0] = source[0];
        data[1] = newBitmask;
        return data;
      }
      function nativeKeysIn(object) {
        var result = [];
        if (object != null) {
          for (var key in Object(object)) {
            result.push(key);
          }
        }
        return result;
      }
      function objectToString(value) {
        return nativeObjectToString.call(value);
      }
      function overRest(func, start, transform) {
        start = nativeMax(start === undefined$1 ? func.length - 1 : start, 0);
        return function () {
          var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);
          while (++index < length) {
            array[index] = args[start + index];
          }
          index = -1;
          var otherArgs = Array(start + 1);
          while (++index < start) {
            otherArgs[index] = args[index];
          }
          otherArgs[start] = transform(array);
          return apply(func, this, otherArgs);
        };
      }
      function parent(object, path) {
        return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
      }
      function reorder(array, indexes) {
        var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);
        while (length--) {
          var index = indexes[length];
          array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined$1;
        }
        return array;
      }
      function safeGet(object, key) {
        if (key === 'constructor' && typeof object[key] === 'function') {
          return;
        }
        if (key == '__proto__') {
          return;
        }
        return object[key];
      }
      var setData = shortOut(baseSetData);
      var setTimeout = ctxSetTimeout || function (func, wait) {
        return root.setTimeout(func, wait);
      };
      var setToString = shortOut(baseSetToString);
      function setWrapToString(wrapper, reference, bitmask) {
        var source = reference + '';
        return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
      }
      function shortOut(func) {
        var count = 0,
          lastCalled = 0;
        return function () {
          var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);
          lastCalled = stamp;
          if (remaining > 0) {
            if (++count >= HOT_COUNT) {
              return arguments[0];
            }
          } else {
            count = 0;
          }
          return func.apply(undefined$1, arguments);
        };
      }
      function shuffleSelf(array, size) {
        var index = -1,
          length = array.length,
          lastIndex = length - 1;
        size = size === undefined$1 ? length : size;
        while (++index < size) {
          var rand = baseRandom(index, lastIndex),
            value = array[rand];
          array[rand] = array[index];
          array[index] = value;
        }
        array.length = size;
        return array;
      }
      var stringToPath = memoizeCapped(function (string) {
        var result = [];
        if (string.charCodeAt(0) === 46) {
          result.push('');
        }
        string.replace(rePropName, function (match, number, quote, subString) {
          result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
        });
        return result;
      });
      function toKey(value) {
        if (typeof value == 'string' || isSymbol(value)) {
          return value;
        }
        var result = value + '';
        return result == '0' && 1 / value == -INFINITY ? '-0' : result;
      }
      function toSource(func) {
        if (func != null) {
          try {
            return funcToString.call(func);
          } catch (e) {}
          try {
            return func + '';
          } catch (e) {}
        }
        return '';
      }
      function updateWrapDetails(details, bitmask) {
        arrayEach(wrapFlags, function (pair) {
          var value = '_.' + pair[0];
          if (bitmask & pair[1] && !arrayIncludes(details, value)) {
            details.push(value);
          }
        });
        return details.sort();
      }
      function wrapperClone(wrapper) {
        if (wrapper instanceof LazyWrapper) {
          return wrapper.clone();
        }
        var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
        result.__actions__ = copyArray(wrapper.__actions__);
        result.__index__ = wrapper.__index__;
        result.__values__ = wrapper.__values__;
        return result;
      }
      function chunk(array, size, guard) {
        if (guard ? isIterateeCall(array, size, guard) : size === undefined$1) {
          size = 1;
        } else {
          size = nativeMax(toInteger(size), 0);
        }
        var length = array == null ? 0 : array.length;
        if (!length || size < 1) {
          return [];
        }
        var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));
        while (index < length) {
          result[resIndex++] = baseSlice(array, index, index += size);
        }
        return result;
      }
      function compact(array) {
        var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];
        while (++index < length) {
          var value = array[index];
          if (value) {
            result[resIndex++] = value;
          }
        }
        return result;
      }
      function concat() {
        var length = arguments.length;
        if (!length) {
          return [];
        }
        var args = Array(length - 1),
          array = arguments[0],
          index = length;
        while (index--) {
          args[index - 1] = arguments[index];
        }
        return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
      }
      var difference = baseRest(function (array, values) {
        return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
      });
      var differenceBy = baseRest(function (array, values) {
        var iteratee = last(values);
        if (isArrayLikeObject(iteratee)) {
          iteratee = undefined$1;
        }
        return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
      });
      var differenceWith = baseRest(function (array, values) {
        var comparator = last(values);
        if (isArrayLikeObject(comparator)) {
          comparator = undefined$1;
        }
        return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined$1, comparator) : [];
      });
      function drop(array, n, guard) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        n = guard || n === undefined$1 ? 1 : toInteger(n);
        return baseSlice(array, n < 0 ? 0 : n, length);
      }
      function dropRight(array, n, guard) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        n = guard || n === undefined$1 ? 1 : toInteger(n);
        n = length - n;
        return baseSlice(array, 0, n < 0 ? 0 : n);
      }
      function dropRightWhile(array, predicate) {
        return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
      }
      function dropWhile(array, predicate) {
        return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
      }
      function fill(array, value, start, end) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
          start = 0;
          end = length;
        }
        return baseFill(array, value, start, end);
      }
      function findIndex(array, predicate, fromIndex) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return -1;
        }
        var index = fromIndex == null ? 0 : toInteger(fromIndex);
        if (index < 0) {
          index = nativeMax(length + index, 0);
        }
        return baseFindIndex(array, getIteratee(predicate, 3), index);
      }
      function findLastIndex(array, predicate, fromIndex) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return -1;
        }
        var index = length - 1;
        if (fromIndex !== undefined$1) {
          index = toInteger(fromIndex);
          index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
        }
        return baseFindIndex(array, getIteratee(predicate, 3), index, true);
      }
      function flatten(array) {
        var length = array == null ? 0 : array.length;
        return length ? baseFlatten(array, 1) : [];
      }
      function flattenDeep(array) {
        var length = array == null ? 0 : array.length;
        return length ? baseFlatten(array, INFINITY) : [];
      }
      function flattenDepth(array, depth) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        depth = depth === undefined$1 ? 1 : toInteger(depth);
        return baseFlatten(array, depth);
      }
      function fromPairs(pairs) {
        var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};
        while (++index < length) {
          var pair = pairs[index];
          result[pair[0]] = pair[1];
        }
        return result;
      }
      function head(array) {
        return array && array.length ? array[0] : undefined$1;
      }
      function indexOf(array, value, fromIndex) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return -1;
        }
        var index = fromIndex == null ? 0 : toInteger(fromIndex);
        if (index < 0) {
          index = nativeMax(length + index, 0);
        }
        return baseIndexOf(array, value, index);
      }
      function initial(array) {
        var length = array == null ? 0 : array.length;
        return length ? baseSlice(array, 0, -1) : [];
      }
      var intersection = baseRest(function (arrays) {
        var mapped = arrayMap(arrays, castArrayLikeObject);
        return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
      });
      var intersectionBy = baseRest(function (arrays) {
        var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);
        if (iteratee === last(mapped)) {
          iteratee = undefined$1;
        } else {
          mapped.pop();
        }
        return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
      });
      var intersectionWith = baseRest(function (arrays) {
        var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);
        comparator = typeof comparator == 'function' ? comparator : undefined$1;
        if (comparator) {
          mapped.pop();
        }
        return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined$1, comparator) : [];
      });
      function join(array, separator) {
        return array == null ? '' : nativeJoin.call(array, separator);
      }
      function last(array) {
        var length = array == null ? 0 : array.length;
        return length ? array[length - 1] : undefined$1;
      }
      function lastIndexOf(array, value, fromIndex) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return -1;
        }
        var index = length;
        if (fromIndex !== undefined$1) {
          index = toInteger(fromIndex);
          index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
        }
        return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
      }
      function nth(array, n) {
        return array && array.length ? baseNth(array, toInteger(n)) : undefined$1;
      }
      var pull = baseRest(pullAll);
      function pullAll(array, values) {
        return array && array.length && values && values.length ? basePullAll(array, values) : array;
      }
      function pullAllBy(array, values, iteratee) {
        return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
      }
      function pullAllWith(array, values, comparator) {
        return array && array.length && values && values.length ? basePullAll(array, values, undefined$1, comparator) : array;
      }
      var pullAt = flatRest(function (array, indexes) {
        var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);
        basePullAt(array, arrayMap(indexes, function (index) {
          return isIndex(index, length) ? +index : index;
        }).sort(compareAscending));
        return result;
      });
      function remove(array, predicate) {
        var result = [];
        if (!(array && array.length)) {
          return result;
        }
        var index = -1,
          indexes = [],
          length = array.length;
        predicate = getIteratee(predicate, 3);
        while (++index < length) {
          var value = array[index];
          if (predicate(value, index, array)) {
            result.push(value);
            indexes.push(index);
          }
        }
        basePullAt(array, indexes);
        return result;
      }
      function reverse(array) {
        return array == null ? array : nativeReverse.call(array);
      }
      function slice(array, start, end) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
          start = 0;
          end = length;
        } else {
          start = start == null ? 0 : toInteger(start);
          end = end === undefined$1 ? length : toInteger(end);
        }
        return baseSlice(array, start, end);
      }
      function sortedIndex(array, value) {
        return baseSortedIndex(array, value);
      }
      function sortedIndexBy(array, value, iteratee) {
        return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
      }
      function sortedIndexOf(array, value) {
        var length = array == null ? 0 : array.length;
        if (length) {
          var index = baseSortedIndex(array, value);
          if (index < length && eq(array[index], value)) {
            return index;
          }
        }
        return -1;
      }
      function sortedLastIndex(array, value) {
        return baseSortedIndex(array, value, true);
      }
      function sortedLastIndexBy(array, value, iteratee) {
        return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
      }
      function sortedLastIndexOf(array, value) {
        var length = array == null ? 0 : array.length;
        if (length) {
          var index = baseSortedIndex(array, value, true) - 1;
          if (eq(array[index], value)) {
            return index;
          }
        }
        return -1;
      }
      function sortedUniq(array) {
        return array && array.length ? baseSortedUniq(array) : [];
      }
      function sortedUniqBy(array, iteratee) {
        return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
      }
      function tail(array) {
        var length = array == null ? 0 : array.length;
        return length ? baseSlice(array, 1, length) : [];
      }
      function take(array, n, guard) {
        if (!(array && array.length)) {
          return [];
        }
        n = guard || n === undefined$1 ? 1 : toInteger(n);
        return baseSlice(array, 0, n < 0 ? 0 : n);
      }
      function takeRight(array, n, guard) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        n = guard || n === undefined$1 ? 1 : toInteger(n);
        n = length - n;
        return baseSlice(array, n < 0 ? 0 : n, length);
      }
      function takeRightWhile(array, predicate) {
        return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
      }
      function takeWhile(array, predicate) {
        return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
      }
      var union = baseRest(function (arrays) {
        return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
      });
      var unionBy = baseRest(function (arrays) {
        var iteratee = last(arrays);
        if (isArrayLikeObject(iteratee)) {
          iteratee = undefined$1;
        }
        return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
      });
      var unionWith = baseRest(function (arrays) {
        var comparator = last(arrays);
        comparator = typeof comparator == 'function' ? comparator : undefined$1;
        return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined$1, comparator);
      });
      function uniq(array) {
        return array && array.length ? baseUniq(array) : [];
      }
      function uniqBy(array, iteratee) {
        return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
      }
      function uniqWith(array, comparator) {
        comparator = typeof comparator == 'function' ? comparator : undefined$1;
        return array && array.length ? baseUniq(array, undefined$1, comparator) : [];
      }
      function unzip(array) {
        if (!(array && array.length)) {
          return [];
        }
        var length = 0;
        array = arrayFilter(array, function (group) {
          if (isArrayLikeObject(group)) {
            length = nativeMax(group.length, length);
            return true;
          }
        });
        return baseTimes(length, function (index) {
          return arrayMap(array, baseProperty(index));
        });
      }
      function unzipWith(array, iteratee) {
        if (!(array && array.length)) {
          return [];
        }
        var result = unzip(array);
        if (iteratee == null) {
          return result;
        }
        return arrayMap(result, function (group) {
          return apply(iteratee, undefined$1, group);
        });
      }
      var without = baseRest(function (array, values) {
        return isArrayLikeObject(array) ? baseDifference(array, values) : [];
      });
      var xor = baseRest(function (arrays) {
        return baseXor(arrayFilter(arrays, isArrayLikeObject));
      });
      var xorBy = baseRest(function (arrays) {
        var iteratee = last(arrays);
        if (isArrayLikeObject(iteratee)) {
          iteratee = undefined$1;
        }
        return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
      });
      var xorWith = baseRest(function (arrays) {
        var comparator = last(arrays);
        comparator = typeof comparator == 'function' ? comparator : undefined$1;
        return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined$1, comparator);
      });
      var zip = baseRest(unzip);
      function zipObject(props, values) {
        return baseZipObject(props || [], values || [], assignValue);
      }
      function zipObjectDeep(props, values) {
        return baseZipObject(props || [], values || [], baseSet);
      }
      var zipWith = baseRest(function (arrays) {
        var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined$1;
        iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined$1;
        return unzipWith(arrays, iteratee);
      });
      function chain(value) {
        var result = lodash(value);
        result.__chain__ = true;
        return result;
      }
      function tap(value, interceptor) {
        interceptor(value);
        return value;
      }
      function thru(value, interceptor) {
        return interceptor(value);
      }
      var wrapperAt = flatRest(function (paths) {
        var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function (object) {
            return baseAt(object, paths);
          };
        if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) {
          return this.thru(interceptor);
        }
        value = value.slice(start, +start + (length ? 1 : 0));
        value.__actions__.push({
          'func': thru,
          'args': [interceptor],
          'thisArg': undefined$1
        });
        return new LodashWrapper(value, this.__chain__).thru(function (array) {
          if (length && !array.length) {
            array.push(undefined$1);
          }
          return array;
        });
      });
      function wrapperChain() {
        return chain(this);
      }
      function wrapperCommit() {
        return new LodashWrapper(this.value(), this.__chain__);
      }
      function wrapperNext() {
        if (this.__values__ === undefined$1) {
          this.__values__ = toArray(this.value());
        }
        var done = this.__index__ >= this.__values__.length,
          value = done ? undefined$1 : this.__values__[this.__index__++];
        return {
          'done': done,
          'value': value
        };
      }
      function wrapperToIterator() {
        return this;
      }
      function wrapperPlant(value) {
        var result,
          parent = this;
        while (parent instanceof baseLodash) {
          var clone = wrapperClone(parent);
          clone.__index__ = 0;
          clone.__values__ = undefined$1;
          if (result) {
            previous.__wrapped__ = clone;
          } else {
            result = clone;
          }
          var previous = clone;
          parent = parent.__wrapped__;
        }
        previous.__wrapped__ = value;
        return result;
      }
      function wrapperReverse() {
        var value = this.__wrapped__;
        if (value instanceof LazyWrapper) {
          var wrapped = value;
          if (this.__actions__.length) {
            wrapped = new LazyWrapper(this);
          }
          wrapped = wrapped.reverse();
          wrapped.__actions__.push({
            'func': thru,
            'args': [reverse],
            'thisArg': undefined$1
          });
          return new LodashWrapper(wrapped, this.__chain__);
        }
        return this.thru(reverse);
      }
      function wrapperValue() {
        return baseWrapperValue(this.__wrapped__, this.__actions__);
      }
      var countBy = createAggregator(function (result, value, key) {
        if (hasOwnProperty.call(result, key)) {
          ++result[key];
        } else {
          baseAssignValue(result, key, 1);
        }
      });
      function every(collection, predicate, guard) {
        var func = isArray(collection) ? arrayEvery : baseEvery;
        if (guard && isIterateeCall(collection, predicate, guard)) {
          predicate = undefined$1;
        }
        return func(collection, getIteratee(predicate, 3));
      }
      function filter(collection, predicate) {
        var func = isArray(collection) ? arrayFilter : baseFilter;
        return func(collection, getIteratee(predicate, 3));
      }
      var find = createFind(findIndex);
      var findLast = createFind(findLastIndex);
      function flatMap(collection, iteratee) {
        return baseFlatten(map(collection, iteratee), 1);
      }
      function flatMapDeep(collection, iteratee) {
        return baseFlatten(map(collection, iteratee), INFINITY);
      }
      function flatMapDepth(collection, iteratee, depth) {
        depth = depth === undefined$1 ? 1 : toInteger(depth);
        return baseFlatten(map(collection, iteratee), depth);
      }
      function forEach(collection, iteratee) {
        var func = isArray(collection) ? arrayEach : baseEach;
        return func(collection, getIteratee(iteratee, 3));
      }
      function forEachRight(collection, iteratee) {
        var func = isArray(collection) ? arrayEachRight : baseEachRight;
        return func(collection, getIteratee(iteratee, 3));
      }
      var groupBy = createAggregator(function (result, value, key) {
        if (hasOwnProperty.call(result, key)) {
          result[key].push(value);
        } else {
          baseAssignValue(result, key, [value]);
        }
      });
      function includes(collection, value, fromIndex, guard) {
        collection = isArrayLike(collection) ? collection : values(collection);
        fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
        var length = collection.length;
        if (fromIndex < 0) {
          fromIndex = nativeMax(length + fromIndex, 0);
        }
        return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
      }
      var invokeMap = baseRest(function (collection, path, args) {
        var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];
        baseEach(collection, function (value) {
          result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
        });
        return result;
      });
      var keyBy = createAggregator(function (result, value, key) {
        baseAssignValue(result, key, value);
      });
      function map(collection, iteratee) {
        var func = isArray(collection) ? arrayMap : baseMap;
        return func(collection, getIteratee(iteratee, 3));
      }
      function orderBy(collection, iteratees, orders, guard) {
        if (collection == null) {
          return [];
        }
        if (!isArray(iteratees)) {
          iteratees = iteratees == null ? [] : [iteratees];
        }
        orders = guard ? undefined$1 : orders;
        if (!isArray(orders)) {
          orders = orders == null ? [] : [orders];
        }
        return baseOrderBy(collection, iteratees, orders);
      }
      var partition = createAggregator(function (result, value, key) {
        result[key ? 0 : 1].push(value);
      }, function () {
        return [[], []];
      });
      function reduce(collection, iteratee, accumulator) {
        var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;
        return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
      }
      function reduceRight(collection, iteratee, accumulator) {
        var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;
        return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
      }
      function reject(collection, predicate) {
        var func = isArray(collection) ? arrayFilter : baseFilter;
        return func(collection, negate(getIteratee(predicate, 3)));
      }
      function sample(collection) {
        var func = isArray(collection) ? arraySample : baseSample;
        return func(collection);
      }
      function sampleSize(collection, n, guard) {
        if (guard ? isIterateeCall(collection, n, guard) : n === undefined$1) {
          n = 1;
        } else {
          n = toInteger(n);
        }
        var func = isArray(collection) ? arraySampleSize : baseSampleSize;
        return func(collection, n);
      }
      function shuffle(collection) {
        var func = isArray(collection) ? arrayShuffle : baseShuffle;
        return func(collection);
      }
      function size(collection) {
        if (collection == null) {
          return 0;
        }
        if (isArrayLike(collection)) {
          return isString(collection) ? stringSize(collection) : collection.length;
        }
        var tag = getTag(collection);
        if (tag == mapTag || tag == setTag) {
          return collection.size;
        }
        return baseKeys(collection).length;
      }
      function some(collection, predicate, guard) {
        var func = isArray(collection) ? arraySome : baseSome;
        if (guard && isIterateeCall(collection, predicate, guard)) {
          predicate = undefined$1;
        }
        return func(collection, getIteratee(predicate, 3));
      }
      var sortBy = baseRest(function (collection, iteratees) {
        if (collection == null) {
          return [];
        }
        var length = iteratees.length;
        if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
          iteratees = [];
        } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
          iteratees = [iteratees[0]];
        }
        return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
      });
      var now = ctxNow || function () {
        return root.Date.now();
      };
      function after(n, func) {
        if (typeof func != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        n = toInteger(n);
        return function () {
          if (--n < 1) {
            return func.apply(this, arguments);
          }
        };
      }
      function ary(func, n, guard) {
        n = guard ? undefined$1 : n;
        n = func && n == null ? func.length : n;
        return createWrap(func, WRAP_ARY_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, n);
      }
      function before(n, func) {
        var result;
        if (typeof func != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        n = toInteger(n);
        return function () {
          if (--n > 0) {
            result = func.apply(this, arguments);
          }
          if (n <= 1) {
            func = undefined$1;
          }
          return result;
        };
      }
      var bind = baseRest(function (func, thisArg, partials) {
        var bitmask = WRAP_BIND_FLAG;
        if (partials.length) {
          var holders = replaceHolders(partials, getHolder(bind));
          bitmask |= WRAP_PARTIAL_FLAG;
        }
        return createWrap(func, bitmask, thisArg, partials, holders);
      });
      var bindKey = baseRest(function (object, key, partials) {
        var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
        if (partials.length) {
          var holders = replaceHolders(partials, getHolder(bindKey));
          bitmask |= WRAP_PARTIAL_FLAG;
        }
        return createWrap(key, bitmask, object, partials, holders);
      });
      function curry(func, arity, guard) {
        arity = guard ? undefined$1 : arity;
        var result = createWrap(func, WRAP_CURRY_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, undefined$1, arity);
        result.placeholder = curry.placeholder;
        return result;
      }
      function curryRight(func, arity, guard) {
        arity = guard ? undefined$1 : arity;
        var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, undefined$1, arity);
        result.placeholder = curryRight.placeholder;
        return result;
      }
      function debounce(func, wait, options) {
        var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;
        if (typeof func != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        wait = toNumber(wait) || 0;
        if (isObject(options)) {
          leading = !!options.leading;
          maxing = 'maxWait' in options;
          maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
          trailing = 'trailing' in options ? !!options.trailing : trailing;
        }
        function invokeFunc(time) {
          var args = lastArgs,
            thisArg = lastThis;
          lastArgs = lastThis = undefined$1;
          lastInvokeTime = time;
          result = func.apply(thisArg, args);
          return result;
        }
        function leadingEdge(time) {
          lastInvokeTime = time;
          timerId = setTimeout(timerExpired, wait);
          return leading ? invokeFunc(time) : result;
        }
        function remainingWait(time) {
          var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;
          return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
        }
        function shouldInvoke(time) {
          var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;
          return lastCallTime === undefined$1 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
        }
        function timerExpired() {
          var time = now();
          if (shouldInvoke(time)) {
            return trailingEdge(time);
          }
          timerId = setTimeout(timerExpired, remainingWait(time));
        }
        function trailingEdge(time) {
          timerId = undefined$1;
          if (trailing && lastArgs) {
            return invokeFunc(time);
          }
          lastArgs = lastThis = undefined$1;
          return result;
        }
        function cancel() {
          if (timerId !== undefined$1) {
            clearTimeout(timerId);
          }
          lastInvokeTime = 0;
          lastArgs = lastCallTime = lastThis = timerId = undefined$1;
        }
        function flush() {
          return timerId === undefined$1 ? result : trailingEdge(now());
        }
        function debounced() {
          var time = now(),
            isInvoking = shouldInvoke(time);
          lastArgs = arguments;
          lastThis = this;
          lastCallTime = time;
          if (isInvoking) {
            if (timerId === undefined$1) {
              return leadingEdge(lastCallTime);
            }
            if (maxing) {
              clearTimeout(timerId);
              timerId = setTimeout(timerExpired, wait);
              return invokeFunc(lastCallTime);
            }
          }
          if (timerId === undefined$1) {
            timerId = setTimeout(timerExpired, wait);
          }
          return result;
        }
        debounced.cancel = cancel;
        debounced.flush = flush;
        return debounced;
      }
      var defer = baseRest(function (func, args) {
        return baseDelay(func, 1, args);
      });
      var delay = baseRest(function (func, wait, args) {
        return baseDelay(func, toNumber(wait) || 0, args);
      });
      function flip(func) {
        return createWrap(func, WRAP_FLIP_FLAG);
      }
      function memoize(func, resolver) {
        if (typeof func != 'function' || resolver != null && typeof resolver != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        var memoized = function () {
          var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;
          if (cache.has(key)) {
            return cache.get(key);
          }
          var result = func.apply(this, args);
          memoized.cache = cache.set(key, result) || cache;
          return result;
        };
        memoized.cache = new (memoize.Cache || MapCache)();
        return memoized;
      }
      memoize.Cache = MapCache;
      function negate(predicate) {
        if (typeof predicate != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return function () {
          var args = arguments;
          switch (args.length) {
            case 0:
              return !predicate.call(this);
            case 1:
              return !predicate.call(this, args[0]);
            case 2:
              return !predicate.call(this, args[0], args[1]);
            case 3:
              return !predicate.call(this, args[0], args[1], args[2]);
          }
          return !predicate.apply(this, args);
        };
      }
      function once(func) {
        return before(2, func);
      }
      var overArgs = castRest(function (func, transforms) {
        transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
        var funcsLength = transforms.length;
        return baseRest(function (args) {
          var index = -1,
            length = nativeMin(args.length, funcsLength);
          while (++index < length) {
            args[index] = transforms[index].call(this, args[index]);
          }
          return apply(func, this, args);
        });
      });
      var partial = baseRest(function (func, partials) {
        var holders = replaceHolders(partials, getHolder(partial));
        return createWrap(func, WRAP_PARTIAL_FLAG, undefined$1, partials, holders);
      });
      var partialRight = baseRest(function (func, partials) {
        var holders = replaceHolders(partials, getHolder(partialRight));
        return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined$1, partials, holders);
      });
      var rearg = flatRest(function (func, indexes) {
        return createWrap(func, WRAP_REARG_FLAG, undefined$1, undefined$1, undefined$1, indexes);
      });
      function rest(func, start) {
        if (typeof func != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        start = start === undefined$1 ? start : toInteger(start);
        return baseRest(func, start);
      }
      function spread(func, start) {
        if (typeof func != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        start = start == null ? 0 : nativeMax(toInteger(start), 0);
        return baseRest(function (args) {
          var array = args[start],
            otherArgs = castSlice(args, 0, start);
          if (array) {
            arrayPush(otherArgs, array);
          }
          return apply(func, this, otherArgs);
        });
      }
      function throttle(func, wait, options) {
        var leading = true,
          trailing = true;
        if (typeof func != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        if (isObject(options)) {
          leading = 'leading' in options ? !!options.leading : leading;
          trailing = 'trailing' in options ? !!options.trailing : trailing;
        }
        return debounce(func, wait, {
          'leading': leading,
          'maxWait': wait,
          'trailing': trailing
        });
      }
      function unary(func) {
        return ary(func, 1);
      }
      function wrap(value, wrapper) {
        return partial(castFunction(wrapper), value);
      }
      function castArray() {
        if (!arguments.length) {
          return [];
        }
        var value = arguments[0];
        return isArray(value) ? value : [value];
      }
      function clone(value) {
        return baseClone(value, CLONE_SYMBOLS_FLAG);
      }
      function cloneWith(value, customizer) {
        customizer = typeof customizer == 'function' ? customizer : undefined$1;
        return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
      }
      function cloneDeep(value) {
        return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
      }
      function cloneDeepWith(value, customizer) {
        customizer = typeof customizer == 'function' ? customizer : undefined$1;
        return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
      }
      function conformsTo(object, source) {
        return source == null || baseConformsTo(object, source, keys(source));
      }
      function eq(value, other) {
        return value === other || value !== value && other !== other;
      }
      var gt = createRelationalOperation(baseGt);
      var gte = createRelationalOperation(function (value, other) {
        return value >= other;
      });
      var isArguments = baseIsArguments(function () {
        return arguments;
      }()) ? baseIsArguments : function (value) {
        return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
      };
      var isArray = Array.isArray;
      var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
      function isArrayLike(value) {
        return value != null && isLength(value.length) && !isFunction(value);
      }
      function isArrayLikeObject(value) {
        return isObjectLike(value) && isArrayLike(value);
      }
      function isBoolean(value) {
        return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
      }
      var isBuffer = nativeIsBuffer || stubFalse;
      var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
      function isElement(value) {
        return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
      }
      function isEmpty(value) {
        if (value == null) {
          return true;
        }
        if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) {
          return !value.length;
        }
        var tag = getTag(value);
        if (tag == mapTag || tag == setTag) {
          return !value.size;
        }
        if (isPrototype(value)) {
          return !baseKeys(value).length;
        }
        for (var key in value) {
          if (hasOwnProperty.call(value, key)) {
            return false;
          }
        }
        return true;
      }
      function isEqual(value, other) {
        return baseIsEqual(value, other);
      }
      function isEqualWith(value, other, customizer) {
        customizer = typeof customizer == 'function' ? customizer : undefined$1;
        var result = customizer ? customizer(value, other) : undefined$1;
        return result === undefined$1 ? baseIsEqual(value, other, undefined$1, customizer) : !!result;
      }
      function isError(value) {
        if (!isObjectLike(value)) {
          return false;
        }
        var tag = baseGetTag(value);
        return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
      }
      function isFinite(value) {
        return typeof value == 'number' && nativeIsFinite(value);
      }
      function isFunction(value) {
        if (!isObject(value)) {
          return false;
        }
        var tag = baseGetTag(value);
        return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
      }
      function isInteger(value) {
        return typeof value == 'number' && value == toInteger(value);
      }
      function isLength(value) {
        return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
      }
      function isObject(value) {
        var type = typeof value;
        return value != null && (type == 'object' || type == 'function');
      }
      function isObjectLike(value) {
        return value != null && typeof value == 'object';
      }
      var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
      function isMatch(object, source) {
        return object === source || baseIsMatch(object, source, getMatchData(source));
      }
      function isMatchWith(object, source, customizer) {
        customizer = typeof customizer == 'function' ? customizer : undefined$1;
        return baseIsMatch(object, source, getMatchData(source), customizer);
      }
      function isNaN(value) {
        return isNumber(value) && value != +value;
      }
      function isNative(value) {
        if (isMaskable(value)) {
          throw new Error(CORE_ERROR_TEXT);
        }
        return baseIsNative(value);
      }
      function isNull(value) {
        return value === null;
      }
      function isNil(value) {
        return value == null;
      }
      function isNumber(value) {
        return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
      }
      function isPlainObject(value) {
        if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
          return false;
        }
        var proto = getPrototype(value);
        if (proto === null) {
          return true;
        }
        var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
        return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
      }
      var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
      function isSafeInteger(value) {
        return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
      }
      var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
      function isString(value) {
        return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
      }
      function isSymbol(value) {
        return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
      }
      var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
      function isUndefined(value) {
        return value === undefined$1;
      }
      function isWeakMap(value) {
        return isObjectLike(value) && getTag(value) == weakMapTag;
      }
      function isWeakSet(value) {
        return isObjectLike(value) && baseGetTag(value) == weakSetTag;
      }
      var lt = createRelationalOperation(baseLt);
      var lte = createRelationalOperation(function (value, other) {
        return value <= other;
      });
      function toArray(value) {
        if (!value) {
          return [];
        }
        if (isArrayLike(value)) {
          return isString(value) ? stringToArray(value) : copyArray(value);
        }
        if (symIterator && value[symIterator]) {
          return iteratorToArray(value[symIterator]());
        }
        var tag = getTag(value),
          func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
        return func(value);
      }
      function toFinite(value) {
        if (!value) {
          return value === 0 ? value : 0;
        }
        value = toNumber(value);
        if (value === INFINITY || value === -INFINITY) {
          var sign = value < 0 ? -1 : 1;
          return sign * MAX_INTEGER;
        }
        return value === value ? value : 0;
      }
      function toInteger(value) {
        var result = toFinite(value),
          remainder = result % 1;
        return result === result ? remainder ? result - remainder : result : 0;
      }
      function toLength(value) {
        return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
      }
      function toNumber(value) {
        if (typeof value == 'number') {
          return value;
        }
        if (isSymbol(value)) {
          return NAN;
        }
        if (isObject(value)) {
          var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
          value = isObject(other) ? other + '' : other;
        }
        if (typeof value != 'string') {
          return value === 0 ? value : +value;
        }
        value = baseTrim(value);
        var isBinary = reIsBinary.test(value);
        return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
      }
      function toPlainObject(value) {
        return copyObject(value, keysIn(value));
      }
      function toSafeInteger(value) {
        return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
      }
      function toString(value) {
        return value == null ? '' : baseToString(value);
      }
      var assign = createAssigner(function (object, source) {
        if (isPrototype(source) || isArrayLike(source)) {
          copyObject(source, keys(source), object);
          return;
        }
        for (var key in source) {
          if (hasOwnProperty.call(source, key)) {
            assignValue(object, key, source[key]);
          }
        }
      });
      var assignIn = createAssigner(function (object, source) {
        copyObject(source, keysIn(source), object);
      });
      var assignInWith = createAssigner(function (object, source, srcIndex, customizer) {
        copyObject(source, keysIn(source), object, customizer);
      });
      var assignWith = createAssigner(function (object, source, srcIndex, customizer) {
        copyObject(source, keys(source), object, customizer);
      });
      var at = flatRest(baseAt);
      function create(prototype, properties) {
        var result = baseCreate(prototype);
        return properties == null ? result : baseAssign(result, properties);
      }
      var defaults = baseRest(function (object, sources) {
        object = Object(object);
        var index = -1;
        var length = sources.length;
        var guard = length > 2 ? sources[2] : undefined$1;
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          length = 1;
        }
        while (++index < length) {
          var source = sources[index];
          var props = keysIn(source);
          var propsIndex = -1;
          var propsLength = props.length;
          while (++propsIndex < propsLength) {
            var key = props[propsIndex];
            var value = object[key];
            if (value === undefined$1 || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) {
              object[key] = source[key];
            }
          }
        }
        return object;
      });
      var defaultsDeep = baseRest(function (args) {
        args.push(undefined$1, customDefaultsMerge);
        return apply(mergeWith, undefined$1, args);
      });
      function findKey(object, predicate) {
        return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
      }
      function findLastKey(object, predicate) {
        return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
      }
      function forIn(object, iteratee) {
        return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
      }
      function forInRight(object, iteratee) {
        return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
      }
      function forOwn(object, iteratee) {
        return object && baseForOwn(object, getIteratee(iteratee, 3));
      }
      function forOwnRight(object, iteratee) {
        return object && baseForOwnRight(object, getIteratee(iteratee, 3));
      }
      function functions(object) {
        return object == null ? [] : baseFunctions(object, keys(object));
      }
      function functionsIn(object) {
        return object == null ? [] : baseFunctions(object, keysIn(object));
      }
      function get(object, path, defaultValue) {
        var result = object == null ? undefined$1 : baseGet(object, path);
        return result === undefined$1 ? defaultValue : result;
      }
      function has(object, path) {
        return object != null && hasPath(object, path, baseHas);
      }
      function hasIn(object, path) {
        return object != null && hasPath(object, path, baseHasIn);
      }
      var invert = createInverter(function (result, value, key) {
        if (value != null && typeof value.toString != 'function') {
          value = nativeObjectToString.call(value);
        }
        result[value] = key;
      }, constant(identity));
      var invertBy = createInverter(function (result, value, key) {
        if (value != null && typeof value.toString != 'function') {
          value = nativeObjectToString.call(value);
        }
        if (hasOwnProperty.call(result, value)) {
          result[value].push(key);
        } else {
          result[value] = [key];
        }
      }, getIteratee);
      var invoke = baseRest(baseInvoke);
      function keys(object) {
        return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
      }
      function keysIn(object) {
        return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
      }
      function mapKeys(object, iteratee) {
        var result = {};
        iteratee = getIteratee(iteratee, 3);
        baseForOwn(object, function (value, key, object) {
          baseAssignValue(result, iteratee(value, key, object), value);
        });
        return result;
      }
      function mapValues(object, iteratee) {
        var result = {};
        iteratee = getIteratee(iteratee, 3);
        baseForOwn(object, function (value, key, object) {
          baseAssignValue(result, key, iteratee(value, key, object));
        });
        return result;
      }
      var merge = createAssigner(function (object, source, srcIndex) {
        baseMerge(object, source, srcIndex);
      });
      var mergeWith = createAssigner(function (object, source, srcIndex, customizer) {
        baseMerge(object, source, srcIndex, customizer);
      });
      var omit = flatRest(function (object, paths) {
        var result = {};
        if (object == null) {
          return result;
        }
        var isDeep = false;
        paths = arrayMap(paths, function (path) {
          path = castPath(path, object);
          isDeep || (isDeep = path.length > 1);
          return path;
        });
        copyObject(object, getAllKeysIn(object), result);
        if (isDeep) {
          result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
        }
        var length = paths.length;
        while (length--) {
          baseUnset(result, paths[length]);
        }
        return result;
      });
      function omitBy(object, predicate) {
        return pickBy(object, negate(getIteratee(predicate)));
      }
      var pick = flatRest(function (object, paths) {
        return object == null ? {} : basePick(object, paths);
      });
      function pickBy(object, predicate) {
        if (object == null) {
          return {};
        }
        var props = arrayMap(getAllKeysIn(object), function (prop) {
          return [prop];
        });
        predicate = getIteratee(predicate);
        return basePickBy(object, props, function (value, path) {
          return predicate(value, path[0]);
        });
      }
      function result(object, path, defaultValue) {
        path = castPath(path, object);
        var index = -1,
          length = path.length;
        if (!length) {
          length = 1;
          object = undefined$1;
        }
        while (++index < length) {
          var value = object == null ? undefined$1 : object[toKey(path[index])];
          if (value === undefined$1) {
            index = length;
            value = defaultValue;
          }
          object = isFunction(value) ? value.call(object) : value;
        }
        return object;
      }
      function set(object, path, value) {
        return object == null ? object : baseSet(object, path, value);
      }
      function setWith(object, path, value, customizer) {
        customizer = typeof customizer == 'function' ? customizer : undefined$1;
        return object == null ? object : baseSet(object, path, value, customizer);
      }
      var toPairs = createToPairs(keys);
      var toPairsIn = createToPairs(keysIn);
      function transform(object, iteratee, accumulator) {
        var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);
        iteratee = getIteratee(iteratee, 4);
        if (accumulator == null) {
          var Ctor = object && object.constructor;
          if (isArrLike) {
            accumulator = isArr ? new Ctor() : [];
          } else if (isObject(object)) {
            accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
          } else {
            accumulator = {};
          }
        }
        (isArrLike ? arrayEach : baseForOwn)(object, function (value, index, object) {
          return iteratee(accumulator, value, index, object);
        });
        return accumulator;
      }
      function unset(object, path) {
        return object == null ? true : baseUnset(object, path);
      }
      function update(object, path, updater) {
        return object == null ? object : baseUpdate(object, path, castFunction(updater));
      }
      function updateWith(object, path, updater, customizer) {
        customizer = typeof customizer == 'function' ? customizer : undefined$1;
        return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
      }
      function values(object) {
        return object == null ? [] : baseValues(object, keys(object));
      }
      function valuesIn(object) {
        return object == null ? [] : baseValues(object, keysIn(object));
      }
      function clamp(number, lower, upper) {
        if (upper === undefined$1) {
          upper = lower;
          lower = undefined$1;
        }
        if (upper !== undefined$1) {
          upper = toNumber(upper);
          upper = upper === upper ? upper : 0;
        }
        if (lower !== undefined$1) {
          lower = toNumber(lower);
          lower = lower === lower ? lower : 0;
        }
        return baseClamp(toNumber(number), lower, upper);
      }
      function inRange(number, start, end) {
        start = toFinite(start);
        if (end === undefined$1) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        number = toNumber(number);
        return baseInRange(number, start, end);
      }
      function random(lower, upper, floating) {
        if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
          upper = floating = undefined$1;
        }
        if (floating === undefined$1) {
          if (typeof upper == 'boolean') {
            floating = upper;
            upper = undefined$1;
          } else if (typeof lower == 'boolean') {
            floating = lower;
            lower = undefined$1;
          }
        }
        if (lower === undefined$1 && upper === undefined$1) {
          lower = 0;
          upper = 1;
        } else {
          lower = toFinite(lower);
          if (upper === undefined$1) {
            upper = lower;
            lower = 0;
          } else {
            upper = toFinite(upper);
          }
        }
        if (lower > upper) {
          var temp = lower;
          lower = upper;
          upper = temp;
        }
        if (floating || lower % 1 || upper % 1) {
          var rand = nativeRandom();
          return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
        }
        return baseRandom(lower, upper);
      }
      var camelCase = createCompounder(function (result, word, index) {
        word = word.toLowerCase();
        return result + (index ? capitalize(word) : word);
      });
      function capitalize(string) {
        return upperFirst(toString(string).toLowerCase());
      }
      function deburr(string) {
        string = toString(string);
        return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
      }
      function endsWith(string, target, position) {
        string = toString(string);
        target = baseToString(target);
        var length = string.length;
        position = position === undefined$1 ? length : baseClamp(toInteger(position), 0, length);
        var end = position;
        position -= target.length;
        return position >= 0 && string.slice(position, end) == target;
      }
      function escape(string) {
        string = toString(string);
        return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
      }
      function escapeRegExp(string) {
        string = toString(string);
        return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
      }
      var kebabCase = createCompounder(function (result, word, index) {
        return result + (index ? '-' : '') + word.toLowerCase();
      });
      var lowerCase = createCompounder(function (result, word, index) {
        return result + (index ? ' ' : '') + word.toLowerCase();
      });
      var lowerFirst = createCaseFirst('toLowerCase');
      function pad(string, length, chars) {
        string = toString(string);
        length = toInteger(length);
        var strLength = length ? stringSize(string) : 0;
        if (!length || strLength >= length) {
          return string;
        }
        var mid = (length - strLength) / 2;
        return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
      }
      function padEnd(string, length, chars) {
        string = toString(string);
        length = toInteger(length);
        var strLength = length ? stringSize(string) : 0;
        return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
      }
      function padStart(string, length, chars) {
        string = toString(string);
        length = toInteger(length);
        var strLength = length ? stringSize(string) : 0;
        return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
      }
      function parseInt(string, radix, guard) {
        if (guard || radix == null) {
          radix = 0;
        } else if (radix) {
          radix = +radix;
        }
        return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
      }
      function repeat(string, n, guard) {
        if (guard ? isIterateeCall(string, n, guard) : n === undefined$1) {
          n = 1;
        } else {
          n = toInteger(n);
        }
        return baseRepeat(toString(string), n);
      }
      function replace() {
        var args = arguments,
          string = toString(args[0]);
        return args.length < 3 ? string : string.replace(args[1], args[2]);
      }
      var snakeCase = createCompounder(function (result, word, index) {
        return result + (index ? '_' : '') + word.toLowerCase();
      });
      function split(string, separator, limit) {
        if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
          separator = limit = undefined$1;
        }
        limit = limit === undefined$1 ? MAX_ARRAY_LENGTH : limit >>> 0;
        if (!limit) {
          return [];
        }
        string = toString(string);
        if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
          separator = baseToString(separator);
          if (!separator && hasUnicode(string)) {
            return castSlice(stringToArray(string), 0, limit);
          }
        }
        return string.split(separator, limit);
      }
      var startCase = createCompounder(function (result, word, index) {
        return result + (index ? ' ' : '') + upperFirst(word);
      });
      function startsWith(string, target, position) {
        string = toString(string);
        position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
        target = baseToString(target);
        return string.slice(position, position + target.length) == target;
      }
      function template(string, options, guard) {
        var settings = lodash.templateSettings;
        if (guard && isIterateeCall(string, options, guard)) {
          options = undefined$1;
        }
        string = toString(string);
        options = assignInWith({}, options, settings, customDefaultsAssignIn);
        var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);
        var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";
        var reDelimiters = RegExp((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');
        var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
        string.replace(reDelimiters, function (match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
          interpolateValue || (interpolateValue = esTemplateValue);
          source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
          if (escapeValue) {
            isEscaping = true;
            source += "' +\n__e(" + escapeValue + ") +\n'";
          }
          if (evaluateValue) {
            isEvaluating = true;
            source += "';\n" + evaluateValue + ";\n__p += '";
          }
          if (interpolateValue) {
            source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
          }
          index = offset + match.length;
          return match;
        });
        source += "';\n";
        var variable = hasOwnProperty.call(options, 'variable') && options.variable;
        if (!variable) {
          source = 'with (obj) {\n' + source + '\n}\n';
        } else if (reForbiddenIdentifierChars.test(variable)) {
          throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
        }
        source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');
        source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ', __j = Array.prototype.join;\n' + "function print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
        var result = attempt(function () {
          return Function(importsKeys, sourceURL + 'return ' + source).apply(undefined$1, importsValues);
        });
        result.source = source;
        if (isError(result)) {
          throw result;
        }
        return result;
      }
      function toLower(value) {
        return toString(value).toLowerCase();
      }
      function toUpper(value) {
        return toString(value).toUpperCase();
      }
      function trim(string, chars, guard) {
        string = toString(string);
        if (string && (guard || chars === undefined$1)) {
          return baseTrim(string);
        }
        if (!string || !(chars = baseToString(chars))) {
          return string;
        }
        var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;
        return castSlice(strSymbols, start, end).join('');
      }
      function trimEnd(string, chars, guard) {
        string = toString(string);
        if (string && (guard || chars === undefined$1)) {
          return string.slice(0, trimmedEndIndex(string) + 1);
        }
        if (!string || !(chars = baseToString(chars))) {
          return string;
        }
        var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
        return castSlice(strSymbols, 0, end).join('');
      }
      function trimStart(string, chars, guard) {
        string = toString(string);
        if (string && (guard || chars === undefined$1)) {
          return string.replace(reTrimStart, '');
        }
        if (!string || !(chars = baseToString(chars))) {
          return string;
        }
        var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));
        return castSlice(strSymbols, start).join('');
      }
      function truncate(string, options) {
        var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;
        if (isObject(options)) {
          var separator = 'separator' in options ? options.separator : separator;
          length = 'length' in options ? toInteger(options.length) : length;
          omission = 'omission' in options ? baseToString(options.omission) : omission;
        }
        string = toString(string);
        var strLength = string.length;
        if (hasUnicode(string)) {
          var strSymbols = stringToArray(string);
          strLength = strSymbols.length;
        }
        if (length >= strLength) {
          return string;
        }
        var end = length - stringSize(omission);
        if (end < 1) {
          return omission;
        }
        var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
        if (separator === undefined$1) {
          return result + omission;
        }
        if (strSymbols) {
          end += result.length - end;
        }
        if (isRegExp(separator)) {
          if (string.slice(end).search(separator)) {
            var match,
              substring = result;
            if (!separator.global) {
              separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
            }
            separator.lastIndex = 0;
            while (match = separator.exec(substring)) {
              var newEnd = match.index;
            }
            result = result.slice(0, newEnd === undefined$1 ? end : newEnd);
          }
        } else if (string.indexOf(baseToString(separator), end) != end) {
          var index = result.lastIndexOf(separator);
          if (index > -1) {
            result = result.slice(0, index);
          }
        }
        return result + omission;
      }
      function unescape(string) {
        string = toString(string);
        return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
      }
      var upperCase = createCompounder(function (result, word, index) {
        return result + (index ? ' ' : '') + word.toUpperCase();
      });
      var upperFirst = createCaseFirst('toUpperCase');
      function words(string, pattern, guard) {
        string = toString(string);
        pattern = guard ? undefined$1 : pattern;
        if (pattern === undefined$1) {
          return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
        }
        return string.match(pattern) || [];
      }
      var attempt = baseRest(function (func, args) {
        try {
          return apply(func, undefined$1, args);
        } catch (e) {
          return isError(e) ? e : new Error(e);
        }
      });
      var bindAll = flatRest(function (object, methodNames) {
        arrayEach(methodNames, function (key) {
          key = toKey(key);
          baseAssignValue(object, key, bind(object[key], object));
        });
        return object;
      });
      function cond(pairs) {
        var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();
        pairs = !length ? [] : arrayMap(pairs, function (pair) {
          if (typeof pair[1] != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          return [toIteratee(pair[0]), pair[1]];
        });
        return baseRest(function (args) {
          var index = -1;
          while (++index < length) {
            var pair = pairs[index];
            if (apply(pair[0], this, args)) {
              return apply(pair[1], this, args);
            }
          }
        });
      }
      function conforms(source) {
        return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
      }
      function constant(value) {
        return function () {
          return value;
        };
      }
      function defaultTo(value, defaultValue) {
        return value == null || value !== value ? defaultValue : value;
      }
      var flow = createFlow();
      var flowRight = createFlow(true);
      function identity(value) {
        return value;
      }
      function iteratee(func) {
        return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
      }
      function matches(source) {
        return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
      }
      function matchesProperty(path, srcValue) {
        return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
      }
      var method = baseRest(function (path, args) {
        return function (object) {
          return baseInvoke(object, path, args);
        };
      });
      var methodOf = baseRest(function (object, args) {
        return function (path) {
          return baseInvoke(object, path, args);
        };
      });
      function mixin(object, source, options) {
        var props = keys(source),
          methodNames = baseFunctions(source, props);
        if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
          options = source;
          source = object;
          object = this;
          methodNames = baseFunctions(source, keys(source));
        }
        var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);
        arrayEach(methodNames, function (methodName) {
          var func = source[methodName];
          object[methodName] = func;
          if (isFunc) {
            object.prototype[methodName] = function () {
              var chainAll = this.__chain__;
              if (chain || chainAll) {
                var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);
                actions.push({
                  'func': func,
                  'args': arguments,
                  'thisArg': object
                });
                result.__chain__ = chainAll;
                return result;
              }
              return func.apply(object, arrayPush([this.value()], arguments));
            };
          }
        });
        return object;
      }
      function noConflict() {
        if (root._ === this) {
          root._ = oldDash;
        }
        return this;
      }
      function noop() {}
      function nthArg(n) {
        n = toInteger(n);
        return baseRest(function (args) {
          return baseNth(args, n);
        });
      }
      var over = createOver(arrayMap);
      var overEvery = createOver(arrayEvery);
      var overSome = createOver(arraySome);
      function property(path) {
        return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
      }
      function propertyOf(object) {
        return function (path) {
          return object == null ? undefined$1 : baseGet(object, path);
        };
      }
      var range = createRange();
      var rangeRight = createRange(true);
      function stubArray() {
        return [];
      }
      function stubFalse() {
        return false;
      }
      function stubObject() {
        return {};
      }
      function stubString() {
        return '';
      }
      function stubTrue() {
        return true;
      }
      function times(n, iteratee) {
        n = toInteger(n);
        if (n < 1 || n > MAX_SAFE_INTEGER) {
          return [];
        }
        var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);
        iteratee = getIteratee(iteratee);
        n -= MAX_ARRAY_LENGTH;
        var result = baseTimes(length, iteratee);
        while (++index < n) {
          iteratee(index);
        }
        return result;
      }
      function toPath(value) {
        if (isArray(value)) {
          return arrayMap(value, toKey);
        }
        return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
      }
      function uniqueId(prefix) {
        var id = ++idCounter;
        return toString(prefix) + id;
      }
      var add = createMathOperation(function (augend, addend) {
        return augend + addend;
      }, 0);
      var ceil = createRound('ceil');
      var divide = createMathOperation(function (dividend, divisor) {
        return dividend / divisor;
      }, 1);
      var floor = createRound('floor');
      function max(array) {
        return array && array.length ? baseExtremum(array, identity, baseGt) : undefined$1;
      }
      function maxBy(array, iteratee) {
        return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined$1;
      }
      function mean(array) {
        return baseMean(array, identity);
      }
      function meanBy(array, iteratee) {
        return baseMean(array, getIteratee(iteratee, 2));
      }
      function min(array) {
        return array && array.length ? baseExtremum(array, identity, baseLt) : undefined$1;
      }
      function minBy(array, iteratee) {
        return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined$1;
      }
      var multiply = createMathOperation(function (multiplier, multiplicand) {
        return multiplier * multiplicand;
      }, 1);
      var round = createRound('round');
      var subtract = createMathOperation(function (minuend, subtrahend) {
        return minuend - subtrahend;
      }, 0);
      function sum(array) {
        return array && array.length ? baseSum(array, identity) : 0;
      }
      function sumBy(array, iteratee) {
        return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
      }
      lodash.after = after;
      lodash.ary = ary;
      lodash.assign = assign;
      lodash.assignIn = assignIn;
      lodash.assignInWith = assignInWith;
      lodash.assignWith = assignWith;
      lodash.at = at;
      lodash.before = before;
      lodash.bind = bind;
      lodash.bindAll = bindAll;
      lodash.bindKey = bindKey;
      lodash.castArray = castArray;
      lodash.chain = chain;
      lodash.chunk = chunk;
      lodash.compact = compact;
      lodash.concat = concat;
      lodash.cond = cond;
      lodash.conforms = conforms;
      lodash.constant = constant;
      lodash.countBy = countBy;
      lodash.create = create;
      lodash.curry = curry;
      lodash.curryRight = curryRight;
      lodash.debounce = debounce;
      lodash.defaults = defaults;
      lodash.defaultsDeep = defaultsDeep;
      lodash.defer = defer;
      lodash.delay = delay;
      lodash.difference = difference;
      lodash.differenceBy = differenceBy;
      lodash.differenceWith = differenceWith;
      lodash.drop = drop;
      lodash.dropRight = dropRight;
      lodash.dropRightWhile = dropRightWhile;
      lodash.dropWhile = dropWhile;
      lodash.fill = fill;
      lodash.filter = filter;
      lodash.flatMap = flatMap;
      lodash.flatMapDeep = flatMapDeep;
      lodash.flatMapDepth = flatMapDepth;
      lodash.flatten = flatten;
      lodash.flattenDeep = flattenDeep;
      lodash.flattenDepth = flattenDepth;
      lodash.flip = flip;
      lodash.flow = flow;
      lodash.flowRight = flowRight;
      lodash.fromPairs = fromPairs;
      lodash.functions = functions;
      lodash.functionsIn = functionsIn;
      lodash.groupBy = groupBy;
      lodash.initial = initial;
      lodash.intersection = intersection;
      lodash.intersectionBy = intersectionBy;
      lodash.intersectionWith = intersectionWith;
      lodash.invert = invert;
      lodash.invertBy = invertBy;
      lodash.invokeMap = invokeMap;
      lodash.iteratee = iteratee;
      lodash.keyBy = keyBy;
      lodash.keys = keys;
      lodash.keysIn = keysIn;
      lodash.map = map;
      lodash.mapKeys = mapKeys;
      lodash.mapValues = mapValues;
      lodash.matches = matches;
      lodash.matchesProperty = matchesProperty;
      lodash.memoize = memoize;
      lodash.merge = merge;
      lodash.mergeWith = mergeWith;
      lodash.method = method;
      lodash.methodOf = methodOf;
      lodash.mixin = mixin;
      lodash.negate = negate;
      lodash.nthArg = nthArg;
      lodash.omit = omit;
      lodash.omitBy = omitBy;
      lodash.once = once;
      lodash.orderBy = orderBy;
      lodash.over = over;
      lodash.overArgs = overArgs;
      lodash.overEvery = overEvery;
      lodash.overSome = overSome;
      lodash.partial = partial;
      lodash.partialRight = partialRight;
      lodash.partition = partition;
      lodash.pick = pick;
      lodash.pickBy = pickBy;
      lodash.property = property;
      lodash.propertyOf = propertyOf;
      lodash.pull = pull;
      lodash.pullAll = pullAll;
      lodash.pullAllBy = pullAllBy;
      lodash.pullAllWith = pullAllWith;
      lodash.pullAt = pullAt;
      lodash.range = range;
      lodash.rangeRight = rangeRight;
      lodash.rearg = rearg;
      lodash.reject = reject;
      lodash.remove = remove;
      lodash.rest = rest;
      lodash.reverse = reverse;
      lodash.sampleSize = sampleSize;
      lodash.set = set;
      lodash.setWith = setWith;
      lodash.shuffle = shuffle;
      lodash.slice = slice;
      lodash.sortBy = sortBy;
      lodash.sortedUniq = sortedUniq;
      lodash.sortedUniqBy = sortedUniqBy;
      lodash.split = split;
      lodash.spread = spread;
      lodash.tail = tail;
      lodash.take = take;
      lodash.takeRight = takeRight;
      lodash.takeRightWhile = takeRightWhile;
      lodash.takeWhile = takeWhile;
      lodash.tap = tap;
      lodash.throttle = throttle;
      lodash.thru = thru;
      lodash.toArray = toArray;
      lodash.toPairs = toPairs;
      lodash.toPairsIn = toPairsIn;
      lodash.toPath = toPath;
      lodash.toPlainObject = toPlainObject;
      lodash.transform = transform;
      lodash.unary = unary;
      lodash.union = union;
      lodash.unionBy = unionBy;
      lodash.unionWith = unionWith;
      lodash.uniq = uniq;
      lodash.uniqBy = uniqBy;
      lodash.uniqWith = uniqWith;
      lodash.unset = unset;
      lodash.unzip = unzip;
      lodash.unzipWith = unzipWith;
      lodash.update = update;
      lodash.updateWith = updateWith;
      lodash.values = values;
      lodash.valuesIn = valuesIn;
      lodash.without = without;
      lodash.words = words;
      lodash.wrap = wrap;
      lodash.xor = xor;
      lodash.xorBy = xorBy;
      lodash.xorWith = xorWith;
      lodash.zip = zip;
      lodash.zipObject = zipObject;
      lodash.zipObjectDeep = zipObjectDeep;
      lodash.zipWith = zipWith;
      lodash.entries = toPairs;
      lodash.entriesIn = toPairsIn;
      lodash.extend = assignIn;
      lodash.extendWith = assignInWith;
      mixin(lodash, lodash);
      lodash.add = add;
      lodash.attempt = attempt;
      lodash.camelCase = camelCase;
      lodash.capitalize = capitalize;
      lodash.ceil = ceil;
      lodash.clamp = clamp;
      lodash.clone = clone;
      lodash.cloneDeep = cloneDeep;
      lodash.cloneDeepWith = cloneDeepWith;
      lodash.cloneWith = cloneWith;
      lodash.conformsTo = conformsTo;
      lodash.deburr = deburr;
      lodash.defaultTo = defaultTo;
      lodash.divide = divide;
      lodash.endsWith = endsWith;
      lodash.eq = eq;
      lodash.escape = escape;
      lodash.escapeRegExp = escapeRegExp;
      lodash.every = every;
      lodash.find = find;
      lodash.findIndex = findIndex;
      lodash.findKey = findKey;
      lodash.findLast = findLast;
      lodash.findLastIndex = findLastIndex;
      lodash.findLastKey = findLastKey;
      lodash.floor = floor;
      lodash.forEach = forEach;
      lodash.forEachRight = forEachRight;
      lodash.forIn = forIn;
      lodash.forInRight = forInRight;
      lodash.forOwn = forOwn;
      lodash.forOwnRight = forOwnRight;
      lodash.get = get;
      lodash.gt = gt;
      lodash.gte = gte;
      lodash.has = has;
      lodash.hasIn = hasIn;
      lodash.head = head;
      lodash.identity = identity;
      lodash.includes = includes;
      lodash.indexOf = indexOf;
      lodash.inRange = inRange;
      lodash.invoke = invoke;
      lodash.isArguments = isArguments;
      lodash.isArray = isArray;
      lodash.isArrayBuffer = isArrayBuffer;
      lodash.isArrayLike = isArrayLike;
      lodash.isArrayLikeObject = isArrayLikeObject;
      lodash.isBoolean = isBoolean;
      lodash.isBuffer = isBuffer;
      lodash.isDate = isDate;
      lodash.isElement = isElement;
      lodash.isEmpty = isEmpty;
      lodash.isEqual = isEqual;
      lodash.isEqualWith = isEqualWith;
      lodash.isError = isError;
      lodash.isFinite = isFinite;
      lodash.isFunction = isFunction;
      lodash.isInteger = isInteger;
      lodash.isLength = isLength;
      lodash.isMap = isMap;
      lodash.isMatch = isMatch;
      lodash.isMatchWith = isMatchWith;
      lodash.isNaN = isNaN;
      lodash.isNative = isNative;
      lodash.isNil = isNil;
      lodash.isNull = isNull;
      lodash.isNumber = isNumber;
      lodash.isObject = isObject;
      lodash.isObjectLike = isObjectLike;
      lodash.isPlainObject = isPlainObject;
      lodash.isRegExp = isRegExp;
      lodash.isSafeInteger = isSafeInteger;
      lodash.isSet = isSet;
      lodash.isString = isString;
      lodash.isSymbol = isSymbol;
      lodash.isTypedArray = isTypedArray;
      lodash.isUndefined = isUndefined;
      lodash.isWeakMap = isWeakMap;
      lodash.isWeakSet = isWeakSet;
      lodash.join = join;
      lodash.kebabCase = kebabCase;
      lodash.last = last;
      lodash.lastIndexOf = lastIndexOf;
      lodash.lowerCase = lowerCase;
      lodash.lowerFirst = lowerFirst;
      lodash.lt = lt;
      lodash.lte = lte;
      lodash.max = max;
      lodash.maxBy = maxBy;
      lodash.mean = mean;
      lodash.meanBy = meanBy;
      lodash.min = min;
      lodash.minBy = minBy;
      lodash.stubArray = stubArray;
      lodash.stubFalse = stubFalse;
      lodash.stubObject = stubObject;
      lodash.stubString = stubString;
      lodash.stubTrue = stubTrue;
      lodash.multiply = multiply;
      lodash.nth = nth;
      lodash.noConflict = noConflict;
      lodash.noop = noop;
      lodash.now = now;
      lodash.pad = pad;
      lodash.padEnd = padEnd;
      lodash.padStart = padStart;
      lodash.parseInt = parseInt;
      lodash.random = random;
      lodash.reduce = reduce;
      lodash.reduceRight = reduceRight;
      lodash.repeat = repeat;
      lodash.replace = replace;
      lodash.result = result;
      lodash.round = round;
      lodash.runInContext = runInContext;
      lodash.sample = sample;
      lodash.size = size;
      lodash.snakeCase = snakeCase;
      lodash.some = some;
      lodash.sortedIndex = sortedIndex;
      lodash.sortedIndexBy = sortedIndexBy;
      lodash.sortedIndexOf = sortedIndexOf;
      lodash.sortedLastIndex = sortedLastIndex;
      lodash.sortedLastIndexBy = sortedLastIndexBy;
      lodash.sortedLastIndexOf = sortedLastIndexOf;
      lodash.startCase = startCase;
      lodash.startsWith = startsWith;
      lodash.subtract = subtract;
      lodash.sum = sum;
      lodash.sumBy = sumBy;
      lodash.template = template;
      lodash.times = times;
      lodash.toFinite = toFinite;
      lodash.toInteger = toInteger;
      lodash.toLength = toLength;
      lodash.toLower = toLower;
      lodash.toNumber = toNumber;
      lodash.toSafeInteger = toSafeInteger;
      lodash.toString = toString;
      lodash.toUpper = toUpper;
      lodash.trim = trim;
      lodash.trimEnd = trimEnd;
      lodash.trimStart = trimStart;
      lodash.truncate = truncate;
      lodash.unescape = unescape;
      lodash.uniqueId = uniqueId;
      lodash.upperCase = upperCase;
      lodash.upperFirst = upperFirst;
      lodash.each = forEach;
      lodash.eachRight = forEachRight;
      lodash.first = head;
      mixin(lodash, function () {
        var source = {};
        baseForOwn(lodash, function (func, methodName) {
          if (!hasOwnProperty.call(lodash.prototype, methodName)) {
            source[methodName] = func;
          }
        });
        return source;
      }(), {
        'chain': false
      });
      lodash.VERSION = VERSION;
      arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function (methodName) {
        lodash[methodName].placeholder = lodash;
      });
      arrayEach(['drop', 'take'], function (methodName, index) {
        LazyWrapper.prototype[methodName] = function (n) {
          n = n === undefined$1 ? 1 : nativeMax(toInteger(n), 0);
          var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
          if (result.__filtered__) {
            result.__takeCount__ = nativeMin(n, result.__takeCount__);
          } else {
            result.__views__.push({
              'size': nativeMin(n, MAX_ARRAY_LENGTH),
              'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
            });
          }
          return result;
        };
        LazyWrapper.prototype[methodName + 'Right'] = function (n) {
          return this.reverse()[methodName](n).reverse();
        };
      });
      arrayEach(['filter', 'map', 'takeWhile'], function (methodName, index) {
        var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
        LazyWrapper.prototype[methodName] = function (iteratee) {
          var result = this.clone();
          result.__iteratees__.push({
            'iteratee': getIteratee(iteratee, 3),
            'type': type
          });
          result.__filtered__ = result.__filtered__ || isFilter;
          return result;
        };
      });
      arrayEach(['head', 'last'], function (methodName, index) {
        var takeName = 'take' + (index ? 'Right' : '');
        LazyWrapper.prototype[methodName] = function () {
          return this[takeName](1).value()[0];
        };
      });
      arrayEach(['initial', 'tail'], function (methodName, index) {
        var dropName = 'drop' + (index ? '' : 'Right');
        LazyWrapper.prototype[methodName] = function () {
          return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
        };
      });
      LazyWrapper.prototype.compact = function () {
        return this.filter(identity);
      };
      LazyWrapper.prototype.find = function (predicate) {
        return this.filter(predicate).head();
      };
      LazyWrapper.prototype.findLast = function (predicate) {
        return this.reverse().find(predicate);
      };
      LazyWrapper.prototype.invokeMap = baseRest(function (path, args) {
        if (typeof path == 'function') {
          return new LazyWrapper(this);
        }
        return this.map(function (value) {
          return baseInvoke(value, path, args);
        });
      });
      LazyWrapper.prototype.reject = function (predicate) {
        return this.filter(negate(getIteratee(predicate)));
      };
      LazyWrapper.prototype.slice = function (start, end) {
        start = toInteger(start);
        var result = this;
        if (result.__filtered__ && (start > 0 || end < 0)) {
          return new LazyWrapper(result);
        }
        if (start < 0) {
          result = result.takeRight(-start);
        } else if (start) {
          result = result.drop(start);
        }
        if (end !== undefined$1) {
          end = toInteger(end);
          result = end < 0 ? result.dropRight(-end) : result.take(end - start);
        }
        return result;
      };
      LazyWrapper.prototype.takeRightWhile = function (predicate) {
        return this.reverse().takeWhile(predicate).reverse();
      };
      LazyWrapper.prototype.toArray = function () {
        return this.take(MAX_ARRAY_LENGTH);
      };
      baseForOwn(LazyWrapper.prototype, function (func, methodName) {
        var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);
        if (!lodashFunc) {
          return;
        }
        lodash.prototype[methodName] = function () {
          var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);
          var interceptor = function (value) {
            var result = lodashFunc.apply(lodash, arrayPush([value], args));
            return isTaker && chainAll ? result[0] : result;
          };
          if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
            isLazy = useLazy = false;
          }
          var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;
          if (!retUnwrapped && useLazy) {
            value = onlyLazy ? value : new LazyWrapper(this);
            var result = func.apply(value, args);
            result.__actions__.push({
              'func': thru,
              'args': [interceptor],
              'thisArg': undefined$1
            });
            return new LodashWrapper(result, chainAll);
          }
          if (isUnwrapped && onlyLazy) {
            return func.apply(this, args);
          }
          result = this.thru(interceptor);
          return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
        };
      });
      arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function (methodName) {
        var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
        lodash.prototype[methodName] = function () {
          var args = arguments;
          if (retUnwrapped && !this.__chain__) {
            var value = this.value();
            return func.apply(isArray(value) ? value : [], args);
          }
          return this[chainName](function (value) {
            return func.apply(isArray(value) ? value : [], args);
          });
        };
      });
      baseForOwn(LazyWrapper.prototype, function (func, methodName) {
        var lodashFunc = lodash[methodName];
        if (lodashFunc) {
          var key = lodashFunc.name + '';
          if (!hasOwnProperty.call(realNames, key)) {
            realNames[key] = [];
          }
          realNames[key].push({
            'name': methodName,
            'func': lodashFunc
          });
        }
      });
      realNames[createHybrid(undefined$1, WRAP_BIND_KEY_FLAG).name] = [{
        'name': 'wrapper',
        'func': undefined$1
      }];
      LazyWrapper.prototype.clone = lazyClone;
      LazyWrapper.prototype.reverse = lazyReverse;
      LazyWrapper.prototype.value = lazyValue;
      lodash.prototype.at = wrapperAt;
      lodash.prototype.chain = wrapperChain;
      lodash.prototype.commit = wrapperCommit;
      lodash.prototype.next = wrapperNext;
      lodash.prototype.plant = wrapperPlant;
      lodash.prototype.reverse = wrapperReverse;
      lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
      lodash.prototype.first = lodash.prototype.head;
      if (symIterator) {
        lodash.prototype[symIterator] = wrapperToIterator;
      }
      return lodash;
    };
    var _ = runInContext();
    if (freeModule) {
      (freeModule.exports = _)._ = _;
      freeExports._ = _;
    } else {
      root._ = _;
    }
  }).call(commonjsGlobal);
});

const VideoTraining = ({
  formType
}) => {
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [videoTrainingUrl, setVideoTrainingUrl] = useState([]);
  const [showErrors, setShowErrors] = useState(false);
  const fetchManualData = async () => {
    try {
      var _response$data;
      const dataToSend = {
        RequestInfo: {
          apiId: "Rainmaker",
          action: "_create",
          did: 1,
          key: "",
          msgId: "20170310130900|en_IN",
          ts: 0,
          ver: ".01"
        }
      };
      const response = await axios.post(`${Urls$1.UserManualSearch}?isApproved=${formType}&isSubApproved=Training Video`, dataToSend);
      console.log("📘 Response From Training Video API:", response.data);
      setTableData(((_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.UserManual) || []);
    } catch (error) {
      console.error("❌ Error fetching Training Video data:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchManualData();
  }, [formType]);
  if (loading) {
    return /*#__PURE__*/React__default.createElement(Paper, {
      elevation: 0,
      sx: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: 180,
        backgroundColor: "#f8fafc"
      }
    }, /*#__PURE__*/React__default.createElement(CircularProgress, {
      size: 28,
      sx: {
        color: "#0c5a88"
      }
    }), /*#__PURE__*/React__default.createElement(Typography$1, {
      sx: {
        ml: 2,
        color: "#0c5a88"
      }
    }, "Loading documents..."));
  }
  return /*#__PURE__*/React__default.createElement(TableContainer, {
    component: Paper,
    sx: {
      maxHeight: 300,
      overflow: "auto",
      borderRadius: 2,
      boxShadow: 1
    }
  }, /*#__PURE__*/React__default.createElement(Table, {
    size: "small"
  }, /*#__PURE__*/React__default.createElement(TableHead, {
    sx: {
      backgroundColor: "#e0edf8"
    }
  }, /*#__PURE__*/React__default.createElement(TableRow, null, /*#__PURE__*/React__default.createElement(TableCell, {
    sx: {
      fontWeight: 600
    }
  }, "S.No."), /*#__PURE__*/React__default.createElement(TableCell, {
    sx: {
      fontWeight: 600
    }
  }, "Category"), /*#__PURE__*/React__default.createElement(TableCell, {
    sx: {
      fontWeight: 600
    }
  }, "Training Video"), /*#__PURE__*/React__default.createElement(TableCell, {
    sx: {
      fontWeight: 600
    }
  }, "Description"), /*#__PURE__*/React__default.createElement(TableCell, {
    sx: {
      fontWeight: 600
    }
  }, "Updated On"), /*#__PURE__*/React__default.createElement(TableCell, {
    sx: {
      fontWeight: 600
    }
  }, "Download Link"))), /*#__PURE__*/React__default.createElement(TableBody, null, tableData.length > 0 ? tableData.map((row, index) => {
    var _row$auditDetails;
    return /*#__PURE__*/React__default.createElement(TableRow, {
      key: row.id || index
    }, /*#__PURE__*/React__default.createElement(TableCell, null, index + 1), /*#__PURE__*/React__default.createElement(TableCell, null, row.category || "—"), /*#__PURE__*/React__default.createElement(TableCell, null, row.isSubApproved || "—"), /*#__PURE__*/React__default.createElement(TableCell, null, row.description || "—"), /*#__PURE__*/React__default.createElement(TableCell, null, (_row$auditDetails = row.auditDetails) !== null && _row$auditDetails !== void 0 && _row$auditDetails.createdTime ? new Date(row.auditDetails.createdTime).toLocaleDateString() : "—"), /*#__PURE__*/React__default.createElement(TableCell, null, row.downloadLink ? /*#__PURE__*/React__default.createElement(Link, {
      href: row.downloadLink,
      target: "_blank",
      rel: "noopener",
      sx: {
        color: "#0c5a88",
        fontWeight: 500
      }
    }, "Download") : "—"));
  }) : /*#__PURE__*/React__default.createElement(TableRow, null, /*#__PURE__*/React__default.createElement(TableCell, {
    colSpan: 6,
    align: "center"
  }, "No data available")))));
};

const UserManualPopup = ({
  open,
  onClose
}) => {
  var _Digit$UserService$ge;
  const [activeTab, setActiveTab] = useState(0);
  const userInfo = ((_Digit$UserService$ge = Digit.UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : _Digit$UserService$ge.info) || {};
  const isEmployee = (userInfo === null || userInfo === void 0 ? void 0 : userInfo.type) === "EMPLOYEE";
  const tabs = [{
    label: "User Manual",
    content: /*#__PURE__*/React__default.createElement(UserManualTable, {
      tenantId: "hp",
      formType: "manual"
    })
  }, {
    label: "Video Tutorial",
    content: /*#__PURE__*/React__default.createElement(VideoTutorial, {
      tenantId: "hp",
      formType: "manual"
    })
  }, {
    label: "FAQ",
    content: /*#__PURE__*/React__default.createElement(FAQTable, {
      tenantId: "hp",
      formType: "manual"
    })
  }, {
    label: "SOP",
    content: /*#__PURE__*/React__default.createElement(SOPTable, {
      tenantId: "hp",
      formType: "manual"
    })
  }, {
    label: "Building Byelaws and GO",
    content: /*#__PURE__*/React__default.createElement(BuildingShow, {
      tenantId: "hp",
      formType: "manual"
    })
  }, ...(!isEmployee ? [{
    label: "Training Video",
    content: /*#__PURE__*/React__default.createElement(VideoTraining, {
      tenantId: "hp",
      formType: "manual"
    })
  }, {
    label: "Sample Drawing",
    content: /*#__PURE__*/React__default.createElement(SampleDrawing, {
      tenantId: "hp",
      formType: "manual"
    })
  }] : [])];
  const handleTabChange = (event, newValue) => setActiveTab(newValue);
  useEffect(() => {
    if (activeTab >= tabs.length) {
      setActiveTab(0);
    }
  }, [activeTab, tabs.length]);
  const TabPanel = ({
    children,
    value,
    index
  }) => /*#__PURE__*/React__default.createElement(Box$1, {
    role: "tabpanel",
    hidden: value !== index,
    sx: {
      p: 3,
      backgroundColor: "#fff",
      borderRadius: 1,
      boxShadow: 1,
      minHeight: 240
    }
  }, value === index && children);
  return /*#__PURE__*/React__default.createElement(Dialog, {
    open: open,
    onClose: onClose,
    fullWidth: true,
    maxWidth: "md",
    sx: {
      "& .MuiDialog-paper": {
        borderRadius: 2,
        backgroundColor: "#ebf3fa",
        width: "90%",
        maxWidth: "1200px",
        position: "relative"
      }
    }
  }, /*#__PURE__*/React__default.createElement(IconButton$2, {
    onClick: onClose,
    sx: {
      position: "absolute",
      top: 4,
      right: 4,
      zIndex: 9999,
      color: "#fff",
      backgroundColor: "rgba(255,255,255,0.2)",
      width: 28,
      height: 28,
      "&:hover": {
        backgroundColor: "rgba(255,255,255,0.3)"
      },
      "& .MuiSvgIcon-root": {
        fontSize: "18px"
      }
    }
  }, /*#__PURE__*/React__default.createElement(CloseIcon, null)), /*#__PURE__*/React__default.createElement(DialogTitle, {
    sx: {
      textAlign: "center",
      fontWeight: 600,
      fontSize: "1.3rem",
      background: "linear-gradient(to right, #0c5a88, #1976d2)",
      color: "#fff",
      padding: "12px 20px",
      lineHeight: 1.0,
      position: "relative",
      minHeight: "60px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement(Box$1, {
    sx: {
      position: "absolute",
      left: 20,
      top: 0,
      bottom: 0,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "flex-start",
      textAlign: "left",
      "& span": {
        fontSize: "0.85rem",
        lineHeight: 1.2
      },
      "& a": {
        cursor: "pointer"
      }
    },
    className: "manual-documents-title"
  }, isEmployee && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("span", null, "Contact: 08064522140"), /*#__PURE__*/React__default.createElement("span", null, "Helpdesk: ", /*#__PURE__*/React__default.createElement("a", {
    onClick: () => window.open("https://mainet.abmindia.com/training/", "_blank")
  }, "Click Here")))), /*#__PURE__*/React__default.createElement("div", null, "Manual & Documents")), /*#__PURE__*/React__default.createElement(DialogContent, {
    sx: {
      p: 3
    }
  }, /*#__PURE__*/React__default.createElement(Paper, {
    elevation: 0,
    sx: {
      display: "flex",
      justifyContent: "center",
      backgroundColor: "transparent",
      mb: 2,
      mt: 2
    }
  }, /*#__PURE__*/React__default.createElement(Tabs, {
    value: activeTab,
    onChange: handleTabChange,
    variant: "scrollable",
    scrollButtons: "auto",
    TabIndicatorProps: {
      style: {
        backgroundColor: "#0c5a88"
      }
    },
    sx: {
      "& .MuiTab-root": {
        textTransform: "none",
        fontWeight: 600,
        borderRadius: 1,
        mx: 0.5,
        backgroundColor: "#c5e3f6",
        color: "#0c3d64",
        minWidth: 140,
        "&.Mui-selected": {
          backgroundColor: "#0c5a88",
          color: "#fff"
        }
      }
    }
  }, tabs.map((tab, index) => /*#__PURE__*/React__default.createElement(Tab, {
    key: index,
    label: tab.label
  })))), tabs.map((tab, index) => /*#__PURE__*/React__default.createElement(TabPanel, {
    key: index,
    value: activeTab,
    index: index
  }, tab.content))));
};

const InboxGeneral = {
  Search: ({
    ...filters
  }) => {
    return Request({
      url: Urls.InboxSearch,
      useCache: false,
      method: "POST",
      auth: true,
      userService: true,
      data: {
        ...filters
      }
    });
  }
};

const useInbox = ({
  tenantId,
  filters,
  config
}) => {
  var _Object$keys;
  return useQuery(["INBOX_DATA", tenantId, ...((_Object$keys = Object.keys(filters)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.map(e => filters === null || filters === void 0 ? void 0 : filters[e]))], () => InboxGeneral.Search({
    inbox: {
      ...filters
    }
  }), {
    ...config
  });
};

const useCommonInbox = ({
  tenantId,
  filters,
  config,
  userBusinessServices
}) => {
  var _Digit$UserService$ge, _Digit$UserService$ge2;
  const {
    applicationStatus,
    mobileNumber,
    applicationNumber,
    sortBy,
    sortOrder,
    locality,
    uuid,
    limit,
    offset
  } = filters;
  const USER_UUID = (_Digit$UserService$ge = Digit.UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : (_Digit$UserService$ge2 = _Digit$UserService$ge.info) === null || _Digit$UserService$ge2 === void 0 ? void 0 : _Digit$UserService$ge2.uuid;
  const _filters = {
    tenantId,
    processSearchCriteria: {
      moduleName: "bpa-services",
      businessService: userBusinessServices,
      ...((applicationStatus === null || applicationStatus === void 0 ? void 0 : applicationStatus.length) > 0 ? {
        status: applicationStatus
      } : {}),
      ...(uuid && Object.keys(uuid).length > 0 ? {
        assignee: uuid.code === "ASSIGNED_TO_ME" ? USER_UUID : ""
      } : {})
    },
    moduleSearchCriteria: {
      ...(mobileNumber ? {
        mobileNumber
      } : {}),
      ...(applicationNumber ? {
        applicationNumber
      } : {}),
      ...(sortBy ? {
        sortBy
      } : {}),
      ...(sortOrder ? {
        sortOrder
      } : {}),
      ...((locality === null || locality === void 0 ? void 0 : locality.length) > 0 ? {
        locality: locality.map(item => item.name.split("_").pop()).join(",")
      } : {})
    },
    limit,
    offset
  };
  return useInbox({
    tenantId,
    filters: _filters,
    config: {
      select: data => {
        var _data$items;
        return {
          statuses: data.statusMap,
          table: data === null || data === void 0 ? void 0 : (_data$items = data.items) === null || _data$items === void 0 ? void 0 : _data$items.map(application => {
            var _application$business, _application$business2, _application$business3, _application$business4, _application$business5, _application$business6, _application$business7, _application$business8, _application$business9, _application$business10, _application$business11, _application$business12, _application$business13, _application$business14, _application$business15, _application$business16, _application$business17, _application$business18, _application$business19, _application$business20, _application$business21, _application$business22, _application$business23, _application$business24, _application$business25, _application$business26, _application$business27, _application$business28, _application$business29, _application$business30, _application$business31, _application$business32, _application$ProcessI, _application$ProcessI2, _application$ProcessI3, _application$business33, _application$business34, _application$business35, _application$business36, _application$business37, _application$business38, _application$business39, _application$business40, _application$business41, _application$business42, _application$ProcessI4, _application$ProcessI5, _application$ProcessI6;
            return {
              applicationId: application === null || application === void 0 ? void 0 : (_application$business = application.businessObject) === null || _application$business === void 0 ? void 0 : _application$business.applicationNo,
              date: application === null || application === void 0 ? void 0 : (_application$business2 = application.businessObject) === null || _application$business2 === void 0 ? void 0 : (_application$business3 = _application$business2.auditDetails) === null || _application$business3 === void 0 ? void 0 : _application$business3.createdTime,
              businessService: application === null || application === void 0 ? void 0 : (_application$business4 = application.businessObject) === null || _application$business4 === void 0 ? void 0 : _application$business4.businessService,
              status: application === null || application === void 0 ? void 0 : (_application$business5 = application.businessObject) === null || _application$business5 === void 0 ? void 0 : _application$business5.status,
              proposedActivity: application === null || application === void 0 ? void 0 : (_application$business6 = application.businessObject) === null || _application$business6 === void 0 ? void 0 : _application$business6.activityProposed,
              plotArea: (application === null || application === void 0 ? void 0 : (_application$business7 = application.businessObject) === null || _application$business7 === void 0 ? void 0 : _application$business7.plotArea) || (application === null || application === void 0 ? void 0 : (_application$business8 = application.businessObject) === null || _application$business8 === void 0 ? void 0 : (_application$business9 = _application$business8.descriptionOfLand) === null || _application$business9 === void 0 ? void 0 : _application$business9.landArea) || (application === null || application === void 0 ? void 0 : (_application$business10 = application.businessObject) === null || _application$business10 === void 0 ? void 0 : (_application$business11 = _application$business10.descriptionOfLand) === null || _application$business11 === void 0 ? void 0 : _application$business11.totalPlotArea),
              schemeName: application === null || application === void 0 ? void 0 : (_application$business12 = application.businessObject) === null || _application$business12 === void 0 ? void 0 : _application$business12.schemeName,
              plotNo: (application === null || application === void 0 ? void 0 : (_application$business13 = application.businessObject) === null || _application$business13 === void 0 ? void 0 : _application$business13.plotNo) || (application === null || application === void 0 ? void 0 : (_application$business14 = application.businessObject) === null || _application$business14 === void 0 ? void 0 : (_application$business15 = _application$business14.descriptionOfLand) === null || _application$business15 === void 0 ? void 0 : (_application$business16 = _application$business15.khasraDetails) === null || _application$business16 === void 0 ? void 0 : (_application$business17 = _application$business16[0]) === null || _application$business17 === void 0 ? void 0 : _application$business17.plotNo),
              owner: application === null || application === void 0 ? void 0 : (_application$business18 = application.businessObject) === null || _application$business18 === void 0 ? void 0 : (_application$business19 = _application$business18.landInfo) === null || _application$business19 === void 0 ? void 0 : (_application$business20 = _application$business19.owners) === null || _application$business20 === void 0 ? void 0 : (_application$business21 = _application$business20[0]) === null || _application$business21 === void 0 ? void 0 : _application$business21.name,
              emailId: application === null || application === void 0 ? void 0 : (_application$business22 = application.businessObject) === null || _application$business22 === void 0 ? void 0 : (_application$business23 = _application$business22.landInfo) === null || _application$business23 === void 0 ? void 0 : (_application$business24 = _application$business23.owners) === null || _application$business24 === void 0 ? void 0 : (_application$business25 = _application$business24[0]) === null || _application$business25 === void 0 ? void 0 : _application$business25.emailId,
              applicationType: application === null || application === void 0 ? void 0 : (_application$business26 = application.businessObject) === null || _application$business26 === void 0 ? void 0 : _application$business26.applicationType,
              userPhoto: application === null || application === void 0 ? void 0 : (_application$business27 = application.businessObject) === null || _application$business27 === void 0 ? void 0 : (_application$business28 = _application$business27.landInfo) === null || _application$business28 === void 0 ? void 0 : (_application$business29 = _application$business28.owners) === null || _application$business29 === void 0 ? void 0 : (_application$business30 = _application$business29[0]) === null || _application$business30 === void 0 ? void 0 : _application$business30.photo,
              location: application === null || application === void 0 ? void 0 : (_application$business31 = application.businessObject) === null || _application$business31 === void 0 ? void 0 : _application$business31.location1,
              registrationNo: application === null || application === void 0 ? void 0 : (_application$business32 = application.businessObject) === null || _application$business32 === void 0 ? void 0 : _application$business32.registrationNo,
              nextAction: application === null || application === void 0 ? void 0 : (_application$ProcessI = application.ProcessInstance) === null || _application$ProcessI === void 0 ? void 0 : (_application$ProcessI2 = _application$ProcessI.nextActions) === null || _application$ProcessI2 === void 0 ? void 0 : (_application$ProcessI3 = _application$ProcessI2[0]) === null || _application$ProcessI3 === void 0 ? void 0 : _application$ProcessI3.action,
              department: application === null || application === void 0 ? void 0 : (_application$business33 = application.businessObject) === null || _application$business33 === void 0 ? void 0 : _application$business33.department,
              land_Id: application === null || application === void 0 ? void 0 : (_application$business34 = application.businessObject) === null || _application$business34 === void 0 ? void 0 : _application$business34.land_Id,
              ltpName: (application === null || application === void 0 ? void 0 : (_application$business35 = application.businessObject) === null || _application$business35 === void 0 ? void 0 : (_application$business36 = _application$business35.professionaldetails) === null || _application$business36 === void 0 ? void 0 : _application$business36.name) || (application === null || application === void 0 ? void 0 : (_application$business37 = application.businessObject) === null || _application$business37 === void 0 ? void 0 : (_application$business38 = _application$business37.professionalInformation) === null || _application$business38 === void 0 ? void 0 : _application$business38.name),
              recievedTime: application === null || application === void 0 ? void 0 : (_application$business39 = application.businessObject) === null || _application$business39 === void 0 ? void 0 : (_application$business40 = _application$business39.auditDetails) === null || _application$business40 === void 0 ? void 0 : _application$business40.lastModifiedTime,
              selectedUnit: application === null || application === void 0 ? void 0 : (_application$business41 = application.businessObject) === null || _application$business41 === void 0 ? void 0 : _application$business41.selectedUnit,
              isGovernmentBuilding: (application === null || application === void 0 ? void 0 : (_application$business42 = application.businessObject) === null || _application$business42 === void 0 ? void 0 : _application$business42.isGovernmentBuilding) === "yes",
              ProcessInstance: application === null || application === void 0 ? void 0 : application.ProcessInstance,
              businessObject: application === null || application === void 0 ? void 0 : application.businessObject,
              isAutoForwarded: Boolean(application === null || application === void 0 ? void 0 : (_application$ProcessI4 = application.ProcessInstance) === null || _application$ProcessI4 === void 0 ? void 0 : (_application$ProcessI5 = _application$ProcessI4.assigner) === null || _application$ProcessI5 === void 0 ? void 0 : (_application$ProcessI6 = _application$ProcessI5.roles) === null || _application$ProcessI6 === void 0 ? void 0 : _application$ProcessI6.some(role => (role === null || role === void 0 ? void 0 : role.code) === "WF_ADMIN_ESCLATE" || (role === null || role === void 0 ? void 0 : role.name) === "Admin Escalation" || typeof role === "string" && (role === "WF_ADMIN_ESCLATE" || role.includes("WF_ADMIN_ESCLATE"))))
            };
          }),
          totalCount: data === null || data === void 0 ? void 0 : data.totalCount
        };
      },
      ...config
    }
  });
};

const useNOCInbox = ({
  tenantId,
  filters,
  config,
  userBusinessServices
}) => {
  var _Digit$UserService$ge, _Digit$UserService$ge2;
  const {
    applicationStatus,
    mobileNumber,
    applicationNumber,
    sortBy,
    sortOrder,
    locality,
    uuid,
    limit,
    offset
  } = filters;
  const USER_UUID = (_Digit$UserService$ge = Digit.UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : (_Digit$UserService$ge2 = _Digit$UserService$ge.info) === null || _Digit$UserService$ge2 === void 0 ? void 0 : _Digit$UserService$ge2.uuid;
  console.log("userInfoFromNOCInbox", Digit.UserService.getUser(), userBusinessServices);
  const _filters = {
    tenantId,
    processSearchCriteria: {
      moduleName: "noc-services",
      businessService: [userBusinessServices],
      ...((applicationStatus === null || applicationStatus === void 0 ? void 0 : applicationStatus.length) > 0 ? {
        status: applicationStatus
      } : {}),
      ...(uuid && Object.keys(uuid).length > 0 ? {
        assignee: uuid.code === "ASSIGNED_TO_ME" ? USER_UUID : ""
      } : {})
    },
    moduleSearchCriteria: {
      ...(mobileNumber ? {
        mobileNumber
      } : {}),
      ...(applicationNumber ? {
        applicationNumber
      } : {}),
      ...(sortBy ? {
        sortBy
      } : {}),
      ...(sortOrder ? {
        sortOrder
      } : {}),
      ...((locality === null || locality === void 0 ? void 0 : locality.length) > 0 ? {
        locality: locality.map(item => item.name.split("_").pop()).join(",")
      } : {})
    },
    limit,
    offset
  };
  return useInbox({
    tenantId,
    filters: _filters,
    config: {
      select: data => {
        var _data$items;
        return {
          statuses: data.statusMap,
          table: data === null || data === void 0 ? void 0 : (_data$items = data.items) === null || _data$items === void 0 ? void 0 : _data$items.map(application => {
            var _application$business, _application$business2, _application$business3, _application$ProcessI, _application$business4, _application$business5, _application$business6, _application$business7, _application$business8, _application$business9, _application$business10, _application$business11, _application$business12, _application$business13, _application$business14, _application$business15, _application$business16, _application$business17, _application$business18, _application$business19, _application$business20, _application$ProcessI2, _application$ProcessI3, _application$ProcessI4, _application$business21, _application$business22, _application$business23, _application$business24, _application$business25, _application$business26, _application$business27, _application$business28, _application$business29, _application$business30, _application$ProcessI5, _application$ProcessI6, _application$ProcessI7;
            return {
              applicationId: application === null || application === void 0 ? void 0 : (_application$business = application.businessObject) === null || _application$business === void 0 ? void 0 : _application$business.applicationNo,
              date: application === null || application === void 0 ? void 0 : (_application$business2 = application.businessObject) === null || _application$business2 === void 0 ? void 0 : (_application$business3 = _application$business2.auditDetails) === null || _application$business3 === void 0 ? void 0 : _application$business3.createdTime,
              businessService: application === null || application === void 0 ? void 0 : (_application$ProcessI = application.ProcessInstance) === null || _application$ProcessI === void 0 ? void 0 : _application$ProcessI.businessService,
              status: application === null || application === void 0 ? void 0 : (_application$business4 = application.businessObject) === null || _application$business4 === void 0 ? void 0 : _application$business4.applicationStatus,
              owner: application === null || application === void 0 ? void 0 : (_application$business5 = application.businessObject) === null || _application$business5 === void 0 ? void 0 : (_application$business6 = _application$business5.landInfo) === null || _application$business6 === void 0 ? void 0 : (_application$business7 = _application$business6.owners) === null || _application$business7 === void 0 ? void 0 : (_application$business8 = _application$business7[0]) === null || _application$business8 === void 0 ? void 0 : _application$business8.name,
              applicationType: application === null || application === void 0 ? void 0 : (_application$business9 = application.businessObject) === null || _application$business9 === void 0 ? void 0 : _application$business9.applicationType,
              userPhoto: application === null || application === void 0 ? void 0 : (_application$business10 = application.businessObject) === null || _application$business10 === void 0 ? void 0 : (_application$business11 = _application$business10.landInfo) === null || _application$business11 === void 0 ? void 0 : (_application$business12 = _application$business11.owners) === null || _application$business12 === void 0 ? void 0 : (_application$business13 = _application$business12[0]) === null || _application$business13 === void 0 ? void 0 : _application$business13.photo,
              plotNo: (application === null || application === void 0 ? void 0 : (_application$business14 = application.businessObject) === null || _application$business14 === void 0 ? void 0 : _application$business14.plotNo) || (application === null || application === void 0 ? void 0 : (_application$business15 = application.businessObject) === null || _application$business15 === void 0 ? void 0 : (_application$business16 = _application$business15.descriptionOfLand) === null || _application$business16 === void 0 ? void 0 : (_application$business17 = _application$business16.khasraDetails) === null || _application$business17 === void 0 ? void 0 : (_application$business18 = _application$business17[0]) === null || _application$business18 === void 0 ? void 0 : _application$business18.plotNo),
              location: application === null || application === void 0 ? void 0 : (_application$business19 = application.businessObject) === null || _application$business19 === void 0 ? void 0 : _application$business19.location1,
              registrationNo: application === null || application === void 0 ? void 0 : (_application$business20 = application.businessObject) === null || _application$business20 === void 0 ? void 0 : _application$business20.registrationNo,
              nextAction: application === null || application === void 0 ? void 0 : (_application$ProcessI2 = application.ProcessInstance) === null || _application$ProcessI2 === void 0 ? void 0 : (_application$ProcessI3 = _application$ProcessI2.nextActions) === null || _application$ProcessI3 === void 0 ? void 0 : (_application$ProcessI4 = _application$ProcessI3[0]) === null || _application$ProcessI4 === void 0 ? void 0 : _application$ProcessI4.action,
              department: application === null || application === void 0 ? void 0 : (_application$business21 = application.businessObject) === null || _application$business21 === void 0 ? void 0 : _application$business21.department,
              land_Id: application === null || application === void 0 ? void 0 : (_application$business22 = application.businessObject) === null || _application$business22 === void 0 ? void 0 : _application$business22.land_Id,
              ltpName: (application === null || application === void 0 ? void 0 : (_application$business23 = application.businessObject) === null || _application$business23 === void 0 ? void 0 : (_application$business24 = _application$business23.professionaldetails) === null || _application$business24 === void 0 ? void 0 : _application$business24.name) || (application === null || application === void 0 ? void 0 : (_application$business25 = application.businessObject) === null || _application$business25 === void 0 ? void 0 : (_application$business26 = _application$business25.professionalInformation) === null || _application$business26 === void 0 ? void 0 : _application$business26.name),
              recievedTime: application === null || application === void 0 ? void 0 : (_application$business27 = application.businessObject) === null || _application$business27 === void 0 ? void 0 : (_application$business28 = _application$business27.auditDetails) === null || _application$business28 === void 0 ? void 0 : _application$business28.lastModifiedTime,
              sourceRefId: application === null || application === void 0 ? void 0 : (_application$business29 = application.businessObject) === null || _application$business29 === void 0 ? void 0 : _application$business29.sourceRefId,
              selectedUnit: application === null || application === void 0 ? void 0 : (_application$business30 = application.businessObject) === null || _application$business30 === void 0 ? void 0 : _application$business30.selectedUnit,
              ProcessInstance: application === null || application === void 0 ? void 0 : application.ProcessInstance,
              businessObject: application === null || application === void 0 ? void 0 : application.businessObject,
              isAutoForwarded: Boolean(application === null || application === void 0 ? void 0 : (_application$ProcessI5 = application.ProcessInstance) === null || _application$ProcessI5 === void 0 ? void 0 : (_application$ProcessI6 = _application$ProcessI5.assigner) === null || _application$ProcessI6 === void 0 ? void 0 : (_application$ProcessI7 = _application$ProcessI6.roles) === null || _application$ProcessI7 === void 0 ? void 0 : _application$ProcessI7.some(role => (role === null || role === void 0 ? void 0 : role.code) === "WF_ADMIN_ESCLATE" || (role === null || role === void 0 ? void 0 : role.name) === "Admin Escalation" || typeof role === "string" && (role === "WF_ADMIN_ESCLATE" || role.includes("WF_ADMIN_ESCLATE"))))
            };
          }),
          totalCount: data === null || data === void 0 ? void 0 : data.totalCount
        };
      },
      ...config
    }
  });
};

const useTPInbox = ({
  tenantId,
  filters,
  config
}) => {
  var _Digit$UserService$ge, _Digit$UserService$ge2;
  const {
    applicationStatus,
    mobileNumber,
    applicationNumber,
    sortBy,
    sortOrder,
    locality,
    uuid,
    limit,
    offset
  } = filters;
  const USER_UUID = (_Digit$UserService$ge = Digit.UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : (_Digit$UserService$ge2 = _Digit$UserService$ge.info) === null || _Digit$UserService$ge2 === void 0 ? void 0 : _Digit$UserService$ge2.uuid;
  const _filters = {
    tenantId,
    processSearchCriteria: {
      moduleName: "BPAREG",
      businessService: ["BPAREG"],
      assignee: "",
      ...((applicationStatus === null || applicationStatus === void 0 ? void 0 : applicationStatus.length) > 0 ? {
        status: applicationStatus
      } : {}),
      ...(uuid && Object.keys(uuid).length > 0 ? {
        assignee: uuid.code === "ASSIGNED_TO_ME" ? USER_UUID : ""
      } : {})
    },
    moduleSearchCriteria: {
      sortOrder: "DESC",
      ...(mobileNumber ? {
        mobileNumber
      } : {}),
      ...(applicationNumber ? {
        applicationNumber
      } : {}),
      ...(sortBy ? {
        sortBy
      } : {}),
      ...((locality === null || locality === void 0 ? void 0 : locality.length) > 0 ? {
        locality: locality.map(item => item.code.split("_").pop()).join(",")
      } : {})
    },
    limit,
    offset
  };
  return useInbox({
    tenantId,
    filters: _filters,
    config: {
      select: data => {
        var _data$items;
        return {
          statuses: data.statusMap,
          table: data === null || data === void 0 ? void 0 : (_data$items = data.items) === null || _data$items === void 0 ? void 0 : _data$items.map(application => {
            var _application$business, _application$business2, _application$business3, _application$business4, _application$business5, _application$business6, _application$business7, _application$business8, _application$business9, _application$business10, _application$business11, _application$business12, _application$business13, _application$business14, _application$business15, _application$business16, _application$business17, _application$business18, _application$business19, _application$business20, _application$business21, _application$business22, _application$business23, _application$business24, _application$business25, _application$business26, _application$business27, _application$business28, _application$business29, _application$business30, _application$business31, _application$business32, _application$business33, _application$business34, _application$ProcessI, _application$ProcessI2, _application$ProcessI3, _application$ProcessI4, _application$ProcessI5;
            return {
              applicationId: application === null || application === void 0 ? void 0 : (_application$business = application.businessObject) === null || _application$business === void 0 ? void 0 : _application$business.applicationNumber,
              date: application === null || application === void 0 ? void 0 : (_application$business2 = application.businessObject) === null || _application$business2 === void 0 ? void 0 : (_application$business3 = _application$business2.auditDetails) === null || _application$business3 === void 0 ? void 0 : _application$business3.createdTime,
              businessService: application === null || application === void 0 ? void 0 : (_application$business4 = application.businessObject) === null || _application$business4 === void 0 ? void 0 : _application$business4.businessService,
              locality: `${application === null || application === void 0 ? void 0 : (_application$business5 = application.businessObject) === null || _application$business5 === void 0 ? void 0 : (_application$business6 = _application$business5.tenantId) === null || _application$business6 === void 0 ? void 0 : (_application$business7 = _application$business6.toUpperCase()) === null || _application$business7 === void 0 ? void 0 : (_application$business8 = _application$business7.split(".")) === null || _application$business8 === void 0 ? void 0 : _application$business8.join("_")}_REVENUE_${application === null || application === void 0 ? void 0 : (_application$business9 = application.businessObject) === null || _application$business9 === void 0 ? void 0 : (_application$business10 = _application$business9.tenantId) === null || _application$business10 === void 0 ? void 0 : _application$business10.toUpperCase()}`,
              status: application === null || application === void 0 ? void 0 : (_application$business11 = application.businessObject) === null || _application$business11 === void 0 ? void 0 : _application$business11.status,
              approvalLetter: application === null || application === void 0 ? void 0 : (_application$business12 = application.businessObject) === null || _application$business12 === void 0 ? void 0 : _application$business12.approvalLetterUrl,
              registrationType: application === null || application === void 0 ? void 0 : (_application$business13 = application.businessObject) === null || _application$business13 === void 0 ? void 0 : _application$business13.registrationType,
              owner: application === null || application === void 0 ? void 0 : (_application$business14 = application.businessObject) === null || _application$business14 === void 0 ? void 0 : (_application$business15 = _application$business14.tradeLicenseDetail) === null || _application$business15 === void 0 ? void 0 : (_application$business16 = _application$business15.owners) === null || _application$business16 === void 0 ? void 0 : (_application$business17 = _application$business16[0]) === null || _application$business17 === void 0 ? void 0 : _application$business17.name,
              dairyNo: application === null || application === void 0 ? void 0 : (_application$business18 = application.businessObject) === null || _application$business18 === void 0 ? void 0 : _application$business18.tcpDairyNumber,
              plotNo: (application === null || application === void 0 ? void 0 : (_application$business19 = application.businessObject) === null || _application$business19 === void 0 ? void 0 : _application$business19.plotNo) || (application === null || application === void 0 ? void 0 : (_application$business20 = application.businessObject) === null || _application$business20 === void 0 ? void 0 : (_application$business21 = _application$business20.descriptionOfLand) === null || _application$business21 === void 0 ? void 0 : (_application$business22 = _application$business21.khasraDetails) === null || _application$business22 === void 0 ? void 0 : (_application$business23 = _application$business22[0]) === null || _application$business23 === void 0 ? void 0 : _application$business23.plotNo),
              applicationType: application === null || application === void 0 ? void 0 : (_application$business24 = application.businessObject) === null || _application$business24 === void 0 ? void 0 : _application$business24.licenseType,
              userPhoto: application === null || application === void 0 ? void 0 : (_application$business25 = application.businessObject) === null || _application$business25 === void 0 ? void 0 : (_application$business26 = _application$business25.tradeLicenseDetail) === null || _application$business26 === void 0 ? void 0 : (_application$business27 = _application$business26.owners) === null || _application$business27 === void 0 ? void 0 : (_application$business28 = _application$business27[0]) === null || _application$business28 === void 0 ? void 0 : _application$business28.photo,
              ltpName: (application === null || application === void 0 ? void 0 : (_application$business29 = application.businessObject) === null || _application$business29 === void 0 ? void 0 : (_application$business30 = _application$business29.professionaldetails) === null || _application$business30 === void 0 ? void 0 : _application$business30.name) || (application === null || application === void 0 ? void 0 : (_application$business31 = application.businessObject) === null || _application$business31 === void 0 ? void 0 : (_application$business32 = _application$business31.professionalInformation) === null || _application$business32 === void 0 ? void 0 : _application$business32.name),
              recievedTime: application === null || application === void 0 ? void 0 : (_application$business33 = application.businessObject) === null || _application$business33 === void 0 ? void 0 : (_application$business34 = _application$business33.auditDetails) === null || _application$business34 === void 0 ? void 0 : _application$business34.lastModifiedTime,
              sla: Math.round((application === null || application === void 0 ? void 0 : (_application$ProcessI = application.ProcessInstance) === null || _application$ProcessI === void 0 ? void 0 : _application$ProcessI.businesssServiceSla) / (24 * 60 * 60 * 1000)),
              stateSla: Math.round((application === null || application === void 0 ? void 0 : (_application$ProcessI2 = application.ProcessInstance) === null || _application$ProcessI2 === void 0 ? void 0 : _application$ProcessI2.stateSla) / (24 * 60 * 60 * 1000)),
              ProcessInstance: application === null || application === void 0 ? void 0 : application.ProcessInstance,
              businessObject: application === null || application === void 0 ? void 0 : application.businessObject,
              isAutoForwarded: Boolean(application === null || application === void 0 ? void 0 : (_application$ProcessI3 = application.ProcessInstance) === null || _application$ProcessI3 === void 0 ? void 0 : (_application$ProcessI4 = _application$ProcessI3.assigner) === null || _application$ProcessI4 === void 0 ? void 0 : (_application$ProcessI5 = _application$ProcessI4.roles) === null || _application$ProcessI5 === void 0 ? void 0 : _application$ProcessI5.some(role => (role === null || role === void 0 ? void 0 : role.code) === "WF_ADMIN_ESCLATE" || (role === null || role === void 0 ? void 0 : role.name) === "Admin Escalation" || typeof role === "string" && (role === "WF_ADMIN_ESCLATE" || role.includes("WF_ADMIN_ESCLATE"))))
            };
          }),
          totalCount: data === null || data === void 0 ? void 0 : data.totalCount
        };
      },
      ...config
    }
  });
};

const isMobile = window.innerWidth <= 768;
const nocDepartmentRoles = ["Acquisition_Section_Incharge", "Nazul_Section_Incharge", "Improvement_Trust_Incharge", "Property_Section_Incharge", "Urban_Ceiling_Incharge", "Tehsildar", "AAI_General_Manager", "Army_Airforce_Station_Officer", "Fire_Chief_Officer", "Irrigation_Executive_Officer", "UPMRC_MD", "Forest_District_Officer", "Railways_Section_Engineer", "Power_Executive_Engineer", "NHAI_Project_Director", "PWD_Executive_Engineer", "ASI_Superintendent", "Jail_Superintendent", "ULB_Nagar_Aayukt", "Environment_UPPCB_Secretary", "Security_ADG", "UPAVP_Chief_Architect"];
const fetchApplications = (tenantId, userBusinessServices, officerRole) => {
  var _sortParams$, _sortParams$2, _sortParams$3, _sortParams$4;
  const [sortParams, setSortParams] = useState([{
    id: "applicationDate",
    desc: false
  }]);
  const [pageSize, setPageSize] = useState(3000);
  const [pageOffset, setPageOffset] = useState(0);
  const [searchParams, setSearchParams] = useState({});
  const hasAuthorizedRoles = officerRole === null || officerRole === void 0 ? void 0 : officerRole.some(role => role.code === "NODAL_OFFICER_AWAS" || role.code === "Nodal Officer");
  const paginationParams = isMobile ? {
    limit: 100,
    offset: 0,
    sortBy: (_sortParams$ = sortParams[0]) === null || _sortParams$ === void 0 ? void 0 : _sortParams$.id,
    sortOrder: (_sortParams$2 = sortParams[0]) !== null && _sortParams$2 !== void 0 && _sortParams$2.desc ? "DESC" : "ASC"
  } : {
    limit: pageSize,
    offset: pageOffset,
    sortBy: (_sortParams$3 = sortParams[0]) === null || _sortParams$3 === void 0 ? void 0 : _sortParams$3.id,
    sortOrder: (_sortParams$4 = sortParams[0]) !== null && _sortParams$4 !== void 0 && _sortParams$4.desc ? "DESC" : "ASC"
  };
  const isNocDepartment = officerRole === null || officerRole === void 0 ? void 0 : officerRole.some(role => nocDepartmentRoles.includes(role.code));
  console.log("isNOCDepartment", isNocDepartment, userBusinessServices);
  const {
    isFetching,
    isLoading: hookLoading,
    searchResponseKey,
    data,
    searchFields,
    ...rest
  } = hasAuthorizedRoles ? useTPInbox({
    tenantId,
    filters: {
      ...searchParams,
      ...paginationParams,
      sortParams
    },
    config: {
      staleTime: 0,
      cacheTime: 0,
      refetchOnMount: true,
      refetchOnWindowFocus: false,
      refetchOnReconnect: true
    }
  }) : isNocDepartment ? useNOCInbox({
    tenantId,
    userBusinessServices,
    filters: {
      ...searchParams,
      ...paginationParams,
      sortParams
    },
    config: {
      enabled: !!userBusinessServices,
      staleTime: 0,
      cacheTime: 0,
      refetchOnMount: true,
      refetchOnWindowFocus: false,
      refetchOnReconnect: true
    }
  }) : useCommonInbox({
    tenantId,
    userBusinessServices,
    filters: {
      ...searchParams,
      ...paginationParams,
      sortParams,
      uuid: {
        code: "ASSIGNED_TO_ME"
      }
    },
    config: {
      enabled: !!userBusinessServices,
      staleTime: 0,
      cacheTime: 0,
      refetchOnMount: true,
      refetchOnWindowFocus: false,
      refetchOnReconnect: true
    }
  });
  return {
    applications: data || [],
    isOfficerLTP: hasAuthorizedRoles,
    isFetching
  };
};

const TabPanel = ({
  children,
  value,
  index,
  ...rest
}) => {
  return /*#__PURE__*/React__default.createElement(Box$2, Object.assign({
    role: "tabpanel",
    hidden: value !== index,
    id: `full-width-tabpanel-${index}`
  }, rest), value === index && /*#__PURE__*/React__default.createElement(Box$2, {
    sx: {
      p: 2
    }
  }, children));
};
TabPanel.propTypes = {
  children: propTypes.node.isRequired,
  value: propTypes.oneOfType([propTypes.string, propTypes.number]),
  index: propTypes.oneOfType([propTypes.string, propTypes.number])
};
TabPanel.defaultProps = {
  value: "0",
  index: "0"
};

var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
var _freeGlobal = freeGlobal;

var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
var root = _freeGlobal || freeSelf || Function('return this')();
var _root = root;

var Symbol$1 = _root.Symbol;
var _Symbol = Symbol$1;

var objectProto = Object.prototype;
var hasOwnProperty$1 = objectProto.hasOwnProperty;
var nativeObjectToString = objectProto.toString;
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;
function getRawTag(value) {
  var isOwn = hasOwnProperty$1.call(value, symToStringTag),
    tag = value[symToStringTag];
  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}
  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}
var _getRawTag = getRawTag;

var objectProto$1 = Object.prototype;
var nativeObjectToString$1 = objectProto$1.toString;
function objectToString(value) {
  return nativeObjectToString$1.call(value);
}
var _objectToString = objectToString;

var nullTag = '[object Null]',
  undefinedTag = '[object Undefined]';
var symToStringTag$1 = _Symbol ? _Symbol.toStringTag : undefined;
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return symToStringTag$1 && symToStringTag$1 in Object(value) ? _getRawTag(value) : _objectToString(value);
}
var _baseGetTag = baseGetTag;

function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}
var isObject_1 = isObject;

var asyncTag = '[object AsyncFunction]',
  funcTag = '[object Function]',
  genTag = '[object GeneratorFunction]',
  proxyTag = '[object Proxy]';
function isFunction(value) {
  if (!isObject_1(value)) {
    return false;
  }
  var tag = _baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
var isFunction_1 = isFunction;

var coreJsData = _root['__core-js_shared__'];
var _coreJsData = coreJsData;

var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(_coreJsData && _coreJsData.keys && _coreJsData.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();
function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}
var _isMasked = isMasked;

var funcProto = Function.prototype;
var funcToString = funcProto.toString;
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return func + '';
    } catch (e) {}
  }
  return '';
}
var _toSource = toSource;

var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
var reIsHostCtor = /^\[object .+?Constructor\]$/;
var funcProto$1 = Function.prototype,
  objectProto$2 = Object.prototype;
var funcToString$1 = funcProto$1.toString;
var hasOwnProperty$2 = objectProto$2.hasOwnProperty;
var reIsNative = RegExp('^' + funcToString$1.call(hasOwnProperty$2).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
function baseIsNative(value) {
  if (!isObject_1(value) || _isMasked(value)) {
    return false;
  }
  var pattern = isFunction_1(value) ? reIsNative : reIsHostCtor;
  return pattern.test(_toSource(value));
}
var _baseIsNative = baseIsNative;

function getValue(object, key) {
  return object == null ? undefined : object[key];
}
var _getValue = getValue;

function getNative(object, key) {
  var value = _getValue(object, key);
  return _baseIsNative(value) ? value : undefined;
}
var _getNative = getNative;

var Map = _getNative(_root, 'Map');
var _Map = Map;

var nativeCreate = _getNative(Object, 'create');

var defineProperty = function () {
  try {
    var func = _getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}();

function isObjectLike(value) {
  return value != null && typeof value == 'object';
}
var isObjectLike_1 = isObjectLike;

var argsTag = '[object Arguments]';
function baseIsArguments(value) {
  return isObjectLike_1(value) && _baseGetTag(value) == argsTag;
}
var _baseIsArguments = baseIsArguments;

var objectProto$3 = Object.prototype;
var hasOwnProperty$3 = objectProto$3.hasOwnProperty;
var propertyIsEnumerable = objectProto$3.propertyIsEnumerable;
var isArguments = _baseIsArguments(function () {
  return arguments;
}()) ? _baseIsArguments : function (value) {
  return isObjectLike_1(value) && hasOwnProperty$3.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
};

function stubFalse() {
  return false;
}
var stubFalse_1 = stubFalse;

var isBuffer_1 = createCommonjsModule(function (module, exports) {
  var freeExports =  exports && !exports.nodeType && exports;
  var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;
  var moduleExports = freeModule && freeModule.exports === freeExports;
  var Buffer = moduleExports ? _root.Buffer : undefined;
  var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
  var isBuffer = nativeIsBuffer || stubFalse_1;
  module.exports = isBuffer;
});

var _nodeUtil = createCommonjsModule(function (module, exports) {
  var freeExports =  exports && !exports.nodeType && exports;
  var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;
  var moduleExports = freeModule && freeModule.exports === freeExports;
  var freeProcess = moduleExports && _freeGlobal.process;
  var nodeUtil = function () {
    try {
      var types = freeModule && freeModule.require && freeModule.require('util').types;
      if (types) {
        return types;
      }
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }();
  module.exports = nodeUtil;
});

var _cloneBuffer = createCommonjsModule(function (module, exports) {
  var freeExports =  exports && !exports.nodeType && exports;
  var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;
  var moduleExports = freeModule && freeModule.exports === freeExports;
  var Buffer = moduleExports ? _root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
  function cloneBuffer(buffer, isDeep) {
    if (isDeep) {
      return buffer.slice();
    }
    var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
  }
  module.exports = cloneBuffer;
});

var DataView = _getNative(_root, 'DataView');
var _DataView = DataView;

var Promise$1 = _getNative(_root, 'Promise');
var _Promise = Promise$1;

var Set = _getNative(_root, 'Set');
var _Set = Set;

var WeakMap = _getNative(_root, 'WeakMap');
var _WeakMap = WeakMap;

var mapTag = '[object Map]',
  objectTag = '[object Object]',
  promiseTag = '[object Promise]',
  setTag = '[object Set]',
  weakMapTag = '[object WeakMap]';
var dataViewTag = '[object DataView]';
var dataViewCtorString = _toSource(_DataView),
  mapCtorString = _toSource(_Map),
  promiseCtorString = _toSource(_Promise),
  setCtorString = _toSource(_Set),
  weakMapCtorString = _toSource(_WeakMap);
var getTag = _baseGetTag;
if (_DataView && getTag(new _DataView(new ArrayBuffer(1))) != dataViewTag || _Map && getTag(new _Map()) != mapTag || _Promise && getTag(_Promise.resolve()) != promiseTag || _Set && getTag(new _Set()) != setTag || _WeakMap && getTag(new _WeakMap()) != weakMapTag) {
  getTag = function (value) {
    var result = _baseGetTag(value),
      Ctor = result == objectTag ? value.constructor : undefined,
      ctorString = Ctor ? _toSource(Ctor) : '';
    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString:
          return dataViewTag;
        case mapCtorString:
          return mapTag;
        case promiseCtorString:
          return promiseTag;
        case setCtorString:
          return setTag;
        case weakMapCtorString:
          return weakMapTag;
      }
    }
    return result;
  };
}

const convertEpochToDateDMY = dateEpoch => {
  if (dateEpoch == null || dateEpoch == undefined || dateEpoch == "") {
    return "NA";
  }
  const dateFromApi = new Date(dateEpoch);
  let month = dateFromApi.getMonth() + 1;
  let day = dateFromApi.getDate();
  let year = dateFromApi.getFullYear();
  month = (month > 9 ? "" : "0") + month;
  day = (day > 9 ? "" : "0") + day;
  return `${day}/${month}/${year}`;
};
const convertEpochToDate = dateEpoch => {
  if (dateEpoch) {
    const dateFromApi = new Date(dateEpoch);
    let month = dateFromApi.getMonth() + 1;
    let day = dateFromApi.getDate();
    let year = dateFromApi.getFullYear();
    month = (month > 9 ? "" : "0") + month;
    day = (day > 9 ? "" : "0") + day;
    return `${year}-${month}-${day}`;
  } else {
    return null;
  }
};
const getOrderDocuments = (appUploadedDocumnets, isNoc = false) => {
  let finalDocs = [];
  if ((appUploadedDocumnets === null || appUploadedDocumnets === void 0 ? void 0 : appUploadedDocumnets.length) > 0) {
    let uniqueDocmnts = appUploadedDocumnets.filter((elem, index) => appUploadedDocumnets.findIndex(obj => {
      var _obj$documentType, _obj$documentType$spl, _obj$documentType$spl2, _elem$documentType, _elem$documentType$sp, _elem$documentType$sp2;
      return (obj === null || obj === void 0 ? void 0 : (_obj$documentType = obj.documentType) === null || _obj$documentType === void 0 ? void 0 : (_obj$documentType$spl = _obj$documentType.split(".")) === null || _obj$documentType$spl === void 0 ? void 0 : (_obj$documentType$spl2 = _obj$documentType$spl.slice(0, 2)) === null || _obj$documentType$spl2 === void 0 ? void 0 : _obj$documentType$spl2.join("_")) === (elem === null || elem === void 0 ? void 0 : (_elem$documentType = elem.documentType) === null || _elem$documentType === void 0 ? void 0 : (_elem$documentType$sp = _elem$documentType.split(".")) === null || _elem$documentType$sp === void 0 ? void 0 : (_elem$documentType$sp2 = _elem$documentType$sp.slice(0, 2)) === null || _elem$documentType$sp2 === void 0 ? void 0 : _elem$documentType$sp2.join("_"));
    }) === index);
    uniqueDocmnts === null || uniqueDocmnts === void 0 ? void 0 : uniqueDocmnts.map(uniDoc => {
      var _resultsDocs$, _resultsDocs$$documen, _resultsDocs$$documen2, _resultsDocs$$documen3;
      const resultsDocs = appUploadedDocumnets === null || appUploadedDocumnets === void 0 ? void 0 : appUploadedDocumnets.filter(appDoc => {
        var _uniDoc$documentType, _uniDoc$documentType$, _uniDoc$documentType$2, _appDoc$documentType, _appDoc$documentType$, _appDoc$documentType$2;
        return (uniDoc === null || uniDoc === void 0 ? void 0 : (_uniDoc$documentType = uniDoc.documentType) === null || _uniDoc$documentType === void 0 ? void 0 : (_uniDoc$documentType$ = _uniDoc$documentType.split(".")) === null || _uniDoc$documentType$ === void 0 ? void 0 : (_uniDoc$documentType$2 = _uniDoc$documentType$.slice(0, 2)) === null || _uniDoc$documentType$2 === void 0 ? void 0 : _uniDoc$documentType$2.join("_")) == (appDoc === null || appDoc === void 0 ? void 0 : (_appDoc$documentType = appDoc.documentType) === null || _appDoc$documentType === void 0 ? void 0 : (_appDoc$documentType$ = _appDoc$documentType.split(".")) === null || _appDoc$documentType$ === void 0 ? void 0 : (_appDoc$documentType$2 = _appDoc$documentType$.slice(0, 2)) === null || _appDoc$documentType$2 === void 0 ? void 0 : _appDoc$documentType$2.join("_"));
      });
      resultsDocs === null || resultsDocs === void 0 ? void 0 : resultsDocs.forEach(resDoc => resDoc.title = resDoc.documentType);
      finalDocs.push({
        title: !isNoc ? resultsDocs === null || resultsDocs === void 0 ? void 0 : (_resultsDocs$ = resultsDocs[0]) === null || _resultsDocs$ === void 0 ? void 0 : (_resultsDocs$$documen = _resultsDocs$.documentType) === null || _resultsDocs$$documen === void 0 ? void 0 : (_resultsDocs$$documen2 = _resultsDocs$$documen.split(".")) === null || _resultsDocs$$documen2 === void 0 ? void 0 : (_resultsDocs$$documen3 = _resultsDocs$$documen2.slice(0, 2)) === null || _resultsDocs$$documen3 === void 0 ? void 0 : _resultsDocs$$documen3.join("_") : "",
        values: resultsDocs
      });
    });
  }
  return finalDocs;
};

const useStyles$1 = makeStyles$1(theme => ({
  card: {
    width: 400,
    height: 'auto',
    backgroundColor: '#225785',
    borderRadius: "10px",
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'row',
    color: '#cccccc',
    margin: 'auto',
    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px"
  },
  strip: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    marginTop: '5px'
  }
}));
const NoRecords = () => {
  const classes = useStyles$1();
  return /*#__PURE__*/React__default.createElement(Card$2, {
    className: classes.card
  }, /*#__PURE__*/React__default.createElement(CardContent$1, null, /*#__PURE__*/React__default.createElement(Typography$2, {
    variant: "h5",
    component: "div",
    align: "center"
  }, "No Records Found")));
};

const useStyles$2 = makeStyles$1(theme => ({
  card: {
    width: 400,
    height: "auto",
    backgroundColor: "#FFFFF",
    borderRadius: "10px",
    display: "flex",
    justifyContent: "center",
    flexDirection: "row",
    color: "rgb(25, 118, 210)",
    margin: "auto",
    border: "1px solid rgb(25, 118, 210)",
    boxShadow: "rgba(16, 3, 21, 0.24) 0px 3px 8px"
  },
  strip: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    marginTop: "5px"
  }
}));
const NotificationChatboard = () => {
  var _userRolesArray$, _userData$info;
  const classes = useStyles$2();
  const userData = Digit.UserService.getUser() || {};
  console.log("ussseeeerData", userData);
  const authToken = (userData === null || userData === void 0 ? void 0 : userData.access_token) || null;
  const userRolesArray = userData === null || userData === void 0 ? void 0 : userData.info.roles.filter(user => user.code !== "EMPLOYEE");
  const userRole = userRolesArray === null || userRolesArray === void 0 ? void 0 : (_userRolesArray$ = userRolesArray[0]) === null || _userRolesArray$ === void 0 ? void 0 : _userRolesArray$.code;
  const chatBoardStatus = "PENDING";
  const useruuid = userData === null || userData === void 0 ? void 0 : (_userData$info = userData.info) === null || _userData$info === void 0 ? void 0 : _userData$info.uuid;
  const [notificationData, setNotificationData] = useState([]);
  console.log("Role of User", userRole, notificationData);
  const history = useHistory$1();
  console.log("Ussssseruuuid", useruuid);
  const handleInboxChatboard = (items, id) => {
    history.push(`/digit-ui/employee/obps/Inbox/chatboard/MAP_SUB/${items}?messageId=${id}`);
  };
  const handlemodalsubmit = async (userRole, chatBoardStatus, useruuid) => {
    const postData = {
      requestInfo: {
        api_id: "1",
        ver: "1",
        ts: null,
        action: "create",
        did: "",
        key: "",
        msg_id: "",
        requester_id: "",
        authToken: authToken
      }
    };
    try {
      const notificationResult = await axios.post(`/land-services/egscrutiny/_search4?userRole=${userRole}&chatBoardStatus=${chatBoardStatus}&useruuid=${useruuid}`, postData, {}).then(response => {
        return response.data;
      });
      console.log("Response of Notifications", notificationResult);
      setNotificationData(notificationResult === null || notificationResult === void 0 ? void 0 : notificationResult.egScrutiny);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    handlemodalsubmit(userRole, chatBoardStatus, useruuid);
  }, [userRole, chatBoardStatus, useruuid]);
  return /*#__PURE__*/React__default.createElement("div", null, notificationData.length > 0 ? /*#__PURE__*/React__default.createElement("div", null, notificationData === null || notificationData === void 0 ? void 0 : notificationData.map((notification, index) => /*#__PURE__*/React__default.createElement(Card$2, {
    className: classes.card
  }, /*#__PURE__*/React__default.createElement(CardContent$1, null, /*#__PURE__*/React__default.createElement("div", {
    className: "row",
    key: index
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "col-6",
    style: {
      width: "75%"
    }
  }, /*#__PURE__*/React__default.createElement("p", null, notification.applicationId), /*#__PURE__*/React__default.createElement("p", null, notification.isApproved), /*#__PURE__*/React__default.createElement("p", null, notification.chatBoardStatus), /*#__PURE__*/React__default.createElement("p", {
    style: {
      whiteSpace: "nowrap"
    }
  }, notification.employeeName, ",", notification.designation)), /*#__PURE__*/React__default.createElement("div", {
    className: "col-6",
    style: {
      width: "25%"
    }
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    size: "small",
    sx: {
      ml: 1,
      fontSize: "11px",
      float: "right"
    },
    variant: "contained",
    color: "success",
    onClick: () => handleInboxChatboard(notification.applicationId, notification.id)
  }, "Take Action"))))))) : /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(NoRecords, null)));
};

const types = {
  UPDATE_DETAILS: "UPDATE_DETAILS"
};
const updateFormData = (businessServices, tenantId, count, officerRole) => ({
  type: types.UPDATE_DETAILS,
  payload: {
    businessServices,
    tenantId,
    count,
    officerRole
  }
});

const tablist = [{
  label: "LTP Registration",
  color: "black"
}, {
  label: "Other Module Applications",
  color: "black"
}, {
  label: "Notifications",
  color: "black"
}];
const isAutoForwardedRecord = item => {
  var _item$raw;
  if (item !== null && item !== void 0 && item.isAutoForwarded) return true;
  const processInstance = (item === null || item === void 0 ? void 0 : item.ProcessInstance) || (item === null || item === void 0 ? void 0 : item.processInstance) || (item === null || item === void 0 ? void 0 : (_item$raw = item.raw) === null || _item$raw === void 0 ? void 0 : _item$raw.ProcessInstance);
  const assigner = (processInstance === null || processInstance === void 0 ? void 0 : processInstance.assigner) || (item === null || item === void 0 ? void 0 : item.assigner);
  if ((assigner === null || assigner === void 0 ? void 0 : assigner.userName) === "WF_ADMIN_ESCLATE" || (assigner === null || assigner === void 0 ? void 0 : assigner.name) === "Admin Escalation") return true;
  const roles = assigner === null || assigner === void 0 ? void 0 : assigner.roles;
  if (Array.isArray(roles)) {
    return roles.some(role => {
      const code = typeof role === "string" ? role : role === null || role === void 0 ? void 0 : role.code;
      const name = typeof role === "object" ? role === null || role === void 0 ? void 0 : role.name : "";
      return code === "WF_ADMIN_ESCLATE" || name === "Admin Escalation";
    });
  }
  return false;
};
const EmpMenu = ({
  userBusinessServices,
  tenantId,
  officerRole
}) => {
  var _applications$table2, _applications$table3, _applications$table4;
  const history = useHistory();
  const {
    applications,
    isOfficerLTP
  } = fetchApplications(tenantId, userBusinessServices, officerRole);
  const dispatch = useDispatch();
  console.log("fetchedApplications", applications);
  console.log("officer role --- ", officerRole);
  const applicationsCount = applications === null || applications === void 0 ? void 0 : applications.totalCount;
  const [anchorEl, setAnchorEl] = useState(null);
  const [open, setOpen] = useState(false);
  const [currentTab, setCurrentTab] = useState("1");
  const {
    t
  } = useTranslation();
  const handleClose = () => {
    setOpen(false);
    setAnchorEl(null);
  };
  const handleChange = (event, nextTab) => {
    setCurrentTab(nextTab);
  };
  const navigateProfessional = item => {
    history.push(`/digit-ui/employee/obps/professional/${item === null || item === void 0 ? void 0 : item.applicationId}`);
    handleClose();
  };
  const handleTakeAction = item => {
    console.log("itemFromTakeAction", item);
    switch (item === null || item === void 0 ? void 0 : item.businessService) {
      case "BPA_MAPSUB_DA":
      case "BPA_MAPSUB_AVP":
        history.push(`/digit-ui/employee/obps/application/MAP_SUB/${item === null || item === void 0 ? void 0 : item.applicationId}`);
        handleClose();
        break;
      case "BPA_FAR_DA":
      case "BPA_FAR_AVP":
        history.push(`/digit-ui/employee/obps/application/PURCHASABLE_FAR/${item === null || item === void 0 ? void 0 : item.applicationId}`);
        handleClose();
        break;
      case "BPA_LANDUSE_DA":
      case "BPA_LANDUSE_AVP":
        history.push(`/digit-ui/employee/obps/application/formLandUse/${item === null || item === void 0 ? void 0 : item.applicationId}`);
        handleClose();
        break;
    }
  };
  useEffect(() => {
    var _applications$table;
    if ((applications === null || applications === void 0 ? void 0 : (_applications$table = applications.table) === null || _applications$table === void 0 ? void 0 : _applications$table.length) > 0) {
      setCurrentTab("0");
    } else {
      setCurrentTab("1");
    }
  }, [applications]);
  useEffect(() => {
    setCurrentTab("2");
  }, []);
  useEffect(() => {
    if (applications) {
      dispatch(updateFormData(userBusinessServices, tenantId, applicationsCount, officerRole));
    }
  }, [applications]);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Menu, {
    id: "basic-menu",
    anchorEl: anchorEl,
    open: open,
    onClose: handleClose,
    MenuListProps: {
      "aria-labelledby": "basic-button"
    },
    sx: {
      zIndex: 10000
    }
  }, /*#__PURE__*/React__default.createElement(Card$3, {
    sx: {
      backgroundColor: "#ecf2f7",
      color: "#8090a0"
    }
  }, /*#__PURE__*/React__default.createElement(MenuItem$5, null, /*#__PURE__*/React__default.createElement(Tabs, {
    value: currentTab,
    onChange: handleChange
  }, tablist.map(({
    label,
    color
  }, index) => /*#__PURE__*/React__default.createElement(Tab, {
    key: index,
    label: `${t(label)}`,
    value: `${index}`,
    sx: {
      textTransform: "none",
      p: "0 1rem",
      color,
      border: "1px solid #555"
    }
  }))))), /*#__PURE__*/React__default.createElement(TabPanel, {
    value: currentTab,
    index: "0",
    sx: {
      p: 0
    }
  }, /*#__PURE__*/React__default.createElement("div", null, isOfficerLTP && (applications === null || applications === void 0 ? void 0 : (_applications$table2 = applications.table) === null || _applications$table2 === void 0 ? void 0 : _applications$table2.map(item => {
    return /*#__PURE__*/React__default.createElement(Card$3, {
      key: item.owner + item.date,
      sx: {
        display: "flex",
        marginBottom: "3px",
        width: "100%"
      }
    }, /*#__PURE__*/React__default.createElement(Box$1, {
      sx: {
        width: "25%",
        margin: "3px"
      }
    }, /*#__PURE__*/React__default.createElement(Box$1, {
      sx: {
        width: "65px",
        height: "60px",
        border: "1px solid",
        marginLeft: "10px"
      }
    }, /*#__PURE__*/React__default.createElement("img", {
      width: "60px",
      height: "52px",
      src: item === null || item === void 0 ? void 0 : item.userPhoto
    }))), /*#__PURE__*/React__default.createElement(Box$1, {
      sx: {
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("b", null, item.owner)), /*#__PURE__*/React__default.createElement("div", {
      style: {
        fontSize: "11px",
        color: "#1976d2"
      }
    }, item.applicationId), /*#__PURE__*/React__default.createElement("div", {
      style: {
        fontSize: "11px",
        color: "#1976d2"
      }
    }, t(`EMP_${item.applicationType}`)), /*#__PURE__*/React__default.createElement("div", {
      style: {
        fontSize: "11px"
      }
    }, "Applied on : ", convertEpochToDateDMY(item.date))), /*#__PURE__*/React__default.createElement(Box$1, {
      sx: {
        width: "25%",
        marginRight: "10px",
        marginTop: "20px"
      }
    }, /*#__PURE__*/React__default.createElement(Button$1, {
      size: "small",
      sx: {
        ml: 1,
        fontSize: "11px",
        alignContent: "center"
      },
      variant: "contained",
      color: "success",
      onClick: () => navigateProfessional(item)
    }, "Take Action")));
  })), (isOfficerLTP && (applications === null || applications === void 0 ? void 0 : (_applications$table3 = applications.table) === null || _applications$table3 === void 0 ? void 0 : _applications$table3.length) <= 0 || !isOfficerLTP) && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(NoRecords, null)))), /*#__PURE__*/React__default.createElement(TabPanel, {
    value: currentTab,
    index: "1",
    sx: {
      p: 0
    }
  }, /*#__PURE__*/React__default.createElement("div", null, !isOfficerLTP && (applications === null || applications === void 0 ? void 0 : (_applications$table4 = applications.table) === null || _applications$table4 === void 0 ? void 0 : _applications$table4.map(item => {
    return /*#__PURE__*/React__default.createElement("div", {
      key: item.applicationId
    }, /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Card$3, {
      sx: {
        display: "flex",
        marginBottom: "3px",
        width: "100%"
      }
    }, /*#__PURE__*/React__default.createElement(Box$1, {
      sx: {
        width: "25%",
        margin: "3px"
      }
    }, /*#__PURE__*/React__default.createElement(Box$1, {
      sx: {
        width: "65px",
        height: "60px",
        border: "1px solid",
        marginLeft: "10px"
      }
    }, /*#__PURE__*/React__default.createElement("img", {
      width: "60px",
      height: "52px",
      src: item === null || item === void 0 ? void 0 : item.userPhoto
    }))), /*#__PURE__*/React__default.createElement(Box$1, {
      sx: {
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("b", null, item.owner)), /*#__PURE__*/React__default.createElement("div", {
      style: {
        fontSize: "11px",
        color: "#1976d2",
        display: "flex",
        alignItems: "center",
        gap: "6px"
      }
    }, /*#__PURE__*/React__default.createElement("span", null, item.applicationId), isAutoForwardedRecord(item) && /*#__PURE__*/React__default.createElement("span", {
      style: {
        backgroundColor: "#d97706",
        color: "#ffffff",
        fontSize: "9px",
        fontWeight: 700,
        padding: "1px 4px",
        borderRadius: "3px",
        lineHeight: "1.2"
      }
    }, "Auto Forwarded")), /*#__PURE__*/React__default.createElement("div", {
      style: {
        fontSize: "11px",
        color: "#1976d2"
      }
    }, t(`EMP_${item.applicationType}`)), /*#__PURE__*/React__default.createElement("div", {
      style: {
        fontSize: "11px"
      }
    }, "Applied On : ", convertEpochToDateDMY(item.date))), /*#__PURE__*/React__default.createElement(Box$1, {
      sx: {
        width: "25%",
        marginRight: "10px",
        marginTop: "20px"
      }
    }, /*#__PURE__*/React__default.createElement(Button$1, {
      size: "small",
      sx: {
        ml: 1,
        fontSize: "11px",
        alignContent: "center"
      },
      variant: "contained",
      color: "success",
      onClick: () => handleTakeAction(item)
    }, "Take Action")))));
  })), isOfficerLTP && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(NoRecords, null)))), /*#__PURE__*/React__default.createElement(TabPanel, {
    value: currentTab,
    index: "2",
    sx: {
      p: 0
    }
  }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(NotificationChatboard, null)))));
};

const TextToImg = props => /*#__PURE__*/React__default.createElement("span", {
  className: "user-img-txt",
  onClick: props.toggleMenu,
  title: props.name
}, props.name[0].toUpperCase());
const TopBar = ({
  t,
  stateInfo,
  toggleSidebar,
  isSidebarOpen,
  handleLogout,
  userDetails,
  CITIZEN,
  cityDetails,
  mobileView,
  userOptions,
  handleUserDropdownSelection,
  logoUrl,
  showLanguageChange: _showLanguageChange = true,
  sidebarOpen,
  sidebarToggle
}) => {
  var _Digit$UserService$ge, _userInfo$roles, _userInfo$roles2, _userInfo$roles2$find, _userDetails$info2, _cityDetails$city, _cityDetails$city2, _stateInfo$code, _userDetails$info3, _userDetails$info4, _userDetails$info5, _userDetails$info5$us;
  const [profilePic, setProfilePic] = React__default.useState(null);
  const [userBusinessServices, setUserBusinessServices] = React__default.useState(null);
  const [manualOpen, setManualOpen] = React__default.useState(false);
  const user = Digit.SessionStorage.get("USER_DETAIL") || {};
  const userInfo = ((_Digit$UserService$ge = Digit.UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : _Digit$UserService$ge.info) || {};
  const officerRole = userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$roles = userInfo.roles) === null || _userInfo$roles === void 0 ? void 0 : _userInfo$roles.filter(item => item.code !== "EMPLOYEE");
  const designationName = userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$roles2 = userInfo.roles) === null || _userInfo$roles2 === void 0 ? void 0 : (_userInfo$roles2$find = _userInfo$roles2.find(ele => (ele === null || ele === void 0 ? void 0 : ele.code) !== "EMPLOYEE")) === null || _userInfo$roles2$find === void 0 ? void 0 : _userInfo$roles2$find.name;
  const authority = user === null || user === void 0 ? void 0 : user.location1;
  console.log("logforauthority", authority, designationName, user);
  React__default.useEffect(async () => {
    var _userDetails$info;
    const tenant = Digit.ULBService.getCurrentTenantId();
    const uuid = userDetails === null || userDetails === void 0 ? void 0 : (_userDetails$info = userDetails.info) === null || _userDetails$info === void 0 ? void 0 : _userDetails$info.uuid;
    if (uuid) {
      const usersResponse = await Digit.UserService.userSearch(tenant, {
        uuid: [uuid]
      }, {});
      if (usersResponse && usersResponse.user && usersResponse.user.length) {
        var _userDetails$photo;
        const userDetails = usersResponse.user[0];
        Digit.SessionStorage.set("USER_DETAIL", userDetails);
        const businessService = (userDetails === null || userDetails === void 0 ? void 0 : userDetails.organisationName) === "noc-services" ? userDetails === null || userDetails === void 0 ? void 0 : userDetails.organisationCode : userDetails === null || userDetails === void 0 ? void 0 : userDetails.businessService;
        setUserBusinessServices(businessService);
        console.log("userInfoAyush", usersResponse);
        const thumbs = userDetails === null || userDetails === void 0 ? void 0 : (_userDetails$photo = userDetails.photo) === null || _userDetails$photo === void 0 ? void 0 : _userDetails$photo.split(",");
        setProfilePic(thumbs === null || thumbs === void 0 ? void 0 : thumbs.at(0));
      }
    }
  }, [profilePic !== null, userDetails === null || userDetails === void 0 ? void 0 : (_userDetails$info2 = userDetails.info) === null || _userDetails$info2 === void 0 ? void 0 : _userDetails$info2.uuid]);
  const CitizenHomePageTenantId = Digit.ULBService.getCitizenCurrentTenant(true);
  const tenant = Digit.ULBService.getStateId();
  let history = useHistory();
  const {
    pathname
  } = useLocation();
  const conditionsToDisableNotificationCountTrigger = () => {
    var _Digit$UserService, _Digit$UserService$ge2, _Digit$UserService$ge3, _Digit$UserService2, _Digit$UserService2$g, _Digit$UserService2$g2;
    if (((_Digit$UserService = Digit.UserService) === null || _Digit$UserService === void 0 ? void 0 : (_Digit$UserService$ge2 = _Digit$UserService.getUser()) === null || _Digit$UserService$ge2 === void 0 ? void 0 : (_Digit$UserService$ge3 = _Digit$UserService$ge2.info) === null || _Digit$UserService$ge3 === void 0 ? void 0 : _Digit$UserService$ge3.type) === "EMPLOYEE") return false;
    if (((_Digit$UserService2 = Digit.UserService) === null || _Digit$UserService2 === void 0 ? void 0 : (_Digit$UserService2$g = _Digit$UserService2.getUser()) === null || _Digit$UserService2$g === void 0 ? void 0 : (_Digit$UserService2$g2 = _Digit$UserService2$g.info) === null || _Digit$UserService2$g2 === void 0 ? void 0 : _Digit$UserService2$g2.type) === "CITIZEN") {
      if (!CitizenHomePageTenantId) return false;else return true;
    }
    return false;
  };
  const {
    data: {
      unreadCount: unreadNotificationCount
    } = {},
    isSuccess: notificationCountLoaded
  } = Digit.Hooks.useNotificationCount({
    tenantId: tenant,
    config: {
      enabled: conditionsToDisableNotificationCountTrigger()
    }
  });
  const updateSidebar = () => {
    if (!Digit.clikOusideFired) {
      toggleSidebar(true);
    } else {
      Digit.clikOusideFired = false;
    }
  };
  function onNotificationIconClick() {
    history.push("/digit-ui/citizen/engagement/notifications");
  }
  const urlsToDisableNotificationIcon = pathname => {
    var _Digit$UserService3, _Digit$UserService3$g;
    return !!((_Digit$UserService3 = Digit.UserService) !== null && _Digit$UserService3 !== void 0 && (_Digit$UserService3$g = _Digit$UserService3.getUser()) !== null && _Digit$UserService3$g !== void 0 && _Digit$UserService3$g.access_token) ? false : ["/digit-ui/citizen/select-language", "/digit-ui/citizen/select-location"].includes(pathname);
  };
  if (CITIZEN) {
    return /*#__PURE__*/React__default.createElement(TopBar$4, {
      img: stateInfo === null || stateInfo === void 0 ? void 0 : stateInfo.logoUrlWhite,
      isMobile: true,
      toggleSidebar: updateSidebar,
      logoUrl: logoUrl || (stateInfo === null || stateInfo === void 0 ? void 0 : stateInfo.logoUrlWhite),
      onLogout: handleLogout,
      userDetails: userDetails,
      notificationCount: unreadNotificationCount < 99 ? unreadNotificationCount : 99,
      notificationCountLoaded: notificationCountLoaded,
      cityOfCitizenShownBesideLogo: t(CitizenHomePageTenantId),
      onNotificationIconClick: onNotificationIconClick,
      hideNotificationIconOnSomeUrlsWhenNotLoggedIn: urlsToDisableNotificationIcon(pathname),
      sidebarOpen: sidebarOpen,
      sidebarToggle: sidebarToggle
    });
  }
  const loggedin = userDetails !== null && userDetails !== void 0 && userDetails.access_token ? true : false;
  const nameAuthority = `${designationName}${authority ? ` - ${authority}` : ``}`;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "topbar"
  }, mobileView ? /*#__PURE__*/React__default.createElement(Hamburger, {
    handleClick: toggleSidebar,
    color: "#9E9E9E"
  }) : null, /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex",
      alignItems: "center",
      justifyContent: "end",
      width: "100%"
    }
  }, loggedin && (cityDetails !== null && cityDetails !== void 0 && (_cityDetails$city = cityDetails.city) !== null && _cityDetails$city !== void 0 && _cityDetails$city.ulbGrade ? /*#__PURE__*/React__default.createElement("p", {
    className: "ulb",
    style: mobileView ? {
      fontSize: "14px",
      display: "inline-block"
    } : {}
  }, t(cityDetails === null || cityDetails === void 0 ? void 0 : cityDetails.i18nKey).toUpperCase(), " ", t(`ULBGRADE_${cityDetails === null || cityDetails === void 0 ? void 0 : (_cityDetails$city2 = cityDetails.city) === null || _cityDetails$city2 === void 0 ? void 0 : _cityDetails$city2.ulbGrade.toUpperCase().replace(" ", "_").replace(".", "_")}`).toUpperCase()) : ""), !loggedin && /*#__PURE__*/React__default.createElement("p", {
    className: "ulb",
    style: mobileView ? {
      fontSize: "14px",
      display: "inline-block"
    } : {}
  }, t(`MYCITY_${stateInfo === null || stateInfo === void 0 ? void 0 : (_stateInfo$code = stateInfo.code) === null || _stateInfo$code === void 0 ? void 0 : _stateInfo$code.toUpperCase()}_LABEL`), " ", t(`MYCITY_STATECODE_LABEL`)), !mobileView && /*#__PURE__*/React__default.createElement("div", {
    className: mobileView ? "right" : "flex-right right w-80 column-gap-15",
    style: !loggedin ? {
      width: "80%"
    } : {}
  }, designationName === "JE" && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(MenuPopupCalender, null)), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("button", {
    className: "btn-header-menu",
    onClick: () => setManualOpen(true)
  }, "Help"), /*#__PURE__*/React__default.createElement(UserManualPopup, {
    open: manualOpen,
    onClose: () => setManualOpen(false)
  })), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(EmpMenu, {
    userBusinessServices: userBusinessServices,
    tenantId: tenant,
    officerRole: officerRole
  })), /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      flexDirection: "column"
    }
  }, /*#__PURE__*/React__default.createElement("b", {
    style: {
      fontSize: 18,
      textAlign: "center",
      color: "#fff"
    }
  }, userDetails === null || userDetails === void 0 ? void 0 : (_userDetails$info3 = userDetails.info) === null || _userDetails$info3 === void 0 ? void 0 : _userDetails$info3.name), /*#__PURE__*/React__default.createElement("p", {
    style: {
      fontSize: 13,
      color: "#fff"
    }
  }, "(", nameAuthority, ")")), (userDetails === null || userDetails === void 0 ? void 0 : userDetails.access_token) && /*#__PURE__*/React__default.createElement("div", {
    className: "left"
  }, /*#__PURE__*/React__default.createElement(Dropdown, {
    option: userOptions,
    optionKey: "name",
    select: handleUserDropdownSelection,
    showArrow: true,
    freeze: true,
    style: mobileView ? {
      right: 0
    } : {},
    optionCardStyles: {
      overflow: "revert",
      right: 0
    },
    customSelector: profilePic == null ? /*#__PURE__*/React__default.createElement(TextToImg, {
      name: (userDetails === null || userDetails === void 0 ? void 0 : (_userDetails$info4 = userDetails.info) === null || _userDetails$info4 === void 0 ? void 0 : _userDetails$info4.name) || (userDetails === null || userDetails === void 0 ? void 0 : (_userDetails$info5 = userDetails.info) === null || _userDetails$info5 === void 0 ? void 0 : (_userDetails$info5$us = _userDetails$info5.userInfo) === null || _userDetails$info5$us === void 0 ? void 0 : _userDetails$info5$us.name) || "Employee"
    }) : /*#__PURE__*/React__default.createElement("img", {
      src: `${profilePic}`,
      style: {
        height: "48px",
        width: "48px",
        borderRadius: "50%"
      }
    })
  })))));
};

const SideBarMenu = (t, closeSidebar, redirectToLoginPage, isEmployee) => [{
  type: "link",
  element: "HOME",
  text: t("COMMON_BOTTOM_NAVIGATION_HOME"),
  link: isEmployee ? "/digit-ui/employee" : "/digit-ui/citizen/profile",
  icon: /*#__PURE__*/React__default.createElement(HomeIcon, {
    className: "icon"
  }),
  populators: {
    onClick: closeSidebar
  }
}, {
  id: 'login-btn',
  element: "LOGIN",
  text: t("CORE_COMMON_LOGIN"),
  icon: /*#__PURE__*/React__default.createElement(LogoutIcon, {
    className: "icon"
  }),
  populators: {
    onClick: redirectToLoginPage
  }
}];

const PoweredBy = () => {
  var _window, _window$globalConfigs, _window$globalConfigs2;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "digit-footer"
  }, /*#__PURE__*/React__default.createElement("img", {
    alt: "Powered by DIGIT",
    src: (_window = window) === null || _window === void 0 ? void 0 : (_window$globalConfigs = _window.globalConfigs) === null || _window$globalConfigs === void 0 ? void 0 : (_window$globalConfigs2 = _window$globalConfigs.getConfig) === null || _window$globalConfigs2 === void 0 ? void 0 : _window$globalConfigs2.call(_window$globalConfigs, "DIGIT_FOOTER"),
    style: {
      cursor: "pointer"
    },
    onClick: () => {
      var _window2, _window2$globalConfig, _window2$globalConfig2;
      window.open((_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$globalConfig = _window2.globalConfigs) === null || _window2$globalConfig === void 0 ? void 0 : (_window2$globalConfig2 = _window2$globalConfig.getConfig) === null || _window2$globalConfig2 === void 0 ? void 0 : _window2$globalConfig2.call(_window2$globalConfig, "DIGIT_HOME_URL"), "_blank").focus();
    }
  }), " ");
};
const CitizenSideBar = ({
  isOpen,
  isMobile,
  toggleSidebar,
  onLogout,
  isEmployee: _isEmployee = false,
  sidebarOpen,
  sidebarToggle
}) => {
  const {
    data: storeData,
    isFetched
  } = Digit.Hooks.useStore.getInitData();
  const user = Digit.UserService.getUser();
  const {
    t
  } = useTranslation();
  const history = useHistory();
  const closeSidebar = () => {
    Digit.clikOusideFired = true;
    toggleSidebar(false);
  };
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const showProfilePage = () => {
    const redirectUrl = _isEmployee ? "/digit-ui/employee/user/profile" : "/digit-ui/citizen/user/profile";
    history.push(redirectUrl);
    closeSidebar();
  };
  const redirectToLoginPage = () => {
    history.push("/digit-ui/citizen/login");
    closeSidebar();
  };
  let menuItems = [...SideBarMenu(t, closeSidebar, redirectToLoginPage, _isEmployee)];
  let profileItem;
  if (isFetched && user && user.access_token) {
    profileItem = "";
    menuItems = menuItems.filter(item => (item === null || item === void 0 ? void 0 : item.id) !== "login-btn");
    menuItems = [...menuItems, {
      text: t("EDIT_PROFILE"),
      element: "PROFILE",
      icon: /*#__PURE__*/React__default.createElement(EditPencilIcon, {
        className: "icon edit-btn-ico",
        width: "16",
        height: "16"
      }),
      populators: {
        onClick: showProfilePage
      }
    }, {
      text: t("CORE_COMMON_LOGOUT"),
      element: "LOGOUT",
      icon: /*#__PURE__*/React__default.createElement(LogoutIcon, {
        className: "icon"
      }),
      populators: {
        onClick: onLogout
      }
    }, {
      text: /*#__PURE__*/React__default.createElement(React__default.Fragment, null, t("CS_COMMON_HELPLINE"), /*#__PURE__*/React__default.createElement("div", {
        className: "telephone",
        style: {
          marginTop: "-10%"
        }
      }, storeData === null || storeData === void 0 ? void 0 : storeData.tenants.map(i => {
      }), /*#__PURE__*/React__default.createElement("div", {
        className: "link"
      }, /*#__PURE__*/React__default.createElement("a", {
        href: `tel:${storeData === null || storeData === void 0 ? void 0 : storeData.tenants[0].contactNumber}`
      }, storeData === null || storeData === void 0 ? void 0 : storeData.tenants[0].contactNumber)))),
      element: "Helpline",
      icon: /*#__PURE__*/React__default.createElement(Phone, {
        className: "icon"
      })
    }];
  }
  if (history.location.pathname.includes("/openlink")) {
    profileItem = /*#__PURE__*/React__default.createElement("span", null);
    menuItems = menuItems.filter(ele => ele.element === "LANGUAGE");
  }
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(NavBar, {
    open: sidebarOpen,
    profileItem: profileItem,
    menuItems: menuItems,
    onClose: closeSidebar,
    Footer: /*#__PURE__*/React__default.createElement(PoweredBy, null)
  }));
};

const DashboardAccordion = ({
  title,
  icon,
  formTypes: _formTypes = [],
  dashboardData: _dashboardData = [],
  classes,
  linkTo,
  currentFormType,
  isAccordion: _isAccordion = true,
  isSelfApproval: _isSelfApproval = false
}) => {
  const filteredData = currentFormType ? _dashboardData[currentFormType] : _dashboardData;
  const displayData = _isSelfApproval ? [{
    action: "Show All Files",
    count: _dashboardData === null || _dashboardData === void 0 ? void 0 : _dashboardData.count
  }] : filteredData;
  return /*#__PURE__*/React__default.createElement(Accordion, {
    className: classes.accordion
  }, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    className: classes.accordionSummary,
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMore, {
      style: {
        color: "white"
      }
    }),
    "aria-controls": "manage-application-content",
    id: `accordion-${title}`
  }, /*#__PURE__*/React__default.createElement(Link$1, {
    to: !_isAccordion && linkTo,
    className: classes.accordionLink,
    activeClassName: "active"
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    className: classes.accordionHeader
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      marginRight: "3px"
    }
  }, icon), title))), (displayData === null || displayData === void 0 ? void 0 : displayData.length) > 0 && _isAccordion && /*#__PURE__*/React__default.createElement(AccordionDetails, {
    className: "accordionDetailNew"
  }, displayData.map(item => {
    const redirectUrl = currentFormType ? `/digit-ui/employee/obps/dashboardui/table/${currentFormType}/${_isSelfApproval ? "AllFiles" : item.label}/planningPermission` : `/digit-ui/employee/obps/dashboardui/table/${item.label}/professional`;
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, {
      key: item.action
    }, /*#__PURE__*/React__default.createElement(Link$1, {
      to: linkTo ? linkTo : redirectUrl,
      activeClassName: "active"
    }, item.action, " (", item.count, ")"), /*#__PURE__*/React__default.createElement(Divider, null));
  })));
};

const useStyles$3 = makeStyles$1(theme => ({
  accordion: {
    backgroundColor: "transparent",
    padding: "0",
    boxShadow: "none",
    margin: "0!important",
    "&:hover": {
      background: "#64a3c9",
      color: "#000",
      borderRadius: "0px"
    }
  },
  accordionDetails: {
    display: "flex",
    flexDirection: "column",
    margin: "0px",
    padding: "0px"
  },
  accordionSummary: {
    backgroundColor: "transparent",
    margin: "10px 0px!important",
    minHeight: "100%!important",
    "&:hover": {
      background: "#64a3c9",
      color: "#000"
    }
  },
  divider: {
    background: theme.palette.divider
  },
  accordionHeader: {
    display: "flex",
    fontSize: "13px",
    color: "#fff",
    alignItems: "center",
    "& svg": {
      fontSize: "17px"
    }
  },
  accordionLink: {
    fontSize: "13px",
    color: "#fff",
    textDecoration: "none",
    textDecorationLine: "none",
    "&:hover": {
      duration: 1,
      color: "#ccc",
      display: "block",
      textDecoration: "none",
      fontSize: "13px"
    },
    "&.active": {
      color: "#003366"
    }
  }
}));
const EmployeeSideBar = ({
  mobileView,
  collapsed
}) => {
  var _Digit$UserService$ge, _Digit, _Digit$Utils, _officerRole$;
  const classes = useStyles$3();
  const {
    businessServices,
    tenantIds,
    count,
    officerRole
  } = useSelector(state => state.empInbox);
  const userDetails = Digit.SessionStorage.get("USER_DETAIL");
  const authToken = ((_Digit$UserService$ge = Digit.UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : _Digit$UserService$ge.access_token) || {};
  const ADMIN = Digit.Utils.hrmsAccess();
  const SUPERUSER = Digit.Utils.superUserAccess();
  const FINANCE_CONTROLLER = Digit.Utils.financeController();
  const isDevOrUat = (_Digit = Digit) !== null && _Digit !== void 0 && (_Digit$Utils = _Digit.Utils) !== null && _Digit$Utils !== void 0 && _Digit$Utils.isDevOrUatEnv ? Digit.Utils.isDevOrUatEnv() : false;
  const tenantId = userDetails === null || userDetails === void 0 ? void 0 : userDetails.tenantId;
  console.log(SUPERUSER, "superuser", ADMIN);
  console.log("userDetailsSideBarEmp", userDetails, businessServices, tenantId, count, officerRole);
  const [SSODashUrl, setSSODashUrl] = useState("");
  const [dashboardData, setDashBoardData] = useState({});
  const [selfData, setSelfData] = useState({});
  const [nocDashboardData, setNocDashboardData] = useState({});
  const [ltpData, setLtpData] = useState([]);
  const STADMIN = Digit.UserService.hasAccess("STADMIN");
  const NATADMIN = Digit.UserService.hasAccess("NATADMIN");
  const isVC = useMemo(() => {
    var _user$info;
    const user = Digit.UserService.getUser();
    const userRoles = (user === null || user === void 0 ? void 0 : (_user$info = user.info) === null || _user$info === void 0 ? void 0 : _user$info.roles) || [];
    const allRoles = [...(officerRole || []), ...userRoles];
    const matchRole = allRoles.some(r => {
      const code = (typeof r === "string" ? r : (r === null || r === void 0 ? void 0 : r.code) || "").toUpperCase();
      const name = (typeof r === "string" ? r : (r === null || r === void 0 ? void 0 : r.name) || "").toUpperCase();
      return code === "VICE_CHAIRMAN" || code === "VC" || code === "BPA_VC" || code.includes("VICE_CHAIRMAN") || name.includes("VICE CHAIRMAN") || name.includes("VICE-CHAIRMAN");
    });
    if (matchRole) return true;
    try {
      var _Digit2, _Digit2$UserService;
      if ((_Digit2 = Digit) !== null && _Digit2 !== void 0 && (_Digit2$UserService = _Digit2.UserService) !== null && _Digit2$UserService !== void 0 && _Digit2$UserService.hasAccess && Digit.UserService.hasAccess(["Vice_Chairman", "VC", "VICE_CHAIRMAN", "vice_chairman", "BPA_VC"])) {
        return true;
      }
    } catch (e) {}
    return false;
  }, [officerRole]);
  const roleToFormTypesMap = {
    JE: ["FORM_MAP", "FORM_PURCHASABLE_FAR", "FORM_LANDUSE", "FORM_PLINTH", "FORM_COMPLETION", "FORM_COMPOUNDING"],
    AE: ["FORM_MAP", "FORM_PURCHASABLE_FAR", "FORM_LANDUSE", "FORM_PLINTH", "FORM_COMPLETION", "FORM_COMPOUNDING"],
    EE: ["FORM_MAP", "FORM_PURCHASABLE_FAR", "FORM_LANDUSE", "FORM_PLINTH", "FORM_COMPLETION", "FORM_COMPOUNDING"],
    CTP: ["FORM_MAP", "FORM_PURCHASABLE_FAR", "FORM_LANDUSE", "FORM_PLINTH", "FORM_COMPLETION", "FORM_COMPOUNDING"],
    TP: ["FORM_MAP", "FORM_PURCHASABLE_FAR", "FORM_LANDUSE", "FORM_PLINTH", "FORM_COMPLETION", "FORM_COMPOUNDING"],
    Vice_Chairman: ["FORM_MAP", "FORM_PURCHASABLE_FAR", "FORM_LANDUSE", "FORM_PLINTH", "FORM_COMPLETION", "FORM_COMPOUNDING"],
    Additional_Secretory: ["FORM_MAP", "FORM_PURCHASABLE_FAR", "FORM_LANDUSE", "FORM_PLINTH", "FORM_COMPLETION", "FORM_COMPOUNDING"],
    Joint_Secretary: ["FORM_MAP", "FORM_PURCHASABLE_FAR", "FORM_LANDUSE", "FORM_PLINTH", "FORM_COMPLETION", "FORM_COMPOUNDING"],
    Additional_Secretary: ["FORM_MAP", "FORM_PURCHASABLE_FAR", "FORM_LANDUSE", "FORM_PLINTH", "FORM_COMPLETION", "FORM_COMPOUNDING"],
    Secretory: ["FORM_MAP", "FORM_PURCHASABLE_FAR", "FORM_LANDUSE", "FORM_PLINTH", "FORM_COMPLETION", "FORM_COMPOUNDING"],
    Secretary: ["FORM_MAP", "FORM_PURCHASABLE_FAR", "FORM_LANDUSE", "FORM_PLINTH", "FORM_COMPLETION", "FORM_COMPOUNDING"],
    BPA_SURVEYOR: ["FORM_MAP", "FORM_PURCHASABLE_FAR", "FORM_LANDUSE", "FORM_PLINTH", "FORM_COMPLETION", "FORM_COMPOUNDING"],
    ASSOCIATE_JE: ["FORM_MAP", "FORM_PURCHASABLE_FAR", "FORM_LANDUSE", "FORM_PLINTH", "FORM_COMPLETION", "FORM_COMPOUNDING"],
    Authorized_Officer: ["FORM_LANDUSE"],
    DRAFTSMAN: ["FORM_LANDUSE"],
    APA: ["FORM_LANDUSE", "FORM_PURCHASABLE_FAR", "FORM_MAP", "FORM_COMPOUNDING"],
    CAP: ["FORM_LANDUSE", "FORM_PURCHASABLE_FAR", "FORM_MAP", "FORM_COMPOUNDING"],
    ATP: ["FORM_LANDUSE", "FORM_PURCHASABLE_FAR", "FORM_MAP", "FORM_COMPOUNDING"],
    AP: ["FORM_LANDUSE", "FORM_PURCHASABLE_FAR", "FORM_MAP", "FORM_COMPOUNDING"],
    HC: ["FORM_LANDUSE", "FORM_PURCHASABLE_FAR", "FORM_MAP", "FORM_COMPOUNDING"],
    AAP: ["FORM_LANDUSE", "FORM_PURCHASABLE_FAR", "FORM_MAP", "FORM_COMPOUNDING"],
    Acquisition_Section_Incharge: ["FORM_NOC", "FORM_MAP", "FORM_COMPOUNDING", "FORM_LANDUSE"],
    Nazul_Section_Incharge: ["FORM_NOC", "FORM_MAP", "FORM_COMPOUNDING", "FORM_LANDUSE"],
    Improvement_Trust_Incharge: ["FORM_NOC", "FORM_MAP", "FORM_COMPOUNDING", "FORM_LANDUSE"],
    Property_Section_Incharge: ["FORM_NOC", "FORM_MAP", "FORM_COMPOUNDING", "FORM_LANDUSE"],
    Urban_Ceiling_Incharge: ["FORM_NOC", "FORM_MAP", "FORM_COMPOUNDING", "FORM_LANDUSE"],
    Tehsildar: ["FORM_NOC", "FORM_MAP", "FORM_COMPOUNDING", "FORM_LANDUSE"],
    AAI_General_Manager: ["FORM_NOC", "FORM_MAP", "FORM_COMPOUNDING", "FORM_LANDUSE"],
    Army_Airforce_Station_Officer: ["FORM_NOC", "FORM_MAP", "FORM_COMPOUNDING", "FORM_LANDUSE"],
    Fire_Chief_Officer: ["FORM_NOC", "FORM_MAP", "FORM_COMPOUNDING", "FORM_LANDUSE"],
    Irrigation_Executive_Officer: ["FORM_NOC", "FORM_MAP", "FORM_COMPOUNDING", "FORM_LANDUSE"],
    UPMRC_MD: ["FORM_NOC", "FORM_MAP", "FORM_COMPOUNDING", "FORM_LANDUSE"],
    Forest_District_Officer: ["FORM_NOC", "FORM_MAP", "FORM_COMPOUNDING", "FORM_LANDUSE"],
    Railways_Section_Engineer: ["FORM_NOC", "FORM_MAP", "FORM_COMPOUNDING", "FORM_LANDUSE"],
    Power_Executive_Engineer: ["FORM_NOC", "FORM_MAP", "FORM_COMPOUNDING", "FORM_LANDUSE"],
    NHAI_Project_Director: ["FORM_NOC", "FORM_MAP", "FORM_COMPOUNDING", "FORM_LANDUSE"],
    PWD_Executive_Engineer: ["FORM_NOC", "FORM_MAP", "FORM_COMPOUNDING", "FORM_LANDUSE"],
    ASI_Superintendent: ["FORM_NOC", "FORM_MAP", "FORM_COMPOUNDING", "FORM_LANDUSE"],
    Jail_Superintendent: ["FORM_NOC", "FORM_MAP", "FORM_COMPOUNDING", "FORM_LANDUSE"],
    ULB_Nagar_Aayukt: ["FORM_NOC", "FORM_MAP", "FORM_COMPOUNDING", "FORM_LANDUSE"],
    Environment_UPPCB_Secretary: ["FORM_NOC", "FORM_MAP", "FORM_COMPOUNDING", "FORM_LANDUSE"],
    Security_ADG: ["FORM_NOC", "FORM_MAP", "FORM_COMPOUNDING", "FORM_LANDUSE"],
    UPAVP_Chief_Architect: ["FORM_NOC", "FORM_MAP", "FORM_COMPOUNDING", "FORM_LANDUSE"]
  };
  const isNocModule = (userDetails === null || userDetails === void 0 ? void 0 : userDetails.organisationName) === "noc-services";
  const hasAuthorizedRoles = officerRole === null || officerRole === void 0 ? void 0 : officerRole.some(role => role.code === "NODAL_OFFICER_AWAS" || role.code === "Nodal Officer");
  const authorizedOfficer = officerRole === null || officerRole === void 0 ? void 0 : officerRole.some(role => ["Authorized_Officer", "DRAFTSMAN", "APA", "CAP", "AP", "AAP", "HC", "EE", "ATP", "TP", "CTP", "Additional_Secretory", "Additional_Secretary", "Vice_Chairman", "Joint_Secretary", "Secretory", "Secretary", "BPA_SURVEYOR", "ASSOCIATE_JE", "JE", "AE"].includes(role.code));
  const excludedRoles = ["Authorized_Officer", "DRAFTSMAN", "APA", "Acquisition_Section_Incharge", "NODAL_OFFICER_AWAS", "Nodal Officer", "HRMS_ADMIN", "SUPERUSER", "EMPLOYEE_ADMIN", "FINANCE_CONTROLLER", "Jail_Superintendent", "Power_Executive_Engineer", "Fire_Chief_Officer", "Power_Executive_Engineer", "Railways_Section_Engineer", "Tehsildar", "NHAI_Project_Director", "PWD_Executive_Engineer", "ASI_Superintendent", "Environment_UPPCB_Secretary", "UPMRC_MD", "ULB_Nagar_Aayukt", "Forest_District_Officer", "Urban_Ceiling_Incharge", "Nazul_Section_Incharge"];
  const showMapSub = !(officerRole !== null && officerRole !== void 0 && officerRole.some(role => excludedRoles.includes(role.code)));
  const getFormType = roleCode => {
    return roleToFormTypesMap[roleCode] || [];
  };
  const roleCode = officerRole === null || officerRole === void 0 ? void 0 : (_officerRole$ = officerRole[0]) === null || _officerRole$ === void 0 ? void 0 : _officerRole$.code;
  const formTypes = useMemo(() => getFormType(roleCode), [roleCode]);
  console.log("calculatedFormTypes", formTypes);
  const fetchLtpData = async () => {
    const data = await OBPSService.InboxSearchApplicationProfessional(tenantId, {});
    console.log("logginFromSidebar2", data);
    setLtpData(data);
  };
  const fetchAllFormTypesData = async () => {
    const allInboxResults = {};
    const allNocResults = {};
    console.log("fromFetchAllFormTypesData", formTypes, isNocModule);
    for (const formType of formTypes) {
      try {
        if (isNocModule) {
          const [nocResult, inboxResult] = await Promise.all([OBPSService.NOCCountSearch(tenantId, {
            applicationType: "FORM_NOC"
          }), OBPSService.InboxSearchApplication(tenantId, {
            applicationType: formType
          })]);
          allNocResults[formType] = nocResult;
          allInboxResults[formType] = inboxResult;
        } else {
          const inboxResult = await OBPSService.InboxSearchApplication(tenantId, {
            applicationType: formType
          });
          allInboxResults[formType] = inboxResult;
        }
      } catch (error) {
        console.error(`Error fetching for ${formType}`, error);
        allInboxResults[formType] = [];
        if (isNocModule) allNocResults[formType] = [];
      }
    }
    setDashBoardData(allInboxResults);
    if (isNocModule) setNocDashboardData(allNocResults);
  };
  const fetchSelfData = async () => {
    try {
      const postData = {
        RequestInfo: {
          apiId: "Rainmaker",
          authToken: authToken,
          userInfo: userDetails,
          msgId: "1757415138608|en_IN"
        }
      };
      const res = await axios.post(`${Urls.obps.getSelfApprovalData}?tenantId=${tenantId}`, postData);
      setSelfData(res.data);
      console.log("selfData", res, res.data);
    } catch (error) {
      console.log("error in fetching self data", error);
    }
  };
  useEffect(() => {
    var _officerRole$2, _officerRole$3, _officerRole$4;
    setSSODashUrl(localStorage.getItem("ssoDashboardURL"));
    if ((officerRole === null || officerRole === void 0 ? void 0 : (_officerRole$2 = officerRole[0]) === null || _officerRole$2 === void 0 ? void 0 : _officerRole$2.code) === "Nodal Officer" || (officerRole === null || officerRole === void 0 ? void 0 : (_officerRole$3 = officerRole[0]) === null || _officerRole$3 === void 0 ? void 0 : _officerRole$3.code) === "NODAL_OFFICER_AWAS") {
      fetchLtpData();
    }
    if (formTypes.length > 0 && (officerRole === null || officerRole === void 0 ? void 0 : (_officerRole$4 = officerRole[0]) === null || _officerRole$4 === void 0 ? void 0 : _officerRole$4.code) != "Nodal Officer") {
      fetchAllFormTypesData();
    }
  }, [roleCode, tenantId]);
  useEffect(() => {
    if (tenantId) {
      fetchSelfData();
    }
  }, [tenantId]);
  const {
    t
  } = useTranslation();
  console.log(dashboardData, "dashboardDataaa");
  return /*#__PURE__*/React__default.createElement("div", {
    className: "sidebar",
    style: {
      width: collapsed ? "0" : undefined,
      minWidth: collapsed ? "0" : undefined,
      padding: collapsed ? "0" : undefined,
      overflow: collapsed ? "hidden" : undefined,
      transition: "width 0.3s ease, min-width 0.3s ease, padding 0.3s ease"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: collapsed ? "none" : undefined
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "sidebar-sec-logo"
  }, /*#__PURE__*/React__default.createElement("img", {
    className: "state",
    src: "https://upload.wikimedia.org/wikipedia/commons/f/fa/Seal_of_Uttar_Pradesh.svg"
  }), /*#__PURE__*/React__default.createElement("h3", null, "FASTPAS")), (ADMIN || SUPERUSER) && /*#__PURE__*/React__default.createElement("div", {
    className: "without-dropdown"
  }, /*#__PURE__*/React__default.createElement("a", {
    href: "/digit-ui/employee"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classes.accordionHeader
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      marginRight: "5px"
    }
  }, /*#__PURE__*/React__default.createElement(AiFillHome, null)), " ", "Home"))), /*#__PURE__*/React__default.createElement("div", {
    className: "without-dropdown"
  }, /*#__PURE__*/React__default.createElement("a", {
    href: "/digit-ui/employee/obps/dashboard-details"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classes.accordionHeader,
    style: {
      background: window.location.pathname.includes("dashboard-details") ? "linear-gradient(135deg,rgba(21,101,192,0.15),rgba(2,136,209,0.08))" : undefined,
      borderLeft: window.location.pathname.includes("dashboard-details") ? "3px solid #1565c0" : undefined
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      marginRight: "5px"
    }
  }, /*#__PURE__*/React__default.createElement(AiFillDashboard, null)), " ", t("FASTPAS.DASHBOARD.MAIN.TEXT")))), !(ADMIN || SUPERUSER || FINANCE_CONTROLLER) && /*#__PURE__*/React__default.createElement("div", {
    className: "without-dropdown"
  }, /*#__PURE__*/React__default.createElement("a", {
    href: "/digit-ui/employee"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classes.accordionHeader
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      marginRight: "5px"
    }
  }, /*#__PURE__*/React__default.createElement(AiFillDashboard, null)), " ", "Received Files ", count && /*#__PURE__*/React__default.createElement("span", null, " (", count, ")")))), hasAuthorizedRoles && !authorizedOfficer && /*#__PURE__*/React__default.createElement(DashboardAccordion, {
    title: "Licensed Technical Professional",
    icon: /*#__PURE__*/React__default.createElement(TbArticleFilledFilled, null),
    formTypes: formTypes,
    dashboardData: ltpData,
    classes: classes
  }), isNocModule && /*#__PURE__*/React__default.createElement(DashboardAccordion, {
    title: "NOC Applications",
    icon: /*#__PURE__*/React__default.createElement(TbArticleFilledFilled, null),
    formTypes: formTypes,
    dashboardData: nocDashboardData,
    classes: classes,
    currentFormType: "FORM_NOC"
  }), authorizedOfficer && /*#__PURE__*/React__default.createElement(DashboardAccordion, {
    title: t("FASTPAS.GLOBAL.LAND.USE.VER.TEXT"),
    icon: /*#__PURE__*/React__default.createElement(TbArticleFilledFilled, null),
    formTypes: formTypes,
    dashboardData: dashboardData,
    classes: classes,
    currentFormType: "FORM_LANDUSE"
  }), showMapSub && /*#__PURE__*/React__default.createElement(DashboardAccordion, {
    title: t("FASTPAS.GLOBAL.MAP.SUBMISSION.TEXT"),
    icon: /*#__PURE__*/React__default.createElement(TbArticleFilledFilled, null),
    formTypes: formTypes,
    dashboardData: dashboardData,
    classes: classes,
    currentFormType: "FORM_MAP"
  }), showMapSub && /*#__PURE__*/React__default.createElement(DashboardAccordion, {
    title: t("Self Certification"),
    icon: /*#__PURE__*/React__default.createElement(TbArticleFilledFilled, null),
    formTypes: formTypes,
    dashboardData: selfData === null || selfData === void 0 ? void 0 : selfData.selfCertificate,
    classes: classes,
    currentFormType: "SELF_CERTIFICATION",
    isSelfApproval: true
  }), showMapSub && /*#__PURE__*/React__default.createElement(DashboardAccordion, {
    title: t("Self Approval"),
    icon: /*#__PURE__*/React__default.createElement(TbArticleFilledFilled, null),
    formTypes: formTypes,
    dashboardData: selfData === null || selfData === void 0 ? void 0 : selfData.selfApproval,
    classes: classes,
    currentFormType: "SELF_APPROVAL",
    isSelfApproval: true
  }), showMapSub && /*#__PURE__*/React__default.createElement(DashboardAccordion, {
    title: t("Compounding"),
    icon: /*#__PURE__*/React__default.createElement(TbArticleFilledFilled, null),
    formTypes: formTypes,
    dashboardData: dashboardData,
    classes: classes,
    currentFormType: "FORM_COMPOUNDING"
  }), showMapSub && /*#__PURE__*/React__default.createElement(DashboardAccordion, {
    title: "Purchasable FAR",
    icon: /*#__PURE__*/React__default.createElement(TbArticleFilledFilled, null),
    formTypes: formTypes,
    dashboardData: dashboardData,
    classes: classes,
    currentFormType: "FORM_PURCHASABLE_FAR"
  }), showMapSub && /*#__PURE__*/React__default.createElement(DashboardAccordion, {
    title: t("FASTPAS.GLOBAL.PLINTH.SUB.TEXT"),
    icon: /*#__PURE__*/React__default.createElement(TbArticleFilledFilled, null),
    formTypes: formTypes,
    dashboardData: dashboardData,
    classes: classes,
    currentFormType: "FORM_PLINTH"
  }), showMapSub && /*#__PURE__*/React__default.createElement(DashboardAccordion, {
    title: t("Completion"),
    icon: /*#__PURE__*/React__default.createElement(TbArticleFilledFilled, null),
    formTypes: formTypes,
    dashboardData: dashboardData,
    classes: classes,
    currentFormType: "FORM_COMPLETION"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "without-dropdown"
  }, /*#__PURE__*/React__default.createElement("a", {
    href: "/digit-ui/employee/obps/mis-reports"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classes.accordionHeader
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      marginRight: "5px"
    }
  }, /*#__PURE__*/React__default.createElement(BiSolidReport, null)), " ", "MIS Reports"))), isVC && /*#__PURE__*/React__default.createElement("div", {
    className: "without-dropdown"
  }, /*#__PURE__*/React__default.createElement("a", {
    href: "/digit-ui/employee/obps/edit-challan"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classes.accordionHeader,
    style: {
      background: window.location.pathname.includes("edit-challan") ? "linear-gradient(135deg,rgba(21,101,192,0.15),rgba(2,136,209,0.08))" : undefined,
      borderLeft: window.location.pathname.includes("edit-challan") ? "3px solid #1565c0" : undefined
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      marginRight: "5px"
    }
  }, /*#__PURE__*/React__default.createElement(FaEdit, null)), " ", t("FASTPAS_EDIT_CHALLAN", "Edit Challan"))))));
};

const SideBar = ({
  t,
  CITIZEN,
  isSidebarOpen,
  toggleSidebar,
  handleLogout,
  mobileView,
  userDetails,
  sidebarOpen,
  sidebarToggle,
  sidebarCollapsed
}) => {
  if (CITIZEN) return /*#__PURE__*/React__default.createElement(CitizenSideBar, {
    isOpen: isSidebarOpen,
    isMobile: true,
    toggleSidebar: toggleSidebar,
    onLogout: handleLogout,
    sidebarOpen: sidebarOpen,
    sidebarToggle: sidebarToggle
  });else {
    if (!mobileView && userDetails !== null && userDetails !== void 0 && userDetails.access_token) return /*#__PURE__*/React__default.createElement(EmployeeSideBar, Object.assign({}, {
      mobileView,
      userDetails
    }, {
      collapsed: sidebarCollapsed
    }));else return /*#__PURE__*/React__default.createElement(CitizenSideBar, {
      isOpen: isSidebarOpen,
      isMobile: true,
      toggleSidebar: toggleSidebar,
      onLogout: handleLogout,
      isEmployee: true
    });
  }
};

const TopBarSideBar = ({
  t,
  stateInfo,
  userDetails,
  CITIZEN,
  cityDetails,
  mobileView,
  handleUserDropdownSelection,
  logoUrl,
  showSidebar: _showSidebar = true,
  showLanguageChange
}) => {
  const [isSidebarOpen, toggleSidebar] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [sidebarWidth, setSidebarWidth] = useState(0);
  const toggleEmployeeSidebar = () => setSidebarCollapsed(prev => !prev);
  const history = useHistory();
  const sidebarToggle = () => setSidebarOpen(!sidebarOpen);
  const handleLogout = () => {
    toggleSidebar(false);
    Digit.UserService.logout();
  };
  const userProfile = () => history.push("/digit-ui/employee/user/profile");
  const userOptions = [{
    name: t("EDIT_PROFILE"),
    icon: /*#__PURE__*/React__default.createElement(EditPencilIcon, {
      className: "icon"
    }),
    func: userProfile
  }, {
    name: t("CORE_COMMON_LOGOUT"),
    icon: /*#__PURE__*/React__default.createElement(LogoutIcon, {
      className: "icon"
    }),
    func: handleLogout
  }];
  const loggedin = userDetails !== null && userDetails !== void 0 && userDetails.access_token ? true : false;
  const showToggle = !CITIZEN && !mobileView && loggedin && _showSidebar;
  useLayoutEffect(() => {
    if (!showToggle) return;
    let observer;
    const measure = () => {
      const sidebar = document.querySelector(".employee .sidebar");
      if (sidebar) {
        const w = sidebar.getBoundingClientRect().width;
        if (w > 0) {
          setSidebarWidth(w);
          if (!observer) {
            observer = new ResizeObserver(() => {
              const nw = sidebar.getBoundingClientRect().width;
              if (nw > 0) setSidebarWidth(nw);
            });
            observer.observe(sidebar);
          }
        }
      }
    };
    measure();
    const timer = setTimeout(measure, 300);
    return () => {
      clearTimeout(timer);
      if (observer) observer.disconnect();
    };
  }, [showToggle]);
  useEffect(() => {
    if (!showToggle || sidebarWidth === 0) return;
    const mainEl = document.querySelector(".employee .main");
    if (mainEl) {
      mainEl.style.transition = "margin-left 0.3s ease, padding-top 0.3s ease";
      mainEl.style.marginLeft = sidebarCollapsed ? "0px" : `${sidebarWidth}px`;
    }
    return () => {
      const el = document.querySelector(".employee .main");
      if (el) {
        el.style.marginLeft = "";
        el.style.paddingTop = "";
        el.style.transition = "";
      }
    };
  }, [sidebarCollapsed, sidebarWidth, showToggle]);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(TopBar, {
    t: t,
    stateInfo: stateInfo,
    toggleSidebar: toggleSidebar,
    isSidebarOpen: isSidebarOpen,
    handleLogout: handleLogout,
    userDetails: userDetails,
    CITIZEN: CITIZEN,
    cityDetails: cityDetails,
    mobileView: mobileView,
    userOptions: userOptions,
    handleUserDropdownSelection: handleUserDropdownSelection,
    logoUrl: logoUrl,
    showLanguageChange: showLanguageChange,
    sidebarOpen: sidebarOpen,
    sidebarToggle: sidebarToggle
  }), _showSidebar && /*#__PURE__*/React__default.createElement(SideBar, {
    t: t,
    CITIZEN: CITIZEN,
    isSidebarOpen: isSidebarOpen,
    toggleSidebar: toggleSidebar,
    handleLogout: handleLogout,
    mobileView: mobileView,
    userDetails: userDetails,
    sidebarOpen: sidebarOpen,
    sidebarToggle: sidebarToggle,
    sidebarCollapsed: sidebarCollapsed
  }), showToggle && /*#__PURE__*/React__default.createElement("div", {
    style: {
      position: "fixed",
      top: "0px",
      left: sidebarCollapsed ? "0px" : `${sidebarWidth}px`,
      right: 0,
      height: "36px",
      display: "flex",
      alignItems: "center",
      paddingLeft: "10px",
      zIndex: 1001,
      transition: "left 0.3s ease"
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    onClick: toggleEmployeeSidebar,
    title: sidebarCollapsed ? "Expand Sidebar" : "Collapse Sidebar",
    style: {
      cursor: "pointer",
      color: "white",
      display: "flex",
      alignItems: "center"
    }
  }, sidebarCollapsed ? /*#__PURE__*/React__default.createElement(ArrowForwardIos, {
    style: {
      fontSize: "18px"
    }
  }) : /*#__PURE__*/React__default.createElement(ArrowBackIos, {
    style: {
      fontSize: "18px"
    }
  }))));
};

function UploadDrawer({
  setProfilePic,
  closeDrawer,
  userType,
  removeProfilePic,
  showToast
}) {
  const [uploadedFile, setUploadedFile] = useState(null);
  const [file, setFile] = useState("");
  const [error, setError] = useState(null);
  const {
    t
  } = useTranslation();
  const selectfile = e => setFile(e.target.files[0]);
  const removeimg = () => {
    removeProfilePic();
    closeDrawer();
  };
  const onOverlayBodyClick = () => closeDrawer();
  useEffect(() => {
    (async () => {
      setError(null);
      if (file) {
        if (file.size >= 1000000) {
          showToast("error", t("CORE_COMMON_PROFILE_MAXIMUM_UPLOAD_SIZE_EXCEEDED"));
          setError(t("CORE_COMMON_PROFILE_MAXIMUM_UPLOAD_SIZE_EXCEEDED"));
        } else {
          try {
            var _response$data, _response$data$files;
            const response = await Digit.UploadServices.Filestorage(`${userType}-profile`, file, Digit.ULBService.getStateId());
            if ((response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$files = _response$data.files) === null || _response$data$files === void 0 ? void 0 : _response$data$files.length) > 0) {
              var _response$data2, _response$data2$files;
              const fileStoreId = response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : (_response$data2$files = _response$data2.files[0]) === null || _response$data2$files === void 0 ? void 0 : _response$data2$files.fileStoreId;
              setUploadedFile(fileStoreId);
              setProfilePic(fileStoreId);
            } else {
              showToast("error", t("CORE_COMMON_PROFILE_FILE_UPLOAD_ERROR"));
              setError(t("CORE_COMMON_PROFILE_FILE_UPLOAD_ERROR"));
            }
          } catch (err) {
            showToast("error", t("CORE_COMMON_PROFILE_INVALID_FILE_INPUT"));
          }
        }
      }
    })();
  }, [file]);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      position: "fixed",
      top: "0",
      left: "0",
      right: "0",
      bottom: "0",
      width: "100%",
      height: "100vh",
      backgroundColor: "rgba(0,0,0,.5)"
    },
    onClick: onOverlayBodyClick
  }), /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%",
      justifyContent: "space-between",
      display: "flex",
      backgroundColor: "white",
      alignItems: "center",
      position: "fixed",
      left: "0",
      right: "0",
      height: "20%",
      bottom: userType === "citizen" ? "2.5rem" : "0",
      zIndex: "2"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      flex: "1",
      flexDirection: "column",
      width: "100%",
      justifyContent: "center",
      alignItems: "center",
      gap: "8px 0"
    }
  }, /*#__PURE__*/React__default.createElement("label", {
    for: "file",
    style: {
      cursor: "pointer"
    }
  }, " ", /*#__PURE__*/React__default.createElement(GalleryIcon, null)), /*#__PURE__*/React__default.createElement("label", {
    style: {
      cursor: "pointer"
    }
  }, " Gallery"), /*#__PURE__*/React__default.createElement("input", {
    type: "file",
    id: "file",
    accept: "image/*, .png, .jpeg, .jpg",
    onChange: selectfile,
    style: {
      display: "none"
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      flex: "1",
      width: "100%",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column",
      gap: "8px 0"
    }
  }, /*#__PURE__*/React__default.createElement("button", {
    onClick: removeimg
  }, /*#__PURE__*/React__default.createElement(RemoveIcon, null)), /*#__PURE__*/React__default.createElement("label", {
    style: {
      cursor: "pointer"
    }
  }, "Remove"))));
}

function SinatureDrawer({
  setSignaturePic,
  closeDrawer,
  userType,
  removeProfilePic,
  showToast
}) {
  const [uploadedFile, setUploadedFile] = useState(null);
  const [file, setFile] = useState("");
  const [error, setError] = useState(null);
  const {
    t
  } = useTranslation();
  const selectfile = e => setFile(e.target.files[0]);
  const removeimg = () => {
    removeProfilePic();
    closeDrawer();
  };
  const onOverlayBodyClick = () => closeDrawer();
  useEffect(() => {
    (async () => {
      setError(null);
      if (file) {
        if (file.size >= 1000000) {
          showToast("error", t("CORE_COMMON_PROFILE_MAXIMUM_UPLOAD_SIZE_EXCEEDED"));
          setError(t("CORE_COMMON_PROFILE_MAXIMUM_UPLOAD_SIZE_EXCEEDED"));
        } else {
          try {
            var _response$data, _response$data$files;
            const response = await Digit.UploadServices.Filestorage(`${userType}-profile`, file, Digit.ULBService.getStateId());
            if ((response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : (_response$data$files = _response$data.files) === null || _response$data$files === void 0 ? void 0 : _response$data$files.length) > 0) {
              var _response$data2, _response$data2$files;
              const fileStoreId = response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : (_response$data2$files = _response$data2.files[0]) === null || _response$data2$files === void 0 ? void 0 : _response$data2$files.fileStoreId;
              setUploadedFile(fileStoreId);
              setSignaturePic(fileStoreId);
            } else {
              showToast("error", t("CORE_COMMON_PROFILE_FILE_UPLOAD_ERROR"));
              setError(t("CORE_COMMON_PROFILE_FILE_UPLOAD_ERROR"));
            }
          } catch (err) {
            showToast("error", t("CORE_COMMON_PROFILE_INVALID_FILE_INPUT"));
          }
        }
      }
    })();
  }, [file]);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      position: "fixed",
      top: "0",
      left: "0",
      right: "0",
      bottom: "0",
      width: "100%",
      height: "100vh",
      backgroundColor: "rgba(0,0,0,.5)"
    },
    onClick: onOverlayBodyClick
  }), /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%",
      justifyContent: "space-between",
      display: "flex",
      backgroundColor: "white",
      alignItems: "center",
      position: "fixed",
      left: "0",
      right: "0",
      height: "20%",
      bottom: userType === "citizen" ? "2.5rem" : "0",
      zIndex: "2"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      flex: "1",
      flexDirection: "column",
      width: "100%",
      justifyContent: "center",
      alignItems: "center",
      gap: "8px 0"
    }
  }, /*#__PURE__*/React__default.createElement("label", {
    for: "file",
    style: {
      cursor: "pointer"
    }
  }, " ", /*#__PURE__*/React__default.createElement(GalleryIcon, null)), /*#__PURE__*/React__default.createElement("label", {
    style: {
      cursor: "pointer"
    }
  }, " Gallery"), /*#__PURE__*/React__default.createElement("input", {
    type: "file",
    id: "file",
    accept: "image/*, .png, .jpeg, .jpg",
    onChange: selectfile,
    style: {
      display: "none"
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      flex: "1",
      width: "100%",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column",
      gap: "8px 0"
    }
  }, /*#__PURE__*/React__default.createElement("button", {
    onClick: removeimg
  }, /*#__PURE__*/React__default.createElement(RemoveIcon, null)), /*#__PURE__*/React__default.createElement("label", {
    style: {
      cursor: "pointer"
    }
  }, "Remove"))));
}

const defaultImage = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAO4AAADUCAMAAACs0e/bAAAAM1BMVEXK0eL" + "/" + "/" + "/" + "/Dy97GzuD4+fvL0uPg5O7T2efb4OvR1+Xr7vTk5/Df4+37/P3v8fbO1eTt8PUsnq5FAAAGqElEQVR4nO2d25ajIBBFCajgvf/" + "/a0eMyZgEjcI5xgt7Hmatme507UaxuJXidiDqjmSgeVIMlB1ZR1WZAf2gbdu0QwixSYzjOJPmHurfEGEfY9XzjNGG9whQCeVAuv5xQEySLtR9hPuIcwj0EeroN5m3D1IbsbgHK0esiQ9MKs" + "qXVr8Hm/a/Pulk6wihpCIXBw3dh7bTvRBt9+dC5NfS1VH3xETdM3MxXRN1T0zUPTNR98xcS1dlV9NNfx3DhkTdM6PKqHteVBF1z0vU5f0sKdpc2zWLKutXrjJjdLvpesRmukqYonauPhXpds" + "Lb6CppmpnltsYIuY2yavi6Mi2/rzAWm1zUfF0limVLqkZyA+mDYevKBS37aGC+L1lX5e7uyU1Cv565uiua9k5LFqbqqrnu2I3m+jJ11ZoLeRtfmdB0Uw/ZDsP0VTxdn7a1VERfmq7Xl" + "Xyn5D2QWLoq8bZlPoBJumphJjVBw/Ll6CoTZGsTDs4NrGqKbqBth8ZHJUi6cn168QmleSm6GmB7Kxm+6obXlf7PoDHosCwM3QpiS2legi6ocSl3L0G3BdneDDgwQdENfeY+SfDJBkF37Z" + "B+GvwzA6/rMaafAn8143VhPZWdjMWG1oHXhdnemgPoAvLlB/iZyRTfVeF06wPoQhJmlm4bdcOAZRlRN5gcPc5SoPEQR1fDdbOo6wn+uYvXxY0QCLom6gYROKH+Aj5nvphuFXWDiLpRdxl" + "/19LFT95k6CHCrnW7pCDqBn1i1PUFvii2c11oZOJ6usWeH0RRNzC4Zs+6FTi2nevCVwCjbugnXklX5fkfTldL8PEilUB1kfNyN1u9MME2sATr4lbuB7AjfLAuvsRm1A0g6gYRdcPAjvBlje" + "2Z8brI8OC68AcRdlCkwLohx2mcZMjw9q+LzarQurjtnwPYAydX08WecECO/u6Ad0GBdYG7jO5gB4Ap+PwKcA9ZT43dn4/W9TyiPAn4OAJaF7h3uwe8StSCddFdM3jqFa2LvnnB5zzhuuBBAj" + "Y4gi50cg694gnXhTYvfMdrjtcFZhrwE9r41gUem8IXWMC3LrBzxh+a0gRd1N1LOK7M0IUUGuggvEmHoStA2/MJh7MpupiDU4TzjhxdzLAoO4ouZvqVURbFMHQlZD6SUeWHoguZsSLUGegreh" + "A+FZFowPdUWTi6iMoZlIpGGUUXkDbjj/9ZOLqAQS/+GIKl5BQOCn/ycqpzkXSDm5dU7ZWkG7wUyGlcmm7g5Ux56AqirgoaJ7BeokPTDbp9CbVunjFxPrl7+HqnkrSq1Da7JX20f3dV8yJi6v" + "oO81mX8vV0mx3qUsZCPRfTlVRdz2EvdufYGDvNQvvwqHtmXd+a1ITinwNcXc+lT6JuzdT1XDyBn/x7wtX1HCQQdW9MXc8xArGrirowfLeUEbMqqq6f7TF1lfRdOuGNiGi6SpT+WxY06xUfNN" + "2wBfyE9I4tlm7w5hvOPDNJN3yNiLMipji6gE3chKhouoCtN5x3QlF0EZt8OW/8ougitqJQlk1aii7iFC9l0MvRReyao7xNjKML2Z/PuHlzhi5mFxljiZeiC9rPTEisNEMX9KYAwo5Xhi7qaA" + "3hamboYm7dG+NVrXhdaYDv5zFaQZsYrCtbbAGnjkQDX2+J1FXCwOsqWOpKoIQNTFdqYBWydxqNqUoG0pVpCS+H8kaJaGKErlIaXj7CRRE+gRWuKwW9YZ80oVOUgbpdT0zpnSZJTIiwCtJVelv" + "Xntr4P5j6BWfPb5Wcx84C4cq3hb11lco2u2Mdwp6XdJ/Ne3wb8DWdfiRenZaXrhLwOj4e+GQeHroy3YOspS7TlU28Wle2m2QUS0mqdcbrdNW+ZHsSsyK7tBfm0q/dWcv+Z3mytVx3t7KWulq" + "Ue6ilunu8jF8pFwgv1FXp3mUt35OtRbr7eM4u4Gs6vUBXgeuHc5kfE/cbvWZtkROLm1DMtLCy80tzsu2PRj0hTI8fvrQuvsjlJkyutszq+m423wHaLTyniy/XuiGZ84LuT+m5ZfNfRxyGs7L" + "XZOvia7VujatUwVTrIt+Q/Csc7Tuhe+BOakT10b4TuoiiJjvgU9emTO42PwEfBa+cuodKkuf42DXr1D3JpXz73Hnn0j10evHKe+nufgfUm+7B84sX9FfdEzXux2DBpWuKokkCqN/5pa/8pmvn" + "L+RGKCddCGmatiPyPB/+ekO/M/q/7uvbt22kTt3zEnXPzCV13T3Gel4/6NduDu66xRvlPNkM1RjjxUdv+4WhGx6TftD19Q/dfzpwcHO+rE3fAAAAAElFTkSuQmCC";
const defaultSignatureImg = "https://www.jsign.com/wp-content/uploads/2021/06/icon-tablet-signature-pen.svg";
const UserProfile = ({
  stateCode,
  userType,
  cityDetails
}) => {
  var _Digit$UserService$ge, _userDetails$permanen, _errors$userName, _errors$emailAddress, _errors$mobileNumber, _errors$userName2, _errors$mobileNumber2, _errors$emailAddress2, _errors$currentPasswo, _errors$newPassword, _errors$confirmPasswo;
  const history = useHistory();
  const {
    t
  } = useTranslation();
  const stateId = Digit.ULBService.getStateId();
  const tenant = Digit.ULBService.getCurrentTenantId();
  const userInfo = ((_Digit$UserService$ge = Digit.UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : _Digit$UserService$ge.info) || {};
  const [userDetails, setUserDetails] = useState(null);
  const {
    data: cities,
    isLoading
  } = Digit.Hooks.useTenants();
  const cityCode = tenant.includes("da") ? "da" : "avp";
  const districts = !isLoading ? cities === null || cities === void 0 ? void 0 : cities.filter(city => {
    var _city$code;
    return !((_city$code = city.code) !== null && _city$code !== void 0 && _city$code.includes("up"));
  }) : [];
  const [name, setName] = useState(userInfo !== null && userInfo !== void 0 && userInfo.name ? userInfo.name : "");
  const [email, setEmail] = useState(userInfo !== null && userInfo !== void 0 && userInfo.emailId ? userInfo.emailId : "");
  const [gender, setGender] = useState(userDetails === null || userDetails === void 0 ? void 0 : userDetails.gender);
  const [city, setCity] = useState(userDetails === null || userDetails === void 0 ? void 0 : (_userDetails$permanen = userDetails.permanentAddress) === null || _userDetails$permanen === void 0 ? void 0 : _userDetails$permanen.district);
  const [mobileNumber, setMobileNo] = useState(userInfo !== null && userInfo !== void 0 && userInfo.mobileNumber ? userInfo.mobileNumber : "");
  const [profilePic, setProfilePic] = useState(userDetails === null || userDetails === void 0 ? void 0 : userDetails.photo);
  const [signaturePic, setSignaturePic] = useState(userDetails === null || userDetails === void 0 ? void 0 : userDetails.signature);
  const [profileImg, setProfileImg] = useState("");
  const [signatureImg, SetSignatureImg] = useState(userDetails !== null && userDetails !== void 0 && userDetails.signature ? userDetails === null || userDetails === void 0 ? void 0 : userDetails.signature : "");
  const [openUploadSlide, setOpenUploadSide] = useState(false);
  const [openSignatureUploadSlide, setOpenSignatureUploadSide] = useState(false);
  const [changepassword, setChangepassword] = useState(false);
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [toast, setToast] = useState(null);
  const [loading, setLoading] = useState(false);
  const [windowWidth, setWindowWidth] = React__default.useState(window.innerWidth);
  const [errors, setErrors] = React__default.useState({});
  const isCitizen = Digit.UserService.getType();
  console.log(isCitizen, "isCitizennnn");
  const getUserInfo = async () => {
    const uuid = userInfo === null || userInfo === void 0 ? void 0 : userInfo.uuid;
    if (uuid) {
      const usersResponse = await Digit.UserService.userSearch(tenant, {
        uuid: [uuid]
      }, {});
      usersResponse && usersResponse.user && usersResponse.user.length && setUserDetails(usersResponse.user[0]);
    }
  };
  React__default.useEffect(() => {
    window.addEventListener("resize", () => setWindowWidth(window.innerWidth));
    return () => {
      window.removeEventListener("resize", () => setWindowWidth(window.innerWidth));
    };
  });
  useEffect(() => {
    var _userDetails$permanen2, _userDetails$permanen3, _userDetails$photo, _userDetails$signatur;
    setLoading(true);
    getUserInfo();
    setGender({
      i18nKey: undefined,
      code: userDetails === null || userDetails === void 0 ? void 0 : userDetails.gender,
      value: userDetails === null || userDetails === void 0 ? void 0 : userDetails.gender
    });
    setCity({
      i18nKey: null,
      code: userDetails === null || userDetails === void 0 ? void 0 : (_userDetails$permanen2 = userDetails.permanentAddress) === null || _userDetails$permanen2 === void 0 ? void 0 : _userDetails$permanen2.district,
      name: userDetails === null || userDetails === void 0 ? void 0 : (_userDetails$permanen3 = userDetails.permanentAddress) === null || _userDetails$permanen3 === void 0 ? void 0 : _userDetails$permanen3.district
    });
    const thumbs = userDetails === null || userDetails === void 0 ? void 0 : (_userDetails$photo = userDetails.photo) === null || _userDetails$photo === void 0 ? void 0 : _userDetails$photo.split(",");
    setProfileImg(thumbs === null || thumbs === void 0 ? void 0 : thumbs.at(0));
    const thumbSignature = userDetails === null || userDetails === void 0 ? void 0 : (_userDetails$signatur = userDetails.signature) === null || _userDetails$signatur === void 0 ? void 0 : _userDetails$signatur.split(",");
    SetSignatureImg(thumbSignature === null || thumbSignature === void 0 ? void 0 : thumbSignature.at(0));
    setLoading(false);
  }, [userDetails !== null]);
  let validation = {};
  const editScreen = false;
  const onClickAddPic = () => setOpenUploadSide(!openUploadSlide);
  const onClickAddSignature = () => setOpenSignatureUploadSide(!openSignatureUploadSlide);
  const TogleforPassword = () => setChangepassword(!changepassword);
  const setGenderName = value => setGender(value);
  const setCityName = value => setCity({
    i18nKey: value === null || value === void 0 ? void 0 : value.i18nKey,
    code: value === null || value === void 0 ? void 0 : value.name,
    name: value === null || value === void 0 ? void 0 : value.name
  });
  const closeFileUploadDrawer = () => setOpenUploadSide(false);
  const closeFileSignaturDrawer = () => setOpenSignatureUploadSide(false);
  const setUserName = value => {
    setName(value);
    if (!new RegExp(/^[a-zA-Z ]+$/i).test(value) || value.length === 0 || value.length > 50) {
      setErrors({
        ...errors,
        userName: {
          type: "pattern",
          message: "CORE_COMMON_PROFILE_NAME_INVALID"
        }
      });
    } else {
      setErrors({
        ...errors,
        userName: null
      });
    }
  };
  const setUserEmailAddress = value => {
    setEmail(value);
    if (value.length && !(value.includes("@") && value.includes("."))) {
      setErrors({
        ...errors,
        emailAddress: {
          type: "pattern",
          message: "CORE_COMMON_PROFILE_EMAIL_INVALID"
        }
      });
    } else {
      setErrors({
        ...errors,
        emailAddress: null
      });
    }
  };
  const setUserMobileNumber = value => {
    setMobileNo(value);
    if (userType === "employee" && !new RegExp(/^[6-9]{1}[0-9]{9}$/).test(value)) {
      setErrors({
        ...errors,
        mobileNumber: {
          type: "pattern",
          message: "CORE_COMMON_PROFILE_MOBILE_NUMBER_INVALID"
        }
      });
    } else {
      setErrors({
        ...errors,
        mobileNumber: null
      });
    }
  };
  const setUserCurrentPassword = value => {
    setCurrentPassword(value);
    if (value.length && !new RegExp(/^([a-zA-Z0-9@#$%]{8,15})$/i).test(value)) {
      setErrors({
        ...errors,
        currentPassword: {
          type: "pattern",
          message: "CORE_COMMON_PROFILE_PASSWORD_INVALID"
        }
      });
    } else {
      setErrors({
        ...errors,
        currentPassword: null
      });
    }
  };
  const setUserNewPassword = value => {
    setNewPassword(value);
    if (value.length && !new RegExp(/^([a-zA-Z0-9@#$%]{8,15})$/i).test(value)) {
      setErrors({
        ...errors,
        newPassword: {
          type: "pattern",
          message: "CORE_COMMON_PROFILE_PASSWORD_INVALID"
        }
      });
    } else {
      setErrors({
        ...errors,
        newPassword: null
      });
    }
  };
  const setUserConfirmPassword = value => {
    setConfirmPassword(value);
    if (value.length && !new RegExp(/^([a-zA-Z0-9@#$%]{8,15})$/i).test(value)) {
      setErrors({
        ...errors,
        confirmPassword: {
          type: "pattern",
          message: "CORE_COMMON_PROFILE_PASSWORD_INVALID"
        }
      });
    } else {
      setErrors({
        ...errors,
        confirmPassword: null
      });
    }
  };
  const removeProfilePic = () => {
    setProfilePic(null);
    setProfileImg(null);
  };
  const removeSignaturePic = () => {
    setSignaturePic(null);
    SetSignatureImg(null);
  };
  const showToast = (type, message, duration = 5000) => {
    setToast({
      key: type,
      action: message
    });
    setTimeout(() => {
      setToast(null);
    }, duration);
  };
  const updateProfile = async () => {
    setLoading(true);
    try {
      const requestData = {
        ...userInfo,
        validUpto: userDetails === null || userDetails === void 0 ? void 0 : userDetails.validUpto,
        name,
        gender: gender === null || gender === void 0 ? void 0 : gender.value,
        emailId: email,
        photo: profilePic || profileImg,
        signature: signaturePic || signatureImg,
        mobileNumber: mobileNumber,
        userName: userType === "employee" ? userInfo === null || userInfo === void 0 ? void 0 : userInfo.userName : mobileNumber,
        permanentAddress: {
          district: city === null || city === void 0 ? void 0 : city.name,
          address: city === null || city === void 0 ? void 0 : city.name,
          type: "PERMANENT"
        }
      };
      if (!new RegExp(/^([a-zA-Z ])*$/).test(name) || name === "" || name.length > 50 || name.length < 1) {
        throw JSON.stringify({
          type: "error",
          message: "CORE_COMMON_PROFILE_NAME_INVALID"
        });
      }
      if (userType === "employee" && !new RegExp(/^[6-9]{1}[0-9]{9}$/).test(mobileNumber)) {
        throw JSON.stringify({
          type: "error",
          message: "CORE_COMMON_PROFILE_MOBILE_NUMBER_INVALID"
        });
      }
      if (email.length && !(email.includes("@") && email.includes("."))) {
        throw JSON.stringify({
          type: "error",
          message: "CORE_COMMON_PROFILE_EMAIL_INVALID"
        });
      }
      if (currentPassword.length || newPassword.length || confirmPassword.length) {
        if (newPassword !== confirmPassword) {
          throw JSON.stringify({
            type: "error",
            message: "CORE_COMMON_PROFILE_PASSWORD_MISMATCH"
          });
        }
        if (!(currentPassword.length && newPassword.length && confirmPassword.length)) {
          throw JSON.stringify({
            type: "error",
            message: "CORE_COMMON_PROFILE_PASSWORD_INVALID"
          });
        }
        if (!new RegExp(/^([a-zA-Z0-9@#$%]{8,15})$/i).test(newPassword) && !new RegExp(/^([a-zA-Z0-9@#$%]{8,15})$/i).test(confirmPassword)) {
          throw JSON.stringify({
            type: "error",
            message: "CORE_COMMON_PROFILE_PASSWORD_INVALID"
          });
        }
      }
      const {
        responseInfo,
        user
      } = await Digit.UserService.updateUser(requestData, stateCode);
      if (responseInfo && responseInfo.status === "200") {
        const _user = Digit.UserService.getUser();
        if (_user) {
          Digit.UserService.setUser({
            ..._user,
            info: {
              ..._user.info,
              name,
              mobileNumber,
              emailId: email,
              permanentCity: city === null || city === void 0 ? void 0 : city.name
            }
          });
        }
      }
      if (currentPassword.length && newPassword.length && confirmPassword.length) {
        const _requestData = {
          existingPassword: currentPassword,
          newPassword: newPassword,
          tenantId: tenant,
          type: "EMPLOYEE",
          userName: userInfo === null || userInfo === void 0 ? void 0 : userInfo.userName,
          confirmPassword: confirmPassword
        };
        if (newPassword === confirmPassword) {
          try {
            const res = await Digit.UserService.changePassword(_requestData, tenant);
            const {
              responseInfo: changePasswordResponseInfo
            } = res;
            if (changePasswordResponseInfo !== null && changePasswordResponseInfo !== void 0 && changePasswordResponseInfo.status && changePasswordResponseInfo.status === "200") {
              showToast("success", t("CORE_COMMON_PROFILE_UPDATE_SUCCESS_WITH_PASSWORD"), 5000);
            } else {
              throw "";
            }
          } catch (error) {
            var _error$Errors, _error$Errors$at;
            throw JSON.stringify({
              type: "error",
              message: (_error$Errors = error.Errors) !== null && _error$Errors !== void 0 && (_error$Errors$at = _error$Errors.at(0)) !== null && _error$Errors$at !== void 0 && _error$Errors$at.description ? error.Errors.at(0).description : "CORE_COMMON_PROFILE_UPDATE_ERROR_WITH_PASSWORD"
            });
          }
        } else {
          throw JSON.stringify({
            type: "error",
            message: "CORE_COMMON_PROFILE_ERROR_PASSWORD_NOT_MATCH"
          });
        }
      } else if (responseInfo !== null && responseInfo !== void 0 && responseInfo.status && responseInfo.status === "200") {
        showToast("success", t("CORE_COMMON_PROFILE_UPDATE_SUCCESS"), 5000);
      }
    } catch (error) {
      const errorObj = JSON.parse(error);
      showToast(errorObj.type, t(errorObj.message), 5000);
    }
    setLoading(false);
  };
  let menu = [];
  const {
    data: Menu
  } = Digit.Hooks.pt.useGenderMDMS(stateId, "common-masters", "GenderType");
  Menu && Menu.map(genderDetails => {
    menu.push({
      i18nKey: `PT_COMMON_GENDER_${genderDetails.code}`,
      code: `${genderDetails.code}`,
      value: `${genderDetails.code}`
    });
  });
  const setFileStoreId = async fileStoreId => {
    const thumbnails = fileStoreId ? await getThumbnails([fileStoreId], stateId) : null;
    setProfilePic(fileStoreId);
    setProfileImg(fileStoreId);
    closeFileUploadDrawer();
  };
  const setFileStoreSignature = async fileStoreId => {
    const thumbnailSignature = fileStoreId ? await getThumbnailSignature([fileStoreId], stateId) : null;
    setSignaturePic(fileStoreId);
    SetSignatureImg(fileStoreId);
    setOpenSignatureUploadSide();
  };
  const getThumbnailSignature = async (ids, tenantId) => {
    const res = await Digit.UploadServices.Filefetch(ids, tenantId);
    if (res.data.fileStoreIds && res.data.fileStoreIds.length !== 0) {
      return {
        thumbs: res.data.fileStoreIds.map(o => o.url.split(",")[3]),
        images: res.data.fileStoreIds.map(o => Digit.Utils.getFileUrl(o.url))
      };
    } else {
      return null;
    }
  };
  const getThumbnails = async (ids, tenantId) => {
    const res = await Digit.UploadServices.Filefetch(ids, tenantId);
    if (res.data.fileStoreIds && res.data.fileStoreIds.length !== 0) {
      return {
        thumbs: res.data.fileStoreIds.map(o => o.url.split(",")[3]),
        images: res.data.fileStoreIds.map(o => Digit.Utils.getFileUrl(o.url))
      };
    } else {
      return null;
    }
  };
  if (loading) return /*#__PURE__*/React__default.createElement(Loader, null);
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("section", {
    style: {
      margin: "24px"
    }
  }, /*#__PURE__*/React__default.createElement(BackButton, null)), /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      flex: 1,
      flexDirection: windowWidth < 768 || userType === "citizen" ? "column" : "row",
      margin: userType === "citizen" ? "8px" : "16px",
      gap: userType === "citizen" ? "" : "0 24px",
      boxShadow: userType === "citizen" ? "1px 1px 4px 0px rgba(0,0,0,0.2)" : "",
      background: userType === "citizen" ? "white" : "",
      borderRadius: userType === "citizen" ? "4px" : ""
    }
  }, /*#__PURE__*/React__default.createElement("section", {
    style: {
      position: "relative",
      display: "flex",
      flex: userType === "citizen" ? 1 : 2.5,
      justifyContent: "center",
      alignItems: "center",
      maxWidth: "50%",
      height: "376px",
      borderRadius: "4px",
      boxShadow: userType === "citizen" ? "" : "1px 1px 4px 0px rgba(0,0,0,0.2)",
      border: `${userType === "citizen" ? "8px" : "24px"} solid #fff`,
      background: "#EEEEEE",
      padding: userType === "citizen" ? "8px" : "16px"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      position: "relative",
      height: userType === "citizen" ? "114px" : "150px",
      width: userType === "citizen" ? "114px" : "150px",
      margin: "16px"
    }
  }, /*#__PURE__*/React__default.createElement("img", {
    style: {
      margin: "auto",
      borderRadius: "300px",
      justifyContent: "center",
      height: "100%",
      width: "100%"
    },
    src: !profileImg || profileImg === "" ? defaultImage : profileImg
  }), /*#__PURE__*/React__default.createElement("button", {
    style: {
      position: "absolute",
      left: "50%",
      bottom: "-24px",
      transform: "translateX(-50%)"
    },
    onClick: onClickAddPic
  }, /*#__PURE__*/React__default.createElement(CameraIcon, null))), /*#__PURE__*/React__default.createElement("div", {
    style: {
      position: "relative",
      height: userType === "citizen" ? "114px" : "150px",
      width: userType === "citizen" ? "114px" : "150px",
      margin: "16px"
    }
  }, /*#__PURE__*/React__default.createElement("img", {
    style: {
      margin: "auto",
      borderRadius: "30px",
      justifyContent: "center",
      height: "100%",
      width: "100%"
    },
    src: !signatureImg || signatureImg === "" ? defaultSignatureImg : signatureImg
  }), /*#__PURE__*/React__default.createElement("button", {
    style: {
      color: "#1f4a7c"
    },
    onClick: onClickAddSignature
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, "Attached Signature ", /*#__PURE__*/React__default.createElement(DrawIcon, null))))), /*#__PURE__*/React__default.createElement("section", {
    style: {
      display: "flex",
      flexDirection: "column",
      flex: userType === "citizen" ? 1 : 7.5,
      width: "50%",
      borderRadius: "4px",
      height: "fit-content",
      boxShadow: userType === "citizen" ? "" : "1px 1px 4px 0px rgba(0,0,0,0.2)",
      background: "white",
      padding: userType === "citizen" ? "8px" : "20px",
      paddingBottom: "10px"
    }
  }, userType === "citizen" ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(LabelFieldPair, null, /*#__PURE__*/React__default.createElement(CardLabel, {
    style:  {}
  }, `${t("CORE_COMMON_PROFILE_NAME")}`, "*"), /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement(TextInput$3, Object.assign({
    t: t,
    style: {
      width: "100%"
    },
    type: "text",
    isMandatory: false,
    name: "name",
    value: name,
    onChange: e => setUserName(e.target.value)
  }, validation = {
    isRequired: true,
    pattern: "^[a-zA-Z-.`' ]*$",
    type: "tel",
    title: t("CORE_COMMON_PROFILE_NAME_ERROR_MESSAGE")
  }, {
    disable:  Boolean(userInfo === null || userInfo === void 0 ? void 0 : userInfo.name)
  })), (errors === null || errors === void 0 ? void 0 : errors.userName) && /*#__PURE__*/React__default.createElement(CardLabelError, {
    style: {
      width: "70%",
      fontSize: "12px",
      marginTop: "-21px"
    }
  }, " ", t(errors === null || errors === void 0 ? void 0 : (_errors$userName = errors.userName) === null || _errors$userName === void 0 ? void 0 : _errors$userName.message), " "))), /*#__PURE__*/React__default.createElement(LabelFieldPair, null, /*#__PURE__*/React__default.createElement(CardLabel, {
    style:  {}
  }, `${t("CORE_COMMON_PROFILE_GENDER")}`), /*#__PURE__*/React__default.createElement(Dropdown, {
    style: {
      width: "100%"
    },
    className: "form-field",
    selected: (gender === null || gender === void 0 ? void 0 : gender.length) === 1 ? gender[0] : gender,
    disable: (gender === null || gender === void 0 ? void 0 : gender.length) === 1 || editScreen,
    option: menu,
    select: setGenderName,
    value: gender,
    optionKey: "code",
    t: t,
    name: "gender"
  })), /*#__PURE__*/React__default.createElement(CardLabelError, null), /*#__PURE__*/React__default.createElement(LabelFieldPair, null, /*#__PURE__*/React__default.createElement(CardLabel, {
    style:  {}
  }, `${t("CORE_COMMON_PROFILE_EMAIL")}`), /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement(TextInput$3, {
    t: t,
    style: {
      width: "100%"
    },
    type: "email",
    isMandatory: false,
    optionKey: "i18nKey",
    name: "email",
    value: email,
    onChange: e => setUserEmailAddress(e.target.value),
    disable: editScreen
  }), (errors === null || errors === void 0 ? void 0 : errors.emailAddress) && /*#__PURE__*/React__default.createElement(CardLabelError, {
    style: {
      width: "70%",
      fontSize: "12px",
      marginTop: "-21px"
    }
  }, " ", t(errors === null || errors === void 0 ? void 0 : (_errors$emailAddress = errors.emailAddress) === null || _errors$emailAddress === void 0 ? void 0 : _errors$emailAddress.message), " "))), /*#__PURE__*/React__default.createElement(LabelFieldPair, null, /*#__PURE__*/React__default.createElement(CardLabel, {
    style:  {}
  }, `${t("CORE_COMMON_MOBILE_NUMBER")}`), /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement(TextInput$3, {
    t: t,
    style: {
      width: "100%"
    },
    type: "number",
    isMandatory: false,
    name: "mobileNumber",
    value: mobileNumber,
    onChange: e => setMobileNo(e.target.value)
  }), (errors === null || errors === void 0 ? void 0 : errors.mobileNumber) && /*#__PURE__*/React__default.createElement(CardLabelError, {
    style: {
      width: "70%",
      fontSize: "12px",
      marginTop: "-21px"
    }
  }, " ", t(errors === null || errors === void 0 ? void 0 : (_errors$mobileNumber = errors.mobileNumber) === null || _errors$mobileNumber === void 0 ? void 0 : _errors$mobileNumber.message), " "))), /*#__PURE__*/React__default.createElement("button", {
    onClick: updateProfile,
    style: {
      marginTop: "24px",
      backgroundColor: "#1F4A7C",
      width: "100%",
      height: "40px",
      color: "white",
      borderBottom: "1px solid black"
    }
  }, t("CORE_COMMON_SAVE"))) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(LabelFieldPair, {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement(CardLabel, {
    className: "profile-label-margin",
    style:  {
      width: "300px"
    }
  }, `${t("CORE_COMMON_PROFILE_NAME")}`, "*"), /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement(TextInput$3, Object.assign({
    t: t,
    type: "text",
    isMandatory: false,
    name: "name",
    value: name,
    onChange: e => setUserName(e.target.value),
    placeholder: "Enter Your Name"
  }, validation = {
    isRequired: true,
    pattern: "^[a-zA-Z-.`' ]*$",
    type: "text",
    title: t("CORE_COMMON_PROFILE_NAME_ERROR_MESSAGE")
  }, {
    disable:  Boolean(userInfo === null || userInfo === void 0 ? void 0 : userInfo.name)
  })), (errors === null || errors === void 0 ? void 0 : errors.userName) && /*#__PURE__*/React__default.createElement(CardLabelError, {
    style: {
      width: "70%",
      fontSize: "12px",
      marginTop: "-21px"
    }
  }, " ", t(errors === null || errors === void 0 ? void 0 : (_errors$userName2 = errors.userName) === null || _errors$userName2 === void 0 ? void 0 : _errors$userName2.message), " "))), /*#__PURE__*/React__default.createElement(LabelFieldPair, {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement(CardLabel, {
    className: "profile-label-margin",
    style:  {
      width: "300px"
    }
  }, `${t("CORE_COMMON_PROFILE_GENDER")}`), /*#__PURE__*/React__default.createElement(Dropdown, {
    style: {
      width: "100%"
    },
    selected: (gender === null || gender === void 0 ? void 0 : gender.length) === 1 ? gender[0] : gender,
    disable: gender === null || gender === void 0 ? void 0 : gender.code,
    option: menu,
    select: setGenderName,
    value: gender,
    optionKey: "code",
    t: t,
    name: "gender"
  })), /*#__PURE__*/React__default.createElement(LabelFieldPair, {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement(CardLabel, {
    className: "profile-label-margin",
    style:  {
      width: "300px"
    }
  }, `${t("CORE_COMMON_DISTRICT")}`), /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement(Dropdown, {
    style: {
      width: "100%"
    },
    selected: city,
    option: districts,
    select: setCityName,
    value: city,
    optionKey: "name",
    t: t,
    name: "city"
  }), /*#__PURE__*/React__default.createElement(CardLabelError, null))), /*#__PURE__*/React__default.createElement(LabelFieldPair, {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement(CardLabel, {
    className: "profile-label-margin",
    style: {
      width: "300px"
    }
  }, `${t("CORE_COMMON_PROFILE_MOBILE_NUMBER")}*`), /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement(MobileNumber, Object.assign({
    value: mobileNumber,
    style: {
      width: "100%"
    },
    name: "mobileNumber",
    placeholder: "Enter a valid Mobile No.",
    onChange: value => setUserMobileNumber(value),
    disable: userInfo === null || userInfo === void 0 ? void 0 : userInfo.mobileNumber
  }, {
    required: true,
    pattern: "[6-9]{1}[0-9]{9}",
    type: "tel",
    title: t("CORE_COMMON_PROFILE_MOBILE_NUMBER_INVALID")
  })), (errors === null || errors === void 0 ? void 0 : errors.mobileNumber) && /*#__PURE__*/React__default.createElement(CardLabelError, {
    style: {
      width: "70%",
      fontSize: "12px",
      marginTop: "-21px"
    }
  }, " ", t(errors === null || errors === void 0 ? void 0 : (_errors$mobileNumber2 = errors.mobileNumber) === null || _errors$mobileNumber2 === void 0 ? void 0 : _errors$mobileNumber2.message), " "))), /*#__PURE__*/React__default.createElement(LabelFieldPair, {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement(CardLabel, {
    className: "profile-label-margin",
    style:  {
      width: "300px"
    }
  }, `${t("CORE_COMMON_PROFILE_EMAIL")}`), /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement(TextInput$3, {
    t: t,
    type: "email",
    isMandatory: false,
    placeholder: "Enter a valid Email",
    optionKey: "i18nKey",
    name: "email",
    value: email,
    onChange: e => setUserEmailAddress(e.target.value),
    disable: editScreen
  }), (errors === null || errors === void 0 ? void 0 : errors.emailAddress) && /*#__PURE__*/React__default.createElement(CardLabelError, {
    style: {
      width: "70%",
      fontSize: "12px",
      marginTop: "-21px"
    }
  }, " ", t(errors === null || errors === void 0 ? void 0 : (_errors$emailAddress2 = errors.emailAddress) === null || _errors$emailAddress2 === void 0 ? void 0 : _errors$emailAddress2.message), " "))), /*#__PURE__*/React__default.createElement(LabelFieldPair, null, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("a", {
    style: {
      color: "orange",
      cursor: "default",
      marginBottom: "5",
      cursor: "pointer"
    },
    onClick: TogleforPassword
  }, t("CORE_COMMON_CHANGE_PASSWORD")), changepassword ? /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginTop: "10px"
    }
  }, /*#__PURE__*/React__default.createElement(LabelFieldPair, {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement(CardLabel, {
    className: "profile-label-margin",
    style:  {
      width: "300px"
    }
  }, `${t("CORE_COMMON_PROFILE_CURRENT_PASSWORD")}`), /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement(TextInput$3, {
    t: t,
    type: "password",
    isMandatory: false,
    name: "name",
    pattern: "^([a-zA-Z0-9@#$%])+$",
    onChange: e => setUserCurrentPassword(e.target.value),
    disable: editScreen
  }), (errors === null || errors === void 0 ? void 0 : errors.currentPassword) && /*#__PURE__*/React__default.createElement(CardLabelError, {
    style: {
      width: "70%",
      fontSize: "12px",
      marginTop: "-21px"
    }
  }, t(errors === null || errors === void 0 ? void 0 : (_errors$currentPasswo = errors.currentPassword) === null || _errors$currentPasswo === void 0 ? void 0 : _errors$currentPasswo.message)))), /*#__PURE__*/React__default.createElement(LabelFieldPair, {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement(CardLabel, {
    className: "profile-label-margin",
    style:  {
      width: "300px"
    }
  }, `${t("CORE_COMMON_PROFILE_NEW_PASSWORD")}`), /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement(TextInput$3, {
    t: t,
    type: "password",
    isMandatory: false,
    name: "name",
    pattern: "^([a-zA-Z0-9@#$%])+$",
    onChange: e => setUserNewPassword(e.target.value),
    disable: editScreen
  }), (errors === null || errors === void 0 ? void 0 : errors.newPassword) && /*#__PURE__*/React__default.createElement(CardLabelError, {
    style: {
      width: "70%",
      fontSize: "12px",
      marginTop: "-21px"
    }
  }, t(errors === null || errors === void 0 ? void 0 : (_errors$newPassword = errors.newPassword) === null || _errors$newPassword === void 0 ? void 0 : _errors$newPassword.message)))), /*#__PURE__*/React__default.createElement(LabelFieldPair, {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement(CardLabel, {
    className: "profile-label-margin",
    style:  {
      width: "300px"
    }
  }, `${t("CORE_COMMON_PROFILE_CONFIRM_PASSWORD")}`), /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement(TextInput$3, {
    t: t,
    type: "password",
    isMandatory: false,
    name: "name",
    pattern: "^([a-zA-Z0-9@#$%])+$",
    onChange: e => setUserConfirmPassword(e.target.value),
    disable: editScreen
  }), (errors === null || errors === void 0 ? void 0 : errors.confirmPassword) && /*#__PURE__*/React__default.createElement(CardLabelError, {
    style: {
      width: "70%",
      fontSize: "12px",
      marginTop: "-21px"
    }
  }, t(errors === null || errors === void 0 ? void 0 : (_errors$confirmPasswo = errors.confirmPassword) === null || _errors$confirmPasswo === void 0 ? void 0 : _errors$confirmPasswo.message))))) : ""))))), /*#__PURE__*/React__default.createElement("div", {
    style: {
      height: "88px",
      backgroundColor: "#FFFFFF",
      display: "flex",
      justifyContent: "flex-end",
      marginTop: "-20px",
      alignItems: "center"
    }
  }, /*#__PURE__*/React__default.createElement("button", {
    onClick: updateProfile,
    style: {
      marginTop: "24px",
      backgroundColor: "#1F4A7C",
      width: windowWidth < 768 ? "100%" : "248px",
      height: "40px",
      float: "right",
      margin: windowWidth < 768 ? "0 16px" : "",
      marginRight: windowWidth < 768 ? "16px" : "31px",
      color: "white",
      borderBottom: "1px solid black"
    }
  }, t("CORE_COMMON_SAVE"))), toast && /*#__PURE__*/React__default.createElement(Toast, {
    error: toast.key === "error",
    label: t(toast.key === "success" ? `CORE_COMMON_PROFILE_UPDATE_SUCCESS` : toast.action),
    onClose: () => setToast(null),
    style: {
      maxWidth: "670px"
    }
  }), openUploadSlide == true ? /*#__PURE__*/React__default.createElement(UploadDrawer, {
    setProfilePic: setFileStoreId,
    closeDrawer: closeFileUploadDrawer,
    userType: userType,
    removeProfilePic: removeProfilePic,
    showToast: showToast
  }) : "", openSignatureUploadSlide == true ? /*#__PURE__*/React__default.createElement(SinatureDrawer, {
    setSignaturePic: setFileStoreSignature,
    closeDrawer: closeFileSignaturDrawer,
    userType: userType,
    removeProfilePic: removeSignaturePic,
    showToast: showToast
  }) : "");
};

const StyledRadioGroup$1 = styled$1(RadioGroup)(({
  theme
}) => ({
  columnGap: theme.spacing(1),
  alignItems: "center",
  minHeight: 40
}));
const RadioButton$1 = ({
  row,
  data,
  control,
  name,
  width,
  defaultValue,
  clickControl,
  validation,
  disabled
}) => {
  return /*#__PURE__*/React__default.createElement(Controller, {
    name: name,
    control: control,
    rules: validation,
    defaultValue: defaultValue,
    render: ({
      field: {
        onChange,
        value
      },
      fieldState: {
        error
      }
    }) => /*#__PURE__*/React__default.createElement(StyledRadioGroup$1, {
      "aria-labelledby": "radio-buttons-group-label",
      value: value || defaultValue || "",
      name: name || "radio-buttons-group",
      row: row,
      onChange: e => {
        onChange(e);
        clickControl === null || clickControl === void 0 ? void 0 : clickControl(e);
      },
      sx: {
        width: width || "18.25vw",
        translate: "-8px 0"
      }
    }, data === null || data === void 0 ? void 0 : data.map(item => /*#__PURE__*/React__default.createElement(FormControlLabel, {
      sx: {
        margin: 0
      },
      key: item.value,
      value: item.value,
      control: /*#__PURE__*/React__default.createElement(Radio, null),
      label: item.label,
      disabled: disabled
    })), error && /*#__PURE__*/React__default.createElement(Typography$1, {
      variant: "caption",
      className: "error-message"
    }, error.message))
  });
};

const FormInfo$1 = styled$1(Box$1)(() => ({
  backgroundColor: "#fff7cb",
  margin: "2rem auto 0",
  padding: "1.5rem"
}));
const PrimaryTabsWrapper = styled$1("div")(({
  theme
}) => ({
  width: "100%",
  fontFamily: '"Calibri", sans-serif',
  fontSize: "14px",
  color: "#fff",
  height: "2rem",
  marginTop: "11px",
  marginBottom: "8px"
}));
const MainTabs$1 = styled$1(Tabs)(() => ({
  marginInline: "auto"
}));
const MainTab$1 = styled$1(Tab)(() => ({
  "&.MuiTab-root": {
    textTransform: "none",
    paddingInline: "1rem",
    color: "#1F4A7C",
    outline: "none"
  },
  "&.Mui-selected": {
    backgroundColor: "#1F4A7C",
    color: "white"
  }
}));
const PrimaryTabs = styled$1(Tabs)(() => ({
  "& .MuiTabs-scroller": {
    justifyContent: "center",
    height: "2rem"
  },
  "& .Mui-selected": {
    backgroundColor: "#5CB85C",
    color: "white"
  },
  "& span": {
    translate: "0 5px"
  }
}));
const PrimaryTab = styled$1(Tab)(() => ({
  "&.MuiTab-root": {
    outline: "none",
    fontSize: "12px",
    whiteSpace: "nowrap",
    backgroundColor: "rgb(53, 124, 167)",
    color: "#fff",
    fontFamily: '"Calibri", sans-serif',
    borderRadius: "6px 6px 0px 0px",
    marginLeft: "4px",
    textTransform: "none",
    height: "1.5rem",
    padding: "12px 8px",
    minHeight: "30px"
  },
  "&.Mui-selected": {
    background: "linear-gradient(135deg, rgb(14, 55, 79) 0%, rgb(21, 108, 156) 100%)",
    color: "#fff",
    fontSize: "12px",
    whiteSpace: "nowrap",
    borderRadius: "6px 6px 0px 0px",
    borderBottom: "2px solid rgb(14 55 79)",
    marginLeft: "4px",
    textTransform: "none",
    height: "1.5rem",
    padding: "12px 8px",
    minHeight: "30px"
  }
}));
const PrimaryTabNewTheme = styled$1(Tab)(() => ({
  "&.MuiTab-root": {
    outline: "none",
    fontSize: "12px",
    whiteSpace: "nowrap",
    backgroundColor: "rgb(53 124 167)",
    color: "#fff",
    fontFamily: '"Calibri", sans-serif',
    borderRadius: "6px 6px 0px 0px",
    marginLeft: "4px",
    textTransform: "none",
    height: "1.5rem",
    padding: "12px 8px",
    minHeight: "30px"
  },
  "&.Mui-selected": {
    background: "linear-gradient(22deg, rgb(14, 55, 79) 0%, rgb(38 86 112) 100%)",
    color: "#fff",
    fontSize: "12px",
    whiteSpace: "nowrap",
    borderRadius: "6px 6px 0px 0px",
    borderBottom: "2px solid rgb(14, 55, 79)",
    marginLeft: "4px",
    textTransform: "none",
    height: "1.5rem",
    padding: "12px 8px",
    minHeight: "30px"
  }
}));
const MandatoryInfo$1 = styled$1(Box$1)(() => ({
  lineHeight: 1,
  fontSize: 14,
  color: "red",
  "& span": {
    display: "inline-block",
    translate: "0 4px",
    fontSize: 18
  }
}));
const InfoBox$1 = styled$1(Box$1)(() => ({
  lineHeight: 1.5,
  fontSize: "16px",
  color: "#1F4A7C",
  padding: "8px 16px",
  backgroundColor: "#f0f4fa",
  borderRadius: "1px",
  fontWeight: "600",
  "& span": {
    display: "inline-block",
    translate: "0 4px",
    fontSize: 18
  }
}));
const StyledMenuItem$1 = styled$1(MenuItem$4)(() => ({
  "&.MuiMenuItem-root": {
    padding: "0.25rem 0.75rem",
    display: "block"
  }
}));
const SubTabsWrapper$1 = styled$1(Box$1)(({
  theme
}) => ({
  width: "100%",
  fontFamily: '"Calibri", sans-serif',
  fontSize: "14px",
  color: "#fff",
  height: "2rem",
  marginBottom: "18px"
}));
const SubTabs$1 = styled$1(Tabs)(() => ({
  "& .MuiTabs-scroller": {
    justifyContent: "center",
    height: "2rem"
  },
  "& .Mui-selected": {
    backgroundColor: "rgb(73, 151, 192)",
    color: "white"
  },
  "& span": {
    translate: "0 5px"
  }
}));
const SubTab$1 = styled$1(Tab)(() => ({
  "&.MuiTab-root": {
    outline: "none",
    fontSize: ".85rem",
    backgroundColor: "rgb(53 124 167)",
    color: "#fff",
    fontFamily: '"Calibri", sans-serif',
    borderRadius: "6px 6px 0px 0px",
    marginLeft: "4px",
    textTransform: "none",
    height: "1.5rem",
    padding: "12px 16px",
    minHeight: "30px"
  },
  "&.Mui-selected": {
    background: "linear-gradient(135deg, rgb(14, 55, 79) 0%, rgb(21, 108, 156) 100%)",
    color: "#fff",
    fontSize: ".85rem",
    borderRadius: "6px 6px 0px 0px",
    borderBottom: "2px solid rgb(14, 55, 79)",
    marginLeft: "4px",
    textTransform: "none",
    height: "1.5rem",
    padding: "12px 16px",
    minHeight: "30px"
  }
}));
const SubTabNewTheme = styled$1(Tab)(() => ({
  "&.MuiTab-root": {
    outline: "none",
    fontSize: ".85rem",
    backgroundColor: "rgb(53 124 167)!important",
    color: "#fff",
    fontFamily: '"Calibri", sans-serif',
    marginLeft: "4px",
    textTransform: "none",
    height: "1.5rem",
    padding: "12px 16px",
    minHeight: "30px"
  },
  "&.Mui-selected": {
    background: "linear-gradient(135deg, rgb(14, 55, 79) 0%, rgb(21, 108, 156) 100%)!important",
    color: "#fff",
    fontSize: ".85rem",
    borderBottom: "2px solid rgb(14, 55, 79)",
    marginLeft: "4px",
    textTransform: "none",
    height: "1.5rem",
    padding: "12px 16px",
    minHeight: "30px"
  }
}));
const StyledDivider = styled$1(Divider$1)(({
  theme
}) => ({
  height: "1px" + "!important",
  backgroundColor: "#085A85",
  color: "#1F4A7C",
  alignSelf: "center"
}));
const PortalWrapper = styled$1("div")(() => ({
  display: "flex",
  height: "100vh",
  width: "100%",
  boxSizing: "border-box",
  overflow: "hidden"
}));
const SideWrapper = styled$1("div")(() => ({
  flex: "0 0 15%",
  backgroundColor: "#262D33"
}));
const SideBarWrapper = styled$1(Box$1)(() => ({
  height: "100vh",
  color: "#fff",
  padding: "1rem",
  boxSizing: "border-box"
}));
const ModuleTextWrapper = styled$1("h2")(() => ({
  backgroundColor: "#157CB3",
  margin: ".625rem",
  padding: ".5rem"
}));
const MainWrapper = styled$1("div")(() => ({
  flex: "0 0 100%",
  padding: "1rem",
  overflowX: "hidden"
}));
const FormInputContainer = styled$1("div")(() => ({
  display: "flex",
  borderRadius: "1px",
  padding: "1.25rem 1.5rem",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "flex-start",
  width: "100%",
  overflow: "auto"
}));
const RowWrapper = styled$1("div")(() => ({
  flex: 1,
  gap: "1rem",
  display: "flex",
  flexDirection: "column"
}));
const StyledOutlinedInput = styled$1(OutlinedInput)(() => ({
  borderRadius: "5px",
  border: "2px solid #1F4A7C"
}));
const SummaryCard = styled$1(Card$3)(() => ({
  backgroundColor: "rgb(21, 124, 179)"
}));
const CustomAccordionSummary = styled$1(AccordionSummary)(({
  theme
}) => ({
  marginLeft: 0,
  color: "#fff",
  background: "linear-gradient(135deg, rgb(14, 55, 79) 0%, rgb(21, 108, 156) 100%)",
  "& .MuiAccordionSummary-content": {
    margin: 0,
    alignItems: "center"
  }
}));

const SelectWrapper$1 = ({
  label,
  inputLabel,
  data: _data = [],
  helperText,
  autoWidth,
  placeholder,
  control,
  name,
  defaultValue,
  width,
  disabled: _disabled = false,
  validation,
  height,
  onBlur
}) => {
  return /*#__PURE__*/React__default.createElement(Controller, {
    name: name || "name",
    control: control,
    rules: validation,
    defaultValue: defaultValue,
    render: ({
      field: {
        onChange,
        value
      },
      fieldState: {
        error
      }
    }) => /*#__PURE__*/React__default.createElement(FormControl, {
      sx: {
        width: width || "18.25vw",
        borderRadius: "5px"
      },
      size: "small",
      disabled: _disabled,
      error: !!error
    }, /*#__PURE__*/React__default.createElement(Select, {
      displayEmpty: true,
      value: value || defaultValue || "",
      onChange: e => {
        onChange(e);
        onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
      },
      autoWidth: autoWidth,
      name: name,
      sx: {
        width: width || "18.25vw",
        borderRadius: "1px"
      },
      input: /*#__PURE__*/React__default.createElement(OutlinedInput, {
        style: {
          borderRadius: "1px",
          height: height || "30px",
          width: width || "18.25vw"
        }
      }),
      renderValue: selected => {
        if (selected.length === 0) {
          return /*#__PURE__*/React__default.createElement("em", {
            style: {
              fontStyle: "normal"
            }
          }, placeholder);
        }
        return selected;
      },
      MenuProps: {
        disablePortal: false,
        disableScrollLock: true
      },
      inputProps: {
        "aria-label": "Without label"
      }
    }, /*#__PURE__*/React__default.createElement(StyledMenuItem$1, {
      disabled: true,
      value: ""
    }, /*#__PURE__*/React__default.createElement("em", {
      style: {
        fontStyle: "normal"
      }
    }, placeholder)), Array.isArray(_data) && (_data === null || _data === void 0 ? void 0 : _data.map(item => {
      const dropdowns = (item === null || item === void 0 ? void 0 : item.name) || (item === null || item === void 0 ? void 0 : item.value) || (item === null || item === void 0 ? void 0 : item.i18nKey);
      return /*#__PURE__*/React__default.createElement(StyledMenuItem$1, {
        value: dropdowns,
        key: dropdowns
      }, dropdowns);
    }))), error && /*#__PURE__*/React__default.createElement(Typography$1, {
      variant: "caption",
      className: "error-message"
    }, error.message), helperText && !error && /*#__PURE__*/React__default.createElement(FormHelperText, null, helperText))
  });
};

const TextInput$1 = ({
  children,
  select,
  width,
  height,
  disabled,
  multiline,
  control,
  type,
  name,
  defaultValue,
  validation: _validation = {},
  isRequired,
  minLength,
  maxLength,
  inputClassName,
  maxValue,
  message,
  decimalScale: _decimalScale = null,
  formatOnBlur: _formatOnBlur = false,
  ...rest
}) => {
  const combinedValidation = {
    ..._validation,
    ...(isRequired && {
      required: {
        value: true,
        message: "This field is required"
      }
    }),
    ...(minLength && {
      minLength: {
        value: minLength,
        message: `The input must be at least ${minLength} characters long.`
      }
    }),
    ...(maxLength && {
      maxLength: {
        value: maxLength,
        message: `The input can only be ${maxLength} characters long.`
      }
    }),
    ...(maxValue && {
      validate: {
        lessThanMax: value => {
          if (Number(value) > maxValue) {
            return message || `The value must not exceed ${maxValue}`;
          }
          return true;
        }
      }
    })
  };
  return /*#__PURE__*/React__default.createElement(Controller, {
    name: name,
    control: control,
    defaultValue: defaultValue,
    rules: combinedValidation,
    render: ({
      field: {
        onChange,
        value,
        onBlur
      },
      fieldState: {
        error
      }
    }) => /*#__PURE__*/React__default.createElement(FormControl, {
      sx: {
        width: width || "18.25vw",
        borderRadius: "1px",
        minHeight: multiline ? "60px" : "auto"
      },
      size: "small",
      error: !!error
    }, /*#__PURE__*/React__default.createElement(TextField$1, Object.assign({
      sx: {
        width: width || "18.25vw",
        marginRight: select ? "1rem" : 0,
        "& .MuiOutlinedInput-root": {
          "&.Mui-error .MuiOutlinedInput-notchedOutline": {
            borderColor: "orange"
          },
          "& .MuiInputBase-root.Mui-disabled": {
            opacity: 0.7
          }
        }
      },
      className: `${inputClassName}`,
      name: name,
      onChange: onChange,
      onBlur: e => {
        onBlur();
        if (_formatOnBlur && _decimalScale !== null && value !== "" && value !== null && value !== undefined) {
          const num = Number(value);
          if (!isNaN(num)) {
            onChange(num.toFixed(_decimalScale));
          }
        }
        if (rest.onBlur) {
          rest.onBlur(e);
        }
      },
      select: select
    }, !multiline && {
      type
    }, {
      multiline: multiline,
      value: value || "",
      minRows: multiline ? 3 : 0,
      disabled: disabled,
      error: !!error
    }, rest), children), error && /*#__PURE__*/React__default.createElement(Typography$1, {
      variant: "caption",
      className: "error-message"
    }, error.message))
  });
};

const UploadButton$1 = ({
  error
}) => {
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      textAlign: "center"
    }
  }, /*#__PURE__*/React__default.createElement(IconButton$1, {
    color: "primary",
    "aria-label": "upload picture",
    component: "label"
  }, /*#__PURE__*/React__default.createElement("input", {
    hidden: true,
    accept: "image/*",
    type: "file"
  }), /*#__PURE__*/React__default.createElement("img", {
    src: "https://tcp.hp.gov.in/img/noPhptoPassport.jpg",
    className: "img",
    alt: "upload"
  })), /*#__PURE__*/React__default.createElement("h6", {
    className: "error"
  }, error));
};

const formatDate$1 = date => {
  return dayjs(date).format("YYYY-MM-DD");
};
const DatePick$1 = ({
  label,
  defaultValue,
  control,
  name,
  width,
  validation,
  maxDate,
  disableFuture,
  disablePast,
  disabled,
  isRequired
}) => {
  var _validation$required;
  const [reqDate, setReqDate] = useState(null);
  useEffect(() => {
    if (defaultValue) {
      setReqDate(dayjs(formatDate$1(defaultValue)));
    }
  }, [defaultValue]);
  return /*#__PURE__*/React__default.createElement(Controller, {
    name: name,
    defaultValue: reqDate,
    rules: {
      ...((validation === null || validation === void 0 ? void 0 : (_validation$required = validation.required) === null || _validation$required === void 0 ? void 0 : _validation$required.value) && {
        validate: value => {
          var _validation$required2, _validation$required3;
          if (!value) return validation === null || validation === void 0 ? void 0 : (_validation$required2 = validation.required) === null || _validation$required2 === void 0 ? void 0 : _validation$required2.message;
          const selected = dayjs(value);
          if (!selected.isValid()) {
            return "Please select a valid date";
          }
          if (selected.year < 1950) {
            return "Please select a date after 1950";
          }
          if (selected.year > 2050) {
            return "Please select a date before 2050";
          }
          if (selected.month > 11) {
            return "Please select a valid month";
          }
          return !!value || (validation === null || validation === void 0 ? void 0 : (_validation$required3 = validation.required) === null || _validation$required3 === void 0 ? void 0 : _validation$required3.message);
        }
      }),
      ...(isRequired && {
        required: {
          value: true,
          message: "This field is required"
        }
      }),
      ...(disablePast && {
        validate: value => {
          if (!value) return true;
          const today = dayjs().startOf("day");
          const selected = dayjs(value).startOf("day");
          return !selected.isBefore(today) || "Past dates are not allowed";
        }
      })
    },
    control: control,
    render: ({
      field: {
        onChange,
        value
      },
      fieldState: {
        error
      }
    }) => /*#__PURE__*/React__default.createElement(FormControl, {
      sx: {
        width: width || "18.25vw",
        borderRadius: "1px"
      },
      size: "small",
      error: !!error
    }, /*#__PURE__*/React__default.createElement(LocalizationProvider, {
      dateAdapter: AdapterDayjs,
      adapterLocale: "en-in"
    }, /*#__PURE__*/React__default.createElement(DatePicker, {
      name: name,
      slotProps: {
        textField: {
          error: !!error,
          sx: {
            width: width || "18.25vw",
            borderRadius: "1px",
            "& .MuiInputBase-root": {
              height: "30px"
            }
          }
        }
      },
      label: label,
      value: value ? dayjs(value) : reqDate,
      onChange: event => {
        if (event) {
          const formattedDate = formatDate$1(event);
          onChange(formattedDate);
        } else {
          onChange(null);
        }
      },
      disableFuture: disableFuture,
      disablePast: disablePast,
      disabled: disabled,
      maxDate: maxDate,
      renderInput: params => /*#__PURE__*/React__default.createElement(TextField$1, Object.assign({
        size: "small"
      }, params, {
        error: !!error,
        helperText: error ? error.message : null
      }))
    })), error && /*#__PURE__*/React__default.createElement(Typography$1, {
      variant: "caption",
      className: "error-message"
    }, error.message))
  });
};

const TimePick$1 = ({
  label,
  width,
  control,
  name,
  defaultValue
}) => {
  return /*#__PURE__*/React__default.createElement(Controller, {
    name: name,
    control: control,
    defaultValue: defaultValue || dayjs(),
    render: ({
      field: {
        onChange,
        value
      }
    }) => /*#__PURE__*/React__default.createElement(LocalizationProvider, {
      dateAdapter: AdapterDayjs,
      adapterLocale: "en-in"
    }, /*#__PURE__*/React__default.createElement(DemoContainer, {
      components: ['MobileTimePicker']
    }, /*#__PURE__*/React__default.createElement(DemoItem, null, /*#__PURE__*/React__default.createElement(MobileTimePicker, {
      label: label,
      value: value || dayjs(),
      onChange: val => onChange(val),
      slotProps: {
        textField: {
          size: 'small'
        }
      },
      sx: {
        width: width ? width : '18.25vw'
      }
    }))))
  });
};

const YearMonthPicker = ({
  yearPlaceholder: _yearPlaceholder = "Year",
  monthPlaceholder: _monthPlaceholder = "Month",
  name,
  control,
  validation,
  defaultValue,
  disabled,
  width: _width = "9vw",
  height: _height = "30px"
}) => {
  const years = Array.from({
    length: 30
  }, (_, i) => i);
  const months = Array.from({
    length: 12
  }, (_, i) => i);
  return /*#__PURE__*/React__default.createElement(Controller, {
    name: name,
    control: control,
    rules: validation,
    defaultValue: defaultValue || "",
    render: ({
      field: {
        onChange,
        value
      },
      fieldState: {
        error
      }
    }) => {
      const [currentYear, currentMonth] = value ? value.split("-").map(item => parseInt(item.match(/\d+/), 10)) : [null, null];
      const handleChange = (type, selectedValue) => {
        const updatedYear = type === "year" ? selectedValue : currentYear || 0;
        const updatedMonth = type === "month" ? selectedValue : currentMonth || 0;
        const yearLabel = updatedYear === 1 || updatedYear === 0 ? "Year" : "Years";
        const monthLabel = updatedMonth === 1 ? "Month" : "Months";
        const formattedValue = `${updatedYear || 0} ${yearLabel}-${updatedMonth || 0} ${monthLabel}`;
        onChange(formattedValue);
      };
      return /*#__PURE__*/React__default.createElement("div", {
        style: {
          display: "flex",
          gap: "10px"
        }
      }, /*#__PURE__*/React__default.createElement(FormControl, {
        sx: {
          width: _width,
          borderRadius: "5px"
        },
        size: "small",
        error: !!error,
        disabled: disabled
      }, /*#__PURE__*/React__default.createElement(Select, {
        value: currentYear || "",
        onChange: e => handleChange("year", e.target.value),
        displayEmpty: true,
        input: /*#__PURE__*/React__default.createElement(OutlinedInput, {
          style: {
            borderRadius: "5px",
            height: _height
          }
        }),
        renderValue: selected => {
          if (!selected) {
            return /*#__PURE__*/React__default.createElement("em", {
              style: {
                fontStyle: "normal"
              }
            }, _yearPlaceholder);
          }
          return selected > 1 ? `${selected} Years` : selected === 0 || selected === 1 ? `${selected} Year` : "";
        },
        inputProps: {
          "aria-label": "Year Dropdown"
        }
      }, /*#__PURE__*/React__default.createElement(StyledMenuItem$1, {
        disabled: true,
        value: ""
      }, /*#__PURE__*/React__default.createElement("em", {
        style: {
          fontStyle: "normal"
        }
      }, _yearPlaceholder)), years.map(item => /*#__PURE__*/React__default.createElement(StyledMenuItem$1, {
        key: item,
        value: item
      }, item)))), /*#__PURE__*/React__default.createElement(FormControl, {
        sx: {
          width: _width,
          borderRadius: "5px"
        },
        size: "small",
        error: !!error,
        disabled: disabled
      }, /*#__PURE__*/React__default.createElement(Select, {
        value: currentMonth || "",
        onChange: e => handleChange("month", e.target.value),
        displayEmpty: true,
        input: /*#__PURE__*/React__default.createElement(OutlinedInput, {
          style: {
            borderRadius: "5px",
            height: _height
          }
        }),
        renderValue: selected => {
          if (!selected && selected !== 0) {
            return /*#__PURE__*/React__default.createElement("em", {
              style: {
                fontStyle: "normal"
              }
            }, _monthPlaceholder);
          }
          return selected === 1 ? `${selected} Month` : `${selected} Months`;
        },
        inputProps: {
          "aria-label": "Month Dropdown"
        }
      }, /*#__PURE__*/React__default.createElement(StyledMenuItem$1, {
        disabled: true,
        value: ""
      }, /*#__PURE__*/React__default.createElement("em", {
        style: {
          fontStyle: "normal"
        }
      }, _monthPlaceholder)), months.map(item => /*#__PURE__*/React__default.createElement(StyledMenuItem$1, {
        key: item,
        value: item
      }, item)))), error && /*#__PURE__*/React__default.createElement(Typography$1, {
        variant: "caption",
        className: "error-message"
      }, error.message));
    }
  });
};

const SelectWrappers = ({
  control,
  name,
  label,
  defaultValue,
  data: _data = [],
  width,
  multiple: _multiple = false,
  disabled,
  validation,
  placeholder,
  height,
  onBlur
}) => {
  return /*#__PURE__*/React__default.createElement(FormControl$1, {
    sx: {
      width: width || "18.25vw",
      height
    },
    size: "small",
    disabled: disabled
  }, label && /*#__PURE__*/React__default.createElement(InputLabel$1, null, label), /*#__PURE__*/React__default.createElement(Controller, {
    name: name,
    control: control,
    defaultValue: defaultValue || (_multiple ? [] : ""),
    rules: validation,
    render: ({
      field,
      fieldState
    }) => /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Select$1, Object.assign({}, field, {
      multiple: _multiple,
      onBlur: onBlur,
      displayEmpty: true,
      renderValue: selected => _multiple ? selected.length ? selected.join(", ") : placeholder || "Select options" : selected || placeholder
    }), _data.map(item => /*#__PURE__*/React__default.createElement(MenuItem$4, {
      key: item.value,
      value: item.value
    }, item.label))), fieldState.error && /*#__PURE__*/React__default.createElement(FormHelperText, {
      error: true
    }, fieldState.error.message))
  }));
};

const SearchSelect = ({
  name,
  control,
  data: _data = [],
  placeholder: _placeholder = "Select an option",
  disabled: _disabled = false,
  validation: _validation = {},
  defaultValue: _defaultValue = null,
  width: _width = "18.25vw",
  height: _height = "30px",
  select: _select = false,
  returnObject: _returnObject = false
}) => {
  return /*#__PURE__*/React__default.createElement(Controller, {
    name: name,
    control: control,
    defaultValue: _defaultValue,
    rules: _validation,
    render: ({
      field: {
        onChange,
        value
      },
      fieldState: {
        error
      }
    }) => /*#__PURE__*/React__default.createElement(FormControl$1, {
      sx: {
        width: _width,
        borderRadius: "1px"
      },
      size: "small",
      error: !!error
    }, /*#__PURE__*/React__default.createElement(Autocomplete, {
      options: _data || [],
      getOptionLabel: option => typeof option === "string" ? option : option.label,
      isOptionEqualToValue: (option, val) => option.value === (val === null || val === void 0 ? void 0 : val.value),
      value: _returnObject ? value || null : (_data === null || _data === void 0 ? void 0 : _data.find(item => (item === null || item === void 0 ? void 0 : item.value) === value)) || null,
      onChange: (event, newValue) => {
        onChange(_returnObject ? newValue : (newValue === null || newValue === void 0 ? void 0 : newValue.label) || "");
      },
      disabled: _disabled,
      renderInput: params => /*#__PURE__*/React__default.createElement(TextField$1, Object.assign({}, params, {
        placeholder: _placeholder,
        size: "small",
        disabled: _disabled,
        error: !!error,
        sx: {
          width: _width || "18.25vw",
          "& .MuiOutlinedInput-root": {
            borderRadius: "1px",
            height: _height || "30px",
            "&.Mui-error .MuiOutlinedInput-notchedOutline": {
              borderColor: "orange"
            }
          }
        }
      }))
    }), error && /*#__PURE__*/React__default.createElement(Typography$1, {
      variant: "caption",
      className: "error-message"
    }, error.message))
  });
};

const InputWrapper = ({
  label,
  width,
  height,
  disabled: _disabled = false,
  selectSuffix: _selectSuffix = null,
  hasLabel: _hasLabel = true,
  mandatory,
  name,
  control,
  placeholder,
  type,
  data,
  mobileNumber,
  select,
  defaultValue,
  multiColumn,
  multiLine: _multiLine = false,
  uploadValidity,
  labelWidth,
  clickControl,
  getDocumentData,
  containerStyles,
  containerClasses,
  getIndex,
  getArea,
  validation,
  maxLength,
  showSearchIcon,
  onSearchClick,
  isRequired,
  maxDate,
  disableFuture,
  disablePast,
  minLength,
  maxValue,
  allowedChars,
  onBlur,
  inputClassName,
  message,
  customLabel,
  onlyNumeric: _onlyNumeric = false,
  customLabelStyles,
  trimSpace: _trimSpace = false,
  returnObject: _returnObject = false,
  isPassword: _isPassword = false,
  decimalScale: _decimalScale = null,
  onlyAlphabet: _onlyAlphabet = false,
  formatOnBlur: _formatOnBlur = false
}) => {
  const [showPassword, setShowPassword] = React__default.useState(false);
  return /*#__PURE__*/React__default.createElement("div", {
    className: `inputContainer`,
    style: containerStyles
  }, _hasLabel && type !== "checkbox" && /*#__PURE__*/React__default.createElement("h3", {
    className: `label ${multiColumn ? "multiCoumn" : customLabel ? customLabel : ""}`,
    style: {
      width: labelWidth && labelWidth,
      height: height || "30px",
      ...customLabelStyles
    }
  }, label, mandatory && /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, " *")), type === "textInput" ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, _selectSuffix && /*#__PURE__*/React__default.createElement(SelectWrapper$1, Object.assign({
    variant: "outlined",
    width: "6vw",
    size: "small"
  }, _selectSuffix, {
    defaultValue: _selectSuffix === null || _selectSuffix === void 0 ? void 0 : _selectSuffix.defaultValue,
    validation: validation
  })), /*#__PURE__*/React__default.createElement(TextInput$1, {
    placeholder: placeholder,
    variant: "outlined",
    size: "small",
    disabled: _disabled,
    width: width || (_selectSuffix ? "11.25vw" : "18.25vw"),
    height: height,
    name: name,
    message: message,
    select: select,
    control: control,
    defaultValue: defaultValue,
    multiline: _multiLine,
    maxValue: maxValue,
    isRequired: isRequired,
    inputClassName: inputClassName,
    InputProps: {
      ...(mobileNumber && {
        startAdornment: /*#__PURE__*/React__default.createElement(InputAdornment, {
          position: "start"
        }, "+91")
      }),
      endAdornment: showSearchIcon &&
      /*#__PURE__*/
      React__default.createElement(InputAdornment, {
        position: "end"
      }, /*#__PURE__*/React__default.createElement(IconButton$2, {
        onClick: onSearchClick
      }, /*#__PURE__*/React__default.createElement(Search$1, null))),
      sx: {
        height: height || (_multiLine ? "auto" : "30px")
      }
    },
    validation: validation,
    inputProps: {
      maxLength
    },
    onInput: e => {
      let value = e.target.value;
      if (_onlyAlphabet) {
        value = value.replace(/[^A-Za-z\s]/g, "");
        value = value.replace(/^\s+/g, "");
        value = value.replace(/\s{2,}/g, " ");
      }
      if (_trimSpace) {
        value = value.replace(/\s/g, "");
      }
      if (maxLength && value.length > maxLength) {
        value = value.slice(0, maxLength);
      }
      e.target.value = value;
    }
  }, !_selectSuffix && data && select && (data === null || data === void 0 ? void 0 : data.map(option => /*#__PURE__*/React__default.createElement(MenuItem$4, {
    key: option.value,
    value: option.value
  }, option.label))))) : type === "radioButton" ? /*#__PURE__*/React__default.createElement(RadioButton$1, {
    defaultValue: defaultValue,
    clickControl: clickControl,
    control: control,
    width: width,
    data: data,
    name: name,
    row: true,
    validation: validation,
    disabled: _disabled,
    inputClassName: inputClassName
  }) : type === "selectInput" ? /*#__PURE__*/React__default.createElement(SelectWrapper$1, {
    control: control,
    placeholder: placeholder,
    defaultValue: defaultValue,
    inputLabel: placeholder,
    width: width || "18.25vw",
    height: height,
    label: label,
    data: data,
    name: name,
    disabled: _disabled,
    validation: validation,
    onBlur: onBlur,
    InputProps: {}
  }) : type === "multiSelectInput" ? /*#__PURE__*/React__default.createElement(Controller, {
    name: name,
    control: control,
    defaultValue: defaultValue || [],
    rules: validation,
    render: ({
      field: {
        onChange,
        value
      }
    }) => /*#__PURE__*/React__default.createElement(Select$1, {
      multiple: true,
      displayEmpty: true,
      value: value,
      onChange: e => onChange(e.target.value),
      renderValue: selected => selected.length ? selected.map(val => {
        const found = data.find(d => d.value === val);
        return (found === null || found === void 0 ? void 0 : found.label) || val;
      }).join(", ") : placeholder,
      size: "small",
      fullWidth: true,
      sx: {
        backgroundColor: "#fff"
      }
    }, data.map(option => /*#__PURE__*/React__default.createElement(MenuItem$4, {
      key: option.value,
      value: option.value
    }, /*#__PURE__*/React__default.createElement(Checkbox, {
      checked: value.includes(option.value)
    }), /*#__PURE__*/React__default.createElement(ListItemText, {
      primary: option.label
    }))))
  }) : type === "multiSelectInputs" ? /*#__PURE__*/React__default.createElement(SelectWrappers, {
    control: control,
    placeholder: placeholder,
    defaultValue: defaultValue || [],
    inputLabel: placeholder,
    width: width,
    height: height,
    label: label,
    data: data,
    name: name,
    multiple: true,
    disabled: _disabled,
    validation: validation,
    onBlur: onBlur
  }) : type === "upload" ? /*#__PURE__*/React__default.createElement(UploadButton$1, {
    error: uploadValidity
  }) : type === "htmlUpload" ? /*#__PURE__*/React__default.createElement("div", {
    className: "uploadHtml"
  }, /*#__PURE__*/React__default.createElement("input", {
    type: "file",
    name: name,
    onChange: e => {
      var _e$target;
      return getDocumentData(e === null || e === void 0 ? void 0 : (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.files[0], name);
    }
  }), /*#__PURE__*/React__default.createElement("h6", {
    className: "error"
  }, uploadValidity)) : type === "datePicker" ? /*#__PURE__*/React__default.createElement(DatePick$1, {
    placeholder: placeholder,
    control: control,
    name: name,
    width: width,
    defaultValue: defaultValue,
    validation: validation,
    maxDate: maxDate,
    disableFuture: disableFuture,
    disablePast: disablePast,
    disabled: _disabled
  }) : type === "yearMonthPicker" ? /*#__PURE__*/React__default.createElement(YearMonthPicker, {
    label: label,
    control: control,
    name: name,
    validation: validation,
    placeholder: placeholder,
    defaultValue: defaultValue,
    disabled: _disabled
  }) : type === "timePicker" ? /*#__PURE__*/React__default.createElement(TimePick$1, {
    control: control,
    label: label,
    name: name,
    defaultValue: defaultValue
  }) : type === "number" ? /*#__PURE__*/React__default.createElement(TextInput$1, {
    placeholder: placeholder,
    variant: "outlined",
    size: "small",
    disabled: _disabled,
    width: width || "18.25vw",
    height: height,
    name: name,
    control: control,
    isRequired: isRequired,
    defaultValue: defaultValue,
    validation: validation,
    inputClassName: inputClassName,
    InputProps: {
      ...(mobileNumber && {
        startAdornment: /*#__PURE__*/React__default.createElement(InputAdornment, {
          position: "start"
        }, "+91")
      }),
      style: {
        borderRadius: "1px"
      },
      sx: {
        height: height || "30px"
      }
    },
    onInput: e => {
      let value = e.target.value;
      value = value.replace(/[^0-9]/g, "");
      const max = maxLength ? parseInt(maxLength, 10) : null;
      if (max && value.length > max) {
        value = value.slice(0, max);
      }
      e.target.value = value;
    }
  }) : type === "checkbox" ? /*#__PURE__*/React__default.createElement(Controller, {
    name: name,
    control: control,
    defaultValue: defaultValue,
    render: ({
      field: {
        onChange,
        value
      }
    }) => /*#__PURE__*/React__default.createElement(Checkbox, {
      checked: value,
      sx: containerStyles,
      onChange: e => {
        onChange(e.target.checked);
      },
      disabled: _disabled
    })
  }) : type === "decimal" ? /*#__PURE__*/React__default.createElement(TextInput$1, {
    placeholder: placeholder,
    variant: "outlined",
    size: "small",
    type: "text",
    disabled: _disabled,
    width: width || "18.25vw",
    height: height,
    name: name,
    control: control,
    validation: validation,
    isRequired: isRequired,
    defaultValue: defaultValue,
    minLength: minLength,
    maxLength: maxLength,
    maxValue: maxValue,
    message: message,
    inputProps: {
      maxLength,
      inputMode: "decimal"
    },
    InputProps: {
      style: {
        borderRadius: "1px"
      },
      sx: {
        height: height || "30px"
      }
    },
    onInput: e => {
      const input = e.target;
      const cursorPosition = input.selectionStart;
      let value = input.value.replace(/[^0-9.]/g, "");
      const parts = value.split(".");
      if (parts.length > 2) {
        value = `${parts[0]}.${parts.slice(1).join("")}`;
      }
      const max = maxLength ? Number(maxLength) : null;
      if (max && value.length > max) {
        value = value.slice(0, max);
      }
      if (input.value !== value) {
        input.value = value;
        requestAnimationFrame(() => {
          const newPosition = Math.min(cursorPosition, value.length);
          input.setSelectionRange(newPosition, newPosition);
        });
      }
    }
  }) : type === "specialChar" ? /*#__PURE__*/React__default.createElement(TextInput$1, {
    placeholder: placeholder,
    variant: "outlined",
    size: "small",
    disabled: _disabled,
    width: width || "18.25vw",
    height: height,
    name: name,
    control: control,
    isRequired: isRequired,
    defaultValue: defaultValue,
    validation: validation,
    decimalScale: _decimalScale,
    formatOnBlur: _formatOnBlur,
    InputProps: {
      style: {
        borderRadius: "1px"
      },
      sx: {
        height: height || "30px"
      }
    },
    onInput: e => {
      let value = e.target.value;
      const escapeRegex = str => str.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
      const escapedPattern = allowedChars ? escapeRegex(allowedChars) : "";
      if (_onlyAlphabet) {
        const regex = new RegExp(`[^A-Za-z${escapedPattern}]`, "g");
        value = value.replace(regex, "");
      } else if (_onlyNumeric) {
        const regex = new RegExp(`[^0-9${escapedPattern}]`, "g");
        value = value.replace(regex, "");
      } else {
        const regex = new RegExp(`[^0-9A-Za-z${escapedPattern}]`, "g");
        value = value.replace(regex, "");
      }
      if (!_onlyAlphabet && allowedChars !== null && allowedChars !== void 0 && allowedChars.includes(".")) {
        const parts = value.split(".");
        if (parts.length > 2) {
          value = parts[0] + "." + parts.slice(1).join("");
        }
        if (_decimalScale !== null && parts[1]) {
          value = parts[0] + "." + parts[1].slice(0, _decimalScale);
        }
      }
      if (maxLength && value.length > maxLength) {
        value = value.slice(0, maxLength);
      }
      e.target.value = value;
    }
  }) : type === "searchSelect" ? /*#__PURE__*/React__default.createElement(SearchSelect, {
    name: name,
    control: control,
    data: data,
    placeholder: placeholder,
    disabled: _disabled,
    validation: validation,
    defaultValue: defaultValue,
    width: width,
    height: height,
    select: select,
    returnObject: _returnObject
  }) : type === "password" ? /*#__PURE__*/React__default.createElement(TextInput$1, {
    placeholder: placeholder,
    variant: "outlined",
    size: "small",
    disabled: _disabled,
    width: width || "18.25vw",
    height: height,
    name: name,
    control: control,
    defaultValue: defaultValue,
    validation: validation,
    isRequired: isRequired,
    inputClassName: inputClassName,
    type: showPassword ? "textInput" : "password",
    InputProps: {
      endAdornment: /*#__PURE__*/React__default.createElement(InputAdornment, {
        position: "end"
      }, /*#__PURE__*/React__default.createElement(IconButton$2, {
        onClick: () => setShowPassword(prev => !prev),
        edge: "end"
      }, showPassword ? /*#__PURE__*/React__default.createElement(VisibilityOff, null) : /*#__PURE__*/React__default.createElement(Visibility, null))),
      sx: {
        height: height || "30px"
      }
    },
    inputProps: {
      maxLength
    },
    onInput: e => {
      let value = e.target.value;
      if (_trimSpace) {
        value = value.replace(/\s/g, "");
      }
      if (maxLength && value.length > maxLength) {
        value = value.slice(0, maxLength);
      }
      e.target.value = value;
    }
  }) : "");
};

const ForgotPasswordRecovery = () => {
  const {
    control,
    handleSubmit,
    watch
  } = useForm();
  const tenant = Digit.ULBService.getStateId();
  const [mobileNumber, setMobileNumber] = useState("");
  const [userDetails, setUserDetials] = useState(null);
  const [otpSent, setOtpSent] = useState(false);
  const [showToast, setShowToast] = useState(null);
  const navigate = useHistory();
  const userName = watch("employeeId");
  const onSubmit = async data => {
    const otp = {
      otp: data.otp,
      UUID: userDetails === null || userDetails === void 0 ? void 0 : userDetails.uuid,
      isValidationSuccessful: true,
      tenantId: tenant,
      identity: mobileNumber
    };
    try {
      var _response$otp;
      const response = await Digit.UserService.otpValidate({
        otp
      });
      console.log(response, "responseeeddee");
      if (response !== null && response !== void 0 && (_response$otp = response.otp) !== null && _response$otp !== void 0 && _response$otp.isValidationSuccessful) {
        navigate.push("/digit-ui/employee/user/reset-password", {
          otp: response.otp.otp,
          tenantId: response.otp.tenantId,
          mobileNumber: response.otp.identity,
          uuid: response.otp.UUID,
          userType: "employee"
        });
      }
    } catch (err) {
      var _err$response, _err$response$data, _err$response$data$er, _err$response$data$er2, _err$response$data$er3, _err$response2, _err$response2$data, _err$response2$data$e;
      console.error("Authentication Error:", err);
      const errorMessage = (err === null || err === void 0 ? void 0 : (_err$response = err.response) === null || _err$response === void 0 ? void 0 : (_err$response$data = _err$response.data) === null || _err$response$data === void 0 ? void 0 : (_err$response$data$er = _err$response$data.error) === null || _err$response$data$er === void 0 ? void 0 : (_err$response$data$er2 = _err$response$data$er.fields) === null || _err$response$data$er2 === void 0 ? void 0 : (_err$response$data$er3 = _err$response$data$er2[0]) === null || _err$response$data$er3 === void 0 ? void 0 : _err$response$data$er3.message) || (err === null || err === void 0 ? void 0 : (_err$response2 = err.response) === null || _err$response2 === void 0 ? void 0 : (_err$response2$data = _err$response2.data) === null || _err$response2$data === void 0 ? void 0 : (_err$response2$data$e = _err$response2$data.error) === null || _err$response2$data$e === void 0 ? void 0 : _err$response2$data$e.message) || (err === null || err === void 0 ? void 0 : err.message) || "Unable to authenticate user. Please try again.";
      setShowToast({
        error: true,
        message: errorMessage
      });
    }
  };
  const closeToast = () => {
    setShowToast(null);
  };
  useEffect(() => {
    if (!showToast) return;
    const timeOut = setTimeout(closeToast, 2000);
    return () => clearTimeout(timeOut);
  }, [showToast]);
  const handleOtpRecovery = async () => {
    if (!userName) {
      setShowToast({
        error: true,
        message: "Please enter Employee Id"
      });
      return;
    }
    setOtpSent(false);
    try {
      var _usersResponse$user, _usersResponse$user2, _usersResponse$user2$, _usersResponse$user3;
      const usersResponse = await Digit.UserService.openUserSearch(tenant, {
        userName
      });
      if (!(usersResponse !== null && usersResponse !== void 0 && usersResponse.user) || (usersResponse === null || usersResponse === void 0 ? void 0 : (_usersResponse$user = usersResponse.user) === null || _usersResponse$user === void 0 ? void 0 : _usersResponse$user.length) === 0) {
        throw new Error("User not found");
      }
      const mobile = usersResponse === null || usersResponse === void 0 ? void 0 : (_usersResponse$user2 = usersResponse.user) === null || _usersResponse$user2 === void 0 ? void 0 : (_usersResponse$user2$ = _usersResponse$user2[0]) === null || _usersResponse$user2$ === void 0 ? void 0 : _usersResponse$user2$.mobileNumber;
      setUserDetials(usersResponse === null || usersResponse === void 0 ? void 0 : (_usersResponse$user3 = usersResponse.user) === null || _usersResponse$user3 === void 0 ? void 0 : _usersResponse$user3[0]);
      if (!mobile) {
        throw new Error("Mobile number not linked with user");
      }
      setMobileNumber(mobile);
      const otpPayload = {
        mobileNumber: mobile,
        tenantId: tenant,
        type: "login",
        userType: "employee"
      };
      await Digit.UserService.sendOtp({
        otp: otpPayload
      }, tenant);
      setOtpSent(true);
    } catch (err) {
      console.error("OTP Recovery Error:", err);
      setShowToast({
        error: true,
        message: (err === null || err === void 0 ? void 0 : err.message) || "Something went wrong while sending OTP"
      });
    }
  };
  const getMaskedMobile = number => {
    if (!number) return "";
    return `******${number.slice(-4)}`;
  };
  return /*#__PURE__*/React__default.createElement(Box$1, {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "100vh",
    sx: {
      backgroundColor: "#0F4C75"
    }
  }, /*#__PURE__*/React__default.createElement(Card$3, {
    sx: {
      width: 420,
      borderRadius: 2
    }
  }, /*#__PURE__*/React__default.createElement(CardContent$2, null, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "h6",
    align: "center",
    fontWeight: "bold",
    gutterBottom: true
  }, "FORGOT PASSWORD"), /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body2",
    align: "center",
    color: "text.secondary",
    mb: 3
  }, "Please enter your details to reset your password."), /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "Enter Employee ID",
    name: "employeeId",
    type: "textInput",
    placeholder: "Employee ID",
    mandatory: true,
    width: 390,
    validation: {
      required: {
        value: true,
        message: "Employee ID is required"
      }
    }
  }), /*#__PURE__*/React__default.createElement(Box$1, {
    mt: 2
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    fullWidth: true,
    variant: "contained",
    type: "button",
    onClick: handleOtpRecovery,
    sx: {
      backgroundColor: "#1F4A7C",
      "&:hover": {
        backgroundColor: "#163A63"
      }
    }
  }, "SEND OTP")), otpSent && /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body2",
    color: "success.main",
    align: "center",
    mt: 2
  }, "OTP has been sent to ", getMaskedMobile(mobileNumber)), otpSent && /*#__PURE__*/React__default.createElement(Box$1, {
    mt: 3
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "Enter OTP",
    name: "otp",
    placeholder: "OTP",
    width: 390,
    type: "textInput",
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "OTP is required"
      }
    }
  })), otpSent && /*#__PURE__*/React__default.createElement(Box$1, {
    mt: 3
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    fullWidth: true,
    variant: "contained",
    type: "submit",
    sx: {
      backgroundColor: "#1F4A7C",
      "&:hover": {
        backgroundColor: "#163A63"
      }
    }
  }, "SUBMIT"))), /*#__PURE__*/React__default.createElement(Box$1, {
    mt: 2,
    textAlign: "center"
  }, /*#__PURE__*/React__default.createElement(Link, {
    href: "/digit-ui/citizen",
    underline: "hover"
  }, "Back to Login Page"))), showToast && /*#__PURE__*/React__default.createElement(Toast, {
    error: showToast === null || showToast === void 0 ? void 0 : showToast.error,
    warning: showToast === null || showToast === void 0 ? void 0 : showToast.warning,
    label: showToast === null || showToast === void 0 ? void 0 : showToast.message,
    onClose: closeToast,
    isDleteBtn: true
  })));
};

const ResetPasswordRecovery = () => {
  const {
    control,
    handleSubmit
  } = useForm();
  const location = useLocation();
  const navigate = useHistory();
  const [showToast, setShowToast] = useState(null);
  const {
    otp,
    tenantId,
    mobileNumber,
    uuid,
    userType
  } = location.state || {};
  const onSubmit = async data => {
    if (data.newPassword !== data.confirmPassword) {
      setShowToast({
        key: true,
        message: "Password doesnot match. Please try again."
      });
      return;
    }
    const requestData = {
      userName: mobileNumber,
      newPassword: data.newPassword,
      otpReference: otp,
      tenantId,
      type: userType.toUpperCase()
    };
    try {
      await Digit.UserService.changePasswordNoLogin(requestData, tenantId);
      setShowToast({
        key: "success",
        message: "Password changed successfully"
      });
      setTimeout(() => navigate.push("/digit-ui/citizen"), 3000);
    } catch (err) {
      var _err$response, _err$response$data, _err$response$data$Er, _err$response$data$Er2;
      console.error("Reset Password Error:", err);
      alert((err === null || err === void 0 ? void 0 : (_err$response = err.response) === null || _err$response === void 0 ? void 0 : (_err$response$data = _err$response.data) === null || _err$response$data === void 0 ? void 0 : (_err$response$data$Er = _err$response$data.Errors) === null || _err$response$data$Er === void 0 ? void 0 : (_err$response$data$Er2 = _err$response$data$Er[0]) === null || _err$response$data$Er2 === void 0 ? void 0 : _err$response$data$Er2.message) || "Unable to reset password");
    }
  };
  const closeToast = () => {
    setShowToast(null);
  };
  return /*#__PURE__*/React__default.createElement(Box$1, {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "100vh",
    sx: {
      backgroundColor: "#0F4C75"
    }
  }, /*#__PURE__*/React__default.createElement(Card$3, {
    sx: {
      width: 420,
      borderRadius: 2
    }
  }, /*#__PURE__*/React__default.createElement(CardContent$2, null, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "h6",
    align: "center",
    fontWeight: "bold",
    gutterBottom: true
  }, "RESET PASSWORD"), /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body2",
    align: "center",
    color: "text.secondary",
    mb: 3
  }, "Please set your new password below following the criteria."), /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "Enter your new Password",
    name: "newPassword",
    type: "password",
    width: 390,
    isPassword: true,
    mandatory: true,
    validation: {
      required: {
        value: true,
        message: "Password is required"
      }
    }
  }), /*#__PURE__*/React__default.createElement(Box$1, {
    mt: 2
  }, /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    label: "Re-Enter your new Password",
    name: "confirmPassword",
    type: "password",
    mandatory: true,
    isPassword: true,
    width: 390,
    validation: {
      required: {
        value: true,
        message: "Confirm password is required"
      }
    }
  })), /*#__PURE__*/React__default.createElement(Box$1, {
    mt: 2
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body2",
    color: "text.secondary"
  }, "\u2022 Password must contain at least 8 characters ", /*#__PURE__*/React__default.createElement("br", null), "\u2022 At least one special character ", /*#__PURE__*/React__default.createElement("br", null), "\u2022 At least one number ", /*#__PURE__*/React__default.createElement("br", null), "\u2022 At least one uppercase letter ", /*#__PURE__*/React__default.createElement("br", null), "\u2022 At least one lowercase letter")), /*#__PURE__*/React__default.createElement(Box$1, {
    mt: 3
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    fullWidth: true,
    variant: "contained",
    type: "submit",
    sx: {
      backgroundColor: "#1F4A7C",
      "&:hover": {
        backgroundColor: "#163A63"
      }
    }
  }, "Continue"))), /*#__PURE__*/React__default.createElement(Box$1, {
    mt: 2,
    textAlign: "center"
  }, /*#__PURE__*/React__default.createElement(Link, {
    href: "/digit-ui/citizen",
    underline: "hover"
  }, "Back to Login Page"))), showToast && /*#__PURE__*/React__default.createElement(Toast, {
    error: showToast === null || showToast === void 0 ? void 0 : showToast.error,
    warning: showToast === null || showToast === void 0 ? void 0 : showToast.warning,
    label: showToast.key === "success" ? showToast === null || showToast === void 0 ? void 0 : showToast.message : showToast === null || showToast === void 0 ? void 0 : showToast.message,
    onClose: closeToast,
    isDleteBtn: true
  })));
};

const EmployeeApp = ({
  stateInfo,
  userDetails,
  CITIZEN,
  cityDetails,
  mobileView,
  handleUserDropdownSelection,
  logoUrl,
  DSO,
  stateCode,
  modules,
  appTenants,
  sourceUrl,
  pathname
}) => {
  var _location$pathname, _location$pathname2;
  const {
    t
  } = useTranslation();
  const {
    path
  } = useRouteMatch();
  const location = useLocation();
  const showLanguageChange = location === null || location === void 0 ? void 0 : (_location$pathname = location.pathname) === null || _location$pathname === void 0 ? void 0 : _location$pathname.includes("language-selection");
  const isUserProfile = location === null || location === void 0 ? void 0 : (_location$pathname2 = location.pathname) === null || _location$pathname2 === void 0 ? void 0 : _location$pathname2.includes("user/profile");
  useEffect(() => {
    Digit.UserService.setType("employee");
  }, []);
  sourceUrl = "https://s3.ap-south-1.amazonaws.com/egov-qa-assets";
  return /*#__PURE__*/React__default.createElement("div", {
    className: "employee"
  }, /*#__PURE__*/React__default.createElement(Switch, null, /*#__PURE__*/React__default.createElement(Route, {
    path: `${path}/user`
  }, isUserProfile && /*#__PURE__*/React__default.createElement(TopBarSideBar, {
    t: t,
    stateInfo: stateInfo,
    userDetails: userDetails,
    CITIZEN: CITIZEN,
    cityDetails: cityDetails,
    mobileView: mobileView,
    handleUserDropdownSelection: handleUserDropdownSelection,
    logoUrl: logoUrl,
    showSidebar: isUserProfile ? true : false,
    showLanguageChange: !showLanguageChange
  }), /*#__PURE__*/React__default.createElement("div", {
    className: isUserProfile ? "grounded-container" : "loginContainer",
    style: isUserProfile ? {
      padding: 0,
      paddingTop: "80px",
      marginLeft: mobileView ? "" : "215px"
    } : {
      "--banner-url": `url(${stateInfo === null || stateInfo === void 0 ? void 0 : stateInfo.bannerUrl})`,
      padding: "0px"
    }
  }, /*#__PURE__*/React__default.createElement(Switch, null, /*#__PURE__*/React__default.createElement(Route, {
    path: `${path}/user/login`
  }, /*#__PURE__*/React__default.createElement(EmployeeLogin, null)), /*#__PURE__*/React__default.createElement(Route, {
    path: `${path}/user/forgot-password`
  }, /*#__PURE__*/React__default.createElement(EmployeeForgotPassword, null)), /*#__PURE__*/React__default.createElement(Route, {
    path: `${path}/user/forgot-password-recover`
  }, /*#__PURE__*/React__default.createElement(ForgotPasswordRecovery, null)), /*#__PURE__*/React__default.createElement(Route, {
    path: `${path}/user/change-password`
  }, /*#__PURE__*/React__default.createElement(EmployeeChangePassword, null)), /*#__PURE__*/React__default.createElement(Route, {
    path: `${path}/user/reset-password`
  }, /*#__PURE__*/React__default.createElement(ResetPasswordRecovery, null)), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/user/profile`,
    component: () => /*#__PURE__*/React__default.createElement(UserProfile, {
      stateCode: stateCode,
      userType: "employee",
      cityDetails: cityDetails
    })
  }), /*#__PURE__*/React__default.createElement(Route, {
    path: `${path}/user/language-selection`
  }, /*#__PURE__*/React__default.createElement(LanguageSelection, null)), /*#__PURE__*/React__default.createElement(Route, null, /*#__PURE__*/React__default.createElement(Redirect, {
    to: `${path}/user/language-selection`
  }))))), /*#__PURE__*/React__default.createElement(Route, null, /*#__PURE__*/React__default.createElement(TopBarSideBar, {
    t: t,
    stateInfo: stateInfo,
    userDetails: userDetails,
    CITIZEN: CITIZEN,
    cityDetails: cityDetails,
    mobileView: mobileView,
    handleUserDropdownSelection: handleUserDropdownSelection,
    logoUrl: logoUrl
  }), /*#__PURE__*/React__default.createElement("div", {
    className: `main ${DSO ? "m-auto" : ""}`
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "employee-app-wrapper"
  }, /*#__PURE__*/React__default.createElement(ErrorBoundary, null, /*#__PURE__*/React__default.createElement(AppModules, {
    stateCode: stateCode,
    userType: "employee",
    modules: modules,
    appTenants: appTenants
  }))), /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%",
      bottom: 0
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "center",
      color: "#1F4A7C"
    }
  }, /*#__PURE__*/React__default.createElement("h3", {
    style: {
      cursor: "pointer",
      display: "inline-flex"
    }
  }, /*#__PURE__*/React__default.createElement("a", {
    href: "https://www.digit.org/",
    target: "_blank",
    rel: "noopener noreferrer",
    onClick: e => {
      e.preventDefault();
      window.open("https://www.digit.org/", "_blank").focus();
    },
    style: {
      color: "blue",
      textDecoration: "none",
      fontWeight: "bold"
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      color: "rgb(31, 74, 124)"
    }
  }, "Powered by"), " ", /*#__PURE__*/React__default.createElement("span", {
    style: {
      color: "green"
    }
  }, "UPYOG"))), /*#__PURE__*/React__default.createElement("span", {
    style: {
      margin: "0 10px"
    }
  }, "|"), /*#__PURE__*/React__default.createElement("span", {
    style: {
      cursor: "pointer",
      fontSize: "16px",
      fontWeight: "400"
    },
    onClick: () => {
      window.open("https://niua.in/", "_blank").focus();
    }
  }, "Copyright \xA9 2022 National Institute of Urban Affairs"), /*#__PURE__*/React__default.createElement("span", {
    style: {
      margin: "0 10px"
    }
  }, "|"), /*#__PURE__*/React__default.createElement("a", {
    style: {
      cursor: "pointer",
      fontSize: "16px",
      fontWeight: "400"
    },
    href: "#",
    target: "_blank"
  }, "UPYOG License"))))), /*#__PURE__*/React__default.createElement(Route, null, /*#__PURE__*/React__default.createElement(Redirect, {
    to: `${path}/user/language-selection`
  }))));
};

const useStyles$4 = makeStyles(theme => ({
  button: {
    backgroundColor: 'black',
    marginRight: theme.spacing(1),
    '&:hover': {
      backgroundColor: "rgba(50, 50, 50, 1)"
    }
  },
  Info: {
    color: '#CC8500',
    fontSize: '14px',
    marginTop: '10px',
    marginLeft: '10px',
    textShadow: '.5px .5px #CC8500',
    animation: '$blinker 3s linear infinite'
  },
  '@keyframes blinker': {
    '50%': {
      opacity: 0
    }
  }
}));

const useStyles$5 = makeStyles(theme => ({
  contentContainer: {
    display: "flex",
    justifyContent: "space-between",
    width: "80%",
    margin: "0 auto",
    flexDirection: "row",
    backgroundColor: "#ECECEC",
    opacity: 0.9,
    padding: theme.spacing(3),
    marginTop: theme.spacing(10)
  },
  textSection: {
    width: "50%",
    color: "black"
  },
  imageSection: {
    width: "48%",
    textAlign: "center"
  },
  header1: {
    fontWeight: "bolder",
    fontSize: "40px",
    marginLeft: theme.spacing(1)
  },
  header2: {
    fontWeight: "bolder",
    fontSize: "26px",
    marginLeft: theme.spacing(1)
  },
  paragraph: {
    margin: theme.spacing(2)
  },
  lastPara: {
    color: "#5E5E5E",
    fontSize: "18px",
    fontWeight: "bold",
    marginTop: theme.spacing(6)
  },
  Info: {
    color: "#CC8500",
    fontSize: "14px",
    marginTop: "10px",
    textShadow: ".5px .5px #CC8500"
  }
}));

const useStyles$6 = makeStyles(theme => ({
  info: {
    color: '#CC8500',
    fontSize: '14px',
    marginTop: '10px',
    marginLeft: '10px',
    textShadow: '.5px .5px #CC8500',
    animation: '$blinker 2s linear infinite'
  },
  '@keyframes blinker': {
    '50%': {
      opacity: 0
    }
  }
}));

const HomeWrapper = styled$2(Box$1)(({
  theme
}) => ({
  fontFamily: theme.typography.fontFamily,
  marginTop: theme.spacing(-10)
}));
const TopBarWrapper = styled$2(Box$1)(({
  theme
}) => ({
  backgroundColor: theme.palette.ud.primary.main,
  [theme.breakpoints.up('lg')]: {
    backgroundColor: theme.palette.background.paper
  },
  padding: theme.spacing(0.25, 0)
}));
const ContainerWrapper = styled$2(Container$1)(({
  theme
}) => ({
  maxWidth: theme.breakpoints['lg'],
  justifyContent: 'flex-end',
  gap: theme.spacing(2.5),
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  [theme.breakpoints.up('lg')]: {
    flexDirection: 'row'
  }
}));
const SearchWrapper = styled$2('div')(({
  theme
}) => ({
  borderRadius: theme.shape.borderRadius,
  marginTop: theme.spacing(2),
  border: '1px solid #D4D2D2',
  backgroundColor: '#F7F7F7',
  position: 'relative',
  '&:hover': {
    backgroundColor: '#F5F5F5'
  },
  width: '100%',
  [theme.breakpoints.up('lg')]: {
    marginTop: 0,
    width: 'auto'
  }
}));
const StyledInputBase = styled$2(InputBase)(({
  theme
}) => ({
  color: 'inherit',
  width: '100%',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 0, 1, 1),
    paddingRight: `calc(1em + ${theme.spacing(3)})`,
    transition: theme.transitions.create('width'),
    [theme.breakpoints.up('lg')]: {
      width: '12ch',
      '&:focus': {
        width: '20ch'
      }
    }
  }
}));
const SearchIconWrapper = styled$2('div')(({
  theme
}) => ({
  padding: theme.spacing(0, 1),
  justifyContent: 'center',
  pointerEvents: 'none',
  alignItems: 'center',
  position: 'absolute',
  display: 'flex',
  height: '100%',
  right: 0,
  top: 0,
  '& svg': {
    fill: '#9F9F9F'
  }
}));
const LanguageSwitch = styled$2(Button$2)(({
  theme
}) => ({
  borderRadius: theme.spacing(0.5),
  backgroundColor: '#F4F4F4',
  '&:hover': {
    backgroundColor: '#F6F6F6'
  },
  textTransform: 'unset',
  gap: theme.spacing(1),
  textAlign: 'center',
  color: '#181818',
  minWidth: '100%',
  padding: 0,
  [theme.breakpoints.up('lg')]: {
    minWidth: theme.spacing(6.25),
    padding: theme.spacing(1, 2)
  }
}));
const ThemeWrapper = styled$2(Box$1)(({
  theme
}) => ({
  color: theme.palette.common.white,
  gap: theme.spacing(1),
  alignItems: 'center',
  display: 'flex',
  '& svg': {
    fill: theme.palette.common.white,
    [theme.breakpoints.up('lg')]: {
      fill: theme.palette.mode === 'dark' ? theme.palette.common.white : theme.palette.grey['600']
    }
  }
}));
const ButtonsWrapper = styled$2(Box$1)(({
  theme
}) => ({
  alignItems: 'center',
  display: 'flex',
  '& .MuiButton-root': {
    color: theme.palette.common.black,
    borderRadius: theme.spacing(0.5),
    paddingInline: theme.spacing(1),
    minWidth: theme.spacing(3.5),
    height: theme.spacing(3.5),
    '&.MuiButton-contained': {
      borderColor: theme.palette.mode === 'dark' ? theme.palette.grey['200'] : '#D9D9D9',
      backgroundColor: '#D9D9D9'
    },
    '&.MuiButton-outlined': {
      borderColor: theme.palette.mode === 'dark' ? theme.palette.grey['200'] : theme.palette.common.black,
      backgroundColor: theme.palette.common.white
    }
  }
}));
const VolumeMenu = styled$2(Menu$1)(({
  theme
}) => ({
  '& .MuiMenu-paper': {
    paddingInline: theme.spacing(2),
    minWidth: 200,
    '& .MuiStack-root': {
      marginBottom: 0
    },
    '& .MuiSlider-thumb, & .MuiSlider-track': {
      backgroundColor: theme.palette.ud.primary.main
    }
  }
}));
const HeaderWrapper = styled$2(Box$1)(({
  theme
}) => ({
  backgroundColor: theme.palette.background.paper
}));
const HeaderContainer = styled$2(Container$1)(({
  theme
}) => ({
  maxWidth: theme.breakpoints['lg'],
  justifyContent: 'space-between',
  paddingBlock: theme.spacing(1),
  alignItems: 'center',
  display: 'flex'
}));
const HeaderTitle = styled$2(Box$1)(() => ({
  textAlign: 'center'
}));
const Title1 = styled$2(Typography$1)(({
  theme
}) => ({
  fontSize: theme.typography.fontSize,
  color: theme.palette.grey['50'],
  [theme.breakpoints.up('lg')]: {
    fontSize: theme.typography.fontSize * 1.4,
    color: theme.palette.mode === 'dark' ? theme.palette.grey['100'] : '#191B20'
  }
}));
const Title2 = styled$2(Typography$1)(({
  theme
}) => ({
  fontWeight: theme.typography.fontWeightBold,
  fontSize: theme.typography.fontSize,
  color: theme.palette.grey['100'],
  [theme.breakpoints.up('lg')]: {
    fontSize: theme.typography.fontSize * 1.6,
    color: theme.palette.mode === 'dark' ? theme.palette.grey['50'] : '#0C0D10'
  }
}));
const MenuWrapper = styled$2(AppBar)(({
  theme
}) => ({
  backgroundColor: theme.palette.ud.primary.main,
  color: theme.palette.ud.primary.text
}));
const NavContainer = styled$2(Container$1)(({
  theme
}) => ({
  maxWidth: theme.breakpoints['lg'],
  minHeight: theme.spacing(6.25),
  [theme.breakpoints.up('lg')]: {
    color: theme.palette.common.black,
    backgroundColor: 'transparent',
    minHeight: theme.spacing(5)
  },
  backgroundColor: theme.palette.ud.primary.main,
  color: theme.palette.ud.primary.text
}));
const NavToolbar = styled$2(Toolbar)(({
  theme
}) => ({
  maxWidth: theme.breakpoints['lg'],
  justifyContent: 'space-between',
  padding: theme.spacing(0.5, 0),
  [theme.breakpoints.up('lg')]: {
    padding: theme.spacing(1, 0),
    justifyContent: 'center'
  },
  minHeight: theme.spacing(4),
  columnGap: theme.spacing(1),
  textAlign: 'center'
}));
const StyledMenu = styled$2(Menu$1)(({
  theme
}) => ({
  '& .MuiMenu-paper': {
    backgroundColor: theme.palette.ud.primary.main,
    borderRadius: theme.shape.borderRadius * .75,
    translateY: theme.spacing(0.5),
    minWidth: 140,
    '& .MuiButton-root': {
      paddingInline: theme.spacing(2),
      textAlign: 'left',
      display: 'block',
      width: '100%'
    }
  }
}));
const MenuItem = styled$2(Button$2)(({
  theme
}) => ({
  borderRadius: theme.shape.borderRadius * 0.5,
  color: theme.palette.primary.contrastText,
  paddingBlock: theme.spacing(0.25)
}));
const StyledDivider$1 = styled$2(Divider$1)(({
  theme
}) => ({
  height: theme.spacing(3.25) + ' !important',
  color: theme.palette.grey['50'],
  alignSelf: 'center'
}));
const StyledDrawer = styled$2(Drawer)(({
  theme
}) => ({
  '& .MuiDrawer-paper': {
    backgroundColor: theme.palette.ud.primary.main,
    boxSizing: 'border-box',
    overflow: 'hidden',
    '& .subMenu': {
      backgroundColor: alpha(theme.palette.common.black, 0.1),
      paddingInline: theme.spacing(2),
      '& .MuiButton-root': {
        display: 'block',
        textAlign: 'left',
        width: '100%'
      }
    },
    '& .MuiButton-root': {
      paddingInline: theme.spacing(2),
      justifyContent: 'space-between',
      lineHeight: theme.spacing(5),
      borderRadius: 0,
      '&.MuiButton-contained, &.MuiButton-outlined': {
        paddingInline: theme.spacing(3)
      },
      '&.MuiButton-outlined': {
        borderColor: alpha(theme.palette.common.black, 0.1)
      }
    },
    '& .MuiDivider-vertical': {
      height: '1px !important',
      display: 'block',
      width: '100%'
    }
  }
}));
const HeroWrapper = styled$2(Box$1)(({
  theme,
  bgimg
}) => ({
  background: `${theme.palette.grey['200']} url('${bgimg}') center center / cover no-repeat`,
  transition: `background 1.5s ease-in-out`,
  minHeight: `calc(100dvh - 50px)`,
  position: 'relative',
  [theme.breakpoints.up('lg')]: {
    minHeight: `calc(100dvh - 150px)`
  }
}));
const HeroTopLeftMessage = styled$2(Box$1)(({
  theme
}) => ({
  backgroundColor: alpha(theme.palette.common.black, 0.25),
  fontWeight: theme.typography.fontWeightMedium,
  textShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.75)',
  inset: theme.spacing(4, 4, 'auto', 4),
  [theme.breakpoints.up('sm')]: {
    inset: theme.spacing(4, 'auto', 'auto', 4)
  },
  fontSize: theme.typography.fontSize * 1.4,
  color: theme.palette.common.white,
  borderRadius: theme.spacing(0.5),
  backdropFilter: 'blur(1px)',
  padding: theme.spacing(2),
  position: 'absolute'
}));
const HeroMantriStrip = styled$2(Box$1)(({
  theme
}) => ({
  backgroundColor: alpha(theme.palette.common.black, 0.7),
  inset: theme.spacing('auto', 0, 2),
  color: theme.palette.common.white,
  padding: theme.spacing(3, 4),
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(3, 8)
  },
  [theme.breakpoints.up('lg')]: {
    padding: theme.spacing(3, 12)
  },
  backdropFilter: 'blur(1px)',
  position: 'absolute'
}));
const PersonCard = styled$2(Grid$1)(({
  theme
}) => ({
  justifyContent: 'space-between',
  gap: theme.spacing(2),
  alignItems: 'center',
  display: 'flex'
}));
const PersonPic = styled$2(Box$1)(({
  theme
}) => ({
  '& img': {
    objectFit: 'cover',
    display: 'block',
    height: 80,
    width: 80
  }
}));
const PersonDesc = styled$2(Box$1)(({
  theme
}) => ({
  fontSize: theme.typography.fontSize,
  color: theme.palette.common.white,
  flex: 1,
  '& strong': {
    fontWeight: theme.typography.fontWeightMedium,
    display: 'block'
  }
}));
const ServicesContainer = styled$2(Container$1)(({
  theme
}) => ({
  maxWidth: theme.breakpoints['lg'],
  paddingBlock: theme.spacing(4)
}));
const ServiceGrid = styled$2(Grid$1)(({
  theme
}) => ({
  justifyContent: 'center',
  '& .MuiButtonBase-root': {
    fontWeight: theme.typography.fontWeightSemiBold,
    flexDirection: 'column',
    textAlign: 'center',
    width: '100%',
    flex: 1,
    '& img': {
      marginBottom: theme.spacing(1),
      display: 'block',
      margin: 'auto',
      maxWidth: 150
    }
  }
}));
const AppDetailsWrapper = styled$2(Box$1)(({
  theme
}) => ({
  backgroundColor: theme.palette.ud.primary.main,
  fontWeight: theme.typography.fontWeightMedium,
  color: theme.palette.ud.primary.text,
  paddingBlock: theme.spacing(3.75)
}));
const AppDetailsContainer = styled$2(Container$1)(({
  theme
}) => ({
  maxWidth: theme.breakpoints['lg']
}));
const AppDetailsHead = styled$2(Typography$1)(({
  theme
}) => ({
  fontWeight: theme.typography.fontWeightMedium,
  fontSize: theme.typography.fontSize * 2,
  marginBottom: theme.spacing(2),
  textTransform: 'uppercase'
}));
const AppDetailsLabel = styled$2(Box$1)(({
  theme
}) => ({
  fontSize: theme.typography.fontSize * 1.5
}));
const AppDetailsValue = styled$2(Box$1)(({
  theme
}) => ({
  fontSize: theme.typography.fontSize * 6
}));
const FormsContainer = styled$2(Container$1)(({
  theme
}) => ({
  maxWidth: theme.breakpoints['lg'],
  paddingBlock: theme.spacing(3),
  flexDirection: 'column',
  alignItems: 'stretch',
  display: 'flex',
  [theme.breakpoints.up('md')]: {
    alignItems: 'flex-start',
    flexDirection: 'row'
  },
  '& > div': {
    flex: 1,
    textAlign: 'center',
    padding: theme.spacing(2, 3, 3),
    '&.feedbackForm': {
      paddingInline: 0
    },
    [theme.breakpoints.up('md')]: {
      '&.feedbackForm': {
        padding: theme.spacing(2, 3, 3)
      },
      textAlign: 'right'
    },
    '& .title': {
      fontWeight: theme.typography.fontWeightSemiBold,
      fontSize: theme.typography.fontSize * 1.5,
      color: theme.palette.ud.primary.main,
      marginBottom: theme.spacing(1.5),
      textTransform: 'uppercase',
      textAlign: 'left'
    }
  }
}));
const ChecklistWrapper = styled$2(Box$1)(({
  theme
}) => ({
  border: '1px solid #F7A143',
  marginInline: 'auto',
  maxWidth: 530,
  '& .content': {
    marginBottom: theme.spacing(2),
    textAlign: 'left',
    '& p': {
      fontSize: theme.typography.fontSize,
      marginBottom: theme.spacing(1)
    }
  },
  '& .MuiButton-root': {
    color: theme.palette.ud.primary.main,
    textTransform: 'unset'
  }
}));
const FeedbackWrapper = styled$2(Box$1)(({
  theme
}) => ({
  padding: theme.spacing(0),
  textAlign: 'center',
  [theme.breakpoints.up('md')]: {
    textAlign: 'right'
  }
}));
const FormContainer = styled$2(Box$1)(({
  theme
}) => ({
  marginInline: 'auto',
  textAlign: 'center',
  maxWidth: 530,
  [theme.breakpoints.up('md')]: {
    textAlign: 'left',
    marginRight: 0,
    maxWidth: 450
  },
  '& button[type="submit"]': {
    width: '100%'
  },
  '&.tcp': {
    '& .title': {
      fontWeight: theme.typography.fontWeightSemiBold,
      fontSize: theme.typography.fontSize * 1.5,
      color: theme.palette.tcp.primary.main,
      marginBottom: theme.spacing(1.5),
      marginRight: theme.spacing(4),
      textTransform: 'uppercase',
      textAlign: 'center'
    },
    '& .MuiFormGroup-root': {
      '& label .MuiFormControlLabel-label, & label svg': {
        color: theme.palette.tcp.primary.main
      },
      '& label svg': {
        fill: theme.palette.tcp.primary.main
      },
      justifyContent: 'center',
      gap: theme.spacing(2),
      '& .MuiButtonBase-root': {
        padding: theme.spacing(1)
      }
    }
  }
}));
const StyledRadioGroup$2 = styled$2(RadioGroup$1)(({
  theme
}) => ({
  '& label': {
    '&.MuiFormControlLabel-root': {
      marginBottom: 0
    },
    '& .MuiFormControlLabel-label': {
      fontWeight: theme.typography.fontWeightSemiBold,
      fontSize: theme.typography.fontSize * 1.1,
      color: theme.palette.ud.primary.main
    },
    '& svg': {
      fill: theme.palette.ud.primary.main
    }
  }
}));
const FooterWrapper = styled$2('footer')(({
  theme
}) => ({
  backgroundColor: theme.palette.ud.primary.main,
  color: theme.palette.ud.primary.text,
  fontSize: theme.typography.fontSize,
  padding: theme.spacing(1),
  textAlign: 'center'
}));
const TcpFooterWrapper = styled$2('footer')(({
  theme
}) => ({
  backgroundColor: theme.palette.tcp.primary.main,
  color: theme.palette.ud.primary.text,
  fontSize: theme.typography.fontSize,
  padding: theme.spacing(1),
  textAlign: 'center'
}));

const useStyles$7 = makeStyles({
  main: {
    padding: 50
  },
  heading: {
    fontWeight: 'normal',
    textAlign: 'center',
    fontSize: 30,
    color: '#2F5EA8'
  },
  container: {
    padding: '1rem 0.5rem',
    overflow: 'hidden'
  },
  slides: {
    transition: '500ms translate ease-out',
    width: 'max-content',
    display: 'flex',
    gap: '1rem'
  },
  slide: {
    overflow: 'hidden',
    height: 'auto',
    padding: 8,
    flex: 1,
    '& a': {
      width: '100%'
    },
    '& img': {
      objectFit: 'contain',
      width: '100%',
      height: 100
    }
  }
});
const links = ['https://www.awasbandhu.in/', 'https://awas.upsdc.gov.in/Home', 'https://upavp.in/', 'https://www.coa.gov.in/ver_arch.php?lang=1', 'https://www.awasbandhu.in/', 'https://awas.upsdc.gov.in/Home', 'https://upavp.in/', 'https://www.coa.gov.in/ver_arch.php?lang=1'];
const photos = ['https://imgur.com/9IjoR0I.jpeg', 'https://imgur.com/2n1djI9.png', 'https://imgur.com/HBlnYIt.png', 'https://imgur.com/3OhHQd1.png', 'https://imgur.com/9IjoR0I.jpeg', 'https://imgur.com/2n1djI9.png', 'https://imgur.com/HBlnYIt.png', 'https://imgur.com/3OhHQd1.png'];
const LinksSlideshow = ({
  titleStyles,
  containerStyles,
  noOfSlides: _noOfSlides = 4
}) => {
  const classes = useStyles$7();
  const galleryRef = useRef(null);
  const slidesRef = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [slidePose, setSlidePose] = useState(0);
  useEffect(() => {
    const timer = setTimeout(() => {
      var _slidesRef$current, _galleryRef$current, _galleryRef$current2;
      const slides = Math.ceil(((_slidesRef$current = slidesRef.current) === null || _slidesRef$current === void 0 ? void 0 : _slidesRef$current.clientWidth) / ((_galleryRef$current = galleryRef.current) === null || _galleryRef$current === void 0 ? void 0 : _galleryRef$current.clientWidth));
      const slideWidth = (_galleryRef$current2 = galleryRef.current) === null || _galleryRef$current2 === void 0 ? void 0 : _galleryRef$current2.clientWidth;
      setSlidePose(`-${slideWidth * currentIndex}px 0px`);
      setCurrentIndex((currentIndex + 1) % slides);
    }, 3000);
    return () => clearTimeout(timer);
  }, [currentIndex]);
  return /*#__PURE__*/React__default.createElement("div", {
    className: classes.main,
    style: {
      padding: "0.5rem"
    }
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: classes.heading,
    style: titleStyles
  }, "Important Links"), /*#__PURE__*/React__default.createElement(Box$1, {
    className: classes.container,
    style: containerStyles,
    ref: galleryRef
  }, /*#__PURE__*/React__default.createElement(Box$1, {
    className: classes.slides,
    ref: slidesRef,
    sx: {
      translate: slidePose
    }
  }, photos.map((photo, i) => {
    var _galleryRef$current3;
    return /*#__PURE__*/React__default.createElement(Paper, {
      elevation: 3,
      className: classes.slide,
      key: `${photo}-${i}`,
      sx: {
        width: `${((_galleryRef$current3 = galleryRef.current) === null || _galleryRef$current3 === void 0 ? void 0 : _galleryRef$current3.clientWidth) / _noOfSlides - 16}px`
      }
    }, /*#__PURE__*/React__default.createElement("a", {
      href: links[i],
      target: "_blank"
    }, /*#__PURE__*/React__default.createElement("img", {
      src: photo,
      alt: `slide-${i}`
    })));
  }))));
};

function Search() {
  return /*#__PURE__*/React__default.createElement(SearchWrapper, null, /*#__PURE__*/React__default.createElement(StyledInputBase, {
    placeholder: "Search\u2026",
    inputProps: {
      'aria-label': 'search'
    }
  }), /*#__PURE__*/React__default.createElement(SearchIconWrapper, null, /*#__PURE__*/React__default.createElement(SearchIcon, null)));
}

function LanguageSwitcher() {
  const [language, setLanguage] = useState('हिंदी');
  const toggleLanguage = () => setLanguage(lang => lang === 'हिंदी' ? 'Eng' : 'हिंदी');
  return /*#__PURE__*/React__default.createElement(LanguageSwitch, {
    onClick: toggleLanguage
  }, /*#__PURE__*/React__default.createElement(Box$1, {
    sx: {
      display: {
        lg: 'none'
      }
    }
  }, "Change Language:"), language);
}

function FontSizeController() {
  return /*#__PURE__*/React__default.createElement(Box$1, null, /*#__PURE__*/React__default.createElement(Box$1, {
    sx: {
      display: {
        lg: 'none'
      },
      color: 'white'
    }
  }, "Change Font Size:"), /*#__PURE__*/React__default.createElement(ButtonsWrapper, null, /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    disableElevation: true
  }, "-A"), /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "outlined"
  }, "A"), /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    disableElevation: true
  }, "+A")));
}

function ThemeSwitcher() {
  const theme = useTheme();
  const colorMode = useContext(ColorModeContext);
  return /*#__PURE__*/React__default.createElement(ThemeWrapper, null, /*#__PURE__*/React__default.createElement(Box$1, {
    sx: {
      display: {
        lg: 'none'
      }
    }
  }, "Change Theme:"), /*#__PURE__*/React__default.createElement(IconButton$2, {
    onClick: colorMode.toggleThemeMode
  }, theme.palette.mode === 'light' ? /*#__PURE__*/React__default.createElement(DarkMode, null) : /*#__PURE__*/React__default.createElement(LightMode, null)));
}

const topIconsList = [{
  icon: 'https://i.imgur.com/jFkgXhu.png',
  text: 'Volume',
  url: null
}, {
  icon: 'https://i.imgur.com/Fb1IAgl.png',
  text: 'Android',
  url: 'https://play.google.com/store/apps/details?id=com.csm.hptcp.hptcpmobileapp'
}, {
  icon: 'https://i.imgur.com/u3rR5CI.png',
  text: 'Apple',
  url: 'https://itunes.apple.com/us/app/him-tcp/id1161638555?ls=1&mt=8'
}, {
  icon: 'https://i.imgur.com/JDHzKDv.png',
  text: 'Microsoft',
  url: 'https://www.microsoft.com/en-in/store/p/him-tcp/9nblggh406mz'
}];
const bannerImgUrls = ['https://i.imgur.com/ttaSbOH.jpeg'];
const bannerCmStripData = [{
  photo: "https://www.awasbandhu.in/wp-content/uploads/2023/01/cmyogi.jpg",
  name: "Yogi Adityanath",
  designation: "Hon'ble Chief Minister"
}, {
  photo: "https://www.awasbandhu.in/wp-content/uploads/2023/01/principal-sec.jpg",
  name: "Dr. Nitin Ramesh Gokarn",
  designation: "Addl. Chief Secretary, Housing and Urban Planning"
}, {
  photo: "https://www.awasbandhu.in/wp-content/uploads/2024/03/principal-sec-02.png",
  name: "Dr. Balkar Singh",
  designation: "Executive Director, Awas Bandhu"
}];
const getServicesData = toggleModal => [{
  icon: 'https://i.imgur.com/bjeMi4C.png',
  label: 'Online User Services',
  action: '/digit-ui/citizen/profile'
}, {
  icon: 'https://i.imgur.com/P4YELk9.png',
  label: 'Fee Calculator',
  action: '/digit-ui/citizen/feecalculator'
}, {
  icon: 'https://i.imgur.com/KmG8cB5.png',
  label: 'Check/ Track Application Status',
  action: toggleModal
}, {
  icon: 'https://i.imgur.com/JoPAAOR.png',
  label: 'Officer Login',
  action: '/digit-ui/employee'
}];
const homeUrl = '/digit-ui/citizen';
const navData = [{
  label: 'Home',
  url: homeUrl
}, {
  label: 'About Us',
  url: `${homeUrl}/aboutus`
}, {
  label: 'Notification / Order',
  url: `${homeUrl}/notifications`
}, {
  label: 'Acts & Rules',
  url: null,
  subMenu: [{
    label: 'Acts',
    url: `${homeUrl}/acts`
  }, {
    label: 'Rules',
    url: `${homeUrl}/rules`
  }]
}, {
  label: 'Development Plan',
  url: `${homeUrl}/development-plan`
}, {
  label: 'FAQ',
  url: `${homeUrl}/faq`
}, {
  label: 'User Manual',
  url: `${homeUrl}/userguidemanual`
}, {
  label: 'Contact Us',
  url: `${homeUrl}/contactus`
}];
const checklistData = [{
  label: 'Form of application for permission of sub-division / development of land',
  url: '#',
  onClick: () => null
}, {
  label: 'Inspection Procedure and Checklist of obtaining Final NOC',
  url: '#',
  onClick: () => null
}, {
  label: 'Inspection Procedure and checklist of obtaining Construction Permit',
  url: '#',
  onClick: () => null
}, {
  label: 'Form Application for compostion of offences under section 39-C read with sub-section (3) of section',
  url: '#',
  onClick: () => null
}, {
  label: 'Procedure and Guidelines for Obtaining Planning Permission on Form 12',
  url: '#',
  onClick: () => null
}, {
  label: 'Form of application for permission of Development of Land / Construction of Building',
  url: '#',
  onClick: () => null
}, {
  label: 'Inspection Procedure and checklist of obtaining Construction Permit',
  url: '#',
  onClick: () => null
}, {
  label: 'Procedure and Guidelines for Obtaining Planning Permission on Form 12',
  url: '#',
  onClick: () => null
}, {
  label: 'Inspection Procedure and checklist of obtaining Construction Permit',
  url: '#',
  onClick: () => null
}, {
  label: 'Procedure, Checklist for Obtaining NOC After...',
  url: '#',
  onClick: () => null
}, {
  label: 'Inspection Procedure & Checklist for ...',
  url: '#',
  onClick: () => null
}];
const feedbackFormFields = [{
  name: 'name',
  label: 'Name',
  placeholder: 'Name'
}, {
  name: 'mobileNo',
  label: 'Mobile No.',
  placeholder: 'Mobile No.'
}, {
  name: 'email',
  label: 'E-mail',
  placeholder: 'E-mail'
}, {
  name: 'subject',
  label: 'Subject',
  placeholder: 'Subject'
}, {
  name: 'message',
  label: 'Message',
  placeholder: 'Enter Your Message'
}];
const feedbackFormDefaults = {
  formType: "feedback",
  name: '',
  mobileNo: '',
  email: '',
  subject: '',
  message: ''
};

function TopIcons() {
  const [anchorEl, setAnchorEl] = useState(null);
  const [volume, setVolume] = React__default.useState(30);
  const open = Boolean(anchorEl);
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleChange = (event, newValue) => {
    setVolume(newValue);
  };
  return /*#__PURE__*/React__default.createElement(ButtonsWrapper, null, topIconsList === null || topIconsList === void 0 ? void 0 : topIconsList.map(({
    icon,
    text,
    url
  }) => text === 'Volume' ? /*#__PURE__*/React__default.createElement(IconButton$2, {
    key: text,
    id: "volume-button",
    "aria-haspopup": "true",
    "aria-controls": open ? 'volume-menu' : undefined,
    "aria-expanded": open ? 'true' : undefined,
    onClick: handleClick
  }, /*#__PURE__*/React__default.createElement("img", {
    src: icon,
    alt: text
  })) : /*#__PURE__*/React__default.createElement(IconButton$2, {
    href: url,
    key: text,
    target: "_blank"
  }, /*#__PURE__*/React__default.createElement("img", {
    src: icon,
    alt: text
  }))), /*#__PURE__*/React__default.createElement(VolumeMenu, {
    id: "volume-menu",
    anchorEl: anchorEl,
    open: open,
    onClose: handleClose,
    MenuListProps: {
      'aria-labelledby': 'volume-button'
    }
  }, /*#__PURE__*/React__default.createElement(Stack, {
    spacing: 2,
    direction: "row",
    sx: {
      mb: 1
    },
    alignItems: "center"
  }, /*#__PURE__*/React__default.createElement(VolumeDown, null), /*#__PURE__*/React__default.createElement(Slider, {
    "aria-label": "Volume",
    value: volume,
    onChange: handleChange
  }), /*#__PURE__*/React__default.createElement(VolumeUp, null))));
}

function TopBar$1() {
  return /*#__PURE__*/React__default.createElement(TopBarWrapper, null, /*#__PURE__*/React__default.createElement(ContainerWrapper, null, /*#__PURE__*/React__default.createElement(Search, null), /*#__PURE__*/React__default.createElement(LanguageSwitcher, null), /*#__PURE__*/React__default.createElement(FontSizeController, null), /*#__PURE__*/React__default.createElement(ThemeSwitcher, null), /*#__PURE__*/React__default.createElement(TopIcons, null)));
}

function NavMenu() {
  const history = useHistory();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleBtnClick = url => {
    console.log(url);
    return url ? history.push(url) : null;
  };
  return /*#__PURE__*/React__default.createElement(MenuWrapper, {
    component: "nav"
  }, /*#__PURE__*/React__default.createElement(NavContainer, null, /*#__PURE__*/React__default.createElement(NavToolbar, null, navData.map(menu => /*#__PURE__*/React__default.createElement(React__default.Fragment, {
    key: menu.label + menu.url
  }, /*#__PURE__*/React__default.createElement(MenuItem, Object.assign({}, menu.label === 'Home' && {
    color: 'warning',
    variant: 'contained',
    disableElevation: true
  }, menu.subMenu ? {
    ...(open && {
      'aria-controls': 'sub-menu'
    }),
    ...(open && {
      'aria-expanded': 'true'
    }),
    'aria-haspopup': "true",
    onClick: handleClick,
    id: 'menu-button',
    endIcon: /*#__PURE__*/React__default.createElement(ArrowDropDown, null)
  } : {
    onClick: event => {
      handleBtnClick(menu.url);
      handleClick(event);
    }
  }), menu.label), /*#__PURE__*/React__default.createElement(StyledDivider$1, {
    orientation: "vertical"
  }), menu.subMenu && /*#__PURE__*/React__default.createElement(StyledMenu, {
    id: "sub-menu",
    anchorEl: anchorEl,
    open: open,
    onClose: handleClose,
    MenuListProps: {
      'aria-labelledby': 'menu-button'
    }
  }, menu.subMenu.map(sub => /*#__PURE__*/React__default.createElement(MenuItem, {
    onClick: event => {
      handleBtnClick(sub.url);
      handleClose();
    },
    key: sub.label + sub.url
  }, sub.label))))))));
}

function MenuLinks({
  open,
  anchorEl,
  handleClose,
  handleClick
}) {
  const history = useHistory();
  const handleBtnClick = url => {
    console.log(url);
    return url ? history.push(url) : null;
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, navData.map(menu => /*#__PURE__*/React__default.createElement(React__default.Fragment, {
    key: menu.label + menu.url
  }, /*#__PURE__*/React__default.createElement(MenuItem, Object.assign({}, menu.label === 'Home' && {
    color: 'warning',
    variant: 'contained',
    disableElevation: true
  }, menu.subMenu ? {
    ...(open && {
      'aria-controls': 'sub-menu'
    }),
    ...(open && {
      'aria-expanded': 'true'
    }),
    'aria-haspopup': "true",
    onClick: event => {
      handleBtnClick(menu.url);
      handleClick(event);
    },
    id: 'menu-button',
    endIcon: /*#__PURE__*/React__default.createElement(ArrowDropDown, null)
  } : {
    onClick: () => handleBtnClick(menu.url)
  }), menu.label), /*#__PURE__*/React__default.createElement(StyledDivider$1, {
    orientation: "vertical"
  }), menu.subMenu && /*#__PURE__*/React__default.createElement(StyledMenu, {
    id: "sub-menu",
    anchorEl: anchorEl,
    open: open,
    className: "subMenu",
    onClose: handleClose,
    MenuListProps: {
      'aria-labelledby': 'menu-button'
    }
  }, menu.subMenu.map((sub, index) => /*#__PURE__*/React__default.createElement(React__default.Fragment, null, index > 0 && /*#__PURE__*/React__default.createElement(StyledDivider$1, {
    orientation: "vertical"
  }), /*#__PURE__*/React__default.createElement(MenuItem, {
    key: sub.label + sub.url,
    onClick: event => {
      handleBtnClick(sub.url);
      handleClose(event);
    }
  }, sub.label))), /*#__PURE__*/React__default.createElement(StyledDivider$1, {
    orientation: "vertical"
  })))));
}

const drawerWidth = 240;
function MobileHeader({
  window
}) {
  const [navMenuOpen, setNavMenuOpen] = useState(false);
  const [settingsMenuOpen, setSettingsMenuOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const container = window !== undefined ? () => window().document.body : undefined;
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleDrawerToggle = () => {
    setNavMenuOpen(prevState => !prevState);
  };
  const handleSettingsToggle = () => {
    setSettingsMenuOpen(prevState => !prevState);
  };
  return /*#__PURE__*/React__default.createElement(NavContainer, null, /*#__PURE__*/React__default.createElement(NavToolbar, null, /*#__PURE__*/React__default.createElement(IconButton$2, {
    color: "inherit",
    "aria-label": "open drawer",
    edge: "start",
    onClick: handleDrawerToggle
  }, /*#__PURE__*/React__default.createElement(MenuIcon, null)), /*#__PURE__*/React__default.createElement(Box$1, {
    sx: {
      display: 'flex',
      alignItems: 'center',
      gap: 2
    }
  }, /*#__PURE__*/React__default.createElement("img", {
    src: "https://i.imgur.com/jMyQPbq.png",
    style: {
      maxHeight: 40
    }
  }), /*#__PURE__*/React__default.createElement(HeaderTitle, {
    sx: {
      display: {
        sm: 'block',
        xs: 'none'
      }
    }
  }, /*#__PURE__*/React__default.createElement(Title1, {
    variant: "h6"
  }, "Government of Uttar Pradesh"), /*#__PURE__*/React__default.createElement(Title2, {
    variant: "h5"
  }, "Department of Urban Development"))), /*#__PURE__*/React__default.createElement(IconButton$2, {
    color: "inherit",
    "aria-label": "open settings",
    edge: "end",
    onClick: handleSettingsToggle
  }, /*#__PURE__*/React__default.createElement(SettingsIcon, null)), /*#__PURE__*/React__default.createElement(StyledDrawer, {
    open: navMenuOpen,
    variant: "temporary",
    container: container,
    onClose: handleDrawerToggle,
    ModalProps: {
      keepMounted: true
    },
    sx: {
      '& .MuiDrawer-paper': {
        width: drawerWidth
      }
    }
  }, /*#__PURE__*/React__default.createElement(MenuLinks, {
    open: open,
    anchorEl: anchorEl,
    handleClose: handleClose,
    handleClick: handleClick
  })), /*#__PURE__*/React__default.createElement(StyledDrawer, {
    anchor: "right",
    variant: "temporary",
    container: container,
    open: settingsMenuOpen,
    onClose: handleSettingsToggle,
    ModalProps: {
      keepMounted: true
    },
    sx: {
      '& .MuiDrawer-paper': {
        width: drawerWidth
      }
    }
  }, /*#__PURE__*/React__default.createElement(TopBar$1, null))));
}

function Header$1() {
  const isDesktop = useMediaQuery(theme => theme.breakpoints.up('lg'));
  if (isDesktop) {
    return /*#__PURE__*/React__default.createElement(HeaderWrapper, null, /*#__PURE__*/React__default.createElement(TopBar$1, null), /*#__PURE__*/React__default.createElement(HeaderContainer, null, /*#__PURE__*/React__default.createElement("img", {
      src: "https://upload.wikimedia.org/wikipedia/commons/f/fa/Seal_of_Uttar_Pradesh.svg",
      width: 100,
      height: 100
    }), /*#__PURE__*/React__default.createElement(HeaderTitle, null, /*#__PURE__*/React__default.createElement(Title1, {
      variant: "h5"
    }, "Government of Uttar Pradesh"), /*#__PURE__*/React__default.createElement(Title2, {
      variant: "h4"
    }, "Department of Development Authority")), /*#__PURE__*/React__default.createElement("img", {
      src: "https://upload.wikimedia.org/wikipedia/commons/f/fa/Seal_of_Uttar_Pradesh.svg",
      width: 100,
      height: 100
    })), /*#__PURE__*/React__default.createElement(NavMenu, null));
  }
  return /*#__PURE__*/React__default.createElement(MobileHeader, null);
}

function Hero() {
  const [currentSlide, setCurrentSlide] = useState(0);
  useEffect(() => {
    let timer = setInterval(() => {
      setCurrentSlide(curr => curr + 1 < bannerImgUrls.length ? curr + 1 : 0);
    }, 4000);
    return () => clearInterval(timer);
  }, []);
  return /*#__PURE__*/React__default.createElement(HeroWrapper, {
    bgimg: bannerImgUrls[currentSlide]
  }, /*#__PURE__*/React__default.createElement(HeroTopLeftMessage, null, "Urban planning is the art of shaping Civilisation."), /*#__PURE__*/React__default.createElement(HeroMantriStrip, null, /*#__PURE__*/React__default.createElement(Grid$1, {
    container: true,
    spacing: 2
  }, bannerCmStripData.map(({
    photo,
    name,
    designation
  }) => /*#__PURE__*/React__default.createElement(PersonCard, {
    item: true,
    key: name,
    xs: 12,
    md: 6,
    lg: 12 / bannerCmStripData.length
  }, /*#__PURE__*/React__default.createElement(PersonPic, null, /*#__PURE__*/React__default.createElement("img", {
    src: photo,
    alt: name
  })), /*#__PURE__*/React__default.createElement(PersonDesc, null, /*#__PURE__*/React__default.createElement("strong", null, name), designation))))));
}

function BPADocumentsPreview({
  documents,
  svgStyles = {},
  isSendBackFlow = false,
  isHrLine = false,
  titleStyles
}) {
  const {
    t
  } = useTranslation();
  return (
    /*#__PURE__*/
    React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
      className: "row",
      style: {
        marginLeft: "2%"
      }
    }, documents === null || documents === void 0 ? void 0 : documents.map((document, index) => {
      var _document$values;
      return /*#__PURE__*/React__default.createElement("div", {
        className: "col-4",
        key: document.id || index
      }, document !== null && document !== void 0 && document.values && (document === null || document === void 0 ? void 0 : document.values.length) > 0 ? document === null || document === void 0 ? void 0 : (_document$values = document.values) === null || _document$values === void 0 ? void 0 : _document$values.map((value, index) => {
        var _value$additionalDeta;
        return /*#__PURE__*/React__default.createElement("div", {
          key: (value === null || value === void 0 ? void 0 : value.documentType) || index,
          style: {
            display: "flex",
            marginTop: "10px"
          }
        }, /*#__PURE__*/React__default.createElement("a", {
          target: "_",
          href: value === null || value === void 0 ? void 0 : value.url,
          style: {
            minWidth: "80px",
            height: "auto",
            minWidth: "30px"
          }
        }, /*#__PURE__*/React__default.createElement("p", null, /*#__PURE__*/React__default.createElement(FaFilePdf, {
          color: "#a10505",
          style: {
            width: '20px',
            height: '30px'
          }
        }))), /*#__PURE__*/React__default.createElement("p", {
          style: {
            margin: '2px 0'
          }
        }, t(value === null || value === void 0 ? void 0 : (_value$additionalDeta = value.additionalDetails) === null || _value$additionalDeta === void 0 ? void 0 : _value$additionalDeta.title)));
      }) : !window.location.href.includes("citizen") && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("p", null, t("BPA_NO_DOCUMENTS_UPLOADED_LABEL"))));
    })))
  );
}

const useStyles$8 = makeStyles({
  table: {
    minWidth: 650
  }
});
const BPACheckListPreview = ({
  certificate,
  nocFromHPSEBcertificate,
  whetherNearbyAsiMonument_noccertificate,
  whetherNearbyHfl_noccertificate,
  nocFromNHAIcertificate,
  whetherSeweragePassingThrough_noccertificate,
  whetherSlidingArea_doc,
  photo,
  whetherAirportPermissionRequired_noc,
  formData
}) => {
  var _formData$regulatedse, _formData$setBacks, _formData$regulatedse2, _formData$setBacks2, _formData$regulatedse3, _formData$setBacks3, _formData$regulatedse4, _formData$setBacks4, _formData$nhregulated, _formData$nhsetBacks, _formData$nhregulated2, _formData$nhsetBacks2, _formData$nhregulated3, _formData$nhsetBacks3, _formData$nhregulated4, _formData$nhsetBacks4, _nocFromHPSEBcertific, _nocFromHPSEBcertific2, _whetherNearbyAsiMonu, _whetherNearbyAsiMonu2, _whetherNearbyHfl_noc, _whetherNearbyHfl_noc2, _nocFromNHAIcertifica, _nocFromNHAIcertifica2, _whetherSeweragePassi, _nwhetherSeweragePass, _nwhetherSeweragePass2, _whetherSlidingArea_d, _whetherSlidingArea_d2, _certificate$, _certificate$2, _photo$, _photo$2, _whetherAirportPermis, _whetherAirportPermis2;
  const classes = useStyles$8();
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement(Table$1, {
    striped: true,
    bordered: true,
    className: "m-0"
  }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
    style: {
      minWidth: 'fit-content'
    }
  }, "SI#"), /*#__PURE__*/React__default.createElement("th", null, "Description"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      minWidth: 'fit-content'
    }
  }, "As per Regulations"), /*#__PURE__*/React__default.createElement("th", null, "As proposed"), /*#__PURE__*/React__default.createElement("th", null, "Remarks"), /*#__PURE__*/React__default.createElement("th", null, "Relaxation"))), /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "1"), /*#__PURE__*/React__default.createElement("td", null, "Type of Area"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("h6", null, "Core"), /*#__PURE__*/React__default.createElement("h6", null, "NOn Core"), /*#__PURE__*/React__default.createElement("h6", null, "Restricted"), /*#__PURE__*/React__default.createElement("h6", null, "Green"), /*#__PURE__*/React__default.createElement("h6", null, "Heritage"), /*#__PURE__*/React__default.createElement("h6", null, "Sinking"), /*#__PURE__*/React__default.createElement("h6", null, "Sliding"), /*#__PURE__*/React__default.createElement("h6", null, "Other")), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.typeOfArea), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.typeOfArea_remarks), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.typeOfArea_relaxation)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "2"), /*#__PURE__*/React__default.createElement("td", null, "Plot Area For Sub-division/Development Activity (in sq.mt.)"), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.plotAreaForSubdivision_regulated), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.plotAreaForSubdivision), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.plotAreaForSubdivision_remarks), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.plotAreaForSubdivision_relaxation)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "3"), /*#__PURE__*/React__default.createElement("td", null, "Ownership & Revenue documents"), /*#__PURE__*/React__default.createElement("td", null, "Required"), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.ownershipRevenueDocuments), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.ownershipRevenueDocuments_remarks), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.ownershipRevenueDocuments_relaxation))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "4"), /*#__PURE__*/React__default.createElement("td", null, "Land-use *"), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.regulatedLandUse), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.landUse), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.landUse_remarks), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.landUse_relaxation)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "5"), /*#__PURE__*/React__default.createElement("td", null, "F.A.R."), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.regulatedFAR), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.far), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.far_remarks), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.far_relaxation)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "6"), /*#__PURE__*/React__default.createElement("td", null, "Built up area (in sq.mt.)"), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.regulatedBuildUpArea), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.builtupArea), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.builtupArea_remarks), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.builtupArea_relaxation)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    rowSpan: 5,
    style: {
      verticalAlign: 'top'
    }
  }, "7"), /*#__PURE__*/React__default.createElement("td", null, "Setbacks(meter)"), /*#__PURE__*/React__default.createElement("td", null, "\xA0"), /*#__PURE__*/React__default.createElement("td", null, "\xA0"), /*#__PURE__*/React__default.createElement("td", null, "\xA0"), /*#__PURE__*/React__default.createElement("td", null, "\xA0")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Front"), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : (_formData$regulatedse = formData.regulatedsetBacks) === null || _formData$regulatedse === void 0 ? void 0 : _formData$regulatedse.front), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : (_formData$setBacks = formData.setBacks) === null || _formData$setBacks === void 0 ? void 0 : _formData$setBacks.front), /*#__PURE__*/React__default.createElement("td", {
    rowSpan: 4,
    style: {
      verticalAlign: 'top'
    }
  }, formData === null || formData === void 0 ? void 0 : formData.setBacks_remarks), /*#__PURE__*/React__default.createElement("td", {
    rowSpan: 4,
    style: {
      verticalAlign: 'top'
    }
  }, formData === null || formData === void 0 ? void 0 : formData.setBacks_relaxation)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Rear"), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : (_formData$regulatedse2 = formData.regulatedsetBacks) === null || _formData$regulatedse2 === void 0 ? void 0 : _formData$regulatedse2.rear), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : (_formData$setBacks2 = formData.setBacks) === null || _formData$setBacks2 === void 0 ? void 0 : _formData$setBacks2.rear)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Left Side"), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : (_formData$regulatedse3 = formData.regulatedsetBacks) === null || _formData$regulatedse3 === void 0 ? void 0 : _formData$regulatedse3.left), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : (_formData$setBacks3 = formData.setBacks) === null || _formData$setBacks3 === void 0 ? void 0 : _formData$setBacks3.left)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Right Side"), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : (_formData$regulatedse4 = formData.regulatedsetBacks) === null || _formData$regulatedse4 === void 0 ? void 0 : _formData$regulatedse4.right), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : (_formData$setBacks4 = formData.setBacks) === null || _formData$setBacks4 === void 0 ? void 0 : _formData$setBacks4.right)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    rowSpan: 5,
    style: {
      verticalAlign: 'top'
    }
  }), /*#__PURE__*/React__default.createElement("td", null, "Whether Construction abuts with N.H Set Backs (Meter)"), /*#__PURE__*/React__default.createElement("td", null, "\xA0"), /*#__PURE__*/React__default.createElement("td", null, "\xA0"), /*#__PURE__*/React__default.createElement("td", null, "\xA0"), /*#__PURE__*/React__default.createElement("td", null, "\xA0")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Front"), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : (_formData$nhregulated = formData.nhregulatedsetBacks) === null || _formData$nhregulated === void 0 ? void 0 : _formData$nhregulated.front), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : (_formData$nhsetBacks = formData.nhsetBacks) === null || _formData$nhsetBacks === void 0 ? void 0 : _formData$nhsetBacks.front), /*#__PURE__*/React__default.createElement("td", {
    rowSpan: 4,
    style: {
      verticalAlign: 'top'
    }
  }, formData === null || formData === void 0 ? void 0 : formData.nhsetBacks_remarks), /*#__PURE__*/React__default.createElement("td", {
    rowSpan: 4,
    style: {
      verticalAlign: 'top'
    }
  }, /*#__PURE__*/React__default.createElement("td", {
    rowSpan: 4,
    style: {
      verticalAlign: 'top'
    }
  }, formData === null || formData === void 0 ? void 0 : formData.nhsetBacks_relaxation))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Rear"), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : (_formData$nhregulated2 = formData.nhregulatedsetBacks) === null || _formData$nhregulated2 === void 0 ? void 0 : _formData$nhregulated2.rear), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : (_formData$nhsetBacks2 = formData.nhsetBacks) === null || _formData$nhsetBacks2 === void 0 ? void 0 : _formData$nhsetBacks2.rear)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Left Side"), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : (_formData$nhregulated3 = formData.nhregulatedsetBacks) === null || _formData$nhregulated3 === void 0 ? void 0 : _formData$nhregulated3.left), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : (_formData$nhsetBacks3 = formData.nhsetBacks) === null || _formData$nhsetBacks3 === void 0 ? void 0 : _formData$nhsetBacks3.left)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Right Side"), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : (_formData$nhregulated4 = formData.nhregulatedsetBacks) === null || _formData$nhregulated4 === void 0 ? void 0 : _formData$nhregulated4.right), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : (_formData$nhsetBacks4 = formData.nhsetBacks) === null || _formData$nhsetBacks4 === void 0 ? void 0 : _formData$nhsetBacks4.right)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "8"), /*#__PURE__*/React__default.createElement("td", null, "Number of storey's"), /*#__PURE__*/React__default.createElement("td", null, "Strictly Upto FAR and Upto the Height of 21 meter"), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.numberOfStoreys), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.numberOfStoreys_remarks), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.numberOfStoreys_relaxation)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    rowSpan: 3,
    style: {
      verticalAlign: 'top'
    }
  }, "9"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("strong", null, "Road/path existing at site")), /*#__PURE__*/React__default.createElement("td", null, "\xA0"), /*#__PURE__*/React__default.createElement("td", null, "\xA0"), /*#__PURE__*/React__default.createElement("td", {
    rowSpan: 3,
    style: {
      verticalAlign: 'top'
    }
  }, formData === null || formData === void 0 ? void 0 : formData.roadPathExisting_remarks), /*#__PURE__*/React__default.createElement("td", {
    rowSpan: 3
  }, formData === null || formData === void 0 ? void 0 : formData.roadPathExisting_relaxation)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Existing at site"), /*#__PURE__*/React__default.createElement("td", null, "3 meter (Minimum)"), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.existingAtSite)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Shown in Tatima"), /*#__PURE__*/React__default.createElement("td", null, "Required"), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.shownInTatima)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "10"), /*#__PURE__*/React__default.createElement("td", null, "Parking provision"), /*#__PURE__*/React__default.createElement("td", null, "Mandatory If Feasible"), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.parkingProvision), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.parkingProvision_remarks), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.parkingProvision_relaxation)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "11"), /*#__PURE__*/React__default.createElement("td", null, "Whether any HT/LT Line, crossing over the proposed land", /*#__PURE__*/React__default.createElement("br", null)), /*#__PURE__*/React__default.createElement("td", null, (formData === null || formData === void 0 ? void 0 : formData.whetherHtLtLineCrossing) == 'yes' && '(Upload NOC from HPSEB)', (formData === null || formData === void 0 ? void 0 : formData.whetherHtLtLineCrossing) === "no" && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, formData === null || formData === void 0 ? void 0 : formData.whetherHtLtLineCrossing)), /*#__PURE__*/React__default.createElement("td", null, (formData === null || formData === void 0 ? void 0 : formData.whetherHtLtLineCrossing) == 'yes' && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, (nocFromHPSEBcertificate === null || nocFromHPSEBcertificate === void 0 ? void 0 : (_nocFromHPSEBcertific = nocFromHPSEBcertificate[0]) === null || _nocFromHPSEBcertific === void 0 ? void 0 : _nocFromHPSEBcertific.url) && /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("p", null, " ", /*#__PURE__*/React__default.createElement("a", {
    target: "_",
    href: nocFromHPSEBcertificate === null || nocFromHPSEBcertificate === void 0 ? void 0 : (_nocFromHPSEBcertific2 = nocFromHPSEBcertificate[0]) === null || _nocFromHPSEBcertific2 === void 0 ? void 0 : _nocFromHPSEBcertific2.url,
    style: {
      minWidth: "80px",
      height: "auto",
      minWidth: "30px"
    }
  }, /*#__PURE__*/React__default.createElement("p", null, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: '20px',
      height: '30px'
    }
  })))))), (formData === null || formData === void 0 ? void 0 : formData.whetherHtLtLineCrossing) === "no" && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, formData === null || formData === void 0 ? void 0 : formData.whetherHtLtLineCrossing)), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.nocFromHPSEB_remarks), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.nocFromHPSEB_relaxation)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "12"), /*#__PURE__*/React__default.createElement("td", null, "Whether proposed site is located nearby ASI Protected monument", /*#__PURE__*/React__default.createElement("br", null)), /*#__PURE__*/React__default.createElement("td", null, (formData === null || formData === void 0 ? void 0 : formData.whetherNearbyAsiMonument) === "no" && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, formData === null || formData === void 0 ? void 0 : formData.whetherNearbyAsiMonument), (formData === null || formData === void 0 ? void 0 : formData.whetherNearbyAsiMonument) === 'yes' && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, "(Download NOC from the competent authority)", /*#__PURE__*/React__default.createElement("br", null), "Click here (https://nmanoc.nic.in/home/register)", /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("strong", null, "to apply for NOC from NMA"), " ", /*#__PURE__*/React__default.createElement(HelpIcon, {
    size: "small",
    color: "info"
  }))), /*#__PURE__*/React__default.createElement("td", null, (formData === null || formData === void 0 ? void 0 : formData.whetherNearbyAsiMonument) == 'yes' && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, (whetherNearbyAsiMonument_noccertificate === null || whetherNearbyAsiMonument_noccertificate === void 0 ? void 0 : (_whetherNearbyAsiMonu = whetherNearbyAsiMonument_noccertificate[0]) === null || _whetherNearbyAsiMonu === void 0 ? void 0 : _whetherNearbyAsiMonu.url) && /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("p", null, " ", /*#__PURE__*/React__default.createElement("a", {
    target: "_",
    href: whetherNearbyAsiMonument_noccertificate === null || whetherNearbyAsiMonument_noccertificate === void 0 ? void 0 : (_whetherNearbyAsiMonu2 = whetherNearbyAsiMonument_noccertificate[0]) === null || _whetherNearbyAsiMonu2 === void 0 ? void 0 : _whetherNearbyAsiMonu2.url,
    style: {
      minWidth: "80px",
      height: "auto",
      minWidth: "30px"
    }
  }, /*#__PURE__*/React__default.createElement("p", null, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: '20px',
      height: '30px'
    }
  })))))), (formData === null || formData === void 0 ? void 0 : formData.whetherNearbyAsiMonument) === "no" && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, formData === null || formData === void 0 ? void 0 : formData.whetherNearbyAsiMonument)), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.whetherNearbyAsiMonument_remarks), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.whetherNearbyAsiMonument_relaxation)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "13"), /*#__PURE__*/React__default.createElement("td", null, "Whether proposed Plan is located nearby HFL", /*#__PURE__*/React__default.createElement("br", null)), /*#__PURE__*/React__default.createElement("td", null, (formData === null || formData === void 0 ? void 0 : formData.whetherNearbyHfl) === 'yes' && '(Download NOC from the competent authority)', (formData === null || formData === void 0 ? void 0 : formData.whetherNearbyHfl) === "no" && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, formData === null || formData === void 0 ? void 0 : formData.whetherNearbyHfl)), /*#__PURE__*/React__default.createElement("td", null, (formData === null || formData === void 0 ? void 0 : formData.whetherNearbyHfl) === 'yes' && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, (whetherNearbyHfl_noccertificate === null || whetherNearbyHfl_noccertificate === void 0 ? void 0 : (_whetherNearbyHfl_noc = whetherNearbyHfl_noccertificate[0]) === null || _whetherNearbyHfl_noc === void 0 ? void 0 : _whetherNearbyHfl_noc.url) && /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("p", null, " ", /*#__PURE__*/React__default.createElement("a", {
    target: "_",
    href: whetherNearbyHfl_noccertificate === null || whetherNearbyHfl_noccertificate === void 0 ? void 0 : (_whetherNearbyHfl_noc2 = whetherNearbyHfl_noccertificate[0]) === null || _whetherNearbyHfl_noc2 === void 0 ? void 0 : _whetherNearbyHfl_noc2.url,
    style: {
      minWidth: "80px",
      height: "auto",
      minWidth: "30px"
    }
  }, /*#__PURE__*/React__default.createElement("p", null, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: '20px',
      height: '30px'
    }
  })))))), (formData === null || formData === void 0 ? void 0 : formData.whetherNearbyHfl) === "no" && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, formData === null || formData === void 0 ? void 0 : formData.whetherNearbyHfl)), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.whetherNearbyHflc_remarks), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.whetherNearbyHflc_relaxation)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      verticalAlign: 'top'
    }
  }, "14"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("strong", null, "Whether trees are standing on plot"), /*#__PURE__*/React__default.createElement("br", null)), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.whetherTreesOnPlot), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.whetherTreesOnPlot), /*#__PURE__*/React__default.createElement("td", null), /*#__PURE__*/React__default.createElement("td", null, " ", formData === null || formData === void 0 ? void 0 : formData.whetherTreesOnPlot_relaxation, " ")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null), /*#__PURE__*/React__default.createElement("td", null, "Whether plot is Abutting to Forest Boundary", /*#__PURE__*/React__default.createElement("br", null), "Distance from Forest Boundary (Meter)"), /*#__PURE__*/React__default.createElement("td", null), /*#__PURE__*/React__default.createElement("td", null), /*#__PURE__*/React__default.createElement("td", null, " "), /*#__PURE__*/React__default.createElement("td", null)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "15"), /*#__PURE__*/React__default.createElement("td", null, "Whether plot is Directly abutting with National Highway/State Highway/Bye-pass/Other H.P. Public Department Schedule road"), /*#__PURE__*/React__default.createElement("td", null, (formData === null || formData === void 0 ? void 0 : formData.whetherAbuttingHighway) === 'yes' && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, "(Download NOC from the competent authority along with Site plan)", /*#__PURE__*/React__default.createElement("br", null), "Click here (https://morthnoc.nic.in) ", /*#__PURE__*/React__default.createElement("strong", null, "to apply for NOC from NHAI"), " ", /*#__PURE__*/React__default.createElement(HelpIcon, {
    size: "small",
    color: "info"
  })), (formData === null || formData === void 0 ? void 0 : formData.whetherAbuttingHighway) === "no" && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, formData === null || formData === void 0 ? void 0 : formData.whetherAbuttingHighway)), /*#__PURE__*/React__default.createElement("td", null, (formData === null || formData === void 0 ? void 0 : formData.whetherAbuttingHighway) === 'yes' && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, (nocFromNHAIcertificate === null || nocFromNHAIcertificate === void 0 ? void 0 : (_nocFromNHAIcertifica = nocFromNHAIcertificate[0]) === null || _nocFromNHAIcertifica === void 0 ? void 0 : _nocFromNHAIcertifica.url) && /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("p", null, " ", /*#__PURE__*/React__default.createElement("a", {
    target: "_",
    href: nocFromNHAIcertificate === null || nocFromNHAIcertificate === void 0 ? void 0 : (_nocFromNHAIcertifica2 = nocFromNHAIcertificate[0]) === null || _nocFromNHAIcertifica2 === void 0 ? void 0 : _nocFromNHAIcertifica2.url,
    style: {
      minWidth: "80px",
      height: "auto",
      minWidth: "30px"
    }
  }, /*#__PURE__*/React__default.createElement("p", null, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: '20px',
      height: '30px'
    }
  })))))), (formData === null || formData === void 0 ? void 0 : formData.whetherAbuttingHighway) === "no" && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, formData === null || formData === void 0 ? void 0 : formData.whetherAbuttingHighway)), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.whetherAbuttingHighway_remarks), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.whetherAbuttingHighway_relaxation)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      verticalAlign: 'top'
    }
  }, "16"), /*#__PURE__*/React__default.createElement("td", null, "Whether proposed plot is abutting to natural drainage", /*#__PURE__*/React__default.createElement("br", null)), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.whetherAbuttingNaturalDrainage), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.whetherAbuttingNaturalDrainage), /*#__PURE__*/React__default.createElement("td", null), /*#__PURE__*/React__default.createElement("td", null)), (formData === null || formData === void 0 ? void 0 : formData.whetherAbuttingNaturalDrainage) === 'yes' && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null), /*#__PURE__*/React__default.createElement("td", null, "Distance from Nullah (Meter)"), /*#__PURE__*/React__default.createElement("td", null, "\xA0"), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.distanceFromNullah)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null), /*#__PURE__*/React__default.createElement("td", null, "Distance from Khud/HFL of River (Meter)"), /*#__PURE__*/React__default.createElement("td", null, "\xA0"), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.distanceFromKhudHfl))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "17"), /*#__PURE__*/React__default.createElement("td", null, "Whether any Pipeline/Sewerage line crossing or passing through the plot", /*#__PURE__*/React__default.createElement("br", null)), /*#__PURE__*/React__default.createElement("td", null, (formData === null || formData === void 0 ? void 0 : formData.whetherSeweragePassingThrough) === 'yes' && '(Upload NOC from the competent authority)', " ", (formData === null || formData === void 0 ? void 0 : formData.whetherSeweragePassingThrough) === "no" && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, formData === null || formData === void 0 ? void 0 : formData.whetherSeweragePassingThrough)), /*#__PURE__*/React__default.createElement("td", null, (formData === null || formData === void 0 ? void 0 : formData.whetherSeweragePassingThrough) === 'yes' && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, (whetherSeweragePassingThrough_noccertificate === null || whetherSeweragePassingThrough_noccertificate === void 0 ? void 0 : (_whetherSeweragePassi = whetherSeweragePassingThrough_noccertificate[0]) === null || _whetherSeweragePassi === void 0 ? void 0 : _whetherSeweragePassi.url) && /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("p", null, " ", /*#__PURE__*/React__default.createElement("a", {
    target: "_",
    href: (_nwhetherSeweragePass = nwhetherSeweragePassingThrough_noccertificate) === null || _nwhetherSeweragePass === void 0 ? void 0 : (_nwhetherSeweragePass2 = _nwhetherSeweragePass[0]) === null || _nwhetherSeweragePass2 === void 0 ? void 0 : _nwhetherSeweragePass2.url,
    style: {
      minWidth: "80px",
      height: "auto",
      minWidth: "30px"
    }
  }, /*#__PURE__*/React__default.createElement("p", null, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: '20px',
      height: '30px'
    }
  })))))), (formData === null || formData === void 0 ? void 0 : formData.whetherSeweragePassingThrough) === "no" && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, formData === null || formData === void 0 ? void 0 : formData.whetherSeweragePassingThrough)), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.whetherSeweragePassingThrough_remarks), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.whetherSeweragePassingThrough_relaxation)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "18"), /*#__PURE__*/React__default.createElement("td", null, "Provision of Solar Passive Building"), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.regulatedprovisionOfSolar), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.provisionOfSolar), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.provisionOfSolar_remarks), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.provisionOfSolar_relaxation)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "19"), /*#__PURE__*/React__default.createElement("td", null, "Provision of barrier free access for persons with disability"), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.regulatedprovisionForDisabiled), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.provisionForDisabiled), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.provisionForDisabiled_remarks), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.provisionForDisabiled_relaxation)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "20"), /*#__PURE__*/React__default.createElement("td", null, "Whether the Proposed Plan is above the road level on Valley Side."), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.whetherAboveRoadLevel), /*#__PURE__*/React__default.createElement("td", null, (formData === null || formData === void 0 ? void 0 : formData.whetherAboveRoadLevel) === 'yes' && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, formData === null || formData === void 0 ? void 0 : formData.whetherAboveRoadLevel_view), (formData === null || formData === void 0 ? void 0 : formData.whetherAboveRoadLevel) === 'no' && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, formData === null || formData === void 0 ? void 0 : formData.whetherAboveRoadLevel)), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.whetherAboveRoadLevel_remarks), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.whetherAboveRoadLevel_relaxation)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "21"), /*#__PURE__*/React__default.createElement("td", null, "Whether proposed Plan is located in Sinking and Sliding area"), /*#__PURE__*/React__default.createElement("td", null, " ", formData === null || formData === void 0 ? void 0 : formData.whetherSlidingArea), /*#__PURE__*/React__default.createElement("td", null, (formData === null || formData === void 0 ? void 0 : formData.whetherSlidingArea) === 'yes' && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, (whetherSlidingArea_doc === null || whetherSlidingArea_doc === void 0 ? void 0 : (_whetherSlidingArea_d = whetherSlidingArea_doc[0]) === null || _whetherSlidingArea_d === void 0 ? void 0 : _whetherSlidingArea_d.url) && /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("p", null, " ", /*#__PURE__*/React__default.createElement("a", {
    target: "_",
    href: whetherSlidingArea_doc === null || whetherSlidingArea_doc === void 0 ? void 0 : (_whetherSlidingArea_d2 = whetherSlidingArea_doc[0]) === null || _whetherSlidingArea_d2 === void 0 ? void 0 : _whetherSlidingArea_d2.url,
    style: {
      minWidth: "80px",
      height: "auto",
      minWidth: "30px"
    }
  }, /*#__PURE__*/React__default.createElement("p", null, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: '20px',
      height: '30px'
    }
  })))))), (formData === null || formData === void 0 ? void 0 : formData.whetherSlidingArea) === "no" && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, formData === null || formData === void 0 ? void 0 : formData.whetherSlidingArea)), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.whetherSlidingArea_remarks), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.whetherSlidingArea_relaxation)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "22"), /*#__PURE__*/React__default.createElement("td", null, "Rain water harvesting tank provision"), /*#__PURE__*/React__default.createElement("td", null, "Required @20 ltr per roof top area"), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.provisionRainWaterHarvesting), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.provisionRainWaterHarvesting_remarks), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.provisionRainWaterHarvesting_relaxation)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "23"), /*#__PURE__*/React__default.createElement("td", null, "Structural Stability Certificate"), /*#__PURE__*/React__default.createElement("td", null, "Stability Certificate "), /*#__PURE__*/React__default.createElement("td", null, (certificate === null || certificate === void 0 ? void 0 : (_certificate$ = certificate[0]) === null || _certificate$ === void 0 ? void 0 : _certificate$.url) && /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("p", null, " ", /*#__PURE__*/React__default.createElement("a", {
    target: "_",
    href: certificate === null || certificate === void 0 ? void 0 : (_certificate$2 = certificate[0]) === null || _certificate$2 === void 0 ? void 0 : _certificate$2.url,
    style: {
      minWidth: "80px",
      height: "auto",
      minWidth: "30px"
    }
  }, /*#__PURE__*/React__default.createElement("p", null, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: '20px',
      height: '30px'
    }
  })))))), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.structuralStabilityCertificate_remarks), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.structuralStabilityCertificate_relaxation)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "24"), /*#__PURE__*/React__default.createElement("td", null, "Number of Dwelling Units"), /*#__PURE__*/React__default.createElement("td", null, "8 Minimum if not for sale Otherwise 8 Maximum"), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.numberOfDwellingUnits), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.numberOfDwellingUnits_remarks), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.numberOfDwellingUnits_relaxation)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    rowSpan: 2,
    style: {
      verticalAlign: 'top'
    }
  }, "25"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("strong", null, "Risk based Classification of building")), /*#__PURE__*/React__default.createElement("td", null, "\xA0"), /*#__PURE__*/React__default.createElement("td", null, "\xA0"), /*#__PURE__*/React__default.createElement("td", null, "\xA0"), /*#__PURE__*/React__default.createElement("td", null, "\xA0")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Whether building with communication tower"), /*#__PURE__*/React__default.createElement("td", null, " ", formData === null || formData === void 0 ? void 0 : formData.whetherCommunicationTower), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.whetherCommunicationTower), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.whetherCommunicationTower_relaxation), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.whetherCommunicationTower_relaxation)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "\xA0"), /*#__PURE__*/React__default.createElement("td", null, "Whether proposal is for Group Housing Scheme"), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.whetherGroupHousing), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.whetherGroupHousing), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.whetherGroupHousing_remarks), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.whetherGroupHousing_relaxation)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "\xA0"), /*#__PURE__*/React__default.createElement("td", null, "Whether building raised on land fill"), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.whetherBuildingLandFill), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.whetherBuildingLandFill), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.whetherBuildingLandFill_remarks), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.whetherBuildingLandFill_relaxation)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "\xA0"), /*#__PURE__*/React__default.createElement("td", null, "Whether building raised on reclaimed land"), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.whetherRaisedReclaimed), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.whetherRaisedReclaimed), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.whetherRaisedReclaimed_remarks), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.whetherRaisedReclaimed_relaxation)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    rowSpan: 12,
    style: {
      verticalAlign: 'top'
    }
  }, "26"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("strong", null, "General requirements")), /*#__PURE__*/React__default.createElement("td", null, "\xA0"), /*#__PURE__*/React__default.createElement("td", null, "\xA0"), /*#__PURE__*/React__default.createElement("td", null, "\xA0"), /*#__PURE__*/React__default.createElement("td", null, "\xA0")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Slope of land(Degree)"), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.regulatedslopeOfLandDegree), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.slopeOfLandDegree), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.slopeOfLandDegree_remarks), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.slopeOfLandDegree_relaxation)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Height of parking floor(Meter)"), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.regulatedheightOfParkingFloor), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.heightOfParkingFloor), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.heightOfParkingFloor_remarks), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.heightOfParkingFloor_relaxation)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Height of slopping roof(Meter)"), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.regulatedheightOfSloppingRoof), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.heightOfSloppingRoof), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.heightOfSloppingRoof_remarks), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.heightOfSloppingRoof_relaxation)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Height of floor(Meter)"), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.regulatedheightOfFloor), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.heightOfFloor), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.heightOfFloor_remarks), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.heightOfFloor_relaxation)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Height of building(Meter)"), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.regulatedheightOfBuilding), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.heightOfBuilding), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.heightOfBuilding_remarks), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.heightOfBuilding_relaxation)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Maximum hill cut(Meter)"), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.regulatedmaxHillCut), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.maxHillCut), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.maxHillCut_remarks), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.maxHillCut_relaxation)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Distance between two blocks(Meter)"), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.regulateddistanceBetween2Blocks), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.distanceBetween2Blocks), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.distanceBetween2Blocks_remarks), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.distanceBetween2Blocks_relaxation)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Plinth height(Meter)"), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.regulatedplinthHeight), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.plinthHeight), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.plinthHeight_remarks), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.plinthHeight_relaxation)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Height of Service floor(Meter)"), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.regulatedheightOfServiceFloor), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.heightOfServiceFloor), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.heightOfServiceFloor_remarks), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.heightOfServiceFloor_relaxation)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Equivalent car Space"), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.regulatedequivalentCarSpace), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.equivalentCarSpace), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.equivalentCarSpace_remarks), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.equivalentCarSpace_relaxation)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Buildable width"), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.regulatedbuildableWidth), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.buildableWidth), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.buildableWidth_remarks), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.buildableWidth_relaxation)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "27"), /*#__PURE__*/React__default.createElement("td", null, "Photograph's of site"), /*#__PURE__*/React__default.createElement("td", null, "Photograph Doc"), /*#__PURE__*/React__default.createElement("td", null, (photo === null || photo === void 0 ? void 0 : (_photo$ = photo[0]) === null || _photo$ === void 0 ? void 0 : _photo$.url) && /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("p", null, " ", /*#__PURE__*/React__default.createElement("a", {
    target: "_",
    href: photo === null || photo === void 0 ? void 0 : (_photo$2 = photo[0]) === null || _photo$2 === void 0 ? void 0 : _photo$2.url,
    style: {
      minWidth: "80px",
      height: "auto",
      minWidth: "30px"
    }
  }, /*#__PURE__*/React__default.createElement("p", null, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: '20px',
      height: '30px'
    }
  })))))), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.PhotographsOfSite_remarks), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.PhotographsOfSite_relaxation)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "28"), /*#__PURE__*/React__default.createElement("td", null, "Any other information"), /*#__PURE__*/React__default.createElement("td", null, " ", formData === null || formData === void 0 ? void 0 : formData.anyOtherInformation), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.anyOtherInformation), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.anyOtherInformation_remarks), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.anyOtherInformation_relaxation)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "29"), /*#__PURE__*/React__default.createElement("td", null, "Whether the permission from Airport Authority of India is Required?"), /*#__PURE__*/React__default.createElement("td", null, (formData === null || formData === void 0 ? void 0 : formData.whetherAirportPermissionRequired) === 'yes' && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, "(Upload NOC from the competent authority along with Site plan)", /*#__PURE__*/React__default.createElement("br", null), "Click here (https://nocas2.aai.aero/nocas/Registration.html)", /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("strong", null, "To apply for NOC from AAI"), " ", /*#__PURE__*/React__default.createElement(HelpIcon, {
    size: "small",
    color: "info"
  }))), /*#__PURE__*/React__default.createElement("td", null, (formData === null || formData === void 0 ? void 0 : formData.whetherAirportPermissionRequired) === 'yes' && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, (whetherAirportPermissionRequired_noc === null || whetherAirportPermissionRequired_noc === void 0 ? void 0 : (_whetherAirportPermis = whetherAirportPermissionRequired_noc[0]) === null || _whetherAirportPermis === void 0 ? void 0 : _whetherAirportPermis.url) && /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("p", null, " ", /*#__PURE__*/React__default.createElement("a", {
    target: "_",
    href: whetherAirportPermissionRequired_noc === null || whetherAirportPermissionRequired_noc === void 0 ? void 0 : (_whetherAirportPermis2 = whetherAirportPermissionRequired_noc[0]) === null || _whetherAirportPermis2 === void 0 ? void 0 : _whetherAirportPermis2.url,
    style: {
      minWidth: "80px",
      height: "auto",
      minWidth: "30px"
    }
  }, /*#__PURE__*/React__default.createElement("p", null, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: '20px',
      height: '30px'
    }
  })))))), (formData === null || formData === void 0 ? void 0 : formData.whetherAirportPermissionRequired) === 'no' && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, formData === null || formData === void 0 ? void 0 : formData.whetherAirportPermissionRequired)), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.whetherAirportPermissionRequired_remarks), /*#__PURE__*/React__default.createElement("td", null, formData === null || formData === void 0 ? void 0 : formData.whetherAirportPermissionRequired_relaxation)))))));
};

const StyledTableCell = styled$3(TableCell)(({
  theme
}) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#99b3d98c",
    color: theme.palette.common.black
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14
  }
}));
const StyledTableRow = styled$3(TableRow)(({
  theme
}) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover
  },
  '&:last-child td, &:last-child th': {
    border: 0
  }
}));

const StyledTableCell$1 = styled$3(TableCell)(({
  theme
}) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#99b3d98c",
    color: theme.palette.common.black
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14
  }
}));
const StyledTableRow$1 = styled$3(TableRow)(({
  theme
}) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover
  },
  '&:last-child td, &:last-child th': {
    border: 0
  }
}));
function KhasraTables({
  formData
}) {
  var _formData$khasraArea;
  return /*#__PURE__*/createElement(TableContainer, {
    component: Paper
  }, /*#__PURE__*/createElement(Table, {
    sx: {
      minWidth: 700
    },
    "aria-label": "customized table"
  }, /*#__PURE__*/createElement(TableHead, null, /*#__PURE__*/createElement(TableRow, null, /*#__PURE__*/createElement(StyledTableCell$1, null, "Sr. No"), /*#__PURE__*/createElement(StyledTableCell$1, {
    align: "right"
  }, "Khasra No"), /*#__PURE__*/createElement(StyledTableCell$1, {
    align: "right"
  }, "Area"))), /*#__PURE__*/createElement(TableBody, null, formData === null || formData === void 0 ? void 0 : (_formData$khasraArea = formData.khasraArea) === null || _formData$khasraArea === void 0 ? void 0 : _formData$khasraArea.map((item, index) => /*#__PURE__*/createElement(StyledTableRow$1, {
    key: item.id || index
  }, /*#__PURE__*/createElement(StyledTableCell$1, {
    component: "th",
    scope: "row"
  }, index + 1), /*#__PURE__*/createElement(StyledTableCell$1, {
    align: "right"
  }, item.khasra || 'N/A'), /*#__PURE__*/createElement(StyledTableCell$1, {
    align: "right"
  }, item.area || 'N/A'))))));
}

const Form12ApplicaionFormatView = ({
  formData,
  applicationDocs,
  totalAmount,
  edcrDetails
}) => {
  var _formData$application, _formData$landInfo, _formData$landInfo$ch, _formData$blocks, _formData$taxHeadEsti;
  const {
    t
  } = useTranslation();
  const {
    landInfo,
    professionaldetails
  } = formData;
  const {
    checklistdata,
    owners,
    address
  } = landInfo;
  const tenant = Digit.ULBService.getCurrentTenantId();
  const isTcp = formData === null || formData === void 0 ? void 0 : (_formData$application = formData.applicationNo) === null || _formData$application === void 0 ? void 0 : _formData$application.includes('TCP');
  const accessData = plot => {
    const name = plot;
    return (originalRow, rowIndex, columns) => {
      return originalRow[name];
    };
  };
  const filteredDocuments = applicationDocs.filter(doc => !["applicantPhoto", "signature", "OwnerPhoto"].includes(doc.documentType));
  const checklistfilteredCertificate = applicationDocs.filter(doc => ["landInfo.checklist.structuralStabilityCertificate"].includes(doc.documentType));
  const checklistfilteredPhoto = applicationDocs.filter(doc => ["checklist.PhotographsOfSite"].includes(doc.documentType));
  const nocFromHPSEBcertificate = applicationDocs.filter(doc => ["checklist.nocFromHPSEB"].includes(doc.documentType));
  const whetherNearbyAsiMonument_noccertificate = applicationDocs.filter(doc => ["checklist.whetherNearbyAsiMonument_noc"].includes(doc.documentType));
  const whetherNearbyHfl_noccertificate = applicationDocs.filter(doc => ["checklist.whetherNearbyHfl_noccertificate"].includes(doc.documentType));
  const nocFromNHAI = applicationDocs.filter(doc => ["checklist.nocFromNHAI"].includes(doc.documentType));
  const whetherSeweragePassingThrough_noccertificate = applicationDocs.filter(doc => ["checklist.whetherSeweragePassingThrough_noccertificate"].includes(doc.documentType));
  const whetherSlidingArea_doc = applicationDocs.filter(doc => ["checklist.whetherSlidingArea_doc"].includes(doc.documentType));
  const whetherAirportPermissionRequired_noc = applicationDocs.filter(doc => ["checklist.whetherAirportPermissionRequired_noc"].includes(doc.documentType));
  const tableHeader = [{
    name: "BPA_TABLE_COL_FLOOR",
    id: "Floor"
  }, {
    name: "BPA_TABLE_COL_LEVEL",
    id: "Level"
  }, {
    name: "BPA_TABLE_COL_OCCUPANCY",
    id: "Occupancy"
  }, {
    name: "BPA_TABLE_COL_BUILDUPAREA",
    id: "BuildupArea"
  }, {
    name: "BPA_TABLE_COL_FLOORAREA",
    id: "FloorArea"
  }, {
    name: "BPA_TABLE_COL_CARPETAREA",
    id: "CarpetArea"
  }];
  const tableColumns = useMemo(() => {
    return tableHeader.map(ob => ({
      Header: t(`${ob.name}`),
      accessor: accessData(ob.id),
      id: ob.id
    }));
  });
  function getFloorData(block) {
    var _block$building;
    let floors = [];
    block === null || block === void 0 ? void 0 : (_block$building = block.building) === null || _block$building === void 0 ? void 0 : _block$building.floors.map(ob => {
      var _ob$occupancies, _ob$occupancies$, _ob$occupancies2, _ob$occupancies2$, _ob$occupancies3, _ob$occupancies3$, _ob$occupancies4, _ob$occupancies4$;
      floors.push({
        Floor: t(`BPA_FLOOR_NAME_${ob.number}`),
        Level: ob.number,
        Occupancy: t(`${(_ob$occupancies = ob.occupancies) === null || _ob$occupancies === void 0 ? void 0 : (_ob$occupancies$ = _ob$occupancies[0]) === null || _ob$occupancies$ === void 0 ? void 0 : _ob$occupancies$.type}`),
        BuildupArea: (_ob$occupancies2 = ob.occupancies) === null || _ob$occupancies2 === void 0 ? void 0 : (_ob$occupancies2$ = _ob$occupancies2[0]) === null || _ob$occupancies2$ === void 0 ? void 0 : _ob$occupancies2$.builtUpArea,
        FloorArea: ((_ob$occupancies3 = ob.occupancies) === null || _ob$occupancies3 === void 0 ? void 0 : (_ob$occupancies3$ = _ob$occupancies3[0]) === null || _ob$occupancies3$ === void 0 ? void 0 : _ob$occupancies3$.floorArea) || 0,
        CarpetArea: ((_ob$occupancies4 = ob.occupancies) === null || _ob$occupancies4 === void 0 ? void 0 : (_ob$occupancies4$ = _ob$occupancies4[0]) === null || _ob$occupancies4$ === void 0 ? void 0 : _ob$occupancies4$.CarpetArea) || 0,
        key: t(`BPA_FLOOR_NAME_${ob.number}`)
      });
    });
    return floors;
  }
  const urlImg = isTcp ? "https://upload.wikimedia.org/wikipedia/commons/f/fa/Seal_of_Uttar_Pradesh.svg" : "https://upload.wikimedia.org/wikipedia/commons/f/fa/Seal_of_Uttar_Pradesh.svg";
  const nameOfDepartment = isTcp ? "Department of Town and Country Planning" : "UP Housing & Development Board";
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginTop: "1px",
      backgroundColor: "#fff"
    }
  }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      padding: "5px",
      marginLeft: "15px"
    }
  }, /*#__PURE__*/React__default.createElement("img", {
    width: "60",
    height: "30",
    src: urlImg,
    alt: "Himachal"
  }), /*#__PURE__*/React__default.createElement("div", {
    style: {
      color: "blue"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginLeft: "12px",
      fontSize: "23px",
      marginTop: "6px"
    }
  }, nameOfDepartment), /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginLeft: "12px",
      marginTop: "4px"
    }
  }, 'Hamara Prayas....Aapka Awas')))), /*#__PURE__*/React__default.createElement("strong", null, " ", /*#__PURE__*/React__default.createElement("hr", null), " "), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("div", {
    style: {
      textAlign: "center",
      marginBottom: "5px",
      backgroundColor: "#99b3d98c",
      border: "1px solid rgba(91, 90, 95, 0.35)"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Map Submission")), /*#__PURE__*/React__default.createElement(Card$3, {
    style: {
      paddingBottom: " 15px",
      marginTop: "5px",
      marginBottom: "5px"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      textAlign: "center",
      marginBottom: "5px",
      backgroundColor: "#99b3d98c",
      border: "1px solid rgba(91, 90, 95, 0.35)"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Application Details ")), /*#__PURE__*/React__default.createElement("div", {
    className: "row",
    style: {
      marginLeft: "0px"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "90%"
    }
  }, /*#__PURE__*/React__default.createElement("div", null, owners === null || owners === void 0 ? void 0 : owners.map((item, index) => /*#__PURE__*/React__default.createElement("div", {
    key: `${item === null || item === void 0 ? void 0 : item.mobileNumber}_${index}`,
    style: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between'
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: '60%',
      marginLeft: "2%",
      marginTop: "15px"
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "font-weight-bold",
    style: {
      marginRight: "12px",
      whiteSpace: "nowrap"
    }
  }, "Name :"), " ", /*#__PURE__*/React__default.createElement("p", null, " ", item === null || item === void 0 ? void 0 : item.name)), /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "font-weight-bold",
    style: {
      marginRight: "12px",
      whiteSpace: "nowrap"
    }
  }, "Father/Guardian Name :"), " ", /*#__PURE__*/React__default.createElement("p", null, " ", item === null || item === void 0 ? void 0 : item.fatherOrHusbandName)), /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "font-weight-bold",
    style: {
      marginRight: "12px",
      whiteSpace: "nowrap"
    }
  }, "Gender :"), " ", /*#__PURE__*/React__default.createElement("p", null, " ", item === null || item === void 0 ? void 0 : item.gender)), /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "font-weight-bold",
    style: {
      marginRight: "12px",
      whiteSpace: "nowrap"
    }
  }, "MobileNumber :"), " ", /*#__PURE__*/React__default.createElement("p", null, " ", item === null || item === void 0 ? void 0 : item.mobileNumber)), /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "font-weight-bold",
    style: {
      marginRight: "12px",
      whiteSpace: "nowrap"
    }
  }, "Email :"), " ", /*#__PURE__*/React__default.createElement("p", null, " ", item === null || item === void 0 ? void 0 : item.emailId)), /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "font-weight-bold",
    style: {
      marginRight: "12px",
      whiteSpace: "nowrap"
    }
  }, "Application Number :"), " ", /*#__PURE__*/React__default.createElement("p", null, " ", formData === null || formData === void 0 ? void 0 : formData.applicationNo))), /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: '25%',
      marginTop: "auto"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "row",
    style: {
      margin: "4px"
    }
  }, item !== null && item !== void 0 && item.photo ? /*#__PURE__*/React__default.createElement("img", {
    style: {
      width: "110px",
      height: "110px"
    },
    src: item === null || item === void 0 ? void 0 : item.photo,
    alt: 'image',
    className: "img-thumbnail"
  }) : /*#__PURE__*/React__default.createElement(Avatar, {
    style: {
      width: "70px",
      height: "70px"
    }
  }, item === null || item === void 0 ? void 0 : item.photo)), /*#__PURE__*/React__default.createElement("div", {
    className: "row",
    style: {
      margin: "4px"
    }
  }, item !== null && item !== void 0 && item.signature ?
  /*#__PURE__*/
  React__default.createElement("img", {
    style: {
      width: "110px",
      height: "40px"
    },
    src: item === null || item === void 0 ? void 0 : item.signature,
    alt: 'signature',
    className: "img-thumbnail"
  }) : /*#__PURE__*/React__default.createElement(BorderColorIcon, {
    style: {
      width: "70px",
      height: "25px"
    }
  }, item === null || item === void 0 ? void 0 : item.signature))))))))), /*#__PURE__*/React__default.createElement(Card$3, {
    style: {
      paddingBottom: " 15px",
      marginTop: "5px",
      marginBottom: "5px"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      textAlign: "center",
      marginBottom: "5px",
      backgroundColor: "#99b3d98c",
      border: "1px solid rgba(91, 90, 95, 0.35)"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Address Details ")), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "50%"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      margin: "3px",
      border: "2px solid rgba(91, 90, 95, 0.35)",
      backgroundColor: "#99b3d98c",
      marginTop: "14px",
      textAlign: "center",
      marginBottom: "10px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Correspondance Address")), /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginLeft: "7%",
      marginRight: "5%"
    }
  }, owners === null || owners === void 0 ? void 0 : owners.map((item, index) => {
    var _item$correspondenceA, _item$correspondenceA2, _item$correspondenceA3, _item$correspondenceA4, _item$correspondenceA5, _item$correspondenceA6;
    return /*#__PURE__*/React__default.createElement("div", {
      key: index
    }, /*#__PURE__*/React__default.createElement("span", {
      style: {
        display: "flex"
      }
    }, /*#__PURE__*/React__default.createElement("p", {
      className: "font-weight-bold",
      style: {
        marginRight: "12px",
        whiteSpace: "nowrap"
      }
    }, "Address :"), " ", /*#__PURE__*/React__default.createElement("p", null, " ", (item === null || item === void 0 ? void 0 : (_item$correspondenceA = item.correspondenceAddress) === null || _item$correspondenceA === void 0 ? void 0 : _item$correspondenceA.address) || 'N/A')), /*#__PURE__*/React__default.createElement("span", {
      style: {
        display: "flex"
      }
    }, /*#__PURE__*/React__default.createElement("p", {
      className: "font-weight-bold",
      style: {
        marginRight: "12px",
        whiteSpace: "nowrap"
      }
    }, "State :"), " ", /*#__PURE__*/React__default.createElement("p", null, " ", (item === null || item === void 0 ? void 0 : (_item$correspondenceA2 = item.correspondenceAddress) === null || _item$correspondenceA2 === void 0 ? void 0 : _item$correspondenceA2.state) || 'Uttar Pradesh')), /*#__PURE__*/React__default.createElement("span", {
      style: {
        display: "flex"
      }
    }, /*#__PURE__*/React__default.createElement("p", {
      className: "font-weight-bold",
      style: {
        marginRight: "12px",
        whiteSpace: "nowrap"
      }
    }, "District :"), " ", /*#__PURE__*/React__default.createElement("p", null, " ", (item === null || item === void 0 ? void 0 : (_item$correspondenceA3 = item.correspondenceAddress) === null || _item$correspondenceA3 === void 0 ? void 0 : _item$correspondenceA3.district) || 'N/A')), /*#__PURE__*/React__default.createElement("span", {
      style: {
        display: "flex"
      }
    }, /*#__PURE__*/React__default.createElement("p", {
      className: "font-weight-bold",
      style: {
        marginRight: "12px",
        whiteSpace: "nowrap"
      }
    }, "Tehsil :"), " ", /*#__PURE__*/React__default.createElement("p", null, " ", (item === null || item === void 0 ? void 0 : (_item$correspondenceA4 = item.correspondenceAddress) === null || _item$correspondenceA4 === void 0 ? void 0 : _item$correspondenceA4.tehsil) || 'N/A')), /*#__PURE__*/React__default.createElement("span", {
      style: {
        display: "flex"
      }
    }, /*#__PURE__*/React__default.createElement("p", {
      className: "font-weight-bold",
      style: {
        marginRight: "12px",
        whiteSpace: "nowrap"
      }
    }, "Town/Village/Ward :"), " ", /*#__PURE__*/React__default.createElement("p", null, " ", (item === null || item === void 0 ? void 0 : (_item$correspondenceA5 = item.correspondenceAddress) === null || _item$correspondenceA5 === void 0 ? void 0 : _item$correspondenceA5.town) || 'N/A')), /*#__PURE__*/React__default.createElement("span", {
      style: {
        display: "flex"
      }
    }, /*#__PURE__*/React__default.createElement("p", {
      className: "font-weight-bold",
      style: {
        marginRight: "12px",
        whiteSpace: "nowrap"
      }
    }, "PinNo : "), " ", /*#__PURE__*/React__default.createElement("p", null, " ", (item === null || item === void 0 ? void 0 : (_item$correspondenceA6 = item.correspondenceAddress) === null || _item$correspondenceA6 === void 0 ? void 0 : _item$correspondenceA6.pinno) || 'N/A')));
  }))), /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "50%"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      margin: "3px",
      border: "2px solid rgba(91, 90, 95, 0.35)",
      backgroundColor: "#99b3d98c",
      marginTop: "14px",
      textAlign: "center",
      marginBottom: "10px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Permanent Address")), /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginLeft: "7%",
      marginRight: "5%"
    }
  }, owners === null || owners === void 0 ? void 0 : owners.map((item, index) => {
    var _item$permanentAddres, _item$permanentAddres2, _item$permanentAddres3, _item$permanentAddres4, _item$permanentAddres5, _item$permanentAddres6;
    return /*#__PURE__*/React__default.createElement("div", {
      key: index
    }, /*#__PURE__*/React__default.createElement("span", {
      style: {
        display: "flex"
      }
    }, /*#__PURE__*/React__default.createElement("p", {
      className: "font-weight-bold",
      style: {
        marginRight: "12px",
        whiteSpace: "nowrap"
      }
    }, "Address :"), " ", /*#__PURE__*/React__default.createElement("p", null, " ", (item === null || item === void 0 ? void 0 : (_item$permanentAddres = item.permanentAddress) === null || _item$permanentAddres === void 0 ? void 0 : _item$permanentAddres.address) || 'N/A')), /*#__PURE__*/React__default.createElement("span", {
      style: {
        display: "flex"
      }
    }, /*#__PURE__*/React__default.createElement("p", {
      className: "font-weight-bold",
      style: {
        marginRight: "12px",
        whiteSpace: "nowrap"
      }
    }, "State :"), " ", /*#__PURE__*/React__default.createElement("p", null, " ", (item === null || item === void 0 ? void 0 : (_item$permanentAddres2 = item.permanentAddres) === null || _item$permanentAddres2 === void 0 ? void 0 : _item$permanentAddres2.state) || 'Uttar Pradesh')), /*#__PURE__*/React__default.createElement("span", {
      style: {
        display: "flex"
      }
    }, /*#__PURE__*/React__default.createElement("p", {
      className: "font-weight-bold",
      style: {
        marginRight: "12px",
        whiteSpace: "nowrap"
      }
    }, "District :"), " ", /*#__PURE__*/React__default.createElement("p", null, " ", (item === null || item === void 0 ? void 0 : (_item$permanentAddres3 = item.permanentAddress) === null || _item$permanentAddres3 === void 0 ? void 0 : _item$permanentAddres3.district) || 'N/A')), /*#__PURE__*/React__default.createElement("span", {
      style: {
        display: "flex"
      }
    }, /*#__PURE__*/React__default.createElement("p", {
      className: "font-weight-bold",
      style: {
        marginRight: "12px",
        whiteSpace: "nowrap"
      }
    }, "Tehsil :"), " ", /*#__PURE__*/React__default.createElement("p", null, " ", (item === null || item === void 0 ? void 0 : (_item$permanentAddres4 = item.permanentAddress) === null || _item$permanentAddres4 === void 0 ? void 0 : _item$permanentAddres4.tehsil) || 'N/A')), /*#__PURE__*/React__default.createElement("span", {
      style: {
        display: "flex"
      }
    }, /*#__PURE__*/React__default.createElement("p", {
      className: "font-weight-bold",
      style: {
        marginRight: "12px",
        whiteSpace: "nowrap"
      }
    }, "Town/Village/Ward :"), " ", /*#__PURE__*/React__default.createElement("p", null, " ", (item === null || item === void 0 ? void 0 : (_item$permanentAddres5 = item.permanentAddress) === null || _item$permanentAddres5 === void 0 ? void 0 : _item$permanentAddres5.town) || 'N/A')), /*#__PURE__*/React__default.createElement("span", {
      style: {
        display: "flex"
      }
    }, /*#__PURE__*/React__default.createElement("p", {
      className: "font-weight-bold",
      style: {
        marginRight: "12px",
        whiteSpace: "nowrap"
      }
    }, "PinNo : "), " ", /*#__PURE__*/React__default.createElement("p", null, " ", (item === null || item === void 0 ? void 0 : (_item$permanentAddres6 = item.permanentAddress) === null || _item$permanentAddres6 === void 0 ? void 0 : _item$permanentAddres6.pinno) || 'N/A')));
  }))))), /*#__PURE__*/React__default.createElement(Card$3, {
    style: {
      paddingBottom: " 15px",
      marginTop: "5px",
      marginBottom: "5px"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      textAlign: "center",
      backgroundColor: "#99b3d98c",
      padding: "5px",
      color: "black",
      border: " 2px solid rgba(91, 90, 95, 0.35)"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Description Of Land Proposed for Development of Land/Construction of Building")), /*#__PURE__*/React__default.createElement("div", {
    className: "row",
    style: {
      marginLeft: "0px"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "90%"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "row",
    style: {
      marginLeft: "1%",
      marginTop: "1%"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "col-6"
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "font-weight-bold",
    style: {
      marginRight: "12px",
      whiteSpace: "nowrap"
    }
  }, "Revenue Village/Mohalla :"), " ", /*#__PURE__*/React__default.createElement("p", null, (formData === null || formData === void 0 ? void 0 : formData.revenueVillageMohal) || 'N/A', " "))), /*#__PURE__*/React__default.createElement("div", {
    className: "col-6"
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "font-weight-bold",
    style: {
      marginRight: "12px",
      whiteSpace: "nowrap"
    }
  }, "Khatuni No :"), " ", /*#__PURE__*/React__default.createElement("p", null, " ", (formData === null || formData === void 0 ? void 0 : formData.khatauniNo) || 'N/A'))), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("div", {
    className: "col-6"
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "font-weight-bold",
    style: {
      marginRight: "12px",
      whiteSpace: "nowrap"
    }
  }, "Applied Land Use:  "), " ", /*#__PURE__*/React__default.createElement("p", null, " ", (formData === null || formData === void 0 ? void 0 : formData.typeofArea) || 'N/A'))), /*#__PURE__*/React__default.createElement("div", {
    className: "col-6"
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "font-weight-bold",
    style: {
      marginRight: "12px",
      whiteSpace: "nowrap"
    }
  }, "Khata No :"), " ", /*#__PURE__*/React__default.createElement("p", null, (formData === null || formData === void 0 ? void 0 : formData.khataNo) || 'N/A', " "))), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("div", {
    className: "col-6"
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "font-weight-bold",
    style: {
      marginRight: "12px",
      whiteSpace: "nowrap"
    }
  }, "Total Plot Area: "), " ", /*#__PURE__*/React__default.createElement("p", null, " ", (formData === null || formData === void 0 ? void 0 : formData.plotArea) || 'N/A'))), /*#__PURE__*/React__default.createElement("div", {
    className: "col-6"
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "font-weight-bold",
    style: {
      marginRight: "12px",
      whiteSpace: "nowrap"
    }
  }, "District:  "), " ", /*#__PURE__*/React__default.createElement("p", null, " ", (address === null || address === void 0 ? void 0 : address.city) || 'N/A'))), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("div", {
    className: "col-6"
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, isTcp ? /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, " ", /*#__PURE__*/React__default.createElement("p", {
    className: "font-weight-bold",
    style: {
      marginRight: "12px",
      whiteSpace: "nowrap"
    }
  }, "Notified Area:  "), " ", /*#__PURE__*/React__default.createElement("p", null, " ", (address === null || address === void 0 ? void 0 : address.doorNo) || 'N/A')) : /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "font-weight-bold",
    style: {
      marginRight: "12px",
      whiteSpace: "nowrap"
    }
  }, "ULB:  "), " ", /*#__PURE__*/React__default.createElement("p", null, " ", (address === null || address === void 0 ? void 0 : address.doorNo) || 'N/A')))), /*#__PURE__*/React__default.createElement("div", {
    className: "col-6"
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "font-weight-bold",
    style: {
      marginRight: "12px",
      whiteSpace: "nowrap"
    }
  }, "Area Type:  "), " ", /*#__PURE__*/React__default.createElement("p", null, " ", (address === null || address === void 0 ? void 0 : address.areaType) || 'N/A'))), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("div", {
    className: "col-6"
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "font-weight-bold",
    style: {
      marginRight: "12px",
      whiteSpace: "nowrap"
    }
  }, "Property Type:  "), " ", /*#__PURE__*/React__default.createElement("p", null, " ", (formData === null || formData === void 0 ? void 0 : formData.propertyType) || 'N/A'))), /*#__PURE__*/React__default.createElement("div", {
    className: "col-6"
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "font-weight-bold",
    style: {
      marginRight: "12px",
      whiteSpace: "nowrap"
    }
  }, "Case Ref No: "), " ", /*#__PURE__*/React__default.createElement("p", null, "  ", (formData === null || formData === void 0 ? void 0 : formData.caseReferenceNo) || 'N/A'))), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("div", {
    className: "col-6"
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "font-weight-bold",
    style: {
      marginRight: "12px",
      whiteSpace: "nowrap"
    }
  }, "No of Blocks:  "), " ", /*#__PURE__*/React__default.createElement("p", null, " ", (formData === null || formData === void 0 ? void 0 : formData.noOfBlocks) || 'N/A'))), /*#__PURE__*/React__default.createElement("div", {
    className: "col-6"
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "font-weight-bold",
    style: {
      marginRight: "12px",
      whiteSpace: "nowrap"
    }
  }, "Risk Type:  "), " ", /*#__PURE__*/React__default.createElement("p", null, " ", (formData === null || formData === void 0 ? void 0 : formData.riskType) || 'N/A'))), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("div", {
    className: "col-6"
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "font-weight-bold",
    style: {
      marginRight: "12px",
      whiteSpace: "nowrap"
    }
  }, "Number of Plot:  "), " ", /*#__PURE__*/React__default.createElement("p", null, (formData === null || formData === void 0 ? void 0 : formData.noOfPlot) || 'N/A'))), /*#__PURE__*/React__default.createElement("div", {
    className: "col-6"
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "font-weight-bold",
    style: {
      marginRight: "12px",
      whiteSpace: "nowrap"
    }
  }, " Latitude/Longitude: "), " ", /*#__PURE__*/React__default.createElement("p", null, " ", (formData === null || formData === void 0 ? void 0 : formData.latLong) || 'N/A'))), /*#__PURE__*/React__default.createElement("br", null), (formData === null || formData === void 0 ? void 0 : formData.constructionType) && /*#__PURE__*/React__default.createElement("div", {
    className: "col-6"
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "font-weight-bold",
    style: {
      marginRight: "12px",
      whiteSpace: "nowrap"
    }
  }, "Type of Construction: "), " ", /*#__PURE__*/React__default.createElement("p", null, " ", (formData === null || formData === void 0 ? void 0 : formData.constructionType) || 'N/A'))), /*#__PURE__*/React__default.createElement("div", {
    className: "col-6"
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "font-weight-bold",
    style: {
      marginRight: "12px",
      whiteSpace: "nowrap"
    }
  }, "Whether Subdivision Approved:  "), " ", /*#__PURE__*/React__default.createElement("p", null, (formData === null || formData === void 0 ? void 0 : formData.whetherSubdivisionApproved) || 'N/A'))), /*#__PURE__*/React__default.createElement("div", {
    className: "col-6"
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "font-weight-bold",
    style: {
      marginRight: "12px",
      whiteSpace: "nowrap"
    }
  }, "Whether Property is ancestral:  "), " ", /*#__PURE__*/React__default.createElement("p", null, (formData === null || formData === void 0 ? void 0 : formData.isAncestralProperty) || 'N/A'))), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("div", {
    className: "col-6"
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "font-weight-bold",
    style: {
      marginRight: "12px",
      whiteSpace: "nowrap"
    }
  }, "Muck to be disposed (cubic mt.):  "), " ", /*#__PURE__*/React__default.createElement("p", null, " ", (formData === null || formData === void 0 ? void 0 : (_formData$landInfo = formData.landInfo) === null || _formData$landInfo === void 0 ? void 0 : (_formData$landInfo$ch = _formData$landInfo.checklistdata) === null || _formData$landInfo$ch === void 0 ? void 0 : _formData$landInfo$ch.muckToBeDisposed) || 'N/A'))), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "font-weight-bold",
    style: {
      marginRight: "12px",
      whiteSpace: "nowrap"
    }
  }, "Maximum Permissible Ground Coverage (in Sq.mt):  "), " ", /*#__PURE__*/React__default.createElement("p", null, " ", (formData === null || formData === void 0 ? void 0 : formData.maximumPermissibleGroundCoverage) || 'N/A'))), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "font-weight-bold",
    style: {
      marginRight: "12px",
      whiteSpace: "nowrap"
    }
  }, "Proposal Submitted For:  "), " ", /*#__PURE__*/React__default.createElement("p", null, " ", (formData === null || formData === void 0 ? void 0 : formData.proposal) || 'N/A'))), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "font-weight-bold",
    style: {
      marginRight: "12px",
      whiteSpace: "nowrap"
    }
  }, "Plot Area for Sub-division/Development Activity:   "), " ", /*#__PURE__*/React__default.createElement("p", null, " ", (formData === null || formData === void 0 ? void 0 : formData.totalPlotArea) || 'N/A'))), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("br", null), (formData === null || formData === void 0 ? void 0 : formData.khasraArea) && /*#__PURE__*/React__default.createElement(KhasraTables, {
    formData: formData
  }))))), (formData === null || formData === void 0 ? void 0 : formData.blocks) && /*#__PURE__*/React__default.createElement(Card$3, {
    style: {
      paddingBottom: " 15px",
      marginTop: "5px",
      marginBottom: "5px"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      textAlign: "center",
      backgroundColor: "#99b3d98c",
      padding: "5px",
      color: "black",
      border: " 2px solid rgba(91, 90, 95, 0.35)"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Details of Blocks")), /*#__PURE__*/React__default.createElement("div", {
    style: {
      margin: "1%"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "col-6"
  }, (formData === null || formData === void 0 ? void 0 : formData.edcrReport) && /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "font-weight-bold",
    style: {
      marginRight: "12px",
      whiteSpace: "nowrap"
    }
  }, "edcr-Report :"), /*#__PURE__*/React__default.createElement("p", null, " ", /*#__PURE__*/React__default.createElement("a", {
    target: "_",
    href: formData === null || formData === void 0 ? void 0 : formData.edcrReport,
    style: {
      minWidth: "80px",
      height: "auto",
      minWidth: "30px"
    }
  }, /*#__PURE__*/React__default.createElement("p", null, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: '20px',
      height: '30px'
    }
  })))))), /*#__PURE__*/React__default.createElement("div", {
    className: "col-6"
  }, (formData === null || formData === void 0 ? void 0 : formData.drawingPdf) && /*#__PURE__*/React__default.createElement("span", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "font-weight-bold",
    style: {
      marginRight: "12px",
      whiteSpace: "nowrap"
    }
  }, "DrawingPdf :"), /*#__PURE__*/React__default.createElement("p", null, " ", /*#__PURE__*/React__default.createElement("a", {
    target: "_",
    href: formData === null || formData === void 0 ? void 0 : formData.drawingPdf,
    style: {
      minWidth: "80px",
      height: "auto",
      minWidth: "30px"
    }
  }, /*#__PURE__*/React__default.createElement("p", null, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: '20px',
      height: '30px'
    }
  }))))))), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("h4", null, "Occupancy : ", formData === null || formData === void 0 ? void 0 : formData.occupancy), formData === null || formData === void 0 ? void 0 : (_formData$blocks = formData.blocks) === null || _formData$blocks === void 0 ? void 0 : _formData$blocks.map((block, index) => /*#__PURE__*/React__default.createElement("div", {
    style: {
      overflow: "scroll"
    },
    key: index
  }, /*#__PURE__*/React__default.createElement("div", null, "blocks Number : ", index + 1), /*#__PURE__*/React__default.createElement(Table$2, {
    className: "customTable table-fixed-first-column table-border-style",
    t: t,
    disableSort: false,
    autoSort: true,
    manualPagination: false,
    isPaginationRequired: false,
    initSortId: "S N ",
    data: getFloorData(block),
    columns: tableColumns,
    getCellProps: cellInfo => {
      return {
        style: {}
      };
    }
  }), /*#__PURE__*/React__default.createElement("br", null))))), /*#__PURE__*/React__default.createElement(Card$3, {
    style: {
      paddingBottom: " 15px",
      marginTop: "5px",
      marginBottom: "5px"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      textAlign: "center",
      backgroundColor: "#99b3d98c",
      padding: "5px",
      color: "black",
      border: " 2px solid rgba(91, 90, 95, 0.35)"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Documents/Maps")), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement(BPADocumentsPreview, {
    documents: getOrderDocuments(filteredDocuments),
    svgStyles: {},
    isSendBackFlow: false,
    isHrLine: true,
    titleStyles: {
      fontSize: "18px",
      lineHeight: "24px",
      "fontWeight": 700,
      marginBottom: "10px"
    }
  }))), /*#__PURE__*/React__default.createElement(Card$3, {
    style: {
      paddingBottom: " 15px",
      marginTop: "5px",
      marginBottom: "5px"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      textAlign: "center",
      backgroundColor: "#99b3d98c",
      padding: "5px",
      color: "black",
      border: " 2px solid rgba(91, 90, 95, 0.35)"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "CheckList")), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(BPACheckListPreview, {
    certificate: checklistfilteredCertificate,
    nocFromHPSEBcertificate: nocFromHPSEBcertificate,
    whetherNearbyAsiMonument_noccertificate: whetherNearbyAsiMonument_noccertificate,
    whetherNearbyHfl_noccertificate: whetherNearbyHfl_noccertificate,
    nocFromNHAIcertificate: nocFromNHAI,
    whetherSeweragePassingThrough_noccertificate: whetherSeweragePassingThrough_noccertificate,
    whetherSlidingArea_doc: whetherSlidingArea_doc,
    photo: checklistfilteredPhoto,
    whetherAirportPermissionRequired_noc: whetherAirportPermissionRequired_noc,
    formData: checklistdata
  }))), formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti = formData.taxHeadEstimates) === null || _formData$taxHeadEsti === void 0 ? void 0 : _formData$taxHeadEsti.map((item, index) => {
    var _item$feeDetails, _item$feeDetails2, _item$feeDetails2$dev;
    return /*#__PURE__*/React__default.createElement(Box$1, {
      gridColumn: "span 12",
      sx: {
        ml: 2
      },
      key: index
    }, /*#__PURE__*/React__default.createElement(Card$3, {
      style: {
        paddingBottom: " 20px",
        marginTop: "10px",
        marginBottom: "5px"
      }
    }, isTcp && (formData === null || formData === void 0 ? void 0 : formData.plotArea) < 500 && (formData === null || formData === void 0 ? void 0 : formData.typeofArea) !== "Residential" && /*#__PURE__*/React__default.createElement("div", {
      style: {
        textAlign: "center",
        backgroundColor: "#99b3d98c",
        padding: "5px",
        color: "black",
        border: " 2px solid rgba(91, 90, 95, 0.35)"
      }
    }, "Processing fee to Fee structure "), isTcp && (formData === null || formData === void 0 ? void 0 : formData.plotArea) < 500 && (formData === null || formData === void 0 ? void 0 : formData.typeofArea) === "Residential" && /*#__PURE__*/React__default.createElement("div", {
      style: {
        textAlign: "center",
        backgroundColor: "#99b3d98c",
        padding: "5px",
        color: "black",
        border: " 2px solid rgba(91, 90, 95, 0.35)"
      }
    }, "Processing fee to Fee structure "), isTcp && (formData === null || formData === void 0 ? void 0 : formData.plotArea) > 500 && /*#__PURE__*/React__default.createElement("div", {
      style: {
        textAlign: "center",
        backgroundColor: "#99b3d98c",
        padding: "5px",
        color: "black",
        border: " 2px solid rgba(91, 90, 95, 0.35)"
      }
    }, "Processing fee to Fee structure "), !isTcp && (formData === null || formData === void 0 ? void 0 : formData.plotArea) < 500 && (formData === null || formData === void 0 ? void 0 : formData.typeofArea) != "Residential" && /*#__PURE__*/React__default.createElement("div", {
      style: {
        textAlign: "center",
        backgroundColor: "#99b3d98c",
        padding: "5px",
        color: "black",
        border: " 2px solid rgba(91, 90, 95, 0.35)"
      }
    }, "Incudling Application & Processing fee to Fee structure "), !isTcp && (formData === null || formData === void 0 ? void 0 : formData.plotArea) < 500 && (formData === null || formData === void 0 ? void 0 : formData.typeofArea) === "Residential" && index === 0 && /*#__PURE__*/React__default.createElement("div", {
      style: {
        textAlign: "center",
        backgroundColor: "#99b3d98c",
        padding: "5px",
        color: "black",
        border: " 2px solid rgba(91, 90, 95, 0.35)"
      }
    }, "Application Fee "), !isTcp && (formData === null || formData === void 0 ? void 0 : formData.plotArea) < 500 && (formData === null || formData === void 0 ? void 0 : formData.typeofArea) === "Residential" && index === 1 && /*#__PURE__*/React__default.createElement("div", {
      style: {
        textAlign: "center",
        backgroundColor: "#99b3d98c",
        padding: "5px",
        color: "black",
        border: " 2px solid rgba(91, 90, 95, 0.35)"
      }
    }, "Processing fee to Fee structure"), !isTcp && (formData === null || formData === void 0 ? void 0 : formData.plotArea) > 500 && index === 1 && /*#__PURE__*/React__default.createElement("div", {
      style: {
        textAlign: "center",
        backgroundColor: "#99b3d98c",
        padding: "5px",
        color: "black",
        border: " 2px solid rgba(91, 90, 95, 0.35)"
      }
    }, "Processing fee to Fee structure"), !isTcp && (formData === null || formData === void 0 ? void 0 : formData.plotArea) > 500 && index === 0 && /*#__PURE__*/React__default.createElement("div", {
      style: {
        textAlign: "center",
        backgroundColor: "#99b3d98c",
        padding: "5px",
        color: "black",
        border: " 2px solid rgba(91, 90, 95, 0.35)"
      }
    }, "Application Fee"), (item === null || item === void 0 ? void 0 : (_item$feeDetails = item.feeDetails) === null || _item$feeDetails === void 0 ? void 0 : _item$feeDetails.deviationTable) && /*#__PURE__*/React__default.createElement("table", {
      class: "table table-sm"
    }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("p", {
      style: {
        marginTop: "20px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Floor No"))), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("p", {
      style: {
        marginTop: "20px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Use Type"))), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("p", {
      style: {
        marginTop: "20px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Total Area (Sq.M.)"))), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("p", {
      style: {
        marginTop: "20px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Unit Price()"))), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("p", {
      style: {
        marginTop: "20px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Price()"))), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("p", {
      style: {
        marginTop: "20px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Parking Area"))))), /*#__PURE__*/React__default.createElement("tbody", null, item === null || item === void 0 ? void 0 : (_item$feeDetails2 = item.feeDetails) === null || _item$feeDetails2 === void 0 ? void 0 : (_item$feeDetails2$dev = _item$feeDetails2.deviationTable) === null || _item$feeDetails2$dev === void 0 ? void 0 : _item$feeDetails2$dev.map((feeData, index) => {
      var _feeData$floorType, _feeData$landUseType, _feeData$landUseType2, _feeData$landUseType3, _feeData$landUseType4, _feeData$floorType2;
      return /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, feeData === null || feeData === void 0 ? void 0 : (_feeData$floorType = feeData.floorType) === null || _feeData$floorType === void 0 ? void 0 : _feeData$floorType.name), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, feeData === null || feeData === void 0 ? void 0 : (_feeData$landUseType = feeData.landUseType) === null || _feeData$landUseType === void 0 ? void 0 : _feeData$landUseType.name)), /*#__PURE__*/React__default.createElement("td", null, feeData === null || feeData === void 0 ? void 0 : (_feeData$landUseType2 = feeData.landUseType) === null || _feeData$landUseType2 === void 0 ? void 0 : _feeData$landUseType2.area), /*#__PURE__*/React__default.createElement("td", null, feeData === null || feeData === void 0 ? void 0 : (_feeData$landUseType3 = feeData.landUseType) === null || _feeData$landUseType3 === void 0 ? void 0 : _feeData$landUseType3.unitPrice), /*#__PURE__*/React__default.createElement("td", null, feeData === null || feeData === void 0 ? void 0 : (_feeData$landUseType4 = feeData.landUseType) === null || _feeData$landUseType4 === void 0 ? void 0 : _feeData$landUseType4.price), /*#__PURE__*/React__default.createElement("td", null, feeData === null || feeData === void 0 ? void 0 : (_feeData$floorType2 = feeData.floorType) === null || _feeData$floorType2 === void 0 ? void 0 : _feeData$floorType2.area));
    }))), /*#__PURE__*/React__default.createElement("table", {
      class: "table table-sm"
    }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("p", {
      style: {
        marginLeft: "10px",
        textAlign: "left"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Total Amount"))), /*#__PURE__*/React__default.createElement("tbody", null, (item === null || item === void 0 ? void 0 : item.applicationFee) !== 0 && (item === null || item === void 0 ? void 0 : item.applicationFee) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      colspan: "2"
    }, t(`BPA_COMMON_APPLICATION_FEE`)), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, `₹ ${item === null || item === void 0 ? void 0 : item.applicationFee}`))), (item === null || item === void 0 ? void 0 : item.buildUpCharges) !== 0 && (item === null || item === void 0 ? void 0 : item.buildUpCharges) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      colspan: "2"
    }, "Building Permission Fee"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, `₹ ${item === null || item === void 0 ? void 0 : item.buildUpCharges}`))), (item === null || item === void 0 ? void 0 : item.cluFee) !== 0 && (item === null || item === void 0 ? void 0 : item.cluFee) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      colspan: "2"
    }, "CLU Fee"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, `₹ ${item === null || item === void 0 ? void 0 : item.cluFee}`))), (item === null || item === void 0 ? void 0 : item.deviationCharges) && (item === null || item === void 0 ? void 0 : item.deviationCharges) !== 0 && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      colspan: "2"
    }, "Deviation Charges"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, `₹ ${item === null || item === void 0 ? void 0 : item.deviationCharges}`))), (item === null || item === void 0 ? void 0 : item.muckCharges) !== 0 && (item === null || item === void 0 ? void 0 : item.muckCharges) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      colspan: "2"
    }, "Total Muck-Charges"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, `₹ ${item === null || item === void 0 ? void 0 : item.muckCharges}`))), (item === null || item === void 0 ? void 0 : item.totalCBMFees) !== 0 && (item === null || item === void 0 ? void 0 : item.totalCBMFees) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      colspan: "2"
    }, /*#__PURE__*/React__default.createElement("b", null, "Total Planning Permission Fee")), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, `₹ ${item === null || item === void 0 ? void 0 : item.totalCBMFees}`))), (item === null || item === void 0 ? void 0 : item.premiumFARFee) !== 0 && (item === null || item === void 0 ? void 0 : item.premiumFARFee) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      colspan: "2"
    }, "Premium FAR Fee"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, `₹ ${item === null || item === void 0 ? void 0 : item.premiumFARFee}`))), (item === null || item === void 0 ? void 0 : item.echarges) !== 0 && (item === null || item === void 0 ? void 0 : item.echarges) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      colspan: "2"
    }, "e-charges (3%)"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, `₹ ${item === null || item === void 0 ? void 0 : item.echarges}`))), (item === null || item === void 0 ? void 0 : item.amountDisplay) !== 0 && (item === null || item === void 0 ? void 0 : item.amountDisplay) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      colspan: "2"
    }, /*#__PURE__*/React__default.createElement("b", null, "Grand Total Amount")), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, `₹ ${item === null || item === void 0 ? void 0 : item.amountDisplay}`)))))));
  }), /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Box$1, {
    gridColumn: "span 12",
    sx: {
      ml: 2
    }
  }, /*#__PURE__*/React__default.createElement(Card$3, {
    style: {
      paddingBottom: " 20px",
      marginTop: "10px",
      marginBottom: "5px"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      textAlign: "center",
      backgroundColor: "#99b3d98c",
      padding: "5px",
      color: "black",
      border: " 2px solid rgba(91, 90, 95, 0.35)"
    }
  }, "Processing fee to Fee structure "), /*#__PURE__*/React__default.createElement("table", {
    class: "table table-sm"
  }, /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colspan: "2"
  }, " Building Approval charges"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, `₹ 0`))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colspan: "2"
  }, "Malba Charges"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, `₹ 0`))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colspan: "2"
  }, "Water Charges"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, `₹ 0`))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colspan: "2"
  }, "Site Inspection Charges"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, `₹ 0`))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colspan: "2"
  }, "Shudhikaran Charges"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("b", null, `₹ 0`))))))))));
};

const Form12SummaryView = ({
  formData,
  collectionBillDetails,
  edcrDetails
}) => {
  var _formData$PrevStateDo, _formData$documents, _formData$PrevStateNo, _formData$nocDocument, _formData$nocDocument2, _pdfDetails$pdfFiles, _formData$taxHeadEsti, _formData$taxHeadEsti2, _formData$application, _formData$serviceType;
  const stateId = Digit.ULBService.getStateId();
  const appType = formData === null || formData === void 0 ? void 0 : formData.applicationType;
  const BusinessService = (formData === null || formData === void 0 ? void 0 : formData.businessService) === `BPA_${appType === null || appType === void 0 ? void 0 : appType.replace("_", "")}` ? `BPA.${appType}_FEE` : `BPA.${appType}_FEE_UD`;
  const docs = (formData === null || formData === void 0 ? void 0 : formData.documents) || {};
  const documents = typeof docs === 'object' && !Array.isArray(docs) ? Object.values(docs) : docs;
  formData.documents = documents;
  let improvedDoc = [];
  formData === null || formData === void 0 ? void 0 : (_formData$PrevStateDo = formData.PrevStateDocuments) === null || _formData$PrevStateDo === void 0 ? void 0 : _formData$PrevStateDo.map(preDoc => {
    improvedDoc.push({
      ...preDoc,
      module: "OBPS"
    });
  });
  formData === null || formData === void 0 ? void 0 : (_formData$documents = formData.documents) === null || _formData$documents === void 0 ? void 0 : _formData$documents.map(appDoc => {
    improvedDoc.push({
      ...appDoc,
      module: "OBPS"
    });
  });
  formData === null || formData === void 0 ? void 0 : (_formData$PrevStateNo = formData.PrevStateNocDocuments) === null || _formData$PrevStateNo === void 0 ? void 0 : _formData$PrevStateNo.map(preNocDoc => {
    improvedDoc.push({
      ...preNocDoc,
      module: "NOC"
    });
  });
  formData === null || formData === void 0 ? void 0 : (_formData$nocDocument = formData.nocDocuments) === null || _formData$nocDocument === void 0 ? void 0 : (_formData$nocDocument2 = _formData$nocDocument.nocDocuments) === null || _formData$nocDocument2 === void 0 ? void 0 : _formData$nocDocument2.map(nocDoc => {
    improvedDoc.push({
      ...nocDoc,
      module: "NOC"
    });
  });
  const {
    data: pdfDetails,
    isLoading: pdfLoading
  } = Digit.Hooks.useDocumentSearch(improvedDoc, {
    enabled: (improvedDoc === null || improvedDoc === void 0 ? void 0 : improvedDoc.length) > 0 ? true : false
  });
  let applicationDocs = [];
  if ((pdfDetails === null || pdfDetails === void 0 ? void 0 : (_pdfDetails$pdfFiles = pdfDetails.pdfFiles) === null || _pdfDetails$pdfFiles === void 0 ? void 0 : _pdfDetails$pdfFiles.length) > 0) {
    var _pdfDetails$pdfFiles2;
    pdfDetails === null || pdfDetails === void 0 ? void 0 : (_pdfDetails$pdfFiles2 = pdfDetails.pdfFiles) === null || _pdfDetails$pdfFiles2 === void 0 ? void 0 : _pdfDetails$pdfFiles2.map(pdfAppDoc => {
      if ((pdfAppDoc === null || pdfAppDoc === void 0 ? void 0 : pdfAppDoc.module) == "OBPS") applicationDocs.push(pdfAppDoc);
    });
  }
  let consumerCode = formData === null || formData === void 0 ? void 0 : formData.applicationNo;
  const fetchBillParams = {
    consumerCode
  };
  const {
    data: paymentDetails
  } = Digit.Hooks.useFetchBillsForBuissnessService({
    businessService: BusinessService,
    ...fetchBillParams,
    tenantId: stateId
  }, {
    enabled: consumerCode ? true : false,
    retry: false
  });
  const totalAmount = formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti = formData.taxHeadEstimates) === null || _formData$taxHeadEsti === void 0 ? void 0 : (_formData$taxHeadEsti2 = _formData$taxHeadEsti[0]) === null || _formData$taxHeadEsti2 === void 0 ? void 0 : _formData$taxHeadEsti2.estimateAmount;
  const isEditApplication = window.location.href.includes("editApplication");
  const sendbacktocitizenApp = window.location.href.includes("sendbacktocitizen");
  let routeLink = `/digit-ui/citizen/obps/form11/${formData === null || formData === void 0 ? void 0 : (_formData$application = formData.applicationType) === null || _formData$application === void 0 ? void 0 : _formData$application.toLowerCase()}/${formData === null || formData === void 0 ? void 0 : (_formData$serviceType = formData.serviceType) === null || _formData$serviceType === void 0 ? void 0 : _formData$serviceType.toLowerCase()}`;
  if (isEditApplication) routeLink = `/digit-ui/citizen/obps/editApplication/form11/${formData === null || formData === void 0 ? void 0 : formData.tenantId}/${formData === null || formData === void 0 ? void 0 : formData.applicationNo}`;
  if (sendbacktocitizenApp) routeLink = `/digit-ui/citizen/obps/sendbacktocitizen/form11/${formData === null || formData === void 0 ? void 0 : formData.tenantId}/${formData === null || formData === void 0 ? void 0 : formData.applicationNo}`;
  if (pdfLoading) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  console.log("dfygbhusw", formData);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Form12ApplicaionFormatView, {
    formData: formData,
    applicationDocs: applicationDocs,
    totalAmount: totalAmount,
    edcrDetails: edcrDetails,
    collectionBillDetails: collectionBillDetails
  }));
};

function ApplicationView12({
  id,
  formType
}) {
  const history = useHistory();
  const stateId = Digit.ULBService.getStateId();
  const isEmployee = history.location.pathname.includes("employee");
  const {
    data = {},
    isLoading
  } = Digit.Hooks.obps.useBPADetailsPage(stateId, {
    applicationNo: id,
    isEmployee
  });
  const {
    applicationData,
    edcrDetails,
    collectionBillDetails
  } = data;
  if (!isLoading && data) {
    console.log("dfygbhusw", data, id, formType);
  }
  if (isLoading) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, !isLoading && data && /*#__PURE__*/React__default.createElement(Form12SummaryView, {
    formData: applicationData,
    edcrDetails: edcrDetails,
    collectionBillDetails: collectionBillDetails
  }));
}

const departmentList = [{
  value: "AVP",
  label: "UPAVP",
  name: "avp"
}, {
  value: "DA",
  label: "DA",
  name: "da"
}];
const ownerOrLtp = [{
  value: "OWNER",
  label: "OWNER",
  name: "OWNER"
}, {
  value: "LTP",
  label: "LTP",
  name: "LTP"
}];

const StyledFormControl = styled$1(FormControl$1)(({
  theme
}) => ({
  columnGap: theme.spacing(2),
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "row",
  display: "flex"
}));
const StyledFormLabel = styled$1(FormLabel)(({
  theme
}) => ({
  color: theme.palette.grey[900],
  minWidth: theme.spacing(18),
  marginBottom: 0
}));
const StyledFormControlLabel = styled$1(FormControlLabel$1)(() => ({
  margin: 0
}));
const StyledRadioGroup$3 = styled$1(RadioGroup$1)(({
  theme
}) => ({
  columnGap: theme.spacing(2),
  alignItems: "center",
  width: "18.25vw",
  minHeight: 40
}));
function useDepartmentSelector() {
  var _Digit;
  const [applicationFlow, setApplicationFlow] = useState(((_Digit = Digit) === null || _Digit === void 0 ? void 0 : _Digit.SessionStorage.get("CITIZEN.COMMON.HOME.FLOW")) || null);
  const handleDepartmentOnChange = ({
    target: {
      value
    }
  }) => {
    var _Digit2;
    (_Digit2 = Digit) === null || _Digit2 === void 0 ? void 0 : _Digit2.SessionStorage.set("CITIZEN.COMMON.HOME.FLOW", value);
    setApplicationFlow(value);
  };
  return [applicationFlow === "DA", applicationFlow, () => /*#__PURE__*/React__default.createElement("section", {
    className: "container1",
    style: {
      marginTop: 0
    }
  }, /*#__PURE__*/React__default.createElement(Grid$1, {
    container: true,
    justifyContent: "center"
  }, /*#__PURE__*/React__default.createElement(Grid$1, {
    item: true,
    xs: 12,
    md: 6
  }, applicationFlow === null && /*#__PURE__*/React__default.createElement(StyledFormControl, null, /*#__PURE__*/React__default.createElement(StyledFormLabel, null, "Department ", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, "*")), /*#__PURE__*/React__default.createElement(StyledRadioGroup$3, {
    onChange: handleDepartmentOnChange,
    "aria-labelledby": "departments-list",
    name: "department",
    row: true
  }, departmentList === null || departmentList === void 0 ? void 0 : departmentList.map(item => {
    return /*#__PURE__*/React__default.createElement(StyledFormControlLabel, {
      control: /*#__PURE__*/React__default.createElement(Radio$1, null),
      value: item === null || item === void 0 ? void 0 : item.value,
      label: item === null || item === void 0 ? void 0 : item.label,
      key: item === null || item === void 0 ? void 0 : item.name
    });
  }))))))];
}

const questions = [{
  label: "Does your site require NOC from Municipal Corporation?",
  applicantName: "nocFromMunicipalCorporation",
  employeeName: "nocFromMunicipalCorporationEmployee"
}, {
  label: "Does your plot fall under 300m radius of any monument?",
  applicantName: "plotRadiusMonument",
  employeeName: "plotRadiusMonumentEmployee"
}, {
  label: "Does your proposal require Fire Noc?",
  applicantName: "requireFireNoc",
  employeeName: "requireFireNocEmployee"
}, {
  label: "Does your proposal require Environmental clearance Noc?",
  applicantName: "environmentClearanceNoc",
  employeeName: "environmentClearanceNocEmployee"
}, {
  label: "Is proposed plot near major crossroad (Chauraha) or affecting traffic?",
  applicantName: "plotNearCrossroad",
  employeeName: "plotNearCrossroadEmployee"
}, {
  label: "Is your plot nearby irrigation land/irrigation canal?",
  applicantName: "plotNearIrrigationLand",
  employeeName: "plotNearIrrigationLandEmployee"
}, {
  label: "Is your plot abutting PWD Road?",
  applicantName: "plotAbuttingPWD",
  employeeName: "plotAbuttingPWDEmployee"
}, {
  label: "Is your plot within 100 meters of a metro structure/corridor?",
  applicantName: "plotNearMetro",
  employeeName: "plotNearMetroEmployee"
}, {
  label: "Is the proposed site within 30 meters of a railway line/land?",
  applicantName: "siteNearRailwayBoundary",
  employeeName: "siteNearRailwayBoundaryEmployee"
}, {
  label: "Is your plot near Forest Land or any Major tree which requires NOC from the forest department?",
  applicantName: "plotNearForestLand",
  employeeName: "plotNearForestLandEmployee"
}, {
  label: "Is your plot abutting any National Highway?",
  applicantName: "plotAbuttingNationalHighway",
  employeeName: "plotAbuttingNationalHighwayEmployee"
}, {
  label: "Are you planning to use boundary material on your plot (for plots larger than 2000 sq. m)?",
  applicantName: "useBuildingMaterial",
  employeeName: "useBuildingMaterialEmployee"
}, {
  label: "Is your plot falling in funnel zone of Airport authorities/defence airport?",
  applicantName: "plotFunnelZoneAirport",
  employeeName: "plotFunnelZoneAirportEmployee"
}, {
  label: "Does your site require Land Acquisition department NOC?",
  applicantName: "landAcquisitionNOC",
  employeeName: "landAcquisitionNOCEmployee"
}, {
  label: "Does your site require Nazool department NOC?",
  applicantName: "nazoolDepartmentNOC",
  employeeName: "nazoolDepartmentNOCEmployee"
}, {
  label: "Does your site require Improvement Trust NOC?",
  applicantName: "improvementTrustNOC",
  employeeName: "improvementTrustNOCEmployee"
}, {
  label: "Does your site require NOC from Tehsil?",
  applicantName: "nocFromTehsil",
  employeeName: "nocFromTehsilEmployee"
}, {
  label: "Does your site require Property Department NOC? (Is your plot Leasehold?)",
  applicantName: "propertyDepartmentNOC",
  employeeName: "propertyDepartmentNOCEmployee"
}, {
  label: "Does your site require Ceiling department NOC?",
  applicantName: "ceilingDepartmentNOC",
  employeeName: "ceilingDepartmentNOCEmployee"
}, {
  label: "Does your site require Land Use Certificate?",
  applicantName: "landUseCertificate",
  employeeName: "landUseCertificateEmployee"
}, {
  label: "Is your proposed plot near defence area?",
  applicantName: "plotNearDefenseArea",
  employeeName: "plotNearDefenseAreaEmployee"
}, {
  label: "Is your proposed site within 100 meters of any security zone?",
  applicantName: "siteNearSecurityZone",
  employeeName: "siteNearSecurityZoneEmployee"
}, {
  label: " Is the plot situated within 30 meters of any government authority?",
  applicantName: "siteNearGovtAuthority",
  employeeName: "siteNearGovtAuthorityEmployee"
}, {
  label: "Is your proposed property affecting any Administrative revenue?",
  applicantName: "propertyAffectingRevenue",
  employeeName: "propertyAffectingRevenueEmployee"
}, {
  label: "Is your plot adjacent to UPAVP Land?",
  applicantName: "plotAdjacentUPAVP",
  employeeName: "plotAdjacentUPAVPEmployee"
}, {
  label: "Are you proposing any tourist activities on your plot?",
  applicantName: "touristActivities",
  employeeName: "touristActivitiesEmployee"
}, {
  label: "Is your plot abutting any Major road of National Capital Region?",
  applicantName: "plotAbuttingMajorRoadNCR",
  employeeName: "plotAbuttingMajorRoadNCREmployee"
}, {
  label: "Is your plot within 100 meters of a jail?",
  applicantName: "plotNearJail",
  employeeName: "plotNearJailEmployee"
}, {
  label: "Is your proposed site not a single dwelling unit and you are proposing a basement?",
  applicantName: "siteProposingBasement",
  employeeName: "siteProposingBasementEmployee"
}, {
  label: "Does your plot require an approach road from any National Highway?",
  applicantName: "plotApproachRoadNH",
  employeeName: "plotApproachRoadNHEmployee"
}, {
  label: "Is the property allotted to you directly by the authority/UPAVP?",
  applicantName: "propertyAllottedByUPAVP",
  employeeName: "propertyAllottedByUPAVPEmployee"
}, {
  label: "Do you want to attach any additional documents?",
  applicantName: "attachAdditionalDocuments",
  employeeName: "attachAdditionalDocumentsEmployee"
}, {
  label: "Does your plot require permission from Torrent Power Limited/Any other electricity service provider?",
  applicantName: "permissionElectricityProvider",
  employeeName: "permissionElectricityProviderEmployee"
}, {
  label: "Is your plot proposed for Green Building?",
  applicantName: "proposedGreenBuilding",
  employeeName: "proposedGreenBuildingEmployee"
}, {
  label: "Does your site require NOC from the Security Department?",
  applicantName: "securityDepartmentNOC",
  employeeName: "securityDepartmentNOCEmployee"
}];

const ApplicaionFormatView = forwardRef(({
  formData,
  applicationDocs,
  logoData
}, ref) => {
  var _logoData$boundary, _logoData$boundary$fi, _formData$landInfo, _formData$nocDetails, _formData$nocDetails2, _formData$description, _formData$professiona, _formData$professiona2, _formData$professiona3, _formData$professiona4, _formData$professiona5, _formData$professiona6, _formData$professiona7, _formData$description2, _formData$description3, _formData$description4, _formData$description5, _formData$description6, _formData$description7, _formData$description8, _formData$description9, _formData$description10, _formData$description11, _formData$description12, _formData$description13, _formData$description14, _formData$description15, _formData$description16, _formData$description17, _formData$description18, _formData$description19, _formData$description20, _formData$description21, _formData$description22, _formData$description23, _formData$description24, _formData$description25, _formData$description26, _formData$description27, _formData$description28, _formData$description29, _formData$landInfo2, _formData$landInfo2$o, _formData$landInfo2$o2, _formData$landInfo2$o3, _formData$landInfo3, _formData$landInfo3$o, _formData$landInfo3$o2, _formData$landInfo3$o3, _formData$description30, _formData$description31, _formData$description32, _formData$description33, _formData$description34, _formData$description35, _formData$description36, _formData$description37, _formData$description38, _formData$taxHeadEsti, _formData$taxHeadEsti2;
  const history = useHistory();
  const [logoUrl, setLogoUrl] = useState("");
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const [, applicationFlow] = useDepartmentSelector();
  const {
    t
  } = useTranslation();
  const isEmployee = history.location.pathname.includes("employee");
  const user = Digit.UserService.getUser();
  const isLowRiskCase = (formData === null || formData === void 0 ? void 0 : formData.riskType) === "LOW";
  const currentLogoId = logoData === null || logoData === void 0 ? void 0 : (_logoData$boundary = logoData.boundary) === null || _logoData$boundary === void 0 ? void 0 : (_logoData$boundary$fi = _logoData$boundary.find(item => item.name === (formData === null || formData === void 0 ? void 0 : formData.location1))) === null || _logoData$boundary$fi === void 0 ? void 0 : _logoData$boundary$fi.fileStoreId;
  const fetchLogoUrl = async () => {
    if (!currentLogoId) return;
    const result = await getDocumentByFileStoreId(currentLogoId, setIsPreviewLoading, true);
    setLogoUrl(result);
  };
  let nameOfDepartment;
  const isDA = (formData === null || formData === void 0 ? void 0 : formData.department) === "DA";
  if (isEmployee) {
    var _user$info, _formData$location;
    nameOfDepartment = (user === null || user === void 0 ? void 0 : (_user$info = user.info) === null || _user$info === void 0 ? void 0 : _user$info.tenantId) == "up.da" ? `${formData === null || formData === void 0 ? void 0 : (_formData$location = formData.location1) === null || _formData$location === void 0 ? void 0 : _formData$location.toUpperCase()} DEVELOPMENT AUTHORITY` : "AWAS EVAM VIKAS PARISHAD";
  } else {
    nameOfDepartment = applicationFlow === "DA" ? `${formData === null || formData === void 0 ? void 0 : formData.location1.toUpperCase()} DEVELOPMENT AUTHORITY` : "AWAS EVAM VIKAS PARISHAD";
  }
  const descriptionOfLand = formData === null || formData === void 0 ? void 0 : formData.descriptionOfLand;
  const owners = formData === null || formData === void 0 ? void 0 : (_formData$landInfo = formData.landInfo) === null || _formData$landInfo === void 0 ? void 0 : _formData$landInfo.owners;
  const roadWidths = descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.roadWidths;
  const khasraDetails = descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.khasraDetails;
  const approachRoadWidths = descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.approachRoadWidths;
  console.log(formData, "FromSUmmary");
  const nocApplicantData = formData === null || formData === void 0 ? void 0 : (_formData$nocDetails = formData.nocDetails) === null || _formData$nocDetails === void 0 ? void 0 : _formData$nocDetails.applicantNOCData;
  const selectedNOCs = console.log(nocApplicantData, "nocapplicant");
  const additionalNOC = formData === null || formData === void 0 ? void 0 : (_formData$nocDetails2 = formData.nocDetails) === null || _formData$nocDetails2 === void 0 ? void 0 : _formData$nocDetails2.additionalApplicantNOC;
  console.log("additionalNocs", additionalNOC);
  const isSchemeType = (formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : _formData$description.schemeType) === "Scheme";
  const StyledTableCell = styled$1(TableCell)(({
    theme
  }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#1f4a7c",
      color: theme.palette.common.white
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14
    }
  }));
  const StyledTableRow = styled$1(TableRow)(({
    theme
  }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover
    },
    "&:last-child td, &:last-child th": {
      border: 0
    }
  }));
  const accordionSummaryStyles = {
    backgroundColor: "rgb(230, 239, 248)",
    height: "1rem",
    minHeight: "48px",
    "&.Mui-expanded": {
      backgroundColor: "rgb(230, 239, 248)",
      minHeight: "48px",
      height: "1rem"
    }
  };
  const filteredDocuments = applicationDocs.filter(doc => !["applicantPhoto", "signature"].includes(doc.documentType));
  useEffect(() => {
    fetchLogoUrl();
  }, [logoData, formData]);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      backgroundColor: "#ffffff"
    },
    ref: ref
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      padding: "5px",
      background: "rgb(230, 239, 248)"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      background: "white",
      borderRadius: "50%"
    }
  }, /*#__PURE__*/React__default.createElement("img", {
    width: "60",
    height: "30",
    src: logoUrl,
    alt: "Uttar-Pradesh-Logo"
  })), /*#__PURE__*/React__default.createElement("div", {
    style: {
      color: "#1f4a7c"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginLeft: "12px",
      fontSize: "1.25rem",
      fontWeight: "600",
      fontFamily: "Montserrat"
    }
  }, nameOfDepartment), /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginLeft: "12px",
      fontFamily: "Montserrat",
      fontWeight: "500"
    }
  }, "Government of Uttar Pradesh"))), /*#__PURE__*/React__default.createElement("div", {
    className: "container1",
    style: {
      width: "100%",
      marginTop: "1rem"
    }
  }, (formData === null || formData === void 0 ? void 0 : formData.land_Id) && /*#__PURE__*/React__default.createElement(Card$3, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(Accordion, {
    defaultExpanded: true
  }, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null),
    sx: accordionSummaryStyles
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Land Id"))), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", null, " ", /*#__PURE__*/React__default.createElement("b", null, "FASTPAS ID : "), /*#__PURE__*/React__default.createElement("span", {
    style: {
      marginLeft: "1rem"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.land_Id)))))), /*#__PURE__*/React__default.createElement(Card$3, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(Accordion, {
    defaultExpanded: true
  }, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null),
    sx: accordionSummaryStyles
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Verifying Authority"))), /*#__PURE__*/React__default.createElement(AccordionDetails, null, isDA ? /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "20%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Selected Office : ")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "20%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.selectedOffice)))) : /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, (formData === null || formData === void 0 ? void 0 : formData.selectedUnit) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Selected Unit:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData.selectedUnit)), (formData === null || formData === void 0 ? void 0 : formData.selectedCity) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Selected City:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData.selectedCity))))))))), /*#__PURE__*/React__default.createElement(Card$3, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(Accordion, {
    defaultExpanded: true
  }, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null),
    sx: accordionSummaryStyles
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Owner Information"))), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("div", null, owners === null || owners === void 0 ? void 0 : owners.map((item, index) => {
    var _item$correspondenceA, _item$correspondenceA2, _item$correspondenceA3, _item$correspondenceA4, _item$correspondenceA5, _item$correspondenceA6;
    return /*#__PURE__*/React__default.createElement("div", {
      key: index,
      style: {
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        marginTop: "15px",
        marginBottom: "15px",
        paddingBottom: "15px"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        flex: "1 1 calc(50% - 10px)",
        marginRight: "10px"
      }
    }, /*#__PURE__*/React__default.createElement("table", {
      style: {
        width: "100%",
        borderCollapse: "collapse"
      }
    }, /*#__PURE__*/React__default.createElement("tbody", null, (item === null || item === void 0 ? void 0 : item.name) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Name :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : item.name)), (item === null || item === void 0 ? void 0 : item.fatherOrHusbandName) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Father Name :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : item.fatherOrHusbandName)), (item === null || item === void 0 ? void 0 : item.mobileNumber) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Mobile Number :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : item.mobileNumber)), (item === null || item === void 0 ? void 0 : item.aadhaarNumber) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Aadhaar Number :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : item.aadhaarNumber)), (formData === null || formData === void 0 ? void 0 : formData.applicationNo) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Application Number :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, formData === null || formData === void 0 ? void 0 : formData.applicationNo)), (item === null || item === void 0 ? void 0 : item.gender) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Gender :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : item.gender)), (item === null || item === void 0 ? void 0 : item.emailId) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "E-mail ID :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : item.emailId)), (item === null || item === void 0 ? void 0 : (_item$correspondenceA = item.correspondenceAddress) === null || _item$correspondenceA === void 0 ? void 0 : _item$correspondenceA.state) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "State :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : (_item$correspondenceA2 = item.correspondenceAddress) === null || _item$correspondenceA2 === void 0 ? void 0 : _item$correspondenceA2.state)), (item === null || item === void 0 ? void 0 : item.address) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Address :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : item.address)), (item === null || item === void 0 ? void 0 : (_item$correspondenceA3 = item.correspondenceAddress) === null || _item$correspondenceA3 === void 0 ? void 0 : _item$correspondenceA3.pinno) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Pin Code :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : (_item$correspondenceA4 = item.correspondenceAddress) === null || _item$correspondenceA4 === void 0 ? void 0 : _item$correspondenceA4.pinno)), (item === null || item === void 0 ? void 0 : (_item$correspondenceA5 = item.correspondenceAddress) === null || _item$correspondenceA5 === void 0 ? void 0 : _item$correspondenceA5.town) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "District :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : (_item$correspondenceA6 = item.correspondenceAddress) === null || _item$correspondenceA6 === void 0 ? void 0 : _item$correspondenceA6.town)), (item === null || item === void 0 ? void 0 : item.statusType) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Applicant Status :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : item.statusType)), (item === null || item === void 0 ? void 0 : item.remarks) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Remarks :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : item.remarks))))), (item === null || item === void 0 ? void 0 : item.photo) && /*#__PURE__*/React__default.createElement("div", {
      style: {
        flex: "1 1 calc(50% - 10px)",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-around",
        alignItems: "center",
        padding: "24px"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "row",
      style: {
        marginBottom: "10px"
      }
    }, item !== null && item !== void 0 && item.photo ? /*#__PURE__*/React__default.createElement("img", {
      style: {
        width: "200px",
        height: "180px",
        objectFit: "cover"
      },
      src: item === null || item === void 0 ? void 0 : item.photo,
      alt: "image",
      className: "img-thumbnail"
    }) : /*#__PURE__*/React__default.createElement(Avatar$1, {
      style: {
        width: "200px",
        height: "80px"
      }
    }, item === null || item === void 0 ? void 0 : item.photo)), /*#__PURE__*/React__default.createElement("div", {
      className: "row",
      style: {
        marginBottom: "10px",
        marginTop: "80px"
      }
    }, item !== null && item !== void 0 && item.signature ? /*#__PURE__*/React__default.createElement("img", {
      style: {
        width: "200px",
        height: "80px"
      },
      src: item === null || item === void 0 ? void 0 : item.signature,
      alt: "signature",
      className: "img-thumbnail"
    }) : /*#__PURE__*/React__default.createElement(BorderColorIcon, {
      style: {
        width: "70px",
        height: "25px"
      }
    }, item === null || item === void 0 ? void 0 : item.signature))));
  }))))))), /*#__PURE__*/React__default.createElement(Card$3, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(Accordion, {
    defaultExpanded: true
  }, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null),
    sx: accordionSummaryStyles
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Licensed Technical Professional (LTP) Information"))), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, (formData === null || formData === void 0 ? void 0 : (_formData$professiona = formData.professionalInformation) === null || _formData$professiona === void 0 ? void 0 : _formData$professiona.consultantCategory) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Consultant Category :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData.professionalInformation.consultantCategory)), (formData === null || formData === void 0 ? void 0 : (_formData$professiona2 = formData.professionalInformation) === null || _formData$professiona2 === void 0 ? void 0 : _formData$professiona2.name) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Name :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData.professionalInformation.name)), (formData === null || formData === void 0 ? void 0 : (_formData$professiona3 = formData.professionalInformation) === null || _formData$professiona3 === void 0 ? void 0 : _formData$professiona3.planDate) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Validity :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData.professionalInformation.planDate)), (formData === null || formData === void 0 ? void 0 : (_formData$professiona4 = formData.professionalInformation) === null || _formData$professiona4 === void 0 ? void 0 : _formData$professiona4.mobileNumber) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Mobile No. :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData.professionalInformation.mobileNumber)), (formData === null || formData === void 0 ? void 0 : (_formData$professiona5 = formData.professionalInformation) === null || _formData$professiona5 === void 0 ? void 0 : _formData$professiona5.certificateNumber) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Certificate No. :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData.professionalInformation.certificateNumber)), (formData === null || formData === void 0 ? void 0 : (_formData$professiona6 = formData.professionalInformation) === null || _formData$professiona6 === void 0 ? void 0 : _formData$professiona6.licenseNumber) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "License No :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData.professionalInformation.licenseNumber)), (formData === null || formData === void 0 ? void 0 : (_formData$professiona7 = formData.professionalInformation) === null || _formData$professiona7 === void 0 ? void 0 : _formData$professiona7.emailId) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "E-mail Id :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData.professionalInformation.emailId))))))))), /*#__PURE__*/React__default.createElement(Card$3, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(Accordion, {
    defaultExpanded: true
  }, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null),
    sx: accordionSummaryStyles
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Land Information"))), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      margin: "0px 4px",
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, (formData === null || formData === void 0 ? void 0 : (_formData$description2 = formData.descriptionOfLand) === null || _formData$description2 === void 0 ? void 0 : _formData$description2.schemeType) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Scheme Type :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$description3 = formData.descriptionOfLand) === null || _formData$description3 === void 0 ? void 0 : _formData$description3.schemeType) || "")), (formData === null || formData === void 0 ? void 0 : (_formData$description4 = formData.descriptionOfLand) === null || _formData$description4 === void 0 ? void 0 : _formData$description4.planOn) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Plan on :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$description5 = formData.descriptionOfLand) === null || _formData$description5 === void 0 ? void 0 : _formData$description5.planOn) || "")), (formData === null || formData === void 0 ? void 0 : (_formData$description6 = formData.descriptionOfLand) === null || _formData$description6 === void 0 ? void 0 : _formData$description6.schemeName) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Scheme Name :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$description7 = formData.descriptionOfLand) === null || _formData$description7 === void 0 ? void 0 : _formData$description7.schemeName) || "")), (formData === null || formData === void 0 ? void 0 : (_formData$description8 = formData.descriptionOfLand) === null || _formData$description8 === void 0 ? void 0 : _formData$description8.sectorNo) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Sector No. :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$description9 = formData.descriptionOfLand) === null || _formData$description9 === void 0 ? void 0 : _formData$description9.sectorNo) || "")), (formData === null || formData === void 0 ? void 0 : (_formData$description10 = formData.descriptionOfLand) === null || _formData$description10 === void 0 ? void 0 : _formData$description10.developmentArea) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Development Area :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$description11 = formData.descriptionOfLand) === null || _formData$description11 === void 0 ? void 0 : _formData$description11.developmentArea) || "")), (formData === null || formData === void 0 ? void 0 : (_formData$description12 = formData.descriptionOfLand) === null || _formData$description12 === void 0 ? void 0 : _formData$description12.activityAsPerMap) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Primary Use of Proposed Activity :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$description13 = formData.descriptionOfLand) === null || _formData$description13 === void 0 ? void 0 : _formData$description13.activityAsPerMap) || "")), (formData === null || formData === void 0 ? void 0 : (_formData$description14 = formData.descriptionOfLand) === null || _formData$description14 === void 0 ? void 0 : _formData$description14.activityProposed) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Activity Proposed :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$description15 = formData.descriptionOfLand) === null || _formData$description15 === void 0 ? void 0 : _formData$description15.activityProposed) || "")), (formData === null || formData === void 0 ? void 0 : (_formData$description16 = formData.descriptionOfLand) === null || _formData$description16 === void 0 ? void 0 : _formData$description16.selectLandUse) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Permissibility of Activities :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$description17 = formData.descriptionOfLand) === null || _formData$description17 === void 0 ? void 0 : _formData$description17.selectLandUse) || "")), (formData === null || formData === void 0 ? void 0 : (_formData$description18 = formData.descriptionOfLand) === null || _formData$description18 === void 0 ? void 0 : _formData$description18.proposedActivity) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Proposed Activity as per Zoning Regulation :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$description19 = formData.descriptionOfLand) === null || _formData$description19 === void 0 ? void 0 : _formData$description19.proposedActivity) || "")), (formData === null || formData === void 0 ? void 0 : (_formData$description20 = formData.descriptionOfLand) === null || _formData$description20 === void 0 ? void 0 : _formData$description20.landUsesType) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, (formData === null || formData === void 0 ? void 0 : (_formData$description21 = formData.descriptionOfLand) === null || _formData$description21 === void 0 ? void 0 : _formData$description21.schemeType) === "Scheme" ? "Land Use as per Layout Plan :" : "Land Use as per Master Plan :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$description22 = formData.descriptionOfLand) === null || _formData$description22 === void 0 ? void 0 : _formData$description22.landUsesType) || "")), (formData === null || formData === void 0 ? void 0 : (_formData$description23 = formData.descriptionOfLand) === null || _formData$description23 === void 0 ? void 0 : _formData$description23.subLandUseAsPerLayout) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, (formData === null || formData === void 0 ? void 0 : (_formData$description24 = formData.descriptionOfLand) === null || _formData$description24 === void 0 ? void 0 : _formData$description24.schemeType) === "Scheme" ? "Land Sub Use as per Layout :" : "Land Use as per Master Plan :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$description25 = formData.descriptionOfLand) === null || _formData$description25 === void 0 ? void 0 : _formData$description25.subLandUseAsPerLayout) || "")), (formData === null || formData === void 0 ? void 0 : (_formData$description26 = formData.descriptionOfLand) === null || _formData$description26 === void 0 ? void 0 : _formData$description26.otherMasterPlan) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Other Master Layout Plan :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$description27 = formData.descriptionOfLand) === null || _formData$description27 === void 0 ? void 0 : _formData$description27.otherMasterPlan) || "")), (formData === null || formData === void 0 ? void 0 : (_formData$description28 = formData.descriptionOfLand) === null || _formData$description28 === void 0 ? void 0 : _formData$description28.selectLandUse) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Permissibility of Activities :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$description29 = formData.descriptionOfLand) === null || _formData$description29 === void 0 ? void 0 : _formData$description29.selectLandUse) || "")), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.blockNo) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Block No./Name :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.blockNo) || "")), (formData === null || formData === void 0 ? void 0 : (_formData$landInfo2 = formData.landInfo) === null || _formData$landInfo2 === void 0 ? void 0 : (_formData$landInfo2$o = _formData$landInfo2.owners) === null || _formData$landInfo2$o === void 0 ? void 0 : (_formData$landInfo2$o2 = _formData$landInfo2$o[0]) === null || _formData$landInfo2$o2 === void 0 ? void 0 : (_formData$landInfo2$o3 = _formData$landInfo2$o2.permanentAddress) === null || _formData$landInfo2$o3 === void 0 ? void 0 : _formData$landInfo2$o3.district) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_DISTRICT"), " :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$landInfo3 = formData.landInfo) === null || _formData$landInfo3 === void 0 ? void 0 : (_formData$landInfo3$o = _formData$landInfo3.owners) === null || _formData$landInfo3$o === void 0 ? void 0 : (_formData$landInfo3$o2 = _formData$landInfo3$o[0]) === null || _formData$landInfo3$o2 === void 0 ? void 0 : (_formData$landInfo3$o3 = _formData$landInfo3$o2.permanentAddress) === null || _formData$landInfo3$o3 === void 0 ? void 0 : _formData$landInfo3$o3.district) || "")), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.plotFront) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Front Width (M) :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.plotFront) || "")), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.plotRear) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Rear Width (M) :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.plotRear) || "")), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.plotSide1) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Side Width 1 :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.plotSide1) || "")), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.plotSide2) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Side Width 2 :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.plotSide2) || "")), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.khatauniNo) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Khatauni No. :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.khatauniNo) || "")), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.khataNo) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Khata No. :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.khataNo) || "")), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.plotNo) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Plot No. :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.plotNo) || "")), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.landWidth) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Land Width :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.landWidth) || "")), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.landLength) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Land Length :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.landLength) || "")), (khasraDetails === null || khasraDetails === void 0 ? void 0 : khasraDetails.length) > 0 && !isSchemeType && khasraDetails.map((item, index) => /*#__PURE__*/React__default.createElement(React__default.Fragment, {
    key: index
  }, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "District ", index + 1, " :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, item.district || "")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Tehsil ", index + 1, " :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, item.tehsil || "")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Village ", index + 1, " :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, item.village || "")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Plot No. ", index + 1, " :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, item.plotNo || "")))), (formData === null || formData === void 0 ? void 0 : (_formData$description30 = formData.descriptionOfLand) === null || _formData$description30 === void 0 ? void 0 : _formData$description30.plotAreaDoc) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Plot Area (as per document) (sq. m) :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : (_formData$description31 = formData.descriptionOfLand) === null || _formData$description31 === void 0 ? void 0 : _formData$description31.plotAreaDoc)), (formData === null || formData === void 0 ? void 0 : (_formData$description32 = formData.descriptionOfLand) === null || _formData$description32 === void 0 ? void 0 : _formData$description32.landArea) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Plot Area (as per site) (sq. m) :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : (_formData$description33 = formData.descriptionOfLand) === null || _formData$description33 === void 0 ? void 0 : _formData$description33.landArea)), (formData === null || formData === void 0 ? void 0 : (_formData$description34 = formData.descriptionOfLand) === null || _formData$description34 === void 0 ? void 0 : _formData$description34.plotAreaPossession) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Plot Area (as per possession) (sq. m) :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : (_formData$description35 = formData.descriptionOfLand) === null || _formData$description35 === void 0 ? void 0 : _formData$description35.plotAreaPossession)), (roadWidths === null || roadWidths === void 0 ? void 0 : roadWidths.length) > 0 && roadWidths.map((road, index) => /*#__PURE__*/React__default.createElement("tr", {
    key: index
  }, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Road Width (Existing) (m) :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, road.value || ""))), (approachRoadWidths === null || approachRoadWidths === void 0 ? void 0 : approachRoadWidths.length) > 0 && approachRoadWidths.map((road, index) => /*#__PURE__*/React__default.createElement("tr", {
    key: index
  }, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Road Width (as per the respective plan) (m) :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, road.value || ""))), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.landMark) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Nearby Landmark :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.landMark) || "")), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.landAddress) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Land Address :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.landAddress) || "")))))))), /*#__PURE__*/React__default.createElement(Card$3, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(Accordion, {
    defaultExpanded: true
  }, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null),
    sx: accordionSummaryStyles
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Documents Section"), " ")), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement(BPADocumentsPreview, {
    documents: getOrderDocuments(filteredDocuments),
    svgStyles: {},
    isSendBackFlow: false,
    isHrLine: true,
    titleStyles: {
      fontSize: "18px",
      lineHeight: "24px",
      fontWeight: 700,
      marginBottom: "10px"
    }
  }))))), ((descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.latitude) || (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.googleMapLocation)) && /*#__PURE__*/React__default.createElement(Card$3, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(Accordion, {
    defaultExpanded: true
  }, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null),
    sx: accordionSummaryStyles
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Location Information"))), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.latitude) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Map Coordinates:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, "Latitude: ", descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.latitude, ", Longitude: ", descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.longitude)), (formData === null || formData === void 0 ? void 0 : (_formData$description36 = formData.descriptionOfLand) === null || _formData$description36 === void 0 ? void 0 : _formData$description36.googleMapLocation) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Map Location:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : (_formData$description37 = formData.descriptionOfLand) === null || _formData$description37 === void 0 ? void 0 : _formData$description37.googleMapLocation))))))))), (nocApplicantData || additionalNOC) && !isLowRiskCase && /*#__PURE__*/React__default.createElement(Card$3, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(Accordion, {
    defaultExpanded: true
  }, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null),
    sx: accordionSummaryStyles
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("BPA_MY_APPLICATIONS_LANDUSENOC")))), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, questions.filter(questionItem => nocApplicantData[questionItem.applicantName] === true).map((questionItem, index) => {
    const {
      label,
      applicantName
    } = questionItem;
    const answer = nocApplicantData[applicantName] ? "Yes" : "No";
    console.log("fromMap", answer, label, questions.filter(questionItem => nocApplicantData[questionItem.applicantName] === true));
    return /*#__PURE__*/React__default.createElement("tr", {
      key: index
    }, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "70%",
        textAlign: "left",
        padding: "8px"
      }
    }, label), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "30%",
        textAlign: "center",
        padding: "8px"
      }
    }, answer));
  }), additionalNOC === null || additionalNOC === void 0 ? void 0 : additionalNOC.map((item, index) => {
    return /*#__PURE__*/React__default.createElement("tr", {
      key: index
    }, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "70%",
        textAlign: "left",
        padding: "8px"
      }
    }, item.value), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "30%",
        textAlign: "center",
        padding: "8px"
      }
    }, "Yes"));
  })))))))), !((formData === null || formData === void 0 ? void 0 : (_formData$description38 = formData.descriptionOfLand) === null || _formData$description38 === void 0 ? void 0 : _formData$description38.schemeType) == "Scheme") && /*#__PURE__*/React__default.createElement(Card$3, {
    className: "formContainer"
  }, " ", /*#__PURE__*/React__default.createElement(Accordion, {
    defaultExpanded: true
  }, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null),
    sx: accordionSummaryStyles
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Processing Fee for Land Use Verification"))), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Total Amount"), /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginLeft: "1rem"
    }
  }, /*#__PURE__*/React__default.createElement("span", null, "\u20B9 ", formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti = formData.taxHeadEstimate) === null || _formData$taxHeadEsti === void 0 ? void 0 : (_formData$taxHeadEsti2 = _formData$taxHeadEsti[0]) === null || _formData$taxHeadEsti2 === void 0 ? void 0 : _formData$taxHeadEsti2.estimateAmount))))))))));
});

const NOCCheckList = ({
  checklist
}) => {
  var _checklist$buildupAre, _checklist$buildupAre2, _checklist$buildupAre3, _checklist$buildupAre4, _checklist$farNOC, _checklist$farNOC2, _checklist$farNOC3, _checklist$farNOC4, _checklist$coverageNO, _checklist$coverageNO2, _checklist$coverageNO3, _checklist$coverageNO4, _checklist$regulateds, _checklist$setBacks, _checklist$setBacks_r, _checklist$regulateds2, _checklist$setBacks2, _checklist$setBacks_r2, _checklist$regulateds3, _checklist$setBacks3, _checklist$setBacks_r3, _checklist$regulateds4, _checklist$setBacks4, _checklist$setBacks_r4, _checklist$numberOfSt, _checklist$numberOfSt2, _checklist$numberOfSt3, _checklist$numberOfSt4, _checklist$pathDevelo, _checklist$pathDevelo2, _checklist$pathDevelo3, _checklist$pathDevelo4, _checklist$parkingPro, _checklist$parkingPro2, _checklist$parkingPro3, _checklist$parkingPro4, _checklist$htLineNOC, _checklist$htLineNOC2, _checklist$htLineNOC3, _checklist$htLineNOC4, _checklist$provisionO, _checklist$provisionO2, _checklist$provisionO3, _checklist$provisionO4, _checklist$barrierfre, _checklist$barrierfre2, _checklist$barrierfre3, _checklist$barrierfre4, _checklist$provisionR, _checklist$provisionR2, _checklist$provisionR3, _checklist$provisionR4, _checklist$numberOfDw, _checklist$numberOfDw2, _checklist$numberOfDw3, _checklist$numberOfDw4, _checklist$maxHillCut, _checklist$maxHillCut2, _checklist$maxHillCut3, _checklist$maxHillCut4, _checklist$sewerNOC, _checklist$sewerNOC2, _checklist$sewerNOC3, _checklist$sewerNOC4, _checklist$septicNOC, _checklist$septicNOC2, _checklist$septicNOC3, _checklist$septicNOC4, _checklist$heightOfSl, _checklist$heightOfSl2, _checklist$heightOfSl3, _checklist$heightOfSl4, _checklist$plinthHeig, _checklist$plinthHeig2, _checklist$plinthHeig3, _checklist$plinthHeig4, _checklist$closedFloo, _checklist$closedFloo2, _checklist$closedFloo3, _checklist$closedFloo4, _checklist$retainingw, _checklist$retainingw2, _checklist$retainingw3, _checklist$retainingw4, _checklist$boundaryWa, _checklist$boundaryWa2, _checklist$boundaryWa3, _checklist$boundaryWa4, _checklist$aboveValle, _checklist$aboveValle2, _checklist$aboveValle3, _checklist$aboveValle4;
  const url = window.location.href;
  const isStructuralOrEmployee = url.includes("structural") || url.includes("employee");
  return /*#__PURE__*/React__default.createElement("section", {
    className: "container1"
  }, /*#__PURE__*/React__default.createElement("form", null, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Checklist")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement(Table$3, {
    striped: true,
    bordered: true,
    className: "m-0",
    style: {
      width: isStructuralOrEmployee ? '82%' : '100%'
    }
  }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
    style: {
      minWidth: 'fit-content'
    }
  }, "Sr.", /*#__PURE__*/React__default.createElement("br", null), "No."), /*#__PURE__*/React__default.createElement("th", {
    style: {
      minWidth: 'fit-content'
    }
  }, "Description"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      minWidth: 'fit-content'
    }
  }, "Detail of Regulation as per provision"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      minWidth: 'fit-content'
    }
  }, "Detail of Regualtion as per approved plan"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      minWidth: 'fit-content'
    }
  }, "Provision made as per approved plan"), /*#__PURE__*/React__default.createElement("th", {
    style: {
      minWidth: 'fit-content'
    }
  }, "Remarks"))), /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "1"), /*#__PURE__*/React__default.createElement("td", null, "Built up Area"), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$buildupAre = checklist.buildupAreaNOC) === null || _checklist$buildupAre === void 0 ? void 0 : _checklist$buildupAre.regulated), /*#__PURE__*/React__default.createElement("td", null, (checklist === null || checklist === void 0 ? void 0 : (_checklist$buildupAre2 = checklist.buildupAreaNOC) === null || _checklist$buildupAre2 === void 0 ? void 0 : _checklist$buildupAre2.proposed) || (checklist === null || checklist === void 0 ? void 0 : checklist.builtupArea)), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$buildupAre3 = checklist.buildupAreaNOC) === null || _checklist$buildupAre3 === void 0 ? void 0 : _checklist$buildupAre3.relaxation), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$buildupAre4 = checklist.buildupAreaNOC) === null || _checklist$buildupAre4 === void 0 ? void 0 : _checklist$buildupAre4.remarks)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "2"), /*#__PURE__*/React__default.createElement("td", null, "FAR"), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$farNOC = checklist.farNOC) === null || _checklist$farNOC === void 0 ? void 0 : _checklist$farNOC.regulated), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$farNOC2 = checklist.farNOC) === null || _checklist$farNOC2 === void 0 ? void 0 : _checklist$farNOC2.proposed), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$farNOC3 = checklist.farNOC) === null || _checklist$farNOC3 === void 0 ? void 0 : _checklist$farNOC3.relaxation), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$farNOC4 = checklist.farNOC) === null || _checklist$farNOC4 === void 0 ? void 0 : _checklist$farNOC4.remarks)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "3"), /*#__PURE__*/React__default.createElement("td", null, "% Coverage"), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$coverageNO = checklist.coverageNOC) === null || _checklist$coverageNO === void 0 ? void 0 : _checklist$coverageNO.regulated), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$coverageNO2 = checklist.coverageNOC) === null || _checklist$coverageNO2 === void 0 ? void 0 : _checklist$coverageNO2.proposed), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$coverageNO3 = checklist.coverageNOC) === null || _checklist$coverageNO3 === void 0 ? void 0 : _checklist$coverageNO3.relaxation), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$coverageNO4 = checklist.coverageNOC) === null || _checklist$coverageNO4 === void 0 ? void 0 : _checklist$coverageNO4.remarks)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    rowSpan: 5,
    style: {
      verticalAlign: 'top'
    }
  }, "4"), /*#__PURE__*/React__default.createElement("td", null, "Setbacks(meter)"), /*#__PURE__*/React__default.createElement("td", null, "\xA0"), /*#__PURE__*/React__default.createElement("td", null, "\xA0"), /*#__PURE__*/React__default.createElement("td", null, "\xA0")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Front"), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$regulateds = checklist.regulatedsetBacks) === null || _checklist$regulateds === void 0 ? void 0 : _checklist$regulateds.front), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$setBacks = checklist.setBacks) === null || _checklist$setBacks === void 0 ? void 0 : _checklist$setBacks.front), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$setBacks_r = checklist.setBacks_relaxation_NOC) === null || _checklist$setBacks_r === void 0 ? void 0 : _checklist$setBacks_r.front), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : checklist.setBacks_remarks)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Rear"), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$regulateds2 = checklist.regulatedsetBacks) === null || _checklist$regulateds2 === void 0 ? void 0 : _checklist$regulateds2.rear), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$setBacks2 = checklist.setBacks) === null || _checklist$setBacks2 === void 0 ? void 0 : _checklist$setBacks2.rear), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$setBacks_r2 = checklist.setBacks_relaxation_NOC) === null || _checklist$setBacks_r2 === void 0 ? void 0 : _checklist$setBacks_r2.rear), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : checklist.setBacks_remarks)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Left Side"), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$regulateds3 = checklist.regulatedsetBacks) === null || _checklist$regulateds3 === void 0 ? void 0 : _checklist$regulateds3.left), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$setBacks3 = checklist.setBacks) === null || _checklist$setBacks3 === void 0 ? void 0 : _checklist$setBacks3.left), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$setBacks_r3 = checklist.setBacks_relaxation_NOC) === null || _checklist$setBacks_r3 === void 0 ? void 0 : _checklist$setBacks_r3.left), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : checklist.setBacks_remarks)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "Right Side"), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$regulateds4 = checklist.regulatedsetBacks) === null || _checklist$regulateds4 === void 0 ? void 0 : _checklist$regulateds4.right), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$setBacks4 = checklist.setBacks) === null || _checklist$setBacks4 === void 0 ? void 0 : _checklist$setBacks4.right), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$setBacks_r4 = checklist.setBacks_relaxation_NOC) === null || _checklist$setBacks_r4 === void 0 ? void 0 : _checklist$setBacks_r4.right), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : checklist.setBacks_remarks)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "5"), /*#__PURE__*/React__default.createElement("td", null, "No of Storeys"), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$numberOfSt = checklist.numberOfStoreysNOC) === null || _checklist$numberOfSt === void 0 ? void 0 : _checklist$numberOfSt.regulated), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$numberOfSt2 = checklist.numberOfStoreysNOC) === null || _checklist$numberOfSt2 === void 0 ? void 0 : _checklist$numberOfSt2.proposed), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$numberOfSt3 = checklist.numberOfStoreysNOC) === null || _checklist$numberOfSt3 === void 0 ? void 0 : _checklist$numberOfSt3.relaxation), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$numberOfSt4 = checklist.numberOfStoreysNOC) === null || _checklist$numberOfSt4 === void 0 ? void 0 : _checklist$numberOfSt4.remarks)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "6"), /*#__PURE__*/React__default.createElement("td", null, "Roads/Path exist at a site (Whether path develop at the site or not)"), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$pathDevelo = checklist.pathDevelopNOC) === null || _checklist$pathDevelo === void 0 ? void 0 : _checklist$pathDevelo.regulated), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$pathDevelo2 = checklist.pathDevelopNOC) === null || _checklist$pathDevelo2 === void 0 ? void 0 : _checklist$pathDevelo2.proposed), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$pathDevelo3 = checklist.pathDevelopNOC) === null || _checklist$pathDevelo3 === void 0 ? void 0 : _checklist$pathDevelo3.relaxation), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$pathDevelo4 = checklist.pathDevelopNOC) === null || _checklist$pathDevelo4 === void 0 ? void 0 : _checklist$pathDevelo4.remarks)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "7"), /*#__PURE__*/React__default.createElement("td", null, "Parking Provision"), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$parkingPro = checklist.parkingProvisionNOC) === null || _checklist$parkingPro === void 0 ? void 0 : _checklist$parkingPro.regulated), /*#__PURE__*/React__default.createElement("td", null, (checklist === null || checklist === void 0 ? void 0 : (_checklist$parkingPro2 = checklist.parkingProvisionNOC) === null || _checklist$parkingPro2 === void 0 ? void 0 : _checklist$parkingPro2.proposed) || (checklist === null || checklist === void 0 ? void 0 : checklist.parkingProvision)), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$parkingPro3 = checklist.parkingProvisionNOC) === null || _checklist$parkingPro3 === void 0 ? void 0 : _checklist$parkingPro3.relaxation), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$parkingPro4 = checklist.parkingProvisionNOC) === null || _checklist$parkingPro4 === void 0 ? void 0 : _checklist$parkingPro4.remarks)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "8"), /*#__PURE__*/React__default.createElement("td", null, "Whether any HT/LT line crossing over the proposed land"), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$htLineNOC = checklist.htLineNOC) === null || _checklist$htLineNOC === void 0 ? void 0 : _checklist$htLineNOC.regulated), /*#__PURE__*/React__default.createElement("td", null, (checklist === null || checklist === void 0 ? void 0 : (_checklist$htLineNOC2 = checklist.htLineNOC) === null || _checklist$htLineNOC2 === void 0 ? void 0 : _checklist$htLineNOC2.proposed) || (checklist === null || checklist === void 0 ? void 0 : checklist.whetherHtLtLineCrossing)), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$htLineNOC3 = checklist.htLineNOC) === null || _checklist$htLineNOC3 === void 0 ? void 0 : _checklist$htLineNOC3.relaxation), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$htLineNOC4 = checklist.htLineNOC) === null || _checklist$htLineNOC4 === void 0 ? void 0 : _checklist$htLineNOC4.remarks)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "9"), /*#__PURE__*/React__default.createElement("td", null, "Provision for solar passive building technology made or not"), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$provisionO = checklist.provisionOfSolarNOC) === null || _checklist$provisionO === void 0 ? void 0 : _checklist$provisionO.regulated), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$provisionO2 = checklist.provisionOfSolarNOC) === null || _checklist$provisionO2 === void 0 ? void 0 : _checklist$provisionO2.proposed), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$provisionO3 = checklist.provisionOfSolarNOC) === null || _checklist$provisionO3 === void 0 ? void 0 : _checklist$provisionO3.relaxation), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$provisionO4 = checklist.provisionOfSolarNOC) === null || _checklist$provisionO4 === void 0 ? void 0 : _checklist$provisionO4.remarks)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "10"), /*#__PURE__*/React__default.createElement("td", null, "Provision of barrier-free access for person"), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$barrierfre = checklist.barrierfreeNOC) === null || _checklist$barrierfre === void 0 ? void 0 : _checklist$barrierfre.regulated), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$barrierfre2 = checklist.barrierfreeNOC) === null || _checklist$barrierfre2 === void 0 ? void 0 : _checklist$barrierfre2.proposed), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$barrierfre3 = checklist.barrierfreeNOC) === null || _checklist$barrierfre3 === void 0 ? void 0 : _checklist$barrierfre3.relaxation), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$barrierfre4 = checklist.barrierfreeNOC) === null || _checklist$barrierfre4 === void 0 ? void 0 : _checklist$barrierfre4.remarks)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "11"), /*#__PURE__*/React__default.createElement("td", null, "Provision of rainwater harvesting tank (optional in case of the building having a roof area less than 200 Sqm) Connectivity to the rainwater harvesting tank."), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$provisionR = checklist.provisionRainWaterHarvestingNOC) === null || _checklist$provisionR === void 0 ? void 0 : _checklist$provisionR.regulated), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$provisionR2 = checklist.provisionRainWaterHarvestingNOC) === null || _checklist$provisionR2 === void 0 ? void 0 : _checklist$provisionR2.proposed), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$provisionR3 = checklist.provisionRainWaterHarvestingNOC) === null || _checklist$provisionR3 === void 0 ? void 0 : _checklist$provisionR3.relaxation), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$provisionR4 = checklist.provisionRainWaterHarvestingNOC) === null || _checklist$provisionR4 === void 0 ? void 0 : _checklist$provisionR4.remarks)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "12"), /*#__PURE__*/React__default.createElement("td", null, "Number of Dwelling Units"), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$numberOfDw = checklist.numberOfDwellingUnitsNOC) === null || _checklist$numberOfDw === void 0 ? void 0 : _checklist$numberOfDw.regulated), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$numberOfDw2 = checklist.numberOfDwellingUnitsNOC) === null || _checklist$numberOfDw2 === void 0 ? void 0 : _checklist$numberOfDw2.proposed), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$numberOfDw3 = checklist.numberOfDwellingUnitsNOC) === null || _checklist$numberOfDw3 === void 0 ? void 0 : _checklist$numberOfDw3.relaxation), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$numberOfDw4 = checklist.numberOfDwellingUnitsNOC) === null || _checklist$numberOfDw4 === void 0 ? void 0 : _checklist$numberOfDw4.remarks)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "13"), /*#__PURE__*/React__default.createElement("td", null, "Maximum Hill Cut"), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$maxHillCut = checklist.maxHillCutNOC) === null || _checklist$maxHillCut === void 0 ? void 0 : _checklist$maxHillCut.regulated), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$maxHillCut2 = checklist.maxHillCutNOC) === null || _checklist$maxHillCut2 === void 0 ? void 0 : _checklist$maxHillCut2.proposed), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$maxHillCut3 = checklist.maxHillCutNOC) === null || _checklist$maxHillCut3 === void 0 ? void 0 : _checklist$maxHillCut3.relaxation), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$maxHillCut4 = checklist.maxHillCutNOC) === null || _checklist$maxHillCut4 === void 0 ? void 0 : _checklist$maxHillCut4.remarks)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "14"), /*#__PURE__*/React__default.createElement("td", null, "Whether sewer exists in the vicinity or not. Connectivity to the sewer line."), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$sewerNOC = checklist.sewerNOC) === null || _checklist$sewerNOC === void 0 ? void 0 : _checklist$sewerNOC.regulated), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$sewerNOC2 = checklist.sewerNOC) === null || _checklist$sewerNOC2 === void 0 ? void 0 : _checklist$sewerNOC2.proposed), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$sewerNOC3 = checklist.sewerNOC) === null || _checklist$sewerNOC3 === void 0 ? void 0 : _checklist$sewerNOC3.relaxation), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$sewerNOC4 = checklist.sewerNOC) === null || _checklist$sewerNOC4 === void 0 ? void 0 : _checklist$sewerNOC4.remarks)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "15"), /*#__PURE__*/React__default.createElement("td", null, "Provision of Septic tank"), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$septicNOC = checklist.septicNOC) === null || _checklist$septicNOC === void 0 ? void 0 : _checklist$septicNOC.regulated), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$septicNOC2 = checklist.septicNOC) === null || _checklist$septicNOC2 === void 0 ? void 0 : _checklist$septicNOC2.proposed), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$septicNOC3 = checklist.septicNOC) === null || _checklist$septicNOC3 === void 0 ? void 0 : _checklist$septicNOC3.relaxation), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$septicNOC4 = checklist.septicNOC) === null || _checklist$septicNOC4 === void 0 ? void 0 : _checklist$septicNOC4.remarks)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "16"), /*#__PURE__*/React__default.createElement("td", null, "Provision of a sloping roof"), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$heightOfSl = checklist.heightOfSloppingRoofNOC) === null || _checklist$heightOfSl === void 0 ? void 0 : _checklist$heightOfSl.regulated), /*#__PURE__*/React__default.createElement("td", null, (checklist === null || checklist === void 0 ? void 0 : (_checklist$heightOfSl2 = checklist.heightOfSloppingRoofNOC) === null || _checklist$heightOfSl2 === void 0 ? void 0 : _checklist$heightOfSl2.proposed) || (checklist === null || checklist === void 0 ? void 0 : checklist.heightOfSloppingRoof)), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$heightOfSl3 = checklist.heightOfSloppingRoofNOC) === null || _checklist$heightOfSl3 === void 0 ? void 0 : _checklist$heightOfSl3.relaxation), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$heightOfSl4 = checklist.heightOfSloppingRoofNOC) === null || _checklist$heightOfSl4 === void 0 ? void 0 : _checklist$heightOfSl4.remarks)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "17"), /*#__PURE__*/React__default.createElement("td", null, "Height raising/Plinth level"), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$plinthHeig = checklist.plinthHeightNOC) === null || _checklist$plinthHeig === void 0 ? void 0 : _checklist$plinthHeig.regulated), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$plinthHeig2 = checklist.plinthHeightNOC) === null || _checklist$plinthHeig2 === void 0 ? void 0 : _checklist$plinthHeig2.proposed), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$plinthHeig3 = checklist.plinthHeightNOC) === null || _checklist$plinthHeig3 === void 0 ? void 0 : _checklist$plinthHeig3.relaxation), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$plinthHeig4 = checklist.plinthHeightNOC) === null || _checklist$plinthHeig4 === void 0 ? void 0 : _checklist$plinthHeig4.remarks)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "18"), /*#__PURE__*/React__default.createElement("td", null, "The closed floor in any"), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$closedFloo = checklist.closedFloorNOC) === null || _checklist$closedFloo === void 0 ? void 0 : _checklist$closedFloo.regulated), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$closedFloo2 = checklist.closedFloorNOC) === null || _checklist$closedFloo2 === void 0 ? void 0 : _checklist$closedFloo2.proposed), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$closedFloo3 = checklist.closedFloorNOC) === null || _checklist$closedFloo3 === void 0 ? void 0 : _checklist$closedFloo3.relaxation), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$closedFloo4 = checklist.closedFloorNOC) === null || _checklist$closedFloo4 === void 0 ? void 0 : _checklist$closedFloo4.remarks)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "19"), /*#__PURE__*/React__default.createElement("td", null, "Retaining work and site development"), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$retainingw = checklist.retainingworkNOC) === null || _checklist$retainingw === void 0 ? void 0 : _checklist$retainingw.regulated), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$retainingw2 = checklist.retainingworkNOC) === null || _checklist$retainingw2 === void 0 ? void 0 : _checklist$retainingw2.proposed), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$retainingw3 = checklist.retainingworkNOC) === null || _checklist$retainingw3 === void 0 ? void 0 : _checklist$retainingw3.relaxation), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$retainingw4 = checklist.retainingworkNOC) === null || _checklist$retainingw4 === void 0 ? void 0 : _checklist$retainingw4.remarks)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "20"), /*#__PURE__*/React__default.createElement("td", null, "Boundary Wall erected or not"), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$boundaryWa = checklist.boundaryWallsNOC) === null || _checklist$boundaryWa === void 0 ? void 0 : _checklist$boundaryWa.regulated), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$boundaryWa2 = checklist.boundaryWallsNOC) === null || _checklist$boundaryWa2 === void 0 ? void 0 : _checklist$boundaryWa2.proposed), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$boundaryWa3 = checklist.boundaryWallsNOC) === null || _checklist$boundaryWa3 === void 0 ? void 0 : _checklist$boundaryWa3.relaxation), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$boundaryWa4 = checklist.boundaryWallsNOC) === null || _checklist$boundaryWa4 === void 0 ? void 0 : _checklist$boundaryWa4.remarks)), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "21"), /*#__PURE__*/React__default.createElement("td", null, "Whether the building is above the road on the valley side."), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$aboveValle = checklist.aboveValleySideNOC) === null || _checklist$aboveValle === void 0 ? void 0 : _checklist$aboveValle.regulated), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$aboveValle2 = checklist.aboveValleySideNOC) === null || _checklist$aboveValle2 === void 0 ? void 0 : _checklist$aboveValle2.proposed), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$aboveValle3 = checklist.aboveValleySideNOC) === null || _checklist$aboveValle3 === void 0 ? void 0 : _checklist$aboveValle3.relaxation), /*#__PURE__*/React__default.createElement("td", null, checklist === null || checklist === void 0 ? void 0 : (_checklist$aboveValle4 = checklist.aboveValleySideNOC) === null || _checklist$aboveValle4 === void 0 ? void 0 : _checklist$aboveValle4.remarks))))))));
};

const NOCFormatView = ({
  formData,
  applicationDocs
}) => {
  var _formData$application, _formData$taxHeadEsti, _landAreaDetails$loca, _landAreaDetails$vill, _professionalDetails$;
  const {
    t
  } = useTranslation();
  const isUdFlow = formData === null || formData === void 0 ? void 0 : (_formData$application = formData.applicationNo) === null || _formData$application === void 0 ? void 0 : _formData$application.includes('UD');
  const landAreaDetails = formData === null || formData === void 0 ? void 0 : formData.landAreaDetails;
  const professionalDetails = formData === null || formData === void 0 ? void 0 : formData.professionalInformation;
  const tcpNOCDetails = formData === null || formData === void 0 ? void 0 : formData.tcpNOCdetails;
  const udNOCDetails = formData === null || formData === void 0 ? void 0 : formData.udNOCdetails;
  const checklist = formData === null || formData === void 0 ? void 0 : formData.checklist;
  const feeDetails = formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti = formData.taxHeadEstimate) === null || _formData$taxHeadEsti === void 0 ? void 0 : _formData$taxHeadEsti[0];
  const udNOCdetailsDocuments = applicationDocs === null || applicationDocs === void 0 ? void 0 : applicationDocs.filter(doc => {
    var _doc$documentType;
    return doc === null || doc === void 0 ? void 0 : (_doc$documentType = doc.documentType) === null || _doc$documentType === void 0 ? void 0 : _doc$documentType.includes('udNOCdetails');
  });
  const stabilityDocDocuments = applicationDocs === null || applicationDocs === void 0 ? void 0 : applicationDocs.filter(doc => (doc === null || doc === void 0 ? void 0 : doc.documentType) === 'stabilityDoc');
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginTop: "1px",
      backgroundColor: "#fff"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      textAlign: "center",
      marginBottom: "5px",
      backgroundColor: "#99b3d98c",
      border: "1px solid rgba(91, 90, 95, 0.35)"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "NOC Application")), /*#__PURE__*/React__default.createElement(Card$3, {
    style: {
      backgroundColor: "#eeeab5b0",
      padding: "20px"
    }
  }, "NOC Form used for taking permission for Electrical, Sewerage, and water connection from the Urban Development Department."), /*#__PURE__*/React__default.createElement(Card$3, {
    style: {
      maxWidth: '100%',
      margin: 'auto'
    }
  }, /*#__PURE__*/React__default.createElement(CardContent$2, null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      textAlign: "center",
      marginBottom: "5px",
      backgroundColor: "#99b3d98c",
      border: "1px solid rgba(91, 90, 95, 0.35)"
    }
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "h6",
    component: "h2"
  }, "Application Details:")), /*#__PURE__*/React__default.createElement(Grid$1, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React__default.createElement(Grid$1, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1"
  }, "Apllication Type: ", formData === null || formData === void 0 ? void 0 : formData.applicationType)), /*#__PURE__*/React__default.createElement(Grid$1, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1"
  }, "Applied For: ", formData === null || formData === void 0 ? void 0 : formData.appliedFor)), /*#__PURE__*/React__default.createElement(Grid$1, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1"
  }, "Reference Application No: ", formData === null || formData === void 0 ? void 0 : formData.oldApplicationNo)), /*#__PURE__*/React__default.createElement(Grid$1, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1"
  }, "Application No: ", formData === null || formData === void 0 ? void 0 : formData.applicationNo)), /*#__PURE__*/React__default.createElement(Grid$1, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1"
  }, "District: ", landAreaDetails === null || landAreaDetails === void 0 ? void 0 : landAreaDetails.city)), /*#__PURE__*/React__default.createElement(Grid$1, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1"
  }, "Notified-Area: ", landAreaDetails === null || landAreaDetails === void 0 ? void 0 : (_landAreaDetails$loca = landAreaDetails.locality) === null || _landAreaDetails$loca === void 0 ? void 0 : _landAreaDetails$loca.name)), /*#__PURE__*/React__default.createElement(Grid$1, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1"
  }, "Village: ", landAreaDetails === null || landAreaDetails === void 0 ? void 0 : (_landAreaDetails$vill = landAreaDetails.village) === null || _landAreaDetails$vill === void 0 ? void 0 : _landAreaDetails$vill.name)), /*#__PURE__*/React__default.createElement(Grid$1, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1"
  }, "Area Type: ", landAreaDetails === null || landAreaDetails === void 0 ? void 0 : landAreaDetails.areaType))))), /*#__PURE__*/React__default.createElement(Card$3, {
    style: {
      maxWidth: '100%',
      margin: 'auto'
    }
  }, /*#__PURE__*/React__default.createElement(CardContent$2, null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      textAlign: "center",
      marginBottom: "5px",
      backgroundColor: "#99b3d98c",
      border: "1px solid rgba(91, 90, 95, 0.35)"
    }
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "h6",
    component: "h2"
  }, "Professional Details:")), /*#__PURE__*/React__default.createElement(Grid$1, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React__default.createElement(Grid$1, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1"
  }, "Name: ", professionalDetails === null || professionalDetails === void 0 ? void 0 : professionalDetails.name)), /*#__PURE__*/React__default.createElement(Grid$1, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1"
  }, "Registration Number: ", professionalDetails === null || professionalDetails === void 0 ? void 0 : professionalDetails.registrationNumber)), /*#__PURE__*/React__default.createElement(Grid$1, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1"
  }, "Mobile Number: ", professionalDetails === null || professionalDetails === void 0 ? void 0 : professionalDetails.mobileNumber)), /*#__PURE__*/React__default.createElement(Grid$1, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1"
  }, "Email-Id    : ", professionalDetails === null || professionalDetails === void 0 ? void 0 : professionalDetails.emailId)), /*#__PURE__*/React__default.createElement(Grid$1, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1"
  }, "Address: ", professionalDetails === null || professionalDetails === void 0 ? void 0 : (_professionalDetails$ = professionalDetails.address) === null || _professionalDetails$ === void 0 ? void 0 : _professionalDetails$.address))))), !isUdFlow && /*#__PURE__*/React__default.createElement(Card$3, {
    style: {
      maxWidth: '100%',
      margin: 'auto'
    }
  }, /*#__PURE__*/React__default.createElement(CardContent$2, null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      textAlign: "center",
      marginBottom: "5px",
      backgroundColor: "#99b3d98c",
      border: "1px solid rgba(91, 90, 95, 0.35)"
    }
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "h6",
    component: "h2"
  }, "NOC Details:")), tcpNOCDetails === null || tcpNOCDetails === void 0 ? void 0 : tcpNOCDetails.map((item, index) => /*#__PURE__*/React__default.createElement(React__default.Fragment, {
    key: index
  }, /*#__PURE__*/React__default.createElement(Grid$1, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React__default.createElement(Grid$1, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1"
  }, "NOC Type: ", item === null || item === void 0 ? void 0 : item.nocType)), /*#__PURE__*/React__default.createElement(Grid$1, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1"
  }, "Floor Type: ", item === null || item === void 0 ? void 0 : item.floorName)), /*#__PURE__*/React__default.createElement(Grid$1, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1"
  }, "Land-Use Type : ", item === null || item === void 0 ? void 0 : item.landUseType)), /*#__PURE__*/React__default.createElement(Grid$1, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1"
  }, "Services  : ", item === null || item === void 0 ? void 0 : item.services))), index !== tcpNOCDetails.length - 1 && /*#__PURE__*/React__default.createElement(Divider$1, {
    style: {
      marginTop: '10px'
    }
  }), " ")))), isUdFlow && /*#__PURE__*/React__default.createElement(Card$3, {
    style: {
      maxWidth: '100%',
      margin: 'auto'
    }
  }, /*#__PURE__*/React__default.createElement(CardContent$2, null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      textAlign: "center",
      marginBottom: "5px",
      backgroundColor: "#99b3d98c",
      border: "1px solid rgba(91, 90, 95, 0.35)"
    }
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "h6",
    component: "h2"
  }, "NOC Details:")), udNOCDetails === null || udNOCDetails === void 0 ? void 0 : udNOCDetails.map((item, index) => /*#__PURE__*/React__default.createElement(React__default.Fragment, {
    key: index
  }, /*#__PURE__*/React__default.createElement(Grid$1, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React__default.createElement(Grid$1, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1"
  }, "Name: ", item.name)), /*#__PURE__*/React__default.createElement(Grid$1, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1"
  }, "Email: ", item.emailId)), /*#__PURE__*/React__default.createElement(Grid$1, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1"
  }, "Applied On: ", new Date(item.appliedOnDate).toLocaleDateString()))), /*#__PURE__*/React__default.createElement(Grid$1, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React__default.createElement(Grid$1, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1"
  }, "Categories: ", item.categories)), /*#__PURE__*/React__default.createElement(Grid$1, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1"
  }, "Blocks: ", item.blockNameAsPerDatabase)), /*#__PURE__*/React__default.createElement(Grid$1, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1"
  }, "Floor Name: ", item.floorName))), " ", /*#__PURE__*/React__default.createElement(Grid$1, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React__default.createElement(Grid$1, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1"
  }, "No of Connections: ", item.noOfConnections)), /*#__PURE__*/React__default.createElement(Grid$1, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1"
  }, "Noc Type: ", item.nocType)), /*#__PURE__*/React__default.createElement(Grid$1, {
    item: true,
    xs: 4
  }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(BPADocumentsPreview, {
    documents: getOrderDocuments([udNOCdetailsDocuments[index]]),
    svgStyles: {},
    isSendBackFlow: false,
    isHrLine: true,
    titleStyles: {
      fontSize: "18px",
      lineHeight: "24px",
      "fontWeight": 700,
      marginBottom: "10px"
    }
  })))), index !== udNOCDetails.length - 1 && /*#__PURE__*/React__default.createElement(Divider$1, null), " ")))), checklist && /*#__PURE__*/React__default.createElement(Card$3, {
    style: {
      maxWidth: '100%',
      margin: 'auto'
    }
  }, /*#__PURE__*/React__default.createElement(CardContent$2, null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      textAlign: "center",
      marginBottom: "5px",
      backgroundColor: "#99b3d98c",
      border: "1px solid rgba(91, 90, 95, 0.35)"
    }
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "h6",
    component: "h2"
  }, "Checklist Details:")), /*#__PURE__*/React__default.createElement(NOCCheckList, {
    checklist: checklist
  }))), isUdFlow && /*#__PURE__*/React__default.createElement(Card$3, {
    style: {
      maxWidth: '100%',
      margin: 'auto'
    }
  }, /*#__PURE__*/React__default.createElement(CardContent$2, null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      textAlign: "center",
      marginBottom: "5px",
      backgroundColor: "#99b3d98c",
      border: "1px solid rgba(91, 90, 95, 0.35)"
    }
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "h6",
    component: "h2"
  }, "Document Details:")), /*#__PURE__*/React__default.createElement(Grid$1, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React__default.createElement(Grid$1, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1"
  }, "Stability Document:")), /*#__PURE__*/React__default.createElement(Grid$1, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(BPADocumentsPreview, {
    documents: getOrderDocuments(stabilityDocDocuments),
    svgStyles: {},
    isSendBackFlow: false,
    isHrLine: true,
    titleStyles: {
      fontSize: "18px",
      lineHeight: "24px",
      "fontWeight": 700,
      marginBottom: "10px"
    }
  })))))), isUdFlow && /*#__PURE__*/React__default.createElement(Card$3, {
    style: {
      maxWidth: '100%',
      margin: 'auto'
    }
  }, /*#__PURE__*/React__default.createElement(CardContent$2, null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      textAlign: "center",
      marginBottom: "5px",
      backgroundColor: "#99b3d98c",
      border: "1px solid rgba(91, 90, 95, 0.35)"
    }
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "h6",
    component: "h2"
  }, "Fee Details")), /*#__PURE__*/React__default.createElement(Grid$1, {
    container: true,
    spacing: 2
  }, /*#__PURE__*/React__default.createElement(Grid$1, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1"
  }, "Total Amount: ", feeDetails === null || feeDetails === void 0 ? void 0 : feeDetails.estimateAmount)))))));
};

const citizenBaseUrl = "/digit-ui/citizen";
const urlImg = "https://upload.wikimedia.org/wikipedia/commons/f/fa/Seal_of_Uttar_Pradesh.svg";

const OwnerSummary = forwardRef(({
  formData,
  ref
}) => {
  var _formData$landInfo, _formData$landInfo2, _documents$filter, _documents$filter$, _formData$ownerOrAppl, _formData$ownerOrAppl2, _formData$approvedLay, _formData$approvedLay2, _formData$morethanOne, _formData$morethanOne2, _formData$morethanOne3, _formData$morethanOne4, _descriptionOfLand$go, _descriptionOfLand$go2, _descriptionOfLand$go3, _descriptionOfLand$go4, _formData$checklist, _formData$checklist2, _formData$checklist3, _formData$checklist4, _formData$checklist5, _formData$checklist6, _formData$checklist7, _formData$checklist8, _formData$checklist9, _formData$checklist10, _formData$checklist11, _formData$checklist12;
  const [, applicationFlow] = useDepartmentSelector();
  const {
    t
  } = useTranslation();
  const [, setIsPreviewLoading] = useState(false);
  const descriptionOfLand = formData === null || formData === void 0 ? void 0 : formData.descriptionOfLand;
  const properties = descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.properties;
  const owners = formData === null || formData === void 0 ? void 0 : (_formData$landInfo = formData.landInfo) === null || _formData$landInfo === void 0 ? void 0 : _formData$landInfo.owners;
  const applicant = formData === null || formData === void 0 ? void 0 : formData.applicant;
  const documents = formData === null || formData === void 0 ? void 0 : formData.documents;
  const bankInfo = formData === null || formData === void 0 ? void 0 : (_formData$landInfo2 = formData.landInfo) === null || _formData$landInfo2 === void 0 ? void 0 : _formData$landInfo2.bankdetails;
  const authorization = documents === null || documents === void 0 ? void 0 : (_documents$filter = documents.filter(doc => ["authorization Letter"].includes(doc.documentType))) === null || _documents$filter === void 0 ? void 0 : (_documents$filter$ = _documents$filter[0]) === null || _documents$filter$ === void 0 ? void 0 : _documents$filter$.fileStoreId;
  const filteredDocuments = documents === null || documents === void 0 ? void 0 : documents.filter(doc => !/^(signature|applicantPhoto)\[\d+\]$/.test(doc.documentType));
  const nameOfDepartment = applicationFlow == "DA" ? "DEVELOPMENT AUTHORITY" : "AWAS EVAM VIKAS PARISHAD";
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      backgroundColor: "#ffffff"
    },
    ref: ref
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      padding: "5px",
      background: "rgb(230, 239, 248)"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      background: "white",
      borderRadius: "50%"
    }
  }, /*#__PURE__*/React__default.createElement("img", {
    width: "60",
    height: "30",
    src: urlImg,
    alt: "Uttar-Pradesh-Logo"
  })), /*#__PURE__*/React__default.createElement("div", {
    style: {
      color: "#1f4a7c"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginLeft: "12px",
      fontSize: "1.25rem",
      fontWeight: "600",
      fontFamily: '"Calibri", sans-serif'
    }
  }, nameOfDepartment), /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginLeft: "12px",
      fontFamily: '"Calibri", sans-serif',
      fontWeight: "500"
    }
  }, "Government of Uttar Pradesh"))), /*#__PURE__*/React__default.createElement("div", {
    className: "groupContainer",
    style: {
      width: "100%",
      marginTop: "1rem"
    }
  }, /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t('Basic Information'))), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, (formData === null || formData === void 0 ? void 0 : formData.ownerOrApplicant) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Are You the Owner or Applicant")), /*#__PURE__*/React__default.createElement("td", null, (formData === null || formData === void 0 ? void 0 : (_formData$ownerOrAppl = formData.ownerOrApplicant) === null || _formData$ownerOrAppl === void 0 ? void 0 : _formData$ownerOrAppl.charAt(0).toUpperCase()) + (formData === null || formData === void 0 ? void 0 : (_formData$ownerOrAppl2 = formData.ownerOrApplicant) === null || _formData$ownerOrAppl2 === void 0 ? void 0 : _formData$ownerOrAppl2.slice(1)))), (formData === null || formData === void 0 ? void 0 : formData.approvedLayout) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Is Your Property Part of Approved Layout:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$approvedLay = formData.approvedLayout) === null || _formData$approvedLay === void 0 ? void 0 : _formData$approvedLay.charAt(0).toUpperCase()) + (formData === null || formData === void 0 ? void 0 : (_formData$approvedLay2 = formData.approvedLayout) === null || _formData$approvedLay2 === void 0 ? void 0 : _formData$approvedLay2.slice(1)))), (formData === null || formData === void 0 ? void 0 : formData.morethanOneOwner) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Is More than One Owner:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$morethanOne = formData.morethanOneOwner) === null || _formData$morethanOne === void 0 ? void 0 : _formData$morethanOne.charAt(0).toUpperCase()) + (formData === null || formData === void 0 ? void 0 : (_formData$morethanOne2 = formData.morethanOneOwner) === null || _formData$morethanOne2 === void 0 ? void 0 : _formData$morethanOne2.slice(1)))), (formData === null || formData === void 0 ? void 0 : formData.morethanOneProperty) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Is More than One Property:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$morethanOne3 = formData.morethanOneProperty) === null || _formData$morethanOne3 === void 0 ? void 0 : _formData$morethanOne3.charAt(0).toUpperCase()) + (formData === null || formData === void 0 ? void 0 : (_formData$morethanOne4 = formData.morethanOneProperty) === null || _formData$morethanOne4 === void 0 ? void 0 : _formData$morethanOne4.slice(1))))))))), (applicant === null || applicant === void 0 ? void 0 : applicant.name) && /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Applicant Information")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, (applicant === null || applicant === void 0 ? void 0 : applicant.name) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Name:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData.professionalInformation.name)), (applicant === null || applicant === void 0 ? void 0 : applicant.mobileNumber) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Mobile No:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, applicant === null || applicant === void 0 ? void 0 : applicant.mobileNumber)), (applicant === null || applicant === void 0 ? void 0 : applicant.emailId) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "E-mail Id:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, applicant === null || applicant === void 0 ? void 0 : applicant.emailId)), (applicant === null || applicant === void 0 ? void 0 : applicant.aadhaarNumber) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Aadhaar No:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, applicant === null || applicant === void 0 ? void 0 : applicant.aadhaarNumber)), (applicant === null || applicant === void 0 ? void 0 : applicant.address) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Address:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, applicant === null || applicant === void 0 ? void 0 : applicant.address)), (applicant === null || applicant === void 0 ? void 0 : applicant.address) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Authorization Letter:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: '20px',
      height: '30px'
    },
    onClick: () => getDocumentByFileStoreId(authorization, setIsPreviewLoading)
  })))))))), /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, owners === null || owners === void 0 ? void 0 : owners.map((item, index) => {
    var _item$correspondenceA, _item$correspondenceA2, _item$correspondenceA3, _item$correspondenceA4, _item$correspondenceA5, _item$correspondenceA6;
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
      className: "formHeaderContainer"
    }, /*#__PURE__*/React__default.createElement("h2", {
      className: "formHeading"
    }, index > 0 ? 'Addition Owner Information' : 'Owner Information')), /*#__PURE__*/React__default.createElement("div", {
      className: "formInputContainer",
      style: {
        display: "flex",
        justifyContent: "center"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        width: "100%"
      }
    }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
      key: index,
      style: {
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        marginTop: "15px",
        marginBottom: "15px",
        paddingBottom: "15px"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        flex: "1 1 calc(50% - 10px)",
        marginRight: "10px"
      }
    }, /*#__PURE__*/React__default.createElement("table", {
      style: {
        width: "100%",
        borderCollapse: "collapse"
      }
    }, /*#__PURE__*/React__default.createElement("tbody", null, (item === null || item === void 0 ? void 0 : item.name) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Name :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : item.name)), (item === null || item === void 0 ? void 0 : item.fatherOrHusbandName) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Father Name :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : item.fatherOrHusbandName)), (item === null || item === void 0 ? void 0 : item.mobileNumber) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Mobile Number :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : item.mobileNumber)), (item === null || item === void 0 ? void 0 : item.aadhaarNumber) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Aadhaar Number :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : item.aadhaarNumber)), (formData === null || formData === void 0 ? void 0 : formData.applicationNo) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Application Number :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, formData === null || formData === void 0 ? void 0 : formData.applicationNo)), (item === null || item === void 0 ? void 0 : item.gender) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Gender :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : item.gender)), (item === null || item === void 0 ? void 0 : item.emailId) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "E-mail ID :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : item.emailId)), (item === null || item === void 0 ? void 0 : (_item$correspondenceA = item.correspondenceAddress) === null || _item$correspondenceA === void 0 ? void 0 : _item$correspondenceA.state) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "State :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : (_item$correspondenceA2 = item.correspondenceAddress) === null || _item$correspondenceA2 === void 0 ? void 0 : _item$correspondenceA2.state)), (item === null || item === void 0 ? void 0 : item.address) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Address :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : item.address)), (item === null || item === void 0 ? void 0 : (_item$correspondenceA3 = item.correspondenceAddress) === null || _item$correspondenceA3 === void 0 ? void 0 : _item$correspondenceA3.pinno) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Pin Code :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : (_item$correspondenceA4 = item.correspondenceAddress) === null || _item$correspondenceA4 === void 0 ? void 0 : _item$correspondenceA4.pinno)), (item === null || item === void 0 ? void 0 : (_item$correspondenceA5 = item.correspondenceAddress) === null || _item$correspondenceA5 === void 0 ? void 0 : _item$correspondenceA5.town) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "City :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : (_item$correspondenceA6 = item.correspondenceAddress) === null || _item$correspondenceA6 === void 0 ? void 0 : _item$correspondenceA6.town)), (item === null || item === void 0 ? void 0 : item.statusType) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Applicant Status :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : item.statusType)), (item === null || item === void 0 ? void 0 : item.remarks) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Remarks :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : item.remarks))))), (item === null || item === void 0 ? void 0 : item.photo) && /*#__PURE__*/React__default.createElement("div", {
      style: {
        flex: "1 1 calc(50% - 10px)",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-around",
        alignItems: "center"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "row",
      style: {
        marginBottom: "10px"
      }
    }, item !== null && item !== void 0 && item.photo ? /*#__PURE__*/React__default.createElement("img", {
      style: {
        width: "200px",
        height: "180px",
        objectFit: "cover"
      },
      src: item === null || item === void 0 ? void 0 : item.photo,
      alt: "image",
      className: "img-thumbnail"
    }) : /*#__PURE__*/React__default.createElement(Avatar$1, {
      style: {
        width: "200px",
        height: "80px"
      }
    }, item === null || item === void 0 ? void 0 : item.photo)), /*#__PURE__*/React__default.createElement("div", {
      className: "row",
      style: {
        marginBottom: "10px"
      }
    }, item !== null && item !== void 0 && item.signature ? /*#__PURE__*/React__default.createElement("img", {
      style: {
        width: "200px",
        height: "80px"
      },
      src: item === null || item === void 0 ? void 0 : item.signature,
      alt: "signature",
      className: "img-thumbnail"
    }) : /*#__PURE__*/React__default.createElement(BorderColorIcon, {
      style: {
        width: "70px",
        height: "25px"
      }
    }, item === null || item === void 0 ? void 0 : item.signature))))))));
  })), /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, properties === null || properties === void 0 ? void 0 : properties.map((item, index) => {
    var _item$appliedLandUse, _item$appliedLandUse2, _item$propertyType, _item$propertyType2, _item$propertyAddress, _item$propertyAddress2, _item$propertyAddress3, _item$propertyAddress4;
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, {
      defaultExpanded: true,
      key: index
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "formHeaderContainer"
    }, /*#__PURE__*/React__default.createElement("h2", {
      className: "formHeading"
    }, index > 0 ? 'Additional Registration Information' : 'Registration Information')), /*#__PURE__*/React__default.createElement("div", {
      className: "formInputContainer",
      style: {
        margin: "0px 4px",
        display: "flex",
        justifyContent: "center"
      }
    }, /*#__PURE__*/React__default.createElement("table", {
      style: {
        width: "100%"
      }
    }, /*#__PURE__*/React__default.createElement("tbody", null, item.schemeName && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        textAlign: "left",
        padding: "8px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Scheme Type :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        padding: "8px"
      }
    }, item.schemeName)), ((_item$appliedLandUse = item.appliedLandUse) === null || _item$appliedLandUse === void 0 ? void 0 : _item$appliedLandUse.name) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        textAlign: "left",
        padding: "8px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Applied Land Use :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        padding: "8px"
      }
    }, (_item$appliedLandUse2 = item.appliedLandUse) === null || _item$appliedLandUse2 === void 0 ? void 0 : _item$appliedLandUse2.name)), item.khatauniNo && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        textAlign: "left",
        padding: "8px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Khatauni No. :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        padding: "8px"
      }
    }, item.khatauniNo)), item.khataNo && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        textAlign: "left",
        padding: "8px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Khata No. :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        padding: "8px"
      }
    }, item.khataNo)), item.khasraNo && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        textAlign: "left",
        padding: "8px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Khasra No. :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        padding: "8px"
      }
    }, item.khasraNo)), item.plotNo && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        textAlign: "left",
        padding: "8px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Plot No. :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        padding: "8px"
      }
    }, item.plotNo)), item.roadWidth && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        textAlign: "left",
        padding: "8px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Road Width :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        padding: "8px"
      }
    }, item.roadWidth)), item.plotArea && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        textAlign: "left",
        padding: "8px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Plot Area :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        padding: "8px"
      }
    }, item.plotArea)), ((_item$propertyType = item.propertyType) === null || _item$propertyType === void 0 ? void 0 : _item$propertyType.name) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        textAlign: "left",
        padding: "8px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Property Type :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        padding: "8px"
      }
    }, (_item$propertyType2 = item.propertyType) === null || _item$propertyType2 === void 0 ? void 0 : _item$propertyType2.name)), (((_item$propertyAddress = item.propertyAddress) === null || _item$propertyAddress === void 0 ? void 0 : _item$propertyAddress.address) || item.city || ((_item$propertyAddress2 = item.propertyAddress) === null || _item$propertyAddress2 === void 0 ? void 0 : _item$propertyAddress2.pinno)) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        textAlign: "left",
        padding: "8px"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Address :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "50%",
        padding: "8px"
      }
    }, `${((_item$propertyAddress3 = item.propertyAddress) === null || _item$propertyAddress3 === void 0 ? void 0 : _item$propertyAddress3.address) || ''}, ${item.city || ''}, ${((_item$propertyAddress4 = item.propertyAddress) === null || _item$propertyAddress4 === void 0 ? void 0 : _item$propertyAddress4.pinno) || ''}`))))));
  })), /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Bank Details")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, (bankInfo === null || bankInfo === void 0 ? void 0 : bankInfo.accountHolderName) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Account Holder Name:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, bankInfo === null || bankInfo === void 0 ? void 0 : bankInfo.accountHolderName)), (bankInfo === null || bankInfo === void 0 ? void 0 : bankInfo.accountNo) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Account No:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, bankInfo === null || bankInfo === void 0 ? void 0 : bankInfo.accountNo)), (bankInfo === null || bankInfo === void 0 ? void 0 : bankInfo.bankName) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Bank Name:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, bankInfo === null || bankInfo === void 0 ? void 0 : bankInfo.bankName)), (bankInfo === null || bankInfo === void 0 ? void 0 : bankInfo.branchName) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Branch Name:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, bankInfo === null || bankInfo === void 0 ? void 0 : bankInfo.branchName)), (bankInfo === null || bankInfo === void 0 ? void 0 : bankInfo.ifscCode) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "IFSC Code:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, bankInfo === null || bankInfo === void 0 ? void 0 : bankInfo.ifscCode))))))), /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Location Information")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.googleMapCoordinates) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Map Cordinates:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, "Latitude: ", descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : (_descriptionOfLand$go = descriptionOfLand.googleMapCoordinates) === null || _descriptionOfLand$go === void 0 ? void 0 : (_descriptionOfLand$go2 = _descriptionOfLand$go[0]) === null || _descriptionOfLand$go2 === void 0 ? void 0 : _descriptionOfLand$go2.latitude, ", Longitude: ", descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : (_descriptionOfLand$go3 = descriptionOfLand.googleMapCoordinates) === null || _descriptionOfLand$go3 === void 0 ? void 0 : (_descriptionOfLand$go4 = _descriptionOfLand$go3[0]) === null || _descriptionOfLand$go4 === void 0 ? void 0 : _descriptionOfLand$go4.longitude)), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.googleMapLocation) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Map Location:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.googleMapLocation))))))), /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Documents Section"), " "), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement(Grid$1, {
    container: true,
    spacing: 2
  }, filteredDocuments === null || filteredDocuments === void 0 ? void 0 : filteredDocuments.map((document, index) => {
    var _document$documentTyp, _document$documentTyp2;
    const documentType = (document === null || document === void 0 ? void 0 : (_document$documentTyp = document.documentType) === null || _document$documentTyp === void 0 ? void 0 : _document$documentTyp.charAt(0).toUpperCase()) + (document === null || document === void 0 ? void 0 : (_document$documentTyp2 = document.documentType) === null || _document$documentTyp2 === void 0 ? void 0 : _document$documentTyp2.slice(1));
    return /*#__PURE__*/React__default.createElement(Grid$1, {
      item: true,
      xs: 12,
      md: 6,
      key: index
    }, " ", /*#__PURE__*/React__default.createElement(Grid$1, {
      container: true,
      spacing: 2
    }, /*#__PURE__*/React__default.createElement(Grid$1, {
      item: true,
      xs: 6
    }, /*#__PURE__*/React__default.createElement("strong", null, documentType, " "), ":"), " ", /*#__PURE__*/React__default.createElement(Grid$1, {
      item: true,
      xs: 6
    }, /*#__PURE__*/React__default.createElement(FaFilePdf, {
      color: "#a10505",
      style: {
        width: '20px',
        height: '30px'
      },
      onClick: () => getDocumentByFileStoreId(document === null || document === void 0 ? void 0 : document.fileStoreId, setIsPreviewLoading)
    }))));
  })))), (formData === null || formData === void 0 ? void 0 : (_formData$checklist = formData.checklist) === null || _formData$checklist === void 0 ? void 0 : _formData$checklist.allotmentDate) !== null && /*#__PURE__*/React__default.createElement(SummaryCard, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t('Checklist Information'))), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, (formData === null || formData === void 0 ? void 0 : formData.ownerOrApplicant) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Agreement Date:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : (_formData$checklist2 = formData.checklist) === null || _formData$checklist2 === void 0 ? void 0 : _formData$checklist2.agreementDate)), (formData === null || formData === void 0 ? void 0 : (_formData$checklist3 = formData.checklist) === null || _formData$checklist3 === void 0 ? void 0 : _formData$checklist3.allotmentDate) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Allotment Date:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : (_formData$checklist4 = formData.checklist) === null || _formData$checklist4 === void 0 ? void 0 : _formData$checklist4.allotmentDate)), (formData === null || formData === void 0 ? void 0 : (_formData$checklist5 = formData.checklist) === null || _formData$checklist5 === void 0 ? void 0 : _formData$checklist5.paymentStatus) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Payment Status:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : (_formData$checklist6 = formData.checklist) === null || _formData$checklist6 === void 0 ? void 0 : _formData$checklist6.paymentStatus)), (formData === null || formData === void 0 ? void 0 : (_formData$checklist7 = formData.checklist) === null || _formData$checklist7 === void 0 ? void 0 : _formData$checklist7.uptodatePaymentStatus) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Updated Payment Status:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : (_formData$checklist8 = formData.checklist) === null || _formData$checklist8 === void 0 ? void 0 : _formData$checklist8.uptodatePaymentStatus)), (formData === null || formData === void 0 ? void 0 : (_formData$checklist9 = formData.checklist) === null || _formData$checklist9 === void 0 ? void 0 : _formData$checklist9.isPossesionAreaDiff) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Is Possession Area Different:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : (_formData$checklist10 = formData.checklist) === null || _formData$checklist10 === void 0 ? void 0 : _formData$checklist10.isPossesionAreaDiff)), (formData === null || formData === void 0 ? void 0 : (_formData$checklist11 = formData.checklist) === null || _formData$checklist11 === void 0 ? void 0 : _formData$checklist11.areaOfExtraLand) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Area Of Extra Land:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : (_formData$checklist12 = formData.checklist) === null || _formData$checklist12 === void 0 ? void 0 : _formData$checklist12.areaOfExtraLand)))))))));
});

const ApplicaionFormatViewNew = forwardRef(({
  formData,
  applicationDocs,
  logoData,
  oldCaseSearch: _oldCaseSearch = false
}, ref) => {
  var _logoData$boundary, _logoData$boundary$fi, _formData$location, _formData$landInfo, _formData$nocDetails, _formData$nocDetails2, _applicationDocs$find, _applicationDocs$find2, _formData$description, _formData$description2, _formData$professiona, _formData$professiona2, _formData$professiona3, _formData$professiona4, _formData$professiona5, _formData$professiona6, _formData$professiona7, _formData$description3, _formData$description4, _formData$description5, _formData$description6, _formData$description7, _formData$description8, _formData$description9, _formData$description10, _formData$description11, _formData$description12, _formData$description13, _formData$description14, _formData$description15, _formData$description16, _formData$description17, _formData$description18, _formData$description19, _formData$description20, _formData$description21, _formData$description22, _formData$description23, _formData$description24, _formData$description25, _formData$description26, _formData$description27, _formData$description28, _formData$description29, _formData$description30, _formData$description31, _formData$description32, _formData$description33, _formData$description34, _formData$description35, _formData$description36, _formData$description37, _formData$landInfo2, _formData$landInfo2$o, _formData$landInfo2$o2, _formData$landInfo2$o3, _formData$landInfo3, _formData$landInfo3$o, _formData$landInfo3$o2, _formData$landInfo3$o3, _formData$landInfo4, _formData$landInfo4$o, _formData$landInfo4$o2, _formData$landInfo4$o3, _formData$landInfo5, _formData$landInfo5$o, _formData$landInfo5$o2, _formData$landInfo5$o3, _formData$landInfo6, _formData$landInfo6$o, _formData$landInfo6$o2, _formData$landInfo6$o3, _formData$landInfo7, _formData$landInfo7$o, _formData$landInfo7$o2, _formData$landInfo7$o3, _formData$description38, _formData$description39, _formData$description40, _formData$description41, _formData$description42, _formData$description43, _formData$description44, _formData$description45, _formData$description46, _formData$description47, _formData$description48, _formData$taxHeadEsti, _formData$taxHeadEsti2;
  console.log("logoDataFromSummary", logoData);
  console.log("logoDataFromSummary111", _oldCaseSearch);
  const history = useHistory();
  const [logoUrl, setLogoUrl] = useState("");
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const [, applicationFlow] = useDepartmentSelector();
  const {
    t
  } = useTranslation();
  const isEmployee = history.location.pathname.includes("employee");
  const user = Digit.UserService.getUser();
  const isLowRiskCase = (formData === null || formData === void 0 ? void 0 : formData.riskType) === "LOW";
  let nameOfDepartment;
  const isDA = (formData === null || formData === void 0 ? void 0 : formData.department) === "DA";
  const currentLogoId = isDA ? logoData === null || logoData === void 0 ? void 0 : (_logoData$boundary = logoData.boundary) === null || _logoData$boundary === void 0 ? void 0 : (_logoData$boundary$fi = _logoData$boundary.find(item => item.name === (formData === null || formData === void 0 ? void 0 : formData.location1))) === null || _logoData$boundary$fi === void 0 ? void 0 : _logoData$boundary$fi.fileStoreId : logoData === null || logoData === void 0 ? void 0 : logoData.fileStoreId;
  const fetchLogoUrl = async () => {
    if (!currentLogoId) return;
    const result = await getDocumentByFileStoreId(currentLogoId, setIsPreviewLoading, true);
    setLogoUrl(result);
  };
  nameOfDepartment = isDA ? `${formData === null || formData === void 0 ? void 0 : (_formData$location = formData.location1) === null || _formData$location === void 0 ? void 0 : _formData$location.toUpperCase()} DEVELOPMENT AUTHORITY` : "AWAS EVAM VIKAS PARISHAD";
  const descriptionOfLand = formData === null || formData === void 0 ? void 0 : formData.descriptionOfLand;
  const owners = formData === null || formData === void 0 ? void 0 : (_formData$landInfo = formData.landInfo) === null || _formData$landInfo === void 0 ? void 0 : _formData$landInfo.owners;
  const roadWidths = descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.roadWidths;
  const approachRoadWidths = descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.approachRoadWidths;
  console.log(formData, "FromSUmmary");
  const nocApplicantData = formData === null || formData === void 0 ? void 0 : (_formData$nocDetails = formData.nocDetails) === null || _formData$nocDetails === void 0 ? void 0 : _formData$nocDetails.applicantNOCData;
  const selectedNOCs = console.log(nocApplicantData, "nocapplicant");
  const additionalNOC = formData === null || formData === void 0 ? void 0 : (_formData$nocDetails2 = formData.nocDetails) === null || _formData$nocDetails2 === void 0 ? void 0 : _formData$nocDetails2.additionalApplicantNOC;
  console.log("additionalNocs", additionalNOC);
  const StyledTableCell = styled$1(TableCell)(({
    theme
  }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#1f4a7c",
      color: theme.palette.common.white
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14
    }
  }));
  const StyledTableRow = styled$1(TableRow)(({
    theme
  }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover
    },
    "&:last-child td, &:last-child th": {
      border: 0
    }
  }));
  const accordionSummaryStyles = {
    backgroundColor: "#FFFF",
    height: "1rem",
    minHeight: "48px",
    "&.Mui-expanded": {
      backgroundColor: "#FFFF",
      minHeight: "48px",
      height: "1rem"
    }
  };
  const filteredDocuments = applicationDocs.filter(doc => _oldCaseSearch ? !["applicantPhoto", "signature", "mutationLetter", "registrySaleDeedHPTA"].includes(doc.documentType) : !["applicantPhoto", "signature"].includes(doc.documentType));
  const mutationLetterId = (_applicationDocs$find = applicationDocs.find(doc => doc.documentType === "mutationLetter")) === null || _applicationDocs$find === void 0 ? void 0 : _applicationDocs$find.fileStoreId;
  const registrySaleDeedHPTAId = (_applicationDocs$find2 = applicationDocs.find(doc => doc.documentType === "registrySaleDeedHPTA")) === null || _applicationDocs$find2 === void 0 ? void 0 : _applicationDocs$find2.fileStoreId;
  useEffect(() => {
    fetchLogoUrl();
  }, [logoData, formData]);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      backgroundColor: "#fff"
    },
    ref: ref
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      background: "#fff"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      background: "white",
      borderRadius: "50%"
    }
  }, /*#__PURE__*/React__default.createElement("img", {
    src: logoUrl,
    alt: "Uttar-Pradesh-Logo",
    style: {
      marginTop: isDA ? "0.5em" : "1em",
      height: "4em",
      width: "auto",
      objectFit: "contain"
    }
  })), /*#__PURE__*/React__default.createElement("div", {
    style: {
      color: "#000",
      marginTop: "20px"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginLeft: "30px",
      fontSize: "1.25rem",
      fontWeight: "600",
      fontFamily: "Montserrat"
    }
  }, nameOfDepartment), /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginLeft: "30px",
      fontFamily: "Montserrat",
      fontWeight: "500"
    }
  }, "Government of Uttar Pradesh"))), /*#__PURE__*/React__default.createElement("div", {
    className: "container3",
    style: {
      width: "100%",
      marginTop: "1rem"
    }
  }, ((formData === null || formData === void 0 ? void 0 : (_formData$description = formData.descriptionOfLand) === null || _formData$description === void 0 ? void 0 : _formData$description.schemeType) !== "Scheme" && (formData === null || formData === void 0 ? void 0 : formData.IsApprovalCertificate) && (formData === null || formData === void 0 ? void 0 : formData.land_Id) || (formData === null || formData === void 0 ? void 0 : (_formData$description2 = formData.descriptionOfLand) === null || _formData$description2 === void 0 ? void 0 : _formData$description2.schemeType) === "Scheme" && (formData === null || formData === void 0 ? void 0 : formData.land_Id)) && /*#__PURE__*/React__default.createElement(Card$3, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(Accordion, {
    defaultExpanded: true
  }, /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("b", null, "FASTPAS ID : "), /*#__PURE__*/React__default.createElement("span", {
    style: {
      marginLeft: "1rem"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.land_Id)))))), (formData === null || formData === void 0 ? void 0 : formData.oldCaseApplicationNo) && /*#__PURE__*/React__default.createElement(Card$3, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(Accordion, {
    defaultExpanded: true
  }, /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("b", null, "Old Case Application No : "), /*#__PURE__*/React__default.createElement("span", {
    style: {
      marginLeft: "1rem"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.oldCaseApplicationNo)))))), /*#__PURE__*/React__default.createElement(Card$3, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(Accordion, {
    defaultExpanded: true
  }, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null),
    sx: accordionSummaryStyles
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Verifying Authority"))), /*#__PURE__*/React__default.createElement(AccordionDetails, null, isDA ? /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "20%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Selected Office : ")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "20%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : formData.selectedOffice)))) : /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, (formData === null || formData === void 0 ? void 0 : formData.selectedUnit) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Selected Unit:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData.selectedUnit)), (formData === null || formData === void 0 ? void 0 : formData.selectedCity) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Selected City:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData.selectedCity))))))))), /*#__PURE__*/React__default.createElement(Card$3, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(Accordion, {
    defaultExpanded: true
  }, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null),
    sx: accordionSummaryStyles
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Owner Information"))), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("div", null, owners === null || owners === void 0 ? void 0 : owners.map((item, index) => {
    var _item$correspondenceA, _item$correspondenceA2, _item$correspondenceA3, _item$correspondenceA4, _item$correspondenceA5, _item$correspondenceA6;
    return /*#__PURE__*/React__default.createElement("div", {
      key: index,
      style: {
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        marginTop: "15px",
        marginBottom: "15px",
        paddingBottom: "15px"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      style: {
        flex: "1 1 calc(50% - 10px)",
        marginRight: "10px"
      }
    }, /*#__PURE__*/React__default.createElement("table", {
      style: {
        width: "100%",
        borderCollapse: "collapse"
      }
    }, /*#__PURE__*/React__default.createElement("tbody", null, (item === null || item === void 0 ? void 0 : item.name) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Name :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px",
        wordBreak: "break-word",
        overflowWrap: "anywhere"
      }
    }, item === null || item === void 0 ? void 0 : item.name)), (item === null || item === void 0 ? void 0 : item.fatherOrHusbandName) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Father Name / Husband Name :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px",
        wordBreak: "break-word",
        overflowWrap: "anywhere"
      }
    }, item === null || item === void 0 ? void 0 : item.fatherOrHusbandName)), (item === null || item === void 0 ? void 0 : item.mobileNumber) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Mobile Number :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : item.mobileNumber)), (item === null || item === void 0 ? void 0 : item.aadhaarNumber) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Aadhaar Number :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : item.aadhaarNumber)), (formData === null || formData === void 0 ? void 0 : formData.applicationNo) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Application Number :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, formData === null || formData === void 0 ? void 0 : formData.applicationNo)), (item === null || item === void 0 ? void 0 : item.gender) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Gender :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : item.gender)), (item === null || item === void 0 ? void 0 : item.emailId) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "E-mail ID :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : item.emailId)), (item === null || item === void 0 ? void 0 : (_item$correspondenceA = item.correspondenceAddress) === null || _item$correspondenceA === void 0 ? void 0 : _item$correspondenceA.state) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "State :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : (_item$correspondenceA2 = item.correspondenceAddress) === null || _item$correspondenceA2 === void 0 ? void 0 : _item$correspondenceA2.state)), (item === null || item === void 0 ? void 0 : item.address) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Address :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : item.address)), (item === null || item === void 0 ? void 0 : (_item$correspondenceA3 = item.correspondenceAddress) === null || _item$correspondenceA3 === void 0 ? void 0 : _item$correspondenceA3.pinno) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Pin Code :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : (_item$correspondenceA4 = item.correspondenceAddress) === null || _item$correspondenceA4 === void 0 ? void 0 : _item$correspondenceA4.pinno)), (item === null || item === void 0 ? void 0 : (_item$correspondenceA5 = item.correspondenceAddress) === null || _item$correspondenceA5 === void 0 ? void 0 : _item$correspondenceA5.town) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "City :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : (_item$correspondenceA6 = item.correspondenceAddress) === null || _item$correspondenceA6 === void 0 ? void 0 : _item$correspondenceA6.town)), (item === null || item === void 0 ? void 0 : item.statusType) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Applicant Status :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : item.statusType)), (item === null || item === void 0 ? void 0 : item.remarks) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      style: {
        textAlign: "left",
        padding: "8px",
        width: "50%"
      }
    }, /*#__PURE__*/React__default.createElement("b", null, "Remarks :")), /*#__PURE__*/React__default.createElement("td", {
      style: {
        padding: "8px"
      }
    }, item === null || item === void 0 ? void 0 : item.remarks))))), (item === null || item === void 0 ? void 0 : item.photo) && /*#__PURE__*/React__default.createElement("div", {
      style: {
        flex: "1 1 calc(50% - 10px)",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-around",
        alignItems: "center",
        padding: "24px"
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "row",
      style: {
        marginBottom: "10px"
      }
    }, item !== null && item !== void 0 && item.photo ? /*#__PURE__*/React__default.createElement("img", {
      style: {
        width: "200px",
        height: "180px",
        objectFit: "cover"
      },
      src: item === null || item === void 0 ? void 0 : item.photo,
      alt: "image",
      className: "img-thumbnail"
    }) : /*#__PURE__*/React__default.createElement(Avatar$1, {
      style: {
        width: "200px",
        height: "80px"
      }
    }, item === null || item === void 0 ? void 0 : item.photo)), /*#__PURE__*/React__default.createElement("div", {
      className: "row",
      style: {
        marginBottom: "10px",
        marginTop: "80px"
      }
    }, item !== null && item !== void 0 && item.signature ? /*#__PURE__*/React__default.createElement("img", {
      style: {
        width: "200px",
        height: "80px"
      },
      src: item === null || item === void 0 ? void 0 : item.signature,
      alt: "signature",
      className: "img-thumbnail"
    }) : /*#__PURE__*/React__default.createElement(BorderColorIcon, {
      style: {
        width: "70px",
        height: "25px"
      }
    }, item === null || item === void 0 ? void 0 : item.signature))));
  }))))))), /*#__PURE__*/React__default.createElement(Card$3, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(Accordion, {
    defaultExpanded: true
  }, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null),
    sx: accordionSummaryStyles
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Licensed Technical Professional (LTP) Information"))), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, (formData === null || formData === void 0 ? void 0 : (_formData$professiona = formData.professionalInformation) === null || _formData$professiona === void 0 ? void 0 : _formData$professiona.consultantCategory) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Consultant Category:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData.professionalInformation.consultantCategory)), (formData === null || formData === void 0 ? void 0 : (_formData$professiona2 = formData.professionalInformation) === null || _formData$professiona2 === void 0 ? void 0 : _formData$professiona2.name) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Name:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData.professionalInformation.name)), (formData === null || formData === void 0 ? void 0 : (_formData$professiona3 = formData.professionalInformation) === null || _formData$professiona3 === void 0 ? void 0 : _formData$professiona3.planDate) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Validity:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData.professionalInformation.planDate)), (formData === null || formData === void 0 ? void 0 : (_formData$professiona4 = formData.professionalInformation) === null || _formData$professiona4 === void 0 ? void 0 : _formData$professiona4.mobileNumber) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Mobile No:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData.professionalInformation.mobileNumber)), (formData === null || formData === void 0 ? void 0 : (_formData$professiona5 = formData.professionalInformation) === null || _formData$professiona5 === void 0 ? void 0 : _formData$professiona5.certificateNumber) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Certificate No.:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData.professionalInformation.certificateNumber)), (formData === null || formData === void 0 ? void 0 : (_formData$professiona6 = formData.professionalInformation) === null || _formData$professiona6 === void 0 ? void 0 : _formData$professiona6.licenseNumber) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "License No:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData.professionalInformation.licenseNumber)), (formData === null || formData === void 0 ? void 0 : (_formData$professiona7 = formData.professionalInformation) === null || _formData$professiona7 === void 0 ? void 0 : _formData$professiona7.emailId) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "E-mail Id:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData.professionalInformation.emailId))))))))), /*#__PURE__*/React__default.createElement(Card$3, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(Accordion, {
    defaultExpanded: true
  }, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null),
    sx: accordionSummaryStyles
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Land Information"))), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      margin: "0px 4px",
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, (formData === null || formData === void 0 ? void 0 : (_formData$description3 = formData.descriptionOfLand) === null || _formData$description3 === void 0 ? void 0 : _formData$description3.schemeType) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Scheme Type :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$description4 = formData.descriptionOfLand) === null || _formData$description4 === void 0 ? void 0 : _formData$description4.schemeType) || "")), (formData === null || formData === void 0 ? void 0 : (_formData$description5 = formData.descriptionOfLand) === null || _formData$description5 === void 0 ? void 0 : _formData$description5.planOn) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Plan on :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$description6 = formData.descriptionOfLand) === null || _formData$description6 === void 0 ? void 0 : _formData$description6.planOn) || "")), (formData === null || formData === void 0 ? void 0 : (_formData$description7 = formData.descriptionOfLand) === null || _formData$description7 === void 0 ? void 0 : _formData$description7.schemeName) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Scheme Name :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$description8 = formData.descriptionOfLand) === null || _formData$description8 === void 0 ? void 0 : _formData$description8.schemeName) || "")), (formData === null || formData === void 0 ? void 0 : (_formData$description9 = formData.descriptionOfLand) === null || _formData$description9 === void 0 ? void 0 : _formData$description9.sectorNo) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Sector No. :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$description10 = formData.descriptionOfLand) === null || _formData$description10 === void 0 ? void 0 : _formData$description10.sectorNo) || "")), (formData === null || formData === void 0 ? void 0 : (_formData$description11 = formData.descriptionOfLand) === null || _formData$description11 === void 0 ? void 0 : _formData$description11.developmentArea) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Development Area:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$description12 = formData.descriptionOfLand) === null || _formData$description12 === void 0 ? void 0 : _formData$description12.developmentArea) || "")), (formData === null || formData === void 0 ? void 0 : (_formData$description13 = formData.descriptionOfLand) === null || _formData$description13 === void 0 ? void 0 : _formData$description13.activityAsPerMap) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Primary Use of Proposed Activity")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$description14 = formData.descriptionOfLand) === null || _formData$description14 === void 0 ? void 0 : _formData$description14.activityAsPerMap) || "")), (formData === null || formData === void 0 ? void 0 : (_formData$description15 = formData.descriptionOfLand) === null || _formData$description15 === void 0 ? void 0 : _formData$description15.activityProposed) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Activity Proposed")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$description16 = formData.descriptionOfLand) === null || _formData$description16 === void 0 ? void 0 : _formData$description16.activityProposed) || "")), (formData === null || formData === void 0 ? void 0 : (_formData$description17 = formData.descriptionOfLand) === null || _formData$description17 === void 0 ? void 0 : _formData$description17.selectLandUse) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Permissibility of Activities")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$description18 = formData.descriptionOfLand) === null || _formData$description18 === void 0 ? void 0 : _formData$description18.selectLandUse) || "")), (formData === null || formData === void 0 ? void 0 : (_formData$description19 = formData.descriptionOfLand) === null || _formData$description19 === void 0 ? void 0 : _formData$description19.proposedActivity) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Proposed Activity as per Zoning Regulation :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$description20 = formData.descriptionOfLand) === null || _formData$description20 === void 0 ? void 0 : _formData$description20.proposedActivity) || "")), (formData === null || formData === void 0 ? void 0 : (_formData$description21 = formData.descriptionOfLand) === null || _formData$description21 === void 0 ? void 0 : _formData$description21.landUsesType) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, (formData === null || formData === void 0 ? void 0 : (_formData$description22 = formData.descriptionOfLand) === null || _formData$description22 === void 0 ? void 0 : _formData$description22.schemeType) === "Scheme" ? "Land Use as per Layout Plan :" : "Land Use as per Master Plan :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$description23 = formData.descriptionOfLand) === null || _formData$description23 === void 0 ? void 0 : _formData$description23.landUsesType) || "")), (formData === null || formData === void 0 ? void 0 : (_formData$description24 = formData.descriptionOfLand) === null || _formData$description24 === void 0 ? void 0 : _formData$description24.subLandUseAsPerLayout) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, (formData === null || formData === void 0 ? void 0 : (_formData$description25 = formData.descriptionOfLand) === null || _formData$description25 === void 0 ? void 0 : _formData$description25.schemeType) === "Scheme" ? "Land Sub Use as per Layout :" : "Land Sub Use as per Master Plan :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$description26 = formData.descriptionOfLand) === null || _formData$description26 === void 0 ? void 0 : _formData$description26.subLandUseAsPerLayout) || "")), (formData === null || formData === void 0 ? void 0 : (_formData$description27 = formData.descriptionOfLand) === null || _formData$description27 === void 0 ? void 0 : _formData$description27.otherMasterPlan) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Other Master Layout Plan :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$description28 = formData.descriptionOfLand) === null || _formData$description28 === void 0 ? void 0 : _formData$description28.otherMasterPlan) || "")), (formData === null || formData === void 0 ? void 0 : (_formData$description29 = formData.descriptionOfLand) === null || _formData$description29 === void 0 ? void 0 : _formData$description29.selectLandUse) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Permissibility of Activities :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$description30 = formData.descriptionOfLand) === null || _formData$description30 === void 0 ? void 0 : _formData$description30.selectLandUse) || "")), (formData === null || formData === void 0 ? void 0 : (_formData$description31 = formData.descriptionOfLand) === null || _formData$description31 === void 0 ? void 0 : _formData$description31.requiredLandUsesType) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Required Land Use Type :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$description32 = formData.descriptionOfLand) === null || _formData$description32 === void 0 ? void 0 : _formData$description32.requiredLandUsesType) || "")), (formData === null || formData === void 0 ? void 0 : (_formData$description33 = formData.descriptionOfLand) === null || _formData$description33 === void 0 ? void 0 : _formData$description33.reqSubLandUseAsPerLayout) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Require Sub Land Use Type :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$description34 = formData.descriptionOfLand) === null || _formData$description34 === void 0 ? void 0 : _formData$description34.reqSubLandUseAsPerLayout) || "")), (formData === null || formData === void 0 ? void 0 : (_formData$description35 = formData.descriptionOfLand) === null || _formData$description35 === void 0 ? void 0 : _formData$description35.reqActivityProposed) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Require Activity Proposed :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$description36 = formData.descriptionOfLand) === null || _formData$description36 === void 0 ? void 0 : _formData$description36.reqActivityProposed) || "")), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.blockNo) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Block No./Name :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.blockNo) || "")), Array.isArray(formData === null || formData === void 0 ? void 0 : (_formData$description37 = formData.descriptionOfLand) === null || _formData$description37 === void 0 ? void 0 : _formData$description37.khasraDetails) && formData.descriptionOfLand.khasraDetails.map((khasra, idx) => /*#__PURE__*/React__default.createElement(React__default.Fragment, {
    key: idx
  }, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Plot No./Khasra No./Arazi No. ", idx + 1, " :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px",
      wordBreak: "break-all"
    }
  }, khasra.plotNo || "NA")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Village ", idx + 1, " :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, khasra.village || khasra.villageName || "NA")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Tehsil ", idx + 1, " :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, khasra.tehsil || "NA")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "District ", idx + 1, " :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, khasra.district || "NA")))), (formData === null || formData === void 0 ? void 0 : (_formData$landInfo2 = formData.landInfo) === null || _formData$landInfo2 === void 0 ? void 0 : (_formData$landInfo2$o = _formData$landInfo2.owners) === null || _formData$landInfo2$o === void 0 ? void 0 : (_formData$landInfo2$o2 = _formData$landInfo2$o[0]) === null || _formData$landInfo2$o2 === void 0 ? void 0 : (_formData$landInfo2$o3 = _formData$landInfo2$o2.permanentAddress) === null || _formData$landInfo2$o3 === void 0 ? void 0 : _formData$landInfo2$o3.district) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("LABEL_DISTRICT"), " :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$landInfo3 = formData.landInfo) === null || _formData$landInfo3 === void 0 ? void 0 : (_formData$landInfo3$o = _formData$landInfo3.owners) === null || _formData$landInfo3$o === void 0 ? void 0 : (_formData$landInfo3$o2 = _formData$landInfo3$o[0]) === null || _formData$landInfo3$o2 === void 0 ? void 0 : (_formData$landInfo3$o3 = _formData$landInfo3$o2.permanentAddress) === null || _formData$landInfo3$o3 === void 0 ? void 0 : _formData$landInfo3$o3.district) || "")), (formData === null || formData === void 0 ? void 0 : (_formData$landInfo4 = formData.landInfo) === null || _formData$landInfo4 === void 0 ? void 0 : (_formData$landInfo4$o = _formData$landInfo4.owners) === null || _formData$landInfo4$o === void 0 ? void 0 : (_formData$landInfo4$o2 = _formData$landInfo4$o[0]) === null || _formData$landInfo4$o2 === void 0 ? void 0 : (_formData$landInfo4$o3 = _formData$landInfo4$o2.permanentAddress) === null || _formData$landInfo4$o3 === void 0 ? void 0 : _formData$landInfo4$o3.tehsil) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Tehsil"), " :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$landInfo5 = formData.landInfo) === null || _formData$landInfo5 === void 0 ? void 0 : (_formData$landInfo5$o = _formData$landInfo5.owners) === null || _formData$landInfo5$o === void 0 ? void 0 : (_formData$landInfo5$o2 = _formData$landInfo5$o[0]) === null || _formData$landInfo5$o2 === void 0 ? void 0 : (_formData$landInfo5$o3 = _formData$landInfo5$o2.permanentAddress) === null || _formData$landInfo5$o3 === void 0 ? void 0 : _formData$landInfo5$o3.tehsil) || "")), (formData === null || formData === void 0 ? void 0 : (_formData$landInfo6 = formData.landInfo) === null || _formData$landInfo6 === void 0 ? void 0 : (_formData$landInfo6$o = _formData$landInfo6.owners) === null || _formData$landInfo6$o === void 0 ? void 0 : (_formData$landInfo6$o2 = _formData$landInfo6$o[0]) === null || _formData$landInfo6$o2 === void 0 ? void 0 : (_formData$landInfo6$o3 = _formData$landInfo6$o2.permanentAddress) === null || _formData$landInfo6$o3 === void 0 ? void 0 : _formData$landInfo6$o3.village) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, t("Village"), " :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (formData === null || formData === void 0 ? void 0 : (_formData$landInfo7 = formData.landInfo) === null || _formData$landInfo7 === void 0 ? void 0 : (_formData$landInfo7$o = _formData$landInfo7.owners) === null || _formData$landInfo7$o === void 0 ? void 0 : (_formData$landInfo7$o2 = _formData$landInfo7$o[0]) === null || _formData$landInfo7$o2 === void 0 ? void 0 : (_formData$landInfo7$o3 = _formData$landInfo7$o2.permanentAddress) === null || _formData$landInfo7$o3 === void 0 ? void 0 : _formData$landInfo7$o3.village) || "")), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.plotFront) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Front Width (M) :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.plotFront) || "")), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.plotRear) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Rear Width (M) :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.plotRear) || "")), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.plotSide1) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Side Width 1 :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.plotSide1) || "")), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.plotSide2) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Side Width 2 :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.plotSide2) || "")), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.khatauniNo) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Khatauni No. :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.khatauniNo) || "")), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.khataNo) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Khata No. :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.khataNo) || "")), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.plotNo) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Plot No. :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.plotNo) || "")), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.landWidth) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Land Width :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.landWidth) || "")), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.landLength) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Land Length :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.landLength) || "")), (formData === null || formData === void 0 ? void 0 : (_formData$description38 = formData.descriptionOfLand) === null || _formData$description38 === void 0 ? void 0 : _formData$description38.plotAreaDoc) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Plot Area (as per document) :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : (_formData$description39 = formData.descriptionOfLand) === null || _formData$description39 === void 0 ? void 0 : _formData$description39.plotAreaDoc)), (formData === null || formData === void 0 ? void 0 : (_formData$description40 = formData.descriptionOfLand) === null || _formData$description40 === void 0 ? void 0 : _formData$description40.landArea) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Plot Area (as per site) :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : (_formData$description41 = formData.descriptionOfLand) === null || _formData$description41 === void 0 ? void 0 : _formData$description41.landArea)), (formData === null || formData === void 0 ? void 0 : (_formData$description42 = formData.descriptionOfLand) === null || _formData$description42 === void 0 ? void 0 : _formData$description42.plotAreaPossession) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Plot Area (as per possession) :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : (_formData$description43 = formData.descriptionOfLand) === null || _formData$description43 === void 0 ? void 0 : _formData$description43.plotAreaPossession)), (roadWidths === null || roadWidths === void 0 ? void 0 : roadWidths.length) > 0 && roadWidths.map((road, index) => /*#__PURE__*/React__default.createElement("tr", {
    key: index
  }, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Road Width (Existing) :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, road.value || ""))), (approachRoadWidths === null || approachRoadWidths === void 0 ? void 0 : approachRoadWidths.length) > 0 && approachRoadWidths.map((road, index) => /*#__PURE__*/React__default.createElement("tr", {
    key: index
  }, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Road Width (as per the respective plan) :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, road.value || ""))), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.landMark) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Near by Landmark :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.landMark) || "")), (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.landAddress) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Land Address :")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.landAddress) || "")))))))), /*#__PURE__*/React__default.createElement(Card$3, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(Accordion, {
    defaultExpanded: true
  }, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null),
    sx: accordionSummaryStyles
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Documents Section"), " ")), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement(BPADocumentsPreview, {
    documents: getOrderDocuments(filteredDocuments),
    svgStyles: {},
    isSendBackFlow: false,
    isHrLine: true,
    titleStyles: {
      fontSize: "18px",
      lineHeight: "24px",
      fontWeight: 700,
      marginBottom: "10px"
    }
  }), _oldCaseSearch && /*#__PURE__*/React__default.createElement(Grid$1, {
    item: true,
    xs: 12,
    md: 6,
    style: {
      marginTop: "10px"
    }
  }, " ", /*#__PURE__*/React__default.createElement(Grid$1, {
    container: true,
    spacing: 2,
    alignItems: "center"
  }, /*#__PURE__*/React__default.createElement(Grid$1, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React__default.createElement("p", null, "Registry/Sale deed/HPTA/Land ownership/Gift deed:")), " ", /*#__PURE__*/React__default.createElement(Grid$1, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "20px",
      height: "30px"
    },
    onClick: () => getDocumentByFileStoreIdV2(registrySaleDeedHPTAId, setIsPreviewLoading)
  })), (formData === null || formData === void 0 ? void 0 : (_formData$description44 = formData.descriptionOfLand) === null || _formData$description44 === void 0 ? void 0 : _formData$description44.schemeType) !== "Scheme" && /*#__PURE__*/React__default.createElement(Grid$1, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React__default.createElement("p", null, "Mutation Letter:")), (formData === null || formData === void 0 ? void 0 : (_formData$description45 = formData.descriptionOfLand) === null || _formData$description45 === void 0 ? void 0 : _formData$description45.schemeType) !== "Scheme" && /*#__PURE__*/React__default.createElement(Grid$1, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React__default.createElement(FaFilePdf, {
    color: "#a10505",
    style: {
      width: "20px",
      height: "30px"
    },
    onClick: () => getDocumentByFileStoreIdV2(mutationLetterId, setIsPreviewLoading)
  })))))))), ((descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.latitude) || (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.googleMapLocation)) && /*#__PURE__*/React__default.createElement(Card$3, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(Accordion, {
    defaultExpanded: true
  }, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null),
    sx: accordionSummaryStyles
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Location Information"))), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, (descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.latitude) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Map Cordinates:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, "Latitude: ", descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.latitude, ", Longitude: ", descriptionOfLand === null || descriptionOfLand === void 0 ? void 0 : descriptionOfLand.longitude)), (formData === null || formData === void 0 ? void 0 : (_formData$description46 = formData.descriptionOfLand) === null || _formData$description46 === void 0 ? void 0 : _formData$description46.googleMapLocation) && /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      textAlign: "left",
      padding: "8px"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Map Location:")), /*#__PURE__*/React__default.createElement("td", {
    style: {
      width: "50%",
      padding: "8px"
    }
  }, formData === null || formData === void 0 ? void 0 : (_formData$description47 = formData.descriptionOfLand) === null || _formData$description47 === void 0 ? void 0 : _formData$description47.googleMapLocation))))))))), (nocApplicantData || additionalNOC) && !isLowRiskCase && /*#__PURE__*/React__default.createElement(Card$3, {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement(Accordion, {
    defaultExpanded: true
  }, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null),
    sx: accordionSummaryStyles
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, t("BPA_MY_APPLICATIONS_LANDUSENOC")))), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    style: {
      width: "100%",
      borderCollapse: "collapse"
    }
  }, /*#__PURE__*/React__default.createElement("tbody", null, questions.filter(questionItem => nocApplicantData[questionItem.applicantName] === true).map((questionItem, index) => {
    const {
      label,
      applicantName
    } = questionItem;
    const answer = nocApplicantData[applicantName] ? "Yes" : "No";
    console.log("fromMap", answer, label, questions.filter(questionItem => nocApplicantData[questionItem.applicantName] === true));
    return /*#__PURE__*/React__default.createElement("tr", {
      key: index
    }, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "70%",
        textAlign: "left",
        padding: "8px"
      }
    }, label), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "30%",
        textAlign: "center",
        padding: "8px"
      }
    }, answer));
  }), additionalNOC === null || additionalNOC === void 0 ? void 0 : additionalNOC.map((item, index) => {
    return /*#__PURE__*/React__default.createElement("tr", {
      key: index
    }, /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "70%",
        textAlign: "left",
        padding: "8px"
      }
    }, item.value), /*#__PURE__*/React__default.createElement("td", {
      style: {
        width: "30%",
        textAlign: "center",
        padding: "8px"
      }
    }, "Yes"));
  })))))))), (formData === null || formData === void 0 ? void 0 : (_formData$description48 = formData.descriptionOfLand) === null || _formData$description48 === void 0 ? void 0 : _formData$description48.schemeType) !== "Scheme" && !((formData === null || formData === void 0 ? void 0 : formData.isGovernmentBuilding) === "yes") && (!_oldCaseSearch && (formData === null || formData === void 0 ? void 0 : formData.status) !== "REVERT_TO_APPLICANT" || (formData === null || formData === void 0 ? void 0 : formData.isGovernmentBuilding) !== "yes" && (formData === null || formData === void 0 ? void 0 : formData.taxHeadEstimate) !== null) && /*#__PURE__*/React__default.createElement(Card$3, {
    className: "formContainer"
  }, " ", /*#__PURE__*/React__default.createElement(Accordion, {
    defaultExpanded: true
  }, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null),
    sx: accordionSummaryStyles
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Processing Fee for Land Use Verification"))), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React__default.createElement("b", null, "Total Amount"), /*#__PURE__*/React__default.createElement("p", {
    style: {
      marginLeft: "1rem"
    }
  }, /*#__PURE__*/React__default.createElement("span", null, "\u20B9 ", formData === null || formData === void 0 ? void 0 : (_formData$taxHeadEsti = formData.taxHeadEstimate) === null || _formData$taxHeadEsti === void 0 ? void 0 : (_formData$taxHeadEsti2 = _formData$taxHeadEsti[0]) === null || _formData$taxHeadEsti2 === void 0 ? void 0 : _formData$taxHeadEsti2.estimateAmount))))))))));
});

const TakeActionItem = forwardRef(({
  id,
  formType,
  logoData,
  oldCaseSearch
}, ref) => {
  var _data$LandUse, _data$ownerRegistrati, _data$PurchasableFAR, _data$BPA, _formData$paymentDeta, _formData$paymentDeta2, _formData$paymentDeta3, _paymentDetails$Bill, _paymentDetails$Bill$, _paymentDetails$Bill$2, _formData$PrevStateDo, _formData$PrevStateNo, _formData$nocDocument, _formData$nocDocument2, _pdfDetails$pdfFiles;
  const history = useHistory();
  const stateId = Digit.ULBService.getStateId();
  const isEmployee = history.location.pathname.includes("EMPLOYEE");
  const {
    data = {},
    isLoading,
    refetch
  } = Digit.Hooks.obps.useBPADetailsPage(stateId, {
    applicationNo: id,
    isEmployee,
    formType
  }, {
    formType
  });
  const {
    data: {
      BPA: {
        logoStore
      } = {}
    } = {},
    isLoading: isLogoLoading
  } = Digit.Hooks.obps.useMDMS("up", "BPA", ["logoStore"]);
  const avpLogo = logoStore === null || logoStore === void 0 ? void 0 : logoStore.find(item => item.code === "up.avp");
  const daLogo = logoStore === null || logoStore === void 0 ? void 0 : logoStore.find(item => item.code === "up.da");
  useEffect(() => {
    if (id && formType) {
      refetch();
    }
  }, [id, formType, refetch]);
  console.log(data, "fromTakeAction");
  const formData = (data === null || data === void 0 ? void 0 : (_data$LandUse = data.LandUse) === null || _data$LandUse === void 0 ? void 0 : _data$LandUse[0]) || (data === null || data === void 0 ? void 0 : (_data$ownerRegistrati = data.ownerRegistration) === null || _data$ownerRegistrati === void 0 ? void 0 : _data$ownerRegistrati[0]) || (data === null || data === void 0 ? void 0 : (_data$PurchasableFAR = data.PurchasableFAR) === null || _data$PurchasableFAR === void 0 ? void 0 : _data$PurchasableFAR[0]) || (data === null || data === void 0 ? void 0 : (_data$BPA = data.BPA) === null || _data$BPA === void 0 ? void 0 : _data$BPA[0]) || (data === null || data === void 0 ? void 0 : data.applicationData);
  const {
    collectionBillRes,
    collectionBillDetails
  } = data;
  if (!isLoading && formData) {
    var _collectionBillRes$, _collectionBillRes$$p;
    formData.paymentDetails = collectionBillRes === null || collectionBillRes === void 0 ? void 0 : (_collectionBillRes$ = collectionBillRes[0]) === null || _collectionBillRes$ === void 0 ? void 0 : (_collectionBillRes$$p = _collectionBillRes$.paymentDetails) === null || _collectionBillRes$$p === void 0 ? void 0 : _collectionBillRes$$p[0];
  }
  let consumerCode = id;
  const fetchBillParams = {
    consumerCode
  };
  const appType = formData === null || formData === void 0 ? void 0 : formData.applicationType;
  const BusinessService = (formData === null || formData === void 0 ? void 0 : formData.businessService) === `BPA_${appType === null || appType === void 0 ? void 0 : appType.replace("_", "")}` ? `BPA.${appType}_FEE` : `BPA.${appType}_FEE_UD`;
  const {
    data: paymentDetails
  } = Digit.Hooks.useFetchBillsForBuissnessService({
    businessService: BusinessService,
    ...fetchBillParams,
    tenantId: stateId
  }, {
    enabled: consumerCode ? true : false,
    retry: false
  });
  const totalAmount = (formData === null || formData === void 0 ? void 0 : (_formData$paymentDeta = formData.paymentDetails) === null || _formData$paymentDeta === void 0 ? void 0 : (_formData$paymentDeta2 = _formData$paymentDeta.bill) === null || _formData$paymentDeta2 === void 0 ? void 0 : (_formData$paymentDeta3 = _formData$paymentDeta2.billDetails[0]) === null || _formData$paymentDeta3 === void 0 ? void 0 : _formData$paymentDeta3.amount) || (paymentDetails === null || paymentDetails === void 0 ? void 0 : (_paymentDetails$Bill = paymentDetails.Bill) === null || _paymentDetails$Bill === void 0 ? void 0 : (_paymentDetails$Bill$ = _paymentDetails$Bill[0]) === null || _paymentDetails$Bill$ === void 0 ? void 0 : (_paymentDetails$Bill$2 = _paymentDetails$Bill$.billDetails[0]) === null || _paymentDetails$Bill$2 === void 0 ? void 0 : _paymentDetails$Bill$2.amount);
  const docs = (formData === null || formData === void 0 ? void 0 : formData.documents) || {};
  const documents = typeof docs === "object" && !Array.isArray(docs) ? Object.values(docs) : docs;
  let improvedDoc = [];
  formData === null || formData === void 0 ? void 0 : (_formData$PrevStateDo = formData.PrevStateDocuments) === null || _formData$PrevStateDo === void 0 ? void 0 : _formData$PrevStateDo.map(preDoc => {
    improvedDoc.push({
      ...preDoc,
      module: "OBPS"
    });
  });
  documents === null || documents === void 0 ? void 0 : documents.map(appDoc => {
    improvedDoc.push({
      ...appDoc,
      module: "OBPS"
    });
  });
  formData === null || formData === void 0 ? void 0 : (_formData$PrevStateNo = formData.PrevStateNocDocuments) === null || _formData$PrevStateNo === void 0 ? void 0 : _formData$PrevStateNo.map(preNocDoc => {
    improvedDoc.push({
      ...preNocDoc,
      module: "NOC"
    });
  });
  formData === null || formData === void 0 ? void 0 : (_formData$nocDocument = formData.nocDocuments) === null || _formData$nocDocument === void 0 ? void 0 : (_formData$nocDocument2 = _formData$nocDocument.nocDocuments) === null || _formData$nocDocument2 === void 0 ? void 0 : _formData$nocDocument2.map(nocDoc => {
    improvedDoc.push({
      ...nocDoc,
      module: "NOC"
    });
  });
  const {
    data: pdfDetails,
    isLoading: pdfLoading
  } = Digit.Hooks.useDocumentSearch(improvedDoc, {
    enabled: (improvedDoc === null || improvedDoc === void 0 ? void 0 : improvedDoc.length) > 0 ? true : false
  });
  let applicationDocs = [];
  if ((pdfDetails === null || pdfDetails === void 0 ? void 0 : (_pdfDetails$pdfFiles = pdfDetails.pdfFiles) === null || _pdfDetails$pdfFiles === void 0 ? void 0 : _pdfDetails$pdfFiles.length) > 0) {
    var _pdfDetails$pdfFiles2;
    console.log(pdfDetails, "fromTakeActionDOcs");
    pdfDetails === null || pdfDetails === void 0 ? void 0 : (_pdfDetails$pdfFiles2 = pdfDetails.pdfFiles) === null || _pdfDetails$pdfFiles2 === void 0 ? void 0 : _pdfDetails$pdfFiles2.map(pdfAppDoc => {
      if ((pdfAppDoc === null || pdfAppDoc === void 0 ? void 0 : pdfAppDoc.module) === "OBPS") applicationDocs.push(pdfAppDoc);
    });
  }
  if (pdfLoading) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, formType === "formNOC" ? /*#__PURE__*/React__default.createElement(NOCFormatView, {
    formData: formData,
    applicationDocs: applicationDocs,
    totalAmount: totalAmount
  }) : formType === "OWNER_REGISTRATION" ? /*#__PURE__*/React__default.createElement(OwnerSummary, {
    formData: formData,
    ref: ref
  }) : /*#__PURE__*/React__default.createElement(ApplicaionFormatViewNew, {
    ref: ref,
    formData: formData,
    applicationDocs: applicationDocs,
    totalAmount: totalAmount,
    logoData: (formData === null || formData === void 0 ? void 0 : formData.department) === "DA" ? daLogo : avpLogo,
    oldCaseSearch: oldCaseSearch
  }));
});

function Services() {
  const {
    t
  } = useTranslation();
  const history = useHistory();
  const isLoggedIn = Digit.UserService.getUser();
  const [open, setOpen] = useState(false);
  const [searchOption, setSearchOption] = useState('reference');
  const [placeholderText, setPlaceholderText] = useState('Enter reference number');
  const [applicationNo, setApplicationNo] = useState('');
  const [showToast, setShowToast] = useState(null);
  const [formNo, setFormNo] = useState(null);
  const [formModal, setFormModal] = useState(false);
  const closeToast = () => {
    setShowToast(null);
  };
  useEffect(() => {
    if (!showToast) return;
    const timeOut = setTimeout(closeToast, 3000);
    return () => clearTimeout(timeOut);
  }, [showToast]);
  const toggleModal = () => {
    setOpen(isOpen => !isOpen);
  };
  const toggleFormModal = () => {
    setFormModal(formModal => !formModal);
  };
  const handleClick = action => {
    if (typeof action === 'function') {
      return action();
    }
    if (action === '/digit-ui/citizen/profile') {
      const specialAction = isLoggedIn ? action : {
        pathname: '/digit-ui/citizen/login',
        state: {
          from: action,
          userType: 'citizen'
        }
      };
      return history.push(specialAction);
    }
    return history.push(action);
  };
  const handleSearchOptionChange = event => {
    setSearchOption(event.target.value);
    setPlaceholderText(event.target.value === 'reference' ? 'Enter reference number' : 'Enter mobile number');
  };
  const handleSubmit = e => {
    e.preventDefault();
    if (applicationNo.includes('TCP')) {
      setShowToast({
        error: true,
        message: `Please search the UD Applications here...`
      });
      return 0;
    }
    const formNoMapping = {
      '12': 'form12',
      '11': 'form11',
      '26': 'form26'
    };
    const prefix = applicationNo.slice(4, 6);
    const formNo = formNoMapping[prefix];
    if (formNo) {
      setFormNo(formNo);
    }
    setFormModal(true);
  };
  const formComponents = {
    'form12': ApplicationView12,
    'form11': TakeActionItem,
    'form26': TakeActionItem
  };
  const ModalContent = formComponents[formNo];
  const servicesData = useMemo(() => getServicesData(toggleModal), []);
  return /*#__PURE__*/React__default.createElement(ServicesContainer, null, /*#__PURE__*/React__default.createElement(Grid$1, {
    container: true,
    spacing: 4
  }, servicesData.map(service => /*#__PURE__*/React__default.createElement(ServiceGrid, {
    item: true,
    xs: 12,
    sm: 6,
    md: 4,
    lg: 12 / 4,
    key: service.label
  }, /*#__PURE__*/React__default.createElement(ButtonBase, {
    onClick: () => handleClick(service.action)
  }, /*#__PURE__*/React__default.createElement("img", {
    src: service.icon,
    alt: service.label
  }), /*#__PURE__*/React__default.createElement("div", null, service.label))))), /*#__PURE__*/React__default.createElement(Modal, {
    open: open,
    onClose: toggleModal
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      backgroundColor: 'white',
      padding: '20px',
      borderRadius: '10px',
      outline: 'none'
    }
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "h5",
    component: "h2",
    style: {
      marginBottom: '20px'
    }
  }, "Know Your Application Status"), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(RadioGroup$1, {
    "aria-label": "search option",
    name: "searchOption",
    value: searchOption,
    onChange: handleSearchOptionChange
  }, /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    value: "reference",
    control: /*#__PURE__*/React__default.createElement(Radio$1, null),
    label: "Search by Application No"
  }))), /*#__PURE__*/React__default.createElement(TextField$1, {
    label: placeholderText,
    placeholder: placeholderText,
    fullWidth: true,
    margin: "normal",
    onChange: e => setApplicationNo(e.target.value)
  }), /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'center',
      marginTop: '20px'
    }
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    color: "primary",
    style: {
      backgroundColor: 'rgb(14, 118, 147)'
    },
    onClick: handleSubmit
  }, "Submit")))), showToast && /*#__PURE__*/React__default.createElement(Toast, {
    error: showToast === null || showToast === void 0 ? void 0 : showToast.error,
    warning: showToast === null || showToast === void 0 ? void 0 : showToast.warning,
    label: t(showToast === null || showToast === void 0 ? void 0 : showToast.message),
    onClose: closeToast,
    isDleteBtn: true
  }), /*#__PURE__*/React__default.createElement(Modal, {
    open: formModal,
    onClose: toggleFormModal
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: 'flex',
      margin: 'auto',
      width: '70%',
      height: '100%',
      overflow: 'scroll'
    }
  }, ModalContent && /*#__PURE__*/React__default.createElement(ModalContent, {
    formType: formNo,
    id: applicationNo
  }))));
}

function AppDetails() {
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const fetchApplicationStatsData = async () => {
    return await OBPSService.InboxSearchApplication(tenantId, {
      udHome: true
    });
  };
  const {
    isLoading,
    error,
    data
  } = useQuery('applicationStats', fetchApplicationStatsData);
  if (isLoading) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  if (error) {
    return /*#__PURE__*/React__default.createElement("div", {
      style: {
        textAlign: 'center'
      }
    }, "Something went wrong, please try again.");
  }
  return /*#__PURE__*/React__default.createElement(AppDetailsWrapper, null, /*#__PURE__*/React__default.createElement(AppDetailsContainer, null, /*#__PURE__*/React__default.createElement(AppDetailsHead, {
    variant: "h3"
  }, "Application Details"), /*#__PURE__*/React__default.createElement(Grid$1, {
    container: true,
    spacing: 2,
    justifyContent: 'center',
    alignItems: 'center'
  }, /*#__PURE__*/React__default.createElement(Grid$1, {
    container: true,
    columnSpacing: 3,
    rowSpacing: 4,
    item: true,
    md: 12,
    lg: 9
  }, data.map(({
    label,
    count,
    action
  }) => /*#__PURE__*/React__default.createElement(Grid$1, {
    item: true,
    key: action,
    xs: 12,
    sm: 6,
    md: 4
  }, /*#__PURE__*/React__default.createElement(AppDetailsLabel, null, label === 'Approved' ? 'Permission Granted' : label), /*#__PURE__*/React__default.createElement(AppDetailsValue, null, count)))), /*#__PURE__*/React__default.createElement(Grid$1, {
    item: true,
    md: 12,
    lg: 3,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }, /*#__PURE__*/React__default.createElement("a", {
    href: "https://nmanoc.nic.in/",
    target: "_blank",
    rel: "noopener nofollow"
  }, /*#__PURE__*/React__default.createElement("img", {
    src: "https://i.imgur.com/fRAizoN.png",
    alt: "Get your ASI NOC"
  }))))));
}

function Checklist() {
  return /*#__PURE__*/React__default.createElement(ChecklistWrapper, null, /*#__PURE__*/React__default.createElement(Box$1, {
    className: "title"
  }, "Forms / checklists"), /*#__PURE__*/React__default.createElement(Box$1, {
    className: "content"
  }, checklistData.map((item, index) => /*#__PURE__*/React__default.createElement("p", {
    key: `${item.label}_${index}`
  }, item.label))), /*#__PURE__*/React__default.createElement(Button$2, {
    endIcon: /*#__PURE__*/React__default.createElement(ChevronRightIcon, null)
  }, "View More"));
}

function Input({
  control,
  name,
  label,
  placeholder,
  maxLength
}) {
  const {
    field
  } = useController({
    name,
    control,
    rules: {
      required: true
    }
  });
  return /*#__PURE__*/React__default.createElement(TextField$1, Object.assign({
    onChange: field.onChange,
    onBlur: field.onBlur,
    inputRef: field.ref,
    value: field.value,
    name: field.name,
    placeholder: placeholder,
    label: label,
    fullWidth: true
  }, name === 'message' && {
    multiline: true,
    rows: 3
  }, {
    inputProps: {
      maxLength: maxLength
    }
  }));
}

const FormTypeRadio = ({
  control
}) => /*#__PURE__*/React__default.createElement(Controller, {
  control: control,
  name: 'formType',
  render: ({
    field
  }) => /*#__PURE__*/React__default.createElement(StyledRadioGroup$2, Object.assign({
    row: true
  }, field, {
    "aria-labelledby": "form-type"
  }), /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    value: "feedback",
    control: /*#__PURE__*/React__default.createElement(Radio$1, null),
    label: "Feedback"
  }), /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    value: "complaint",
    control: /*#__PURE__*/React__default.createElement(Radio$1, null),
    label: "Complaint"
  }))
});
function Feedback({
  isTCP = false
}) {
  const {
    control,
    handleSubmit,
    reset,
    formState: {
      isValid
    }
  } = useForm({
    defaultValues: feedbackFormDefaults
  });
  const [captcha, setCaptcha] = useState('');
  const [captchaInput, setCaptchaInput] = useState('');
  const [isCaptchaValid, setIsCaptchaValid] = useState(false);
  const onSubmit = data => {
    console.info(data.formType, 'form submitted:', data);
    reset(defaultValues);
  };
  useEffect(() => {
    generateCaptcha();
  }, []);
  useEffect(() => {
    setIsCaptchaValid(captcha === captchaInput);
  }, [captcha, captchaInput]);
  const generateCaptcha = () => {
    const randomCaptcha = Math.floor(1000 + Math.random() * 9000).toString();
    setCaptcha(randomCaptcha);
    setCaptchaInput('');
  };
  return /*#__PURE__*/React__default.createElement(FeedbackWrapper, {
    className: "feedbackForm"
  }, /*#__PURE__*/React__default.createElement(FormContainer, {
    className: isTCP ? 'tcp' : 'ud'
  }, /*#__PURE__*/React__default.createElement(Box$1, {
    className: "title"
  }, "Feedback / Complaint"), /*#__PURE__*/React__default.createElement("form", {
    className: "formContent",
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement(Grid$1, {
    container: true,
    rowSpacing: 2,
    columnSpacing: 4
  }, /*#__PURE__*/React__default.createElement(Grid$1, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React__default.createElement(FormTypeRadio, {
    control: control
  })), feedbackFormFields.map(field => /*#__PURE__*/React__default.createElement(Grid$1, {
    item: true,
    xs: 12,
    key: field.name,
    lg: ['mobileNo', 'email'].includes(field.name) ? 6 : 12
  }, /*#__PURE__*/React__default.createElement(Input, Object.assign({
    control: control
  }, field)))), /*#__PURE__*/React__default.createElement(Grid$1, {
    item: true,
    xs: 12,
    lg: 6
  }, /*#__PURE__*/React__default.createElement(Input, {
    control: control,
    name: 'captcha',
    label: "Captcha",
    placeholder: "Enter Captcha",
    maxLength: 4
  })), /*#__PURE__*/React__default.createElement(Grid$1, {
    item: true,
    xs: 12,
    lg: 6,
    container: true,
    alignItems: "center"
  }, /*#__PURE__*/React__default.createElement(Box$1, {
    display: "flex",
    alignItems: "center"
  }, /*#__PURE__*/React__default.createElement(Box$1, {
    mr: 1
  }, "Captcha: ", /*#__PURE__*/React__default.createElement("span", {
    style: {
      color: 'black',
      fontStyle: 'italic',
      fontSize: '20px'
    }
  }, captcha)), /*#__PURE__*/React__default.createElement(IconButton, {
    onClick: generateCaptcha
  }, /*#__PURE__*/React__default.createElement(CachedIcon, null)))), /*#__PURE__*/React__default.createElement(Grid$1, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    type: "submit",
    variant: "contained",
    color: "warning",
    size: "large",
    disabled: !isValid || !isCaptchaValid
  }, "Submit"))))));
}

function Forms() {
  return /*#__PURE__*/React__default.createElement(FormsContainer, null, /*#__PURE__*/React__default.createElement(Checklist, null), /*#__PURE__*/React__default.createElement(Feedback, null));
}

function Footer() {
  return /*#__PURE__*/React__default.createElement(FooterWrapper, null, /*#__PURE__*/React__default.createElement(Box$1, null, "\xA9 2023-24 Urban Development Department, Govt. of Uttar Pradesh"), /*#__PURE__*/React__default.createElement(Box$1, null, "Powered by UPYOG | Copywrite \xA9 2022 National Institute of Urban Affairs | UPYOG License"));
}

function NewUDHome() {
  var _location$pathname;
  const location = useLocation();
  const homepath = location === null || location === void 0 ? void 0 : (_location$pathname = location.pathname) === null || _location$pathname === void 0 ? void 0 : _location$pathname.includes("digit-ui/citizen");
  const isBigScreen = useMediaQuery(theme => theme.breakpoints.up('lg'));
  const isMediumScreen = useMediaQuery('(min-width:900px) and (max-width:1199px)');
  const isSmallScreen = useMediaQuery('(min-width:600px) and (max-width:899px)');
  return /*#__PURE__*/React__default.createElement(HomeWrapper, {
    style: {
      marginTop: homepath ? '-80px' : '0px'
    }
  }, /*#__PURE__*/React__default.createElement(Header$1, null), /*#__PURE__*/React__default.createElement(Hero, null), /*#__PURE__*/React__default.createElement(Services, null), /*#__PURE__*/React__default.createElement(AppDetails, null), /*#__PURE__*/React__default.createElement(Forms, null), /*#__PURE__*/React__default.createElement(LinksSlideshow, {
    titleStyles: {
      textTransform: 'uppercase',
      fontSize: '1.25rem',
      color: '#0E7693',
      fontWeight: 600
    },
    containerStyles: {
      maxWidth: 1200 - 48,
      marginInline: 'auto'
    },
    noOfSlides: isBigScreen ? 5 : isMediumScreen ? 3 : isSmallScreen ? 2 : 1
  }), /*#__PURE__*/React__default.createElement(Footer, null));
}

const HeaderTitle$1 = styled$2(Box$1)(() => ({
  textAlign: 'center'
}));
const Title1$1 = styled$2(Typography$1)(({
  theme
}) => ({
  fontSize: theme.typography.fontSize,
  color: theme.palette.grey['50'],
  [theme.breakpoints.up('lg')]: {
    fontSize: theme.typography.fontSize * 1.4,
    color: theme.palette.mode === 'dark' ? theme.palette.grey['100'] : '#191B20'
  }
}));
const Title2$1 = styled$2(Typography$1)(({
  theme
}) => ({
  fontWeight: theme.typography.fontWeightBold,
  fontSize: theme.typography.fontSize,
  color: theme.palette.grey['100'],
  [theme.breakpoints.up('lg')]: {
    fontSize: theme.typography.fontSize * 1.6,
    color: theme.palette.mode === 'dark' ? theme.palette.grey['50'] : '#0C0D10'
  }
}));
const HomeWrapper$1 = styled$2(Box$1)(({
  theme
}) => ({
  fontFamily: theme.typography.fontFamily,
  marginTop: theme.spacing(-10)
}));
const NavContainer$1 = styled$2(Container$1)(({
  theme
}) => ({
  maxWidth: theme.breakpoints['lg'],
  minHeight: theme.spacing(6.25),
  [theme.breakpoints.up('lg')]: {
    color: theme.palette.common.black,
    backgroundColor: 'transparent',
    minHeight: theme.spacing(5)
  },
  backgroundColor: theme.palette.tcp.primary.main,
  color: theme.palette.tcp.primary.text
}));
const NavToolbar$1 = styled$2(Toolbar)(({
  theme
}) => ({
  maxWidth: theme.breakpoints['lg'],
  justifyContent: 'space-between',
  padding: theme.spacing(0.5, 0),
  [theme.breakpoints.up('lg')]: {
    padding: theme.spacing(1, 0),
    justifyContent: 'center'
  },
  minHeight: theme.spacing(4),
  columnGap: theme.spacing(1),
  textAlign: 'center'
}));
const StyledDrawer$1 = styled$2(Drawer)(({
  theme
}) => ({
  '& .MuiDrawer-paper': {
    backgroundColor: theme.palette.tcp.primary.main,
    boxSizing: 'border-box',
    overflow: 'hidden',
    '& .subMenu': {
      backgroundColor: alpha(theme.palette.common.black, 0.1),
      paddingInline: theme.spacing(2),
      '& .MuiButton-root': {
        display: 'block',
        textAlign: 'left',
        width: '100%'
      }
    },
    '& .MuiButton-root': {
      paddingInline: theme.spacing(2),
      justifyContent: 'space-between',
      lineHeight: theme.spacing(5),
      borderRadius: 0,
      '&.MuiButton-contained, &.MuiButton-outlined': {
        paddingInline: theme.spacing(3)
      },
      '&.MuiButton-outlined': {
        borderColor: alpha(theme.palette.common.black, 0.1)
      }
    },
    '& .MuiDivider-vertical': {
      height: '1px !important',
      display: 'block',
      width: '100%'
    }
  }
}));
const MenuItem$1 = styled$2(Button$2)(({
  theme
}) => ({
  borderRadius: theme.shape.borderRadius * 0.5,
  color: theme.palette.primary.contrastText,
  paddingBlock: theme.spacing(0.25)
}));
const StyledDivider$2 = styled$2(Divider$1)(({
  theme
}) => ({
  height: theme.spacing(3.25) + ' !important',
  color: theme.palette.grey['50'],
  alignSelf: 'center'
}));
const StyledMenu$1 = styled$2(Menu$1)(({
  theme
}) => ({
  '& .MuiMenu-paper': {
    backgroundColor: theme.palette.tcp.primary.main,
    borderRadius: theme.shape.borderRadius * .75,
    translateY: theme.spacing(0.5),
    minWidth: 140,
    '& .MuiButton-root': {
      paddingInline: theme.spacing(2),
      textAlign: 'left',
      display: 'block',
      width: '100%'
    }
  }
}));
const TCPTopBarWrapper = styled$2(Box$1)(({
  theme
}) => ({
  backgroundColor: theme.palette.tcp.primary.main,
  [theme.breakpoints.up('lg')]: {
    backgroundColor: theme.palette.background.paper
  },
  padding: theme.spacing(0.25, 0)
}));
const ContainerWrapper$1 = styled$2(Container$1)(({
  theme
}) => ({
  maxWidth: theme.breakpoints['lg'],
  justifyContent: 'flex-end',
  gap: theme.spacing(2.5),
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  [theme.breakpoints.up('lg')]: {
    flexDirection: 'row'
  }
}));
const HeroWrapper$1 = styled$2(Box$1)(({
  theme,
  bgimg
}) => ({
  background: `${theme.palette.grey['200']} url('${bgimg}') center center / cover no-repeat`,
  transition: `background 1.5s ease-in-out`,
  minHeight: `calc(100dvh + 350px)`,
  position: 'relative',
  [theme.breakpoints.up('lg')]: {
    minHeight: `calc(100dvh + 400px)`
  }
}));
const HeroTopLeftMessage$1 = styled$2(Box$1)(({
  theme
}) => ({
  backgroundColor: alpha(theme.palette.common.black, 0.25),
  fontWeight: theme.typography.fontWeightMedium,
  textShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.75)',
  inset: theme.spacing(4, 4, 'auto', 4),
  [theme.breakpoints.up('sm')]: {
    inset: theme.spacing(4, 'auto', 'auto', 4)
  },
  fontSize: theme.typography.fontSize * 1.4,
  color: theme.palette.common.white,
  borderRadius: theme.spacing(0.5),
  backdropFilter: 'blur(1px)',
  padding: theme.spacing(2),
  position: 'absolute'
}));
const HeroMantriStrip$1 = styled$2(Box$1)(({
  theme
}) => ({
  backgroundColor: alpha(theme.palette.common.black, 0.7),
  inset: theme.spacing('auto', 0, 2),
  color: theme.palette.common.white,
  padding: theme.spacing(3, 4),
  [theme.breakpoints.up('md')]: {
    padding: theme.spacing(3, 8)
  },
  [theme.breakpoints.up('lg')]: {
    padding: theme.spacing(3, 12)
  },
  backdropFilter: 'blur(1px)',
  position: 'absolute'
}));
const PersonCard$1 = styled$2(Grid$1)(({
  theme
}) => ({
  justifyContent: 'space-between',
  gap: theme.spacing(2),
  alignItems: 'center',
  display: 'flex'
}));
const PersonPic$1 = styled$2(Box$1)(({
  theme
}) => ({
  '& img': {
    objectFit: 'cover',
    display: 'block',
    height: 80,
    width: 80
  }
}));
const PersonDesc$1 = styled$2(Box$1)(({
  theme
}) => ({
  fontSize: theme.typography.fontSize,
  color: theme.palette.common.white,
  flex: 1,
  '& strong': {
    fontWeight: theme.typography.fontWeightMedium,
    display: 'block'
  }
}));
const ServicesContainer$1 = styled$2(Container$1)(({
  theme
}) => ({
  maxWidth: theme.breakpoints['lg'],
  paddingBlock: theme.spacing(4)
}));
const ServiceGrid$1 = styled$2(Grid$1)(({
  theme
}) => ({
  justifyContent: 'center',
  '& .MuiButtonBase-root': {
    fontWeight: theme.typography.fontWeightSemiBold,
    flexDirection: 'row',
    textAlign: 'center',
    width: '100%',
    flex: 1,
    '& img': {
      marginBottom: theme.spacing(1),
      display: 'block',
      margin: 'auto',
      maxWidth: 150
    }
  }
}));
const getGradientBackground = index => {
  switch (index) {
    case 0:
      return 'linear-gradient(to bottom, #F7A143, #fbdfb3)';
    case 1:
      return 'linear-gradient(to bottom, #4BAB58, #b7ddbc)';
    case 2:
      return 'linear-gradient(to bottom, #60329C, #bfadd7)';
    case 3:
      return 'linear-gradient(to bottom, #2E91E8, #abd3f5)';
    default:
      return 'linear-gradient(to bottom, #000000, #FFFFFF)';
  }
};
const ServiceButton = styled$2(ButtonBase)(({
  theme,
  index
}) => ({
  padding: theme.spacing(2),
  backgroundImage: getGradientBackground(index),
  borderRadius: '20px',
  color: 'white',
  textAlign: 'center',
  width: '100%',
  height: '100%'
}));
const FacilationContainer = styled$2(Card)(({
  theme
}) => ({
  position: 'relative',
  width: '100%',
  margin: 'auto',
  marginTop: theme.spacing(4),
  padding: theme.spacing(2),
  height: 'auto',
  overflow: 'hidden'
}));
const CitizenTextContainer = styled$2('div')(({
  theme
}) => ({
  margin: 'auto',
  textAlign: 'center',
  color: '#fff',
  fontWeight: 'bold',
  marginTop: theme.spacing(2),
  fontSize: '24px'
}));
const FacilationButton = styled$2(ButtonBase)(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  width: '100%',
  height: '100%'
}));

const eServiceArray = [{
  href: 'https://tcp.hp.gov.in/Download/UM_HPTCP_CITIZEN_PORTAL.pdf',
  label: 'Download User Manual for TCP Citizen/Private Professional Portal',
  icon: 'pdf'
}, {
  href: 'https://tcp.hp.gov.in/Download/UM_HPTCP_OFFICER_PORTAL.pdf',
  label: 'Download User Manual for TCP Officer Portal',
  icon: 'pdf'
}, {
  href: 'https://tcp.hp.gov.in/Download/TCP_form10.wmv',
  label: 'Download Video Tutorial for Private Professional Registration',
  icon: 'wmv'
}, {
  href: 'https://tcp.hp.gov.in/Download/TCP_form11.wmv',
  label: 'Download Video Tutorial for Subdivision of Land',
  icon: 'wmv'
}, {
  href: 'https://tcp.hp.gov.in/Download/TCP_form12.wmv',
  label: 'Download Video Tutorial for Building Permission',
  icon: 'wmv'
}, {
  href: 'https://tcp.hp.gov.in/Download/TCP_form26.wmv',
  label: 'Download Video Tutorial for Deviation',
  icon: 'wmv'
}];
const useStyles$9 = makeStyles(theme => ({
  appBar: {
    '&.MuiPaper-root': {
      backgroundColor: theme.palette.mode === 'light' ? '#fafafa' : '#999',
      color: theme.palette.mode === 'light' ? 'black' : 'white',
      minHeight: '2.25rem'
    }
  },
  toolbar: {
    '&.MuiToolbar-root': {
      justifyContent: 'space-between',
      paddingBlock: '0.25rem',
      minHeight: '2.25rem'
    }
  },
  flexBox: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.75rem'
  },
  icons: {
    borderRight: '1px solid rgba(85, 85, 85, 0.25)',
    paddingRight: '0.75rem',
    alignItems: 'center',
    display: 'flex'
  },
  divider: {
    '&.MuiDivider-flexItem': {
      backgroundColor: '#555',
      marginInline: '0.75rem',
      height: 'auto'
    }
  },
  eServiceUserGuide: {
    padding: 5,
    cursor: 'pointer'
  },
  eMapLoginBtn: {
    width: 130,
    height: 35,
    backgroundColor: '#207CBD !important',
    color: 'white !important'
  },
  skip2Main: {
    fontSize: '14px !important',
    margin: '0 20px',
    cursor: 'pointer'
  },
  language: {
    fontSize: '1rem !important',
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem'
  },
  iconBtn: {
    width: 22,
    height: 22,
    margin: '0 4px'
  },
  searchField: {
    background: `${theme.palette.mode === 'light' ? 'white' : '#bbb'} url(https://tcp.hp.gov.in/img/search.png) no-repeat calc(100% - 10px) center`,
    border: `1px solid ${theme.palette.mode === 'light' ? '#eee' : '#aaa'}`,
    padding: '5px 10px'
  },
  iconStyle: {
    width: 25,
    height: 25,
    borderRadius: '50%',
    border: '2px solid #1F4A7C',
    color: '#1F4A7C'
  }
}));
function Strip() {
  const theme = useTheme();
  const colorMode = useContext(ColorModeContext);
  const classes = useStyles$9();
  const [userGuidePop, setUserGuidePop] = useState(false);
  const toggleUserGuide = () => {
    setUserGuidePop(state => !state);
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(AppBar, {
    position: "static",
    className: classes.appBar
  }, /*#__PURE__*/React__default.createElement(Toolbar, {
    className: classes.toolbar
  }, /*#__PURE__*/React__default.createElement(Box$1, {
    className: classes.flexBox
  }, /*#__PURE__*/React__default.createElement(Box$1, {
    className: classes.icons
  }, /*#__PURE__*/React__default.createElement(IconButton$2, {
    size: "small",
    "aria-label": "screenReader",
    onClick: () => window.open('https://tcp.hp.gov.in/screenReader', "_blank")
  }, /*#__PURE__*/React__default.createElement(BsFillVolumeUpFill, {
    className: classes.iconStyle
  })), /*#__PURE__*/React__default.createElement(IconButton$2, {
    size: "small",
    "aria-label": "android app",
    onClick: () => window.open('https://play.google.com/store/apps/details?id=com.csm.hptcp.hptcpmobileapp', "_blank")
  }, /*#__PURE__*/React__default.createElement(DiAndroid, {
    className: classes.iconStyle
  })), /*#__PURE__*/React__default.createElement(IconButton$2, {
    size: "small",
    "aria-label": "microsoft app",
    onClick: () => window.open('https://www.microsoft.com/en-in/store/p/him-tcp/9nblggh406mz', "_blank")
  }, /*#__PURE__*/React__default.createElement(AiFillWindows, {
    className: classes.iconStyle
  })), /*#__PURE__*/React__default.createElement(IconButton$2, {
    size: "small",
    "aria-label": "apple/iOS app",
    onClick: () => window.open('https://itunes.apple.com/us/app/him-tcp/id1161638555?ls=1&mt=8', "_blank")
  }, /*#__PURE__*/React__default.createElement(BsApple, {
    className: classes.iconStyle
  }))), /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "p",
    className: classes.eServiceUserGuide,
    onClick: toggleUserGuide
  }, "e-service User Guide"), /*#__PURE__*/React__default.createElement(Button$2, {
    onClick: () => window.open('https://tcp.hp.gov.in/login/4', "_blank"),
    className: classes.eMapLoginBtn
  }, "E-Map Login")), /*#__PURE__*/React__default.createElement("a", {
    href: "#skip2main",
    className: classes.skip2Main
  }, "Skip to main content"), /*#__PURE__*/React__default.createElement(Box$1, {
    className: classes.flexBox
  }, /*#__PURE__*/React__default.createElement(Box$1, {
    className: classes.icons
  }, /*#__PURE__*/React__default.createElement(IconButton$2, {
    size: "small"
  }, /*#__PURE__*/React__default.createElement(TextDecrease, null)), /*#__PURE__*/React__default.createElement(IconButton$2, {
    size: "small"
  }, /*#__PURE__*/React__default.createElement(HdrAuto, null)), /*#__PURE__*/React__default.createElement(IconButton$2, {
    size: "small"
  }, /*#__PURE__*/React__default.createElement(TextIncrease, null)), /*#__PURE__*/React__default.createElement(Divider$1, {
    orientation: "vertical",
    variant: "middle",
    flexItem: true,
    className: classes.divider
  }), /*#__PURE__*/React__default.createElement(IconButton$2, {
    size: "small",
    onClick: colorMode.toggleThemeMode
  }, theme.palette.mode === 'light' ? /*#__PURE__*/React__default.createElement(DarkMode, null) : /*#__PURE__*/React__default.createElement(LightMode, null))), /*#__PURE__*/React__default.createElement(Button$2, {
    className: classes.language
  }, /*#__PURE__*/React__default.createElement(Language, null), " ", /*#__PURE__*/React__default.createElement(Typography$1, null, "\u0939\u093F\u0902\u0926\u0940")), /*#__PURE__*/React__default.createElement("input", {
    className: classes.searchField,
    type: "text",
    placeholder: "Search here..."
  })))), /*#__PURE__*/React__default.createElement(Modal$1, {
    open: userGuidePop,
    onClose: toggleUserGuide
  }, /*#__PURE__*/React__default.createElement(Box$1, {
    sx: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      backgroundColor: 'white',
      borderRadius: '10px',
      outline: 'none'
    }
  }, /*#__PURE__*/React__default.createElement(Box$1, {
    sx: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '10px 10px 10px 20px',
      borderBottom: '1px solid #eee'
    }
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "h5",
    component: "h2"
  }, "e-Services User Guide"), /*#__PURE__*/React__default.createElement(IconButton$2, {
    "aria-label": "close",
    onClick: toggleUserGuide
  }, /*#__PURE__*/React__default.createElement(Close, null))), /*#__PURE__*/React__default.createElement(Box$1, {
    sx: {
      padding: '20px 20px 10px'
    }
  }, eServiceArray.map(({
    href,
    label,
    icon
  }, index) => /*#__PURE__*/React__default.createElement("a", {
    key: `${href}_${index}`,
    href: href,
    target: "_blank",
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: '1rem',
      backgroundColor: '#dceefb',
      borderRadius: '5px',
      padding: '1rem',
      marginBottom: '1rem'
    }
  }, label, " ", icon === 'pdf' ? /*#__PURE__*/React__default.createElement(PictureAsPdf, null) : /*#__PURE__*/React__default.createElement(VideoCameraBack, null)))))));
}

const GovtStrip = () => {
  return /*#__PURE__*/React__default.createElement(Box$1, {
    sx: {
      height: 140,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      bgcolor: '#fff',
      color: 'black',
      gap: '1rem',
      padding: '0 1.5rem'
    }
  }, /*#__PURE__*/React__default.createElement(Box$1, {
    sx: {
      display: 'flex',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React__default.createElement("img", {
    src: "https://upload.wikimedia.org/wikipedia/commons/f/fa/Seal_of_Uttar_Pradesh.svg",
    alt: "image2",
    style: {
      height: 70,
      margin: '10px 16px 10px 0'
    }
  }), /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: 'flex',
      color: '#1F4A7C',
      width: '590px',
      border: '7px solid #1F4A7C',
      position: 'relative',
      justifyContent: 'space-between'
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column'
    }
  }, /*#__PURE__*/React__default.createElement("h4", {
    style: {
      margin: 10,
      padding: '0 10px',
      whiteSpace: 'nowrap',
      position: 'absolute',
      top: '-20px',
      backgroundColor: 'white'
    }
  }, "\u0909\u0924\u094D\u0924\u0930 \u092A\u094D\u0930\u0926\u0947\u0936 \u0938\u0930\u0915\u093E\u0930"), /*#__PURE__*/React__default.createElement("h2", {
    style: {
      color: '#154773',
      fontSize: '1.25rem',
      margin: '14px 10px 5px'
    }
  }, "\u0906\u0935\u093E\u0938 \u090F\u0935\u0902 \u0935\u093F\u0915\u093E\u0938 \u092A\u0930\u093F\u0937\u0926"), /*#__PURE__*/React__default.createElement("h2", {
    style: {
      fontSize: '1.5rem',
      margin: '0px 0px 14px 10px'
    }
  }, "Awas Evam Vikas Parishad"), /*#__PURE__*/React__default.createElement("h6", {
    style: {
      color: '#154773',
      margin: 10,
      padding: '0 10px',
      position: 'absolute',
      bottom: '-23px',
      right: 0,
      whiteSpace: 'nowrap',
      backgroundColor: 'white'
    }
  }, "Government of Uttar Pradesh")), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("img", {
    src: "https://upload.wikimedia.org/wikipedia/commons/f/fa/Seal_of_Uttar_Pradesh.svg",
    alt: "Himachal",
    style: {
      height: '70px',
      margin: '10px 10px 10px 10px'
    }
  })))), /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: 10
    }
  }, /*#__PURE__*/React__default.createElement("img", {
    src: "https://i.imgur.com/TmeY0xa.jpeg",
    alt: "imageAmrit",
    style: {
      height: 70
    }
  }), /*#__PURE__*/React__default.createElement("img", {
    src: "https://i.imgur.com/ERyQTFC.png",
    alt: "imageSwatchh",
    style: {
      height: 70
    }
  }), /*#__PURE__*/React__default.createElement("img", {
    src: "https://i.imgur.com/L8ZRv8Y.png",
    alt: "image150",
    style: {
      height: 70
    }
  }), /*#__PURE__*/React__default.createElement("img", {
    src: "https://static.mygov.in/archive/g20/images/g20-logo.png",
    alt: "imageG20",
    style: {
      height: 70
    }
  })));
};

const bannerImgUrls$1 = ['https://i.imgur.com/lrTWHNw.png'];
const bannerCmStripData$1 = [{
  photo: "https://www.awasbandhu.in/wp-content/uploads/2023/01/cmyogi.jpg",
  name: "Yogi Adityanath",
  designation: "Hon'ble Chief Minister"
}, {
  photo: "https://www.awasbandhu.in/wp-content/uploads/2023/01/principal-sec.jpg",
  name: "Dr. Nitin Ramesh Gokarn",
  designation: "Addl. Chief Secretary, Housing and Urban Planning"
}, {
  photo: "https://www.awasbandhu.in/wp-content/uploads/2024/03/principal-sec-02.png",
  name: "Dr. Balkar Singh",
  designation: "Executive Director, Awas Bandhu"
}];
const getServicesData$1 = toggleModal => [{
  icon: 'https://i.imgur.com/72lqHju.png',
  label: 'Online Services',
  action: '/digit-ui/citizen/profile',
  gradientClass: ''
}, {
  icon: 'https://i.imgur.com/RLDNCUS.png',
  label: 'Officer Login',
  action: '/digit-ui/employee'
}, {
  icon: 'https://i.imgur.com/9piU18h.png',
  label: 'Fee Calculator',
  action: '/digit-ui/citizen/feeCalculator'
}, {
  icon: 'https://i.imgur.com/mfeY0Ib.png',
  label: 'Check Application Status',
  action: toggleModal
}];
const homeUrl$1 = '/digit-ui/citizen';
const navData$1 = [{
  label: 'Home',
  url: homeUrl$1
}, {
  label: 'About Us',
  url: `${homeUrl$1}/objectives`
}, {
  label: 'Contact Us',
  url: `${homeUrl$1}/contact-us`
}, {
  label: 'Planning Regulations',
  url: `${homeUrl$1}/appendix-1`
}, {
  label: 'Development Plan',
  url: `${homeUrl$1}/development-plan`
}, {
  label: 'Notification / Order',
  url: `${homeUrl$1}/notifications-under-tcp-act`
}, {
  label: 'Acts & Rules',
  url: null,
  subMenu: [{
    label: 'Delegation of Power',
    url: `${homeUrl$1}/delegation-of-powers`
  }]
}, {
  label: 'Media',
  url: `${homeUrl$1}/photo-gallery`
}];

function MenuLinks$1({
  open,
  anchorEl,
  handleClose,
  handleClick
}) {
  const history = useHistory();
  const handleBtnClick = url => {
    console.log(url);
    return url ? history.push(url) : null;
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, navData$1.map(menu => /*#__PURE__*/React__default.createElement(React__default.Fragment, {
    key: menu.label + menu.url
  }, /*#__PURE__*/React__default.createElement(MenuItem$1, Object.assign({}, menu.label === 'Home' && {
    color: 'warning',
    variant: 'contained',
    disableElevation: true
  }, menu.subMenu ? {
    ...(open && {
      'aria-controls': 'sub-menu'
    }),
    ...(open && {
      'aria-expanded': 'true'
    }),
    'aria-haspopup': "true",
    onClick: event => {
      handleBtnClick(menu.url);
      handleClick(event);
    },
    id: 'menu-button',
    endIcon: /*#__PURE__*/React__default.createElement(ArrowDropDown, null)
  } : {
    onClick: () => handleBtnClick(menu.url)
  }), menu.label), /*#__PURE__*/React__default.createElement(StyledDivider$2, {
    orientation: "vertical"
  }), menu.subMenu && /*#__PURE__*/React__default.createElement(StyledMenu$1, {
    id: "sub-menu",
    anchorEl: anchorEl,
    open: open,
    className: "subMenu",
    onClose: handleClose,
    MenuListProps: {
      'aria-labelledby': 'menu-button'
    }
  }, menu.subMenu.map((sub, index) => /*#__PURE__*/React__default.createElement(React__default.Fragment, null, index > 0 && /*#__PURE__*/React__default.createElement(StyledDivider$2, {
    orientation: "vertical"
  }), /*#__PURE__*/React__default.createElement(MenuItem$1, {
    key: sub.label + sub.url,
    onClick: event => {
      handleBtnClick(sub.url);
      handleClose(event);
    }
  }, sub.label))), /*#__PURE__*/React__default.createElement(StyledDivider$2, {
    orientation: "vertical"
  })))));
}

function TopBar$2() {
  return /*#__PURE__*/React__default.createElement(TCPTopBarWrapper, null, /*#__PURE__*/React__default.createElement(ContainerWrapper$1, null, /*#__PURE__*/React__default.createElement(Search, null), /*#__PURE__*/React__default.createElement(LanguageSwitcher, null), /*#__PURE__*/React__default.createElement(FontSizeController, null), /*#__PURE__*/React__default.createElement(ThemeSwitcher, null), /*#__PURE__*/React__default.createElement(TopIcons, null)));
}

const drawerWidth$1 = 240;
function MobileHeader$1({
  window
}) {
  const [navMenuOpen, setNavMenuOpen] = useState(false);
  const [settingsMenuOpen, setSettingsMenuOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const container = window !== undefined ? () => window().document.body : undefined;
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleDrawerToggle = () => {
    setNavMenuOpen(prevState => !prevState);
  };
  const handleSettingsToggle = () => {
    setSettingsMenuOpen(prevState => !prevState);
  };
  return /*#__PURE__*/React__default.createElement(NavContainer$1, {
    style: {
      backgroundColor: '#1F4A7C'
    }
  }, /*#__PURE__*/React__default.createElement(NavToolbar$1, null, /*#__PURE__*/React__default.createElement(IconButton$2, {
    color: "inherit",
    "aria-label": "open drawer",
    edge: "start",
    onClick: handleDrawerToggle
  }, /*#__PURE__*/React__default.createElement(MenuIcon, null)), /*#__PURE__*/React__default.createElement(Box$1, {
    sx: {
      display: 'flex',
      alignItems: 'center',
      gap: 2
    }
  }, /*#__PURE__*/React__default.createElement("img", {
    src: "https://upload.wikimedia.org/wikipedia/commons/f/fa/Seal_of_Uttar_Pradesh.svg",
    style: {
      maxHeight: 40
    }
  }), /*#__PURE__*/React__default.createElement(HeaderTitle$1, {
    sx: {
      display: {
        sm: 'block',
        xs: 'none'
      }
    }
  }, /*#__PURE__*/React__default.createElement(Title1$1, {
    variant: "h6"
  }, "Government of Uttar Pradesh"), /*#__PURE__*/React__default.createElement(Title2$1, {
    variant: "h5"
  }, "Department of Town and Country Planning"))), /*#__PURE__*/React__default.createElement(IconButton$2, {
    color: "inherit",
    "aria-label": "open settings",
    edge: "end",
    onClick: handleSettingsToggle
  }, /*#__PURE__*/React__default.createElement(SettingsIcon, null)), /*#__PURE__*/React__default.createElement(StyledDrawer$1, {
    open: navMenuOpen,
    variant: "temporary",
    container: container,
    onClose: handleDrawerToggle,
    ModalProps: {
      keepMounted: true
    },
    sx: {
      '& .MuiDrawer-paper': {
        width: drawerWidth$1
      }
    }
  }, /*#__PURE__*/React__default.createElement(MenuLinks$1, {
    open: open,
    anchorEl: anchorEl,
    handleClose: handleClose,
    handleClick: handleClick
  })), /*#__PURE__*/React__default.createElement(StyledDrawer$1, {
    anchor: "right",
    variant: "temporary",
    container: container,
    open: settingsMenuOpen,
    onClose: handleSettingsToggle,
    ModalProps: {
      keepMounted: true
    },
    sx: {
      '& .MuiDrawer-paper': {
        width: drawerWidth$1
      }
    }
  }, /*#__PURE__*/React__default.createElement(TopBar$2, null))));
}

function Header$2() {
  const isDesktop = useMediaQuery(theme => theme.breakpoints.up('lg'));
  if (isDesktop) {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Strip, null), /*#__PURE__*/React__default.createElement(GovtStrip, null));
  }
  return /*#__PURE__*/React__default.createElement(MobileHeader$1, null);
}

const useStyles$a = makeStyles(theme => ({
  parentContainer: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%'
  },
  infoWrapper: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#fff',
    height: '32px',
    padding: '0 8px',
    borderRadius: '4px',
    textShadow: '.5px .5px #CC8500',
    animation: '$backgroundChange 4s linear infinite'
  },
  info: {
    color: 'black',
    textAlign: 'center',
    fontWeight: 'bold',
    marginLeft: theme.spacing(1)
  },
  icon: {
    width: '32px',
    height: '16px'
  },
  '@keyframes backgroundChange': {
    '0%': {
      backgroundColor: '#fff'
    },
    '50%': {
      backgroundColor: '#26aa01'
    },
    '100%': {
      backgroundColor: '#fff'
    }
  }
}));
function Hero$1() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const classes = useStyles$a();
  useEffect(() => {
    let timer = setInterval(() => {
      setCurrentSlide(curr => curr + 1 < bannerImgUrls$1.length ? curr + 1 : 0);
    }, 4000);
    return () => clearInterval(timer);
  }, []);
  return /*#__PURE__*/React__default.createElement(HeroWrapper$1, {
    bgimg: bannerImgUrls$1[currentSlide]
  }, /*#__PURE__*/React__default.createElement(HeroTopLeftMessage$1, null, "Development is about transforming the lives of people"), /*#__PURE__*/React__default.createElement(HeroMantriStrip$1, null, /*#__PURE__*/React__default.createElement(Grid$1, {
    container: true,
    spacing: 2,
    wrap: "nowrap",
    justifyContent: "center"
  }, bannerCmStripData$1.map(({
    photo,
    name,
    designation
  }) => /*#__PURE__*/React__default.createElement(PersonCard$1, {
    item: true,
    key: name,
    xs: 12,
    md: 6,
    lg: 3
  }, /*#__PURE__*/React__default.createElement(PersonPic$1, null, /*#__PURE__*/React__default.createElement("img", {
    src: photo,
    alt: name
  })), /*#__PURE__*/React__default.createElement(PersonDesc$1, null, /*#__PURE__*/React__default.createElement("strong", null, name), designation))))));
}

function Services$1() {
  const {
    t
  } = useTranslation();
  const history = useHistory();
  const isLoggedIn = Digit.UserService.getUser();
  const [open, setOpen] = useState(false);
  const [searchOption, setSearchOption] = useState('reference');
  const [placeholderText, setPlaceholderText] = useState('Enter reference number');
  const [applicationNo, setApplicationNo] = useState('');
  const [showToast, setShowToast] = useState(null);
  const [formNo, setFormNo] = useState(null);
  const [formModal, setFormModal] = useState(false);
  const closeToast = () => {
    setShowToast(null);
  };
  useEffect(() => {
    if (!showToast) return;
    const timeOut = setTimeout(closeToast, 3000);
    return () => clearTimeout(timeOut);
  }, [showToast]);
  const toggleModal = () => {
    setOpen(isOpen => !isOpen);
  };
  const toggleFormModal = () => {
    setFormModal(formModal => !formModal);
  };
  const handleClick = action => {
    if (typeof action === 'function') {
      return action();
    }
    if (action === '/digit-ui/citizen/profile') {
      const specialAction = isLoggedIn ? action : {
        pathname: '/digit-ui/citizen/login',
        state: {
          from: action,
          userType: 'citizen'
        }
      };
      return history.push(specialAction);
    }
    return history.push(action);
  };
  const handleSearchOptionChange = event => {
    setSearchOption(event.target.value);
    setPlaceholderText(event.target.value === 'reference' ? 'Enter reference number' : 'Enter mobile number');
  };
  const handleSubmit = e => {
    e.preventDefault();
    if (applicationNo.includes('UD')) {
      setShowToast({
        error: true,
        message: `Please search the TCP Applications here...`
      });
      return 0;
    }
    const formNoMapping = {
      '12': 'form12',
      '11': 'form11',
      '26': 'form26'
    };
    const prefix = applicationNo.slice(5, 7);
    const formNo = formNoMapping[prefix];
    if (formNo) {
      setFormNo(formNo);
    }
    setFormModal(true);
  };
  const formComponents = {
    'form12': ApplicationView12,
    'form11': TakeActionItem,
    'form26': TakeActionItem
  };
  const ModalContent = formComponents[formNo];
  const servicesData = useMemo(() => getServicesData$1(toggleModal), []);
  return /*#__PURE__*/React__default.createElement(ServicesContainer$1, null, /*#__PURE__*/React__default.createElement(Grid$1, {
    container: true,
    spacing: 4
  }, servicesData.map((service, index) => /*#__PURE__*/React__default.createElement(ServiceGrid$1, {
    item: true,
    xs: 12,
    sm: 6,
    md: 4,
    lg: 12 / 4,
    key: service.label
  }, /*#__PURE__*/React__default.createElement(ServiceButton, {
    onClick: () => handleClick(service.action),
    index: index
  }, /*#__PURE__*/React__default.createElement("img", {
    src: service.icon,
    alt: service.label
  }), /*#__PURE__*/React__default.createElement("div", null, service.label))))), /*#__PURE__*/React__default.createElement(Modal, {
    open: open,
    onClose: toggleModal
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      backgroundColor: 'white',
      padding: '20px',
      borderRadius: '10px',
      outline: 'none'
    }
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "h5",
    component: "h2",
    style: {
      marginBottom: '20px'
    }
  }, "Know Your Application Status"), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(RadioGroup$1, {
    "aria-label": "search option",
    name: "searchOption",
    value: searchOption,
    onChange: handleSearchOptionChange
  }, /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    value: "reference",
    control: /*#__PURE__*/React__default.createElement(Radio$1, null),
    label: "Search by Application No"
  }))), /*#__PURE__*/React__default.createElement(TextField$1, {
    label: placeholderText,
    placeholder: placeholderText,
    fullWidth: true,
    margin: "normal",
    onChange: e => setApplicationNo(e.target.value)
  }), /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'center',
      marginTop: '20px'
    }
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    color: "primary",
    style: {
      backgroundColor: '#1F4A7C'
    },
    onClick: handleSubmit
  }, "Submit")))), showToast && /*#__PURE__*/React__default.createElement(Toast, {
    error: showToast === null || showToast === void 0 ? void 0 : showToast.error,
    warning: showToast === null || showToast === void 0 ? void 0 : showToast.warning,
    label: t(showToast === null || showToast === void 0 ? void 0 : showToast.message),
    onClose: closeToast,
    isDleteBtn: true
  }), /*#__PURE__*/React__default.createElement(Modal, {
    open: formModal,
    onClose: toggleFormModal
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: 'flex',
      margin: 'auto',
      width: '70%',
      height: '100%',
      overflow: 'scroll'
    }
  }, ModalContent && /*#__PURE__*/React__default.createElement(ModalContent, {
    formType: formNo,
    id: applicationNo
  }))));
}

const useStyles$b = makeStyles$1(theme => ({
  root: {
    textAlign: 'center',
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4)
  },
  paragraph: {
    width: '85%',
    margin: 'auto'
  },
  aboutus: {
    color: '#2F5EA8',
    fontSize: '24px',
    fontWeight: 'bold'
  }
}));
const AboutUs = () => {
  const classes = useStyles$b();
  return /*#__PURE__*/React__default.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h4",
    gutterBottom: true,
    className: classes.aboutus
  }, "ABOUT US"), /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body1",
    className: classes.paragraph
  }, "The Town and Country Planning was created as a small cell in Uttar Pradesh, Public Works Department in the year 1964. During 1979, it was created as in independent Directorate headed by Chief Engineer of Uttar Pradesh Public Works Department till 1993 when independent Director was appointed as Head of Department."));
};

const useStyles$c = makeStyles(theme => ({
  card: {
    maxWidth: 350,
    margin: '10px',
    boxShadow: 'rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;',
    height: 420
  },
  header: {
    backgroundColor: '#2F5EA8',
    color: '#fff',
    padding: '10px',
    fontSize: '15px',
    borderRadius: '7px'
  },
  link: {
    color: '#2F5EA8',
    textDecoration: 'none',
    fontSize: '14px',
    display: 'block',
    margin: '10px',
    transition: 'color 0.3s ease, text-decoration 0.3s ease, background-color 0.3s ease',
    cursor: 'pointer'
  },
  imageContainer: {
    display: 'flex',
    alignItems: 'center',
    margin: '30px 0'
  },
  image: {
    width: '120px',
    height: '60px',
    marginRight: '10px'
  },
  imageText: {
    fontWeight: 'bold'
  },
  view: {
    padding: '6px 12px',
    color: '#1F4A7C',
    marginLeft: '200px'
  },
  divider: {
    margin: '5px 0'
  }
}));
const CommonInfo = ({
  heading,
  paragraphs,
  buttonLabel,
  link
}) => {
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const classes = useStyles$c();
  const history = useHistory();
  const handleButtonClick = () => {
    history.push(link);
  };
  return /*#__PURE__*/React__default.createElement(Card, {
    className: classes.card
  }, /*#__PURE__*/React__default.createElement(CardContent, null, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h6",
    className: classes.header
  }, heading), paragraphs.map((paragraph, index) => paragraph.image ? /*#__PURE__*/React__default.createElement("div", {
    key: index,
    className: classes.imageContainer
  }, /*#__PURE__*/React__default.createElement("img", {
    src: paragraph.image,
    alt: paragraph.text,
    className: classes.image
  }), /*#__PURE__*/React__default.createElement("p", {
    className: classes.link,
    onClick: () => getDocumentByFileStoreId(paragraph.link, setIsPreviewLoading),
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: classes.imageText
  }, paragraph.text))) : /*#__PURE__*/React__default.createElement("div", {
    key: index
  }, /*#__PURE__*/React__default.createElement("p", {
    className: classes.link,
    onClick: () => getDocumentByFileStoreId(paragraph.link, setIsPreviewLoading),
    rel: "noopener noreferrer"
  }, paragraph.text), index < paragraphs.length - 1 && /*#__PURE__*/React__default.createElement(Divider, {
    className: classes.divider
  }))), /*#__PURE__*/React__default.createElement(Button, {
    className: classes.view,
    onClick: handleButtonClick
  }, buttonLabel)));
};

const basePath = '/digit-ui/citizen';
const infoData = [{
  heading: "Forms CheckLists",
  paragraphs: [{
    text: "Internal Procedure For Change Of Land Use Approval",
    link: "b521d819-007a-412e-8143-edaa57951f66"
  }, {
    text: "Internal Procedure For Building Planning Approval",
    link: "abf94285-3b1f-460e-bde5-73b60b6e1432"
  }, {
    text: "Inspection Procedure And Checklist of Obtaining Construction Permit",
    link: "8461e16f-9588-47a3-b47f-8efd82a8be92"
  }, {
    text: "Inspection Procedure And Checklist for Obtaining Final NOC",
    link: "13822986-edd3-4152-8fc4-4414c3966047"
  }, {
    text: "Procedure And Guidelines For Obtaining Planning Permission on Form12",
    link: "85661128-d905-4ac9-b4e2-299193597b35"
  }],
  buttonLabel: "View More >",
  link: `${basePath}/forms-checklists`
}, {
  heading: "Notification/Orders",
  paragraphs: [{
    text: "Circular Mandating Online Submission of Application",
    link: "90c7d8fc-f4f6-474f-876f-dd84b983dfa9"
  }, {
    text: "Clarification Regarding MIS - Interpreting of Basements",
    link: "3f467201-8918-4f52-9b15-be8532605b01"
  }, {
    text: "Notice For Publication Of Proposed Amendment(s) In Development Plans",
    link: "b7b4cfbd-a368-4378-8052-96bd37ed2c2f"
  }, {
    text: "Amendment In Idp Shimla Notification Dated 28/06/2016",
    link: "bb7cd57d-27b8-42b1-a03d-4488feceaef5"
  }, {
    text: "Exemptions In Rural Areas-clarifications Thereof",
    link: "7e485345-b50b-4856-bf4d-49ae76d85c57"
  }],
  buttonLabel: "View More >",
  link: `${basePath}/notifications-under-tcp-act`
}, {
  heading: "Development Plans",
  paragraphs: [{
    image: "https://tcp.hp.gov.in/Application/uploadDocuments/devlopmentPlan/PlanImeage20231201_125157.jpg",
    text: "Kullu Valley Planning Area",
    link: "a4b14125-e083-4c1d-a313-4abfed428c0a"
  }, {
    image: "https://tcp.hp.gov.in/Application/uploadDocuments/devlopmentPlan/PlanImeage20230520_125218.jpg",
    text: "Mehatpur",
    link: "13416074-abe2-4671-8b93-8e3dcf9663e7"
  }, {
    image: "https://tcp.hp.gov.in/Application/uploadDocuments/devlopmentPlan/PlanImeage20230520_124721.jpg",
    text: "Hatkoti",
    link: "c0972bbe-7d37-4d84-b20b-f231cd4cd1c6"
  }],
  buttonLabel: "View More >",
  link: `${basePath}/development-plan`
}];
function AppInfo() {
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-around',
      flexWrap: 'wrap'
    }
  }, infoData.map((info, index) => /*#__PURE__*/React__default.createElement(CommonInfo, {
    key: index,
    heading: info.heading,
    paragraphs: info.paragraphs,
    buttonLabel: info.buttonLabel,
    link: info.link
  })));
}

const useStyles$d = makeStyles(theme => ({
  root: {
    width: '50%',
    height: '550px',
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center'
  },
  formContainer: {
    width: 'auto',
    height: 'auto',
    padding: theme.spacing(2)
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2)
  },
  submitButton: {
    backgroundColor: '#1F4A7C',
    color: 'white',
    '&:hover': {
      backgroundColor: '#45a049'
    },
    marginTop: '20px',
    borderRadius: '5px'
  }
}));

const useStyles$e = makeStyles(theme => ({
  root: {
    display: 'flex',
    width: '100%',
    margin: 'auto',
    marginTop: theme.spacing(4),
    justifyContent: 'space-around',
    flexWrap: 'wrap'
  },
  imageContainer: {
    marginLeft: '5%',
    width: '45%',
    height: '520px',
    background: 'url(https://i.imgur.com/5k0HbLm.png)',
    objectFit: 'cover',
    backgroundPosition: 'center',
    backgroundSize: 'contain'
  }
}));
const FeedbackComplaint = () => {
  const classes = useStyles$e();
  return /*#__PURE__*/React__default.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classes.imageContainer
  }), /*#__PURE__*/React__default.createElement(Feedback, {
    isTCP: true
  }));
};

function Footer$1() {
  return /*#__PURE__*/React__default.createElement(TcpFooterWrapper, null, /*#__PURE__*/React__default.createElement(Box$1, null, "\xA9 2023-24 Department of Town & Country Planning, Govt. of Uttar Pradesh"), /*#__PURE__*/React__default.createElement(Box$1, null, "Powered by UPYOG | Copywrite \xA9 2022 National Institute of Urban Affairs | UPYOG License"));
}

const Image$1 = 'https://i.imgur.com/4LnPljT.jpeg';
const useStyles$f = makeStyles$2(theme => ({
  card: {
    position: 'relative',
    width: '100%',
    margin: 'auto',
    marginTop: theme.spacing(4),
    padding: theme.spacing(2),
    height: 'auto',
    overflow: 'hidden'
  },
  backgroundImage: {
    content: "''",
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundImage: `url(${Image$1})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    opacity: '50%'
  },
  backgroundColorLayer: {
    backgroundColor: 'rgba(47, 94, 168, 0.7)',
    width: '100%',
    height: '100%',
    position: 'absolute',
    opacity: '70%',
    top: 0,
    left: 0,
    zIndex: 1
  },
  icon: {
    fontSize: 40,
    color: 'white',
    width: '55px',
    height: '55px',
    zIndex: 2
  },
  title: {
    marginTop: theme.spacing(1),
    textAlign: 'center',
    color: 'white',
    margin: '20px',
    zIndex: 2
  },
  header: {
    position: 'relative',
    marginTop: theme.spacing(1),
    textAlign: 'center',
    color: '#fff',
    zIndex: 2,
    fontSize: '24px',
    fontWeight: '600px',
    marginBottom: '12px'
  }
}));
const CitizenFacilitation = () => {
  const classes = useStyles$f();
  const history = useHistory();
  const homeUrl = '/digit-ui/citizen';
  const inprogressUrl = `${homeUrl}/InProgreeService`;
  const iconData = [{
    icon: /*#__PURE__*/React__default.createElement("img", {
      src: "https://i.imgur.com/m4QnIck.png",
      className: classes.icon
    }),
    title: 'Notified Planning/Special Area',
    action: `${homeUrl}/notifiedArea`
  }, {
    icon: /*#__PURE__*/React__default.createElement("img", {
      src: "https://i.imgur.com/0qU2lat.png",
      className: classes.icon
    }),
    title: 'RTI',
    action: `${homeUrl}/rti`
  }, {
    icon: /*#__PURE__*/React__default.createElement("img", {
      src: "https://i.imgur.com/gAdiHIh.png",
      className: classes.icon
    }),
    title: 'Regitered Estate Agent',
    action: `${homeUrl}/registeredAgent`
  }, {
    icon: /*#__PURE__*/React__default.createElement("img", {
      src: "https://i.imgur.com/G0ZeisD.png",
      className: classes.icon
    }),
    title: 'Registered Promoters',
    action: `${homeUrl}/registeredArchitect`
  }, {
    icon: /*#__PURE__*/React__default.createElement("img", {
      src: "https://i.imgur.com/49sZB4N.png",
      className: classes.icon
    }),
    title: 'Directory of Registered Proffessionals',
    action: `${homeUrl}/registeredArchitect`
  }, {
    icon: /*#__PURE__*/React__default.createElement("img", {
      src: "https://i.imgur.com/64dfsol.png",
      className: classes.icon
    }),
    title: 'Download Forms',
    action: inprogressUrl
  }, {
    icon: /*#__PURE__*/React__default.createElement("img", {
      src: "https://i.imgur.com/2RI9Vr4.png",
      className: classes.icon
    }),
    title: 'Public Service Guarantee Act',
    action: `${homeUrl}/publicActs`
  }, {
    icon: /*#__PURE__*/React__default.createElement("img", {
      src: "https://i.imgur.com/Fmq7Rqx.png",
      className: classes.icon
    }),
    title: 'License and Essentiality Certificates',
    action: `${homeUrl}/licenseCertificate`
  }, {
    icon: /*#__PURE__*/React__default.createElement("img", {
      src: "https://i.imgur.com/cEmJalq.png",
      className: classes.icon
    }),
    title: 'Planning Permission case',
    action: `${homeUrl}/registeredArchitect`
  }, {
    icon: /*#__PURE__*/React__default.createElement("img", {
      src: "https://i.imgur.com/rLZI0Jx.png",
      className: classes.icon
    }),
    title: 'Instruction/Orders',
    action: `${homeUrl}/instructions-orders`
  }, {
    icon: /*#__PURE__*/React__default.createElement("img", {
      src: "https://i.imgur.com/TqMvq5G.png",
      className: classes.icon
    }),
    title: 'Area Locator',
    action: inprogressUrl
  }, {
    icon: /*#__PURE__*/React__default.createElement("img", {
      src: "https://i.imgur.com/eDXNkGq.png",
      className: classes.icon
    }),
    title: 'Unauthorized Construction',
    action: inprogressUrl
  }];
  return /*#__PURE__*/React__default.createElement(Card, {
    className: classes.card
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classes.backgroundImage
  }), /*#__PURE__*/React__default.createElement("div", {
    className: classes.backgroundColorLayer
  }), /*#__PURE__*/React__default.createElement(CardContent, null, /*#__PURE__*/React__default.createElement("div", {
    className: classes.header
  }, "Citizen Facilitation"), /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 2,
    justifyContent: "center",
    alignItems: "center",
    alignContent: "center"
  }, iconData.map((item, index) => /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    key: index,
    xs: 6,
    sm: 4,
    md: 3,
    lg: 2
  }, /*#__PURE__*/React__default.createElement(FacilationButton, {
    onClick: () => history.push(item.action)
  }, item.icon, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "subtitle1",
    className: classes.title
  }, item.title)))))));
};

const Navbar = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorE2, setAnchorE2] = useState(null);
  const [anchorE3, setAnchorE3] = useState(null);
  const [anchorE4, setAnchorE4] = useState(null);
  const [anchorE5, setAnchorE5] = useState(null);
  const [anchorE6, setAnchorE6] = useState(null);
  const [anchorE7, setAnchorE7] = useState(null);
  const [anchorE8, setAnchorE8] = useState(null);
  const [anchorE9, setAnchorE9] = useState(null);
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const {
    path
  } = useRouteMatch();
  const handleClickAboutUs = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleClickRegulation = event => {
    setAnchorE2(event.currentTarget);
  };
  const handleClickNotifications = event => {
    setAnchorE3(event.currentTarget);
  };
  const handleActRules = event => {
    setAnchorE4(event.currentTarget);
  };
  const handleMedia = event => {
    setAnchorE5(event.currentTarget);
  };
  const handleTutorial = event => {
    setAnchorE9(event.currentTarget);
  };
  const handleClickGenral = event => {
    setAnchorE6(event.currentTarget);
  };
  const handleClickUserManual = event => {
    setAnchorE7(event.currentTarget);
  };
  const handleClickForm12 = event => {
    setAnchorE8(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
    setAnchorE2(null);
    setAnchorE3(null);
    setAnchorE4(null);
    setAnchorE5(null);
    setAnchorE6(null);
    setAnchorE7(null);
    setAnchorE8(null);
  };
  return /*#__PURE__*/React__default.createElement(AppBar, {
    position: "static",
    style: {
      background: '#1F4A7C',
      height: '44px'
    }
  }, /*#__PURE__*/React__default.createElement(Toolbar, null, /*#__PURE__*/React__default.createElement(Button$2, {
    LinkComponent: Link$1,
    to: "/digit-ui/citizen",
    color: "inherit",
    style: {
      marginLeft: '70px',
      marginBottom: '18px',
      fontSize: '12px',
      color: 'white'
    }
  }, /*#__PURE__*/React__default.createElement(FcHome, {
    style: {
      width: '30px',
      height: '30px'
    }
  })), /*#__PURE__*/React__default.createElement(Button$2, {
    color: "inherit",
    onClick: handleClickAboutUs,
    style: {
      marginLeft: '30px',
      marginBottom: '18px',
      fontSize: '12px',
      color: 'white'
    }
  }, "About Us", /*#__PURE__*/React__default.createElement("span", {
    style: {
      marginLeft: '5px'
    }
  }, /*#__PURE__*/React__default.createElement(SlArrowDown, null))), /*#__PURE__*/React__default.createElement(Menu$1, {
    anchorEl: anchorEl,
    open: Boolean(anchorEl),
    onClose: handleClose,
    PaperProps: {
      style: {
        backgroundColor: '#1F4A7C',
        padding: '10px'
      }
    }
  }, /*#__PURE__*/React__default.createElement(MenuItem$4, {
    onClick: handleClose,
    style: {
      color: '#fff',
      fontSize: '12px'
    }
  }, /*#__PURE__*/React__default.createElement(Link$1, {
    style: {
      textDecoration: 'none',
      color: '#fff'
    },
    to: `/digit-ui/citizen/objectives`
  }, "OBJECTIVE")), /*#__PURE__*/React__default.createElement(Divider$1, null), /*#__PURE__*/React__default.createElement(MenuItem$4, {
    onClick: handleClose,
    style: {
      color: '#fff',
      fontSize: '12px'
    }
  }, /*#__PURE__*/React__default.createElement(Link$1, {
    style: {
      textDecoration: 'none',
      color: '#fff'
    },
    to: "/digit-ui/citizen/organizational-setup"
  }, "ORGANIZATIONAL SETUP")), /*#__PURE__*/React__default.createElement(Divider$1, null), /*#__PURE__*/React__default.createElement(MenuItem$4, {
    onClick: handleClose,
    style: {
      color: '#fff',
      fontSize: '12px'
    }
  }, /*#__PURE__*/React__default.createElement(Link$1, {
    style: {
      textDecoration: 'none',
      color: '#fff'
    },
    to: "/digit-ui/citizen/contact-us"
  }, "CONTACT US")), /*#__PURE__*/React__default.createElement(Divider$1, null), /*#__PURE__*/React__default.createElement(MenuItem$4, {
    onClick: handleClose,
    style: {
      color: '#fff',
      fontSize: '12px'
    }
  }, /*#__PURE__*/React__default.createElement(Link$1, {
    style: {
      textDecoration: 'none',
      color: '#fff'
    },
    to: "/digit-ui/citizen/employee-profile"
  }, "EMPLOYEE PROFILE")), /*#__PURE__*/React__default.createElement(Divider$1, null), /*#__PURE__*/React__default.createElement(MenuItem$4, {
    onClick: handleClose,
    style: {
      color: '#fff',
      fontSize: '12px'
    }
  }, /*#__PURE__*/React__default.createElement(Link$1, {
    style: {
      textDecoration: 'none',
      color: '#fff'
    },
    to: "/digit-ui/citizen/ex-employee-profile"
  }, "EX-EMPLOYEE PROFILE"))), /*#__PURE__*/React__default.createElement(Button$2, {
    color: "inherit",
    onClick: handleClickRegulation,
    style: {
      marginLeft: '30px',
      marginBottom: '18px',
      color: 'white'
    }
  }, "Planning Regulations", /*#__PURE__*/React__default.createElement("span", {
    style: {
      marginLeft: '5px'
    }
  }, /*#__PURE__*/React__default.createElement(SlArrowDown, null))), /*#__PURE__*/React__default.createElement(Menu$1, {
    anchorEl: anchorE2,
    open: Boolean(anchorE2),
    onClose: handleClose,
    PaperProps: {
      style: {
        backgroundColor: '#1F4A7C',
        padding: '10px'
      }
    }
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    color: "inherit",
    onClick: handleClickGenral,
    style: {
      color: '#fff',
      fontSize: '12px'
    }
  }, "GENERAL", /*#__PURE__*/React__default.createElement("span", {
    style: {
      marginLeft: '200px'
    }
  }, '>')), /*#__PURE__*/React__default.createElement(Menu$1, {
    anchorEl: anchorE6,
    open: Boolean(anchorE6),
    onClose: handleClose,
    PaperProps: {
      style: {
        backgroundColor: '#1F4A7C',
        width: '150px',
        height: '100px',
        margin: '-40px 0px 0px 253px',
        padding: '10px'
      }
    }
  }, /*#__PURE__*/React__default.createElement(MenuItem$4, {
    onClick: handleClose,
    style: {
      color: '#fff',
      fontSize: '12px'
    }
  }, /*#__PURE__*/React__default.createElement(Link$1, {
    style: {
      textDecoration: 'none',
      color: '#fff'
    },
    to: "/digit-ui/citizen/appendix-1"
  }, "APPENDIX-1")), /*#__PURE__*/React__default.createElement(Divider$1, null), /*#__PURE__*/React__default.createElement(MenuItem$4, {
    onClick: handleClose,
    style: {
      color: '#fff',
      fontSize: '12px'
    }
  }, /*#__PURE__*/React__default.createElement(Link$1, {
    style: {
      textDecoration: 'none',
      color: '#fff'
    },
    to: "/digit-ui/citizen/appendix-8"
  }, "APPENDIX-8"))), /*#__PURE__*/React__default.createElement(Divider$1, null), /*#__PURE__*/React__default.createElement(MenuItem$4, {
    onClick: handleClose,
    style: {
      color: '#fff',
      fontSize: '12px'
    }
  }, /*#__PURE__*/React__default.createElement(Link$1, {
    style: {
      textDecoration: 'none',
      color: '#fff'
    },
    to: "/digit-ui/citizen/apartment-colonies-regulation"
  }, "APARTMENT/COLONIES REGULATION"))), /*#__PURE__*/React__default.createElement(Link$1, {
    to: "/digit-ui/citizen/development-plan",
    style: {
      textDecoration: 'none'
    }
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    color: "inherit",
    style: {
      marginLeft: '30px',
      marginBottom: '18px',
      fontSize: '12px',
      color: 'white'
    }
  }, "Development Plan")), /*#__PURE__*/React__default.createElement(Button$2, {
    color: "inherit",
    onClick: handleClickUserManual,
    style: {
      marginLeft: '30px',
      marginBottom: '18px',
      color: 'white'
    }
  }, "User Manual ", /*#__PURE__*/React__default.createElement("span", {
    style: {
      marginLeft: '5px'
    }
  }, /*#__PURE__*/React__default.createElement(SlArrowDown, null))), /*#__PURE__*/React__default.createElement(Menu$1, {
    anchorEl: anchorE7,
    open: Boolean(anchorE7),
    onClose: handleClose,
    PaperProps: {
      style: {
        backgroundColor: '#1F4A7C'
      }
    }
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    color: "inherit",
    onClick: handleClickForm12,
    style: {
      color: '#fff',
      fontSize: '12px'
    }
  }, "Form12", /*#__PURE__*/React__default.createElement("span", {
    style: {
      marginLeft: '100px'
    }
  }, '>')), /*#__PURE__*/React__default.createElement(Menu$1, {
    anchorEl: anchorE8,
    open: Boolean(anchorE8),
    onClose: handleClose,
    PaperProps: {
      style: {
        backgroundColor: '#1F4A7C',
        width: '250px',
        height: '150px',
        margin: '-40px 0px 0px 170px',
        padding: '20px',
        overflow: 'hidden'
      }
    }
  }, /*#__PURE__*/React__default.createElement(MenuItem$4, {
    onClick: () => getDocumentByFileStoreId("171f71f5-efe7-476d-835d-6e673d935f2e", setIsPreviewLoading),
    style: {
      color: '#fff',
      fontSize: '12px'
    }
  }, "USER MANUAL FOR OBPS"), /*#__PURE__*/React__default.createElement(Divider$1, null), /*#__PURE__*/React__default.createElement(MenuItem$4, {
    onClick: handleClose,
    style: {
      color: '#fff',
      fontSize: '12px'
    }
  }, /*#__PURE__*/React__default.createElement("a", {
    href: "https://hptcp.hp.gov.in/edcr/rest/dcr/downloadfile?tenantId=hp&fileStoreId=f115810c-681f-4519-91e1-86f58a39b273",
    target: "_blank",
    style: {
      textDecoration: 'none',
      color: '#fff'
    }
  }, "Sample Drawing for Residential")), /*#__PURE__*/React__default.createElement(Divider$1, null), /*#__PURE__*/React__default.createElement(MenuItem$4, {
    onClick: handleClose,
    style: {
      color: '#fff',
      fontSize: '12px'
    }
  }, /*#__PURE__*/React__default.createElement("a", {
    href: "https://hptcp.hp.gov.in/edcr/rest/dcr/downloadfile?tenantId=hp&fileStoreId=e6cef4d6-23cb-41ea-b06f-d7e4ee1db3d4",
    target: "_blank",
    style: {
      textDecoration: 'none',
      color: '#fff'
    }
  }, "Sample Drawing for Commercial"))), /*#__PURE__*/React__default.createElement(Divider$1, null), /*#__PURE__*/React__default.createElement(Button$2, {
    color: "inherit",
    onClick: () => getDocumentByFileStoreId("3bf23245-1112-46d6-b51b-acdfd0dae3cd", setIsPreviewLoading),
    style: {
      color: '#fff',
      fontSize: '12px'
    }
  }, "Form11", /*#__PURE__*/React__default.createElement("span", {
    style: {
      marginLeft: '100px'
    }
  }, '>')), /*#__PURE__*/React__default.createElement(Divider$1, null), /*#__PURE__*/React__default.createElement(Button$2, {
    color: "inherit",
    onClick: () => getDocumentByFileStoreId("4aa92862-cae2-4423-b0d8-3eb07549e74f", setIsPreviewLoading),
    style: {
      color: '#fff',
      fontSize: '12px'
    }
  }, "Form26", /*#__PURE__*/React__default.createElement("span", {
    style: {
      marginLeft: '100px'
    }
  }, '>')), /*#__PURE__*/React__default.createElement(Divider$1, null), /*#__PURE__*/React__default.createElement(Button$2, {
    color: "inherit",
    onClick: () => getDocumentByFileStoreId("3c0512c1-2aff-419b-aa10-1333a15ea3eb", setIsPreviewLoading),
    style: {
      color: '#fff',
      fontSize: '12px'
    }
  }, "Form CLU", /*#__PURE__*/React__default.createElement("span", {
    style: {
      marginLeft: '100px'
    }
  }, '>')), /*#__PURE__*/React__default.createElement(Divider$1, null), /*#__PURE__*/React__default.createElement(Button$2, {
    color: "inherit",
    onClick: () => getDocumentByFileStoreId("9e1a9c1e-b22e-4887-9564-59605064e4f6", setIsPreviewLoading),
    style: {
      color: '#fff',
      fontSize: '12px'
    }
  }, "Mobile Tower Application")), /*#__PURE__*/React__default.createElement(Button$2, {
    color: "inherit",
    onClick: handleClickNotifications,
    style: {
      marginLeft: '30px',
      marginBottom: '18px',
      fontSize: '12px',
      color: 'white'
    }
  }, "Notifications / Orders ", /*#__PURE__*/React__default.createElement("span", {
    style: {
      marginLeft: '5px'
    }
  }, /*#__PURE__*/React__default.createElement(SlArrowDown, null))), /*#__PURE__*/React__default.createElement(Menu$1, {
    anchorEl: anchorE3,
    open: Boolean(anchorE3),
    onClose: handleClose,
    PaperProps: {
      style: {
        backgroundColor: '#1F4A7C',
        padding: '10px'
      }
    }
  }, /*#__PURE__*/React__default.createElement(MenuItem$4, {
    onClick: handleClose,
    style: {
      color: '#fff',
      fontSize: '12px'
    }
  }, /*#__PURE__*/React__default.createElement(Link$1, {
    style: {
      textDecoration: 'none',
      color: '#fff'
    },
    to: "/digit-ui/citizen/court-orders"
  }, "COURT ORDERS")), /*#__PURE__*/React__default.createElement(Divider$1, null), /*#__PURE__*/React__default.createElement(MenuItem$4, {
    onClick: handleClose,
    style: {
      color: '#fff',
      fontSize: '12px'
    }
  }, /*#__PURE__*/React__default.createElement(Link$1, {
    style: {
      textDecoration: 'none',
      color: '#fff'
    },
    to: "/digit-ui/citizen/notifications-under-tcp-act"
  }, "NOTIFICATIONS UNDER TCP ACT")), /*#__PURE__*/React__default.createElement(Divider$1, null), /*#__PURE__*/React__default.createElement(MenuItem$4, {
    onClick: handleClose,
    style: {
      color: '#fff',
      fontSize: '12px'
    }
  }, /*#__PURE__*/React__default.createElement(Link$1, {
    style: {
      textDecoration: 'none',
      color: '#fff'
    },
    to: "/digit-ui/citizen/service-matter"
  }, "SERVICE MATTER"))), /*#__PURE__*/React__default.createElement(Button$2, {
    color: "inherit",
    onClick: handleActRules,
    style: {
      marginLeft: '30px',
      marginBottom: '18px',
      fontSize: '12px',
      color: 'white'
    }
  }, "Act & Rules"), /*#__PURE__*/React__default.createElement(Menu$1, {
    anchorEl: anchorE4,
    open: Boolean(anchorE4),
    onClose: handleClose,
    PaperProps: {
      style: {
        backgroundColor: '#1F4A7C',
        padding: '10px'
      }
    }
  }, /*#__PURE__*/React__default.createElement(MenuItem$4, {
    onClick: handleClose,
    style: {
      color: '#fff',
      fontSize: '12px'
    }
  }, /*#__PURE__*/React__default.createElement(Link$1, {
    style: {
      textDecoration: 'none',
      color: '#fff'
    },
    to: "/digit-ui/citizen/delegation-of-powers"
  }, "DELEGATION OF POWER"))), /*#__PURE__*/React__default.createElement(Button$2, {
    color: "inherit",
    onClick: handleMedia,
    style: {
      marginLeft: '30px',
      marginBottom: '18px',
      fontSize: '12px',
      color: 'white'
    }
  }, "Media ", /*#__PURE__*/React__default.createElement("span", {
    style: {
      marginLeft: '5px'
    }
  }, /*#__PURE__*/React__default.createElement(SlArrowDown, null))), /*#__PURE__*/React__default.createElement(Menu$1, {
    anchorEl: anchorE5,
    open: Boolean(anchorE5),
    onClose: handleClose,
    PaperProps: {
      style: {
        backgroundColor: '#1F4A7C',
        padding: '10px'
      }
    }
  }, /*#__PURE__*/React__default.createElement(MenuItem$4, {
    onClick: handleClose,
    style: {
      color: '#fff',
      fontSize: '12px'
    }
  }, /*#__PURE__*/React__default.createElement(Link$1, {
    style: {
      textDecoration: 'none',
      color: '#fff'
    },
    to: "/digit-ui/citizen/photo-gallery"
  }, "PHOTO GALLERY")), /*#__PURE__*/React__default.createElement(Divider$1, null), /*#__PURE__*/React__default.createElement(MenuItem$4, {
    onClick: handleClose,
    style: {
      color: '#fff',
      fontSize: '12px'
    }
  }, /*#__PURE__*/React__default.createElement(Link$1, {
    style: {
      textDecoration: 'none',
      color: '#fff'
    },
    to: "/digit-ui/citizen/video-gallery"
  }, "VIDEO GALLERY")), /*#__PURE__*/React__default.createElement(Divider$1, null), /*#__PURE__*/React__default.createElement(MenuItem$4, {
    onClick: handleClose,
    style: {
      color: '#fff',
      fontSize: '12px'
    }
  }, /*#__PURE__*/React__default.createElement(Link$1, {
    style: {
      textDecoration: 'none',
      color: '#fff'
    },
    to: "/digit-ui/citizen/heritage-gallery"
  }, "HERITAGE GALLERY"))), /*#__PURE__*/React__default.createElement(Button$2, {
    color: "inherit",
    onClick: handleTutorial,
    style: {
      marginLeft: '30px',
      marginBottom: '18px',
      fontSize: '12px',
      color: 'white'
    }
  }, "Tutorial Video ", /*#__PURE__*/React__default.createElement("span", {
    style: {
      marginLeft: '5px'
    }
  }, /*#__PURE__*/React__default.createElement(SlArrowDown, null))), /*#__PURE__*/React__default.createElement(Menu$1, {
    anchorEl: anchorE9,
    open: Boolean(anchorE9),
    onClose: handleClose,
    PaperProps: {
      style: {
        backgroundColor: '#1F4A7C',
        padding: '10px'
      }
    }
  }, /*#__PURE__*/React__default.createElement(MenuItem$4, {
    onClick: handleClose,
    style: {
      color: '#fff',
      fontSize: '12px'
    }
  }, /*#__PURE__*/React__default.createElement("a", {
    href: "https://youtu.be/LXQBX2gzypY",
    target: "_blank",
    rel: "noopener noreferrer",
    style: {
      textDecoration: 'none',
      color: '#fff'
    }
  }, "Professional login & DXF Uploading")), /*#__PURE__*/React__default.createElement(Divider$1, null), /*#__PURE__*/React__default.createElement(MenuItem$4, {
    onClick: handleClose,
    style: {
      color: '#fff',
      fontSize: '12px'
    }
  }, /*#__PURE__*/React__default.createElement("a", {
    href: "https://youtu.be/6OoOvF63JpY",
    target: "_blank",
    rel: "noopener noreferrer",
    style: {
      textDecoration: 'none',
      color: '#fff'
    }
  }, "Form12 Filling & Structure Certificate Process")), /*#__PURE__*/React__default.createElement(Divider$1, null), /*#__PURE__*/React__default.createElement(MenuItem$4, {
    onClick: handleClose,
    style: {
      color: '#fff',
      fontSize: '12px'
    }
  }, /*#__PURE__*/React__default.createElement("a", {
    href: "https://youtu.be/ODczwj0dFEE",
    target: "_blank",
    rel: "noopener noreferrer",
    style: {
      textDecoration: 'none',
      color: '#fff'
    }
  }, "Fee Payment & Self Approval")), /*#__PURE__*/React__default.createElement(Divider$1, null), /*#__PURE__*/React__default.createElement(MenuItem$4, {
    onClick: handleClose,
    style: {
      color: '#fff',
      fontSize: '12px'
    }
  }, /*#__PURE__*/React__default.createElement("a", {
    href: "https://youtu.be/p7YjpBXog4w",
    target: "_blank",
    rel: "noopener noreferrer",
    style: {
      textDecoration: 'none',
      color: '#fff'
    }
  }, "EDCR Formatting in CAD Building Plans")))));
};

function NewTCPHome() {
  var _location$pathname;
  const location = useLocation();
  const homepath = location === null || location === void 0 ? void 0 : (_location$pathname = location.pathname) === null || _location$pathname === void 0 ? void 0 : _location$pathname.includes("digit-ui/citizen");
  const isBigScreen = useMediaQuery(theme => theme.breakpoints.up('lg'));
  const isMediumScreen = useMediaQuery('(min-width: 900px) and (max-width: 1200px)');
  const isSmallScreen = useMediaQuery('(min-width: 600px) and (max-width: 899px)');
  return /*#__PURE__*/React__default.createElement(HomeWrapper$1, {
    style: {
      marginTop: homepath ? '-80px' : '0px'
    }
  }, /*#__PURE__*/React__default.createElement(Header$2, null), /*#__PURE__*/React__default.createElement(Navbar, null), /*#__PURE__*/React__default.createElement(Hero$1, null), /*#__PURE__*/React__default.createElement(Services$1, null), /*#__PURE__*/React__default.createElement(AboutUs, null), /*#__PURE__*/React__default.createElement(AppInfo, null), /*#__PURE__*/React__default.createElement(CitizenFacilitation, null), /*#__PURE__*/React__default.createElement(FeedbackComplaint, null), /*#__PURE__*/React__default.createElement(LinksSlideshow, {
    titleStyles: {
      textTransform: 'uppercase',
      fontSize: '1.25rem',
      color: '#0E7693',
      fontWeight: 600
    },
    containerStyles: {
      maxWidth: 1200 - 48,
      marginInline: 'auto'
    },
    noOfSlides: isBigScreen ? 4 : isMediumScreen ? 3 : isSmallScreen ? 2 : 1
  }), /*#__PURE__*/React__default.createElement(Footer$1, null));
}

const useStyles$g = makeStyles$1(theme => ({
  videoBackground: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    objectFit: "cover",
    zIndex: -1
  },
  videoOverlay: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#fff",
    textAlign: "center",
    padding: theme.spacing(4)
  }
}));

const GovtStripImages = [{
  src: "https://static.mygov.in/archive/g20/images/g20-logo.png",
  alt: "G20",
  link: "https://www.g20.org/en"
}, {
  src: "https://www.makeinindia.com/sites/default/files/mii.png",
  alt: "Make In India",
  link: "https://www.makeinindia.com/"
}, {
  src: "https://amritkaal.nic.in/writereaddata/Portal/images/logo-black.png",
  alt: "Azadi Ka Amrit Mahotsav",
  link: "https://amritkaal.nic.in/"
}, {
  src: "https://swachhbharatmission.ddws.gov.in/themes/custom/repo-theme-master/images/swach-bharat.png",
  alt: "Swachh Bharat",
  link: "https://swachhbharat.mygov.in/"
}];
const bannerImgUrls$2 = ["https://i.ibb.co/Ndpv1djB/hero-carousel-2.jpg", "https://i.ibb.co/GqKyTrG/hero-carousel-1.jpg", "https://i.ibb.co/G43f5GNn/hero-carousel-3.jpg"];
const fastpasinfoUrlbg = "https://abmhosting.in/fastpass/homepage/avp4/assets/img/about.jpg";

let _ = t => t,
  _t,
  _t2;
const fadeInDown = keyframes(_t || (_t = _`
  0% {
    transform: translateY(-100%);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
`));
const pulsate = keyframes(_t2 || (_t2 = _`
  0% {
    transform: scale(1);
    opacity: 1;
  }
  100% {
    transform: scale(1.5);
    opacity: 0.6;
  }
`));
const HomeWrapper$2 = styled$2("div")(({
  theme
}) => ({}));
const HeaderWrapper$1 = styled$2(Box$1)(({
  theme
}) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  height: "30px",
  paddingLeft: '13px',
  background: "linear-gradient(135deg, rgb(14, 55, 79) 0%, rgb(21, 108, 156) 100%)"
}));
const LeftContent = styled$2(Box$1)(({
  theme
}) => ({
  marginLeft: "0%",
  fontSize: theme.typography.fontSize,
  color: "#fff"
}));
const DepartmentButton = styled$2(Button$2)(({
  theme
}) => ({
  color: "#fff",
  backgroundColor: "rgb(61 157 149)",
  fontSize: theme.typography.fontSize,
  fontWeight: theme.typography.fontWeightBold,
  textTransform: "none",
  "&:hover": {
    backgroundColor: "rgb(50 109 104)",
    color: "#fff"
  }
}));
const RightButtonContent = styled$2(Box$1)(({
  theme
}) => ({
  marginRight: "5%",
  display: "flex",
  alignItems: "center",
  color: "#fff",
  height: "2.5rem"
}));
const RightContent = styled$2(Box$1)(({
  theme
}) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  alignItems: "center"
}));
const HeaderGovtWrapper = styled$2(Box$1)(({
  theme
}) => ({
  position: "sticky",
  animation: "fill 11s linear",
  animationFillMode: "forwards",
  top: "0",
  left: "0",
  right: "0",
  zIndex: "1000",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  minHeight: "1rem",
  background: `url("https://dot.gov.in/sites/all/themes/cmf/images/top-bg.png")`,
  borderWidth: "2px 2px 0 2px",
  borderColor: "rgb(17, 27, 40)",
  borderStyle: "solid",
  [`@media (max-width: 1024px)`]: {
    flexDirection: "column",
    alignItems: "flex-start"
  },
  backgroundColor: "rgb(237, 240, 244)"
}));
const LeftGovtContent = styled$2(Box$1)(({
  theme
}) => ({
  backgroundImage: "	https://dot.gov.in/sites/all/themes/cmf/images/top-bg.png",
  backgroundColor: "rgb(237, 240, 244)",
  marginLeft: "1%",
  marginRight: "1%",
  minHeight: "60px",
  [`@media (max-width: 500px)`]: {
    marginLeft: "0.5%",
    marginBottom: "0.1rem"
  }
}));
const RightGovtContent = styled$2("div")(({
  theme
}) => ({
  display: "flex",
  marginRight: "0%",
  alignItems: "right ",
  backgroundColor: "rgb(237, 240, 244)",
  [`@media (max-width: 400px)`]: {
    marginLeft: "20%"
  }
}));
const TopBarWrapper$1 = styled$2("div")(({
  theme
}) => ({
  position: "sticky",
  zIndex: 1000,
  top: 0
}));
const SlideWrapper = styled$2("div")(({
  bgimg,
  isLoaded
}) => ({
  width: "70%",
  height: "400px",
  float: "left",
  background: `
          linear-gradient(rgba(0, 30, 139, 0.2), rgba(0, 30, 139, 0.3)),
          url('${bgimg}') center center / cover no-repeat
        `,
  filter: isLoaded ? "none" : "blur(10px)",
  transition: "background 1.5s ease-in-out, filter 0.5s ease",
  position: "relative",
  "&::before": {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.2)",
    zIndex: 1
  }
}));
const LoginCardWrapper = styled$2("div")(({
  theme,
  bgimg
}) => ({
  width: "30%",
  height: "400px",
  float: "right",
  background: `linear-gradient(#00000070,#0000007d), url('https://i.ibb.co/QvT4DmKv/sidebar.jpg') center center / cover no-repeat`,
  transition: `background 1.5s ease-in-out`,
  position: "relative",
  "::before": {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.4)",
    zIndex: 1
  }
}));
const SlideLoginCardWrapper = styled$2("div")(({
  theme,
  bgimg
}) => ({
  width: "100%",
  height: "378px",
  background: `linear-gradient(rgba(0, 30, 139, 0.3), rgba(0, 30, 139, 0.3)), url('${bgimg}') center center / cover no-repeat`,
  transition: `background 1.5s ease-in-out`,
  position: "relative",
  "::before": {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.4)",
    zIndex: 1
  }
}));
const SlideText = styled$2(Box$1)(({
  theme
}) => ({
  position: "absolute",
  width: "80%",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  zIndex: 2,
  color: "white",
  textAlign: "center",
  padding: "0 2rem",
  [theme.breakpoints.up("lg")]: {}
}));
const WelcomeSlideText = styled$2(Box$1)(({
  theme,
  isVisible
}) => ({
  fontSize: "1.5rem",
  fontWeight: "800",
  transform: isVisible ? "translateY(0)" : "translateY(-100%)",
  opacity: isVisible ? 1 : 0,
  transition: "transform 1s ease-in-out, opacity 1s ease-in-out",
  fontFamily: '"Raleway", sans-serif'
}));
const EDCRSlideText = styled$2(Box$1)(({
  theme
}) => ({
  fontSize: "1.50rem",
  fontFamily: '"Raleway", sans-serif',
  fontWeight: "500",
  lineHeight: "1.2",
  marginTop: "1rem"
}));
const ParaSlideText = styled$2(Box$1)(({
  theme,
  isVisible
}) => ({
  fontFamily: '"Raleway", sans-serif',
  marginTop: "1rem",
  fontWeight: "600",
  fontSize: "1rem",
  transform: isVisible ? "translateY(0)" : "translateY(-100%)",
  opacity: isVisible ? 1 : 0,
  transition: "transform 2s ease-in-out, opacity 2s ease-in-out"
}));
const FASTPasHeader = styled$2(Box$1)(({
  theme
}) => ({
  textAlign: "center",
  position: "relative",
  marginTop: "1.5rem"
}));
const TopButton = styled$2("div")(({
  theme
}) => ({
  position: "relative",
  float: "right",
  width: "100%",
  right: "10px",
  bottom: "80px",
  height: "10px",
  fontSize: "3rem",
  zIndex: "1",
  cursor: "pointer",
  color: "#CFE8DF"
}));
const StreamText = styled$2("div")(({
  theme
}) => ({
  fontSize: "1rem",
  fontWeight: "600",
  paddingBottom: "1.25rem",
  lineHeight: "1.2",
  color: theme.palette.awasbandhu.primary.main,
  position: "relative",
  "&::after": {
    content: '""',
    position: "absolute",
    display: "block",
    width: "4rem",
    height: "3px",
    backgroundColor: "#5cb874",
    left: "50%",
    transform: "translateX(-50%)",
    bottom: 0
  }
}));
const FastPasPanelWrapper = styled$2("div")({
  display: "flex",
  justifyContent: "space-around",
  padding: "1rem",
  gap: "0.5rem"
});
const VideoBox = styled$2("div")({
  width: "100%",
  height: "100%",
  backgroundImage: `url(${fastpasinfoUrlbg})`,
  backgroundSize: "contain",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center",
  position: "relative",
  cursor: "pointer",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  "&::before": {
    content: '""',
    position: "absolute",
    width: "6rem",
    height: "6rem",
    borderRadius: "50%",
    background: "#5cb874",
    border: "5px solid #ffffff",
    zIndex: 1,
    animation: `${pulsate} 2s infinite`
  },
  "&::after": {
    content: '""',
    position: "absolute",
    width: "0",
    height: "0",
    borderLeft: "30px solid white",
    borderTop: "20px solid transparent",
    borderBottom: "20px solid transparent",
    borderRight: "-5px solid transparent",
    left: "calc(50% + 5px)",
    top: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 2
  }
});
const ContentBox = styled$2("div")(({
  theme
}) => ({
  width: "100%",
  transform: "translateY(-7.5rem)",
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "flex-start",
  textAlign: "justify",
  "& h1": {
    fontSize: "3rem",
    fontWeight: "bold",
    color: theme.palette.awasbandhu.primary.main,
    marginBottom: "0.5rem",
    textDecoration: "none"
  },
  "& p": {
    fontSize: "1rem",
    marginBottom: "0.5rem",
    lineHeight: "1.5",
    textAlign: "justify"
  }
}));
const CardsWrappers = styled$2("div")({
  display: "flex",
  justifyContent: "space-between",
  padding: "2rem",
  gap: "1.5rem",
  height: "fit-content",
  flexWrap: "wrap",
  marginBottom: "2rem"
});
const InfoCard = styled$2(Box$1)(({
  theme
}) => ({
  width: "32.5%",
  backgroundColor: "#f8f9fa",
  borderRadius: "5px",
  boxShadow: "0px 0 30px rgba(0, 0, 0, 0.1)",
  overflow: "hidden",
  padding: "1rem"
}));
const CardInfoHeader = styled$2("div")(({
  theme
}) => ({
  color: "#364A65",
  fontSize: "1.2rem",
  fontWeight: "bold",
  textAlign: "left",
  padding: ".25rem",
  paddingLeft: ".75rem",
  "& hover": {
    backgroundColor: "#364A65",
    color: "rgb(168 40 40)"
  }
}));
const CardInfoContent = styled$2("div")({
  padding: "1 rem",
  "& p": {
    marginBottom: "1rem",
    lineHeight: "1.4"
  }
});
const ReadMoreButton = styled$2(Button$2)(({
  theme
}) => ({
  marginTop: "1rem",
  backgroundColor: "#4caf50",
  color: "white",
  "&:hover": {
    backgroundColor: theme.palette.primary.dark
  }
}));
const FPFooterWrapper = styled$2(Box$1)(({
  theme
}) => ({
  padding: "7px",
  background: "linear-gradient(135deg, rgb(14, 55, 79) 0%, rgb(21, 108, 156) 100%)",
  color: "#ffffff",
  textAlign: "center",
  borderTop: "1px solid #ffffff3b"
}));
const FooterFPText = styled$2(Typography$1)(({
  theme
}) => ({
  display: "flex",
  flexDirection: "column",
  fontSize: "11px",
  textAlign: "center",
  alignItems: "center"
}));
const AboveFooterWrappers = styled$2(Box$1)(({
  theme
}) => ({
  backgroundColor: "#253243",
  color: "#ffffff",
  padding: "2rem"
}));
const SocialIcons = styled$2(Box$1)(({
  theme
}) => ({
  display: "inline-block",
  margin: "10px",
  "& svg": {
    fontSize: "2rem",
    color: "#1c1052",
    transition: "color 0.3s",
    "&:hover": {
      color: theme.palette.primary.main
    }
  }
}));
const AddressCard = styled$2(Card$3)(({
  theme
}) => ({
  padding: "0.4rem",
  backgroundColor: "#fff",
  boxShadow: "0px 0 20px rgba(0, 0, 0, 0.1)",
  display: "flex",
  flexDirection: "column",
  gap: "0.5rem",
  width: "100%",
  maxWidth: "500px",
  marginBottom: "2rem",
  height: "400px"
}));
const FormCard = styled$2(Card$3)(({
  theme
}) => ({
  padding: "0.5rem",
  backgroundColor: "#fff",
  display: "flex",
  flexDirection: "column",
  gap: "0.5 rem",
  width: "100%",
  maxWidth: "500px",
  marginBottom: "2rem",
  height: "400px"
}));
const CardWrapper = styled$2(Box$1)(({
  theme
}) => ({
  display: "flex",
  justifyContent: "space-around",
  gap: "2rem",
  flexWrap: "wrap",
  marginTop: "2rem"
}));
const HeaderContainer$1 = styled$2(Container$1)(({
  theme
}) => ({
  maxWidth: theme.breakpoints["lg"],
  justifyContent: "space-between",
  paddingBlock: theme.spacing(1),
  alignItems: "center",
  display: "flex"
}));
const HeaderTitle$2 = styled$2(Box$1)(() => ({
  textAlign: "center"
}));
const Title1$2 = styled$2(Typography$1)(({
  theme
}) => ({
  fontSize: theme.typography.fontSize,
  color: theme.palette.grey["50"],
  [theme.breakpoints.up("lg")]: {
    fontSize: theme.typography.fontSize * 1.4,
    color: theme.palette.mode === "dark" ? theme.palette.grey["100"] : "#191B20"
  }
}));
const Title2$2 = styled$2(Typography$1)(({
  theme
}) => ({
  fontWeight: theme.typography.fontWeightBold,
  fontSize: theme.typography.fontSize,
  color: theme.palette.grey["100"],
  [theme.breakpoints.up("lg")]: {
    fontSize: theme.typography.fontSize * 1.6,
    color: theme.palette.mode === "dark" ? theme.palette.grey["50"] : "#0C0D10"
  }
}));
const MenuWrapper$1 = styled$2(AppBar)(({
  theme
}) => ({
  backgroundColor: theme.palette.ud.primary.main,
  color: theme.palette.ud.primary.text
}));
const NavContainer$2 = styled$2(Container$1)(({
  theme
}) => ({
  maxWidth: theme.breakpoints["lg"],
  minHeight: theme.spacing(6.25),
  [theme.breakpoints.up("lg")]: {
    color: theme.palette.common.black,
    backgroundColor: "transparent",
    minHeight: theme.spacing(5)
  },
  backgroundColor: theme.palette.ud.primary.main,
  color: theme.palette.ud.primary.text
}));
const NavToolbar$2 = styled$2(Toolbar)(({
  theme
}) => ({
  maxWidth: theme.breakpoints["lg"],
  justifyContent: "space-between",
  padding: theme.spacing(0.5, 0),
  [theme.breakpoints.up("lg")]: {
    padding: theme.spacing(1, 0),
    justifyContent: "center"
  },
  minHeight: theme.spacing(4),
  columnGap: theme.spacing(1),
  textAlign: "center"
}));
const StyledMenu$2 = styled$2(Menu$1)(({
  theme
}) => ({
  "& .MuiMenu-paper": {
    backgroundColor: theme.palette.ud.primary.main,
    borderRadius: theme.shape.borderRadius * 0.75,
    translateY: theme.spacing(0.5),
    minWidth: 140,
    "& .MuiButton-root": {
      paddingInline: theme.spacing(2),
      textAlign: "left",
      display: "block",
      width: "100%"
    }
  }
}));
const MenuItem$2 = styled$2(Button$2)(({
  theme
}) => ({
  borderRadius: theme.shape.borderRadius * 0.5,
  color: theme.palette.primary.contrastText,
  paddingBlock: theme.spacing(0.25)
}));
const StyledDivider$3 = styled$2(Divider$1)(({
  theme
}) => ({
  height: theme.spacing(3.25) + " !important",
  color: theme.palette.grey["50"],
  alignSelf: "center"
}));
const StyledDrawer$2 = styled$2(Drawer)(({
  theme
}) => ({
  "& .MuiDrawer-paper": {
    backgroundColor: theme.palette.ud.primary.main,
    boxSizing: "border-box",
    overflow: "hidden",
    "& .subMenu": {
      backgroundColor: alpha(theme.palette.common.black, 0.1),
      paddingInline: theme.spacing(2),
      "& .MuiButton-root": {
        display: "block",
        textAlign: "left",
        width: "100%"
      }
    },
    "& .MuiButton-root": {
      paddingInline: theme.spacing(2),
      justifyContent: "space-between",
      lineHeight: theme.spacing(5),
      borderRadius: 0,
      "&.MuiButton-contained, &.MuiButton-outlined": {
        paddingInline: theme.spacing(3)
      },
      "&.MuiButton-outlined": {
        borderColor: alpha(theme.palette.common.black, 0.1)
      }
    },
    "& .MuiDivider-vertical": {
      height: "1px !important",
      display: "block",
      width: "100%"
    }
  }
}));
const HeroWrapper$2 = styled$2(Box$1)(({
  theme,
  bgimg
}) => ({
  background: `${theme.palette.grey["200"]} url('${bgimg}') center center / cover no-repeat`,
  transition: `background 1.5s ease-in-out`,
  minHeight: `calc(100dvh - 50px)`,
  position: "relative",
  [theme.breakpoints.up("lg")]: {
    minHeight: `calc(100dvh - 150px)`
  }
}));
const HeroTopLeftMessage$2 = styled$2(Box$1)(({
  theme
}) => ({
  backgroundColor: alpha(theme.palette.common.black, 0.25),
  fontWeight: theme.typography.fontWeightMedium,
  textShadow: "0 2px 4px 0 rgba(0, 0, 0, 0.75)",
  inset: theme.spacing(4, 4, "auto", 4),
  [theme.breakpoints.up("sm")]: {
    inset: theme.spacing(4, "auto", "auto", 4)
  },
  fontSize: theme.typography.fontSize * 1.4,
  color: theme.palette.common.white,
  borderRadius: theme.spacing(0.5),
  backdropFilter: "blur(1px)",
  padding: theme.spacing(2),
  position: "absolute"
}));
const HeroMantriStrip$2 = styled$2(Box$1)(({
  theme
}) => ({
  backgroundColor: alpha(theme.palette.common.black, 0.7),
  inset: theme.spacing("auto", 0, 2),
  color: theme.palette.common.white,
  padding: theme.spacing(3, 4),
  [theme.breakpoints.up("md")]: {
    padding: theme.spacing(3, 8)
  },
  [theme.breakpoints.up("lg")]: {
    padding: theme.spacing(3, 12)
  },
  backdropFilter: "blur(1px)",
  position: "absolute"
}));
const PersonCard$2 = styled$2(Grid$1)(({
  theme
}) => ({
  justifyContent: "space-between",
  gap: theme.spacing(2),
  alignItems: "center",
  display: "flex"
}));
const PersonPic$2 = styled$2(Box$1)(({
  theme
}) => ({
  "& img": {
    objectFit: "cover",
    display: "block",
    height: 80,
    width: 80
  }
}));
const PersonDesc$2 = styled$2(Box$1)(({
  theme
}) => ({
  fontSize: theme.typography.fontSize,
  color: theme.palette.common.white,
  flex: 1,
  "& strong": {
    fontWeight: theme.typography.fontWeightMedium,
    display: "block"
  }
}));
const ServicesContainer$2 = styled$2(Container$1)(({
  theme
}) => ({
  maxWidth: theme.breakpoints["lg"],
  paddingBlock: theme.spacing(4)
}));
const ServiceGrid$2 = styled$2(Grid$1)(({
  theme
}) => ({
  justifyContent: "center",
  "& .MuiButtonBase-root": {
    fontWeight: theme.typography.fontWeightSemiBold,
    flexDirection: "column",
    textAlign: "center",
    width: "100%",
    flex: 1,
    "& img": {
      marginBottom: theme.spacing(1),
      display: "block",
      margin: "auto",
      maxWidth: 150
    }
  }
}));
const AppDetailsWrapper$1 = styled$2(Box$1)(({
  theme
}) => ({
  backgroundColor: theme.palette.ud.primary.main,
  fontWeight: theme.typography.fontWeightMedium,
  color: theme.palette.ud.primary.text,
  paddingBlock: theme.spacing(3.75)
}));
const AppDetailsContainer$1 = styled$2(Container$1)(({
  theme
}) => ({
  maxWidth: theme.breakpoints["lg"]
}));
const AppDetailsHead$1 = styled$2(Typography$1)(({
  theme
}) => ({
  fontWeight: theme.typography.fontWeightMedium,
  fontSize: theme.typography.fontSize * 2,
  marginBottom: theme.spacing(2),
  textTransform: "uppercase"
}));
const AppDetailsLabel$1 = styled$2(Box$1)(({
  theme
}) => ({
  fontSize: theme.typography.fontSize * 1.5
}));
const AppDetailsValue$1 = styled$2(Box$1)(({
  theme
}) => ({
  fontSize: theme.typography.fontSize * 6
}));
const FormsContainer$1 = styled$2(Container$1)(({
  theme
}) => ({
  maxWidth: theme.breakpoints["lg"],
  paddingBlock: theme.spacing(3),
  flexDirection: "column",
  alignItems: "stretch",
  display: "flex",
  [theme.breakpoints.up("md")]: {
    alignItems: "flex-start",
    flexDirection: "row"
  },
  "& > div": {
    flex: 1,
    textAlign: "center",
    padding: theme.spacing(2, 3, 3),
    "&.feedbackForm": {
      paddingInline: 0
    },
    [theme.breakpoints.up("md")]: {
      "&.feedbackForm": {
        padding: theme.spacing(2, 3, 3)
      },
      textAlign: "right"
    },
    "& .title": {
      fontWeight: theme.typography.fontWeightSemiBold,
      fontSize: theme.typography.fontSize * 1.5,
      color: theme.palette.ud.primary.main,
      marginBottom: theme.spacing(1.5),
      textTransform: "uppercase",
      textAlign: "left"
    }
  }
}));
const ChecklistWrapper$1 = styled$2(Box$1)(({
  theme
}) => ({
  border: "1px solid #F7A143",
  marginInline: "auto",
  maxWidth: 530,
  "& .content": {
    marginBottom: theme.spacing(2),
    textAlign: "left",
    "& p": {
      fontSize: theme.typography.fontSize,
      marginBottom: theme.spacing(1)
    }
  },
  "& .MuiButton-root": {
    color: theme.palette.ud.primary.main,
    textTransform: "unset"
  }
}));
const FeedbackWrapper$1 = styled$2(Box$1)(({
  theme
}) => ({
  padding: theme.spacing(0),
  textAlign: "center",
  [theme.breakpoints.up("md")]: {
    textAlign: "right"
  }
}));
const FormContainer$1 = styled$2(Box$1)(({
  theme
}) => ({
  marginInline: "auto",
  textAlign: "center",
  maxWidth: 530,
  [theme.breakpoints.up("md")]: {
    textAlign: "left",
    marginRight: 0,
    maxWidth: 450
  },
  '& button[type="submit"]': {
    width: "100%"
  },
  "&.tcp": {
    "& .title": {
      fontWeight: theme.typography.fontWeightSemiBold,
      fontSize: theme.typography.fontSize * 1.5,
      color: theme.palette.tcp.primary.main,
      marginBottom: theme.spacing(1.5),
      marginRight: theme.spacing(4),
      textTransform: "uppercase",
      textAlign: "center"
    },
    "& .MuiFormGroup-root": {
      "& label .MuiFormControlLabel-label, & label svg": {
        color: theme.palette.tcp.primary.main
      },
      "& label svg": {
        fill: theme.palette.tcp.primary.main
      },
      justifyContent: "center",
      gap: theme.spacing(2),
      "& .MuiButtonBase-root": {
        padding: theme.spacing(1)
      }
    }
  }
}));
const StyledRadioGroup$4 = styled$2(RadioGroup$1)(({
  theme
}) => ({
  "& label": {
    "&.MuiFormControlLabel-root": {
      marginBottom: 0
    },
    "& .MuiFormControlLabel-label": {
      fontWeight: theme.typography.fontWeightSemiBold,
      fontSize: theme.typography.fontSize * 1.1,
      color: theme.palette.ud.primary.main
    },
    "& svg": {
      fill: theme.palette.ud.primary.main
    }
  }
}));
const FooterWrapper$1 = styled$2("footer")(({
  theme
}) => ({
  backgroundColor: theme.palette.ud.primary.main,
  color: theme.palette.ud.primary.text,
  fontSize: theme.typography.fontSize,
  padding: theme.spacing(1),
  textAlign: "center"
}));
const TcpFooterWrapper$1 = styled$2("footer")(({
  theme
}) => ({
  backgroundColor: theme.palette.tcp.primary.main,
  color: theme.palette.ud.primary.text,
  fontSize: theme.typography.fontSize,
  padding: theme.spacing(1),
  textAlign: "center"
}));

const LanguageSelection$1 = () => {
  const {
    t
  } = useTranslation();
  const history = useHistory();
  const {
    data: {
      languages,
      stateInfo
    } = {},
    isLoading
  } = Digit.Hooks.useStore.getInitData();
  const selectedLanguage = Digit.StoreData.getCurrentLanguage();
  const texts = useMemo(() => ({
    header: t("CS_COMMON_CHOOSE_LANGUAGE"),
    submitBarLabel: t("CORE_COMMON_CONTINUE")
  }), [t]);
  const RadioButtonProps = useMemo(() => ({
    options: languages,
    optionsKey: "label",
    additionalWrapperClass: "reverse-radio-selection-wrapper",
    onSelect: language => Digit.LocalizationService.changeLanguage(language.value, stateInfo.code),
    selectedOption: languages === null || languages === void 0 ? void 0 : languages.filter(i => i.value === selectedLanguage)[0]
  }), [selectedLanguage, languages]);
  function onSubmit() {
    history.push(`/digit-ui/citizen/select-location`);
  }
  return isLoading ? /*#__PURE__*/React__default.createElement(Loader, null) : /*#__PURE__*/React__default.createElement(PageBasedInput, {
    texts: texts,
    onSubmit: onSubmit
  }, /*#__PURE__*/React__default.createElement(CardHeader, null, t("CS_COMMON_CHOOSE_LANGUAGE")), /*#__PURE__*/React__default.createElement(RadioButtons, RadioButtonProps));
};

function Header$3() {
  const [language, setLanguage] = useState("Select Language");
  const [anchorEl, setAnchorEl] = useState(null);
  const tenantId = Digit.ULBService.getCurrentTenantId() || "up";
  const {
    t
  } = useTranslation();
  const handleLanguageChange = async selectedLang => {
    const languageCode = selectedLang === "English" ? "en_IN" : "hi_IN";
    setLanguage(selectedLang);
    await Digit.LocalizationService.changeLanguage(languageCode, tenantId);
    handleClose();
  };
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return /*#__PURE__*/React__default.createElement(HeaderWrapper$1, null, /*#__PURE__*/React__default.createElement(LeftContent, null, t("FASTPAS.HOME.GOV_HEADER.GOVERNMENT_NAME")), /*#__PURE__*/React__default.createElement(RightContent, null, /*#__PURE__*/React__default.createElement(LanguageOutlined, {
    style: {
      marginRight: "15px",
      color: "#fff",
      fontSize: "20px"
    },
    onClick: handleClick
  }), /*#__PURE__*/React__default.createElement(Menu$1, {
    anchorEl: anchorEl,
    open: Boolean(anchorEl),
    onClose: handleClose
  }, /*#__PURE__*/React__default.createElement(MenuItem$4, {
    onClick: () => handleLanguageChange("English")
  }, "English"), /*#__PURE__*/React__default.createElement(MenuItem$4, {
    onClick: () => handleLanguageChange("Hindi")
  }, "Hindi"))));
}

function GovtStrip$1() {
  const urlImg = "https://upload.wikimedia.org/wikipedia/commons/f/fa/Seal_of_Uttar_Pradesh.svg";
  const {
    t
  } = useTranslation();
  const [prevScrollPos, setPrevScrollPos] = useState(0);
  const [visible, setVisible] = useState(true);
  const handleScroll = () => {
    const currentScrollPos = window.scrollY;
    if (currentScrollPos > 0) {
      setVisible(false);
    } else {
      setVisible(true);
    }
    setPrevScrollPos(currentScrollPos);
  };
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  });
  return (
    /*#__PURE__*/
    React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(HeaderGovtWrapper, null, /*#__PURE__*/React__default.createElement(LeftGovtContent, null, /*#__PURE__*/React__default.createElement("div", {
      style: {
        display: "flex"
      }
    }, /*#__PURE__*/React__default.createElement("img", {
      src: urlImg,
      alt: "Uttar-Pradesh-Logo",
      class: "uplogo"
    }), /*#__PURE__*/React__default.createElement("div", {
      class: "container-heading"
    }, /*#__PURE__*/React__default.createElement("h1", {
      class: "headerup"
    }, t("FASTPAS.HOME.GOV_HEADER.DEPARTMENT_NAME")), /*#__PURE__*/React__default.createElement("h2", {
      class: "headerup"
    }, t("FASTPAS.HOME.GOV_HEADER.GOVERNMENT_NAME"))))), /*#__PURE__*/React__default.createElement(RightGovtContent, {
      className: "preLogo"
    }, GovtStripImages.map((image, index) => /*#__PURE__*/React__default.createElement("a", {
      key: index,
      href: image.link,
      target: "_blank",
      rel: "noopener noreferrer"
    }, /*#__PURE__*/React__default.createElement("img", {
      src: image.src,
      alt: image.alt
    }))))))
  );
}

const ResponseDialog = ({
  open,
  onClose,
  type,
  response
}) => {
  if (!response) return null;
  const {
    applicationNo,
    status,
    mobileNo,
    selfApprovaldrawingDetailsUrl,
    drawingDetailsUrl,
    sanctionLetterUrl,
    selfApprovalsanctionLetterUrl
  } = (response === null || response === void 0 ? void 0 : response.BPA) || response || {};
  return /*#__PURE__*/React__default.createElement(Dialog, {
    open: open,
    onClose: onClose,
    maxWidth: "sm",
    fullWidth: true
  }, /*#__PURE__*/React__default.createElement(Card$3, {
    sx: {
      borderRadius: "16px",
      boxShadow: 3,
      p: 3
    }
  }, /*#__PURE__*/React__default.createElement(DialogTitle, {
    sx: {
      textAlign: "center",
      fontWeight: "bold"
    }
  }, type === "owner" ? "Owner" : "Citizen", " Response"), /*#__PURE__*/React__default.createElement(DialogContent, null, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1",
    gutterBottom: true
  }, /*#__PURE__*/React__default.createElement("strong", null, "Application No:"), " ", applicationNo || "N/A"), /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1",
    gutterBottom: true
  }, /*#__PURE__*/React__default.createElement("strong", null, "Status:"), " ", status || "N/A"), type === "owner" && mobileNo && /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1"
  }, /*#__PURE__*/React__default.createElement("strong", null, "Mobile:"), " ", mobileNo), type === "owner" && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, (selfApprovaldrawingDetailsUrl || drawingDetailsUrl) && /*#__PURE__*/React__default.createElement(Typography$1, null, /*#__PURE__*/React__default.createElement(Link, {
    href: selfApprovaldrawingDetailsUrl || drawingDetailsUrl,
    target: "_blank",
    rel: "noopener"
  }, "\uD83D\uDCC4 View Drawing")), (sanctionLetterUrl || selfApprovalsanctionLetterUrl) && /*#__PURE__*/React__default.createElement(Typography$1, null, /*#__PURE__*/React__default.createElement(Link, {
    href: sanctionLetterUrl || selfApprovalsanctionLetterUrl,
    target: "_blank",
    rel: "noopener"
  }, "\uD83D\uDCC4 View Sanction Letter")))), /*#__PURE__*/React__default.createElement(Box$1, {
    sx: {
      textAlign: "center",
      mt: 2
    }
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    color: "primary",
    onClick: onClose
  }, "Close"))));
};
const NoDataDialog = ({
  open,
  onClose
}) => /*#__PURE__*/React__default.createElement(Dialog, {
  open: open,
  onClose: onClose,
  maxWidth: "xs",
  fullWidth: true
}, /*#__PURE__*/React__default.createElement(Card$3, {
  sx: {
    p: 3,
    textAlign: "center",
    borderRadius: "16px"
  }
}, /*#__PURE__*/React__default.createElement(Typography$1, {
  variant: "h6",
  color: "error",
  gutterBottom: true
}, "\u274C No Record Found"), /*#__PURE__*/React__default.createElement(Typography$1, {
  variant: "body2",
  sx: {
    mb: 2
  }
}, "No record found for this file number. Please check and try again."), /*#__PURE__*/React__default.createElement(Button$2, {
  variant: "contained",
  onClick: onClose
}, "Close")));
const OwnerDialog = ({
  open,
  onClose,
  type: _type = "owner"
}) => {
  const [step, setStep] = useState(1);
  const [fileNumber, setFileNumber] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [otpDigits, setOtpDigits] = useState(["", "", "", "", "", ""]);
  const [otpError, setOtpError] = useState("");
  const [alertMsg, setAlertMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const [timer, setTimer] = useState(30);
  const [canResend, setCanResend] = useState(false);
  const [responseDialogOpen, setResponseDialogOpen] = useState(false);
  const [noDataDialogOpen, setNoDataDialogOpen] = useState(false);
  const [responseData, setResponseData] = useState(null);
  const inputRefs = useRef([]);
  const tenantId = "up";
  const stateId = "up";
  useEffect(() => {
    let countdown;
    if (step === 2 && timer > 0) {
      countdown = setTimeout(() => setTimer(prev => prev - 1), 1000);
    } else if (timer === 0) {
      setCanResend(true);
    }
    return () => clearTimeout(countdown);
  }, [timer, step]);
  useEffect(() => {
    if (!open) {
      setStep(1);
      setFileNumber("");
      setMobileNumber("");
      setOtpDigits(["", "", "", "", "", ""]);
      setTimer(30);
      setCanResend(false);
      setAlertMsg("");
    }
  }, [open]);
  const validateMobile = value => /^[6-9]\d{9}$/.test(value);
  const handleSendOtp = async () => {
    if (!validateMobile(mobileNumber)) {
      setAlertMsg("❌ Enter a valid 10-digit mobile number.");
      return;
    }
    setLoading(true);
    setAlertMsg("");
    const requestData = {
      otp: {
        mobileNumber,
        userType: "citizen",
        type: "login",
        tenantId
      },
      RequestInfo: {
        apiId: "Rainmaker",
        msgId: `${Date.now()}|en_IN`
      }
    };
    try {
      const res = await Digit.UserService.sendOtp(requestData, stateId);
      if (res !== null && res !== void 0 && res.isSuccessful || res !== null && res !== void 0 && res.ResponseInfo) {
        setAlertMsg(`✅ OTP sent successfully to ${mobileNumber}`);
        setStep(2);
        setTimer(30);
        setCanResend(false);
      }
    } catch (err) {
      console.error("Send OTP Error:", err);
      setAlertMsg("❌ New User? Please register your detail in the portal.");
    } finally {
      setLoading(false);
    }
  };
  const handleVerifyOtp = async () => {
    const otp = otpDigits.join("");
    if (otp.length !== 6) {
      setOtpError("Please enter 6-digit OTP");
      return;
    }
    setOtpError("");
    setLoading(true);
    setAlertMsg("");
    try {
      var _res$data;
      const res = await axios.post(`${Urls$1.OTP_Send_verify}`, {
        mobileNumber,
        otp
      });
      if ((res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.successful) === true) {
        setAlertMsg("✅ OTP verified successfully!");
        await handleSearchApi();
      } else {
        setOtpError("❌ Invalid OTP. Please try again.");
        setTimer(30);
        setCanResend(false);
      }
    } catch (err) {
      console.error("OTP Verification Error:", err);
      setOtpError("❌ OTP verification failed.");
    } finally {
      setLoading(false);
    }
  };
  const handleSearchApi = async () => {
    try {
      var _res$data2, _res$data3;
      const payload = {
        BPA: {
          applicationNo: fileNumber,
          mobileNumber: _type === "owner" ? mobileNumber : undefined
        },
        RequestInfo: {
          apiId: "Rainmaker",
          msgId: `${Date.now()}|en_IN`
        }
      };
      const res = await axios.post(`${Urls$1.trackAppliactionStatus}`, payload, {
        headers: {
          "Content-Type": "application/json"
        }
      });
      console.log("Search API Response:", res.data);
      if (!(res !== null && res !== void 0 && (_res$data2 = res.data) !== null && _res$data2 !== void 0 && _res$data2.message)) {
        setResponseData(res.data);
        setResponseDialogOpen(true);
      } else if (res !== null && res !== void 0 && (_res$data3 = res.data) !== null && _res$data3 !== void 0 && _res$data3.message) {
        setNoDataDialogOpen(true);
      }
    } catch (error) {
      console.error("Search API Error:", error);
      setNoDataDialogOpen(true);
    } finally {
      onClose();
    }
  };
  const handleCitizenSearch = async () => {
    if (!fileNumber) return setAlertMsg("❌ Please enter file number.");
    await handleSearchApi();
  };
  const handleOtpChange = (value, index) => {
    var _inputRefs$current;
    if (!/^\d*$/.test(value)) return;
    const newOtp = [...otpDigits];
    newOtp[index] = value;
    setOtpDigits(newOtp);
    if (value && index < 5) (_inputRefs$current = inputRefs.current[index + 1]) === null || _inputRefs$current === void 0 ? void 0 : _inputRefs$current.focus();
  };
  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otpDigits[index] && index > 0) {
      var _inputRefs$current2;
      (_inputRefs$current2 = inputRefs.current[index - 1]) === null || _inputRefs$current2 === void 0 ? void 0 : _inputRefs$current2.focus();
    }
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Dialog, {
    open: open,
    onClose: onClose,
    maxWidth: "sm",
    fullWidth: true
  }, /*#__PURE__*/React__default.createElement(Card$3, {
    sx: {
      borderRadius: "16px",
      boxShadow: 3,
      p: 2
    }
  }, /*#__PURE__*/React__default.createElement(DialogTitle, {
    sx: {
      background: "#E6E6F3",
      color: "#003366",
      fontWeight: "bold",
      py: 1.5,
      mb: 2
    }
  }, _type === "owner" ? step === 1 ? "Mobile Verification" : "OTP Verification" : "Citizen Search"), /*#__PURE__*/React__default.createElement(DialogContent, null, alertMsg && /*#__PURE__*/React__default.createElement(Alert, {
    severity: alertMsg.includes("✅") ? "success" : "info",
    sx: {
      mb: 2
    }
  }, alertMsg), _type === "owner" && step === 1 && /*#__PURE__*/React__default.createElement(Box$1, null, /*#__PURE__*/React__default.createElement(TextField$1, {
    label: "File Number",
    fullWidth: true,
    sx: {
      mb: 2
    },
    value: fileNumber,
    onChange: e => setFileNumber(e.target.value)
  }), /*#__PURE__*/React__default.createElement(TextField$1, {
    label: "Mobile Number",
    fullWidth: true,
    value: mobileNumber,
    onChange: e => setMobileNumber(e.target.value.replace(/\D/g, "")),
    inputProps: {
      maxLength: 10
    },
    sx: {
      mb: 2
    }
  }), /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    color: "primary",
    fullWidth: true,
    onClick: handleSendOtp,
    disabled: loading || !fileNumber || mobileNumber.length < 10
  }, loading ? "Sending OTP..." : "Get OTP")), _type === "owner" && step === 2 && /*#__PURE__*/React__default.createElement(Box$1, {
    textAlign: "center"
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    sx: {
      mb: 1
    }
  }, "Enter the OTP sent to ", /*#__PURE__*/React__default.createElement("strong", null, mobileNumber)), /*#__PURE__*/React__default.createElement(Grid$1, {
    container: true,
    justifyContent: "center",
    spacing: 1,
    sx: {
      mb: 2
    }
  }, otpDigits.map((digit, idx) => /*#__PURE__*/React__default.createElement(Grid$1, {
    item: true,
    key: idx
  }, /*#__PURE__*/React__default.createElement(TextField$1, {
    inputRef: el => inputRefs.current[idx] = el,
    value: digit,
    onChange: e => handleOtpChange(e.target.value, idx),
    onKeyDown: e => handleKeyDown(e, idx),
    inputProps: {
      maxLength: 1,
      style: {
        textAlign: "center",
        width: "40px"
      }
    }
  })))), otpError && /*#__PURE__*/React__default.createElement(Typography$1, {
    color: "error",
    sx: {
      mb: 2
    }
  }, otpError), !canResend ? /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body2",
    color: "text.secondary",
    sx: {
      mb: 2
    }
  }, "Resend OTP in ", timer, " seconds") : /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "text",
    color: "primary",
    onClick: handleSendOtp,
    sx: {
      mb: 2
    }
  }, "Resend OTP"), /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    color: "primary",
    onClick: handleVerifyOtp,
    disabled: loading
  }, loading ? "Verifying..." : "Next")), _type === "citizen" && /*#__PURE__*/React__default.createElement(Box$1, null, /*#__PURE__*/React__default.createElement(TextField$1, {
    label: "File Number",
    fullWidth: true,
    sx: {
      mb: 2
    },
    value: fileNumber,
    onChange: e => setFileNumber(e.target.value)
  }), /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    color: "primary",
    fullWidth: true,
    onClick: handleCitizenSearch,
    disabled: loading || !fileNumber
  }, loading ? "Searching..." : "Search"))))), /*#__PURE__*/React__default.createElement(ResponseDialog, {
    open: responseDialogOpen,
    onClose: () => setResponseDialogOpen(false),
    type: _type,
    response: responseData
  }), /*#__PURE__*/React__default.createElement(NoDataDialog, {
    open: noDataDialogOpen,
    onClose: () => setNoDataDialogOpen(false)
  }));
};

const WhatsNewTable = ({
  formType
}) => {
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(true);
  const fetchManualData = async () => {
    try {
      var _response$data;
      const dataToSend = {
        RequestInfo: {
          apiId: "Rainmaker",
          action: "_create",
          did: 1,
          key: "",
          msgId: "20170310130900|en_IN",
          ts: 0,
          ver: ".01"
        }
      };
      const response = await axios.post(`${Urls$1.UserManualSearch}?isApproved=${formType}`, dataToSend);
      console.log("📘 Response From User Manual API:", response.data);
      setTableData((((_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.UserManual) || []).reverse());
    } catch (error) {
      console.error("❌ Error fetching user manual data:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchManualData();
  }, [formType]);
  if (loading) {
    return /*#__PURE__*/React__default.createElement(Paper, {
      elevation: 0,
      sx: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: 180,
        backgroundColor: "#f8fafc"
      }
    }, /*#__PURE__*/React__default.createElement(CircularProgress, {
      size: 28,
      sx: {
        color: "#0c5a88"
      }
    }), /*#__PURE__*/React__default.createElement(Typography$1, {
      sx: {
        ml: 2,
        color: "#0c5a88"
      }
    }, "Loading documents..."));
  }
  return /*#__PURE__*/React__default.createElement(TableContainer, {
    component: Paper,
    sx: {
      maxHeight: 300,
      overflow: "auto",
      borderRadius: 2,
      boxShadow: 1
    }
  }, /*#__PURE__*/React__default.createElement(Table, {
    size: "small"
  }, /*#__PURE__*/React__default.createElement(TableHead, {
    sx: {
      backgroundColor: "#e0edf8"
    }
  }, /*#__PURE__*/React__default.createElement(TableRow, null, /*#__PURE__*/React__default.createElement(TableCell, {
    sx: {
      fontWeight: 600
    }
  }, "S.No."), /*#__PURE__*/React__default.createElement(TableCell, {
    sx: {
      fontWeight: 600
    }
  }, "Category"), /*#__PURE__*/React__default.createElement(TableCell, {
    sx: {
      fontWeight: 600
    }
  }, "Description"), /*#__PURE__*/React__default.createElement(TableCell, {
    sx: {
      fontWeight: 600
    }
  }, "Updated On"))), /*#__PURE__*/React__default.createElement(TableBody, null, tableData.length > 0 ? tableData.map((row, index) => /*#__PURE__*/React__default.createElement(TableRow, {
    key: row.id || index
  }, /*#__PURE__*/React__default.createElement(TableCell, null, index + 1), /*#__PURE__*/React__default.createElement(TableCell, null, row.category || "—"), /*#__PURE__*/React__default.createElement(TableCell, null, row.description || "—"), /*#__PURE__*/React__default.createElement(TableCell, null, row.updatedDate ? row.updatedDate : new Date(row.auditDetails.createdTime).toLocaleDateString()))) : /*#__PURE__*/React__default.createElement(TableRow, null, /*#__PURE__*/React__default.createElement(TableCell, {
    colSpan: 6,
    align: "center"
  }, "No data available")))));
};

const WhatsNewPopup = ({
  open,
  onClose
}) => {
  const [activeTab, setActiveTab] = useState(0);
  const tabLabels = ["Whats New"];
  const handleTabChange = (event, newValue) => setActiveTab(newValue);
  const TabPanel = ({
    children,
    value,
    index
  }) => /*#__PURE__*/React__default.createElement(Box$1, {
    role: "tabpanel",
    hidden: value !== index,
    sx: {
      p: 3,
      backgroundColor: "#fff",
      borderRadius: 1,
      boxShadow: 1,
      minHeight: 240
    }
  }, value === index && children);
  return /*#__PURE__*/React__default.createElement(Dialog, {
    open: open,
    onClose: onClose,
    fullWidth: true,
    maxWidth: "md",
    sx: {
      "& .MuiDialog-paper": {
        borderRadius: 2,
        backgroundColor: "#ebf3fa",
        width: "90%",
        maxWidth: "1200px"
      }
    }
  }, /*#__PURE__*/React__default.createElement(DialogTitle, {
    sx: {
      textAlign: "center",
      fontWeight: 600,
      fontSize: "1.3rem",
      background: "linear-gradient(to right, #0c5a88, #1976d2)",
      color: "#fff",
      padding: "8px 20px",
      lineHeight: 1.0
    }
  }, "What's New"), /*#__PURE__*/React__default.createElement(DialogContent, {
    sx: {
      p: 3
    }
  }, /*#__PURE__*/React__default.createElement(Paper, {
    elevation: 0,
    sx: {
      display: "flex",
      justifyContent: "center",
      backgroundColor: "transparent",
      mb: 2,
      mt: 2
    }
  }, /*#__PURE__*/React__default.createElement(Tabs, {
    value: activeTab,
    onChange: handleTabChange,
    variant: "scrollable",
    scrollButtons: "auto",
    TabIndicatorProps: {
      style: {
        backgroundColor: "#0c5a88"
      }
    },
    sx: {
      "& .MuiTab-root": {
        textTransform: "none",
        fontWeight: 600,
        borderRadius: 1,
        mx: 0.5,
        backgroundColor: "#c5e3f6",
        color: "#0c3d64",
        minWidth: 140,
        "&.Mui-selected": {
          backgroundColor: "#0c5a88",
          color: "#fff"
        }
      }
    }
  }, tabLabels.map((label, index) => /*#__PURE__*/React__default.createElement(Tab, {
    key: index,
    label: label
  })))), /*#__PURE__*/React__default.createElement(TabPanel, {
    value: activeTab,
    index: 0
  }, /*#__PURE__*/React__default.createElement(WhatsNewTable, {
    tenantId: "hp",
    formType: "Whats New"
  }))));
};

function HoverMenu({
  label,
  children
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  return /*#__PURE__*/React__default.createElement(Box$1, {
    sx: {
      display: "inline-block"
    },
    onMouseEnter: e => setAnchorEl(e.currentTarget),
    onMouseLeave: () => setAnchorEl(null)
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    className: "btn-header-menu"
  }, label), /*#__PURE__*/React__default.createElement(Popper, {
    open: open,
    anchorEl: anchorEl,
    placement: "bottom-start",
    disablePortal: true,
    sx: {
      zIndex: 1300,
      top: "-8px !important"
    }
  }, /*#__PURE__*/React__default.createElement(Paper, {
    elevation: 4,
    sx: {
      borderRadius: "0px 0px 10px 10px"
    }
  }, /*#__PURE__*/React__default.createElement(MenuList, {
    autoFocusItem: false
  }, children))));
}
function DepartmentPanel({
  setApplicationFlow,
  setShowDuePaymentGroup
}) {
  const {
    t
  } = useTranslation();
  const history = useHistory();
  const isLTPGradingEnabled = process.env.REACT_APP_ENABLE_LTP_GRADING === "true";
  const [ribbonMessage, setRibbonMessage] = useState("");
  const [aboutUsOpen, setAboutUsOpen] = useState(false);
  const [downloadsOpen, setDownloadsOpen] = useState(false);
  const [whatsNewsOpen, setWhatsNewsOpen] = useState(false);
  const [openOwner, setOpenOwner] = useState(false);
  const [openCitizen, setOpenCitizen] = useState(false);
  useEffect(() => {
    const fetchRibbonMessage = async () => {
      try {
        var _res$data, _latest$description;
        const res = await axios.post(`${Urls$1.UserManualSearch}?isApproved=RIBBON_MESSAGE`, {
          RequestInfo: {
            apiId: "Rainmaker"
          }
        });
        const manuals = (res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.UserManual) || [];
        if (!manuals.length) {
          setRibbonMessage("");
          return;
        }
        const latest = manuals[manuals.length - 1];
        setRibbonMessage((latest === null || latest === void 0 ? void 0 : (_latest$description = latest.description) === null || _latest$description === void 0 ? void 0 : _latest$description.trim()) || "");
      } catch (e) {
        console.error("Ribbon fetch failed", e);
      }
    };
    fetchRibbonMessage();
  }, []);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, ribbonMessage && /*#__PURE__*/React__default.createElement(Box$1, {
    sx: {
      width: "100%",
      overflow: "hidden",
      backgroundColor: "#c62828",
      color: "#fff",
      py: 1,
      zIndex: 1500
    }
  }, /*#__PURE__*/React__default.createElement(Box$1, {
    sx: {
      display: "inline-block",
      whiteSpace: "nowrap",
      paddingLeft: "100vw",
      animation: "ribbon-scroll 17s linear infinite",
      fontWeight: 600
    },
    dangerouslySetInnerHTML: {
      __html: ribbonMessage
    }
  })), /*#__PURE__*/React__default.createElement(HeaderWrapper$1, {
    className: "menu-header"
  }, /*#__PURE__*/React__default.createElement(LeftContent, null, /*#__PURE__*/React__default.createElement(Button$2, {
    className: "btn-header-menu",
    onClick: () => setAboutUsOpen(true)
  }, t("FASTPAS.HOME.GOV_HEADER.ABOUT_US")), /*#__PURE__*/React__default.createElement(HoverMenu, {
    label: t("FASTPAS.HOME.GOV_HEADER.DOWNLOADS")
  }, /*#__PURE__*/React__default.createElement(MenuItem$4, {
    onClick: () => setDownloadsOpen(true)
  }, t("FASTPAS.HOME.RESOURCES.MANUAL_AND_DOCUMENT")), /*#__PURE__*/React__default.createElement(MenuItem$4, {
    onClick: () => setWhatsNewsOpen(true)
  }, t("FASTPAS.HOME.RESOURCES.WHATS_NEW"))), /*#__PURE__*/React__default.createElement(HoverMenu, {
    label: t("FASTPAS.HOME.NAV.TRACK_APPLICATION")
  }, /*#__PURE__*/React__default.createElement(MenuItem$4, {
    onClick: () => setOpenOwner(true)
  }, t("FASTPAS.HOME.CITIZEN.OWNER")), /*#__PURE__*/React__default.createElement(MenuItem$4, {
    onClick: () => setOpenCitizen(true)
  }, t("FASTPAS.HOME.CITIZEN.CITIZEN_LABEL"))), /*#__PURE__*/React__default.createElement(Button$2, {
    className: "btn-header-menu",
    onClick: () => history.push("/digit-ui/citizen/ltpGrading")
  }, t("FASTPAS.HOME.NAV.LTP_GRADING")), /*#__PURE__*/React__default.createElement(Button$2, {
    className: "btn-header-menu",
    onClick: () => window.open("https://epay.sbi.bank.in/secure/transactionTrack", "_blank", "noopener,noreferrer")
  }, t("FASTPAS.HOME.NAV.CHECK_PAYMENT"))), /*#__PURE__*/React__default.createElement(RightButtonContent, null)), /*#__PURE__*/React__default.createElement(UserManualPopup, {
    open: downloadsOpen,
    onClose: () => setDownloadsOpen(false)
  }), /*#__PURE__*/React__default.createElement(WhatsNewPopup, {
    open: whatsNewsOpen,
    onClose: () => setWhatsNewsOpen(false)
  }), /*#__PURE__*/React__default.createElement(OwnerDialog, {
    open: openOwner,
    onClose: () => setOpenOwner(false)
  }), /*#__PURE__*/React__default.createElement(OwnerDialog, {
    type: "citizen",
    open: openCitizen,
    onClose: () => setOpenCitizen(false)
  }), /*#__PURE__*/React__default.createElement("style", null, `
          @keyframes ribbon-scroll {
            0% { transform: translateX(0); }
            100% { transform: translateX(-100%); }
          }
        `));
}

function Arrows({
  prevSlide,
  nextSlide
}) {
  return /*#__PURE__*/React__default.createElement("div", {
    className: "arrows"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "prev",
    onClick: prevSlide,
    style: styles.prev
  }, "\u276E"), /*#__PURE__*/React__default.createElement("span", {
    className: "next",
    onClick: nextSlide,
    style: styles.next
  }, "\u276F"));
}
const styles = {
  prev: {
    cursor: "pointer",
    zIndex: "100%",
    position: "absolute",
    top: "50%",
    width: "auto",
    padding: "1rem",
    marginTop: "-3rem",
    fontSize: "40px",
    fontWeight: "bold",
    borderRadius: "0px 5px 5px 0px",
    zIndex: "100"
  },
  next: {
    cursor: "pointer",
    zIndex: "100%",
    position: "absolute",
    top: "50%",
    width: "auto",
    padding: "1rem",
    marginTop: "-3rem",
    fontSize: "40px",
    fontWeight: "bold",
    borderRadius: "0px 5px 5px 0px",
    right: "0",
    borderRadius: "5px 0px 0px 5px",
    zIndex: "100"
  }
};

function Dots({
  activeIndex,
  onclick,
  sliderImage
}) {
  return /*#__PURE__*/React__default.createElement("div", {
    className: styles$1.allDots,
    style: styles$1.allDots
  }, sliderImage.map((slideImage, index) => /*#__PURE__*/React__default.createElement("span", {
    key: index,
    style: activeIndex === index ? styles$1.dot : styles$1.activeDot,
    onClick: () => onclick(index)
  })));
}
const styles$1 = {
  allDots: {
    width: "100%",
    position: "absolute",
    display: "flex",
    top: "85%",
    justifyContent: "center",
    zIndex: "200"
  },
  activeDot: {
    cursor: "pointer",
    height: "1rem",
    width: "1rem",
    margin: "0px 3px",
    backgroundColor: "rgba(0, 0, 0, 0.3)",
    borderRadius: "50%",
    display: "inline-block",
    backgroundColor: "rgba(255, 255, 255, 0.5)"
  },
  dot: {
    cursor: "pointer",
    height: "1rem",
    width: "1rem",
    margin: "0px 3px",
    backgroundColor: "black",
    borderRadius: "50%",
    display: "inline-block"
  }
};

const RadioButton$2 = ({
  row,
  data,
  control,
  name,
  defaultValue,
  clickControl
}) => {
  return /*#__PURE__*/React__default.createElement(Controller, {
    name: name,
    control: control,
    render: ({
      field: {
        onChange,
        value
      }
    }) => /*#__PURE__*/React__default.createElement(RadioGroup, {
      "aria-labelledby": "demo-radio-buttons-group-label",
      defaultValue: defaultValue,
      name: "radio-buttons-group",
      row: row,
      onChange: clickControl
    }, data === null || data === void 0 ? void 0 : data.map(item => {
      return /*#__PURE__*/React__default.createElement(FormControlLabel, {
        key: item === null || item === void 0 ? void 0 : item.value,
        value: item === null || item === void 0 ? void 0 : item.value,
        control: /*#__PURE__*/React__default.createElement(Radio, null),
        label: item === null || item === void 0 ? void 0 : item.label,
        onChange: onChange
      });
    }))
  });
};

const SelectWrapper$2 = ({
  label,
  inputLabel,
  data,
  helperText,
  autoWidth,
  placeholder,
  control,
  name,
  defaultValue,
  width
}) => {
  return /*#__PURE__*/React__default.createElement(Controller, {
    name: name || "name",
    control: control,
    render: ({
      field: {
        onChange,
        value
      }
    }) => /*#__PURE__*/React__default.createElement(FormControl, {
      sx: {
        minWidth: width ? width : "16.625vw"
      },
      size: "small"
    }, /*#__PURE__*/React__default.createElement(InputLabel$2, {
      id: "demo-simple-select-label"
    }, inputLabel), /*#__PURE__*/React__default.createElement(Select, {
      value: value || "",
      label: label,
      onChange: onChange,
      autoWidth: autoWidth,
      placeholder: placeholder,
      defaultValue: defaultValue,
      sx: {
        minWidth: width ? width : "15.625vw"
      },
      size: "small",
      variant: "outlined",
      width: width ? width : "15.625vw"
    }, data === null || data === void 0 ? void 0 : data.map(item => {
      return /*#__PURE__*/React__default.createElement(MenuItem$5, {
        value: item === null || item === void 0 ? void 0 : item.value,
        key: item === null || item === void 0 ? void 0 : item.value
      }, item === null || item === void 0 ? void 0 : item.label);
    })), /*#__PURE__*/React__default.createElement(FormHelperText, null, helperText))
  });
};

const TextInput$2 = ({
  label,
  variant,
  disabled,
  defaultValue,
  placeholder,
  InputProps,
  size,
  fullWidth,
  color,
  helperText,
  children,
  select,
  width,
  multiline,
  control,
  name,
  height
}) => {
  return /*#__PURE__*/React__default.createElement(Controller, {
    name: name,
    control: control,
    render: ({
      field: {
        onChange,
        value
      }
    }) => /*#__PURE__*/React__default.createElement(TextField$1, {
      sx: {
        minWidth: width,
        marginRight: select ? "1vw" : 0
      },
      label: label,
      variant: variant,
      disabled: disabled,
      defaultValue: defaultValue,
      placeholder: placeholder,
      InputProps: InputProps,
      size: size,
      fullWidth: fullWidth,
      onChange: onChange,
      color: color,
      helperText: helperText,
      select: select,
      multiline: true,
      minRows: multiline ? 3 : 0,
      maxRows: multiline ? 3 : 0
    }, children)
  });
};

const UploadButton$2 = ({
  error
}) => {
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      textAlign: "center"
    }
  }, /*#__PURE__*/React__default.createElement(IconButton$1, {
    color: "primary",
    "aria-label": "upload picture",
    component: "label"
  }, /*#__PURE__*/React__default.createElement("input", {
    hidden: true,
    accept: "image/*",
    type: "file"
  }), /*#__PURE__*/React__default.createElement("img", {
    src: "https://live.staticflickr.com/65535/52919251485_80b3f6d8b7_m.jpg",
    className: "img",
    alt: "upload"
  })), /*#__PURE__*/React__default.createElement("h6", {
    className: "error"
  }, error));
};

const DatePick$2 = ({
  label,
  variant,
  disabled,
  defaultValue,
  placeholder,
  InputProps,
  size,
  fullWidth,
  color,
  helperText,
  children,
  select,
  width,
  multiline,
  control,
  name,
  height
}) => {
  const [reqDate, setreqDate] = useState(new Date());
  return (
    /*#__PURE__*/
    React__default.createElement(Controller, {
      name: "reqDate",
      control: control,
      render: ({
        field: {
          onChange,
          ...restField
        }
      }) => /*#__PURE__*/React__default.createElement(LocalizationProvider, {
        dateAdapter: AdapterDayjs,
        adapterLocale: "en-in"
      }, /*#__PURE__*/React__default.createElement(DatePicker, {
        slotProps: {
          textField: {
            size: 'small'
          }
        },
        label: label,
        onChange: event => {
          onChange(event);
          setreqDate(event);
        },
        sx: {
          width: width ? width : "16.625vw"
        },
        renderInput: params => /*#__PURE__*/React__default.createElement(TextField$1, Object.assign({
          size: "small"
        }, params))
      }))
    })
  );
};

const InputContainer$1 = ({
  label,
  width,
  mandatory,
  name,
  control,
  placeholder,
  type,
  data,
  mobileNumber,
  select,
  defaultValue,
  multiColumn,
  multiLine,
  uploadValidity,
  labelWidth,
  clickControl,
  getDocumentData
}) => {
  return /*#__PURE__*/React__default.createElement("div", {
    className: "inputContainer"
  }, /*#__PURE__*/React__default.createElement("h3", {
    className: `label ${multiColumn ? "multiCoumn" : ""}`,
    style: {
      width: labelWidth && labelWidth
    }
  }, mandatory ? /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, "*") : "", label), type === "textInput" ? /*#__PURE__*/React__default.createElement(TextInput$2, {
    label: placeholder,
    variant: "outlined",
    size: "small",
    width: width ? width : "15.625vw",
    name: name,
    select: select,
    control: control,
    defaultValue: defaultValue,
    multiline: multiLine,
    InputProps: {
      startAdornment: mobileNumber && /*#__PURE__*/React__default.createElement(InputAdornment, {
        position: "start"
      }, "+91")
    }
  }, data && select && (data === null || data === void 0 ? void 0 : data.map(option => /*#__PURE__*/React__default.createElement(MenuItem$4, {
    key: option.value,
    value: option.value
  }, option.label)))) : type === "radioButton" ? /*#__PURE__*/React__default.createElement(RadioButton$2, {
    row: true,
    data: data,
    control: control,
    name: name,
    defaultValue: defaultValue,
    clickControl: clickControl
  }) : type === "selectInput" ? /*#__PURE__*/React__default.createElement(SelectWrapper$2, {
    control: control,
    inputLabel: placeholder,
    label: label,
    data: data,
    name: name
  }) : type === "upload" ? /*#__PURE__*/React__default.createElement(UploadButton$2, {
    error: uploadValidity
  }) : type === "htmlUpload" ? /*#__PURE__*/React__default.createElement("div", {
    className: "uploadHtml"
  }, /*#__PURE__*/React__default.createElement("input", {
    type: "file",
    name: name,
    onChange: e => {
      var _e$target;
      return getDocumentData(e === null || e === void 0 ? void 0 : (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.files[0], name);
    }
  }), /*#__PURE__*/React__default.createElement("h6", {
    className: "error"
  }, uploadValidity)) : type === "datePicker" ? /*#__PURE__*/React__default.createElement(DatePick$2, {
    control: control,
    label: label,
    name: name
  }) : type === "number" ? /*#__PURE__*/React__default.createElement(TextInput$2, {
    label: placeholder,
    variant: "outlined",
    size: "small",
    width: width ? width : "15.625vw",
    name: name,
    select: select,
    control: control,
    defaultValue: defaultValue,
    multiline: multiLine,
    InputProps: {
      startAdornment: mobileNumber && /*#__PURE__*/React__default.createElement(InputAdornment, {
        position: "start"
      }, "+91")
    }
  }) : "");
};

const ButtonWrapper$1 = ({
  variant,
  disabled,
  onClick,
  color,
  size,
  startIcon,
  endIcon,
  label,
  background,
  type
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Button$1, {
    sx: {
      borderRadius: "0.2vw",
      background: background || ""
    },
    variant: variant,
    disabled: disabled,
    onClick: onClick,
    size: size,
    startIcon: startIcon,
    endIcon: endIcon,
    type: type ? type : "button"
  }, t(label)));
};

const upimg = "https://i.imgur.com/3LD4CAw.png";
const bannerImgUrls$3 = ["https://i.imgur.com/TWbUpQ3.jpeg", "https://i.imgur.com/PiNpOT2.jpeg"];
const PageWrapper = styled$2(Box$1)(({
  theme
}) => ({
  display: "flex",
  backgroundColor: "blue",
  borderRadius: "10px",
  overflow: "hidden",
  boxShadow: "0 8px 20px rgba(0, 0, 0, 0.2)",
  background: "linear-gradient(135deg, #364a65, #4676b7)",
  width: "90%",
  height: "90vh",
  marginLeft: "auto",
  marginRight: "auto"
}));
const SliderWrapper = styled$2(Box$1)(({
  theme
}) => ({
  width: "50%",
  display: "flex",
  flex: 2,
  justifyContent: "center",
  alignItems: "center",
  overflow: "hidden",
  position: "relative",
  padding: "2rem"
}));
const Slide = styled$2(Box$1)(({
  theme
}) => ({
  width: "100%",
  height: "100%",
  backgroundSize: "cover",
  backgroundPosition: "center",
  transition: "background-image 1s ease-in-out"
}));
const LoginCard = styled$2(Card$3)(({
  theme,
  bgImg
}) => ({
  padding: "3rem",
  display: "flex",
  width: "40%",
  position: "relative",
  background: `url('${bgImg}') center center / cover no-repeat`,
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center"
}));
const StyledButton = styled$2(Button$2)(({
  theme
}) => ({
  backgroundColor: theme.palette.awasbandhu.primary.main,
  color: "#fff",
  marginTop: "1rem",
  width: "100%",
  boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.2)",
  "&:hover": {
    backgroundColor: theme.palette.awasbandhu.primary.dark
  }
}));
const EmployeeLoginLink = styled$2(Typography$1)(({
  theme
}) => ({
  color: theme.palette.awasbandhu.primary.main,
  marginTop: "1rem",
  cursor: "pointer",
  textDecoration: "underline"
}));
const StyledHeading = styled$2(Typography$1)({
  textAlign: "center",
  color: "#fff",
  fontSize: "13px",
  fontWeight: 600,
  fontFamily: "sans-serif"
});
const StyledImage = styled$2("img")({
  position: "relative",
  width: "18%",
  margin: "0 auto",
  marginTop: "10px"
});
const ButtonStripWrapper = styled$2(Box$1)(() => ({
  display: "flex",
  textAlign: "center",
  height: "40px",
  margin: "10px 25%",
  alignContent: "center",
  width: "fit-content"
}));
const StyledButtons = styled$2(Button$2)(({
  theme
}) => ({
  backgroundColor: "#325f9d",
  color: "#ffffff",
  width: "150px",
  padding: "10px 30px",
  boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.2)",
  marginLeft: "8px",
  marginRight: "8px",
  transition: "0.3s",
  "&:hover": {
    backgroundColor: theme.palette.awasbandhu.primary.dark
  }
}));
const SlideWrapper$1 = styled$2(Box$1)(({
  theme,
  bgimg
}) => ({
  background: `url('${bgimg}') center center / cover no-repeat`,
  transition: `background 1.5s ease-in-out`,
  position: "relative",
  height: `50%`,
  width: "100%",
  [theme.breakpoints.up("lg")]: {
    height: `60%`
  }
}));
const WelcomeSlideText$1 = styled$2(Box$1)(({
  theme,
  isVisible
}) => ({
  fontSize: "1.5rem",
  fontWeight: "600",
  color: "#fff",
  margin: "auto",
  transition: "transform 1s ease-in-out, opacity 1s ease-in-out",
  fontFamily: '"Raleway", sans-serif',
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  marginTop: "30%"
}));
const ButtonsWrapper$1 = styled$2(Tabs)(() => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  padding: "0.5rem 0",
  width: "100%",
  backgroundColor: "#f5f5f5",
  "& .MuiTabs-flexContainer": {
    width: "100%",
    justifyContent: "center"
  }
}));
const Buttons = styled$2(Tabs)(() => ({
  "&.MuiTab-root": {
    fontSize: ".85rem",
    backgroundColor: "rgb(8, 89, 114)",
    color: "#fff",
    fontFamily: '"Calibri", sans-serif',
    borderRadius: "6px",
    margin: "0 5px",
    textTransform: "none",
    padding: "10px 20px",
    minHeight: "30px",
    display: "inline-block",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "rgb(21, 124, 79)"
    }
  },
  "&.Mui-selected": {
    backgroundColor: "rgb(21, 124, 79)",
    color: "#fff",
    fontSize: ".85rem",
    borderRadius: "6px",
    margin: "0 5px",
    padding: "10px 20px",
    borderBottom: "2px solid #1e8bc5",
    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)"
  }
}));

const StyledTextField$1 = styled$1(TextField$1)(() => ({
  "& .MuiOutlinedInput-input": {
    padding: "5px 5px",
    height: "5px",
    width: "94%"
  }
}));
const useStyles$h = makeStyles(theme => ({
  root: {
    height: "100vh",
    backgroundSize: "cover",
    backgroundPosition: "center center",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    objectFit: "cover",
    imageRendering: "auto",
    opacity: ".85"
  },
  overlay: {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(255, 255, 255, 0.8)"
  },
  card: {
    backgroundColor: "#e9f5ff",
    height: "100%"
  },
  logo: {
    width: "90px",
    height: "80px"
  },
  header: {
    marginBottom: "20px",
    textDecoration: "none"
  },
  textField: {
    width: "94%"
  },
  button: {
    width: "223px",
    height: "35px",
    borderRadius: "1px"
  }
}));
const EmployeeLogin2 = ({
  handleFlip,
  flipped
}) => {
  const classes = useStyles$h();
  const stateId = Digit.ULBService.getStateId();
  const getUserType = () => Digit.UserService.getType();
  const {
    t
  } = useTranslation();
  const setEmployeeDetail = (userObject, token) => {
    var _JSON$parse;
    let locale = ((_JSON$parse = JSON.parse(sessionStorage.getItem("Digit.locale"))) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.value) || "en_IN";
    localStorage.setItem("Employee.tenant-id", userObject === null || userObject === void 0 ? void 0 : userObject.tenantId);
    localStorage.setItem("tenant-id", userObject === null || userObject === void 0 ? void 0 : userObject.tenantId);
    localStorage.setItem("citizen.userRequestObject", JSON.stringify(userObject));
    localStorage.setItem("locale", locale);
    localStorage.setItem("Employee.locale", locale);
    localStorage.setItem("token", token);
    localStorage.setItem("Employee.token", token);
    localStorage.setItem("user-info", JSON.stringify(userObject));
    localStorage.setItem("Employee.user-info", JSON.stringify(userObject));
  };
  const {
    data: storeData,
    isLoading: isStoreLoading
  } = Digit.Hooks.useStore.getInitData();
  const navigate = useHistory();
  const [loginSection, setLoginSection] = useState(true);
  const {
    register,
    handleSubmit,
    watch,
    control
  } = useForm();
  const [user, setUser] = useState(null);
  const [showOtpField, setOtpField] = useState(false);
  const [showsecotpField, setSecondOtpField] = useState(false);
  const [showName, setName] = useState(false);
  const [showToast, setShowToast] = useState(null);
  const [disable, setDisable] = useState(true);
  const [captcha, setCaptcha] = useState("");
  const [captchaInput, setCaptchaInput] = useState("");
  const [captchaVisible, setCaptchaVisible] = useState(false);
  const [otpTimer, setOtpTimer] = useState(0);
  const [resendDisabled, setResendDisabled] = useState(true);
  const [otpTimerKey, setOtpTimerKey] = useState(0);
  useEffect(() => {
    var _user$info, _user$info$roles, _user$info2, _user$info2$roles, _window, _window$location, _window$location$href, _user$info3, _user$info4, _user$info4$roles, _user$info5, _user$info6, _user$info6$roles;
    if (!user) {
      return;
    }
    Digit.SessionStorage.set("citizen.userRequestObject", user);
    const filteredRoles = user === null || user === void 0 ? void 0 : (_user$info = user.info) === null || _user$info === void 0 ? void 0 : (_user$info$roles = _user$info.roles) === null || _user$info$roles === void 0 ? void 0 : _user$info$roles.filter(role => role.tenantId === Digit.SessionStorage.get("Employee.tenantId"));
    if ((user === null || user === void 0 ? void 0 : (_user$info2 = user.info) === null || _user$info2 === void 0 ? void 0 : (_user$info2$roles = _user$info2.roles) === null || _user$info2$roles === void 0 ? void 0 : _user$info2$roles.length) > 0) user.info.roles = filteredRoles;
    Digit.UserService.setUser(user);
    setEmployeeDetail(user === null || user === void 0 ? void 0 : user.info, user === null || user === void 0 ? void 0 : user.access_token);
    let redirectPath = "/digit-ui/employee";
    if ((_window = window) !== null && _window !== void 0 && (_window$location = _window.location) !== null && _window$location !== void 0 && (_window$location$href = _window$location.href) !== null && _window$location$href !== void 0 && _window$location$href.includes("from=")) {
      var _window2, _window2$location, _window2$location$hre, _window2$location$hre2;
      redirectPath = decodeURIComponent((_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$location = _window2.location) === null || _window2$location === void 0 ? void 0 : (_window2$location$hre = _window2$location.href) === null || _window2$location$hre === void 0 ? void 0 : (_window2$location$hre2 = _window2$location$hre.split("from=")) === null || _window2$location$hre2 === void 0 ? void 0 : _window2$location$hre2[1]) || "/digit-ui/employee";
    }
    if (user !== null && user !== void 0 && (_user$info3 = user.info) !== null && _user$info3 !== void 0 && _user$info3.roles && user !== null && user !== void 0 && (_user$info4 = user.info) !== null && _user$info4 !== void 0 && (_user$info4$roles = _user$info4.roles) !== null && _user$info4$roles !== void 0 && _user$info4$roles.every(e => e.code === "NATADMIN")) {
      redirectPath = "/digit-ui/employee/payment/integration/dss/NURT_DASHBOARD";
    }
    if (user !== null && user !== void 0 && (_user$info5 = user.info) !== null && _user$info5 !== void 0 && _user$info5.roles && user !== null && user !== void 0 && (_user$info6 = user.info) !== null && _user$info6 !== void 0 && (_user$info6$roles = _user$info6.roles) !== null && _user$info6$roles !== void 0 && _user$info6$roles.every(e => e.code === "STADMIN")) {
      redirectPath = "/digit-ui/employee/payment/integration/dss/home";
    }
    history.replace(redirectPath);
  }, [user]);
  useEffect(() => {
    if (!showToast) return;
    const timeOut = setTimeout(closeToast, 2000);
    return () => clearTimeout(timeOut);
  }, [showToast]);
  useEffect(() => {
    generateCaptcha(6, true);
  }, []);
  useEffect(() => {
    if (captcha === captchaInput) {
      setDisable(false);
    } else {
      setDisable(true);
    }
    console.log({
      captcha,
      captchaInput
    }, "captcha");
  }, [captcha, captchaInput]);
  useEffect(() => {
    let timer;
    if (showOtpField || showsecotpField) {
      setOtpTimer(60);
      setResendDisabled(true);
      timer = setInterval(() => {
        setOtpTimer(prev => {
          if (prev <= 1) {
            clearInterval(timer);
            setResendDisabled(false);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
    return () => clearInterval(timer);
  }, [showOtpField, showsecotpField, otpTimerKey]);
  const generateCaptcha = (length, isAlphanumeric) => {
    let characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    if (!isAlphanumeric) {
      characters = "0123456789";
    }
    let result = "";
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    setCaptcha(result);
    setCaptchaVisible(true);
  };
  const closeToast = () => {
    setShowToast(null);
  };
  useEffect(() => {
    if (captcha.trim() === captchaInput.trim()) {
      setDisable(false);
    } else {
      setDisable(true);
    }
  }, [captcha, setCaptchaInput]);
  const onSubmit = async data => {
    console.log(data);
    const {
      mobileNumber,
      otp,
      registeredName
    } = data;
    if (!showOtpField && !showName) {
      const requestData = {
        otp: {
          mobileNumber: mobileNumber,
          userType: "citizen",
          type: "login",
          tenantId: stateId
        }
      };
      try {
        const res = await Digit.UserService.sendOtp(requestData, stateId);
        if (res !== null && res !== void 0 && res.isSuccessful) {
          setOtpField(true);
        }
      } catch (err) {
        setName(true);
        setShowToast({
          error: true,
          message: `New User? Please register your detail in the portal`
        });
      }
    }
    console.log(otp, registeredName, showName, showOtpField, showsecotpField, "alllllll");
    if (showsecotpField) {
      const requestData = {
        name: registeredName,
        username: mobileNumber,
        otpReference: otp,
        tenantId: stateId,
        mobileNumber: mobileNumber,
        tempRole: data === null || data === void 0 ? void 0 : data.tempRole
      };
      try {
        const {
          ResponseInfo,
          UserRequest: info,
          ...tokens
        } = await Digit.UserService.registerUser(requestData, stateId);
        Digit.SessionStorage.set("citizen.userRequestObject", {
          info,
          ...tokens
        });
        Digit.UserService.setUser({
          info,
          ...tokens
        });
        navigate.push("/digit-ui/citizen/profile");
      } catch (error) {
        setShowToast({
          error: true,
          message: `OTP is Wrong, please try again!`
        });
      }
    }
    if (showName && !showOtpField && !showsecotpField) {
      const requestData = {
        otp: {
          mobileNumber: mobileNumber,
          name: registeredName,
          userType: "citizen",
          type: "register",
          tenantId: stateId
        }
      };
      try {
        const res = await Digit.UserService.sendOtp(requestData, stateId);
        if (res !== null && res !== void 0 && res.isSuccessful) {
          setSecondOtpField(true);
        }
      } catch (err) {
        setShowToast({
          error: true,
          message: `Something went wrong, please try again!`
        });
      }
    }
    if (showOtpField && !showName) {
      const requestData = {
        username: mobileNumber,
        password: otp,
        tenantId: stateId,
        userType: getUserType()
      };
      try {
        const {
          ResponseInfo,
          UserRequest: info,
          ...tokens
        } = await Digit.UserService.authenticate(requestData);
        console.log("outSideIfLogin", info);
        if (info !== null && info !== void 0 && info.uuid) {
          console.log("insideIfLogin", info);
          Digit.SessionStorage.set("citizen.userRequestObject", {
            info,
            ...tokens
          });
          Digit.UserService.setUser({
            info,
            ...tokens
          });
          navigate.push("/digit-ui/citizen/profile");
        } else {
          setShowToast({
            error: true,
            message: `Something went wrong, please try again!`
          });
        }
      } catch (error) {
        setShowToast({
          error: true,
          message: `Wrong OTP, please try again!`
        });
      }
    }
  };
  const handleResendOtp = async () => {
    const mobileNumber = watch("mobileNumber");
    const registeredName = watch("registeredName");
    let requestData;
    if (showsecotpField) {
      requestData = {
        otp: {
          mobileNumber: mobileNumber,
          name: registeredName,
          userType: "citizen",
          type: "register",
          tenantId: stateId
        }
      };
    } else {
      requestData = {
        otp: {
          mobileNumber: mobileNumber,
          userType: "citizen",
          type: "login",
          tenantId: stateId
        }
      };
    }
    try {
      const res = await Digit.UserService.sendOtp(requestData, stateId);
      if (res !== null && res !== void 0 && res.isSuccessful) {
        setOtpField(true);
        setSecondOtpField(showsecotpField);
        setOtpTimerKey(prev => prev + 1);
        setOtpTimer(60);
        setResendDisabled(true);
      }
    } catch (err) {
      setShowToast({
        error: true,
        message: `Unable to resend OTP. Please try again.`
      });
    }
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, showToast && /*#__PURE__*/React__default.createElement(Toast, {
    style: {
      left: "50 %"
    },
    error: showToast === null || showToast === void 0 ? void 0 : showToast.error,
    label: showToast === null || showToast === void 0 ? void 0 : showToast.message,
    onClose: closeToast
  }), loginSection && /*#__PURE__*/React__default.createElement("section", {
    className: "citizen-login-section"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit),
    className: "citizen-login-form",
    autoComplete: "off"
  }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("h3", {
    className: "citizen-label-homepage"
  }, "ENTER MOBILE No."), /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    hasLabel: false,
    disabled: showsecotpField || showOtpField,
    width: "100%",
    height: "24px",
    name: "mobileNumber",
    type: "number",
    maxWidth: "10",
    inputClassName: "input-citizen-homepage",
    mobileNumber: true,
    maxLength: 10,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("MobileNo"),
        message: "Please enter valid mobile no"
      }
    }
  }), showName && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("h3", {
    className: "citizen-label-homepage"
  }, "Enter Name"), /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    width: "100%",
    height: "24px",
    name: "registeredName",
    type: "textInput",
    inputClassName: "input-citizen-homepage",
    hasLabel: false,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("SearchOwnerName"),
        message: "Please enter only letters and space"
      }
    }
  })), showName && /*#__PURE__*/React__default.createElement("div", {
    style: {
      color: "#fff",
      display: "flex",
      alignItems: "center",
      flexDirection: "row",
      justifyContent: "space-between"
    }
  }, /*#__PURE__*/React__default.createElement("h3", {
    className: "citizen-label-homepage"
  }, "Registered As"), /*#__PURE__*/React__default.createElement(InputWrapper, {
    control: control,
    width: "100%",
    name: "tempRole",
    type: "radioButton",
    inputClassName: "input-citizen-homepage",
    hasLabel: false,
    data: ownerOrLtp,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  })), (showOtpField || showsecotpField) && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("h3", {
    className: "citizen-label-homepage"
  }, "Enter OTP"), /*#__PURE__*/React__default.createElement(InputWrapper, {
    hasLabel: false,
    control: control,
    inputClassName: "input-citizen-homepage",
    width: "100%",
    height: "24px",
    name: "otp",
    type: "password",
    maxLength: 6,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    }
  }))), /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "space-evenly",
      textAlign: "center",
      marginTop: "0.5rem"
    }
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    size: "small",
    background: "#4caf50",
    label: "FASTPASS.HOME.COMMON.SUBMIT",
    type: "submit"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    onClick: handleFlip,
    variant: "contained",
    size: "small",
    style: {
      backgroundColor: "#3B4B95",
      color: "#fff"
    },
    label: "FASTPAS.HOME.DEPARTMENT.LOGIN"
  })), (showOtpField || showsecotpField) && /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      margin: "8px 0px 0px 4px"
    }
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body2",
    sx: {
      mr: 2,
      color: "white"
    }
  }, resendDisabled ? `Resend OTP in ${otpTimer}s` : "Didn't receive OTP?"), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    onClick: handleResendOtp,
    variant: "contained",
    size: "small",
    style: {
      backgroundColor: "#3B4B95",
      color: "#fff"
    },
    label: "Resend OTP",
    disabled: resendDisabled
  })))), showToast && /*#__PURE__*/React__default.createElement(Toast, {
    error: showToast === null || showToast === void 0 ? void 0 : showToast.error,
    warning: showToast === null || showToast === void 0 ? void 0 : showToast.warning,
    label: showToast === null || showToast === void 0 ? void 0 : showToast.message,
    onClose: closeToast,
    isDeleteBtn: true
  }));
};

const DALogin2 = ({
  handleFlip,
  flipped
}) => {
  var _location$pathname;
  const getUserType = () => Digit.UserService.getType();
  const navigate = useHistory();
  const stateId = Digit.ULBService.getCurrentTenantId();
  const [showOtpField, setOtpField] = useState(false);
  const [showsecotpField, setSecondOtpField] = useState(false);
  const [showName, setName] = useState(false);
  const [showToast, setShowToast] = useState(null);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [loginSection, setLoginSection] = useState(false);
  const location = useLocation();
  const homepath = location === null || location === void 0 ? void 0 : (_location$pathname = location.pathname) === null || _location$pathname === void 0 ? void 0 : _location$pathname.includes("digit-ui/citizen");
  const {
    handleSubmit,
    control,
    setValue,
    getValues,
    watch,
    reset
  } = useForm({});
  const history = useHistory();
  const {
    t
  } = useTranslation();
  useEffect(() => {
    const handleBack = () => {
      if (location.pathname === "DA") {
        navigate.push("digit-ui");
      }
    };
    window.addEventListener("popstate", handleBack);
    return () => {
      window.removeEventListener("popstate", handleBack);
    };
  }, [location, navigate]);
  const closeToast = () => {
    setShowToast(null);
  };
  const [activeTab, setActiveTab] = useState(1);
  const [showFeePopup, setShowFeePopup] = useState(false);
  const handlePopupClose = () => {
    setLoginSection(false);
  };
  const handleFeePopupClose = () => {
    setShowFeePopup(false);
  };
  useEffect(() => {
    if (!showToast) return;
    const timeOut = setTimeout(closeToast, 3000);
    return () => clearTimeout(timeOut);
  }, [showToast]);
  useEffect(() => {
    let timer = setInterval(() => {
      setCurrentSlide(curr => curr + 1 < bannerImgUrls$3.length ? curr + 1 : 0);
    }, 3000);
    return () => clearInterval(timer);
  }, []);
  const onSubmit = async data => {
    console.log(data);
    const {
      mobileNumber,
      otp,
      registeredName
    } = data;
    if (!showOtpField && !showName) {
      const requestData = {
        otp: {
          mobileNumber: mobileNumber,
          userType: "citizen",
          type: "login",
          tenantId: stateId
        }
      };
      try {
        const res = await Digit.UserService.sendOtp(requestData, stateId);
        if (res !== null && res !== void 0 && res.isSuccessful) {
          setOtpField(true);
        }
      } catch (err) {
        setName(true);
        setShowToast({
          error: true,
          message: `New User? Please register your detail in the portal`
        });
      }
    }
    console.log(otp, registeredName, showName, showOtpField, showsecotpField, "alllllll");
    if (showsecotpField) {
      const requestData = {
        name: registeredName,
        username: mobileNumber,
        otpReference: otp,
        tenantId: stateId,
        mobileNumber: mobileNumber
      };
      try {
        const {
          ResponseInfo,
          UserRequest: info,
          ...tokens
        } = await Digit.UserService.registerUser(requestData, stateId);
        Digit.SessionStorage.set("citizen.userRequestObject", {
          info,
          ...tokens
        });
        Digit.UserService.setUser({
          info,
          ...tokens
        });
        navigate.push("/digit-ui/citizen/profile");
      } catch (error) {
        setShowToast({
          error: true,
          message: `Something went wrong, please try again!`
        });
      }
    }
    if (showName && !showOtpField && !showsecotpField) {
      const requestData = {
        otp: {
          mobileNumber: mobileNumber,
          name: registeredName,
          userType: "citizen",
          type: "register",
          tenantId: stateId
        }
      };
      try {
        const res = await Digit.UserService.sendOtp(requestData, stateId);
        if (res !== null && res !== void 0 && res.isSuccessful) {
          setSecondOtpField(true);
        }
      } catch (err) {
        setShowToast({
          error: true,
          message: `Something went wrong, please try again!`
        });
      }
    }
    if (showOtpField && !showName) {
      const requestData = {
        username: mobileNumber,
        password: otp,
        tenantId: stateId,
        userType: getUserType()
      };
      try {
        const {
          ResponseInfo,
          UserRequest: info,
          ...tokens
        } = await Digit.UserService.authenticate(requestData);
        console.log("outSideIfLogin", info);
        if (info !== null && info !== void 0 && info.uuid) {
          console.log("insideIfLogin", info);
          Digit.SessionStorage.set("citizen.userRequestObject", {
            info,
            ...tokens
          });
          Digit.UserService.setUser({
            info,
            ...tokens
          });
          navigate.push("/digit-ui/citizen/profile");
        } else {
          setShowToast({
            error: true,
            message: `Something went wrong, please try again!`
          });
        }
      } catch (error) {
        setShowToast({
          error: true,
          message: `Something went wrong, please try again!`
        });
      }
    }
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Box$1, null, /*#__PURE__*/React__default.createElement("div", {
    className: "citizen-header-homepage"
  }, /*#__PURE__*/React__default.createElement(StyledImage, {
    src: upimg,
    alt: "up-image"
  }), /*#__PURE__*/React__default.createElement(StyledHeading, null, t("FASTPAS.HOME.BANNER.SYSTEM_TITLE"))), /*#__PURE__*/React__default.createElement("h2", {
    className: "citizen-login-header"
  }, t("FASTPASS.HOME.CITIZEN.LOGIN_REGISTER")), /*#__PURE__*/React__default.createElement(EmployeeLogin2, {
    handleFlip: handleFlip,
    flipped: flipped
  })), /*#__PURE__*/React__default.createElement(Dialog, {
    open: loginSection,
    onClose: handlePopupClose,
    maxWidth: "sm",
    fullWidth: true,
    PaperProps: {
      component: "form",
      onSubmit: event => {
        event.preventDefault();
        event.preventDefault();
        const formData = new FormData(event.currentTarget);
        const formJson = Object.fromEntries(formData.entries());
        const mobileNumber = formJson.mobileNumber;
        handleClose();
        console.log(mobileNumber);
      }
    }
  }, /*#__PURE__*/React__default.createElement(DialogTitle, {
    sx: {
      backgroundColor: "#406192",
      color: "white",
      background: `url('https://i.imgur.com/qfE8uLN.jpeg') center center / cover no-repeat`,
      height: "70%",
      width: "100%"
    }
  }), /*#__PURE__*/React__default.createElement("h1", {
    style: {
      textAlign: "center",
      color: "#333",
      marginTop: "9px",
      fontSize: "20px",
      fontWeight: "bold",
      textDecoration: "none"
    }
  }, "Mobile OTP Verification"), " ", /*#__PURE__*/React__default.createElement(IconButton$2, {
    "aria-label": "close",
    onClick: handlePopupClose,
    sx: theme => ({
      position: "absolute",
      right: 8,
      top: 30,
      color: theme.palette.grey[500]
    })
  }, /*#__PURE__*/React__default.createElement(CloseIcon, null)), /*#__PURE__*/React__default.createElement(DialogContent, null, loginSection &&
  /*#__PURE__*/
  React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper",
    style: {
      flex: "0 0",
      textAlign: "center"
    }
  }, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: "29vw",
    control: control,
    placeholder: "Enter Mobile No.",
    name: "mobileNumber",
    type: "textInput",
    mobileNumber: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("MobileNo"),
        message: "Please enter valid mobile no"
      }
    },
    maxLength: 10
  }), (showOtpField || showsecotpField) && /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginTop: "10px"
    }
  }, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: "29vw",
    control: control,
    placeholder: "Enter Otp",
    name: "otp",
    type: "textInput",
    maxLength: 6
  }))))), /*#__PURE__*/React__default.createElement(DialogActions, null, /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    color: "primary",
    type: "submit",
    onClick: handleSubmit(onSubmit)
  }, "Send OTP"), /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    color: "primary",
    onClick: handlePopupClose
  }, "Cancel"))), /*#__PURE__*/React__default.createElement(Dialog, {
    open: showFeePopup,
    onClose: handleFeePopupClose,
    maxWidth: "sm",
    fullWidth: true,
    PaperProps: {
      component: "form",
      onSubmit: event => {
        event.preventDefault();
        const formData = new FormData(event.currentTarget);
        const formJson = Object.fromEntries(formData.entries());
        console.log(formJson);
        undefined.onSubmit(formJson);
        handleClose();
      }
    }
  }, /*#__PURE__*/React__default.createElement(DialogTitle, {
    sx: {
      backgroundColor: "#406192",
      color: "white",
      background: `url('https://i.imgur.com/qfE8uLN.jpeg') center center / cover no-repeat`,
      height: "5vh",
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("h2", {
    style: {
      textAlign: "center",
      color: "#333",
      marginTop: "20px",
      fontSize: "20px",
      fontWeight: "bold",
      textDecoration: "none"
    }
  }, "Enter Amount"), " "), /*#__PURE__*/React__default.createElement(IconButton$2, {
    "aria-label": "close",
    onClick: handleFeePopupClose,
    sx: theme => ({
      position: "absolute",
      right: 8,
      top: 30,
      color: theme.palette.grey[500]
    })
  }, /*#__PURE__*/React__default.createElement(CloseIcon, null)), /*#__PURE__*/React__default.createElement(DialogContent, null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      margin: "10px 10px"
    }
  }, /*#__PURE__*/React__default.createElement(InputContainer, {
    width: "32rem",
    control: control,
    placeholder: "Enter Amount.",
    name: "Amount",
    type: "textInput",
    mobileNumber: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern("Amount"),
        message: "Please enter valid Amount"
      }
    },
    maxLength: 10
  }))), /*#__PURE__*/React__default.createElement(DialogActions, null, /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    color: "primary",
    type: "submit"
  }, "Calculate Fee"), /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    color: "primary",
    onClick: handleFeePopupClose
  }, "Cancel"))), false , showToast && /*#__PURE__*/React__default.createElement(Toast, {
    error: showToast === null || showToast === void 0 ? void 0 : showToast.error,
    warning: showToast === null || showToast === void 0 ? void 0 : showToast.warning,
    label: showToast === null || showToast === void 0 ? void 0 : showToast.message,
    onClose: closeToast,
    isDleteBtn: true
  }));
};

const StyledTextField$2 = styled$1(TextField$1)(() => ({
  "& .MuiOutlinedInput-root": {
    height: 25
  },
  "& .MuiOutlinedInput-input": {
    padding: "5px",
    fontSize: "12px"
  },
  width: "100%"
}));
const useStyles$i = makeStyles(theme => ({
  root: {
    backgroundImage: "linear-gradient(#00000070,#0000007d), url('https://abmhosting.in/fastpass/loginpage1/images/sidebar.jpg') center center / cover no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "center center",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    objectFit: "cover",
    imageRendering: "auto",
    opacity: ".85",
    border: "1.5px solid #fff"
  },
  overlay: {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(255, 255, 255, 0.8)"
  },
  card: {
    padding: "10px",
    backgroundColor: "rgba(255, 255, 255, 0.8)",
    border: "2px 0px 2px 2px",
    width: "370px",
    backgroundSize: ""
  },
  logo: {
    width: "110px",
    height: "85px"
  },
  header: {
    textDecoration: "dense",
    color: "#fff"
  },
  textField: {
    borderRadius: "1px",
    backgroundColor: "#fff"
  },
  button: {
    width: "100px",
    height: "30px",
    borderRadius: "1px",
    backgroundColor: "#303F9F",
    color: "#fff",
    marginLeft: "32%"
  },
  label: {
    fontSize: "14px",
    color: "#fff"
  },
  p: {
    color: "#B07200",
    marginTop: "2px",
    fontSize: "10px",
    fontWeight: "600"
  }
}));
const EmployeeLoginCard$1 = ({
  handleFlip,
  flipped
}) => {
  const classes = useStyles$i();
  const tenantId = Digit.ULBService.getStateId();
  const [showPassword, setShowPassword] = useState(false);
  const setEmployeeDetail = (userObject, token) => {
    var _JSON$parse;
    let locale = ((_JSON$parse = JSON.parse(sessionStorage.getItem("Digit.locale"))) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.value) || "en_IN";
    localStorage.setItem("Employee.tenant-id", userObject === null || userObject === void 0 ? void 0 : userObject.tenantId);
    localStorage.setItem("tenant-id", userObject === null || userObject === void 0 ? void 0 : userObject.tenantId);
    localStorage.setItem("citizen.userRequestObject", JSON.stringify(userObject));
    localStorage.setItem("locale", locale);
    localStorage.setItem("Employee.locale", locale);
    localStorage.setItem("token", token);
    localStorage.setItem("Employee.token", token);
    localStorage.setItem("user-info", JSON.stringify(userObject));
    localStorage.setItem("Employee.user-info", JSON.stringify(userObject));
  };
  const {
    data: storeData,
    isLoading: isStoreLoading
  } = Digit.Hooks.useStore.getInitData();
  const [error, setError] = useState("");
  const {
    register,
    handleSubmit,
    watch,
    formState: {
      errors
    }
  } = useForm();
  const [user, setUser] = useState(null);
  const [showToast, setShowToast] = useState(null);
  const [disable, setDisable] = useState(true);
  const [captcha, setCaptcha] = useState("");
  const [captchaInput, setCaptchaInput] = useState("");
  const [invalidLogin, setInvalidLogin] = useState(false);
  const [captchaImage, setCaptchaImage] = useState("");
  const [captchaId, setCaptchaId] = useState("");
  const history = useHistory();
  useEffect(() => {
    var _user$info, _user$info$roles, _user$info2, _user$info2$roles, _window, _window$location, _window$location$href, _user$info3, _user$info4, _user$info4$roles, _user$info5, _user$info6, _user$info6$roles;
    if (!user) {
      return;
    }
    Digit.SessionStorage.set("citizen.userRequestObject", user);
    const filteredRoles = user === null || user === void 0 ? void 0 : (_user$info = user.info) === null || _user$info === void 0 ? void 0 : (_user$info$roles = _user$info.roles) === null || _user$info$roles === void 0 ? void 0 : _user$info$roles.filter(role => role.tenantId === Digit.SessionStorage.get("Employee.tenantId"));
    if ((user === null || user === void 0 ? void 0 : (_user$info2 = user.info) === null || _user$info2 === void 0 ? void 0 : (_user$info2$roles = _user$info2.roles) === null || _user$info2$roles === void 0 ? void 0 : _user$info2$roles.length) > 0) user.info.roles = filteredRoles;
    Digit.UserService.setUser(user);
    setEmployeeDetail(user === null || user === void 0 ? void 0 : user.info, user === null || user === void 0 ? void 0 : user.access_token);
    let redirectPath = "/digit-ui/employee";
    if ((_window = window) !== null && _window !== void 0 && (_window$location = _window.location) !== null && _window$location !== void 0 && (_window$location$href = _window$location.href) !== null && _window$location$href !== void 0 && _window$location$href.includes("from=")) {
      var _window2, _window2$location, _window2$location$hre, _window2$location$hre2;
      redirectPath = decodeURIComponent((_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$location = _window2.location) === null || _window2$location === void 0 ? void 0 : (_window2$location$hre = _window2$location.href) === null || _window2$location$hre === void 0 ? void 0 : (_window2$location$hre2 = _window2$location$hre.split("from=")) === null || _window2$location$hre2 === void 0 ? void 0 : _window2$location$hre2[1]) || "/digit-ui/employee";
    }
    if (user !== null && user !== void 0 && (_user$info3 = user.info) !== null && _user$info3 !== void 0 && _user$info3.roles && user !== null && user !== void 0 && (_user$info4 = user.info) !== null && _user$info4 !== void 0 && (_user$info4$roles = _user$info4.roles) !== null && _user$info4$roles !== void 0 && _user$info4$roles.every(e => e.code === "NATADMIN")) {
      redirectPath = "/digit-ui/employee/payment/integration/dss/NURT_DASHBOARD";
    }
    if (user !== null && user !== void 0 && (_user$info5 = user.info) !== null && _user$info5 !== void 0 && _user$info5.roles && user !== null && user !== void 0 && (_user$info6 = user.info) !== null && _user$info6 !== void 0 && (_user$info6$roles = _user$info6.roles) !== null && _user$info6$roles !== void 0 && _user$info6$roles.every(e => e.code === "STADMIN")) {
      redirectPath = "/digit-ui/employee/payment/integration/dss/home";
    }
    history.replace(redirectPath);
  }, [user]);
  useEffect(() => {
    generateCaptcha();
  }, []);
  const generateServerCaptcha = async () => {
    var _captchaResult$Captch, _captchaResult$Captch2;
    const captchaResult = await Digit.UserService.captchaGenerate(tenantId);
    if (captchaResult !== null && captchaResult !== void 0 && (_captchaResult$Captch = captchaResult.CaptchaResponse) !== null && _captchaResult$Captch !== void 0 && _captchaResult$Captch.imageBase64) {
      setCaptchaImage(`data:image/png;base64,${captchaResult.CaptchaResponse.imageBase64}`);
    }
    if (captchaResult !== null && captchaResult !== void 0 && (_captchaResult$Captch2 = captchaResult.CaptchaResponse) !== null && _captchaResult$Captch2 !== void 0 && _captchaResult$Captch2.captchaId) {
      setCaptchaId(captchaResult.CaptchaResponse.captchaId);
    }
  };
  const validateCaptcha = async () => {
    const req = {
      captchaId: captchaId,
      userInput: watch("captcha")
    };
    try {
      var _captchaResult$Captch3, _captchaResult$Captch4;
      const captchaResult = await Digit.UserService.captchaValidate(tenantId, {
        CaptchaValidationRequest: req
      });
      if (captchaResult !== null && captchaResult !== void 0 && (_captchaResult$Captch3 = captchaResult.CaptchaResponse) !== null && _captchaResult$Captch3 !== void 0 && _captchaResult$Captch3.error) {
        return captchaResult.CaptchaResponse.error;
      }
      if (captchaResult !== null && captchaResult !== void 0 && (_captchaResult$Captch4 = captchaResult.CaptchaResponse) !== null && _captchaResult$Captch4 !== void 0 && _captchaResult$Captch4.imageBase64) {
        setCaptchaImage(`data:image/png;base64,${captchaResult.CaptchaResponse.imageBase64}`);
      }
      return captchaResult;
    } catch (error) {
      return error.response.data.message || "Captcha validation failed";
    }
  };
  useEffect(() => {
    generateServerCaptcha();
  }, []);
  const generateCaptcha = () => {
    const randomCaptcha = Math.floor(1000 + Math.random() * 9000).toString();
    setCaptcha(randomCaptcha);
    setCaptchaInput("");
  };
  const onLogin = async data => {
    const captchaResult = await validateCaptcha();
    console.log(captchaResult, "ccaappttcchhrress");
    if ((captchaResult === null || captchaResult === void 0 ? void 0 : captchaResult.isSuccessful) === "Success") {
      setDisable(true);
      const requestData = {
        username: data === null || data === void 0 ? void 0 : data.employeeId,
        password: data === null || data === void 0 ? void 0 : data.empword,
        userType: "EMPLOYEE"
      };
      requestData.tenantId = tenantId;
      delete requestData.city;
      try {
        const {
          UserRequest: info,
          ...tokens
        } = await Digit.UserService.authenticate(requestData);
        Digit.SessionStorage.set("Employee.tenantId", info === null || info === void 0 ? void 0 : info.tenantId);
        setUser({
          info,
          ...tokens
        });
      } catch (err) {
        var _err$response, _err$response$data, _err$response2, _err$response2$data;
        generateServerCaptcha();
        const errorMessage = (err === null || err === void 0 ? void 0 : (_err$response = err.response) === null || _err$response === void 0 ? void 0 : (_err$response$data = _err$response.data) === null || _err$response$data === void 0 ? void 0 : _err$response$data.error_description) || (err === null || err === void 0 ? void 0 : (_err$response2 = err.response) === null || _err$response2 === void 0 ? void 0 : (_err$response2$data = _err$response2.data) === null || _err$response2$data === void 0 ? void 0 : _err$response2$data.error) || "Invalid Login Credential";
        setError(errorMessage);
        setShowToast({
          error: true,
          message: errorMessage
        });
        setInvalidLogin(true);
        setTimeout(closeToast, 5000);
      }
      setDisable(false);
    } else {
      setInvalidLogin(true);
      setError(captchaResult);
      generateServerCaptcha();
      setShowToast({
        error: true,
        message: `Captcha validation failed`
      });
    }
  };
  const closeToast = () => {
    setShowToast(null);
  };
  const onForgotPassword = () => {
    history.push("/digit-ui/employee/user/forgot-password-recover");
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React__default.createElement(CssBaseline$1, null), /*#__PURE__*/React__default.createElement("form", {
    autoComplete: "off",
    onSubmit: handleSubmit(onLogin)
  }, /*#__PURE__*/React__default.createElement("input", {
    type: "text",
    name: "fake_username",
    autoComplete: "username",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React__default.createElement("input", {
    type: "password",
    name: "fake_password",
    autoComplete: "current-password",
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Typography$1, {
    component: "h6",
    align: "center",
    style: {
      fontWeight: "600",
      fontFamily: "sans-serif",
      lineHeight: "24px",
      letterSpacing: ".5px"
    },
    className: classes.header
  }, "EMPLOYEE LOGIN"), /*#__PURE__*/React__default.createElement("h3", {
    className: classes.label
  }, "Enter Employee ID"), /*#__PURE__*/React__default.createElement(StyledTextField$2, Object.assign({}, register("employeeId", {
    required: "Employee ID is required"
  }), {
    margin: "dense",
    variant: "outlined",
    required: true,
    fullWidth: true,
    id: "employeeId",
    name: "employeeId",
    autoFocus: true,
    autoComplete: "off",
    size: "small",
    placeholder: "Enter Employee ID",
    className: classes.textField
  })), errors.username && /*#__PURE__*/React__default.createElement("p", {
    className: classes.p
  }, errors.username.message), /*#__PURE__*/React__default.createElement("h3", {
    className: classes.label
  }, "Enter Password"), /*#__PURE__*/React__default.createElement(StyledTextField$2, Object.assign({}, register("empword", {
    required: "Password is required",
    minLength: {
      value: 6,
      message: "Password must be at least 6 characters"
    }
  }), {
    variant: "outlined",
    required: true,
    fullWidth: true,
    margin: "dense",
    name: "empword",
    type: showPassword ? "text" : "password",
    id: "empword",
    autoComplete: "off",
    className: classes.textField,
    placeholder: "Enter Password"
  })), errors.password &&
  /*#__PURE__*/
  React__default.createElement("p", {
    className: classes.p
  }, errors.password.message), /*#__PURE__*/React__default.createElement(StyledTextField$2, Object.assign({}, register("captcha", {
    required: "CAPTCHA is required"
  }), {
    variant: "outlined",
    margin: "dense",
    fullWidth: true,
    className: classes.textField,
    id: "captcha",
    placeholder: "Enter CAPTCHA",
    autoComplete: "off",
    name: "captcha"
  })), errors.captcha &&
  /*#__PURE__*/
  React__default.createElement("p", {
    className: classes.p
  }, errors.captcha.message), /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center"
    }
  }, /*#__PURE__*/React__default.createElement(InputLabel$1, {
    className: classes.label,
    style: {
      marginRight: "10px"
    }
  }, "CAPTCHA:"), captchaImage && /*#__PURE__*/React__default.createElement("img", {
    src: captchaImage,
    alt: "CAPTCHA",
    style: {
      height: "40px",
      marginRight: "10px"
    }
  }), /*#__PURE__*/React__default.createElement(IconButton$2, {
    onClick: generateServerCaptcha
  }, /*#__PURE__*/React__default.createElement(CachedIcon, {
    style: {
      color: "#fff"
    }
  }))), /*#__PURE__*/React__default.createElement(Button$2, {
    type: "submit",
    fullWidth: true,
    variant: "contained",
    color: "primary",
    className: classes.button
  }, "Continue"), invalidLogin && /*#__PURE__*/React__default.createElement("p", {
    variant: "caption",
    style: {
      color: "red",
      marginTop: "10px",
      padding: "4px"
    }
  }, error), /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "space-between",
      marginTop: "10px"
    }
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    component: "div",
    align: "center",
    onClick: onForgotPassword,
    sx: {
      cursor: "pointer",
      color: "#fff",
      "&:hover": {
        color: "#90caf9",
        textDecoration: "none"
      }
    }
  }, "Forgot Password?"), /*#__PURE__*/React__default.createElement(Typography$1, {
    onClick: handleFlip,
    component: "div",
    align: "center",
    sx: {
      cursor: "pointer",
      color: "#fff",
      "&:hover": {
        color: "#90caf9",
        textDecoration: "none"
      }
    }
  }, "Citizen Login")))));
};

function SlideShow() {
  const stateId = Digit.ULBService.getCurrentTenantId();
  const [showOtpField, setOtpField] = useState(false);
  const [showsecotpField, setSecondOtpField] = useState(false);
  const [showName, setName] = useState(false);
  const [showToast, setShowToast] = useState(null);
  const [loginSection, setLoginSection] = useState(false);
  const location = useLocation();
  const {
    handleSubmit,
    control
  } = useForm({});
  const {
    t
  } = useTranslation();
  const [flipped, setFlipped] = useState(false);
  const handleFlip = () => setFlipped(!flipped);
  const closeToast = () => {
    setShowToast(null);
  };
  const [showFeePopup, setShowFeePopup] = useState(false);
  useEffect(() => {
    if (!showToast) return;
    const timeOut = setTimeout(closeToast, 3000);
    return () => clearTimeout(timeOut);
  }, [showToast]);
  useEffect(() => {
    let timer = setInterval(() => {
      setCurrentSlide(curr => curr + 1 < bannerImgUrls$2.length ? curr + 1 : 0);
    }, 3000);
    return () => clearInterval(timer);
  }, []);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isVisible, setIsVisible] = useState(true);
  const [bgImageLoaded, setBgImageLoaded] = useState(false);
  const [bgImage, setBgImage] = useState("");
  useEffect(() => {
    const img = new Image();
    const url = bannerImgUrls$2[currentSlide];
    img.src = url;
    img.onload = () => {
      setBgImage(url);
      setBgImageLoaded(true);
    };
    const interval = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        setCurrentSlide(prev => prev + 1 < bannerImgUrls$2.length ? prev + 1 : 0);
        setIsVisible(true);
      }, 500);
    }, 4000);
    return () => clearInterval(interval);
  }, [currentSlide]);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(SlideLoginCardWrapper, null, /*#__PURE__*/React__default.createElement(SlideWrapper, {
    bgimg: bgImage,
    isLoaded: bgImageLoaded
  }, /*#__PURE__*/React__default.createElement(SlideText, null, /*#__PURE__*/React__default.createElement(WelcomeSlideText, {
    isVisible: isVisible
  }, t("FASTPAS.HOME.HERO.WELCOME_TEXT")), /*#__PURE__*/React__default.createElement(EDCRSlideText, null, t("FASTPAS.HOME.EDCR.TITLE")), /*#__PURE__*/React__default.createElement(ParaSlideText, {
    isVisible: isVisible
  }, t("FASTPAS.HOME.EDCR.DESCRIPTION"))), /*#__PURE__*/React__default.createElement(Arrows, {
    prevSlide: () => setCurrentSlide(curr => curr - 1 < 0 ? bannerImgUrls$2.length - 1 : curr - 1),
    nextSlide: () => setCurrentSlide(curr => curr + 1 < bannerImgUrls$2.length ? curr + 1 : 0)
  }), /*#__PURE__*/React__default.createElement(Dots, {
    activeIndex: currentSlide,
    sliderImage: bannerImgUrls$2,
    onclick: currentSlide => setCurrentSlide(currentSlide)
  })), /*#__PURE__*/React__default.createElement(LoginCardWrapper, {
    className: "flip-container"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: `flipper ${flipped ? "flipped" : ""}`
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "login-front"
  }, /*#__PURE__*/React__default.createElement(DALogin2, {
    handleFlip: handleFlip,
    flipped: flipped
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "login-back"
  }, /*#__PURE__*/React__default.createElement(EmployeeLoginCard$1, {
    handleFlip: handleFlip,
    flipped: flipped
  }))))));
}

const ScrollButton = () => {
  const [visible, setVisible] = useState(false);
  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 100) {
      setVisible(true);
    } else if (scrolled <= 100) {
      setVisible(false);
    }
  };
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };
  window.addEventListener("scroll", toggleVisible);
  return /*#__PURE__*/React__default.createElement(TopButton, null, /*#__PURE__*/React__default.createElement(FaArrowCircleUp, {
    onClick: scrollToTop,
    style: {
      display: visible ? "inline" : "none",
      float: 'right',
      marginTop: '30px',
      marginLeft: "20px",
      width: '30px',
      height: '25px',
      color: "#3B4B95"
    }
  }));
};

const Counter = () => {
  useEffect(() => {
    const script1 = document.createElement("script");
    script1.type = "text/javascript";
    script1.src = `https://www.freevisitorcounters.com/auth.php?id=${process.env.REACT_APP_COUNTER_KEY}}`;
    document.body.appendChild(script1);
    const script2 = document.createElement("script");
    script2.type = "text/javascript";
    script2.src = `https://www.freevisitorcounters.com/en/home/counter/${process.env.REACT_APP_COUNTER_ID}/t/5`;
    document.body.appendChild(script2);
    return () => {
      document.body.removeChild(script1);
      document.body.removeChild(script2);
    };
  }, []);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("img", {
    src: `https://www.freevisitorcounters.com/en/counter/render/${process.env.REACT_APP_COUNTER_ID}/t/5`,
    alt: "Free visitor counter",
    style: {
      border: 0
    },
    className: "counterimg"
  }));
};

const FastPasFooter = () => {
  const {
    t
  } = useTranslation();
  const meetUrl = "https://teams.microsoft.com/l/meetup-join/19%3ameeting_MjVkYWM4YjktMTY3NS00NzdlLWEzYjItNzRjNDg3NjYzODY4%40thread.v2/0?context=%7b%22Tid%22%3a%223c662ad3-b258-4418-a5f0-218389e2223d%22%2c%22Oid%22%3a%22610dd1a6-83e5-40fa-b1f6-b472a94773e7%22%7d";
  return /*#__PURE__*/React__default.createElement(FPFooterWrapper, null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      position: "absolute",
      left: "15px",
      fontSize: "12px",
      fontWeight: "bold",
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      gap: "4px"
    }
  }, /*#__PURE__*/React__default.createElement("strong", {
    style: {
      fontSize: "12px"
    }
  }, t("FASTPAS.HOME.FOOTER.CONTACT_US_NUMBER")), /*#__PURE__*/React__default.createElement("span", null, "Training Meet Link:", " ", /*#__PURE__*/React__default.createElement("a", {
    className: "click-here-anchor",
    href: meetUrl,
    target: "_blank",
    rel: "noreferrer"
  }, "Click Here"), " ", "(Every Wednesday & Friday 3:00pm to 5:00pm)")), /*#__PURE__*/React__default.createElement("p", {
    style: {
      textAlign: "center",
      fontSize: "12px"
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      fontSize: "11px"
    }
  }, " \xA9 Copyright "), /*#__PURE__*/React__default.createElement("strong", null, "AWAS BANDHU.")), /*#__PURE__*/React__default.createElement(FooterFPText, null, /*#__PURE__*/React__default.createElement(Counter, null)), /*#__PURE__*/React__default.createElement(ScrollButton, null));
};

const modalBoxStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "#9bcde6",
  border: "2px solid #000",
  boxShadow: 24,
  p: 2,
  borderRadius: "10px",
  width: "300px",
  textAlign: "center"
};
const policiesModal = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "#9bcde6",
  border: "2px solid #000",
  boxShadow: 24,
  p: 3,
  borderRadius: "10px",
  width: "600px",
  maxHeight: "300px",
  overflowY: "auto",
  textAlign: "left"
};
const contactUsModal = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "#9bcde6",
  border: "2px solid #000",
  boxShadow: 24,
  p: 3,
  borderRadius: "10px",
  width: "400px",
  textAlign: "left"
};
const menuStyle = {
  fontSize: "11px",
  color: "#fff",
  fontWeight: 400,
  paddingLeft: 0,
  paddingRight: "10px",
  zIndex: 100
};
const ModalComponent = ({
  open,
  onClose,
  children,
  sx
}) => /*#__PURE__*/createElement(Modal, {
  open: open,
  onClose: onClose
}, /*#__PURE__*/createElement(Box$1, {
  sx: sx || modalBoxStyle
}, children));
function AboveFooterNew() {
  const [openModal, setOpenModal] = useState("");
  const [openAccessHelp, setOpenAccessHelp] = useState(false);
  const [openPolicies, setOpenPolicies] = useState(false);
  const [openConnect, setOpenConnect] = useState(false);
  const [openUsefulLinks, setOpenUsefulLinks] = useState(false);
  const [openContactUs, setOpenContactUs] = useState(false);
  const {
    t
  } = useTranslation();
  const handleOpen = modalName => {
    if (modalName === "accessHelp" || modalName === "rightInfo" || modalName === "termsUse" || modalName === "webInfoMan") {
      setOpenAccessHelp(true);
    } else if (modalName === "policies") {
      setOpenPolicies(true);
    } else if (modalName === "connect") {
      setOpenConnect(true);
    } else if (modalName === "usefulLinks") {
      setOpenUsefulLinks(true);
    } else if (modalName === "contactUs") {
      setOpenContactUs(true);
    }
    setOpenModal(modalName);
  };
  const handleClose = () => {
    setOpenModal("");
    setOpenAccessHelp(false);
    setOpenConnect(false);
    setOpenContactUs(false);
    setOpenUsefulLinks(false);
    setOpenPolicies(false);
  };
  return /*#__PURE__*/createElement(AppBar, {
    position: "static",
    sx: {
      backgroundColor: "#373737",
      zIndex: 10,
      overflowX: "auto"
    },
    className: "footer-menu bottom-appbar-footer"
  }, /*#__PURE__*/createElement(Toolbar, {
    sx: {
      color: "White",
      paddingLeft: "7px!important",
      minHeight: "35px"
    },
    variant: "dense"
  }, [{
    label: "FASTPAS.HOME.FOOTER.ACCESSIBILITY_HELP",
    name: "accessHelp"
  }, {
    label: "FASTPAS.HOME.FOOTER.RIGHT_TO_INFORMATION",
    name: "rightInfo"
  }, {
    label: "FASTPAS.HOME.FOOTER.POLICIES",
    name: "policies"
  }, {
    label: "FASTPAS.HOME.FOOTER.TERMS_OF_USE",
    name: "termsUse"
  }, {
    label: "FASTPAS.HOME.FOOTER.USEFUL_LINKS",
    name: "usefulLinks"
  }, {
    label: "FASTPAS.HOME.FOOTER.WEB_INFORMATION_MANAGER",
    name: "webInfoMan"
  }, {
    label: "FASTPAS.HOME.FOOTER.CONTACT_US",
    name: "contactUs"
  }, {
    label: "FASTPAS.HOME.FOOTER.HELPDESK",
    name: "helpdesk",
    link: "https://mainet.abmindia.com/training/"
  }].map(({
    label,
    name
  }) => /*#__PURE__*/createElement(MenuItem$4, {
    key: name,
    sx: menuStyle,
    onClick: () => name === "helpdesk" ? window.open("https://mainet.abmindia.com/training/", "_blank") : handleOpen(name),
    tabIndex: 0
  }, t(label))), /*#__PURE__*/createElement(ModalComponent, {
    open: openPolicies,
    onClose: handleClose,
    sx: policiesModal
  }, /*#__PURE__*/createElement(Typography$1, {
    variant: "h6",
    gutterBottom: true
  }, "Refund Policy"), /*#__PURE__*/createElement(Typography$1, {
    variant: "body2",
    gutterBottom: true
  }, "Refunds will be returned using the original method of payment \u2013 for example, if a donation has been made by credit card, the refund will be credited by the same mode of channel to the same credit card by the merchant. This applies to all payment modes used by the customer."), /*#__PURE__*/createElement(Typography$1, {
    variant: "body2",
    gutterBottom: true
  }, "If the received product is not as per the customer's selection, the customer can contact us within 10 working days. The refund will be processed as per the bank's TAT/norms."), /*#__PURE__*/createElement(Typography$1, {
    variant: "h6",
    gutterBottom: true,
    sx: {
      marginTop: 2
    }
  }, "Cancellation Policy"), /*#__PURE__*/createElement(Typography$1, {
    variant: "body2",
    gutterBottom: true
  }, "Once the product is dispatched, cancellation will not be entertained. However, customers can cancel the product within 5 to 6 days before it gets delivered."), /*#__PURE__*/createElement(Typography$1, {
    variant: "body2",
    gutterBottom: true
  }, "Alternatively, merchants should update the disclaimer on the website."), /*#__PURE__*/createElement(Typography$1, {
    variant: "body2"
  }, "Refunds/Cancellations will not be entertained once the customer has made the payment.")), /*#__PURE__*/createElement(ModalComponent, {
    open: openAccessHelp,
    onClose: handleClose
  }, /*#__PURE__*/createElement(Typography$1, {
    variant: "h6"
  }, "In Progress")), /*#__PURE__*/createElement(ModalComponent, {
    open: openConnect,
    onClose: handleClose
  }, /*#__PURE__*/createElement(Grid$1, {
    container: true,
    justifyContent: "center"
  }, [{
    icon: /*#__PURE__*/createElement(Facebook, {
      sx: {
        fontSize: 50,
        color: "blue"
      }
    }),
    label: "Facebook"
  }, {
    icon: /*#__PURE__*/createElement(Instagram, {
      sx: {
        fontSize: 50
      }
    }),
    label: "Instagram"
  }, {
    icon: /*#__PURE__*/createElement(LinkedIn, {
      sx: {
        fontSize: 50
      }
    }),
    label: "LinkedIn"
  }, {
    icon: /*#__PURE__*/createElement(Twitter, {
      sx: {
        fontSize: 50,
        color: "#1C9CEA"
      }
    }),
    label: "Twitter"
  }].map(({
    icon,
    label
  }) => /*#__PURE__*/createElement(SocialIcons, {
    key: label,
    style: {
      padding: "10px"
    }
  }, /*#__PURE__*/createElement(Link, {
    href: "#",
    target: "_blank",
    rel: "noopener"
  }, icon, /*#__PURE__*/createElement(Typography$1, null, label)))))), /*#__PURE__*/createElement(ModalComponent, {
    open: openUsefulLinks,
    onClose: handleClose
  }, [{
    icon: /*#__PURE__*/createElement(Home$2, null),
    text: "Home"
  }, {
    icon: /*#__PURE__*/createElement(Group, null),
    text: "About Us"
  }, {
    icon: /*#__PURE__*/createElement(MiscellaneousServices, null),
    text: "Services"
  }, {
    icon: /*#__PURE__*/createElement(HelpOutline, null),
    text: "Helpdesk"
  }, {
    icon: /*#__PURE__*/createElement(Download, null),
    text: "Downloads"
  }, {
    icon: /*#__PURE__*/createElement(PrivacyTip, null),
    text: "Privacy Policy"
  }].map(({
    icon,
    text
  }) => /*#__PURE__*/createElement(Typography$1, {
    gutterBottom: true,
    key: text
  }, /*#__PURE__*/createElement(Link, {
    href: text === "Helpdesk" ? "https://mainet.abmindia.com/training/" : "#",
    target: text === "Helpdesk" ? "_blank" : "_self",
    rel: text === "Helpdesk" ? "noopener noreferrer" : undefined,
    color: "inherit",
    style: {
      textDecoration: "none",
      fontSize: "17px"
    }
  }, /*#__PURE__*/createElement("span", {
    style: {
      paddingRight: "5px"
    }
  }, icon), text)))), /*#__PURE__*/createElement(ModalComponent, {
    open: openContactUs,
    onClose: handleClose,
    sx: contactUsModal
  }, /*#__PURE__*/createElement(Typography$1, {
    variant: "body1",
    gutterBottom: true,
    sx: {
      lineHeight: 1.6
    }
  }, "Our office operates on government working days, as per the following schedule:"), /*#__PURE__*/createElement(Typography$1, {
    variant: "body1",
    gutterBottom: true,
    sx: {
      lineHeight: 1.6,
      fontWeight: "medium"
    }
  }, "Monday to Saturday: 9:30 AM to 6:30 PM", /*#__PURE__*/createElement("br", null), "Sunday: Closed"), /*#__PURE__*/createElement(Typography$1, {
    variant: "body1",
    sx: {
      lineHeight: 1.6,
      marginTop: 2,
      marginBottom: 2
    }
  }, "For any assistance beyond working hours, kindly raise a Helpdesk Ticket. Our team will review and respond on the next working day."), /*#__PURE__*/createElement(Typography$1, {
    variant: "h6",
    gutterBottom: true,
    sx: {
      textAlign: "center",
      fontWeight: "bold"
    }
  }, "U.P. Awas Bandhu"), /*#__PURE__*/createElement(Typography$1, {
    variant: "body1",
    gutterBottom: true,
    sx: {
      lineHeight: 1.6
    }
  }, "RWWV+J99, Trilokinath Marg Hajratganj Janpath Market,", /*#__PURE__*/createElement("br", null), "Lalbagh, Lucknow, Uttar Pradesh, 226001"), /*#__PURE__*/createElement(Typography$1, {
    variant: "body1",
    gutterBottom: true,
    sx: {
      lineHeight: 1.6
    }
  }, "Phone: 08064522131 (Prefix with 0 when dialing)"), /*#__PURE__*/createElement(Typography$1, {
    variant: "body1"
  }, "Email: ", /*#__PURE__*/createElement(Link, {
    href: "mailto:awasbandhu@gmail.com"
  }, "awasbandhu[at]gmail[dot]com")))));
}

const DuePayment = ({
  setShowDuePaymentGroup
}) => {
  const {
    handleSubmit,
    control,
    getValues,
    register,
    formState: {
      errors
    }
  } = useForm({
    defaultValues: {
      name: ""
    }
  });
  const [tableData, setTableData] = useState([]);
  const [tableMeta, setTableMeta] = useState({
    applicationNo: ""
  });
  const [loading, setLoading] = useState(false);
  const stateId = Digit.ULBService.getStateId();
  const history = useHistory();
  const handleApplicationSearch = async applicationNo => {
    console.log("inside handleApplicationSearch with app no:", applicationNo);
    let response;
    if (!applicationNo) {
      console.warn("No application number provided");
      return;
    }
    setLoading(true);
    setTableData([]);
    setTableMeta({
      applicationNo: ""
    });
    try {
      if (applicationNo) {
        var _response, _response$, _response2, _response2$;
        console.log("insideIf", applicationNo, stateId);
        response = await OBPSService.BPASearchNoAuth(stateId, {
          applicationNo
        });
        const taxHeadEstimates = ((_response = response) === null || _response === void 0 ? void 0 : (_response$ = _response[0]) === null || _response$ === void 0 ? void 0 : _response$.taxHeadEstimates) || [];
        const appNo = ((_response2 = response) === null || _response2 === void 0 ? void 0 : (_response2$ = _response2[0]) === null || _response2$ === void 0 ? void 0 : _response2$.applicationNo) || "-";
        setTableMeta({
          applicationNo: appNo
        });
        console.log("response", response);
        const consumerCode = appNo;
        const billPromises = taxHeadEstimates.map(item => {
          const businessService = item.calculationBusinesserviceId;
          return Digit.PaymentService.fetchBillNoAuth(stateId, {
            consumerCode,
            businessService
          }).then(res => res.Bill[0]);
        });
        const results = await Promise.all(billPromises);
        console.log("results", results);
        const tableRows = taxHeadEstimates.map(item => {
          const challanNumber = item.challanNo || "-";
          const paymentStatus = item.paymentStatus || "-";
          const amount = item.estimateAmount || 0;
          const date = item.challanGeneratedDateTime ? (() => {
            const [datePart] = item.challanGeneratedDateTime.split(" ");
            const [yyyy, mm, dd] = datePart.split("-");
            return `${dd}-${mm}-${yyyy}`;
          })() : "N/A";
          let businessService = item.calculationBusinesserviceId;
          return {
            applicationNo: appNo,
            challanNumber,
            amount,
            date,
            businessService,
            paymentStatus
          };
        });
        console.log("tableRows", tableRows);
        setTableData(tableRows);
      }
    } catch (e) {
      setTableData([]);
    } finally {
      setLoading(false);
    }
  };
  const onSubmit = data => {
    alert(`Submitted: ${JSON.stringify(data)}`);
  };
  return /*#__PURE__*/React__default.createElement("section", {
    className: "groupContainer2"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer mb-3"
  }, /*#__PURE__*/React__default.createElement("h4", {
    className: "formHeading common-header-sec text-black"
  }, "Pay due payments", " ", /*#__PURE__*/React__default.createElement(IconButton, {
    "aria-label": "close",
    onClick: () => setShowDuePaymentGroup(false),
    style: {
      color: "red",
      padding: "0",
      float: "right"
    }
  }, /*#__PURE__*/React__default.createElement(CloseIcon, null)))), /*#__PURE__*/React__default.createElement(Container$2, {
    fluid: true,
    className: "formInputContainer common-app-form"
  }, /*#__PURE__*/React__default.createElement(Row, null, /*#__PURE__*/React__default.createElement(Col, null, /*#__PURE__*/React__default.createElement(InputWrapper, {
    label: "Application Number",
    control: control,
    placeholder: "Enter application number",
    name: "applicationNo",
    mandatory: true,
    width: "20.25vw",
    maxLength: 23,
    type: "textInput",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      }
    },
    showSearchIcon: true,
    onSearchClick: () => handleApplicationSearch(getValues("applicationNo"))
  })), /*#__PURE__*/React__default.createElement(Col, null)))), /*#__PURE__*/React__default.createElement("div", {
    className: "table-container",
    style: {
      margin: "24px 0"
    }
  }, loading ? /*#__PURE__*/React__default.createElement("div", {
    style: {
      textAlign: "center",
      padding: "16px"
    }
  }, "Loading...") : tableData.length > 0 ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("caption", {
    className: "emp-table-caption"
  }, "Due Payments"), /*#__PURE__*/React__default.createElement("table", {
    className: "application-table",
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", null, "Sr No."), /*#__PURE__*/React__default.createElement("th", null, "Application Number"), /*#__PURE__*/React__default.createElement("th", null, "Challan Number"), /*#__PURE__*/React__default.createElement("th", null, "Amount"), /*#__PURE__*/React__default.createElement("th", null, "Date"), /*#__PURE__*/React__default.createElement("th", null, "Status"))), /*#__PURE__*/React__default.createElement("tbody", null, tableData.map((row, idx) => /*#__PURE__*/React__default.createElement("tr", {
    key: idx
  }, /*#__PURE__*/React__default.createElement("td", null, idx + 1), /*#__PURE__*/React__default.createElement("td", null, row.applicationNo), /*#__PURE__*/React__default.createElement("td", null, row.challanNumber), /*#__PURE__*/React__default.createElement("td", null, "\u20B9 ", row.amount), /*#__PURE__*/React__default.createElement("td", null, row.date), /*#__PURE__*/React__default.createElement("td", null, (row === null || row === void 0 ? void 0 : row.paymentStatus) === "PAID" ? "PAID" : /*#__PURE__*/React__default.createElement("button", {
    className: "btn btn-primary",
    style: {
      padding: "5px",
      backgroundColor: "#1F4A7C"
    },
    onClick: () => {
      const redirectUrl = `${citizenBaseUrl}/payment/collect/noAuth/${row.businessService}/${row.applicationNo}/${stateId}/tenantId=${stateId}`;
      history.push(redirectUrl);
    }
  }, "Pay Now"))))))) : null)));
};

function AwasBandhu({
  setApplicationFlow
}) {
  var _location$pathname;
  const location = useLocation();
  const history = useHistory();
  const [showDuePaymentGroup, setShowDuePaymentGroup] = useState(false);
  const homepath = location === null || location === void 0 ? void 0 : (_location$pathname = location.pathname) === null || _location$pathname === void 0 ? void 0 : _location$pathname.includes("digit-ui/citizen");
  useEffect(() => {
    const user = Digit.UserService.getUser();
    const isLoggedIn = user && user.access_token && user.info;
    if (isLoggedIn) {
      const isEmployee = user.info.type === "EMPLOYEE";
      const redirectPath = isEmployee ? "/digit-ui/employee" : "/digit-ui/citizen/profile";
      history.replace(redirectPath);
    }
  }, []);
  return /*#__PURE__*/React__default.createElement(HomeWrapper$2, null, /*#__PURE__*/React__default.createElement(TopBarWrapper$1, null, /*#__PURE__*/React__default.createElement(Header$3, null), /*#__PURE__*/React__default.createElement(GovtStrip$1, {
    style: {
      padding: "0.1rem"
    }
  }), /*#__PURE__*/React__default.createElement(DepartmentPanel, {
    setApplicationFlow: setApplicationFlow,
    setShowDuePaymentGroup: setShowDuePaymentGroup
  })), showDuePaymentGroup && /*#__PURE__*/React__default.createElement(DuePayment, {
    setShowDuePaymentGroup: setShowDuePaymentGroup
  }), !showDuePaymentGroup && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(SlideShow, null), /*#__PURE__*/React__default.createElement(AboveFooterNew, null), /*#__PURE__*/React__default.createElement(FastPasFooter, null)));
}

const PageWrapper$1 = styled$2(Box$1)(({
  theme
}) => ({
  display: 'flex',
  height: '100vh',
  width: '100vw',
  marginTop: theme.spacing(-10)
}));
const SliderWrapper$1 = styled$2(Box$1)(({
  theme
}) => ({
  width: '50%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  overflow: 'hidden',
  position: 'relative',
  padding: '2rem',
  boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.2)'
}));
const Slide$1 = styled$2(Box$1)(({
  theme
}) => ({
  width: '100%',
  height: '100%',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  transition: 'background-image 1s ease-in-out'
}));
const LoginCard$1 = styled$2(Card$3)(({
  theme
}) => ({
  width: '50%',
  padding: '2rem',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  boxShadow: '    rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px'
}));
const StyledButton$1 = styled$2(Button$2)(({
  theme
}) => ({
  backgroundColor: theme.palette.awasbandhu.primary.main,
  color: '#fff',
  marginTop: '1rem',
  width: '100%',
  boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.2)',
  '&:hover': {
    backgroundColor: theme.palette.awasbandhu.primary.dark
  }
}));
const EmployeeLoginLink$1 = styled$2(Typography$1)(({
  theme
}) => ({
  color: theme.palette.awasbandhu.primary.main,
  marginTop: '1rem',
  cursor: 'pointer',
  textDecoration: 'underline'
}));
const StyledHeading$1 = styled$2(Typography$1)({
  fontWeight: 'bold',
  fontSize: '1.2rem',
  textAlign: 'center',
  marginTop: '1rem',
  marginBottom: '2rem',
  marginLeft: '1rem'
});
const StyledImage$1 = styled$2('img')({
  width: '100px',
  height: 'auto',
  marginBottom: '1rem'
});
const ButtonStripWrapper$1 = styled$2(Box$1)(() => ({
  backgroundColor: 'rgb(230, 239, 248)',
  padding: '1rem',
  display: 'flex',
  justifyContent: 'space-between',
  gap: '2rem'
}));
const StyledButtons$1 = styled$2(Button$2)(({
  theme
}) => ({
  backgroundColor: theme.palette.awasbandhu.primary.main,
  color: '#fff',
  marginTop: '1rem',
  width: '150px',
  padding: '12px',
  boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.2)',
  '&:hover': {
    backgroundColor: theme.palette.awasbandhu.primary.dark
  }
}));
const SlideWrapper$2 = styled$2(Box$1)(({
  theme,
  bgimg
}) => ({
  background: `linear-gradient(rgba(0, 30, 139, 0.3), rgba(0, 30, 139, 0.3)), url('${bgimg}') center center / cover no-repeat`,
  transition: `background 1.5s ease-in-out`,
  position: 'relative',
  minHeight: `calc(100dvh - 50px)`,
  width: '100%',
  [theme.breakpoints.up('lg')]: {
    minHeight: `calc(100dvh - 50px)`
  },
  '::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
    zIndex: 1
  }
}));
const WelcomeSlideText$2 = styled$2(Box$1)(({
  theme,
  isVisible
}) => ({
  fontSize: '1.5rem',
  fontWeight: '600',
  color: '#fff',
  margin: 'auto',
  transition: 'transform 1s ease-in-out, opacity 1s ease-in-out',
  fontFamily: '"Raleway", sans-serif',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginTop: '30%'
}));

const upimg$1 = 'https://upobpas.in/BPAMSClient/seConfigFiles/images/HomePage/logo.png';
const bannerImgUrls$4 = ['https://i.imgur.com/CVonZnW.jpeg', 'https://i.imgur.com/Kq5MXT0.jpeg'];
const PageWrapper$2 = styled$2(Box$1)(({
  theme
}) => ({
  display: 'flex',
  height: '100vh',
  width: '100vw',
  marginTop: theme.spacing(-10)
}));
const SliderWrapper$2 = styled$2(Box$1)(({
  theme
}) => ({
  width: '50%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  overflow: 'hidden',
  position: 'relative',
  padding: '2rem',
  boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.2)'
}));
const Slide$2 = styled$2(Box$1)(({
  theme
}) => ({
  width: '100%',
  height: '100%',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  transition: 'background-image 1s ease-in-out'
}));
const LoginCard$2 = styled$2(Card$3)(({
  theme
}) => ({
  width: '50%',
  padding: '2rem',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  boxShadow: '    rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px'
}));
const StyledButton$2 = styled$2(Button$2)(({
  theme
}) => ({
  backgroundColor: theme.palette.awasbandhu.primary.main,
  color: '#fff',
  marginTop: '1rem',
  width: '100%',
  boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.2)',
  '&:hover': {
    backgroundColor: theme.palette.awasbandhu.primary.dark
  }
}));
const EmployeeLoginLink$2 = styled$2(Typography$1)(({
  theme
}) => ({
  color: theme.palette.awasbandhu.primary.main,
  marginTop: '1rem',
  cursor: 'pointer',
  textDecoration: 'underline'
}));
const StyledHeading$2 = styled$2(Typography$1)({
  fontWeight: 'bold',
  fontSize: '1.2rem',
  textAlign: 'center',
  marginTop: '1rem',
  marginBottom: '2rem',
  marginLeft: '1rem'
});
const StyledImage$2 = styled$2('img')({
  width: '100px',
  height: 'auto',
  marginBottom: '1rem'
});
const ButtonStripWrapper$2 = styled$2(Box$1)(() => ({
  backgroundColor: 'rgb(230, 239, 248)',
  padding: '1rem',
  display: 'flex',
  justifyContent: 'space-between',
  gap: '2rem'
}));
const StyledButtons$2 = styled$2(Button$2)(({
  theme
}) => ({
  backgroundColor: theme.palette.awasbandhu.primary.main,
  color: '#fff',
  marginTop: '1rem',
  width: '10rem',
  padding: '12px',
  fontSize: '11px',
  boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.2)',
  '&:hover': {
    backgroundColor: theme.palette.awasbandhu.primary.dark
  }
}));
const SlideWrapper$3 = styled$2(Box$1)(({
  theme,
  bgimg
}) => ({
  background: `linear-gradient(rgba(0, 30, 139, 0.3), rgba(0, 30, 139, 0.3)), url('${bgimg}') center center / cover no-repeat`,
  transition: `background 1.5s ease-in-out`,
  position: 'relative',
  minHeight: `calc(100dvh - 50px)`,
  width: '100%',
  [theme.breakpoints.up('lg')]: {
    minHeight: `calc(100dvh - 50px)`
  },
  '::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
    zIndex: 1
  }
}));
const WelcomeSlideText$3 = styled$2(Box$1)(({
  theme,
  isVisible
}) => ({
  fontSize: '1.5rem',
  fontWeight: '600',
  color: '#fff',
  margin: 'auto',
  transition: 'transform 1s ease-in-out, opacity 1s ease-in-out',
  fontFamily: '"Raleway", sans-serif',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginTop: '30%'
}));

const AVPLogin = () => {
  var _location$pathname;
  const getUserType = () => Digit.UserService.getType();
  const navigate = useHistory();
  const stateId = Digit.ULBService.getCurrentTenantId();
  const [showOtpField, setOtpField] = useState(false);
  const [showsecotpField, setSecondOtpField] = useState(false);
  const [showName, setName] = useState(false);
  const [showToast, setShowToast] = useState(null);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [loginSection, setLoginSection] = useState(false);
  const location = useLocation();
  const homepath = location === null || location === void 0 ? void 0 : (_location$pathname = location.pathname) === null || _location$pathname === void 0 ? void 0 : _location$pathname.includes("digit-ui/citizen");
  const {
    handleSubmit,
    control,
    setValue,
    getValues,
    watch,
    reset
  } = useForm({});
  const closeToast = () => {
    setShowToast(null);
  };
  useEffect(() => {
    if (!showToast) return;
    const timeOut = setTimeout(closeToast, 3000);
    return () => clearTimeout(timeOut);
  }, [showToast]);
  useEffect(() => {
    let timer = setInterval(() => {
      setCurrentSlide(curr => curr + 1 < bannerImgUrls$4.length ? curr + 1 : 0);
    }, 3000);
    return () => clearInterval(timer);
  }, []);
  const onSubmit = async data => {
    console.log(data);
    const {
      mobileNumber,
      otp,
      registeredName
    } = data;
    if (!showOtpField && !showName) {
      const requestData = {
        otp: {
          mobileNumber: mobileNumber,
          userType: "citizen",
          type: "login",
          tenantId: stateId
        }
      };
      try {
        const res = await Digit.UserService.sendOtp(requestData, stateId);
        if (res !== null && res !== void 0 && res.isSuccessful) {
          setOtpField(true);
        }
      } catch (err) {
        setName(true);
        setShowToast({
          error: true,
          message: `New User? Please register your detail in the portal`
        });
      }
    }
    console.log(otp, registeredName, showName, showOtpField, showsecotpField, "alllllll");
    if (showsecotpField) {
      const requestData = {
        name: registeredName,
        username: mobileNumber,
        otpReference: otp,
        tenantId: stateId,
        mobileNumber: mobileNumber
      };
      try {
        const {
          ResponseInfo,
          UserRequest: info,
          ...tokens
        } = await Digit.UserService.registerUser(requestData, stateId);
        Digit.SessionStorage.set("citizen.userRequestObject", {
          info,
          ...tokens
        });
        Digit.UserService.setUser({
          info,
          ...tokens
        });
        navigate.push('/digit-ui/citizen/profile');
      } catch (error) {
        setShowToast({
          error: true,
          message: `Something went wrong, please try again!`
        });
      }
    }
    if (showName && !showOtpField && !showsecotpField) {
      const requestData = {
        otp: {
          mobileNumber: mobileNumber,
          name: registeredName,
          userType: "citizen",
          type: "register",
          tenantId: stateId
        }
      };
      try {
        const res = await Digit.UserService.sendOtp(requestData, stateId);
        if (res !== null && res !== void 0 && res.isSuccessful) {
          setSecondOtpField(true);
        }
      } catch (err) {
        setShowToast({
          error: true,
          message: `Something went wrong, please try again!`
        });
      }
    }
    if (showOtpField && !showName) {
      const requestData = {
        username: mobileNumber,
        password: otp,
        tenantId: stateId,
        userType: getUserType()
      };
      try {
        const {
          ResponseInfo,
          UserRequest: info,
          ...tokens
        } = await Digit.UserService.authenticate(requestData);
        Digit.SessionStorage.set("citizen.userRequestObject", {
          info,
          ...tokens
        });
        Digit.UserService.setUser({
          info,
          ...tokens
        });
        navigate.push('/digit-ui/citizen/profile');
      } catch (error) {
        setShowToast({
          error: true,
          message: `Something went wrong, please try again!`
        });
      }
    }
  };
  return /*#__PURE__*/React__default.createElement(PageWrapper$2, {
    style: {
      marginTop: homepath ? '-80px' : '0px'
    }
  }, /*#__PURE__*/React__default.createElement(SliderWrapper$2, null, /*#__PURE__*/React__default.createElement(SlideWrapper$3, {
    key: currentSlide,
    bgimg: bannerImgUrls$4[currentSlide]
  }, /*#__PURE__*/React__default.createElement(WelcomeSlideText$3, null, "Fast & Simplified Trust Based Plan Approval System"))), /*#__PURE__*/React__default.createElement(LoginCard$2, null, /*#__PURE__*/React__default.createElement(Box$1, {
    sx: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React__default.createElement(StyledImage$2, {
    src: upimg$1,
    alt: "upimage"
  }), /*#__PURE__*/React__default.createElement(StyledHeading$2, null, "Awas Evam Vikas Parishad")), /*#__PURE__*/React__default.createElement(StyledHeading$2, null, "Fast & Simplified Trust Based Plan Approval System"), /*#__PURE__*/React__default.createElement(ButtonStripWrapper$2, null, /*#__PURE__*/React__default.createElement(StyledButtons$2, {
    onClick: () => setLoginSection(true)
  }, "Online Services"), /*#__PURE__*/React__default.createElement(StyledButtons$2, {
    onClick: () => navigate.push('/digit-ui/employee')
  }, "Officer Login"), /*#__PURE__*/React__default.createElement(StyledButtons$2, {
    onClick: () => window.open("https://www.coa.gov.in/", "_blank")
  }, "COA Verification Link")), loginSection && /*#__PURE__*/React__default.createElement("section", {
    className: "container1",
    style: {
      marginTop: 0
    }
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "User Login")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper",
    style: {
      flex: '0 0'
    }
  }, /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    placeholder: "Enter Mobile No.",
    name: "mobileNumber",
    type: "textInput",
    label: "Enter Mobile No.",
    mobileNumber: true,
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern('MobileNo'),
        message: "Please enter valid mobile no"
      }
    },
    maxLength: 10
  }), showName && /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    placeholder: "Enter Name",
    name: "registeredName",
    type: "textInput",
    label: "Enter Name",
    validation: {
      required: {
        value: true,
        message: "This field is required"
      },
      pattern: {
        value: Digit.Utils.getPattern('Name'),
        message: "Please enter only letters and spaces"
      }
    }
  }), (showOtpField || showsecotpField) && /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    placeholder: "Enter Otp",
    name: "otp",
    type: "textInput",
    label: "Enter OTP",
    maxLength: 6
  }))), /*#__PURE__*/React__default.createElement("div", {
    style: {
      marginLeft: '25%'
    }
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper, {
    variant: "contained",
    size: "medium",
    label: "Next",
    type: "submit",
    sx: {
      backgroundColor: '#1F4A7C',
      width: '10%',
      marginBottom: '3%'
    }
  }))))), showToast && /*#__PURE__*/React__default.createElement(Toast, {
    error: showToast === null || showToast === void 0 ? void 0 : showToast.error,
    warning: showToast === null || showToast === void 0 ? void 0 : showToast.warning,
    label: showToast === null || showToast === void 0 ? void 0 : showToast.message,
    onClose: closeToast,
    isDleteBtn: true
  })));
};

const Home = () => {
  var _Digit;
  const [applicationFlow, setApplicationFlow] = useState(((_Digit = Digit) === null || _Digit === void 0 ? void 0 : _Digit.SessionStorage.get("CITIZEN.COMMON.HOME.FLOW")) || null);
  const isUdFlow = applicationFlow === "DA";
  useEffect(() => {
    if (applicationFlow) {
      var _Digit2;
      (_Digit2 = Digit) === null || _Digit2 === void 0 ? void 0 : _Digit2.SessionStorage.set("CITIZEN.COMMON.HOME.FLOW", applicationFlow);
    }
  }, [applicationFlow]);
  return applicationFlow ? /*#__PURE__*/React__default.createElement(Switch, null, /*#__PURE__*/React__default.createElement(Route, {
    path: "/*"
  }, isUdFlow ? /*#__PURE__*/React__default.createElement(Redirect, {
    to: "/digit-ui/citizen"
  }) : /*#__PURE__*/React__default.createElement(AVPLogin, {
    setApplicationFlow: setApplicationFlow
  }))) : /*#__PURE__*/React__default.createElement(AwasBandhu, {
    setApplicationFlow: setApplicationFlow
  });
};

const LocationSelection = () => {
  const {
    t
  } = useTranslation();
  const history = useHistory();
  const {
    data: cities,
    isLoading
  } = Digit.Hooks.useTenants();
  const [selectedCity, setSelectedCity] = useState(() => ({
    code: Digit.ULBService.getCitizenCurrentTenant(true)
  }));
  const [showError, setShowError] = useState(false);
  const texts = useMemo(() => ({
    header: t("CS_COMMON_CHOOSE_LOCATION"),
    submitBarLabel: t("CORE_COMMON_CONTINUE")
  }), [t]);
  function selectCity(city) {
    setSelectedCity(city);
    setShowError(false);
  }
  const RadioButtonProps = useMemo(() => {
    return {
      options: cities,
      optionsKey: "i18nKey",
      additionalWrapperClass: "reverse-radio-selection-wrapper",
      onSelect: selectCity,
      selectedOption: selectedCity
    };
  }, [cities, t, selectedCity]);
  function onSubmit() {
    if (selectedCity) {
      Digit.SessionStorage.set("CITIZEN.COMMON.HOME.CITY", selectedCity);
      history.push("/digit-ui/citizen");
    } else {
      setShowError(true);
    }
  }
  return isLoading ? /*#__PURE__*/React__default.createElement("loader", null) : /*#__PURE__*/React__default.createElement(Fragment$2, null, /*#__PURE__*/React__default.createElement(BackButton, null), /*#__PURE__*/React__default.createElement(PageBasedInput, {
    texts: texts,
    onSubmit: onSubmit
  }, /*#__PURE__*/React__default.createElement(CardHeader, null, t("CS_COMMON_CHOOSE_LOCATION")), /*#__PURE__*/React__default.createElement(SearchOnRadioButtons, Object.assign({}, RadioButtonProps, {
    placeholder: t("COMMON_TABLE_SEARCH")
  })), showError ? /*#__PURE__*/React__default.createElement(CardLabelError, null, t("CS_COMMON_LOCATION_SELECTION_ERROR")) : null));
};

const useStyles$j = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    color: '#fff',
    width: '66.66%',
    margin: 'auto 30px',
    fontSize: '12px',
    fontWeight: '600',
    textDecoration: 'underline'
  },
  row: {
    display: 'flex',
    flexDirection: 'row'
  },
  link: {
    cursor: 'pointer',
    margin: '10px',
    width: '18%',
    transition: 'color 0.3s',
    '&:hover': {
      color: 'blue'
    },
    '&::before': {
      content: '•',
      marginRight: '5px'
    }
  }
});
const FooterLinks = () => {
  const classes = useStyles$j();
  return /*#__PURE__*/React__default.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classes.row
  }, /*#__PURE__*/React__default.createElement("p", {
    className: classes.link,
    onClick: () => console.log('Redirect to Home')
  }, " \u2022 Home"), /*#__PURE__*/React__default.createElement("p", {
    className: classes.link,
    onClick: () => console.log('Redirect to Important Links')
  }, " \u2022 Important Link"), /*#__PURE__*/React__default.createElement("p", {
    className: classes.link,
    onClick: () => console.log('Redirect to Disclaimer')
  }, " \u2022 Disclaimer"), /*#__PURE__*/React__default.createElement("p", {
    className: classes.link,
    onClick: () => console.log('Redirect to Privacy Policy')
  }, " \u2022 Privacy Policy")), /*#__PURE__*/React__default.createElement("div", {
    className: classes.row
  }, /*#__PURE__*/React__default.createElement("p", {
    className: classes.link,
    onClick: () => console.log('Redirect to Terms and Conditions')
  }, " \u2022 Terms and Conditions"), /*#__PURE__*/React__default.createElement("a", {
    href: "content/faq",
    className: classes.link
  }, " \u2022 FAQ"), /*#__PURE__*/React__default.createElement("p", {
    className: classes.link,
    onClick: () => console.log('Redirect to Feedback & Complaint')
  }, " \u2022 Feedback & Complaint"), /*#__PURE__*/React__default.createElement("p", {
    className: classes.link,
    onClick: () => console.log('Redirect to E-Samadhan')
  }, " \u2022 E-Samadhan")));
};

const useStyles$k = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '33.33%',
    color: '#fff',
    margin: 'auto'
  },
  image: {
    objectFit: 'cover',
    clipPath: 'inset( 0 0 50% 0)',
    marginTop: '30px'
  },
  map: {
    position: 'absolute',
    top: '0',
    left: '0'
  },
  visitor: {
    color: 'rgb(204, 133, 0)',
    fontWeight: '700',
    fontSize: '24px'
  }
});
const SocialMedia = () => {
  const classes = useStyles$k();
  const handleRedirect = site => {
    switch (site) {
      case 'facebook':
        console.log('Redirect to Facebook');
        break;
      case 'twitter':
        console.log('Redirect to Twitter');
        break;
      case 'National Portal Of India':
        console.log('Redirect to Youtube');
        break;
      case 'Uttar Pradesh State Portal':
        console.log('Redirect to Instagram');
        break;
    }
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/React__default.createElement("img", {
    src: "https://i.imgur.com/ks7yCiC.png",
    className: classes.image,
    useMap: "#socialMap",
    alt: "Social Icons"
  }), /*#__PURE__*/React__default.createElement("map", {
    name: "socialMap",
    className: classes.map
  }, /*#__PURE__*/React__default.createElement("area", {
    shape: "rect",
    coords: "0,0,50,50",
    alt: "Facebook",
    onClick: () => handleRedirect('facebook')
  }), /*#__PURE__*/React__default.createElement("area", {
    shape: "rect",
    coords: "50,0,100,50",
    alt: "Twitter",
    onClick: () => handleRedirect('twitter')
  }), /*#__PURE__*/React__default.createElement("area", {
    shape: "rect",
    coords: "0,50,50,100",
    alt: "National Portal Of India",
    onClick: () => handleRedirect('National Portal Of India')
  }), /*#__PURE__*/React__default.createElement("area", {
    shape: "rect",
    coords: "50,50,100,100",
    alt: "Uttar Pradesh State Portal",
    onClick: () => handleRedirect('Uttar Pradesh State Portal')
  })), /*#__PURE__*/React__default.createElement("p", null, "Total Visitors: ", /*#__PURE__*/React__default.createElement("span", {
    className: classes.visitor
  }, "1420875")));
};

const TCPFooter = () => {
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      background: 'rgba(18, 42, 69, 1)'
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'space-around'
    }
  }, /*#__PURE__*/React__default.createElement(FooterLinks, null), /*#__PURE__*/React__default.createElement(SocialMedia, null), /*#__PURE__*/React__default.createElement(Divider$1, null)), /*#__PURE__*/React__default.createElement("p", {
    style: {
      textAlign: 'center',
      color: '#fff',
      fontSize: '14px',
      letterSpacing: '2'
    }
  }, "\xA9 2024-25, Department of Town & Country Planning, Govt. of Uttar Pradesh | Powered By: ", /*#__PURE__*/React__default.createElement("span", {
    style: {
      color: "rgb(204, 133, 0)",
      fontWeight: 'bold',
      fontSize: '16px'
    }
  }, "ABM Knowledgeware Pvt Ltd.")), /*#__PURE__*/React__default.createElement("p", {
    style: {
      textAlign: 'center',
      color: '#fff',
      fontSize: '14px'
    }
  }, "Last Updated On : ", convertEpochToDate(Date.now())));
};

const MapFooter = () => {
  return (
    /*#__PURE__*/
    React__default.createElement(TCPFooter, null)
  );
};

const Objectives = () => {
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Card, {
    style: {
      width: 1200,
      height: '350px',
      margin: '50px 50px 50px 200px',
      color: 'black'
    }
  }, /*#__PURE__*/React__default.createElement(CardContent, {
    style: {
      padding: '30px'
    }
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h5",
    style: {
      margin: '10px 0px',
      color: "black",
      padding: "5px",
      fontSize: '16px',
      fontWeight: 'bold',
      borderBottom: '1px solid black'
    }
  }, "Objectives"), /*#__PURE__*/React__default.createElement(Typography, {
    variant: "p",
    style: {
      margin: '-10px',
      padding: "10px",
      fontSize: '15px',
      borderRadius: '5px',
      lineHeight: '1.6'
    }
  }, "1. To encourage planned and systematic urban and rural growth in a comprehensive manner."), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement(Typography, {
    variant: "p",
    style: {
      margin: '-10px',
      padding: "10px",
      fontSize: '15px',
      borderRadius: '5px',
      lineHeight: '1.6'
    }
  }, "2. To stop haphazard constructions."), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement(Typography, {
    variant: "p",
    style: {
      margin: '-10px',
      padding: "10px",
      fontSize: '15px',
      borderRadius: '5px',
      lineHeight: '1.6'
    }
  }, "3. To make optimum use of precious urban land."), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement(Typography, {
    variant: "p",
    style: {
      margin: '-10px',
      padding: "10px",
      fontSize: '15px',
      borderRadius: '5px',
      lineHeight: '1.6'
    }
  }, "4. To create conducive conditions for encouraging planned constructions."), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement(Typography, {
    variant: "p",
    style: {
      margin: '-10px',
      padding: "10px",
      fontSize: '15px',
      borderRadius: '5px',
      lineHeight: '1.6'
    }
  }, "5. To plan for creating essential urban infrastructure."), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement(Typography, {
    variant: "p",
    style: {
      margin: '-10px',
      padding: "10px",
      fontSize: '15px',
      borderRadius: '5px',
      lineHeight: '1.6'
    }
  }, "6.  To sub serve the basic needs of poor and especially urban slum population."), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement(Typography, {
    variant: "p",
    style: {
      margin: '-10px',
      padding: "10px",
      fontSize: '15px',
      borderRadius: '5px',
      lineHeight: '1.6'
    }
  }, "7.  To upgrade environment for conducive habitat."), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement(Typography, {
    variant: "p",
    style: {
      margin: '-10px',
      padding: "10px",
      fontSize: '15px',
      borderRadius: '5px',
      lineHeight: '1.6'
    }
  }, "8. To preserve the hilly architecture and rich heritage of the State"))));
};

const StyledTableCell$2 = styled$3(TableCell$1)(({
  theme
}) => ({
  [`&.${tableCellClasses$1.head}`]: {
    color: theme.palette.common.white
  },
  [`&.${tableCellClasses$1.body}`]: {
    fontSize: 14
  }
}));
const StyledTableRow$2 = styled$3(TableRow$1)(({
  theme
}) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover
  },
  '&:last-child td, &:last-child th': {
    border: 0
  }
}));
function createData(name, calories, fat, carbs, protein, health) {
  return {
    name,
    calories,
    fat,
    carbs,
    protein,
    health
  };
}
const rows = [createData(1, 'Shimla', 1, 'Una', 1, 'Amb'), createData(2, 'Solan', 2, 'Chamba', 2, 'SunderNagar'), createData(3, 'Dharmasala', 3, 'Rampur Bushehar', 3, 'Ponta Sahib'), createData(4, 'Mandi', 4, 'Parwanoo', 4, 'Rohru'), createData(5, 'Kullu', 5, 'Bilaspur', 5, 'Nadaun'), createData(6, 'Hamirpur', 6, 'Kasuli', 6, ''), createData(7, 'Nahan', 7, 'Manali', 7, ''), createData(8, '', 8, 'Palampur', 8, '')];
function OfficesInfo() {
  return /*#__PURE__*/createElement(TableContainer$1, {
    component: Paper$1,
    sx: {
      width: '90%',
      margin: '20px 10px 0px 70px'
    }
  }, /*#__PURE__*/createElement(Typography$1, {
    variant: "p",
    style: {
      marginTop: '30px'
    }
  }, "The Town & Country Planning Department in the State is still in its infancy. Besides Directorate, it has 7 Divisional Town and Country Planning Offices , 5 Sub-Divisional Town Planning Offices and 5 Town Planning Offices. The Divisional offices are headed by Town and Country Planners and Sub-Divisional offices by Assistant Town Planners and Town Planning Offices by Planning officers . The Divisional as well as Sub-Divisional offices and Town Planning Offices are located in following Towns :-"), /*#__PURE__*/createElement(Table$4, {
    sx: {
      maxWidth: 900,
      margin: '20px 20px 20px 200px'
    },
    "aria-label": "customized table"
  }, /*#__PURE__*/createElement(TableHead$1, {
    style: {
      height: '20px'
    }
  }, /*#__PURE__*/createElement(TableRow$1, {
    style: {
      background: '#1F4A7C',
      height: '20px'
    }
  }, /*#__PURE__*/createElement(StyledTableCell$2, null, "SL#"), /*#__PURE__*/createElement(StyledTableCell$2, {
    align: "right"
  }, "Divisional Offices"), /*#__PURE__*/createElement(StyledTableCell$2, {
    align: "right"
  }, "SL#"), /*#__PURE__*/createElement(StyledTableCell$2, {
    align: "right"
  }, "Sub-Divisonal Offices"), /*#__PURE__*/createElement(StyledTableCell$2, {
    align: "right"
  }, "SL#"), /*#__PURE__*/createElement(StyledTableCell$2, {
    align: "right"
  }, "Town Planning Offices"))), /*#__PURE__*/createElement(TableBody$1, null, rows.map(row => /*#__PURE__*/createElement(StyledTableRow$2, {
    key: row.name
  }, /*#__PURE__*/createElement(StyledTableCell$2, {
    component: "th",
    scope: "row",
    style: {
      width: '10px'
    }
  }, row.name), /*#__PURE__*/createElement(StyledTableCell$2, {
    align: "right"
  }, row.calories), /*#__PURE__*/createElement(StyledTableCell$2, {
    align: "right"
  }, row.fat), /*#__PURE__*/createElement(StyledTableCell$2, {
    align: "right"
  }, row.carbs), /*#__PURE__*/createElement(StyledTableCell$2, {
    align: "right"
  }, row.protein), /*#__PURE__*/createElement(StyledTableCell$2, {
    align: "right"
  }, row.health))))));
}

const StyledTableCell$3 = styled$3(TableCell$1)(({
  theme
}) => ({
  [`&.${tableCellClasses$1.head}`]: {
    color: theme.palette.common.white
  },
  [`&.${tableCellClasses$1.body}`]: {
    fontSize: 14
  }
}));
const StyledTableRow$3 = styled$3(TableRow$1)(({
  theme
}) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover
  },
  '&:last-child td, &:last-child th': {
    border: 0
  }
}));
function createData$1(name, calories, fat, carbs, protein, health) {
  return {
    name,
    calories,
    fat,
    carbs,
    protein,
    health
  };
}
const rows$1 = [createData$1(1, 'Director', 1, 1, '-', '-'), createData$1(2, 'State Town Planner', 1, '-', 1, '-'), createData$1(3, 'Town & COuntry Planner', 8, 6, 2, '-'), createData$1(4, 'Astt. Town Planner', 16, 11, 5, '-'), createData$1(5, 'Planning Officer', 31, 18, 13, '-'), createData$1(6, 'Law Officer', 1, 1, '-', '-'), createData$1(7, 'Tehsildar', 1, '-', 1, '-'), createData$1(8, 'Supdt.Gr.I', 1, 1, '-', '-'), createData$1(9, 'Research Officer', 1, '-', 1, '-'), createData$1(10, 'Section Officer', 1, 1, '-', '-'), createData$1(11, 'Supdt.Gr.II', 2, 2, '-', '-'), createData$1(12, 'Sr.Planning Draughtsman', 10, 8, 2, '-'), createData$1(13, 'Personal Assistant', 1, '-', 1, '-'), createData$1(14, 'Junior Engineer', 38, 30, 8, '-'), createData$1(15, 'Draughtssman', 11, 8, 3, '-'), createData$1(16, 'Jr.Draughtsman', 29, 18, 11, '-'), createData$1(17, 'Ferro Printer', 2, 2, '-', '-'), createData$1(18, 'Research Assistant', 1, 1, '-', '-'), createData$1(19, 'Field Investigator', 2, 1, 1, '-'), createData$1(20, 'Senior Assistant', 11, 11, '-', '-'), createData$1(21, 'Sr.Scale Stenographer', 1, 1, '-', '-'), createData$1(22, 'Computer Operator', 2, 2, '-', '-'), createData$1(23, 'Steno Typist', 12, 12, '-', '-'), createData$1(24, 'Clerk', 17, 15, 2, '-'), createData$1(25, 'Junior Office Assistant', 28, 5, 23, '-'), createData$1(26, 'Driver', 7, 6, 1, '-'), createData$1(27, 'Patwari', 25, 6, 19, '-'), createData$1(28, 'Surveyer', 2, 2, '-', '-'), createData$1(29, 'Head Constable', 1, 1, 1, '-'), createData$1(30, 'Constable', 3, '-', 3, '-'), createData$1(31, 'Process server', 3, '-', 3, '-'), createData$1(32, 'Peon', 26, 23, 3, '-'), createData$1(33, 'Chowkidar-cum-Sweeper', 5, 4, 1, '-'), createData$1(34, 'Chainman', 31, 25, 6, '-'), createData$1(35, 'Welder', 3, '-', 3, '-'), createData$1(36, 'Sweeper', 2, 2, '-', '-')];
function PostwiseSetup() {
  return /*#__PURE__*/createElement(TableContainer$1, {
    component: Paper$1,
    sx: {
      width: '90%',
      margin: '20px 10px 0px 70px'
    }
  }, /*#__PURE__*/createElement(Typography$1, {
    variant: "p",
    style: {
      margin: '20px'
    }
  }, "Detail of  Sanctioned/Filled and Vacant Posts in teh Town & Country Planning Deparatment, Uttar Pradesh as on 31st March 2019:"), /*#__PURE__*/createElement(Table$4, {
    sx: {
      maxWidth: 900,
      margin: '20px 20px 20px 200px'
    },
    "aria-label": "customized table"
  }, /*#__PURE__*/createElement(TableHead$1, {
    style: {
      height: '20px'
    }
  }, /*#__PURE__*/createElement(TableRow$1, {
    style: {
      background: '#1F4A7C',
      height: '20px'
    }
  }, /*#__PURE__*/createElement(StyledTableCell$3, null, "SL#"), /*#__PURE__*/createElement(StyledTableCell$3, {
    align: "right"
  }, "Name of Post"), /*#__PURE__*/createElement(StyledTableCell$3, {
    align: "right"
  }, "Sanctioned Posts"), /*#__PURE__*/createElement(StyledTableCell$3, {
    align: "right"
  }, "Filled"), /*#__PURE__*/createElement(StyledTableCell$3, {
    align: "right"
  }, "Vacant"), /*#__PURE__*/createElement(StyledTableCell$3, {
    align: "right"
  }, "Remarks"))), /*#__PURE__*/createElement(TableBody$1, null, rows$1.map(row => /*#__PURE__*/createElement(StyledTableRow$3, {
    key: row.name
  }, /*#__PURE__*/createElement(StyledTableCell$3, {
    component: "th",
    scope: "row"
  }, row.name), /*#__PURE__*/createElement(StyledTableCell$3, {
    align: "right"
  }, row.calories), /*#__PURE__*/createElement(StyledTableCell$3, {
    align: "right"
  }, row.fat), /*#__PURE__*/createElement(StyledTableCell$3, {
    align: "right"
  }, row.carbs), /*#__PURE__*/createElement(StyledTableCell$3, {
    align: "right"
  }, row.protein), /*#__PURE__*/createElement(StyledTableCell$3, {
    align: "right"
  }, row.health))))));
}

function OrganizationalSetup() {
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'column'
    }
  }, /*#__PURE__*/React__default.createElement(OfficesInfo, null), /*#__PURE__*/React__default.createElement(PostwiseSetup, null));
}

const ContactUs = () => {
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Card, {
    style: {
      width: 1200,
      height: '350px',
      margin: '50px 50px 50px 200px',
      color: 'black'
    }
  }, /*#__PURE__*/React__default.createElement(CardContent, {
    style: {
      padding: '30px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'space-between'
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: '50%'
    }
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h5",
    style: {
      margin: '10px 0px',
      color: "black",
      padding: "5px",
      fontSize: '16px',
      fontWeight: 'bold',
      borderBottom: '1px solid black'
    }
  }, "Contact Us"), /*#__PURE__*/React__default.createElement(Typography, {
    variant: "p",
    style: {
      margin: '-10px',
      padding: "10px",
      fontSize: '15px',
      borderRadius: '5px',
      lineHeight: '1.6'
    }
  }, /*#__PURE__*/React__default.createElement("strong", null, "Directorate of Town and Country Planning Department")), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement(Typography, {
    variant: "p",
    style: {
      margin: '-10px',
      padding: "10px",
      fontSize: '15px',
      borderRadius: '5px',
      lineHeight: '1.6'
    }
  }, "Yojna Bhawan, Block No. 32A, SDA Complex, Vikas Nagar,"), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement(Typography, {
    variant: "p",
    style: {
      margin: '-10px',
      padding: "10px",
      fontSize: '15px',
      borderRadius: '5px',
      lineHeight: '1.6'
    }
  }, "PBX NO. 0177-2624762, Toll Free No. 1800-180-8103 FAX NO. 0177- 2625787,"), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement(Typography, {
    variant: "p",
    style: {
      margin: '-10px',
      padding: "10px",
      fontSize: '15px',
      borderRadius: '5px',
      lineHeight: '1.6'
    }
  }, "E-mail ID: tcp-hp@nic.in  , Web Site: www.tcp.hp.gov.in"), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement(Typography, {
    variant: "p",
    style: {
      margin: '-10px',
      padding: "10px",
      fontSize: '15px',
      borderRadius: '5px',
      lineHeight: '1.6'
    }
  }, "Shimla - 171 009, Uttar Pradesh")), /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: '50%',
      color: 'white'
    }
  }, /*#__PURE__*/React__default.createElement("h4", null, "Google Map Location"), /*#__PURE__*/React__default.createElement("img", {
    src: "https://i.imgur.com/5k0HbLm.png",
    alt: "mapImage",
    style: {
      width: '320px',
      height: '320px',
      translate: '100px -50px'
    }
  })))));
};

const records = [{
  id: 1,
  photo: "https://tcp.hp.gov.in/Application/uploadDocuments/employee/Emp20220215_120357.jpg",
  name: "Sh. Devesh kumar, IAS, IAS",
  designation: "Principal Secretary ,TCP",
  PhoneNo: "",
  MobNo: "",
  Email: "N/A"
}, {
  id: 2,
  photo: "https://tcp.hp.gov.in/img/noPhptoPassport.jpg",
  name: "Sh. Madan Negi",
  designation: "Section Officer ,TCP",
  PhoneNo: "0177-2880435",
  MobNo: "8988054386",
  Email: "N/A"
}, {
  id: 3,
  photo: "https://tcp.hp.gov.in/Application/uploadDocuments/employee/Emp20201027_113328.jpg",
  name: "Sh. Kamal Kant Saroch",
  designation: "Director, TCP Department",
  PhoneNo: "0177-2622494",
  MobNo: "",
  Email: "N/A"
}, {
  id: 4,
  photo: "https://tcp.hp.gov.in/img/noPhptoPassport.jpg",
  name: "State Town Planner",
  designation: "STP",
  PhoneNo: "N/A",
  MobNo: "N/A",
  Email: "N/A"
}, {
  id: 5,
  photo: "https://tcp.hp.gov.in/Application/uploadDocuments/employee/Emp20210129_115347.jpg",
  name: "Sh. Kamar Chand Nanta",
  designation: "TCP(HQ), Directorate",
  PhoneNo: "0177-2621450",
  MobNo: "9816600890",
  Email: "N/A"
}, {
  id: 6,
  photo: "https://tcp.hp.gov.in/Application/uploadDocuments/employee/Emp20210129_115322.jpg",
  name: "Ms. Soma Devi",
  designation: "ATP(HQ), Direcotrate",
  PhoneNo: "",
  MobNo: "",
  Email: "N/A"
}, {
  id: 7,
  photo: "https://tcp.hp.gov.in/Application/uploadDocuments/employee/Emp20210204_113131.jpg",
  name: "Ajay Kumar Sharma",
  designation: "Programmer(HQ), Directorate",
  PhoneNo: "",
  MobNo: "",
  Email: "N/A"
}, {
  id: 8,
  photo: "https://tcp.hp.gov.in/Application/uploadDocuments/employee/Emp20230427_130224.jpg",
  name: "Mr. Akshit Mehta, B.TECH in URBAN AND REGIONAL PLANNING",
  designation: "ASSTT. TOWN PLANNER, HQ",
  PhoneNo: "0177-2624762",
  MobNo: "9888333320",
  Email: "N/A"
}, {
  id: 9,
  photo: "https://tcp.hp.gov.in/img/noPhptoPassport.jpg",
  name: "Mr. Harender Sharma",
  designation: "P.O(HQ), Directorate",
  PhoneNo: "0177-2624762",
  MobNo: "",
  Email: "N/A"
}, {
  id: 10,
  photo: "https://tcp.hp.gov.in/img/noPhptoPassport.jpg",
  name: "Sh. Mayank Manta",
  designation: "Law Officer, Directorate",
  PhoneNo: "0177-2627619",
  MobNo: "9459040229",
  Email: "N/A"
}, {
  id: 11,
  photo: "https://tcp.hp.gov.in/img/noPhptoPassport.jpg",
  name: "Sh. Jai Ram",
  designation: "Sutd.I, Directorate",
  PhoneNo: "0177-2624762",
  MobNo: "9418192290",
  Email: "N/A"
}, {
  id: 12,
  photo: "https://tcp.hp.gov.in/Application/uploadDocuments/employee/Emp20210129_115347.jpg",
  name: "Sh. Kamar Chand Nanta",
  designation: "TCP, Shimla, D.T.P Office Shimla",
  PhoneNo: "0177-2624762",
  MobNo: "9816600890",
  Email: "N/A"
}, {
  id: 13,
  photo: "https://tcp.hp.gov.in/img/noPhptoPassport.jpg",
  name: "ATP Shimla",
  designation: "A.T.P, D.T.P Office Shimla",
  PhoneNo: "01792-233507",
  MobNo: "",
  Email: "N/A"
}, {
  id: 14,
  photo: "https://tcp.hp.gov.in/Application/uploadDocuments/employee/Emp20210129_115627.jpg",
  name: "Mr. Chetan Sharma",
  designation: "P.O D.T.P Office Shimla",
  PhoneNo: "",
  MobNo: "9418088730",
  Email: "N/A"
}, {
  id: 15,
  photo: "https://tcp.hp.gov.in/img/noPhptoPassport.jpg",
  name: "Mr. Jay Prakash",
  designation: "PQ HQ",
  PhoneNo: "",
  MobNo: "9418625202",
  Email: "N/A"
}, {
  id: 16,
  photo: "https://tcp.hp.gov.in/Application/uploadDocuments/employee/Emp20220504_164216.jpg",
  name: "Smt. Prem Lata Chauhan",
  designation: "TCP, D.T.P. Office, SOlan",
  PhoneNo: "01792-228485",
  MobNo: "9418589531",
  Email: "N/A"
}, {
  id: 17,
  photo: "https://tcp.hp.gov.in/img/noPhptoPassport.jpg",
  name: "Sh. Ramesh Bharadwaj",
  designation: "ATP, DTP. Office SOlan",
  PhoneNo: "01792-228486",
  MobNo: "9418075289",
  Email: "N/A"
}, {
  id: 18,
  photo: "https://tcp.hp.gov.in/img/noPhptoPassport.jpg",
  name: "Sh. Rajesh Kumar",
  designation: "P.O TCP Office Shimla",
  PhoneNo: "",
  MobNo: "9418479019",
  Email: "N/A"
}, {
  id: 19,
  photo: "https://tcp.hp.gov.in/Application/uploadDocuments/employee/Emp20210129_120543.jpg",
  name: "MR. Raj Mohan Singh",
  designation: "P.O D.T.P Office Solan",
  PhoneNo: "",
  MobNo: "",
  Email: "N/A"
}, {
  id: 20,
  photo: "https://tcp.hp.gov.in/Application/uploadDocuments/employee/Emp20210129_115627.jpg",
  name: "Akshay Kumar Sharma",
  designation: "A.T.P , S.D.T.P Office, Kasauli",
  PhoneNo: "",
  MobNo: "8219267407",
  Email: "N/A"
}, {
  id: 20,
  photo: "https://tcp.hp.gov.in/Application/uploadDocuments/employee/Emp20220504_164216.jpg",
  name: "Smt. Prem Lata Chauhan",
  designation: "TCP, D.T.P. Office, SOlan",
  PhoneNo: "01792-228485",
  MobNo: "9418589531",
  Email: "N/A"
}, {
  id: 21,
  photo: "https://tcp.hp.gov.in/img/noPhptoPassport.jpg",
  name: "Sh. Nirdosh Kumar",
  designation: "P.O.S.D.T.P Office, Parwanoo",
  PhoneNo: "01792-233507",
  MobNo: "8679166401",
  Email: "N/A"
}];
const columns = [{
  id: "photo",
  label: "Photo",
  width: "15%"
}, {
  id: "name",
  label: "Name & Designation",
  width: "50%"
}, {
  id: "contact",
  label: "Contact Information",
  width: "25%"
}];
const rowsPerPage = 10;
const EmployeeProfile = () => {
  const [page, setPage] = useState(0);
  const handleChangePage = (_, newPage) => {
    setPage(newPage);
  };
  return /*#__PURE__*/React__default.createElement(TableContainer, {
    component: Paper
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "h6",
    style: {
      margin: "20px"
    }
  }, "Employee Profile"), /*#__PURE__*/React__default.createElement(Table, {
    style: {
      width: "90%",
      margin: "30px"
    }
  }, /*#__PURE__*/React__default.createElement(TableHead, null, /*#__PURE__*/React__default.createElement(TableRow, {
    style: {
      background: "#1F4A7C",
      height: "20px"
    }
  }, columns.map(column => /*#__PURE__*/React__default.createElement(TableCell, {
    key: column.id,
    style: {
      color: "white",
      width: column.width
    }
  }, column.label)))), /*#__PURE__*/React__default.createElement(TableBody, null, records.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(record => /*#__PURE__*/React__default.createElement(TableRow, {
    key: record.id
  }, /*#__PURE__*/React__default.createElement(TableCell, null, /*#__PURE__*/React__default.createElement("img", {
    src: record.photo,
    alt: record.name,
    width: "80",
    height: "80"
  })), /*#__PURE__*/React__default.createElement(TableCell, null, /*#__PURE__*/React__default.createElement("div", null, record.name), /*#__PURE__*/React__default.createElement("div", null, record.designation)), /*#__PURE__*/React__default.createElement(TableCell, null, /*#__PURE__*/React__default.createElement("div", null, "Phone No: ", record.PhoneNo), /*#__PURE__*/React__default.createElement("div", null, "Mobile No: ", record.MobNo), /*#__PURE__*/React__default.createElement("div", null, "Email: ", record.Email)))))), /*#__PURE__*/React__default.createElement(TablePagination, {
    rowsPerPageOptions: [],
    component: "div",
    count: records.length,
    rowsPerPage: rowsPerPage,
    page: page,
    onPageChange: handleChangePage
  }));
};

const records$1 = [{
  id: 1,
  photo: "https://tcp.hp.gov.in/Application/uploadDocuments/employee/Emp20220215_120357.jpg",
  name: "Sh. Devesh kumar, IAS, IAS",
  designation: "Principal Secretary ,TCP",
  PhoneNo: "",
  MobNo: "",
  Email: "N/A"
}, {
  id: 2,
  photo: "https://tcp.hp.gov.in/img/noPhptoPassport.jpg",
  name: "Sh. Madan Negi",
  designation: "Section Officer ,TCP",
  PhoneNo: "0177-2880435",
  MobNo: "8988054386",
  Email: "N/A"
}, {
  id: 3,
  photo: "https://tcp.hp.gov.in/Application/uploadDocuments/employee/Emp20201027_113328.jpg",
  name: "Sh. Kamal Kant Saroch",
  designation: "Director, TCP Department",
  PhoneNo: "0177-2622494",
  MobNo: "",
  Email: "N/A"
}, {
  id: 4,
  photo: "https://tcp.hp.gov.in/img/noPhptoPassport.jpg",
  name: "State Town Planner",
  designation: "STP",
  PhoneNo: "N/A",
  MobNo: "N/A",
  Email: "N/A"
}, {
  id: 5,
  photo: "https://tcp.hp.gov.in/Application/uploadDocuments/employee/Emp20210129_115347.jpg",
  name: "Sh. Kamar Chand Nanta",
  designation: "TCP(HQ), Directorate",
  PhoneNo: "0177-2621450",
  MobNo: "9816600890",
  Email: "N/A"
}, {
  id: 6,
  photo: "https://tcp.hp.gov.in/Application/uploadDocuments/employee/Emp20210129_115322.jpg",
  name: "Ms. Soma Devi",
  designation: "ATP(HQ), Direcotrate",
  PhoneNo: "",
  MobNo: "",
  Email: "N/A"
}, {
  id: 7,
  photo: "https://tcp.hp.gov.in/Application/uploadDocuments/employee/Emp20210204_113131.jpg",
  name: "Ajay Kumar Sharma",
  designation: "Programmer(HQ), Directorate",
  PhoneNo: "",
  MobNo: "",
  Email: "N/A"
}, {
  id: 8,
  photo: "https://tcp.hp.gov.in/Application/uploadDocuments/employee/Emp20230427_130224.jpg",
  name: "Mr. Akshit Mehta, B.TECH in URBAN AND REGIONAL PLANNING",
  designation: "ASSTT. TOWN PLANNER, HQ",
  PhoneNo: "0177-2624762",
  MobNo: "9888333320",
  Email: "N/A"
}, {
  id: 9,
  photo: "https://tcp.hp.gov.in/img/noPhptoPassport.jpg",
  name: "Mr. Harender Sharma",
  designation: "P.O(HQ), Directorate",
  PhoneNo: "0177-2624762",
  MobNo: "",
  Email: "N/A"
}, {
  id: 10,
  photo: "https://tcp.hp.gov.in/img/noPhptoPassport.jpg",
  name: "Sh. Mayank Manta",
  designation: "Law Officer, Directorate",
  PhoneNo: "0177-2627619",
  MobNo: "9459040229",
  Email: "NA"
}, {
  id: 11,
  photo: "https://tcp.hp.gov.in/img/noPhptoPassport.jpg",
  name: "Sh. Jai Ram",
  designation: "Sutd.I, Directorate",
  PhoneNo: "0177-2624762",
  MobNo: "9418192290",
  Email: "N/A"
}, {
  id: 12,
  photo: "https://tcp.hp.gov.in/Application/uploadDocuments/employee/Emp20210129_115347.jpg",
  name: "Sh. Kamar Chand Nanta",
  designation: "TCP, Shimla, D.T.P Office Shimla",
  PhoneNo: "0177-2624762",
  MobNo: "9816600890",
  Email: "N/A"
}, {
  id: 13,
  photo: "https://tcp.hp.gov.in/img/noPhptoPassport.jpg",
  name: "ATP Shimla",
  designation: "A.T.P, D.T.P Office Shimla",
  PhoneNo: "01792-233507",
  MobNo: "",
  Email: "N/A"
}, {
  id: 14,
  photo: "https://tcp.hp.gov.in/Application/uploadDocuments/employee/Emp20210129_115627.jpg",
  name: "Mr. Chetan Sharma",
  designation: "P.O D.T.P Office Shimla",
  PhoneNo: "",
  MobNo: "9418088730",
  Email: "NA"
}, {
  id: 15,
  photo: "https://tcp.hp.gov.in/img/noPhptoPassport.jpg",
  name: "Mr. Jay Prakash",
  designation: "PQ HQ",
  PhoneNo: "",
  MobNo: "9418625202",
  Email: "N/A"
}, {
  id: 16,
  photo: "https://tcp.hp.gov.in/Application/uploadDocuments/employee/Emp20220504_164216.jpg",
  name: "Smt. Prem Lata Chauhan",
  designation: "TCP, D.T.P. Office, SOlan",
  PhoneNo: "01792-228485",
  MobNo: "9418589531",
  Email: "N/A"
}, {
  id: 17,
  photo: "https://tcp.hp.gov.in/img/noPhptoPassport.jpg",
  name: "Sh. Ramesh Bharadwaj",
  designation: "ATP, DTP. Office SOlan",
  PhoneNo: "01792-228486",
  MobNo: "9418075289",
  Email: "N/A"
}, {
  id: 18,
  photo: "https://tcp.hp.gov.in/img/noPhptoPassport.jpg",
  name: "Sh. Rajesh Kumar",
  designation: "P.O TCP Office Shimla",
  PhoneNo: "",
  MobNo: "9418479019",
  Email: "NA"
}, {
  id: 19,
  photo: "https://tcp.hp.gov.in/Application/uploadDocuments/employee/Emp20210129_120543.jpg",
  name: "MR. Raj Mohan Singh",
  designation: "P.O D.T.P Office Solan",
  PhoneNo: "",
  MobNo: "",
  Email: "NA"
}, {
  id: 20,
  photo: "https://tcp.hp.gov.in/Application/uploadDocuments/employee/Emp20210129_115627.jpg",
  name: "Akshay Kumar Sharma",
  designation: "A.T.P , S.D.T.P Office, Kasauli",
  PhoneNo: "",
  MobNo: "8219267407",
  Email: "N/A"
}, {
  id: 20,
  photo: "https://tcp.hp.gov.in/Application/uploadDocuments/employee/Emp20220504_164216.jpg",
  name: "Smt. Prem Lata Chauhan",
  designation: "TCP, D.T.P. Office, SOlan",
  PhoneNo: "01792-228485",
  MobNo: "9418589531",
  Email: "N/A"
}, {
  id: 21,
  photo: "https://tcp.hp.gov.in/img/noPhptoPassport.jpg",
  name: "Sh. Nirdosh Kumar",
  designation: "P.O.S.D.T.P Office, Parwanoo",
  PhoneNo: "01792-233507",
  MobNo: "8679166401",
  Email: "N/A"
}];
const columns$1 = [{
  id: "photo",
  label: "Photo",
  width: "15%"
}, {
  id: "name",
  label: "Name & Designation",
  width: "50%"
}, {
  id: "contact",
  label: "Contact Information",
  width: "25%"
}];
const rowsPerPage$1 = 10;
const ExEmployeeProfile = () => {
  const [page, setPage] = useState(0);
  const handleChangePage = (_, newPage) => {
    setPage(newPage);
  };
  return /*#__PURE__*/React__default.createElement(TableContainer, {
    component: Paper
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "h6",
    style: {
      margin: "20px"
    }
  }, "Ex-Employee Profile"), /*#__PURE__*/React__default.createElement(Table, {
    style: {
      width: "90%",
      margin: "30px"
    }
  }, /*#__PURE__*/React__default.createElement(TableHead, null, /*#__PURE__*/React__default.createElement(TableRow, {
    style: {
      background: "#1F4A7C",
      height: "20px"
    }
  }, columns$1.map(column => /*#__PURE__*/React__default.createElement(TableCell, {
    key: column.id,
    style: {
      color: "white",
      width: column.width
    }
  }, column.label)))), /*#__PURE__*/React__default.createElement(TableBody, null, records$1.slice(page * rowsPerPage$1, page * rowsPerPage$1 + rowsPerPage$1).map(record => /*#__PURE__*/React__default.createElement(TableRow, {
    key: record.id
  }, /*#__PURE__*/React__default.createElement(TableCell, null, /*#__PURE__*/React__default.createElement("img", {
    src: record.photo,
    alt: record.name,
    width: "80",
    height: "80"
  })), /*#__PURE__*/React__default.createElement(TableCell, null, /*#__PURE__*/React__default.createElement("div", null, record.name), /*#__PURE__*/React__default.createElement("div", null, record.designation)), /*#__PURE__*/React__default.createElement(TableCell, null, /*#__PURE__*/React__default.createElement("div", null, "Phone No: ", record.PhoneNo), /*#__PURE__*/React__default.createElement("div", null, "Mobile No: ", record.MobNo), /*#__PURE__*/React__default.createElement("div", null, "Email: ", record.Email)))))), /*#__PURE__*/React__default.createElement(TablePagination, {
    rowsPerPageOptions: [],
    component: "div",
    count: records$1.length,
    rowsPerPage: rowsPerPage$1,
    page: page,
    onPageChange: handleChangePage
  }));
};

const rows$2 = [{
  slNo: 1,
  description: "Minimum width of pedestrian links to smaller cluster of plots, not exceeding 5 in number.",
  pdfUrl: "3.00 M."
}, {
  slNo: 2,
  description: "Minimum width of vehicular access, if number of plots is above 5.",
  pdfUrl: " 5.00 M (with cul-de-sac) at the end."
}, {
  slNo: 3,
  description: "Minimum area for open/green space for the scheme having more than 5 plots.",
  pdfUrl: "10%"
}, {
  slNo: 4,
  description: "Minimum area for soak pit etc. (irrespective of number of plots)",
  pdfUrl: "5% of the scheme area"
}, {
  slNo: 5,
  description: "Orientation of the plots shall be provided in such a manner so as to be in conformity with the integration of existing plots/infrastructure, wind direction, natural flow of surface drainage to allow un-obstructed rain water discharge.",
  pdfUrl: "---"
}, {
  slNo: 6,
  description: "Layout of plots shall be governed by easy access having acceptable grades minimum 1in 15 and which may not obstruct view or vista.",
  pdfUrl: "---"
}];
function GeneralRegulation() {
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      margin: '20px'
    }
  }, /*#__PURE__*/React__default.createElement("p", null, /*#__PURE__*/React__default.createElement("strong", null, "General Regulation")), /*#__PURE__*/React__default.createElement("p", null, "The following provoisions shall be applicable where no specific mention is made namely"), /*#__PURE__*/React__default.createElement("ol", null, /*#__PURE__*/React__default.createElement("li", null, "Every plot should abut with path having 3.00 Meter width. In case the width is on lesser side, the applicant has to surrender land to make it 3.00 Metre wide."), /*#__PURE__*/React__default.createElement("li", null, "The height of a building shall further be related to the width of abutting path:")), /*#__PURE__*/React__default.createElement("p", null, "For path less than 3.0M and non-vehicular\xA0\xA0\xA0 :-\xA0 10 Metres"), /*#__PURE__*/React__default.createElement("p", null, "For path less than 3.0M but vehicular\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0 :-\xA0 13 Metres"), /*#__PURE__*/React__default.createElement("p", null, "For path between 3.0M to 5.00M\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0 :-\xA0 13 Metres"), /*#__PURE__*/React__default.createElement("p", null, "\xA0\xA0\xA0\xA0\xA0 3. Maximum acceptable slope for development shall be 45 degrees."), /*#__PURE__*/React__default.createElement("p", null, "\xA0\xA0\xA0\xA0 4.\xA0 Maximum height of plinth level shall be 2.00 Meters."), /*#__PURE__*/React__default.createElement("p", null, "\xA0\xA0\xA0\xA0 5.One parking floor shall be mandatory wherever feasible. Maximum height of parking floor shall be 3.00 Metres for residential use and 4.00 Metres for other uses. Shear walls shall be constructed on all the"), /*#__PURE__*/React__default.createElement("p", null, "\xA0\xA0\xA0\xA0 5.One parking floor shall be mandatory wherever feasible. Maximum height of parking floor shall be 3.00 Metres for residential use and 4.00 Metres for other uses. Shear walls shall be constructed on all the"), /*#__PURE__*/React__default.createElement("p", null, "\xA0\xA0\xA0\xA0\xA0\xA0\xA0 three sides\xA0\xA0 of parking floor, so that it does not behave as a soft storey."), /*#__PURE__*/React__default.createElement("p", null, "\xA0\xA0\xA0\xA0 6.In case, space as per requirement for parking is available in open, over and above the set backs, condition of parking floor shall not be insisted. The closed floors in a building at any level, if proposed and"), /*#__PURE__*/React__default.createElement("p", null, "\xA0\xA0\xA0\xA0\xA0\xA0\xA0 feasible for parking may be converted into parking floors. However, only one parking floor shall be exempt from Floor Area Ratio (FAR), subject to the height of building restriction and structural stability."), /*#__PURE__*/React__default.createElement("p", null, "Though, one parking floor is mandatory yet second parking floor can be constructed which will be optional. Here too only one parking floor shall be exempt from Floor Area Ratio (FAR), subject to the height of building restriction and structural stability."), /*#__PURE__*/React__default.createElement("p", null, "\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0 Fee for parking floor(s) shall have to be payable in all cases."), /*#__PURE__*/React__default.createElement("p", null, "\xA0\xA0\xA0\xA0\xA0 7. Every room used or intended to be used for the purpose of an office or for habitation in any building shall have a height of minimum 2.75Meters and maximum 3.50 Meters measured from the surface of floor to\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0 lowest point of the\xA0 ceiling (bottom of slab). The chimneys, elevators, poles, tanks and other projections not used for human occupancy may extend above the prescribed height limits. The cornices and window sills may also project into any required Set Backs."), /*#__PURE__*/React__default.createElement("p", null, "\xA0\xA0\xA0\xA0\xA0 8. Sloping roof shall be mandatory in hill areas (As per the URDPFI Guidelines, 2014 and National Building Code, 2005 hilly areas is any area above 600 m in height from mean sea level, or any area with average slope of 30\xB0)which may be CGI, GI sheet or slate roof with facia."), /*#__PURE__*/React__default.createElement("ol", null, /*#__PURE__*/React__default.createElement("li", null, "The roof shall be painted with post office red or forest green or natural roofing material such as slates. Height of sloping roof zero at eaves and maximum ", /*#__PURE__*/React__default.createElement("strong", null, "2.75"), " Metres at centre shall be permissible. The Dormer at suitable distance on either side of the roof shall be permissible subject to the condition that the ridge of Dormer shall be below the ridge line of main roof."), /*#__PURE__*/React__default.createElement("li", null, "Roof top @ 12 M", /*#__PURE__*/React__default.createElement("sup", null, "2 "), "per 1 Kilo Watt peak (KWp) shall be used for Solar Photovoltaic (PV) installations.")), /*#__PURE__*/React__default.createElement("p", null, "\xA0\xA0\xA0\xA0\xA0 9. Set Backs:-"), /*#__PURE__*/React__default.createElement("ol", null, /*#__PURE__*/React__default.createElement("li", null, "Minimum front Set Backs from the line of controlled width of Highways and Uttar Pradesh Public Works Department\u2019s scheduled roads falling within the Planning Area /Special Area limits (excluding the land, included in the inhabited sites of a village as entered and demarcated in the Revenue record or on sites in notified Municipal or town area that are already built up) shall be 3.00Metres."), /*#__PURE__*/React__default.createElement("li", null, "Minimum front Set Back from non-scheduled roads and Municipal roads shall be 3.00 Metres."), /*#__PURE__*/React__default.createElement("li", null, "Every building should have a clear means of access there to from a street or road. The competent authority may require the provisions of an access lane or access road within the site of any new building. Where for the purpose of this Regulation, it is necessary to determine the width of any road or street, the same shall be determined by the competent authority.")), /*#__PURE__*/React__default.createElement("p", null, "\xA0\xA0\xA0\xA0\xA0\xA0 10. For the plots abutting Highways, Bye-pass and Uttar Pradesh Public Works Department\u2019s scheduled roads, No Objection Certificate (NOC) from the Uttar Pradesh Public Works Department shall be mandatory in the cases where plot is directly abutting to these roads and there is direct access through connecting bridge and by constructing ramps to such roads."), /*#__PURE__*/React__default.createElement("p", null, "11.\xA0 Maximum hill cut of 3.50 Metre height shall be permissible. No building shall be built to abut against an earth cutting\xA0\xA0 including a toe wall supporting an earth cutting and minimum 1.00 Metre distance shall be maintained between building and toe wall etc."), /*#__PURE__*/React__default.createElement("p", null, "12. Issuance of No Objection Certificate (NOC) for water supply and electricity and sewerage connection:-"), /*#__PURE__*/React__default.createElement("table", {
    border: "1",
    cellpadding: "0",
    cellspacing: "0"
  }, /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("ol", null, /*#__PURE__*/React__default.createElement("li", null, "\xA0"))), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("p", null, "\xA0Temporary")), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("p", null, "At plinth level"))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("ol", null, /*#__PURE__*/React__default.createElement("li", null, "\xA0"))), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("p", null, "\xA0Permanent")), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("p", null, "On completion of dwelling unit /floor /whole building."))))), /*#__PURE__*/React__default.createElement("p", null, "\xA0\xA0\xA0\xA0\xA0\xA0 13.\xA0 Any subsequent deviations made in the building constructed after getting the plan approved and after grant of No Objection Certificate (NOC) issued by the Department shall entail the entire building unauthorized and NOC so issued shall be withdrawn and the services shall be disconnected."), /*#__PURE__*/React__default.createElement("p", null, "\xA0\xA0\xA0\xA0\xA0\xA0 14. Adequate distance from the electric lines as per the requirement of Uttar Pradesh State Electricity Board Limited (HPSEB Ltd.) Rules shall have to be maintained. The No Objection Certificate (NOC) of the competent authority shall also be required, if HT/LT line is crossing through the site."), /*#__PURE__*/React__default.createElement("p", null, "\xA0\xA0\xA0\xA0\xA0\xA0 15. Minimum permissible distance between two Blocks constructed on a plot shall be 5.00 Metres."), /*#__PURE__*/React__default.createElement("p", null, "\xA0\xA0\xA0\xA0\xA0\xA0 16. The construction shall be allowed at distance of 3.00 Metre and 5.00 Metre from Nullah and Khud respectively."), /*#__PURE__*/React__default.createElement("p", null, "\xA0\xA0\xA0\xA0\xA0\xA0 17. No residential building shall be permissible on land having buildable width less than 5.00 Metres after leaving Set Backs."), /*#__PURE__*/React__default.createElement("p", null, "\xA0\xA0\xA0\xA0\xA0\xA0 18. No construction shall be allowed within a radius of 2.00 Metre from the existing tree and 5.00 Metres from the Forest boundary measured from the circumference of an existing tree."), /*#__PURE__*/React__default.createElement("p", null, "\xA0\xA0\xA0\xA0\xA0\xA0 19. Construction on sandwiched plots in Bazaar area shall be permissible for shops as per existing building lines, only in existing built up areas."), /*#__PURE__*/React__default.createElement("p", null, "\xA0\xA0\xA0\xA0\xA0\xA0 20. In new sub-division of land :-"), /*#__PURE__*/React__default.createElement(TableContainer$2, {
    component: Paper$2
  }, /*#__PURE__*/React__default.createElement(Table$5, {
    "aria-label": "Sample Table",
    style: {
      width: '90%',
      margin: '30px'
    }
  }, /*#__PURE__*/React__default.createElement(TableBody$2, null, rows$2.map(row => /*#__PURE__*/React__default.createElement(TableRow$2, {
    key: row.slNo
  }, /*#__PURE__*/React__default.createElement(TableCell$2, {
    component: "th",
    scope: "row"
  }, row.slNo), /*#__PURE__*/React__default.createElement(TableCell$2, null, row.description), /*#__PURE__*/React__default.createElement(TableCell$2, null, row.pdfUrl)))))), /*#__PURE__*/React__default.createElement("p", null, "\xA0\xA0 21. Permissible Area Standard/Norms for different parts of a Building shall be as under:-"), /*#__PURE__*/React__default.createElement(TableContainer$2, {
    component: Paper$2
  }, /*#__PURE__*/React__default.createElement(Table$5, {
    "aria-label": "Sample Table",
    style: {
      width: '90%',
      margin: '30px'
    }
  }, /*#__PURE__*/React__default.createElement(TableBody$2, null, /*#__PURE__*/React__default.createElement(TableRow$2, null, /*#__PURE__*/React__default.createElement(TableCell$2, {
    component: "th",
    scope: "row"
  }, "Habitable Room"), /*#__PURE__*/React__default.createElement(TableCell$2, null, /*#__PURE__*/React__default.createElement("p", null, "Minimum floor area"), /*#__PURE__*/React__default.createElement("p", null, "Minimum width")), /*#__PURE__*/React__default.createElement(TableCell$2, null, /*#__PURE__*/React__default.createElement("p", null, "9.50 M^2"), /*#__PURE__*/React__default.createElement("p", null, "2.40 M"))), /*#__PURE__*/React__default.createElement(TableRow$2, null, /*#__PURE__*/React__default.createElement(TableCell$2, {
    component: "th",
    scope: "row"
  }, "Kitchen"), /*#__PURE__*/React__default.createElement(TableCell$2, null, /*#__PURE__*/React__default.createElement("p", null, "Minimum floor area"), /*#__PURE__*/React__default.createElement("p", null, "Minimum width")), /*#__PURE__*/React__default.createElement(TableCell$2, null, /*#__PURE__*/React__default.createElement("p", null, "4.50 M^2"), /*#__PURE__*/React__default.createElement("p", null, "1.80 M"))), /*#__PURE__*/React__default.createElement(TableRow$2, null, /*#__PURE__*/React__default.createElement(TableCell$2, {
    component: "th",
    scope: "row"
  }, "Bath Room"), /*#__PURE__*/React__default.createElement(TableCell$2, null, /*#__PURE__*/React__default.createElement("p", null, "Minimum floor area"), /*#__PURE__*/React__default.createElement("p", null, "Minimum width")), /*#__PURE__*/React__default.createElement(TableCell$2, null, /*#__PURE__*/React__default.createElement("p", null, "1.80 M^2"), /*#__PURE__*/React__default.createElement("p", null, "1.20 M"))), /*#__PURE__*/React__default.createElement(TableRow$2, null, /*#__PURE__*/React__default.createElement(TableCell$2, {
    component: "th",
    scope: "row"
  }, "Water Closet"), /*#__PURE__*/React__default.createElement(TableCell$2, null, /*#__PURE__*/React__default.createElement("p", null, "Minimum floor area"), /*#__PURE__*/React__default.createElement("p", null, "Minimum width")), /*#__PURE__*/React__default.createElement(TableCell$2, null, /*#__PURE__*/React__default.createElement("p", null, "1.10 M^2"), /*#__PURE__*/React__default.createElement("p", null, ".90 M"))), /*#__PURE__*/React__default.createElement(TableRow$2, null, /*#__PURE__*/React__default.createElement(TableCell$2, {
    component: "th",
    scope: "row"
  }, /*#__PURE__*/React__default.createElement("p", null, "Toilet"), /*#__PURE__*/React__default.createElement("p", null, "(WC+Bath)")), /*#__PURE__*/React__default.createElement(TableCell$2, null, /*#__PURE__*/React__default.createElement("p", null, "Minimum floor area"), /*#__PURE__*/React__default.createElement("p", null, "Minimum width")), /*#__PURE__*/React__default.createElement(TableCell$2, null, /*#__PURE__*/React__default.createElement("p", null, "2.30 M^2"), /*#__PURE__*/React__default.createElement("p", null, "1.20 M"))), /*#__PURE__*/React__default.createElement(TableRow$2, null, /*#__PURE__*/React__default.createElement(TableCell$2, {
    component: "th",
    scope: "row"
  }, "Minimum width of corridor"), /*#__PURE__*/React__default.createElement(TableCell$2, null, /*#__PURE__*/React__default.createElement("p", null, "For Resedential Use"), /*#__PURE__*/React__default.createElement("p", null, "For Other Use")), /*#__PURE__*/React__default.createElement(TableCell$2, null, /*#__PURE__*/React__default.createElement("p", null, "1.00 M"), /*#__PURE__*/React__default.createElement("p", null, "1.20 M"))), /*#__PURE__*/React__default.createElement(TableRow$2, null, /*#__PURE__*/React__default.createElement(TableCell$2, {
    component: "th",
    scope: "row"
  }, "Minimum width of stairs"), /*#__PURE__*/React__default.createElement(TableCell$2, null, /*#__PURE__*/React__default.createElement("p", null, "For Resedential Use"), /*#__PURE__*/React__default.createElement("p", null, "For Other Use")), /*#__PURE__*/React__default.createElement(TableCell$2, null, /*#__PURE__*/React__default.createElement("p", null, "1.00 M"), /*#__PURE__*/React__default.createElement("p", null, "1.50 M"))), /*#__PURE__*/React__default.createElement(TableRow$2, null, /*#__PURE__*/React__default.createElement(TableCell$2, {
    component: "th",
    scope: "row"
  }, "Minimum width of treads without nosing"), /*#__PURE__*/React__default.createElement(TableCell$2, null, /*#__PURE__*/React__default.createElement("p", null, "For Resedential Use"), /*#__PURE__*/React__default.createElement("p", null, "For Other Use")), /*#__PURE__*/React__default.createElement(TableCell$2, null, /*#__PURE__*/React__default.createElement("p", null, "25 Centimeter wide for internal stairs"), /*#__PURE__*/React__default.createElement("p", null, "30 Centimeter wide for internal stairs case "))), /*#__PURE__*/React__default.createElement(TableRow$2, null, /*#__PURE__*/React__default.createElement(TableCell$2, {
    component: "th",
    scope: "row"
  }, "Maximum height of riser"), /*#__PURE__*/React__default.createElement(TableCell$2, null, /*#__PURE__*/React__default.createElement("p", null, "For Resedential Use"), /*#__PURE__*/React__default.createElement("p", null, "For Other Use")), /*#__PURE__*/React__default.createElement(TableCell$2, null, /*#__PURE__*/React__default.createElement("p", null, "19 Centimeter"), /*#__PURE__*/React__default.createElement("p", null, "15 Centimeter"))), /*#__PURE__*/React__default.createElement(TableRow$2, null, /*#__PURE__*/React__default.createElement(TableCell$2, {
    component: "th",
    scope: "row"
  }, "Provison of spiral stair case"), /*#__PURE__*/React__default.createElement(TableCell$2, null, "For Other uses except Resedential use"), /*#__PURE__*/React__default.createElement(TableCell$2, null, "Provision of spiral stair case not less than 1.50 Metre dia with adequate head height for fire escape in addition to regular stair case")), /*#__PURE__*/React__default.createElement(TableRow$2, null, /*#__PURE__*/React__default.createElement(TableCell$2, {
    component: "th",
    scope: "row"
  }, "Openings"), /*#__PURE__*/React__default.createElement(TableCell$2, null, "For sufficient air and light, windows and ventilators should have minimum area equivalent to 1/6th Floor Area"), /*#__PURE__*/React__default.createElement(TableCell$2, {
    component: "th",
    scope: "row"
  }, "---")), /*#__PURE__*/React__default.createElement(TableRow$2, null, /*#__PURE__*/React__default.createElement(TableCell$2, {
    component: "th",
    scope: "row"
  }, "Projections over doors, windows and ventilators."), /*#__PURE__*/React__default.createElement(TableCell$2, null, ".60 M"), /*#__PURE__*/React__default.createElement(TableCell$2, null, "---")), /*#__PURE__*/React__default.createElement(TableRow$2, null, /*#__PURE__*/React__default.createElement(TableCell$2, {
    component: "th",
    scope: "row"
  }, "Balcony Projections"), /*#__PURE__*/React__default.createElement(TableCell$2, null, "1.20 M wide Balcony complete open on two sides with restriction of 50 % of building frontage where minimum front Set Back is 3.00 M shall be permissible."), /*#__PURE__*/React__default.createElement(TableCell$2, {
    component: "th",
    scope: "row"
  }, "---"))))), /*#__PURE__*/React__default.createElement("p", null, "\xA0\xA0\xA0\xA0\xA0 22. The habitable basement and attic shall be counted as independent storey."), /*#__PURE__*/React__default.createElement("p", null, "\xA0\xA0\xA0\xA0\xA0 23. The Apartments and Colonies shall be dealt with as per Regulations contained in Appendix-7", /*#__PURE__*/React__default.createElement("strong", null, "."), " The powers for Registration of Promoters / Estate Agents and powers for issuance of Licences shall vest with the Director (TCP) only and none other authorities."), /*#__PURE__*/React__default.createElement("p", null, "\xA0\xA0\xA0\xA0\xA0 24. Though minimum area of plot has been defined in Regulation II, yet the plots allotted by the Central or State Government under various Social Housing Schemes including Gandhi Kutir Yojana, Indira Awas Yojana, Rajiv Awas Yojana, Affordable Housing Schemes, launched by the Central or State Government, may be considered and permission accorded in relaxation of Regulations. However, the minimum area of plot for the persons belonging to the Economically Weaker Sections and Low Income Groups of society should not be less than 45 M", /*#__PURE__*/React__default.createElement("sup", null, "2 "), "and 80 M", /*#__PURE__*/React__default.createElement("sup", null, "2 "), "respectively."), /*#__PURE__*/React__default.createElement("p", null, "\xA0\xA0\xA0\xA0\xA0 25. Service floor wherever proposed for installation of plumbing and other services and to maintain the hygiene of habitable area in case of Commercial/ Shopping Complex and Tourism Unit. Service floor, wherever proposed shall have height restriction of 2.10 Metres and this floor shall not be counted in the FAR. However, the overall height restriction of building will remain the same."), /*#__PURE__*/React__default.createElement("p", null, "\xA0\xA0\xA0\xA0\xA0 26. Re-construction of existing buildings:-"), /*#__PURE__*/React__default.createElement("p", null, "Regulations regarding re-construction of houses/ buildings in the existence shall be on predominantly existing building lines, provided minimum width of roadas per Rules is available and roof projections, sun shades shall be permitted over streets or paths, as the case may be."), /*#__PURE__*/React__default.createElement("p", null, "\xA0\xA0\xA0\xA0\xA0 26. Re-construction of existing buildings:-"), /*#__PURE__*/React__default.createElement("p", null, "Regulations regarding re-construction of houses/ buildings in the existence shall be on predominantly existing building lines, provided minimum width of roadas per Rules is available and roof projections, sun shades shall be permitted over streets or paths, as the case may be."), /*#__PURE__*/React__default.createElement("p", null, "\xA0\xA0\xA0\xA0\xA0 27. Change of Land Use:-"), /*#__PURE__*/React__default.createElement("p", null, "Change of existing land use for Residential", /*#__PURE__*/React__default.createElement("strong", null, ","), " Commercial, Public and semi-public and Industrial, shall be on existing pattern of development and site conditions subject to the conditions that where basic services like paved roads, drainage, water supply, sewerage disposal, electrical supply line, street lighting etc. do not exist, change of land use or development of land shall not be permitted unless the applicant undertakes that these services shall be provided at his own cost."), /*#__PURE__*/React__default.createElement("p", null, "\xA0\xA0\xA0\xA0\xA0 28. Relaxation in set backs, height of floors and building may be allowed in case of Government projects in the public interest. However, in case of private construction, relaxation in set backs and height of floors only may be considered by the Competent Authority keeping in view of site condition."), /*#__PURE__*/React__default.createElement("p", null, "\xA0\xA0\xA0\xA0\xA0\xA0 29. In case of any clarification with reference to any proviso or if there is no any specific provision, the provisions as envisaged in the Urban and Regional Development Plans Formulation and\xA0 Implementation Guidelines, 2014 of the Government of India or the National Building Code of India,2005shall have to be adhered to."), /*#__PURE__*/React__default.createElement("p", null, "\xA0\xA0\xA0\xA0\xA0\xA0 30. Firefighting provisions and specification shall be as per National Building Code of India, 2005", /*#__PURE__*/React__default.createElement("strong", null, "."))));
}

function IndustrialUse() {
  return /*#__PURE__*/React__default.createElement(TableContainer, {
    component: Paper,
    style: {
      margin: '20px'
    }
  }, /*#__PURE__*/React__default.createElement(Table, {
    sx: {
      minWidth: 700
    },
    "aria-label": "industry table"
  }, /*#__PURE__*/React__default.createElement(TableHead, null, /*#__PURE__*/React__default.createElement(TableRow, {
    style: {
      background: '#1F4A7C',
      height: '20px'
    }
  }, /*#__PURE__*/React__default.createElement(TableCell, {
    style: {
      color: 'white'
    },
    rowspan: 2
  }, /*#__PURE__*/React__default.createElement("strong", null, "Sr. No.")), /*#__PURE__*/React__default.createElement(TableCell, {
    style: {
      color: 'white'
    },
    rowspan: 2
  }, /*#__PURE__*/React__default.createElement("strong", null, "Type of Industry and Minimum Plot Area")), /*#__PURE__*/React__default.createElement(TableCell, {
    style: {
      color: 'white'
    },
    colspan: 4
  }, /*#__PURE__*/React__default.createElement("strong", null, "Minimum Set Back in Metres")), /*#__PURE__*/React__default.createElement(TableCell, {
    style: {
      color: 'white'
    },
    rowspan: 2
  }, /*#__PURE__*/React__default.createElement("strong", null, "Maximum FAR")), /*#__PURE__*/React__default.createElement(TableCell, {
    style: {
      color: 'white'
    },
    rowspan: 2
  }, /*#__PURE__*/React__default.createElement("strong", null, "Maximum Height in Metres from Mean Sea Level upto 1000M")), /*#__PURE__*/React__default.createElement(TableCell, {
    style: {
      color: 'white'
    },
    rowspan: 2
  }, /*#__PURE__*/React__default.createElement("strong", null, "Maximum Height in Metres from Mean Sea Level above 1000M"))), /*#__PURE__*/React__default.createElement(TableRow, {
    style: {
      background: '#1F4A7C',
      height: '20px'
    }
  }, /*#__PURE__*/React__default.createElement(TableCell, {
    style: {
      color: 'white'
    }
  }, /*#__PURE__*/React__default.createElement("strong", null, "Front")), /*#__PURE__*/React__default.createElement(TableCell, {
    style: {
      color: 'white'
    }
  }, /*#__PURE__*/React__default.createElement("strong", null, "Left")), /*#__PURE__*/React__default.createElement(TableCell, {
    style: {
      color: 'white'
    }
  }, /*#__PURE__*/React__default.createElement("strong", null, "Right")), /*#__PURE__*/React__default.createElement(TableCell, {
    style: {
      color: 'white'
    }
  }, /*#__PURE__*/React__default.createElement("strong", null, "Rear")))), /*#__PURE__*/React__default.createElement(TableBody, null, /*#__PURE__*/React__default.createElement(TableRow, null, /*#__PURE__*/React__default.createElement(TableCell, null, "1."), /*#__PURE__*/React__default.createElement(TableCell, null, "Small Scale Industries 250 M", /*#__PURE__*/React__default.createElement("sup", null, "2"), " to 500 M", /*#__PURE__*/React__default.createElement("sup", null, "2")), /*#__PURE__*/React__default.createElement(TableCell, null, "3.00"), /*#__PURE__*/React__default.createElement(TableCell, null, "2.00"), /*#__PURE__*/React__default.createElement(TableCell, null, "2.00"), /*#__PURE__*/React__default.createElement(TableCell, null, "2.00"), /*#__PURE__*/React__default.createElement(TableCell, null, "1.75"), /*#__PURE__*/React__default.createElement(TableCell, null, "15.00"), /*#__PURE__*/React__default.createElement(TableCell, null, "12.00")), /*#__PURE__*/React__default.createElement(TableRow, null, /*#__PURE__*/React__default.createElement(TableCell, null, "2."), /*#__PURE__*/React__default.createElement(TableCell, null, "Service/Light scale Industries Above 500 M", /*#__PURE__*/React__default.createElement("sup", null, "2"), " to 1000 M", /*#__PURE__*/React__default.createElement("sup", null, "2")), /*#__PURE__*/React__default.createElement(TableCell, null, "5.00"), /*#__PURE__*/React__default.createElement(TableCell, null, "2.00"), /*#__PURE__*/React__default.createElement(TableCell, null, "2.00"), /*#__PURE__*/React__default.createElement(TableCell, null, "3.00"), /*#__PURE__*/React__default.createElement(TableCell, null, "1.50"), /*#__PURE__*/React__default.createElement(TableCell, null, "15.00"), /*#__PURE__*/React__default.createElement(TableCell, null, "12.00")), /*#__PURE__*/React__default.createElement(TableRow, null, /*#__PURE__*/React__default.createElement(TableCell, null, "3."), /*#__PURE__*/React__default.createElement(TableCell, null, "Medium scale Industries Above 1000 M", /*#__PURE__*/React__default.createElement("sup", null, "2"), " to 5000 M", /*#__PURE__*/React__default.createElement("sup", null, "2")), /*#__PURE__*/React__default.createElement(TableCell, null, "10.00"), /*#__PURE__*/React__default.createElement(TableCell, null, "5.00"), /*#__PURE__*/React__default.createElement(TableCell, null, "5.00"), /*#__PURE__*/React__default.createElement(TableCell, null, "5.00"), /*#__PURE__*/React__default.createElement(TableCell, null, "1.25"), /*#__PURE__*/React__default.createElement(TableCell, null, "20.00"), /*#__PURE__*/React__default.createElement(TableCell, null, "15.00")), /*#__PURE__*/React__default.createElement(TableRow, null, /*#__PURE__*/React__default.createElement(TableCell, null, "4."), /*#__PURE__*/React__default.createElement(TableCell, null, "Large and Heavy Scale Industries Above 5000 M", /*#__PURE__*/React__default.createElement("sup", null, "2")), /*#__PURE__*/React__default.createElement(TableCell, null, "15.00"), /*#__PURE__*/React__default.createElement(TableCell, null, "7.50"), /*#__PURE__*/React__default.createElement(TableCell, null, "7.50"), /*#__PURE__*/React__default.createElement(TableCell, null, "7.50"), /*#__PURE__*/React__default.createElement(TableCell, null, "1.00"), /*#__PURE__*/React__default.createElement(TableCell, null, "20.00"), /*#__PURE__*/React__default.createElement(TableCell, null, "15.00")))));
}

function OtherUse() {
  return /*#__PURE__*/React__default.createElement(TableContainer, {
    component: Paper,
    style: {
      margin: '20px'
    }
  }, /*#__PURE__*/React__default.createElement(Table, {
    sx: {
      minWidth: 700
    },
    "aria-label": "industry table"
  }, /*#__PURE__*/React__default.createElement(TableHead, null, /*#__PURE__*/React__default.createElement(TableRow, {
    style: {
      background: '#1F4A7C',
      height: '20px'
    }
  }, /*#__PURE__*/React__default.createElement(TableCell, {
    style: {
      color: 'white'
    },
    rowspan: 2
  }, /*#__PURE__*/React__default.createElement("strong", null, "Sr. No.")), /*#__PURE__*/React__default.createElement(TableCell, {
    style: {
      color: 'white'
    },
    rowspan: 2
  }, /*#__PURE__*/React__default.createElement("strong", null, "Description and Minimum Plot Area")), /*#__PURE__*/React__default.createElement(TableCell, {
    style: {
      color: 'white'
    },
    colspan: 4
  }, /*#__PURE__*/React__default.createElement("strong", null, "Minimum Set Back in Metres")), /*#__PURE__*/React__default.createElement(TableCell, {
    style: {
      color: 'white'
    },
    rowspan: 2
  }, /*#__PURE__*/React__default.createElement("strong", null, "Maximum Floor Area Ratio")), /*#__PURE__*/React__default.createElement(TableCell, {
    style: {
      color: 'white'
    },
    rowspan: 2
  }, /*#__PURE__*/React__default.createElement("strong", null, "Maximum Height in Metres"))), /*#__PURE__*/React__default.createElement(TableRow, {
    style: {
      background: '#1F4A7C',
      height: '20px'
    }
  }, /*#__PURE__*/React__default.createElement(TableCell, {
    style: {
      color: 'white'
    }
  }, /*#__PURE__*/React__default.createElement("strong", null, "Front")), /*#__PURE__*/React__default.createElement(TableCell, {
    style: {
      color: 'white'
    }
  }, /*#__PURE__*/React__default.createElement("strong", null, "Left")), /*#__PURE__*/React__default.createElement(TableCell, {
    style: {
      color: 'white'
    }
  }, /*#__PURE__*/React__default.createElement("strong", null, "Right")), /*#__PURE__*/React__default.createElement(TableCell, {
    style: {
      color: 'white'
    }
  }, /*#__PURE__*/React__default.createElement("strong", null, "Rear")))), /*#__PURE__*/React__default.createElement(TableBody, null, /*#__PURE__*/React__default.createElement(TableRow, null, /*#__PURE__*/React__default.createElement(TableCell, {
    colSpan: 9,
    style: {
      textAlign: 'center'
    }
  }, /*#__PURE__*/React__default.createElement("strong", null, "Resedential Use"))), /*#__PURE__*/React__default.createElement(TableRow, null, /*#__PURE__*/React__default.createElement(TableCell, null, "1."), /*#__PURE__*/React__default.createElement(TableCell, null, /*#__PURE__*/React__default.createElement("p", null, "Detached Houses"), /*#__PURE__*/React__default.createElement("p", null, "i. 150 M^2 to 250 M^2"), /*#__PURE__*/React__default.createElement("p", null, "ii. 150 M^2 to 250 M^2"), /*#__PURE__*/React__default.createElement("p", null, "iii. Above 500 M^2")), /*#__PURE__*/React__default.createElement(TableCell, null, /*#__PURE__*/React__default.createElement("p", null, "2.00"), /*#__PURE__*/React__default.createElement("p", null, "3.00"), /*#__PURE__*/React__default.createElement("p", null, "5.00")), /*#__PURE__*/React__default.createElement(TableCell, null, /*#__PURE__*/React__default.createElement("p", null, "1.50"), /*#__PURE__*/React__default.createElement("p", null, "2.00"), /*#__PURE__*/React__default.createElement("p", null, "3.00")), /*#__PURE__*/React__default.createElement(TableCell, null, /*#__PURE__*/React__default.createElement("p", null, "1.50"), /*#__PURE__*/React__default.createElement("p", null, "2.00"), /*#__PURE__*/React__default.createElement("p", null, "3.00")), /*#__PURE__*/React__default.createElement(TableCell, null, /*#__PURE__*/React__default.createElement("p", null, "1.50"), /*#__PURE__*/React__default.createElement("p", null, "2.00"), /*#__PURE__*/React__default.createElement("p", null, "2.00")), /*#__PURE__*/React__default.createElement(TableCell, null, /*#__PURE__*/React__default.createElement("p", null, "1.75"), /*#__PURE__*/React__default.createElement("p", null, "1.75"), /*#__PURE__*/React__default.createElement("p", null, "1.75")), /*#__PURE__*/React__default.createElement(TableCell, null, /*#__PURE__*/React__default.createElement("p", null, "21.00"), /*#__PURE__*/React__default.createElement("p", null, "21.00"), /*#__PURE__*/React__default.createElement("p", null, "21.00"))), /*#__PURE__*/React__default.createElement(TableRow, null, /*#__PURE__*/React__default.createElement(TableCell, null, "2."), /*#__PURE__*/React__default.createElement(TableCell, null, /*#__PURE__*/React__default.createElement("p", null, "Semi-detached Houses with common wall on one side"), /*#__PURE__*/React__default.createElement("p", null, "Upto 120 M^2"), /*#__PURE__*/React__default.createElement("p", null, "Above 120 M^2 to 250 M^2")), /*#__PURE__*/React__default.createElement(TableCell, null, /*#__PURE__*/React__default.createElement("p", null, "2.00"), /*#__PURE__*/React__default.createElement("p", null, "2.00")), /*#__PURE__*/React__default.createElement(TableCell, null, /*#__PURE__*/React__default.createElement("p", null, "1.50"), /*#__PURE__*/React__default.createElement("p", null, "1.75")), /*#__PURE__*/React__default.createElement(TableCell, null, /*#__PURE__*/React__default.createElement("p", null, "1.50"), /*#__PURE__*/React__default.createElement("p", null, "1.75")), /*#__PURE__*/React__default.createElement(TableCell, null, /*#__PURE__*/React__default.createElement("p", null, "1.50"), /*#__PURE__*/React__default.createElement("p", null, "1.75")), /*#__PURE__*/React__default.createElement(TableCell, null, /*#__PURE__*/React__default.createElement("p", null, "1.75"), /*#__PURE__*/React__default.createElement("p", null, "1.75")), /*#__PURE__*/React__default.createElement(TableCell, null, /*#__PURE__*/React__default.createElement("p", null, "21.00"), /*#__PURE__*/React__default.createElement("p", null, "21.00"))), /*#__PURE__*/React__default.createElement(TableRow, null, /*#__PURE__*/React__default.createElement(TableCell, null, "3."), /*#__PURE__*/React__default.createElement(TableCell, null, /*#__PURE__*/React__default.createElement("p", null, "Row Houses with common wall on two sides"), /*#__PURE__*/React__default.createElement("p", null, "90 M^2 to 120 M^2")), /*#__PURE__*/React__default.createElement(TableCell, null, "2.00"), /*#__PURE__*/React__default.createElement(TableCell, null, "Nil"), /*#__PURE__*/React__default.createElement(TableCell, null, "Nil"), /*#__PURE__*/React__default.createElement(TableCell, null, "1.50"), /*#__PURE__*/React__default.createElement(TableCell, null, "1.75"), /*#__PURE__*/React__default.createElement(TableCell, null, "18.00")), /*#__PURE__*/React__default.createElement(TableRow, null, /*#__PURE__*/React__default.createElement(TableCell, {
    colSpan: 9,
    style: {
      textAlign: 'center'
    }
  }, /*#__PURE__*/React__default.createElement("strong", null, "Commercial Use"))), /*#__PURE__*/React__default.createElement(TableRow, null, /*#__PURE__*/React__default.createElement(TableCell, null, "1."), /*#__PURE__*/React__default.createElement(TableCell, null, "Booths upto 10 M^2"), /*#__PURE__*/React__default.createElement(TableCell, null, "1.00"), /*#__PURE__*/React__default.createElement(TableCell, null, "Nil"), /*#__PURE__*/React__default.createElement(TableCell, null, "Nil"), /*#__PURE__*/React__default.createElement(TableCell, null, "Nil"), /*#__PURE__*/React__default.createElement(TableCell, null, "---"), /*#__PURE__*/React__default.createElement(TableCell, null, "4.00")), /*#__PURE__*/React__default.createElement(TableRow, null, /*#__PURE__*/React__default.createElement(TableCell, null, "2."), /*#__PURE__*/React__default.createElement(TableCell, null, /*#__PURE__*/React__default.createElement("p", null, "Shops"), /*#__PURE__*/React__default.createElement("p", null, "(i.) Independent Shop/ Showrooms (standalone) above 10 M", /*#__PURE__*/React__default.createElement("sup", null, "2"), " to 30 M", /*#__PURE__*/React__default.createElement("sup", null, "2")), /*#__PURE__*/React__default.createElement("p", null, "(ii)Row Shops with common wall on two sides above\xA0 30 M", /*#__PURE__*/React__default.createElement("sup", null, "2"), "to 100 M", /*#__PURE__*/React__default.createElement("sup", null, "2")), /*#__PURE__*/React__default.createElement("p", null, "(iii)Row Shops with common wall on two sides above\xA0 100 M", /*#__PURE__*/React__default.createElement("sup", null, "2"), "to 250 M", /*#__PURE__*/React__default.createElement("sup", null, "2")), /*#__PURE__*/React__default.createElement("p", null, "(iv) Above 250 M", /*#__PURE__*/React__default.createElement("sup", null, "2"), " to 500 M", /*#__PURE__*/React__default.createElement("sup", null, "2"))), /*#__PURE__*/React__default.createElement(TableCell, null, /*#__PURE__*/React__default.createElement("p", null, "2.00"), /*#__PURE__*/React__default.createElement("p", null, "2.00"), /*#__PURE__*/React__default.createElement("p", null, "2.00"), /*#__PURE__*/React__default.createElement("p", null, "3.00")), /*#__PURE__*/React__default.createElement(TableCell, null, /*#__PURE__*/React__default.createElement("p", null, "Nil"), /*#__PURE__*/React__default.createElement("p", null, "Nil"), /*#__PURE__*/React__default.createElement("p", null, "1.50"), /*#__PURE__*/React__default.createElement("p", null, "2.00")), /*#__PURE__*/React__default.createElement(TableCell, null, /*#__PURE__*/React__default.createElement("p", null, "Nil"), /*#__PURE__*/React__default.createElement("p", null, "Nil"), /*#__PURE__*/React__default.createElement("p", null, "1.50"), /*#__PURE__*/React__default.createElement("p", null, "2.00")), /*#__PURE__*/React__default.createElement(TableCell, null, /*#__PURE__*/React__default.createElement("p", null, "1.00"), /*#__PURE__*/React__default.createElement("p", null, "1.00"), /*#__PURE__*/React__default.createElement("p", null, "1,50"), /*#__PURE__*/React__default.createElement("p", null, "2.00")), /*#__PURE__*/React__default.createElement(TableCell, {
    style: {
      marginLeft: '30px'
    }
  }, /*#__PURE__*/React__default.createElement("p", null, "--"), /*#__PURE__*/React__default.createElement("p", null, "1.75"), /*#__PURE__*/React__default.createElement("p", null, "1.75"), /*#__PURE__*/React__default.createElement("p", null, "1.75")), /*#__PURE__*/React__default.createElement(TableCell, null, /*#__PURE__*/React__default.createElement("p", null, "6.00"), /*#__PURE__*/React__default.createElement("p", null, "9.00"), /*#__PURE__*/React__default.createElement("p", null, "21.00"), /*#__PURE__*/React__default.createElement("p", null, "21.00"))), /*#__PURE__*/React__default.createElement(TableRow, null, /*#__PURE__*/React__default.createElement(TableCell, null, "3."), /*#__PURE__*/React__default.createElement(TableCell, null, /*#__PURE__*/React__default.createElement("p", null, "Shopping Complex"), /*#__PURE__*/React__default.createElement("p", null, "(i.) 500 M", /*#__PURE__*/React__default.createElement("sup", null, "2"), " to 1500 M", /*#__PURE__*/React__default.createElement("sup", null, "2")), /*#__PURE__*/React__default.createElement("p", null, "(ii)Above\xA0 1500 M", /*#__PURE__*/React__default.createElement("sup", null, "2"), "to 4000 M", /*#__PURE__*/React__default.createElement("sup", null, "2")), /*#__PURE__*/React__default.createElement("p", null, "(iii)Above\xA0 4000 M", /*#__PURE__*/React__default.createElement("sup", null, "2"))), /*#__PURE__*/React__default.createElement(TableCell, null, /*#__PURE__*/React__default.createElement("p", null, "5.00"), /*#__PURE__*/React__default.createElement("p", null, "10.00"), /*#__PURE__*/React__default.createElement("p", null, "12.00")), /*#__PURE__*/React__default.createElement(TableCell, null, /*#__PURE__*/React__default.createElement("p", null, "3.00"), /*#__PURE__*/React__default.createElement("p", null, "5.00"), /*#__PURE__*/React__default.createElement("p", null, "7.50")), /*#__PURE__*/React__default.createElement(TableCell, null, /*#__PURE__*/React__default.createElement("p", null, "3.00"), /*#__PURE__*/React__default.createElement("p", null, "5.00"), /*#__PURE__*/React__default.createElement("p", null, "7.50")), /*#__PURE__*/React__default.createElement(TableCell, null, /*#__PURE__*/React__default.createElement("p", null, "3.00"), /*#__PURE__*/React__default.createElement("p", null, "5.00"), /*#__PURE__*/React__default.createElement("p", null, "6.00")), /*#__PURE__*/React__default.createElement(TableCell, null, /*#__PURE__*/React__default.createElement("p", null, "1.75"), /*#__PURE__*/React__default.createElement("p", null, "1.75"), /*#__PURE__*/React__default.createElement("p", null, "1.50")), /*#__PURE__*/React__default.createElement(TableCell, {
    style: {
      marginLeft: '30px'
    }
  }, /*#__PURE__*/React__default.createElement("p", null, "21.00"), /*#__PURE__*/React__default.createElement("p", null, "21.00"), /*#__PURE__*/React__default.createElement("p", null, "21.00"))), /*#__PURE__*/React__default.createElement(TableRow, null, /*#__PURE__*/React__default.createElement(TableCell, null), /*#__PURE__*/React__default.createElement(TableCell, {
    colSpan: 8
  }, /*#__PURE__*/React__default.createElement("p", null, "Parking"), /*#__PURE__*/React__default.createElement("p", null, /*#__PURE__*/React__default.createElement("p", null, "(i) 500 M", /*#__PURE__*/React__default.createElement("sup", null, "2"), " to 1500 M", /*#__PURE__*/React__default.createElement("sup", null, "2"), "\xA0\xA0 =\xA0 1.50 ECS per100 M", /*#__PURE__*/React__default.createElement("sup", null, "2"), " of built up area")), /*#__PURE__*/React__default.createElement("p", null, "(ii)1500 M", /*#__PURE__*/React__default.createElement("sup", null, "2"), " to 4000 M", /*#__PURE__*/React__default.createElement("sup", null, "2\xA0\xA0 "), "= 2.00 ECS per100 M", /*#__PURE__*/React__default.createElement("sup", null, "2"), " of built up area"), /*#__PURE__*/React__default.createElement("p", null, "(iii) Above 4000 M", /*#__PURE__*/React__default.createElement("sup", null, "2\xA0\xA0\xA0\xA0 "), "= 3.00ECS per100 M", /*#__PURE__*/React__default.createElement("sup", null, "2"), " of built up area"))), /*#__PURE__*/React__default.createElement(TableRow, null, /*#__PURE__*/React__default.createElement(TableCell, null, "4."), /*#__PURE__*/React__default.createElement(TableCell, null, /*#__PURE__*/React__default.createElement("p", null, "Tourism Unit"), /*#__PURE__*/React__default.createElement("p", null, "(i.) 250 M", /*#__PURE__*/React__default.createElement("sup", null, "2"), " to 500 M", /*#__PURE__*/React__default.createElement("sup", null, "2")), /*#__PURE__*/React__default.createElement("p", null, "(ii)Above\xA0 500 M", /*#__PURE__*/React__default.createElement("sup", null, "2"), "to 1500 M", /*#__PURE__*/React__default.createElement("sup", null, "2")), /*#__PURE__*/React__default.createElement("p", null, "(iii)Above\xA0 1500 M", /*#__PURE__*/React__default.createElement("sup", null, "2"))), /*#__PURE__*/React__default.createElement(TableCell, null, /*#__PURE__*/React__default.createElement("p", null, "3.00"), /*#__PURE__*/React__default.createElement("p", null, "5.00"), /*#__PURE__*/React__default.createElement("p", null, "7.00")), /*#__PURE__*/React__default.createElement(TableCell, null, /*#__PURE__*/React__default.createElement("p", null, "2.00"), /*#__PURE__*/React__default.createElement("p", null, "4.00"), /*#__PURE__*/React__default.createElement("p", null, "5.00")), /*#__PURE__*/React__default.createElement(TableCell, null, /*#__PURE__*/React__default.createElement("p", null, "2.00"), /*#__PURE__*/React__default.createElement("p", null, "4.00"), /*#__PURE__*/React__default.createElement("p", null, "5.00")), /*#__PURE__*/React__default.createElement(TableCell, null, /*#__PURE__*/React__default.createElement("p", null, "2.00"), /*#__PURE__*/React__default.createElement("p", null, "3.00"), /*#__PURE__*/React__default.createElement("p", null, "4.00")), /*#__PURE__*/React__default.createElement(TableCell, null, /*#__PURE__*/React__default.createElement("p", null, "1.75"), /*#__PURE__*/React__default.createElement("p", null, "1.50"), /*#__PURE__*/React__default.createElement("p", null, "1.50")), /*#__PURE__*/React__default.createElement(TableCell, {
    style: {
      marginLeft: '30px'
    }
  }, /*#__PURE__*/React__default.createElement("p", null, "21.00"), /*#__PURE__*/React__default.createElement("p", null, "21.00"), /*#__PURE__*/React__default.createElement("p", null, "21.00"))), /*#__PURE__*/React__default.createElement(TableRow, null, /*#__PURE__*/React__default.createElement(TableCell, null), /*#__PURE__*/React__default.createElement(TableCell, {
    colSpan: 8
  }, /*#__PURE__*/React__default.createElement("p", null, "Parking"), /*#__PURE__*/React__default.createElement("p", null, /*#__PURE__*/React__default.createElement("p", null, "(i) 250 M", /*#__PURE__*/React__default.createElement("sup", null, "2"), " to 500 M", /*#__PURE__*/React__default.createElement("sup", null, "2"), "\xA0\xA0 =\xA0 1.00 ECS per100 M", /*#__PURE__*/React__default.createElement("sup", null, "2"), " of built up area")), /*#__PURE__*/React__default.createElement("p", null, "Above (ii)500 M", /*#__PURE__*/React__default.createElement("sup", null, "2"), " to 1500 M", /*#__PURE__*/React__default.createElement("sup", null, "2\xA0\xA0 "), "= 1.50 ECS per100 M", /*#__PURE__*/React__default.createElement("sup", null, "2"), " of built up area"), /*#__PURE__*/React__default.createElement("p", null, "(iii) Above 1500 M", /*#__PURE__*/React__default.createElement("sup", null, "2\xA0\xA0\xA0\xA0 "), "= 2.00ECS per100 M", /*#__PURE__*/React__default.createElement("sup", null, "2"), " of built up area"), /*#__PURE__*/React__default.createElement("p", null, "(iv.)Tourism Units, can be known by the name of Hotel or Guest House or Eco-Tourism or by any other name."), /*#__PURE__*/React__default.createElement("p", null, "(v.)In existing built up areas like Bazaars, the building line can be maintained."))), /*#__PURE__*/React__default.createElement(TableRow, null, /*#__PURE__*/React__default.createElement(TableCell, null, "5."), /*#__PURE__*/React__default.createElement(TableCell, null, /*#__PURE__*/React__default.createElement("p", null, "Cinema / Cineplex"), /*#__PURE__*/React__default.createElement("p", null, " 4000 M", /*#__PURE__*/React__default.createElement("sup", null, "2"), " and above")), /*#__PURE__*/React__default.createElement(TableCell, null, "15.00"), /*#__PURE__*/React__default.createElement(TableCell, null, "7.50"), /*#__PURE__*/React__default.createElement(TableCell, null, "7.50"), /*#__PURE__*/React__default.createElement(TableCell, null, "6.00"), /*#__PURE__*/React__default.createElement(TableCell, null, "1.50"), /*#__PURE__*/React__default.createElement(TableCell, {
    style: {
      marginLeft: '30px'
    }
  }, "21")), /*#__PURE__*/React__default.createElement(TableRow, null, /*#__PURE__*/React__default.createElement(TableCell, null), /*#__PURE__*/React__default.createElement(TableCell, {
    colSpan: 8
  }, /*#__PURE__*/React__default.createElement("p", null, "Parking"), /*#__PURE__*/React__default.createElement("p", null, "(i)  3.00 ECS per100 M", /*#__PURE__*/React__default.createElement("sup", null, "2"), " of built up area"), /*#__PURE__*/React__default.createElement("p", null, "Other Regulations as per Cinematography Act shall also apply."))), /*#__PURE__*/React__default.createElement(TableRow, null, /*#__PURE__*/React__default.createElement(TableCell, null, "6."), /*#__PURE__*/React__default.createElement(TableCell, null, /*#__PURE__*/React__default.createElement("p", null, "Multiplexes"), /*#__PURE__*/React__default.createElement("p", null, " 4000 M", /*#__PURE__*/React__default.createElement("sup", null, "2"), " and above")), /*#__PURE__*/React__default.createElement(TableCell, null, "15.00"), /*#__PURE__*/React__default.createElement(TableCell, null, "9.00"), /*#__PURE__*/React__default.createElement(TableCell, null, "9.00"), /*#__PURE__*/React__default.createElement(TableCell, null, "9.00"), /*#__PURE__*/React__default.createElement(TableCell, null, "1.50"), /*#__PURE__*/React__default.createElement(TableCell, {
    style: {
      marginLeft: '30px'
    }
  }, "21")), /*#__PURE__*/React__default.createElement(TableRow, null, /*#__PURE__*/React__default.createElement(TableCell, null), /*#__PURE__*/React__default.createElement(TableCell, {
    colSpan: 8
  }, /*#__PURE__*/React__default.createElement("p", null, "Parking"), /*#__PURE__*/React__default.createElement("ol", null, /*#__PURE__*/React__default.createElement("li", null, "Permissible within the complex."), /*#__PURE__*/React__default.createElement("li", null, "Parking space to be provided within Multiplex @\xA0 3 ECS for every 100 M", /*#__PURE__*/React__default.createElement("sup", null, "2"), " of built up area."), /*#__PURE__*/React__default.createElement("li", null, "Other Regulations as per Cinematography Act shall also apply."), /*#__PURE__*/React__default.createElement("li", null, "Multiplex complex shall mean an integrated entertainment and shopping centre/ complex having at least 2 Cinema Halls. The minimum area on which this use shall be permitted should not be less than 4000 M", /*#__PURE__*/React__default.createElement("sup", null, "2"), ". Apart from Cinema Halls, the Multiplexes may also have Restaurant, Fast Food, Outlet, Pubs, Health Spas/ Centers, Hotels and other Re-creational activities. The shopping center may have Retail Outlet, Video Games, Parlours, Bowling Alleys, Health Centers, Shopping Malls, Office space.")))), /*#__PURE__*/React__default.createElement(TableRow, null, /*#__PURE__*/React__default.createElement(TableCell, null), /*#__PURE__*/React__default.createElement(TableCell, {
    colSpan: 8
  }, /*#__PURE__*/React__default.createElement("p", null, "Note:-"), /*#__PURE__*/React__default.createElement("p", null, "1.00 ECS (Equivalent Car Space) shall mean as under:-"), /*#__PURE__*/React__default.createElement("ol", null, /*#__PURE__*/React__default.createElement("li", null, "For parking in open \xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0 \xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0= 23 M", /*#__PURE__*/React__default.createElement("sup", null, "2")), /*#__PURE__*/React__default.createElement("li", null, "For parking in stilts or ground floor\xA0 = 28 M", /*#__PURE__*/React__default.createElement("sup", null, "2")), /*#__PURE__*/React__default.createElement("li", null, "For parking in basement floor\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0 = 32 M", /*#__PURE__*/React__default.createElement("sup", null, "2"))))), /*#__PURE__*/React__default.createElement(TableRow, null, /*#__PURE__*/React__default.createElement(TableCell, null, "7."), /*#__PURE__*/React__default.createElement(TableCell, null, /*#__PURE__*/React__default.createElement("p", null, "Multi level parking"), /*#__PURE__*/React__default.createElement("p", null, "(i.) 500 M", /*#__PURE__*/React__default.createElement("sup", null, "2"), " to 1500 M", /*#__PURE__*/React__default.createElement("sup", null, "2")), /*#__PURE__*/React__default.createElement("p", null, "(ii)Above\xA0 1500 M", /*#__PURE__*/React__default.createElement("sup", null, "2"), "to 4000 M", /*#__PURE__*/React__default.createElement("sup", null, "2")), /*#__PURE__*/React__default.createElement("p", null, "(iii)Above\xA0 4000 M", /*#__PURE__*/React__default.createElement("sup", null, "2"))), /*#__PURE__*/React__default.createElement(TableCell, null, /*#__PURE__*/React__default.createElement("p", null, "5.00"), /*#__PURE__*/React__default.createElement("p", null, "10.00"), /*#__PURE__*/React__default.createElement("p", null, "12.00")), /*#__PURE__*/React__default.createElement(TableCell, null, /*#__PURE__*/React__default.createElement("p", null, "3.00"), /*#__PURE__*/React__default.createElement("p", null, "5.00"), /*#__PURE__*/React__default.createElement("p", null, "7.50")), /*#__PURE__*/React__default.createElement(TableCell, null, /*#__PURE__*/React__default.createElement("p", null, "3.00"), /*#__PURE__*/React__default.createElement("p", null, "5.00"), /*#__PURE__*/React__default.createElement("p", null, "7.50")), /*#__PURE__*/React__default.createElement(TableCell, null, /*#__PURE__*/React__default.createElement("p", null, "3.00"), /*#__PURE__*/React__default.createElement("p", null, "5.00"), /*#__PURE__*/React__default.createElement("p", null, "6.00")), /*#__PURE__*/React__default.createElement(TableCell, null, /*#__PURE__*/React__default.createElement("p", null, "1.75"), /*#__PURE__*/React__default.createElement("p", null, "1.75"), /*#__PURE__*/React__default.createElement("p", null, "1.50")), /*#__PURE__*/React__default.createElement(TableCell, {
    style: {
      marginLeft: '30px'
    }
  }, /*#__PURE__*/React__default.createElement("p", null, "21.00"), /*#__PURE__*/React__default.createElement("p", null, "21.00"), /*#__PURE__*/React__default.createElement("p", null, "21.00"))), /*#__PURE__*/React__default.createElement(TableRow, null, /*#__PURE__*/React__default.createElement(TableCell, {
    colSpan: 9
  }, /*#__PURE__*/React__default.createElement("p", null, "Other Uses including public & semi \u2013public, educational buildings, police/fire-stations, medical, community hall, library / religious buildings,\xA0 etc."))), /*#__PURE__*/React__default.createElement(TableRow, null, /*#__PURE__*/React__default.createElement(TableCell, null, "1."), /*#__PURE__*/React__default.createElement(TableCell, null, /*#__PURE__*/React__default.createElement("p", null, "(i.) 250 M", /*#__PURE__*/React__default.createElement("sup", null, "2"), " to 500 M", /*#__PURE__*/React__default.createElement("sup", null, "2")), /*#__PURE__*/React__default.createElement("p", null, "(ii)Above\xA0 500 M", /*#__PURE__*/React__default.createElement("sup", null, "2"), "to 1000 M", /*#__PURE__*/React__default.createElement("sup", null, "2")), /*#__PURE__*/React__default.createElement("p", null, "(iii)Above\xA0 1000 M", /*#__PURE__*/React__default.createElement("sup", null, "2"), " to 5000 M", /*#__PURE__*/React__default.createElement("sup", null, "2")), /*#__PURE__*/React__default.createElement("p", null, "(iii)Above 5000 M", /*#__PURE__*/React__default.createElement("sup", null, "2"))), /*#__PURE__*/React__default.createElement(TableCell, null, /*#__PURE__*/React__default.createElement("p", null, "3.00"), /*#__PURE__*/React__default.createElement("p", null, "5.00"), /*#__PURE__*/React__default.createElement("p", null, "10.00"), /*#__PURE__*/React__default.createElement("p", null, "15.00")), /*#__PURE__*/React__default.createElement(TableCell, null, /*#__PURE__*/React__default.createElement("p", null, "2.00"), /*#__PURE__*/React__default.createElement("p", null, "2.00"), /*#__PURE__*/React__default.createElement("p", null, "5.00"), /*#__PURE__*/React__default.createElement("p", null, "7.50")), /*#__PURE__*/React__default.createElement(TableCell, null, /*#__PURE__*/React__default.createElement("p", null, "2.00"), /*#__PURE__*/React__default.createElement("p", null, "2.00"), /*#__PURE__*/React__default.createElement("p", null, "5.00"), /*#__PURE__*/React__default.createElement("p", null, "7.50")), /*#__PURE__*/React__default.createElement(TableCell, null, /*#__PURE__*/React__default.createElement("p", null, "2.00"), /*#__PURE__*/React__default.createElement("p", null, "3.00"), /*#__PURE__*/React__default.createElement("p", null, "5.00"), /*#__PURE__*/React__default.createElement("p", null, "7.50")), /*#__PURE__*/React__default.createElement(TableCell, null, /*#__PURE__*/React__default.createElement("p", null, "2.00"), /*#__PURE__*/React__default.createElement("p", null, "1.75"), /*#__PURE__*/React__default.createElement("p", null, "1.50"), /*#__PURE__*/React__default.createElement("p", null, "1.50")), /*#__PURE__*/React__default.createElement(TableCell, {
    style: {
      marginLeft: '30px'
    }
  }, /*#__PURE__*/React__default.createElement("p", null, "21.00"), /*#__PURE__*/React__default.createElement("p", null, "21.00"), /*#__PURE__*/React__default.createElement("p", null, "21.00"), /*#__PURE__*/React__default.createElement("p", null, "21.00"))))));
}

const Appendix1 = () => {
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("p", {
    style: {
      textAlign: 'center'
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      fontSize: '16px'
    }
  }, "APPENDIX-1", /*#__PURE__*/React__default.createElement("br", null), "(See rules 13 and 14)")), /*#__PURE__*/React__default.createElement("div", {
    style: {
      margin: '20px'
    }
  }, /*#__PURE__*/React__default.createElement("p", null, /*#__PURE__*/React__default.createElement("strong", null, "REGULATIONS FOR SUB-DIVISION OF LAND OR CHANGE OF LAND USE OR DEVELOPMENT OF LAND OR CONSTRUCTION OF BUILDING IN AREAS WHERE LAND USE IS FROZEN AND INTERIM DEVELOPMENT PLAN OR DEVELOPMENT PLAN HAS NOT BEEN PREPARED.")), /*#__PURE__*/React__default.createElement("p", null, /*#__PURE__*/React__default.createElement("strong", null, "I. \xA0\xA0\xA0\xA0Application for permission:-")), /*#__PURE__*/React__default.createElement("p", null, "\xA0 After the boundaries of the land in question are marked, the applicant shall make an application in Forms 11 or 12, as the case may be addressed to the Director and such application shall be accompanied by such documents as specified in Forms 11 or 12."), /*#__PURE__*/React__default.createElement("p", null, /*#__PURE__*/React__default.createElement("strong", null, "II. The minimum Plot Area, minimum Set Backs and maximum Floor Area Ratio (FAR) shall be as under:-"))), /*#__PURE__*/React__default.createElement(OtherUse, null), /*#__PURE__*/React__default.createElement(IndustrialUse, null), /*#__PURE__*/React__default.createElement(GeneralRegulation, null));
};

function Appendix8() {
  return /*#__PURE__*/createElement(Fragment$2, null, /*#__PURE__*/createElement("div", {
    style: {
      margin: '20px'
    }
  }, /*#__PURE__*/createElement("p", null, "\xA0 \xA0 \xA0"), /*#__PURE__*/createElement("p", null, /*#__PURE__*/createElement("strong", null, "\xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0APPENDIX 8")), /*#__PURE__*/createElement("p", null, /*#__PURE__*/createElement("strong", null, "\xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0(See "), /*#__PURE__*/createElement("strong", null, "rules 13, 14 and 18)")), /*#__PURE__*/createElement("p", null, /*#__PURE__*/createElement("strong", null, "REGULATIONS OF PRESCRIBED LIMITS FOR DEVELOPMENT ACTIVITIES EXEMPTED UNDER "), /*#__PURE__*/createElement("strong", null, "SECTION"), /*#__PURE__*/createElement("strong", null, " 30-A OF THE Uttar Pradesh TOWN AND COUNTRY PLANNING ACT, 1977 (ACT NO. 12 OF 1977)")), /*#__PURE__*/createElement("p", null, /*#__PURE__*/createElement("strong", null, "\xA0\xA0 \xA0 \xA0 \xA0 \xA0 \xA0 Residential Buildings and Farm Houses")), /*#__PURE__*/createElement("p", null, "(i)\xA0\xA0 Maximum floor area\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0 \xA0 \xA0 \xA0 \xA0 =\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0 600.00 M", /*#__PURE__*/createElement("sup", null, "2")), /*#__PURE__*/createElement("p", null, "(ii)\xA0 Maximum number of storeys \xA0\xA0 \xA0\xA0 = \xA0 \xA0 \xA0 \xA03 Nos +1 Parking floor wherever feasible", /*#__PURE__*/createElement("strong", null, ".")), /*#__PURE__*/createElement("p", null, /*#__PURE__*/createElement("strong", null, "Note:-"), " The applicant may have a maximum floor area of 600.00 M", /*#__PURE__*/createElement("sup", null, "2"), "\xA0 distributed over not more than three storeys."), /*#__PURE__*/createElement("strong", null, "\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0 Commercial Use "), /*#__PURE__*/createElement("p", null, "(i) \xA0 Maximum floor area \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0\xA0\xA0\xA0 =\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0 100.00 M", /*#__PURE__*/createElement("sup", null, "2")), /*#__PURE__*/createElement("p", null, "(ii)\xA0 Maximum number of storeys \xA0 \xA0 = \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA02 Nos."), /*#__PURE__*/createElement("p", null, "(iii) Minimum access \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0\xA0 \xA0\xA0 = \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA03.00 M"), /*#__PURE__*/createElement("p", null, "(iv)\xA0 Parking \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0= \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 For loading, un-loading and parking purpose suitable community parking space has to be arranged by the Shop owners."), /*#__PURE__*/createElement("p", null, /*#__PURE__*/createElement("strong", null, "Note:-"), "\xA0 The applicant may have a maximum floor area of 100.00 M", /*#__PURE__*/createElement("sup", null, "2 "), "\xA0distributed\xA0 over not more than two storeys."), /*#__PURE__*/createElement("p", null, /*#__PURE__*/createElement("strong", null, "\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0 Service Industries")), /*#__PURE__*/createElement("p", null, "\xA0\xA0\xA0\xA0\xA0 (i)\xA0 Maximum floor area \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 =\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0 100.00 M", /*#__PURE__*/createElement("sup", null, "2")), /*#__PURE__*/createElement("p", null, "\xA0\xA0\xA0\xA0 (ii)\xA0 Number of storeys \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 =\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0 1 No."), /*#__PURE__*/createElement("p", null, "\xA0\xA0\xA0 (iii)\xA0 Minimum access \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0\xA0 =\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0 3.00 M"), /*#__PURE__*/createElement("p", null, "\xA0\xA0\xA0 (iv)\xA0 Parking \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0\xA0 \xA0 \xA0 =\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0 For loading, un-loading and parking purpose\xA0\xA0 suitable community parking space shall have to be ensured by the Industrialists."), /*#__PURE__*/createElement("p", null, /*#__PURE__*/createElement("strong", null, "\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0 Public Amenities")), /*#__PURE__*/createElement("p", null, "\xA0\xA0\xA0\xA0 (i)\xA0\xA0 Maximum floor area \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 = \xA0 \xA0 As per requirement of the particular amenity.\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0"), /*#__PURE__*/createElement("p", null, "\xA0 \xA0\xA0 (ii) Maximum Number of storeys \xA0 \xA0 \xA0 \xA0 \xA0=\xA0\xA0\xA0\xA0\xA0\xA0 3 Nos."), /*#__PURE__*/createElement("p", null, "\xA0\xA0\xA0\xA0 (iii) Minimum access \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0= \xA0 \xA0 \xA0 \xA03.00 M"), /*#__PURE__*/createElement("p", null, "\xA0\xA0\xA0\xA0 (iv)\xA0 Parking\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0 = \xA0 \xA0 \xA0 @ 0.50 to 1.50 equivalent car space per 100 M", /*#__PURE__*/createElement("sup", null, "2 "), "of floor area.\xA0"), /*#__PURE__*/createElement("p", null, "\xA0 \xA0 \xA0 \xA0 \xA0 \xA0\xA0\xA0\xA0\xA0 (v) Play fields in case of \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 = \xA0 \xA0 \xA0 \xA00.20 Hectare to 1.60 Hectare is Educational buildings. Desirable, however, as per availability of land."), /*#__PURE__*/createElement("p", null, /*#__PURE__*/createElement("strong", null, "\xA0\xA0\xA0\xA0\xA0\xA0 \xA0 \xA0 \xA0 \xA0 \xA0 5. Other Imperatives")), /*#__PURE__*/createElement("p", null, /*#__PURE__*/createElement("strong", null, "\xA0\xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 "), "(i)\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0 Structural safety and seismic proofing including soil investigation should be ensured."), /*#__PURE__*/createElement("p", null, "\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0 \xA0 \xA0 \xA0 \xA0 (ii)\xA0\xA0\xA0\xA0\xA0\xA0\xA0 Attic and basement shall be counted as a storey."), /*#__PURE__*/createElement("p", null, "\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0 \xA0 \xA0 \xA0 (iii)\xA0\xA0\xA0\xA0\xA0\xA0 Sloping roof shall have to be ensured."), /*#__PURE__*/createElement("p", null, /*#__PURE__*/createElement("strong", null, "\xA0 \xA0 \xA0 \xA0 \xA0 \xA0 \xA0 *(iv)\xA0\xA0 \xA0\xA0"), "No construction shall be raised within a distance of 3.00 Metre from the edge of the roads in respect of village roads."), /*#__PURE__*/createElement("p", null, "\xA0 \xA0 \xA0 \xA0 \xA0 \xA0\xA0 \xA0\xA0 (a) \xA0 \xA0 \xA0No construction shall be raised within the controlled width of major District\xA0\xA0 roads."), /*#__PURE__*/createElement("p", null, /*#__PURE__*/createElement("strong", null, "\xA0 \xA0 \xA0 \xA0 \xA0 \xA0\xA0\xA0 *(vi)\xA0 \xA0"), "Minimum Set Back of 3.00 M from the controlled width of National Highways, State Highways and Scheduled Roads under the Uttar Pradesh Road Side Land Control Act, 1968 shall be kept."), /*#__PURE__*/createElement("p", null, "\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0 (vii)\xA0\xA0 Minimum Set Back of 2.00 M in front and 1.50 M in sides and rear side and from the adjoining property, Government land and 5.00 M from Forest land shall have to be maintained."), /*#__PURE__*/createElement("p", null, "\xA0"), /*#__PURE__*/createElement("table", {
    border: "1",
    cellpadding: "0",
    cellspacing: "0"
  }, /*#__PURE__*/createElement("tbody", null, /*#__PURE__*/createElement("tr", null, /*#__PURE__*/createElement("td", null, /*#__PURE__*/createElement("p", null, "* As amended ", /*#__PURE__*/createElement("em", null, "vide"), " Uttar Pradesh Town and Country Planning (Amendment), Rules 2016"))))), /*#__PURE__*/createElement("p", null, "(viii)Adequate distance from the electric lines as per the requirement of Uttar Pradesh State Electricity Board Limited (HPSEB Ltd) Rules shall have to be maintained. The No Objection Certificate (NOC) of the competent authority shall also be required, if HT/LT line is crossing through the Scheme."), /*#__PURE__*/createElement("p", null, "*(ix) \xA0The applicant shall endeavor to develop the colony along the slopes of hill without much disturbance to the natural hill profile. In no case hill cut at any level shall not exceed 3.50 Metres."), /*#__PURE__*/createElement("ol", null, /*#__PURE__*/createElement("li", null, "Provision of Rain Water Harvesting structure @ 20 Liters per M", /*#__PURE__*/createElement("sup", null, "2"), " of roof area should be made."), /*#__PURE__*/createElement("li", null, "Septic Tank and Soak Pit should be constructed."), /*#__PURE__*/createElement("li", null, "Preference shall be given for Solar Passive Building Design."), /*#__PURE__*/createElement("li", null, "Locational attributes, aesthetics, local building material, heritage and environmental aspects should also be taken into account.")), /*#__PURE__*/createElement("p", null, "\xA0"), /*#__PURE__*/createElement("ol", null, /*#__PURE__*/createElement("li", null, /*#__PURE__*/createElement("strong", null, "Remarks"), " :"), /*#__PURE__*/createElement("li", null, "The benefit of above exemptions shall only be available to the residents and original inhabitants of the areas, who owned the property at the time of commencement of the Act and their natural heirs only and not to the persons who purchased land in rural areas."), /*#__PURE__*/createElement("li", null, "\xA0Any person intending to carry out development activities\xA0 exempted under section 30-A of the Uttar Pradesh Town and Country Planning Act, 1977 (Act No. 12 of 1977) shall give information on simple paper alongwith a copy of original jamabandi and original tatima to the concerned Panchayat before carrying out development activities. The concerned Panchayat after verifying the documents, shall grant No Objection Certificate (NOC) to the applicant under section 83-A of the Uttar Pradesh Town and Country Planning Act, 1977 (Act No. 12 of 1977)\xA0 for obtaining service connections."), /*#__PURE__*/createElement("li", null, "Urban and Regional Development Plans Formulation and\xA0 Implementation (URDPFI) Guidelines, 2014 of the Government of India or the National Building Code of India shall have to be adhered to."))));
}

const StyledTableCell$4 = styled$3(TableCell$1)(({
  theme
}) => ({
  [`&.${tableCellClasses$1.head}`]: {
    color: theme.palette.common.white
  },
  [`&.${tableCellClasses$1.body}`]: {
    fontSize: 14
  }
}));
const StyledTableRow$4 = styled$3(TableRow$1)(({
  theme
}) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover
  },
  '&:last-child td, &:last-child th': {
    border: 0
  }
}));
function createData$2(name, calories, fat, carbs, protein, health, lact) {
  return {
    name,
    calories,
    fat,
    carbs,
    protein,
    health,
    lact
  };
}
const rows$3 = [createData$2('Application for Permission of Sub-division/development of Land', 60, 61, 10, 59, 98, 120), createData$2('Application for Building Plan Permission', 67, 41, 60, 29, 58, 67), createData$2('Application for Composition of Offences', 50, 71, 100, 79, 98, 134), createData$2('Application for Real Estate Projects', 40, 51, 70, 89, 68, 122), createData$2('Application for Change of Land Use', 56, 61, 50, 39, 19, 120)];
function AppartmentRegulation() {
  return /*#__PURE__*/createElement(TableContainer$1, {
    component: Paper$1,
    sx: {
      width: '90%',
      margin: '20px 10px 0px 70px'
    }
  }, /*#__PURE__*/createElement(Typography$1, {
    variant: "h6",
    style: {
      display: 'flex',
      justifyContent: 'center',
      height: '50px',
      fontWeight: 'bold',
      fontSize: '30px',
      color: '#1F4A7C',
      backgroundImage: 'linear-gradient(to right, #F5F5FF, #E5E5FF)'
    }
  }, "Apartment Regulations"), /*#__PURE__*/createElement(Table$4, {
    sx: {
      minWidth: 1200
    },
    "aria-label": "customized table"
  }, /*#__PURE__*/createElement(TableHead$1, null, /*#__PURE__*/createElement(TableRow$1, {
    style: {
      background: '#1F4A7C'
    }
  }, /*#__PURE__*/createElement(StyledTableCell$4, null, "Time-Limit Prescribed as per PSGA"), /*#__PURE__*/createElement(StyledTableCell$4, {
    align: "right"
  }, "Total No. of Application Received"), /*#__PURE__*/createElement(StyledTableCell$4, {
    align: "right"
  }, "Total No. of Application Approved"), /*#__PURE__*/createElement(StyledTableCell$4, {
    align: "right"
  }, "Avg. Time"), /*#__PURE__*/createElement(StyledTableCell$4, {
    align: "right"
  }, "Median Time"), /*#__PURE__*/createElement(StyledTableCell$4, {
    align: "right"
  }, "Minimum"), /*#__PURE__*/createElement(StyledTableCell$4, {
    align: "right"
  }, "Maximum"))), /*#__PURE__*/createElement(TableBody$1, null, rows$3.map(row => /*#__PURE__*/createElement(StyledTableRow$4, {
    key: row.name
  }, /*#__PURE__*/createElement(StyledTableCell$4, {
    component: "th",
    scope: "row"
  }, row.name), /*#__PURE__*/createElement(StyledTableCell$4, {
    align: "right"
  }, row.calories), /*#__PURE__*/createElement(StyledTableCell$4, {
    align: "right"
  }, row.fat), /*#__PURE__*/createElement(StyledTableCell$4, {
    align: "right"
  }, row.carbs), /*#__PURE__*/createElement(StyledTableCell$4, {
    align: "right"
  }, row.protein), /*#__PURE__*/createElement(StyledTableCell$4, {
    align: "right"
  }, row.health), /*#__PURE__*/createElement(StyledTableCell$4, {
    align: "right"
  }, row.lact))))));
}

const data = [{
  slNo: '1.',
  caseNo: 'Civil Appeal (D) no. 14669/ 2019',
  title: 'State of H.P vs. Yogendra Mohan Sengupta.',
  nature: 'NGT judgment dated 16.11.2017 challenged being extra-jurisdictional and scope of NGT.',
  nextDate: 'Not given'
}, {
  slNo: '2.',
  caseNo: 'Civil Appeal Diary no. 44451/ 2018.',
  title: 'Pushpinder Singh Chopra versus SPOKE and others.',
  nature: 'Construction of HPTDC Hotel at Kasauli challenged, which was approved by NGT vide its order dated 05.10.2018.',
  nextDate: 'Not given'
}, {
  slNo: '3.',
  caseNo: 'Civil Appeal no. 4526 of 2019',
  title: 'Kasauli Hoteliers Resident Welfare Associations versus SPOKE',
  nature: 'NGT judgment dated 05.10.2018 challenged being extra-jurisdictional and the scope of NGT.',
  nextDate: 'Not given'
}, {
  slNo: '4.',
  caseNo: 'Civil Appeal no. 10377 of 2017',
  title: 'Hotel Kasauli Inn. &anr. versus SPOKE',
  nature: 'NGT judgment dated 05.10.2018 challenged being extra-jurisdictional and the scope of NGT.',
  nextDate: 'Not given'
}, {
  slNo: '5.',
  caseNo: 'Civil Appeal Diary no. 14669 of 2019.',
  title: 'State of Himachal versus SPOKE & others.',
  nature: 'NGT judgment dated 05.10.2018 challenged being extra-jurisdictional and the scope of NGT.',
  nextDate: 'Not given'
}, {
  slNo: '6.',
  caseNo: 'Civil Appeal no.2823/ 2018',
  title: 'Ramesh Chand versus State of Uttar Pradesh & others',
  nature: 'NGT order dated 8.12.2017 challenged',
  nextDate: 'Not given'
}, {
  slNo: '7.',
  caseNo: 'Civil Appeal no. 829 of 2019',
  title: 'M/S Citrus Manali Resorts Pvt. Ltd. versus Ramesh Chand and others',
  nature: 'NGT order dated 8.12.2017 challenged',
  nextDate: 'Not given'
}, {
  slNo: '8.',
  caseNo: 'SLP- (C) no. 2865-66/ 2014',
  title: 'HPCA versus State of H.P & ors.',
  nature: 'Issue of construction of HPCA ground and diversion of Forest land etc.',
  nextDate: 'Not given'
}, {
  slNo: '',
  caseNo: '',
  title: '',
  nature: 'NATIONAL GREEN TRIBUNAL.',
  nextDate: ''
}, {
  slNo: '9.',
  caseNo: 'O.A. no. 104/ 2018',
  title: 'Shiv Pal Bhagat vs. State of H.P',
  nature: 'Illegal setting up of 2 septic tanks and one electric transformer in complete violation of Article 21 of the Constitution of India.',
  nextDate: 'Not given'
}, {
  slNo: '10.',
  caseNo: 'O.A No. 606/2018',
  title: 'Solid Waste Management Rules 2016 &amp; other environmental issues.',
  nature: 'Preparing of a State Policy and Management strategies',
  nextDate: 'Not Given'
}, {
  slNo: "11",
  caseNo: "CWP no. 4869/ 2021",
  title: "GurucharanKaur vs. State",
  nature: "Disconnection of electricity on account of unauthorized construction in Manali.",
  nextDate: "Not given"
}, {
  slNo: "12",
  caseNo: "CWP no. 2243/ 2021",
  title: "M/S Himachal Conductors Ltd. vs. State of H.P",
  nature: "Issue of permission under Section 118 of HPT&amp;LRA, 1972 and apartments.",
  nextDate: "Not given"
}, {
  slNo: "13",
  caseNo: "CWP no. 4439/ 2021",
  title: "Tulsia vs. State of H.P",
  nature: "Unauthorized construction of building in Solan.",
  nextDate: "Not given"
}, {
  slNo: "14",
  caseNo: "CWPIL no. 13/ 2021",
  title: "Kusum Bali vs. State of H.P",
  nature: "To regulate TCP Act in Kummarhatti-Dagshai area.",
  nextDate: "Not given"
}, {
  slNo: "15",
  caseNo: "CWP no. 873/ 2021",
  title: "Suresh Kumar vs. State of H.P",
  nature: "Service matter.",
  nextDate: "Not given"
}, {
  slNo: "16",
  caseNo: "CWP no. 3832/ 2021",
  title: "Diamond Traexim vs. State of H.P",
  nature: "Construction of M/S Nirvana Woods project and its planning permission.",
  nextDate: "Not given"
}, {
  slNo: "17",
  caseNo: "COPC no. 14/ 2021",
  title: "M/S Himland Housing vs. State of H.P",
  nature: "Contempt of Court proceedings/ order\n\nSection 118 permission lapse.",
  nextDate: "Not given"
}, {
  slNo: "18",
  caseNo: "CWPIL no. 20/ 2021",
  title: "UdayPanwar vs. State of H.P",
  nature: "Unauthorized construction of building near Kasumpti.",
  nextDate: "Not given"
}, {
  slNo: "19",
  caseNo: "CWP no. 2470/ 2021",
  title: "Shagun Sharma vs. State of H.P",
  nature: "Service matter/ Transfer of P.O on complaint",
  nextDate: "Not given"
}, {
  slNo: "20",
  caseNo: "CWP no. 692/ 2021",
  title: "Ravi Kumar versus State of H.P &amp; ors",
  nature: "Construction of petrol pump challenged",
  nextDate: "Not given"
}, {
  slNo: "21.",
  caseNo: "CWP no. 5038/ 2021",
  title: "Mohinder Singh versus State of H.P & ors.",
  nature: "Allotment of shop MC Dharamshala.",
  nextDate: "Not given"
}, {
  slNo: "22.",
  caseNo: "CRMMO no. 204/ 2021",
  title: "Savita Sharma versus State of H.P & ors.",
  nature: "Quashing of FIR. Forgery of documents, Solan. Quashing of FIR. Forgery of documents, Solan.",
  nextDate: "Not given"
}, {
  slNo: "23.",
  caseNo: "RSA no. 15/ 2021",
  title: "Govind versus Santosh Kumar/State of H.P & ors.",
  nature: "Civil litigation qua suit land/ substantial question of law.",
  nextDate: "Not given"
}, {
  slNo: "24.",
  caseNo: "CWP no. 3833/ 2021",
  title: "SumitKhanna versus UOI & ors.",
  nature: "Regarding order of HP RERA on real estate project.",
  nextDate: "Not given"
}, {
  slNo: "25.",
  caseNo: "CWP no. 5982/ 2021",
  title: "PuneetKanwar versus State of H.P & ors.",
  nature: "Job on compassionate grounds",
  nextDate: "Not given"
}, {
  slNo: "26.",
  caseNo: "LPA no. 89/ 2021",
  title: "Ruma Devi versus State of H.P & ors.",
  nature: "Service benefits of deceased employee including GPF etc.",
  nextDate: "Not given"
}, {
  slNo: "27.",
  caseNo: "Execution petition no. 13/ 2021",
  title: "MrityunjayTripathiversus State of H.P & ors.",
  nature: "Execution of NGT order passed in the judgment dated 16.11.2017.",
  nextDate: "Not given"
}, {
  slNo: "28.",
  caseNo: "CMPMO 84/ 2020",
  title: "Rani Kukreja vs. State of H.P",
  nature: "Regarding dismissal of Civil Suits having same cause of action in lower Courts.",
  nextDate: "Not given"
}, {
  slNo: "29.",
  caseNo: "CWP no. 442/ 2020",
  title: "Jagdish Chand versus State of HP",
  nature: "Planning permission and approvals with Section 16-C.",
  nextDate: "Not given"
}, {
  slNo: "30.",
  caseNo: "CWP no. 3715/ 2020",
  title: "Neelam Boris versus State of HP",
  nature: "Installation of mobile towers at buildings in Shimla near Aukland House School.",
  nextDate: "Not given"
}, {
  slNo: "31.",
  caseNo: "CWP no. 628/ 2020",
  title: "BhagwanDasi versus State of HP (Connected matter with CWPIL no. 15/ 14)",
  nature: "Composition of deviations of building- Shimla- Kalka NH",
  nextDate: "Not given"
}, {
  slNo: "32.",
  caseNo: "CWP no. 1503/ 2020",
  title: "RajanBadhan versus State of HP",
  nature: "Planning permission and approval case.",
  nextDate: "Not given"
}, {
  slNo: "33.",
  caseNo: "CWP no. 2825 2020",
  title: "Ajay Sharma versus State of HP",
  nature: "Violation of Section 16-C, SADA Una.",
  nextDate: "Not given"
}, {
  slNo: "34.",
  caseNo: "CWP no. 1893/ 2020",
  title: "Naresh Kumar versus State of HP",
  nature: "Planning permission and approval case.",
  nextDate: "Not given"
}, {
  slNo: "35.",
  caseNo: "CWPOA no. 5761/ 2020",
  title: "Virender Kumar vs. State of H.P",
  nature: "Service matter\nSADA employees claiming pay scale and service benefits",
  nextDate: "Not given"
}, {
  slNo: "36.",
  caseNo: "CWPOA no. 4929/ 2020",
  title: "Ashok Kumar vs. State of H.P",
  nature: "Service matter.\n\nSADA employees claiming pay scale and service benefits.",
  nextDate: "Not given"
}, {
  slNo: "37.",
  caseNo: "CWPOA no. 4923/ 2020",
  title: "Arun Kumar vs. State of H.P",
  nature: "Service matter.\n\nSADA employees claiming pay scale and service benefits.",
  nextDate: "Not given"
}, {
  slNo: "38.",
  caseNo: "CWPOA no. 4921/ 2020",
  title: "Rajeev Sharma vs. State of H.P",
  nature: "Service matter.\n\nSADA employees claiming pay scale and service benefits.",
  nextDate: "Not given"
}, {
  slNo: "39.",
  caseNo: "CWP no. 3739/ 2020",
  title: "Mahesh Dutt Sharma versus State of HP",
  nature: "Regarding unauthorized construction in Rampur.",
  nextDate: "Not given"
}, {
  slNo: "40.",
  caseNo: "CWP no. 935/ 2020",
  title: "Rajni Devi versus State of HP",
  nature: "Case of planning permission and approvals, MC Dharamshala.",
  nextDate: "Not given"
}, {
  "slNo": "41.",
  "caseNo": "CWP no. 935/ 2020",
  "title": "Rajni Devi versus State of HP",
  "nature": "Case of planning permission and approvals, MC Dharamshala.",
  "nextDate": "Not given"
}, {
  "slNo": "42.",
  "caseNo": "CWP no. 6029/ 2020",
  "title": "SYSCO versus State of H.P & ors.",
  "nature": "Construction of petrol pump challenged",
  "nextDate": "Not given"
}, {
  "slNo": "43.",
  "caseNo": "CWP no. 4325/ 2020",
  "title": "Bemloi Development & Infrastructure Pvt. Ltd. versus State of H.P & ors.",
  "nature": "Planning permission case for apartments, Shimla",
  "nextDate": "Not given"
}, {
  "slNo": "44.",
  "caseNo": "CWP no. 1447/ 2020",
  "title": "JaneshMahajan versus State of H.P & ors.",
  "nature": "Planning permission case, Dalhousie, Chamba",
  "nextDate": "Not given"
}, {
  "slNo": "45.",
  "caseNo": "CWP no. 1462/ 2019",
  "title": "Satish Kumar versus State of HP (Connected matter with CWPIL no. 15/ 14)",
  "nature": "Composition of deviations of building- Shimla- Kalka NH.",
  "nextDate": "Not given"
}, {
  "slNo": "46.",
  "caseNo": "CWP no. 2077/ 2019",
  "title": "Madhusoodan versus State of H.P & ors.",
  "nature": "Regarding unauthorized construction in MC Dharamshala.",
  "nextDate": "Not given"
}, {
  "slNo": "47.",
  "caseNo": "CWP no. 2774/ 2019",
  "title": "AmanGuleria versus State of H.P & ors.",
  "nature": "Regarding unauthorized construction in MC Dharamshala.",
  "nextDate": "Not given"
}, {
  "slNo": "48.",
  "caseNo": "CWP no. 4389/ 2019",
  "title": "BaldevAtri versus State of H.P & ors.",
  "nature": "Regarding the construction of HP Secretariat employee association at AadityaVihar, Shimla",
  "nextDate": "Not given"
}, {
  "slNo": "49.",
  "caseNo": "CWP no. 1716/ 2019",
  "title": "Prithvi Chand versus State of H.P & ors.",
  "nature": "Service matter. Regularization of services and benefits.",
  "nextDate": "Not given"
}, {
  "slNo": "50.",
  "caseNo": "CWP no. 2086/ 2019",
  "title": "State of HP versus Ramesh Chand & ors.",
  "nature": "NGT order dated 29.07.2019 challenged being without jurisdiction",
  "nextDate": "Not given"
}, {
  slNo: "51.",
  caseNo: "CWP no. 2874/ 2019",
  title: "Mehar Chand versus State of H.P & ors.",
  nature: "Service matter. Regularization of services and benefits.",
  nextDate: "Not given"
}, {
  slNo: "52.",
  caseNo: "CWPIL no. 12/ 2019",
  title: "Court on its on motion versus State of H.P & ors.",
  nature: "Persons with Disabilities to be provided adequate toilets, barrier free access etc",
  nextDate: "Not given"
}, {
  slNo: "53.",
  caseNo: "CWP no. 2607/ 2019",
  title: "Dev Krishnan versus State of H.P & ors.",
  nature: "Matter pertaining to SADA, Kinnaur.",
  nextDate: "Not given"
}, {
  slNo: "54.",
  caseNo: "CWP no. 1465/ 2019",
  title: "Srijan Sharma versus State of H.P & ors.",
  nature: "Permission to carry out construction in green area of Shimla Planning area.",
  nextDate: "Not given"
}, {
  slNo: "55.",
  caseNo: "CWP no. 604/ 2019",
  title: "Udho Builders Pvt. Ltd. versus State of H.P & ors.",
  nature: "Case of Planning permission for apartments, Solan.",
  nextDate: "Not given"
}, {
  slNo: "56.",
  caseNo: "CWP no. 200/ 2019",
  title: "Devinder Singh versus State of H.P & ors.",
  nature: "Planning permission and approvals MC Dharamshala.",
  nextDate: "Not given"
}, {
  slNo: "57.",
  caseNo: "CWP no. 1140/ 2019",
  title: "Sandeep Kumar versus State of H.P & ors.",
  nature: "Composition of deviations/ unauthorized construction in a building, Manali.",
  nextDate: "Not given"
}, {
  slNo: "58.",
  caseNo: "CWP no. 3120/ 2019",
  title: "Rakesh Kumar versus State of Uttar Pradesh & ors.",
  nature: "Regarding planning permission, Bilaspur",
  nextDate: "Not given"
}, {
  slNo: "59.",
  caseNo: "CWP no. 2610/ 2019",
  title: "PoonamGehlot versus State of Uttar Pradesh & ors.",
  nature: "Regarding challenging of Rule 35 of the HP TCP Act being ultra vires.",
  nextDate: "Not given"
}, {
  slNo: "60.",
  caseNo: "CWP no. 925/ 2019",
  title: "Satpal versus State of H.P & ors.",
  nature: "Planning permission and approvals, SADA Una",
  nextDate: "Not given"
}, {
  "slNo": "61.",
  "caseNo": "CWP no. 1208/ 2018",
  "title": "Mulkh Raj versus State of H.P &amp; ors.",
  "nature": "Planning permission and approvals, Dalhousie.",
  "nextDate": "Not given"
}, {
  "slNo": "62.",
  "caseNo": "CWP no. 1716/ 2018",
  "title": "HP Secretariat Employees Cooperative Housing Society (regd.) versus State of H.P &amp; ors.",
  "nature": "Planning permission and approvals.",
  "nextDate": "Not given"
}, {
  "slNo": "63.",
  "caseNo": "Review petition no. 78/ 2018",
  "title": "State of H.P versus Hitanshu Jistu.\n(Retention policy case.)",
  "nature": "Review for saving Section 30-B of HP TCP (Amendment) Act, 2016 quashed by High Court on 22.12.2017.",
  "nextDate": "Not given"
}, {
  "slNo": "64.",
  "caseNo": "Review petition no. 79/ 2018",
  "title": "State of H.P versus RaghavGoel.\n(Retention policy case.)",
  "nature": "Review for saving Section 30-B of HP TCP (Amendment) Act, 2016 quashed by High Court on 22.12.2017.",
  "nextDate": "Not given"
}, {
  "slNo": "65.",
  "caseNo": "Review petition no. 80/ 2018",
  "title": "State of H.P versus AbhimanyuRathor.\n(Retention policy case.)",
  "nature": "Review for saving Section 30-B of HP TCP (Amendment) Act, 2016 quashed by High Court on 22.12.2017.",
  "nextDate": "Not given"
}, {
  "slNo": "66.",
  "caseNo": "CWP no. 825/ 2018",
  "title": "KundanLalVerma versus State of Uttar Pradesh &amp; ors.",
  "nature": "Implications of Section 30-A of the HP TCP Act and appendix-8 of the HP TCP Rules for exemption of construction in rural areas.(Lambhidhar)",
  "nextDate": "Not given"
}, {
  "slNo": "67.",
  "caseNo": "CWP no. 826/2018",
  "title": "Harvinder Singh versus State of Uttar Pradesh &amp; ors.",
  "nature": "Implications of Section 30-A of the HP TCP Act and appendix-8 of the HP TCP Rules for exemption of construction in rural areas.(Lambhidhar)",
  "nextDate": "Not given"
}, {
  "slNo": "68.",
  "caseNo": "CWP no. 828/ 2018",
  "title": "AkshaySood versus State of Uttar Pradesh &amp; ors.",
  "nature": "Implications of Section 30-A of the HP TCP Act and appendix-8 of the HP TCP Rules for exemption of construction in rural areas.(Lambhidhar)",
  "nextDate": "Not given"
}, {
  "slNo": "69.",
  "caseNo": "CWP no. 829/ 2018",
  "title": "Samni Devi versus State of Uttar Pradesh",
  "nature": "Implications of Section 30-A of the HP TCP Act and appendix-8 of the HP TCP Rules for exemption of construction in rural areas.(Lambhidhar)",
  "nextDate": "Not given"
}, {
  "slNo": "70.",
  "caseNo": "CWP no. 827/ 2018",
  "title": "NeerajGhunta versus State of Uttar Pradesh  &amp; ors.",
  "nature": "Implications of Section 30-A of the HP TCP Act and appendix-8 of the HP TCP Rules for exemption of construction in rural areas.(Lambhidhar)",
  "nextDate": "Not given"
}, {
  "slNo": "71.",
  "caseNo": "CWP no. 831/ 2018",
  "title": "Baldev Singh versus State of Uttar Pradesh &amp; ors.",
  "nature": "Implications of Section 30-A of the HP TCP Act and appendix-8 of the HP TCP Rules for exemption of construction in rural areas.(Lambhidhar)",
  "nextDate": "Not given"
}, {
  "slNo": "72.",
  "caseNo": "CWP no. 832/ 2018",
  "title": "PremThanta versus State of Uttar Pradesh &amp; ors.",
  "nature": "Implications of Section 30-A of the HP TCP Act and appendix-8 of the HP TCP Rules for exemption of construction in rural areas.(Lambhidhar)",
  "nextDate": "Not given"
}, {
  "slNo": "73.",
  "caseNo": "CWP no. 833/ 2018",
  "title": "Lata versus State of Uttar Pradesh &amp; ors.",
  "nature": "Implications of Section 30-A of the HP TCP Act and appendix-8 of the HP TCP Rules for exemption of construction in rural areas.(Lambhidhar)",
  "nextDate": "Not given"
}, {
  "slNo": "74.",
  "caseNo": "CWP no. 834/ 2018",
  "title": "Inder Singh versus State of Uttar Pradesh &amp; ors.",
  "nature": "Implications of Section 30-A of the HP TCP Act and appendix-8 of the HP TCP Rules for exemption of construction in rural areas.(Lambhidhar)",
  "nextDate": "Not given"
}, {
  "slNo": "75.",
  "caseNo": "CWP no. 1648/ 2018 a/w CWP no. 63/ 2019",
  "title": "Yashpal Singh Sandhu versus State of Uttar Pradesh &amp; ors.",
  "nature": "Regarding illegal and unauthorized construction of building and encroachment, MC Dharamshala.",
  "nextDate": "Not given"
}, {
  "slNo": "76.",
  "caseNo": "CWP no. 121/ 2017",
  "title": "Savitri Devi versus State of Uttar Pradesh &amp; ors.",
  "nature": "Planning permission and approvals, Chamba",
  "nextDate": "Not given"
}, {
  "slNo": "77.",
  "caseNo": "RSA no. 264/ 2017",
  "title": "Seema Devi versus State of Uttar Pradesh &amp; ors.",
  "nature": "Substantial question of law.",
  "nextDate": "Not given"
}, {
  "slNo": "78.",
  "caseNo": "CWP no. 383 2017",
  "title": "Vivek Enterprises versus State of Uttar Pradesh &amp; ors.",
  "nature": "Planning permission and approval of Apartments.",
  "nextDate": "Not given"
}, {
  "slNo": "79.",
  "caseNo": "CWP no. 383 2017",
  "title": "Sanya Enterprises versus State of Uttar Pradesh &amp; ors.",
  "nature": "Planning permission and approval of Apartments.",
  "nextDate": "Not given"
}, {
  "slNo": "80.",
  "caseNo": "RSA no. 214/ 2017",
  "title": "MeenaVerma versus State of Uttar Pradesh &amp; ors",
  "nature": "Substantial question of law.",
  "nextDate": "Not given"
}, {
  "slNo": "81.",
  "caseNo": "RSA no. 121/ 2017",
  "title": "Samriti Jain versus State of Uttar Pradesh &amp; ors.",
  "nature": "Substantial question of law./ ATP Parwanoo",
  "nextDate": "Not given."
}, {
  "slNo": "82.",
  "caseNo": "CWP no. 265/2016",
  "title": "Sushma Devi versus State of Uttar Pradesh &amp; ors",
  "nature": "Planning permission and approval, SADA Chintpurni",
  "nextDate": "Not given."
}, {
  "slNo": "83.",
  "caseNo": "CWP no. 944/2016",
  "title": "Ramesh Chand versus State of Uttar Pradesh &amp; ors.",
  "nature": "Unauthorized constructions and illegal encroachment cases in Solan MC area.",
  "nextDate": "Not given."
}, {
  "slNo": "84.",
  "caseNo": "CWP no. 1998/2016 a/w CWPIL no. 26/ 16",
  "title": "DevBhoomi versus State of Uttar Pradesh &amp; ors",
  "nature": "Construction of apartments in Solan.",
  "nextDate": "Not given."
}, {
  "slNo": "85.",
  "caseNo": "RSA no. 289/ 2016",
  "title": "HiraLal versus Ram Krishan/ State of Uttar Pradesh &amp; ors.",
  "nature": "Substantial question of law",
  "nextDate": "Not given."
}, {
  "slNo": "86.",
  "caseNo": "CWP no. 8/2016",
  "title": "SL Anand versus State of Uttar Pradesh &amp; ors.",
  "nature": "Planning permission and approvals.",
  "nextDate": "Not given."
}, {
  "slNo": "87.",
  "caseNo": "CWP no. 990/2016",
  "title": "Shivani Sharma versus State of Uttar Pradesh &amp; ors.",
  "nature": "Installation of communication towers.",
  "nextDate": "Not given."
}, {
  "slNo": "88.",
  "caseNo": "CWP no. 1501/2016",
  "title": "HimlandHousing&nbsp; versus State of Uttar Pradesh &amp; ors.",
  "nature": "Approvals of planning permission and Section 118 HPT&amp;LRA, 1972",
  "nextDate": "Not given."
}, {
  "slNo": "89.",
  "caseNo": "CWP no. 4149/2015",
  "title": "RoshanLal versus State of Uttar Pradesh &amp; ors.",
  "nature": "Unauthorized construction of building and composition of deviations, Rampur.",
  "nextDate": "Not given."
}, {
  "slNo": "90.",
  "caseNo": "CWP no. 2150/2015",
  "title": "Madanjit Singh versus State of Uttar Pradesh &amp; ors.",
  "nature": "Planning permission and approvals Kasauli Planning area.",
  "nextDate": "Not given."
}, {
  "slNo": "91.",
  "caseNo": "CWPIL no. 14/2014",
  "title": "Court on its own motion versus State of Uttar Pradesh &amp; ors.",
  "nature": "Regarding unauthorized constructions across Shimla Kalka National Highway",
  "nextDate": "Not given."
}, {
  "slNo": "92.",
  "caseNo": "LPA no. 121/ 2012",
  "title": "Vijay Kumar Aggarwal versus State of Uttar Pradesh &amp; ors.",
  "nature": "Regarding unauthorized construction and approvals of planning permission, Hotel Gulmarg.",
  "nextDate": "Not given."
}, {
  "slNo": "93.",
  "caseNo": "CWP no. 11636/ 2011",
  "title": "Purujit Singh versus State of Uttar Pradesh &amp; ors.",
  "nature": "Construction of tourism village, Naldhera and Rule 16 of the HP TCP Rules.",
  "nextDate": "Not given."
}, {
  "slNo": "94.",
  "caseNo": "CWP no. 9222/ 2011",
  "title": "Jeet Ram versus State of Uttar Pradesh &amp; ors",
  "nature": "Construction of building under retention policy and to supply list of all unauthorized constructions in Shimla.",
  "nextDate": "Not given."
}, {
  "slNo": "95.",
  "caseNo": "RSA no. 104/ 2010",
  "title": "Vijay Kumar versus State of Uttar Pradesh &amp; ors.",
  "nature": "Substantial question of law to quash the judgment dated 26.11.2009 passed by District Judge, Shimla",
  "nextDate": "Not given."
}, {
  "slNo": "96.",
  "caseNo": "RSA no. 615/ 2009",
  "title": "Tula Ram versus Onkar Chand/ State of Uttar Pradesh &amp; ors.",
  "nature": "Substantial question of law to quash the judgment dated 30.09.2009 passed by District Judge, Shimla",
  "nextDate": "Not given"
}, {
  "slNo": "97.",
  "caseNo": "RFA no. 235/ 2005 a/w 243/ 2005",
  "title": "Nirmal Singh vs. Tibetans Children Village Society.",
  "nature": "Substantial question of law",
  "nextDate": "Not given"
}, {
  "slNo": "98.",
  "caseNo": "CWP no. 511/ 2004",
  "title": "Smt. Usha Devi versus State of Uttar Pradesh &amp; ors.",
  "nature": "Case of planning permission and inter se dispute qua property between private parties.",
  "nextDate": "Not given"
}, {
  "slNo": "99.",
  "caseNo": "Civil Suit no. 45/ 2002",
  "title": "BharamVasu versus State of Uttar Pradesh &amp; ors.",
  "nature": "Civil Suit for recovery between private parties.",
  "nextDate": "Not given"
}, {
  "slNo": "100.",
  "caseNo": "CWP No.&nbsp;&nbsp; /2021-",
  "title": "Devender Singh V/s State of H.P.",
  "nature": "Change of Land use from Residence to Guest House/Hotel",
  "nextDate": "Not given"
}, {
  "slNo": "101.",
  "caseNo": "CWP No. 6584 / 2021",
  "title": "Gaurav Kapret V/s State of HP",
  "nature": "Setting up of Retail outlet dealership at a location between Auckland Tunnel to Dhalli Bye-pass Chowk.",
  "nextDate": "Not given"
}, {
  "slNo": "102.",
  "caseNo": "CWP No. 7496/2021",
  "title": "Shamit Sood V/s State of H.P",
  "nature": "Planning Permission case\nPetitioner is aggrieved by the sanctioning of the map approved by Respondent No. 3 to 5 in favor of Respondent No. 6 &amp; 7 without adopting the proper procedures at the time of sanctioning of same. (Area falls within the ambit of jurisdiction of M.C. Theog and the powers of Director TCP stand delegated to M.C. Theog vide Notification dated 06.06.2016).",
  "nextDate": "Not given"
}, {
  "slNo": "103.",
  "caseNo": "CWP No. 7876/2021",
  "title": "Tarun Bakshi V/s State of H.P.",
  "nature": "Petitioner has submitted his case regarding planning permission of their building plans submitted on 03.08.2107 much prior to the passing of the judgement dated 16.11.2017 by the Ld.NGT in case titled as Yogender Mohansen Gupta. The petitioner prays that his case may be considered as per the law/rules and as per the clarifications opinion rendered by the State Govt. of H.P. and Law Deptt. of the State govt. on 01.02.2018, 29.10.2018, 06.12.216 and 24.1.2019.",
  "nextDate": "22.03.2022"
}, {
  "slNo": "104.",
  "caseNo": "CWP No.&nbsp;&nbsp;&nbsp;&nbsp; /2021",
  "title": "Desh Raj V/s State of H.P.",
  "nature": "Service matter",
  "nextDate": "-------"
}, {
  "slNo": "105.",
  "caseNo": "Caveat&nbsp;&nbsp;&nbsp;&nbsp; 2021",
  "title": "Vidya Sharma",
  "nature": "Service matter",
  "nextDate": "-------"
}, {
  "slNo": "106.",
  "caseNo": "CWP No.&nbsp;&nbsp;&nbsp;&nbsp; 2021",
  "title": "M/s Himland Real Estate V/s State of H.P.",
  "nature": "Case regarding provisions of Section 118 of H.P. Tenancy&nbsp; Land and Reforms Act.",
  "nextDate": "-------"
}, {
  "slNo": "107.",
  "caseNo": "CWP No. 7285/2021",
  "title": "Anita Devi V/s State",
  "nature": "Service Matter\nCase regarding appointment of Jr. Engineer in TCP Deptt.",
  "nextDate": "-------"
}, {
  "slNo": "108",
  "caseNo": "CWP No.&nbsp;&nbsp; /2021",
  "title": "Balbir Singh",
  "nature": "Regarding illegal encroachment done by Respondent No. 6 to 9 on the land of Respondent No. 3 and on petitioner's own land",
  "nextDate": "-------"
}, {
  "slNo": "109.",
  "caseNo": "CWP No.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; /2021",
  "title": "Nahan Gaurav Vikas Sanstha (Regd) V/s State of H.P. &amp; otrs",
  "nature": "The petitioner has filed this petition with an intention to save the environment and forest of the Nahan town.",
  "nextDate": "-------"
}, {
  "slNo": "110.",
  "caseNo": "CWP No. 627/2022",
  "title": "Meena Thakur V/s State",
  "nature": "Planning permission case",
  "nextDate": "-------"
}, {
  "slNo": "111.",
  "caseNo": "CWP No. 547/2022",
  "title": "Sunil Malhotra V/s State of H.P.",
  "nature": "Unauthorized construction Case",
  "nextDate": "-------"
}, {
  "slNo": "112.",
  "caseNo": "Civil Suit",
  "title": "Rajkumar vs. Hem Chand.",
  "nature": "Civil Suit for a declaration under Section 34 of the Specific Relief Act.",
  "nextDate": "Not Given."
}, {
  "slNo": "113.",
  "caseNo": "Civil Suit no. 26/ 2020",
  "title": "Sita Ram Verma vs. State of H.P",
  "nature": "Civil Suit for a permanent prohibitory injunction under Section 38, 39 of Specific Relief Act.",
  "nextDate": "Not Given."
}, {
  "slNo": "114.",
  "caseNo": "Civil Suit",
  "title": "Ramesh Chauhan vs. State of H.",
  "nature": "Civil Suit for a permanent prohibitory injunction under Section 38, 39 of Specific Relief Act.",
  "nextDate": "Not Given."
}, {
  "slNo": "115.",
  "caseNo": "Civil Suit",
  "title": "Gulab Singh vs. Tara Dutt",
  "nature": "Civil Suit for a permanent prohibitory injunction under Section 38, 39 of Specific Relief Act.",
  "nextDate": "18.10.2021"
}, {
  "slNo": "116.",
  "caseNo": "Civil Suit no. 45/ 2019",
  "title": "M/S PrabhaBhagra vs. State of H.P",
  "nature": "Civil Suit for a permanent prohibitory injunction under Section 38, 39 of Specific Relief Act.",
  "nextDate": "27.10.2021"
}, {
  "slNo": "117.",
  "caseNo": "Civil Suit",
  "title": "Subash Chand vs. Surinder Thakur.",
  "nature": "Civil Suit for a permanent prohibitory injunction under Section 38, 39 of Specific Relief Act.",
  "nextDate": "Not Given."
}, {
  "slNo": "118.",
  "caseNo": "Civil Suit",
  "title": "Ashutosh Chauhan vs. YontanNegi",
  "nature": "Civil Suit for a permanent prohibitory injunction under Section 38, 39 of Specific Relief Act.",
  "nextDate": "Not Given."
}, {
  "slNo": "119.",
  "caseNo": "Civil Suit",
  "title": "Kanta vs. kaushalya",
  "nature": "Civil Suit for a permanent prohibitory injunction under Section 38, 39 of Specific Relief Act.",
  "nextDate": "Not Given."
}, {
  "slNo": "120.",
  "caseNo": "Civil Suit",
  "title": "Bhupinder Singh vs. SADA.",
  "nature": "Civil Suit for a permanent prohibitory injunction under Section 38, 39 of Specific Relief Act.",
  "nextDate": "30.10.2021"
}, {
  "slNo": "121.",
  "caseNo": "Civil Suit",
  "title": "Dinesh Sharma vs. State of H.P",
  "nature": "Civil Suit for a permanent prohibitory injunction under Section 38, 39 of Specific Relief Act.",
  "nextDate": "Not Given."
}, {
  "slNo": "122.",
  "caseNo": "Civil Suit",
  "title": "Manoharlal vs. State of H.P.",
  "nature": "Civil Suit for a permanent prohibitory injunction under Section 38, 39 of Specific Relief Act.",
  "nextDate": "Not Given."
}, {
  "slNo": "123.",
  "caseNo": "Civil Suit",
  "title": "Budhmaya vs. State of H.P.",
  "nature": "Civil Suit for a permanent prohibitory injunction under Section 38, 39 of Specific Relief Act.",
  "nextDate": "Not Given."
}, {
  "slNo": "124.",
  "caseNo": "Civil Suit",
  "title": "Asha Devi vs. ChetnaChauhan.",
  "nature": "Civil Suit for a permanent prohibitory injunction under Section 38, 39 of Specific Relief Act.",
  "nextDate": "Not Given."
}];
const StyledTableCell$5 = styled$3(TableCell$1)(({
  theme
}) => ({
  [`&.${tableCellClasses$1.head}`]: {
    backgroundColor: "#1f4a7c",
    color: theme.palette.common.white,
    fontSize: 16
  },
  [`&.${tableCellClasses$1.body}`]: {
    fontSize: 14
  }
}));
const StyledTableRow$5 = styled$3(TableRow)(({
  theme
}) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover
  },
  "&:last-child td, &:last-child th": {
    border: 0
  }
}));
const CourtOrders = () => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = event => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const headerData = [{
    label: 'SL. No'
  }, {
    label: 'Case No'
  }, {
    label: 'Title of the Case'
  }, {
    label: 'Nature of the Case'
  }, {
    label: 'Next Date'
  }];
  return /*#__PURE__*/React__default.createElement(Paper, {
    sx: {
      overflow: "hidden",
      marginY: 2
    }
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "h6",
    style: {
      marginLeft: '20px',
      textDecoration: 'underLine'
    }
  }, "Court Orders"), /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "h5",
    style: {
      marginLeft: '20px',
      marginTop: '20px'
    }
  }, "Supreme Court Of India"), /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "h6",
    style: {
      marginLeft: '20px',
      marginTop: '10px'
    }
  }, "Not Given"), /*#__PURE__*/React__default.createElement(TableContainer, null, /*#__PURE__*/React__default.createElement(Table, {
    "aria-label": "simple table",
    style: {
      width: '95%',
      margin: '10px 20px'
    }
  }, /*#__PURE__*/React__default.createElement(TableHead, null, /*#__PURE__*/React__default.createElement(TableRow, null, headerData.map(item => /*#__PURE__*/React__default.createElement(StyledTableCell$5, {
    key: item.label,
    style: {
      border: '1px solid #ffff'
    }
  }, item.label)))), /*#__PURE__*/React__default.createElement(TableBody, {
    style: {
      backgroundColor: '#fbfaff'
    }
  }, data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => /*#__PURE__*/React__default.createElement(StyledTableRow$5, {
    key: row.slNo
  }, /*#__PURE__*/React__default.createElement(StyledTableCell$5, null, index + 1 + page * rowsPerPage), /*#__PURE__*/React__default.createElement(StyledTableCell$5, null, row.caseNo), /*#__PURE__*/React__default.createElement(StyledTableCell$5, null, row.title), /*#__PURE__*/React__default.createElement(StyledTableCell$5, null, row.nature), /*#__PURE__*/React__default.createElement(StyledTableCell$5, null, row.nextDate)))))), /*#__PURE__*/React__default.createElement(TablePagination, {
    rowsPerPageOptions: [10, 25, 50, 75, 100],
    component: "div",
    count: data.length,
    rowsPerPage: rowsPerPage,
    page: page,
    onPageChange: handleChangePage,
    onRowsPerPageChange: handleChangeRowsPerPage
  }));
};

const rows$4 = [{
  slNo: 1,
  description: "Circular mandating online submission of Applications",
  date: '10-Dec-2020',
  pdfUrl: "6707df67-0960-4231-a01e-dda719d885a7"
}];
const AdminstrativeOrders = () => {
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(TableContainer$2, {
    component: Paper$2
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h6",
    style: {
      margin: '20px'
    }
  }, "AdminstrativeOrders"), /*#__PURE__*/React__default.createElement(Table$5, {
    "aria-label": "Sample Table",
    style: {
      width: '90%',
      margin: '30px'
    }
  }, /*#__PURE__*/React__default.createElement(TableHead$2, null, /*#__PURE__*/React__default.createElement(TableRow$2, {
    style: {
      background: '#1F4A7C',
      height: '20px'
    }
  }, /*#__PURE__*/React__default.createElement(TableCell$2, {
    style: {
      width: '5%',
      color: 'white'
    }
  }, "SL. No"), /*#__PURE__*/React__default.createElement(TableCell$2, {
    style: {
      width: '60%',
      color: 'white'
    }
  }, "Headline"), /*#__PURE__*/React__default.createElement(TableCell$2, {
    style: {
      width: '10%',
      color: 'white'
    }
  }, "Notification Date"), /*#__PURE__*/React__default.createElement(TableCell$2, {
    style: {
      width: '5%',
      color: 'white'
    }
  }, "Download"))), /*#__PURE__*/React__default.createElement(TableBody$2, null, rows$4.map(row => /*#__PURE__*/React__default.createElement(TableRow$2, {
    key: row.slNo
  }, /*#__PURE__*/React__default.createElement(TableCell$2, {
    component: "th",
    scope: "row"
  }, row.slNo), /*#__PURE__*/React__default.createElement(TableCell$2, null, row.description), /*#__PURE__*/React__default.createElement(TableCell$2, null, row.date), /*#__PURE__*/React__default.createElement(TableCell$2, {
    onClick: () => getDocumentByFileStoreId(row.pdfUrl, setIsPreviewLoading)
  }, /*#__PURE__*/React__default.createElement(AiFillFilePdf, {
    style: {
      width: '30px',
      height: '30px',
      color: '#f44b55',
      cursor: 'pointer'
    }
  }))))))));
};

const rows$5 = [{
  slNo: 1,
  description: "New * Notification of IDP SHIMLA 13-08-2015*.",
  date: '06-Aug-2016',
  pdfUrl: "922b7c5a-2cf4-49cd-acd8-44dad4978bfc"
}, {
  slNo: 2,
  description: "Clarification regarding mis - interpreting of Basements",
  date: '24-May-2019',
  pdfUrl: "c4c36397-cabb-41f7-beff-8ad6b043dd46"
}, {
  slNo: 3,
  description: "Notice for publication of proposed amendment(s) in development plans.",
  date: '28-Sep-2016',
  pdfUrl: "a173e383-59e9-432b-b243-4f7e37d016ba"
}, {
  slNo: 4,
  description: "Amendment in IDP Shimla notification dated 28/06/2016.",
  date: '28-Sep-2016',
  pdfUrl: "e1d4eac0-c3d0-48b0-b09c-165a3b8d4303"
}, {
  slNo: 5,
  description: "EXEMPTIONS IN RURAL AREAS-CLARIFICATIONS THEREOF",
  date: '28-Sep-2016',
  pdfUrl: "0507dbe5-9d3f-48e1-953c-e4c7be478f72"
}, {
  slNo: 6,
  description: "Policy on section 16(c) of HPTCP, Act 1977",
  date: '28-Sep-2016',
  pdfUrl: "60eefb8e-bd0f-4db6-bcf9-ab577a8e6945"
}, {
  slNo: 7,
  description: "Policy for Establishment of “Dr. A.P.J. Abdul Kalam e-Map Centre” in Town and Country Planning Department and Special Area Development Authority (SADA).",
  date: '28-Sep-2016',
  pdfUrl: "0c42c936-8bce-4f96-bf1c-d17c107edc58"
}, {
  slNo: 8,
  description: "Comparison between notifications dated 28.02.2011 and 13.08.2015 in respect of IDP,Shimla.",
  date: '28-Sep-2016',
  pdfUrl: "5dd0d2d5-1ebd-4c3d-8b25-711e6530b876"
}, {
  slNo: 9,
  description: "Policy for setting up Mobile Communication towers, Dated 22-08-2016 and 4-10-2006 and Clarification on Appendix-9 in HPTCP Rules -2014.",
  date: '05-Aug-2016',
  pdfUrl: "8b51164f-e483-4a59-9c1d-5102d95de0d3"
}, {
  slNo: 10,
  description: "Revised Sujanpur Planning Area",
  date: '19-Jul-2016',
  pdfUrl: "4151868c-67e5-4409-a3f4-ad4ab972f61c"
}, {
  slNo: 11,
  description: "Revised Joginder nager Planning area",
  date: '19-Jul-2016',
  pdfUrl: "848cf44c-dd2f-4311-b0d3-20d13bdeecf1"
}, {
  slNo: 12,
  description: "Revised Ghumarwin Planning Area ",
  date: '19-Jul-2016',
  pdfUrl: "6292b147-2e07-4231-bbfc-a13e32b436a3"
}, {
  slNo: 13,
  description: "Revised Bhota Planning Area ",
  date: '19-Jul-2016',
  pdfUrl: "a15dedcc-3196-48b5-8009-051e2db97055"
}, {
  slNo: 14,
  description: "Ceasing of Shri Naina Devi Ji Planning Area",
  date: '19-Jul-2016',
  pdfUrl: "b5073eaa-e07d-492c-9ad9-7a1f91ec3c5b"
}, {
  slNo: 15,
  description: "Extention in Bilaspur Planning Area",
  date: '19-Jul-2016',
  pdfUrl: "50e21f8e-c02e-4782-9bf2-b002ce17e1f4"
}, {
  slNo: 16,
  description: "Public Service Guarantee Act",
  date: '05-Apr-2016',
  pdfUrl: "303828e7-eab3-41f9-ba99-22b65ef330b8"
}, {
  slNo: 17,
  description: "Kasauli Development Plan amendment notification",
  date: '20-Nov-2015',
  pdfUrl: "e4b53195-70c1-45d7-a7e2-59862fa81004"
}];
const StyledTableCell$6 = styled$3(TableCell$1)(({
  theme
}) => ({
  [`&.${tableCellClasses$1.head}`]: {
    backgroundColor: "#1f4a7c",
    color: theme.palette.common.white,
    fontSize: 16
  },
  [`&.${tableCellClasses$1.body}`]: {
    fontSize: 14
  }
}));
const StyledTableRow$6 = styled$3(TableRow$2)(({
  theme
}) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover
  },
  "&:last-child td, &:last-child th": {
    border: 0
  }
}));
const NotificationTCP = () => {
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(TableContainer$2, {
    component: Paper$2
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h6",
    style: {
      margin: '20px'
    }
  }, "Other Notifications"), /*#__PURE__*/React__default.createElement(Table$5, {
    "aria-label": "Sample Table",
    style: {
      width: '90%',
      margin: '30px'
    }
  }, /*#__PURE__*/React__default.createElement(TableHead$2, null, /*#__PURE__*/React__default.createElement(StyledTableRow$6, {
    style: {
      background: '#1F4A7C',
      height: '20px',
      color: 'white'
    }
  }, /*#__PURE__*/React__default.createElement(StyledTableCell$6, {
    style: {
      color: 'white',
      border: '1px solid #ffff'
    }
  }, "SL. No"), /*#__PURE__*/React__default.createElement(StyledTableCell$6, {
    style: {
      color: 'white',
      border: '1px solid #ffff'
    }
  }, "Headline"), /*#__PURE__*/React__default.createElement(StyledTableCell$6, {
    style: {
      color: 'white',
      border: '1px solid #ffff'
    }
  }, "Notification Date"), /*#__PURE__*/React__default.createElement(StyledTableCell$6, {
    style: {
      color: 'white',
      border: '1px solid #ffff'
    }
  }, "Download"))), /*#__PURE__*/React__default.createElement(TableBody$2, null, rows$5.map(row => /*#__PURE__*/React__default.createElement(StyledTableRow$6, {
    key: row.slNo
  }, /*#__PURE__*/React__default.createElement(StyledTableCell$6, {
    component: "th",
    scope: "row"
  }, row.slNo), /*#__PURE__*/React__default.createElement(StyledTableCell$6, null, row.description), /*#__PURE__*/React__default.createElement(StyledTableCell$6, null, row.date), /*#__PURE__*/React__default.createElement(StyledTableCell$6, {
    onClick: () => getDocumentByFileStoreId(row.pdfUrl, setIsPreviewLoading)
  }, /*#__PURE__*/React__default.createElement(AiFillFilePdf, {
    style: {
      width: '30px',
      height: '30px',
      color: '#f44b55',
      cursor: 'pointer'
    }
  }))))))));
};

function NotificationTCPAct() {
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'column'
    }
  }, /*#__PURE__*/React__default.createElement(NotificationTCP, null), /*#__PURE__*/React__default.createElement(AdminstrativeOrders, null));
}

const rows$6 = [{
  slNo: 1,
  isUrl: false,
  description: "Seniority List of Gazetted Officials",
  pdfUrl: "f9d77f7c-bbe0-402a-89ef-2dcebe18a221"
}, {
  slNo: 2,
  isUrl: true,
  description: "Seniority List of Non Gazetted Official",
  pdfUrl: "https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Seniority_list_of_Non_Gazetted_Official_.pdf"
}, {
  slNo: 3,
  isUrl: false,
  description: "DETAILS OF SANCTIONED/FILLED/VACANT POSTS IN TOWN & COUNTRY PLANNING DEPARTMENT AS ON 31.03.2019",
  pdfUrl: "cc5544b7-c6df-4630-aa16-46c42dd028b7"
}, {
  slNo: 4,
  isUrl: false,
  description: "R & P Rules for Surveyor Class-III",
  pdfUrl: "a7cfddee-dd7c-4ea5-b9e5-aef1ce11b651"
}, {
  slNo: 5,
  isUrl: false,
  description: "R & P Rules for Sr. Planning Draughtman Class-II",
  pdfUrl: "94c1dac7-714d-4b70-bcb9-a0762d7e2bcd"
}, {
  slNo: 6,
  isUrl: false,
  description: " R & P Rules for Research Asstt. Class-III",
  pdfUrl: "5fc5a456-bfa0-40b2-a05f-7d1204297ae8"
}, {
  slNo: 7,
  isUrl: false,
  description: " R & P Rules for Research Officer Class-II",
  pdfUrl: "ef7057f8-9a32-418e-a840-7805e73c194d"
}, {
  slNo: 8,
  isUrl: true,
  description: "R & P Rules for Planning Officer Class-I",
  pdfUrl: "https://www.tcp.hp.gov.in/Application/uploadDocuments/content/P.O_Rules_2.pdf"
}, {
  slNo: 9,
  isUrl: false,
  description: "R & P Rules for Jr. Engg. Class-III",
  pdfUrl: "37dff1f0-1dc1-4813-8977-f792a3b8c7df"
}, {
  slNo: 10,
  isUrl: false,
  description: "R & P Rules for Jr. Engg. Class-III",
  pdfUrl: "6049567a-89c5-45c5-970c-9b3677aae112"
}, {
  slNo: 11,
  isUrl: false,
  description: "R & P Rules for Jr. Draughtsman Class-III",
  pdfUrl: "1eebc371-c030-4392-b1fa-643e92060d08"
}, {
  slNo: 12,
  isUrl: false,
  description: "R & P Rules for Ferro Printer Class-III Part-II",
  pdfUrl: "8eb92d88-a2af-4b00-9c09-bf3746b34339"
}, {
  slNo: 13,
  isUrl: false,
  description: "R & P Rules for Ferro Printer Class-III",
  pdfUrl: "d01b4b89-ebd7-4a70-a067-c187d53e2c96"
}, {
  slNo: 14,
  isUrl: false,
  description: "R & P Rules for Draughtman Class-III",
  pdfUrl: "fc8f2b4e-ee8b-4251-8933-e65b81bfd2fb"
}, {
  slNo: 15,
  isUrl: false,
  description: "R & P Rules for Assistant Town Planner Class-I",
  pdfUrl: "9d9a0b04-c3ed-467d-bc47-8170ea5a80a8"
}, {
  slNo: 16,
  isUrl: false,
  description: "R & P Rules for Field Investigator Class-III Part-II",
  pdfUrl: "4c7fc858-60de-4090-a05c-f17b5db232b5"
}, {
  slNo: 17,
  isUrl: false,
  description: "R & P Rules for Field Investigator Class-III",
  pdfUrl: "774a10f4-1cc0-41c3-98c4-3f8c81d4d26e"
}, {
  slNo: 18,
  isUrl: false,
  description: " R & P Rules of Peon",
  pdfUrl: "da6138d9-6e44-4c00-9fd2-a104dc8286af"
}, {
  slNo: 19,
  isUrl: false,
  description: " R & P Rules of Chainman",
  pdfUrl: "8e0dc69d-fe97-4840-9369-7908dd18156d"
}, {
  slNo: 20,
  isUrl: false,
  description: " Rules for Regulating the Payment for the Grant-in-Aid",
  pdfUrl: "6c0cb9d4-b0d5-4df3-99e2-432fc6ec9228"
}, {
  slNo: 21,
  isUrl: false,
  description: " R & P Rules of Officers",
  pdfUrl: "0e8d8e70-d49b-4e62-9a8e-639ad6435a28"
}, {
  slNo: 22,
  isUrl: false,
  description: "Job Profile",
  pdfUrl: "016c3651-2f1e-4c84-9016-9f3f304fe720"
}, {
  slNo: 23,
  isUrl: false,
  description: "Syallbus for Driver",
  pdfUrl: "d441a723-c7ed-4960-94f6-a706a6c584c5"
}];
const StyledTableCell$7 = styled$3(TableCell$1)(({
  theme
}) => ({
  [`&.${tableCellClasses$1.head}`]: {
    backgroundColor: "#1f4a7c",
    color: theme.palette.common.white,
    fontSize: 16
  },
  [`&.${tableCellClasses$1.body}`]: {
    fontSize: 14
  }
}));
const StyledTableRow$7 = styled$3(TableRow$2)(({
  theme
}) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover
  },
  "&:last-child td, &:last-child th": {
    border: 0
  }
}));
const handlePdfDownload = pdfUrl => {
  window.open(pdfUrl);
};
const ServiceMatter = () => {
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(TableContainer$2, {
    component: Paper$2
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h6",
    style: {
      margin: '20px'
    }
  }, "Service Matter"), /*#__PURE__*/React__default.createElement(Table$5, {
    "aria-label": "Sample Table",
    style: {
      width: '90%',
      margin: '30px'
    }
  }, /*#__PURE__*/React__default.createElement(TableHead$2, null, /*#__PURE__*/React__default.createElement(StyledTableRow$7, {
    style: {
      background: '#1F4A7C',
      height: '20px',
      color: 'white'
    }
  }, /*#__PURE__*/React__default.createElement(TableCell$1, {
    style: {
      width: '5%',
      border: '1px solid #ffff'
    }
  }, "SL. No"), /*#__PURE__*/React__default.createElement(TableCell$1, {
    style: {
      border: '1px solid #ffff'
    }
  }, "Headline"), /*#__PURE__*/React__default.createElement(TableCell$1, {
    style: {
      border: '1px solid #ffff'
    }
  }, "Download"))), /*#__PURE__*/React__default.createElement(TableBody$2, null, rows$6.map(row => /*#__PURE__*/React__default.createElement(StyledTableRow$7, {
    key: row.slNo
  }, /*#__PURE__*/React__default.createElement(StyledTableCell$7, {
    component: "th",
    scope: "row"
  }, row.slNo), /*#__PURE__*/React__default.createElement(StyledTableCell$7, null, row.description), /*#__PURE__*/React__default.createElement(StyledTableCell$7, {
    onClick: () => row !== null && row !== void 0 && row.isUrl ? handlePdfDownload(row.pdfUrl) : getDocumentByFileStoreId(row.pdfUrl, setIsPreviewLoading)
  }, /*#__PURE__*/React__default.createElement(AiFillFilePdf, {
    style: {
      width: '30px',
      height: '30px',
      color: '#f44b55',
      cursor: 'pointer'
    }
  }))))))));
};

const PhotoGallery = () => {
  return /*#__PURE__*/React__default.createElement(Card, {
    style: {
      minHeight: '350px',
      margin: '50px'
    }
  }, /*#__PURE__*/React__default.createElement(CardContent, {
    style: {
      padding: '30px'
    }
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h5",
    style: {
      borderBottom: '1px solid currentColor',
      marginBottom: '1rem',
      paddingBottom: "5px",
      fontWeight: 'bold'
    }
  }, "Photo Gallery"), /*#__PURE__*/React__default.createElement(Typography, {
    variant: "p"
  }, "No Gallery Details Available")));
};

const VideoGallery = () => {
  return /*#__PURE__*/React__default.createElement(Card, {
    style: {
      minHeight: '350px',
      margin: '50px'
    }
  }, /*#__PURE__*/React__default.createElement(CardContent, {
    style: {
      padding: '30px'
    }
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h5",
    style: {
      borderBottom: '1px solid currentColor',
      marginBottom: '1rem',
      paddingBottom: "5px",
      fontWeight: 'bold'
    }
  }, "Video Gallery"), /*#__PURE__*/React__default.createElement(Typography, {
    variant: "p"
  }, "No Gallery Details Available")));
};

const HeritageGallery = () => {
  return /*#__PURE__*/React__default.createElement(Card, {
    style: {
      minHeight: '350px',
      margin: '50px'
    }
  }, /*#__PURE__*/React__default.createElement(CardContent, {
    style: {
      padding: '30px'
    }
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h5",
    style: {
      borderBottom: '1px solid currentColor',
      marginBottom: '1rem',
      paddingBottom: "5px",
      fontWeight: 'bold'
    }
  }, "Heritage Gallery"), /*#__PURE__*/React__default.createElement(Typography, {
    variant: "p"
  }, "No Gallery Details Available")));
};

const rows$7 = [{
  slNo: 1,
  isurl: true,
  description: "Latest Order - Delegation of Power under TCP Act,1977 to Executive Officers/Secretaries of Urban Local Bodies",
  pdfUrl: "https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Department_notification.pdf"
}, {
  slNo: 2,
  isurl: false,
  description: "Delegation of powers under TCP Act",
  pdfUrl: "edd56c3d-051c-473d-be10-8eede0c53fc2"
}, {
  slNo: 3,
  isurl: true,
  description: "Dealing of cases for Regularization of Deviations and Un-authorised Constructions under Section 30-B of the Uttar Pradesh Town and Country Planning (Amendment) Ordinance,2016( Ordinance No. 1 of 2016)",
  pdfUrl: "https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Deligation_of_section_30_B_to_.pdf"
}, {
  slNo: 4,
  isurl: true,
  description: "Delegation of Power under TCP Act,1977 to Commissioner,M.C Dharamshala",
  pdfUrl: "https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Deligation_of_power_MC_Dharamshal.pdf"
}, {
  slNo: 5,
  isurl: true,
  description: "Deligation of Power under section 30-B of Uttar Pradesh Town and country Planning (Amendment)Act,2016(Act No. of 2017)",
  pdfUrl: "https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Deligation_of_power.pdf"
}, {
  slNo: 6,
  isurl: true,
  description: "Competent Authority of dealing cases under Section 30-B of the Uttar Pradesh Town and Country Planning (Amendment) Act,2016(Act No.1 of 2017)",
  pdfUrl: "https://www.tcp.hp.gov.in/Application/uploadDocuments/content/compitent_Authority.pdf"
}, {
  slNo: 7,
  isurl: true,
  description: "Delegation of  power to ULBs under Single Window System.",
  pdfUrl: "https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Deligation_of_Power_14-05-2017.pdf"
}, {
  slNo: 8,
  isurl: false,
  description: " Delegation of power in respect of Flatted/Plotted Colonies or Real Estate Projects",
  pdfUrl: "2113fc56-c40c-4846-98a7-c4238b92af2c"
}, {
  slNo: 9,
  isurl: false,
  description: "Delegation of Power to 20 constituted as planning area.(2018).",
  pdfUrl: "3bf55142-2381-4256-8449-75a447d93be9"
}, {
  slNo: 10,
  isurl: false,
  description: "Delegation of Power to Enforcement Wing.",
  pdfUrl: "23ee2fed-435a-432e-9d33-5550856f97c3"
}, {
  slNo: 11,
  isurl: false,
  description: "Delegation of Power to BBNDA.",
  pdfUrl: "487b19f8-6a5b-491e-b297-700bc8950278"
}, {
  slNo: 12,
  isurl: false,
  description: "Delegation of Power for new MC Solan, MC Palampur & MC Mandi.",
  pdfUrl: "f071f6d5-f6c5-4ff0-a0f3-dfaaf9c59788"
}];
const handlePdfDownload$1 = pdfUrl => {
  window.open(pdfUrl);
};
const PowerDelegation = () => {
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  return /*#__PURE__*/React__default.createElement(TableContainer$2, {
    component: Paper$2
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h6",
    style: {
      margin: '20px'
    }
  }, "Delegation of Powers"), /*#__PURE__*/React__default.createElement(Table$5, {
    "aria-label": "Sample Table",
    style: {
      width: '90%',
      margin: '30px'
    }
  }, /*#__PURE__*/React__default.createElement(TableHead$2, null, /*#__PURE__*/React__default.createElement(TableRow$2, {
    style: {
      background: '#1F4A7C',
      height: '20px'
    }
  }, /*#__PURE__*/React__default.createElement(TableCell$2, {
    style: {
      width: '5%',
      color: 'white'
    }
  }, "SL. No"), /*#__PURE__*/React__default.createElement(TableCell$2, {
    style: {
      width: '75%',
      color: 'white'
    }
  }, "Description"), /*#__PURE__*/React__default.createElement(TableCell$2, {
    style: {
      width: '5%',
      color: 'white'
    }
  }, "PDF"))), /*#__PURE__*/React__default.createElement(TableBody$2, null, rows$7.map(row => /*#__PURE__*/React__default.createElement(TableRow$2, {
    key: row.slNo
  }, /*#__PURE__*/React__default.createElement(TableCell$2, {
    component: "th",
    scope: "row"
  }, row.slNo), /*#__PURE__*/React__default.createElement(TableCell$2, null, row.description), /*#__PURE__*/React__default.createElement(TableCell$2, {
    onClick: () => row.isurl ? handlePdfDownload$1(row.pdfUrl) : getDocumentByFileStoreId(row.pdfUrl, setIsPreviewLoading)
  }, /*#__PURE__*/React__default.createElement(AiFillFilePdf, {
    style: {
      width: '30px',
      height: '30px',
      color: '#1F4A7C'
    }
  })))))));
};

const records$2 = [{
  photo: 'https://tcp.hp.gov.in/Application/uploadDocuments/devlopmentPlan/PlanImeage20171226_124046.jpg',
  headline1: 'Amb Gagret',
  headline2: 'Amb Gagret Development Plan',
  headline3: '',
  Pdf1: 'https://tcp.hp.gov.in/Application/uploadDocuments/devlopmentPlan/PlanDoc020171226_124046.pdf',
  Pdf2: ''
}, {
  photo: 'https://tcp.hp.gov.in/Application/uploadDocuments/devlopmentPlan/PlanImeage20150127_180049.jpg',
  headline1: 'BADDI BAROTIWALA NALAGARH DEVELOPMENT AUTHORITY',
  headline2: 'Development Plan',
  headline3: 'General Development Control Regulations',
  Pdf1: 'https://tcp.hp.gov.in/Application/uploadDocuments/devlopmentPlan/PlanDoc020160604_155907.pdf',
  Pdf2: 'https://tcp.hp.gov.in/Application/uploadDocuments/devlopmentPlan/PlanDoc120191106_111830.pdf'
}, {
  photo: 'https://tcp.hp.gov.in/Application/uploadDocuments/devlopmentPlan/PlanImeage20171223_142125.jpg',
  headline1: 'Baijnath',
  headline2: 'Baijnath Development Plan',
  headline3: '',
  Pdf1: 'https://tcp.hp.gov.in/Application/uploadDocuments/devlopmentPlan/PlanDoc020171223_142125.pdf',
  Pdf2: ''
}, {
  photo: 'https://tcp.hp.gov.in/Application/uploadDocuments/devlopmentPlan/PlanImeage20170325_161944.jpg',
  headline1: 'Barog',
  headline2: 'Barog',
  headline3: '',
  Pdf1: 'https://tcp.hp.gov.in/Application/uploadDocuments/devlopmentPlan/PlanDoc020170325_161944.pdf',
  Pdf2: ''
}, {
  photo: 'https://tcp.hp.gov.in/Application/uploadDocuments/devlopmentPlan/PlanImeage20150127_180726.jpg',
  headline1: 'Bilaspur',
  headline2: 'Development Plan',
  headline3: '',
  Pdf1: 'https://tcp.hp.gov.in/Application/uploadDocuments/devlopmentPlan/PlanDoc020160604_154135.pdf',
  Pdf2: ''
}, {
  photo: 'https://tcp.hp.gov.in/Application/uploadDocuments/devlopmentPlan/PlanImeage20171227_123452.jpg',
  headline1: 'Bir-Billing',
  headline2: 'Bir-Billing Development Plan',
  headline3: '',
  Pdf1: 'https://tcp.hp.gov.in/Application/uploadDocuments/devlopmentPlan/PlanDoc020171227_123452.pdf',
  Pdf2: ''
}, {
  photo: 'https://tcp.hp.gov.in/Application/uploadDocuments/devlopmentPlan/PlanImeage20161017_153953.jpg',
  headline1: 'Chamba',
  headline2: 'Development Plan',
  headline3: 'Map Chamba Development Plan',
  Pdf1: 'https://tcp.hp.gov.in/Application/uploadDocuments/devlopmentPlan/PlanDoc020161017_153953.pdf',
  Pdf2: 'https://tcp.hp.gov.in/Application/uploadDocuments/devlopmentPlan/PlanDoc120161017_154849.pdf'
}, {
  photo: 'https://tcp.hp.gov.in/Application/uploadDocuments/devlopmentPlan/PlanImeage20230307_125911.jpg',
  headline1: 'Chamumda Nandkeshwar Dham DP-2037',
  headline2: 'Chamumda Nandkeshwar Dham DP-2037',
  headline3: '',
  Pdf1: 'https://tcp.hp.gov.in/Application/uploadDocuments/devlopmentPlan/PlanDoc020230307_125911.pdf',
  Pdf2: ''
}, {
  photo: 'https://tcp.hp.gov.in/Application/uploadDocuments/devlopmentPlan/PlanImeage20150127_174621.jpg',
  headline1: 'DALHOUISE',
  headline2: 'Development Plan',
  headline3: '',
  Pdf1: 'https://tcp.hp.gov.in/Application/uploadDocuments/devlopmentPlan/PlanDoc020171226_122950.pdf',
  Pdf2: ''
}, {
  photo: 'https://tcp.hp.gov.in/Application/uploadDocuments/devlopmentPlan/PlanImeage20150127_174852.jpg',
  headline1: 'DHARAMSHALA',
  headline2: 'Development Plan',
  headline3: '',
  Pdf1: 'https://tcp.hp.gov.in/Application/uploadDocuments/devlopmentPlan/PlanDoc020171226_122950.pdf',
  Pdf2: ''
}, {
  photo: 'https://tcp.hp.gov.in/Application/uploadDocuments/devlopmentPlan/PlanImeage20150127_174852.jpg',
  headline1: 'DHARAMSHALA',
  headline2: 'Development Plan',
  headline3: '',
  Pdf1: 'https://tcp.hp.gov.in/Application/uploadDocuments/devlopmentPlan/PlanDoc020171226_122950.pdf',
  Pdf2: ''
}];
const columns$2 = [{
  id: 'photo',
  label: 'Photo',
  width: '15%'
}, {
  id: 'headline',
  label: 'Headline',
  width: '60%'
}, {
  id: 'download',
  label: 'Download',
  width: '15%'
}];
const rowsPerPage$2 = 10;
const PdfTableCell = ({
  pdf1,
  pdf2,
  onClick
}) => {
  return /*#__PURE__*/React__default.createElement(TableCell, {
    onClick: onClick
  }, /*#__PURE__*/React__default.createElement("div", null, pdf1 && /*#__PURE__*/React__default.createElement("a", {
    href: pdf1,
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React__default.createElement(AiFillFilePdf, {
    style: {
      width: '30px',
      height: '30px',
      color: '#f44b55',
      cursor: 'pointer',
      marginRight: '10px'
    }
  }))), /*#__PURE__*/React__default.createElement("div", null, " ", pdf2 && /*#__PURE__*/React__default.createElement("a", {
    href: pdf2,
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React__default.createElement(AiFillFilePdf, {
    style: {
      width: '30px',
      height: '30px',
      color: '#f44b55',
      cursor: 'pointer'
    }
  }))));
};
const DevelopmentPlan = () => {
  const [page, setPage] = useState(0);
  const handleChangePage = (_, newPage) => {
    setPage(newPage);
  };
  const handlePdfDownload = pdfUrl => {
    window.open(pdfUrl);
  };
  return /*#__PURE__*/React__default.createElement(TableContainer, {
    component: Paper
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "h6",
    style: {
      margin: '20px'
    }
  }, "Development Plan"), /*#__PURE__*/React__default.createElement(Table, {
    style: {
      width: '90%',
      margin: '30px'
    }
  }, /*#__PURE__*/React__default.createElement(TableHead, null, /*#__PURE__*/React__default.createElement(TableRow, {
    style: {
      background: '#1F4A7C',
      height: '20px'
    }
  }, columns$2.map(column => /*#__PURE__*/React__default.createElement(TableCell, {
    key: column.id,
    style: {
      color: 'white',
      width: column.width
    }
  }, column.label)))), /*#__PURE__*/React__default.createElement(TableBody, null, records$2.slice(page * rowsPerPage$2, page * rowsPerPage$2 + rowsPerPage$2).map(record => /*#__PURE__*/React__default.createElement(TableRow, {
    key: record.id
  }, /*#__PURE__*/React__default.createElement(TableCell, null, /*#__PURE__*/React__default.createElement("img", {
    src: record.photo,
    alt: record.name,
    width: "80",
    height: "80"
  })), /*#__PURE__*/React__default.createElement(TableCell, null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      fontWeight: 'bold'
    }
  }, record.headline1), /*#__PURE__*/React__default.createElement("div", null, record.headline2), /*#__PURE__*/React__default.createElement("div", null, record.headline3)), /*#__PURE__*/React__default.createElement(PdfTableCell, {
    pdf1: record.Pdf1,
    pdf2: record.Pdf2,
    onClick: () => handlePdfDownload(record.Pdf1 || record.Pdf2)
  }))))), /*#__PURE__*/React__default.createElement(TablePagination, {
    rowsPerPageOptions: [],
    component: "div",
    count: records$2.length,
    rowsPerPage: rowsPerPage$2,
    page: page,
    onPageChange: handleChangePage
  }));
};

const useStyles$l = makeStyles$2({
  button: {
    borderRadius: '10px',
    color: '#154773',
    textDecoration: 'none',
    fontSize: '14px',
    display: 'block',
    margin: '10px',
    '&:hover': {
      textDecoration: 'underline'
    }
  },
  view: {
    padding: "6px 12px",
    border: "1px solid #122b40",
    color: "#fff",
    backgroundColor: " #012951",
    borderRadius: '4px'
  }
});
const CitizenAndOthers = () => {
  const classes = useStyles$l();
  return /*#__PURE__*/React__default.createElement(Card, {
    style: {
      maxWidth: 'fit-content',
      margin: '10px',
      boxShadow: 'rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;'
    }
  }, /*#__PURE__*/React__default.createElement(CardContent, null, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h6",
    style: {
      backgroundColor: '#1F4A7C',
      color: "#fff",
      padding: "10px",
      fontSize: '15px'
    }
  }, "Citizens & Others"), /*#__PURE__*/React__default.createElement("p", {
    variant: "body1",
    href: "/digit-ui/citizen/obps/form11",
    component: "p",
    className: classes.button
  }, "Apply for  permission of  sub-division/Development  of land   ", /*#__PURE__*/React__default.createElement("strong", null, "Form -11")), /*#__PURE__*/React__default.createElement(Divider, null), /*#__PURE__*/React__default.createElement("p", {
    variant: "body1",
    href: "/digit-ui/citizen/obps/edcrscrutiny/apply/home",
    component: "p",
    className: classes.button
  }, "Apply for permission of Development of land and Proposed/ existing building construction  ", /*#__PURE__*/React__default.createElement("strong", null, "Form - 12")), /*#__PURE__*/React__default.createElement(Divider, null), /*#__PURE__*/React__default.createElement("p", {
    variant: "body1",
    href: "/digit-ui/citizen/profile",
    component: "p",
    className: classes.button
  }, "Apply for registration as new estate agent      ", /*#__PURE__*/React__default.createElement("strong", null, "Form - 35")), /*#__PURE__*/React__default.createElement(Divider, null), /*#__PURE__*/React__default.createElement("p", {
    variant: "body1",
    href: "/digit-ui/citizen/profile",
    component: "p",
    className: classes.button
  }, "Apply for renewal of registration  as estate agent    ", /*#__PURE__*/React__default.createElement("strong", null, "Form - 39")), /*#__PURE__*/React__default.createElement(Divider, null), /*#__PURE__*/React__default.createElement("p", {
    variant: "body1",
    href: "/digit-ui/citizen/profile",
    component: "p",
    className: classes.button
  }, "Apply for appeal   ", /*#__PURE__*/React__default.createElement("strong", null, "Form - 16")), /*#__PURE__*/React__default.createElement(Divider, null), /*#__PURE__*/React__default.createElement("p", {
    variant: "body1",
    href: "/digit-ui/citizen/obps/form26",
    component: "p",
    className: classes.button
  }, "Apply for composition of offences  to extent  of  permissible limit of 10%  ", /*#__PURE__*/React__default.createElement("strong", null, "Form - 26")), /*#__PURE__*/React__default.createElement(Divider, null), /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'right',
      marginLeft: '100px',
      marginTop: '30px'
    }
  }, /*#__PURE__*/React__default.createElement(Link$1, {
    to: "profile"
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    className: classes.view,
    style: {
      padding: '6px 12px',
      backgroundColor: '#012951',
      color: 'white',
      border: '1px solid #122b40',
      marginRight: '20px'
    }
  }, "Apply Online")), /*#__PURE__*/React__default.createElement(Link$1, {
    to: "profile"
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    className: classes.view,
    style: {
      padding: '6px 12px',
      backgroundColor: '#012951',
      color: 'white',
      border: '1px solid #122b40'
    }
  }, "Sign In")))));
};

const useStyles$m = makeStyles$2({
  button: {
    borderRadius: '10px',
    color: '#154773',
    textDecoration: 'none',
    fontSize: '14px',
    display: 'block',
    margin: '10px',
    '&:hover': {
      textDecoration: 'underline'
    }
  },
  view: {
    padding: "6px 12px",
    border: "1px solid #122b40",
    color: "#fff",
    backgroundColor: " #012951",
    borderRadius: '4px'
  }
});
const PrivateProfessionals = () => {
  const homeUrl = '/digit-ui/citizen';
  const classes = useStyles$m();
  return /*#__PURE__*/React__default.createElement(Card, {
    style: {
      maxWidth: 'fit-content',
      margin: '10px',
      boxShadow: 'rgba(6, 24, 44, 0.4) 0px 0px 0px 2px, rgba(6, 24, 44, 0.65) 0px 4px 6px -1px, rgba(255, 255, 255, 0.08) 0px 1px 0px inset'
    }
  }, /*#__PURE__*/React__default.createElement(CardContent, null, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h6",
    style: {
      backgroundColor: '#1F4A7C',
      color: "#fff",
      padding: "10px",
      fontSize: '15px'
    }
  }, "Online Services"), /*#__PURE__*/React__default.createElement(Link$1, {
    to: `${homeUrl}/obps/services/registration`
  }, /*#__PURE__*/React__default.createElement("p", {
    variant: "body1",
    component: "p",
    className: classes.button
  }, "Apply for Architect Registration")), /*#__PURE__*/React__default.createElement(Divider, null), /*#__PURE__*/React__default.createElement(Link$1, {
    to: `${homeUrl}/obps/edcrscrutiny/apply/home`
  }, /*#__PURE__*/React__default.createElement("p", {
    variant: "body1",
    component: "p",
    className: classes.button
  }, "Apply for ", /*#__PURE__*/React__default.createElement("strong", null, "Map Submission"))), /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'right'
    }
  }, /*#__PURE__*/React__default.createElement(Link$1, {
    to: "obps/services/registration"
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    className: classes.view,
    style: {
      padding: '6px 12px',
      backgroundColor: '#012951',
      color: 'white',
      border: '1px solid #122b40',
      marginRight: '20px'
    }
  }, "Sign Up")), /*#__PURE__*/React__default.createElement(Link$1, {
    to: "profile"
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    className: classes.view,
    style: {
      padding: '6px 12px',
      backgroundColor: '#012951',
      color: 'white',
      border: '1px solid #122b40'
    }
  }, "Sign In")))));
};

const ApplyOnline = () => {
  var _location$state;
  const location = useLocation();
  const flag = (location === null || location === void 0 ? void 0 : (_location$state = location.state) === null || _location$state === void 0 ? void 0 : _location$state.params) || 'professional';
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'center'
    }
  }, flag === 'citizen' && /*#__PURE__*/React__default.createElement(CitizenAndOthers, null), flag === 'professional' && /*#__PURE__*/React__default.createElement(PrivateProfessionals, null)));
};

const Form11Calculator = () => {
  return /*#__PURE__*/React__default.createElement(Box$1, null, /*#__PURE__*/React__default.createElement("h3", {
    style: {
      width: '100%',
      backgroundColor: '#F1F1F1',
      height: '30px'
    }
  }, "Land Area Details"), /*#__PURE__*/React__default.createElement(Box$1, {
    display: "flex",
    flexDirection: "row"
  }, /*#__PURE__*/React__default.createElement(FormControl$1, {
    style: {
      width: "1300px"
    },
    fullWidth: true
  }, /*#__PURE__*/React__default.createElement(Grid$1, {
    container: true,
    rowSpacing: 1,
    columnSpacing: {
      xs: 1,
      sm: 2,
      md: 3
    }
  }, /*#__PURE__*/React__default.createElement(Grid$1, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body2"
  }, "District:")), /*#__PURE__*/React__default.createElement(Grid$1, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React__default.createElement(Select$1, {
    displayEmpty: true,
    id: "ditrict-select",
    value: "",
    sx: {
      width: "250px",
      marginRight: '20px'
    },
    inputProps: {
      'aria-label': 'Without label'
    }
  }, /*#__PURE__*/React__default.createElement(MenuItem$4, {
    value: 10
  }, "Ten"), /*#__PURE__*/React__default.createElement(MenuItem$4, {
    value: 20
  }, "Twenty"), /*#__PURE__*/React__default.createElement(MenuItem$4, {
    value: 30
  }, "Thirty"))), /*#__PURE__*/React__default.createElement(Grid$1, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body2"
  }, "ULB:")), /*#__PURE__*/React__default.createElement(Grid$1, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React__default.createElement(Select$1, {
    displayEmpty: true,
    id: "ulb-select",
    value: "",
    sx: {
      width: "250px",
      marginRight: '20px'
    }
  }, /*#__PURE__*/React__default.createElement(MenuItem$4, {
    value: 10
  }, "Ten"), /*#__PURE__*/React__default.createElement(MenuItem$4, {
    value: 20
  }, "Twenty"), /*#__PURE__*/React__default.createElement(MenuItem$4, {
    value: 30
  }, "Thirty")))))), /*#__PURE__*/React__default.createElement("h3", {
    style: {
      width: '100%',
      backgroundColor: '#F1F1F1',
      height: '30px'
    }
  }, "Description of Land Proposed for Subdivision/Development of Land"), /*#__PURE__*/React__default.createElement(Box$1, {
    display: "flex",
    flexDirection: "row"
  }, /*#__PURE__*/React__default.createElement(FormControl$1, {
    style: {
      width: "1300px"
    },
    fullWidth: true
  }, /*#__PURE__*/React__default.createElement(Grid$1, {
    container: true,
    rowSpacing: 1,
    columnSpacing: {
      xs: 1,
      sm: 2,
      md: 3
    }
  }, /*#__PURE__*/React__default.createElement(Grid$1, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body2"
  }, "Total Plot Area:")), /*#__PURE__*/React__default.createElement(Grid$1, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React__default.createElement(TextField$1, {
    style: {
      width: "250px"
    }
  })), /*#__PURE__*/React__default.createElement(Grid$1, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body2"
  }, "Applied Land Use:")), /*#__PURE__*/React__default.createElement(Grid$1, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React__default.createElement(Select$1, {
    displayEmpty: true,
    id: "ulb-select",
    value: "",
    sx: {
      width: "250px",
      marginRight: '20px'
    }
  }, /*#__PURE__*/React__default.createElement(MenuItem$4, {
    value: 10
  }, "Ten"), /*#__PURE__*/React__default.createElement(MenuItem$4, {
    value: 20
  }, "Twenty"), /*#__PURE__*/React__default.createElement(MenuItem$4, {
    value: 30
  }, "Thirty")))))), /*#__PURE__*/React__default.createElement("h3", {
    style: {
      width: '100%',
      backgroundColor: '#F1F1F1',
      height: '30px'
    }
  }, "Plot Details"), /*#__PURE__*/React__default.createElement(Box$1, {
    display: "flex",
    flexDirection: "row"
  }, /*#__PURE__*/React__default.createElement(FormControl$1, {
    style: {
      width: "1300px"
    },
    fullWidth: true
  }, /*#__PURE__*/React__default.createElement(Grid$1, {
    container: true,
    rowSpacing: 1,
    columnSpacing: {
      xs: 1,
      sm: 2,
      md: 3
    }
  }, /*#__PURE__*/React__default.createElement(Grid$1, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body2"
  }, "Whether Change Of Land Use Involved ?:")), /*#__PURE__*/React__default.createElement(Grid$1, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement(FormControl$1, null, /*#__PURE__*/React__default.createElement(RadioGroup$1, {
    row: true,
    "aria-labelledby": "demo-radio-buttons-group-label",
    defaultValue: "female",
    name: "radio-buttons-group"
  }, /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    value: "female",
    control: /*#__PURE__*/React__default.createElement(Radio$1, null),
    label: "Yes"
  }), /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    value: "male",
    control: /*#__PURE__*/React__default.createElement(Radio$1, null),
    label: "No"
  }))))))), /*#__PURE__*/React__default.createElement(Button$1, {
    variant: "contained",
    style: {
      marginLeft: "45%",
      backgroundColor: "#47A447",
      marginTop: "50px"
    }
  }, "Calculate Fee"));
};

const Form12 = () => {
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, "Form12");
};

const Form26 = () => {
  return /*#__PURE__*/React.createElement(Fragment, null, "Form 26");
};

const FormType = () => {
  const [selectedOption, setSelectedOption] = useState('first');
  const getComponentToRender = () => {
    switch (selectedOption) {
      case 'first':
        return /*#__PURE__*/React__default.createElement(Form11Calculator, null);
      case 'second':
        return /*#__PURE__*/React__default.createElement(Form12, null);
      case 'third':
        return /*#__PURE__*/React__default.createElement(Form26, null);
      default:
        return null;
    }
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(FormControl$1, {
    component: "fieldset"
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "h6",
    gutterBottom: true
  }, "Choose an option:"), /*#__PURE__*/React__default.createElement(RadioGroup$1, {
    "aria-label": "option",
    name: "option",
    value: selectedOption,
    onChange: e => setSelectedOption(e.target.value)
  }, /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    value: "first",
    control: /*#__PURE__*/React__default.createElement(Radio$1, null),
    label: "First option"
  }), /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    value: "second",
    control: /*#__PURE__*/React__default.createElement(Radio$1, null),
    label: "Second option"
  }), /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    value: "third",
    control: /*#__PURE__*/React__default.createElement(Radio$1, null),
    label: "Third option"
  }))), getComponentToRender());
};

const deviationCategory = [{
  value: "1",
  label: "Plan was approved and deviation beyond permissible limit Upto extent of 10%"
}, {
  value: "2",
  label: "Plan was not approved and construction carried out without deviation"
}, {
  value: "3",
  label: "Plan was not approved and deviation beyond permissible limit Upto the extent of 10%"
}, {
  value: "4",
  label: "Building constructed on under size plot to the extent of 10% less than the permissible plot size"
}];
const nameSuffix = [{
  value: "Mr.",
  label: "Mr."
}, {
  value: "Mrs.",
  label: "Mrs."
}, {
  value: "Miss",
  label: "Miss"
}];
const relationSuffix = [{
  value: "S/O",
  label: "S/O"
}, {
  value: "D/O",
  label: "D/O"
}, {
  value: "W/O",
  label: "W/O"
}];
const propertyType = [{
  value: "Govt.",
  label: "Govt."
}, {
  value: "Private",
  label: "Private"
}, {
  value: "other",
  label: "Other"
}];
const yesOrNo = [{
  value: "yes",
  label: "Yes"
}, {
  value: "no",
  label: "No"
}];
const appealApplicationStatus = [{
  value: "Individual",
  label: "Individual"
}, {
  value: "Firm",
  label: "Firm"
}, {
  value: "Company",
  label: "Company"
}, {
  value: "AssociationOfPerson",
  label: "Association of Person"
}, {
  value: "Co-operativeSociety",
  label: "Co-operative Society"
}, {
  value: "Other",
  label: "Other"
}];
const typeOfLandForDevelopment = [{
  value: "Commercial",
  label: "Commercial"
}, {
  value: "Industrial",
  label: "Industrial"
}, {
  value: "Residential",
  label: "Residential"
}, {
  value: "PublicSemipublic",
  label: "Public Semi public"
}];
const DistrictsData = [{
  value: "Bilaspur",
  label: "Bilaspur"
}, {
  value: "Chamba",
  label: "Chamba"
}, {
  value: "Hamirpur",
  label: "Hamirpur"
}, {
  value: "Kangra",
  label: "Kangra"
}, {
  value: "Kinnaur",
  label: "Kinnaur"
}, {
  value: "Lahaul and Spiti",
  label: "Lahaul and Spiti"
}, {
  value: "Mandi",
  label: "Mandi"
}, {
  value: "Shimla",
  label: "Shimla"
}, {
  value: "Sirmaur",
  label: "Sirmaur"
}];
const statesData = [{
  value: "Andaman and Nicobar",
  label: "Andaman and Nicobar"
}, {
  value: "Andhra Pradesh",
  label: "Andhra Pradesh"
}, {
  value: "Arunachal Pradesh",
  label: "Arunachal Pradesh"
}, {
  value: "Assam",
  label: "Assam"
}, {
  value: "Bihar",
  label: "Bihar"
}, {
  value: "Chandigarh",
  label: "Chandigarh"
}, {
  value: "Chhattisgarh",
  label: "Chhattisgarh"
}];
const NotifiedArea = [{
  value: "Hatkoti",
  label: "Hatkoti"
}, {
  value: "Sarahan",
  label: "Sarahan"
}, {
  value: "Shoghi",
  label: "Shoghi"
}, {
  value: "Kufri",
  label: "Kufri"
}, {
  value: "Barog",
  label: "Barog"
}, {
  value: "Harat",
  label: "Harat"
}];
const VillagesData = [{
  value: "Nako",
  label: "Nako"
}, {
  value: "Kardang",
  label: "Kardang"
}, {
  value: "Chitkul",
  label: "Chitkul"
}, {
  value: "Kibber",
  label: "KIbber"
}, {
  value: "Komic",
  label: "KOmic"
}, {
  value: "Langza",
  label: "Langza"
}, {
  value: "Dhankar",
  label: "Dhankar"
}, {
  value: "Barot",
  label: "Barot"
}, {
  value: "Malana",
  label: "Malana"
}];
const TehsilData = [{
  value: "Jawali",
  label: "Jawali"
}, {
  value: "Indora",
  label: "Indora"
}, {
  value: "Dehra",
  label: "Dehra"
}, {
  value: "Shahpur",
  label: "Shahpur"
}, {
  value: "Baroh",
  label: "Baroh"
}, {
  value: "Khundian",
  label: "Khundian"
}, {
  value: "Dadasiba",
  label: "Dadasiba"
}, {
  value: "Rakkar",
  label: "Rakkar"
}, {
  value: "Fatehpur",
  label: "Fatehpur"
}];

const label = {
  inputProps: {
    "aria-label": "Checkbox demo"
  }
};
function Checkboxes() {
  return /*#__PURE__*/createElement("div", null, /*#__PURE__*/createElement(Checkbox$1, label));
}

const Step1 = () => {
  const {
    handleSubmit,
    control
  } = useForm();
  const onSubmit = data => console.log(data);
  const [showMessage, setShowMessage] = useState(true);
  const handleRadioButton = event => {
    if (event.target.value === "yes") {
      setShowMessage(true);
    } else {
      setShowMessage(false);
    }
    console.log(showMessage);
  };
  return /*#__PURE__*/React__default.createElement("section", {
    className: "container1"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "header"
  }, "Form of application for Permission under sub-section (2) of section 15-A or clause (a) of section 16 or sub-section (1) of section 30 or section 30-A (beyond the limits as specified under section 30-A) of the Himachal Pradesh Town and Country Planning Act, 1977 (Act No. 12 of 1977) for Development of Land/Construction of Building."), /*#__PURE__*/React__default.createElement("div", {
    className: "headerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Applicant Information"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "primary",
    size: "medium",
    label: "Private Professional Information"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "primary",
    size: "medium",
    label: "Checklist"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "primary",
    size: "medium",
    label: "Documents"
  })), /*#__PURE__*/React__default.createElement("h5", {
    className: "mandatoryInfo"
  }, "(*) Indicates Mandatory Field")), /*#__PURE__*/React__default.createElement("div", {
    className: "straightLine"
  }), /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Location of proposed construction")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "District",
    control: control,
    placeholder: "Select District",
    name: "district",
    mandatory: true,
    type: "selectInput",
    data: DistrictsData
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Notified Area ",
    control: control,
    placeholder: "Select Notified Area",
    name: "notifiedArea",
    mandatory: true,
    type: "selectInput",
    data: appealApplicationStatus
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Name of Village ",
    control: control,
    placeholder: "Select Name of Village",
    name: "nameOfVillage",
    mandatory: true,
    type: "selectInput",
    data: appealApplicationStatus
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Name of Ward",
    control: control,
    placeholder: "Select Name of Ward",
    name: "notifiedArea",
    mandatory: true,
    type: "selectInput"
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Applicant Information")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Applicant Name",
    control: control,
    placeholder: "Enter Applicant Name",
    name: "applicantName",
    mandatory: true,
    type: "textInput"
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Guardian Name",
    control: control,
    placeholder: "Enter Guardian Name",
    name: "guardianName",
    type: "textInput"
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Mobile Number",
    control: control,
    placeholder: "Enter Mobile Number",
    name: "mobileNumber",
    mobileNumber: true,
    mandatory: true,
    type: "textInput"
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Email Id",
    control: control,
    placeholder: "Enter Email Id",
    name: "mobileNumber",
    type: "textInput"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Aadhaar No.",
    control: control,
    placeholder: "Enter Aadhaar No.",
    name: "aadharNumber",
    type: "textInput",
    mandatory: true
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Upload Picture",
    control: control,
    name: "picture",
    mandatory: true,
    type: "upload",
    uploadValidity: "(png file only and Max file Size 1 MB)"
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Address Details")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement("h3", {
    className: "addressType"
  }, "Correspondence Address"), /*#__PURE__*/React__default.createElement("div", {
    className: "inputContainer"
  }, /*#__PURE__*/React__default.createElement("h3", {
    className: "label multiCoumn"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, "*"), "Name :"), /*#__PURE__*/React__default.createElement(TextInput$2, {
    defaultValue: "Mr.",
    variant: "outlined",
    size: "small",
    width: "5.625vw",
    select: true,
    name: "initialForCorrespondenceadressName",
    control: control
  }, nameSuffix === null || nameSuffix === void 0 ? void 0 : nameSuffix.map(option => /*#__PURE__*/React__default.createElement(MenuItem$4, {
    key: option.value,
    value: option.value
  }, option.label))), /*#__PURE__*/React__default.createElement(TextInput$2, {
    label: "Enter Name",
    variant: "outlined",
    size: "small",
    width: "15.625vw",
    name: "correspondenceAdressName",
    control: control
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "inputContainer"
  }, /*#__PURE__*/React__default.createElement("h3", {
    className: "label multiCoumn"
  }, "Guardian Name :"), /*#__PURE__*/React__default.createElement(TextInput$2, {
    defaultValue: "S/O",
    variant: "outlined",
    size: "small",
    width: "5.625vw",
    select: true,
    name: "initialForCorrespondenceadressGuardianName",
    control: control
  }, relationSuffix === null || relationSuffix === void 0 ? void 0 : relationSuffix.map(option => /*#__PURE__*/React__default.createElement(MenuItem$4, {
    key: option.value,
    value: option.value
  }, option.label))), /*#__PURE__*/React__default.createElement(TextInput$2, {
    label: "Enter Guardian Name",
    variant: "outlined",
    size: "small",
    width: "15.625vw",
    name: "correspondenceGuardianName",
    control: control
  })), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    control: control,
    inputLabel: "Select State",
    label: "State :",
    data: yesOrNo,
    placeholder: "Select State",
    name: "state",
    mandatory: true,
    type: "selectInput",
    multiColumn: true
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    control: control,
    inputLabel: "Select District",
    label: "District :",
    data: DistrictsData,
    placeholder: "Select District",
    name: "state",
    mandatory: true,
    type: "selectInput",
    multiColumn: true
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    control: control,
    inputLabel: "Select Tehsil",
    label: "Tehsil :",
    placeholder: "Select Tehsil",
    name: "state",
    mandatory: true,
    type: "selectInput",
    multiColumn: true
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Town/Village/Ward : ",
    control: control,
    placeholder: "Enter Town/Village/Ward",
    name: "email",
    mandatory: true,
    type: "textInput",
    multiColumn: true
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Address : ",
    control: control,
    placeholder: "Enter Address",
    name: "address",
    mandatory: true,
    type: "textInput",
    multiColumn: true,
    multiLine: true
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: " Pincode : ",
    control: control,
    placeholder: "Enter Pincode",
    name: "email",
    mandatory: true,
    type: "textInput",
    multiColumn: true
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "checkboxWrapper"
  }, /*#__PURE__*/React__default.createElement("h3", {
    className: "addressType"
  }, "Permanent Address"), /*#__PURE__*/React__default.createElement(Checkboxes, null), "Same as Corresponding Address"), /*#__PURE__*/React__default.createElement("div", {
    className: "inputContainer"
  }, /*#__PURE__*/React__default.createElement("h3", {
    className: "label multiCoumn"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, "*"), "Name :"), /*#__PURE__*/React__default.createElement(TextInput$2, {
    defaultValue: "Mr.",
    variant: "outlined",
    size: "small",
    width: "5.625vw",
    select: true,
    name: "initialForCorrespondenceadressName",
    control: control
  }, nameSuffix === null || nameSuffix === void 0 ? void 0 : nameSuffix.map(option => /*#__PURE__*/React__default.createElement(MenuItem$4, {
    key: option.value,
    value: option.value
  }, option.label))), /*#__PURE__*/React__default.createElement(TextInput$2, {
    label: "Enter Name",
    variant: "outlined",
    size: "small",
    width: "15.625vw",
    name: "correspondenceAdressName",
    control: control
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "inputContainer"
  }, /*#__PURE__*/React__default.createElement("h3", {
    className: "label multiCoumn"
  }, "Guardian Name :"), /*#__PURE__*/React__default.createElement(TextInput$2, {
    defaultValue: "S/O",
    variant: "outlined",
    size: "small",
    width: "5.625vw",
    select: true,
    name: "initialForCorrespondenceadressGuardianName",
    control: control
  }, relationSuffix === null || relationSuffix === void 0 ? void 0 : relationSuffix.map(option => /*#__PURE__*/React__default.createElement(MenuItem$4, {
    key: option.value,
    value: option.value
  }, option.label))), /*#__PURE__*/React__default.createElement(TextInput$2, {
    label: "Enter Guardian Name",
    variant: "outlined",
    size: "small",
    width: "15.625vw",
    name: "correspondenceGuardianName",
    control: control
  })), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    control: control,
    inputLabel: "Select State",
    label: "State :",
    data: yesOrNo,
    placeholder: "Select State",
    name: "state",
    mandatory: true,
    type: "selectInput",
    multiColumn: true
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    control: control,
    inputLabel: "Select District",
    label: "District :",
    data: DistrictsData,
    placeholder: "Select District",
    name: "state",
    mandatory: true,
    type: "selectInput",
    multiColumn: true
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    control: control,
    inputLabel: "Select Tehsil",
    label: "Tehsil :",
    placeholder: "Select Tehsil",
    name: "state",
    mandatory: true,
    type: "selectInput",
    multiColumn: true
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Town/Village/Ward : ",
    control: control,
    placeholder: "Enter Town/Village/Ward",
    name: "email",
    mandatory: true,
    type: "textInput",
    multiColumn: true
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Address : ",
    control: control,
    placeholder: "Enter Address",
    name: "address",
    mandatory: true,
    type: "textInput",
    multiColumn: true,
    multiLine: true
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: " Pincode : ",
    control: control,
    placeholder: "Enter Pincode",
    name: "email",
    mandatory: true,
    type: "textInput",
    multiColumn: true
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer",
    style: {
      paddingLeft: "100"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Description of land proposed for Development of Land/Construction of Building")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Revenue Village/Mohal/Phati/ Up Mohal",
    control: control,
    placeholder: "Enter Village Name.",
    name: "revenueVillageMohalla",
    mandatory: true,
    type: "textInput",
    data: appealApplicationStatus
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Khasra No.",
    control: control,
    placeholder: "Enter Khasra No.",
    name: "applicantName",
    type: "textInput",
    mandatory: true
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Khata No.",
    control: control,
    placeholder: "Enter Khata No.",
    name: "applicantName",
    mandatory: true,
    type: "textInput"
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Khatauni No.",
    control: control,
    placeholder: "Enter Khatauni No.",
    name: "applicantName",
    type: "textInput"
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Latitude/Longitude",
    control: control,
    placeholder: "Enter Latitude/Longitude",
    name: "applicantName",
    type: "textInput"
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Area (Sq.M)",
    control: control,
    placeholder: "Enter Area (Sq.M)",
    name: "applicantName",
    mandatory: true,
    type: "textInput"
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Total Plot Area (Sq.m)",
    control: control,
    placeholder: "Enter Total Plot Area (Sq.m)",
    name: "applicantName",
    mandatory: true,
    type: "textInput"
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Whether Subdivision Approved",
    control: control,
    name: "subdivision",
    mandatory: true,
    data: yesOrNo,
    type: "radioButton",
    defaultValue: "yes",
    clickControl: handleRadioButton
  }), showMessage && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Case Reference No.",
    control: control,
    placeholder: "Enter Case Reference No.",
    name: "applicantName",
    mandatory: true,
    type: "textInput"
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "No. of Plot ",
    control: control,
    placeholder: "Enter No. of Plot ",
    name: "applicantName",
    mandatory: true,
    type: "textInput"
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Subdivision approval supporting document",
    control: control,
    name: "picture",
    mandatory: true,
    type: "htmlUpload",
    uploadValidity: "(pdf file only and Max file Size 10 MB)"
  })), !showMessage && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Property is ancestral ",
    control: control,
    name: "gender",
    mandatory: true,
    data: yesOrNo,
    type: "radioButton"
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Ancestral Property document Upload",
    control: control,
    name: "picture",
    mandatory: true,
    type: "htmlUpload",
    uploadValidity: "(pdf file only and Max file Size 10 MB)"
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "District",
    control: control,
    placeholder: "Select District",
    name: "revenueVillageMohalla",
    mandatory: true,
    type: "selectInput",
    data: propertyType
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Name of Ward",
    control: control,
    placeholder: "Select Name of Ward",
    name: "notifiedArea",
    mandatory: true,
    type: "selectInput"
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Area Type ",
    control: control,
    placeholder: "Select Area Type ",
    name: "revenueVillageMohalla",
    mandatory: true,
    type: "selectInput",
    data: propertyType
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Maximum Permissible Ground Coverage (In Sq.m) ",
    control: control,
    placeholder: "Enter Details",
    name: "revenueVillageMohalla",
    mandatory: true,
    type: "textInput"
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Applied land use",
    control: control,
    placeholder: "Select",
    name: "revenueVillageMohalla",
    mandatory: true,
    type: "selectInput",
    data: propertyType
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Property Type  ",
    control: control,
    placeholder: "Select Property Type ",
    name: "revenueVillageMohalla",
    mandatory: true,
    type: "selectInput",
    data: propertyType
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Proposal submitted for ",
    control: control,
    placeholder: "Select ",
    name: "revenueVillageMohalla",
    mandatory: true,
    type: "selectInput",
    data: propertyType
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Type of Construction ",
    control: control,
    placeholder: "Select",
    name: "revenueVillageMohalla",
    mandatory: true,
    type: "selectInput",
    data: propertyType
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Plot Area for Sub-division/ Development Activity(sq.m) ",
    control: control,
    placeholder: "Enter Details",
    name: "revenueVillageMohalla",
    mandatory: true,
    type: "textInput"
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Builtup Area ")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "No. of Blocks  ",
    control: control,
    placeholder: "1",
    name: "revenueVillageMohalla",
    mandatory: true,
    type: "textInput"
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Details of Block 1 ")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement(Table$1, {
    striped: true,
    bordered: true
  }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", null, "SI#"), /*#__PURE__*/React__default.createElement("th", null, /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, "*"), "Floor Type"), /*#__PURE__*/React__default.createElement("th", null, /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, "*"), "Floor Area Sq.m."), /*#__PURE__*/React__default.createElement("th", null, /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, "*"), "Land Use Type"), /*#__PURE__*/React__default.createElement("th", null, "Parking Area"), /*#__PURE__*/React__default.createElement("th", null, "Exemption"), /*#__PURE__*/React__default.createElement("th", null, "Add More"))), /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "1"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(TextInput$2, {
    label: "Enter Floor Type",
    variant: "outlined",
    size: "small",
    name: "correspondenceAdressName",
    control: control
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(TextInput$2, {
    label: " Enter Floor Area ",
    variant: "outlined",
    size: "small",
    name: "correspondenceAdressName",
    control: control
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(SelectWrapper$2, {
    control: control,
    inputLabel: "Select Land Use Type",
    label: "Select Land Use Type",
    data: yesOrNo
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(TextInput$2, {
    label: " Enter Parking Area",
    variant: "outlined",
    size: "small",
    name: "correspondenceAdressName",
    control: control
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(Checkboxes, null)), /*#__PURE__*/React__default.createElement("td", {
    className: "m-auto"
  }, /*#__PURE__*/React__default.createElement(AddCircleIcon, null))))))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Details of Plot after Subdivision")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "whether Change of Land Usee involved Yes /No ",
    control: control,
    name: "gender",
    mandatory: true,
    data: yesOrNo,
    type: "radioButton"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "If yes ",
    control: control,
    placeholder: "Select",
    name: "revenueVillageMohalla",
    mandatory: true,
    type: "selectInput",
    data: typeOfLandForDevelopment
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Plot Details ")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement(Table$1, {
    striped: true,
    bordered: true
  }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", null, "SI#"), /*#__PURE__*/React__default.createElement("th", null, /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, "*"), "Plot No."), /*#__PURE__*/React__default.createElement("th", null, /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, "*"), "Plot Area"), /*#__PURE__*/React__default.createElement("th", null, /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, "*"), "Type of Land Development"), /*#__PURE__*/React__default.createElement("th", null, "Add More"))), /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "1"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(TextInput$2, {
    label: "Enter Plot No",
    variant: "outlined",
    size: "small",
    name: "correspondenceAdressName",
    control: control
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(TextInput$2, {
    label: " Enter Plot Area",
    variant: "outlined",
    size: "small",
    name: "correspondenceAdressName",
    control: control
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(SelectWrapper$2, {
    control: control,
    inputLabel: "Select Type of Land Development",
    label: "Select Type of Land Development",
    data: yesOrNo
  })), /*#__PURE__*/React__default.createElement("td", {
    className: "m-auto"
  }, /*#__PURE__*/React__default.createElement(AddCircleIcon, null))))))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "warning",
    size: "medium",
    label: "Save as Draft"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Next",
    type: "submit"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Reset"
  })))));
};

const Step2 = () => {
  const {
    handleSubmit,
    control
  } = useForm();
  const onSubmit = data => console.log(data);
  return /*#__PURE__*/React__default.createElement("section", {
    className: "container1"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "headerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "primary",
    size: "medium",
    label: "Applicant Information"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "primary",
    size: "medium",
    label: "Private Professional Information"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Checklist"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "primary",
    size: "medium",
    label: "Documents"
  })), /*#__PURE__*/React__default.createElement("h5", {
    className: "mandatoryInfo"
  }, "(*) Indicates Mandatory Field")), /*#__PURE__*/React__default.createElement("div", {
    className: "straightLine"
  }), /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Checklist to be filled"), /*#__PURE__*/React__default.createElement("div", {
    className: "tableWrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial heading"
  }, "SI# "), /*#__PURE__*/React__default.createElement("div", {
    className: "description heading"
  }, "Description"), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation heading"
  }, "As per Regulations"), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed heading"
  }, "As proposed"), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks heading"
  }, "Remarks"), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation heading"
  }, "Relaxation")), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "1. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Type of Area"), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "2. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Total Plot Area (Sq.m)"), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "3. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "ownership & Revenue documents"), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "4. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Land-use"), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "5. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "FAR"), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }, " "), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "6. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Built up Area (Sq.m)"), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }, " "), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "7. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Setbacks", /*#__PURE__*/React__default.createElement("div", {
    className: "box"
  }, /*#__PURE__*/React__default.createElement("p", null, "Front"), /*#__PURE__*/React__default.createElement("p", null, "Rear"), /*#__PURE__*/React__default.createElement("p", null, "Left"), /*#__PURE__*/React__default.createElement("p", null, "Right"), /*#__PURE__*/React__default.createElement("p", null, "Construction abuts with N.H."), /*#__PURE__*/React__default.createElement("p", null, "Front"), /*#__PURE__*/React__default.createElement("p", null, "Rear"), /*#__PURE__*/React__default.createElement("p", null, "Left"), /*#__PURE__*/React__default.createElement("p", null, "Side"))), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }, " "), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "8. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "No. of storeys "), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }, " "), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "9. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Road/Path Existing at site "), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }, " "), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "10. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Parking Provision "), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }, " "), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "11. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Whether any HT/LT Line, crossing over the proposed land"), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }, " "), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "12. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Whether proposed plan is located nearby ASI Protected monument"), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }, " "), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "13. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Whether proposed Plan is located nearby HFL"), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }, " "), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "14. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Whether trees are standing on Plot", /*#__PURE__*/React__default.createElement("div", {
    className: "box"
  }, /*#__PURE__*/React__default.createElement("p", null, "No. of Trees "), /*#__PURE__*/React__default.createElement("p", null, "Distance of Trees from Proposed development if not to be cut"), /*#__PURE__*/React__default.createElement("p", null, "Whether Permission of Competent authority for cutting of Trees"), /*#__PURE__*/React__default.createElement("p", null, "Whether plot is Abutting to Forest Boundary "), /*#__PURE__*/React__default.createElement("p", null, "Distance from Forest Boundary "))), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }, " "), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "15. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Whether plot is Directly abutting with National Highway/State Highway/Bypass/Other H.P. Public Department Schedule Road."), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }, " "), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "16. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Whether Proposed plot is abutting to natural drainage", /*#__PURE__*/React__default.createElement("div", {
    className: "box"
  }, /*#__PURE__*/React__default.createElement("p", null, "Distance from Nullah "), /*#__PURE__*/React__default.createElement("p", null, "Distance from Khud"))), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }, " "), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "17. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Whether any Pipeline/Sewerage line crossing or passing through the plot"), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }, " "), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "18. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Provision of Solar Passive Building"), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }, " "), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "19. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Provision of barrier free access for persons with disability"), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }, " "), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "20. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Whether the Proposed Plan is above the road level on Valley Side"), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }, " "), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "21. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Whether proposed Plan is located in Sinking and Sliding area"), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }, " "), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "22. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Rainwater harvesting tank provision"), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }, " "), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "23. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Structural Stability Certificate"), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }, " "), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "24. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "No. of Dwelling Units "), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }, " "), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "25. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Risk Based Classification of building", /*#__PURE__*/React__default.createElement("div", {
    className: "box"
  }, /*#__PURE__*/React__default.createElement("p", null, "Whether building with communication tower "), /*#__PURE__*/React__default.createElement("p", null, "Whether proposal is for Group Housing Scheme "), /*#__PURE__*/React__default.createElement("p", null, "Whether building raised on land fill "), /*#__PURE__*/React__default.createElement("p", null, "Whether building raised on reclaimed land "))), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }, " "), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "26. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "General Requirements", /*#__PURE__*/React__default.createElement("div", {
    className: "box"
  }, /*#__PURE__*/React__default.createElement("p", null, "Slope of land "), /*#__PURE__*/React__default.createElement("p", null, "Height of parking Door (Meter) "), /*#__PURE__*/React__default.createElement("p", null, " Height of slopping roof (Meter)"), /*#__PURE__*/React__default.createElement("p", null, " Height of Floor (Meter)"), /*#__PURE__*/React__default.createElement("p", null, " Height of Building (Meter Maximum hill cut (Meter) "), /*#__PURE__*/React__default.createElement("p", null, " Distance between two blocks (Meter)"), /*#__PURE__*/React__default.createElement("p", null, " Plinth height (Meter)"), /*#__PURE__*/React__default.createElement("p", null, " Height of Service Door (Meter)"), /*#__PURE__*/React__default.createElement("p", null, " Equivalent car Space Buildable width"))), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }, " "), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "27. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Site Photographs "), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }, " "), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "28. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Any other information "), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }, " "), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "29. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Whether the permission from Airport Authority of India is Required."), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }, " "), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "warning",
    size: "medium",
    label: "Save as Draft"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Next",
    type: "submit"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Reset"
  }))))));
};

const Step3 = () => {
  const {
    handleSubmit,
    control
  } = useForm();
  const onSubmit = data => console.log(data);
  return /*#__PURE__*/React__default.createElement("section", {
    className: "container1"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "headerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "primary",
    size: "medium",
    label: "Applicant Information"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "primary",
    size: "medium",
    label: "Private Professional Information"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "primary",
    size: "medium",
    label: "Checklist"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Documents"
  })), /*#__PURE__*/React__default.createElement("h5", {
    className: "mandatoryInfo"
  }, "(*) Indicates Mandatory Field")), /*#__PURE__*/React__default.createElement("div", {
    className: "straightLine"
  }), /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Upload Documents")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Structural Stability Certificate ",
    control: control,
    name: "picture",
    mandatory: true,
    type: "htmlUpload",
    uploadValidity: "(pdf file only and Max file Size 30 MB)"
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Undertaking of supervision of Building ",
    control: control,
    name: "picture",
    mandatory: true,
    type: "htmlUpload",
    uploadValidity: "(pdf file only and Max file Size 30 MB)"
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Undertaking of Owner ",
    control: control,
    name: "picture",
    mandatory: true,
    type: "htmlUpload",
    uploadValidity: "(pdf file only and Max file Size 30 MB)"
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Jamabandhi Document ",
    control: control,
    name: "picture",
    mandatory: true,
    type: "htmlUpload",
    uploadValidity: "(pdf file only and Max file Size 30 MB)"
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Demarcation Report/Affidavit ",
    control: control,
    name: "picture",
    type: "htmlUpload",
    uploadValidity: "(pdf file only and Max file Size 30 MB)"
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Location Plan ",
    control: control,
    name: "picture",
    mandatory: true,
    type: "htmlUpload",
    uploadValidity: "(pdf file only and Max file Size 30 MB)"
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "       Tatima Documents  ",
    control: control,
    name: "picture",
    mandatory: true,
    type: "htmlUpload",
    uploadValidity: "(pdf file only and Max file Size 30 MB)"
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "  Proposed Consolidated Map 1 (Note: Upload the map in portrait orientation)      ",
    control: control,
    name: "picture",
    mandatory: true,
    type: "htmlUpload",
    uploadValidity: "(pdf file only and Max file Size 30 MB)"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "   Site Plan     ",
    control: control,
    name: "picture",
    mandatory: true,
    type: "htmlUpload",
    uploadValidity: "(pdf file only and Max file Size 30 MB)"
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "    NOC from Competent Authority for HT/LT Line   ",
    control: control,
    name: "picture",
    mandatory: true,
    type: "htmlUpload",
    uploadValidity: "(pdf file only and Max file Size 30 MB)"
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "   Site Photographs     ",
    control: control,
    name: "picture",
    mandatory: true,
    type: "htmlUpload",
    uploadValidity: "(pdf file only and Max file Size 30 MB)"
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "   Affidavit regarding surrender of Path  ",
    control: control,
    name: "picture",
    mandatory: true,
    type: "htmlUpload",
    uploadValidity: "(pdf file only and Max file Size 30 MB)"
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "  NOC from HPPCB  ",
    control: control,
    name: "picture",
    mandatory: true,
    type: "htmlUpload",
    uploadValidity: "(pdf file only and Max file Size 30 MB)"
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "  Registration certificate from industry Department  ",
    control: control,
    name: "picture",
    mandatory: true,
    type: "htmlUpload",
    uploadValidity: "(pdf file only and Max file Size 30 MB)"
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "  Any Other Doc  ",
    control: control,
    name: "picture",
    type: "htmlUpload",
    uploadValidity: "(pdf file only and Max file Size 30 MB)"
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "warning",
    size: "medium",
    label: "Save as Draft"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Finish",
    type: "submit"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Reset"
  })))));
};

const Step2$1 = () => {
  const {
    handleSubmit,
    control
  } = useForm();
  const onSubmit = data => console.log(data);
  return /*#__PURE__*/React__default.createElement("section", {
    className: "container1"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "headerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "primary",
    size: "medium",
    label: "Applicant Information"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Private Professional Information"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "primary",
    size: "medium",
    label: "Checklist"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "primary",
    size: "medium",
    label: "Documents"
  })), /*#__PURE__*/React__default.createElement("h5", {
    className: "mandatoryInfo"
  }, "(*) Indicates Mandatory Field")), /*#__PURE__*/React__default.createElement("div", {
    className: "straightLine"
  }), /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Private Professional Information")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Registration no.",
    control: control,
    placeholder: "Enter Registration no.",
    name: "district",
    mandatory: true,
    type: "textInput"
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Name",
    control: control,
    placeholder: "Enter Name",
    name: "district",
    mandatory: true,
    type: "textInput"
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Mobile Number",
    control: control,
    placeholder: "Enter Mobile Number",
    name: "mobileNumber",
    mobileNumber: true,
    mandatory: true,
    type: "textInput"
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Address ",
    control: control,
    placeholder: "Enter Address ",
    name: "district",
    mandatory: true,
    type: "textInput"
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "State",
    control: control,
    placeholder: "Enter State",
    name: "district",
    mandatory: true,
    type: "textInput",
    data: statesData
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "District",
    control: control,
    placeholder: "Enter District",
    name: "district",
    mandatory: true,
    type: "textInput"
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Qualification Certificates ",
    control: control,
    name: "picture",
    mandatory: true,
    type: "htmlUpload",
    uploadValidity: "(pdf file only and Max file Size 30 MB)"
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Experience Certificates  ",
    control: control,
    name: "picture",
    mandatory: true,
    type: "htmlUpload",
    uploadValidity: "(pdf file only and Max file Size 30 MB)"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Tehsil",
    control: control,
    placeholder: "Enter Tehsil",
    name: "district",
    mandatory: true,
    type: "textInput"
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Town/Village/Ward",
    control: control,
    placeholder: "Enter Town/Village/Ward",
    name: "district",
    mandatory: true,
    type: "textInput"
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "PIN No.",
    control: control,
    placeholder: "Enter PIN No. ",
    name: "district",
    mandatory: true,
    type: "textInput"
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "E-mail ID ",
    control: control,
    placeholder: "Enter E-mail ID ",
    name: "district",
    mandatory: true,
    type: "textInput"
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Class (As per Categories define)",
    control: control,
    placeholder: "Enter Class",
    name: "district",
    mandatory: true,
    type: "textInput"
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Degree University Name",
    control: control,
    placeholder: "Enter  Degree University Name",
    name: "district",
    mandatory: true,
    type: "textInput"
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Structural Engineer Information")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Registration no.",
    control: control,
    placeholder: "Enter Registration no.",
    name: "district",
    mandatory: true,
    type: "textInput"
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Name",
    control: control,
    placeholder: "Enter Name",
    name: "district",
    mandatory: true,
    type: "textInput"
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Mobile Number",
    control: control,
    placeholder: "Enter Mobile Number",
    name: "mobileNumber",
    mobileNumber: true,
    mandatory: true,
    type: "textInput"
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Address ",
    control: control,
    placeholder: "Enter Address ",
    name: "district",
    mandatory: true,
    type: "textInput"
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "State",
    control: control,
    placeholder: "Enter State",
    name: "district",
    mandatory: true,
    type: "textInput",
    data: statesData
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "District",
    control: control,
    placeholder: "Enter District",
    name: "district",
    mandatory: true,
    type: "textInput"
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Structural Engineer Stability Certificate ",
    control: control,
    name: "picture",
    mandatory: true,
    type: "htmlUpload",
    uploadValidity: "(pdf file only and Max file Size 30 MB)"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Tehsil",
    control: control,
    placeholder: "Enter Tehsil",
    name: "district",
    mandatory: true,
    type: "textInput"
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Town/Village/Ward",
    control: control,
    placeholder: "Enter Town/Village/Ward",
    name: "district",
    mandatory: true,
    type: "textInput"
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "PIN No.",
    control: control,
    placeholder: "Enter PIN No. ",
    name: "district",
    mandatory: true,
    type: "textInput"
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "E-mail ID ",
    control: control,
    placeholder: "Enter E-mail ID ",
    name: "district",
    mandatory: true,
    type: "textInput"
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "warning",
    size: "medium",
    label: "Prev"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save as Draft",
    type: "submit"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Next"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Reset"
  })))));
};

const Form12$1 = () => {
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Step1, null), /*#__PURE__*/React__default.createElement(Step2$1, null), /*#__PURE__*/React__default.createElement(Step2, null), /*#__PURE__*/React__default.createElement(Step3, null));
};

const Step1$1 = ({
  step1Data
}) => {
  const {
    handleSubmit,
    control
  } = useForm();
  const onSubmit = data => {
    step1Data(data);
  };
  return /*#__PURE__*/React__default.createElement("section", {
    className: "container1"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "header"
  }, "Form of application for permission under sub-section (2) of section 15-A or clause (a) of section 16 or sub-section (1) of section 30-A (beyond the limits as specified under section 30-A) of the Uttar Pradesh Town and Country Act,1977 (Act No. 12 of 1977) for sub-division/ development of land.", " "), /*#__PURE__*/React__default.createElement("div", {
    className: "headerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Applicant Information"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "primary",
    size: "medium",
    label: "Private Professional Information"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "primary",
    size: "medium",
    label: "Checklist"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "primary",
    size: "medium",
    label: "Documents"
  })), /*#__PURE__*/React__default.createElement("h5", {
    className: "mandatoryInfo"
  }, "(*) Indicates Mandatory Field")), /*#__PURE__*/React__default.createElement("div", {
    className: "straightLine"
  }), /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Location of proposed for Subdivision/Development")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "District",
    control: control,
    placeholder: "Select District",
    name: "district",
    mandatory: true,
    type: "selectInput",
    data: DistrictsData
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Notified Area",
    control: control,
    placeholder: "Select Notified Area",
    name: "notifiedArea",
    mandatory: true,
    type: "selectInput",
    data: NotifiedArea
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Name of Village",
    control: control,
    placeholder: "Select Name of Village",
    name: "nameOfVillage",
    mandatory: true,
    type: "selectInput",
    data: VillagesData
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Applicant Information")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Applicant Name",
    control: control,
    placeholder: "Enter Applicant Name",
    name: "applicantName",
    mandatory: true,
    type: "textInput"
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Guardian Name",
    control: control,
    placeholder: "Enter Guardian Name",
    name: "guardianName",
    mandatory: true,
    type: "textInput"
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Mobile Number",
    control: control,
    placeholder: "Enter Mobile Number",
    name: "applicantMobileNo",
    mobileNumber: true,
    mandatory: true,
    type: "textInput"
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Email Id",
    control: control,
    placeholder: "Enter Email Id",
    name: "emailId",
    type: "textInput"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Aadhaar No.",
    control: control,
    placeholder: "Enter Aadhaar No.",
    name: "aadharNo",
    type: "textInput",
    mandatory: true
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Upload Picture",
    control: control,
    name: "uploadPhoto",
    mandatory: true,
    type: "upload",
    uploadValidity: "(png file only and Max file Size 1 MB)"
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Address Details")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement("h3", {
    className: "addressType"
  }, "Correspondence Address"), /*#__PURE__*/React__default.createElement("div", {
    className: "inputContainer"
  }, /*#__PURE__*/React__default.createElement("h3", {
    className: "label multiCoumn"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, "*"), "Name :"), /*#__PURE__*/React__default.createElement(TextInput$2, {
    defaultValue: "Mr.",
    variant: "outlined",
    size: "small",
    width: "5.625vw",
    select: true,
    name: "initialForCorrespondenceadressName",
    control: control
  }, nameSuffix === null || nameSuffix === void 0 ? void 0 : nameSuffix.map(option => /*#__PURE__*/React__default.createElement(MenuItem$4, {
    key: option.value,
    value: option.value
  }, option.label))), /*#__PURE__*/React__default.createElement(TextInput$2, {
    label: "Enter Name",
    variant: "outlined",
    size: "small",
    width: "15.625vw",
    name: "correspondenceAdressName",
    control: control
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "inputContainer"
  }, /*#__PURE__*/React__default.createElement("h3", {
    className: "label multiCoumn"
  }, "Guardian Name :"), /*#__PURE__*/React__default.createElement(TextInput$2, {
    defaultValue: "S/O",
    variant: "outlined",
    size: "small",
    width: "5.625vw",
    select: true,
    name: "initialForCorrespondenceadressGuardianName",
    control: control
  }, relationSuffix === null || relationSuffix === void 0 ? void 0 : relationSuffix.map(option => /*#__PURE__*/React__default.createElement(MenuItem$4, {
    key: option.value,
    value: option.value
  }, option.label))), /*#__PURE__*/React__default.createElement(TextInput$2, {
    label: "Enter Guardian Name",
    variant: "outlined",
    size: "small",
    width: "15.625vw",
    name: "correspondenceGuardianName",
    control: control
  })), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    control: control,
    inputLabel: "Select State",
    label: "State :",
    data: statesData,
    placeholder: "Select State",
    name: "correspondenceState",
    mandatory: true,
    type: "selectInput",
    multiColumn: true
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    control: control,
    inputLabel: "Select District",
    label: "District :",
    data: DistrictsData,
    placeholder: "Select District",
    name: "correspondenceDistrict",
    mandatory: true,
    type: "selectInput",
    multiColumn: true
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    control: control,
    inputLabel: "Select Tehsil",
    label: "Tehsil :",
    placeholder: "Select Tehsil",
    name: "correspondenceTehsil",
    mandatory: true,
    type: "selectInput",
    multiColumn: true,
    data: TehsilData
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Town/Village/Ward : ",
    control: control,
    placeholder: "Enter Town/Village/Ward",
    name: "correspondenceVillage",
    mandatory: true,
    type: "textInput",
    multiColumn: true
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Address : ",
    control: control,
    placeholder: "Enter Address",
    name: "correspondenceAddress",
    mandatory: true,
    type: "textInput",
    multiColumn: true,
    multiLine: true
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: " Pincode : ",
    control: control,
    placeholder: "Enter Pincode",
    name: "correspondencePinCode",
    mandatory: true,
    type: "textInput",
    multiColumn: true
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "checkboxWrapper"
  }, /*#__PURE__*/React__default.createElement("h3", {
    className: "addressType"
  }, "Permanent Address"), /*#__PURE__*/React__default.createElement(Checkboxes, null), "Same as Corresponding Address"), /*#__PURE__*/React__default.createElement("div", {
    className: "inputContainer"
  }, /*#__PURE__*/React__default.createElement("h3", {
    className: "label multiCoumn"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, "*"), "Name :"), /*#__PURE__*/React__default.createElement(TextInput$2, {
    defaultValue: "Mr.",
    variant: "outlined",
    size: "small",
    width: "5.625vw",
    select: true,
    name: "initialForPermanentadressName",
    control: control
  }, nameSuffix === null || nameSuffix === void 0 ? void 0 : nameSuffix.map(option => /*#__PURE__*/React__default.createElement(MenuItem$4, {
    key: option.value,
    value: option.value
  }, option.label))), /*#__PURE__*/React__default.createElement(TextInput$2, {
    label: "Enter Name",
    variant: "outlined",
    size: "small",
    width: "15.625vw",
    name: "PermanentAdressName",
    control: control
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "inputContainer"
  }, /*#__PURE__*/React__default.createElement("h3", {
    className: "label multiCoumn"
  }, "Guardian Name :"), /*#__PURE__*/React__default.createElement(TextInput$2, {
    defaultValue: "S/O",
    variant: "outlined",
    size: "small",
    width: "5.625vw",
    select: true,
    name: "initialForPermanentadressGuardianName",
    control: control
  }, relationSuffix === null || relationSuffix === void 0 ? void 0 : relationSuffix.map(option => /*#__PURE__*/React__default.createElement(MenuItem$4, {
    key: option.value,
    value: option.value
  }, option.label))), /*#__PURE__*/React__default.createElement(TextInput$2, {
    label: "Enter Guardian Name",
    variant: "outlined",
    size: "small",
    width: "15.625vw",
    name: "PermanentGuardianName",
    control: control
  })), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    control: control,
    inputLabel: "Select State",
    label: "State :",
    data: statesData,
    placeholder: "Select State",
    name: "permanentState",
    mandatory: true,
    type: "selectInput",
    multiColumn: true
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    control: control,
    inputLabel: "Select District",
    label: "District :",
    data: DistrictsData,
    placeholder: "Select District",
    name: "permanentDistrict",
    mandatory: true,
    type: "selectInput",
    multiColumn: true
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    control: control,
    inputLabel: "Select Tehsil",
    label: "Tehsil :",
    placeholder: "Select Tehsil",
    name: "permanentTehsil",
    mandatory: true,
    type: "selectInput",
    multiColumn: true,
    data: TehsilData
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Town/Village/Ward : ",
    control: control,
    placeholder: "Enter Town/Village/Ward",
    name: "permanentVillage",
    mandatory: true,
    type: "textInput",
    multiColumn: true
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Address : ",
    control: control,
    placeholder: "Enter Address",
    name: "permanentAddress",
    mandatory: true,
    type: "textInput",
    multiColumn: true,
    multiLine: true
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: " Pincode : ",
    control: control,
    placeholder: "Enter Pincode",
    name: "permanentPincode",
    mandatory: true,
    type: "textInput",
    multiColumn: true
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Description of land proposed for Sub-division/Development of Land")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Revenue Village/Mohal/Phati/ Up Mohal",
    control: control,
    placeholder: "Select",
    name: "revenueVillageMohalla",
    mandatory: true,
    type: "selectInput",
    data: VillagesData
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Khasra No.",
    control: control,
    placeholder: "Enter Khasra No.",
    name: "khasraNo",
    type: "textInput",
    mandatory: true
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Khata No.",
    control: control,
    placeholder: "Enter Khata No.",
    name: "khataNo",
    type: "textInput",
    mandatory: true
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Khatauni No.",
    control: control,
    placeholder: "Enter Khatauni No.",
    name: "khatoniNo",
    type: "textInput"
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Latitude/Longitude",
    control: control,
    placeholder: "Enter Latitude/Longitude",
    name: "latitudeLongitude",
    type: "textInput"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Area under Consideration (Sq.m)",
    control: control,
    placeholder: "Enter Area under Consideration ",
    name: "areaUnderConsideration",
    mandatory: true,
    type: "textInput"
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "No. of Plot ",
    control: control,
    placeholder: "Enter No. of Plot ",
    name: "noOfPlot",
    mandatory: true,
    type: "textInput"
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: " Plot Area (Sq.M) for development Activities",
    control: control,
    placeholder: "Enter Area (Sq.M)",
    name: "plotAreaForSubDivisionalDevelopmentActivitiesInSqM",
    mandatory: true,
    type: "textInput"
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Total Plot Area (Sq.m)",
    control: control,
    placeholder: "Enter Total Plot Area (Sq.m)",
    name: "totalPlotArea",
    mandatory: true,
    type: "textInput"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "inputContainer"
  }, /*#__PURE__*/React__default.createElement("h3", {
    className: "label multiColumn"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, "*"), "Property Type :"), /*#__PURE__*/React__default.createElement(RadioButton$2, {
    row: true,
    data: propertyType,
    control: control,
    name: "propertyType"
  }))))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "warning",
    size: "medium",
    label: "Save as Draft"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Next",
    type: "submit"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Reset"
  })))));
};

const Step2$2 = ({
  step2Data
}) => {
  const {
    handleSubmit,
    control
  } = useForm();
  const onSubmit = data => {
    step2Data(data);
  };
  return /*#__PURE__*/React__default.createElement("section", {
    className: "container1"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "headerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "primary",
    size: "medium",
    label: "Applicant Information"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "primary",
    size: "medium",
    label: "Private Professional Information"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Checklist"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "primary",
    size: "medium",
    label: "Documents"
  })), /*#__PURE__*/React__default.createElement("h5", {
    className: "mandatoryInfo"
  }, "(*) Indicates Mandatory Field")), /*#__PURE__*/React__default.createElement("div", {
    className: "straightLine"
  }), /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Checklist to be filled"), /*#__PURE__*/React__default.createElement("div", {
    className: "tableWrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial heading"
  }, "SI# "), /*#__PURE__*/React__default.createElement("div", {
    className: "description heading"
  }, "Description"), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation heading"
  }, "As per Regulations"), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed heading"
  }, "As proposed"), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks heading"
  }, "Remarks"), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation heading"
  }, "Relaxation")), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "1. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Minimum width of pedestrian links to smaller cluster of plots, not exceeding 5 in number."), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "minimumWidthOfPedestrian",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "minimumWidthOfPedestrianremarks",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "2. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Minimum width of vehicular access, if number of plots is above 5."), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "minimumWidthOfVehicularAccess",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "minimumWidthOfVehicularAccessremarks",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "3. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Minimum area for open/green space for the scheme having more than 5 plots."), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "minimumAreaForOpenGreenSpace",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "minimumAreaForOpenGreenSpaceremarks",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "4. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Minimum area for soak pit etc. (irrespective of the number of plots)"), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "minimumAreaForSoakPit",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "minimumAreaForSoakPitRemarks",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "5. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Orientation of the plots shall be provided in such a manner to be in conformity with the integration of existing plots/infrastructure, wind direction, and natural flow of surface drainage unobstructed rain water discharge."), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }, " "), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(RadioButton$2, {
    control: control,
    name: "orientationOfPlots",
    data: yesOrNo
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "orientationOfPlotsRemarks",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "6. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Layout of plots shall be governed by easy access having acceptable grades minimum 1 in 15 and which may not obstruct view of vista"), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }, " "), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(RadioButton$2, {
    control: control,
    name: "layoutOfPlots",
    data: yesOrNo
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "layoutOfPlotsremarks",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "warning",
    size: "medium",
    label: "Save as Draft"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Next",
    type: "submit"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Reset"
  }))))));
};

const Step3$1 = ({
  step3Data
}) => {
  const {
    handleSubmit,
    control
  } = useForm();
  const [filesArr, setFilesArr] = useState([]);
  const onSubmit = data => {
    console.log(data);
    step3Data(filesArr);
  };
  const getDocumentData = async (file, fieldName) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("tenantId", "hr");
    formData.append("module", "property-upload");
    formData.append("tag", "tag-property");
    try {
      const resp = await axios.post("/filestore/v1/files", formData, {});
      console.log(resp, "ramsiyaramresp");
      const filesId = resp.data.files[0];
      filesArr.push({
        "documentType": fieldName,
        "fileStoreId": filesId.fileStoreId
      });
      console.log("ssssss", filesArr);
    } catch (error) {
      console.log(error.message);
    }
  };
  return /*#__PURE__*/React__default.createElement("section", {
    className: "container1"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "headerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "primary",
    size: "medium",
    label: "Applicant Information"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "primary",
    size: "medium",
    label: "Private Professional Information"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "primary",
    size: "medium",
    label: "Checklist"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Documents"
  })), /*#__PURE__*/React__default.createElement("h5", {
    className: "mandatoryInfo"
  }, "(*) Indicates Mandatory Field")), /*#__PURE__*/React__default.createElement("div", {
    className: "straightLine"
  }), /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Upload Documents")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Jamabandhi Document",
    control: control,
    name: "jamabandhiDocument",
    mandatory: true,
    type: "htmlUpload",
    uploadValidity: "(pdf file only and Max file Size 30 MB)",
    getDocumentData: getDocumentData
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Conveyance Deed/Sale/Lease ",
    control: control,
    name: "conveyanceDeed",
    mandatory: true,
    type: "htmlUpload",
    uploadValidity: "(pdf file only and Max file Size 30 MB)",
    getDocumentData: getDocumentData
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Demarcation Report/Affidavit",
    control: control,
    name: "demarcationReport",
    mandatory: true,
    type: "htmlUpload",
    uploadValidity: "(pdf file only and Max file Size 30 MB)",
    getDocumentData: getDocumentData
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Location Plan ",
    control: control,
    name: "locationPlan",
    mandatory: true,
    type: "htmlUpload",
    uploadValidity: "(pdf file only and Max file Size 30 MB)",
    getDocumentData: getDocumentData
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Tatima Documents",
    control: control,
    name: "tatimaDocuments",
    mandatory: true,
    type: "htmlUpload",
    uploadValidity: "(pdf file only and Max file Size 30 MB)",
    getDocumentData: getDocumentData
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Proposed Consolidated Map 1 (Note: Upload the map in portrait orientation) ",
    control: control,
    name: "proposedConsolidatedMap1",
    type: "htmlUpload",
    mandatory: true,
    uploadValidity: "(pdf file only and Max file Size 30 MB)",
    getDocumentData: getDocumentData
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Copy of Contouring Plan ",
    control: control,
    name: "copyOfContouringPlan",
    type: "htmlUpload",
    mandatory: true,
    uploadValidity: "(pdf file only and Max file Size 30 MB)",
    getDocumentData: getDocumentData
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "warning",
    size: "medium",
    label: "Save as Draft"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Finish",
    type: "submit"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Reset"
  })))));
};

const Form11 = () => {
  const [checkListData, setCheckListData] = useState({});
  const [documentData, setDocumentData] = useState([]);
  const [applicantData, setApplicantData] = useState([]);
  const [responseData, setResponseData] = useState({});
  const [applicationNumber, setApplicationNumber] = useState('');
  const [open, setOpen] = useState(false);
  const step1Data = data => {
    setApplicantData(data);
  };
  const step2Data = data => {
    setCheckListData(data);
  };
  const step3Data = data => {
    setDocumentData(data);
  };
  const filteredCheckListData = Object.entries(checkListData).reduce((acc, [key, value]) => {
    if (value !== undefined) {
      acc[key] = value;
    }
    return acc;
  }, {});
  const handleSubmit = () => {
    var _Digit$UserService, _Digit$UserService$ge;
    setOpen(true);
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", "Basic ZWdvdi11c2VyLWNsaWVudDo=");
    const userToken = localStorage.getItem('token');
    const UserToken = (_Digit$UserService = Digit.UserService) === null || _Digit$UserService === void 0 ? void 0 : (_Digit$UserService$ge = _Digit$UserService.getUser()) === null || _Digit$UserService$ge === void 0 ? void 0 : _Digit$UserService$ge.access_token;
    console.log({
      userToken,
      UserToken
    }, "ggggggggggg");
    var raw = JSON.stringify({
      "RequestInfo": {
        "api_id": "1",
        "ver": "1",
        "ts": null,
        "action": "create",
        "did": "",
        "key": "",
        "msg_id": "",
        "requester_id": "",
        "authToken": userToken
      },
      "BPA": {
        "approvalNo": null,
        "accountId": null,
        "edcrNumber": null,
        "riskType": null,
        "applicationType": "FORM_11",
        "serviceType": "FORM_11",
        "landId": null,
        "tenantId": "hr",
        "applicationDate": "1676613488134",
        "status": "INITIATE",
        "department": "TCP",
        "category": "Residential",
        "totalPlotArea": 1.02,
        "applcationDetail": {
          "applicantInfo": {
            "applicantName": applicantData && applicantData.applicantName,
            "guardianName": applicantData && applicantData.guardianName,
            "applicantMobileNo": applicantData && applicantData.applicantMobileNo,
            "aadharNo": applicantData && applicantData.aadharNo,
            "uploadPhoto": "",
            "addMoreApplicant": "VV SS RR",
            "emailId": applicantData && applicantData.emailId,
            "pvtProfMobileNo": applicantData && applicantData.applicantMobileNo,
            "nocApplicantInfo": null
          },
          "landAreaDetails": {
            "district": "district",
            "notifiedArea": "TCP",
            "category": "Residential",
            "nameOfVillage": "nameOfVillage",
            "nameOfULB": "nameOfULB",
            "nameOfWard": null,
            "additionalLandAreaDetails": {
              "Name": "Digambar",
              "Gender": "Male",
              "Age": "88",
              "Try": {
                "address": "address",
                "pin": "444708"
              }
            },
            "applicantionInfo": {
              "Name": "Digambar",
              "Gender": "Male",
              "Age": "88"
            }
          },
          "descriptionOfLand": {
            "revenueVillageMohalla": applicantData && applicantData.revenueVillageMohalla,
            "khatoniNo": applicantData && applicantData.khatoniNo,
            "khasraNo": applicantData && applicantData.khasraNo,
            "khataNo": applicantData && applicantData.khataNo,
            "latitudeLongitude": applicantData && applicantData.latitudeLongitude,
            "totalPlotArea": applicantData && applicantData.totalPlotArea,
            "areaUnderConsideration": applicantData && applicantData.areaUnderConsideration,
            "noOfPlot": applicantData && applicantData.noOfPlot,
            "pvtProfessionalInfo": "pvtProfessionalInfo",
            "useType": "useType",
            "propertyType": "propertyType",
            "plotAreaForSubDivisionalDevelopmentActivitiesInSqM": applicantData && applicantData.plotAreaForSubDivisionalDevelopmentActivitiesInSqM,
            "whetherChangeOfLandUseInvolved": true,
            "additionalDescriptionOfLandDeteails": {
              "address": applicantData && applicantData.correspondenceAddress,
              "pin": applicantData && applicantData.correspondencePinCode
            }
          },
          "permanentAddressDetails": {
            "name": applicantData && applicantData.PermanentAdressName,
            "type": "type",
            "guardianName": applicantData && applicantData.PermanentGuardianName,
            "state": applicantData && applicantData.permanentState,
            "district": applicantData && applicantData.permanentDistrict,
            "tehsil": applicantData && applicantData.permanentTehsil,
            "townVillageWard": applicantData && applicantData.permanentVillage,
            "address": applicantData && applicantData.permanentAddress,
            "pin": applicantData && applicantData.permanentPincode
          },
          "correspondenceAddressDetails": {
            "name": applicantData && applicantData.correspondenceAdressName,
            "type": "type",
            "guardianName": applicantData.correspondenceGuardianName,
            "state": applicantData && applicantData.correspondenceState,
            "district": applicantData && applicantData.correspondenceDistrict,
            "tehsil": applicantData && applicantData.correspondenceTehsil,
            "townVillageWard": applicantData && applicantData.correspondenceVillage,
            "address": applicantData && applicantData.correspondenceAddress,
            "pin": applicantData && applicantData.correspondencePinCode
          },
          "permissionOfSubdivisionChecklist": filteredCheckListData,
          "documents": documentData
        },
        "workflow": {
          "action": "INITIATE",
          "assignes": null,
          "comments": "PPPPPPP",
          "varificationDocuments": null
        }
      }
    });
    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };
    fetch(Urls$1.form11.create, requestOptions).then(response => response.text()).then(result => {
      setResponseData(result);
      console.log({
        result,
        responseData
      }, "rrrrr");
    }).catch(error => console.log('error', error));
  };
  useEffect(() => {
    console.log("ccccccc", checkListData, documentData, applicantData);
  }, [checkListData, documentData, applicantData]);
  const handleClose = () => {
    setOpen(false);
  };
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Step1$1, {
    step1Data: step1Data
  }), /*#__PURE__*/React__default.createElement(Step2$2, {
    step2Data: step2Data
  }), /*#__PURE__*/React__default.createElement(Step3$1, {
    step3Data: step3Data
  }), /*#__PURE__*/React__default.createElement(Button$2, {
    type: "submit",
    style: {
      backgroundColor: '#1fa47c',
      color: 'white',
      marginLeft: '650px',
      marginBottom: '100px'
    },
    onClick: handleSubmit
  }, "Submit"), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Dialog, {
    open: open,
    onClose: handleClose,
    "aria-labelledby": "alert-dialog-title",
    "aria-describedby": "alert-dialog-description"
  }, /*#__PURE__*/React__default.createElement(DialogTitle, {
    id: "alert-dialog-title"
  }, "Form - 11 Application submission details:"), /*#__PURE__*/React__default.createElement(DialogContent, null, /*#__PURE__*/React__default.createElement(DialogContentText, {
    id: "alert-dialog-description"
  }, "Your Application has been submitted successfully. Please note down your Application no - PBBPA20230614000200. for further assistance.")), /*#__PURE__*/React__default.createElement(DialogActions, null, /*#__PURE__*/React__default.createElement(Button$2, {
    onClick: handleClose
  }, "Back"), /*#__PURE__*/React__default.createElement(Button$2, {
    onClick: handleClose,
    autoFocus: true
  }, "Close")))));
};

const Step1$2 = () => {
  const {
    handleSubmit,
    control
  } = useForm();
  const onSubmit = data => console.log(data);
  return /*#__PURE__*/React__default.createElement("section", {
    className: "container1"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "header"
  }, "Form of application for composition of offences under section 39-C read with sub-section (3) of section 39 of the Uttar Pradesh Town and Country planning Act,1977 (Act no.12 of 1977)."), /*#__PURE__*/React__default.createElement("div", {
    className: "headerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Applicant Information"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "primary",
    size: "medium",
    label: "Private Professional Information"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "primary",
    size: "medium",
    label: "Checklist"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "primary",
    size: "medium",
    label: "Documents"
  })), /*#__PURE__*/React__default.createElement("h5", {
    className: "mandatoryInfo"
  }, "(*) Indicates Mandatory Field")), /*#__PURE__*/React__default.createElement("div", {
    className: "straightLine"
  }), /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Application Information")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "inputContainer"
  }, /*#__PURE__*/React__default.createElement("h3", {
    className: "label multiColumn"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, "*"), "Ortences/Deviation Details :"), /*#__PURE__*/React__default.createElement(RadioButton$2, {
    row: true,
    data: yesOrNo,
    control: control,
    name: "deviationDetails"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "inputContainer"
  }, /*#__PURE__*/React__default.createElement("h3", {
    className: "label"
  }, "If yes :"), /*#__PURE__*/React__default.createElement(SelectWrapper$2, {
    control: control,
    inputLabel: "Select Deviation Category",
    label: "Select Deviation Category",
    data: deviationCategory,
    width: "50vw"
  }))))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Application Details")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "inputContainer"
  }, /*#__PURE__*/React__default.createElement("h3", {
    className: "label"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, "*"), "Registration No. :"), /*#__PURE__*/React__default.createElement(TextInput$2, {
    label: "Enter Registration No.",
    variant: "outlined",
    size: "small",
    width: "15.625vw",
    name: "registrationNo.",
    control: control
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "inputContainer"
  }, /*#__PURE__*/React__default.createElement("h3", {
    className: "label"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, "*"), "Subject :"), /*#__PURE__*/React__default.createElement(TextInput$2, {
    label: "Enter Subject",
    variant: "outlined",
    size: "small",
    width: "15.625vw",
    name: "subject",
    control: control
  }))))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Hierarchy Details of Area/Proposed Construction Location")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "inputContainer"
  }, /*#__PURE__*/React__default.createElement("h3", {
    className: "label"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, "*"), "District :"), /*#__PURE__*/React__default.createElement(SelectWrapper$2, {
    control: control,
    inputLabel: "Select District",
    label: "Select District",
    data: DistrictsData
  })), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Name of Ward",
    control: control,
    placeholder: "Select Name of Ward",
    name: "notifiedArea",
    mandatory: true,
    type: "selectInput"
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Applicant Information")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "inputContainer"
  }, /*#__PURE__*/React__default.createElement("h3", {
    className: "label"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, "*"), "Applicant Name :"), /*#__PURE__*/React__default.createElement(TextInput$2, {
    defaultValue: "Mr.",
    variant: "outlined",
    size: "small",
    width: "5.625vw",
    select: true,
    name: "initialForApplicantName",
    control: control
  }, nameSuffix === null || nameSuffix === void 0 ? void 0 : nameSuffix.map(option => /*#__PURE__*/React__default.createElement(MenuItem$4, {
    key: option.value,
    value: option.value
  }, option.label))), /*#__PURE__*/React__default.createElement(TextInput$2, {
    label: "Enter Applicant Name",
    variant: "outlined",
    size: "small",
    width: "15.625vw",
    name: "applicantName",
    control: control
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "inputContainer"
  }, /*#__PURE__*/React__default.createElement("h3", {
    className: "label"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, "*"), "Guardian Name :"), /*#__PURE__*/React__default.createElement(TextInput$2, {
    defaultValue: "S/O",
    variant: "outlined",
    size: "small",
    width: "5.625vw",
    select: true,
    name: "initialForGuardianName",
    control: control
  }, relationSuffix === null || relationSuffix === void 0 ? void 0 : relationSuffix.map(option => /*#__PURE__*/React__default.createElement(MenuItem$4, {
    key: option.value,
    value: option.value
  }, option.label))), /*#__PURE__*/React__default.createElement(TextInput$2, {
    label: "Enter Guardian Name",
    variant: "outlined",
    size: "small",
    width: "15.625vw",
    name: "guardianName",
    control: control
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "inputContainer"
  }, /*#__PURE__*/React__default.createElement("h3", {
    className: "label"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, "*"), "Applicant Mobile Number:"), /*#__PURE__*/React__default.createElement(TextInput$2, {
    variant: "outlined",
    size: "small",
    width: "15.625vw",
    placeholder: "Enter Mobile Name",
    InputProps: {
      startAdornment: /*#__PURE__*/React__default.createElement(InputAdornment, {
        position: "start"
      }, "+91")
    },
    name: "applicantmMobileNumber",
    control: control
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "inputContainer"
  }, /*#__PURE__*/React__default.createElement("h3", {
    className: "label"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, "*"), "Aadhaar Number :"), /*#__PURE__*/React__default.createElement(TextInput$2, {
    variant: "outlined",
    size: "small",
    width: "15.625vw",
    placeholder: "Enter Aadhaar Number",
    name: "aadharNumber",
    control: control
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "inputContainer"
  }, /*#__PURE__*/React__default.createElement("h3", {
    className: "label"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, "*"), "Applicant Email ID :"), /*#__PURE__*/React__default.createElement(TextInput$2, {
    label: "Enter Email ID",
    variant: "outlined",
    size: "small",
    width: "15.625vw",
    name: "applicantEmailId",
    control: control
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "inputContainer"
  }, /*#__PURE__*/React__default.createElement("h3", {
    className: "photo label"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, "*"), "Upload Photo :"), /*#__PURE__*/React__default.createElement(UploadButton$2, null))))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Address Details")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement("h3", {
    className: "addressType"
  }, "Correspondence Address"), /*#__PURE__*/React__default.createElement("div", {
    className: "inputContainer"
  }, /*#__PURE__*/React__default.createElement("h3", {
    className: "label multiCoumn"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, "*"), "Name :"), /*#__PURE__*/React__default.createElement(TextInput$2, {
    defaultValue: "Mr.",
    variant: "outlined",
    size: "small",
    width: "5.625vw",
    select: true,
    name: "initialForCorrespondenceadressName",
    control: control
  }, nameSuffix === null || nameSuffix === void 0 ? void 0 : nameSuffix.map(option => /*#__PURE__*/React__default.createElement(MenuItem$4, {
    key: option.value,
    value: option.value
  }, option.label))), /*#__PURE__*/React__default.createElement(TextInput$2, {
    label: "Enter Name",
    variant: "outlined",
    size: "small",
    width: "15.625vw",
    name: "correspondenceAdressName",
    control: control
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "inputContainer"
  }, /*#__PURE__*/React__default.createElement("h3", {
    className: "label multiCoumn"
  }, "Guardian Name :"), /*#__PURE__*/React__default.createElement(TextInput$2, {
    defaultValue: "S/O",
    variant: "outlined",
    size: "small",
    width: "5.625vw",
    select: true,
    name: "initialForCorrespondenceadressGuardianName",
    control: control
  }, relationSuffix === null || relationSuffix === void 0 ? void 0 : relationSuffix.map(option => /*#__PURE__*/React__default.createElement(MenuItem$4, {
    key: option.value,
    value: option.value
  }, option.label))), /*#__PURE__*/React__default.createElement(TextInput$2, {
    label: "Enter Guardian Name",
    variant: "outlined",
    size: "small",
    width: "15.625vw",
    name: "correspondenceGuardianName",
    control: control
  })), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    control: control,
    inputLabel: "Select State",
    label: "State :",
    placeholder: "Select State",
    name: "state",
    mandatory: true,
    type: "selectInput",
    multiColumn: true,
    data: statesData
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    control: control,
    inputLabel: "Select District",
    label: "District :",
    data: DistrictsData,
    placeholder: "Select District",
    name: "state",
    mandatory: true,
    type: "selectInput",
    multiColumn: true
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    control: control,
    inputLabel: "Select Tehsil",
    label: "Tehsil :",
    placeholder: "Select Tehsil",
    name: "state",
    mandatory: true,
    type: "selectInput",
    multiColumn: true
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Town/Village/Ward : ",
    control: control,
    placeholder: "Enter Town/Village/Ward",
    name: "email",
    mandatory: true,
    type: "textInput",
    multiColumn: true
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Address : ",
    control: control,
    placeholder: "Enter Address",
    name: "address",
    mandatory: true,
    type: "textInput",
    multiColumn: true,
    multiLine: true
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: " Pincode : ",
    control: control,
    placeholder: "Enter Pincode",
    name: "email",
    mandatory: true,
    type: "textInput",
    multiColumn: true
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "checkboxWrapper"
  }, /*#__PURE__*/React__default.createElement("h3", {
    className: "addressType"
  }, "Permanent Address"), /*#__PURE__*/React__default.createElement(Checkboxes, null), "Same as Corresponding Address"), /*#__PURE__*/React__default.createElement("div", {
    className: "inputContainer"
  }, /*#__PURE__*/React__default.createElement("h3", {
    className: "label multiCoumn"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, "*"), "Name :"), /*#__PURE__*/React__default.createElement(TextInput$2, {
    defaultValue: "Mr.",
    variant: "outlined",
    size: "small",
    width: "5.625vw",
    select: true,
    name: "initialForCorrespondenceadressName",
    control: control
  }, nameSuffix === null || nameSuffix === void 0 ? void 0 : nameSuffix.map(option => /*#__PURE__*/React__default.createElement(MenuItem$4, {
    key: option.value,
    value: option.value
  }, option.label))), /*#__PURE__*/React__default.createElement(TextInput$2, {
    label: "Enter Name",
    variant: "outlined",
    size: "small",
    width: "15.625vw",
    name: "correspondenceAdressName",
    control: control
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "inputContainer"
  }, /*#__PURE__*/React__default.createElement("h3", {
    className: "label multiCoumn"
  }, "Guardian Name :"), /*#__PURE__*/React__default.createElement(TextInput$2, {
    defaultValue: "S/O",
    variant: "outlined",
    size: "small",
    width: "5.625vw",
    select: true,
    name: "initialForCorrespondenceadressGuardianName",
    control: control
  }, relationSuffix === null || relationSuffix === void 0 ? void 0 : relationSuffix.map(option => /*#__PURE__*/React__default.createElement(MenuItem$4, {
    key: option.value,
    value: option.value
  }, option.label))), /*#__PURE__*/React__default.createElement(TextInput$2, {
    label: "Enter Guardian Name",
    variant: "outlined",
    size: "small",
    width: "15.625vw",
    name: "correspondenceGuardianName",
    control: control
  })), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    control: control,
    inputLabel: "Select State",
    label: "State :",
    data: statesData,
    placeholder: "Select State",
    name: "state",
    mandatory: true,
    type: "selectInput",
    multiColumn: true
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    control: control,
    inputLabel: "Select District",
    label: "District :",
    data: DistrictsData,
    placeholder: "Select District",
    name: "state",
    mandatory: true,
    type: "selectInput",
    multiColumn: true
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    control: control,
    inputLabel: "Select Tehsil",
    label: "Tehsil :",
    placeholder: "Select Tehsil",
    name: "state",
    mandatory: true,
    type: "selectInput",
    multiColumn: true
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Town/Village/Ward : ",
    control: control,
    placeholder: "Enter Town/Village/Ward",
    name: "email",
    mandatory: true,
    type: "textInput",
    multiColumn: true
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Address : ",
    control: control,
    placeholder: "Enter Address",
    name: "address",
    mandatory: true,
    type: "textInput",
    multiColumn: true,
    multiLine: true
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: " Pincode : ",
    control: control,
    placeholder: "Enter Pincode",
    name: "email",
    mandatory: true,
    type: "textInput",
    multiColumn: true
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Offences/Deviation Details")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "inputContainer"
  }, /*#__PURE__*/React__default.createElement("h3", {
    className: "label multiColumn"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, "*"), "Revenue Village/Mohal/Phati/ Up Mohal :"), /*#__PURE__*/React__default.createElement(TextInput$2, {
    label: "Enter Revenue Village/Mohal",
    variant: "outlined",
    size: "small",
    width: "15.625vw",
    control: control,
    name: "correspondencePincode"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "inputContainer"
  }, /*#__PURE__*/React__default.createElement("h3", {
    className: "label multiColumn"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, "*"), "Khasra No. :"), /*#__PURE__*/React__default.createElement(TextInput$2, {
    label: "Enter Khasra No. ",
    variant: "outlined",
    size: "small",
    width: "15.625vw",
    control: control,
    name: "correspondencePincode"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "inputContainer"
  }, /*#__PURE__*/React__default.createElement("h3", {
    className: "label multiColumn"
  }, " ", /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, "*"), "Khata No. :"), /*#__PURE__*/React__default.createElement(TextInput$2, {
    label: "Enter Khata No.",
    variant: "outlined",
    size: "small",
    width: "15.625vw",
    control: control,
    name: "correspondencePincode"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "inputContainer"
  }, /*#__PURE__*/React__default.createElement("h3", {
    className: "label multiColumn"
  }, "Khatauni No. :"), /*#__PURE__*/React__default.createElement(TextInput$2, {
    label: "Enter Khatauni No. ",
    variant: "outlined",
    size: "small",
    width: "15.625vw",
    control: control,
    name: "correspondencePincode"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "inputContainer"
  }, /*#__PURE__*/React__default.createElement("h3", {
    className: "label multiColumn"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, "*"), "Total Plot Area(Sq.mt.) :"), /*#__PURE__*/React__default.createElement(TextInput$2, {
    label: "Enter Total Plot Area",
    variant: "outlined",
    size: "small",
    width: "15.625vw",
    disabled: true,
    control: control,
    name: "correspondencePincode"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "inputContainer"
  }, /*#__PURE__*/React__default.createElement("h3", {
    className: "label multiColumn"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, "*"), "Case reference no. :"), /*#__PURE__*/React__default.createElement(TextInput$2, {
    label: "Enter case reference no.",
    variant: "outlined",
    size: "small",
    width: "15.625vw",
    control: control,
    name: "correspondencePincode"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "inputContainer"
  }, /*#__PURE__*/React__default.createElement("h3", {
    className: "label multiColumn"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, "*"), "Maximum Permissible Ground Coverage (in Sq.mt.) :"), /*#__PURE__*/React__default.createElement(TextInput$2, {
    label: "Enter ground coverage",
    variant: "outlined",
    size: "small",
    width: "15.625vw",
    control: control,
    name: "correspondencePincode"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "inputContainer"
  }, /*#__PURE__*/React__default.createElement("h3", {
    className: "label multiColumn"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, "*"), "Applied land use :"), /*#__PURE__*/React__default.createElement(SelectWrapper$2, {
    control: control,
    inputLabel: "Select usage",
    label: "Select usage",
    data: deviationCategory,
    name: "correspondencePinc ode"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "inputContainer"
  }, /*#__PURE__*/React__default.createElement("h3", {
    className: "label multiColumn"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, "*"), "Property Type :"), /*#__PURE__*/React__default.createElement(RadioButton$2, {
    row: true,
    data: propertyType,
    control: control,
    name: "propertyType"
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "District",
    control: control,
    placeholder: "Select District",
    name: "revenueVillageMohalla",
    mandatory: true,
    type: "selectInput",
    data: propertyType
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Name of Ward",
    control: control,
    placeholder: "Select Name of Ward",
    name: "notifiedArea",
    mandatory: true,
    type: "selectInput"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "inputContainer"
  }, /*#__PURE__*/React__default.createElement("h3", {
    className: "label multiColumn"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, "*"), "Area (sq.m) :"), /*#__PURE__*/React__default.createElement(TextInput$2, {
    label: "Enter Area",
    variant: "outlined",
    size: "small",
    width: "15.625vw",
    name: "correspondencePincode",
    control: control
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "inputContainer"
  }, /*#__PURE__*/React__default.createElement("h3", {
    className: "label multiColumn"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, "*"), "wheather subdivision Approved :"), /*#__PURE__*/React__default.createElement(RadioButton$2, {
    row: true,
    data: yesOrNo,
    control: control,
    name: "wheatherSubdivisionApproved"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "inputContainer"
  }, /*#__PURE__*/React__default.createElement("h3", {
    className: "label multiColumn"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, "*"), "No. of Plot :"), /*#__PURE__*/React__default.createElement(TextInput$2, {
    label: "Enter No. of Plot",
    variant: "outlined",
    size: "small",
    width: "15.625vw",
    name: "correspondencePincode",
    control: control
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "inputContainer"
  }, /*#__PURE__*/React__default.createElement("h3", {
    className: "label multiColumn"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, "*"), "Proposal submitted for:"), /*#__PURE__*/React__default.createElement(SelectWrapper$2, {
    control: control,
    inputLabel: "Select proposal",
    label: "Select proposal",
    data: deviationCategory
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "inputContainer"
  }, /*#__PURE__*/React__default.createElement("h3", {
    className: "label multiColumn"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, "*"), "Plot Area For Sub-division/Development Activity(sq.m) :"), /*#__PURE__*/React__default.createElement(TextInput$2, {
    label: "Enter plot area",
    variant: "outlined",
    size: "small",
    width: "15.625vw",
    name: "correspondencePincode",
    control: control
  }))))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Builtup Area ")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "No. of Blocks  ",
    control: control,
    placeholder: "1",
    name: "revenueVillageMohalla",
    mandatory: true,
    type: "textInput"
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Details of Block 1 ")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement(Table$3, {
    striped: true,
    bordered: true
  }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", null, "SI#"), /*#__PURE__*/React__default.createElement("th", null, /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, "*"), "Floor Type"), /*#__PURE__*/React__default.createElement("th", null, /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, "*"), "Floor Area Sq.m."), /*#__PURE__*/React__default.createElement("th", null, /*#__PURE__*/React__default.createElement("span", {
    className: "compulsoryField"
  }, "*"), "Land Use Type"), /*#__PURE__*/React__default.createElement("th", null, "Parking Area"), /*#__PURE__*/React__default.createElement("th", null, "Exemption"), /*#__PURE__*/React__default.createElement("th", null, "Add More"))), /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "1"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(TextInput$2, {
    label: "Enter Floor Type",
    variant: "outlined",
    size: "small",
    name: "correspondenceAdressName",
    control: control
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(TextInput$2, {
    label: " Enter Floor Area ",
    variant: "outlined",
    size: "small",
    name: "correspondenceAdressName",
    control: control
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(SelectWrapper$2, {
    control: control,
    inputLabel: "Select Land Use Type",
    label: "Select Land Use Type",
    data: yesOrNo
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(TextInput$2, {
    label: " Enter Parking Area",
    variant: "outlined",
    size: "small",
    name: "correspondenceAdressName",
    control: control
  })), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(Checkboxes, null)), /*#__PURE__*/React__default.createElement("td", {
    className: "m-auto"
  }, /*#__PURE__*/React__default.createElement(AddCircleIcon, null))))))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Reason for composition of offences ")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Reason 1 ",
    control: control,
    placeholder: "Enter Details",
    name: "revenueVillageMohalla",
    mandatory: true,
    type: "textInput"
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Reason 2 ",
    control: control,
    placeholder: "Enter Details",
    name: "revenueVillageMohalla",
    mandatory: true,
    type: "textInput"
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Reason 3",
    control: control,
    placeholder: "Enter Actual Construction",
    name: "revenueVillageMohalla",
    mandatory: true,
    type: "textInput"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Supported Doc to be uploaded ",
    control: control,
    placeholder: "Enter Actual Construction",
    name: "revenueVillageMohalla",
    mandatory: true,
    type: "htmlUpload"
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "warning",
    size: "medium",
    label: "Prev"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save as Draft",
    type: "submit"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Next"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Reset"
  })))));
};

const Step3$2 = () => {
  const {
    handleSubmit,
    control
  } = useForm();
  const onSubmit = data => console.log(data);
  return /*#__PURE__*/React__default.createElement("section", {
    className: "container1"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "headerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "primary",
    size: "medium",
    label: "Applicant Information"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "primary",
    size: "medium",
    label: "Private Professional Information"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Checklist"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "primary",
    size: "medium",
    label: "Documents"
  })), /*#__PURE__*/React__default.createElement("h5", {
    className: "mandatoryInfo"
  }, "(*) Indicates Mandatory Field")), /*#__PURE__*/React__default.createElement("div", {
    className: "straightLine"
  }), /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Checklist to be filled"), /*#__PURE__*/React__default.createElement("div", {
    className: "tableWrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial heading"
  }, "SI# "), /*#__PURE__*/React__default.createElement("div", {
    className: "description heading"
  }, "Description"), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation heading"
  }, "As per Regulations"), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed heading"
  }, "As proposed"), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks heading"
  }, "Remarks"), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation heading"
  }, "Relaxation")), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "1. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Type of Area"), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "2. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Total Plot Area (Sq.m)"), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "3. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "ownership & Revenue documents"), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "4. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Land-use"), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "5. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "FAR"), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }, " "), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "6. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Built up Area (Sq.m)"), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }, " "), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "7. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Setbacks", /*#__PURE__*/React__default.createElement("div", {
    className: "box"
  }, /*#__PURE__*/React__default.createElement("p", null, "Front"), /*#__PURE__*/React__default.createElement("p", null, "Rear"), /*#__PURE__*/React__default.createElement("p", null, "Left"), /*#__PURE__*/React__default.createElement("p", null, "Right"), /*#__PURE__*/React__default.createElement("p", null, "Construction abuts with N.H."), /*#__PURE__*/React__default.createElement("p", null, "Front"), /*#__PURE__*/React__default.createElement("p", null, "Rear"), /*#__PURE__*/React__default.createElement("p", null, "Left"), /*#__PURE__*/React__default.createElement("p", null, "Side"))), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }, " "), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "8. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "No. of storeys "), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }, " "), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "9. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Road/Path Existing at site "), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }, " "), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "10. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Parking Provision "), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }, " "), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "11. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Whether any HT/LT Line, crossing over the proposed land"), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }, " "), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "12. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Whether proposed plan is located nearby ASI Protected monument"), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }, " "), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "13. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Whether proposed Plan is located nearby HFL"), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }, " "), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "14. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Whether trees are standing on Plot", /*#__PURE__*/React__default.createElement("div", {
    className: "box"
  }, /*#__PURE__*/React__default.createElement("p", null, "No. of Trees "), /*#__PURE__*/React__default.createElement("p", null, "Distance of Trees from Proposed development if not to be cut"), /*#__PURE__*/React__default.createElement("p", null, "Whether Permission of Competent authority for cutting of Trees"), /*#__PURE__*/React__default.createElement("p", null, "Whether plot is Abutting to Forest Boundary "), /*#__PURE__*/React__default.createElement("p", null, "Distance from Forest Boundary "))), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }, " "), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "15. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Whether plot is Directly abutting with National Highway/State Highway/Bypass/Other H.P. Public Department Schedule Road."), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }, " "), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "16. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Whether Proposed plot is abutting to natural drainage", /*#__PURE__*/React__default.createElement("div", {
    className: "box"
  }, /*#__PURE__*/React__default.createElement("p", null, "Distance from Nullah "), /*#__PURE__*/React__default.createElement("p", null, "Distance from Khud"))), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }, " "), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "17. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Whether any Pipeline/Sewerage line crossing or passing through the plot"), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }, " "), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "18. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Provision of Solar Passive Building"), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }, " "), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "19. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Provision of barrier free access for persons with disability"), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }, " "), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "20. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Whether the Proposed Plan is above the road level on Valley Side"), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }, " "), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "21. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Whether proposed Plan is located in Sinking and Sliding area"), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }, " "), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "22. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Rainwater harvesting tank provision"), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }, " "), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "23. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Structural Stability Certificate"), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }, " "), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "24. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "No. of Dwelling Units "), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }, " "), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "25. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Risk Based Classification of building", /*#__PURE__*/React__default.createElement("div", {
    className: "box"
  }, /*#__PURE__*/React__default.createElement("p", null, "Whether building with communication tower "), /*#__PURE__*/React__default.createElement("p", null, "Whether proposal is for Group Housing Scheme "), /*#__PURE__*/React__default.createElement("p", null, "Whether building raised on land fill "), /*#__PURE__*/React__default.createElement("p", null, "Whether building raised on reclaimed land "))), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }, " "), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "26. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "General Requirements", /*#__PURE__*/React__default.createElement("div", {
    className: "box"
  }, /*#__PURE__*/React__default.createElement("p", null, "Slope of land "), /*#__PURE__*/React__default.createElement("p", null, "Height of parking Door (Meter) "), /*#__PURE__*/React__default.createElement("p", null, " Height of slopping roof (Meter)"), /*#__PURE__*/React__default.createElement("p", null, " Height of Floor (Meter)"), /*#__PURE__*/React__default.createElement("p", null, " Height of Building (Meter Maximum hill cut (Meter) "), /*#__PURE__*/React__default.createElement("p", null, " Distance between two blocks (Meter)"), /*#__PURE__*/React__default.createElement("p", null, " Plinth height (Meter)"), /*#__PURE__*/React__default.createElement("p", null, " Height of Service Door (Meter)"), /*#__PURE__*/React__default.createElement("p", null, " Equivalent car Space Buildable width"))), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }, " "), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "27. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Site Photographs "), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }, " "), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "28. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Any other information "), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }, " "), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "29. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Whether the permission from Airport Authority of India is Required."), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }, " "), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "warning",
    size: "medium",
    label: "Save as Draft"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Next",
    type: "submit"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Reset"
  }))))));
};

const Step4 = () => {
  const {
    handleSubmit,
    control
  } = useForm();
  const onSubmit = data => console.log(data);
  return /*#__PURE__*/React__default.createElement("section", {
    className: "container1"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "headerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "primary",
    size: "medium",
    label: "Applicant Information"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "primary",
    size: "medium",
    label: "Private Professional Information"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "primary",
    size: "medium",
    label: "Checklist"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Documents"
  })), /*#__PURE__*/React__default.createElement("h5", {
    className: "mandatoryInfo"
  }, "(*) Indicates Mandatory Field")), /*#__PURE__*/React__default.createElement("div", {
    className: "straightLine"
  }), /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Upload Documents")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Jamabandhi Document ",
    control: control,
    name: "picture",
    mandatory: true,
    type: "htmlUpload",
    uploadValidity: "(pdf file only and Max file Size 30 MB)"
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Conveyance Deed/Sale/Lease ",
    control: control,
    name: "picture",
    mandatory: true,
    type: "htmlUpload",
    uploadValidity: "(pdf file only and Max file Size 30 MB)"
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Demarcation Report/Affidavit ",
    control: control,
    name: "picture",
    mandatory: true,
    type: "htmlUpload",
    uploadValidity: "(pdf file only and Max file Size 30 MB)"
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Tatima Documents ",
    control: control,
    name: "picture",
    mandatory: true,
    type: "htmlUpload",
    uploadValidity: "(pdf file only and Max file Size 30 MB)"
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Copy of Approval Map ",
    control: control,
    name: "picture",
    mandatory: true,
    type: "htmlUpload",
    uploadValidity: "(pdf file only and Max file Size 30 MB)"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Location Plan ",
    control: control,
    name: "picture",
    mandatory: true,
    type: "htmlUpload",
    uploadValidity: "(pdf file only and Max file Size 30 MB)"
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: " Site Plan  ",
    control: control,
    name: "picture",
    mandatory: true,
    type: "htmlUpload",
    uploadValidity: "(pdf file only and Max file Size 30 MB)"
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Affidavit of construction on own land ",
    control: control,
    name: "picture",
    mandatory: true,
    type: "htmlUpload",
    uploadValidity: "(pdf file only and Max file Size 30 MB)"
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "     Any other Doc   ",
    control: control,
    name: "picture",
    type: "htmlUpload",
    uploadValidity: "(pdf file only and Max file Size 30 MB)"
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: " \nProposed Consolidated Map 1 (Note: Upload the map in portrait orientation) \n",
    control: control,
    name: "picture",
    mandatory: true,
    type: "htmlUpload",
    uploadValidity: "(pdf file only and Max file Size 30 MB)"
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Other Documents")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Any other NOC if required ",
    control: control,
    name: "picture",
    mandatory: true,
    type: "htmlUpload",
    uploadValidity: "(pdf file only and Max file Size 30 MB)"
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "  Copy of sanction letter ",
    control: control,
    name: "picture",
    mandatory: true,
    type: "htmlUpload",
    uploadValidity: "(pdf file only and Max file Size 30 MB)"
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Any other affidavit if required",
    control: control,
    name: "picture",
    type: "htmlUpload",
    uploadValidity: "(pdf file only and Max file Size 30 MB)"
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "whether Agriculturist Himachali ",
    control: control,
    name: "picture",
    mandatory: true,
    type: "htmlUpload",
    uploadValidity: "(pdf file only and Max file Size 30 MB)"
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "warning",
    size: "medium",
    label: "Save as Draft"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Finish",
    type: "submit"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Reset"
  })))));
};

const Form26$1 = () => {
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Step1$2, null), /*#__PURE__*/React__default.createElement(Step2$1, null), /*#__PURE__*/React__default.createElement(Step3$2, null), /*#__PURE__*/React__default.createElement(Step4, null));
};

const Step1$3 = () => {
  const {
    handleSubmit,
    control
  } = useForm();
  const onSubmit = data => console.log(data);
  return /*#__PURE__*/React__default.createElement("section", {
    className: "container1"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "header"
  }, "The act and rule for Real Estate Projects derived from Rule 13, 14 and 16."), /*#__PURE__*/React__default.createElement("div", {
    className: "headerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Applicant Information"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "primary",
    size: "medium",
    label: "Checklist"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "primary",
    size: "medium",
    label: "Documents"
  })), /*#__PURE__*/React__default.createElement("h5", {
    className: "mandatoryInfo"
  }, "(*) Indicates Mandatory Field")), /*#__PURE__*/React__default.createElement("div", {
    className: "straightLine"
  }), /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Type of Real Es-tate Projects ",
    control: control,
    placeholder: "Select",
    name: "district",
    mandatory: true,
    type: "selectInput",
    data: appealApplicationStatus
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Name and Style of Project",
    control: control,
    placeholder: "Enter Name and Style of Project",
    name: "applicantName",
    mandatory: true,
    type: "textInput"
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Description of land proposed for Development of Land/Con-struction of Building")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Khasra No.",
    control: control,
    placeholder: "Enter Khasra No.",
    name: "applicantName",
    type: "textInput"
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Khatauni No.",
    control: control,
    placeholder: "Enter Khatauni No.",
    name: "applicantName",
    type: "textInput"
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Khata No.",
    control: control,
    placeholder: "Enter Khata No.",
    name: "applicantName",
    type: "textInput",
    mandatory: true
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Hadbast No.",
    control: control,
    placeholder: "Enter Hadbast No.",
    name: "applicantName",
    type: "textInput",
    mandatory: true
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Mauja/Mohal No.",
    control: control,
    placeholder: "Enter Mauja/Mohal No.",
    name: "applicantName",
    type: "textInput",
    mandatory: true
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Tehsil ",
    control: control,
    placeholder: "Select Tehsil ",
    name: "district",
    mandatory: true,
    type: "selectInput",
    data: yesOrNo
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "District ",
    control: control,
    placeholder: "Select District ",
    name: "district",
    mandatory: true,
    type: "selectInput",
    data: yesOrNo
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "State ",
    control: control,
    placeholder: "Select State ",
    name: "district",
    mandatory: true,
    type: "selectInput",
    data: yesOrNo
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Status of the Applicant ")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "whether individual or Company or Firm or Association of Persons or Co-operative Society or joint family",
    control: control,
    placeholder: "Enter Name ",
    name: "applicantName",
    mandatory: true,
    type: "textInput",
    labelWidth: "40vw"
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "In case of Individual or Associ-ation of Persons or joint family")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Name",
    control: control,
    placeholder: "Enter Name ",
    name: "applicantName",
    mandatory: true,
    type: "textInput"
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Father's Name",
    control: control,
    placeholder: "Enter Father's Name ",
    name: "applicantName",
    mandatory: true,
    type: "textInput"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Occupation",
    control: control,
    placeholder: "Enter Occupation ",
    name: "applicantName",
    mandatory: true,
    type: "textInput"
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Permanent Address",
    control: control,
    placeholder: "Enter Permanent Address ",
    name: "applicantName",
    mandatory: true,
    type: "textInput",
    multiLine: true
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "In case of Firm or Co-operative Society or Company")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Name",
    control: control,
    placeholder: "Enter Name ",
    name: "applicantName",
    mandatory: true,
    type: "textInput"
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Permanent Address",
    control: control,
    placeholder: "Enter Permanent Address ",
    name: "applicantName",
    mandatory: true,
    type: "textInput",
    multiLine: true
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Copy of Registra-tion Certificate",
    control: control,
    name: "picture",
    mandatory: true,
    type: "htmlUpload",
    uploadValidity: "(pdf file only and Max file Size 30 MB)"
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Major activities")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Remarks",
    control: control,
    placeholder: "Enter Remarks ",
    name: "applicantName",
    mandatory: true,
    type: "textInput"
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Name and Ad-dress of Part-ners/ Chief Exec-utive/ Full time Directors")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Name",
    control: control,
    placeholder: "Enter Name ",
    name: "applicantName",
    mandatory: true,
    type: "textInput"
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: " Address",
    control: control,
    placeholder: "Enter  Address ",
    name: "applicantName",
    mandatory: true,
    type: "textInput",
    multiLine: true
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Whether applicant is Income Tax payee/ as-sesses")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "If Yes ",
    control: control,
    placeholder: "Select",
    name: "district",
    mandatory: true,
    type: "selectInput",
    data: appealApplicationStatus
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Whether the applicant had ever been granted permis-sion to set up a Real Estate Pro-ject or Building or Apartment un-der any other law")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "If Yes ",
    control: control,
    placeholder: "Select",
    name: "district",
    mandatory: true,
    type: "selectInput",
    data: appealApplicationStatus
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Remarks",
    control: control,
    placeholder: "Enter Remarks ",
    name: "applicantName",
    mandatory: true,
    type: "textInput"
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "(Whether the ap-plicant has ever established a Real Estate Pro-ject or is estab-lishing a Real Es-tate Project, if, yes details thereof")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "If Yes ",
    control: control,
    placeholder: "Select",
    name: "district",
    mandatory: true,
    type: "selectInput",
    data: appealApplicationStatus
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Remarks",
    control: control,
    placeholder: "Enter Remarks ",
    name: "applicantName",
    mandatory: true,
    type: "textInput"
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "warning",
    size: "medium",
    label: "Prev"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Save as Draft",
    type: "submit"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Next"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Reset"
  })))));
};

const Step2$3 = () => {
  const {
    handleSubmit,
    control
  } = useForm();
  const onSubmit = data => console.log(data);
  return /*#__PURE__*/React__default.createElement("section", {
    className: "container1"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "headerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "primary",
    size: "medium",
    label: "Applicant Information"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Checklist"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "primary",
    size: "medium",
    label: "Documents"
  })), /*#__PURE__*/React__default.createElement("h5", {
    className: "mandatoryInfo"
  }, "(*) Indicates Mandatory Field")), /*#__PURE__*/React__default.createElement("div", {
    className: "straightLine"
  }), /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Checklist to be filled"), /*#__PURE__*/React__default.createElement("div", {
    className: "tableWrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial heading"
  }, "SI# "), /*#__PURE__*/React__default.createElement("div", {
    className: "description heading"
  }, "Description"), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation heading"
  }, "As per Regulations"), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed heading"
  }, "As proposed"), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks heading"
  }, "Remarks"), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation heading"
  }, "Relaxation")), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "1. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Name of Real Estate Project"), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "2. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Scheme Area."), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "3. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Slope of Area. "), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "4. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Means of Access"), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "5. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Land Use Structure. "), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "6. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Coverage", /*#__PURE__*/React__default.createElement("div", {
    className: "box"
  }, /*#__PURE__*/React__default.createElement("p", null, "Under Flats (Block wise). "), /*#__PURE__*/React__default.createElement("p", null, "Under other Uses (Block wise)"), /*#__PURE__*/React__default.createElement("p", null, "The Carpet area, area of exclu-sive balcony and area of exclu-sive terrace, if any."))), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "7. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Total Built up Area."), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "8. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Floor Area Ratio (FAR)."), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "9. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "No. of storeys in each Block."), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "10. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Height of each floor."), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "11. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Total Height of Block."), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "12. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "No. of Flats/Dwelling Units in each Block."), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "13. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Total Population."), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "14. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Density per Hectare."), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "15. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Detail of facilities like school, health services etc. concerning population."), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "16. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Parking provision."), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "17. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Structural Stability Certification."), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "18. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Distance of structures from natural drainage."), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "19. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Distance of structures from Highways and other Roads."), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "20. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Distance of structures from HT/LT lines."), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "21. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Self-declaration/undertaking by the applicant regarding maintaining requisite safe distance from electric lines as per the provision of the Uttar Pradesh State Electricity Board Limited in case HT/LT line is crossing over/ nearby proposed site."), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }, " "), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "22. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "No Objection Certificate (NOC) of competent authority in case site abuts National Highway. For other State Highways, and Uttar Pradesh Public Works Department\u2019s scheduled roads the applicant shall be required to submit a self-declaration/undertaking to maintain minimum control width/ setback as per provisions of the Uttar Pradesh Road-side Land Control Act, 1968."), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }, " "), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "23. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Self-declaration/undertaking regarding adhering to fire safety provisions as per Uttar Pradesh Fire Safety Rules, 2019 of Fire Service Department.", /*#__PURE__*/React__default.createElement("div", {
    className: "box"
  }, /*#__PURE__*/React__default.createElement("p", null, "(NOC shall be required at Completion Stage)"))), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }, " "), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "24. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "No Objection Certificate of the competent authority of Uttar Pradesh Irrigation and Public Health Department or consent of Central Ground Water Authority regarding use of ground water."), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }, " "), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "25. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Provision of Rainwater Harvesting system"), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }, " "), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "26. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Arrangement for disposal and treatment of solid waste, sullage, sewage, sewerage, and storm water."), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }, " "), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "27. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Provision for street lighting."), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }, " "), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "27. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Name of the registered Town Planner / Architect/Engineer with full correspondence address, appointed for the job."), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }, " "), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "serial"
  }, "27. "), /*#__PURE__*/React__default.createElement("div", {
    className: "description"
  }, "Name of the registered Structural Engineer with full correspondence address, appointed for the job."), /*#__PURE__*/React__default.createElement("div", {
    className: "regulation"
  }, " "), /*#__PURE__*/React__default.createElement("div", {
    className: "proposed"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "remarks"
  }, /*#__PURE__*/React__default.createElement(TextInput$2, {
    control: control,
    name: "proposed",
    placeholder: "Enter Details"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "relaxation"
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "warning",
    size: "medium",
    label: "Save as Draft"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Next",
    type: "submit"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Reset"
  }))))));
};

const Step3$3 = () => {
  const {
    handleSubmit,
    control
  } = useForm();
  const onSubmit = data => console.log(data);
  return /*#__PURE__*/React__default.createElement("section", {
    className: "container1"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "headerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "primary",
    size: "medium",
    label: "Applicant Information"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "primary",
    size: "medium",
    label: "Checklist"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Documents"
  })), /*#__PURE__*/React__default.createElement("h5", {
    className: "mandatoryInfo"
  }, "(*) Indicates Mandatory Field")), /*#__PURE__*/React__default.createElement("div", {
    className: "straightLine"
  }), /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Upload Documents")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Agriculture Certificate/Permission under section 118 of the HP tenancy and land reforms act 1972 ",
    control: control,
    name: "picture",
    mandatory: true,
    type: "htmlUpload",
    uploadValidity: "(pdf file only and Max file Size 30 MB)",
    labelWidth: "50vw"
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "In case of Firm/Company/Cooperative Society Copy of Regis-tration Certificate",
    control: control,
    name: "picture",
    mandatory: true,
    type: "htmlUpload",
    uploadValidity: "(pdf file only and Max file Size 30 MB)",
    labelWidth: "50vw"
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "A copy of latest Jamabandi (not being more than six-month-old), in original showing the title/ownership of the land under the Real Estate Project.",
    control: control,
    name: "picture",
    mandatory: true,
    type: "htmlUpload",
    uploadValidity: "(pdf file only and Max file Size 30 MB)",
    labelWidth: "50vw"
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "A copy of latest original Tatima(not being more than six month old), showing Khasra number(s), description and area of land in question, abutting Road/path with its width as well as adjoining Khasra numbers falling on all the outer limits/ boundaries of the land in question with their revenue classifi-cation.",
    control: control,
    name: "picture",
    mandatory: true,
    type: "htmlUpload",
    uploadValidity: "(pdf file only and Max file Size 30 MB)",
    labelWidth: "50vw"
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Details of encumbrances on the land on which development of project is proposed including details of any rights, title, inter-est, dues, mortgage, litigation in Revenue Courts and name of party in or over such land or non-encumbrance certificate from an Advocate having experience of atleast ten years or from the revenue authority not below the rank of Tehsildar/ Naib Tehsildar, as the case may be",
    control: control,
    name: "picture",
    mandatory: true,
    type: "htmlUpload",
    uploadValidity: "(pdf file only and Max file Size 30 MB)",
    labelWidth: "50vw"
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "Three sets of Location Plan in the scale of 1:1000 showing North direction, indicating the land in question, showing main approach road(s), name of road(s) on which the property and boundaries abuts, important public buildings like hospital, school, cinema, petrol pump, existing land uses / building uses surrounding the land.",
    control: control,
    name: "picture",
    mandatory: true,
    type: "htmlUpload",
    uploadValidity: "(pdf file only and Max file Size 30 MB)",
    labelWidth: "50vw"
  }), /*#__PURE__*/React__default.createElement(InputContainer$1, {
    label: "The Site Plan to be submitted along with the application for seeking permission shall be drawn to a scale of 1: 200 for plots up to 2500 square metres in size and on a scale of 1:500 for plots more than 2500 square metres in size",
    control: control,
    name: "picture",
    mandatory: true,
    type: "htmlUpload",
    uploadValidity: "(pdf file only and Max file Size 30 MB)",
    labelWidth: "50vw"
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "warning",
    size: "medium",
    label: "Save as Draft"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Submit",
    type: "submit"
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Reset"
  })))));
};

const Form34 = () => {
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Step1$3, null), ";", /*#__PURE__*/React__default.createElement(Step2$3, null), ";", /*#__PURE__*/React__default.createElement(Step3$3, null), ";");
};

const useStyles$n = makeStyles$1(() => ({
  root: {
    marginBottom: 16
  },
  heading: {
    textAlign: "center",
    fontSize: 20,
    fontWeight: "bold",
    marginBottom: 16,
    textDecoration: "none"
  },
  backButton: {
    marginBottom: 16,
    display: "flex",
    alignItems: "center"
  },
  backIcon: {
    marginRight: 8
  },
  card: {
    width: "50%",
    margin: "auto",
    backgroundColor: "#f5f5f5",
    borderRadius: 10,
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
    padding: 16
  },
  title: {
    marginBottom: 16,
    fontWeight: "bold"
  },
  link: {
    display: "block",
    textDecoration: "none",
    color: "#1F4A7C",
    marginBottom: 8,
    transition: "color 0.3s ease"
  },
  linkHover: {
    color: "#f50057"
  }
}));
const Form11Links = () => {
  const classes = useStyles$n();
  const handleGoBack = () => {
    window.location.href = "/digit-ui/citizen/profile";
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classes.backButton
  }, /*#__PURE__*/React__default.createElement(Button$3, {
    variant: "outlined",
    onClick: handleGoBack,
    style: {
      backgroundColor: "#1F4A7C",
      color: "#fff"
    }
  }, t("FASTPAS.GLOBAL.BACK.TEXT"))), /*#__PURE__*/React__default.createElement(Typography$3, {
    variant: "h4",
    component: "h1",
    className: classes.heading
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      fontWeight: "bold"
    }
  }, "Application for"), " permission of Subdivision/Development of land"), /*#__PURE__*/React__default.createElement(Card$4, {
    className: classes.card
  }, /*#__PURE__*/React__default.createElement(CardContent$3, null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      flexDirection: "row"
    }
  }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Typography$3, {
    variant: "h5",
    component: "h2",
    className: classes.title
  }, "Application Options"), /*#__PURE__*/React__default.createElement(Link$2, {
    href: "/digit-ui/citizen/obps/form11/",
    className: classes.link,
    underline: "none"
  }, "Apply"), /*#__PURE__*/React__default.createElement(Link$2, {
    href: "/digit-ui/citizen/obps/formLandUseApplications",
    className: classes.link,
    underline: "none"
  }, "My Applications")), /*#__PURE__*/React__default.createElement("img", {
    src: "https://github.com/SuryodayABM/TCP-Image/blob/main/Images/land-application-icons.png?raw=true",
    alt: "landapplication",
    style: {
      width: "220px",
      height: "220px",
      marginLeft: "200px",
      backgroundColor: "#ffffff"
    }
  })))));
};

const citizenBaseUrl$1 = "/digit-ui/citizen";
const ignoreURLsForTopBlueNav = [citizenBaseUrl$1, `${citizenBaseUrl$1}/applyOnline`, `${citizenBaseUrl$1}/onlineuserservices`, `${citizenBaseUrl$1}/feeCalculator`, `${citizenBaseUrl$1}/feecalculator`, `${citizenBaseUrl$1}/aboutus`, `${citizenBaseUrl$1}/notifications`, `${citizenBaseUrl$1}/acts`, `${citizenBaseUrl$1}/rules`, `${citizenBaseUrl$1}/faq`, `${citizenBaseUrl$1}/userguidemanual`, `${citizenBaseUrl$1}/contactus`, `${citizenBaseUrl$1}/ex-employee-profile`, `${citizenBaseUrl$1}/employee-profile`, `${citizenBaseUrl$1}/contact-us`, `${citizenBaseUrl$1}/organizational-setup`, `${citizenBaseUrl$1}/objectives`, `${citizenBaseUrl$1}/apartment-colonies-regulation`, `${citizenBaseUrl$1}/appendix-1`, `${citizenBaseUrl$1}/appendix-8`, `${citizenBaseUrl$1}/development-plan`, `${citizenBaseUrl$1}/court-orders`, `${citizenBaseUrl$1}/notifications-under-tcp-act`, `${citizenBaseUrl$1}/service-matter`, `${citizenBaseUrl$1}/delegation-of-powers`, `${citizenBaseUrl$1}/photo-gallery`, `${citizenBaseUrl$1}/video-gallery`, `${citizenBaseUrl$1}/heritage-gallery`, `${citizenBaseUrl$1}/content/faq`, `${citizenBaseUrl$1}/obps/services/ownerPortal`, `${citizenBaseUrl$1}/obps/services/selfResidentialPortal`, `${citizenBaseUrl$1}/obps/services/plinthPortal`, `${citizenBaseUrl$1}/obps/services/completionPortal`, `${citizenBaseUrl$1}/obps/services/compoundingModule`, `${citizenBaseUrl$1}/obps/services/selfApprovalPortal`, `${citizenBaseUrl$1}/obps/services/purchasablePortal`, `${citizenBaseUrl$1}/obps/services/groupHousingPortal`, `${citizenBaseUrl$1}/obps/services/propertyPortal`, `${citizenBaseUrl$1}/obps/services/selfCommercialPortal`, `${citizenBaseUrl$1}/obps/services/ltpPortal`, `${citizenBaseUrl$1}/obps/services/edcrPortal`, `${citizenBaseUrl$1}/obps/services/LandUseConversion`, `${citizenBaseUrl$1}/obps/services/formSuggestion`, `${citizenBaseUrl$1}/obps/services/farEdcrPortal`, `${citizenBaseUrl$1}/obps/services/mapRevalidation`, `${citizenBaseUrl$1}/obps/services/dashboard`, `${citizenBaseUrl$1}/obps/services/formLandUse`, `${citizenBaseUrl$1}/obps/services/oldCaseSearchLU`, `${citizenBaseUrl$1}/obps/services/formLandUse/UP`, `${citizenBaseUrl$1}/obps/structural/formLandUse/`, `${citizenBaseUrl$1}/obps/structural/FORM_PRESSRELEASE/`, `${citizenBaseUrl$1}/obps/services/mapSubmissionPortal`, `${citizenBaseUrl$1}/obps/services/purchasableFAR`, `${citizenBaseUrl$1}/obps/mapSubApplications`, `${citizenBaseUrl$1}/obps/formSuggestionApplications`, `${citizenBaseUrl$1}/obps/compoundingApplications`, `${citizenBaseUrl$1}/obps/nocApplications`, `${citizenBaseUrl$1}/obps/plinthApplications`, `${citizenBaseUrl$1}/obps/completionApplications`, `${citizenBaseUrl$1}/obps/pFARApplications`, `${citizenBaseUrl$1}/obps/purchasableFarApplications`, `${citizenBaseUrl$1}/obps/formLandUseApplications`, `${citizenBaseUrl$1}/obps/formLandUseConversionApplications`, `${citizenBaseUrl$1}/obps/formProfessionalApplications`, `${citizenBaseUrl$1}/obps/edcrscrutiny/apply/acknowledgement`, `${citizenBaseUrl$1}/obps/Payment/Applications`];
const ignoreDynamicUrls = [`${citizenBaseUrl$1}/obps/services/formLandUse/UP`, `${citizenBaseUrl$1}/obps/services/purchasableFAR/`, `${citizenBaseUrl$1}/payment/collect/`, `${citizenBaseUrl$1}/obps/architect/appendex10/`, `${citizenBaseUrl$1}/obps/services/mapSubmissionPortal/`, `${citizenBaseUrl$1}/obps/services/purchasablePortal/`, `${citizenBaseUrl$1}/obps/services/ltpPortal`, `${citizenBaseUrl$1}/obps/services/LandUseConversion`, `${citizenBaseUrl$1}/obps/services/formSuggestion`, `${citizenBaseUrl$1}/obps/services/WorkCommencementModule`, `${citizenBaseUrl$1}/obps/services/edcrPortal/`, `${citizenBaseUrl$1}/obps/services/farEdcrPortal/`, `${citizenBaseUrl$1}/obps/services/groupHousingPortal`, `${citizenBaseUrl$1}/obps/services/mapRevalidation/`, `${citizenBaseUrl$1}/obps/structural/formLandUse/`, `${citizenBaseUrl$1}/obps/structural/FORM_PRESSRELEASE/`, `${citizenBaseUrl$1}/obps/services/formLandUse/`, `${citizenBaseUrl$1}/obps/services/oldCaseSearchLU/`, `${citizenBaseUrl$1}/obps/structural/PURCHASABLE_FAR/`, `${citizenBaseUrl$1}/obps/services/plinthPortal/`, `${citizenBaseUrl$1}/obps/structuralform12/`, `${citizenBaseUrl$1}/obps/services/selfResidentialPortal`, `${citizenBaseUrl$1}/obps/services/selfApprovalPortal/`, `${citizenBaseUrl$1}/obps/services/selfCommercialPortal`, `${citizenBaseUrl$1}/obps/services/NOC/`, `${citizenBaseUrl$1}/obps/professional/payment/`, `${citizenBaseUrl$1}/obps/tradelicence/payment/`, `${citizenBaseUrl$1}/obps/Payment/Challan`, `${citizenBaseUrl$1}/obps/Payment/Applications/`, `${citizenBaseUrl$1}/obps/nocApplications/`, `${citizenBaseUrl$1}/obps/services/completionPortal/`];

const useStyles$o = makeStyles$1(theme => ({
  textContainer: {
    position: 'relative',
    overflow: 'hidden',
    width: '100%',
    height: 40,
    marginTop: '10px',
    backgroundColor: '#f0f0f0'
  },
  line1: {
    position: 'absolute',
    top: 0,
    whiteSpace: 'nowrap',
    animation: '$moveText 10s linear infinite',
    right: '10%',
    animationDelay: '0s'
  },
  '@keyframes moveText': {
    '0%': {
      transform: 'translateX(100%)'
    },
    '100%': {
      transform: 'translateX(-200%)'
    }
  }
}));
const GovtStrip$2 = () => {
  const classes = useStyles$o();
  return /*#__PURE__*/React__default.createElement(Box$1, {
    sx: {
      height: 100,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      bgcolor: '#f0f0f0',
      padding: '0 1.5rem'
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React__default.createElement("img", {
    src: "https://upload.wikimedia.org/wikipedia/commons/f/fa/Seal_of_Uttar_Pradesh.svg",
    alt: "image1",
    style: {
      height: '70px',
      marginRight: '20px'
    }
  }), /*#__PURE__*/React__default.createElement(Box$1, {
    sx: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "h6",
    fontWeight: "bold",
    sx: {
      marginTop: '10px',
      fontSize: '20px',
      width: '450px'
    },
    className: "titlegov"
  }, "Urban Development Department"), /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "h6",
    sx: {
      marginTop: '12px',
      fontSize: '15px',
      fontStyle: "italic",
      width: '450px'
    }
  }, "Govt of Uttar Pradesh, India"))), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("img", {
    src: "https://i.imgur.com/TmeY0xa.jpeg",
    alt: "image3",
    style: {
      height: '70px',
      marginLeft: '30px',
      marginRight: '30px',
      display: 'inline'
    }
  }), /*#__PURE__*/React__default.createElement("img", {
    src: "https://i.imgur.com/ERyQTFC.png",
    alt: "image4",
    style: {
      height: '70px',
      marginLeft: '30px',
      marginRight: '30px',
      display: 'inline'
    }
  }), /*#__PURE__*/React__default.createElement("img", {
    src: "https://www.hsvphry.org.in/assets/img/150-years-Mahatma-Gandhi-Logo.png",
    alt: "image5",
    style: {
      height: '70px',
      marginLeft: '30px',
      marginRight: '0px',
      display: 'inline'
    }
  })));
};

const Navbar1 = () => {
  const useStyles = makeStyles(theme => ({
    buttonStyle: {
      fontSize: '14px !important',
      color: 'azure !important',
      whiteSpace: 'nowrap',
      marginRight: 16,
      marginLeft: 16
    }
  }));
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React__default.useState(null);
  const [anchorEl1, setAnchorEl1] = React__default.useState(null);
  const [anchorElsnp, setAnchorElsnp] = React__default.useState(null);
  const [anchorElswm, setAnchorElswm] = React__default.useState(null);
  const [anchorElmncacts, setAnchorElmncacts] = React__default.useState(null);
  const [anchorEltna, setAnchorEltna] = React__default.useState(null);
  const open = Boolean(anchorEl);
  const opensnp = Boolean(anchorElsnp);
  const openswm = Boolean(anchorElswm);
  const openmncacts = Boolean(anchorElmncacts);
  const opentna = Boolean(anchorEltna);
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleClicksnp = event => {
    setAnchorElsnp(event.currentTarget);
  };
  const handleClickswm = event => {
    setAnchorElswm(event.currentTarget);
  };
  const handleClickmncacts = event => {
    setAnchorElmncacts(event.currentTarget);
  };
  const handleClicktna = event => {
    setAnchorEltna(event.currentTarget);
  };
  return /*#__PURE__*/React__default.createElement(AppBar, {
    style: {
      height: "45px",
      backgroundColor: "#0e7693",
      paddingLeft: '16px',
      paddingRight: "16px"
    },
    position: "static"
  }, /*#__PURE__*/React__default.createElement(Toolbar, {
    style: {
      minHeight: "45px"
    }
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    className: classes.buttonStyle,
    id: "home-button",
    "aria-haspopup": "true",
    component: Link$1,
    to: "/"
  }, /*#__PURE__*/React__default.createElement(HomeIcon$1, {
    style: {
      width: "30px",
      height: "30px"
    }
  })), /*#__PURE__*/React__default.createElement(Button$2, {
    className: classes.buttonStyle,
    id: "aboutus-button",
    "aria-haspopup": "false",
    component: Link$1,
    to: "/digit-ui/citizen/aboutus"
  }, "About Us"), /*#__PURE__*/React__default.createElement(Button$2, {
    component: Link$1,
    to: "/digit-ui/citizen/notifications",
    className: classes.buttonStyle,
    id: "snp-button",
    "aria-controls": opensnp ? 'schemes' : undefined,
    "aria-haspopup": "true",
    "aria-expanded": opensnp ? 'true' : undefined,
    onMouseOver: handleClicksnp
  }, "Notifications/Orders"), /*#__PURE__*/React__default.createElement(Button$2, {
    className: classes.buttonStyle,
    id: "actnrules-button",
    "aria-controls": open ? 'act' : undefined,
    "aria-haspopup": "true",
    "aria-expanded": open ? 'true' : undefined,
    onMouseOver: handleClick,
    endIcon: /*#__PURE__*/React__default.createElement(KeyboardArrowDownIcon, null)
  }, "Act & Rules"), /*#__PURE__*/React__default.createElement(Button$2, {
    href: "https://tcp.hp.gov.in/developmentPlan/8",
    className: classes.buttonStyle,
    id: "swm-ngt-button",
    "aria-controls": openswm ? 'solid' : undefined,
    "aria-haspopup": "true",
    "aria-expanded": openswm ? 'true' : undefined,
    onMouseOver: handleClickswm
  }, "Development Plan"), /*#__PURE__*/React__default.createElement(Button$2, {
    component: Link$1,
    to: "/digit-ui/citizen/faq",
    className: classes.buttonStyle,
    id: "mncacts-rules-button",
    "aria-controls": openmncacts ? 'basic-menu' : undefined,
    "aria-haspopup": "true",
    "aria-expanded": openmncacts ? 'true' : undefined,
    onClick: handleClickmncacts
  }, "FAQ"), /*#__PURE__*/React__default.createElement(Button$2, {
    component: Link$1,
    to: "/digit-ui/citizen/userguidemanual",
    className: classes.buttonStyle,
    id: "tendnadvt-button",
    "aria-controls": openmncacts ? 'basic-menu' : undefined,
    "aria-haspopup": "true",
    "aria-expanded": opentna ? 'true' : undefined,
    onClick: handleClicktna
  }, "User Guide"), /*#__PURE__*/React__default.createElement(Button$2, {
    className: classes.buttonStyle,
    id: "contactus-button",
    "aria-haspopup": "true",
    component: Link$1,
    to: "/digit-ui/citizen/contactus"
  }, "Contact Us"), /*#__PURE__*/React__default.createElement(Menu$1, {
    sx: {
      width: {
        sm: 400,
        md: 600
      },
      "& .MuiInputBase-root": {
        height: 80,
        whiteSpace: 'nowrap'
      },
      "& .MuiList-root": {
        width: 125,
        whiteSpace: 'nowrap',
        display: "Box",
        backgroundColor: "#0e7693",
        alignContent: "right"
      }
    },
    id: "act",
    anchorEl: anchorEl,
    open: open,
    onClose: handleClose,
    MenuListProps: {
      'aria-labelledby': 'basic-button'
    },
    anchorOrigin: {
      horizontal: 'left',
      vertical: 'bottom'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'left'
    }
  }, /*#__PURE__*/React__default.createElement(MenuItem$4, {
    style: {
      width: "80px",
      backgroundColor: "#0e7693"
    }
  }, /*#__PURE__*/React__default.createElement(NavLink, {
    to: "/digit-ui/citizen/acts",
    underline: "none",
    style: {
      textDecoration: "none",
      color: 'white'
    }
  }, "Acts")), /*#__PURE__*/React__default.createElement(Divider$1, {
    style: {
      color: "white"
    }
  }), /*#__PURE__*/React__default.createElement(MenuItem$4, {
    style: {
      width: "80px",
      backgroundColor: "#0e7693"
    }
  }, /*#__PURE__*/React__default.createElement(NavLink, {
    to: "/digit-ui/citizen/rules",
    underline: "none",
    style: {
      textDecoration: "none",
      color: 'white'
    }
  }, "Rules")))));
};

function Strip$1() {
  return /*#__PURE__*/React__default.createElement(AppBar, {
    position: "static",
    style: {
      backgroundColor: '#0e7693',
      color: 'white',
      height: '36px',
      marginTop: '-80px'
    }
  }, /*#__PURE__*/React__default.createElement(Toolbar, {
    sx: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start'
    }
  }, /*#__PURE__*/React__default.createElement(Box$1, {
    sx: {
      display: 'flex',
      alignItems: 'center',
      gap: 2,
      height: '36px'
    }
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "h6",
    component: "div",
    style: {
      fontSize: '14px',
      whiteSpace: "nowrap"
    }
  }, "\u0909\u0924\u094D\u0924\u0930 \u092A\u094D\u0930\u0926\u0947\u0936 \u0938\u0930\u0915\u093E\u0930"), /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "h6",
    component: "div",
    style: {
      fontSize: '14px'
    }
  }, "|"), /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "h6",
    component: "div",
    style: {
      fontSize: '12px',
      whiteSpace: "nowrap"
    }
  }, "Government of Uttar Pradesh")), /*#__PURE__*/React__default.createElement(Box$1, {
    sx: {
      display: 'flex',
      alignItems: 'center',
      gap: 2,
      height: '36px'
    }
  }, /*#__PURE__*/React__default.createElement(IconButton$2, {
    size: "small",
    "aria-label": "Facebook",
    onClick: () => window.open('https://www.facebook.com/HP-Department-of-Urban-Development-Shimla-1494597044125270/', "_blank")
  }, /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "18",
    height: "18",
    fill: "white",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951"
  }))), /*#__PURE__*/React__default.createElement(IconButton$2, {
    size: "small",
    "aria-label": "Twitter now X",
    onClick: () => window.open('https://www.twitter.com/UDHIMACHAL', "_blank")
  }, /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "18",
    height: "18",
    fill: "white",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M5.026 15c6.038 0 9.341-5.003 9.341-9.334 0-.14 0-.282-.006-.422A6.685 6.685 0 0 0 16 3.542a6.658 6.658 0 0 1-1.889.518 3.301 3.301 0 0 0 1.447-1.817 6.533 6.533 0 0 1-2.087.793A3.286 3.286 0 0 0 7.875 6.03a9.325 9.325 0 0 1-6.767-3.429 3.289 3.289 0 0 0 1.018 4.382A3.323 3.323 0 0 1 .64 6.575v.045a3.288 3.288 0 0 0 2.632 3.218 3.203 3.203 0 0 1-.865.115 3.23 3.23 0 0 1-.614-.057 3.283 3.283 0 0 0 3.067 2.277A6.588 6.588 0 0 1 .78 13.58a6.32 6.32 0 0 1-.78-.045A9.344 9.344 0 0 0 5.026 15"
  }))))));
}

function Header$4() {
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Strip$1, null), /*#__PURE__*/React__default.createElement(GovtStrip$2, null), /*#__PURE__*/React__default.createElement(Navbar1, null));
}

function AboutUs$1() {
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Header$4, null), /*#__PURE__*/React__default.createElement(Card$3, {
    style: {
      maxWidth: "auto",
      height: 'auto',
      boxShadow: 'rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px, rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset',
      marginBottom: "30px"
    }
  }, /*#__PURE__*/React__default.createElement(CardHeader$1, {
    title: "About Us",
    style: {
      color: "orange"
    }
  }), /*#__PURE__*/React__default.createElement(CardContent$2, null, /*#__PURE__*/React__default.createElement(Grid$1, {
    container: true,
    spacing: 1,
    style: {
      maxWidth: "auto",
      display: 'flex',
      flexDirection: 'column',
      padding: "0px 10px 0px 10px"
    }
  }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("img", {
    src: "https://obpsud.hp.gov.in/img/nahan.jpg",
    alt: "Image",
    style: {
      float: "right",
      width: "40%",
      margin: "15px 0px 10px 16px"
    }
  }), /*#__PURE__*/React__default.createElement("p", {
    className: "paragraph"
  }, "The Uttar Pradesh State is a predominantly hill State with the total population of 68.56 (6.85 Millions) residing in 55673 sq km area. Like any other part of our great country, urbanization is fast increasing and posing variety of problems related to urbanization in Uttar Pradesh as well. Currently urban population of the state is 6.89 Lakhs (0.69 Million) (10.04% of the total population) but it is fast increasing. The Directorate of Urban Development was established during the year 1985-86 to direct, control and monitor the activities of the Urban Local Bodies in the state of Uttar Pradesh. The Directorate has been assigned the responsibility to look after the legislative, Administrative and Development activities of 54 Municipalities (Local Urban Bodies) i.e. 2 Municipal Corporations, 31 Municipal Councils and 21 Nagar Panchayats."), /*#__PURE__*/React__default.createElement("p", {
    className: "paragraph"
  }, "From 1986 to May,1994, the Directorate was performing nominal regulatory functions which merely relates to the coordination of development works, release of grants and passing of municipal budgets. Consequent upon the 74th amendment of the constitution and the enactment of 3 new Municipal Acts viz. H.P. Municipal Corporation Act, 1994, Municipal Act, 1994 and H.P Municipal Services Act 1994, numerous Constitutional, Statutory and obligatory functions are entrusted to the Directorate. The 74th Constitutional Amendment envisages greater decentralization of administrative, legislative and financial functions to the Urban Local Government coupled with more and more functional autonomy to all the municipalities."), /*#__PURE__*/React__default.createElement("p", {
    className: "paragraph"
  }, "The urban Development Department of State, in close partnership with ULBs is striving to find innovative and advanced technological solutions to urban problems of the State like; integrated urban transport, Sanitation, Solid Waste Management, Urban Infrastructure, Urban Poverty, Urban Housing, Urban Planning, Financial Sustainability of ULBs and general Urban Governance. "), /*#__PURE__*/React__default.createElement("p", {
    className: "paragraph"
  }, "The task is gigantic; but the Department find it to be achievable through the active community involvement and hard work and sincere efforts of all officers and employees of the department.")))))));
}

function NavbarFooter() {
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("footer", {
    style: {
      backgroundColor: "#014255",
      height: "65px",
      position: 'fixed',
      width: "100%",
      bottom: "0",
      left: "0"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      float: "left",
      marginRight: "50px"
    }
  }, /*#__PURE__*/React__default.createElement("ul", {
    style: {
      padding: "0px 0px 0px 10px"
    }
  }, /*#__PURE__*/React__default.createElement("li", {
    style: {
      color: "white",
      display: "inline",
      margin: "0px 10px 0px 10px"
    }
  }, /*#__PURE__*/React__default.createElement("a", {
    href: "http://localhost:3000/",
    title: "home",
    style: {
      color: "white",
      listStyle: "none",
      fontSize: "15px"
    }
  }, "Home")), /*#__PURE__*/React__default.createElement("span", {
    style: {
      color: "white"
    }
  }, "|"), /*#__PURE__*/React__default.createElement("li", {
    style: {
      color: "white",
      display: "inline",
      margin: "0px 10px 0px 10px"
    }
  }, /*#__PURE__*/React__default.createElement("a", {
    href: "faq",
    title: "home",
    style: {
      color: "white",
      listStyle: "none",
      fontSize: "15px"
    }
  }, "FAQ ")), /*#__PURE__*/React__default.createElement("span", {
    style: {
      color: "white"
    }
  }, "|"), /*#__PURE__*/React__default.createElement("li", {
    style: {
      color: "white",
      display: "inline",
      margin: "0px 10px 0px 10px"
    }
  }, /*#__PURE__*/React__default.createElement("a", {
    href: "http://localhost:3000/contactus",
    title: "home",
    style: {
      color: "white",
      listStyle: "none",
      fontSize: "15px"
    }
  }, "Contact Us ")), /*#__PURE__*/React__default.createElement("li", {
    style: {
      color: "white",
      marginLeft: "10px",
      marginTop: "5px",
      listStyle: "none",
      fontSize: "13px"
    }
  }, "2017 \xA9 Urban Development Department. All Rights Reserved."))), /*#__PURE__*/React__default.createElement("div", {
    style: {
      float: "right",
      width: "50%",
      color: "white",
      margin: "20px 70px 0px 0px",
      textAlign: "right"
    }
  }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("span", null, "Total Visitors :-", /*#__PURE__*/React__default.createElement("strong", null, "223367"), " ")), /*#__PURE__*/React__default.createElement("div", {
    style: {
      float: "right",
      color: "white",
      margin: "0px 0px 10px 0px",
      textAlign: "right",
      fontSize: "14px"
    }
  }, "Powered By ", /*#__PURE__*/React__default.createElement("span", {
    style: {
      color: "skyblue"
    }
  }, "ABM Knowedgeware Limited")))));
}

const Notifications = () => {
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Header$4, null), /*#__PURE__*/React__default.createElement(Box$1, {
    sx: {
      width: '100%',
      pb: 4
    }
  }, /*#__PURE__*/React__default.createElement(Card$3, {
    style: {
      maxWidth: "100%",
      height: 'auto',
      margin: '20px',
      boxShadow: 'rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px, rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset'
    }
  }, /*#__PURE__*/React__default.createElement(CardHeader$1, {
    title: "Notifications/Orders",
    style: {
      color: "orange"
    }
  }), /*#__PURE__*/React__default.createElement(CardContent$2, null, /*#__PURE__*/React__default.createElement(Grid$1, {
    container: true,
    rowSpacing: 1,
    columnSpacing: {
      xs: 1,
      sm: 2,
      md: 3
    },
    style: {
      display: 'flex',
      flexDirection: 'row',
      margin: '10px'
    }
  }, /*#__PURE__*/React__default.createElement(Grid$1, {
    xs: 6
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "noti-sec"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "pdf-sec"
  }, /*#__PURE__*/React__default.createElement("a", {
    href: "https://obpsud.hp.gov.in/Download/Central%20Inspection%20Framework%20information.pdf"
  }, /*#__PURE__*/React__default.createElement(BsFilePdf, {
    size: 80,
    color: "#274472"
  })), "Download"), /*#__PURE__*/React__default.createElement("div", {
    className: "data-sec"
  }, /*#__PURE__*/React__default.createElement("h5", {
    style: {
      fontSize: "18px",
      fontWeight: "500",
      fontFamily: "Open Sans",
      lineHeight: "22px"
    }
  }, "Central Inspection Framework information"), /*#__PURE__*/React__default.createElement("span", {
    style: {
      color: "#9e9e9e",
      display: "inline"
    }
  }, /*#__PURE__*/React__default.createElement(CalendarMonth, {
    style: {
      verticalAlign: "bottom"
    }
  }), /*#__PURE__*/React__default.createElement("span", {
    style: {
      verticalAlign: "top"
    }
  }, "1-1-2018"))))), /*#__PURE__*/React__default.createElement(Grid$1, {
    xs: 6
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "noti-sec"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "pdf-sec"
  }, /*#__PURE__*/React__default.createElement("a", {
    href: "https://obpsud.hp.gov.in/Download/Clarification%20on%20%20Delegation%20of%20power%20under%20TCP%20Act%201977.pdf"
  }, /*#__PURE__*/React__default.createElement(BsFilePdf, {
    size: 80,
    color: "#274472"
  })), "Download"), /*#__PURE__*/React__default.createElement("div", {
    className: "data-sec"
  }, /*#__PURE__*/React__default.createElement("h5", {
    style: {
      fontSize: "18px",
      fontWeight: "500",
      fontFamily: "Open Sans",
      lineHeight: "22px"
    }
  }, "Clarification from TCP Deptt. on Delegations of Powers"), /*#__PURE__*/React__default.createElement("span", {
    style: {
      color: "#9e9e9e",
      display: "inline"
    }
  }, /*#__PURE__*/React__default.createElement(CalendarMonth, {
    style: {
      verticalAlign: "bottom"
    }
  }), /*#__PURE__*/React__default.createElement("span", {
    style: {
      verticalAlign: "top"
    }
  }, "1-1-2018"))))), /*#__PURE__*/React__default.createElement(Grid$1, {
    xs: 6
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "noti-sec"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "pdf-sec"
  }, /*#__PURE__*/React__default.createElement("a", {
    href: "https://obpsud.hp.gov.in/Download/Clarification%20on%20%20Delegation%20of%20power%20under%20TCP%20Act%201977.pdf"
  }, /*#__PURE__*/React__default.createElement(BsFilePdf, {
    size: 80,
    color: "#274472"
  })), "Download"), /*#__PURE__*/React__default.createElement("div", {
    className: "data-sec"
  }, /*#__PURE__*/React__default.createElement("h5", {
    style: {
      fontSize: "18px",
      fontWeight: "500",
      fontFamily: "Open Sans",
      lineHeight: "22px"
    }
  }, "Clarification on  Delegation of power under TCP Act 1977"), /*#__PURE__*/React__default.createElement("span", {
    style: {
      color: "#9e9e9e",
      display: "inline"
    }
  }, /*#__PURE__*/React__default.createElement(CalendarMonth, {
    style: {
      verticalAlign: "bottom"
    }
  }), /*#__PURE__*/React__default.createElement("span", {
    style: {
      verticalAlign: "top"
    }
  }, "1-1-2018"))))), /*#__PURE__*/React__default.createElement(Grid$1, {
    CardContent: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "noti-sec"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "pdf-sec"
  }, /*#__PURE__*/React__default.createElement("a", {
    href: "https://obpsud.hp.gov.in/Download/Clarification%20on%20%20Delegation%20of%20power%20under%20TCP%20Act%201977.pdf"
  }, /*#__PURE__*/React__default.createElement(BsFilePdf, {
    size: 80,
    color: "#274472"
  })), "Download"), /*#__PURE__*/React__default.createElement("div", {
    className: "data-sec"
  }, /*#__PURE__*/React__default.createElement("h5", {
    style: {
      fontSize: "18px",
      fontWeight: "500",
      fontFamily: "Open Sans",
      lineHeight: "22px"
    }
  }, "Instruction on Strengthening of IT Infrastructure in the ULBs"), /*#__PURE__*/React__default.createElement("span", {
    style: {
      color: "#9e9e9e",
      display: "inline"
    }
  }, /*#__PURE__*/React__default.createElement(CalendarMonth, {
    style: {
      verticalAlign: "bottom"
    }
  }), /*#__PURE__*/React__default.createElement("span", {
    style: {
      verticalAlign: "top"
    }
  }, "1-1-2018"))))), /*#__PURE__*/React__default.createElement(Grid$1, {
    CardContent: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "noti-sec"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "pdf-sec"
  }, /*#__PURE__*/React__default.createElement("a", {
    href: "https://obpsud.hp.gov.in/Download/Instruction%20regarding%20Issuance%20of%20Trade%20Licences.pdf"
  }, /*#__PURE__*/React__default.createElement(BsFilePdf, {
    size: 80,
    color: "#274472"
  })), "Download"), /*#__PURE__*/React__default.createElement("div", {
    className: "data-sec"
  }, /*#__PURE__*/React__default.createElement("h5", {
    style: {
      fontSize: "18px",
      fontWeight: "500",
      fontFamily: "Open Sans",
      lineHeight: "22px"
    }
  }, "Instruction regarding Issuance of Trade Licences"), /*#__PURE__*/React__default.createElement("span", {
    style: {
      color: "#9e9e9e",
      display: "inline"
    }
  }, /*#__PURE__*/React__default.createElement(CalendarMonth, {
    style: {
      verticalAlign: "bottom"
    }
  }), /*#__PURE__*/React__default.createElement("span", {
    style: {
      verticalAlign: "top"
    }
  }, "1-1-2018"))))), /*#__PURE__*/React__default.createElement(Grid$1, {
    CardContent: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "noti-sec"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "pdf-sec"
  }, /*#__PURE__*/React__default.createElement("a", {
    href: "https://obpsud.hp.gov.in/Download/Instruction%20regarding%20Publishing%20Information%20on%20website.pdf"
  }, /*#__PURE__*/React__default.createElement(BsFilePdf, {
    size: 80,
    color: "#274472"
  })), "Download"), /*#__PURE__*/React__default.createElement("div", {
    className: "data-sec"
  }, /*#__PURE__*/React__default.createElement("h5", {
    style: {
      fontSize: "18px",
      fontWeight: "500",
      fontFamily: "Open Sans",
      lineHeight: "22px"
    }
  }, "Instruction regarding Publishing Information on website"), /*#__PURE__*/React__default.createElement("span", {
    style: {
      color: "#9e9e9e",
      display: "inline"
    }
  }, /*#__PURE__*/React__default.createElement(CalendarMonth, {
    style: {
      verticalAlign: "bottom"
    }
  }), /*#__PURE__*/React__default.createElement("span", {
    style: {
      verticalAlign: "top"
    }
  }, "1-1-2018"))))), /*#__PURE__*/React__default.createElement(Grid$1, {
    CardContent: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "noti-sec"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "pdf-sec"
  }, /*#__PURE__*/React__default.createElement("a", {
    href: "https://obpsud.hp.gov.in/Download/Instructions%20on%20adoption%20of%20the%20HP%20TCP%20Rules,%202014.pdf"
  }, /*#__PURE__*/React__default.createElement(BsFilePdf, {
    size: 80,
    color: "#274472"
  })), "Download"), /*#__PURE__*/React__default.createElement("div", {
    className: "data-sec"
  }, /*#__PURE__*/React__default.createElement("h5", {
    style: {
      fontSize: "18px",
      fontWeight: "500",
      fontFamily: "Open Sans",
      lineHeight: "22px"
    }
  }, "Instructions on adoption of the HP TCP Rules, 2014"), /*#__PURE__*/React__default.createElement("span", {
    style: {
      color: "#9e9e9e",
      display: "inline"
    }
  }, /*#__PURE__*/React__default.createElement(CalendarMonth, {
    style: {
      verticalAlign: "bottom"
    }
  }), /*#__PURE__*/React__default.createElement("span", {
    style: {
      verticalAlign: "top"
    }
  }, "1-1-2018"))))), /*#__PURE__*/React__default.createElement(Grid$1, {
    CardContent: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "noti-sec"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "pdf-sec"
  }, /*#__PURE__*/React__default.createElement("a", {
    href: "https://obpsud.hp.gov.in/Download/Notification_Regarding_deligation_of_Powers_of_Director_TCP_to_34_ULBs.pdf"
  }, /*#__PURE__*/React__default.createElement(BsFilePdf, {
    size: 80,
    color: "#274472"
  })), "Download"), /*#__PURE__*/React__default.createElement("div", {
    className: "data-sec"
  }, /*#__PURE__*/React__default.createElement("h5", {
    style: {
      fontSize: "18px",
      fontWeight: "500",
      fontFamily: "Open Sans",
      lineHeight: "22px"
    }
  }, "Notification Regarding deligation of  Powers  of  Director TCP to 34 ULBs"), /*#__PURE__*/React__default.createElement("span", {
    style: {
      color: "#9e9e9e",
      display: "inline"
    }
  }, /*#__PURE__*/React__default.createElement(CalendarMonth, {
    style: {
      verticalAlign: "bottom"
    }
  }), /*#__PURE__*/React__default.createElement("span", {
    style: {
      verticalAlign: "top"
    }
  }, "1-1-2018"))))), /*#__PURE__*/React__default.createElement(Grid$1, {
    CardContent: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "noti-sec"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "pdf-sec"
  }, /*#__PURE__*/React__default.createElement("a", {
    href: "https://obpsud.hp.gov.in/Download/Office%20Orders%20on%20inseption%20to%20be%20carried%20out.pdf"
  }, /*#__PURE__*/React__default.createElement(BsFilePdf, {
    size: 80,
    color: "#274472"
  })), "Download"), /*#__PURE__*/React__default.createElement("div", {
    className: "data-sec"
  }, /*#__PURE__*/React__default.createElement("h5", {
    style: {
      fontSize: "18px",
      fontWeight: "500",
      fontFamily: "Open Sans",
      lineHeight: "22px"
    }
  }, "Office Orders on inseption to be carried out"), /*#__PURE__*/React__default.createElement("span", {
    style: {
      color: "#9e9e9e",
      display: "inline"
    }
  }, /*#__PURE__*/React__default.createElement(CalendarMonth, {
    style: {
      verticalAlign: "bottom"
    }
  }), /*#__PURE__*/React__default.createElement("span", {
    style: {
      verticalAlign: "top"
    }
  }, "1-1-2018"))))), /*#__PURE__*/React__default.createElement(Grid$1, {
    CardContent: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "noti-sec"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "pdf-sec"
  }, /*#__PURE__*/React__default.createElement("a", {
    href: "https://obpsud.hp.gov.in/Download/Risk%20Based%20Classification%20of%20Buildings.pdf"
  }, /*#__PURE__*/React__default.createElement(BsFilePdf, {
    size: 80,
    color: "#274472"
  })), "Download"), /*#__PURE__*/React__default.createElement("div", {
    className: "data-sec"
  }, /*#__PURE__*/React__default.createElement("h5", {
    style: {
      fontSize: "18px",
      fontWeight: "500",
      fontFamily: "Open Sans",
      lineHeight: "22px"
    }
  }, "Risk Based Classification of Buildings"), /*#__PURE__*/React__default.createElement("span", {
    style: {
      color: "#9e9e9e",
      display: "inline"
    }
  }, /*#__PURE__*/React__default.createElement(CalendarMonth, {
    style: {
      verticalAlign: "bottom"
    }
  }), /*#__PURE__*/React__default.createElement("span", {
    style: {
      verticalAlign: "top"
    }
  }, "1-1-2018"))))))))), /*#__PURE__*/React__default.createElement(NavbarFooter, null));
};

const EDCRFAQ = () => {
  return /*#__PURE__*/React__default.createElement(Container$1, {
    style: {
      alignItems: 'flex-start',
      textAlign: 'left',
      marginTop: '20px',
      marginLeft: '-30px'
    }
  }, /*#__PURE__*/React__default.createElement(Box$1, {
    mb: 4
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "h6",
    align: "justify",
    gutterBottom: true
  }, "FAQ Regarding (User manual and Sample Drawing in EDCR Format)"), /*#__PURE__*/React__default.createElement(Accordion, null, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null)
  }, /*#__PURE__*/React__default.createElement(Typography$1, null, "1. Where you can Find Sample drawing and User manual form EDCR Format?")), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement(Typography$1, null, "First Use URL hptcp.hp.gov.in and Click on TCP department on Right corner you will redirect to the TCP Department Homepage in the Header of the TCP Homepage you will file a tab of User manual click on that and you can access EDCR related Document and Sample drawings.")))), /*#__PURE__*/React__default.createElement(Box$1, {
    mb: 4
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "h6",
    align: "justify"
  }, "FAQ Regarding (EDCR Layers)"), /*#__PURE__*/React__default.createElement(Accordion, null, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null)
  }, /*#__PURE__*/React__default.createElement(Typography$1, null, "2. Where You can find DXF Drawing EDCR Format layers details?")), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement(Typography$1, null, "In the User manual downloaded from the TCP New portal please refer to page no 188 and read all the Instructions and Layers details.")))), /*#__PURE__*/React__default.createElement(Box$1, {
    mb: 4
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "h6",
    align: "justify"
  }, "FAQ Regarding (Professional Login)"), /*#__PURE__*/React__default.createElement(Accordion, null, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null)
  }, /*#__PURE__*/React__default.createElement(Typography$1, null, "3. How Professional Can Login in New Portal?")), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement(Typography$1, null, "From the TCP New Portal Click on Online services and on next page click Sign in you have to enter the mobile no. Already registered with the old Portal no need of Userid and Password you can access from the OTP received on the Registered mobile no.")))), /*#__PURE__*/React__default.createElement(Box$1, {
    mb: 4
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "h6",
    align: "justify"
  }, "FAQ Regarding (Self Certification Process)"), /*#__PURE__*/React__default.createElement(Accordion, null, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null)
  }, /*#__PURE__*/React__default.createElement(Typography$1, null, "4. Which type of application professional can Self Certify?")), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement(Typography$1, null, "In the new Portal (hptcp.hp.gov.in) Professional can self certify those application which are Proposed Residential plan in which CLU is not involved and below 500 sqmtr only these files Professional can self certify."))), /*#__PURE__*/React__default.createElement(Accordion, null, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null)
  }, /*#__PURE__*/React__default.createElement(Typography$1, null, "5. Where you can find the Manual of Self Certification Process?")), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement(Typography$1, null, "In User manual Page no 42 (3.2.1) You will get the Self certification Process detailed workflow.")))), /*#__PURE__*/React__default.createElement(Box$1, {
    mb: 4
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "h6",
    align: "justify"
  }, "FAQ Regarding (Mandatory Steps for Users regarding Signature uploading)"), /*#__PURE__*/React__default.createElement(Accordion, null, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null)
  }, /*#__PURE__*/React__default.createElement(Typography$1, null, "6. What type of Steps to be taken by Users for generating Approval letter with Signature?")), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement(Typography$1, null, "When any professional or User log into id then first step you have to upload signature and photo from the edit profile section. Then only Signature will upload on the approval letter."))), /*#__PURE__*/React__default.createElement(Accordion, null, /*#__PURE__*/React__default.createElement(AccordionSummary, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null)
  }, /*#__PURE__*/React__default.createElement(Typography$1, null, "7. How Professionals and Officers can upload Signature and Photo in Profile?")), /*#__PURE__*/React__default.createElement(AccordionDetails, null, /*#__PURE__*/React__default.createElement(Typography$1, null, "In the new Portal (hptcp.hp.gov.in) Professional can self certify those application which are Proposed Residential plan in which CLU is not involved and below 500 sqmtr only these files Professional can self certify.")))));
};

function Faq() {
  return /*#__PURE__*/React__default.createElement(Box$1, null, /*#__PURE__*/React__default.createElement(Header$4, null), /*#__PURE__*/React__default.createElement(Box$1, null, /*#__PURE__*/React__default.createElement(Card$3, {
    style: {
      maxWidth: "100%",
      height: 'auto',
      margin: '20px',
      boxShadow: 'rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px, rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset'
    }
  }, /*#__PURE__*/React__default.createElement(CardHeader$1, {
    title: "Do you know ?",
    style: {
      color: "orange"
    }
  }), /*#__PURE__*/React__default.createElement(CardContent$2, null, /*#__PURE__*/React__default.createElement(Grid$1, {
    container: true,
    spacing: 1,
    style: {
      display: 'flex',
      flexDirection: 'column',
      padding: "0px 10px 0px 10px"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "paragraph1"
  }, "According to the provisions of the Uttar Pradesh Town and Country Planning Act, 1977 ( Act No. 12 of 1977), no construction / development activity can be undertaken in any Planning / Special Area or deemed Planning Area without the prior permission of the competent Authority namely Director, Town and Country Planning, Uttar Pradesh. No local authority or any office or any officer or other authority shall, notwithstanding anything 9apps contained in any other law for the time being in force, grant permission for the change in use of land without the permission in writing of the Director."), /*#__PURE__*/React__default.createElement(EDCRFAQ, null), /*#__PURE__*/React__default.createElement("p", {
    className: "paragraph1"
  }, "No Registrar or the Sub-Registrar, appointed under the Indian Registration Act, 1908, shall register any deed or document of transfer of any sub-division of land by way of sale, gift, exchange, lease or mortgage with possession, unless the sub-division of land is duly approved by the Director, subject to such rules as may be framed in this behalf by the State Government."), /*#__PURE__*/React__default.createElement("ul", {
    className: "paragraph1"
  }, /*#__PURE__*/React__default.createElement("li", null, "Where the land is owned by a person and the transfer is made without involving any further divisions;"), /*#__PURE__*/React__default.createElement("li", null, "where the partition/sub-division of land is made in a joint Hindu Family;"), /*#__PURE__*/React__default.createElement("li", null, "Where the lease is made in relation to a part or whole of a building;"), /*#__PURE__*/React__default.createElement("li", null, "Where the mortgage is made for procuring the loans for construction or improvements over the land either from the Government or from any other financial institution constituted or established under any law for the time being in force or recognized by the State Government.")), /*#__PURE__*/React__default.createElement("p", {
    className: "paragraph1"
  }, "No electricity, water or sewerage connections shall be given to any person within the Planning or Special Area constituted under the Act, unless a No Objection Certificate has been obtained by such person from the Director or the Special Area Development Authority."), /*#__PURE__*/React__default.createElement("p", {
    className: "paragraph1"
  }, "Provided that the service providing authorities shall disconnect the service connections forthwith of a building or land, in case any deviations from the approved plan or unauthorized constructions is brought to the notice or such authorities by the Director or the officer vested with the powers of the Director."), /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: 'block',
      margin: "20px"
    }
  }, /*#__PURE__*/React__default.createElement(Accordion$1, null, /*#__PURE__*/React__default.createElement(AccordionSummary$1, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null),
    "aria-controls": "panel1a-content",
    id: "panel1a-header"
  }, /*#__PURE__*/React__default.createElement(Typography$1, null, "What is an apartment building? ")), /*#__PURE__*/React__default.createElement(AccordionDetails$1, null, /*#__PURE__*/React__default.createElement(Typography$1, null, /*#__PURE__*/React__default.createElement("p", {
    className: "paragraph1"
  }, "\u201Capartment\u201D whether called block, chamber, dwelling unit, flat, lot, premises, suite, tenement, unit ,cottage or by any other name means a separate and self-contained part of any property including one or more rooms or enclosed spaces located on one or more floors or any part or parts thereof, in a building, or in a plot of land, used or intended to be used for residence, Office, shop, showroom, or godown or for carrying on any business, industry, occupation, profession or trade, or for any other type of independent use ancillary to the purpose specified above and with a direct exit to a public street, road or highway or to a common area leading to such street, road or highway and includes any garage or room whether or not adjacent to the building in which such apartment is located, provided by the promoter for the use by the allottee for parking any vehicle or as the case may be, for the residence of any domestic servant employed in such apartment;")))), /*#__PURE__*/React__default.createElement(Accordion$1, null, /*#__PURE__*/React__default.createElement(AccordionSummary$1, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null),
    "aria-controls": "panel2a-content",
    id: "panel2a-header"
  }, /*#__PURE__*/React__default.createElement(Typography$1, null, "What is a colony?  ")), /*#__PURE__*/React__default.createElement(AccordionDetails$1, null, /*#__PURE__*/React__default.createElement(Typography$1, {
    className: "paragraph1"
  }, /*#__PURE__*/React__default.createElement("ul", {
    className: "paragraph1"
  }, /*#__PURE__*/React__default.createElement("li", null, "Any area of land comprising of 2500 or more than 2500 square metres of land contiguous divided or proposed to be divided into plots or apartments or building for residential, commercial or industrial including purpose including cyber city, cyber park purpose."), /*#__PURE__*/React__default.createElement("li", null, "Except:-", /*#__PURE__*/React__default.createElement("ul", {
    className: "paragraph1"
  }, /*#__PURE__*/React__default.createElement("li", null, "Family partition by way inheritance or succession without a motive of earning profit."), /*#__PURE__*/React__default.createElement("li", null, "Earmarked by a factory owner for housing colony for his employees or labourers."))))))), /*#__PURE__*/React__default.createElement(Accordion$1, null, /*#__PURE__*/React__default.createElement(AccordionSummary$1, {
    expandIcon: /*#__PURE__*/React__default.createElement(ExpandMoreIcon, null),
    "aria-controls": "panel3a-content",
    id: "panel3a-header"
  }, /*#__PURE__*/React__default.createElement(Typography$1, null, " Who is a Promoter or can become a Promoter under TCP Act?")), /*#__PURE__*/React__default.createElement(AccordionDetails$1, null, /*#__PURE__*/React__default.createElement(Typography$1, null, /*#__PURE__*/React__default.createElement("p", {
    className: "paragraph1"
  }, "Any individual, Firm, Company, Co-operative Society & Association of Persons, who constructs/causes to construct a building consisting more than eight apartments or sets up/causes to set up a colony over land having area of 2500 or more than 2500 square meters for selling purpose."))))))))), /*#__PURE__*/React__default.createElement(NavbarFooter, null));
}

function Rules() {
  return /*#__PURE__*/React__default.createElement(Box$1, null, /*#__PURE__*/React__default.createElement(Header$4, null), /*#__PURE__*/React__default.createElement(Card$3, {
    style: {
      maxWidth: "100%",
      height: '490px',
      margin: '20px',
      boxShadow: 'rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px, rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset'
    }
  }, /*#__PURE__*/React__default.createElement(CardHeader$1, {
    title: "Rules",
    style: {
      color: "orange"
    }
  }), /*#__PURE__*/React__default.createElement(CardContent$2, null, /*#__PURE__*/React__default.createElement(Grid$1, {
    container: true,
    spacing: 1,
    style: {
      display: 'flex',
      flexDirection: 'row',
      margin: '10px'
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    className: "tableStyle"
  }, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", null, "Sl#"), /*#__PURE__*/React__default.createElement("th", null, "Subject"), /*#__PURE__*/React__default.createElement("th", null, "Download")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "1"), /*#__PURE__*/React__default.createElement("td", null, "Uttar Pradesh Town and Country Planning Rules"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(BsFilePdf, {
    color: "#274472",
    size: 25,
    style: {
      marginLeft: "50px"
    }
  }))))))), /*#__PURE__*/React__default.createElement(NavbarFooter, null));
}

function Acts() {
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Header$4, null), /*#__PURE__*/React__default.createElement(Card$3, {
    style: {
      maxWidth: "100%",
      height: '490px',
      margin: '20px',
      boxShadow: 'rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px, rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset'
    }
  }, /*#__PURE__*/React__default.createElement(CardHeader$1, {
    title: "Acts",
    style: {
      color: "orange"
    }
  }), /*#__PURE__*/React__default.createElement(CardContent$2, null, /*#__PURE__*/React__default.createElement(Grid$1, {
    container: true,
    spacing: 1,
    style: {
      display: 'flex',
      flexDirection: 'row',
      margin: '10px'
    }
  }, /*#__PURE__*/React__default.createElement("table", {
    className: "tableStyle"
  }, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", null, "Sl#"), /*#__PURE__*/React__default.createElement("th", null, "Subject"), /*#__PURE__*/React__default.createElement("th", null, "Download")), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "1"), /*#__PURE__*/React__default.createElement("td", null, "Uttar Pradesh Town and Country Planning Act"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(BsFilePdf, {
    color: "#274472",
    size: 25,
    style: {
      marginLeft: "50px"
    }
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "2"), /*#__PURE__*/React__default.createElement("td", null, "HP Municipal Act, 1994"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(BsFilePdf, {
    color: "#274472",
    size: 25,
    style: {
      marginLeft: "50px"
    }
  }))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, "3"), /*#__PURE__*/React__default.createElement("td", null, "HP Municipal Corporation Act,1994"), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(BsFilePdf, {
    color: "#274472",
    size: 25,
    style: {
      marginLeft: "50px"
    }
  }))))))), /*#__PURE__*/React__default.createElement(NavbarFooter, null));
}

function UserGuideManual() {
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Header$4, null), /*#__PURE__*/React__default.createElement(Box$1, {
    sx: {
      width: '100%'
    }
  }, /*#__PURE__*/React__default.createElement(Card$3, {
    style: {
      maxWidth: "100%",
      height: 'auto',
      margin: '20px',
      boxShadow: 'rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px, rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset'
    }
  }, /*#__PURE__*/React__default.createElement(CardHeader$1, {
    title: "User Manual",
    style: {
      color: "orange"
    }
  }), /*#__PURE__*/React__default.createElement(CardContent$2, null, /*#__PURE__*/React__default.createElement(Grid$1, {
    container: true,
    rowSpacing: 1,
    columnSpacing: {
      xs: 1,
      sm: 2,
      md: 3
    },
    style: {
      display: 'flex',
      flexDirection: 'row',
      margin: '10px'
    }
  }, /*#__PURE__*/React__default.createElement(Grid$1, {
    xs: 4
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "noti-sec"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "pdf-sec",
    onClick: () => getDocumentByFileStoreId("171f71f5-efe7-476d-835d-6e673d935f2e", setIsPreviewLoading)
  }, /*#__PURE__*/React__default.createElement(BsFilePdf, {
    size: 80,
    color: "#274472"
  }), /*#__PURE__*/React__default.createElement("h4", null, "Download")), /*#__PURE__*/React__default.createElement("div", {
    className: "data-sec"
  }, /*#__PURE__*/React__default.createElement("h5", {
    style: {
      fontSize: "18px",
      fontWeight: "500",
      fontFamily: "Open Sans",
      lineHeight: "22px"
    }
  }, "User Manual for OBPS"), /*#__PURE__*/React__default.createElement("span", {
    style: {
      color: "#9e9e9e",
      display: "inline"
    }
  }, /*#__PURE__*/React__default.createElement(CalendarMonth, {
    style: {
      verticalAlign: "bottom"
    }
  }), /*#__PURE__*/React__default.createElement("span", {
    style: {
      verticalAlign: "top"
    }
  }, "20-3-2024"))))), /*#__PURE__*/React__default.createElement(Grid$1, {
    xs: 4
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "noti-sec"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "pdf-sec",
    onClick: () => getDocumentByFileStoreId("3c0512c1-2aff-419b-aa10-1333a15ea3eb", setIsPreviewLoading)
  }, /*#__PURE__*/React__default.createElement(BsFilePdf, {
    size: 80,
    color: "#274472"
  }), /*#__PURE__*/React__default.createElement("h4", null, "Download")), /*#__PURE__*/React__default.createElement("div", {
    className: "data-sec"
  }, /*#__PURE__*/React__default.createElement("h5", {
    style: {
      fontSize: "18px",
      fontWeight: "500",
      fontFamily: "Open Sans",
      lineHeight: "22px"
    }
  }, "User Manual for CLU"), /*#__PURE__*/React__default.createElement("span", {
    style: {
      color: "#9e9e9e",
      display: "inline"
    }
  }, /*#__PURE__*/React__default.createElement(CalendarMonth, {
    style: {
      verticalAlign: "bottom"
    }
  }), /*#__PURE__*/React__default.createElement("span", {
    style: {
      verticalAlign: "top"
    }
  }, "20-3-2024"))))), /*#__PURE__*/React__default.createElement(Grid$1, {
    xs: 4
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "noti-sec"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "pdf-sec"
  }, /*#__PURE__*/React__default.createElement("a", {
    href: "https://hptcp.hp.gov.in/edcr/rest/dcr/downloadfile?tenantId=hp&fileStoreId=5087c70b-35b5-40cc-92cc-0ac29d92d51b",
    target: "_blank"
  }, /*#__PURE__*/React__default.createElement(BsFilePdf, {
    size: 80,
    color: "#274472"
  })), "Download"), /*#__PURE__*/React__default.createElement("div", {
    className: "data-sec"
  }, /*#__PURE__*/React__default.createElement("h5", {
    style: {
      fontSize: "18px",
      fontWeight: "500",
      fontFamily: "Open Sans",
      lineHeight: "22px"
    }
  }, "Sample Drawing for Residential"), /*#__PURE__*/React__default.createElement("span", {
    style: {
      color: "#9e9e9e",
      display: "inline"
    }
  }, /*#__PURE__*/React__default.createElement(CalendarMonth, {
    style: {
      verticalAlign: "bottom"
    }
  }), /*#__PURE__*/React__default.createElement("span", {
    style: {
      verticalAlign: "top"
    }
  }, "20-3-2024"))))), /*#__PURE__*/React__default.createElement(Grid$1, {
    xs: 4
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "noti-sec"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "pdf-sec"
  }, /*#__PURE__*/React__default.createElement("a", {
    href: "https://hptcp.hp.gov.in/edcr/rest/dcr/downloadfile?tenantId=hp&fileStoreId=37838c78-e33e-41a1-be6f-11ae53f92ad1",
    target: "_blank"
  }, /*#__PURE__*/React__default.createElement(BsFilePdf, {
    size: 80,
    color: "#274472"
  })), "Download"), /*#__PURE__*/React__default.createElement("div", {
    className: "data-sec"
  }, /*#__PURE__*/React__default.createElement("h5", {
    style: {
      fontSize: "18px",
      fontWeight: "500",
      fontFamily: "Open Sans",
      lineHeight: "22px"
    }
  }, "Sample Drawing for Commercial"), /*#__PURE__*/React__default.createElement("span", {
    style: {
      color: "#9e9e9e",
      display: "inline"
    }
  }, /*#__PURE__*/React__default.createElement(CalendarMonth, {
    style: {
      verticalAlign: "bottom"
    }
  }), /*#__PURE__*/React__default.createElement("span", {
    style: {
      verticalAlign: "top"
    }
  }, "20-3-2024"))))), /*#__PURE__*/React__default.createElement(Grid$1, {
    xs: 4
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "noti-sec"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "pdf-sec",
    onClick: () => getDocumentByFileStoreId("4aa92862-cae2-4423-b0d8-3eb07549e74f", setIsPreviewLoading)
  }, /*#__PURE__*/React__default.createElement(BsFilePdf, {
    size: 80,
    color: "#274472"
  }), /*#__PURE__*/React__default.createElement("h4", null, "Download")), /*#__PURE__*/React__default.createElement("div", {
    className: "data-sec"
  }, /*#__PURE__*/React__default.createElement("h5", {
    style: {
      fontSize: "18px",
      fontWeight: "500",
      fontFamily: "Open Sans",
      lineHeight: "22px"
    }
  }, "User Manual for form26"), /*#__PURE__*/React__default.createElement("span", {
    style: {
      color: "#9e9e9e",
      display: "inline"
    }
  }, /*#__PURE__*/React__default.createElement(CalendarMonth, {
    style: {
      verticalAlign: "bottom"
    }
  }), /*#__PURE__*/React__default.createElement("span", {
    style: {
      verticalAlign: "top"
    }
  }, "20-3-2024"))))), /*#__PURE__*/React__default.createElement(Grid$1, {
    xs: 4
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "noti-sec"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "pdf-sec",
    onClick: () => getDocumentByFileStoreId("3bf23245-1112-46d6-b51b-acdfd0dae3cd", setIsPreviewLoading)
  }, /*#__PURE__*/React__default.createElement(BsFilePdf, {
    size: 80,
    color: "#274472"
  }), /*#__PURE__*/React__default.createElement("h4", null, "Download")), /*#__PURE__*/React__default.createElement("div", {
    className: "data-sec"
  }, /*#__PURE__*/React__default.createElement("h5", {
    style: {
      fontSize: "18px",
      fontWeight: "500",
      fontFamily: "Open Sans",
      lineHeight: "22px"
    }
  }, "User Manual for form11"), /*#__PURE__*/React__default.createElement("span", {
    style: {
      color: "#9e9e9e",
      display: "inline"
    }
  }, /*#__PURE__*/React__default.createElement(CalendarMonth, {
    style: {
      verticalAlign: "bottom"
    }
  }), /*#__PURE__*/React__default.createElement("span", {
    style: {
      verticalAlign: "top"
    }
  }, "20-3-2024"))))), /*#__PURE__*/React__default.createElement(Grid$1, {
    xs: 4
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "noti-sec"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "pdf-sec",
    onClick: () => getDocumentByFileStoreId("9e1a9c1e-b22e-4887-9564-59605064e4f6", setIsPreviewLoading)
  }, /*#__PURE__*/React__default.createElement(BsFilePdf, {
    size: 80,
    color: "#274472"
  }), /*#__PURE__*/React__default.createElement("h4", null, "Download")), /*#__PURE__*/React__default.createElement("div", {
    className: "data-sec"
  }, /*#__PURE__*/React__default.createElement("h5", {
    style: {
      fontSize: "18px",
      fontWeight: "500",
      fontFamily: "Open Sans",
      lineHeight: "22px"
    }
  }, "User Manual for Mobile Tower Application"), /*#__PURE__*/React__default.createElement("span", {
    style: {
      color: "#9e9e9e",
      display: "inline"
    }
  }, /*#__PURE__*/React__default.createElement(CalendarMonth, {
    style: {
      verticalAlign: "bottom"
    }
  }), /*#__PURE__*/React__default.createElement("span", {
    style: {
      verticalAlign: "top"
    }
  }, "20-3-2024"))))))))), /*#__PURE__*/React__default.createElement(NavbarFooter, null));
}

function ContactUs$1() {
  const items = [{
    header: "Director Directorate of\nUrban Development",
    address: "Palika Bhavan, Talland,Shimla-171002",
    mail: "ud-hp@nic.in",
    phone: "+91-177-2626518",
    fax: "+91-177-2626518",
    mobile: "+91-8580672055(For Portal Related Query)"
  }, {
    header: "Addl./Dy./Joint Director,\nDirectorate of Urban Development",
    address: "Palika Bhavan,Talland,Shimla-171002",
    mail: "",
    phone: "+91-177-2626516",
    fax: "+91-177-2626516",
    mobile: ""
  }, {
    header: "Superintendent Grade-I, \nDirectorate of Urban Development",
    address: "Palika Bhavan,Talland,Shimla-171002",
    mail: "",
    phone: "+91-177-2627130",
    fax: "",
    mobile: ""
  }];
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Header$4, null), /*#__PURE__*/React__default.createElement(Box$1, {
    sx: {
      pb: 5
    }
  }, /*#__PURE__*/React__default.createElement(Card$3, {
    style: {
      maxWidth: "100%",
      height: 'auto',
      margin: '10px'
    }
  }, /*#__PURE__*/React__default.createElement(CardHeader$1, {
    title: "Contact Us",
    style: {
      color: "#144398"
    }
  }), /*#__PURE__*/React__default.createElement(CardContent$2, null, /*#__PURE__*/React__default.createElement(Grid$1, {
    container: true,
    spacing: 1,
    style: {
      display: 'flex',
      flexDirection: 'row',
      margin: '10px'
    },
    rowSpacing: 1,
    columnSpacing: {
      xs: 1,
      sm: 2,
      md: 3
    }
  }, items.map((item, index) => /*#__PURE__*/React__default.createElement(Card$3, {
    style: {
      maxWidth: "90%",
      height: 'auto',
      margin: '10px'
    }
  }, /*#__PURE__*/React__default.createElement(CardHeader$1, {
    title: item.header,
    className: "headerStyle",
    titleTypographyProps: {
      variant: 'h6'
    }
  }), /*#__PURE__*/React__default.createElement(CardContent$2, null, /*#__PURE__*/React__default.createElement(Grid$1, {
    item: true,
    xs: 8,
    sm: 2,
    md: 5,
    key: index,
    style: {
      display: 'flex',
      flexDirection: 'column'
    }
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1",
    style: {
      color: '#274472',
      height: "40px",
      fontWeight: 'bold',
      fontSize: '15px',
      width: '350px',
      WebkitFontSmoothing: 'antialiased',
      MozOsxFontSmoothing: 'grayscale',
      verticalAlign: "top"
    }
  }, /*#__PURE__*/React__default.createElement(HomeIcon$1, {
    style: {
      verticalAlign: "bottom"
    }
  }), item.address), /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1",
    style: {
      color: '#274472',
      height: "40px",
      fontWeight: 'bold',
      fontSize: '15px',
      width: '350px',
      WebkitFontSmoothing: 'antialiased',
      MozOsxFontSmoothing: 'grayscale',
      verticalAlign: "top"
    }
  }, /*#__PURE__*/React__default.createElement(MailOutlineIcon, {
    style: {
      verticalAlign: "bottom"
    }
  }), item.mail), /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1",
    style: {
      color: '#274472',
      height: "40px",
      fontWeight: 'bold',
      fontSize: '15px',
      width: '350px',
      WebkitFontSmoothing: 'antialiased',
      MozOsxFontSmoothing: 'grayscale',
      verticalAlign: "top"
    }
  }, /*#__PURE__*/React__default.createElement(PhoneIcon, {
    style: {
      verticalAlign: "bottom"
    }
  }), item.phone), /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1",
    style: {
      color: '#274472',
      height: "40px",
      width: '300px',
      fontSize: '15px'
    }
  }, /*#__PURE__*/React__default.createElement(FaxIcon, null), item.fax))))))), /*#__PURE__*/React__default.createElement(Box$1, {
    sx: {
      m: '0 2rem 2rem'
    }
  }, /*#__PURE__*/React__default.createElement(CardMedia, {
    sx: {
      maxWidth: '1200px',
      height: 'auto'
    },
    image: "./Image/map.png",
    alt: "Map - Contact us",
    component: "img"
  })))), /*#__PURE__*/React__default.createElement(NavbarFooter, null));
}

const InputText = styled$3(TextField$1)({
  "& label, & label.Mui-focused, & .MuiInput-root": {
    color: "#fff"
  },
  "& .Mui-focused::after": {
    borderBottomColor: "#0e7693"
  }
});
function OnlineUserServices() {
  const getUserType = () => Digit.UserService.getType();
  const history = useHistory$2();
  const {
    t
  } = useTranslation();
  const stateCode = Digit.ULBService.getStateId();
  const [state, setState] = useState({
    raised1: false,
    shadow1: 1,
    raised2: false,
    shadow2: 1,
    raised3: false,
    shadow3: 1
  });
  const stateId = Digit.ULBService.getStateId();
  const [mobileNumber, setMobileNumber] = useState(null);
  const [mobileNumber1, setMobileNumber1] = useState(null);
  const [showOtpField, setOtpField] = useState(false);
  const [name, setName] = useState("");
  const [showOtpField1, setOtpField1] = useState(false);
  const [otp, setOtp] = useState(null);
  const [otp1, setOtp1] = useState(null);
  const [showToast, setShowToast] = useState(null);
  const closeToast = () => {
    setShowToast(null);
  };
  useEffect(() => {
    if (!showToast) return;
    const timeOut = setTimeout(closeToast, 3000);
    return () => clearTimeout(timeOut);
  }, [showToast]);
  const handleClick = async () => {
    if ((mobileNumber === null || mobileNumber === void 0 ? void 0 : mobileNumber.length) !== 10) {
      setShowToast({
        error: true,
        message: `Please enter a valid mobile no`
      });
      return;
    }
    const requestData = {
      otp: {
        mobileNumber: mobileNumber,
        userType: "citizen",
        type: "login",
        tenantId: stateCode
      }
    };
    try {
      const res = await Digit.UserService.sendOtp(requestData, stateId);
      if (res !== null && res !== void 0 && res.isSuccessful) {
        setOtpField(true);
      }
    } catch (err) {
      setShowToast({
        error: true,
        message: `Please register your mobile no in the portal`
      });
    }
  };
  const handleClick1 = async () => {
    if ((mobileNumber1 === null || mobileNumber1 === void 0 ? void 0 : mobileNumber1.length) !== 10) {
      setShowToast({
        error: true,
        message: `Please enter a valid mobile no`
      });
      return;
    }
    const requestData = {
      otp: {
        mobileNumber: mobileNumber1,
        name: name,
        userType: "citizen",
        type: "register",
        tenantId: stateCode
      }
    };
    try {
      const res = await Digit.UserService.sendOtp(requestData, stateId);
      if (res !== null && res !== void 0 && res.isSuccessful) {
        setOtpField1(true);
      }
    } catch (err) {
      setShowToast({
        error: true,
        message: `Something went wrong, please try again!`
      });
    }
  };
  const handleLogin = async () => {
    const requestData = {
      username: mobileNumber,
      password: otp,
      tenantId: stateCode,
      userType: getUserType()
    };
    try {
      const {
        ResponseInfo,
        UserRequest: info,
        ...tokens
      } = await Digit.UserService.authenticate(requestData);
      Digit.SessionStorage.set("citizen.userRequestObject", {
        info,
        ...tokens
      });
      Digit.UserService.setUser({
        info,
        ...tokens
      });
      history.push("profile");
    } catch (error) {
      setShowToast({
        error: true,
        message: `Something went wrong, please try again!`
      });
    }
  };
  const handleLogin1 = async () => {
    const requestData = {
      name,
      username: mobileNumber1,
      otpReference: otp1,
      tenantId: stateCode,
      mobileNumber: mobileNumber1
    };
    try {
      const {
        ResponseInfo,
        UserRequest: info,
        ...tokens
      } = await Digit.UserService.registerUser(requestData, stateCode);
      Digit.SessionStorage.set("citizen.userRequestObject", {
        info,
        ...tokens
      });
      Digit.UserService.setUser({
        info,
        ...tokens
      });
      history.push("profile");
    } catch (error) {
      setShowToast({
        error: true,
        message: `Something went wrong, please try again!`
      });
    }
  };
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Header$4, null), /*#__PURE__*/React__default.createElement(Box$1, {
    sx: {
      width: "80%",
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignContent: "center",
      margin: "3rem 2rem 1rem 10rem"
    }
  }, /*#__PURE__*/React__default.createElement(Card$3, {
    style: {
      width: "400px",
      height: "370px",
      margin: "10px",
      backgroundColor: "rgb(68 155 180)"
    },
    className: "cardHovered",
    onMouseOver: () => setState({
      raised1: true,
      shadow1: 6
    }),
    onMouseOut: () => setState({
      raised1: false,
      shadow1: 1
    }),
    raised: state.raised1,
    zdepth: state.shadow1
  }, /*#__PURE__*/React__default.createElement(CardHeader$1, {
    title: "Private Professional",
    titleTypographyProps: {
      variant: "h6"
    },
    style: {
      color: "white",
      alignItems: "center",
      marginLeft: "40px"
    },
    avatar:
    /*#__PURE__*/
    React__default.createElement(AdminPanelSettingsIcon, {
      style: {
        height: "35px",
        width: "35px",
        color: "white"
      }
    })
  }), /*#__PURE__*/React__default.createElement(CardContent$2, {
    style: {
      alignItems: "center",
      marginTop: "-17px"
    }
  }, /*#__PURE__*/React__default.createElement(Box$1, {
    sx: {
      display: "block",
      border: "1px solid white",
      borderRadius: "25px",
      height: "220px",
      width: "300px",
      margin: "0px 20px 0px 30px"
    }
  }, /*#__PURE__*/React__default.createElement(Box$1, {
    sx: {
      display: "flex",
      alignItems: "flex-end",
      margin: "10px 10px 10px 30px"
    }
  }, /*#__PURE__*/React__default.createElement(AccountCircle, {
    sx: {
      color: "white",
      mr: 1,
      my: 0.5
    }
  }), /*#__PURE__*/React__default.createElement(InputText, {
    label: "Mobile Number",
    variant: "standard",
    value: mobileNumber,
    onChange: e => {
      const inputValue = e.target.value;
      if (/^\d{0,10}$/.test(inputValue)) {
        setMobileNumber(inputValue);
      }
    },
    autoComplete: "off"
  })), /*#__PURE__*/React__default.createElement(Box$1, {
    sx: {
      display: "flex",
      alignItems: "normal",
      flexDirection: "column",
      margin: "10px 5px 10px 30px"
    }
  }, !showOtpField && /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    size: "small",
    style: {
      width: "100px",
      margin: "30px 10px 10px 60px",
      backgroundColor: "#0E7693"
    },
    onClick: handleClick
  }, "Send OTP"), showOtpField && /*#__PURE__*/React__default.createElement(InputText, {
    label: "Enter OTP",
    style: {
      height: "8px",
      width: "90px",
      color: "white",
      marginLeft: "70px"
    },
    variant: "standard",
    value: otp,
    onChange: e => {
      const inputValue = e.target.value;
      if (/^\d{0,6}$/.test(inputValue)) {
        setOtp(inputValue);
      }
    },
    autoComplete: "off"
  }))), /*#__PURE__*/React__default.createElement(Button$2, {
    size: "medium",
    style: {
      width: "150px",
      border: "1px solid blue",
      backgroundColor: "orange",
      color: "white",
      margin: "10px 0px 0px 100px"
    },
    onClick: handleLogin
  }, "Login"))), /*#__PURE__*/React__default.createElement(Card$3, {
    style: {
      width: "400px",
      height: "400px",
      margin: "10px",
      alignItems: "center",
      overflow: "auto",
      maxHeight: "380px",
      scrollbarWidth: "5px"
    },
    className: "cardHovered1",
    onMouseOver: () => setState({
      raised2: true,
      shadow2: 3
    }),
    onMouseOut: () => setState({
      raised2: false,
      shadow2: 1
    }),
    raised: state.raised2,
    zdepth: state.shadow2
  }, /*#__PURE__*/React__default.createElement(CardHeader$1, {
    title: "New User",
    titleTypographyProps: {
      variant: "h6"
    },
    style: {
      color: "#144398",
      alignItems: "center",
      marginLeft: "80px"
    },
    avatar:
    /*#__PURE__*/
    React__default.createElement(PersonAddIcon, {
      style: {
        height: "35px",
        width: "35px",
        color: "#144398"
      }
    })
  }), /*#__PURE__*/React__default.createElement(CardContent$2, {
    style: {
      alignItems: "center",
      marginTop: "-17px"
    }
  }, /*#__PURE__*/React__default.createElement(Grid$1, {
    container: true,
    spacing: 1,
    style: {
      display: "flex",
      flexDirection: "column",
      margin: "0px 10px 10px 0px"
    },
    justifyContent: "space-between",
    rowSpacing: 1,
    columnSpacing: {
      xs: 1,
      sm: 2,
      md: 3
    }
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body2"
  }, "Form of application for permission of Development of Land / Construction of Building. ", /*#__PURE__*/React__default.createElement("strong", null, "(Form - 12)")), /*#__PURE__*/React__default.createElement(Link$1, {
    style: {
      textDecoration: "none",
      color: "orange",
      textAlign: "center"
    },
    to: "/digit-ui/citizen/obps/edcrscrutiny/apply"
  }, "Apply Now"), /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body2"
  }, "Apply For Form12 Self Certification", /*#__PURE__*/React__default.createElement("strong", null, "(Form - 12 Self Certification)")), /*#__PURE__*/React__default.createElement(Link$1, {
    style: {
      textDecoration: "none",
      color: "orange",
      textAlign: "center"
    },
    to: "/digit-ui/citizen/obps/edcrscrutiny/apply"
  }, "Apply Now"), /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body2"
  }, "Form of application for permission of sub-division / development of land. ", /*#__PURE__*/React__default.createElement("strong", null, "(Form - 11)")), /*#__PURE__*/React__default.createElement(Link$1, {
    style: {
      textDecoration: "none",
      color: "orange",
      textAlign: "center"
    },
    to: "/digit-ui/citizen/obps/services/form11"
  }, "Apply Now"), /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body2"
  }, "Form Application for composition of offences under section 39-C read with sub-section (3) of section ", /*#__PURE__*/React__default.createElement("strong", null, "(Form - 26)")), /*#__PURE__*/React__default.createElement(Link$1, {
    style: {
      textDecoration: "none",
      color: "orange",
      textAlign: "center"
    },
    to: "/digit-ui/citizen/obps/services/form26"
  }, "Apply Now"), /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body2"
  }, "Registered citizen user may apply for NOC of water, Electricity and severage."), /*#__PURE__*/React__default.createElement(Link$1, {
    style: {
      textDecoration: "none",
      color: "orange",
      textAlign: "center"
    },
    to: "/digit-ui/citizen/InProgreeService"
  }, "Apply Now"), /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body2"
  }, "Registered citizen user may apply for Mobile Tower Application(Application For MObile Tower)."), /*#__PURE__*/React__default.createElement(Link$1, {
    style: {
      textDecoration: "none",
      color: "orange",
      textAlign: "center"
    },
    to: "/digit-ui/citizen/InProgreeService"
  }, "Apply Now"), /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body2"
  }, "Registered citizen user may apply for Change of Land Use(Change of Land use)."), /*#__PURE__*/React__default.createElement(Link$1, {
    style: {
      textDecoration: "none",
      color: "orange",
      textAlign: "center"
    },
    to: "/digit-ui/citizen/InProgreeService"
  }, "Apply Now"), /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body2"
  }, "Form16(Application Of Appeal)"), /*#__PURE__*/React__default.createElement(Link$1, {
    style: {
      textDecoration: "none",
      color: "orange",
      textAlign: "center"
    },
    to: "/digit-ui/citizen/InProgreeService"
  }, "Apply Now"), /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body2"
  }, "Form34(Real Estate Projects)"), /*#__PURE__*/React__default.createElement(Link$1, {
    style: {
      textDecoration: "none",
      color: "orange",
      textAlign: "center"
    },
    to: "/digit-ui/citizen/InProgreeService"
  }, "Apply Now")))), /*#__PURE__*/React__default.createElement(Card$3, {
    style: {
      width: "400px",
      height: "370px",
      margin: "10px",
      backgroundColor: "rgb(68 155 180)"
    },
    className: "cardHovered2",
    onMouseOver: () => setState({
      raised3: true,
      shadow3: 3
    }),
    onMouseOut: () => setState({
      raised3: false,
      shadow3: 1
    }),
    raised: state.raised3,
    zdepth: state.shadow3
  }, /*#__PURE__*/React__default.createElement(CardHeader$1, {
    title: "Citizen & Others",
    titleTypographyProps: {
      variant: "h6"
    },
    style: {
      color: "white",
      marginLeft: "40px"
    },
    avatar:
    /*#__PURE__*/
    React__default.createElement(HiUserGroup, {
      style: {
        height: "35px",
        width: "35px",
        color: "white"
      }
    })
  }), /*#__PURE__*/React__default.createElement(CardContent$2, {
    style: {
      alignItems: "center",
      marginTop: "-17px"
    }
  }, /*#__PURE__*/React__default.createElement(Box$1, {
    sx: {
      display: "block",
      border: "1px solid white",
      borderRadius: "25px",
      height: "220px",
      width: "300px",
      margin: "10px 20px 10px 30px"
    }
  }, /*#__PURE__*/React__default.createElement(Box$1, {
    sx: {
      display: "flex",
      alignItems: "flex-end",
      margin: "10px 10px 10px 20px"
    }
  }, /*#__PURE__*/React__default.createElement(LocalPhoneIcon, {
    sx: {
      color: "white",
      mr: 1,
      my: 0.5
    }
  }), /*#__PURE__*/React__default.createElement(InputText, {
    label: "Mobile Number",
    autoComplete: "off",
    variant: "standard",
    value: mobileNumber1,
    sx: {
      color: "white"
    },
    onChange: e => {
      const inputValue = e.target.value;
      if (/^\d{0,10}$/.test(inputValue)) {
        setMobileNumber1(inputValue);
      }
    }
  })), /*#__PURE__*/React__default.createElement(Box$1, {
    sx: {
      display: "flex",
      alignItems: "flex-end",
      margin: "10px 10px 10px 20px"
    }
  }, /*#__PURE__*/React__default.createElement(AccountCircle, {
    sx: {
      color: "white",
      mr: 1,
      my: 0.5
    }
  }), /*#__PURE__*/React__default.createElement(InputText, {
    label: "Name",
    autoComplete: "off",
    variant: "standard",
    value: name,
    sx: {
      color: "white"
    },
    onChange: e => setName(e.target.value)
  })), /*#__PURE__*/React__default.createElement(Box$1, {
    sx: {
      display: "flex",
      alignItems: "normal",
      flexDirection: "column",
      margin: "10px 5px 10px 30px"
    }
  }, !showOtpField1 && /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    size: "small",
    style: {
      backgroundColor: "#0E7693",
      width: "100px",
      margin: "30px 10px 10px 60px"
    },
    onClick: handleClick1
  }, "Send OTP"), showOtpField1 && /*#__PURE__*/React__default.createElement(InputText, {
    label: "Enter OTP",
    style: {
      height: "8px",
      width: "90px",
      color: "white",
      marginLeft: "70px"
    },
    variant: "standard",
    value: otp1,
    onChange: e => {
      const inputValue = e.target.value;
      if (/^\d{0,6}$/.test(inputValue)) {
        setOtp1(inputValue);
      }
    },
    autoComplete: "off"
  })), /*#__PURE__*/React__default.createElement(Box$1, {
    sx: {
      display: "flex",
      flexDirection: "column"
    }
  }, /*#__PURE__*/React__default.createElement("p", {
    style: {
      color: "#FFA600",
      fontSize: "12px",
      cursor: "pointer",
      textAlign: "center",
      fontWeight: "500",
      marginTop: "-7px"
    },
    onClick: () => history.push("login")
  }, "Already Registered? Login here..."))), /*#__PURE__*/React__default.createElement(Button$2, {
    size: "medium",
    style: {
      width: "150px",
      border: "1px solid blue",
      backgroundColor: "orange",
      color: "white",
      margin: "10px 0px 0px 100px"
    },
    onClick: handleLogin1
  }, "Register")))), /*#__PURE__*/React__default.createElement(NavbarFooter, null), showToast && /*#__PURE__*/React__default.createElement(Toast, {
    error: showToast === null || showToast === void 0 ? void 0 : showToast.error,
    warning: showToast === null || showToast === void 0 ? void 0 : showToast.warning,
    label: t(showToast === null || showToast === void 0 ? void 0 : showToast.message),
    onClose: closeToast,
    isDleteBtn: true
  }));
}

const useStyles$p = makeStyles(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: theme.spacing(2),
    background: 'rgba(13, 13, 13, 0.7)'
  },
  box: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  text: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginLeft: '10px'
  },
  image: {
    width: '60px',
    height: '60px',
    marginBottom: theme.spacing(1)
  }
}));

const initialBackgroundImage = 'https://imgur.com/lrTWHNw';
const secondaryBackgroundImage = initialBackgroundImage;
const useStyles$q = makeStyles(theme => ({
  root: {
    position: 'relative',
    minHeight: '100vh',
    marginTop: theme.spacing(0.5)
  },
  additionalCard: {
    position: 'absolute',
    top: theme.spacing(2),
    left: theme.spacing(2),
    height: '75px',
    background: 'rgba(30, 30, 30, 0.16)',
    color: 'white'
  },
  strip: {
    position: 'absolute',
    top: theme.spacing(75),
    width: '100%',
    textAlign: 'center'
  },
  backgroundImage: {
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: -1,
    backgroundSize: 'cover',
    backgroundColor: 'rgba(255, 255, 255, 0.7)',
    transition: 'background-image 2s ease-in-out'
  }
}));
const Development = () => {
  const classes = useStyles$q();
  const [backgroundImage, setBackgroundImage] = useState(initialBackgroundImage);
  useEffect(() => {
    const interval = setInterval(() => {
      setBackgroundImage(prevImage => prevImage === initialBackgroundImage ? secondaryBackgroundImage : initialBackgroundImage);
    }, 3000);
    return () => clearInterval(interval);
  }, []);
  return /*#__PURE__*/React__default.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React__default.createElement(Card$3, {
    className: classes.additionalCard
  }, /*#__PURE__*/React__default.createElement(CardContent$2, null, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1"
  }, "Development is about transforming ", /*#__PURE__*/React__default.createElement("br", null), " the lives of people"))), /*#__PURE__*/React__default.createElement("div", {
    className: classes.backgroundImage,
    style: {
      backgroundImage: `url(${backgroundImage})`
    }
  }));
};

const useStyles$r = makeStyles$1(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '30vh',
    marginTop: theme.spacing(2)
  },
  card: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    textAlign: 'center',
    borderRadius: '15px',
    margin: theme.spacing(3)
  },
  image: {
    width: 60,
    height: 60,
    margin: theme.spacing(2)
  },
  card1: {
    background: 'linear-gradient(to bottom, #F7A143, #FFFFFF)'
  },
  card2: {
    background: 'linear-gradient(to bottom, #4BAB58, #FFFFFF)'
  },
  card3: {
    background: 'linear-gradient(to bottom, #60329C, #FFFFFF)'
  },
  card4: {
    background: 'linear-gradient(to bottom, #2E91E8, #FFFFFF)'
  },
  content: {
    display: 'flex',
    flexDirection: 'row'
  },
  title: {
    color: 'white',
    marginTop: '3vh',
    textTransform: 'none'
  }
}));
const CardList = () => {
  const classes = useStyles$r();
  const history = useHistory$2();
  const paths = ['/digit-ui/citizen/applyOnline', '/digit-ui/employee', '/digit-ui/citizen/feeCalculator', 'digit-ui/citizen/obps/my-applications'];
  const handleCardClick = path => {
    history.push(path);
  };
  const cardData = [{
    imageUrl: 'https://i.imgur.com/72lqHju.png',
    title: 'Online Services',
    gradientClass: classes.card1
  }, {
    imageUrl: 'https://i.imgur.com/RLDNCUS.png',
    title: 'Officer Login',
    gradientClass: classes.card2
  }, {
    imageUrl: 'https://i.imgur.com/9piU18h.png',
    title: 'Fee Calculator',
    gradientClass: classes.card3
  }, {
    imageUrl: 'https://i.imgur.com/mfeY0Ib.png',
    title: 'Check Application Status',
    gradientClass: classes.card4
  }];
  return /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 3,
    className: classes.root
  }, cardData.map((data, index) => /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    key: index,
    xs: 12,
    sm: 6,
    md: 4,
    lg: 12 / 4
  }, /*#__PURE__*/React__default.createElement(Button, {
    className: `${classes.card} ${data.gradientClass}`,
    variant: "outlined",
    onClick: () => handleCardClick(paths[index])
  }, /*#__PURE__*/React__default.createElement(CardContent, {
    className: classes.content
  }, /*#__PURE__*/React__default.createElement("img", {
    src: data.imageUrl,
    alt: data.title,
    className: classes.image
  }), /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h6",
    className: classes.title
  }, data.title))))));
};

const Image$2 = 'https://i.imgur.com/4LnPljT.jpeg';
const useStyles$s = makeStyles$2(theme => ({
  card: {
    position: 'relative',
    width: '100%',
    margin: 'auto',
    marginTop: theme.spacing(4),
    padding: theme.spacing(2),
    height: 'auto',
    overflow: 'hidden'
  },
  backgroundImage: {
    content: "''",
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundImage: `url(${Image$2})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    opacity: '50%'
  },
  backgroundColorLayer: {
    backgroundColor: 'rgba(47, 94, 168, 0.7)',
    width: '100%',
    height: '100%',
    position: 'absolute',
    opacity: '70%',
    top: 0,
    left: 0,
    zIndex: 1
  },
  icon: {
    fontSize: 40,
    color: 'white',
    width: '55px',
    height: '55px',
    zIndex: 2
  },
  title: {
    marginTop: theme.spacing(1),
    textAlign: 'center',
    color: 'white',
    margin: '20px',
    zIndex: 2
  },
  header: {
    marginTop: theme.spacing(1),
    textAlign: 'center',
    color: '#fff'
  }
}));
const CitizenFacilitation$1 = () => {
  const classes = useStyles$s();
  const iconData = [{
    icon: /*#__PURE__*/React__default.createElement("img", {
      src: "https://i.imgur.com/m4QnIck.png",
      className: classes.icon
    }),
    title: 'Notified Planning/Special Area'
  }, {
    icon: /*#__PURE__*/React__default.createElement("img", {
      src: "https://i.imgur.com/0qU2lat.png",
      className: classes.icon
    }),
    title: 'RTI'
  }, {
    icon: /*#__PURE__*/React__default.createElement("img", {
      src: "https://i.imgur.com/gAdiHIh.png",
      className: classes.icon
    }),
    title: 'Regitered Estate Agent'
  }, {
    icon: /*#__PURE__*/React__default.createElement("img", {
      src: "https://i.imgur.com/G0ZeisD.png",
      className: classes.icon
    }),
    title: 'Registered Promoters'
  }, {
    icon: /*#__PURE__*/React__default.createElement("img", {
      src: "https://i.imgur.com/49sZB4N.png",
      className: classes.icon
    }),
    title: 'Directory of Registered Proffessionals'
  }, {
    icon: /*#__PURE__*/React__default.createElement("img", {
      src: "https://i.imgur.com/64dfsol.png",
      className: classes.icon
    }),
    title: 'Download Forms'
  }, {
    icon: /*#__PURE__*/React__default.createElement("img", {
      src: "https://i.imgur.com/2RI9Vr4.png",
      className: classes.icon
    }),
    title: 'Public Service Guarantee Act'
  }, {
    icon: /*#__PURE__*/React__default.createElement("img", {
      src: "https://i.imgur.com/Fmq7Rqx.png",
      className: classes.icon
    }),
    title: 'License and Essentiality Certificates'
  }, {
    icon: /*#__PURE__*/React__default.createElement("img", {
      src: "https://i.imgur.com/cEmJalq.png",
      className: classes.icon
    }),
    title: 'Planning Permission case'
  }, {
    icon: /*#__PURE__*/React__default.createElement("img", {
      src: "https://i.imgur.com/rLZI0Jx.png",
      className: classes.icon
    }),
    title: 'Instruction/Orders'
  }, {
    icon: /*#__PURE__*/React__default.createElement("img", {
      src: "https://i.imgur.com/TqMvq5G.png",
      className: classes.icon
    }),
    title: 'Area Locator'
  }, {
    icon: /*#__PURE__*/React__default.createElement("img", {
      src: "https://i.imgur.com/eDXNkGq.png",
      className: classes.icon
    }),
    title: 'Unauthorized Construction'
  }];
  return /*#__PURE__*/React__default.createElement(Card, {
    className: classes.card
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classes.backgroundImage
  }), /*#__PURE__*/React__default.createElement("div", {
    className: classes.backgroundColorLayer
  }), /*#__PURE__*/React__default.createElement(CardContent, null, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h6",
    className: classes.header,
    style: {
      textAlign: 'center',
      color: '#fff',
      fontSize: '30px'
    }
  }, "Citizen Facilitation"), /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    spacing: 2,
    justifyContent: "center",
    alignItems: "center",
    alignContent: "center"
  }, iconData.map((item, index) => /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    key: index,
    xs: 6,
    sm: 4,
    md: 3,
    lg: 2
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }
  }, item.icon, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "subtitle1",
    className: classes.title
  }, item.title)))))));
};

function NewTcp() {
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Strip, null), /*#__PURE__*/React__default.createElement(GovtStrip, null), /*#__PURE__*/React__default.createElement(Navbar, null), /*#__PURE__*/React__default.createElement(Development, null), /*#__PURE__*/React__default.createElement(CardList, null), /*#__PURE__*/React__default.createElement(AboutUs, null), /*#__PURE__*/React__default.createElement(AppInfo, null), /*#__PURE__*/React__default.createElement(CitizenFacilitation$1, null), /*#__PURE__*/React__default.createElement(FeedbackComplaint, null), /*#__PURE__*/React__default.createElement(LinksSlideshow, null), /*#__PURE__*/React__default.createElement(Footer$1, null));
}

const StyledTableCell$8 = styled$3(TableCell$1)(({
  theme
}) => ({
  [`&.${tableCellClasses$1.head}`]: {
    backgroundColor: '#0E7693',
    color: theme.palette.common.white
  },
  [`&.${tableCellClasses$1.body}`]: {
    fontSize: 14
  }
}));
const StyledTableRow$8 = styled$3(TableRow$1)(({
  theme
}) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover
  },
  '&:last-child td, &:last-child th': {
    border: 0
  }
}));

const FilterForm = () => {
  var _Digit;
  const {
    handleSubmit,
    control
  } = useForm();
  const {
    data: cities,
    isLoading
  } = Digit.Hooks.useTenants();
  const applicationFlow = ((_Digit = Digit) === null || _Digit === void 0 ? void 0 : _Digit.SessionStorage.get("CITIZEN.COMMON.HOME.FLOW")) || null;
  const districts = !isLoading && applicationFlow ? cities === null || cities === void 0 ? void 0 : cities.filter(city => {
    var _city$code;
    return (_city$code = city.code) === null || _city$code === void 0 ? void 0 : _city$code.includes(applicationFlow.toLowerCase());
  }) : [];
  const onSubmit = data => {
    console.log(data);
  };
  return /*#__PURE__*/React__default.createElement("section", {
    className: "container1"
  }, /*#__PURE__*/React__default.createElement("form", {
    onSubmit: handleSubmit(onSubmit)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formContainer",
    style: {
      marginTop: '-80px'
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "formHeaderContainer"
  }, /*#__PURE__*/React__default.createElement("h2", {
    className: "formHeading"
  }, "Registered Private Professionals")), /*#__PURE__*/React__default.createElement("div", {
    className: "formInputContainer",
    style: {
      width: '100%',
      justifyContent: 'space-around'
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer, {
    label: "State",
    control: control,
    placeholder: "Uttar Pradesh",
    name: "state",
    type: "textInput",
    defaultValue: 'Uttar Pradesh',
    disabled: true,
    width: "18.25vw"
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    label: "Tehsil",
    control: control,
    placeholder: "Tehsil",
    name: "tehsil",
    type: "textInput",
    width: '18.25vw'
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    label: "Class",
    control: control,
    placeholder: "All--",
    name: "class",
    type: "selectInput",
    data: [{
      label: 'All',
      value: 'All'
    }, {
      label: 'A',
      value: 'A'
    }, {
      label: 'B',
      value: 'B'
    }, {
      label: 'C',
      value: 'C'
    }]
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "columnWrapper"
  }, /*#__PURE__*/React__default.createElement(InputContainer, {
    label: "District",
    control: control,
    placeholder: "Select District",
    inputLabel: "Select District",
    name: "district",
    mandatory: true,
    type: "selectInput",
    data: districts
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    control: control,
    label: "Private Prof. Name",
    placeholder: "Enter Name",
    name: "architectName",
    type: "textInput",
    width: '18.25vw'
  }), /*#__PURE__*/React__default.createElement(InputContainer, {
    label: "Applied by",
    control: control,
    placeholder: "All--",
    data: [{
      value: 'Architect',
      label: 'Architect'
    }, {
      value: 'Engineer',
      label: 'Engineer'
    }, {
      value: 'Draughts Man',
      label: 'Draughts Man'
    }, {
      value: 'Structutal Engineer',
      label: 'Structural Engineer'
    }],
    name: "appliedby",
    type: "selectInput"
  })))), /*#__PURE__*/React__default.createElement("div", {
    className: "footerContainer"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "buttonWrapper"
  }, /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "success",
    size: "medium",
    label: "Search",
    type: "submit",
    onClick: handleSubmit
  }), /*#__PURE__*/React__default.createElement(ButtonWrapper$1, {
    variant: "contained",
    color: "error",
    size: "medium",
    label: "Reset"
  })))));
};

function RegisteredArchitect() {
  const rowsPerPageOptions = [20];
  const {
    t
  } = useTranslation();
  const tenantId = Digit.ULBService.getStateId();
  const [engineersArr, setEngsArr] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(rowsPerPageOptions[0]);
  useEffect(async () => {
    const structualEngResponse = await Digit.UserService.userSearch(tenantId, {
      roleCodes: ["BPA_STRUCTURALENGINEER", "BPA_ARCHITECT"]
    });
    const users = structualEngResponse === null || structualEngResponse === void 0 ? void 0 : structualEngResponse.user.filter(user => !['test', null].includes(user.registrationNumber));
    setEngsArr(users);
  }, []);
  const handleChangePage = (_, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = event => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(FilterForm, null), /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: '90%',
      margin: 'auto'
    }
  }, engineersArr.length === 0 ? /*#__PURE__*/React__default.createElement(Loader, null) : /*#__PURE__*/React__default.createElement(TableContainer$1, {
    component: Paper$1
  }, /*#__PURE__*/React__default.createElement(Table$4, {
    sx: {
      minWidth: 700
    },
    "aria-label": "customized table"
  }, /*#__PURE__*/React__default.createElement(TableHead$1, null, /*#__PURE__*/React__default.createElement(TableRow$1, null, /*#__PURE__*/React__default.createElement(StyledTableCell$8, null, "SL#"), /*#__PURE__*/React__default.createElement(StyledTableCell$8, {
    align: "center"
  }, "Name"), /*#__PURE__*/React__default.createElement(StyledTableCell$8, {
    align: "center"
  }, "Category"), /*#__PURE__*/React__default.createElement(StyledTableCell$8, null, "Class"), /*#__PURE__*/React__default.createElement(StyledTableCell$8, {
    align: "center"
  }, "Address"), /*#__PURE__*/React__default.createElement(StyledTableCell$8, {
    align: "center"
  }, "Email"), /*#__PURE__*/React__default.createElement(StyledTableCell$8, {
    align: "center"
  }, "Mobile"), /*#__PURE__*/React__default.createElement(StyledTableCell$8, {
    align: "center"
  }, "Regd.No"), /*#__PURE__*/React__default.createElement(StyledTableCell$8, {
    align: "center"
  }, "Regd.Date"), /*#__PURE__*/React__default.createElement(StyledTableCell$8, {
    align: "center"
  }, "Qualification"))), /*#__PURE__*/React__default.createElement(TableBody$1, null, (rowsPerPage > 0 ? engineersArr === null || engineersArr === void 0 ? void 0 : engineersArr.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : engineersArr).map((row, index) => {
    var _row$correspondenceAd;
    return /*#__PURE__*/React__default.createElement(StyledTableRow$8, {
      key: row === null || row === void 0 ? void 0 : row.id
    }, /*#__PURE__*/React__default.createElement(StyledTableCell$8, {
      component: "th",
      scope: "row"
    }, index + 1), /*#__PURE__*/React__default.createElement(StyledTableCell$8, {
      align: "center"
    }, row === null || row === void 0 ? void 0 : row.name), /*#__PURE__*/React__default.createElement(StyledTableCell$8, {
      align: "center"
    }, 'A'), /*#__PURE__*/React__default.createElement(StyledTableCell$8, {
      align: "center"
    }, 'Architect'), /*#__PURE__*/React__default.createElement(StyledTableCell$8, {
      align: "center"
    }, row === null || row === void 0 ? void 0 : (_row$correspondenceAd = row.correspondenceAddress) === null || _row$correspondenceAd === void 0 ? void 0 : _row$correspondenceAd.address), /*#__PURE__*/React__default.createElement(StyledTableCell$8, {
      align: "center"
    }, row === null || row === void 0 ? void 0 : row.emailId), /*#__PURE__*/React__default.createElement(StyledTableCell$8, {
      align: "center"
    }, row === null || row === void 0 ? void 0 : row.mobileNumber), /*#__PURE__*/React__default.createElement(StyledTableCell$8, {
      align: "center"
    }, row === null || row === void 0 ? void 0 : row.registrationNumber), /*#__PURE__*/React__default.createElement(StyledTableCell$8, {
      align: "center"
    }, new Date(row === null || row === void 0 ? void 0 : row.createdDate).toLocaleDateString() || ''), /*#__PURE__*/React__default.createElement(StyledTableCell$8, {
      align: "center"
    }, /*#__PURE__*/React__default.createElement("a", {
      href: "/",
      style: {
        color: '#8080FF'
      }
    }, "View")));
  }))))), /*#__PURE__*/React__default.createElement(TablePagination$1, {
    rowsPerPageOptions: rowsPerPageOptions,
    component: "div",
    count: engineersArr === null || engineersArr === void 0 ? void 0 : engineersArr.length,
    rowsPerPage: rowsPerPage,
    page: page,
    onPageChange: handleChangePage,
    onRowsPerPageChange: handleChangeRowsPerPage
  }));
}

const InProgressServiceCard = ({
  isUdFlow
}) => {
  return /*#__PURE__*/React__default.createElement(Card$2, {
    style: {
      background: isUdFlow ? '#0E7693' : '#1F4A7C'
    }
  }, /*#__PURE__*/React__default.createElement(CardContent$1, {
    style: {
      textAlign: 'center',
      color: '#fff'
    }
  }, /*#__PURE__*/React__default.createElement(Typography$2, {
    variant: "h6"
  }, "Thanks for Visiting"), /*#__PURE__*/React__default.createElement(Typography$2, {
    variant: "body1"
  }, "Work is in progress for this service. We will notify you once this service is ready to use.")));
};

const TCPCheckStatus = () => {
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Strip, null), /*#__PURE__*/React__default.createElement(GovtStrip, null), /*#__PURE__*/React__default.createElement(Navbar, null), /*#__PURE__*/React__default.createElement("div", null, "Akash bhai .....!"), /*#__PURE__*/React__default.createElement(Footer$1, null));
};

const FAQComponent = () => {
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      padding: '30px'
    }
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "h6",
    align: "justify"
  }, "Do You Know ?"), /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1",
    align: "justify"
  }, "According to the provisions of the Uttar Pradesh Town and Country Planning Act, 1977 (Act No. 12 of 1977), no construction / development activity can be undertaken in any Planning / Special Area or deemed Planning Area without the prior permission of the competent Authority namely Director, Town and Country Planning, Uttar Pradesh. No local authority or any office or any officer or other authority shall, notwithstanding anything ", /*#__PURE__*/React__default.createElement("a", {
    href: "http://9app.net.in"
  }, "9apps"), " contained in any other law for the time being in force, grant permission for the change in use of land without the permission in writing of the Director."), /*#__PURE__*/React__default.createElement(EDCRFAQ, null), /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1",
    align: "justify",
    style: {
      marginTop: '10px'
    }
  }, "No Registrar or the Sub-Registrar, appointed under the Indian Registration Act, 1908, shall register any deed or document of transfer of any sub-division of land by way of sale, gift, exchange, lease or mortgage with possession, unless the sub-division of land is duly approved by the Director, subject to such rules as may be framed in this behalf by the State Government."), /*#__PURE__*/React__default.createElement(List, {
    component: "ol",
    style: {
      listStyleType: 'lower-roman'
    }
  }, /*#__PURE__*/React__default.createElement(ListItem, null, /*#__PURE__*/React__default.createElement(ListItemText, null, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1",
    style: {
      textAlign: 'justify'
    }
  }, "i. Where the land is owned by a person and the transfer is made without involving any further divisions;"))), /*#__PURE__*/React__default.createElement(ListItem, null, /*#__PURE__*/React__default.createElement(ListItemText, null, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1",
    style: {
      textAlign: 'justify'
    }
  }, "ii. where the partition/sub-division of land is made in a joint Hindu Family;"))), /*#__PURE__*/React__default.createElement(ListItem, null, /*#__PURE__*/React__default.createElement(ListItemText, null, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1",
    style: {
      textAlign: 'justify'
    }
  }, "iii. Where the lease is made in relation to a part or whole of a building;"))), /*#__PURE__*/React__default.createElement(ListItem, null, /*#__PURE__*/React__default.createElement(ListItemText, null, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1",
    style: {
      textAlign: 'justify'
    }
  }, "iv. Where the mortgage is made for procuring the loans for construction or improvements over the land either from the Government or from any other financial institution constituted or established under any law for the time being in force or recognized by the State Government.")))), /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1",
    align: "justify",
    style: {
      marginTop: '10px'
    }
  }, "No electricity, water or sewerage connections shall be given to any person within the Planning or Special Area constituted under the Act, unless a No Objection Certificate has been obtained by such person from the Director or the Special Area Development Authority."), /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1",
    align: "justify",
    style: {
      marginTop: '10px'
    }
  }, "Provided that the service providing authorities shall disconnect the service connections forthwith of a building or land, in case any deviations from the approved plan or unauthorized constructions is brought to the notice or such authorities by the Director or the officer vested with the powers of the Director."), /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "h6",
    align: "justify",
    style: {
      marginTop: '10px',
      textDecoration: 'underline'
    }
  }, "After approval of plan"), /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1",
    align: "justify"
  }, "The following things should be kept in mind after approval of plan and during construction:-"), /*#__PURE__*/React__default.createElement(List, {
    component: "ol",
    style: {
      listStyleType: 'lower-roman'
    }
  }, /*#__PURE__*/React__default.createElement(ListItem, null, /*#__PURE__*/React__default.createElement(ListItemText, null, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1",
    style: {
      textAlign: 'justify'
    }
  }, "i. Get the plot/ land demarcated through Revenue Department and fix pillars on all four corners of the plot. Also raise a boundary wall in order to get saved from any dispute with neighbours."))), /*#__PURE__*/React__default.createElement(ListItem, null, /*#__PURE__*/React__default.createElement(ListItemText, null, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1",
    style: {
      textAlign: 'justify'
    }
  }, "ii. Least cutting and ", /*#__PURE__*/React__default.createElement("a", {
    href: "http://install9apps.in",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "9apps install"), " and filling should be done."))), /*#__PURE__*/React__default.createElement(ListItem, null, /*#__PURE__*/React__default.createElement(ListItemText, null, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1",
    style: {
      textAlign: 'justify'
    }
  }, "iii. The site development as well as construction should be done strictly as per the approved map."))), /*#__PURE__*/React__default.createElement(ListItem, null, /*#__PURE__*/React__default.createElement(ListItemText, null, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1",
    style: {
      textAlign: 'justify'
    }
  }, "iv. Drainage, sewerage and parking provisions be ensured property."))), /*#__PURE__*/React__default.createElement(ListItem, null, /*#__PURE__*/React__default.createElement(ListItemText, null, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1",
    style: {
      textAlign: 'justify'
    }
  }, "v. Approach path or access should be developed at site.")))), /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "h6",
    align: "justify",
    style: {
      marginTop: '10px',
      textDecoration: 'underline'
    }
  }, "Documents to be submitted with applications"), /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1",
    align: "justify",
    style: {
      marginTop: '10px'
    }
  }, "Documents to be submitted for planning permission and sub-division of land should be as per prescribed under Forms 11 and 12 respectively of Uttar Pradesh Town and Country Planning Rules, 2014."), /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "h6",
    align: "justify",
    style: {
      marginTop: '10px',
      textDecoration: 'underline'
    }
  }, "Who should prepare the plan"), /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1",
    align: "justify",
    style: {
      marginTop: '10px'
    }
  }, "Plan can be prepared by the professionals registered/empanelled under Appendix-10 of the Uttar Pradesh Town and Country Planning Rules, 2014."), /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "h5"
  }, "FAQ (Regarding Apartments and Colonies)"), /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "h6",
    align: "justify",
    style: {
      marginTop: '10px'
    }
  }, "What is an apartment building?"), /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1",
    align: "justify",
    style: {
      marginTop: '10px'
    }
  }, "\u201Capartment\u201D whether called block, chamber, dwelling unit, flat, lot, premises, suite, tenement, unit ,cottage or by any other name means a separate and self-contained part of any property including one or more rooms or enclosed spaces located on one or more floors or any part or parts thereof, in a building, or in a plot of land, used or intended to be used for residence, Office, shop, showroom, or godown or for carrying on any business, industry, occupation, profession or trade, or for any other type of independent use ancillary to the purpose specified above and with a direct exit to a public street, road or highway or to a common area leading to such street, road or highway and includes any garage or room whether or not adjacent to the building in which such apartment is located, provided by the promoter for the use by the allottee for parking any vehicle or as the case may be, for the residence of any domestic servant employed in such apartment;"), /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1",
    align: "justify",
    style: {
      marginTop: '10px'
    }
  }, "\u201Cbuilding\u201D includes any structure or erection, or part of a structure or erection, which is intended to be used for residential, industrial, commercial or other purposes, whether in actual use or not. However, for the purpose of apartment, building shall mean a building constructed on any land, containing more than eight apartments, or two or more buildings with a total of more than eight apartments or any existing building converted into more than eight apartments;"), /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "h6",
    align: "justify",
    style: {
      marginTop: '10px'
    }
  }, "What is a colony?"), /*#__PURE__*/React__default.createElement(List, {
    component: "ol",
    style: {
      listStyleType: 'lower-roman'
    }
  }, /*#__PURE__*/React__default.createElement(ListItem, null, /*#__PURE__*/React__default.createElement(ListItemText, null, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1",
    style: {
      textAlign: 'justify'
    }
  }, "Any area of land comprising of 2500 or more than 2500 square metres of land contiguous divided or proposed to be divided into plots or apartments or building for residential, commercial or industrial including purpose including cyber city, cyber park purpose.          "))), /*#__PURE__*/React__default.createElement(ListItem, null, /*#__PURE__*/React__default.createElement(ListItemText, null, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1",
    style: {
      textAlign: 'justify'
    }
  }, "Except:-"))), /*#__PURE__*/React__default.createElement(ListItem, null, /*#__PURE__*/React__default.createElement(ListItemText, null, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1",
    style: {
      textAlign: 'justify'
    }
  }, "Family partition by way inheritance or succession without a motive of earning profit."))), /*#__PURE__*/React__default.createElement(ListItem, null, /*#__PURE__*/React__default.createElement(ListItemText, null, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1",
    style: {
      textAlign: 'justify'
    }
  }, "Earmarked by a factory owner for housing colony for his employees or labourers.")))), /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "h6",
    align: "justify",
    style: {
      marginTop: '10px'
    }
  }, "Who is a Promoter or can become a Promoter under TCP Act?"), /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1",
    align: "justify",
    style: {
      marginTop: '10px'
    }
  }, "Any individual, Firm, Company, Co-operative Society & Association of Persons, who constructs/causes to construct a building consisting more than eight apartments or sets up/causes to set up a colony over land having area of 2500 or more than 2500 square meters for selling purpose."), /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "h6",
    align: "justify",
    style: {
      marginTop: '10px'
    }
  }, "Who is a Estate Agent or can become a Estate Agent under TCP Act?"), /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1",
    align: "justify",
    style: {
      marginTop: '10px'
    }
  }, "\u201Cestate agent\u201D means a person who negotiates or acts on behalf of a person in a transaction of transfer of property whether by way of sale, lease, license, mortgage or otherwise with another person and receives remuneration for his services in the form of commission and includes a person who introduces to each other for negotiation such persons or their agents."), /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "h6",
    align: "justify",
    style: {
      marginTop: '10px'
    }
  }, "What are the requirements to become a Promoter under TCP Act?"), /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1",
    align: "justify",
    style: {
      marginTop: '10px'
    }
  }, "One can apply online for Registration as Promoter fulfilling the following requirements:-"), /*#__PURE__*/React__default.createElement(List, {
    component: "ul"
  }, /*#__PURE__*/React__default.createElement(ListItem, null, /*#__PURE__*/React__default.createElement(ListItemText, null, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1",
    style: {
      textAlign: 'justify'
    }
  }, "Self Certified Statement regarding fulfilling the following requirements:"), /*#__PURE__*/React__default.createElement(List, {
    component: "ul",
    style: {
      listStyleType: 'none'
    }
  }, /*#__PURE__*/React__default.createElement(ListItem, null, /*#__PURE__*/React__default.createElement(ListItemText, null, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1",
    style: {
      textAlign: 'justify'
    }
  }, "> Should not be less than 18 years."))), /*#__PURE__*/React__default.createElement(ListItem, null, /*#__PURE__*/React__default.createElement(ListItemText, null, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1",
    style: {
      textAlign: 'justify'
    }
  }, "> Any individual or one of his employees should have 5 years experience in the field and should have a degree in engineering, architecture or town planning or should be a class-A contractor."))), /*#__PURE__*/React__default.createElement(ListItem, null, /*#__PURE__*/React__default.createElement(ListItemText, null, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1",
    style: {
      textAlign: 'justify'
    }
  }, "> Should not be of unsound mind, un-discharged insolvent, blacklisted entity, or have been convicted of an offence."))), /*#__PURE__*/React__default.createElement(ListItem, null, /*#__PURE__*/React__default.createElement(ListItemText, null, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1",
    style: {
      textAlign: 'justify'
    }
  }, "> Should not be an employee or should not have been dismissed or removed from the Government or Local Authority."))))))), /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "h6",
    align: "justify",
    style: {
      marginTop: '10px',
      textDecoration: 'underline'
    }
  }, "Other documents"), /*#__PURE__*/React__default.createElement(List, {
    component: "ul"
  }, /*#__PURE__*/React__default.createElement(ListItem, null, /*#__PURE__*/React__default.createElement(ListItemText, null, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1",
    style: {
      textAlign: 'justify'
    }
  }, "> Statement of Assets and Liabilities duly certified by Registered Chartered Accountant."))), /*#__PURE__*/React__default.createElement(ListItem, null, /*#__PURE__*/React__default.createElement(ListItemText, null, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1",
    style: {
      textAlign: 'justify'
    }
  }, "> Registration Certificate from RoC or Partnership deed etc."))), /*#__PURE__*/React__default.createElement(ListItem, null, /*#__PURE__*/React__default.createElement(ListItemText, null, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1",
    style: {
      textAlign: 'justify'
    }
  }, "> Copy of Pan Card."))), /*#__PURE__*/React__default.createElement(ListItem, null, /*#__PURE__*/React__default.createElement(ListItemText, null, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1",
    style: {
      textAlign: 'justify'
    }
  }, "> Three years Income Tax Returns of proceeding 3 years."))), /*#__PURE__*/React__default.createElement(ListItem, null, /*#__PURE__*/React__default.createElement(ListItemText, null, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1",
    style: {
      textAlign: 'justify'
    }
  }, "> Details of previous projects executed in preceding 5 years."))), /*#__PURE__*/React__default.createElement(ListItem, null, /*#__PURE__*/React__default.createElement(ListItemText, null, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1",
    style: {
      textAlign: 'justify'
    }
  }, "> An undertaking to appoint a qualified person.")))), /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "h6",
    align: "justify",
    style: {
      marginTop: '10px',
      textDecoration: 'underline'
    }
  }, "What are the requirements to become an Estate Agent under TCP Act?"), /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1",
    style: {
      textAlign: 'justify'
    }
  }, "One can apply online for Registration as Estate Agent fulfilling the following requirements:-"), /*#__PURE__*/React__default.createElement(List, {
    component: "ul"
  }, /*#__PURE__*/React__default.createElement(ListItem, null, /*#__PURE__*/React__default.createElement(ListItemText, null, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1",
    style: {
      textAlign: 'justify'
    }
  }, "> Any individual or one of his employees should have atleast one year experience as an Estate Agent."))), /*#__PURE__*/React__default.createElement(ListItem, null, /*#__PURE__*/React__default.createElement(ListItemText, null, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1",
    style: {
      textAlign: 'justify'
    }
  }, "> Income Tax Returns for the last three years alongwith attested copy of Permanent Account Number (PAN)."))), /*#__PURE__*/React__default.createElement(ListItem, null, /*#__PURE__*/React__default.createElement(ListItemText, null, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1",
    style: {
      textAlign: 'justify'
    }
  }, "> Self certified statement regarding conditions on following points:-", /*#__PURE__*/React__default.createElement("ul", null, /*#__PURE__*/React__default.createElement(ListItem, null, /*#__PURE__*/React__default.createElement(ListItemText, null, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1",
    style: {
      textAlign: 'justify'
    }
  }, "> Should not be less than eighteen years of age."))), /*#__PURE__*/React__default.createElement(ListItem, null, /*#__PURE__*/React__default.createElement(ListItemText, null, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1",
    style: {
      textAlign: 'justify'
    }
  }, "> Should not be in the employment of the Government or a State undertaking or a Local Authority."))), /*#__PURE__*/React__default.createElement(ListItem, null, /*#__PURE__*/React__default.createElement(ListItemText, null, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1",
    style: {
      textAlign: 'justify'
    }
  }, "> Should not be an un-discharged insolvent, un-sound mind or a convicted person.")))))))), /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "h6",
    align: "justify",
    style: {
      marginTop: '10px',
      textDecoration: 'underline'
    }
  }, "What is the fee payable for getting registered as a Promoter?"), /*#__PURE__*/React__default.createElement(List, {
    component: "ol"
  }, /*#__PURE__*/React__default.createElement(ListItem, null, /*#__PURE__*/React__default.createElement(ListItemText, null, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1",
    style: {
      textAlign: 'justify'
    }
  }, "1. Registration Fee Rs 50,000 through e-challan or challan or as DD in favour of Director (TCP)."))), /*#__PURE__*/React__default.createElement(ListItem, null, /*#__PURE__*/React__default.createElement(ListItemText, null, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1",
    style: {
      textAlign: 'justify'
    }
  }, "2. Security (Refundable) Rs 1.00 lacs as Bank Guarantee or FD duly pledged in the name of Director (TCP)."))), /*#__PURE__*/React__default.createElement(ListItem, null, /*#__PURE__*/React__default.createElement(ListItemText, null, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1",
    style: {
      textAlign: 'justify'
    }
  }, "3. E-charge fee Rs. 1500/- through DD in favour of Director (TCP).")))), /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "h6",
    align: "justify",
    style: {
      marginTop: '10px',
      textDecoration: 'underline'
    }
  }, "What is the fee payable for getting registered as an Estate Agent?"), /*#__PURE__*/React__default.createElement(List, {
    component: "ol"
  }, /*#__PURE__*/React__default.createElement(ListItem, null, /*#__PURE__*/React__default.createElement(ListItemText, null, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1",
    style: {
      textAlign: 'justify'
    }
  }, "1. Registration Fee Rs 10,000 through e-challan or challan or as DD in favour of Director (TCP)."))), /*#__PURE__*/React__default.createElement(ListItem, null, /*#__PURE__*/React__default.createElement(ListItemText, null, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1",
    style: {
      textAlign: 'justify'
    }
  }, "2. Security (Refundable) Rs 25,000/-only as Bank Guarantee or FD duly pledged in the name of Director (TCP)."))), /*#__PURE__*/React__default.createElement(ListItem, null, /*#__PURE__*/React__default.createElement(ListItemText, null, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1",
    style: {
      textAlign: 'justify'
    }
  }, "3. E-charge fee Rs. 750/- through DD in favour of Director (TCP).")))), /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "h6",
    align: "justify",
    style: {
      marginTop: '10px',
      textDecoration: 'underline'
    }
  }, "How can I get a licence to develop a colony?"), /*#__PURE__*/React__default.createElement(List, {
    component: "ol"
  }, /*#__PURE__*/React__default.createElement(ListItem, null, /*#__PURE__*/React__default.createElement(ListItemText, null, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1",
    style: {
      textAlign: 'justify'
    }
  }, "1. The person/AOP/Firm/Company should have been registered as Promoter under H.P. TCP Act."))), /*#__PURE__*/React__default.createElement(ListItem, null, /*#__PURE__*/React__default.createElement(ListItemText, null, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1",
    style: {
      textAlign: 'justify'
    }
  }, "2. The land should be in the name of person/ AOP/ Firm/ Company."))), /*#__PURE__*/React__default.createElement(ListItem, null, /*#__PURE__*/React__default.createElement(ListItemText, null, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1",
    style: {
      textAlign: 'justify'
    }
  }, "3. Application Form -47 (Rule-51).")))), /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "h6",
    align: "justify",
    style: {
      marginTop: '10px',
      textDecoration: 'underline'
    }
  }, "What are the steps involved for grant of licence to develop a colony?"), /*#__PURE__*/React__default.createElement(List, {
    component: "ol"
  }, /*#__PURE__*/React__default.createElement(ListItem, null, /*#__PURE__*/React__default.createElement(ListItemText, null, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1",
    style: {
      textAlign: 'justify'
    }
  }, "1. Applicant should be a registered Promoter under H.P. Town and Country Planning Act, 1977."))), /*#__PURE__*/React__default.createElement(ListItem, null, /*#__PURE__*/React__default.createElement(ListItemText, null, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1",
    style: {
      textAlign: 'justify'
    }
  }, "2. He has to submit the case for grant of licence as per Form-47 with relevant documents and Licence fee."))), /*#__PURE__*/React__default.createElement(ListItem, null, /*#__PURE__*/React__default.createElement(ListItemText, null, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1",
    style: {
      textAlign: 'justify'
    }
  }, "3. The documents/cases are scrutinized by the Department and after getting approval of plans/drawings, from the concerned authorities, the case is placed before the Committee constituted by Govt. for scrutinizing the cases pertaining to Apartments."))), /*#__PURE__*/React__default.createElement(ListItem, null, /*#__PURE__*/React__default.createElement(ListItemText, null, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1",
    style: {
      textAlign: 'justify'
    }
  }, "4. As per the recommendation of Committee the Director passes an order under Section 78 (p) (2) of the Act to call upon the Promoter to fulfill the conditions laid down in Rule-53 within 30 days from the issuance of the Notice in Form-48."))), /*#__PURE__*/React__default.createElement(ListItem, null, /*#__PURE__*/React__default.createElement(ListItemText, null, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1",
    style: {
      textAlign: 'justify'
    }
  }, "5. If promoter fails to fulfill the conditions within specified /extended period, the grant of licence shall be refused."))), /*#__PURE__*/React__default.createElement(ListItem, null, /*#__PURE__*/React__default.createElement(ListItemText, null, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1",
    style: {
      textAlign: 'justify'
    }
  }, "6. The Promoter who is found fit for grant of Licence under sub-section (2) of Section 78p of the Act shall be asked by the Director to:-"))), /*#__PURE__*/React__default.createElement("ul", null, /*#__PURE__*/React__default.createElement(ListItem, null, /*#__PURE__*/React__default.createElement(ListItemText, null, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1",
    style: {
      textAlign: 'justify'
    }
  }, "> Furnish an Undertaking to enter into an agreement in Form-50 for carrying out the completion of development works in accordance with the conditions of the Licence to be granted."))), /*#__PURE__*/React__default.createElement(ListItem, null, /*#__PURE__*/React__default.createElement(ListItemText, null, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1",
    style: {
      textAlign: 'justify'
    }
  }, "> Deposit Development charges assessed @ Rs. 200/- per sqm. of plot area in shape of Bank Draft."))))), /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "h6",
    align: "justify",
    style: {
      marginTop: '10px'
    }
  }, "Where can a colony be developed in H.P.?"), /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1",
    style: {
      textAlign: 'justify'
    }
  }, "Anywhere in Uttar Pradesh, subject to the fulfillment of requirements prescribed under Appendix-7 of the H.P. Town and Country Planning Rules, 2014 or Development Plans/ Interim Development Plans."), /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "h6",
    align: "justify",
    style: {
      marginTop: '10px'
    }
  }, "Can a non-himachali or a non-agriculturist himachali buy an apartment or plot in H.P.?"), /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1",
    style: {
      textAlign: 'justify'
    }
  }, "Yes, after taking permission from the Government under Section-118 of H.P. Tenancy and Land Reforms Act, 1972."), /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "h6",
    align: "justify",
    style: {
      marginTop: '10px'
    }
  }, "What is the implication of Section-118 of H.P. Tenancy and Land Reforms Act, 1972 with reference to apartments?"), /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1",
    style: {
      textAlign: 'justify'
    }
  }, "Transfer of land to non-agriculturist is barred under Section-118 under which following steps are involved:-"), /*#__PURE__*/React__default.createElement(List, {
    component: "ol"
  }, /*#__PURE__*/React__default.createElement(ListItem, null, /*#__PURE__*/React__default.createElement(ListItemText, null, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1",
    style: {
      textAlign: 'justify'
    }
  }, "1. Essentiality Certificate."))), /*#__PURE__*/React__default.createElement(ListItem, null, /*#__PURE__*/React__default.createElement(ListItemText, null, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1",
    style: {
      textAlign: 'justify'
    }
  }, "2. Permission under Section-118 required for purchase of land."))), /*#__PURE__*/React__default.createElement(ListItem, null, /*#__PURE__*/React__default.createElement(ListItemText, null, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1",
    style: {
      textAlign: 'justify'
    }
  }, "3. Permission for selling the apartments under Section-118 to non-agriculturist Himachalis and non-Himachalis."))), /*#__PURE__*/React__default.createElement(ListItem, null, /*#__PURE__*/React__default.createElement(ListItemText, null, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1",
    style: {
      textAlign: 'justify'
    }
  }, "4. Permission required for purchasing the apartments or plots by non-himachali or a non-agriculturist himachali.")))), /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "h6",
    align: "justify",
    style: {
      marginTop: '10px'
    }
  }, "Where shall I apply for grant of registration as an Estate Agent or a Promoter?"), /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body1",
    style: {
      textAlign: 'justify'
    }
  }, "The applicant should apply for registration as an Estate Agent in the Directorate Office under online system."));
};

const rows$8 = [{
  slNo: 1,
  description: "Internal Procedure For Change Of Land Use Approval",
  pdfUrl: "https://tcp.hp.gov.in/Application//uploadDocuments/download/Document20201208_123620.pdf"
}, {
  slNo: 2,
  description: "Internal Procedure For Building Planning Approval",
  pdfUrl: "https://tcp.hp.gov.in/Application//uploadDocuments/download/Document20180131_103934.pdf"
}, {
  slNo: 3,
  description: "Inspection Procedure And Checklist Of Obtaining Construction Permit",
  pdfUrl: "https://tcp.hp.gov.in/Application//uploadDocuments/download/Document20210113_155622.pdf"
}, {
  slNo: 4,
  description: "Inspection Procedure And Checklist For Obtaining Final Noc",
  pdfUrl: "https://tcp.hp.gov.in/Application//uploadDocuments/download/Document20180131_103141.pdf"
}, {
  slNo: 5,
  description: "Procedure And Guidelines For Obtaning Planning Permission On Form 12",
  pdfUrl: "https://tcp.hp.gov.in/Application//uploadDocuments/download/Document20180217_143141.pdf"
}, {
  slNo: 6,
  description: "Inspection Procedure & Checklist For Obtaning Noc After Construction",
  pdfUrl: "https://tcp.hp.gov.in/Application//uploadDocuments/download/Document20180217_143209.pdf"
}, {
  slNo: 7,
  description: "Procedure, Checklist For Obtaning Noc After Construction",
  pdfUrl: "https://tcp.hp.gov.in/Application//uploadDocuments/download/Document20180217_143237.pdf"
}, {
  slNo: 8,
  description: "Form/checklist For Sub Division Cases",
  pdfUrl: "https://tcp.hp.gov.in/Application//uploadDocuments/download/Document20160926_133842.pdf"
}, {
  slNo: 9,
  description: "Form/checklist For Registration Of Promoter",
  pdfUrl: "https://tcp.hp.gov.in/Application//uploadDocuments/download/Document20160926_134232.pdf"
}, {
  slNo: 10,
  description: "Form/checklist For Registration Of Estate Agent",
  pdfUrl: "https://tcp.hp.gov.in/Application//uploadDocuments/download/Document20160926_134350.pdf"
}, {
  slNo: 11,
  description: "Form/checklist For License Of Real Estate Projects.",
  pdfUrl: "https://tcp.hp.gov.in/Application/img/pdf.png"
}, {
  slNo: 12,
  description: "Form/checklist For Completion & Occupation Certificate Of Real Estate Projects. ",
  pdfUrl: "https://tcp.hp.gov.in/Application//uploadDocuments/download/Document20150522_080459.docx"
}];
const StyledTableCell$9 = styled$3(TableCell$1)(({
  theme
}) => ({
  [`&.${tableCellClasses$1.head}`]: {
    backgroundColor: "#1f4a7c",
    color: theme.palette.common.white,
    fontSize: 16
  },
  [`&.${tableCellClasses$1.body}`]: {
    fontSize: 14
  }
}));
const StyledTableRow$9 = styled$3(TableRow$2)(({
  theme
}) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover
  },
  "&:last-child td, &:last-child th": {
    border: 0
  }
}));
const handlePdfDownload$2 = pdfUrl => {
  window.open(pdfUrl);
};
const FormAndChecklistTable = () => {
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(TableContainer$2, {
    component: Paper$2
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h6",
    style: {
      margin: '20px'
    }
  }, "Form/Checklist"), /*#__PURE__*/React__default.createElement(Table$5, {
    "aria-label": "Sample Table",
    style: {
      width: '90%',
      margin: '30px'
    }
  }, /*#__PURE__*/React__default.createElement(TableHead$2, null, /*#__PURE__*/React__default.createElement(StyledTableRow$9, {
    style: {
      background: '#1F4A7C',
      height: '20px',
      color: 'white'
    }
  }, /*#__PURE__*/React__default.createElement(StyledTableCell$9, {
    style: {
      color: 'white',
      border: '1px solid #ffff'
    }
  }, "SL. No"), /*#__PURE__*/React__default.createElement(StyledTableCell$9, {
    style: {
      color: 'white',
      border: '1px solid #ffff'
    }
  }, "Headline"), /*#__PURE__*/React__default.createElement(StyledTableCell$9, {
    style: {
      color: 'white',
      border: '1px solid #ffff'
    }
  }, "Download"))), /*#__PURE__*/React__default.createElement(TableBody$2, null, rows$8.map(row => /*#__PURE__*/React__default.createElement(StyledTableRow$9, {
    key: row.slNo
  }, /*#__PURE__*/React__default.createElement(StyledTableCell$9, {
    component: "th",
    scope: "row"
  }, row.slNo), /*#__PURE__*/React__default.createElement(StyledTableCell$9, null, row.description), /*#__PURE__*/React__default.createElement(StyledTableCell$9, {
    onClick: () => handlePdfDownload$2(row.pdfUrl)
  }, /*#__PURE__*/React__default.createElement(AiFillFilePdf, {
    style: {
      width: '30px',
      height: '30px',
      color: '#f44b55',
      cursor: 'pointer'
    }
  }))))))));
};

const data$1 = [{
  id: 1,
  district: 'Shimla',
  planningAreas: [{
    name: 'Shimla',
    url: 'https://tcp.hp.gov.in/Application//uploadDocuments/devlopmentPlan/PlanDoc020150127_173301.pdf'
  }, {
    name: 'Rampur',
    url: 'https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Rampur_Planning_Area.pdf'
  }, {
    name: 'Rohru',
    url: 'https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Rohru_Planning_Area.pdf'
  }, {
    name: 'Theog',
    url: 'https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Theog_Planning_Area.pdf'
  }, {
    name: 'Chopal',
    url: 'https://tcp.hp.gov.in/Application/uploadDocuments/content/Chopal-Rajpatra.pdf'
  }, {
    name: 'Narkanda',
    url: 'https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Narkanda_Planning_Area.pdf'
  }, {
    name: 'Suni',
    url: 'https://tcp.hp.gov.in/Application/uploadDocuments/content/document2_1.pdf'
  }, {
    name: 'Kotkhai',
    url: 'https://tcp.hp.gov.in/Application/uploadDocuments/content/document2_2.pdf'
  }, {
    name: 'Jubbal',
    url: 'https://tcp.hp.gov.in/Application/uploadDocuments/content/document2_3.pdf'
  }],
  specialAreas: [{
    name: 'Hatkoti',
    url: 'https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Hatkoti_Special_Area.pdf'
  }, {
    name: 'Sarahan',
    url: 'https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Sarahan_Special_Area.pdf'
  }, {
    name: 'Shoghi',
    url: 'https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Shoghi_Special_Area.pdf'
  }, {
    name: 'Kufri',
    url: 'https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Kufri_Special_Area.pdf'
  }, {
    name: 'Ghanahatti',
    url: 'https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Ghanahatti_Special_Area.pdf'
  }]
}, {
  id: 2,
  district: 'Solan',
  planningAreas: [{
    name: 'Kasauli',
    url: 'https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Kasauli_Planning_Area.pdf'
  }, {
    name: 'Parwanoo',
    url: 'https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Parwanoo_Planning_Area.pdf'
  }, {
    name: 'Solan',
    url: 'https://tcp.hp.gov.in/Application//uploadDocuments/devlopmentPlan/PlanDoc020150127_180216.pdf'
  }, {
    name: 'Waknaghat',
    url: 'https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Waknaghat_Planning_Area.pdf'
  }, {
    name: 'Hinner',
    url: 'https://www.tcp.hp.gov.in/Application/uploadDocuments/content/notification_Hinner_Planning_Area.pdf'
  }, {
    name: 'Arki',
    url: 'https://tcp.hp.gov.in/Application/uploadDocuments/content/document2_4.pdf'
  }],
  specialAreas: [{
    name: 'Kandaghat',
    url: 'https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Kandaghat_Special_Area.pdf'
  }, {
    name: 'Barog',
    url: 'https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Barog_Special_Area.docx'
  }, {
    name: 'Jabli',
    url: 'https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Jabli_Special_Area.pdf'
  }, {
    name: 'Harat',
    url: 'https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Harat_Special_Area.pdf'
  }, {
    name: 'Chail',
    url: 'https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Chail_Special_Area.pdf'
  }, {
    name: 'Baddi-Barotiwala-Nalagarh',
    url: 'https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Baddi-Barotiwala_Special_Area.pdf'
  }]
}, {
  id: 3,
  district: "Sirmour",
  planningAreas: [{
    name: "Nahan",
    url: "https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Nahan_Planning_Area.pdf"
  }, {
    name: "Paonta-Sahib",
    url: "https://tcp.hp.gov.in/Application/uploadDocuments/content/Paonta_Sahib_Special_Area_1.pdf"
  }, {
    name: "Sangrah",
    url: "https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Sangrah_Planning_Area.pdf"
  }, {
    name: "Dhaulakuan-Majra",
    url: "https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Dhaulakuan-Majra.pdf"
  }, {
    name: "Rajgarh",
    url: "https://tcp.hp.gov.in/Application/uploadDocuments/content/document2_5.pdf"
  }],
  specialAreas: [{
    name: "Paonta Sahib",
    url: "https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Paonta_Sahib_Special_Area.pdf"
  }, {
    name: "Trilokpur",
    url: "https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Trilokpur_Special_Area.pdf"
  }, null, null, null]
}, {
  id: 4,
  district: "Bilaspur",
  planningAreas: [{
    name: "Bilaspur",
    url: "https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Bilaspur_Planning_Area.pdf"
  }, {
    name: "Ghumarwin",
    url: "https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Ghumarwin_Planning_Area.pdf"
  }, {
    name: "Naina Devi",
    url: "https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Naina_Devi_Planning_Area.pdf"
  }, {
    name: "Jhandutta",
    url: "https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Jhandutta_Planning_Area.pdf"
  }, {
    name: "Sri Naina Deviji",
    url: "https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Sri_Naina_Deviji_Planning_Area.pdf"
  }],
  specialAreas: [{
    name: "Paonta-Sahib",
    url: "https://tcp.hp.gov.in/Application/uploadDocuments/content/Paonta_Sahib_Special_Area_1.pdf"
  }, null, null, null, {
    name: "Trilokpur",
    url: "https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Trilokpur_Special_Area.pdf"
  }]
}, {
  id: 4,
  district: "Bilaspur",
  planningAreas: [{
    name: "Bilaspur",
    url: "https://www.tcp.hp.gov.in/Application//uploadDocuments/notification/Notice20160719_110831.pdf"
  }, {
    name: "Ghumarwin",
    url: "https://www.tcp.hp.gov.in/Application//uploadDocuments/notification/Notice20160719_111108.pdf"
  }, {
    name: "Sh. Naina Devi Ji.",
    url: "https://tcp.hp.gov.in/Application/uploadDocuments/content/document2_6.pdf"
  }],
  specialAreas: [null, null, null]
}, {
  id: 5,
  district: "Una",
  planningAreas: [{
    name: "Una",
    url: null
  }, {
    name: "Mehatpur",
    url: "https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Mehatpur_Planning_Area.pdf"
  }, {
    name: "Amb-Gagret",
    url: "https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Amb-Gagret_Planning_Area.pdf"
  }, {
    name: "Tahliwal",
    url: "https://tcp.hp.gov.in/Application/uploadDocuments/content/document2_7.pdf"
  }, {
    name: "Daulatpur",
    url: "https://tcp.hp.gov.in/Application/uploadDocuments/content/document2_8.pdf"
  }, {
    name: "Santokgarh",
    url: "https://tcp.hp.gov.in/Application/uploadDocuments/content/document2_9.pdf"
  }],
  specialAreas: [{
    name: "Una",
    url: "https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Una_Special_Area.pdf"
  }, {
    name: "Chintpurni",
    url: "https://tcp.hp.gov.in/Application/uploadDocuments/content/Sri_Chintpurni_Special_Area.pdf"
  }, null, null, null, null]
}, {
  id: 6,
  district: "Hamirpur",
  planningAreas: [{
    name: "Hamirpur",
    url: "https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Hamirpur_Planning_Area.pdf"
  }, {
    name: "Nadaun",
    url: "https://tcp.hp.gov.in/Application/uploadDocuments/content/Notification_Naduan.pdf"
  }, {
    name: "Sujanpur",
    url: "https://www.tcp.hp.gov.in/Application//uploadDocuments/notification/Notice20160719_111241.pdf"
  }, {
    name: "Bhota",
    url: "https://www.tcp.hp.gov.in/Application//uploadDocuments/notification/Notice20160719_111014.pdf"
  }],
  specialAreas: [{
    name: "Baba Balak Nath",
    url: "https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Baba_Balak_Nath_Special_Area.pdf"
  }, null, null, null]
}];
const NotifiedAreasTable = () => {
  return /*#__PURE__*/React__default.createElement(Fragment$2, null, /*#__PURE__*/React__default.createElement(TableContainer, {
    component: Paper
  }, /*#__PURE__*/React__default.createElement(Table, null, /*#__PURE__*/React__default.createElement(TableHead, null, /*#__PURE__*/React__default.createElement(TableRow, null, /*#__PURE__*/React__default.createElement(TableCell, null, "Sr. No."), /*#__PURE__*/React__default.createElement(TableCell, null, "District"), /*#__PURE__*/React__default.createElement(TableCell, null, "Planning Areas"), /*#__PURE__*/React__default.createElement(TableCell, null, "Special Areas"))), /*#__PURE__*/React__default.createElement(TableBody, null, data$1.map((row, rowIndex) => row.planningAreas.map((planningArea, index) => /*#__PURE__*/React__default.createElement(TableRow, {
    key: `${row.id}-${index}`
  }, index === 0 && /*#__PURE__*/React__default.createElement(Fragment$2, null, /*#__PURE__*/React__default.createElement(TableCell, {
    rowSpan: row.planningAreas.length
  }, row.id), /*#__PURE__*/React__default.createElement(TableCell, {
    rowSpan: row.planningAreas.length
  }, row.district)), /*#__PURE__*/React__default.createElement(TableCell, null, /*#__PURE__*/React__default.createElement(Link, {
    href: planningArea.url,
    target: "_blank",
    rel: "noopener"
  }, planningArea.name)), /*#__PURE__*/React__default.createElement(TableCell, null, row.specialAreas[index] ? /*#__PURE__*/React__default.createElement(Link, {
    href: row.specialAreas[index].url,
    target: "_blank",
    rel: "noopener"
  }, row.specialAreas[index].name) : '-'))))))));
};

const rows$9 = [{
  description: "List of PIO, APIO & Appelate authority",
  pdfUrl: "https://tcp.hp.gov.in/Application/uploadDocuments/content/rti.pdf"
}, {
  description: "List of PIO, APIO & Appelate authority for Real Estate (Regulation and Development) Act,2016",
  pdfUrl: "https://tcp.hp.gov.in/Application/uploadDocuments/content/office_order_3.pdf"
}, {
  description: "PRO-ACTIVE DISCLOSURE OF INFORMATION UNDER RIGHT TO INFORMATION ACT, 2005",
  pdfUrl: "https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Pro_Active.pdf"
}];
const handlePdfDownload$3 = pdfUrl => {
  window.open(pdfUrl);
};
const AdminstrativeOrders$1 = () => {
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(TableContainer$2, {
    component: Paper$2
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h6",
    style: {
      margin: '20px'
    }
  }, "Right to Information"), /*#__PURE__*/React__default.createElement(Table$5, {
    "aria-label": "Sample Table",
    style: {
      width: '90%',
      margin: '30px'
    }
  }, /*#__PURE__*/React__default.createElement(TableHead$2, null, /*#__PURE__*/React__default.createElement(TableRow$2, {
    style: {
      background: '#1F4A7C',
      height: '20px'
    }
  }, /*#__PURE__*/React__default.createElement(TableCell$2, {
    style: {
      width: '60%',
      color: 'white'
    }
  }, "Description"), /*#__PURE__*/React__default.createElement(TableCell$2, {
    style: {
      width: '5%',
      color: 'white'
    }
  }, "Download"))), /*#__PURE__*/React__default.createElement(TableBody$2, null, rows$9.map(row => /*#__PURE__*/React__default.createElement(TableRow$2, {
    key: row.slNo
  }, /*#__PURE__*/React__default.createElement(TableCell$2, null, row.description), /*#__PURE__*/React__default.createElement(TableCell$2, {
    onClick: () => handlePdfDownload$3(row.pdfUrl)
  }, /*#__PURE__*/React__default.createElement(AiFillFilePdf, {
    style: {
      width: '30px',
      height: '30px',
      color: '#f44b55',
      cursor: 'pointer'
    }
  }))))))));
};

const rows$a = [{
  slNo: 1,
  appealNO: '01/2014',
  description: "I.D. Gupta,Vill.& P.O. Salogra,Teh. & Distt. Solan,H.P. Shimla-9. (Appellant). V/S PIO-cum-State Town Planner, Town & Country Pig, Deptt.,H.P. Shimla-9.",
  pdfUrl: "https://tcp.hp.gov.in/Application//uploadDocuments/content/1.2014.pdf"
}, {
  slNo: 2,
  appealNO: '04/2014',
  description: "Nisha Sood wlo Umesh Sood, rlo Kotwali Bazzar, Shimla Hotel, Dharamshala District Kangra HP (Appellant). V/S PIO-cum-Town & Country Planner, DivisionalTown and Planning Office, DharamshalaDistrict KangraHP (Respondent)",
  pdfUrl: "https://tcp.hp.gov.in/Application//uploadDocuments/content/4.2014.pdf"
}, {
  slNo: 3,
  appealNO: '08/2014',
  description: "Om Prakash Garg s/o Bhagat RamVPODurgapur Tehsil and district Shimla HP (Appellant) V/S PIO-cum- Town & Country Planner, Divisional Town and PlanningOffice, Shimla (Respondent)",
  pdfUrl: "https://tcp.hp.gov.in/Application//uploadDocuments/content/8.2014.pdf"
}, {
  slNo: 4,
  appealNO: '2',
  description: "Sh. Pyare LalNegi,Sarpara Niwas,Mehli,Post OfficeMehli,Gusan Road,DistricttShimla(HP) Appellant V/S Town and Country Planner, DivisionalTown Planning Office,Shimla(HP) Respondent",
  pdfUrl: "https://tcp.hp.gov.in/Application//uploadDocuments/content/9.06.2014_1.pdf"
}, {
  slNo: 5,
  appealNO: '2',
  description: "Sh.Anup KumarS/o Sh.Dev Raj,VPO Shamshi,Tehsii & Distt. Kullu (HP) Appellant. V/S Town &Country Planner, DivisionalTown PlanningOffice,Kullu.Respondent",
  pdfUrl: "https://tcp.hp.gov.in/Application//uploadDocuments/content/12.6.2014.pdf"
}, {
  slNo: 6,
  appealNO: '12/2014',
  description: " L.N. Aggarwal, Ex-Director, GSI,(Govt. of India), Bansilal Building, Kotwali Bazar, Dharamsala, District Kangra HP .Appellant V/S  PIO-cum-Town & Country Planner, Divisional Town and Country Planning Office,Dharmashala District Kangra HP .Respondent",
  pdfUrl: "https://tcp.hp.gov.in/Application//uploadDocuments/content/12.2014.pdf"
}];
const StyledTableCell$a = styled$3(TableCell$1)(({
  theme
}) => ({
  [`&.${tableCellClasses$1.head}`]: {
    backgroundColor: "#1f4a7c",
    color: theme.palette.common.white,
    fontSize: 16
  },
  [`&.${tableCellClasses$1.body}`]: {
    fontSize: 14
  }
}));
const StyledTableRow$a = styled$3(TableRow$2)(({
  theme
}) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover
  },
  "&:last-child td, &:last-child th": {
    border: 0
  }
}));
const handlePdfDownload$4 = pdfUrl => {
  window.open(pdfUrl);
};
const NotificationTCP$1 = () => {
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(TableContainer$2, {
    component: Paper$2
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h6",
    style: {
      margin: '20px'
    }
  }, "Order of 1st Appelate Authority Cum Director TCP"), /*#__PURE__*/React__default.createElement(Table$5, {
    "aria-label": "Sample Table",
    style: {
      width: '90%',
      margin: '30px'
    }
  }, /*#__PURE__*/React__default.createElement(TableHead$2, null, /*#__PURE__*/React__default.createElement(StyledTableRow$a, {
    style: {
      background: '#1F4A7C',
      height: '20px',
      color: 'white'
    }
  }, /*#__PURE__*/React__default.createElement(StyledTableCell$a, {
    style: {
      color: 'white',
      border: '1px solid #ffff'
    }
  }, "SL. No"), /*#__PURE__*/React__default.createElement(StyledTableCell$a, {
    style: {
      color: 'white',
      border: '1px solid #ffff'
    }
  }, "Appeal No."), /*#__PURE__*/React__default.createElement(StyledTableCell$a, {
    style: {
      color: 'white',
      border: '1px solid #ffff'
    }
  }, "Title"), /*#__PURE__*/React__default.createElement(StyledTableCell$a, {
    style: {
      color: 'white',
      border: '1px solid #ffff'
    }
  }, "Order"))), /*#__PURE__*/React__default.createElement(TableBody$2, null, rows$a.map(row => /*#__PURE__*/React__default.createElement(StyledTableRow$a, {
    key: row.slNo
  }, /*#__PURE__*/React__default.createElement(StyledTableCell$a, {
    component: "th",
    scope: "row"
  }, row.slNo), /*#__PURE__*/React__default.createElement(StyledTableCell$a, null, row.description), /*#__PURE__*/React__default.createElement(StyledTableCell$a, null, row.date), /*#__PURE__*/React__default.createElement(StyledTableCell$a, {
    onClick: () => handlePdfDownload$4(row.pdfUrl)
  }, /*#__PURE__*/React__default.createElement(AiFillFilePdf, {
    style: {
      width: '30px',
      height: '30px',
      color: '#f44b55',
      cursor: 'pointer'
    }
  }))))))));
};

function RTI() {
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'column'
    }
  }, /*#__PURE__*/React__default.createElement(AdminstrativeOrders$1, null), /*#__PURE__*/React__default.createElement(NotificationTCP$1, null));
}

const rows$b = [{
  slNo: 1,
  name: "Amit Singh Thakur",
  email: "N/A",
  mobile: "9736300042",
  RegdNo: "RE0003/2016",
  Regdate: "29-Nov-2016"
}, {
  slNo: 2,
  name: "Anil Kapoor",
  email: "N/A",
  mobile: "",
  RegdNo: "R.C. No. 01/2015",
  Regdate: "22-JAN-2015"
}, {
  slNo: 3,
  name: "Bakhtawar Singh",
  email: "N/A",
  mobile: "9816021084",
  RegdNo: "RE0005/2017",
  Regdate: "04-Jul-2017"
}, {
  slNo: 4,
  name: "Dhruv Garg, Prop. Assets Pro",
  email: "N/A",
  mobile: "9805992111",
  RegdNo: "RE0004/2017",
  Regdate: "22-Feb-2017"
}, {
  slNo: 5,
  name: "Kcr Estates Private Limited",
  email: "N/A",
  mobile: "9816072072",
  RegdNo: "RE0006/2017",
  Regdate: "04-Jul-2017"
}, {
  slNo: 6,
  name: "M/s Pinewood Aggregators Pvt. Ltd.",
  email: "N/A",
  mobile: "",
  RegdNo: "R.C. No. 03/2015",
  Regdate: "22-Jan-2015"
}, {
  slNo: 7,
  name: "M/s Sandalee Real Estates Promoters And Developers Pvt. Ltd.",
  email: "N/A",
  mobile: "",
  RegdNo: "R.C. No. 02/2015",
  Regdate: "22-Jan-2015"
}, {
  slNo: 8,
  name: "M/s Shandil Estates",
  email: "N/A",
  mobile: "",
  RegdNo: "R.C. No. 09/2015",
  Regdate: "25-Jun-2015"
}, {
  slNo: 9,
  name: "Madhu Bala",
  email: "N/A",
  mobile: "9418019872",
  RegdNo: "RE0002/2016",
  Regdate: "10-Aug-2016"
}, {
  slNo: 10,
  name: "Sh. Ajay Kumar",
  email: "N/A",
  mobile: "",
  RegdNo: "R.C. No.05/2015 ",
  Regdate: "28-Jan-2015"
}, {
  slNo: 11,
  name: "Sh. Atul Rajput",
  email: "N/A",
  mobile: "",
  RegdNo: "R.C. No. 07/2015",
  Regdate: "16-Feb-2015"
}, {
  slNo: 12,
  name: "Sh. Med Ram Sharma",
  email: "N/A",
  mobile: "",
  RegdNo: "R.C. No. 08/2015",
  Regdate: "05-Mar-2015"
}, {
  slNo: 13,
  name: "Sh. Onkar Chand Rana",
  email: "N/A",
  mobile: "",
  RegdNo: "R.C. No. 10/2015",
  Regdate: "07-Aug-2015"
}, {
  slNo: 14,
  name: "Swastik Estates Through Sole Proprietor Smt. Reeti Shandil",
  email: "N/A",
  mobile: "9418434540",
  RegdNo: "RE0001/2016",
  Regdate: "09-Feb-2016"
}];
const StyledTableCell$b = styled$3(TableCell$1)(({
  theme
}) => ({
  [`&.${tableCellClasses$1.head}`]: {
    backgroundColor: "#1f4a7c",
    color: theme.palette.common.white,
    fontSize: 16
  },
  [`&.${tableCellClasses$1.body}`]: {
    fontSize: 14
  }
}));
const StyledTableRow$b = styled$3(TableRow$2)(({
  theme
}) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover
  },
  "&:last-child td, &:last-child th": {
    border: 0
  }
}));
const RegisteredAgent = () => {
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(TableContainer$2, {
    component: Paper$2
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h6",
    style: {
      margin: "20px"
    }
  }, "Registered Estate Agent"), /*#__PURE__*/React__default.createElement(Table$5, {
    "aria-label": "Sample Table",
    style: {
      width: "90%",
      margin: "30px"
    }
  }, /*#__PURE__*/React__default.createElement(TableHead$2, null, /*#__PURE__*/React__default.createElement(StyledTableRow$b, {
    style: {
      background: "#1F4A7C",
      height: "20px",
      color: "white"
    }
  }, /*#__PURE__*/React__default.createElement(StyledTableCell$b, {
    style: {
      color: "white",
      border: "1px solid #ffff"
    }
  }, "SL. No"), /*#__PURE__*/React__default.createElement(StyledTableCell$b, {
    style: {
      color: "white",
      border: "1px solid #ffff"
    }
  }, "Name"), /*#__PURE__*/React__default.createElement(StyledTableCell$b, {
    style: {
      color: "white",
      border: "1px solid #ffff"
    }
  }, "Email"), /*#__PURE__*/React__default.createElement(StyledTableCell$b, {
    style: {
      color: "white",
      border: "1px solid #ffff"
    }
  }, "Reg.NO."), /*#__PURE__*/React__default.createElement(StyledTableCell$b, {
    style: {
      color: "white",
      border: "1px solid #ffff"
    }
  }, "Reg.Date."))), /*#__PURE__*/React__default.createElement(TableBody$2, null, rows$b.map(row => /*#__PURE__*/React__default.createElement(StyledTableRow$b, {
    key: row.slNo
  }, /*#__PURE__*/React__default.createElement(StyledTableCell$b, {
    component: "th",
    scope: "row"
  }, row.slNo), /*#__PURE__*/React__default.createElement(StyledTableCell$b, null, row.name), /*#__PURE__*/React__default.createElement(StyledTableCell$b, null, row.email), /*#__PURE__*/React__default.createElement(StyledTableCell$b, null, row.RegdNo), /*#__PURE__*/React__default.createElement(StyledTableCell$b, null, row.Regdate)))))));
};

const rows$c = [{
  description: "Public Service Guarantee Act",
  pdfUrl: "https://tcp.hp.gov.in/Application/uploadDocuments/content/Public__Service_Guraunty.pdf"
}, {
  description: "Nodal officer for implementation of Public Service Guarantee ACT , 2011",
  pdfUrl: "https://tcp.hp.gov.in/Application/uploadDocuments/content/Nodal_Officer_PSA_1.pdf"
}, {
  description: "Public Service Guarantee Report",
  pdfUrl: "https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Pro_Active.pdf"
}];
const handlePdfDownload$5 = pdfUrl => {
  window.open(pdfUrl);
};
const PublicActs = () => {
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(TableContainer$2, {
    component: Paper$2
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h6",
    style: {
      margin: '20px'
    }
  }, "Public Service Guarantee Act"), /*#__PURE__*/React__default.createElement(Table$5, {
    "aria-label": "Sample Table",
    style: {
      width: '90%',
      margin: '30px'
    }
  }, /*#__PURE__*/React__default.createElement(TableBody$2, null, rows$c.map(row => /*#__PURE__*/React__default.createElement(TableRow$2, {
    key: row.slNo
  }, /*#__PURE__*/React__default.createElement(TableCell$2, null, row.description), /*#__PURE__*/React__default.createElement(TableCell$2, {
    onClick: () => handlePdfDownload$5(row.pdfUrl)
  }, /*#__PURE__*/React__default.createElement(AiFillFilePdf, {
    style: {
      width: '30px',
      height: '30px',
      color: '#f44b55',
      cursor: 'pointer'
    }
  }))))))));
};

const rows$d = [{
  slNo: 1,
  description: "LIST OF REGISTERED COLONIES APPROVED UNDER H.P. APARTMENT AND PROPERTY REGULATION ACT, 2005",
  pdfUrl: "https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Licence_Cases_1_1.pdf"
}];
const rows2 = [{
  slNo: 1,
  description: "LIST OF ESSENTIALITY CERTIFICATE",
  pdfUrl: "https://www.tcp.hp.gov.in/Application/uploadDocuments/content/EC_list.pdf"
}];
const StyledTableCell$c = styled$3(TableCell$1)(({
  theme
}) => ({
  [`&.${tableCellClasses$1.head}`]: {
    backgroundColor: "#1f4a7c",
    color: theme.palette.common.white,
    fontSize: 16
  },
  [`&.${tableCellClasses$1.body}`]: {
    fontSize: 14
  }
}));
const StyledTableRow$c = styled$3(TableRow$2)(({
  theme
}) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover
  },
  "&:last-child td, &:last-child th": {
    border: 0
  }
}));
const handlePdfDownload$6 = pdfUrl => {
  window.open(pdfUrl);
};
const LicenseCertificate = () => {
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(TableContainer$2, {
    component: Paper$2
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h6",
    style: {
      margin: '20px'
    }
  }, "License and Essentiality Certifiate"), /*#__PURE__*/React__default.createElement(Table$5, {
    "aria-label": "Sample Table",
    style: {
      width: '90%',
      margin: '30px'
    }
  }, /*#__PURE__*/React__default.createElement(TableHead$2, null, /*#__PURE__*/React__default.createElement(StyledTableRow$c, {
    style: {
      background: '#1F4A7C',
      height: '20px',
      color: 'white'
    }
  }, /*#__PURE__*/React__default.createElement(StyledTableCell$c, {
    style: {
      color: 'white',
      border: '1px solid #ffff'
    }
  }, "SL. No"), /*#__PURE__*/React__default.createElement(StyledTableCell$c, {
    style: {
      color: 'white',
      border: '1px solid #ffff'
    }
  }, "Subject"), /*#__PURE__*/React__default.createElement(StyledTableCell$c, {
    style: {
      color: 'white',
      border: '1px solid #ffff'
    }
  }, "Download"))), /*#__PURE__*/React__default.createElement(TableBody$2, null, rows$d.map(row => /*#__PURE__*/React__default.createElement(StyledTableRow$c, {
    key: row.slNo
  }, /*#__PURE__*/React__default.createElement(StyledTableCell$c, {
    component: "th",
    scope: "row"
  }, row.slNo), /*#__PURE__*/React__default.createElement(StyledTableCell$c, null, row.description), /*#__PURE__*/React__default.createElement(StyledTableCell$c, {
    onClick: () => handlePdfDownload$6(row.pdfUrl)
  }, /*#__PURE__*/React__default.createElement(AiFillFilePdf, {
    style: {
      width: '30px',
      height: '30px',
      color: '#f44b55',
      cursor: 'pointer'
    }
  }))))))), /*#__PURE__*/React__default.createElement(TableContainer$2, {
    component: Paper$2
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h6",
    style: {
      margin: '20px'
    }
  }, "Essentiality Certifiate"), /*#__PURE__*/React__default.createElement(Table$5, {
    "aria-label": "Sample Table",
    style: {
      width: '90%',
      margin: '30px'
    }
  }, /*#__PURE__*/React__default.createElement(TableHead$2, null, /*#__PURE__*/React__default.createElement(StyledTableRow$c, {
    style: {
      background: '#1F4A7C',
      height: '20px',
      color: 'white'
    }
  }, /*#__PURE__*/React__default.createElement(StyledTableCell$c, {
    style: {
      color: 'white',
      border: '1px solid #ffff'
    }
  }, "SL. No"), /*#__PURE__*/React__default.createElement(StyledTableCell$c, {
    style: {
      color: 'white',
      border: '1px solid #ffff'
    }
  }, "Subject"), /*#__PURE__*/React__default.createElement(StyledTableCell$c, {
    style: {
      color: 'white',
      border: '1px solid #ffff'
    }
  }, "Download"))), /*#__PURE__*/React__default.createElement(TableBody$2, null, rows2.map(row => /*#__PURE__*/React__default.createElement(StyledTableRow$c, {
    key: row.slNo
  }, /*#__PURE__*/React__default.createElement(StyledTableCell$c, {
    component: "th",
    scope: "row"
  }, row.slNo), /*#__PURE__*/React__default.createElement(StyledTableCell$c, null, row.description), /*#__PURE__*/React__default.createElement(StyledTableCell$c, {
    onClick: () => handlePdfDownload$6(row.pdfUrl)
  }, /*#__PURE__*/React__default.createElement(AiFillFilePdf, {
    style: {
      width: '30px',
      height: '30px',
      color: '#f44b55',
      cursor: 'pointer'
    }
  }))))))));
};

const rows$e = [{
  description: "Disaster Management plan",
  pdfUrl: "https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Disaster_Management_plan_1.pdf"
}, {
  description: "Result Framework Document (RFD) for the Year 2015-2016",
  pdfUrl: "https://www.tcp.hp.gov.in/Application/uploadDocuments/content/rfd_15_16.pdf"
}, {
  description: "Status of Annual Confidential reports",
  pdfUrl: "https://www.tcp.hp.gov.in/Application/uploadDocuments/content/jitenpdf.pdf"
}, {
  description: "List of single window system power delegate to Urban Local bodies",
  pdfUrl: "https://tcp.hp.gov.in/Application/uploadDocuments/news/News20160719_105833.pdf"
}, {
  description: "Comparison between notifications dated 28.02.2011 and 13.08.2015 in respect of IDP,Shimla.",
  pdfUrl: "https://tcp.hp.gov.in/Application/uploadDocuments/news/News20150923_162616.pdf"
}, {
  description: "Instruction Regarding Rain Water Harvesting",
  pdfUrl: "https://tcp.hp.gov.in/Application/uploadDocuments/content/Instruction_Regarding_Rain_Water_Harvesting.pdf"
}, {
  description: "Power Delegation from Director to STP",
  pdfUrl: "https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Power_Deligation_from_Director_to_STP.pdf"
}, {
  description: "Innovative Proposals for Award under HP State Innovation Award Scheme for 2015-16",
  pdfUrl: "https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Innovative_Proposals_1.pdf"
}, {
  description: "Ease of doing Business-Online Planning and other permissions by the department of Town and Country Planning.",
  pdfUrl: "https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Ease_of_Doing_2.pdf"
}, {
  description: "Ease of doing business-Risk Bases Classification of Buildings.",
  pdfUrl: "https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Ease_of_Doing_.pdf"
}, {
  description: "Clarification regarding Constitution of District as a Region",
  pdfUrl: "https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Clarification_regarding_Region.pdf"
}, {
  description: "Clarification Regarding Sequences of approval by TCP, PCB and Tourism Department in case of Tourism industry",
  pdfUrl: "https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Instruction_regarding_issuance_of_Consent_to_establish_and_oprate_by_Special_SecyEnvironment.pdf"
}, {
  description: "Revised Policy for Setting up Mobile Communication Tower",
  pdfUrl: "https://www.tcp.hp.gov.in/Application/uploadDocuments/content/Revised_Policy_for_Setting_UP_Mobile_Communication_Towers.pdf"
}, {
  description: "Instruction regarding the Uttar Pradesh Town and Country Planning (Amendment) Rules ,2020",
  pdfUrl: "https://tcp.hp.gov.in/Application/uploadDocuments/content/News20210215_162901.pdf"
}];
const handlePdfDownload$7 = pdfUrl => {
  window.open(pdfUrl);
};
const InstructionOrders = () => {
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(TableContainer$2, {
    component: Paper$2
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h6",
    style: {
      margin: '20px'
    }
  }, "Instructions/Orders"), /*#__PURE__*/React__default.createElement(Table$5, {
    "aria-label": "Sample Table",
    style: {
      width: '90%',
      margin: '30px'
    }
  }, /*#__PURE__*/React__default.createElement(TableBody$2, null, rows$e.map(row => /*#__PURE__*/React__default.createElement(TableRow$2, {
    key: row.slNo
  }, /*#__PURE__*/React__default.createElement(TableCell$2, null, row.description), /*#__PURE__*/React__default.createElement(TableCell$2, {
    onClick: () => handlePdfDownload$7(row.pdfUrl)
  }, /*#__PURE__*/React__default.createElement(AiFillFilePdf, {
    style: {
      width: '30px',
      height: '30px',
      color: '#f44b55',
      cursor: 'pointer'
    }
  }))))))));
};

const TopBarContainer = styled$1("div")({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "22px 20px",
  background: "linear-gradient(135deg, rgb(14, 55, 79) 0%, rgb(21, 108, 156) 100%)",
  boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
  position: "sticky",
  top: 0,
  zIndex: 1001
});
const TopBarLeft = styled$1("div")({
  display: "flex",
  alignItems: "center",
  gap: "20px"
});
const TopBarName = styled$1("div")({
  "& strong": {
    fontSize: "16px",
    color: "#333"
  }
});
const DropdownMenu = styled$1("div")({
  position: "absolute",
  right: "0",
  top: "100%",
  backgroundColor: "#fff",
  border: "1px solid #e0e0e0",
  borderRadius: "4px",
  boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
  zIndex: "1000",
  minWidth: "150px"
});
const DropdownItem = styled$1("div")({
  padding: "8px 16px",
  cursor: "pointer",
  "&:hover": {
    backgroundColor: "#f5f5f5"
  }
});
const TopBarValidity = styled$1("div")({
  "& strong": {
    fontWeight: 800,
    marginRight: "5px",
    color: "#666"
  },
  color: "#666",
  whiteSpace: "normal",
  overflowWrap: "anywhere"
});
const TopBarRight = styled$1("div")({
  display: "flex",
  alignItems: "center",
  gap: "20px"
});
const TopBarIcon = styled$1("div")({
  color: "#6FA2DC",
  fontSize: "18px",
  cursor: "pointer",
  transition: "color 0.2s",
  display: "flex",
  alignItems: "center",
  position: "relative",
  "&:hover": {
    color: "#333"
  }
});
const MenuWrapper$2 = styled$1("div")({
  overflowY: "auto",
  height: "100%",
  "&::-webkit-scrollbar": {
    width: "4px"
  },
  "&::-webkit-scrollbar-track": {
    background: "#f1f1f1"
  },
  "&::-webkit-scrollbar-thumb": {
    background: "#888"
  },
  "&::-webkit-scrollbar-thumb:hover": {
    background: "#555"
  }
});
const SidebarContainer = styled$1("div")(props => ({
  width: props.collapsed ? "0px" : "250px",
  transition: "width 0.3s ease",
  overflow: "hidden",
  height: "100vh",
  boxShadow: "2px 0 5px rgba(0,0,0,0.1)",
  zIndex: 100,
  position: "fixed",
  top: "0px",
  background: "linear-gradient(135deg, #0E374F 0%, #156C9C 100%)"
}));
const SidebarHeader = styled$1("div")({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "8px 12px 8px 6px",
  color: "#fff",
  borderBottom: "1px solid rgb(221, 221, 221)",
  background: "linear-gradient(311deg, rgb(14, 55, 79) 0%, rgb(21, 108, 156) 100%)"
});
const HeaderTitle$3 = styled$1("h3")({
  margin: 0,
  fontWeight: "bold",
  fontSize: "1rem"
});
const HamburgerIcon = styled$1(FaBars)({
  cursor: "pointer",
  fontSize: "1rem"
});
const MenuItem$3 = styled$1("div")({
  color: "#fff",
  padding: "0.75rem 1rem",
  fontSize: ".9rem",
  margin: "0.25rem 0",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  cursor: "pointer",
  fontWeight: "bold"
});
const SubMenuItem = styled$1("div")({
  padding: "0.5rem 1rem 0.5rem 2rem",
  color: "#fff",
  fontSize: "0.75rem",
  cursor: "pointer",
  display: "flex",
  justifyContent: "space-between",
  "&:not(:last-child)": {
    borderBottom: "1px solid rgba(0,0,0,0.1)"
  }
});
const NestedSubMenuItem = styled$1("div")({
  padding: "0.5rem 1rem 0.5rem 2rem",
  color: "#fff",
  fontSize: "0.75rem",
  cursor: "pointer",
  display: "flex",
  justifyContent: "space-between",
  "&:not(:last-child)": {
    borderBottom: "1px solid rgba(0,0,0,0.1)"
  }
});
const CopyIcon = styled$1(FaCopy)({
  cursor: "pointer",
  fontSize: "0.9rem"
});
const DashboardLayout = styled$1("div")(({
  isObpsRoute
}) => ({
  display: "flex",
  minHeight: "100vh",
  width: "100%"
}));
const MainContent = styled$1("div")(props => ({
  flex: 1,
  display: "flex",
  flexDirection: "column",
  width: "75%",
  minHeight: "100vh",
  paddingLeft: props.collapsed ? "0px" : "250px"
}));
const MenuItemTitle = styled$1("span")({
  fontWeight: "normal"
});
const FileInfoStrip = styled$1("div")({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "10px 20px",
  backgroundColor: "#fff",
  boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
  borderRadius: "4px",
  margin: "8px 0",
  position: "sticky",
  top: 40,
  zIndex: 1000
});
const FileNo = styled$1("span")({
  flex: 1,
  textAlign: "left"
});
const RiskType = styled$1("span")(props => ({
  textAlign: "center",
  fontWeight: "bold",
  color: props.riskType === "High Risk" ? "#d32f2f" : "#388e3c",
  padding: "4px 8px",
  borderRadius: "6px"
}));
const Status = styled$1("span")(props => ({
  textAlign: "center",
  backgroundColor: "#4caf50",
  color: "white",
  padding: "4px 8px",
  borderRadius: "6px",
  fontSize: "0.8rem"
}));
const Owner = styled$1("div")({
  flex: 1,
  textAlign: "right",
  fontWeight: "bold"
});
const AuthInfoStrip = styled$1("div")({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "10px 20px",
  backgroundColor: "#fff",
  boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
  borderRadius: "4px",
  margin: "8px 0"
});
const AuthorityName = styled$1("span")({
  flex: 1,
  textAlign: "left",
  fontWeight: "500"
});
const InfoText = styled$1("span")({
  flex: 1,
  textAlign: "center",
  color: "red",
  fontStyle: "italic"
});
const ActionButton = styled$1("button")({
  backgroundColor: "#2862A4",
  color: "white",
  border: "none",
  borderRadius: "4px",
  padding: "8px 16px",
  margin: "0 4px",
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  gap: "8px",
  "&:hover": {
    backgroundColor: "#1e4a7e"
  }
});
const PortalWrapper$1 = styled$1("div")(() => ({
  boxSizing: "border-box"
}));
const NotificationBadge = styled$1("span")(() => ({
  position: "absolute",
  top: "-4px",
  right: "-4px",
  backgroundColor: "rgb(235, 46, 46)",
  color: "#fff",
  borderRadius: "50%",
  width: "15px",
  height: "15px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "10px",
  fontWeight: "bold"
}));

const flags = {
  edcr: process.env.REACT_APP_ENABLE_EDCR === "true",
  selfCert: process.env.REACT_APP_ENABLE_SELF_CERT === "true",
  selfApproval: process.env.REACT_APP_ENABLE_SELF_APPROVAL === "true",
  selfApprovalScheme: process.env.REACT_APP_ENABLE_SELF_APPROVAL_SCHEME === "true",
  selfApprovalNonScheme: process.env.REACT_APP_ENABLE_SELF_APPROVAL_NON_SCHEME === "true",
  revalidation: process.env.REACT_APP_ENABLE_REVALIDATION === "true",
  groupHousing: process.env.REACT_APP_ENABLE_GROUP_HOUSING === "true",
  plinth: process.env.REACT_APP_ENABLE_PLINTH === "true",
  landUseConversion: process.env.REACT_APP_ENABLE_LANDUSE_CONVERSION === "true",
  workCommencement: process.env.REACT_APP_ENABLE_WORK_COMMENCEMENT === "true",
  purchasableFar: process.env.REACT_APP_ENABLE_PURCHASABLE_FAR === "true",
  completion: process.env.REACT_APP_ENABLE_COMPLETION === "true",
  compounding: process.env.REACT_APP_ENABLE_COMPOUNDING === "true"
};

dayjs.extend(customParseFormat);
const Sidebar = ({
  userDetails,
  toggleSidebar,
  collapsed
}) => {
  var _userInfo$info, _userInfo$info$roles;
  const {
    t
  } = useTranslation();
  const [expandedItems, setExpandedItems] = useState({});
  const [expandedSubItems, setExpandedSubItems] = useState({});
  const [showPopup, setShowPopup] = useState(false);
  const history = useHistory();
  const userInfo = Digit.UserService.getUser();
  const userRoles = userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info = userInfo.info) === null || _userInfo$info === void 0 ? void 0 : (_userInfo$info$roles = _userInfo$info.roles) === null || _userInfo$info$roles === void 0 ? void 0 : _userInfo$info$roles.map(e => e.code);
  const userDetail = Digit.SessionStorage.get("USER_DETAIL") || userDetails;
  const [isValidityExpired, setIsValidityExpired] = useState(null);
  const [isValidityNull, setIsValidityNull] = useState(null);
  const [pendingNavigation, setPendingNavigation] = useState(null);
  const styles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      background: "rgba(0,0,0,0.3)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 9999
    },
    noticeBox: {
      background: "#fff",
      padding: "25px 30px",
      borderRadius: "10px",
      width: "380px",
      textAlign: "center",
      boxShadow: "0 6px 20px rgba(0,0,0,0.2)",
      borderTop: "5px solid #ff9800"
    },
    title: {
      fontSize: "18px",
      fontWeight: "600",
      marginBottom: "10px"
    },
    message: {
      fontSize: "14px",
      color: "#444",
      marginBottom: "20px"
    },
    button: {
      padding: "8px 20px",
      background: "#ff9800",
      color: "#fff",
      border: "none",
      borderRadius: "5px",
      cursor: "pointer",
      fontWeight: "500"
    }
  };
  useEffect(() => {
    if (!userDetail) return;
    if (!(userDetail !== null && userDetail !== void 0 && userDetail.validUpto)) {
      setIsValidityNull(true);
      setIsValidityExpired(true);
      return;
    }
    const validUpto = dayjs(userDetail === null || userDetail === void 0 ? void 0 : userDetail.validUpto, "DD-MM-YYYY HH:mm:ss");
    const now = dayjs();
    const expired = validUpto.isBefore(now);
    setIsValidityExpired(expired);
  }, [userDetail]);
  const isLtp = (userRoles === null || userRoles === void 0 ? void 0 : userRoles.some(role => !["OWNER", "EMPLOYEE"].includes(role))) && !isValidityExpired && (userRoles === null || userRoles === void 0 ? void 0 : userRoles.length) > 2;
  const expiredLTP = (userRoles === null || userRoles === void 0 ? void 0 : userRoles.some(role => !["OWNER", "EMPLOYEE"].includes(role))) && isValidityExpired;
  const isOwner = (userRoles === null || userRoles === void 0 ? void 0 : userRoles.includes("OWNER")) && !isLtp;
  const isCitizen = (userRoles === null || userRoles === void 0 ? void 0 : userRoles.includes("LTP")) && !isLtp;
  const fileCount = Digit.SessionStorage.get("FILE_COUNT") || "---";
  const toggleItem = item => {
    setExpandedItems(prev => ({
      ...prev,
      [item]: !prev[item]
    }));
  };
  const toggleSubItem = (parentTitle, subItemName) => {
    setExpandedSubItems(prev => ({
      ...prev,
      [`${parentTitle}-${subItemName}`]: !prev[`${parentTitle}-${subItemName}`]
    }));
  };
  const handleNavigation = (path, state = {}, keysToRemove = []) => {
    if (path.includes("/obps/services/")) {
      var _Digit;
      Digit.SessionStorage.del("CITIZEN.COMMON.HOME.FLOW");
      (_Digit = Digit) === null || _Digit === void 0 ? void 0 : _Digit.SessionStorage.del("LTP.SCRUTINY.SELECTION");
    }
    if (keysToRemove.length > 0) {
      keysToRemove.forEach(key => {
        Digit.SessionStorage.del(key);
      });
    }
    history.push(path, state);
  };
  const allMenuItems = [{
    title: `${t("FASTPAS.FILES.RECEIVED.TEXT")} (${fileCount})`,
    path: `${citizenBaseUrl$1}/profile`
  }, {
    title: t("FASTPAS.GLOBAL.LTP.TEXT"),
    subItems: [{
      name: isValidityNull ? t("FASTPAS.GLOBAL.APPLY.TEXT") : isValidityExpired ? "Reapply" : t("FASTPAS.GLOBAL.APPLY.TEXT"),
      path: `${citizenBaseUrl$1}/obps/services/ltpPortal`
    }, {
      name: t("FASTPAS.GLOBAL.MY.APPLICATION.TEXT"),
      path: `${citizenBaseUrl$1}/obps/formProfessionalApplications`
    }]
  }, {
    title: t("FASTPAS.GLOBAL.LAND.USE.VER.TEXT"),
    subItems: [{
      name: t("FASTPAS.GLOBAL.APPLY.TEXT"),
      path: `${citizenBaseUrl$1}/obps/services/formLandUse`
    }, {
      name: t('FASTPAS.GLOBAL.APPLY.OLD.CASE.TEXT'),
      path: `${citizenBaseUrl$1}/obps/services/oldCaseSearchLU`
    }, {
      name: t("FASTPAS.GLOBAL.MY.APPLICATION.TEXT"),
      path: `${citizenBaseUrl$1}/obps/formLandUseApplications`
    }]
  }, {
    title: t("FASTPAS.GLOBAL.MAP.SUBMISSION.TEXT"),
    subItems: [{
      name: t("FASTPAS.GLOBAL.APPLY.TEXT"),
      subItems: [flags.edcr && {
        name: t('FASTPAS.GLOBAL.MAP.SUBMISSION.TEXT'),
        path: `${citizenBaseUrl$1}/obps/services/groupHousingPortal`
      }, flags.selfCert && {
        name: "Self Certification via Registration (Residential-upto 100 Sqm & Commercial-upto 30 Sqm)",
        path: `${citizenBaseUrl$1}/obps/services/selfResidentialPortal`
      }, flags.selfApproval && {
        name: "Self Approval via LTP",
        subItems: [flags.selfApprovalScheme && {
          name: "Scheme Residential upto 500 Sqmt & Commercial upto 200 Sqmt.",
          path: `${citizenBaseUrl$1}/obps/services/selfApprovalPortal`
        }, flags.selfApprovalNonScheme && {
          name: "Non-Scheme Residential upto 300 Sqmt.",
          path: `${citizenBaseUrl$1}/obps/services/selfApprovalPortal`
        }].filter(Boolean)
      }].filter(Boolean)
    }, {
      name: t("FASTPAS.GLOBAL.MY.APPLICATION.TEXT"),
      path: `${citizenBaseUrl$1}/obps/mapSubApplications`
    }, {
      name: t("FASTPAS.GLOBAL.COMPOUNDING.APP.TEXT"),
      path: `${citizenBaseUrl$1}/obps/compoundingApplications`
    }]
  }, flags.plinth && {
    title: t('FASTPAS.GLOBAL.PLINTH.SUB.TEXT'),
    subItems: [{
      name: t("FASTPAS.GLOBAL.APPLY.TEXT"),
      path: `${citizenBaseUrl$1}/obps/services/plinthPortal`
    }, {
      name: t("FASTPAS.GLOBAL.MY.APPLICATION.TEXT"),
      path: `${citizenBaseUrl$1}/obps/plinthApplications`
    }]
  }, flags.landUseConversion && {
    title: t("FASTPAS.GLOBAL.LAND.USE.TEXT"),
    subItems: [{
      name: t("FASTPAS.GLOBAL.INV.SUGG.OBJ.TEXT"),
      path: `${citizenBaseUrl$1}/obps/services/formSuggestion`
    }, {
      name: t("FASTPAS.GLOBAL.MY.APPLICATION.TEXT"),
      path: `${citizenBaseUrl$1}/obps/formLandUseConversionApplications`
    }, {
      name: t("FASTPAS.GLOBAL.MY.SUG.APP.TEXT"),
      path: `${citizenBaseUrl$1}/obps/formSuggestionApplications`
    }]
  }, flags.workCommencement && {
    title: t("FASTPAS.GLOBAL.WORK.COM.TEXT"),
    subItems: [{
      name: t("FASTPAS.GLOBAL.APPLY.TEXT"),
      path: `${citizenBaseUrl$1}/obps/services/WorkCommencementModule`
    }, {
      name: t("FASTPAS.GLOBAL.MY.APPLICATION.TEXT"),
      path: `${citizenBaseUrl$1}/obps/WorkCommencementModule`
    }]
  }, flags.completion && {
    title: t("FASTPAS.GLOBAL.COMPLETITION.MODULE.TEXT"),
    subItems: [{
      name: t("FASTPAS.GLOBAL.APPLY.TEXT"),
      path: `${citizenBaseUrl$1}/obps/services/completionPortal`
    }, {
      name: t("FASTPAS.GLOBAL.MY.APPLICATION.TEXT"),
      path: `${citizenBaseUrl$1}/obps/completionApplications`
    }]
  }, flags.purchasableFar && {
    title: t("FASTPAS.GLOBAL.PUR.FAR.MODULE.TEXT"),
    subItems: [{
      name: t("FASTPAS.GLOBAL.APPLY.TEXT"),
      path: `${citizenBaseUrl$1}/obps/services/purchasablePortal`
    }, {
      name: t("FASTPAS.GLOBAL.MY.APPLICATION.TEXT"),
      path: `${citizenBaseUrl$1}/obps/pFARApplications`
    }]
  }, {
    title: t("FASTPAS.GLOBAL.MAKEPAYMENT.TEXT"),
    path: `${citizenBaseUrl$1}/obps/Payment/Applications`
  }].filter(Boolean);
  let menuItems = [];
  if (isCitizen) {
    menuItems = allMenuItems.filter(item => item.title === t("FASTPAS.GLOBAL.LTP.TEXT"));
  } else if (isOwner) {
    menuItems = allMenuItems.map(item => {
      var _item$subItems2;
      if (item.title === t("FASTPAS.GLOBAL.LTP.TEXT") || item.title === t("FASTPAS.GLOBAL.LAND.USE.VER.TEXT") || item.title === t("FASTPAS.GLOBAL.LAND.USE.TEXT")) {
        return item;
      }
      if (item.title === t("FASTPAS.GLOBAL.MAP.SUBMISSION.TEXT")) {
        var _item$subItems;
        return {
          ...item,
          subItems: item === null || item === void 0 ? void 0 : (_item$subItems = item.subItems) === null || _item$subItems === void 0 ? void 0 : _item$subItems.map(subItem => {
            if (subItem.name === t("FASTPAS.GLOBAL.APPLY.TEXT") && subItem.subItems) {
              var _subItem$subItems;
              return {
                ...subItem,
                subItems: subItem === null || subItem === void 0 ? void 0 : (_subItem$subItems = subItem.subItems) === null || _subItem$subItems === void 0 ? void 0 : _subItem$subItems.filter(nested => {
                  var _nested$name;
                  return nested === null || nested === void 0 ? void 0 : (_nested$name = nested.name) === null || _nested$name === void 0 ? void 0 : _nested$name.includes("Self Certification via Registration");
                })
              };
            }
            return subItem;
          })
        };
      }
      return {
        ...item,
        subItems: item === null || item === void 0 ? void 0 : (_item$subItems2 = item.subItems) === null || _item$subItems2 === void 0 ? void 0 : _item$subItems2.filter(subItem => subItem.name !== t("FASTPAS.GLOBAL.APPLY.TEXT"))
      };
    });
  } else if (isLtp) {
    menuItems = allMenuItems.map(item => {
      if (item.title === t("FASTPAS.GLOBAL.LTP.TEXT")) {
        var _item$subItems3;
        return {
          ...item,
          subItems: item === null || item === void 0 ? void 0 : (_item$subItems3 = item.subItems) === null || _item$subItems3 === void 0 ? void 0 : _item$subItems3.filter(subItem => subItem.name !== t("FASTPAS.GLOBAL.APPLY.TEXT"))
        };
      }
      if (item.title === t("FASTPAS.GLOBAL.MAP.SUBMISSION.TEXT")) {
        return {
          ...item,
          subItems: item.subItems.map(menu => {
            if (menu.name === t("FASTPAS.GLOBAL.APPLY.TEXT")) {
              return {
                ...menu,
                subItems: menu.subItems.filter(subItem => subItem.name !== "Self Certification via Registration (Residential-upto 100 Sqm & Commercial-upto 30 Sqm)")
              };
            }
            return menu;
          })
        };
      }
      return item;
    });
  } else if (expiredLTP) {
    menuItems = allMenuItems.filter(item => item.title === t("FASTPAS.GLOBAL.LTP.TEXT"));
  } else {
    menuItems = allMenuItems;
  }
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(SidebarContainer, {
    collapsed: collapsed
  }, /*#__PURE__*/React__default.createElement(SidebarHeader, null, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center"
    }
  }, /*#__PURE__*/React__default.createElement("img", {
    className: "sidebr-logo mr-3",
    src: "https://cdn.s3waas.gov.in/s3310dcbbf4cce62f762a2aaa148d556bd/uploads/2018/02/2018022129.png"
  }), /*#__PURE__*/React__default.createElement(HeaderTitle$3, null, "FASTPAS")), /*#__PURE__*/React__default.createElement(HamburgerIcon, {
    onClick: toggleSidebar
  })), /*#__PURE__*/React__default.createElement(MenuWrapper$2, {
    collapsed: collapsed,
    className: "all-menu-wrapper"
  }, menuItems.map(item => /*#__PURE__*/React__default.createElement("div", {
    key: item.title,
    className: history.location.pathname === item.path ? "single-node active" : "single-node"
  }, item.subItems ?
  /*#__PURE__*/
  React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(MenuItem$3, {
    onClick: () => toggleItem(item.title)
  }, /*#__PURE__*/React__default.createElement(MenuItemTitle, null, item.title), /*#__PURE__*/React__default.createElement("div", null, expandedItems[item.title] ? /*#__PURE__*/React__default.createElement(FaChevronUp, null) : /*#__PURE__*/React__default.createElement(FaChevronDown, null))), expandedItems[item.title] && /*#__PURE__*/React__default.createElement("div", null, item.subItems.map(subItem => /*#__PURE__*/React__default.createElement(React__default.Fragment, {
    key: subItem.name
  }, subItem.subItems ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(SubMenuItem, {
    onClick: e => {
      e.stopPropagation();
      toggleSubItem(item.title, subItem.name);
    }
  }, /*#__PURE__*/React__default.createElement("span", null, subItem.name), /*#__PURE__*/React__default.createElement("div", null, expandedSubItems[`${item.title}-${subItem.name}`] ? /*#__PURE__*/React__default.createElement(FaChevronUp, null) : /*#__PURE__*/React__default.createElement(FaChevronDown, null))), expandedSubItems[`${item.title}-${subItem.name}`] && /*#__PURE__*/React__default.createElement("div", null, subItem.subItems.map(nestedSubItem => /*#__PURE__*/React__default.createElement(React__default.Fragment, {
    key: nestedSubItem.name
  }, nestedSubItem.subItems ?
  /*#__PURE__*/
  React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(NestedSubMenuItem, {
    onClick: e => {
      e.stopPropagation();
      toggleSubItem(`${item.title}-${subItem.name}`, nestedSubItem.name);
    }
  }, /*#__PURE__*/React__default.createElement("span", null, nestedSubItem.name), /*#__PURE__*/React__default.createElement("div", null, expandedSubItems[`${item.title}-${subItem.name}-${nestedSubItem.name}`] ? /*#__PURE__*/React__default.createElement(FaChevronUp, null) : /*#__PURE__*/React__default.createElement(FaChevronDown, null))), expandedSubItems[`${item.title}-${subItem.name}-${nestedSubItem.name}`] && /*#__PURE__*/React__default.createElement("div", null, nestedSubItem.subItems.map(deeperNestedSubItem => /*#__PURE__*/React__default.createElement(NestedSubMenuItem, {
    key: deeperNestedSubItem.name,
    onClick: e => {
      e.stopPropagation();
      const keysToRemove = deeperNestedSubItem.name.includes("Scheme") ? ["OWNER_INFO", "FASTPAS_ID", "FILE_NO"] : [];
      handleNavigation(deeperNestedSubItem.path, {}, keysToRemove);
    },
    className: history.location.pathname === deeperNestedSubItem.path ? "submenu-item-active nested-single-menus" : "nested-single-menus",
    active: history.location.pathname === deeperNestedSubItem.path
  }, /*#__PURE__*/React__default.createElement("span", null, deeperNestedSubItem.name))))) :
  /*#__PURE__*/
  React__default.createElement(NestedSubMenuItem, {
    onClick: e => {
      e.stopPropagation();
      handleNavigation(nestedSubItem.path);
    },
    className: history.location.pathname === nestedSubItem.path ? "submenu-item-active nested-single-menus" : "nested-single-menus",
    active: history.location.pathname === nestedSubItem.path
  }, /*#__PURE__*/React__default.createElement("span", null, nestedSubItem.name)))))) : /*#__PURE__*/React__default.createElement(SubMenuItem, {
    onClick: e => {
      e.stopPropagation();
      const isLandUseApply = item.title === t("FASTPAS.GLOBAL.LAND.USE.VER.TEXT") && subItem.name === t("FASTPAS.GLOBAL.APPLY.TEXT");
      if (isOwner && isLandUseApply) {
        setPendingNavigation({
          path: subItem.path,
          state: {},
          keysToRemove: ["FORMLANDUSE"]
        });
        setShowPopup(true);
        return;
      }
      const keysToRemove = isLandUseApply ? ["FORMLANDUSE"] : [];
      if (subItem.name === "Reapply") {
        handleNavigation(subItem.path, {
          reapply: true
        }, keysToRemove);
      } else {
        handleNavigation(subItem.path, {}, keysToRemove);
      }
    }
  }, /*#__PURE__*/React__default.createElement("span", null, subItem.name)))))) :
  /*#__PURE__*/
  React__default.createElement(MenuItem$3, {
    onClick: () => handleNavigation(item.path),
    className: history.location.pathname === item.path ? "submenu-item-active nested-single-menus" : "nested-single-menus",
    active: history.location.pathname === item.path
  }, /*#__PURE__*/React__default.createElement(MenuItemTitle, null, item.title)))))), showPopup && /*#__PURE__*/React__default.createElement("div", {
    style: styles.overlay
  }, /*#__PURE__*/React__default.createElement("div", {
    style: styles.noticeBox
  }, /*#__PURE__*/React__default.createElement("div", {
    style: styles.title
  }, "Notice"), /*#__PURE__*/React__default.createElement("div", {
    style: styles.message
  }, "This land use verification is not applicable for map submission."), /*#__PURE__*/React__default.createElement("button", {
    style: styles.button,
    onClick: () => {
      setShowPopup(false);
      if (pendingNavigation) {
        handleNavigation(pendingNavigation.path, pendingNavigation.state, pendingNavigation.keysToRemove);
        setPendingNavigation(null);
      }
    }
  }, "OK"))));
};

const TopBar$3 = ({
  userDetails,
  applicationDetail,
  toggleSidebar,
  collapsed
}) => {
  var _applicationDetail$la, _applicationDetail$la2, _applicationDetail$la3, _applicationDetail$la4, _applicationDetail$la5, _applicationDetail$la6, _applicationDetail$la7, _applicationDetail$la8, _applicationDetail$la9, _applicationDetail$la10, _applicationDetail$la11, _applicationDetail$la12;
  const stateId = Digit.ULBService.getStateId();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [count, setCount] = useState(0);
  const dropdownRef = useRef(null);
  const history = useHistory();
  const ownerName = Digit.SessionStorage.get("OWNER_INFO");
  const {
    t
  } = useTranslation();
  useEffect(() => {
    const handleClickOutside = event => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const handleEditProfile = () => {
    history.push("/digit-ui/citizen/user/account");
    setIsDropdownOpen(false);
  };
  const handleDashboard = () => {
    history.push("/digit-ui/citizen/profile");
    setIsDropdownOpen(false);
  };
  const filters = {
    tenantId: stateId,
    processSearchCriteria: {
      moduleName: "bpa-services",
      businessService: ["BPA_LANDUSE_DA", "BPA_FAR_DA", "BPA_MAPSUB_DA"]
    },
    moduleSearchCriteria: {
      sortBy: "applicationDate",
      sortOrder: "ASC"
    },
    limit: 2999,
    offset: 0
  };
  const handleLogout = () => {
    Digit.UserService.logout();
    setIsDropdownOpen(false);
  };
  useEffect(() => {
    const fetchAndSetUserDetails = async () => {
      try {
        var _inboxData$statusMap;
        const inboxData = await InboxGeneral.Search({
          inbox: {
            ...filters
          }
        });
        console.log(inboxData, "inboxData");
        const filteredData = inboxData === null || inboxData === void 0 ? void 0 : (_inboxData$statusMap = inboxData.statusMap) === null || _inboxData$statusMap === void 0 ? void 0 : _inboxData$statusMap.filter(item => item.applicationstatus === "UPLOAD_DOC" || item.applicationstatus === "REVERT_TO_APPLICANT");
        const inboxCount = filteredData === null || filteredData === void 0 ? void 0 : filteredData.reduce((acc, item) => acc + ((item === null || item === void 0 ? void 0 : item.count) || 0), 0);
        console.log({
          inboxCount,
          filteredData
        }, "inboxxx");
        setCount(inboxCount);
      } catch (error) {
        console.error("Error fetching notifications:", error);
        setCount(0);
      }
    };
    fetchAndSetUserDetails();
  }, []);
  return /*#__PURE__*/React__default.createElement(TopBarContainer, null, /*#__PURE__*/React__default.createElement(TopBarLeft, null, /*#__PURE__*/React__default.createElement(TopBarIcon, {
    as: collapsed ? ArrowForwardIos : ArrowBackIos,
    title: "Back",
    onClick: toggleSidebar,
    style: {
      color: "white"
    }
  }), /*#__PURE__*/React__default.createElement(TopBarName, {
    className: "text-white"
  }, ((applicationDetail === null || applicationDetail === void 0 ? void 0 : (_applicationDetail$la = applicationDetail.landInfo) === null || _applicationDetail$la === void 0 ? void 0 : (_applicationDetail$la2 = _applicationDetail$la.owners) === null || _applicationDetail$la2 === void 0 ? void 0 : (_applicationDetail$la3 = _applicationDetail$la2[0]) === null || _applicationDetail$la3 === void 0 ? void 0 : _applicationDetail$la3.name) || ownerName) && "Owner:"), /*#__PURE__*/React__default.createElement(TopBarValidity, {
    className: "text-white"
  }, (applicationDetail === null || applicationDetail === void 0 ? void 0 : (_applicationDetail$la4 = applicationDetail.landInfo) === null || _applicationDetail$la4 === void 0 ? void 0 : (_applicationDetail$la5 = _applicationDetail$la4.owners) === null || _applicationDetail$la5 === void 0 ? void 0 : (_applicationDetail$la6 = _applicationDetail$la5[0]) === null || _applicationDetail$la6 === void 0 ? void 0 : _applicationDetail$la6.name) || ownerName), /*#__PURE__*/React__default.createElement(TopBarName, {
    className: "text-white"
  }, (applicationDetail === null || applicationDetail === void 0 ? void 0 : (_applicationDetail$la7 = applicationDetail.landInfo) === null || _applicationDetail$la7 === void 0 ? void 0 : (_applicationDetail$la8 = _applicationDetail$la7.owners) === null || _applicationDetail$la8 === void 0 ? void 0 : (_applicationDetail$la9 = _applicationDetail$la8[0]) === null || _applicationDetail$la9 === void 0 ? void 0 : _applicationDetail$la9.mobileNumber) && "Mobile No:"), /*#__PURE__*/React__default.createElement(TopBarValidity, {
    className: "text-white"
  }, applicationDetail === null || applicationDetail === void 0 ? void 0 : (_applicationDetail$la10 = applicationDetail.landInfo) === null || _applicationDetail$la10 === void 0 ? void 0 : (_applicationDetail$la11 = _applicationDetail$la10.owners) === null || _applicationDetail$la11 === void 0 ? void 0 : (_applicationDetail$la12 = _applicationDetail$la11[0]) === null || _applicationDetail$la12 === void 0 ? void 0 : _applicationDetail$la12.mobileNumber), (applicationDetail === null || applicationDetail === void 0 ? void 0 : applicationDetail.land_Id) && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("span", {
    className: "text-white"
  }, "FASTPAS ID: "), /*#__PURE__*/React__default.createElement("span", {
    className: "text-white"
  }, applicationDetail.land_Id))), /*#__PURE__*/React__default.createElement(TopBarRight, {
    className: "top-right-icon-sec"
  }, /*#__PURE__*/React__default.createElement(TopBarIcon, {
    as: Fullscreen,
    title: "Fullscreen",
    onClick: () => {
      if (document.fullscreenElement) {
        document.exitFullscreen();
      } else {
        document.documentElement.requestFullscreen();
      }
    }
  }), /*#__PURE__*/React__default.createElement(TopBarIcon, {
    as: FaQuestionCircle,
    title: "Helpdesk",
    onClick: () => window.open("https://mainet.abmindia.com/training/", "_blank", "noopener,noreferrer")
  }), /*#__PURE__*/React__default.createElement("div", {
    ref: dropdownRef,
    style: {
      position: "relative"
    }
  }, /*#__PURE__*/React__default.createElement(TopBarIcon, {
    as: FaUser,
    title: "User",
    onClick: () => setIsDropdownOpen(!isDropdownOpen)
  }), isDropdownOpen && /*#__PURE__*/React__default.createElement(DropdownMenu, null, /*#__PURE__*/React__default.createElement(DropdownItem, {
    onClick: handleDashboard
  }, t("FASTPAS.DASHBOARD.MAIN.TEXT")), /*#__PURE__*/React__default.createElement(DropdownItem, {
    onClick: handleEditProfile
  }, "Edit Profile"), /*#__PURE__*/React__default.createElement(DropdownItem, {
    onClick: handleLogout
  }, "Logout")))));
};

const StyledTableCell$d = styled$1(TableCell)(({
  theme
}) => ({
  fontWeight: "bold",
  backgroundColor: "#1f4a7c",
  color: theme.palette.common.white,
  "& .MuiTableSortLabel-root": {
    color: "white",
    "&:hover": {
      color: "white"
    },
    "&.Mui-active": {
      color: "white"
    }
  },
  "& .MuiInput-root": {
    "&:before": {
      borderBottomColor: "rgba(255, 255, 255, 0.42)"
    },
    "&:hover:not(.Mui-disabled):before": {
      borderBottomColor: "white"
    },
    "&:after": {
      borderBottomColor: "white"
    },
    "& input": {
      color: "white",
      "&::placeholder": {
        color: "rgba(255, 255, 255, 0.7)"
      }
    }
  },
  "& .MuiSvgIcon-root": {
    color: "white"
  }
}));
const StyledTableRow$d = styled$1(TableRow)(({
  theme
}) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover
  },
  "&:last-child td, &:last-child th": {
    border: 0
  }
}));
const SmallTableCell = styled$1(TableCell)({
  fontSize: "0.75rem",
  padding: "8px 12px"
});
const getApplicationUrl = applicationNo => {
  if (!applicationNo) return "#";
  const parts = applicationNo.split("/");
  const typeCode = parts[2];
  switch (typeCode) {
    case "MS":
      return `/digit-ui/citizen/obps/structuralform12/${applicationNo}`;
    case "LU":
      return `/digit-ui/citizen/obps/structural/formLandUse/${applicationNo}`;
    case "PF":
      return `/digit-ui/citizen/obps/structuralform12/${applicationNo}`;
    case "CC":
      return `/digit-ui/citizen/obps/structuralform12/${applicationNo}`;
    default:
      return "#";
  }
};
const EnhancedTable = ({
  data,
  isLoading,
  tenantId
}) => {
  const {
    t
  } = useTranslation();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [globalSearch, setGlobalSearch] = useState("");
  const [orderBy, setOrderBy] = useState("applicationDate");
  const [order, setOrder] = useState("desc");
  const [filters, setFilters] = useState({
    name: "",
    architect: "",
    plotArea: "",
    mobileNumber: "",
    applicationNo: "",
    applicationType: "",
    status: "",
    date: "",
    schemeName: ""
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedColumns, setSelectedColumns] = useState(["srNo", "name", "mobileNumber", "applicationNo", "applicationType", "applicationDate", "status"]);
  useEffect(() => {
    Digit.SessionStorage.del("OWNER_INFO");
    Digit.SessionStorage.del("FASTPAS_ID");
    Digit.SessionStorage.del("FILE_NO");
    Digit.SessionStorage.del("EDCR_CREATE");
    Digit.SessionStorage.del("FORM_MAP_SUBMISSION");
    Digit.SessionStorage.del("FORM_SELF_RESIDENTIAL");
    Digit.SessionStorage.del("SELF_CURRENT_TAB");
    Digit.SessionStorage.del("FORM_KYP");
    Digit.SessionStorage.del("FORM_SELF_APPROVAL");
    if ((data === null || data === void 0 ? void 0 : data.length) > 0) {
      Digit.SessionStorage.set("FILE_COUNT", data === null || data === void 0 ? void 0 : data.length);
    }
  }, []);
  const allColumns = [{
    id: "srNo",
    label: "Sr No",
    filterable: false,
    sortable: false,
    render: (item, index) => page * rowsPerPage + index + 1,
    width: "5%"
  }, {
    id: "name",
    label: "Name",
    filterable: true,
    sortable: true,
    render: item => {
      var _item$landInfo, _item$landInfo$owners, _item$landInfo$owners2;
      return (item === null || item === void 0 ? void 0 : (_item$landInfo = item.landInfo) === null || _item$landInfo === void 0 ? void 0 : (_item$landInfo$owners = _item$landInfo.owners) === null || _item$landInfo$owners === void 0 ? void 0 : (_item$landInfo$owners2 = _item$landInfo$owners[0]) === null || _item$landInfo$owners2 === void 0 ? void 0 : _item$landInfo$owners2.name) || "-";
    },
    width: "12%"
  }, {
    id: "mobileNumber",
    label: "Mobile No.",
    filterable: true,
    sortable: true,
    render: item => {
      var _item$landInfo2, _item$landInfo2$owner, _item$landInfo2$owner2;
      return (item === null || item === void 0 ? void 0 : (_item$landInfo2 = item.landInfo) === null || _item$landInfo2 === void 0 ? void 0 : (_item$landInfo2$owner = _item$landInfo2.owners) === null || _item$landInfo2$owner === void 0 ? void 0 : (_item$landInfo2$owner2 = _item$landInfo2$owner[0]) === null || _item$landInfo2$owner2 === void 0 ? void 0 : _item$landInfo2$owner2.mobileNumber) || "-";
    },
    width: "10%"
  }, {
    id: "applicationNo",
    label: "Application No.",
    filterable: true,
    sortable: true,
    render: item => /*#__PURE__*/React__default.createElement("strong", {
      onClick: e => {
        var _item$landInfo3, _item$landInfo3$owner, _item$landInfo3$owner2;
        e.preventDefault();
        window.location.href = getApplicationUrl(item === null || item === void 0 ? void 0 : item.applicationNo);
        Digit.SessionStorage.set("OWNER_INFO", item === null || item === void 0 ? void 0 : (_item$landInfo3 = item.landInfo) === null || _item$landInfo3 === void 0 ? void 0 : (_item$landInfo3$owner = _item$landInfo3.owners) === null || _item$landInfo3$owner === void 0 ? void 0 : (_item$landInfo3$owner2 = _item$landInfo3$owner[0]) === null || _item$landInfo3$owner2 === void 0 ? void 0 : _item$landInfo3$owner2.name);
        Digit.SessionStorage.set("FASTPAS_ID", item);
        Digit.SessionStorage.set("FILE_NO", item === null || item === void 0 ? void 0 : item.applicationNo);
      },
      style: {
        color: "#007bff",
        textDecoration: "none",
        cursor: "pointer"
      }
    }, (item === null || item === void 0 ? void 0 : item.applicationNo) || "-"),
    width: "10%"
  }, {
    id: "applicationType",
    label: "Application Type",
    filterable: true,
    sortable: true,
    render: item => t(item === null || item === void 0 ? void 0 : item.applicationType) || "-",
    width: "10%"
  }, {
    id: "applicationDate",
    label: "Date",
    filterable: false,
    sortable: true,
    render: item => {
      var _item$auditDetails;
      return convertEpochToDateDMY(item === null || item === void 0 ? void 0 : (_item$auditDetails = item.auditDetails) === null || _item$auditDetails === void 0 ? void 0 : _item$auditDetails.createdTime) || "-";
    },
    width: "10%"
  }, {
    id: "status",
    label: "Status",
    filterable: true,
    sortable: true,
    render: item => {
      var _item$assignes, _item$assignes$, _item$assignes$$roles, _item$assignes$$roles2, _item$assignes2;
      const role = item === null || item === void 0 ? void 0 : (_item$assignes = item.assignes) === null || _item$assignes === void 0 ? void 0 : (_item$assignes$ = _item$assignes[0]) === null || _item$assignes$ === void 0 ? void 0 : (_item$assignes$$roles = _item$assignes$.roles) === null || _item$assignes$$roles === void 0 ? void 0 : (_item$assignes$$roles2 = _item$assignes$$roles.find(role => role.name !== "Employee")) === null || _item$assignes$$roles2 === void 0 ? void 0 : _item$assignes$$roles2.name;
      if ((item === null || item === void 0 ? void 0 : (_item$assignes2 = item.assignes) === null || _item$assignes2 === void 0 ? void 0 : _item$assignes2.length) > 0) {
        var _item$assignes3;
        return `Pending with [${role}] (${item === null || item === void 0 ? void 0 : (_item$assignes3 = item.assignes) === null || _item$assignes3 === void 0 ? void 0 : _item$assignes3[0].name})` || `-`;
      }
      return t(`WF_BPA_MAP_${item === null || item === void 0 ? void 0 : item.status}`) || `-`;
    },
    width: "13%"
  }];
  const columns = allColumns.filter(col => selectedColumns.includes(col.id));
  const handleColumnToggle = columnId => {
    if (selectedColumns.includes(columnId)) {
      if (selectedColumns.length > 1) {
        setSelectedColumns(selectedColumns.filter(id => id !== columnId));
      }
    } else {
      setSelectedColumns([...selectedColumns, columnId]);
    }
  };
  const handleOpenColumnFilter = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseColumnFilter = () => {
    setAnchorEl(null);
  };
  const getComparator = (order, orderBy) => {
    return (a, b) => {
      const getValue = item => {
        var _item$landInfo4, _item$landInfo4$owner, _item$landInfo4$owner2, _item$landInfo4$owner3, _item$landInfo5, _item$landInfo5$owner, _item$landInfo5$owner2, _item$applicationNo, _item$applicationType, _item$auditDetails2, _t;
        switch (orderBy) {
          case "name":
            return (item === null || item === void 0 ? void 0 : (_item$landInfo4 = item.landInfo) === null || _item$landInfo4 === void 0 ? void 0 : (_item$landInfo4$owner = _item$landInfo4.owners) === null || _item$landInfo4$owner === void 0 ? void 0 : (_item$landInfo4$owner2 = _item$landInfo4$owner[0]) === null || _item$landInfo4$owner2 === void 0 ? void 0 : (_item$landInfo4$owner3 = _item$landInfo4$owner2.name) === null || _item$landInfo4$owner3 === void 0 ? void 0 : _item$landInfo4$owner3.toLowerCase()) || "";
          case "mobileNumber":
            return parseInt(item === null || item === void 0 ? void 0 : (_item$landInfo5 = item.landInfo) === null || _item$landInfo5 === void 0 ? void 0 : (_item$landInfo5$owner = _item$landInfo5.owners) === null || _item$landInfo5$owner === void 0 ? void 0 : (_item$landInfo5$owner2 = _item$landInfo5$owner[0]) === null || _item$landInfo5$owner2 === void 0 ? void 0 : _item$landInfo5$owner2.mobileNumber) || 0;
          case "applicationNo":
            return (item === null || item === void 0 ? void 0 : (_item$applicationNo = item.applicationNo) === null || _item$applicationNo === void 0 ? void 0 : _item$applicationNo.toLowerCase()) || "";
          case "applicationType":
            return (item === null || item === void 0 ? void 0 : (_item$applicationType = item.applicationType) === null || _item$applicationType === void 0 ? void 0 : _item$applicationType.toLowerCase()) || "";
          case "applicationDate":
            return (item === null || item === void 0 ? void 0 : (_item$auditDetails2 = item.auditDetails) === null || _item$auditDetails2 === void 0 ? void 0 : _item$auditDetails2.createdTime) || 0;
          case "status":
            return ((_t = t(`WF_BPA_MAP_${item === null || item === void 0 ? void 0 : item.status}`)) === null || _t === void 0 ? void 0 : _t.toLowerCase()) || "";
          default:
            return "";
        }
      };
      const aValue = getValue(a);
      const bValue = getValue(b);
      if (order === "desc") {
        return bValue > aValue ? 1 : bValue < aValue ? -1 : 0;
      } else {
        return aValue > bValue ? 1 : aValue < bValue ? -1 : 0;
      }
    };
  };
  const handleSort = property => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = event => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleFilterChange = (property, value) => {
    setFilters({
      ...filters,
      [property]: value
    });
    setPage(0);
  };
  const handleClearFilter = property => {
    setFilters({
      ...filters,
      [property]: ""
    });
  };
  const handleGlobalSearch = value => {
    setGlobalSearch(value);
    setPage(0);
  };
  const matchesSearch = (value, search) => {
    if (!value) return false;
    return value.toString().toLowerCase().includes(search.toLowerCase());
  };
  const getFilteredData = () => {
    let filteredData = data || [];
    if (globalSearch) {
      var _filteredData;
      filteredData = (_filteredData = filteredData) === null || _filteredData === void 0 ? void 0 : _filteredData.filter(item => {
        var _item$landInfo6, _item$landInfo6$owner, _item$landInfo6$owner2, _item$professionaldet, _item$landInfo7, _item$landInfo7$owner, _item$landInfo7$owner2, _item$auditDetails3;
        return matchesSearch(item === null || item === void 0 ? void 0 : (_item$landInfo6 = item.landInfo) === null || _item$landInfo6 === void 0 ? void 0 : (_item$landInfo6$owner = _item$landInfo6.owners) === null || _item$landInfo6$owner === void 0 ? void 0 : (_item$landInfo6$owner2 = _item$landInfo6$owner[0]) === null || _item$landInfo6$owner2 === void 0 ? void 0 : _item$landInfo6$owner2.name, globalSearch) || matchesSearch(item === null || item === void 0 ? void 0 : (_item$professionaldet = item.professionaldetails) === null || _item$professionaldet === void 0 ? void 0 : _item$professionaldet.name, globalSearch) || matchesSearch(item === null || item === void 0 ? void 0 : item.plotArea, globalSearch) || matchesSearch(item === null || item === void 0 ? void 0 : (_item$landInfo7 = item.landInfo) === null || _item$landInfo7 === void 0 ? void 0 : (_item$landInfo7$owner = _item$landInfo7.owners) === null || _item$landInfo7$owner === void 0 ? void 0 : (_item$landInfo7$owner2 = _item$landInfo7$owner[0]) === null || _item$landInfo7$owner2 === void 0 ? void 0 : _item$landInfo7$owner2.mobileNumber, globalSearch) || matchesSearch(item === null || item === void 0 ? void 0 : item.applicationNo, globalSearch) || matchesSearch(item === null || item === void 0 ? void 0 : item.applicationType, globalSearch) || matchesSearch(item === null || item === void 0 ? void 0 : item.status, globalSearch) || matchesSearch(item === null || item === void 0 ? void 0 : item.schemeName, globalSearch) || matchesSearch(convertEpochToDateDMY(item === null || item === void 0 ? void 0 : (_item$auditDetails3 = item.auditDetails) === null || _item$auditDetails3 === void 0 ? void 0 : _item$auditDetails3.createdTime), globalSearch);
      });
    }
    if (filters.name) {
      filteredData = filteredData.filter(item => {
        var _item$landInfo8, _item$landInfo8$owner, _item$landInfo8$owner2;
        return matchesSearch(item === null || item === void 0 ? void 0 : (_item$landInfo8 = item.landInfo) === null || _item$landInfo8 === void 0 ? void 0 : (_item$landInfo8$owner = _item$landInfo8.owners) === null || _item$landInfo8$owner === void 0 ? void 0 : (_item$landInfo8$owner2 = _item$landInfo8$owner[0]) === null || _item$landInfo8$owner2 === void 0 ? void 0 : _item$landInfo8$owner2.name, filters.name);
      });
    }
    if (filters.mobileNumber) {
      filteredData = filteredData.filter(item => {
        var _item$landInfo9, _item$landInfo9$owner, _item$landInfo9$owner2;
        return matchesSearch(item === null || item === void 0 ? void 0 : (_item$landInfo9 = item.landInfo) === null || _item$landInfo9 === void 0 ? void 0 : (_item$landInfo9$owner = _item$landInfo9.owners) === null || _item$landInfo9$owner === void 0 ? void 0 : (_item$landInfo9$owner2 = _item$landInfo9$owner[0]) === null || _item$landInfo9$owner2 === void 0 ? void 0 : _item$landInfo9$owner2.mobileNumber, filters.mobileNumber);
      });
    }
    if (filters.applicationNo) {
      filteredData = filteredData.filter(item => matchesSearch(item === null || item === void 0 ? void 0 : item.applicationNo, filters.applicationNo));
    }
    if (filters.applicationType) {
      filteredData = filteredData.filter(item => matchesSearch(item === null || item === void 0 ? void 0 : item.applicationType, filters.applicationType));
    }
    if (filters.status) {
      filteredData = filteredData.filter(item => matchesSearch(item === null || item === void 0 ? void 0 : item.status, filters.status));
    }
    return filteredData;
  };
  const filteredData = getFilteredData();
  const filteredAndSortedData = filteredData.slice().sort(getComparator(order, orderBy));
  const paginatedData = filteredAndSortedData === null || filteredAndSortedData === void 0 ? void 0 : filteredAndSortedData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      padding: "0px 4px"
    }
  }, /*#__PURE__*/React__default.createElement(TableContainer, {
    className: "citizen-table-container"
  }, /*#__PURE__*/React__default.createElement(BackButton, null), /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between"
    }
  }, /*#__PURE__*/React__default.createElement("caption", {
    className: "citizen-table-caption"
  }, "My Applications"), /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      gap: "8px"
    }
  }, /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "outlined",
    className: "bg-white",
    startIcon: /*#__PURE__*/React__default.createElement(FilterListIcon, null),
    onClick: handleOpenColumnFilter,
    size: "small",
    sx: {
      height: "27px",
      fontSize: "12px",
      borderColor: "rgb(31, 74, 124)",
      color: "rgb(31, 74, 124)"
    }
  }, t("FASTPAS.GLOBAL.FILTERS.TEXT"), "(", selectedColumns.length, "/", allColumns.length, ")"), /*#__PURE__*/React__default.createElement(TextField$1, {
    variant: "outlined",
    size: "small",
    placeholder: "Search here...",
    value: globalSearch,
    onChange: e => handleGlobalSearch(e.target.value),
    InputProps: {
      startAdornment: /*#__PURE__*/React__default.createElement(InputAdornment, {
        position: "start"
      }, /*#__PURE__*/React__default.createElement(SearchIcon, {
        sx: {
          background: "#1f4a7c",
          color: "#fff",
          height: "24px",
          borderRadius: "7px 0px 0px 7px",
          width: "29px"
        }
      })),
      endAdornment: globalSearch && /*#__PURE__*/React__default.createElement(InputAdornment, {
        position: "end"
      }, /*#__PURE__*/React__default.createElement(IconButton$2, {
        size: "small",
        onClick: () => handleGlobalSearch("")
      }, /*#__PURE__*/React__default.createElement(ClearIcon, {
        fontSize: "small"
      })))
    },
    sx: {
      padding: "0px",
      height: "25px",
      "& .MuiInputBase-root": {
        height: "27px",
        padding: "0px",
        backgroundColor: '#fff'
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "rgb(31, 74, 124)"
      },
      "& .MuiOutlinedInput-input": {
        padding: "0",
        fontSize: "12px"
      }
    }
  }))), /*#__PURE__*/React__default.createElement(Popover, {
    open: Boolean(anchorEl),
    anchorEl: anchorEl,
    onClose: handleCloseColumnFilter,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "left"
    },
    transformOrigin: {
      vertical: "top",
      horizontal: "left"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "select-column-popover"
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "subtitle2",
    gutterBottom: true
  }, "Select Columns to Display"), /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    control: /*#__PURE__*/React__default.createElement(Checkbox, {
      sx: {
        padding: "0px"
      },
      checked: selectedColumns.length === allColumns.length,
      indeterminate: selectedColumns.length > 0 && selectedColumns.length < allColumns.length,
      onChange: e => {
        if (e.target.checked) {
          setSelectedColumns(allColumns.map(col => col.id));
        } else {
          setSelectedColumns([allColumns[0].id]);
        }
      }
    }),
    sx: {
      margin: "0px",
      fontWeight: "bold"
    },
    label: "Select All"
  }), allColumns.map(column => /*#__PURE__*/React__default.createElement("div", {
    key: column.id
  }, /*#__PURE__*/React__default.createElement(FormControlLabel$1, {
    control: /*#__PURE__*/React__default.createElement(Checkbox, {
      sx: {
        padding: "0px"
      },
      checked: selectedColumns.includes(column.id),
      onChange: () => handleColumnToggle(column.id),
      disabled: column.id === "srNo" && selectedColumns.length === 1
    }),
    sx: {
      margin: "0px"
    },
    label: column.label
  }))))), /*#__PURE__*/React__default.createElement(Table, {
    stickyHeader: true,
    "aria-label": "enhanced table",
    size: "small",
    className: "citizen-application-table",
    style: {
      tableLayout: "fixed",
      width: "100%"
    }
  }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", {
    className: "citizen-header-row"
  }, columns.map(column => /*#__PURE__*/React__default.createElement("td", {
    key: column.id,
    style: {
      width: column.width
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }
  }, column.label, column.sortable && /*#__PURE__*/React__default.createElement(TableSortLabel, {
    active: orderBy === column.id,
    direction: orderBy === column.id ? order : "asc",
    onClick: () => handleSort(column.id),
    sx: {
      color: "white !important",
      "& .MuiTableSortLabel-icon": {
        opacity: "1 !important",
        color: "white !important"
      },
      "&:hover": {
        color: "white !important"
      }
    },
    IconComponent: props => /*#__PURE__*/React__default.createElement(ArrowDownward, Object.assign({}, props, {
      sx: {
        color: "white !important",
        opacity: 1
      }
    }))
  }))))), /*#__PURE__*/React__default.createElement("tr", null, columns === null || columns === void 0 ? void 0 : columns.map(column => /*#__PURE__*/React__default.createElement("td", {
    key: column.id
  }, column.filterable && /*#__PURE__*/React__default.createElement(TextField$1, {
    variant: "standard",
    size: "small",
    value: filters[column.id] || "",
    onChange: e => handleFilterChange(column.id, e.target.value),
    InputProps: {
      endAdornment: filters[column.id] && /*#__PURE__*/React__default.createElement(InputAdornment, {
        position: "end"
      }, /*#__PURE__*/React__default.createElement(IconButton$2, {
        size: "small",
        onClick: () => handleClearFilter(column.id),
        sx: {
          color: "white"
        }
      }, /*#__PURE__*/React__default.createElement(ClearIcon, {
        fontSize: "small"
      })))
    },
    sx: {
      "& .MuiInput-input": {
        color: "black !important",
        fontSize: "0.75rem"
      },
      width: "100%"
    }
  }))))), /*#__PURE__*/React__default.createElement("tbody", null, isLoading ? /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colSpan: columns.length,
    align: "center"
  }, "Loading...")) : paginatedData.length === 0 ? /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colSpan: columns.length,
    align: "center"
  }, "No records found")) : paginatedData.map((item, index) => /*#__PURE__*/React__default.createElement("tr", {
    hover: true,
    key: index
  }, columns.map(column => /*#__PURE__*/React__default.createElement("td", {
    key: `${index}-${column.id}`,
    style: {
      width: column.width,
      whiteSpace: "normal",
      wordBreak: "break-word",
      overflowWrap: "break-word",
      verticalAlign: "top"
    }
  }, column.render(item, index)))))))), /*#__PURE__*/React__default.createElement(TablePagination, {
    rowsPerPageOptions: [10, 25, 50, 100],
    component: "div",
    count: filteredAndSortedData.length,
    rowsPerPage: rowsPerPage,
    page: page,
    onPageChange: handleChangePage,
    onRowsPerPageChange: handleChangeRowsPerPage
  }));
};

const BPACommonSearchApp = () => {
  const {
    t
  } = useTranslation();
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const {
    data,
    isLoading: loader
  } = Digit.Hooks.obps.useBPASearch(tenantId);
  if (loader) return /*#__PURE__*/React__default.createElement(Loader, null);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(EnhancedTable, {
    data: data,
    isLoading: loader,
    tenantId: tenantId
  }));
};

const FileStrip = ({
  ltpDetail,
  mapDetailsFromSession
}) => {
  var _userInfo$info, _userInfo$info$roles, _userInfo$info2, _userInfo$info3;
  const userInfo = Digit.UserService.getUser();
  const userRoles = userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info = userInfo.info) === null || _userInfo$info === void 0 ? void 0 : (_userInfo$info$roles = _userInfo$info.roles) === null || _userInfo$info$roles === void 0 ? void 0 : _userInfo$info$roles.map(e => e.code);
  const isLtp = userRoles === null || userRoles === void 0 ? void 0 : userRoles.some(role => !["OWNER", "EMPLOYEE", "CITIZEN"].includes(role));
  const isOwner = (userRoles === null || userRoles === void 0 ? void 0 : userRoles.includes("OWNER")) && !isLtp;
  const isCitizen = userRoles === null || userRoles === void 0 ? void 0 : userRoles.includes("LTP");
  const roleLabel = isLtp ? "LTP Mobile No" : isOwner ? "Owner Mobile No" : isCitizen ? "Citizen Mobile No" : "Mobile No";
  return /*#__PURE__*/React__default.createElement(FileInfoStrip, null, (mapDetailsFromSession === null || mapDetailsFromSession === void 0 ? void 0 : mapDetailsFromSession.applicationNo) && /*#__PURE__*/React__default.createElement(FileNo, null, "File No: ", (mapDetailsFromSession === null || mapDetailsFromSession === void 0 ? void 0 : mapDetailsFromSession.applicationNo) || "N/A"), /*#__PURE__*/React__default.createElement("span", null, roleLabel, ":-\xA0"), " ", /*#__PURE__*/React__default.createElement("span", {
    style: {
      fontWeight: "bold"
    }
  }, (userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info2 = userInfo.info) === null || _userInfo$info2 === void 0 ? void 0 : _userInfo$info2.mobileNumber) || "N/A"), /*#__PURE__*/React__default.createElement(Owner, null, /*#__PURE__*/React__default.createElement("strong", null, userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$info3 = userInfo.info) === null || _userInfo$info3 === void 0 ? void 0 : _userInfo$info3.name), /*#__PURE__*/React__default.createElement("div", {
    style: {
      fontWeight: "normal",
      fontSize: "0.9em"
    }
  }, ltpDetail === null || ltpDetail === void 0 ? void 0 : ltpDetail.registrationNumber)));
};

function SideTopBarLayout({
  t,
  stateInfo,
  userDetails,
  CITIZEN,
  cityDetails,
  children,
  formData
}) {
  const location = useLocation();
  const isObpsRoute = location.pathname.includes("obps");
  const isProfileRoute = location.pathname.includes("profile");
  const isProfileAccount = location.pathname.includes("account");
  const stateId = Digit.ULBService.getStateId();
  const [applicationDetail, setApplicationDetail] = useState(null);
  const [ltpDetail, setLtpDetail] = useState(null);
  const [mapDetails, setMapDetails] = useState(null);
  const [collapsed, setCollapsed] = useState(false);
  const [userData, setUserData] = useState(null);
  const toggleSidebar = () => {
    setCollapsed(!collapsed);
  };
  useEffect(() => {
    const fetchAndSetUserDetails = async () => {
      const {
        info: userInfo
      } = Digit.UserService.getUser();
      const uuid = userInfo === null || userInfo === void 0 ? void 0 : userInfo.uuid;
      if (uuid) {
        var _usersResponse$user;
        const usersResponse = await Digit.UserService.userSearch(stateId, {
          uuid: [uuid]
        }, {});
        const userDetail = usersResponse === null || usersResponse === void 0 ? void 0 : (_usersResponse$user = usersResponse.user) === null || _usersResponse$user === void 0 ? void 0 : _usersResponse$user[0];
        setUserData(userDetail);
        const ltpDetail = {
          user: userDetail
        };
        Digit.SessionStorage.set("USER_DETAIL", userDetail);
        Digit.SessionStorage.set("LTP_DETAIL", ltpDetail);
        return ltpDetail;
      }
      return null;
    };
    const interval = setInterval(async () => {
      const appDetailFromSession = Digit.SessionStorage.get("FASTPAS_ID");
      let userDetailFromSession = Digit.SessionStorage.get("USER_DETAIL");
      const mapDetailsFromSession = Digit.SessionStorage.get("FORM_MAP_SUBMISSION");
      if (!userDetailFromSession) {
        userDetailFromSession = await fetchAndSetUserDetails();
      }
      if (appDetailFromSession) setApplicationDetail(appDetailFromSession);
      if (userDetailFromSession) setLtpDetail(userDetailFromSession);
      if (mapDetailsFromSession) setMapDetails(mapDetailsFromSession);
      if (appDetailFromSession && userDetailFromSession && mapDetailsFromSession) {
        clearInterval(interval);
      }
    }, 3000);
    return () => clearInterval(interval);
  }, []);
  return /*#__PURE__*/React__default.createElement(DashboardLayout, {
    isObpsRoute: isObpsRoute
  }, /*#__PURE__*/React__default.createElement(Sidebar, {
    userDetails: userData,
    collapsed: collapsed,
    toggleSidebar: toggleSidebar,
    setCollapsed: setCollapsed
  }), /*#__PURE__*/React__default.createElement(MainContent, {
    collapsed: collapsed
  }, /*#__PURE__*/React__default.createElement(TopBar$3, {
    userDetails: userDetails,
    collapsed: collapsed,
    applicationDetail: applicationDetail,
    toggleSidebar: toggleSidebar
  }), /*#__PURE__*/React__default.createElement(FileStrip, {
    ltpDetail: ltpDetail,
    mapDetailsFromSession: mapDetails
  }), isProfileRoute && /*#__PURE__*/React__default.createElement(BPACommonSearchApp, null), isProfileAccount && /*#__PURE__*/React__default.createElement(UserProfile, null), /*#__PURE__*/React__default.createElement("div", {
    style: {
      flex: 1,
      overflow: "auto"
    }
  }, children)));
}

const DownloadDocuments = () => {
  const {
    id
  } = useParams();
  const [error, setError] = useState(null);
  const [urls, setUrls] = useState({
    selfCertificateUrl: null,
    selfDrawingUrl: null
  });
  const [loading, setLoading] = useState({
    certificate: false,
    drawing: false
  });
  const [progress, setProgress] = useState({
    certificate: 0,
    drawing: 0
  });
  const intervalRefs = useRef({
    certificate: null,
    drawing: null
  });
  useEffect(() => {
    const fetchUrls = async () => {
      try {
        var _Urls$qrCodeURL, _res$data, _res$data2;
        const res = await axios.post(`${Urls$1 === null || Urls$1 === void 0 ? void 0 : (_Urls$qrCodeURL = Urls$1.qrCodeURL) === null || _Urls$qrCodeURL === void 0 ? void 0 : _Urls$qrCodeURL.SelfMap}?applicationId=${id}`, {
          RequestInfo: {
            apiId: "Rainmaker",
            action: "_create",
            did: 1,
            key: "",
            msgId: "20170310130900|en_IN",
            ts: 0,
            ver: ".01"
          }
        });
        setUrls({
          selfCertificateUrl: (res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.selfCertificateUrl) || null,
          selfDrawingUrl: (res === null || res === void 0 ? void 0 : (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.selfDrawingUrl) || null
        });
      } catch (err) {
        console.error("API Error:", err);
        setError("Failed to fetch document URLs.");
      }
    };
    fetchUrls();
    return () => {
      clearInterval(intervalRefs.current.certificate);
      clearInterval(intervalRefs.current.drawing);
    };
  }, [id]);
  const simulateProgress = (type, callback) => {
    let curr = 0;
    const increment = 100 / (Math.floor(Math.random() * 6) + 5);
    setLoading(prev => ({
      ...prev,
      [type]: true
    }));
    setProgress(prev => ({
      ...prev,
      [type]: 0
    }));
    intervalRefs.current[type] = setInterval(() => {
      curr += increment;
      if (curr >= 100) {
        clearInterval(intervalRefs.current[type]);
        setProgress(prev => ({
          ...prev,
          [type]: 100
        }));
        setLoading(prev => ({
          ...prev,
          [type]: false
        }));
        callback();
      } else {
        setProgress(prev => ({
          ...prev,
          [type]: curr
        }));
      }
    }, 1000);
  };
  const handleDownload = type => {
    const url = type === "certificate" ? urls.selfCertificateUrl : urls.selfDrawingUrl;
    if (!url) return;
    simulateProgress(type, () => {
      window.open(url, "_blank");
    });
  };
  return /*#__PURE__*/React__default.createElement(Box$1, {
    sx: {
      maxWidth: 600,
      p: 3
    }
  }, error && /*#__PURE__*/React__default.createElement(Alert, {
    severity: "error"
  }, error), /*#__PURE__*/React__default.createElement(Stack, {
    spacing: 4
  }, /*#__PURE__*/React__default.createElement(Box$1, null, urls.selfCertificateUrl ? !loading.certificate ? /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    startIcon: /*#__PURE__*/React__default.createElement(FileDownloadIcon, null),
    fullWidth: true,
    onClick: () => handleDownload("certificate")
  }, "View Self Certificate") : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body2",
    mb: 1
  }, "Preparing document..."), /*#__PURE__*/React__default.createElement(LinearProgress, {
    value: progress.certificate,
    variant: "determinate",
    sx: {
      height: 10,
      borderRadius: 5
    }
  }), /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body2",
    mt: 1
  }, Math.round(progress.certificate), "%")) : /*#__PURE__*/React__default.createElement(Alert, {
    severity: "info"
  }, "Self Certificate not available yet.")), /*#__PURE__*/React__default.createElement(Box$1, null, urls.selfDrawingUrl ? !loading.drawing ? /*#__PURE__*/React__default.createElement(Button$2, {
    variant: "contained",
    startIcon: /*#__PURE__*/React__default.createElement(FileDownloadIcon, null),
    fullWidth: true,
    onClick: () => handleDownload("drawing")
  }, "View Drawing PDF") : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body2",
    mb: 1
  }, "Preparing document..."), /*#__PURE__*/React__default.createElement(LinearProgress, {
    value: progress.drawing,
    variant: "determinate",
    sx: {
      height: 10,
      borderRadius: 5
    }
  }), /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body2",
    mt: 1
  }, Math.round(progress.drawing), "%")) : /*#__PURE__*/React__default.createElement(Alert, {
    severity: "info"
  }, "Drawing PDF not available yet."))));
};

const DownloadDesignLTP = () => {
  const navigate = useHistory();
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: "design-pdf-download",
    style: {
      height: "100vh",
      width: "100vw",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: "#f5f5f5",
      overflow: "hidden",
      position: "relative"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      position: "absolute",
      top: 10,
      left: 10,
      display: "flex",
      alignItems: "center"
    }
  }, /*#__PURE__*/React__default.createElement(AccessibilityRoundedIcon, {
    titleAccess: "Accessibility",
    style: {
      width: "50px",
      height: "50px"
    }
  })), /*#__PURE__*/React__default.createElement(Paper, {
    style: {
      width: "70wh",
      height: "430px",
      maxWidth: 500,
      overflow: "auto"
    }
  }, /*#__PURE__*/React__default.createElement(Box$1, {
    sx: {
      display: "flex",
      justifyContent: "space-around",
      p: 1,
      borderBottom: "1px solid #ccc"
    }
  }, /*#__PURE__*/React__default.createElement("img", {
    src: "https://upload.wikimedia.org/wikipedia/commons/f/fa/Seal_of_Uttar_Pradesh.svg",
    alt: "emblem",
    loading: "lazy",
    style: {
      height: "60px",
      alignItems: "center"
    }
  }), /*#__PURE__*/React__default.createElement("img", {
    src: "https://financialservices.gov.in/beta/themes/fds/images/120w_75_azadi.png",
    alt: "amrit mahotsav",
    loading: "lazy",
    style: {
      height: "55px",
      alignItems: "center"
    }
  }), /*#__PURE__*/React__default.createElement("img", {
    src: "https://financialservices.gov.in/beta/themes/fds/images/make-in-india-header.png",
    alt: "digital",
    loading: "lazy",
    style: {
      height: "55px",
      alignItems: "center"
    }
  })), /*#__PURE__*/React__default.createElement(Box$1, {
    sx: {
      display: "flex",
      justifyContent: "space-between",
      p: 1,
      borderBottom: "1px solid #fff",
      color: "#fff",
      backgroundColor: "#012C46"
    }
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "h5",
    fontWeight: "bold",
    textAlign: "center",
    color: "#fff",
    flex: 1
  }, "Housing and Urban Planning Department", /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body2",
    color: "#fff"
  }, "Government of Uttar Pradesh"))), /*#__PURE__*/React__default.createElement(Box$1, {
    sx: {
      p: 1,
      backgroundColor: "#FFE082",
      margin: "10px"
    }
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "h6",
    color: "purple",
    fontWeight: "bold"
  }, "Tip of the day"), /*#__PURE__*/React__default.createElement("ul", null, /*#__PURE__*/React__default.createElement("li", null, "Keep changing your password often and make them complex and not guessable."), /*#__PURE__*/React__default.createElement("li", null, "Document should only be downloaded from authentic platforms!"))), /*#__PURE__*/React__default.createElement(Box$1, null, /*#__PURE__*/React__default.createElement(DownloadDocuments, null)), /*#__PURE__*/React__default.createElement(Grid$1, {
    container: true
  }, /*#__PURE__*/React__default.createElement(Grid$1, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement(Box$1, {
    sx: {
      backgroundColor: "#0288D1",
      color: "#fff",
      p: 1,
      textAlign: "center",
      fontWeight: "bold",
      cursor: "pointer"
    }
  }, "Department User's ", /*#__PURE__*/React__default.createElement("br", null), "(", /*#__PURE__*/React__default.createElement(Link, {
    onClick: () => navigate.push("/digit-ui/employee/user/login")
  }, "Login for Department"), ")")), /*#__PURE__*/React__default.createElement(Grid$1, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement(Box$1, {
    sx: {
      backgroundColor: "#0288D1",
      color: "#fff",
      p: 1,
      textAlign: "center",
      fontWeight: "bold",
      cursor: "pointer"
    }
  }, "Citizen User's ", /*#__PURE__*/React__default.createElement("br", null), "(", /*#__PURE__*/React__default.createElement(Link, {
    onClick: () => navigate.push("/digit-ui/citizen/login")
  }, "Login For Citizen"), ")"))))));
};

const DownloadDesignLTP$1 = () => {
  const navigate = useHistory();
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: "design-pdf-download",
    style: {
      height: "100vh",
      width: "100vw",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: "#f5f5f5",
      overflow: "hidden",
      position: 'relative'
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      position: "absolute",
      top: 10,
      left: 10,
      display: "flex",
      alignItems: "center"
    }
  }, /*#__PURE__*/React__default.createElement(AccessibilityRoundedIcon, {
    titleAccess: "Accessibility",
    style: {
      width: '50px',
      height: '50px'
    }
  })), /*#__PURE__*/React__default.createElement(Paper, {
    style: {
      width: "70wh",
      height: "430px",
      maxWidth: 500,
      overflow: "auto"
    }
  }, /*#__PURE__*/React__default.createElement(Box$1, {
    sx: {
      display: "flex",
      justifyContent: "space-around",
      p: 1,
      borderBottom: "1px solid #ccc"
    }
  }, /*#__PURE__*/React__default.createElement("img", {
    src: "https://upload.wikimedia.org/wikipedia/commons/f/fa/Seal_of_Uttar_Pradesh.svg",
    alt: "emblem",
    loading: "lazy",
    style: {
      height: "60px",
      alignItems: 'center'
    }
  }), /*#__PURE__*/React__default.createElement("img", {
    src: "https://financialservices.gov.in/beta/themes/fds/images/120w_75_azadi.png",
    alt: "amrit mahotsav",
    loading: "lazy",
    style: {
      height: "55px",
      alignItems: 'center'
    }
  }), /*#__PURE__*/React__default.createElement("img", {
    src: "https://financialservices.gov.in/beta/themes/fds/images/make-in-india-header.png",
    alt: "digital",
    loading: "lazy",
    style: {
      height: "55px",
      alignItems: 'center'
    }
  })), /*#__PURE__*/React__default.createElement(Box$1, {
    sx: {
      display: "flex",
      justifyContent: "space-between",
      p: 1,
      borderBottom: "1px solid #fff",
      color: "#fff",
      backgroundColor: '#012C46'
    }
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "h5",
    fontWeight: "bold",
    textAlign: "center",
    color: "#fff",
    flex: 1
  }, "Housing and Urban Planning Department", /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "body2",
    color: "#fff"
  }, "Government of Uttar Pradesh"))), /*#__PURE__*/React__default.createElement(Box$1, {
    sx: {
      p: 1,
      backgroundColor: "#FFE082",
      margin: "10px"
    }
  }, /*#__PURE__*/React__default.createElement(Typography$1, {
    variant: "h6",
    color: "purple",
    fontWeight: "bold"
  }, "Tip of the day"), /*#__PURE__*/React__default.createElement("ul", null, /*#__PURE__*/React__default.createElement("li", null, "Keep changing your password often and make them complex and not guessable."), /*#__PURE__*/React__default.createElement("li", null, "Document should only be downloaded from authentic platforms!"))), /*#__PURE__*/React__default.createElement(Box$1, null, /*#__PURE__*/React__default.createElement(DownloadDocuments, null)), /*#__PURE__*/React__default.createElement(Grid$1, {
    container: true
  }, /*#__PURE__*/React__default.createElement(Grid$1, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement(Box$1, {
    sx: {
      backgroundColor: "#0288D1",
      color: "#fff",
      p: 1,
      textAlign: "center",
      fontWeight: "bold",
      cursor: 'pointer'
    }
  }, "Department User's ", /*#__PURE__*/React__default.createElement("br", null), "(", /*#__PURE__*/React__default.createElement(Link, {
    onClick: () => navigate.push("/digit-ui/employee/user/login")
  }, "Login for Department"), ")")), /*#__PURE__*/React__default.createElement(Grid$1, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React__default.createElement(Box$1, {
    sx: {
      backgroundColor: "#0288D1",
      color: "#fff",
      p: 1,
      textAlign: "center",
      fontWeight: "bold",
      cursor: 'pointer'
    }
  }, "Citizen User's ", /*#__PURE__*/React__default.createElement("br", null), "(", /*#__PURE__*/React__default.createElement(Link, {
    onClick: () => navigate.push("/digit-ui/citizen/login")
  }, "Login For Citizen"), ")"))))));
};

const ReusableTable = ({
  columns,
  data,
  rowsPerPageOptions: _rowsPerPageOptions = [10, 25, 50, 100],
  defaultRowsPerPage: _defaultRowsPerPage = 25,
  tableTitle: _tableTitle = "",
  backButton: _backButton = true,
  backTo: _backTo = -1,
  isLTPGrading: _isLTPGrading = false
}) => {
  var _columns$;
  const [orderBy, setOrderBy] = useState(((_columns$ = columns[0]) === null || _columns$ === void 0 ? void 0 : _columns$.id) || "");
  const [order, setOrder] = useState("asc");
  const [globalSearch, setGlobalSearch] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(_defaultRowsPerPage);
  const filteredData = _isLTPGrading ? data.filter(row => {
    const values = Object.values(row).map(v => v ? v.toString().toLowerCase().trim() : "");
    return !values.some(val => val === "owner" || val.includes("owner"));
  }) : data;
  const displayTableTitle = _isLTPGrading ? "LTP Grading Dashboard" : _tableTitle;
  const getComparator = (order, orderBy) => (a, b) => {
    const aValue = a[orderBy];
    const bValue = b[orderBy];
    if (order === "desc") return bValue > aValue ? 1 : bValue < aValue ? -1 : 0;else return aValue > bValue ? 1 : aValue < bValue ? -1 : 0;
  };
  const searchedData = filteredData.filter(row => columns.some(col => {
    var _row$col$id;
    return (_row$col$id = row[col.id]) === null || _row$col$id === void 0 ? void 0 : _row$col$id.toString().toLowerCase().includes(globalSearch.toLowerCase());
  }));
  const sortedData = searchedData.sort(getComparator(order, orderBy));
  const paginatedData = sortedData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  const handleSort = property => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };
  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = event => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: "reusable-table-container"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "reusable-table-header"
  }, _backButton && /*#__PURE__*/React__default.createElement(BackButton, null)), /*#__PURE__*/React__default.createElement("div", {
    className: "reusable-table-title-section"
  }, displayTableTitle && /*#__PURE__*/React__default.createElement("h2", {
    className: "reusable-table-title"
  }, displayTableTitle), /*#__PURE__*/React__default.createElement("div", {
    className: "reusable-table-search-container"
  }, /*#__PURE__*/React__default.createElement(TextField$2, {
    variant: "outlined",
    size: "small",
    placeholder: "Search here...",
    value: globalSearch,
    onChange: e => setGlobalSearch(e.target.value),
    InputProps: {
      startAdornment: /*#__PURE__*/React__default.createElement(InputAdornment$1, {
        position: "start"
      }, /*#__PURE__*/React__default.createElement(SearchIcon, {
        className: "reusable-table-search-icon"
      })),
      endAdornment: globalSearch && /*#__PURE__*/React__default.createElement(InputAdornment$1, {
        position: "end"
      }, /*#__PURE__*/React__default.createElement(IconButton$1, {
        size: "small",
        onClick: () => setGlobalSearch("")
      }, /*#__PURE__*/React__default.createElement(ClearIcon, {
        fontSize: "small"
      })))
    },
    className: "reusable-table-search-field"
  }))), /*#__PURE__*/React__default.createElement("div", {
    className: "reusable-table-main-container"
  }, /*#__PURE__*/React__default.createElement(TableContainer$1, {
    className: "reusable-table-table-container"
  }, /*#__PURE__*/React__default.createElement(Table$4, {
    stickyHeader: true,
    className: "reusable-table-table"
  }, /*#__PURE__*/React__default.createElement("thead", null, /*#__PURE__*/React__default.createElement("tr", null, columns.map((col, index) => /*#__PURE__*/React__default.createElement("th", {
    key: col.id,
    className: "reusable-table-header-cell"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "reusable-table-header-content"
  }, /*#__PURE__*/React__default.createElement("span", null, col.label), col.sortable && /*#__PURE__*/React__default.createElement(TableSortLabel$1, {
    active: orderBy === col.id,
    direction: orderBy === col.id ? order : "asc",
    onClick: () => handleSort(col.id),
    sx: {
      color: "white !important",
      "& .MuiTableSortLabel-icon": {
        opacity: "1 !important",
        color: "white !important"
      },
      "&:hover": {
        color: "white !important"
      }
    },
    IconComponent: props => /*#__PURE__*/React__default.createElement(ArrowDownward, Object.assign({}, props, {
      sx: {
        color: "white !important",
        opacity: 1,
        fontSize: "16px"
      }
    }))
  })))))), /*#__PURE__*/React__default.createElement("tbody", null, paginatedData.length === 0 ? /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colSpan: columns.length,
    className: "reusable-table-no-records"
  }, "No records found")) : paginatedData.map((row, idx) => /*#__PURE__*/React__default.createElement("tr", {
    key: row.id || idx,
    className: idx % 2 === 0 ? "reusable-table-even-row" : "reusable-table-odd-row"
  }, columns.map(col => /*#__PURE__*/React__default.createElement("td", {
    key: col.id,
    className: "reusable-table-body-cell"
  }, col.render ? col.render(row, idx) : row[col.id]))))))), /*#__PURE__*/React__default.createElement(TablePagination$1, {
    className: "reusable-table-pagination",
    component: "div",
    count: searchedData.length,
    page: page,
    onPageChange: handleChangePage,
    rowsPerPage: rowsPerPage,
    onRowsPerPageChange: handleChangeRowsPerPage,
    rowsPerPageOptions: _rowsPerPageOptions
  })));
};

const columns$3 = [{
  id: "srNo",
  label: "Sr. No",
  sortable: false,
  render: (row, idx) => idx + 1
}, {
  id: "name",
  label: "Name",
  sortable: true
}, {
  id: "roleName",
  label: "Role",
  sortable: true
}, {
  id: "approvalRateScore",
  label: "Approval Rate Score",
  sortable: true
}, {
  id: "timelineScore",
  label: "Timeline Score",
  sortable: true
}, {
  id: "resubmissionScore",
  label: "Resubmission Score",
  sortable: true
}, {
  id: "totalScore",
  label: "Total Score",
  sortable: false,
  render: row => Number(row.approvalRateScore) + Number(row.timelineScore) + Number(row.resubmissionScore)
}];
const LTPGrading = () => {
  const [gradingData, setGradingData] = useState([]);
  useEffect(() => {
    const fetchLtpGrading = async () => {
      try {
        const ltpGrading = await Digit.OBPSService.ltpGrading();
        setGradingData((ltpGrading === null || ltpGrading === void 0 ? void 0 : ltpGrading.DashboardDetails) || []);
      } catch (error) {
        console.error("Error fetching ltpGrading:", error);
      }
    };
    fetchLtpGrading();
  }, []);
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      padding: "24px"
    }
  }, /*#__PURE__*/React__default.createElement(ReusableTable, {
    columns: columns$3,
    data: gradingData,
    tableTitle: "LTP Grading Dashboard",
    isLTPGrading: true
  }));
};

const getTenants$1 = (codes, tenants) => {
  return tenants.filter(tenant => codes.map(item => item.code).includes(tenant.code));
};
const Layout = ({
  children
}) => {
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Strip, null), /*#__PURE__*/React__default.createElement(GovtStrip, null), /*#__PURE__*/React__default.createElement(Navbar, null), children, /*#__PURE__*/React__default.createElement(MapFooter, null));
};
const Home$1 = ({
  stateInfo,
  userDetails,
  CITIZEN,
  cityDetails,
  mobileView,
  handleUserDropdownSelection,
  DSO,
  initData,
  stateCode,
  modules,
  appTenants,
  sourceUrl,
  pathname
}) => {
  var _Digit;
  const applicationFlow = ((_Digit = Digit) === null || _Digit === void 0 ? void 0 : _Digit.SessionStorage.get("CITIZEN.COMMON.HOME.FLOW")) || null;
  const isUdFlow = applicationFlow === "UD";
  const classname = Digit.Hooks.fsm.useRouteSubscription(pathname);
  const [showTopNav, setShowTopNav] = useState(false);
  const {
    t
  } = useTranslation();
  const {
    path
  } = useRouteMatch();
  sourceUrl = "https://s3.ap-south-1.amazonaws.com/egov-qa-assets";
  const matchDynamicUrl = pathname => {
    return ignoreDynamicUrls.some(url => pathname.startsWith(url));
  };
  useEffect(() => {
    setShowTopNav(() => userDetails && !(ignoreURLsForTopBlueNav.includes(pathname) || matchDynamicUrl(pathname)));
  }, [pathname]);
  console.log("pathName", path, pathname, pathname == "/digit-ui/citizen/login" || pathname == "/digit-ui/citizen");
  const appRoutes = modules === null || modules === void 0 ? void 0 : modules.map(({
    code,
    tenants
  }, index) => {
    const Module = Digit.ComponentRegistryService.getComponent(`${code}Module`);
    return /*#__PURE__*/React__default.createElement(Route, {
      key: index,
      path: `${path}/${code.toLowerCase()}`
    }, /*#__PURE__*/React__default.createElement(Module, {
      stateCode: stateCode,
      moduleCode: code,
      userType: "citizen",
      tenants: getTenants$1(tenants, appTenants)
    }));
  });
  const ModuleLevelLinkHomePages = modules === null || modules === void 0 ? void 0 : modules.map(({
    code,
    bannerImage
  }, index) => {
    let Links = Digit.ComponentRegistryService.getComponent(`${code}Links`) || (() => /*#__PURE__*/React__default.createElement(React__default.Fragment, null));
    return /*#__PURE__*/React__default.createElement(Route, {
      key: index,
      path: `${path}/${code.toLowerCase()}-home`
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "moduleLinkHomePage"
    }, /*#__PURE__*/React__default.createElement(BackButton, {
      className: "moduleLinkHomePageBackButton"
    }), /*#__PURE__*/React__default.createElement("h1", null, t("MODULE_" + code.toUpperCase()))), /*#__PURE__*/React__default.createElement("div", {
      className: "moduleLinkHomePageModuleLinks"
    }, /*#__PURE__*/React__default.createElement(Links, {
      key: index,
      matchPath: `/digit-ui/citizen/${code.toLowerCase()}`,
      userType: "citizen"
    })));
  });
  return /*#__PURE__*/React__default.createElement("div", {
    className: classname
  }, showTopNav &&
  /*#__PURE__*/
  React__default.createElement(SideTopBarLayout, {
    t: t,
    stateInfo: stateInfo,
    userDetails: userDetails,
    CITIZEN: CITIZEN,
    cityDetails: cityDetails
  }), /*#__PURE__*/React__default.createElement("div", {
    className: pathname == "/digit-ui/citizen/login" || pathname == "/digit-ui/citizen" || pathname == "/digit-ui/citizen/checkStatusltp/:id" ? `` : "main center-container mb-25"
  }, /*#__PURE__*/React__default.createElement(Switch, null, /*#__PURE__*/React__default.createElement(Route, {
    exact: true,
    path: path
  }, /*#__PURE__*/React__default.createElement(Home, null)), /*#__PURE__*/React__default.createElement(Route, {
    path: `${path}/objectives`
  }, /*#__PURE__*/React__default.createElement(Layout, null, /*#__PURE__*/React__default.createElement(Objectives, null))), /*#__PURE__*/React__default.createElement(Route, {
    path: `${path}/organizational-setup`
  }, /*#__PURE__*/React__default.createElement(Layout, null, /*#__PURE__*/React__default.createElement(OrganizationalSetup, null))), /*#__PURE__*/React__default.createElement(Route, {
    path: `${path}/contact-us`
  }, /*#__PURE__*/React__default.createElement(Layout, null, /*#__PURE__*/React__default.createElement(ContactUs, null))), /*#__PURE__*/React__default.createElement(Route, {
    path: `${path}/ltpGrading`
  }, /*#__PURE__*/React__default.createElement(LTPGrading, null)), /*#__PURE__*/React__default.createElement(Route, {
    path: `${path}/paymentChallan`
  }, /*#__PURE__*/React__default.createElement(DuePayment, null)), /*#__PURE__*/React__default.createElement(Route, {
    path: `${path}/employee-profile`
  }, /*#__PURE__*/React__default.createElement(Layout, null, /*#__PURE__*/React__default.createElement(EmployeeProfile, null))), /*#__PURE__*/React__default.createElement(Route, {
    path: `${path}/ex-employee-profile`
  }, /*#__PURE__*/React__default.createElement(Layout, null, /*#__PURE__*/React__default.createElement(ExEmployeeProfile, null))), /*#__PURE__*/React__default.createElement(Route, {
    path: `${path}/appendix-1`
  }, /*#__PURE__*/React__default.createElement(Layout, null, /*#__PURE__*/React__default.createElement(Appendix1, null))), /*#__PURE__*/React__default.createElement(Route, {
    path: `${path}/appendix-8`
  }, /*#__PURE__*/React__default.createElement(Layout, null, /*#__PURE__*/React__default.createElement(Appendix8, null))), /*#__PURE__*/React__default.createElement(Route, {
    path: `${path}/apartment-colonies-regulation`
  }, /*#__PURE__*/React__default.createElement(Layout, null, /*#__PURE__*/React__default.createElement(AppartmentRegulation, null))), /*#__PURE__*/React__default.createElement(Route, {
    path: `${path}/court-orders`
  }, /*#__PURE__*/React__default.createElement(Layout, null, /*#__PURE__*/React__default.createElement(CourtOrders, null))), /*#__PURE__*/React__default.createElement(Route, {
    path: `${path}/notifications-under-tcp-act`
  }, /*#__PURE__*/React__default.createElement(Layout, null, /*#__PURE__*/React__default.createElement(NotificationTCPAct, null))), /*#__PURE__*/React__default.createElement(Route, {
    path: `${path}/forms-checklists`
  }, /*#__PURE__*/React__default.createElement(Layout, null, /*#__PURE__*/React__default.createElement(FormAndChecklistTable, null))), /*#__PURE__*/React__default.createElement(Route, {
    path: `${path}/service-matter`
  }, /*#__PURE__*/React__default.createElement(Layout, null, /*#__PURE__*/React__default.createElement(ServiceMatter, null))), /*#__PURE__*/React__default.createElement(Route, {
    path: `${path}/photo-gallery`
  }, /*#__PURE__*/React__default.createElement(Layout, null, /*#__PURE__*/React__default.createElement(PhotoGallery, null))), /*#__PURE__*/React__default.createElement(Route, {
    path: `${path}/video-gallery`
  }, /*#__PURE__*/React__default.createElement(Layout, null, /*#__PURE__*/React__default.createElement(VideoGallery, null))), /*#__PURE__*/React__default.createElement(Route, {
    path: `${path}/heritage-gallery`
  }, /*#__PURE__*/React__default.createElement(Layout, null, /*#__PURE__*/React__default.createElement(HeritageGallery, null))), /*#__PURE__*/React__default.createElement(Route, {
    path: `${path}/delegation-of-powers`
  }, /*#__PURE__*/React__default.createElement(Layout, null, /*#__PURE__*/React__default.createElement(PowerDelegation, null))), /*#__PURE__*/React__default.createElement(Route, {
    path: `${path}/development-plan`
  }, /*#__PURE__*/React__default.createElement(Layout, null, /*#__PURE__*/React__default.createElement(DevelopmentPlan, null))), /*#__PURE__*/React__default.createElement(Route, {
    path: `${path}/applyOnline`
  }, /*#__PURE__*/React__default.createElement(Layout, null, /*#__PURE__*/React__default.createElement(ApplyOnline, null))), /*#__PURE__*/React__default.createElement(Route, {
    path: `${path}/content/faq`
  }, /*#__PURE__*/React__default.createElement(Layout, null, /*#__PURE__*/React__default.createElement(FAQComponent, null))), /*#__PURE__*/React__default.createElement(Route, {
    path: `${path}/notifiedArea`
  }, /*#__PURE__*/React__default.createElement(Layout, null, /*#__PURE__*/React__default.createElement(NotifiedAreasTable, null))), /*#__PURE__*/React__default.createElement(Route, {
    path: `${path}/rti`
  }, /*#__PURE__*/React__default.createElement(Layout, null, /*#__PURE__*/React__default.createElement(RTI, null))), /*#__PURE__*/React__default.createElement(Route, {
    path: `${path}/registeredAgent`
  }, /*#__PURE__*/React__default.createElement(Layout, null, /*#__PURE__*/React__default.createElement(RegisteredAgent, null))), /*#__PURE__*/React__default.createElement(Route, {
    path: `${path}/publicActs`
  }, /*#__PURE__*/React__default.createElement(Layout, null, /*#__PURE__*/React__default.createElement(PublicActs, null))), /*#__PURE__*/React__default.createElement(Route, {
    path: `${path}/licenseCertificate`
  }, /*#__PURE__*/React__default.createElement(Layout, null, /*#__PURE__*/React__default.createElement(LicenseCertificate, null))), /*#__PURE__*/React__default.createElement(Route, {
    path: `${path}/instructions-orders`
  }, /*#__PURE__*/React__default.createElement(Layout, null, /*#__PURE__*/React__default.createElement(InstructionOrders, null))), /*#__PURE__*/React__default.createElement(Route, {
    path: `${path}/feeCalculator`
  }, /*#__PURE__*/React__default.createElement(Layout, null, /*#__PURE__*/React__default.createElement(FormType, null))), /*#__PURE__*/React__default.createElement(Route, {
    path: `${path}/services/form12`
  }, /*#__PURE__*/React__default.createElement(Form12$1, null)), /*#__PURE__*/React__default.createElement(Route, {
    path: `${path}/aboutus`
  }, /*#__PURE__*/React__default.createElement(AboutUs$1, null)), " ", /*#__PURE__*/React__default.createElement(Route, {
    path: `${path}/notifications`
  }, /*#__PURE__*/React__default.createElement(Notifications, null)), " ", /*#__PURE__*/React__default.createElement(Route, {
    path: `${path}/faq`
  }, /*#__PURE__*/React__default.createElement(Faq, null)), " ", /*#__PURE__*/React__default.createElement(Route, {
    path: `${path}/rules`
  }, /*#__PURE__*/React__default.createElement(Rules, null)), " ", /*#__PURE__*/React__default.createElement(Route, {
    path: `${path}/acts`
  }, /*#__PURE__*/React__default.createElement(Acts, null)), " ", /*#__PURE__*/React__default.createElement(Route, {
    path: `${path}/userguidemanual`
  }, /*#__PURE__*/React__default.createElement(UserGuideManual, null)), " ", /*#__PURE__*/React__default.createElement(Route, {
    path: `${path}/contactus`
  }, /*#__PURE__*/React__default.createElement(ContactUs$1, null)), " ", /*#__PURE__*/React__default.createElement(Route, {
    path: `${path}/onlineuserservices`
  }, /*#__PURE__*/React__default.createElement(OnlineUserServices, null)), " ", /*#__PURE__*/React__default.createElement(Route, {
    path: `${path}/tcphome`
  }, /*#__PURE__*/React__default.createElement(NewTcp, null)), " ", /*#__PURE__*/React__default.createElement(Route, {
    path: `${path}/udhome`
  }, /*#__PURE__*/React__default.createElement(NewUDHome, null)), " ", /*#__PURE__*/React__default.createElement(Route, {
    path: `${path}/landingPage`
  }, /*#__PURE__*/React__default.createElement(NewTCPHome, null)), " ", /*#__PURE__*/React__default.createElement(Route, {
    path: `${path}/registeredArchitect`
  }, /*#__PURE__*/React__default.createElement(RegisteredArchitect, null)), " ", /*#__PURE__*/React__default.createElement(Route, {
    path: `${path}/InProgreeService`
  }, /*#__PURE__*/React__default.createElement(InProgressServiceCard, {
    isUdFlow: isUdFlow
  })), /*#__PURE__*/React__default.createElement(Route, {
    path: `${path}/tcp/checkStatus`
  }, /*#__PURE__*/React__default.createElement(TCPCheckStatus, null)), /*#__PURE__*/React__default.createElement(Route, {
    path: `${path}/checkStatusltp/:id`
  }, /*#__PURE__*/React__default.createElement(DownloadDesignLTP, null)), /*#__PURE__*/React__default.createElement(Route, {
    path: `${path}/checkStatus/:id`
  }, /*#__PURE__*/React__default.createElement(DownloadDesignLTP$1, null)), /*#__PURE__*/React__default.createElement(Route, {
    path: `${path}/services/form11links`
  }, /*#__PURE__*/React__default.createElement(Form11Links, null)), /*#__PURE__*/React__default.createElement(Route, {
    path: `${path}/services/form11`
  }, /*#__PURE__*/React__default.createElement(Form11, null)), /*#__PURE__*/React__default.createElement(Route, {
    path: `${path}/services/form26`
  }, /*#__PURE__*/React__default.createElement(Form26$1, null)), /*#__PURE__*/React__default.createElement(Route, {
    path: `${path}/services/form34`
  }, /*#__PURE__*/React__default.createElement(Form34, null)), /*#__PURE__*/React__default.createElement(Route, {
    exact: true,
    path: `${path}/select-language`
  }, /*#__PURE__*/React__default.createElement(LanguageSelection$1, null)), /*#__PURE__*/React__default.createElement(Route, {
    exact: true,
    path: `${path}/select-location`
  }, /*#__PURE__*/React__default.createElement(LocationSelection, null)), /*#__PURE__*/React__default.createElement(Route, {
    path: `${path}/all-services`
  }, /*#__PURE__*/React__default.createElement(AppHome, {
    userType: "citizen",
    modules: modules
  })), /*#__PURE__*/React__default.createElement(Route, {
    path: `${path}/login`
  }, /*#__PURE__*/React__default.createElement(Login, {
    stateCode: stateCode
  })), /*#__PURE__*/React__default.createElement(Route, {
    path: `${path}/register`
  }, /*#__PURE__*/React__default.createElement(Login, {
    stateCode: stateCode,
    isUserRegistered: false
  })), /*#__PURE__*/React__default.createElement(PrivateRoute, {
    path: `${path}/user/profile`,
    component: () => /*#__PURE__*/React__default.createElement(UserProfile, {
      stateCode: stateCode,
      userType: "employee",
      cityDetails: cityDetails
    })
  }), /*#__PURE__*/React__default.createElement(ErrorBoundary, null, appRoutes, ModuleLevelLinkHomePages))), applicationFlow && /*#__PURE__*/React__default.createElement("div", {
    style: {
      width: "100%",
      bottom: 0,
      marginLeft: "12%"
    }
  }, /*#__PURE__*/React__default.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "center",
      color: "#1F4A7C"
    }
  }, /*#__PURE__*/React__default.createElement("h3", {
    style: {
      cursor: "pointer",
      display: "inline-flex"
    }
  }, /*#__PURE__*/React__default.createElement("a", {
    href: "https://www.digit.org/",
    target: "_blank",
    rel: "noopener noreferrer",
    onClick: e => {
      e.preventDefault();
      window.open("https://www.digit.org/", "_blank").focus();
    },
    style: {
      color: "blue",
      textDecoration: "none",
      fontWeight: "bold"
    }
  }, /*#__PURE__*/React__default.createElement("span", {
    style: {
      color: "rgb(31, 74, 124)"
    }
  }, "Powered by"), " ", /*#__PURE__*/React__default.createElement("span", {
    style: {
      color: "green"
    }
  }, "UPYOG"))), /*#__PURE__*/React__default.createElement("span", {
    style: {
      margin: "0 10px"
    }
  }, "|"), /*#__PURE__*/React__default.createElement("span", {
    style: {
      cursor: "pointer",
      fontSize: "16px",
      fontWeight: "400"
    },
    onClick: () => {
      window.open("https://niua.in/", "_blank").focus();
    }
  }, "Copyright \xA9 2022 National Institute of Urban Affairs"), /*#__PURE__*/React__default.createElement("span", {
    style: {
      margin: "0 10px"
    }
  }, "|"), /*#__PURE__*/React__default.createElement("a", {
    style: {
      cursor: "pointer",
      fontSize: "16px",
      fontWeight: "400"
    },
    href: "#",
    target: "_blank"
  }, "UPYOG License"))));
};

const theme = mode => createTheme({
  palette: {
    mode,
    ud: {
      primary: {
        main: '#0E7693',
        text: '#fff'
      }
    },
    tcp: {
      primary: {
        main: '#1f4a7c',
        text: '#fff'
      }
    },
    awasbandhu: {
      primary: {
        main: '#364a65',
        text: '#fff'
      }
    },
    primary: {
      main: '#556cd6'
    },
    secondary: {
      main: '#19857b'
    },
    error: {
      main: '#f00'
    },
    divider: "rgba(0, 0, 0, 0.25)",
    dull: {
      main: '#A9A9A9',
      light: '#D3D3D3',
      dark: '#808080',
      contrastText: '#fff'
    }
  },
  shape: {
    borderRadius: 6
  },
  typography: {
    htmlFontSize: 18,
    fontFamily: '"Poppins", sans-serif',
    fontWeightSemiBold: 600,
    fontSize: 14
  },
  overrides: {
    MuiButton: {
      root: {
        padding: '6px 16px'
      }
    }
  }
});

const ColorModeContext = createContext({
  toggleThemeMode: () => {}
});
const DigitApp = ({
  initData,
  stateCode,
  modules,
  appTenants,
  logoUrl
}) => {
  var _userDetails$info;
  const history = useHistory();
  const {
    pathname,
    search
  } = useLocation();
  const [mode, setMode] = useState("light");
  const colorMode = useMemo(() => ({
    toggleThemeMode: () => {
      setMode(prevMode => prevMode === "light" ? "dark" : "light");
    }
  }), []);
  const himachalTheme = useMemo(() => theme(mode), [mode]);
  const innerWidth = window.innerWidth;
  const cityDetails = Digit.ULBService.getCurrentUlb();
  const userDetails = Digit.UserService.getUser();
  const {
    data: storeData
  } = Digit.Hooks.useStore.getInitData();
  const {
    stateInfo
  } = storeData || {};
  const DSO = Digit.UserService.hasAccess(["FSM_DSO"]);
  let CITIZEN = (userDetails === null || userDetails === void 0 ? void 0 : (_userDetails$info = userDetails.info) === null || _userDetails$info === void 0 ? void 0 : _userDetails$info.type) === "CITIZEN" || !window.location.pathname.split("/").includes("employee") ? true : false;
  if (window.location.pathname.split("/").includes("employee")) CITIZEN = false;
  useEffect(() => {
    const user = Digit.UserService.getUser();
    const isLoggedIn = user && user.access_token && user.info;
    const getPrefix = path => {
      const match = path.match(/^(.*)\/digit-ui/);
      return match ? match[1] : "";
    };
    const isLoginOrLanding = path => {
      if (!path) return true;
      const normalized = path.replace(/\/$/, "");
      const prefix = getPrefix(normalized);
      return normalized === `${prefix}/digit-ui` || normalized === `${prefix}/digit-ui/citizen` || normalized === `${prefix}/digit-ui/citizen/login` || normalized === `${prefix}/digit-ui/employee/user/login` || normalized === `${prefix}/digit-ui/employee/user/language-selection` || normalized === `${prefix}/digit-ui/citizen/select-language` || normalized === `${prefix}/digit-ui/citizen/select-location` || normalized.includes("dsc-service") || normalized.includes("process-signed-pdf");
    };
    if (isLoggedIn) {
      if (isLoginOrLanding(pathname)) {
        const lastVisited = sessionStorage.getItem("last_visited_path");
        if (lastVisited && !isLoginOrLanding(lastVisited)) {
          history.replace(lastVisited);
        } else {
          const prefix = getPrefix(pathname);
          const defaultRedirect = user.info.type === "EMPLOYEE" ? `${prefix}/digit-ui/employee` : `${prefix}/digit-ui/citizen/profile`;
          history.replace(defaultRedirect);
        }
      } else {
        if (!pathname.includes("dsc-service") && !pathname.includes("process-signed-pdf")) {
          sessionStorage.setItem("last_visited_path", pathname + (search || ""));
        }
      }
    }
  }, [pathname, search, history]);
  const [isStateLocalisation, setIsStateLocalisation] = useState(true);
  useEffect(() => {
    if (isStateLocalisation) {
      setIsStateLocalisation(false);
      Digit.LocalizationService.getLocale({
        modules: ["rainmaker-bpa", "rainmaker-bpareg"],
        locale: Digit.StoreData.getCurrentLanguage(),
        tenantId: "up"
      });
    }
  }, []);
  useEffect(() => {
    if (!(pathname !== null && pathname !== void 0 && pathname.includes("application-details"))) {
      if (!(pathname !== null && pathname !== void 0 && pathname.includes("inbox"))) {
        Digit.SessionStorage.del("fsm/inbox/searchParams");
      }
      if (pathname !== null && pathname !== void 0 && pathname.includes("search")) {
        Digit.SessionStorage.del("fsm/search/searchParams");
      }
    }
    if (!(pathname !== null && pathname !== void 0 && pathname.includes("dss"))) {
      Digit.SessionStorage.del("DSS_FILTERS");
    }
  }, [pathname]);
  useEffect(() => {
    const unlisten = history.listen(() => {
      var _window;
      (_window = window) === null || _window === void 0 ? void 0 : _window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth"
      });
    });
    return () => unlisten();
  }, [history]);
  const handleUserDropdownSelection = option => {
    option.func();
  };
  const mobileView = innerWidth <= 640;
  let sourceUrl = `${window.location.origin}/citizen`;
  const commonProps = {
    stateInfo,
    userDetails,
    CITIZEN,
    cityDetails,
    mobileView,
    handleUserDropdownSelection,
    logoUrl,
    DSO,
    initData,
    stateCode,
    modules,
    appTenants,
    sourceUrl,
    pathname
  };
  return /*#__PURE__*/React__default.createElement(ColorModeContext.Provider, {
    value: colorMode
  }, /*#__PURE__*/React__default.createElement(ThemeProvider, {
    theme: himachalTheme
  }, /*#__PURE__*/React__default.createElement(CssBaseline$1, null), /*#__PURE__*/React__default.createElement(Switch, null, /*#__PURE__*/React__default.createElement(Route, {
    path: "/digit-ui/employee"
  }, /*#__PURE__*/React__default.createElement(EmployeeApp, commonProps)), /*#__PURE__*/React__default.createElement(Route, {
    path: "/digit-ui/citizen"
  }, /*#__PURE__*/React__default.createElement(Home$1, commonProps)), /*#__PURE__*/React__default.createElement(Route, {
    path: "/",
    exact: true
  }, /*#__PURE__*/React__default.createElement(Home, null)), /*#__PURE__*/React__default.createElement(Route, {
    path: "/checkStatus"
  }, /*#__PURE__*/React__default.createElement(TCPCheckStatus, null)), /*#__PURE__*/React__default.createElement(Route, null, /*#__PURE__*/React__default.createElement(Redirect, {
    to: "/digit-ui/citizen"
  })))));
};

const commonReducer = defaultData => (state = defaultData, action) => {
  switch (action.type) {
    case "LANGUAGE_SELECT":
      return {
        ...state,
        selectedLanguage: action.payload
      };
    default:
      return state;
  }
};

const types$1 = {
  INIT_DOCUMENTS: "INIT_FORM12_DOCUMENTS",
  ADD_DOCUMENT: "ADD_FORM12_DOCUMENT",
  REMOVE_DOCUMENT: "REMOVE_FORM12_DOCUMENT",
  RESET_DOCUMENTS: "RESET_FORM12_DOCUMENTS"
};

const {
  INIT_DOCUMENTS,
  ADD_DOCUMENT,
  REMOVE_DOCUMENT,
  RESET_DOCUMENTS
} = types$1;
const initState = {
  documents: []
};
const form12Reducer = () => (state = initState, action) => {
  switch (action.type) {
    case INIT_DOCUMENTS:
      {
        return {
          documents: action.payload
        };
      }
    case ADD_DOCUMENT:
      {
        return {
          ...state,
          documents: [...state.documents, action.payload]
        };
      }
    case REMOVE_DOCUMENT:
      {
        return {
          ...state,
          documents: [...state.documents.filter(doc => doc.documentType !== action.payload)]
        };
      }
    case RESET_DOCUMENTS:
      {
        return initState;
      }
    default:
      return state;
  }
};

const types$2 = {
  INIT_DOCUMENTS: "INIT_FORM11_DOCUMENTS",
  ADD_DOCUMENT: "ADD_FORM11_DOCUMENT",
  REMOVE_DOCUMENT: "REMOVE_FORM11_DOCUMENT",
  RESET_DOCUMENTS: "RESET_FORM11_DOCUMENTS"
};

const {
  INIT_DOCUMENTS: INIT_DOCUMENTS$1,
  ADD_DOCUMENT: ADD_DOCUMENT$1,
  REMOVE_DOCUMENT: REMOVE_DOCUMENT$1,
  RESET_DOCUMENTS: RESET_DOCUMENTS$1
} = types$2;
const initState$1 = {
  documents: []
};
const form11Reducer = () => (state = initState$1, action) => {
  switch (action.type) {
    case INIT_DOCUMENTS$1:
      {
        return {
          documents: action.payload
        };
      }
    case ADD_DOCUMENT$1:
      {
        return {
          ...state,
          documents: [...state.documents, action.payload]
        };
      }
    case REMOVE_DOCUMENT$1:
      {
        return {
          ...state,
          documents: [...state.documents.filter(doc => doc.documentType !== action.payload)]
        };
      }
    case RESET_DOCUMENTS$1:
      {
        return initState$1;
      }
    default:
      return state;
  }
};

const types$3 = {
  ADD_DOCUMENT: "ADD_REGISTRATION_DOCUMENT",
  REMOVE_DOCUMENT: "REMOVE_REGISTRATION_DOCUMENT",
  INIT_DOCUMENTS: "INIT_REGISTRATION_DOCUMENTS",
  RESET_DOCUMENTS: "RESET_REGISTRATION_DOCUMENTS"
};

const {
  ADD_DOCUMENT: ADD_DOCUMENT$2,
  REMOVE_DOCUMENT: REMOVE_DOCUMENT$2,
  INIT_DOCUMENTS: INIT_DOCUMENTS$2,
  RESET_DOCUMENTS: RESET_DOCUMENTS$2
} = types$3;
const initState$2 = {
  applicationDocuments: []
};
const registrationReducer = () => (state = initState$2, action) => {
  switch (action.type) {
    case INIT_DOCUMENTS$2:
      {
        return {
          applicationDocuments: action.payload
        };
      }
    case ADD_DOCUMENT$2:
      {
        return {
          ...state,
          applicationDocuments: [...state.applicationDocuments, action.payload]
        };
      }
    case REMOVE_DOCUMENT$2:
      {
        return {
          ...state,
          applicationDocuments: [...state.applicationDocuments.filter(doc => doc.documentType !== action.payload)]
        };
      }
    case RESET_DOCUMENTS$2:
      {
        return initState$2;
      }
    default:
      return state;
  }
};

const types$4 = {
  INIT_DOCUMENTS: "INIT_FORM26_DOCUMENTS",
  ADD_DOCUMENT: "ADD_FORM26_DOCUMENT",
  REMOVE_DOCUMENT: "REMOVE_FORM26_DOCUMENT",
  RESET_DOCUMENTS: "RESET_FORM26_DOCUMENTS"
};

const {
  ADD_DOCUMENT: ADD_DOCUMENT$3,
  REMOVE_DOCUMENT: REMOVE_DOCUMENT$3,
  RESET_DOCUMENTS: RESET_DOCUMENTS$3,
  INIT_DOCUMENTS: INIT_DOCUMENTS$3
} = types$4;
const initState$3 = {
  documents: []
};
const form26Reducer = () => (state = initState$3, action) => {
  switch (action.type) {
    case INIT_DOCUMENTS$3:
      {
        return {
          documents: action.payload
        };
      }
    case ADD_DOCUMENT$3:
      {
        return {
          ...state,
          documents: [...state.documents, action.payload]
        };
      }
    case REMOVE_DOCUMENT$3:
      {
        return {
          ...state,
          documents: [...state.documents.filter(doc => doc.documentType !== action.payload)]
        };
      }
    case RESET_DOCUMENTS$3:
      return initState$3;
    default:
      return state;
  }
};

const types$5 = {
  INIT_DOCUMENTS: "INIT_FORM_CLU_DOCUMENTS",
  ADD_DOCUMENT: "ADD_FORM_CLU_DOCUMENT",
  REMOVE_DOCUMENT: "REMOVE_FORM_CLU_DOCUMENT",
  RESET_DOCUMENTS: "RESET_FORM_CLU_DOCUMENTS"
};

const {
  INIT_DOCUMENTS: INIT_DOCUMENTS$4,
  ADD_DOCUMENT: ADD_DOCUMENT$4,
  REMOVE_DOCUMENT: REMOVE_DOCUMENT$4,
  RESET_DOCUMENTS: RESET_DOCUMENTS$4
} = types$5;
const initState$4 = {
  documents: []
};
const formCLUReducer = () => (state = initState$4, action) => {
  switch (action.type) {
    case INIT_DOCUMENTS$4:
      {
        return {
          documents: action.payload
        };
      }
    case ADD_DOCUMENT$4:
      {
        return {
          ...state,
          documents: [...state.documents, action.payload]
        };
      }
    case REMOVE_DOCUMENT$4:
      {
        return {
          ...state,
          documents: [...state.documents.filter(doc => doc.documentType !== action.payload)]
        };
      }
    case RESET_DOCUMENTS$4:
      {
        return initState$4;
      }
    default:
      return state;
  }
};

const types$6 = {
  INIT_DOCUMENTS: "INIT_FORM_34_DOCUMENTS",
  ADD_DOCUMENT: "ADD_FORM_34_DOCUMENT",
  REMOVE_DOCUMENT: "REMOVE_FORM_34_DOCUMENT",
  RESET_DOCUMENTS: "RESET_FORM_34_DOCUMENTS"
};

const {
  INIT_DOCUMENTS: INIT_DOCUMENTS$5,
  ADD_DOCUMENT: ADD_DOCUMENT$5,
  REMOVE_DOCUMENT: REMOVE_DOCUMENT$5,
  RESET_DOCUMENTS: RESET_DOCUMENTS$5
} = types$6;
const initState$5 = {
  documents: []
};
const form34Reducer = () => (state = initState$5, action) => {
  switch (action.type) {
    case INIT_DOCUMENTS$5:
      {
        return {
          documents: action.payload
        };
      }
    case ADD_DOCUMENT$5:
      {
        return {
          ...state,
          documents: [...state.documents, action.payload]
        };
      }
    case REMOVE_DOCUMENT$5:
      {
        return {
          ...state,
          documents: [...state.documents.filter(doc => doc.documentType !== action.payload)]
        };
      }
    case RESET_DOCUMENTS$5:
      {
        return initState$5;
      }
    default:
      return state;
  }
};

const types$7 = {
  INIT_DOCUMENTS: "INIT_FORM_CLU_DOCUMENTS",
  ADD_DOCUMENT: "ADD_FORM_CLU_DOCUMENT",
  REMOVE_DOCUMENT: "REMOVE_FORM_CLU_DOCUMENT",
  RESET_DOCUMENTS: "RESET_FORM_CLU_DOCUMENTS"
};

const {
  INIT_DOCUMENTS: INIT_DOCUMENTS$6,
  ADD_DOCUMENT: ADD_DOCUMENT$6,
  REMOVE_DOCUMENT: REMOVE_DOCUMENT$6,
  RESET_DOCUMENTS: RESET_DOCUMENTS$6
} = types$7;
const initState$6 = {
  documents: []
};
const formNOCReducer = () => (state = initState$6, action) => {
  switch (action.type) {
    case INIT_DOCUMENTS$6:
      {
        return {
          documents: action.payload
        };
      }
    case ADD_DOCUMENT$6:
      {
        return {
          ...state,
          documents: [...state.documents, action.payload]
        };
      }
    case REMOVE_DOCUMENT$6:
      {
        return {
          ...state,
          documents: [...state.documents.filter(doc => doc.documentType !== action.payload)]
        };
      }
    case RESET_DOCUMENTS$6:
      {
        return initState$6;
      }
    default:
      return state;
  }
};

const types$8 = {
  INIT_DOCUMENTS: "INIT_FORM16_DOCUMENTS",
  ADD_DOCUMENT: "ADD_FORM16_DOCUMENT",
  REMOVE_DOCUMENT: "REMOVE_FORM16_DOCUMENT",
  RESET_DOCUMENTS: "RESET_FORM16_DOCUMENTS"
};

const {
  INIT_DOCUMENTS: INIT_DOCUMENTS$7,
  ADD_DOCUMENT: ADD_DOCUMENT$7,
  REMOVE_DOCUMENT: REMOVE_DOCUMENT$7,
  RESET_DOCUMENTS: RESET_DOCUMENTS$7
} = types$8;
const initState$7 = {
  documents: []
};
const form16Reducer = () => (state = initState$7, action) => {
  switch (action.type) {
    case INIT_DOCUMENTS$7:
      {
        return {
          documents: action.payload
        };
      }
    case ADD_DOCUMENT$7:
      {
        return {
          ...state,
          documents: [...state.documents, action.payload]
        };
      }
    case REMOVE_DOCUMENT$7:
      {
        return {
          ...state,
          documents: [...state.documents.filter(doc => doc.documentType !== action.payload)]
        };
      }
    case RESET_DOCUMENTS$7:
      {
        return initState$7;
      }
    default:
      return state;
  }
};

const types$9 = {
  INIT_DOCUMENTS: "INIT_FORM_MT_DOCUMENTS",
  ADD_DOCUMENT: "ADD_FORM_MT_DOCUMENT",
  REMOVE_DOCUMENT: "REMOVE_FORM_MT_DOCUMENT",
  RESET_DOCUMENTS: "RESET_FORM_MT_DOCUMENTS"
};

const {
  INIT_DOCUMENTS: INIT_DOCUMENTS$8,
  ADD_DOCUMENT: ADD_DOCUMENT$8,
  REMOVE_DOCUMENT: REMOVE_DOCUMENT$8,
  RESET_DOCUMENTS: RESET_DOCUMENTS$8
} = types$9;
const initState$8 = {
  documents: []
};
const formMTReducer = () => (state = initState$8, action) => {
  switch (action.type) {
    case INIT_DOCUMENTS$8:
      {
        return {
          documents: action.payload
        };
      }
    case ADD_DOCUMENT$8:
      {
        return {
          ...state,
          documents: [...state.documents, action.payload]
        };
      }
    case REMOVE_DOCUMENT$8:
      {
        return {
          ...state,
          documents: [...state.documents.filter(doc => doc.documentType !== action.payload)]
        };
      }
    case RESET_DOCUMENTS$8:
      {
        return initState$8;
      }
    default:
      return state;
  }
};

const types$a = {
  UPDATE_NOC_FORM_FIELD: "UPDATE_NOC_FORM_FIELD",
  UPDATE_NOC_FORM_DATA: "UPDATE_NOC_FORM_DATA",
  UPDATE_OTHERS_DETAILS: "UPDATE_NOC_OTHERS_DETAILS",
  UPDATE_APPLICANT_OTHERS_DETAILS: "UPDATE_APPLICANT_NOC_OTHERS_DETAILS"
};

const initialState = JSON.parse(sessionStorage.getItem("nocFormData")) ? JSON.parse(sessionStorage.getItem("nocFormData")) : {};
const nocReducer = (state = initialState, action) => {
  switch (action.type) {
    case types$a.UPDATE_NOC_FORM_FIELD:
      const newState = {
        ...state,
        [action.payload.name]: action.payload.value
      };
      sessionStorage.setItem("nocFormData", JSON.stringify(newState));
      return newState;
    case types$a.UPDATE_NOC_FORM_DATA:
      const bulkFieldState = {
        ...state,
        ...action.payload
      };
      sessionStorage.setItem("nocFormData", JSON.stringify(bulkFieldState));
      return bulkFieldState;
    case types$a.UPDATE_OTHERS_DETAILS:
      const updatedOthersState = {
        ...state,
        othersDetails: action.payload
      };
      sessionStorage.setItem("nocFormData", JSON.stringify(updatedOthersState));
      return updatedOthersState;
    case types$a.UPDATE_APPLICANT_OTHERS_DETAILS:
      const updatedApplicantOthersState = {
        ...state,
        othersNocDetailsApplicant: action.payload
      };
      sessionStorage.setItem("nocFormData", JSON.stringify(updatedOthersState));
      return updatedApplicantOthersState;
    default:
      return state;
  }
};

const types$b = {
  UPDATE_CHECKLIST_FORM_FIELD: "UPDATE_CHECKLIST_FORM_FIELD"
};

const initialState$1 = {
  allotmentDate: null,
  isPossesionAreaDiff: null,
  areaOfExtraLand: null,
  paymentStatus: null,
  agreementDate: null,
  uptodatePaymentStatus: null,
  registryStatus: null
};
const checklistReducer = (state = initialState$1, action) => {
  switch (action === null || action === void 0 ? void 0 : action.type) {
    case types$b.UPDATE_CHECKLIST_FORM_FIELD:
      const newState = {
        ...state,
        [action.payload.name]: action.payload.value
      };
      sessionStorage.setItem("emoCheckList", JSON.stringify(newState));
      return newState;
    default:
      return state;
  }
};

const types$c = {
  UPDATE_CHECKLIST_REVIEW: "UPDATE_CHECKLIST_REVIEW",
  SET_APPLICATION_DATA: "SET_APPLICATION_DATA"
};

const initialState$2 = {
  checklistReview: {}
};
const checklistReviewReducer = (state = initialState$2, action) => {
  switch (action.type) {
    case types$c.UPDATE_CHECKLIST_REVIEW:
      return {
        ...state,
        checklistReview: {
          ...state.checklistReview,
          ...action.payload
        }
      };
    default:
      return state;
  }
};

const SET_SCHEMES_RATE = "SET_SCHEMES_RATE";

const initialState$3 = {
  schemesRate: []
};
const schemeRateReducer = (state = initialState$3, action) => {
  switch (action.type) {
    case SET_SCHEMES_RATE:
      return {
        ...state,
        schemesRate: action.payload
      };
    default:
      return state;
  }
};

const initialState$4 = {
  applicationData: null,
  isAppDataLoading: false,
  error: null
};
const applicationDataReducer = (state = initialState$4, action) => {
  switch (action.type) {
    case types$c.SET_APPLICATION_DATA:
      return {
        ...state,
        applicationData: action.payload.data,
        isAppDataLoading: action.payload.isLoading,
        error: action.payload.error
      };
    default:
      return state;
  }
};

const types$d = {
  UPDATE_DOCUMENT: "UPDATE_DOCUMENT"
};

const initialState$5 = {
  documents: {}
};
const remarksDialogReducer = (state = initialState$5, action) => {
  switch (action.type) {
    case types$d.UPDATE_DOCUMENT:
      {
        const doc = action.payload;
        console.log("doc in reducer:", doc);
        return {
          ...state,
          ...doc
        };
      }
    default:
      return state;
  }
};

const initialState$6 = {
  theminimumqualifications: null,
  theapplicantRegistered: null,
  theApplicantPossess: null,
  thelicenseMembership: null,
  theApplicantGraduate: null,
  theapplicantMember: null,
  theApplicantHold: null,
  theApplicantQualifications: null,
  theApplicantFiveYears: null,
  theApplicantTwoYears: null,
  theApplicantOneYears: null,
  theApplicantPossessValid: null,
  theApplicantAssociateMembership: null,
  theApplicantITPI: null,
  theApplicantITPImembership: null,
  theLandscapeArchitecture: null,
  theDegreeUrbanDesign: null
};
const checklistLTPReducer = (state = initialState$6, action) => {
  switch (action === null || action === void 0 ? void 0 : action.type) {
    case types$b.UPDATE_CHECKLIST_FORM_FIELD:
      const newState = {
        ...state,
        [action.payload.name]: action.payload.value
      };
      sessionStorage.setItem("ltpCheckList", JSON.stringify(newState));
      return newState;
    default:
      return state;
  }
};

const initialState$7 = {
  inspectionReportData: {}
};
const siteInspectionReportReducer = (state = initialState$7, action) => {
  switch (action.type) {
    case types$c.UPDATE_CHECKLIST_REVIEW:
      return {
        ...state,
        inspectionReportData: {
          ...state.inspectionReportData,
          ...action.payload
        }
      };
    default:
      return state;
  }
};

const initialState$8 = {
  businessServices: [],
  tenantId: "",
  count: 0,
  officerRole: []
};
const empInboxReducer = (state = initialState$8, action) => {
  switch (action.type) {
    case types.UPDATE_DETAILS:
      return {
        ...state,
        businessServices: action.payload.businessServices,
        tenantId: action.payload.tenantId,
        count: action.payload.count,
        officerRole: action.payload.officerRole
      };
    default:
      return state;
  }
};

const getRootReducer = (defaultStore, moduleReducers) => combineReducers({
  common: commonReducer(defaultStore),
  form12: form12Reducer(),
  form11: form11Reducer(),
  form26: form26Reducer(),
  formCLU: formCLUReducer(),
  formNOC: formNOCReducer(),
  form16: form16Reducer(),
  formMT: formMTReducer(),
  form34: form34Reducer(),
  formLandUse: nocReducer,
  registration: registrationReducer(),
  checkList: checklistReducer,
  purchasableFarChecklist: checklistReviewReducer,
  ltpChecklist: checklistLTPReducer,
  inspectionReportChecklist: siteInspectionReportReducer,
  approvedLandUseData: applicationDataReducer,
  remarksDialog: remarksDialogReducer,
  mdmsSchemes: schemeRateReducer,
  empInbox: empInboxReducer,
  ...moduleReducers
});
const middleware = [thunk];
const composeEnhancers = typeof window === "object" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({}) : compose;
const enhancer = composeEnhancers(applyMiddleware(...middleware));
const getStore = (defaultStore, moduleReducers = {}) => {
  return createStore(getRootReducer(defaultStore, moduleReducers), enhancer);
};

const DigitUIWrapper = ({
  stateCode,
  enabledModules,
  moduleReducers
}) => {
  var _initData$stateInfo;
  const {
    isLoading,
    data: initData
  } = Digit.Hooks.useInitStore(stateCode, enabledModules);
  if (isLoading) {
    return /*#__PURE__*/React__default.createElement(Loader, {
      page: true
    });
  }
  const i18n = getI18n();
  return /*#__PURE__*/React__default.createElement(Provider, {
    store: getStore(initData, moduleReducers(initData))
  }, /*#__PURE__*/React__default.createElement(BrowserRouter, null, /*#__PURE__*/React__default.createElement(DigitApp, {
    initData: initData,
    stateCode: stateCode,
    modules: initData === null || initData === void 0 ? void 0 : initData.modules,
    appTenants: initData.tenants,
    logoUrl: initData === null || initData === void 0 ? void 0 : (_initData$stateInfo = initData.stateInfo) === null || _initData$stateInfo === void 0 ? void 0 : _initData$stateInfo.logoUrl
  })));
};
const DigitUI = ({
  stateCode,
  registry,
  enabledModules,
  moduleReducers
}) => {
  const userType = Digit.UserService.getType();
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 15 * 60 * 1000,
        cacheTime: 50 * 60 * 1000,
        retryDelay: attemptIndex => Infinity
      }
    }
  });
  const ComponentProvider = Digit.Contexts.ComponentProvider;
  const DSO = Digit.UserService.hasAccess(["FSM_DSO"]);
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(ErrorBoundary, null, /*#__PURE__*/React__default.createElement(QueryClientProvider, {
    client: queryClient
  }, /*#__PURE__*/React__default.createElement(ComponentProvider.Provider, {
    value: registry
  }, /*#__PURE__*/React__default.createElement(DigitUIWrapper, {
    stateCode: stateCode,
    enabledModules: enabledModules,
    moduleReducers: moduleReducers
  })))));
};
const componentsToRegister = {
  SelectOtp
};
const initCoreComponents = () => {
  Object.entries(componentsToRegister).forEach(([key, value]) => {
    Digit.ComponentRegistryService.setComponent(key, value);
  });
};

export { DigitUI, initCoreComponents };
//# sourceMappingURL=index.modern.js.map
